
      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire3e1a"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire3e1a"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("gaxBK", function(module, exports) {
// This file is a compatibility shim for bundlers (e.g. webpack 4) that do not
// support the package.json `exports` field for resolving subpath exports.

module.exports = (parcelRequire("kPbkB"));

});
parcelRegister("kPbkB", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $kYwtu = parcelRequire("kYwtu");

var $bkBh2 = parcelRequire("bkBh2");

var $jCNU0 = parcelRequire("jCNU0");

var $capUI = parcelRequire("capUI");

var $g4dpo = parcelRequire("g4dpo");

var $boFM9 = parcelRequire("boFM9");

var $yI1C9 = parcelRequire("yI1C9");

var $kBDP8 = parcelRequire("kBDP8");

var $2IR8A = parcelRequire("2IR8A");

var $f0qnC = parcelRequire("f0qnC");

var $iFH83 = parcelRequire("iFH83");

var $6Hymv = parcelRequire("6Hymv");

var $hFfKc = parcelRequire("hFfKc");

var $452ZL = parcelRequire("452ZL");

var $gTasE = parcelRequire("gTasE");

var $gjixg = parcelRequire("gjixg");

var $1tl8I = parcelRequire("1tl8I");

var $79m2C = parcelRequire("79m2C");

var $ThQQg = parcelRequire("ThQQg");

var $diBhM = parcelRequire("diBhM");

var $5Ezlt = parcelRequire("5Ezlt");

var $4fnou = parcelRequire("4fnou");

var $dsI2h = parcelRequire("dsI2h");

var $d3JtV = parcelRequire("d3JtV");

var $k6fyv = parcelRequire("k6fyv");

var $aY6AE = parcelRequire("aY6AE");

var $cCAVw = parcelRequire("cCAVw");

var $39KQC = parcelRequire("39KQC");

var $aQrJw = parcelRequire("aQrJw");

var $j3q4C = parcelRequire("j3q4C");

var $bjiMJ = parcelRequire("bjiMJ");

var $g33UP = parcelRequire("g33UP");

var $kpR1z = parcelRequire("kpR1z");

var $ghLoo = parcelRequire("ghLoo");

var $lpr4K = parcelRequire("lpr4K");

var $9DnJa = parcelRequire("9DnJa");

var $6HYaL = parcelRequire("6HYaL");

var $fsIRO = parcelRequire("fsIRO");

var $1rqgb = parcelRequire("1rqgb");

var $9SwL9 = parcelRequire("9SwL9");

var $6emr7 = parcelRequire("6emr7");

var $hOwNc = parcelRequire("hOwNc");

var $3Vae5 = parcelRequire("3Vae5");

var $7vFKP = parcelRequire("7vFKP");

var $8UX2H = parcelRequire("8UX2H");

var $jizDx = parcelRequire("jizDx");

var $9FRK6 = parcelRequire("9FRK6");

var $8jbnX = parcelRequire("8jbnX");

var $f9GTk = parcelRequire("f9GTk");

var $dkhYR = parcelRequire("dkhYR");

var $kxe8l = parcelRequire("kxe8l");

var $7DICZ = parcelRequire("7DICZ");

var $fM5oA = parcelRequire("fM5oA");

var $aCCmm = parcelRequire("aCCmm");

var $5EABE = parcelRequire("5EABE");

var $aNC5c = parcelRequire("aNC5c");

var $ckY1h = parcelRequire("ckY1h");

var $cRlHT = parcelRequire("cRlHT");

var $akxwg = parcelRequire("akxwg");

var $8Bk70 = parcelRequire("8Bk70");

var $hqWNa = parcelRequire("hqWNa");

var $7ZoMM = parcelRequire("7ZoMM");

var $7aBU0 = parcelRequire("7aBU0");

var $hfsCi = parcelRequire("hfsCi");

var $kP6ZH = parcelRequire("kP6ZH");

var $6KRgN = parcelRequire("6KRgN");

var $h4TTy = parcelRequire("h4TTy");

var $cWoZT = parcelRequire("cWoZT");

var $aB7g9 = parcelRequire("aB7g9");

var $8Vant = parcelRequire("8Vant");

var $5k42w = parcelRequire("5k42w");

var $8mrnP = parcelRequire("8mrnP");

var $cvcY5 = parcelRequire("cvcY5");

var $gzBJP = parcelRequire("gzBJP");

var $jnFoQ = parcelRequire("jnFoQ");

var $4qll8 = parcelRequire("4qll8");

var $dpTK0 = parcelRequire("dpTK0");

var $8fRJG = parcelRequire("8fRJG");

var $8vWe2 = parcelRequire("8vWe2");

var $6e3bz = parcelRequire("6e3bz");

var $hluB2 = parcelRequire("hluB2");

var $7LBlQ = parcelRequire("7LBlQ");

var $kfRXe = parcelRequire("kfRXe");

var $42tGj = parcelRequire("42tGj");

var $5zO49 = parcelRequire("5zO49");

var $dBNYS = parcelRequire("dBNYS");

var $c4s7L = parcelRequire("c4s7L");

var $hLsdQ = parcelRequire("hLsdQ");

var $iQAGO = parcelRequire("iQAGO");

var $MHfcn = parcelRequire("MHfcn");

var $azBVI = parcelRequire("azBVI");

var $dqmpD = parcelRequire("dqmpD");

var $823gY = parcelRequire("823gY");

var $e6pkh = parcelRequire("e6pkh");

var $cMrSV = parcelRequire("cMrSV");

var $aaeQR = parcelRequire("aaeQR");

var $55dom = parcelRequire("55dom");

var $eyueP = parcelRequire("eyueP");

var $fx2ii = parcelRequire("fx2ii");

var $kqIrz = parcelRequire("kqIrz");

var $6zRv1 = parcelRequire("6zRv1");

var $boef1 = parcelRequire("boef1");

var $l8LMz = parcelRequire("l8LMz");

var $9Af4h = parcelRequire("9Af4h");

var $1fQ84 = parcelRequire("1fQ84");

var $lhIXN = parcelRequire("lhIXN");

var $4xjJr = parcelRequire("4xjJr");

var $bSQ9n = parcelRequire("bSQ9n");

var $kxKwQ = parcelRequire("kxKwQ");

var $fXIk8 = parcelRequire("fXIk8");

var $9HMF4 = parcelRequire("9HMF4");

var $8ICT0 = parcelRequire("8ICT0");

var $hPkVj = parcelRequire("hPkVj");

var $5EpvI = parcelRequire("5EpvI");

var $20hDs = parcelRequire("20hDs");

var $1q5J2 = parcelRequire("1q5J2");

var $7E8b3 = parcelRequire("7E8b3");

var $9rQX1 = parcelRequire("9rQX1");

var $eP8Ri = parcelRequire("eP8Ri");

var $8mzKS = parcelRequire("8mzKS");

var $f1mbT = parcelRequire("f1mbT");

var $3AeQc = parcelRequire("3AeQc");

var $4JTi6 = parcelRequire("4JTi6");

var $1d06v = parcelRequire("1d06v");

var $dzfKZ = parcelRequire("dzfKZ");

var $kIp0s = parcelRequire("kIp0s");

var $4gyod = parcelRequire("4gyod");

var $6JkyB = parcelRequire("6JkyB");

var $eD1cG = parcelRequire("eD1cG");

var $c3njb = parcelRequire("c3njb");

var $7OVjx = parcelRequire("7OVjx");

var $btATC = parcelRequire("btATC");

var $gaj81 = parcelRequire("gaj81");

var $1VSHh = parcelRequire("1VSHh");

var $5sHNN = parcelRequire("5sHNN");

var $d7glj = parcelRequire("d7glj");

var $arYVC = parcelRequire("arYVC");

var $58ep5 = parcelRequire("58ep5");

var $eligX = parcelRequire("eligX");

var $ihsl1 = parcelRequire("ihsl1");

var $3ZCGz = parcelRequire("3ZCGz");

var $h0BBG = parcelRequire("h0BBG");

var $636GJ = parcelRequire("636GJ");

var $6lXp4 = parcelRequire("6lXp4");

var $iLGyZ = parcelRequire("iLGyZ");

var $l5MWU = parcelRequire("l5MWU");

var $hLsvb = parcelRequire("hLsvb");

var $l3xRy = parcelRequire("l3xRy");

var $kzbBU = parcelRequire("kzbBU");

var $bLH3w = parcelRequire("bLH3w");

var $5qT6j = parcelRequire("5qT6j");

var $5PTIz = parcelRequire("5PTIz");

var $318WW = parcelRequire("318WW");

var $2K1Wi = parcelRequire("2K1Wi");

var $lLUp4 = parcelRequire("lLUp4");

var $fNJme = parcelRequire("fNJme");
module.exports.registerSpanErrorInstrumentation = $kYwtu.registerSpanErrorInstrumentation;
module.exports.getCapturedScopesOnSpan = $bkBh2.getCapturedScopesOnSpan;
module.exports.markSpanAsTracerProviderSpan = $bkBh2.markSpanAsTracerProviderSpan;
module.exports.markSpanForOtelSourceInference = $bkBh2.markSpanForOtelSourceInference;
module.exports.markSpanSourceAsExplicit = $bkBh2.markSpanSourceAsExplicit;
module.exports.setCapturedScopesOnSpan = $bkBh2.setCapturedScopesOnSpan;
module.exports.spanIsTracerProviderSpan = $bkBh2.spanIsTracerProviderSpan;
module.exports.spanShouldInferOtelSource = $bkBh2.spanShouldInferOtelSource;
module.exports.spanSourceWasExplicitlySet = $bkBh2.spanSourceWasExplicitlySet;
module.exports.TRACING_DEFAULTS = $jCNU0.TRACING_DEFAULTS;
module.exports.startIdleSpan = $jCNU0.startIdleSpan;
module.exports.SentrySpan = $capUI.SentrySpan;
module.exports._INTERNAL_setDeferSegmentSpanCapture = $g4dpo._INTERNAL_setDeferSegmentSpanCapture;
module.exports.SentryNonRecordingSpan = $boFM9.SentryNonRecordingSpan;
module.exports.SPAN_STATUS_ERROR = $yI1C9.SPAN_STATUS_ERROR;
module.exports.SPAN_STATUS_OK = $yI1C9.SPAN_STATUS_OK;
module.exports.SPAN_STATUS_UNSET = $yI1C9.SPAN_STATUS_UNSET;
module.exports.getSpanStatusFromHttpCode = $yI1C9.getSpanStatusFromHttpCode;
module.exports.setHttpStatus = $yI1C9.setHttpStatus;
module.exports.SUPPRESS_TRACING_KEY = $kBDP8.SUPPRESS_TRACING_KEY;
module.exports._INTERNAL_startInactiveSpan = $kBDP8._INTERNAL_startInactiveSpan;
module.exports.continueTrace = $kBDP8.continueTrace;
module.exports.isTracingSuppressed = $kBDP8.isTracingSuppressed;
module.exports.spanIsIgnored = $kBDP8.spanIsIgnored;
module.exports.startInactiveSpan = $kBDP8.startInactiveSpan;
module.exports.startNewTrace = $kBDP8.startNewTrace;
module.exports.startSpan = $kBDP8.startSpan;
module.exports.startSpanManual = $kBDP8.startSpanManual;
module.exports.suppressTracing = $kBDP8.suppressTracing;
module.exports.withActiveSpan = $kBDP8.withActiveSpan;
module.exports.bindScopeToEmitter = $2IR8A.bindScopeToEmitter;
module.exports.getDynamicSamplingContextFromClient = $f0qnC.getDynamicSamplingContextFromClient;
module.exports.getDynamicSamplingContextFromScope = $f0qnC.getDynamicSamplingContextFromScope;
module.exports.getDynamicSamplingContextFromSpan = $f0qnC.getDynamicSamplingContextFromSpan;
module.exports.spanToBaggageHeader = $f0qnC.spanToBaggageHeader;
module.exports.setMeasurement = $iFH83.setMeasurement;
module.exports.timedEventsToMeasurements = $iFH83.timedEventsToMeasurements;
module.exports.sampleSpan = $6Hymv.sampleSpan;
module.exports.logSpanEnd = $hFfKc.logSpanEnd;
module.exports.logSpanStart = $hFfKc.logSpanStart;
module.exports.captureSpan = $452ZL.captureSpan;
module.exports.safeSetSpanJSONAttributes = $452ZL.safeSetSpanJSONAttributes;
module.exports.GEN_AI_CONVERSATION_ID_ATTRIBUTE = $gTasE.GEN_AI_CONVERSATION_ID_ATTRIBUTE;
module.exports.SEMANTIC_ATTRIBUTE_CACHE_HIT = $gTasE.SEMANTIC_ATTRIBUTE_CACHE_HIT;
module.exports.SEMANTIC_ATTRIBUTE_CACHE_ITEM_SIZE = $gTasE.SEMANTIC_ATTRIBUTE_CACHE_ITEM_SIZE;
module.exports.SEMANTIC_ATTRIBUTE_CACHE_KEY = $gTasE.SEMANTIC_ATTRIBUTE_CACHE_KEY;
module.exports.SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME = $gTasE.SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME;
module.exports.SEMANTIC_ATTRIBUTE_HTTP_REQUEST_METHOD = $gTasE.SEMANTIC_ATTRIBUTE_HTTP_REQUEST_METHOD;
module.exports.SEMANTIC_ATTRIBUTE_PROFILE_ID = $gTasE.SEMANTIC_ATTRIBUTE_PROFILE_ID;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME = $gTasE.SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_ENVIRONMENT = $gTasE.SEMANTIC_ATTRIBUTE_SENTRY_ENVIRONMENT;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON = $gTasE.SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT = $gTasE.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE = $gTasE.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_OP = $gTasE.SEMANTIC_ATTRIBUTE_SENTRY_OP;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN = $gTasE.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_PREVIOUS_TRACE_SAMPLE_RATE = $gTasE.SEMANTIC_ATTRIBUTE_SENTRY_PREVIOUS_TRACE_SAMPLE_RATE;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_RELEASE = $gTasE.SEMANTIC_ATTRIBUTE_SENTRY_RELEASE;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE = $gTasE.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SDK_INTEGRATIONS = $gTasE.SEMANTIC_ATTRIBUTE_SENTRY_SDK_INTEGRATIONS;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SDK_NAME = $gTasE.SEMANTIC_ATTRIBUTE_SENTRY_SDK_NAME;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SDK_VERSION = $gTasE.SEMANTIC_ATTRIBUTE_SENTRY_SDK_VERSION;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_ID = $gTasE.SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_ID;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_NAME = $gTasE.SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_NAME;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE = $gTasE.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_STATUS_MESSAGE = $gTasE.SEMANTIC_ATTRIBUTE_SENTRY_STATUS_MESSAGE;
module.exports.SEMANTIC_ATTRIBUTE_URL_FULL = $gTasE.SEMANTIC_ATTRIBUTE_URL_FULL;
module.exports.SEMANTIC_ATTRIBUTE_USER_EMAIL = $gTasE.SEMANTIC_ATTRIBUTE_USER_EMAIL;
module.exports.SEMANTIC_ATTRIBUTE_USER_ID = $gTasE.SEMANTIC_ATTRIBUTE_USER_ID;
module.exports.SEMANTIC_ATTRIBUTE_USER_IP_ADDRESS = $gTasE.SEMANTIC_ATTRIBUTE_USER_IP_ADDRESS;
module.exports.SEMANTIC_ATTRIBUTE_USER_USERNAME = $gTasE.SEMANTIC_ATTRIBUTE_USER_USERNAME;
module.exports.SEMANTIC_LINK_ATTRIBUTE_LINK_TYPE = $gTasE.SEMANTIC_LINK_ATTRIBUTE_LINK_TYPE;
module.exports.createEventEnvelope = $gjixg.createEventEnvelope;
module.exports.createSessionEnvelope = $gjixg.createSessionEnvelope;
module.exports.createSpanEnvelope = $gjixg.createSpanEnvelope;
module.exports.addEventProcessor = $1tl8I.addEventProcessor;
module.exports.captureCheckIn = $1tl8I.captureCheckIn;
module.exports.captureEvent = $1tl8I.captureEvent;
module.exports.captureException = $1tl8I.captureException;
module.exports.captureMessage = $1tl8I.captureMessage;
module.exports.captureSession = $1tl8I.captureSession;
module.exports.close = $1tl8I.close;
module.exports.endSession = $1tl8I.endSession;
module.exports.flush = $1tl8I.flush;
module.exports.isEnabled = $1tl8I.isEnabled;
module.exports.isInitialized = $1tl8I.isInitialized;
module.exports.lastEventId = $1tl8I.lastEventId;
module.exports.setAttribute = $1tl8I.setAttribute;
module.exports.setAttributes = $1tl8I.setAttributes;
module.exports.setContext = $1tl8I.setContext;
module.exports.setConversationId = $1tl8I.setConversationId;
module.exports.setExtra = $1tl8I.setExtra;
module.exports.setExtras = $1tl8I.setExtras;
module.exports.setTag = $1tl8I.setTag;
module.exports.setTags = $1tl8I.setTags;
module.exports.setUser = $1tl8I.setUser;
module.exports.startSession = $1tl8I.startSession;
module.exports.withMonitor = $1tl8I.withMonitor;
module.exports.getClient = $79m2C.getClient;
module.exports.getCurrentScope = $79m2C.getCurrentScope;
module.exports.getExternalPropagationContext = $79m2C.getExternalPropagationContext;
module.exports.getGlobalScope = $79m2C.getGlobalScope;
module.exports.getIsolationScope = $79m2C.getIsolationScope;
module.exports.getTraceContextFromScope = $79m2C.getTraceContextFromScope;
module.exports.hasExternalPropagationContext = $79m2C.hasExternalPropagationContext;
module.exports.registerExternalPropagationContext = $79m2C.registerExternalPropagationContext;
module.exports.withIsolationScope = $79m2C.withIsolationScope;
module.exports.withScope = $79m2C.withScope;
module.exports.getDefaultCurrentScope = $ThQQg.getDefaultCurrentScope;
module.exports.getDefaultIsolationScope = $ThQQg.getDefaultIsolationScope;
module.exports.getAsyncContextStrategy = $diBhM.getAsyncContextStrategy;
module.exports.setAsyncContextStrategy = $diBhM.setAsyncContextStrategy;
module.exports._INTERNAL_createTracingChannelBinding = $5Ezlt._INTERNAL_createTracingChannelBinding;
module.exports.waitForTracingChannelBinding = $5Ezlt.waitForTracingChannelBinding;
module.exports.getGlobalSingleton = $4fnou.getGlobalSingleton;
module.exports.getMainCarrier = $4fnou.getMainCarrier;
module.exports.closeSession = $dsI2h.closeSession;
module.exports.makeSession = $dsI2h.makeSession;
module.exports.updateSession = $dsI2h.updateSession;
module.exports.Scope = $d3JtV.Scope;
module.exports.notifyEventProcessors = $k6fyv.notifyEventProcessors;
module.exports.SENTRY_API_VERSION = $aY6AE.SENTRY_API_VERSION;
module.exports.getEnvelopeEndpointWithUrlEncodedAuth = $aY6AE.getEnvelopeEndpointWithUrlEncodedAuth;
module.exports.getReportDialogEndpoint = $aY6AE.getReportDialogEndpoint;
module.exports.Client = $cCAVw.Client;
module.exports.initAndBind = $39KQC.initAndBind;
module.exports.setCurrentClient = $39KQC.setCurrentClient;
module.exports.createTransport = $aQrJw.createTransport;
module.exports.makeOfflineTransport = $j3q4C.makeOfflineTransport;
module.exports.MULTIPLEXED_TRANSPORT_EXTRA_KEY = $bjiMJ.MULTIPLEXED_TRANSPORT_EXTRA_KEY;
module.exports.makeMultiplexedTransport = $bjiMJ.makeMultiplexedTransport;
module.exports.addIntegration = $g33UP.addIntegration;
module.exports.defineIntegration = $g33UP.defineIntegration;
module.exports.extendIntegration = $g33UP.extendIntegration;
module.exports.getIntegrationsToSetup = $g33UP.getIntegrationsToSetup;
module.exports.installedIntegrations = $g33UP.installedIntegrations;
module.exports._INTERNAL_clearAiProviderSkips = $kpR1z._INTERNAL_clearAiProviderSkips;
module.exports._INTERNAL_shouldSkipAiProviderWrapping = $kpR1z._INTERNAL_shouldSkipAiProviderWrapping;
module.exports._INTERNAL_skipAiProviderWrapping = $kpR1z._INTERNAL_skipAiProviderWrapping;
module.exports._INTERNAL_filterKeyValueData = $ghLoo.filterKeyValueData;
module.exports._INTERNAL_filterCookies = $lpr4K.filterCookies;
module.exports._INTERNAL_filterQueryParams = $9DnJa.filterQueryParams;
module.exports.envToBool = $6HYaL.envToBool;
module.exports.applyScopeDataToEvent = $fsIRO.applyScopeDataToEvent;
module.exports.getCombinedScopeData = $fsIRO.getCombinedScopeData;
module.exports.mergeScopeData = $fsIRO.mergeScopeData;
module.exports.prepareEvent = $1rqgb.prepareEvent;
module.exports.createCheckInEnvelope = $9SwL9.createCheckInEnvelope;
module.exports.hasSpansEnabled = $6emr7.hasSpansEnabled;
module.exports.isStreamedBeforeSendSpanCallback = $hOwNc.isStreamedBeforeSendSpanCallback;
module.exports.withStreamedSpan = $hOwNc.withStreamedSpan;
module.exports.isSentryRequestUrl = $3Vae5.isSentryRequestUrl;
module.exports.handleCallbackErrors = $7vFKP.handleCallbackErrors;
module.exports.fmt = $8UX2H.fmt;
module.exports.parameterize = $8UX2H.parameterize;
module.exports.handleTunnelRequest = $jizDx.handleTunnelRequest;
module.exports.addAutoIpAddressToSession = $9FRK6.addAutoIpAddressToSession;
module.exports.addAutoIpAddressToUser = $9FRK6.addAutoIpAddressToUser;
module.exports.INTERNAL_getSegmentSpan = $8jbnX.INTERNAL_getSegmentSpan;
module.exports.addChildSpanToSpan = $8jbnX.addChildSpanToSpan;
module.exports.convertSpanLinksForEnvelope = $8jbnX.convertSpanLinksForEnvelope;
module.exports.getActiveSpan = $8jbnX.getActiveSpan;
module.exports.getRootSpan = $8jbnX.getRootSpan;
module.exports.getSpanDescendants = $8jbnX.getSpanDescendants;
module.exports.getStatusMessage = $8jbnX.getStatusMessage;
module.exports.spanIsSampled = $8jbnX.spanIsSampled;
module.exports.spanIsSentrySpan = $8jbnX.spanIsSentrySpan;
module.exports.spanTimeInputToSeconds = $8jbnX.spanTimeInputToSeconds;
module.exports.spanToJSON = $8jbnX.spanToJSON;
module.exports.spanToStreamedSpanJSON = $8jbnX.spanToStreamedSpanJSON;
module.exports.spanToTraceContext = $8jbnX.spanToTraceContext;
module.exports.spanToTraceHeader = $8jbnX.spanToTraceHeader;
module.exports.updateSpanName = $8jbnX.updateSpanName;
module.exports._INTERNAL_setSpanForScope = $f9GTk._setSpanForScope;
module.exports.parseSampleRate = $dkhYR.parseSampleRate;
module.exports.applySdkMetadata = $kxe8l.applySdkMetadata;
module.exports.getTraceData = $7DICZ.getTraceData;
module.exports.shouldPropagateTraceForUrl = $fM5oA.shouldPropagateTraceForUrl;
module.exports.getTraceMetaTags = $aCCmm.getTraceMetaTags;
module.exports.debounce = $5EABE.debounce;
module.exports.uniq = $aNC5c.uniq;
module.exports.derefWeakRef = $ckY1h.derefWeakRef;
module.exports.makeWeakRef = $ckY1h.makeWeakRef;
module.exports.shouldIgnoreSpan = $cRlHT.shouldIgnoreSpan;
module.exports.MAX_BODY_BYTE_LENGTH = $akxwg.MAX_BODY_BYTE_LENGTH;
module.exports.captureBodyFromWinterCGRequest = $akxwg.captureBodyFromWinterCGRequest;
module.exports.extractQueryParamsFromUrl = $akxwg.extractQueryParamsFromUrl;
module.exports.getMaxBodyByteLength = $akxwg.getMaxBodyByteLength;
module.exports.headersToDict = $akxwg.headersToDict;
module.exports.httpHeadersToSpanAttributes = $akxwg.httpHeadersToSpanAttributes;
module.exports.httpRequestToRequestData = $akxwg.httpRequestToRequestData;
module.exports.winterCGHeadersToDict = $akxwg.winterCGHeadersToDict;
module.exports.winterCGRequestToRequestData = $akxwg.winterCGRequestToRequestData;
module.exports.DEFAULT_ENVIRONMENT = $8Bk70.DEFAULT_ENVIRONMENT;
module.exports.DEV_ENVIRONMENT = $8Bk70.DEV_ENVIRONMENT;
module.exports.SPAN_KIND = $hqWNa.SPAN_KIND;
module.exports.spanKindToName = $hqWNa.spanKindToName;
module.exports.addBreadcrumb = $7ZoMM.addBreadcrumb;
module.exports.functionToStringIntegration = $7aBU0.functionToStringIntegration;
module.exports.eventFiltersIntegration = $hfsCi.eventFiltersIntegration;
module.exports.inboundFiltersIntegration = $hfsCi.inboundFiltersIntegration;
module.exports.linkedErrorsIntegration = $kP6ZH.linkedErrorsIntegration;
module.exports.moduleMetadataIntegration = $6KRgN.moduleMetadataIntegration;
module.exports.requestDataIntegration = $h4TTy.requestDataIntegration;
module.exports.captureConsoleIntegration = $cWoZT.captureConsoleIntegration;
module.exports.dedupeIntegration = $aB7g9.dedupeIntegration;
module.exports.extraErrorDataIntegration = $8Vant.extraErrorDataIntegration;
module.exports.rewriteFramesIntegration = $5k42w.rewriteFramesIntegration;
module.exports.instrumentSupabaseClient = $8mrnP.instrumentSupabaseClient;
module.exports.supabaseIntegration = $8mrnP.supabaseIntegration;
module.exports.zodErrorsIntegration = $cvcY5.zodErrorsIntegration;
module.exports.thirdPartyErrorFilterIntegration = $gzBJP.thirdPartyErrorFilterIntegration;
module.exports.consoleIntegration = $jnFoQ.consoleIntegration;
module.exports.featureFlagsIntegration = $4qll8.featureFlagsIntegration;
module.exports.growthbookIntegration = $dpTK0.growthbookIntegration;
module.exports.conversationIdIntegration = $8fRJG.conversationIdIntegration;
module.exports.profiler = $8vWe2.profiler;
module.exports._INTERNAL_getTracingHeadersForFetchRequest = $6e3bz._INTERNAL_getTracingHeadersForFetchRequest;
module.exports.instrumentFetchRequest = $6e3bz.instrumentFetchRequest;
module.exports.captureFeedback = $hluB2.captureFeedback;
module.exports._INTERNAL_captureLog = $7LBlQ._INTERNAL_captureLog;
module.exports._INTERNAL_captureSerializedLog = $7LBlQ._INTERNAL_captureSerializedLog;
module.exports._INTERNAL_flushLogsBuffer = $7LBlQ._INTERNAL_flushLogsBuffer;
module.exports.logger = $kfRXe;
module.exports.consoleLoggingIntegration = $42tGj.consoleLoggingIntegration;
module.exports._INTERNAL_captureMetric = $5zO49._INTERNAL_captureMetric;
module.exports._INTERNAL_captureSerializedMetric = $5zO49._INTERNAL_captureSerializedMetric;
module.exports._INTERNAL_flushMetricsBuffer = $5zO49._INTERNAL_flushMetricsBuffer;
module.exports.metrics = $dBNYS;
module.exports.createConsolaReporter = $c4s7L.createConsolaReporter;
module.exports.addVercelAiProcessors = $hLsdQ.addVercelAiProcessors;
module.exports.getProviderMetadataAttributes = $hLsdQ.getProviderMetadataAttributes;
module.exports.getTruncatedJsonString = $iQAGO.getTruncatedJsonString;
module.exports.resolveAIRecordingOptions = $iQAGO.resolveAIRecordingOptions;
module.exports.shouldEnableTruncation = $iQAGO.shouldEnableTruncation;
module.exports.GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE = $MHfcn.GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE;
module.exports.GEN_AI_REQUEST_MODEL_ATTRIBUTE = $MHfcn.GEN_AI_REQUEST_MODEL_ATTRIBUTE;
module.exports.GEN_AI_SYSTEM_INSTRUCTIONS_ATTRIBUTE = $MHfcn.GEN_AI_SYSTEM_INSTRUCTIONS_ATTRIBUTE;
module.exports._INTERNAL_cleanupToolCallSpanContext = $azBVI._INTERNAL_cleanupToolCallSpanContext;
module.exports._INTERNAL_getSpanContextForToolCallId = $azBVI._INTERNAL_getSpanContextForToolCallId;
module.exports._INTERNAL_toolCallSpanContextMap = $dqmpD.toolCallSpanContextMap;
module.exports.addOpenAiRequestAttributes = $823gY.addRequestAttributes;
module.exports.extractOpenAiRequestAttributes = $823gY.extractRequestAttributes;
module.exports.instrumentOpenAiClient = $823gY.instrumentOpenAiClient;
module.exports.addOpenAiResponseAttributes = $e6pkh.addResponseAttributes;
module.exports.extractOpenAiRequestParameters = $e6pkh.extractRequestParameters;
module.exports.instrumentOpenAiStream = $cMrSV.instrumentStream;
module.exports.OPENAI_INTEGRATION_NAME = $aaeQR.OPENAI_INTEGRATION_NAME;
module.exports.addAnthropicRequestAttributes = $55dom.addPrivateRequestAttributes;
module.exports.addAnthropicResponseAttributes = $55dom.addResponseAttributes;
module.exports.extractAnthropicRequestAttributes = $55dom.extractRequestAttributes;
module.exports.instrumentAnthropicAiClient = $55dom.instrumentAnthropicAiClient;
module.exports.instrumentAsyncIterableStream = $eyueP.instrumentAsyncIterableStream;
module.exports.instrumentMessageStream = $eyueP.instrumentMessageStream;
module.exports.ANTHROPIC_AI_INTEGRATION_NAME = $fx2ii.ANTHROPIC_AI_INTEGRATION_NAME;
module.exports.addGoogleGenAIRequestAttributes = $kqIrz.addPrivateRequestAttributes;
module.exports.addGoogleGenAIResponseAttributes = $kqIrz.addResponseAttributes;
module.exports.extractGoogleGenAIRequestAttributes = $kqIrz.extractRequestAttributes;
module.exports.instrumentGoogleGenAIClient = $kqIrz.instrumentGoogleGenAIClient;
module.exports.instrumentGoogleGenAIStream = $6zRv1.instrumentStream;
module.exports.GOOGLE_GENAI_INTEGRATION_NAME = $boef1.GOOGLE_GENAI_INTEGRATION_NAME;
module.exports.createLangChainCallbackHandler = $l8LMz.createLangChainCallbackHandler;
module.exports._INTERNAL_getLangChainEmbeddingsSpanOptions = $9Af4h._INTERNAL_getLangChainEmbeddingsSpanOptions;
module.exports.instrumentLangChainEmbeddings = $9Af4h.instrumentLangChainEmbeddings;
module.exports._INTERNAL_mergeLangChainCallbackHandler = $1fQ84._INTERNAL_mergeLangChainCallbackHandler;
module.exports.LANGCHAIN_INTEGRATION_NAME = $lhIXN.LANGCHAIN_INTEGRATION_NAME;
module.exports._INTERNAL_getLangGraphCreateAgentSpanOptions = $4xjJr._INTERNAL_getLangGraphCreateAgentSpanOptions;
module.exports.instrumentCompiledGraphInvoke = $4xjJr.instrumentCompiledGraphInvoke;
module.exports.instrumentCreateReactAgent = $4xjJr.instrumentCreateReactAgent;
module.exports.instrumentLangGraph = $4xjJr.instrumentLangGraph;
module.exports.instrumentStateGraphCompile = $4xjJr.instrumentStateGraphCompile;
module.exports.extractAgentNameFromParams = $bSQ9n.extractAgentNameFromParams;
module.exports.extractLLMFromParams = $bSQ9n.extractLLMFromParams;
module.exports.wrapToolsWithSpans = $bSQ9n.wrapToolsWithSpans;
module.exports.LANGGRAPH_INTEGRATION_NAME = $kxKwQ.LANGGRAPH_INTEGRATION_NAME;
module.exports.instrumentWorkersAiClient = $fXIk8.instrumentWorkersAiClient;
module.exports.SpanBuffer = $9HMF4.SpanBuffer;
module.exports.hasSpanStreamingEnabled = $8ICT0.hasSpanStreamingEnabled;
module.exports.spanStreamingIntegration = $hPkVj.spanStreamingIntegration;
module.exports._INTERNAL_FLAG_BUFFER_SIZE = $5EpvI._INTERNAL_FLAG_BUFFER_SIZE;
module.exports._INTERNAL_MAX_FLAGS_PER_SPAN = $5EpvI._INTERNAL_MAX_FLAGS_PER_SPAN;
module.exports._INTERNAL_addFeatureFlagToActiveSpan = $5EpvI._INTERNAL_addFeatureFlagToActiveSpan;
module.exports._INTERNAL_copyFlagsFromScopeToEvent = $5EpvI._INTERNAL_copyFlagsFromScopeToEvent;
module.exports._INTERNAL_insertFlagToScope = $5EpvI._INTERNAL_insertFlagToScope;
module.exports.applyAggregateErrorsToEvent = $20hDs.applyAggregateErrorsToEvent;
module.exports.getBreadcrumbLogLevelFromHttpStatusCode = $1q5J2.getBreadcrumbLogLevelFromHttpStatusCode;
module.exports.dsnFromString = $7E8b3.dsnFromString;
module.exports.dsnToString = $7E8b3.dsnToString;
module.exports.makeDsn = $7E8b3.makeDsn;
module.exports.SentryError = $9rQX1.SentryError;
module.exports.GLOBAL_OBJ = $eP8Ri.GLOBAL_OBJ;
module.exports.addConsoleInstrumentationFilter = $8mzKS.addConsoleInstrumentationFilter;
module.exports.addConsoleInstrumentationHandler = $8mzKS.addConsoleInstrumentationHandler;
module.exports.addFetchEndInstrumentationHandler = $f1mbT.addFetchEndInstrumentationHandler;
module.exports.addFetchInstrumentationHandler = $f1mbT.addFetchInstrumentationHandler;
module.exports.addGlobalErrorInstrumentationHandler = $3AeQc.addGlobalErrorInstrumentationHandler;
module.exports.addGlobalUnhandledRejectionInstrumentationHandler = $4JTi6.addGlobalUnhandledRejectionInstrumentationHandler;
module.exports.addHandler = $1d06v.addHandler;
module.exports.maybeInstrument = $1d06v.maybeInstrument;
module.exports.resetInstrumentationHandlers = $1d06v.resetInstrumentationHandlers;
module.exports.triggerHandlers = $1d06v.triggerHandlers;
module.exports.isDOMError = $dzfKZ.isDOMError;
module.exports.isDOMException = $dzfKZ.isDOMException;
module.exports.isElement = $dzfKZ.isElement;
module.exports.isError = $dzfKZ.isError;
module.exports.isErrorEvent = $dzfKZ.isErrorEvent;
module.exports.isEvent = $dzfKZ.isEvent;
module.exports.isInstanceOf = $dzfKZ.isInstanceOf;
module.exports.isObjectLike = $dzfKZ.isObjectLike;
module.exports.isParameterizedString = $dzfKZ.isParameterizedString;
module.exports.isPlainObject = $dzfKZ.isPlainObject;
module.exports.isPrimitive = $dzfKZ.isPrimitive;
module.exports.isRegExp = $dzfKZ.isRegExp;
module.exports.isString = $dzfKZ.isString;
module.exports.isSyntheticEvent = $dzfKZ.isSyntheticEvent;
module.exports.isThenable = $dzfKZ.isThenable;
module.exports.isVueViewModel = $dzfKZ.isVueViewModel;
module.exports.isBrowser = $kIp0s.isBrowser;
module.exports.CONSOLE_LEVELS = $4gyod.CONSOLE_LEVELS;
module.exports.consoleSandbox = $4gyod.consoleSandbox;
module.exports.debug = $4gyod.debug;
module.exports.originalConsoleMethods = $4gyod.originalConsoleMethods;
module.exports.addContextToFrame = $6JkyB.addContextToFrame;
module.exports.addExceptionMechanism = $6JkyB.addExceptionMechanism;
module.exports.addExceptionTypeValue = $6JkyB.addExceptionTypeValue;
module.exports.checkOrSetAlreadyCaught = $6JkyB.checkOrSetAlreadyCaught;
module.exports.getEventDescription = $6JkyB.getEventDescription;
module.exports.isAlreadyCaptured = $6JkyB.isAlreadyCaptured;
module.exports.parseSemver = $6JkyB.parseSemver;
module.exports.uuid4 = $6JkyB.uuid4;
module.exports.normalize = $eD1cG.normalize;
module.exports.normalizeToSize = $eD1cG.normalizeToSize;
module.exports.normalizeUrlToBase = $eD1cG.normalizeUrlToBase;
module.exports.setNormalizeStringifier = $eD1cG.setNormalizeStringifier;
module.exports.setNormalizationDepthOverrideHint = $c3njb.setNormalizationDepthOverrideHint;
module.exports.setSkipNormalizationHint = $c3njb.setSkipNormalizationHint;
module.exports.addNonEnumerableProperty = $7OVjx.addNonEnumerableProperty;
module.exports.convertToPlainObject = $7OVjx.convertToPlainObject;
module.exports.dropUndefinedKeys = $7OVjx.dropUndefinedKeys;
module.exports.extractExceptionKeysForMessage = $7OVjx.extractExceptionKeysForMessage;
module.exports.fill = $7OVjx.fill;
module.exports.getOriginalFunction = $7OVjx.getOriginalFunction;
module.exports.markFunctionWrapped = $7OVjx.markFunctionWrapped;
module.exports.objectify = $7OVjx.objectify;
module.exports.basename = $btATC.basename;
module.exports.dirname = $btATC.dirname;
module.exports.isAbsolute = $btATC.isAbsolute;
module.exports.join = $btATC.join;
module.exports.normalizePath = $btATC.normalizePath;
module.exports.relative = $btATC.relative;
module.exports.resolve = $btATC.resolve;
module.exports.SENTRY_BUFFER_FULL_ERROR = $gaj81.SENTRY_BUFFER_FULL_ERROR;
module.exports.makePromiseBuffer = $gaj81.makePromiseBuffer;
module.exports.severityLevelFromString = $1VSHh.severityLevelFromString;
module.exports.replaceExports = $5sHNN.replaceExports;
module.exports.UNKNOWN_FUNCTION = $d7glj.UNKNOWN_FUNCTION;
module.exports.createStackParser = $d7glj.createStackParser;
module.exports.getFramesFromEvent = $d7glj.getFramesFromEvent;
module.exports.getFunctionName = $d7glj.getFunctionName;
module.exports.stackParserFromStackParserOptions = $d7glj.stackParserFromStackParserOptions;
module.exports.stripSentryFramesAndReverse = $d7glj.stripSentryFramesAndReverse;
module.exports.isMatchingPattern = $arYVC.isMatchingPattern;
module.exports.safeJoin = $arYVC.safeJoin;
module.exports.snipLine = $arYVC.snipLine;
module.exports.stringMatchesSomePattern = $arYVC.stringMatchesSomePattern;
module.exports.stringify = $arYVC.stringify;
module.exports.truncate = $arYVC.truncate;
module.exports.isNativeFunction = $58ep5.isNativeFunction;
module.exports.supportsDOMError = $58ep5.supportsDOMError;
module.exports.supportsDOMException = $58ep5.supportsDOMException;
module.exports.supportsErrorEvent = $58ep5.supportsErrorEvent;
module.exports.supportsFetch = $58ep5.supportsFetch;
module.exports.supportsHistory = $58ep5.supportsHistory;
module.exports.supportsNativeFetch = $58ep5.supportsNativeFetch;
module.exports.supportsReferrerPolicy = $58ep5.supportsReferrerPolicy;
module.exports.supportsReportingObserver = $58ep5.supportsReportingObserver;
module.exports.SyncPromise = $eligX.SyncPromise;
module.exports.rejectedSyncPromise = $eligX.rejectedSyncPromise;
module.exports.resolvedSyncPromise = $eligX.resolvedSyncPromise;
module.exports.browserPerformanceTimeOrigin = $ihsl1.browserPerformanceTimeOrigin;
module.exports.dateTimestampInSeconds = $ihsl1.dateTimestampInSeconds;
module.exports.timestampInSeconds = $ihsl1.timestampInSeconds;
module.exports.TRACEPARENT_REGEXP = $3ZCGz.TRACEPARENT_REGEXP;
module.exports.extractTraceparentData = $3ZCGz.extractTraceparentData;
module.exports.generateSentryTraceHeader = $3ZCGz.generateSentryTraceHeader;
module.exports.generateTraceparentHeader = $3ZCGz.generateTraceparentHeader;
module.exports.propagationContextFromHeaders = $3ZCGz.propagationContextFromHeaders;
module.exports.shouldContinueTrace = $3ZCGz.shouldContinueTrace;
module.exports.getSDKSource = $h0BBG.getSDKSource;
module.exports.isBrowserBundle = $h0BBG.isBrowserBundle;
module.exports.addItemToEnvelope = $636GJ.addItemToEnvelope;
module.exports.createAttachmentEnvelopeItem = $636GJ.createAttachmentEnvelopeItem;
module.exports.createEnvelope = $636GJ.createEnvelope;
module.exports.createEventEnvelopeHeaders = $636GJ.createEventEnvelopeHeaders;
module.exports.createSpanEnvelopeItem = $636GJ.createSpanEnvelopeItem;
module.exports.envelopeContainsItemType = $636GJ.envelopeContainsItemType;
module.exports.envelopeItemTypeToDataCategory = $636GJ.envelopeItemTypeToDataCategory;
module.exports.forEachEnvelopeItem = $636GJ.forEachEnvelopeItem;
module.exports.getSdkMetadataForEnvelopeHeader = $636GJ.getSdkMetadataForEnvelopeHeader;
module.exports.parseEnvelope = $636GJ.parseEnvelope;
module.exports.serializeEnvelope = $636GJ.serializeEnvelope;
module.exports.createClientReportEnvelope = $6lXp4.createClientReportEnvelope;
module.exports.DEFAULT_RETRY_AFTER = $iLGyZ.DEFAULT_RETRY_AFTER;
module.exports.disabledUntil = $iLGyZ.disabledUntil;
module.exports.isRateLimited = $iLGyZ.isRateLimited;
module.exports.parseRetryAfterHeader = $iLGyZ.parseRetryAfterHeader;
module.exports.updateRateLimits = $iLGyZ.updateRateLimits;
module.exports.MAX_BAGGAGE_STRING_LENGTH = $l5MWU.MAX_BAGGAGE_STRING_LENGTH;
module.exports.SENTRY_BAGGAGE_KEY_PREFIX = $l5MWU.SENTRY_BAGGAGE_KEY_PREFIX;
module.exports.SENTRY_BAGGAGE_KEY_PREFIX_REGEX = $l5MWU.SENTRY_BAGGAGE_KEY_PREFIX_REGEX;
module.exports.baggageHeaderToDynamicSamplingContext = $l5MWU.baggageHeaderToDynamicSamplingContext;
module.exports.dynamicSamplingContextToSentryBaggageHeader = $l5MWU.dynamicSamplingContextToSentryBaggageHeader;
module.exports.mergeBaggageHeaders = $l5MWU.mergeBaggageHeaders;
module.exports.objectToBaggageHeader = $l5MWU.objectToBaggageHeader;
module.exports.parseBaggageHeader = $l5MWU.parseBaggageHeader;
module.exports.getHttpSpanDetailsFromUrlObject = $hLsvb.getHttpSpanDetailsFromUrlObject;
module.exports.getSanitizedUrlString = $hLsvb.getSanitizedUrlString;
module.exports.getSanitizedUrlStringFromUrlObject = $hLsvb.getSanitizedUrlStringFromUrlObject;
module.exports.isURLObjectRelative = $hLsvb.isURLObjectRelative;
module.exports.parseStringToURLObject = $hLsvb.parseStringToURLObject;
module.exports.parseUrl = $hLsvb.parseUrl;
module.exports.stripDataUrlContent = $hLsvb.stripDataUrlContent;
module.exports.stripUrlQueryAndFragment = $hLsvb.stripUrlQueryAndFragment;
module.exports._INTERNAL_enhanceErrorWithSentryInfo = $l3xRy._enhanceErrorWithSentryInfo;
module.exports.eventFromMessage = $l3xRy.eventFromMessage;
module.exports.eventFromUnknownInput = $l3xRy.eventFromUnknownInput;
module.exports.exceptionFromError = $l3xRy.exceptionFromError;
module.exports.parseStackFrames = $l3xRy.parseStackFrames;
module.exports.LRUMap = $kzbBU.LRUMap;
module.exports.generateSpanId = $bLH3w.generateSpanId;
module.exports.generateTraceId = $bLH3w.generateTraceId;
module.exports.SDK_VERSION = $5qT6j.SDK_VERSION;
module.exports.getDebugImagesForResources = $5PTIz.getDebugImagesForResources;
module.exports.getFilenameToDebugIdMap = $5PTIz.getFilenameToDebugIdMap;
module.exports.getFilenameToMetadataMap = $318WW.getFilenameToMetadataMap;
module.exports.escapeStringForRegex = $2K1Wi.escapeStringForRegex;
module.exports._INTERNAL_safeDateNow = $lLUp4.safeDateNow;
module.exports._INTERNAL_safeMathRandom = $lLUp4.safeMathRandom;
module.exports._INTERNAL_withRandomSafeContext = $lLUp4.withRandomSafeContext;
module.exports.getComponentName = $fNJme.getComponentName;
module.exports.getLocationHref = $fNJme.getLocationHref;
module.exports.htmlTreeAsString = $fNJme.htmlTreeAsString;

});
parcelRegister("kYwtu", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $hiZR1 = parcelRequire("hiZR1");

var $3AeQc = parcelRequire("3AeQc");

var $4JTi6 = parcelRequire("4JTi6");

var $4gyod = parcelRequire("4gyod");

var $8jbnX = parcelRequire("8jbnX");

var $yI1C9 = parcelRequire("yI1C9");
let $f4529a05c2b6a2e6$var$errorsInstrumented = false;
function $f4529a05c2b6a2e6$var$registerSpanErrorInstrumentation() {
    if ($f4529a05c2b6a2e6$var$errorsInstrumented) return;
    function errorCallback() {
        const activeSpan = $8jbnX.getActiveSpan();
        const rootSpan = activeSpan && $8jbnX.getRootSpan(activeSpan);
        if (rootSpan) {
            const message = "internal_error";
            $hiZR1.DEBUG_BUILD && $4gyod.debug.log(`[Tracing] Root span: ${message} -> Global error occurred`);
            rootSpan.setStatus({
                code: $yI1C9.SPAN_STATUS_ERROR,
                message: message
            });
        }
    }
    $f4529a05c2b6a2e6$var$errorsInstrumented = true;
    $3AeQc.addGlobalErrorInstrumentationHandler(errorCallback);
    $4JTi6.addGlobalUnhandledRejectionInstrumentationHandler(errorCallback);
}
module.exports.registerSpanErrorInstrumentation = $f4529a05c2b6a2e6$var$registerSpanErrorInstrumentation;

});
parcelRegister("hiZR1", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $c994190d382791e4$var$DEBUG_BUILD = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;
module.exports.DEBUG_BUILD = $c994190d382791e4$var$DEBUG_BUILD;

});

parcelRegister("3AeQc", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $eP8Ri = parcelRequire("eP8Ri");

var $1d06v = parcelRequire("1d06v");
let $29c03efa328e3b11$var$_oldOnErrorHandler = null;
function $29c03efa328e3b11$var$addGlobalErrorInstrumentationHandler(handler) {
    const type = "error";
    $1d06v.addHandler(type, handler);
    $1d06v.maybeInstrument(type, $29c03efa328e3b11$var$instrumentError);
}
function $29c03efa328e3b11$var$instrumentError() {
    $29c03efa328e3b11$var$_oldOnErrorHandler = $eP8Ri.GLOBAL_OBJ.onerror;
    $eP8Ri.GLOBAL_OBJ.onerror = function(msg, url, line, column, error) {
        const handlerData = {
            column: column,
            error: error,
            line: line,
            msg: msg,
            url: url
        };
        $1d06v.triggerHandlers("error", handlerData);
        if ($29c03efa328e3b11$var$_oldOnErrorHandler) return $29c03efa328e3b11$var$_oldOnErrorHandler.apply(this, arguments);
        return false;
    };
    $eP8Ri.GLOBAL_OBJ.onerror.__SENTRY_INSTRUMENTED__ = true;
}
module.exports.addGlobalErrorInstrumentationHandler = $29c03efa328e3b11$var$addGlobalErrorInstrumentationHandler;

});
parcelRegister("eP8Ri", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $acacb33e50aba64b$var$GLOBAL_OBJ = globalThis;
module.exports.GLOBAL_OBJ = $acacb33e50aba64b$var$GLOBAL_OBJ;

});

parcelRegister("1d06v", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $hiZR1 = parcelRequire("hiZR1");

var $4gyod = parcelRequire("4gyod");

var $d7glj = parcelRequire("d7glj");
const $0e1716011a5e2a87$var$handlers = {};
const $0e1716011a5e2a87$var$instrumented = {};
function $0e1716011a5e2a87$var$addHandler(type, handler) {
    $0e1716011a5e2a87$var$handlers[type] = $0e1716011a5e2a87$var$handlers[type] || [];
    $0e1716011a5e2a87$var$handlers[type].push(handler);
    return ()=>{
        const typeHandlers = $0e1716011a5e2a87$var$handlers[type];
        if (typeHandlers) {
            const index = typeHandlers.indexOf(handler);
            if (index !== -1) typeHandlers.splice(index, 1);
        }
    };
}
function $0e1716011a5e2a87$var$resetInstrumentationHandlers() {
    Object.keys($0e1716011a5e2a87$var$handlers).forEach((key)=>{
        $0e1716011a5e2a87$var$handlers[key] = void 0;
    });
}
function $0e1716011a5e2a87$var$maybeInstrument(type, instrumentFn) {
    if (!$0e1716011a5e2a87$var$instrumented[type]) {
        $0e1716011a5e2a87$var$instrumented[type] = true;
        try {
            instrumentFn();
        } catch (e) {
            $hiZR1.DEBUG_BUILD && $4gyod.debug.error(`Error while instrumenting ${type}`, e);
        }
    }
}
function $0e1716011a5e2a87$var$triggerHandlers(type, data) {
    const typeHandlers = type && $0e1716011a5e2a87$var$handlers[type];
    if (!typeHandlers) return;
    for (const handler of typeHandlers)try {
        handler(data);
    } catch (e) {
        $hiZR1.DEBUG_BUILD && $4gyod.debug.error(`Error while triggering instrumentation handler.
Type: ${type}
Name: ${$d7glj.getFunctionName(handler)}
Error:`, e);
    }
}
module.exports.addHandler = $0e1716011a5e2a87$var$addHandler;
module.exports.maybeInstrument = $0e1716011a5e2a87$var$maybeInstrument;
module.exports.resetInstrumentationHandlers = $0e1716011a5e2a87$var$resetInstrumentationHandlers;
module.exports.triggerHandlers = $0e1716011a5e2a87$var$triggerHandlers;

});
parcelRegister("4gyod", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $4fnou = parcelRequire("4fnou");

var $hiZR1 = parcelRequire("hiZR1");

var $eP8Ri = parcelRequire("eP8Ri");
const $31b3551375eaace1$var$CONSOLE_LEVELS = [
    "debug",
    "info",
    "warn",
    "error",
    "log",
    "assert",
    "trace"
];
const $31b3551375eaace1$var$PREFIX = "Sentry Logger ";
const $31b3551375eaace1$var$originalConsoleMethods = {};
function $31b3551375eaace1$var$consoleSandbox(callback) {
    if (!("console" in $eP8Ri.GLOBAL_OBJ)) return callback();
    const console = $eP8Ri.GLOBAL_OBJ.console;
    const wrappedFuncs = {};
    const wrappedLevels = Object.keys($31b3551375eaace1$var$originalConsoleMethods);
    wrappedLevels.forEach((level)=>{
        const originalConsoleMethod = $31b3551375eaace1$var$originalConsoleMethods[level];
        wrappedFuncs[level] = console[level];
        console[level] = originalConsoleMethod;
    });
    try {
        return callback();
    } finally{
        wrappedLevels.forEach((level)=>{
            console[level] = wrappedFuncs[level];
        });
    }
}
function $31b3551375eaace1$var$enable() {
    $31b3551375eaace1$var$_getLoggerSettings().enabled = true;
}
function $31b3551375eaace1$var$disable() {
    $31b3551375eaace1$var$_getLoggerSettings().enabled = false;
}
function $31b3551375eaace1$var$isEnabled() {
    return $31b3551375eaace1$var$_getLoggerSettings().enabled;
}
function $31b3551375eaace1$var$log(...args) {
    $31b3551375eaace1$var$_maybeLog("log", ...args);
}
function $31b3551375eaace1$var$warn(...args) {
    $31b3551375eaace1$var$_maybeLog("warn", ...args);
}
function $31b3551375eaace1$var$error(...args) {
    $31b3551375eaace1$var$_maybeLog("error", ...args);
}
function $31b3551375eaace1$var$_maybeLog(level, ...args) {
    if (!$hiZR1.DEBUG_BUILD) return;
    if ($31b3551375eaace1$var$isEnabled()) $31b3551375eaace1$var$consoleSandbox(()=>{
        $eP8Ri.GLOBAL_OBJ.console[level](`${$31b3551375eaace1$var$PREFIX}[${level}]:`, ...args);
    });
}
function $31b3551375eaace1$var$_getLoggerSettings() {
    if (!$hiZR1.DEBUG_BUILD) return {
        enabled: false
    };
    return $4fnou.getGlobalSingleton("loggerSettings", ()=>({
            enabled: false
        }));
}
const $31b3551375eaace1$var$debug = {
    enable: /** Enable logging. */ $31b3551375eaace1$var$enable,
    disable: /** Disable logging. */ $31b3551375eaace1$var$disable,
    isEnabled: /** Check if logging is enabled. */ $31b3551375eaace1$var$isEnabled,
    log: /** Log a message. */ $31b3551375eaace1$var$log,
    warn: /** Log a warning. */ $31b3551375eaace1$var$warn,
    error: /** Log an error. */ $31b3551375eaace1$var$error
};
module.exports.CONSOLE_LEVELS = $31b3551375eaace1$var$CONSOLE_LEVELS;
module.exports.consoleSandbox = $31b3551375eaace1$var$consoleSandbox;
module.exports.debug = $31b3551375eaace1$var$debug;
module.exports.originalConsoleMethods = $31b3551375eaace1$var$originalConsoleMethods;

});
parcelRegister("4fnou", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $5qT6j = parcelRequire("5qT6j");

var $eP8Ri = parcelRequire("eP8Ri");
function $317ab5b3956cc772$var$getMainCarrier() {
    $317ab5b3956cc772$var$getSentryCarrier($eP8Ri.GLOBAL_OBJ);
    return $eP8Ri.GLOBAL_OBJ;
}
function $317ab5b3956cc772$var$getSentryCarrier(carrier) {
    const __SENTRY__ = carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    __SENTRY__.version = __SENTRY__.version || $5qT6j.SDK_VERSION;
    return __SENTRY__[$5qT6j.SDK_VERSION] = __SENTRY__[$5qT6j.SDK_VERSION] || {};
}
function $317ab5b3956cc772$var$getGlobalSingleton(name, creator, obj = $eP8Ri.GLOBAL_OBJ) {
    const __SENTRY__ = obj.__SENTRY__ = obj.__SENTRY__ || {};
    const carrier = __SENTRY__[$5qT6j.SDK_VERSION] = __SENTRY__[$5qT6j.SDK_VERSION] || {};
    return carrier[name] || (carrier[name] = creator());
}
module.exports.getGlobalSingleton = $317ab5b3956cc772$var$getGlobalSingleton;
module.exports.getMainCarrier = $317ab5b3956cc772$var$getMainCarrier;
module.exports.getSentryCarrier = $317ab5b3956cc772$var$getSentryCarrier;

});
parcelRegister("5qT6j", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $3f4a1f56410ff80b$var$SDK_VERSION = "10.67.0";
module.exports.SDK_VERSION = $3f4a1f56410ff80b$var$SDK_VERSION;

});



parcelRegister("d7glj", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $98c89b1d47f7cf33$var$STACKTRACE_FRAME_LIMIT = 50;
const $98c89b1d47f7cf33$var$UNKNOWN_FUNCTION = "?";
const $98c89b1d47f7cf33$var$WEBPACK_ERROR_REGEXP = /\(error: (.*)\)/;
const $98c89b1d47f7cf33$var$STRIP_FRAME_REGEXP = /captureMessage|captureException/;
function $98c89b1d47f7cf33$var$createStackParser(...parsers) {
    const sortedParsers = parsers.sort((a, b)=>a[0] - b[0]).map((p)=>p[1]);
    return (stack, skipFirstLines = 0, framesToPop = 0)=>{
        const frames = [];
        const lines = stack.split("\n");
        for(let i = skipFirstLines; i < lines.length; i++){
            let line = lines[i];
            if (line.length > 1024) line = line.slice(0, 1024);
            const cleanedLine = $98c89b1d47f7cf33$var$WEBPACK_ERROR_REGEXP.test(line) ? line.replace($98c89b1d47f7cf33$var$WEBPACK_ERROR_REGEXP, "$1") : line;
            if (cleanedLine.includes("Error: ")) continue;
            for (const parser of sortedParsers){
                const frame = parser(cleanedLine);
                if (frame) {
                    frames.push(frame);
                    break;
                }
            }
            if (frames.length >= $98c89b1d47f7cf33$var$STACKTRACE_FRAME_LIMIT + framesToPop) break;
        }
        return $98c89b1d47f7cf33$var$stripSentryFramesAndReverse(frames.slice(framesToPop));
    };
}
function $98c89b1d47f7cf33$var$stackParserFromStackParserOptions(stackParser) {
    if (Array.isArray(stackParser)) return $98c89b1d47f7cf33$var$createStackParser(...stackParser);
    return stackParser;
}
function $98c89b1d47f7cf33$var$stripSentryFramesAndReverse(stack) {
    if (!stack.length) return [];
    const localStack = Array.from(stack);
    if (/sentryWrapped/.test($98c89b1d47f7cf33$var$getLastStackFrame(localStack).function || "")) localStack.pop();
    localStack.reverse();
    if ($98c89b1d47f7cf33$var$STRIP_FRAME_REGEXP.test($98c89b1d47f7cf33$var$getLastStackFrame(localStack).function || "")) {
        localStack.pop();
        if ($98c89b1d47f7cf33$var$STRIP_FRAME_REGEXP.test($98c89b1d47f7cf33$var$getLastStackFrame(localStack).function || "")) localStack.pop();
    }
    return localStack.slice(0, $98c89b1d47f7cf33$var$STACKTRACE_FRAME_LIMIT).map((frame)=>({
            ...frame,
            filename: frame.filename || $98c89b1d47f7cf33$var$getLastStackFrame(localStack).filename,
            function: frame.function || $98c89b1d47f7cf33$var$UNKNOWN_FUNCTION
        }));
}
function $98c89b1d47f7cf33$var$getLastStackFrame(arr) {
    return arr[arr.length - 1] || {};
}
const $98c89b1d47f7cf33$var$defaultFunctionName = "<anonymous>";
function $98c89b1d47f7cf33$var$getFunctionName(fn) {
    try {
        if (!fn || typeof fn !== "function") return $98c89b1d47f7cf33$var$defaultFunctionName;
        return fn.name || $98c89b1d47f7cf33$var$defaultFunctionName;
    } catch  {
        return $98c89b1d47f7cf33$var$defaultFunctionName;
    }
}
function $98c89b1d47f7cf33$var$getFramesFromEvent(event) {
    const exception = event.exception;
    if (exception) {
        const frames = [];
        try {
            exception.values.forEach((value)=>{
                if (value.stacktrace.frames) frames.push(...value.stacktrace.frames);
            });
            return frames;
        } catch  {
            return void 0;
        }
    }
    return void 0;
}
function $98c89b1d47f7cf33$var$normalizeStackTracePath(path) {
    let filename = path?.startsWith("file://") ? path.slice(7) : path;
    if (filename?.match(/\/[A-Z]:/)) filename = filename.slice(1);
    return filename;
}
module.exports.UNKNOWN_FUNCTION = $98c89b1d47f7cf33$var$UNKNOWN_FUNCTION;
module.exports.createStackParser = $98c89b1d47f7cf33$var$createStackParser;
module.exports.getFramesFromEvent = $98c89b1d47f7cf33$var$getFramesFromEvent;
module.exports.getFunctionName = $98c89b1d47f7cf33$var$getFunctionName;
module.exports.normalizeStackTracePath = $98c89b1d47f7cf33$var$normalizeStackTracePath;
module.exports.stackParserFromStackParserOptions = $98c89b1d47f7cf33$var$stackParserFromStackParserOptions;
module.exports.stripSentryFramesAndReverse = $98c89b1d47f7cf33$var$stripSentryFramesAndReverse;

});



parcelRegister("4JTi6", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $eP8Ri = parcelRequire("eP8Ri");

var $1d06v = parcelRequire("1d06v");
let $37364106459fae5c$var$_oldOnUnhandledRejectionHandler = null;
function $37364106459fae5c$var$addGlobalUnhandledRejectionInstrumentationHandler(handler) {
    const type = "unhandledrejection";
    $1d06v.addHandler(type, handler);
    $1d06v.maybeInstrument(type, $37364106459fae5c$var$instrumentUnhandledRejection);
}
function $37364106459fae5c$var$instrumentUnhandledRejection() {
    $37364106459fae5c$var$_oldOnUnhandledRejectionHandler = $eP8Ri.GLOBAL_OBJ.onunhandledrejection;
    $eP8Ri.GLOBAL_OBJ.onunhandledrejection = function(e) {
        const handlerData = e;
        $1d06v.triggerHandlers("unhandledrejection", handlerData);
        if ($37364106459fae5c$var$_oldOnUnhandledRejectionHandler) return $37364106459fae5c$var$_oldOnUnhandledRejectionHandler.apply(this, arguments);
        return true;
    };
    $eP8Ri.GLOBAL_OBJ.onunhandledrejection.__SENTRY_INSTRUMENTED__ = true;
}
module.exports.addGlobalUnhandledRejectionInstrumentationHandler = $37364106459fae5c$var$addGlobalUnhandledRejectionInstrumentationHandler;

});

parcelRegister("8jbnX", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $diBhM = parcelRequire("diBhM");

var $iSFYH = parcelRequire("iSFYH");

var $4fnou = parcelRequire("4fnou");

var $79m2C = parcelRequire("79m2C");

var $gTasE = parcelRequire("gTasE");

var $yI1C9 = parcelRequire("yI1C9");

var $bkBh2 = parcelRequire("bkBh2");

var $7OVjx = parcelRequire("7OVjx");

var $bLH3w = parcelRequire("bLH3w");

var $ihsl1 = parcelRequire("ihsl1");

var $3ZCGz = parcelRequire("3ZCGz");

var $4gyod = parcelRequire("4gyod");

var $f9GTk = parcelRequire("f9GTk");
const $60c8edfa32b97b59$var$TRACE_FLAG_NONE = 0;
const $60c8edfa32b97b59$var$TRACE_FLAG_SAMPLED = 1;
let $60c8edfa32b97b59$var$hasShownSpanDropWarning = false;
function $60c8edfa32b97b59$var$spanToTransactionTraceContext(span) {
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    const { data: data, op: op, parent_span_id: parent_span_id, status: status, origin: origin, links: links } = $60c8edfa32b97b59$var$spanToJSON(span);
    return {
        parent_span_id: parent_span_id,
        span_id: span_id,
        trace_id: trace_id,
        data: data,
        op: op,
        status: status,
        origin: origin,
        links: links
    };
}
function $60c8edfa32b97b59$var$spanToTraceContext(span) {
    const { spanId: spanId, traceId: trace_id, isRemote: isRemote } = span.spanContext();
    const parent_span_id = isRemote ? spanId : $60c8edfa32b97b59$var$spanToJSON(span).parent_span_id;
    const scope = $bkBh2.getCapturedScopesOnSpan(span).scope;
    const span_id = isRemote ? scope?.getPropagationContext().propagationSpanId || $bLH3w.generateSpanId() : spanId;
    return {
        parent_span_id: parent_span_id,
        span_id: span_id,
        trace_id: trace_id
    };
}
function $60c8edfa32b97b59$var$spanToTraceHeader(span) {
    const { traceId: traceId, spanId: spanId } = span.spanContext();
    const sampled = $60c8edfa32b97b59$var$spanIsSampled(span);
    return $3ZCGz.generateSentryTraceHeader(traceId, spanId, sampled);
}
function $60c8edfa32b97b59$var$spanToTraceparentHeader(span) {
    const { traceId: traceId, spanId: spanId } = span.spanContext();
    const sampled = $60c8edfa32b97b59$var$spanIsSampled(span);
    return $3ZCGz.generateTraceparentHeader(traceId, spanId, sampled);
}
function $60c8edfa32b97b59$var$convertSpanLinksForEnvelope(links) {
    if (links && links.length > 0) return links.map(({ context: { spanId: spanId, traceId: traceId, traceFlags: traceFlags, ...restContext }, attributes: attributes })=>({
            span_id: spanId,
            trace_id: traceId,
            sampled: traceFlags === $60c8edfa32b97b59$var$TRACE_FLAG_SAMPLED,
            attributes: attributes,
            ...restContext
        }));
    else return void 0;
}
function $60c8edfa32b97b59$var$getStreamedSpanLinks(links) {
    if (links?.length) return links.map(({ context: { spanId: spanId, traceId: traceId, traceFlags: traceFlags }, attributes: attributes })=>({
            span_id: spanId,
            trace_id: traceId,
            sampled: traceFlags === $60c8edfa32b97b59$var$TRACE_FLAG_SAMPLED,
            attributes: attributes
        }));
    else return void 0;
}
function $60c8edfa32b97b59$var$spanTimeInputToSeconds(input) {
    if (typeof input === "number") return $60c8edfa32b97b59$var$ensureTimestampInSeconds(input);
    if (Array.isArray(input)) return input[0] + input[1] / 1e9;
    if (input instanceof Date) return $60c8edfa32b97b59$var$ensureTimestampInSeconds(input.getTime());
    return $ihsl1.timestampInSeconds();
}
function $60c8edfa32b97b59$var$ensureTimestampInSeconds(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp / 1e3 : timestamp;
}
function $60c8edfa32b97b59$var$spanToJSON(span) {
    if ($60c8edfa32b97b59$var$spanIsSentrySpan(span)) return span.getSpanJSON();
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    if ($60c8edfa32b97b59$var$spanIsOpenTelemetrySdkTraceBaseSpan(span)) {
        const { attributes: attributes, startTime: startTime, name: name, endTime: endTime, status: status, links: links } = span;
        return {
            span_id: span_id,
            trace_id: trace_id,
            data: attributes,
            description: name,
            parent_span_id: $60c8edfa32b97b59$var$getOtelParentSpanId(span),
            start_timestamp: $60c8edfa32b97b59$var$spanTimeInputToSeconds(startTime),
            // This is [0,0] by default in OTEL, in which case we want to interpret this as no end time
            timestamp: $60c8edfa32b97b59$var$spanTimeInputToSeconds(endTime) || void 0,
            status: $60c8edfa32b97b59$var$getStatusMessage(status),
            op: attributes[$gTasE.SEMANTIC_ATTRIBUTE_SENTRY_OP],
            origin: attributes[$gTasE.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN],
            links: $60c8edfa32b97b59$var$convertSpanLinksForEnvelope(links)
        };
    }
    return {
        span_id: span_id,
        trace_id: trace_id,
        start_timestamp: 0,
        data: {}
    };
}
function $60c8edfa32b97b59$var$spanToStreamedSpanJSON(span) {
    if ($60c8edfa32b97b59$var$spanIsSentrySpan(span)) return span.getStreamedSpanJSON();
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    if ($60c8edfa32b97b59$var$spanIsOpenTelemetrySdkTraceBaseSpan(span)) {
        const { attributes: attributes, startTime: startTime, name: name, endTime: endTime, status: status, links: links } = span;
        return {
            name: name,
            span_id: span_id,
            trace_id: trace_id,
            parent_span_id: $60c8edfa32b97b59$var$getOtelParentSpanId(span),
            start_timestamp: $60c8edfa32b97b59$var$spanTimeInputToSeconds(startTime),
            end_timestamp: $60c8edfa32b97b59$var$spanTimeInputToSeconds(endTime),
            is_segment: span === $60c8edfa32b97b59$var$INTERNAL_getSegmentSpan(span),
            status: $60c8edfa32b97b59$var$getSimpleStatus(status),
            attributes: $60c8edfa32b97b59$var$addStatusMessageAttribute(attributes, status),
            links: $60c8edfa32b97b59$var$getStreamedSpanLinks(links)
        };
    }
    return {
        span_id: span_id,
        trace_id: trace_id,
        start_timestamp: 0,
        name: "",
        end_timestamp: 0,
        status: "ok",
        is_segment: span === $60c8edfa32b97b59$var$INTERNAL_getSegmentSpan(span)
    };
}
function $60c8edfa32b97b59$var$getOtelParentSpanId(span) {
    return "parentSpanId" in span ? span.parentSpanId : "parentSpanContext" in span ? span.parentSpanContext?.spanId : void 0;
}
function $60c8edfa32b97b59$var$streamedSpanJsonToSerializedSpan(spanJson) {
    return {
        ...spanJson,
        attributes: $iSFYH.serializeAttributes(spanJson.attributes),
        links: spanJson.links?.map((link)=>({
                ...link,
                attributes: $iSFYH.serializeAttributes(link.attributes)
            }))
    };
}
function $60c8edfa32b97b59$var$spanIsOpenTelemetrySdkTraceBaseSpan(span) {
    const castSpan = span;
    return !!castSpan.attributes && !!castSpan.startTime && !!castSpan.name && !!castSpan.endTime && !!castSpan.status;
}
function $60c8edfa32b97b59$var$spanIsSentrySpan(span) {
    return typeof span.getSpanJSON === "function";
}
function $60c8edfa32b97b59$var$spanIsSampled(span) {
    const { traceFlags: traceFlags } = span.spanContext();
    return traceFlags === $60c8edfa32b97b59$var$TRACE_FLAG_SAMPLED;
}
function $60c8edfa32b97b59$var$getStatusMessage(status) {
    if (!status || status.code === $yI1C9.SPAN_STATUS_UNSET) return void 0;
    if (status.code === $yI1C9.SPAN_STATUS_OK) return "ok";
    return status.message || "internal_error";
}
function $60c8edfa32b97b59$var$getSimpleStatus(status) {
    return !status || status.code === $yI1C9.SPAN_STATUS_OK || status.code === $yI1C9.SPAN_STATUS_UNSET || status.message === "cancelled" ? "ok" : "error";
}
function $60c8edfa32b97b59$var$addStatusMessageAttribute(attributes, status) {
    const statusMessage = $60c8edfa32b97b59$var$getSimpleStatus(status) === "error" ? status?.message : void 0;
    return {
        ...statusMessage && {
            [$gTasE.SEMANTIC_ATTRIBUTE_SENTRY_STATUS_MESSAGE]: statusMessage
        },
        ...attributes
    };
}
const $60c8edfa32b97b59$var$CHILD_SPANS_FIELD = "_sentryChildSpans";
const $60c8edfa32b97b59$var$ROOT_SPAN_FIELD = "_sentryRootSpan";
function $60c8edfa32b97b59$var$addChildSpanToSpan(span, childSpan) {
    const rootSpan = span[$60c8edfa32b97b59$var$ROOT_SPAN_FIELD] || span;
    $7OVjx.addNonEnumerableProperty(childSpan, $60c8edfa32b97b59$var$ROOT_SPAN_FIELD, rootSpan);
    if (span[$60c8edfa32b97b59$var$CHILD_SPANS_FIELD]) span[$60c8edfa32b97b59$var$CHILD_SPANS_FIELD].add(childSpan);
    else $7OVjx.addNonEnumerableProperty(span, $60c8edfa32b97b59$var$CHILD_SPANS_FIELD, /* @__PURE__ */ new Set([
        childSpan
    ]));
}
function $60c8edfa32b97b59$var$removeChildSpanFromSpan(span, childSpan) {
    if (span[$60c8edfa32b97b59$var$CHILD_SPANS_FIELD]) span[$60c8edfa32b97b59$var$CHILD_SPANS_FIELD].delete(childSpan);
}
function $60c8edfa32b97b59$var$getSpanDescendants(span) {
    const resultSet = /* @__PURE__ */ new Set();
    function addSpanChildren(span2) {
        if (resultSet.has(span2)) return;
        else if ($60c8edfa32b97b59$var$spanIsSampled(span2)) {
            resultSet.add(span2);
            const childSpans = span2[$60c8edfa32b97b59$var$CHILD_SPANS_FIELD] ? Array.from(span2[$60c8edfa32b97b59$var$CHILD_SPANS_FIELD]) : [];
            for (const childSpan of childSpans)addSpanChildren(childSpan);
        }
    }
    addSpanChildren(span);
    return Array.from(resultSet);
}
const $60c8edfa32b97b59$var$getRootSpan = $60c8edfa32b97b59$var$INTERNAL_getSegmentSpan;
function $60c8edfa32b97b59$var$INTERNAL_getSegmentSpan(span) {
    return span[$60c8edfa32b97b59$var$ROOT_SPAN_FIELD] || span;
}
function $60c8edfa32b97b59$var$getActiveSpan() {
    const carrier$1 = $4fnou.getMainCarrier();
    const acs = $diBhM.getAsyncContextStrategy(carrier$1);
    if (acs.getActiveSpan) return acs.getActiveSpan();
    return $f9GTk._getSpanForScope($79m2C.getCurrentScope());
}
function $60c8edfa32b97b59$var$showSpanDropWarning() {
    if (!$60c8edfa32b97b59$var$hasShownSpanDropWarning) {
        $4gyod.consoleSandbox(()=>{
            console.warn("[Sentry] Returning null from `beforeSendSpan` is disallowed. To drop certain spans, configure the respective integrations directly or use `ignoreSpans`.");
        });
        $60c8edfa32b97b59$var$hasShownSpanDropWarning = true;
    }
}
function $60c8edfa32b97b59$var$updateSpanName(span, name) {
    span.updateName(name);
    span.setAttributes({
        [$gTasE.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE]: "custom",
        [$gTasE.SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME]: name
    });
}
module.exports.INTERNAL_getSegmentSpan = $60c8edfa32b97b59$var$INTERNAL_getSegmentSpan;
module.exports.TRACE_FLAG_NONE = $60c8edfa32b97b59$var$TRACE_FLAG_NONE;
module.exports.TRACE_FLAG_SAMPLED = $60c8edfa32b97b59$var$TRACE_FLAG_SAMPLED;
module.exports.addChildSpanToSpan = $60c8edfa32b97b59$var$addChildSpanToSpan;
module.exports.addStatusMessageAttribute = $60c8edfa32b97b59$var$addStatusMessageAttribute;
module.exports.convertSpanLinksForEnvelope = $60c8edfa32b97b59$var$convertSpanLinksForEnvelope;
module.exports.getActiveSpan = $60c8edfa32b97b59$var$getActiveSpan;
module.exports.getRootSpan = $60c8edfa32b97b59$var$getRootSpan;
module.exports.getSimpleStatus = $60c8edfa32b97b59$var$getSimpleStatus;
module.exports.getSpanDescendants = $60c8edfa32b97b59$var$getSpanDescendants;
module.exports.getStatusMessage = $60c8edfa32b97b59$var$getStatusMessage;
module.exports.getStreamedSpanLinks = $60c8edfa32b97b59$var$getStreamedSpanLinks;
module.exports.removeChildSpanFromSpan = $60c8edfa32b97b59$var$removeChildSpanFromSpan;
module.exports.showSpanDropWarning = $60c8edfa32b97b59$var$showSpanDropWarning;
module.exports.spanIsSampled = $60c8edfa32b97b59$var$spanIsSampled;
module.exports.spanIsSentrySpan = $60c8edfa32b97b59$var$spanIsSentrySpan;
module.exports.spanTimeInputToSeconds = $60c8edfa32b97b59$var$spanTimeInputToSeconds;
module.exports.spanToJSON = $60c8edfa32b97b59$var$spanToJSON;
module.exports.spanToStreamedSpanJSON = $60c8edfa32b97b59$var$spanToStreamedSpanJSON;
module.exports.spanToTraceContext = $60c8edfa32b97b59$var$spanToTraceContext;
module.exports.spanToTraceHeader = $60c8edfa32b97b59$var$spanToTraceHeader;
module.exports.spanToTraceparentHeader = $60c8edfa32b97b59$var$spanToTraceparentHeader;
module.exports.spanToTransactionTraceContext = $60c8edfa32b97b59$var$spanToTransactionTraceContext;
module.exports.streamedSpanJsonToSerializedSpan = $60c8edfa32b97b59$var$streamedSpanJsonToSerializedSpan;
module.exports.updateSpanName = $60c8edfa32b97b59$var$updateSpanName;

});
parcelRegister("diBhM", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $4fnou = parcelRequire("4fnou");

var $crUAf = parcelRequire("crUAf");
function $9ae9e0fb78b52c14$var$setAsyncContextStrategy(strategy) {
    const registry = $4fnou.getMainCarrier();
    const sentry = $4fnou.getSentryCarrier(registry);
    sentry.acs = strategy;
}
function $9ae9e0fb78b52c14$var$getAsyncContextStrategy(carrier$1) {
    const sentry = $4fnou.getSentryCarrier(carrier$1);
    if (sentry.acs) return sentry.acs;
    return $crUAf.getStackAsyncContextStrategy();
}
module.exports.getAsyncContextStrategy = $9ae9e0fb78b52c14$var$getAsyncContextStrategy;
module.exports.setAsyncContextStrategy = $9ae9e0fb78b52c14$var$setAsyncContextStrategy;

});
parcelRegister("crUAf", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $ThQQg = parcelRequire("ThQQg");

var $d3JtV = parcelRequire("d3JtV");

var $lVeNe = parcelRequire("lVeNe");

var $dzfKZ = parcelRequire("dzfKZ");

var $4fnou = parcelRequire("4fnou");
class $9103e5f9a4fdcb27$var$AsyncContextStack {
    constructor(scope$1, isolationScope){
        let assignedScope;
        if (!scope$1) assignedScope = new $d3JtV.Scope();
        else assignedScope = scope$1;
        let assignedIsolationScope;
        if (!isolationScope) assignedIsolationScope = new $d3JtV.Scope();
        else assignedIsolationScope = isolationScope;
        this._stack = [
            {
                scope: assignedScope
            }
        ];
        this._isolationScope = assignedIsolationScope;
    }
    /**
   * Fork a scope for the stack.
   */ withScope(callback) {
        const scope = this._pushScope();
        let maybePromiseResult;
        try {
            maybePromiseResult = callback(scope);
        } catch (e) {
            this._popScope();
            throw e;
        }
        if ($dzfKZ.isThenable(maybePromiseResult)) return $lVeNe.chainAndCopyPromiseLike(maybePromiseResult, ()=>this._popScope(), ()=>this._popScope());
        this._popScope();
        return maybePromiseResult;
    }
    /**
   * Get the client of the stack.
   */ getClient() {
        return this.getStackTop().client;
    }
    /**
   * Returns the scope of the top stack.
   */ getScope() {
        return this.getStackTop().scope;
    }
    /**
   * Get the isolation scope for the stack.
   */ getIsolationScope() {
        return this._isolationScope;
    }
    /**
   * Returns the topmost scope layer in the order domain > local > process.
   */ getStackTop() {
        return this._stack[this._stack.length - 1];
    }
    /**
   * Push a scope to the stack.
   */ _pushScope() {
        const scope = this.getScope().clone();
        this._stack.push({
            client: this.getClient(),
            scope: scope
        });
        return scope;
    }
    /**
   * Pop a scope from the stack.
   */ _popScope() {
        if (this._stack.length <= 1) return false;
        return !!this._stack.pop();
    }
}
function $9103e5f9a4fdcb27$var$getAsyncContextStack() {
    const registry = $4fnou.getMainCarrier();
    const sentry = $4fnou.getSentryCarrier(registry);
    return sentry.stack = sentry.stack || new $9103e5f9a4fdcb27$var$AsyncContextStack($ThQQg.getDefaultCurrentScope(), $ThQQg.getDefaultIsolationScope());
}
function $9103e5f9a4fdcb27$var$withScope(callback) {
    return $9103e5f9a4fdcb27$var$getAsyncContextStack().withScope(callback);
}
function $9103e5f9a4fdcb27$var$withSetScope(scope, callback) {
    const stack = $9103e5f9a4fdcb27$var$getAsyncContextStack();
    return stack.withScope(()=>{
        stack.getStackTop().scope = scope;
        return callback(scope);
    });
}
function $9103e5f9a4fdcb27$var$withIsolationScope(callback) {
    return $9103e5f9a4fdcb27$var$getAsyncContextStack().withScope(()=>{
        return callback($9103e5f9a4fdcb27$var$getAsyncContextStack().getIsolationScope());
    });
}
function $9103e5f9a4fdcb27$var$getStackAsyncContextStrategy() {
    return {
        withIsolationScope: $9103e5f9a4fdcb27$var$withIsolationScope,
        withScope: $9103e5f9a4fdcb27$var$withScope,
        withSetScope: $9103e5f9a4fdcb27$var$withSetScope,
        withSetIsolationScope: (_isolationScope, callback)=>{
            return $9103e5f9a4fdcb27$var$withIsolationScope(callback);
        },
        getCurrentScope: ()=>$9103e5f9a4fdcb27$var$getAsyncContextStack().getScope(),
        getIsolationScope: ()=>$9103e5f9a4fdcb27$var$getAsyncContextStack().getIsolationScope()
    };
}
module.exports.AsyncContextStack = $9103e5f9a4fdcb27$var$AsyncContextStack;
module.exports.getStackAsyncContextStrategy = $9103e5f9a4fdcb27$var$getStackAsyncContextStrategy;

});
parcelRegister("ThQQg", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $4fnou = parcelRequire("4fnou");

var $d3JtV = parcelRequire("d3JtV");
function $0a62fc102c00540e$var$getDefaultCurrentScope() {
    return $4fnou.getGlobalSingleton("defaultCurrentScope", ()=>new $d3JtV.Scope());
}
function $0a62fc102c00540e$var$getDefaultIsolationScope() {
    return $4fnou.getGlobalSingleton("defaultIsolationScope", ()=>new $d3JtV.Scope());
}
module.exports.getDefaultCurrentScope = $0a62fc102c00540e$var$getDefaultCurrentScope;
module.exports.getDefaultIsolationScope = $0a62fc102c00540e$var$getDefaultIsolationScope;

});
parcelRegister("d3JtV", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $hiZR1 = parcelRequire("hiZR1");

var $dsI2h = parcelRequire("dsI2h");

var $4gyod = parcelRequire("4gyod");

var $dzfKZ = parcelRequire("dzfKZ");

var $c9oD0 = parcelRequire("c9oD0");

var $6JkyB = parcelRequire("6JkyB");

var $bLH3w = parcelRequire("bLH3w");

var $lLUp4 = parcelRequire("lLUp4");

var $f9GTk = parcelRequire("f9GTk");

var $arYVC = parcelRequire("arYVC");

var $ihsl1 = parcelRequire("ihsl1");
const $981ed5e87a98aa98$var$DEFAULT_MAX_BREADCRUMBS = 100;
class $981ed5e87a98aa98$var$Scope {
    // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
    constructor(){
        this._notifyingListeners = false;
        this._scopeListeners = [];
        this._eventProcessors = [];
        this._breadcrumbs = [];
        this._attachments = [];
        this._user = {};
        this._tags = {};
        this._attributes = {};
        this._extra = {};
        this._contexts = {};
        this._sdkProcessingMetadata = {};
        this._propagationContext = {
            traceId: $bLH3w.generateTraceId(),
            sampleRand: $lLUp4.safeMathRandom()
        };
    }
    /**
   * Clone all data from this scope into a new scope.
   */ clone() {
        const newScope = new $981ed5e87a98aa98$var$Scope();
        newScope._breadcrumbs = [
            ...this._breadcrumbs
        ];
        newScope._tags = {
            ...this._tags
        };
        newScope._attributes = {
            ...this._attributes
        };
        newScope._extra = {
            ...this._extra
        };
        newScope._contexts = {
            ...this._contexts
        };
        if (this._contexts.flags) newScope._contexts.flags = {
            values: [
                ...this._contexts.flags.values
            ]
        };
        newScope._user = this._user;
        newScope._level = this._level;
        newScope._session = this._session;
        newScope._transactionName = this._transactionName;
        newScope._fingerprint = this._fingerprint;
        newScope._eventProcessors = [
            ...this._eventProcessors
        ];
        newScope._attachments = [
            ...this._attachments
        ];
        newScope._sdkProcessingMetadata = {
            ...this._sdkProcessingMetadata
        };
        newScope._propagationContext = {
            ...this._propagationContext
        };
        newScope._client = this._client;
        newScope._lastEventId = this._lastEventId;
        newScope._conversationId = this._conversationId;
        $f9GTk._setSpanForScope(newScope, $f9GTk._getSpanForScope(this));
        return newScope;
    }
    /**
   * Update the client assigned to this scope.
   * Note that not every scope will have a client assigned - isolation scopes & the global scope will generally not have a client,
   * as well as manually created scopes.
   */ setClient(client) {
        this._client = client;
    }
    /**
   * Set the ID of the last captured error event.
   * This is generally only captured on the isolation scope.
   */ setLastEventId(lastEventId) {
        this._lastEventId = lastEventId;
    }
    /**
   * Get the client assigned to this scope.
   */ getClient() {
        return this._client;
    }
    /**
   * Get the ID of the last captured error event.
   * This is generally only available on the isolation scope.
   */ lastEventId() {
        return this._lastEventId;
    }
    /**
   * @inheritDoc
   */ addScopeListener(callback) {
        this._scopeListeners.push(callback);
    }
    /**
   * Add an event processor that will be called before an event is sent.
   */ addEventProcessor(callback) {
        this._eventProcessors.push(callback);
        return this;
    }
    /**
   * Set the user for this scope.
   * Set to `null` to unset the user.
   */ setUser(user) {
        this._user = user || {
            email: void 0,
            id: void 0,
            ip_address: void 0,
            username: void 0
        };
        if (this._session) $dsI2h.updateSession(this._session, {
            user: user
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Get the user from this scope.
   */ getUser() {
        return this._user;
    }
    /**
   * Set the conversation ID for this scope.
   * Set to `null` to unset the conversation ID.
   */ setConversationId(conversationId) {
        this._conversationId = conversationId || void 0;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set an object that will be merged into existing tags on the scope,
   * and will be sent as tags data with the event.
   */ setTags(tags) {
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set a single tag that will be sent as tags data with the event.
   */ setTag(key, value) {
        return this.setTags({
            [key]: value
        });
    }
    /**
   * Sets attributes onto the scope.
   *
   * These attributes are applied to logs, metrics and streamed spans.
   *
   * Supported attribute value types are `string`, `number`, `boolean`, `string[]`, `number[]` and `boolean[]`.
   *
   * @param newAttributes - The attributes to set on the scope, as key-value pairs.
   *
   * @example
   * ```typescript
   * scope.setAttributes({
   *   is_admin: true,
   *   payment_selection: 'credit_card',
   *   render_duration: 150,
   * });
   * ```
   */ setAttributes(newAttributes) {
        this._attributes = {
            ...this._attributes,
            ...newAttributes
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets an attribute onto the scope.
   *
   * These attributes are applied to logs, metrics and streamed spans.
   *
   * Supported attribute value types are `string`, `number`, `boolean`, `string[]`, `number[]` and `boolean[]`.
   *
   * @param key - The attribute key.
   * @param value - The attribute value.
   *
   * @example
   * ```typescript
   * scope.setAttribute('is_admin', true);
   * scope.setAttribute('render_duration', 150);
   * ```
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setAttribute(key, value) {
        return this.setAttributes({
            [key]: value
        });
    }
    /**
   * Removes the attribute with the given key from the scope.
   *
   * @param key - The attribute key.
   *
   * @example
   * ```typescript
   * scope.removeAttribute('is_admin');
   * ```
   */ removeAttribute(key) {
        if (key in this._attributes) {
            delete this._attributes[key];
            this._notifyScopeListeners();
        }
        return this;
    }
    /**
   * Set an object that will be merged into existing extra on the scope,
   * and will be sent as extra data with the event.
   */ setExtras(extras) {
        this._extra = {
            ...this._extra,
            ...extras
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set a single key:value extra entry that will be sent as extra data with the event.
   */ setExtra(key, extra) {
        this._extra = {
            ...this._extra,
            [key]: extra
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the fingerprint on the scope to send with the events.
   * @param {string[]} fingerprint Fingerprint to group events in Sentry.
   */ setFingerprint(fingerprint) {
        this._fingerprint = fingerprint;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the level on the scope for future events.
   */ setLevel(level) {
        this._level = level;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the transaction name on the scope so that the name of e.g. taken server route or
   * the page location is attached to future events.
   *
   * IMPORTANT: Calling this function does NOT change the name of the currently active
   * root span. If you want to change the name of the active root span, use
   * `Sentry.updateSpanName(rootSpan, 'new name')` instead.
   *
   * By default, the SDK updates the scope's transaction name automatically on sensible
   * occasions, such as a page navigation or when handling a new request on the server.
   */ setTransactionName(name) {
        this._transactionName = name;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets context data with the given name.
   * Data passed as context will be normalized. You can also pass `null` to unset the context.
   * Note that context data will not be merged - calling `setContext` will overwrite an existing context with the same key.
   */ setContext(key, context) {
        if (context === null) delete this._contexts[key];
        else this._contexts[key] = context;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set the session for the scope.
   */ setSession(session) {
        if (!session) delete this._session;
        else this._session = session;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Get the session from the scope.
   */ getSession() {
        return this._session;
    }
    /**
   * Updates the scope with provided data. Can work in three variations:
   * - plain object containing updatable attributes
   * - Scope instance that'll extract the attributes from
   * - callback function that'll receive the current scope as an argument and allow for modifications
   */ update(captureContext) {
        if (!captureContext) return this;
        const scopeToMerge = typeof captureContext === "function" ? captureContext(this) : captureContext;
        const scopeInstance = scopeToMerge instanceof $981ed5e87a98aa98$var$Scope ? scopeToMerge.getScopeData() : $dzfKZ.isPlainObject(scopeToMerge) ? captureContext : void 0;
        const { tags: tags, attributes: attributes, extra: extra, user: user, contexts: contexts, level: level, fingerprint: fingerprint = [], propagationContext: propagationContext, conversationId: conversationId } = scopeInstance || {};
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._attributes = {
            ...this._attributes,
            ...attributes
        };
        this._extra = {
            ...this._extra,
            ...extra
        };
        this._contexts = {
            ...this._contexts,
            ...contexts
        };
        if (user && Object.keys(user).length) this._user = user;
        if (level) this._level = level;
        if (fingerprint.length) this._fingerprint = fingerprint;
        if (propagationContext) this._propagationContext = propagationContext;
        if (conversationId) this._conversationId = conversationId;
        return this;
    }
    /**
   * Clears the current scope and resets its properties.
   * Note: The client will not be cleared.
   */ clear() {
        this._breadcrumbs = [];
        this._tags = {};
        this._attributes = {};
        this._extra = {};
        this._user = {};
        this._contexts = {};
        this._level = void 0;
        this._transactionName = void 0;
        this._fingerprint = void 0;
        this._session = void 0;
        this._conversationId = void 0;
        $f9GTk._setSpanForScope(this, void 0);
        this._attachments = [];
        this.setPropagationContext({
            traceId: $bLH3w.generateTraceId(),
            sampleRand: $lLUp4.safeMathRandom()
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Adds a breadcrumb to the scope.
   * By default, the last 100 breadcrumbs are kept.
   */ addBreadcrumb(breadcrumb, maxBreadcrumbs) {
        const maxCrumbs = typeof maxBreadcrumbs === "number" ? maxBreadcrumbs : $981ed5e87a98aa98$var$DEFAULT_MAX_BREADCRUMBS;
        if (maxCrumbs <= 0) return this;
        const mergedBreadcrumb = {
            timestamp: $ihsl1.dateTimestampInSeconds(),
            ...breadcrumb,
            // Breadcrumb messages can theoretically be infinitely large and they're held in memory so we truncate them not to leak (too much) memory
            message: breadcrumb.message ? $arYVC.truncate(breadcrumb.message, 2048) : breadcrumb.message
        };
        this._breadcrumbs.push(mergedBreadcrumb);
        if (this._breadcrumbs.length > maxCrumbs) {
            this._breadcrumbs = this._breadcrumbs.slice(-maxCrumbs);
            this._client?.recordDroppedEvent("buffer_overflow", "log_item");
        }
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Get the last breadcrumb of the scope.
   */ getLastBreadcrumb() {
        return this._breadcrumbs[this._breadcrumbs.length - 1];
    }
    /**
   * Clear all breadcrumbs from the scope.
   */ clearBreadcrumbs() {
        this._breadcrumbs = [];
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Add an attachment to the scope.
   */ addAttachment(attachment) {
        this._attachments.push(attachment);
        return this;
    }
    /**
   * Clear all attachments from the scope.
   */ clearAttachments() {
        this._attachments = [];
        return this;
    }
    /**
   * Get the data of this scope, which should be applied to an event during processing.
   */ getScopeData() {
        return {
            breadcrumbs: this._breadcrumbs,
            attachments: this._attachments,
            contexts: this._contexts,
            tags: this._tags,
            attributes: this._attributes,
            extra: this._extra,
            user: this._user,
            level: this._level,
            fingerprint: this._fingerprint || [],
            eventProcessors: this._eventProcessors,
            propagationContext: this._propagationContext,
            sdkProcessingMetadata: this._sdkProcessingMetadata,
            transactionName: this._transactionName,
            span: $f9GTk._getSpanForScope(this),
            conversationId: this._conversationId
        };
    }
    /**
   * Add data which will be accessible during event processing but won't get sent to Sentry.
   */ setSDKProcessingMetadata(newData) {
        this._sdkProcessingMetadata = $c9oD0.merge(this._sdkProcessingMetadata, newData, 2);
        return this;
    }
    /**
   * Add propagation context to the scope, used for distributed tracing
   */ setPropagationContext(context) {
        this._propagationContext = context;
        return this;
    }
    /**
   * Get propagation context from the scope, used for distributed tracing
   */ getPropagationContext() {
        return this._propagationContext;
    }
    /**
   * Capture an exception for this scope.
   *
   * @returns {string} The id of the captured Sentry event.
   */ captureException(exception, hint) {
        const eventId = hint?.event_id || $6JkyB.uuid4();
        if (!this._client) {
            $hiZR1.DEBUG_BUILD && $4gyod.debug.warn("No client configured on scope - will not capture exception!");
            return eventId;
        }
        const syntheticException = new Error("Sentry syntheticException");
        this._client.captureException(exception, {
            originalException: exception,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Capture a message for this scope.
   *
   * @returns {string} The id of the captured message.
   */ captureMessage(message, level, hint) {
        const eventId = hint?.event_id || $6JkyB.uuid4();
        if (!this._client) {
            $hiZR1.DEBUG_BUILD && $4gyod.debug.warn("No client configured on scope - will not capture message!");
            return eventId;
        }
        const syntheticException = hint?.syntheticException ?? new Error(message);
        this._client.captureMessage(message, level, {
            originalException: message,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Capture a Sentry event for this scope.
   *
   * @returns {string} The id of the captured event.
   */ captureEvent(event, hint) {
        const eventId = event.event_id || hint?.event_id || $6JkyB.uuid4();
        if (!this._client) {
            $hiZR1.DEBUG_BUILD && $4gyod.debug.warn("No client configured on scope - will not capture event!");
            return eventId;
        }
        this._client.captureEvent(event, {
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * This will be called on every set call.
   */ _notifyScopeListeners() {
        if (!this._notifyingListeners) {
            this._notifyingListeners = true;
            this._scopeListeners.forEach((callback)=>{
                callback(this);
            });
            this._notifyingListeners = false;
        }
    }
}
module.exports.Scope = $981ed5e87a98aa98$var$Scope;

});
parcelRegister("dsI2h", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $6JkyB = parcelRequire("6JkyB");

var $ihsl1 = parcelRequire("ihsl1");
function $9cd00c7d0ad22aaa$var$makeSession(context) {
    const startingTime = $ihsl1.timestampInSeconds();
    const session = {
        sid: $6JkyB.uuid4(),
        init: true,
        timestamp: startingTime,
        started: startingTime,
        duration: 0,
        status: "ok",
        errors: 0,
        ignoreDuration: false,
        toJSON: ()=>$9cd00c7d0ad22aaa$var$sessionToJSON(session)
    };
    if (context) $9cd00c7d0ad22aaa$var$updateSession(session, context);
    return session;
}
function $9cd00c7d0ad22aaa$var$updateSession(session, context = {}) {
    if (context.user) {
        if (!session.ipAddress && context.user.ip_address) session.ipAddress = context.user.ip_address;
        if (!session.did && !context.did) session.did = context.user.id || context.user.email || context.user.username;
    }
    session.timestamp = context.timestamp || $ihsl1.timestampInSeconds();
    if (context.abnormal_mechanism) session.abnormal_mechanism = context.abnormal_mechanism;
    if (context.ignoreDuration) session.ignoreDuration = context.ignoreDuration;
    if (context.sid) session.sid = context.sid.length === 32 ? context.sid : $6JkyB.uuid4();
    if (context.init !== void 0) session.init = context.init;
    if (!session.did && context.did) session.did = `${context.did}`;
    if (typeof context.started === "number") session.started = context.started;
    if (session.ignoreDuration) session.duration = void 0;
    else if (typeof context.duration === "number") session.duration = context.duration;
    else {
        const duration = session.timestamp - session.started;
        session.duration = duration >= 0 ? duration : 0;
    }
    if (context.release) session.release = context.release;
    if (context.environment) session.environment = context.environment;
    if (!session.ipAddress && context.ipAddress) session.ipAddress = context.ipAddress;
    if (!session.userAgent && context.userAgent) session.userAgent = context.userAgent;
    if (typeof context.errors === "number") session.errors = context.errors;
    if (context.status) session.status = context.status;
}
function $9cd00c7d0ad22aaa$var$closeSession(session, status) {
    let context = {};
    if (status) context = {
        status: status
    };
    else if (session.status === "ok") context = {
        status: "exited"
    };
    $9cd00c7d0ad22aaa$var$updateSession(session, context);
}
function $9cd00c7d0ad22aaa$var$sessionToJSON(session) {
    return {
        sid: `${session.sid}`,
        init: session.init,
        // Make sure that sec is converted to ms for date constructor
        started: new Date(session.started * 1e3).toISOString(),
        timestamp: new Date(session.timestamp * 1e3).toISOString(),
        status: session.status,
        errors: session.errors,
        did: typeof session.did === "number" || typeof session.did === "string" ? `${session.did}` : void 0,
        duration: session.duration,
        abnormal_mechanism: session.abnormal_mechanism,
        attrs: {
            release: session.release,
            environment: session.environment,
            ip_address: session.ipAddress,
            user_agent: session.userAgent
        }
    };
}
module.exports.closeSession = $9cd00c7d0ad22aaa$var$closeSession;
module.exports.makeSession = $9cd00c7d0ad22aaa$var$makeSession;
module.exports.updateSession = $9cd00c7d0ad22aaa$var$updateSession;

});
parcelRegister("6JkyB", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $7OVjx = parcelRequire("7OVjx");

var $lLUp4 = parcelRequire("lLUp4");

var $arYVC = parcelRequire("arYVC");

var $eP8Ri = parcelRequire("eP8Ri");
function $4e66e445ae0035d4$var$getCrypto() {
    const gbl = $eP8Ri.GLOBAL_OBJ;
    return gbl.crypto || gbl.msCrypto;
}
let $4e66e445ae0035d4$var$emptyUuid;
function $4e66e445ae0035d4$var$getRandomByte() {
    return $lLUp4.safeMathRandom() * 16;
}
function $4e66e445ae0035d4$var$uuid4(crypto = $4e66e445ae0035d4$var$getCrypto()) {
    try {
        if (crypto?.randomUUID) return $lLUp4.withRandomSafeContext(()=>crypto.randomUUID()).replace(/-/g, "");
    } catch  {}
    if (!$4e66e445ae0035d4$var$emptyUuid) $4e66e445ae0035d4$var$emptyUuid = "10000000100040008000100000000000";
    return $4e66e445ae0035d4$var$emptyUuid.replace(/[018]/g, (c)=>// eslint-disable-next-line no-bitwise
        (c ^ ($4e66e445ae0035d4$var$getRandomByte() & 15) >> c / 4).toString(16));
}
function $4e66e445ae0035d4$var$getFirstException(event) {
    return event.exception?.values?.[0];
}
function $4e66e445ae0035d4$var$getEventDescription(event) {
    const { message: message, event_id: eventId } = event;
    if (message) return message;
    const firstException = $4e66e445ae0035d4$var$getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return `${firstException.type}: ${firstException.value}`;
        return firstException.type || firstException.value || eventId || "<unknown>";
    }
    return eventId || "<unknown>";
}
function $4e66e445ae0035d4$var$addExceptionTypeValue(event, value, type) {
    const exception = event.exception = event.exception || {};
    const values = exception.values = exception.values || [];
    const firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || "";
    if (!firstException.type) firstException.type = type || "Error";
}
function $4e66e445ae0035d4$var$addExceptionMechanism(event, newMechanism) {
    const firstException = $4e66e445ae0035d4$var$getFirstException(event);
    if (!firstException) return;
    const defaultMechanism = {
        type: "generic",
        handled: true
    };
    const currentMechanism = firstException.mechanism;
    firstException.mechanism = {
        ...defaultMechanism,
        ...currentMechanism,
        ...newMechanism
    };
    if (newMechanism && "data" in newMechanism) {
        const mergedData = {
            ...currentMechanism?.data,
            ...newMechanism.data
        };
        firstException.mechanism.data = mergedData;
    }
}
const $4e66e445ae0035d4$var$SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
function $4e66e445ae0035d4$var$_parseInt(input) {
    return parseInt(input || "", 10);
}
function $4e66e445ae0035d4$var$parseSemver(input) {
    const match = input.match($4e66e445ae0035d4$var$SEMVER_REGEXP) || [];
    const major = $4e66e445ae0035d4$var$_parseInt(match[1]);
    const minor = $4e66e445ae0035d4$var$_parseInt(match[2]);
    const patch = $4e66e445ae0035d4$var$_parseInt(match[3]);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? void 0 : major,
        minor: isNaN(minor) ? void 0 : minor,
        patch: isNaN(patch) ? void 0 : patch,
        prerelease: match[4]
    };
}
function $4e66e445ae0035d4$var$addContextToFrame(lines, frame, linesOfContext = 5) {
    if (frame.lineno === void 0) return;
    const maxLines = lines.length;
    const sourceLine = Math.max(Math.min(maxLines - 1, frame.lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map((line)=>$arYVC.snipLine(line, 0));
    const lineIndex = Math.min(maxLines - 1, sourceLine);
    frame.context_line = $arYVC.snipLine(lines[lineIndex], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map((line)=>$arYVC.snipLine(line, 0));
}
function $4e66e445ae0035d4$var$checkOrSetAlreadyCaught(exception) {
    if ($4e66e445ae0035d4$var$isAlreadyCaptured(exception)) return true;
    try {
        $7OVjx.addNonEnumerableProperty(exception, "__sentry_captured__", true);
    } catch  {}
    return false;
}
function $4e66e445ae0035d4$var$isAlreadyCaptured(exception) {
    try {
        return exception.__sentry_captured__;
    } catch  {}
}
module.exports.addContextToFrame = $4e66e445ae0035d4$var$addContextToFrame;
module.exports.addExceptionMechanism = $4e66e445ae0035d4$var$addExceptionMechanism;
module.exports.addExceptionTypeValue = $4e66e445ae0035d4$var$addExceptionTypeValue;
module.exports.checkOrSetAlreadyCaught = $4e66e445ae0035d4$var$checkOrSetAlreadyCaught;
module.exports.getEventDescription = $4e66e445ae0035d4$var$getEventDescription;
module.exports.isAlreadyCaptured = $4e66e445ae0035d4$var$isAlreadyCaptured;
module.exports.parseSemver = $4e66e445ae0035d4$var$parseSemver;
module.exports.uuid4 = $4e66e445ae0035d4$var$uuid4;

});
parcelRegister("7OVjx", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $hiZR1 = parcelRequire("hiZR1");

var $4gyod = parcelRequire("4gyod");

var $dzfKZ = parcelRequire("dzfKZ");
function $5b19a94c0f68a3b6$var$fill(source, name, replacementFactory) {
    if (!(name in source)) return;
    const original = source[name];
    if (typeof original !== "function") return;
    const wrapped = replacementFactory(original);
    if (typeof wrapped === "function") $5b19a94c0f68a3b6$var$markFunctionWrapped(wrapped, original);
    try {
        source[name] = wrapped;
    } catch  {
        $hiZR1.DEBUG_BUILD && $4gyod.debug.log(`Failed to replace method "${name}" in object`, source);
    }
}
function $5b19a94c0f68a3b6$var$addNonEnumerableProperty(obj, name, value) {
    try {
        Object.defineProperty(obj, name, {
            value: // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
            value,
            writable: true,
            configurable: true
        });
    } catch  {
        $hiZR1.DEBUG_BUILD && $4gyod.debug.log(`Failed to add non-enumerable property "${String(name)}" to object`, obj);
    }
}
function $5b19a94c0f68a3b6$var$markFunctionWrapped(wrapped, original) {
    try {
        const proto = original.prototype || {};
        wrapped.prototype = original.prototype = proto;
        $5b19a94c0f68a3b6$var$addNonEnumerableProperty(wrapped, "__sentry_original__", original);
    } catch  {}
}
function $5b19a94c0f68a3b6$var$wrapMethod(obj, field, wrapped, enumerable = true) {
    const original = obj[field];
    if (typeof original !== "function") throw new Error(`Cannot wrap method: ${field} is not a function`);
    if ($5b19a94c0f68a3b6$var$getOriginalFunction(original)) throw new Error(`Attempting to wrap method ${field} multiple times`);
    $5b19a94c0f68a3b6$var$markFunctionWrapped(wrapped, original);
    Object.defineProperty(obj, field, {
        writable: true,
        configurable: true,
        enumerable: enumerable,
        value: wrapped
    });
}
function $5b19a94c0f68a3b6$var$getOriginalFunction(func) {
    return func.__sentry_original__;
}
function $5b19a94c0f68a3b6$var$convertToPlainObject(value) {
    if ($dzfKZ.isError(value)) return {
        message: value.message,
        name: value.name,
        stack: value.stack,
        ...$5b19a94c0f68a3b6$var$getOwnProperties(value)
    };
    if ($dzfKZ.isEvent(value)) {
        const { type: type, target: target, currentTarget: currentTarget, detail: detail } = value;
        return {
            type: type,
            target: target,
            currentTarget: currentTarget,
            ...detail ? {
                detail: detail
            } : {},
            ...$5b19a94c0f68a3b6$var$getOwnProperties(value)
        };
    }
    return value;
}
function $5b19a94c0f68a3b6$var$getOwnProperties(obj) {
    if ($dzfKZ.isObjectLike(obj)) return Object.fromEntries(Object.entries(obj));
    return {};
}
function $5b19a94c0f68a3b6$var$extractExceptionKeysForMessage(exception) {
    const keys = Object.keys($5b19a94c0f68a3b6$var$convertToPlainObject(exception));
    keys.sort();
    return !keys[0] ? "[object has no keys]" : keys.join(", ");
}
function $5b19a94c0f68a3b6$var$dropUndefinedKeys(inputValue) {
    const memoizationMap = /* @__PURE__ */ new Map();
    return $5b19a94c0f68a3b6$var$_dropUndefinedKeys(inputValue, memoizationMap);
}
function $5b19a94c0f68a3b6$var$_dropUndefinedKeys(inputValue, memoizationMap) {
    if (inputValue === null || typeof inputValue !== "object") return inputValue;
    const memoVal = memoizationMap.get(inputValue);
    if (memoVal !== void 0) return memoVal;
    if (Array.isArray(inputValue)) {
        const returnValue = [];
        memoizationMap.set(inputValue, returnValue);
        inputValue.forEach((value)=>{
            returnValue.push($5b19a94c0f68a3b6$var$_dropUndefinedKeys(value, memoizationMap));
        });
        return returnValue;
    }
    if ($5b19a94c0f68a3b6$var$isPojo(inputValue)) {
        const returnValue = {};
        memoizationMap.set(inputValue, returnValue);
        const keys = Object.keys(inputValue);
        keys.forEach((key)=>{
            const val = inputValue[key];
            if (val !== void 0) returnValue[key] = $5b19a94c0f68a3b6$var$_dropUndefinedKeys(val, memoizationMap);
        });
        return returnValue;
    }
    return inputValue;
}
function $5b19a94c0f68a3b6$var$isPojo(input) {
    const constructor = input.constructor;
    return constructor === Object || constructor === void 0;
}
function $5b19a94c0f68a3b6$var$objectify(wat) {
    let objectified;
    switch(true){
        // this will catch both undefined and null
        case wat == void 0:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === "symbol" || typeof wat === "bigint":
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case $dzfKZ.isPrimitive(wat):
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}
module.exports.addNonEnumerableProperty = $5b19a94c0f68a3b6$var$addNonEnumerableProperty;
module.exports.convertToPlainObject = $5b19a94c0f68a3b6$var$convertToPlainObject;
module.exports.dropUndefinedKeys = $5b19a94c0f68a3b6$var$dropUndefinedKeys;
module.exports.extractExceptionKeysForMessage = $5b19a94c0f68a3b6$var$extractExceptionKeysForMessage;
module.exports.fill = $5b19a94c0f68a3b6$var$fill;
module.exports.getOriginalFunction = $5b19a94c0f68a3b6$var$getOriginalFunction;
module.exports.markFunctionWrapped = $5b19a94c0f68a3b6$var$markFunctionWrapped;
module.exports.objectify = $5b19a94c0f68a3b6$var$objectify;
module.exports.wrapMethod = $5b19a94c0f68a3b6$var$wrapMethod;

});
parcelRegister("dzfKZ", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $9e0ac44369eefb8e$var$objectToString = Object.prototype.toString;
function $9e0ac44369eefb8e$var$isError(wat) {
    switch($9e0ac44369eefb8e$var$objectToString.call(wat)){
        case "[object Error]":
        case "[object Exception]":
        case "[object DOMException]":
        case "[object WebAssembly.Exception]":
            return true;
        default:
            return $9e0ac44369eefb8e$var$isInstanceOf(wat, Error);
    }
}
function $9e0ac44369eefb8e$var$isBuiltin(wat, className) {
    return $9e0ac44369eefb8e$var$objectToString.call(wat) === `[object ${className}]`;
}
function $9e0ac44369eefb8e$var$isErrorEvent(wat) {
    return $9e0ac44369eefb8e$var$isBuiltin(wat, "ErrorEvent");
}
function $9e0ac44369eefb8e$var$isDOMError(wat) {
    return $9e0ac44369eefb8e$var$isBuiltin(wat, "DOMError");
}
function $9e0ac44369eefb8e$var$isDOMException(wat) {
    return $9e0ac44369eefb8e$var$isBuiltin(wat, "DOMException");
}
function $9e0ac44369eefb8e$var$isString(wat) {
    return $9e0ac44369eefb8e$var$isBuiltin(wat, "String");
}
function $9e0ac44369eefb8e$var$isParameterizedString(wat) {
    return typeof wat === "object" && wat !== null && "__sentry_template_string__" in wat && "__sentry_template_values__" in wat;
}
function $9e0ac44369eefb8e$var$isPrimitive(wat) {
    return wat === null || $9e0ac44369eefb8e$var$isParameterizedString(wat) || typeof wat !== "object" && typeof wat !== "function";
}
function $9e0ac44369eefb8e$var$isPlainObject(wat) {
    return $9e0ac44369eefb8e$var$isBuiltin(wat, "Object");
}
function $9e0ac44369eefb8e$var$isObjectLike(wat) {
    return typeof wat === "object" && wat !== null;
}
function $9e0ac44369eefb8e$var$isEvent(wat) {
    return typeof Event !== "undefined" && $9e0ac44369eefb8e$var$isInstanceOf(wat, Event);
}
function $9e0ac44369eefb8e$var$isElement(wat) {
    return typeof Element !== "undefined" && $9e0ac44369eefb8e$var$isInstanceOf(wat, Element);
}
function $9e0ac44369eefb8e$var$isRegExp(wat) {
    return $9e0ac44369eefb8e$var$isBuiltin(wat, "RegExp");
}
function $9e0ac44369eefb8e$var$isThenable(wat) {
    return Boolean(wat?.then && typeof wat.then === "function");
}
function $9e0ac44369eefb8e$var$isSyntheticEvent(wat) {
    return $9e0ac44369eefb8e$var$isPlainObject(wat) && "nativeEvent" in wat && "preventDefault" in wat && "stopPropagation" in wat;
}
function $9e0ac44369eefb8e$var$isInstanceOf(wat, base) {
    try {
        return wat instanceof base;
    } catch  {
        return false;
    }
}
function $9e0ac44369eefb8e$var$isVueViewModel(wat) {
    return !!(typeof wat === "object" && wat !== null && (wat.__isVue || wat._isVue || wat.__v_isVNode));
}
function $9e0ac44369eefb8e$var$isRequest(request) {
    return typeof Request !== "undefined" && $9e0ac44369eefb8e$var$isInstanceOf(request, Request);
}
module.exports.isDOMError = $9e0ac44369eefb8e$var$isDOMError;
module.exports.isDOMException = $9e0ac44369eefb8e$var$isDOMException;
module.exports.isElement = $9e0ac44369eefb8e$var$isElement;
module.exports.isError = $9e0ac44369eefb8e$var$isError;
module.exports.isErrorEvent = $9e0ac44369eefb8e$var$isErrorEvent;
module.exports.isEvent = $9e0ac44369eefb8e$var$isEvent;
module.exports.isInstanceOf = $9e0ac44369eefb8e$var$isInstanceOf;
module.exports.isObjectLike = $9e0ac44369eefb8e$var$isObjectLike;
module.exports.isParameterizedString = $9e0ac44369eefb8e$var$isParameterizedString;
module.exports.isPlainObject = $9e0ac44369eefb8e$var$isPlainObject;
module.exports.isPrimitive = $9e0ac44369eefb8e$var$isPrimitive;
module.exports.isRegExp = $9e0ac44369eefb8e$var$isRegExp;
module.exports.isRequest = $9e0ac44369eefb8e$var$isRequest;
module.exports.isString = $9e0ac44369eefb8e$var$isString;
module.exports.isSyntheticEvent = $9e0ac44369eefb8e$var$isSyntheticEvent;
module.exports.isThenable = $9e0ac44369eefb8e$var$isThenable;
module.exports.isVueViewModel = $9e0ac44369eefb8e$var$isVueViewModel;

});


parcelRegister("lLUp4", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $eP8Ri = parcelRequire("eP8Ri");
let $fd99bd50ea3f639f$var$RESOLVED_RUNNER;
function $fd99bd50ea3f639f$var$withRandomSafeContext(cb) {
    if ($fd99bd50ea3f639f$var$RESOLVED_RUNNER !== void 0) return $fd99bd50ea3f639f$var$RESOLVED_RUNNER ? $fd99bd50ea3f639f$var$RESOLVED_RUNNER(cb) : cb();
    const sym = /* @__PURE__ */ Symbol.for("__SENTRY_SAFE_RANDOM_ID_WRAPPER__");
    const globalWithSymbol = $eP8Ri.GLOBAL_OBJ;
    if (sym in globalWithSymbol && typeof globalWithSymbol[sym] === "function") {
        $fd99bd50ea3f639f$var$RESOLVED_RUNNER = globalWithSymbol[sym];
        return $fd99bd50ea3f639f$var$RESOLVED_RUNNER(cb);
    }
    $fd99bd50ea3f639f$var$RESOLVED_RUNNER = null;
    return cb();
}
function $fd99bd50ea3f639f$var$safeMathRandom() {
    return $fd99bd50ea3f639f$var$withRandomSafeContext(()=>Math.random());
}
function $fd99bd50ea3f639f$var$safeDateNow() {
    return $fd99bd50ea3f639f$var$withRandomSafeContext(()=>Date.now());
}
module.exports.safeDateNow = $fd99bd50ea3f639f$var$safeDateNow;
module.exports.safeMathRandom = $fd99bd50ea3f639f$var$safeMathRandom;
module.exports.withRandomSafeContext = $fd99bd50ea3f639f$var$withRandomSafeContext;

});

parcelRegister("arYVC", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $dzfKZ = parcelRequire("dzfKZ");

var $eD1cG = parcelRequire("eD1cG");
function $79bbb0149f493a90$var$stringify(value, fallback = "[unserializable]") {
    if (typeof value === "string") return value;
    try {
        return JSON.stringify(value);
    } catch  {
        return typeof fallback === "function" ? fallback(value) : fallback;
    }
}
function $79bbb0149f493a90$var$truncate(str, max = 0) {
    if (typeof str !== "string" || max === 0) return str;
    return str.length <= max ? str : `${str.slice(0, max)}...`;
}
function $79bbb0149f493a90$var$snipLine(line, colno) {
    let newLine = line;
    const lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) colno = lineLength;
    let start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    let end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = `'{snip} ${newLine}`;
    if (end < lineLength) newLine += " {snip}";
    return newLine;
}
function $79bbb0149f493a90$var$safeJoin(input, delimiter) {
    if (!Array.isArray(input)) return "";
    const output = [];
    for(let i = 0; i < input.length; i++){
        const value = input[i];
        if ($dzfKZ.isPrimitive(value)) output.push(String(value));
        else if (value instanceof Error) output.push(value.message ? `${value.name}: ${value.message}` : value.name);
        else output.push($eD1cG.stringifyValue(void 0, value));
    }
    return output.join(delimiter);
}
function $79bbb0149f493a90$var$isMatchingPattern(value, pattern, requireExactStringMatch = false) {
    if (!$dzfKZ.isString(value)) return false;
    if ($dzfKZ.isRegExp(pattern)) return pattern.test(value);
    if ($dzfKZ.isString(pattern)) return requireExactStringMatch ? value === pattern : value.includes(pattern);
    if (typeof pattern === "function") return pattern(value);
    return false;
}
function $79bbb0149f493a90$var$stringMatchesSomePattern(testString, patterns = [], requireExactStringMatch = false) {
    for (const pattern of patterns){
        if ($79bbb0149f493a90$var$isMatchingPattern(testString, pattern, requireExactStringMatch)) return true;
    }
    return false;
}
module.exports.isMatchingPattern = $79bbb0149f493a90$var$isMatchingPattern;
module.exports.safeJoin = $79bbb0149f493a90$var$safeJoin;
module.exports.snipLine = $79bbb0149f493a90$var$snipLine;
module.exports.stringMatchesSomePattern = $79bbb0149f493a90$var$stringMatchesSomePattern;
module.exports.stringify = $79bbb0149f493a90$var$stringify;
module.exports.truncate = $79bbb0149f493a90$var$truncate;

});
parcelRegister("eD1cG", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $c3njb = parcelRequire("c3njb");

var $7OVjx = parcelRequire("7OVjx");

var $d7glj = parcelRequire("d7glj");
let $aa65a436891b976a$var$stringifier;
function $aa65a436891b976a$var$setNormalizeStringifier(newStringifier) {
    $aa65a436891b976a$var$stringifier = newStringifier;
}
function $aa65a436891b976a$var$normalize(input, depth = 100, maxProperties = Infinity) {
    try {
        return $aa65a436891b976a$var$visit("", input, depth, maxProperties);
    } catch (err) {
        return {
            ERROR: `**non-serializable** (${err})`
        };
    }
}
function $aa65a436891b976a$var$normalizeToSize(object, depth = 3, maxSize = 102400) {
    const normalized = $aa65a436891b976a$var$normalize(object, depth);
    if ($aa65a436891b976a$var$jsonSize(normalized) > maxSize) return $aa65a436891b976a$var$normalizeToSize(object, depth - 1, maxSize);
    return normalized;
}
function $aa65a436891b976a$var$visit(key, value, depth = Infinity, maxProperties = Infinity, memo = $aa65a436891b976a$var$memoBuilder()) {
    const [memoize, unmemoize] = memo;
    if (value == null || // this matches null and undefined -> eqeq not eqeqeq
    [
        "boolean",
        "string"
    ].includes(typeof value) || typeof value === "number" && Number.isFinite(value)) return value;
    const stringified = $aa65a436891b976a$var$stringifyValue(key, value);
    if (!stringified.startsWith("[object ")) return stringified;
    if ($c3njb.hasSkipNormalizationHint(value)) return value;
    const overrideDepth = $c3njb.getNormalizationDepthOverrideHint(value);
    const remainingDepth = overrideDepth !== void 0 ? overrideDepth : depth;
    if (remainingDepth === 0) return stringified.replace("object ", "");
    if (memoize(value)) return "[Circular ~]";
    const valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === "function") try {
        const jsonValue = valueWithToJSON.toJSON();
        return $aa65a436891b976a$var$visit("", jsonValue, remainingDepth - 1, maxProperties, memo);
    } catch  {}
    const normalized = Array.isArray(value) ? [] : {};
    let numAdded = 0;
    const visitable = $7OVjx.convertToPlainObject(value);
    for(const visitKey in visitable){
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) continue;
        if (numAdded >= maxProperties) {
            normalized[visitKey] = "[MaxProperties ~]";
            break;
        }
        const visitValue = visitable[visitKey];
        normalized[visitKey] = $aa65a436891b976a$var$visit(visitKey, visitValue, remainingDepth - 1, maxProperties, memo);
        numAdded++;
    }
    unmemoize(value);
    return normalized;
}
function $aa65a436891b976a$var$stringifyValue(key, value) {
    try {
        if ($aa65a436891b976a$var$stringifier) {
            const stringified = $aa65a436891b976a$var$stringifier(value);
            if (stringified) return stringified;
        }
        if (typeof $parcel$global !== "undefined" && value === $parcel$global) return "[Global]";
        if (typeof value === "number" && !Number.isFinite(value)) return `[${value}]`;
        if (typeof value === "function") return `[Function: ${$d7glj.getFunctionName(value)}]`;
        if (typeof value === "symbol") return `[${String(value)}]`;
        if (typeof value === "bigint") return `[BigInt: ${String(value)}]`;
        const objName = $aa65a436891b976a$var$getConstructorName(value);
        return `[object ${objName}]`;
    } catch (err) {
        return `**non-serializable** (${err})`;
    }
}
function $aa65a436891b976a$var$getConstructorName(value) {
    const prototype = Object.getPrototypeOf(value);
    return prototype?.constructor ? prototype.constructor.name : "null prototype";
}
function $aa65a436891b976a$var$utf8Length(value) {
    return ~-encodeURI(value).split(/%..|./).length;
}
function $aa65a436891b976a$var$jsonSize(value) {
    return $aa65a436891b976a$var$utf8Length(JSON.stringify(value));
}
function $aa65a436891b976a$var$normalizeUrlToBase(url, basePath) {
    const escapedBase = basePath.replace(/\\/g, "/").replace(/[|\\{}()[\]^$+*?.]/g, "\\$&");
    let newUrl = url;
    try {
        newUrl = decodeURI(url);
    } catch  {}
    return newUrl.replace(/\\/g, "/").replace(/webpack:\/?/g, "").replace(new RegExp(`(file://)?/*${escapedBase}/*`, "ig"), "app:///");
}
function $aa65a436891b976a$var$memoBuilder() {
    const inner = /* @__PURE__ */ new WeakSet();
    function memoize(obj) {
        if (inner.has(obj)) return true;
        inner.add(obj);
        return false;
    }
    function unmemoize(obj) {
        inner.delete(obj);
    }
    return [
        memoize,
        unmemoize
    ];
}
module.exports.normalize = $aa65a436891b976a$var$normalize;
module.exports.normalizeToSize = $aa65a436891b976a$var$normalizeToSize;
module.exports.normalizeUrlToBase = $aa65a436891b976a$var$normalizeUrlToBase;
module.exports.setNormalizeStringifier = $aa65a436891b976a$var$setNormalizeStringifier;
module.exports.stringifyValue = $aa65a436891b976a$var$stringifyValue;

});
parcelRegister("c3njb", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $7OVjx = parcelRequire("7OVjx");
const $8c67d869b7b34318$var$SENTRY_SKIP_NORMALIZATION = /* @__PURE__ */ Symbol.for("sentry.skipNormalization");
const $8c67d869b7b34318$var$SENTRY_OVERRIDE_NORMALIZATION_DEPTH = /* @__PURE__ */ Symbol.for("sentry.overrideNormalizationDepth");
function $8c67d869b7b34318$var$setSkipNormalizationHint(obj) {
    $7OVjx.addNonEnumerableProperty(obj, $8c67d869b7b34318$var$SENTRY_SKIP_NORMALIZATION, true);
}
function $8c67d869b7b34318$var$setNormalizationDepthOverrideHint(obj, depth) {
    $7OVjx.addNonEnumerableProperty(obj, $8c67d869b7b34318$var$SENTRY_OVERRIDE_NORMALIZATION_DEPTH, depth);
}
function $8c67d869b7b34318$var$hasSkipNormalizationHint(value) {
    return Boolean(value[$8c67d869b7b34318$var$SENTRY_SKIP_NORMALIZATION]);
}
function $8c67d869b7b34318$var$getNormalizationDepthOverrideHint(value) {
    const v = value[$8c67d869b7b34318$var$SENTRY_OVERRIDE_NORMALIZATION_DEPTH];
    return typeof v === "number" ? v : void 0;
}
module.exports.getNormalizationDepthOverrideHint = $8c67d869b7b34318$var$getNormalizationDepthOverrideHint;
module.exports.hasSkipNormalizationHint = $8c67d869b7b34318$var$hasSkipNormalizationHint;
module.exports.setNormalizationDepthOverrideHint = $8c67d869b7b34318$var$setNormalizationDepthOverrideHint;
module.exports.setSkipNormalizationHint = $8c67d869b7b34318$var$setSkipNormalizationHint;

});




parcelRegister("ihsl1", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $lLUp4 = parcelRequire("lLUp4");

var $eP8Ri = parcelRequire("eP8Ri");
const $d4efcbdd7f843f89$var$ONE_SECOND_IN_MS = 1e3;
function $d4efcbdd7f843f89$var$dateTimestampInSeconds() {
    return $lLUp4.safeDateNow() / $d4efcbdd7f843f89$var$ONE_SECOND_IN_MS;
}
function $d4efcbdd7f843f89$var$createUnixTimestampInSecondsFunc() {
    const { performance: performance } = $eP8Ri.GLOBAL_OBJ;
    if (!performance?.now || !performance.timeOrigin) return $d4efcbdd7f843f89$var$dateTimestampInSeconds;
    const timeOrigin = performance.timeOrigin;
    return ()=>{
        return (timeOrigin + $lLUp4.withRandomSafeContext(()=>performance.now())) / $d4efcbdd7f843f89$var$ONE_SECOND_IN_MS;
    };
}
let $d4efcbdd7f843f89$var$_cachedTimestampInSeconds;
function $d4efcbdd7f843f89$var$timestampInSeconds() {
    const func = $d4efcbdd7f843f89$var$_cachedTimestampInSeconds ?? ($d4efcbdd7f843f89$var$_cachedTimestampInSeconds = $d4efcbdd7f843f89$var$createUnixTimestampInSecondsFunc());
    return func();
}
let $d4efcbdd7f843f89$var$cachedTimeOrigin = null;
function $d4efcbdd7f843f89$var$getBrowserTimeOrigin() {
    const { performance: performance } = $eP8Ri.GLOBAL_OBJ;
    if (!performance?.now) return void 0;
    const threshold = 3e5;
    const performanceNow = $lLUp4.withRandomSafeContext(()=>performance.now());
    const dateNow = $lLUp4.safeDateNow();
    const timeOrigin = performance.timeOrigin;
    if (typeof timeOrigin === "number") {
        const timeOriginDelta = Math.abs(timeOrigin + performanceNow - dateNow);
        if (timeOriginDelta < threshold) return timeOrigin;
    }
    const navigationStart = performance.timing?.navigationStart;
    if (typeof navigationStart === "number") {
        const navigationStartDelta = Math.abs(navigationStart + performanceNow - dateNow);
        if (navigationStartDelta < threshold) return navigationStart;
    }
    return dateNow - performanceNow;
}
function $d4efcbdd7f843f89$var$browserPerformanceTimeOrigin() {
    if ($d4efcbdd7f843f89$var$cachedTimeOrigin === null) $d4efcbdd7f843f89$var$cachedTimeOrigin = $d4efcbdd7f843f89$var$getBrowserTimeOrigin();
    return $d4efcbdd7f843f89$var$cachedTimeOrigin;
}
module.exports.browserPerformanceTimeOrigin = $d4efcbdd7f843f89$var$browserPerformanceTimeOrigin;
module.exports.dateTimestampInSeconds = $d4efcbdd7f843f89$var$dateTimestampInSeconds;
module.exports.timestampInSeconds = $d4efcbdd7f843f89$var$timestampInSeconds;

});


parcelRegister("c9oD0", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $8d896df53e214804$var$merge(initialObj, mergeObj, levels = 2) {
    if (!mergeObj || typeof mergeObj !== "object" || levels <= 0) return mergeObj;
    if (initialObj && Object.keys(mergeObj).length === 0) return initialObj;
    const output = {
        ...initialObj
    };
    for(const key in mergeObj)if (Object.prototype.hasOwnProperty.call(mergeObj, key)) output[key] = $8d896df53e214804$var$merge(output[key], mergeObj[key], levels - 1);
    return output;
}
module.exports.merge = $8d896df53e214804$var$merge;

});

parcelRegister("bLH3w", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $6JkyB = parcelRequire("6JkyB");
function $89157b7cd432452d$var$generateTraceId() {
    return $6JkyB.uuid4();
}
function $89157b7cd432452d$var$generateSpanId() {
    return $6JkyB.uuid4().substring(16);
}
module.exports.generateSpanId = $89157b7cd432452d$var$generateSpanId;
module.exports.generateTraceId = $89157b7cd432452d$var$generateTraceId;

});

parcelRegister("f9GTk", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $7OVjx = parcelRequire("7OVjx");

var $ckY1h = parcelRequire("ckY1h");
const $b088f7a339fa32f6$var$SCOPE_SPAN_FIELD = "_sentrySpan";
function $b088f7a339fa32f6$var$_setSpanForScope(scope, span) {
    if (span) $7OVjx.addNonEnumerableProperty(scope, $b088f7a339fa32f6$var$SCOPE_SPAN_FIELD, $ckY1h.makeWeakRef(span));
    else delete scope[$b088f7a339fa32f6$var$SCOPE_SPAN_FIELD];
}
function $b088f7a339fa32f6$var$_getSpanForScope(scope) {
    return $ckY1h.derefWeakRef(scope[$b088f7a339fa32f6$var$SCOPE_SPAN_FIELD]);
}
module.exports._getSpanForScope = $b088f7a339fa32f6$var$_getSpanForScope;
module.exports._setSpanForScope = $b088f7a339fa32f6$var$_setSpanForScope;

});
parcelRegister("ckY1h", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $eP8Ri = parcelRequire("eP8Ri");
function $8fb5e8f5d20aed33$var$makeWeakRef(value) {
    try {
        const WeakRefImpl = $eP8Ri.GLOBAL_OBJ.WeakRef;
        if (typeof WeakRefImpl === "function") return new WeakRefImpl(value);
    } catch  {}
    return value;
}
function $8fb5e8f5d20aed33$var$derefWeakRef(ref) {
    if (!ref) return void 0;
    if (typeof ref === "object" && "deref" in ref && typeof ref.deref === "function") try {
        return ref.deref();
    } catch  {
        return void 0;
    }
    return ref;
}
module.exports.derefWeakRef = $8fb5e8f5d20aed33$var$derefWeakRef;
module.exports.makeWeakRef = $8fb5e8f5d20aed33$var$makeWeakRef;

});




parcelRegister("lVeNe", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $ff5a6569db55c96c$var$isActualPromise = (p)=>p instanceof Promise && !p[$ff5a6569db55c96c$var$kChainedCopy];
const $ff5a6569db55c96c$var$kChainedCopy = /* @__PURE__ */ Symbol("chained PromiseLike");
const $ff5a6569db55c96c$var$chainAndCopyPromiseLike = (original, onSuccess, onError)=>{
    const chained = original.then((value)=>{
        onSuccess(value);
        return value;
    }, (err)=>{
        onError(err);
        throw err;
    });
    return $ff5a6569db55c96c$var$isActualPromise(chained) && $ff5a6569db55c96c$var$isActualPromise(original) ? chained : $ff5a6569db55c96c$var$copyProps(original, chained);
};
const $ff5a6569db55c96c$var$copyProps = (original, chained)=>{
    if (!chained) return original;
    let mutated = false;
    for(const key in original){
        if (key in chained) continue;
        mutated = true;
        const value = original[key];
        if (typeof value === "function") Object.defineProperty(chained, key, {
            value: (...args)=>value.apply(original, args),
            enumerable: true,
            configurable: true,
            writable: true
        });
        else chained[key] = value;
    }
    if (mutated) Object.assign(chained, {
        [$ff5a6569db55c96c$var$kChainedCopy]: true
    });
    return chained;
};
module.exports.chainAndCopyPromiseLike = $ff5a6569db55c96c$var$chainAndCopyPromiseLike;

});



parcelRegister("iSFYH", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $dzfKZ = parcelRequire("dzfKZ");
function $dbedd51ade19936f$var$isAttributeObject(maybeObj) {
    return typeof maybeObj === "object" && maybeObj != null && !Array.isArray(maybeObj) && Object.keys(maybeObj).includes("value");
}
function $dbedd51ade19936f$var$attributeValueToTypedAttributeValue(rawValue, useFallback) {
    const { value: value, unit: unit } = $dbedd51ade19936f$var$isAttributeObject(rawValue) ? rawValue : {
        value: rawValue,
        unit: void 0
    };
    const attributeValue = $dbedd51ade19936f$var$getTypedAttributeValue(value);
    const checkedUnit = unit && typeof unit === "string" ? {
        unit: unit
    } : {};
    if (attributeValue) return {
        ...attributeValue,
        ...checkedUnit
    };
    if (!useFallback || useFallback === "skip-undefined" && value === void 0) return;
    let stringValue = "";
    try {
        stringValue = JSON.stringify(value) ?? "";
    } catch  {}
    return {
        value: stringValue,
        type: "string",
        ...checkedUnit
    };
}
function $dbedd51ade19936f$var$serializeAttributes(attributes, fallback = false) {
    const serializedAttributes = {};
    for (const [key, value] of Object.entries(attributes ?? {})){
        const typedValue = $dbedd51ade19936f$var$attributeValueToTypedAttributeValue(value, fallback);
        if (typedValue) serializedAttributes[key] = typedValue;
    }
    return serializedAttributes;
}
function $dbedd51ade19936f$var$estimateTypedAttributesSizeInBytes(attributes) {
    if (!attributes) return 0;
    let weight = 0;
    for (const [key, attr] of Object.entries(attributes)){
        weight += key.length * 2;
        weight += attr.type.length * 2;
        weight += (attr.unit?.length ?? 0) * 2;
        const val = attr.value;
        if (Array.isArray(val)) weight += $dbedd51ade19936f$var$estimatePrimitiveSizeInBytes(val[0]) * val.length;
        else if ($dzfKZ.isPrimitive(val)) weight += $dbedd51ade19936f$var$estimatePrimitiveSizeInBytes(val);
        else weight += 100;
    }
    return weight;
}
function $dbedd51ade19936f$var$estimatePrimitiveSizeInBytes(value) {
    if (typeof value === "string") return value.length * 2;
    else if (typeof value === "boolean") return 4;
    else if (typeof value === "number") return 8;
    return 0;
}
function $dbedd51ade19936f$var$getTypedAttributeValue(value) {
    if (Array.isArray(value)) return {
        value: value,
        type: "array"
    };
    const primitiveType = typeof value === "string" ? "string" : typeof value === "boolean" ? "boolean" : typeof value === "number" && !Number.isNaN(value) ? Number.isInteger(value) ? "integer" : "double" : null;
    if (primitiveType) return {
        value: value,
        type: primitiveType
    };
}
module.exports.attributeValueToTypedAttributeValue = $dbedd51ade19936f$var$attributeValueToTypedAttributeValue;
module.exports.estimateTypedAttributesSizeInBytes = $dbedd51ade19936f$var$estimateTypedAttributesSizeInBytes;
module.exports.isAttributeObject = $dbedd51ade19936f$var$isAttributeObject;
module.exports.serializeAttributes = $dbedd51ade19936f$var$serializeAttributes;

});

parcelRegister("79m2C", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $diBhM = parcelRequire("diBhM");

var $4fnou = parcelRequire("4fnou");

var $d3JtV = parcelRequire("d3JtV");

var $bLH3w = parcelRequire("bLH3w");
let $534a789cb55ccd9d$var$_externalPropagationContextProvider;
function $534a789cb55ccd9d$var$registerExternalPropagationContext(fn) {
    $534a789cb55ccd9d$var$_externalPropagationContextProvider = fn;
}
function $534a789cb55ccd9d$var$getExternalPropagationContext() {
    return $534a789cb55ccd9d$var$_externalPropagationContextProvider?.();
}
function $534a789cb55ccd9d$var$hasExternalPropagationContext() {
    return $534a789cb55ccd9d$var$_externalPropagationContextProvider !== void 0;
}
function $534a789cb55ccd9d$var$getCurrentScope() {
    const carrier$1 = $4fnou.getMainCarrier();
    const acs = $diBhM.getAsyncContextStrategy(carrier$1);
    return acs.getCurrentScope();
}
function $534a789cb55ccd9d$var$getIsolationScope() {
    const carrier$1 = $4fnou.getMainCarrier();
    const acs = $diBhM.getAsyncContextStrategy(carrier$1);
    return acs.getIsolationScope();
}
function $534a789cb55ccd9d$var$getGlobalScope() {
    return $4fnou.getGlobalSingleton("globalScope", ()=>new $d3JtV.Scope());
}
function $534a789cb55ccd9d$var$withScope(...rest) {
    const carrier$1 = $4fnou.getMainCarrier();
    const acs = $diBhM.getAsyncContextStrategy(carrier$1);
    if (rest.length === 2) {
        const [scope, callback] = rest;
        if (!scope) return acs.withScope(callback);
        return acs.withSetScope(scope, callback);
    }
    return acs.withScope(rest[0]);
}
function $534a789cb55ccd9d$var$withIsolationScope(...rest) {
    const carrier$1 = $4fnou.getMainCarrier();
    const acs = $diBhM.getAsyncContextStrategy(carrier$1);
    if (rest.length === 2) {
        const [isolationScope, callback] = rest;
        if (!isolationScope) return acs.withIsolationScope(callback);
        return acs.withSetIsolationScope(isolationScope, callback);
    }
    return acs.withIsolationScope(rest[0]);
}
function $534a789cb55ccd9d$var$getClient() {
    return $534a789cb55ccd9d$var$getCurrentScope().getClient();
}
function $534a789cb55ccd9d$var$getTraceContextFromScope(scope) {
    const externalContext = $534a789cb55ccd9d$var$getExternalPropagationContext();
    if (externalContext) return {
        trace_id: externalContext.traceId,
        span_id: externalContext.spanId
    };
    const propagationContext$1 = scope.getPropagationContext();
    const { traceId: traceId, parentSpanId: parentSpanId, propagationSpanId: propagationSpanId } = propagationContext$1;
    const traceContext = {
        trace_id: traceId,
        span_id: propagationSpanId || $bLH3w.generateSpanId()
    };
    if (parentSpanId) traceContext.parent_span_id = parentSpanId;
    return traceContext;
}
module.exports.getClient = $534a789cb55ccd9d$var$getClient;
module.exports.getCurrentScope = $534a789cb55ccd9d$var$getCurrentScope;
module.exports.getExternalPropagationContext = $534a789cb55ccd9d$var$getExternalPropagationContext;
module.exports.getGlobalScope = $534a789cb55ccd9d$var$getGlobalScope;
module.exports.getIsolationScope = $534a789cb55ccd9d$var$getIsolationScope;
module.exports.getTraceContextFromScope = $534a789cb55ccd9d$var$getTraceContextFromScope;
module.exports.hasExternalPropagationContext = $534a789cb55ccd9d$var$hasExternalPropagationContext;
module.exports.registerExternalPropagationContext = $534a789cb55ccd9d$var$registerExternalPropagationContext;
module.exports.withIsolationScope = $534a789cb55ccd9d$var$withIsolationScope;
module.exports.withScope = $534a789cb55ccd9d$var$withScope;

});

parcelRegister("gTasE", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $c4b9e5bfeed624c9$var$SEMANTIC_ATTRIBUTE_SENTRY_SOURCE = "sentry.source";
const $c4b9e5bfeed624c9$var$SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE = "sentry.sample_rate";
const $c4b9e5bfeed624c9$var$SEMANTIC_ATTRIBUTE_SENTRY_PREVIOUS_TRACE_SAMPLE_RATE = "sentry.previous_trace_sample_rate";
const $c4b9e5bfeed624c9$var$SEMANTIC_ATTRIBUTE_SENTRY_OP = "sentry.op";
const $c4b9e5bfeed624c9$var$SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN = "sentry.origin";
const $c4b9e5bfeed624c9$var$SEMANTIC_ATTRIBUTE_SENTRY_STATUS_MESSAGE = "sentry.status.message";
const $c4b9e5bfeed624c9$var$SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON = "sentry.idle_span_finish_reason";
const $c4b9e5bfeed624c9$var$SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT = "sentry.measurement_unit";
const $c4b9e5bfeed624c9$var$SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE = "sentry.measurement_value";
const $c4b9e5bfeed624c9$var$SEMANTIC_ATTRIBUTE_SENTRY_RELEASE = "sentry.release";
const $c4b9e5bfeed624c9$var$SEMANTIC_ATTRIBUTE_SENTRY_ENVIRONMENT = "sentry.environment";
const $c4b9e5bfeed624c9$var$SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_NAME = "sentry.segment.name";
const $c4b9e5bfeed624c9$var$SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_ID = "sentry.segment.id";
const $c4b9e5bfeed624c9$var$SEMANTIC_ATTRIBUTE_SENTRY_SDK_NAME = "sentry.sdk.name";
const $c4b9e5bfeed624c9$var$SEMANTIC_ATTRIBUTE_SENTRY_SDK_VERSION = "sentry.sdk.version";
const $c4b9e5bfeed624c9$var$SEMANTIC_ATTRIBUTE_SENTRY_SDK_INTEGRATIONS = "sentry.sdk.integrations";
const $c4b9e5bfeed624c9$var$SEMANTIC_ATTRIBUTE_USER_ID = "user.id";
const $c4b9e5bfeed624c9$var$SEMANTIC_ATTRIBUTE_USER_EMAIL = "user.email";
const $c4b9e5bfeed624c9$var$SEMANTIC_ATTRIBUTE_USER_IP_ADDRESS = "user.ip_address";
const $c4b9e5bfeed624c9$var$SEMANTIC_ATTRIBUTE_USER_USERNAME = "user.name";
const $c4b9e5bfeed624c9$var$SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME = "sentry.custom_span_name";
const $c4b9e5bfeed624c9$var$SEMANTIC_ATTRIBUTE_PROFILE_ID = "sentry.profile_id";
const $c4b9e5bfeed624c9$var$SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME = "sentry.exclusive_time";
const $c4b9e5bfeed624c9$var$SEMANTIC_ATTRIBUTE_CACHE_HIT = "cache.hit";
const $c4b9e5bfeed624c9$var$SEMANTIC_ATTRIBUTE_CACHE_KEY = "cache.key";
const $c4b9e5bfeed624c9$var$SEMANTIC_ATTRIBUTE_CACHE_ITEM_SIZE = "cache.item_size";
const $c4b9e5bfeed624c9$var$SEMANTIC_ATTRIBUTE_HTTP_REQUEST_METHOD = "http.request.method";
const $c4b9e5bfeed624c9$var$SEMANTIC_ATTRIBUTE_URL_FULL = "url.full";
const $c4b9e5bfeed624c9$var$SEMANTIC_LINK_ATTRIBUTE_LINK_TYPE = "sentry.link.type";
const $c4b9e5bfeed624c9$var$GEN_AI_CONVERSATION_ID_ATTRIBUTE = "gen_ai.conversation.id";
module.exports.GEN_AI_CONVERSATION_ID_ATTRIBUTE = $c4b9e5bfeed624c9$var$GEN_AI_CONVERSATION_ID_ATTRIBUTE;
module.exports.SEMANTIC_ATTRIBUTE_CACHE_HIT = $c4b9e5bfeed624c9$var$SEMANTIC_ATTRIBUTE_CACHE_HIT;
module.exports.SEMANTIC_ATTRIBUTE_CACHE_ITEM_SIZE = $c4b9e5bfeed624c9$var$SEMANTIC_ATTRIBUTE_CACHE_ITEM_SIZE;
module.exports.SEMANTIC_ATTRIBUTE_CACHE_KEY = $c4b9e5bfeed624c9$var$SEMANTIC_ATTRIBUTE_CACHE_KEY;
module.exports.SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME = $c4b9e5bfeed624c9$var$SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME;
module.exports.SEMANTIC_ATTRIBUTE_HTTP_REQUEST_METHOD = $c4b9e5bfeed624c9$var$SEMANTIC_ATTRIBUTE_HTTP_REQUEST_METHOD;
module.exports.SEMANTIC_ATTRIBUTE_PROFILE_ID = $c4b9e5bfeed624c9$var$SEMANTIC_ATTRIBUTE_PROFILE_ID;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME = $c4b9e5bfeed624c9$var$SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_ENVIRONMENT = $c4b9e5bfeed624c9$var$SEMANTIC_ATTRIBUTE_SENTRY_ENVIRONMENT;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON = $c4b9e5bfeed624c9$var$SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT = $c4b9e5bfeed624c9$var$SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE = $c4b9e5bfeed624c9$var$SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_OP = $c4b9e5bfeed624c9$var$SEMANTIC_ATTRIBUTE_SENTRY_OP;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN = $c4b9e5bfeed624c9$var$SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_PREVIOUS_TRACE_SAMPLE_RATE = $c4b9e5bfeed624c9$var$SEMANTIC_ATTRIBUTE_SENTRY_PREVIOUS_TRACE_SAMPLE_RATE;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_RELEASE = $c4b9e5bfeed624c9$var$SEMANTIC_ATTRIBUTE_SENTRY_RELEASE;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE = $c4b9e5bfeed624c9$var$SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SDK_INTEGRATIONS = $c4b9e5bfeed624c9$var$SEMANTIC_ATTRIBUTE_SENTRY_SDK_INTEGRATIONS;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SDK_NAME = $c4b9e5bfeed624c9$var$SEMANTIC_ATTRIBUTE_SENTRY_SDK_NAME;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SDK_VERSION = $c4b9e5bfeed624c9$var$SEMANTIC_ATTRIBUTE_SENTRY_SDK_VERSION;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_ID = $c4b9e5bfeed624c9$var$SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_ID;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_NAME = $c4b9e5bfeed624c9$var$SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_NAME;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE = $c4b9e5bfeed624c9$var$SEMANTIC_ATTRIBUTE_SENTRY_SOURCE;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_STATUS_MESSAGE = $c4b9e5bfeed624c9$var$SEMANTIC_ATTRIBUTE_SENTRY_STATUS_MESSAGE;
module.exports.SEMANTIC_ATTRIBUTE_URL_FULL = $c4b9e5bfeed624c9$var$SEMANTIC_ATTRIBUTE_URL_FULL;
module.exports.SEMANTIC_ATTRIBUTE_USER_EMAIL = $c4b9e5bfeed624c9$var$SEMANTIC_ATTRIBUTE_USER_EMAIL;
module.exports.SEMANTIC_ATTRIBUTE_USER_ID = $c4b9e5bfeed624c9$var$SEMANTIC_ATTRIBUTE_USER_ID;
module.exports.SEMANTIC_ATTRIBUTE_USER_IP_ADDRESS = $c4b9e5bfeed624c9$var$SEMANTIC_ATTRIBUTE_USER_IP_ADDRESS;
module.exports.SEMANTIC_ATTRIBUTE_USER_USERNAME = $c4b9e5bfeed624c9$var$SEMANTIC_ATTRIBUTE_USER_USERNAME;
module.exports.SEMANTIC_LINK_ATTRIBUTE_LINK_TYPE = $c4b9e5bfeed624c9$var$SEMANTIC_LINK_ATTRIBUTE_LINK_TYPE;

});

parcelRegister("yI1C9", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $0685538bb33d090d$var$SPAN_STATUS_UNSET = 0;
const $0685538bb33d090d$var$SPAN_STATUS_OK = 1;
const $0685538bb33d090d$var$SPAN_STATUS_ERROR = 2;
function $0685538bb33d090d$var$getSpanStatusFromHttpCode(httpStatus) {
    if (httpStatus < 400 && httpStatus >= 100) return {
        code: $0685538bb33d090d$var$SPAN_STATUS_OK
    };
    if (httpStatus >= 400 && httpStatus < 500) switch(httpStatus){
        case 401:
            return {
                code: $0685538bb33d090d$var$SPAN_STATUS_ERROR,
                message: "unauthenticated"
            };
        case 403:
            return {
                code: $0685538bb33d090d$var$SPAN_STATUS_ERROR,
                message: "permission_denied"
            };
        case 404:
            return {
                code: $0685538bb33d090d$var$SPAN_STATUS_ERROR,
                message: "not_found"
            };
        case 409:
            return {
                code: $0685538bb33d090d$var$SPAN_STATUS_ERROR,
                message: "already_exists"
            };
        case 413:
            return {
                code: $0685538bb33d090d$var$SPAN_STATUS_ERROR,
                message: "failed_precondition"
            };
        case 429:
            return {
                code: $0685538bb33d090d$var$SPAN_STATUS_ERROR,
                message: "resource_exhausted"
            };
        case 499:
            return {
                code: $0685538bb33d090d$var$SPAN_STATUS_ERROR,
                message: "cancelled"
            };
        default:
            return {
                code: $0685538bb33d090d$var$SPAN_STATUS_ERROR,
                message: "invalid_argument"
            };
    }
    if (httpStatus >= 500 && httpStatus < 600) switch(httpStatus){
        case 501:
            return {
                code: $0685538bb33d090d$var$SPAN_STATUS_ERROR,
                message: "unimplemented"
            };
        case 503:
            return {
                code: $0685538bb33d090d$var$SPAN_STATUS_ERROR,
                message: "unavailable"
            };
        case 504:
            return {
                code: $0685538bb33d090d$var$SPAN_STATUS_ERROR,
                message: "deadline_exceeded"
            };
        default:
            return {
                code: $0685538bb33d090d$var$SPAN_STATUS_ERROR,
                message: "internal_error"
            };
    }
    return {
        code: $0685538bb33d090d$var$SPAN_STATUS_ERROR,
        message: "internal_error"
    };
}
function $0685538bb33d090d$var$setHttpStatus(span, httpStatus) {
    span.setAttribute("http.response.status_code", httpStatus);
    const spanStatus = $0685538bb33d090d$var$getSpanStatusFromHttpCode(httpStatus);
    if (spanStatus.message !== "unknown_error") span.setStatus(spanStatus);
}
module.exports.SPAN_STATUS_ERROR = $0685538bb33d090d$var$SPAN_STATUS_ERROR;
module.exports.SPAN_STATUS_OK = $0685538bb33d090d$var$SPAN_STATUS_OK;
module.exports.SPAN_STATUS_UNSET = $0685538bb33d090d$var$SPAN_STATUS_UNSET;
module.exports.getSpanStatusFromHttpCode = $0685538bb33d090d$var$getSpanStatusFromHttpCode;
module.exports.setHttpStatus = $0685538bb33d090d$var$setHttpStatus;

});

parcelRegister("bkBh2", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $7OVjx = parcelRequire("7OVjx");

var $ckY1h = parcelRequire("ckY1h");
const $83fe79c9b4946a55$var$SCOPE_ON_START_SPAN_FIELD = "_sentryScope";
const $83fe79c9b4946a55$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD = "_sentryIsolationScope";
const $83fe79c9b4946a55$var$OTEL_SOURCE_INFERENCE_SPAN_FIELD = /* @__PURE__ */ Symbol.for("sentry.otelSourceInference");
const $83fe79c9b4946a55$var$OTEL_SOURCE_EXPLICITLY_SET_SPAN_FIELD = /* @__PURE__ */ Symbol.for("sentry.otelSourceExplicitlySet");
const $83fe79c9b4946a55$var$TRACER_PROVIDER_SPAN_FIELD = /* @__PURE__ */ Symbol.for("sentry.tracerProviderSpan");
function $83fe79c9b4946a55$var$setCapturedScopesOnSpan(span, scope, isolationScope) {
    if (span) {
        $7OVjx.addNonEnumerableProperty(span, $83fe79c9b4946a55$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD, $ckY1h.makeWeakRef(isolationScope));
        $7OVjx.addNonEnumerableProperty(span, $83fe79c9b4946a55$var$SCOPE_ON_START_SPAN_FIELD, scope);
    }
}
function $83fe79c9b4946a55$var$getCapturedScopesOnSpan(span) {
    const spanWithScopes = span;
    return {
        scope: spanWithScopes[$83fe79c9b4946a55$var$SCOPE_ON_START_SPAN_FIELD],
        isolationScope: $ckY1h.derefWeakRef(spanWithScopes[$83fe79c9b4946a55$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD])
    };
}
function $83fe79c9b4946a55$var$markSpanForOtelSourceInference(span) {
    $7OVjx.addNonEnumerableProperty(span, $83fe79c9b4946a55$var$OTEL_SOURCE_INFERENCE_SPAN_FIELD, true);
}
function $83fe79c9b4946a55$var$spanShouldInferOtelSource(span) {
    return span[$83fe79c9b4946a55$var$OTEL_SOURCE_INFERENCE_SPAN_FIELD] === true;
}
function $83fe79c9b4946a55$var$markSpanSourceAsExplicit(span) {
    $7OVjx.addNonEnumerableProperty(span, $83fe79c9b4946a55$var$OTEL_SOURCE_EXPLICITLY_SET_SPAN_FIELD, true);
}
function $83fe79c9b4946a55$var$spanSourceWasExplicitlySet(span) {
    return span[$83fe79c9b4946a55$var$OTEL_SOURCE_EXPLICITLY_SET_SPAN_FIELD] === true;
}
function $83fe79c9b4946a55$var$markSpanAsTracerProviderSpan(span) {
    $7OVjx.addNonEnumerableProperty(span, $83fe79c9b4946a55$var$TRACER_PROVIDER_SPAN_FIELD, true);
}
function $83fe79c9b4946a55$var$spanIsTracerProviderSpan(span) {
    return span[$83fe79c9b4946a55$var$TRACER_PROVIDER_SPAN_FIELD] === true;
}
module.exports.getCapturedScopesOnSpan = $83fe79c9b4946a55$var$getCapturedScopesOnSpan;
module.exports.markSpanAsTracerProviderSpan = $83fe79c9b4946a55$var$markSpanAsTracerProviderSpan;
module.exports.markSpanForOtelSourceInference = $83fe79c9b4946a55$var$markSpanForOtelSourceInference;
module.exports.markSpanSourceAsExplicit = $83fe79c9b4946a55$var$markSpanSourceAsExplicit;
module.exports.setCapturedScopesOnSpan = $83fe79c9b4946a55$var$setCapturedScopesOnSpan;
module.exports.spanIsTracerProviderSpan = $83fe79c9b4946a55$var$spanIsTracerProviderSpan;
module.exports.spanShouldInferOtelSource = $83fe79c9b4946a55$var$spanShouldInferOtelSource;
module.exports.spanSourceWasExplicitlySet = $83fe79c9b4946a55$var$spanSourceWasExplicitlySet;

});

parcelRegister("3ZCGz", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $4gyod = parcelRequire("4gyod");

var $l5MWU = parcelRequire("l5MWU");

var $7E8b3 = parcelRequire("7E8b3");

var $dkhYR = parcelRequire("dkhYR");

var $bLH3w = parcelRequire("bLH3w");

var $lLUp4 = parcelRequire("lLUp4");
const $2e8513c23bb68309$var$TRACEPARENT_REGEXP = new RegExp("^[ \\t]*([0-9a-f]{32})?-?([0-9a-f]{16})?-?([01])?[ \\t]*$");
function $2e8513c23bb68309$var$extractTraceparentData(traceparent) {
    if (!traceparent) return void 0;
    const matches = traceparent.match($2e8513c23bb68309$var$TRACEPARENT_REGEXP);
    if (!matches) return void 0;
    let parentSampled;
    if (matches[3] === "1") parentSampled = true;
    else if (matches[3] === "0") parentSampled = false;
    return {
        traceId: matches[1],
        parentSampled: parentSampled,
        parentSpanId: matches[2]
    };
}
function $2e8513c23bb68309$var$propagationContextFromHeaders(sentryTrace, baggage$1) {
    const traceparentData = $2e8513c23bb68309$var$extractTraceparentData(sentryTrace);
    const dynamicSamplingContext = $l5MWU.baggageHeaderToDynamicSamplingContext(baggage$1);
    if (!traceparentData?.traceId) return {
        traceId: $bLH3w.generateTraceId(),
        sampleRand: $lLUp4.safeMathRandom()
    };
    const sampleRand = $2e8513c23bb68309$var$getSampleRandFromTraceparentAndDsc(traceparentData, dynamicSamplingContext);
    if (dynamicSamplingContext) dynamicSamplingContext.sample_rand = sampleRand.toString();
    const { traceId: traceId, parentSpanId: parentSpanId, parentSampled: parentSampled } = traceparentData;
    return {
        traceId: traceId,
        parentSpanId: parentSpanId,
        sampled: parentSampled,
        dsc: dynamicSamplingContext || {},
        sampleRand: // If we have traceparent data but no DSC it means we are not head of trace and we must freeze it
        sampleRand
    };
}
function $2e8513c23bb68309$var$generateSentryTraceHeader(traceId = $bLH3w.generateTraceId(), spanId = $bLH3w.generateSpanId(), sampled) {
    let sampledString = "";
    if (sampled !== void 0) sampledString = sampled ? "-1" : "-0";
    return `${traceId}-${spanId}${sampledString}`;
}
function $2e8513c23bb68309$var$generateTraceparentHeader(traceId = $bLH3w.generateTraceId(), spanId = $bLH3w.generateSpanId(), sampled) {
    return `00-${traceId}-${spanId}-${sampled ? "01" : "00"}`;
}
function $2e8513c23bb68309$var$getSampleRandFromTraceparentAndDsc(traceparentData, dsc) {
    const parsedSampleRand = $dkhYR.parseSampleRate(dsc?.sample_rand);
    if (parsedSampleRand !== void 0) return parsedSampleRand;
    const parsedSampleRate = $dkhYR.parseSampleRate(dsc?.sample_rate);
    if (parsedSampleRate && traceparentData?.parentSampled !== void 0) return traceparentData.parentSampled ? // Returns a sample rand with positive sampling decision [0, sampleRate)
    $lLUp4.safeMathRandom() * parsedSampleRate : // Returns a sample rand with negative sampling decision [sampleRate, 1)
    parsedSampleRate + $lLUp4.safeMathRandom() * (1 - parsedSampleRate);
    else return $lLUp4.safeMathRandom();
}
function $2e8513c23bb68309$var$shouldContinueTrace(client, baggageOrgId) {
    const clientOrgId = $7E8b3.extractOrgIdFromClient(client);
    if (baggageOrgId && clientOrgId && baggageOrgId !== clientOrgId) {
        $4gyod.debug.log(`Won't continue trace because org IDs don't match (incoming baggage: ${baggageOrgId}, SDK options: ${clientOrgId})`);
        return false;
    }
    const strictTraceContinuation = client.getOptions().strictTraceContinuation || false;
    if (strictTraceContinuation) {
        if (baggageOrgId && !clientOrgId || !baggageOrgId && clientOrgId) {
            $4gyod.debug.log(`Starting a new trace because strict trace continuation is enabled but one org ID is missing (incoming baggage: ${baggageOrgId}, Sentry client: ${clientOrgId})`);
            return false;
        }
    }
    return true;
}
module.exports.TRACEPARENT_REGEXP = $2e8513c23bb68309$var$TRACEPARENT_REGEXP;
module.exports.extractTraceparentData = $2e8513c23bb68309$var$extractTraceparentData;
module.exports.generateSentryTraceHeader = $2e8513c23bb68309$var$generateSentryTraceHeader;
module.exports.generateTraceparentHeader = $2e8513c23bb68309$var$generateTraceparentHeader;
module.exports.propagationContextFromHeaders = $2e8513c23bb68309$var$propagationContextFromHeaders;
module.exports.shouldContinueTrace = $2e8513c23bb68309$var$shouldContinueTrace;

});
parcelRegister("l5MWU", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $hiZR1 = parcelRequire("hiZR1");

var $4gyod = parcelRequire("4gyod");

var $dzfKZ = parcelRequire("dzfKZ");
const $f5b008e5491ffd45$var$SENTRY_BAGGAGE_KEY_PREFIX = "sentry-";
const $f5b008e5491ffd45$var$SENTRY_BAGGAGE_KEY_PREFIX_REGEX = /^sentry-/;
const $f5b008e5491ffd45$var$MAX_BAGGAGE_STRING_LENGTH = 8192;
function $f5b008e5491ffd45$var$baggageHeaderToDynamicSamplingContext(baggageHeader) {
    const baggageObject = $f5b008e5491ffd45$var$parseBaggageHeader(baggageHeader);
    if (!baggageObject) return void 0;
    const dynamicSamplingContext = Object.entries(baggageObject).reduce((acc, [key, value])=>{
        if (key.startsWith($f5b008e5491ffd45$var$SENTRY_BAGGAGE_KEY_PREFIX)) {
            const nonPrefixedKey = key.slice($f5b008e5491ffd45$var$SENTRY_BAGGAGE_KEY_PREFIX.length);
            acc[nonPrefixedKey] = value;
        }
        return acc;
    }, {});
    if (Object.keys(dynamicSamplingContext).length > 0) return dynamicSamplingContext;
    else return void 0;
}
function $f5b008e5491ffd45$var$dynamicSamplingContextToSentryBaggageHeader(dynamicSamplingContext) {
    if (!dynamicSamplingContext) return void 0;
    const sentryPrefixedDSC = Object.entries(dynamicSamplingContext).reduce((acc, [dscKey, dscValue])=>{
        if (dscValue) acc[`${$f5b008e5491ffd45$var$SENTRY_BAGGAGE_KEY_PREFIX}${dscKey}`] = dscValue;
        return acc;
    }, {});
    return $f5b008e5491ffd45$var$objectToBaggageHeader(sentryPrefixedDSC);
}
function $f5b008e5491ffd45$var$parseBaggageHeader(baggageHeader) {
    if (!baggageHeader || !$dzfKZ.isString(baggageHeader) && !Array.isArray(baggageHeader)) return void 0;
    if (Array.isArray(baggageHeader)) return baggageHeader.reduce((acc, curr)=>{
        const currBaggageObject = $f5b008e5491ffd45$var$baggageHeaderToObject(curr);
        Object.entries(currBaggageObject).forEach(([key, value])=>{
            acc[key] = value;
        });
        return acc;
    }, {});
    return $f5b008e5491ffd45$var$baggageHeaderToObject(baggageHeader);
}
function $f5b008e5491ffd45$var$baggageHeaderToObject(baggageHeader) {
    return baggageHeader.split(",").map((baggageEntry)=>{
        const eqIdx = baggageEntry.indexOf("=");
        if (eqIdx === -1) return [];
        const key = baggageEntry.slice(0, eqIdx);
        const value = baggageEntry.slice(eqIdx + 1);
        return [
            key,
            value
        ].map((keyOrValue)=>{
            try {
                return decodeURIComponent(keyOrValue.trim());
            } catch  {
                return;
            }
        });
    }).reduce((acc, [key, value])=>{
        if (key && value) acc[key] = value;
        return acc;
    }, {});
}
function $f5b008e5491ffd45$var$objectToBaggageHeader(object) {
    if (Object.keys(object).length === 0) return void 0;
    return Object.entries(object).reduce((baggageHeader, [objectKey, objectValue], currentIndex)=>{
        const baggageEntry = `${encodeURIComponent(objectKey)}=${encodeURIComponent(objectValue)}`;
        const newBaggageHeader = currentIndex === 0 ? baggageEntry : `${baggageHeader},${baggageEntry}`;
        if (newBaggageHeader.length > $f5b008e5491ffd45$var$MAX_BAGGAGE_STRING_LENGTH) {
            $hiZR1.DEBUG_BUILD && $4gyod.debug.warn(`Not adding key: ${objectKey} with val: ${objectValue} to baggage header due to exceeding baggage size limits.`);
            return baggageHeader;
        } else return newBaggageHeader;
    }, "");
}
function $f5b008e5491ffd45$var$mergeBaggageHeaders(existing, incoming) {
    if (!existing) return incoming;
    const existingEntries = $f5b008e5491ffd45$var$parseBaggageHeader(existing);
    const incomingEntries = $f5b008e5491ffd45$var$parseBaggageHeader(incoming);
    if (!incomingEntries) return existing;
    const merged = {};
    let hasNewSentryEntries = false;
    const newSentryEntries = {};
    const newNonSentryEntries = {};
    for (const [key, value] of Object.entries(incomingEntries))if (key.startsWith($f5b008e5491ffd45$var$SENTRY_BAGGAGE_KEY_PREFIX)) {
        newSentryEntries[key] = value;
        hasNewSentryEntries = true;
    } else newNonSentryEntries[key] = value;
    if (existingEntries) {
        for (const [key, value] of Object.entries(existingEntries))if (!hasNewSentryEntries || !key.startsWith($f5b008e5491ffd45$var$SENTRY_BAGGAGE_KEY_PREFIX)) merged[key] = value;
    }
    if (hasNewSentryEntries) Object.assign(merged, newSentryEntries);
    for (const [key, value] of Object.entries(newNonSentryEntries))merged[key] ?? (merged[key] = value);
    return $f5b008e5491ffd45$var$objectToBaggageHeader(merged);
}
module.exports.MAX_BAGGAGE_STRING_LENGTH = $f5b008e5491ffd45$var$MAX_BAGGAGE_STRING_LENGTH;
module.exports.SENTRY_BAGGAGE_KEY_PREFIX = $f5b008e5491ffd45$var$SENTRY_BAGGAGE_KEY_PREFIX;
module.exports.SENTRY_BAGGAGE_KEY_PREFIX_REGEX = $f5b008e5491ffd45$var$SENTRY_BAGGAGE_KEY_PREFIX_REGEX;
module.exports.baggageHeaderToDynamicSamplingContext = $f5b008e5491ffd45$var$baggageHeaderToDynamicSamplingContext;
module.exports.dynamicSamplingContextToSentryBaggageHeader = $f5b008e5491ffd45$var$dynamicSamplingContextToSentryBaggageHeader;
module.exports.mergeBaggageHeaders = $f5b008e5491ffd45$var$mergeBaggageHeaders;
module.exports.objectToBaggageHeader = $f5b008e5491ffd45$var$objectToBaggageHeader;
module.exports.parseBaggageHeader = $f5b008e5491ffd45$var$parseBaggageHeader;

});

parcelRegister("7E8b3", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $hiZR1 = parcelRequire("hiZR1");

var $4gyod = parcelRequire("4gyod");
const $59129cad66e5c850$var$ORG_ID_REGEX = /^o(\d+)\./;
const $59129cad66e5c850$var$DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+)?)?@)((?:\[[:.%\w]+\]|[\w.-]+))(?::(\d+))?\/(.+)/;
function $59129cad66e5c850$var$isValidProtocol(protocol) {
    return protocol === "http" || protocol === "https";
}
function $59129cad66e5c850$var$dsnToString(dsn, withPassword = false) {
    const { host: host, path: path, pass: pass, port: port, projectId: projectId, protocol: protocol, publicKey: publicKey } = dsn;
    return `${protocol}://${publicKey}${withPassword && pass ? `:${pass}` : ""}@${host}${port ? `:${port}` : ""}/${path ? `${path}/` : path}${projectId}`;
}
function $59129cad66e5c850$var$dsnFromString(str) {
    const match = $59129cad66e5c850$var$DSN_REGEX.exec(str);
    if (!match) {
        $4gyod.consoleSandbox(()=>{
            console.error(`Invalid Sentry Dsn: ${str}`);
        });
        return void 0;
    }
    const [protocol, publicKey, pass = "", host = "", port = "", lastPath = ""] = match.slice(1);
    let path = "";
    let projectId = lastPath;
    const split = projectId.split("/");
    if (split.length > 1) {
        path = split.slice(0, -1).join("/");
        projectId = split.pop();
    }
    if (projectId) {
        const projectMatch = projectId.match(/^\d+/);
        if (projectMatch) projectId = projectMatch[0];
    }
    return $59129cad66e5c850$var$dsnFromComponents({
        host: host,
        pass: pass,
        path: path,
        projectId: projectId,
        port: port,
        protocol: protocol,
        publicKey: publicKey
    });
}
function $59129cad66e5c850$var$dsnFromComponents(components) {
    return {
        protocol: components.protocol,
        publicKey: components.publicKey || "",
        pass: components.pass || "",
        host: components.host,
        port: components.port || "",
        path: components.path || "",
        projectId: components.projectId
    };
}
function $59129cad66e5c850$var$validateDsn(dsn) {
    if (!$hiZR1.DEBUG_BUILD) return true;
    const { port: port, projectId: projectId, protocol: protocol } = dsn;
    const requiredComponents = [
        "protocol",
        "publicKey",
        "host",
        "projectId"
    ];
    const hasMissingRequiredComponent = requiredComponents.find((component)=>{
        if (!dsn[component]) {
            $4gyod.debug.error(`Invalid Sentry Dsn: ${component} missing`);
            return true;
        }
        return false;
    });
    if (hasMissingRequiredComponent) return false;
    if (!projectId.match(/^\d+$/)) {
        $4gyod.debug.error(`Invalid Sentry Dsn: Invalid projectId ${projectId}`);
        return false;
    }
    if (!$59129cad66e5c850$var$isValidProtocol(protocol)) {
        $4gyod.debug.error(`Invalid Sentry Dsn: Invalid protocol ${protocol}`);
        return false;
    }
    if (port && isNaN(parseInt(port, 10))) {
        $4gyod.debug.error(`Invalid Sentry Dsn: Invalid port ${port}`);
        return false;
    }
    return true;
}
function $59129cad66e5c850$var$extractOrgIdFromDsnHost(host) {
    const match = host.match($59129cad66e5c850$var$ORG_ID_REGEX);
    return match?.[1];
}
function $59129cad66e5c850$var$extractOrgIdFromClient(client) {
    const options = client.getOptions();
    const { host: host } = client.getDsn() || {};
    let org_id;
    if (options.orgId) org_id = String(options.orgId);
    else if (host) org_id = $59129cad66e5c850$var$extractOrgIdFromDsnHost(host);
    return org_id;
}
function $59129cad66e5c850$var$makeDsn(from) {
    const components = typeof from === "string" ? $59129cad66e5c850$var$dsnFromString(from) : $59129cad66e5c850$var$dsnFromComponents(from);
    if (!components || !$59129cad66e5c850$var$validateDsn(components)) return void 0;
    return components;
}
module.exports.dsnFromString = $59129cad66e5c850$var$dsnFromString;
module.exports.dsnToString = $59129cad66e5c850$var$dsnToString;
module.exports.extractOrgIdFromClient = $59129cad66e5c850$var$extractOrgIdFromClient;
module.exports.extractOrgIdFromDsnHost = $59129cad66e5c850$var$extractOrgIdFromDsnHost;
module.exports.makeDsn = $59129cad66e5c850$var$makeDsn;

});

parcelRegister("dkhYR", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $9b3b172fa9ca82fe$var$parseSampleRate(sampleRate) {
    if (typeof sampleRate === "boolean") return Number(sampleRate);
    const rate = typeof sampleRate === "string" ? parseFloat(sampleRate) : sampleRate;
    if (typeof rate !== "number" || isNaN(rate) || rate < 0 || rate > 1) return void 0;
    return rate;
}
module.exports.parseSampleRate = $9b3b172fa9ca82fe$var$parseSampleRate;

});




parcelRegister("jCNU0", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $79m2C = parcelRequire("79m2C");

var $hiZR1 = parcelRequire("hiZR1");

var $gTasE = parcelRequire("gTasE");

var $4gyod = parcelRequire("4gyod");

var $6emr7 = parcelRequire("6emr7");

var $cRlHT = parcelRequire("cRlHT");

var $f9GTk = parcelRequire("f9GTk");

var $8jbnX = parcelRequire("8jbnX");

var $ihsl1 = parcelRequire("ihsl1");

var $boFM9 = parcelRequire("boFM9");

var $capUI = parcelRequire("capUI");

var $yI1C9 = parcelRequire("yI1C9");

var $kBDP8 = parcelRequire("kBDP8");

var $bkBh2 = parcelRequire("bkBh2");
const $e4984677c41781bd$var$TRACING_DEFAULTS = {
    idleTimeout: 1e3,
    finalTimeout: 3e4,
    childSpanTimeout: 15e3
};
const $e4984677c41781bd$var$FINISH_REASON_HEARTBEAT_FAILED = "heartbeatFailed";
const $e4984677c41781bd$var$FINISH_REASON_IDLE_TIMEOUT = "idleTimeout";
const $e4984677c41781bd$var$FINISH_REASON_FINAL_TIMEOUT = "finalTimeout";
const $e4984677c41781bd$var$FINISH_REASON_EXTERNAL_FINISH = "externalFinish";
function $e4984677c41781bd$var$startIdleSpan(startSpanOptions, options = {}) {
    const activities = /* @__PURE__ */ new Map();
    let _finished = false;
    let _idleTimeoutID;
    let _finishReason = $e4984677c41781bd$var$FINISH_REASON_EXTERNAL_FINISH;
    let _autoFinishAllowed = !options.disableAutoFinish;
    const _cleanupHooks = [];
    const { idleTimeout: idleTimeout = $e4984677c41781bd$var$TRACING_DEFAULTS.idleTimeout, finalTimeout: finalTimeout = $e4984677c41781bd$var$TRACING_DEFAULTS.finalTimeout, childSpanTimeout: childSpanTimeout = $e4984677c41781bd$var$TRACING_DEFAULTS.childSpanTimeout, beforeSpanEnd: beforeSpanEnd, trimIdleSpanEndTimestamp: trimIdleSpanEndTimestamp = true } = options;
    const client = $79m2C.getClient();
    const scope = $79m2C.getCurrentScope();
    if (!client || !$6emr7.hasSpansEnabled()) {
        const span2 = new $boFM9.SentryNonRecordingSpan({
            traceId: scope.getPropagationContext().traceId
        });
        $bkBh2.setCapturedScopesOnSpan(span2, scope, $79m2C.getIsolationScope());
        return span2;
    }
    const previousActiveSpan = $8jbnX.getActiveSpan();
    const span = $e4984677c41781bd$var$_startIdleSpan(startSpanOptions);
    span.end = new Proxy(span.end, {
        apply (target, thisArg, args) {
            if (beforeSpanEnd) beforeSpanEnd(span);
            if ($boFM9.spanIsNonRecordingSpan(thisArg)) return;
            const [definedEndTimestamp, ...rest] = args;
            const timestamp = definedEndTimestamp || $ihsl1.timestampInSeconds();
            const spanEndTimestamp = $8jbnX.spanTimeInputToSeconds(timestamp);
            const spans = $8jbnX.getSpanDescendants(span).filter((child)=>child !== span);
            const spanJson = $8jbnX.spanToJSON(span);
            if (!spans.length || !trimIdleSpanEndTimestamp) {
                onIdleSpanEnded(spanEndTimestamp);
                return Reflect.apply(target, thisArg, [
                    spanEndTimestamp,
                    ...rest
                ]);
            }
            const ignoreSpans = client.getOptions().ignoreSpans;
            const latestSpanEndTimestamp = spans?.reduce((acc, current)=>{
                const currentSpanJson = $8jbnX.spanToJSON(current);
                if (!currentSpanJson.timestamp) return acc;
                if (ignoreSpans && $cRlHT.shouldIgnoreSpan({
                    description: currentSpanJson.description,
                    op: currentSpanJson.op,
                    attributes: currentSpanJson.data
                }, ignoreSpans)) return acc;
                return acc ? Math.max(acc, currentSpanJson.timestamp) : currentSpanJson.timestamp;
            }, void 0);
            const spanStartTimestamp = spanJson.start_timestamp;
            const endTimestamp = Math.min(spanStartTimestamp ? spanStartTimestamp + finalTimeout / 1e3 : Infinity, Math.max(spanStartTimestamp || -Infinity, Math.min(spanEndTimestamp, latestSpanEndTimestamp || Infinity)));
            onIdleSpanEnded(endTimestamp);
            return Reflect.apply(target, thisArg, [
                endTimestamp,
                ...rest
            ]);
        }
    });
    function _cancelIdleTimeout() {
        if (_idleTimeoutID) {
            clearTimeout(_idleTimeoutID);
            _idleTimeoutID = void 0;
        }
    }
    function _restartIdleTimeout(endTimestamp) {
        _cancelIdleTimeout();
        _idleTimeoutID = setTimeout(()=>{
            if (!_finished && activities.size === 0 && _autoFinishAllowed) {
                _finishReason = $e4984677c41781bd$var$FINISH_REASON_IDLE_TIMEOUT;
                span.end(endTimestamp);
            }
        }, idleTimeout);
    }
    function _restartChildSpanTimeout(endTimestamp) {
        _idleTimeoutID = setTimeout(()=>{
            if (!_finished && _autoFinishAllowed) {
                _finishReason = $e4984677c41781bd$var$FINISH_REASON_HEARTBEAT_FAILED;
                span.end(endTimestamp);
            }
        }, childSpanTimeout);
    }
    function _pushActivity(spanId) {
        _cancelIdleTimeout();
        activities.set(spanId, true);
        const endTimestamp = $ihsl1.timestampInSeconds();
        _restartChildSpanTimeout(endTimestamp + childSpanTimeout / 1e3);
    }
    function _popActivity(spanId) {
        if (activities.has(spanId)) activities.delete(spanId);
        if (activities.size === 0) {
            const endTimestamp = $ihsl1.timestampInSeconds();
            _restartIdleTimeout(endTimestamp + idleTimeout / 1e3);
        }
    }
    function onIdleSpanEnded(endTimestamp) {
        _finished = true;
        activities.clear();
        _cleanupHooks.forEach((cleanup)=>cleanup());
        $f9GTk._setSpanForScope(scope, previousActiveSpan);
        const spanJSON = $8jbnX.spanToJSON(span);
        const { start_timestamp: startTimestamp } = spanJSON;
        if (!startTimestamp) return;
        const attributes = spanJSON.data;
        if (!attributes[$gTasE.SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON]) span.setAttribute($gTasE.SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON, _finishReason);
        const currentStatus = spanJSON.status;
        if (!currentStatus || currentStatus === "unknown") span.setStatus({
            code: $yI1C9.SPAN_STATUS_OK
        });
        $4gyod.debug.log(`[Tracing] Idle span "${spanJSON.op}" finished`);
        const childSpans = $8jbnX.getSpanDescendants(span).filter((child)=>child !== span);
        let discardedSpans = 0;
        childSpans.forEach((childSpan)=>{
            if (childSpan.isRecording()) {
                childSpan.setStatus({
                    code: $yI1C9.SPAN_STATUS_ERROR,
                    message: "cancelled"
                });
                childSpan.end(endTimestamp);
                $hiZR1.DEBUG_BUILD && $4gyod.debug.log("[Tracing] Cancelling span since span ended early", JSON.stringify(childSpan, void 0, 2));
            }
            const childSpanJSON = $8jbnX.spanToJSON(childSpan);
            const { timestamp: childEndTimestamp = 0, start_timestamp: childStartTimestamp = 0 } = childSpanJSON;
            const spanStartedBeforeIdleSpanEnd = childStartTimestamp <= endTimestamp;
            const timeoutWithMarginOfError = (finalTimeout + idleTimeout) / 1e3;
            const spanEndedBeforeFinalTimeout = childEndTimestamp - childStartTimestamp <= timeoutWithMarginOfError;
            if ($hiZR1.DEBUG_BUILD) {
                const stringifiedSpan = JSON.stringify(childSpan, void 0, 2);
                if (!spanStartedBeforeIdleSpanEnd) $4gyod.debug.log("[Tracing] Discarding span since it happened after idle span was finished", stringifiedSpan);
                else if (!spanEndedBeforeFinalTimeout) $4gyod.debug.log("[Tracing] Discarding span since it finished after idle span final timeout", stringifiedSpan);
            }
            if (!spanEndedBeforeFinalTimeout || !spanStartedBeforeIdleSpanEnd) {
                $8jbnX.removeChildSpanFromSpan(span, childSpan);
                discardedSpans++;
            }
        });
        if (discardedSpans > 0) span.setAttribute("sentry.idle_span_discarded_spans", discardedSpans);
    }
    _cleanupHooks.push(client.on("spanStart", (startedSpan)=>{
        if (_finished || startedSpan === span || !!$8jbnX.spanToJSON(startedSpan).timestamp || startedSpan instanceof $capUI.SentrySpan && startedSpan.isStandaloneSpan()) return;
        const allSpans = $8jbnX.getSpanDescendants(span);
        if (allSpans.includes(startedSpan)) _pushActivity(startedSpan.spanContext().spanId);
    }));
    _cleanupHooks.push(client.on("spanEnd", (endedSpan)=>{
        if (_finished) return;
        _popActivity(endedSpan.spanContext().spanId);
    }));
    _cleanupHooks.push(client.on("idleSpanEnableAutoFinish", (spanToAllowAutoFinish)=>{
        if (spanToAllowAutoFinish === span) {
            _autoFinishAllowed = true;
            _restartIdleTimeout();
            if (activities.size) _restartChildSpanTimeout();
        }
    }));
    if (!options.disableAutoFinish) _restartIdleTimeout();
    setTimeout(()=>{
        if (!_finished) {
            span.setStatus({
                code: $yI1C9.SPAN_STATUS_ERROR,
                message: "deadline_exceeded"
            });
            _finishReason = $e4984677c41781bd$var$FINISH_REASON_FINAL_TIMEOUT;
            span.end();
        }
    }, finalTimeout);
    return span;
}
function $e4984677c41781bd$var$_startIdleSpan(options) {
    const span = $kBDP8.startInactiveSpan(options);
    $f9GTk._setSpanForScope($79m2C.getCurrentScope(), span);
    $hiZR1.DEBUG_BUILD && $4gyod.debug.log("[Tracing] Started span is an idle span");
    return span;
}
module.exports.TRACING_DEFAULTS = $e4984677c41781bd$var$TRACING_DEFAULTS;
module.exports.startIdleSpan = $e4984677c41781bd$var$startIdleSpan;

});
parcelRegister("6emr7", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $79m2C = parcelRequire("79m2C");
function $4895744d17336b73$var$hasSpansEnabled(maybeOptions) {
    if (typeof __SENTRY_TRACING__ === "boolean" && !__SENTRY_TRACING__) return false;
    const options = maybeOptions || $79m2C.getClient()?.getOptions();
    return !!options && // Note: This check is `!= null`, meaning "nullish". `0` is not "nullish", `undefined` and `null` are. (This comment was brought to you by 15 minutes of questioning life)
    (options.tracesSampleRate != null || !!options.tracesSampler);
}
module.exports.hasSpansEnabled = $4895744d17336b73$var$hasSpansEnabled;

});

parcelRegister("cRlHT", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $hiZR1 = parcelRequire("hiZR1");

var $4gyod = parcelRequire("4gyod");

var $arYVC = parcelRequire("arYVC");
function $95cb45cc82b40b3d$var$logIgnoredSpan(droppedSpan) {
    $4gyod.debug.log(`Ignoring span ${droppedSpan.op} - ${droppedSpan.description} because it matches \`ignoreSpans\`.`);
}
function $95cb45cc82b40b3d$var$shouldIgnoreSpan(span, ignoreSpans) {
    if (!ignoreSpans?.length) return false;
    for (const pattern of ignoreSpans){
        if ($95cb45cc82b40b3d$var$isStringOrRegExp(pattern)) {
            if (span.description && $arYVC.isMatchingPattern(span.description, pattern)) {
                $hiZR1.DEBUG_BUILD && $95cb45cc82b40b3d$var$logIgnoredSpan(span);
                return true;
            }
            continue;
        }
        const hasAttributes = !!pattern.attributes && Object.keys(pattern.attributes).length > 0;
        if (!pattern.name && !pattern.op && !hasAttributes) continue;
        const nameMatches = pattern.name ? span.description && $arYVC.isMatchingPattern(span.description, pattern.name) : true;
        const opMatches = pattern.op ? span.op && $arYVC.isMatchingPattern(span.op, pattern.op) : true;
        const attrsMatch = pattern.attributes ? Object.entries(pattern.attributes).every(([key, valuePattern])=>$95cb45cc82b40b3d$var$_matchesAttributeValue(span.attributes?.[key], valuePattern)) : true;
        if (nameMatches && opMatches && attrsMatch) {
            $hiZR1.DEBUG_BUILD && $95cb45cc82b40b3d$var$logIgnoredSpan(span);
            return true;
        }
    }
    return false;
}
function $95cb45cc82b40b3d$var$_matchesAttributeValue(actual, pat) {
    if (typeof actual === "string" && (typeof pat === "string" || pat instanceof RegExp)) return $arYVC.isMatchingPattern(actual, pat);
    if (Array.isArray(actual) && Array.isArray(pat)) return actual.length === pat.length && actual.every((v, i)=>v === pat[i]);
    return actual === pat;
}
function $95cb45cc82b40b3d$var$reparentChildSpans(spans, dropSpan) {
    const droppedSpanParentId = dropSpan.parent_span_id;
    const droppedSpanId = dropSpan.span_id;
    if (!droppedSpanParentId) return;
    for (const span of spans)if (span.parent_span_id === droppedSpanId) span.parent_span_id = droppedSpanParentId;
}
function $95cb45cc82b40b3d$var$isStringOrRegExp(value) {
    return typeof value === "string" || value instanceof RegExp;
}
module.exports.reparentChildSpans = $95cb45cc82b40b3d$var$reparentChildSpans;
module.exports.shouldIgnoreSpan = $95cb45cc82b40b3d$var$shouldIgnoreSpan;

});

parcelRegister("boFM9", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $7OVjx = parcelRequire("7OVjx");

var $bLH3w = parcelRequire("bLH3w");

var $8jbnX = parcelRequire("8jbnX");
const $84c2575de3db7eed$var$NON_RECORDING_SPAN_FIELD = /* @__PURE__ */ Symbol.for("sentry.nonRecordingSpan");
class $84c2575de3db7eed$var$SentryNonRecordingSpan {
    constructor(spanContext = {}){
        this._traceId = spanContext.traceId || $bLH3w.generateTraceId();
        this._spanId = spanContext.spanId || $bLH3w.generateSpanId();
        this.dropReason = spanContext.dropReason;
        $7OVjx.addNonEnumerableProperty(this, $84c2575de3db7eed$var$NON_RECORDING_SPAN_FIELD, true);
    }
    /** @inheritdoc */ spanContext() {
        return {
            spanId: this._spanId,
            traceId: this._traceId,
            traceFlags: $8jbnX.TRACE_FLAG_NONE
        };
    }
    /** @inheritdoc */ end(_timestamp) {}
    /** @inheritdoc */ setAttribute(_key, _value) {
        return this;
    }
    /** @inheritdoc */ setAttributes(_values) {
        return this;
    }
    /** @inheritdoc */ setStatus(_status) {
        return this;
    }
    /** @inheritdoc */ updateName(_name) {
        return this;
    }
    /** @inheritdoc */ isRecording() {
        return false;
    }
    /** @inheritdoc */ addEvent(_name, _attributesOrStartTime, _startTime) {
        return this;
    }
    /** @inheritDoc */ addLink(_link) {
        return this;
    }
    /** @inheritDoc */ addLinks(_links) {
        return this;
    }
    /**
   * This should generally not be used,
   * but we need it for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */ recordException(_exception, _time) {}
}
function $84c2575de3db7eed$var$spanIsNonRecordingSpan(span) {
    return !!span && span[$84c2575de3db7eed$var$NON_RECORDING_SPAN_FIELD] === true;
}
module.exports.SentryNonRecordingSpan = $84c2575de3db7eed$var$SentryNonRecordingSpan;
module.exports.spanIsNonRecordingSpan = $84c2575de3db7eed$var$spanIsNonRecordingSpan;

});

parcelRegister("capUI", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $79m2C = parcelRequire("79m2C");

var $hiZR1 = parcelRequire("hiZR1");

var $gjixg = parcelRequire("gjixg");

var $gTasE = parcelRequire("gTasE");

var $4gyod = parcelRequire("4gyod");

var $bLH3w = parcelRequire("bLH3w");

var $8jbnX = parcelRequire("8jbnX");

var $ihsl1 = parcelRequire("ihsl1");

var $f0qnC = parcelRequire("f0qnC");

var $hFfKc = parcelRequire("hFfKc");

var $iFH83 = parcelRequire("iFH83");

var $1Je3N = parcelRequire("1Je3N");

var $8ICT0 = parcelRequire("8ICT0");

var $bkBh2 = parcelRequire("bkBh2");
const $8dba8529b88ce9eb$var$MAX_SPAN_COUNT = 1e3;
class $8dba8529b88ce9eb$var$SentrySpan {
    /**
   * You should never call the constructor manually, always use `Sentry.startSpan()`
   * or other span methods.
   * @internal
   * @hideconstructor
   * @hidden
   */ constructor(spanContext = {}){
        this._traceId = spanContext.traceId || $bLH3w.generateTraceId();
        this._spanId = spanContext.spanId || $bLH3w.generateSpanId();
        this._startTime = spanContext.startTimestamp || $ihsl1.timestampInSeconds();
        this._links = spanContext.links;
        this._attributes = {};
        this.setAttributes({
            [$gTasE.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: "manual",
            [$gTasE.SEMANTIC_ATTRIBUTE_SENTRY_OP]: spanContext.op,
            ...spanContext.attributes
        });
        this._name = spanContext.name;
        if (spanContext.parentSpanId) this._parentSpanId = spanContext.parentSpanId;
        if ("sampled" in spanContext) this._sampled = spanContext.sampled;
        if (spanContext.endTimestamp) this._endTime = spanContext.endTimestamp;
        this._events = [];
        this._isStandaloneSpan = spanContext.isStandalone;
        if (this._endTime) this._onSpanEnded();
    }
    /** @inheritDoc */ addLink(link) {
        if (this._frozen) return this;
        if (this._links) this._links.push(link);
        else this._links = [
            link
        ];
        return this;
    }
    /** @inheritDoc */ addLinks(links) {
        if (this._frozen) return this;
        if (this._links) this._links.push(...links);
        else this._links = links;
        return this;
    }
    /**
   * This should generally not be used,
   * but it is needed for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */ recordException(_exception, _time) {}
    /** @inheritdoc */ spanContext() {
        const { _spanId: spanId, _traceId: traceId, _sampled: sampled } = this;
        return {
            spanId: spanId,
            traceId: traceId,
            traceFlags: sampled ? $8jbnX.TRACE_FLAG_SAMPLED : $8jbnX.TRACE_FLAG_NONE
        };
    }
    /** @inheritdoc */ setAttribute(key, value) {
        if (this._frozen) return this;
        if (value === void 0) delete this._attributes[key];
        else this._attributes[key] = value;
        if (key === $gTasE.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE && value !== void 0 && $bkBh2.spanShouldInferOtelSource(this)) $bkBh2.markSpanSourceAsExplicit(this);
        return this;
    }
    /** @inheritdoc */ setAttributes(attributes) {
        Object.keys(attributes).forEach((key)=>this.setAttribute(key, attributes[key]));
        return this;
    }
    /**
   * This should generally not be used,
   * but we need it for browser tracing where we want to adjust the start time afterwards.
   * USE THIS WITH CAUTION!
   *
   * @hidden
   * @internal
   */ updateStartTime(timeInput) {
        if (this._frozen) return;
        this._startTime = $8jbnX.spanTimeInputToSeconds(timeInput);
    }
    /**
   * @inheritDoc
   */ setStatus(value) {
        if (this._frozen) return this;
        this._status = value;
        return this;
    }
    /**
   * @inheritDoc
   */ updateName(name) {
        if (this._frozen) return this;
        this._name = name;
        if (!$bkBh2.spanShouldInferOtelSource(this)) this.setAttribute($gTasE.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE, "custom");
        return this;
    }
    /** @inheritdoc */ end(endTimestamp) {
        if (this._endTime) {
            this._frozen = $bkBh2.spanIsTracerProviderSpan(this);
            return;
        }
        this._endTime = $8jbnX.spanTimeInputToSeconds(endTimestamp);
        $hFfKc.logSpanEnd(this);
        this._onSpanEnded();
        this._frozen = $bkBh2.spanIsTracerProviderSpan(this);
    }
    /**
   * Get JSON representation of this span.
   *
   * @hidden
   * @internal This method is purely for internal purposes and should not be used outside
   * of SDK code. If you need to get a JSON representation of a span,
   * use `spanToJSON(span)` instead.
   */ getSpanJSON() {
        return {
            data: this._attributes,
            description: this._name,
            op: this._attributes[$gTasE.SEMANTIC_ATTRIBUTE_SENTRY_OP],
            parent_span_id: this._parentSpanId,
            span_id: this._spanId,
            start_timestamp: this._startTime,
            status: $8jbnX.getStatusMessage(this._status),
            timestamp: this._endTime,
            trace_id: this._traceId,
            origin: this._attributes[$gTasE.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN],
            profile_id: this._attributes[$gTasE.SEMANTIC_ATTRIBUTE_PROFILE_ID],
            exclusive_time: this._attributes[$gTasE.SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME],
            measurements: $iFH83.timedEventsToMeasurements(this._events),
            is_segment: this._isStandaloneSpan && $8jbnX.getRootSpan(this) === this || void 0,
            segment_id: this._isStandaloneSpan ? $8jbnX.getRootSpan(this).spanContext().spanId : void 0,
            links: $8jbnX.convertSpanLinksForEnvelope(this._links)
        };
    }
    /**
   * Get {@link StreamedSpanJSON} representation of this span.
   *
   * @hidden
   * @internal This method is purely for internal purposes and should not be used outside
   * of SDK code. If you need to get a JSON representation of a span,
   * use `spanToStreamedSpanJSON(span)` instead.
   */ getStreamedSpanJSON() {
        return {
            name: this._name ?? "",
            span_id: this._spanId,
            trace_id: this._traceId,
            parent_span_id: this._parentSpanId,
            start_timestamp: this._startTime,
            // just in case _endTime is not set, we use the start time (i.e. duration 0)
            end_timestamp: this._endTime ?? this._startTime,
            is_segment: this._isStandaloneSpan || this === $8jbnX.getRootSpan(this),
            status: $8jbnX.getSimpleStatus(this._status),
            attributes: $8jbnX.addStatusMessageAttribute(this._attributes, this._status),
            links: $8jbnX.getStreamedSpanLinks(this._links)
        };
    }
    /** @inheritdoc */ isRecording() {
        return !this._endTime && !!this._sampled;
    }
    /**
   * @inheritdoc
   */ addEvent(name, attributesOrStartTime, startTime) {
        if (this._frozen) return this;
        $hiZR1.DEBUG_BUILD && $4gyod.debug.log("[Tracing] Adding an event to span:", name);
        const time$1 = $8dba8529b88ce9eb$var$isSpanTimeInput(attributesOrStartTime) ? attributesOrStartTime : startTime || $ihsl1.timestampInSeconds();
        const attributes = $8dba8529b88ce9eb$var$isSpanTimeInput(attributesOrStartTime) ? {} : attributesOrStartTime || {};
        const event = {
            name: name,
            time: $8jbnX.spanTimeInputToSeconds(time$1),
            attributes: attributes
        };
        this._events.push(event);
        return this;
    }
    /**
   * This method should generally not be used,
   * but for now we need a way to publicly check if the `_isStandaloneSpan` flag is set.
   * USE THIS WITH CAUTION!
   * @internal
   * @hidden
   * @experimental
   */ isStandaloneSpan() {
        return !!this._isStandaloneSpan;
    }
    /** Emit `spanEnd` when the span is ended. */ _onSpanEnded() {
        const client = $79m2C.getClient();
        if (client) {
            client.emit("spanEnd", this);
            if (!this._isStandaloneSpan) client.emit("afterSpanEnd", this);
        }
        const rootSpan = $8jbnX.getRootSpan(this);
        const isSegmentSpan = this._isStandaloneSpan || this === rootSpan;
        if (this._isStandaloneSpan) {
            if (this._sampled) $8dba8529b88ce9eb$var$sendSpanEnvelope($gjixg.createSpanEnvelope([
                this
            ], client));
            else {
                $hiZR1.DEBUG_BUILD && $4gyod.debug.log("[Tracing] Discarding standalone span because its trace was not chosen to be sampled.");
                if (client) client.recordDroppedEvent("sample_rate", "span");
            }
            return;
        }
        if (!isSegmentSpan) {
            const strategy2 = $1Je3N.getSegmentSpanCaptureStrategy();
            if (strategy2) {
                const scope2 = $bkBh2.getCapturedScopesOnSpan(this).scope || $79m2C.getCurrentScope();
                strategy2.onChildSpanEnded(this, rootSpan, (options)=>this._convertSpanToTransaction(options), scope2);
            }
            return;
        }
        if (client && $8ICT0.hasSpanStreamingEnabled(client)) {
            client.emit("afterSegmentSpanEnd", this);
            return;
        }
        const scope = $bkBh2.getCapturedScopesOnSpan(this).scope || $79m2C.getCurrentScope();
        const strategy = $1Je3N.getSegmentSpanCaptureStrategy();
        if (strategy) strategy.onSegmentSpanEnded((options)=>this._convertSpanToTransaction(options), scope);
        else {
            const transactionEvent = this._convertSpanToTransaction();
            if (transactionEvent) scope.captureEvent(transactionEvent);
        }
    }
    /**
   * Finish the transaction & prepare the event to send to Sentry.
   */ _convertSpanToTransaction(options = {}) {
        if (!$8dba8529b88ce9eb$var$isFullFinishedSpan($8jbnX.spanToJSON(this))) return void 0;
        if (!this._name) {
            $hiZR1.DEBUG_BUILD && $4gyod.debug.warn("Transaction has no name, falling back to `<unlabeled transaction>`.");
            this._name = "<unlabeled transaction>";
        }
        const { scope: capturedSpanScope, isolationScope: capturedSpanIsolationScope } = $bkBh2.getCapturedScopesOnSpan(this);
        const normalizedRequest = capturedSpanScope?.getScopeData().sdkProcessingMetadata?.normalizedRequest;
        if (this._sampled !== true) return void 0;
        options.onSpanCaptured?.(this);
        const spans = [];
        for (const descendant of $8jbnX.getSpanDescendants(this)){
            if (descendant === this || $8dba8529b88ce9eb$var$isStandaloneSpan(descendant) || options.isSpanAlreadyCaptured?.(descendant)) continue;
            const spanJSON = $8jbnX.spanToJSON(descendant);
            if (!$8dba8529b88ce9eb$var$isFullFinishedSpan(spanJSON)) continue;
            options.onSpanCaptured?.(descendant);
            spans.push(spanJSON);
        }
        const source = this._attributes[$gTasE.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE];
        delete this._attributes[$gTasE.SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME];
        let hasGenAiSpans = false;
        spans.forEach((span)=>{
            delete span.data[$gTasE.SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME];
            if (span.op?.startsWith("gen_ai.")) hasGenAiSpans = true;
        });
        const transaction = {
            contexts: {
                trace: $8jbnX.spanToTransactionTraceContext(this)
            },
            spans: // spans.sort() mutates the array, but `spans` is already a copy so we can safely do this here
            // we do not use spans anymore after this point
            spans.length > $8dba8529b88ce9eb$var$MAX_SPAN_COUNT ? spans.sort((a, b)=>a.start_timestamp - b.start_timestamp).slice(0, $8dba8529b88ce9eb$var$MAX_SPAN_COUNT) : spans,
            start_timestamp: this._startTime,
            timestamp: this._endTime,
            transaction: this._name,
            type: "transaction",
            sdkProcessingMetadata: {
                capturedSpanScope: capturedSpanScope,
                capturedSpanIsolationScope: capturedSpanIsolationScope,
                dynamicSamplingContext: $f0qnC.getDynamicSamplingContextFromSpan(this),
                hasGenAiSpans: hasGenAiSpans
            },
            request: normalizedRequest,
            ...source && {
                transaction_info: {
                    source: source
                }
            }
        };
        const measurements = $iFH83.timedEventsToMeasurements(this._events);
        const hasMeasurements = measurements && Object.keys(measurements).length;
        if (hasMeasurements) {
            $hiZR1.DEBUG_BUILD && $4gyod.debug.log("[Measurements] Adding measurements to transaction event", JSON.stringify(measurements, void 0, 2));
            transaction.measurements = measurements;
        }
        return transaction;
    }
}
function $8dba8529b88ce9eb$var$isSpanTimeInput(value) {
    return value && typeof value === "number" || value instanceof Date || Array.isArray(value);
}
function $8dba8529b88ce9eb$var$isFullFinishedSpan(input) {
    return !!input.start_timestamp && !!input.timestamp && !!input.span_id && !!input.trace_id;
}
function $8dba8529b88ce9eb$var$isStandaloneSpan(span) {
    return span instanceof $8dba8529b88ce9eb$var$SentrySpan && span.isStandaloneSpan();
}
function $8dba8529b88ce9eb$var$sendSpanEnvelope(envelope) {
    const client = $79m2C.getClient();
    if (!client) return;
    const spanItems = envelope[1];
    if (!spanItems || spanItems.length === 0) {
        client.recordDroppedEvent("before_send", "span");
        return;
    }
    client.sendEnvelope(envelope);
}
module.exports.SentrySpan = $8dba8529b88ce9eb$var$SentrySpan;

});
parcelRegister("gjixg", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $f0qnC = parcelRequire("f0qnC");

var $hOwNc = parcelRequire("hOwNc");

var $7E8b3 = parcelRequire("7E8b3");

var $636GJ = parcelRequire("636GJ");

var $lLUp4 = parcelRequire("lLUp4");

var $cRlHT = parcelRequire("cRlHT");

var $8jbnX = parcelRequire("8jbnX");
function $bdfccc7647000be5$var$_enhanceEventWithSdkInfo(event, newSdkInfo) {
    if (!newSdkInfo) return event;
    const eventSdkInfo = event.sdk || {};
    event.sdk = {
        ...eventSdkInfo,
        name: eventSdkInfo.name || newSdkInfo.name,
        version: eventSdkInfo.version || newSdkInfo.version,
        integrations: [
            ...event.sdk?.integrations || [],
            ...newSdkInfo.integrations || []
        ],
        packages: [
            ...event.sdk?.packages || [],
            ...newSdkInfo.packages || []
        ],
        settings: event.sdk?.settings || newSdkInfo.settings ? {
            ...event.sdk?.settings,
            ...newSdkInfo.settings
        } : void 0
    };
    return event;
}
function $bdfccc7647000be5$var$createSessionEnvelope(session, dsn$1, metadata, tunnel) {
    const sdkInfo = $636GJ.getSdkMetadataForEnvelopeHeader(metadata);
    const envelopeHeaders = {
        sent_at: new Date($lLUp4.safeDateNow()).toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn$1 && {
            dsn: $7E8b3.dsnToString(dsn$1)
        }
    };
    const envelopeItem = "aggregates" in session ? [
        {
            type: "sessions"
        },
        session
    ] : [
        {
            type: "session"
        },
        session.toJSON()
    ];
    return $636GJ.createEnvelope(envelopeHeaders, [
        envelopeItem
    ]);
}
function $bdfccc7647000be5$var$createEventEnvelope(event, dsn, metadata, tunnel) {
    const sdkInfo = $636GJ.getSdkMetadataForEnvelopeHeader(metadata);
    const eventType = event.type && event.type !== "replay_event" ? event.type : "event";
    $bdfccc7647000be5$var$_enhanceEventWithSdkInfo(event, metadata?.sdk);
    const envelopeHeaders = $636GJ.createEventEnvelopeHeaders(event, sdkInfo, tunnel, dsn);
    delete event.sdkProcessingMetadata;
    const eventItem = [
        {
            type: eventType
        },
        event
    ];
    return $636GJ.createEnvelope(envelopeHeaders, [
        eventItem
    ]);
}
function $bdfccc7647000be5$var$createSpanEnvelope(spans, client) {
    function dscHasRequiredProps(dsc2) {
        return !!dsc2.trace_id && !!dsc2.public_key;
    }
    const dsc = $f0qnC.getDynamicSamplingContextFromSpan(spans[0]);
    const dsn$1 = client?.getDsn();
    const tunnel = client?.getOptions().tunnel;
    const headers = {
        sent_at: new Date($lLUp4.safeDateNow()).toISOString(),
        ...dscHasRequiredProps(dsc) && {
            trace: dsc
        },
        ...!!tunnel && dsn$1 && {
            dsn: $7E8b3.dsnToString(dsn$1)
        }
    };
    const { beforeSendSpan: beforeSendSpan$1, ignoreSpans: ignoreSpans } = client?.getOptions() || {};
    const filteredSpans = ignoreSpans?.length ? spans.filter((span)=>{
        const json = $8jbnX.spanToJSON(span);
        return !$cRlHT.shouldIgnoreSpan({
            description: json.description,
            op: json.op,
            attributes: json.data
        }, ignoreSpans);
    }) : spans;
    const droppedSpans = spans.length - filteredSpans.length;
    if (droppedSpans) client?.recordDroppedEvent("before_send", "span", droppedSpans);
    const convertToSpanJSON = beforeSendSpan$1 ? (span)=>{
        const spanJson = $8jbnX.spanToJSON(span);
        const processedSpan = !$hOwNc.isStreamedBeforeSendSpanCallback(beforeSendSpan$1) ? beforeSendSpan$1(spanJson) : spanJson;
        if (!processedSpan) {
            $8jbnX.showSpanDropWarning();
            return spanJson;
        }
        return processedSpan;
    } : $8jbnX.spanToJSON;
    const items = [];
    for (const span of filteredSpans){
        const spanJson = convertToSpanJSON(span);
        if (spanJson) items.push($636GJ.createSpanEnvelopeItem(spanJson));
    }
    return $636GJ.createEnvelope(headers, items);
}
module.exports._enhanceEventWithSdkInfo = $bdfccc7647000be5$var$_enhanceEventWithSdkInfo;
module.exports.createEventEnvelope = $bdfccc7647000be5$var$createEventEnvelope;
module.exports.createSessionEnvelope = $bdfccc7647000be5$var$createSessionEnvelope;
module.exports.createSpanEnvelope = $bdfccc7647000be5$var$createSpanEnvelope;

});
parcelRegister("f0qnC", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $8Bk70 = parcelRequire("8Bk70");

var $79m2C = parcelRequire("79m2C");

var $gTasE = parcelRequire("gTasE");

var $l5MWU = parcelRequire("l5MWU");

var $7E8b3 = parcelRequire("7E8b3");

var $6emr7 = parcelRequire("6emr7");

var $7OVjx = parcelRequire("7OVjx");

var $8jbnX = parcelRequire("8jbnX");

var $boFM9 = parcelRequire("boFM9");

var $bkBh2 = parcelRequire("bkBh2");
const $aecb51969c842b92$var$FROZEN_DSC_FIELD = "_frozenDsc";
function $aecb51969c842b92$var$freezeDscOnSpan(span, dsc) {
    const spanWithMaybeDsc = span;
    $7OVjx.addNonEnumerableProperty(spanWithMaybeDsc, $aecb51969c842b92$var$FROZEN_DSC_FIELD, dsc);
}
function $aecb51969c842b92$var$getDynamicSamplingContextFromClient(trace_id, client) {
    const options = client.getOptions();
    const { publicKey: public_key } = client.getDsn() || {};
    const dsc = {
        environment: options.environment || $8Bk70.DEFAULT_ENVIRONMENT,
        release: options.release,
        public_key: public_key,
        trace_id: trace_id,
        org_id: $7E8b3.extractOrgIdFromClient(client)
    };
    client.emit("createDsc", dsc);
    return dsc;
}
function $aecb51969c842b92$var$getDynamicSamplingContextFromScope(client, scope) {
    const propagationContext = scope.getPropagationContext();
    return propagationContext.dsc || $aecb51969c842b92$var$getDynamicSamplingContextFromClient(propagationContext.traceId, client);
}
function $aecb51969c842b92$var$getDynamicSamplingContextFromSpan(span) {
    const client = $79m2C.getClient();
    if (!client) return {};
    const rootSpan = $8jbnX.getRootSpan(span);
    const rootSpanJson = $8jbnX.spanToJSON(rootSpan);
    const rootSpanAttributes = rootSpanJson.data;
    const traceState = rootSpan.spanContext().traceState;
    const rootSpanSampleRate = traceState?.get("sentry.sample_rate") ?? rootSpanAttributes[$gTasE.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE] ?? rootSpanAttributes[$gTasE.SEMANTIC_ATTRIBUTE_SENTRY_PREVIOUS_TRACE_SAMPLE_RATE];
    function applyLocalSampleRateToDsc(dsc2) {
        if (typeof rootSpanSampleRate === "number" || typeof rootSpanSampleRate === "string") dsc2.sample_rate = `${rootSpanSampleRate}`;
        return dsc2;
    }
    const frozenDsc = rootSpan[$aecb51969c842b92$var$FROZEN_DSC_FIELD];
    if (frozenDsc) return applyLocalSampleRateToDsc(frozenDsc);
    const isNonRecordingRoot = $boFM9.spanIsNonRecordingSpan(rootSpan);
    const isIgnoredRoot = isNonRecordingRoot && rootSpan.dropReason === "ignored";
    if (isNonRecordingRoot && (!$6emr7.hasSpansEnabled(client.getOptions()) || isIgnoredRoot)) {
        const capturedScope = $bkBh2.getCapturedScopesOnSpan(rootSpan).scope;
        if (capturedScope) {
            const dsc2 = {
                ...$aecb51969c842b92$var$getDynamicSamplingContextFromScope(client, capturedScope)
            };
            if (isIgnoredRoot) dsc2.sampled = "false";
            return applyLocalSampleRateToDsc(dsc2);
        }
    }
    const traceStateDsc = traceState?.get("sentry.dsc");
    const dscOnTraceState = traceStateDsc && $l5MWU.baggageHeaderToDynamicSamplingContext(traceStateDsc);
    if (dscOnTraceState) return applyLocalSampleRateToDsc(dscOnTraceState);
    const dsc = $aecb51969c842b92$var$getDynamicSamplingContextFromClient(span.spanContext().traceId, client);
    const source = rootSpanAttributes[$gTasE.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE] ?? rootSpanAttributes["sentry.segment.name.source"];
    const name = rootSpanJson.description;
    if (source !== "url" && name) dsc.transaction = name;
    if ($6emr7.hasSpansEnabled()) {
        dsc.sampled = String($8jbnX.spanIsSampled(rootSpan));
        dsc.sample_rand = // The Sentry OTEL SpanSampler takes care of writing the sample rand on the root span
        traceState?.get("sentry.sample_rand") ?? // On all other platforms we can actually get the scopes from a root span (we use this as a fallback)
        $bkBh2.getCapturedScopesOnSpan(rootSpan).scope?.getPropagationContext().sampleRand.toString();
    }
    applyLocalSampleRateToDsc(dsc);
    client.emit("createDsc", dsc, rootSpan);
    return dsc;
}
function $aecb51969c842b92$var$spanToBaggageHeader(span) {
    const dsc = $aecb51969c842b92$var$getDynamicSamplingContextFromSpan(span);
    return $l5MWU.dynamicSamplingContextToSentryBaggageHeader(dsc);
}
module.exports.freezeDscOnSpan = $aecb51969c842b92$var$freezeDscOnSpan;
module.exports.getDynamicSamplingContextFromClient = $aecb51969c842b92$var$getDynamicSamplingContextFromClient;
module.exports.getDynamicSamplingContextFromScope = $aecb51969c842b92$var$getDynamicSamplingContextFromScope;
module.exports.getDynamicSamplingContextFromSpan = $aecb51969c842b92$var$getDynamicSamplingContextFromSpan;
module.exports.spanToBaggageHeader = $aecb51969c842b92$var$spanToBaggageHeader;

});
parcelRegister("8Bk70", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $64316140ce898362$var$DEFAULT_ENVIRONMENT = "production";
const $64316140ce898362$var$DEV_ENVIRONMENT = "development";
module.exports.DEFAULT_ENVIRONMENT = $64316140ce898362$var$DEFAULT_ENVIRONMENT;
module.exports.DEV_ENVIRONMENT = $64316140ce898362$var$DEV_ENVIRONMENT;

});


parcelRegister("hOwNc", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $7OVjx = parcelRequire("7OVjx");
function $cf808b19cd80ad7b$var$withStreamedSpan(callback) {
    $7OVjx.addNonEnumerableProperty(callback, "_streamed", true);
    return callback;
}
function $cf808b19cd80ad7b$var$isStreamedBeforeSendSpanCallback(callback) {
    return !!callback && typeof callback === "function" && "_streamed" in callback && !!callback._streamed;
}
module.exports.isStreamedBeforeSendSpanCallback = $cf808b19cd80ad7b$var$isStreamedBeforeSendSpanCallback;
module.exports.withStreamedSpan = $cf808b19cd80ad7b$var$withStreamedSpan;

});

parcelRegister("636GJ", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $4fnou = parcelRequire("4fnou");

var $7E8b3 = parcelRequire("7E8b3");

var $eD1cG = parcelRequire("eD1cG");

var $lLUp4 = parcelRequire("lLUp4");

var $eP8Ri = parcelRequire("eP8Ri");
function $467836031cc6ec64$var$createEnvelope(headers, items = []) {
    return [
        headers,
        items
    ];
}
function $467836031cc6ec64$var$addItemToEnvelope(envelope, newItem) {
    const [headers, items] = envelope;
    return [
        headers,
        [
            ...items,
            newItem
        ]
    ];
}
function $467836031cc6ec64$var$forEachEnvelopeItem(envelope, callback) {
    const envelopeItems = envelope[1];
    for (const envelopeItem of envelopeItems){
        const envelopeItemType = envelopeItem[0].type;
        const result = callback(envelopeItem, envelopeItemType);
        if (result) return true;
    }
    return false;
}
function $467836031cc6ec64$var$envelopeContainsItemType(envelope, types) {
    return $467836031cc6ec64$var$forEachEnvelopeItem(envelope, (_, type)=>types.includes(type));
}
function $467836031cc6ec64$var$encodeUTF8(input) {
    const carrier$1 = $4fnou.getSentryCarrier($eP8Ri.GLOBAL_OBJ);
    return carrier$1.encodePolyfill ? carrier$1.encodePolyfill(input) : new TextEncoder().encode(input);
}
function $467836031cc6ec64$var$decodeUTF8(input) {
    const carrier$1 = $4fnou.getSentryCarrier($eP8Ri.GLOBAL_OBJ);
    return carrier$1.decodePolyfill ? carrier$1.decodePolyfill(input) : new TextDecoder().decode(input);
}
function $467836031cc6ec64$var$serializeEnvelope(envelope) {
    const [envHeaders, items] = envelope;
    let parts = JSON.stringify(envHeaders);
    function append(next) {
        if (typeof parts === "string") parts = typeof next === "string" ? parts + next : [
            $467836031cc6ec64$var$encodeUTF8(parts),
            next
        ];
        else parts.push(typeof next === "string" ? $467836031cc6ec64$var$encodeUTF8(next) : next);
    }
    for (const item of items){
        const [itemHeaders, payload] = item;
        append(`
${JSON.stringify(itemHeaders)}
`);
        if (typeof payload === "string" || payload instanceof Uint8Array) append(payload);
        else {
            let stringifiedPayload;
            try {
                stringifiedPayload = JSON.stringify(payload);
            } catch  {
                stringifiedPayload = JSON.stringify($eD1cG.normalize(payload));
            }
            append(stringifiedPayload);
        }
    }
    return typeof parts === "string" ? parts : $467836031cc6ec64$var$concatBuffers(parts);
}
function $467836031cc6ec64$var$concatBuffers(buffers) {
    const totalLength = buffers.reduce((acc, buf)=>acc + buf.length, 0);
    const merged = new Uint8Array(totalLength);
    let offset = 0;
    for (const buffer of buffers){
        merged.set(buffer, offset);
        offset += buffer.length;
    }
    return merged;
}
function $467836031cc6ec64$var$parseEnvelope(env) {
    let buffer = typeof env === "string" ? $467836031cc6ec64$var$encodeUTF8(env) : env;
    function readBinary(length) {
        const bin = buffer.subarray(0, length);
        buffer = buffer.subarray(length + 1);
        return bin;
    }
    function readJson() {
        let i = buffer.indexOf(10);
        if (i < 0) i = buffer.length;
        return JSON.parse($467836031cc6ec64$var$decodeUTF8(readBinary(i)));
    }
    const envelopeHeader = readJson();
    const items = [];
    while(buffer.length){
        const itemHeader = readJson();
        const binaryLength = typeof itemHeader.length === "number" ? itemHeader.length : void 0;
        items.push([
            itemHeader,
            binaryLength ? readBinary(binaryLength) : readJson()
        ]);
    }
    return [
        envelopeHeader,
        items
    ];
}
function $467836031cc6ec64$var$createSpanEnvelopeItem(spanJson) {
    const spanHeaders = {
        type: "span"
    };
    return [
        spanHeaders,
        spanJson
    ];
}
function $467836031cc6ec64$var$createAttachmentEnvelopeItem(attachment) {
    const buffer = typeof attachment.data === "string" ? $467836031cc6ec64$var$encodeUTF8(attachment.data) : attachment.data;
    return [
        {
            type: "attachment",
            length: buffer.length,
            filename: attachment.filename,
            content_type: attachment.contentType,
            attachment_type: attachment.attachmentType
        },
        buffer
    ];
}
const $467836031cc6ec64$var$DATA_CATEGORY_OVERRIDES = {
    sessions: "session",
    event: "error",
    client_report: "internal",
    user_report: "default",
    profile_chunk: "profile",
    replay_event: "replay",
    replay_recording: "replay",
    check_in: "monitor",
    raw_security: "security",
    log: "log_item",
    trace_metric: "metric"
};
function $467836031cc6ec64$var$_isOverriddenType(type) {
    return type in $467836031cc6ec64$var$DATA_CATEGORY_OVERRIDES;
}
function $467836031cc6ec64$var$envelopeItemTypeToDataCategory(type) {
    return $467836031cc6ec64$var$_isOverriddenType(type) ? $467836031cc6ec64$var$DATA_CATEGORY_OVERRIDES[type] : type;
}
function $467836031cc6ec64$var$getSdkMetadataForEnvelopeHeader(metadataOrEvent) {
    if (!metadataOrEvent?.sdk) return;
    const { name: name, version: version } = metadataOrEvent.sdk;
    return {
        name: name,
        version: version
    };
}
function $467836031cc6ec64$var$createEventEnvelopeHeaders(event, sdkInfo, tunnel, dsn$1) {
    const dynamicSamplingContext = event.sdkProcessingMetadata?.dynamicSamplingContext;
    return {
        event_id: event.event_id,
        sent_at: new Date($lLUp4.safeDateNow()).toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn$1 && {
            dsn: $7E8b3.dsnToString(dsn$1)
        },
        ...dynamicSamplingContext && {
            trace: dynamicSamplingContext
        }
    };
}
module.exports.addItemToEnvelope = $467836031cc6ec64$var$addItemToEnvelope;
module.exports.createAttachmentEnvelopeItem = $467836031cc6ec64$var$createAttachmentEnvelopeItem;
module.exports.createEnvelope = $467836031cc6ec64$var$createEnvelope;
module.exports.createEventEnvelopeHeaders = $467836031cc6ec64$var$createEventEnvelopeHeaders;
module.exports.createSpanEnvelopeItem = $467836031cc6ec64$var$createSpanEnvelopeItem;
module.exports.envelopeContainsItemType = $467836031cc6ec64$var$envelopeContainsItemType;
module.exports.envelopeItemTypeToDataCategory = $467836031cc6ec64$var$envelopeItemTypeToDataCategory;
module.exports.forEachEnvelopeItem = $467836031cc6ec64$var$forEachEnvelopeItem;
module.exports.getSdkMetadataForEnvelopeHeader = $467836031cc6ec64$var$getSdkMetadataForEnvelopeHeader;
module.exports.parseEnvelope = $467836031cc6ec64$var$parseEnvelope;
module.exports.serializeEnvelope = $467836031cc6ec64$var$serializeEnvelope;

});


parcelRegister("hFfKc", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $hiZR1 = parcelRequire("hiZR1");

var $4gyod = parcelRequire("4gyod");

var $8jbnX = parcelRequire("8jbnX");
function $cdc27a7280646417$var$logSpanStart(span) {
    if (!$hiZR1.DEBUG_BUILD) return;
    const { description: description = "< unknown name >", op: op = "< unknown op >", parent_span_id: parentSpanId } = $8jbnX.spanToJSON(span);
    const { spanId: spanId } = span.spanContext();
    const sampled = $8jbnX.spanIsSampled(span);
    const rootSpan = $8jbnX.getRootSpan(span);
    const isRootSpan = rootSpan === span;
    const header = `[Tracing] Starting ${sampled ? "sampled" : "unsampled"} ${isRootSpan ? "root " : ""}span`;
    const infoParts = [
        `op: ${op}`,
        `name: ${description}`,
        `ID: ${spanId}`
    ];
    if (parentSpanId) infoParts.push(`parent ID: ${parentSpanId}`);
    if (!isRootSpan) {
        const { op: op2, description: description2 } = $8jbnX.spanToJSON(rootSpan);
        infoParts.push(`root ID: ${rootSpan.spanContext().spanId}`);
        if (op2) infoParts.push(`root op: ${op2}`);
        if (description2) infoParts.push(`root description: ${description2}`);
    }
    $4gyod.debug.log(`${header}
  ${infoParts.join("\n  ")}`);
}
function $cdc27a7280646417$var$logSpanEnd(span) {
    if (!$hiZR1.DEBUG_BUILD) return;
    const { description: description = "< unknown name >", op: op = "< unknown op >" } = $8jbnX.spanToJSON(span);
    const { spanId: spanId } = span.spanContext();
    const rootSpan = $8jbnX.getRootSpan(span);
    const isRootSpan = rootSpan === span;
    const msg = `[Tracing] Finishing "${op}" ${isRootSpan ? "root " : ""}span "${description}" with ID ${spanId}`;
    $4gyod.debug.log(msg);
}
module.exports.logSpanEnd = $cdc27a7280646417$var$logSpanEnd;
module.exports.logSpanStart = $cdc27a7280646417$var$logSpanStart;

});

parcelRegister("iFH83", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $hiZR1 = parcelRequire("hiZR1");

var $gTasE = parcelRequire("gTasE");

var $4gyod = parcelRequire("4gyod");

var $8jbnX = parcelRequire("8jbnX");
function $d97d82d3a916b040$var$setMeasurement(name, value, unit, activeSpan = $8jbnX.getActiveSpan()) {
    const rootSpan = activeSpan && $8jbnX.getRootSpan(activeSpan);
    if (rootSpan) {
        $hiZR1.DEBUG_BUILD && $4gyod.debug.log(`[Measurement] Setting measurement on root span: ${name} = ${value} ${unit}`);
        rootSpan.addEvent(name, {
            [$gTasE.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE]: value,
            [$gTasE.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT]: unit
        });
    }
}
function $d97d82d3a916b040$var$timedEventsToMeasurements(events) {
    if (!events || events.length === 0) return void 0;
    const measurements = {};
    events.forEach((event)=>{
        const attributes = event.attributes || {};
        const unit = attributes[$gTasE.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT];
        const value = attributes[$gTasE.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE];
        if (typeof unit === "string" && typeof value === "number") measurements[event.name] = {
            value: value,
            unit: unit
        };
    });
    return measurements;
}
module.exports.setMeasurement = $d97d82d3a916b040$var$setMeasurement;
module.exports.timedEventsToMeasurements = $d97d82d3a916b040$var$timedEventsToMeasurements;

});

parcelRegister("1Je3N", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $4fnou = parcelRequire("4fnou");
function $1424e67b35a1a5b0$var$setSegmentSpanCaptureStrategy(strategy) {
    $4fnou.getSentryCarrier($4fnou.getMainCarrier()).segmentSpanCaptureStrategy = strategy;
}
function $1424e67b35a1a5b0$var$getSegmentSpanCaptureStrategy() {
    return $4fnou.getSentryCarrier($4fnou.getMainCarrier()).segmentSpanCaptureStrategy;
}
module.exports.getSegmentSpanCaptureStrategy = $1424e67b35a1a5b0$var$getSegmentSpanCaptureStrategy;
module.exports.setSegmentSpanCaptureStrategy = $1424e67b35a1a5b0$var$setSegmentSpanCaptureStrategy;

});

parcelRegister("8ICT0", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $659098cdd85f0f75$var$hasSpanStreamingEnabled(client) {
    return client.getOptions().traceLifecycle === "stream";
}
module.exports.hasSpanStreamingEnabled = $659098cdd85f0f75$var$hasSpanStreamingEnabled;

});


parcelRegister("kBDP8", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $diBhM = parcelRequire("diBhM");

var $4fnou = parcelRequire("4fnou");

var $79m2C = parcelRequire("79m2C");

var $hiZR1 = parcelRequire("hiZR1");

var $gTasE = parcelRequire("gTasE");

var $l5MWU = parcelRequire("l5MWU");

var $4gyod = parcelRequire("4gyod");

var $7vFKP = parcelRequire("7vFKP");

var $6emr7 = parcelRequire("6emr7");

var $cRlHT = parcelRequire("cRlHT");

var $8ICT0 = parcelRequire("8ICT0");

var $dkhYR = parcelRequire("dkhYR");

var $bLH3w = parcelRequire("bLH3w");

var $lLUp4 = parcelRequire("lLUp4");

var $f9GTk = parcelRequire("f9GTk");

var $8jbnX = parcelRequire("8jbnX");

var $3ZCGz = parcelRequire("3ZCGz");

var $f0qnC = parcelRequire("f0qnC");

var $hFfKc = parcelRequire("hFfKc");

var $6Hymv = parcelRequire("6Hymv");

var $boFM9 = parcelRequire("boFM9");

var $capUI = parcelRequire("capUI");

var $yI1C9 = parcelRequire("yI1C9");

var $bkBh2 = parcelRequire("bkBh2");
const $f0062784a164c0d3$var$SUPPRESS_TRACING_KEY = "__SENTRY_SUPPRESS_TRACING__";
function $f0062784a164c0d3$var$startSpan(options, callback) {
    const acs = $f0062784a164c0d3$var$getAcs();
    if (acs.startSpan) return acs.startSpan(options, callback);
    const spanArguments = $f0062784a164c0d3$var$parseSentrySpanArguments(options);
    const { forceTransaction: forceTransaction, parentSpan: customParentSpan, scope: customScope } = options;
    const customForkedScope = customScope?.clone();
    return $79m2C.withScope(customForkedScope, ()=>{
        const wrapper = $f0062784a164c0d3$var$getActiveSpanWrapper(customParentSpan);
        return wrapper(()=>{
            const scope = $79m2C.getCurrentScope();
            const parentSpan = $f0062784a164c0d3$var$getParentSpan(scope, customParentSpan);
            const client = $79m2C.getClient();
            const missingRequiredParent = options.onlyIfParent && !parentSpan;
            const activeSpan = missingRequiredParent ? $f0062784a164c0d3$var$startMissingRequiredParentSpan(scope, client) : $f0062784a164c0d3$var$createChildOrRootSpan({
                parentSpan: parentSpan,
                spanArguments: spanArguments,
                forceTransaction: forceTransaction,
                scope: scope
            });
            if (!$f0062784a164c0d3$var$spanIsIgnored(activeSpan) || !parentSpan) $f9GTk._setSpanForScope(scope, activeSpan);
            return $7vFKP.handleCallbackErrors(()=>callback(activeSpan), ()=>{
                const { status: status } = $8jbnX.spanToJSON(activeSpan);
                if (activeSpan.isRecording() && (!status || status === "ok")) activeSpan.setStatus({
                    code: $yI1C9.SPAN_STATUS_ERROR,
                    message: "internal_error"
                });
            }, ()=>{
                activeSpan.end();
            });
        });
    });
}
function $f0062784a164c0d3$var$startSpanManual(options, callback) {
    const acs = $f0062784a164c0d3$var$getAcs();
    if (acs.startSpanManual) return acs.startSpanManual(options, callback);
    const spanArguments = $f0062784a164c0d3$var$parseSentrySpanArguments(options);
    const { forceTransaction: forceTransaction, parentSpan: customParentSpan, scope: customScope } = options;
    const customForkedScope = customScope?.clone();
    return $79m2C.withScope(customForkedScope, ()=>{
        const wrapper = $f0062784a164c0d3$var$getActiveSpanWrapper(customParentSpan);
        return wrapper(()=>{
            const scope = $79m2C.getCurrentScope();
            const parentSpan = $f0062784a164c0d3$var$getParentSpan(scope, customParentSpan);
            const missingRequiredParent = options.onlyIfParent && !parentSpan;
            const activeSpan = missingRequiredParent ? $f0062784a164c0d3$var$startMissingRequiredParentSpan(scope, $79m2C.getClient()) : $f0062784a164c0d3$var$createChildOrRootSpan({
                parentSpan: parentSpan,
                spanArguments: spanArguments,
                forceTransaction: forceTransaction,
                scope: scope
            });
            if (!$f0062784a164c0d3$var$spanIsIgnored(activeSpan) || !parentSpan) $f9GTk._setSpanForScope(scope, activeSpan);
            return $7vFKP.handleCallbackErrors(// We pass the `finish` function to the callback, so the user can finish the span manually
            // this is mainly here for historic purposes because previously, we instructed users to call
            // `finish` instead of `span.end()` to also clean up the scope. Nowadays, calling `span.end()`
            // or `finish` has the same effect and we simply leave it here to avoid breaking user code.
            ()=>callback(activeSpan, ()=>activeSpan.end()), ()=>{
                const { status: status } = $8jbnX.spanToJSON(activeSpan);
                if (activeSpan.isRecording() && (!status || status === "ok")) activeSpan.setStatus({
                    code: $yI1C9.SPAN_STATUS_ERROR,
                    message: "internal_error"
                });
            });
        });
    });
}
function $f0062784a164c0d3$var$startInactiveSpan(options) {
    const acs = $f0062784a164c0d3$var$getAcs();
    if (acs.startInactiveSpan) return acs.startInactiveSpan(options);
    return $f0062784a164c0d3$var$_startInactiveSpanImpl(options);
}
function $f0062784a164c0d3$var$_INTERNAL_startInactiveSpan(options) {
    return $f0062784a164c0d3$var$_startInactiveSpanImpl(options);
}
function $f0062784a164c0d3$var$_startInactiveSpanImpl(options) {
    const spanArguments = $f0062784a164c0d3$var$parseSentrySpanArguments(options);
    const { forceTransaction: forceTransaction, parentSpan: customParentSpan } = options;
    const wrapper = options.scope ? (callback)=>$79m2C.withScope(options.scope, callback) : customParentSpan !== void 0 ? (callback)=>$f0062784a164c0d3$var$withActiveSpan(customParentSpan, callback) : (callback)=>callback();
    return wrapper(()=>{
        const scope = $79m2C.getCurrentScope();
        const parentSpan = $f0062784a164c0d3$var$getParentSpan(scope, customParentSpan);
        const client = $79m2C.getClient();
        const missingRequiredParent = options.onlyIfParent && !parentSpan;
        if (missingRequiredParent) return $f0062784a164c0d3$var$startMissingRequiredParentSpan(scope, client);
        return $f0062784a164c0d3$var$createChildOrRootSpan({
            parentSpan: parentSpan,
            spanArguments: spanArguments,
            forceTransaction: forceTransaction,
            scope: scope
        });
    });
}
const $f0062784a164c0d3$var$continueTrace = (options, callback)=>{
    const carrier$1 = $4fnou.getMainCarrier();
    const acs = $diBhM.getAsyncContextStrategy(carrier$1);
    if (acs.continueTrace) return acs.continueTrace(options, callback);
    const { sentryTrace: sentryTrace, baggage: baggage$1 } = options;
    const client = $79m2C.getClient();
    const incomingDsc = $l5MWU.baggageHeaderToDynamicSamplingContext(baggage$1);
    if (client && !$3ZCGz.shouldContinueTrace(client, incomingDsc?.org_id)) return $f0062784a164c0d3$var$startNewTrace(callback);
    return $79m2C.withScope((scope)=>{
        const propagationContext = $3ZCGz.propagationContextFromHeaders(sentryTrace, baggage$1);
        scope.setPropagationContext(propagationContext);
        $f9GTk._setSpanForScope(scope, void 0);
        return callback();
    });
};
function $f0062784a164c0d3$var$withActiveSpan(span, callback) {
    const acs = $f0062784a164c0d3$var$getAcs();
    if (acs.withActiveSpan) return acs.withActiveSpan(span, callback);
    return $79m2C.withScope((scope)=>{
        $f9GTk._setSpanForScope(scope, span || void 0);
        return callback(scope);
    });
}
function $f0062784a164c0d3$var$suppressTracing(callback) {
    const acs = $f0062784a164c0d3$var$getAcs();
    if (acs.suppressTracing) return acs.suppressTracing(callback);
    return $79m2C.withScope((scope)=>{
        scope.setSDKProcessingMetadata({
            [$f0062784a164c0d3$var$SUPPRESS_TRACING_KEY]: true
        });
        const res = callback();
        scope.setSDKProcessingMetadata({
            [$f0062784a164c0d3$var$SUPPRESS_TRACING_KEY]: void 0
        });
        return res;
    });
}
function $f0062784a164c0d3$var$isTracingSuppressed(scope = $79m2C.getCurrentScope()) {
    const acs = $f0062784a164c0d3$var$getAcs();
    if (acs.isTracingSuppressed) return acs.isTracingSuppressed(scope);
    return scope.getScopeData().sdkProcessingMetadata[$f0062784a164c0d3$var$SUPPRESS_TRACING_KEY] === true;
}
function $f0062784a164c0d3$var$startNewTrace(callback) {
    const acs = $f0062784a164c0d3$var$getAcs();
    if (acs.startNewTrace) return acs.startNewTrace(callback);
    return $79m2C.withScope((scope)=>{
        scope.setPropagationContext({
            traceId: $bLH3w.generateTraceId(),
            sampleRand: $lLUp4.safeMathRandom()
        });
        $hiZR1.DEBUG_BUILD && $4gyod.debug.log(`Starting a new trace with id ${scope.getPropagationContext().traceId}`);
        return $f0062784a164c0d3$var$withActiveSpan(null, callback);
    });
}
function $f0062784a164c0d3$var$startMissingRequiredParentSpan(scope, client) {
    client?.recordDroppedEvent("no_parent_span", "span");
    const span = new $boFM9.SentryNonRecordingSpan({
        traceId: scope.getPropagationContext().traceId
    });
    $bkBh2.setCapturedScopesOnSpan(span, scope, $79m2C.getIsolationScope());
    return span;
}
function $f0062784a164c0d3$var$createChildOrRootSpan({ parentSpan: parentSpan, spanArguments: spanArguments, forceTransaction: forceTransaction, scope: scope }) {
    const isolationScope = $79m2C.getIsolationScope();
    if (!$6emr7.hasSpansEnabled()) {
        const scopePropagationContext = {
            ...isolationScope.getPropagationContext(),
            ...scope.getPropagationContext()
        };
        const traceId = parentSpan ? parentSpan.spanContext().traceId : scopePropagationContext.traceId;
        const span2 = new $boFM9.SentryNonRecordingSpan({
            traceId: traceId
        });
        if (parentSpan && !forceTransaction) $8jbnX.addChildSpanToSpan(parentSpan, span2);
        $bkBh2.setCapturedScopesOnSpan(span2, scope, isolationScope);
        return span2;
    }
    const client = $79m2C.getClient();
    if ($f0062784a164c0d3$var$_shouldIgnoreStreamedSpan(client, spanArguments)) {
        if (!$f0062784a164c0d3$var$isTracingSuppressed(scope)) client?.recordDroppedEvent("ignored", "span");
        const ignoredSpan = new $boFM9.SentryNonRecordingSpan({
            dropReason: "ignored",
            traceId: parentSpan?.spanContext().traceId ?? scope.getPropagationContext().traceId
        });
        if (parentSpan && !forceTransaction) $8jbnX.addChildSpanToSpan(parentSpan, ignoredSpan);
        $bkBh2.setCapturedScopesOnSpan(ignoredSpan, scope, isolationScope);
        return ignoredSpan;
    }
    let span;
    if (parentSpan && !forceTransaction) {
        span = $f0062784a164c0d3$var$_startChildSpan(parentSpan, scope, spanArguments, isolationScope);
        $8jbnX.addChildSpanToSpan(parentSpan, span);
    } else if (parentSpan) {
        const dsc = $f0qnC.getDynamicSamplingContextFromSpan(parentSpan);
        const { traceId: traceId, spanId: parentSpanId } = parentSpan.spanContext();
        const parentSampled = $8jbnX.spanIsSampled(parentSpan);
        span = $f0062784a164c0d3$var$_startRootSpan({
            traceId: traceId,
            parentSpanId: parentSpanId,
            ...spanArguments
        }, scope, isolationScope, parentSampled);
        $f0qnC.freezeDscOnSpan(span, dsc);
    } else {
        const { traceId: traceId, dsc: dsc, parentSpanId: parentSpanId, sampled: parentSampled } = {
            ...isolationScope.getPropagationContext(),
            ...scope.getPropagationContext()
        };
        span = $f0062784a164c0d3$var$_startRootSpan({
            traceId: traceId,
            parentSpanId: parentSpanId,
            ...spanArguments
        }, scope, isolationScope, parentSampled);
        if (dsc) $f0qnC.freezeDscOnSpan(span, dsc);
    }
    $hFfKc.logSpanStart(span);
    return span;
}
function $f0062784a164c0d3$var$parseSentrySpanArguments(options) {
    const exp = options.experimental || {};
    const initialCtx = {
        isStandalone: exp.standalone,
        ...options
    };
    if (options.startTime) {
        const ctx = {
            ...initialCtx
        };
        ctx.startTimestamp = $8jbnX.spanTimeInputToSeconds(options.startTime);
        delete ctx.startTime;
        return ctx;
    }
    return initialCtx;
}
function $f0062784a164c0d3$var$getAcs() {
    const carrier$1 = $4fnou.getMainCarrier();
    return $diBhM.getAsyncContextStrategy(carrier$1);
}
function $f0062784a164c0d3$var$_startRootSpan(spanArguments, scope, isolationScope, parentSampled) {
    const client = $79m2C.getClient();
    const options = client?.getOptions() || {};
    const { name: name = "" } = spanArguments;
    const mutableSpanSamplingData = {
        spanAttributes: {
            ...spanArguments.attributes
        },
        spanName: name,
        parentSampled: parentSampled
    };
    client?.emit("beforeSampling", mutableSpanSamplingData, {
        decision: false
    });
    const finalParentSampled = mutableSpanSamplingData.parentSampled ?? parentSampled;
    const finalAttributes = mutableSpanSamplingData.spanAttributes;
    const currentPropagationContext = scope.getPropagationContext();
    const _isTracingSuppressed = $f0062784a164c0d3$var$isTracingSuppressed(scope);
    const [sampled, sampleRate, localSampleRateWasApplied] = _isTracingSuppressed ? [
        false
    ] : $6Hymv.sampleSpan(options, {
        name: name,
        parentSampled: finalParentSampled,
        attributes: finalAttributes,
        normalizedRequest: isolationScope.getScopeData().sdkProcessingMetadata.normalizedRequest,
        parentSampleRate: $dkhYR.parseSampleRate(currentPropagationContext.dsc?.sample_rate)
    }, currentPropagationContext.sampleRand);
    const rootSpan = new $capUI.SentrySpan({
        ...spanArguments,
        attributes: {
            [$gTasE.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE]: "custom",
            [$gTasE.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE]: sampleRate !== void 0 && localSampleRateWasApplied ? sampleRate : void 0,
            ...finalAttributes
        },
        sampled: sampled
    });
    if (!sampled && client && !_isTracingSuppressed) {
        $hiZR1.DEBUG_BUILD && $4gyod.debug.log("[Tracing] Discarding root span because its trace was not chosen to be sampled.");
        client.recordDroppedEvent("sample_rate", $8ICT0.hasSpanStreamingEnabled(client) ? "span" : "transaction");
    }
    $bkBh2.setCapturedScopesOnSpan(rootSpan, scope, isolationScope);
    if (client) client.emit("spanStart", rootSpan);
    return rootSpan;
}
function $f0062784a164c0d3$var$_startChildSpan(parentSpan, scope, spanArguments, isolationScope) {
    const { spanId: spanId, traceId: traceId } = parentSpan.spanContext();
    const _isTracingSuppressed = $f0062784a164c0d3$var$isTracingSuppressed(scope);
    const sampled = _isTracingSuppressed ? false : $8jbnX.spanIsSampled(parentSpan);
    const childSpan = sampled ? new $capUI.SentrySpan({
        ...spanArguments,
        parentSpanId: spanId,
        traceId: traceId,
        sampled: sampled
    }) : new $boFM9.SentryNonRecordingSpan({
        traceId: traceId
    });
    $8jbnX.addChildSpanToSpan(parentSpan, childSpan);
    $bkBh2.setCapturedScopesOnSpan(childSpan, scope, isolationScope);
    const client = $79m2C.getClient();
    if (!client) return childSpan;
    if ($8ICT0.hasSpanStreamingEnabled(client) && $boFM9.spanIsNonRecordingSpan(childSpan)) {
        if ($boFM9.spanIsNonRecordingSpan(parentSpan) && parentSpan.dropReason) {
            childSpan.dropReason = parentSpan.dropReason;
            client.recordDroppedEvent(parentSpan.dropReason, "span");
        } else if (!_isTracingSuppressed) {
            childSpan.dropReason = "sample_rate";
            client.recordDroppedEvent("sample_rate", "span");
        }
    }
    client.emit("spanStart", childSpan);
    if (spanArguments.endTimestamp) {
        client.emit("spanEnd", childSpan);
        client.emit("afterSpanEnd", childSpan);
    }
    return childSpan;
}
function $f0062784a164c0d3$var$getParentSpan(scope, customParentSpan) {
    if (customParentSpan) return customParentSpan;
    if (customParentSpan === null) return void 0;
    const span = $f9GTk._getSpanForScope(scope);
    if (!span) return void 0;
    const client = $79m2C.getClient();
    const options = client ? client.getOptions() : {};
    if (options.parentSpanIsAlwaysRootSpan) return $8jbnX.getRootSpan(span);
    return span;
}
function $f0062784a164c0d3$var$getActiveSpanWrapper(parentSpan) {
    return parentSpan !== void 0 ? (callback)=>{
        return $f0062784a164c0d3$var$withActiveSpan(parentSpan, callback);
    } : (callback)=>callback();
}
function $f0062784a164c0d3$var$_shouldIgnoreStreamedSpan(client, spanArguments) {
    const ignoreSpans = client?.getOptions().ignoreSpans;
    if (!client || !$8ICT0.hasSpanStreamingEnabled(client) || !ignoreSpans?.length) return false;
    return $cRlHT.shouldIgnoreSpan({
        description: spanArguments.name || "",
        op: spanArguments.attributes?.[$gTasE.SEMANTIC_ATTRIBUTE_SENTRY_OP] || spanArguments.op,
        attributes: spanArguments.attributes
    }, ignoreSpans);
}
function $f0062784a164c0d3$var$spanIsIgnored(span) {
    return $boFM9.spanIsNonRecordingSpan(span) && span.dropReason === "ignored";
}
module.exports.SUPPRESS_TRACING_KEY = $f0062784a164c0d3$var$SUPPRESS_TRACING_KEY;
module.exports._INTERNAL_startInactiveSpan = $f0062784a164c0d3$var$_INTERNAL_startInactiveSpan;
module.exports.continueTrace = $f0062784a164c0d3$var$continueTrace;
module.exports.isTracingSuppressed = $f0062784a164c0d3$var$isTracingSuppressed;
module.exports.spanIsIgnored = $f0062784a164c0d3$var$spanIsIgnored;
module.exports.startInactiveSpan = $f0062784a164c0d3$var$startInactiveSpan;
module.exports.startNewTrace = $f0062784a164c0d3$var$startNewTrace;
module.exports.startSpan = $f0062784a164c0d3$var$startSpan;
module.exports.startSpanManual = $f0062784a164c0d3$var$startSpanManual;
module.exports.suppressTracing = $f0062784a164c0d3$var$suppressTracing;
module.exports.withActiveSpan = $f0062784a164c0d3$var$withActiveSpan;

});
parcelRegister("7vFKP", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $lVeNe = parcelRequire("lVeNe");

var $dzfKZ = parcelRequire("dzfKZ");
function $577bd12d7a5db921$var$handleCallbackErrors(fn, onError, onFinally = ()=>{}, onSuccess = ()=>{}) {
    let maybePromiseResult;
    try {
        maybePromiseResult = fn();
    } catch (e) {
        onError(e);
        onFinally();
        throw e;
    }
    return $577bd12d7a5db921$var$maybeHandlePromiseRejection(maybePromiseResult, onError, onFinally, onSuccess);
}
function $577bd12d7a5db921$var$maybeHandlePromiseRejection(value, onError, onFinally, onSuccess) {
    if ($dzfKZ.isThenable(value)) return $lVeNe.chainAndCopyPromiseLike(value, (result)=>{
        onFinally();
        onSuccess(result);
    }, (err)=>{
        onError(err);
        onFinally();
    });
    onFinally();
    onSuccess(value);
    return value;
}
module.exports.handleCallbackErrors = $577bd12d7a5db921$var$handleCallbackErrors;

});

parcelRegister("6Hymv", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $hiZR1 = parcelRequire("hiZR1");

var $4gyod = parcelRequire("4gyod");

var $6emr7 = parcelRequire("6emr7");

var $dkhYR = parcelRequire("dkhYR");
function $4e1169d44d65f9f9$var$sampleSpan(options, samplingContext, sampleRand) {
    if (!$6emr7.hasSpansEnabled(options)) return [
        false
    ];
    let localSampleRateWasApplied = void 0;
    let sampleRate;
    if (typeof options.tracesSampler === "function") {
        sampleRate = options.tracesSampler({
            ...samplingContext,
            inheritOrSampleWith: (fallbackSampleRate)=>{
                if (typeof samplingContext.parentSampleRate === "number") return samplingContext.parentSampleRate;
                if (typeof samplingContext.parentSampled === "boolean") return Number(samplingContext.parentSampled);
                return fallbackSampleRate;
            }
        });
        localSampleRateWasApplied = true;
    } else if (samplingContext.parentSampled !== void 0) sampleRate = samplingContext.parentSampled;
    else if (typeof options.tracesSampleRate !== "undefined") {
        sampleRate = options.tracesSampleRate;
        localSampleRateWasApplied = true;
    }
    const parsedSampleRate = $dkhYR.parseSampleRate(sampleRate);
    if (parsedSampleRate === void 0) {
        $hiZR1.DEBUG_BUILD && $4gyod.debug.warn(`[Tracing] Discarding root span because of invalid sample rate. Sample rate must be a boolean or a number between 0 and 1. Got ${JSON.stringify(sampleRate)} of type ${JSON.stringify(typeof sampleRate)}.`);
        return [
            false
        ];
    }
    if (!parsedSampleRate) {
        $hiZR1.DEBUG_BUILD && $4gyod.debug.log(`[Tracing] Discarding transaction because ${typeof options.tracesSampler === "function" ? "tracesSampler returned 0 or false" : "a negative sampling decision was inherited or tracesSampleRate is set to 0"}`);
        return [
            false,
            parsedSampleRate,
            localSampleRateWasApplied
        ];
    }
    const shouldSample = sampleRand < parsedSampleRate;
    if (!shouldSample) $hiZR1.DEBUG_BUILD && $4gyod.debug.log(`[Tracing] Discarding transaction because it's not included in the random sample (sampling rate = ${Number(sampleRate)})`);
    return [
        shouldSample,
        parsedSampleRate,
        localSampleRateWasApplied
    ];
}
module.exports.sampleSpan = $4e1169d44d65f9f9$var$sampleSpan;

});



parcelRegister("g4dpo", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $5EABE = parcelRequire("5EABE");

var $1Je3N = parcelRequire("1Je3N");
const $bb276bb3cff6c547$var$CAPTURED_SPANS = /* @__PURE__ */ new WeakSet();
const $bb276bb3cff6c547$var$isSpanAlreadyCaptured = (span)=>$bb276bb3cff6c547$var$CAPTURED_SPANS.has(span);
const $bb276bb3cff6c547$var$markSpanCaptured = (span)=>{
    $bb276bb3cff6c547$var$CAPTURED_SPANS.add(span);
};
const $bb276bb3cff6c547$var$CLIENT_QUEUES = /* @__PURE__ */ new WeakMap();
function $bb276bb3cff6c547$var$_INTERNAL_setDeferSegmentSpanCapture(client) {
    if (!$1Je3N.getSegmentSpanCaptureStrategy()) $1Je3N.setSegmentSpanCaptureStrategy($bb276bb3cff6c547$var$deferredSegmentSpanCaptureStrategy);
    if ($bb276bb3cff6c547$var$CLIENT_QUEUES.has(client)) return;
    const pendingCaptures = /* @__PURE__ */ new Set();
    const debouncedDrain = $5EABE.debounce(()=>{
        const captures = [
            ...pendingCaptures
        ];
        pendingCaptures.clear();
        for (const capture of captures)capture();
    }, 1, {
        maxWait: 100
    });
    client.on("flush", ()=>{
        debouncedDrain.flush();
    });
    $bb276bb3cff6c547$var$CLIENT_QUEUES.set(client, (capture)=>{
        pendingCaptures.add(capture);
        debouncedDrain();
    });
}
const $bb276bb3cff6c547$var$deferredSegmentSpanCaptureStrategy = {
    onSegmentSpanEnded (convert, scope) {
        const client = scope.getClient();
        const enqueue = client && $bb276bb3cff6c547$var$CLIENT_QUEUES.get(client);
        if (!enqueue) {
            const transactionEvent = convert();
            if (transactionEvent) client?.captureEvent(transactionEvent);
            return;
        }
        enqueue(()=>{
            const transactionEvent = convert({
                isSpanAlreadyCaptured: $bb276bb3cff6c547$var$isSpanAlreadyCaptured,
                onSpanCaptured: $bb276bb3cff6c547$var$markSpanCaptured
            });
            if (transactionEvent) client.captureEvent(transactionEvent);
        });
    },
    onChildSpanEnded (span, rootSpan, convert, scope) {
        if ($bb276bb3cff6c547$var$CAPTURED_SPANS.has(span) || !$bb276bb3cff6c547$var$CAPTURED_SPANS.has(rootSpan)) return;
        const client = scope.getClient();
        const enqueue = client && $bb276bb3cff6c547$var$CLIENT_QUEUES.get(client);
        const captureOrphan = ()=>{
            const transactionEvent = convert({
                isSpanAlreadyCaptured: $bb276bb3cff6c547$var$isSpanAlreadyCaptured,
                onSpanCaptured: $bb276bb3cff6c547$var$markSpanCaptured
            });
            if (transactionEvent?.contexts?.trace?.data) transactionEvent.contexts.trace.data["sentry.parent_span_already_sent"] = true;
            if (transactionEvent) client?.captureEvent(transactionEvent);
        };
        if (enqueue) enqueue(captureOrphan);
        else captureOrphan();
    }
};
module.exports._INTERNAL_setDeferSegmentSpanCapture = $bb276bb3cff6c547$var$_INTERNAL_setDeferSegmentSpanCapture;

});
parcelRegister("5EABE", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $41dd15671c2d9bc9$var$debounce(func, wait, options) {
    let callbackReturnValue;
    let timerId;
    let maxTimerId;
    const maxWait = options?.maxWait ? Math.max(options.maxWait, wait) : 0;
    const setTimeoutImpl = options?.setTimeoutImpl || setTimeout;
    function invokeFunc() {
        cancelTimers();
        callbackReturnValue = func();
        return callbackReturnValue;
    }
    function cancelTimers() {
        timerId !== void 0 && clearTimeout(timerId);
        maxTimerId !== void 0 && clearTimeout(maxTimerId);
        timerId = maxTimerId = void 0;
    }
    function flush() {
        if (timerId !== void 0 || maxTimerId !== void 0) return invokeFunc();
        return callbackReturnValue;
    }
    function debounced() {
        if (timerId) clearTimeout(timerId);
        timerId = setTimeoutImpl(invokeFunc, wait);
        if (maxWait && maxTimerId === void 0) maxTimerId = setTimeoutImpl(invokeFunc, maxWait);
        return callbackReturnValue;
    }
    debounced.cancel = cancelTimers;
    debounced.flush = flush;
    return debounced;
}
module.exports.debounce = $41dd15671c2d9bc9$var$debounce;

});


parcelRegister("2IR8A", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $79m2C = parcelRequire("79m2C");
const $1fb8e8d338a2dd72$var$ADD_LISTENER_METHODS = [
    "addListener",
    "on",
    "once",
    "prependListener",
    "prependOnceListener",
    "addEventListener"
];
const $1fb8e8d338a2dd72$var$REMOVE_LISTENER_METHODS = [
    "removeListener",
    "off",
    "removeEventListener"
];
const $1fb8e8d338a2dd72$var$SCOPE_BOUND_LISTENERS = /* @__PURE__ */ Symbol("SentryScopeBoundListeners");
let $1fb8e8d338a2dd72$var$registeringWrapper;
function $1fb8e8d338a2dd72$var$isReentrantWrapperRegistration(listener) {
    return $1fb8e8d338a2dd72$var$registeringWrapper !== void 0 && (listener === $1fb8e8d338a2dd72$var$registeringWrapper || listener.listener === $1fb8e8d338a2dd72$var$registeringWrapper);
}
function $1fb8e8d338a2dd72$var$bindScopeToEmitter(emitter, scope = $79m2C.getCurrentScope()) {
    const ee = emitter;
    if ($1fb8e8d338a2dd72$var$getPatchMap(ee)) return emitter;
    $1fb8e8d338a2dd72$var$createPatchMap(ee);
    for (const methodName of $1fb8e8d338a2dd72$var$ADD_LISTENER_METHODS){
        if (typeof ee[methodName] !== "function") continue;
        ee[methodName] = $1fb8e8d338a2dd72$var$patchAddListener(ee, ee[methodName], scope);
    }
    for (const methodName of $1fb8e8d338a2dd72$var$REMOVE_LISTENER_METHODS){
        if (typeof ee[methodName] !== "function") continue;
        ee[methodName] = $1fb8e8d338a2dd72$var$patchRemoveListener(ee, ee[methodName]);
    }
    if (typeof ee.removeAllListeners === "function") ee.removeAllListeners = $1fb8e8d338a2dd72$var$patchRemoveAllListeners(ee, ee.removeAllListeners);
    return emitter;
}
function $1fb8e8d338a2dd72$var$bindListenerToScope(listener, scope) {
    return function(...args) {
        return $79m2C.withScope(scope, ()=>listener.apply(this, args));
    };
}
function $1fb8e8d338a2dd72$var$isBoundListener(listener) {
    return typeof listener === "function";
}
function $1fb8e8d338a2dd72$var$patchAddListener(ee, original, scope) {
    return function(...args) {
        const event = args[0];
        const listener = args[1];
        const rest = args.slice(2);
        if (!$1fb8e8d338a2dd72$var$isBoundListener(listener) || $1fb8e8d338a2dd72$var$isReentrantWrapperRegistration(listener)) return original.apply(this, args);
        const map = $1fb8e8d338a2dd72$var$getPatchMap(ee) || $1fb8e8d338a2dd72$var$createPatchMap(ee);
        let listeners = map.get(event);
        if (!listeners) {
            listeners = /* @__PURE__ */ new WeakMap();
            map.set(event, listeners);
        }
        let boundListener = listeners.get(listener);
        if (!boundListener) {
            boundListener = $1fb8e8d338a2dd72$var$bindListenerToScope(listener, scope);
            listeners.set(listener, boundListener);
        }
        const previous = $1fb8e8d338a2dd72$var$registeringWrapper;
        $1fb8e8d338a2dd72$var$registeringWrapper = boundListener;
        try {
            return original.call(this, event, boundListener, ...rest);
        } finally{
            $1fb8e8d338a2dd72$var$registeringWrapper = previous;
        }
    };
}
function $1fb8e8d338a2dd72$var$patchRemoveListener(ee, original) {
    return function(...args) {
        const event = args[0];
        const listener = args[1];
        const rest = args.slice(2);
        const boundListener = $1fb8e8d338a2dd72$var$isBoundListener(listener) ? $1fb8e8d338a2dd72$var$getPatchMap(ee)?.get(event)?.get(listener) : void 0;
        if (!boundListener) return original.apply(this, args);
        return original.call(this, event, boundListener, ...rest);
    };
}
function $1fb8e8d338a2dd72$var$patchRemoveAllListeners(ee, original) {
    return function(...args) {
        const map = $1fb8e8d338a2dd72$var$getPatchMap(ee);
        if (map) {
            if (args.length === 0) $1fb8e8d338a2dd72$var$createPatchMap(ee);
            else {
                const event = args[0];
                map.delete(event);
            }
        }
        return original.apply(this, args);
    };
}
function $1fb8e8d338a2dd72$var$createPatchMap(ee) {
    const map = /* @__PURE__ */ new Map();
    ee[$1fb8e8d338a2dd72$var$SCOPE_BOUND_LISTENERS] = map;
    return map;
}
function $1fb8e8d338a2dd72$var$getPatchMap(ee) {
    return ee[$1fb8e8d338a2dd72$var$SCOPE_BOUND_LISTENERS];
}
module.exports.bindScopeToEmitter = $1fb8e8d338a2dd72$var$bindScopeToEmitter;

});

parcelRegister("452ZL", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $gTasE = parcelRequire("gTasE");

var $fsIRO = parcelRequire("fsIRO");

var $8jbnX = parcelRequire("8jbnX");

var $bkBh2 = parcelRequire("bkBh2");

var $hOwNc = parcelRequire("hOwNc");

var $e3oiS = parcelRequire("e3oiS");

var $8Bk70 = parcelRequire("8Bk70");

var $5Qfaf = parcelRequire("5Qfaf");
function $2f89f3d4cb7c0079$var$captureSpan(span, client) {
    const spanJSON = $8jbnX.spanToStreamedSpanJSON(span);
    const segmentSpan = $8jbnX.INTERNAL_getSegmentSpan(span);
    const serializedSegmentSpan = $8jbnX.spanToStreamedSpanJSON(segmentSpan);
    const { isolationScope: spanIsolationScope, scope: spanScope } = $bkBh2.getCapturedScopesOnSpan(span);
    const finalScopeData = $fsIRO.getCombinedScopeData(spanIsolationScope, spanScope);
    $2f89f3d4cb7c0079$var$applyCommonSpanAttributes(spanJSON, serializedSegmentSpan, client, finalScopeData);
    const spanKind = span.kind;
    client.emit("preprocessSpan", spanJSON, {
        spanKind: spanKind
    });
    if (spanJSON.is_segment) {
        $2f89f3d4cb7c0079$var$applyScopeToSegmentSpan(spanJSON, finalScopeData);
        $2f89f3d4cb7c0079$var$applySdkMetadataToSegmentSpan(spanJSON, client);
        client.emit("processSegmentSpan", spanJSON);
    }
    client.emit("processSpan", spanJSON);
    const { beforeSendSpan: beforeSendSpan$1 } = client.getOptions();
    const processedSpan = beforeSendSpan$1 && $hOwNc.isStreamedBeforeSendSpanCallback(beforeSendSpan$1) ? $2f89f3d4cb7c0079$var$applyBeforeSendSpanCallback(spanJSON, beforeSendSpan$1) : spanJSON;
    const spanNameSource = processedSpan.attributes?.[$gTasE.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE];
    if (spanJSON.is_segment && spanNameSource) $2f89f3d4cb7c0079$var$safeSetSpanJSONAttributes(processedSpan, {
        ["sentry.segment.name.source"]: spanNameSource
    });
    return {
        ...$8jbnX.streamedSpanJsonToSerializedSpan(processedSpan),
        _segmentSpan: segmentSpan
    };
}
function $2f89f3d4cb7c0079$var$applyScopeToSegmentSpan(segmentSpanJSON, scopeData) {
    const contextAttributes = $e3oiS.scopeContextsToSpanAttributes(scopeData.contexts);
    $2f89f3d4cb7c0079$var$safeSetSpanJSONAttributes(segmentSpanJSON, contextAttributes);
}
function $2f89f3d4cb7c0079$var$safeSetSpanJSONAttributes(spanJSON, newAttributes) {
    const originalAttributes = spanJSON.attributes ?? (spanJSON.attributes = {});
    Object.entries(newAttributes).forEach(([key, value])=>{
        if (value != null && !(key in originalAttributes)) originalAttributes[key] = value;
    });
}
function $2f89f3d4cb7c0079$var$applySdkMetadataToSegmentSpan(segmentSpanJSON, client) {
    const integrationNames = client.getIntegrationNames();
    if (!integrationNames.length) return;
    $2f89f3d4cb7c0079$var$safeSetSpanJSONAttributes(segmentSpanJSON, {
        [$gTasE.SEMANTIC_ATTRIBUTE_SENTRY_SDK_INTEGRATIONS]: integrationNames
    });
}
function $2f89f3d4cb7c0079$var$applyCommonSpanAttributes(spanJSON, serializedSegmentSpan, client, scopeData) {
    const sdk = client.getSdkMetadata();
    const { release: release, environment: environment } = client.getOptions();
    $2f89f3d4cb7c0079$var$safeSetSpanJSONAttributes(spanJSON, {
        [$5Qfaf.SENTRY_TRACE_LIFECYCLE]: "stream",
        [$5Qfaf.SENTRY_SEGMENT_NAME]: serializedSegmentSpan.name,
        [$5Qfaf.SENTRY_SEGMENT_ID]: serializedSegmentSpan.span_id,
        [$5Qfaf.SENTRY_SDK_NAME]: sdk?.sdk?.name,
        [$5Qfaf.SENTRY_SDK_VERSION]: sdk?.sdk?.version,
        [$gTasE.SEMANTIC_ATTRIBUTE_SENTRY_RELEASE]: release,
        [$gTasE.SEMANTIC_ATTRIBUTE_SENTRY_ENVIRONMENT]: environment || $8Bk70.DEFAULT_ENVIRONMENT,
        [$gTasE.SEMANTIC_ATTRIBUTE_USER_ID]: scopeData.user?.id,
        [$gTasE.SEMANTIC_ATTRIBUTE_USER_EMAIL]: scopeData.user?.email,
        [$gTasE.SEMANTIC_ATTRIBUTE_USER_IP_ADDRESS]: scopeData.user?.ip_address,
        [$gTasE.SEMANTIC_ATTRIBUTE_USER_USERNAME]: scopeData.user?.username,
        ...scopeData.attributes
    });
}
function $2f89f3d4cb7c0079$var$applyBeforeSendSpanCallback(span, beforeSendSpan) {
    const modifedSpan = beforeSendSpan(span);
    if (!modifedSpan) {
        $8jbnX.showSpanDropWarning();
        return span;
    }
    return modifedSpan;
}
module.exports.applyBeforeSendSpanCallback = $2f89f3d4cb7c0079$var$applyBeforeSendSpanCallback;
module.exports.captureSpan = $2f89f3d4cb7c0079$var$captureSpan;
module.exports.safeSetSpanJSONAttributes = $2f89f3d4cb7c0079$var$safeSetSpanJSONAttributes;

});
parcelRegister("fsIRO", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $79m2C = parcelRequire("79m2C");

var $f0qnC = parcelRequire("f0qnC");

var $c9oD0 = parcelRequire("c9oD0");

var $8jbnX = parcelRequire("8jbnX");
function $b41c462da4c93c36$var$applyScopeDataToEvent(event, data) {
    const { fingerprint: fingerprint, span: span, breadcrumbs: breadcrumbs, sdkProcessingMetadata: sdkProcessingMetadata } = data;
    $b41c462da4c93c36$var$applyDataToEvent(event, data);
    if (span) $b41c462da4c93c36$var$applySpanToEvent(event, span);
    $b41c462da4c93c36$var$applyFingerprintToEvent(event, fingerprint);
    $b41c462da4c93c36$var$applyBreadcrumbsToEvent(event, breadcrumbs);
    $b41c462da4c93c36$var$applySdkMetadataToEvent(event, sdkProcessingMetadata);
}
function $b41c462da4c93c36$var$mergeScopeData(data, mergeData) {
    const { extra: extra, tags: tags, attributes: attributes, user: user, contexts: contexts, level: level, sdkProcessingMetadata: sdkProcessingMetadata, breadcrumbs: breadcrumbs, fingerprint: fingerprint, eventProcessors: eventProcessors, attachments: attachments, propagationContext: propagationContext, transactionName: transactionName, span: span } = mergeData;
    $b41c462da4c93c36$var$mergeAndOverwriteScopeData(data, "extra", extra);
    $b41c462da4c93c36$var$mergeAndOverwriteScopeData(data, "tags", tags);
    $b41c462da4c93c36$var$mergeAndOverwriteScopeData(data, "attributes", attributes);
    $b41c462da4c93c36$var$mergeAndOverwriteScopeData(data, "user", user);
    $b41c462da4c93c36$var$mergeAndOverwriteScopeData(data, "contexts", contexts);
    data.sdkProcessingMetadata = $c9oD0.merge(data.sdkProcessingMetadata, sdkProcessingMetadata, 2);
    if (level) data.level = level;
    if (transactionName) data.transactionName = transactionName;
    if (span) data.span = span;
    if (breadcrumbs.length) data.breadcrumbs = [
        ...data.breadcrumbs,
        ...breadcrumbs
    ];
    if (fingerprint.length) data.fingerprint = [
        ...data.fingerprint,
        ...fingerprint
    ];
    if (eventProcessors.length) data.eventProcessors = [
        ...data.eventProcessors,
        ...eventProcessors
    ];
    if (attachments.length) data.attachments = [
        ...data.attachments,
        ...attachments
    ];
    data.propagationContext = {
        ...data.propagationContext,
        ...propagationContext
    };
}
function $b41c462da4c93c36$var$mergeAndOverwriteScopeData(data, prop, mergeVal) {
    data[prop] = $c9oD0.merge(data[prop], mergeVal, 1);
}
function $b41c462da4c93c36$var$getCombinedScopeData(isolationScope, currentScope) {
    const scopeData = $79m2C.getGlobalScope().getScopeData();
    isolationScope && $b41c462da4c93c36$var$mergeScopeData(scopeData, isolationScope.getScopeData());
    currentScope && $b41c462da4c93c36$var$mergeScopeData(scopeData, currentScope.getScopeData());
    return scopeData;
}
function $b41c462da4c93c36$var$applyDataToEvent(event, data) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, transactionName: transactionName } = data;
    if (Object.keys(extra).length) event.extra = {
        ...extra,
        ...event.extra
    };
    if (Object.keys(tags).length) event.tags = {
        ...tags,
        ...event.tags
    };
    if (Object.keys(user).length) event.user = {
        ...user,
        ...event.user
    };
    if (Object.keys(contexts).length) event.contexts = {
        ...contexts,
        ...event.contexts
    };
    if (level) event.level = level;
    if (transactionName && event.type !== "transaction") event.transaction = transactionName;
}
function $b41c462da4c93c36$var$applyBreadcrumbsToEvent(event, breadcrumbs) {
    const mergedBreadcrumbs = [
        ...event.breadcrumbs || [],
        ...breadcrumbs
    ];
    event.breadcrumbs = mergedBreadcrumbs.length ? mergedBreadcrumbs : void 0;
}
function $b41c462da4c93c36$var$applySdkMetadataToEvent(event, sdkProcessingMetadata) {
    event.sdkProcessingMetadata = {
        ...event.sdkProcessingMetadata,
        ...sdkProcessingMetadata
    };
}
function $b41c462da4c93c36$var$applySpanToEvent(event, span) {
    event.contexts = {
        trace: $8jbnX.spanToTraceContext(span),
        ...event.contexts
    };
    event.sdkProcessingMetadata = {
        dynamicSamplingContext: $f0qnC.getDynamicSamplingContextFromSpan(span),
        ...event.sdkProcessingMetadata
    };
    const rootSpan = $8jbnX.getRootSpan(span);
    const transactionName = $8jbnX.spanToJSON(rootSpan).description;
    if (transactionName && !event.transaction && event.type === "transaction") event.transaction = transactionName;
}
function $b41c462da4c93c36$var$applyFingerprintToEvent(event, fingerprint) {
    event.fingerprint = event.fingerprint ? Array.isArray(event.fingerprint) ? event.fingerprint : [
        event.fingerprint
    ] : [];
    if (fingerprint) event.fingerprint = event.fingerprint.concat(fingerprint);
    if (!event.fingerprint.length) delete event.fingerprint;
}
module.exports.applyScopeDataToEvent = $b41c462da4c93c36$var$applyScopeDataToEvent;
module.exports.getCombinedScopeData = $b41c462da4c93c36$var$getCombinedScopeData;
module.exports.mergeAndOverwriteScopeData = $b41c462da4c93c36$var$mergeAndOverwriteScopeData;
module.exports.mergeScopeData = $b41c462da4c93c36$var$mergeScopeData;

});

parcelRegister("e3oiS", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $a3b432afe2881755$var$scopeContextsToSpanAttributes(contexts) {
    const attrs = {};
    const { response: response, profile: profile, cloud_resource: cloud_resource, culture: culture, state: state } = contexts;
    if (response) {
        if (response.status_code != null) attrs["http.response.status_code"] = response.status_code;
        if (response.body_size != null) attrs["http.response.body.size"] = response.body_size;
    }
    if (profile) {
        if (profile.profile_id) attrs["sentry.profile_id"] = profile.profile_id;
        if (profile.profiler_id) attrs["sentry.profiler_id"] = profile.profiler_id;
    }
    if (cloud_resource) {
        for (const [key, value] of Object.entries(cloud_resource))if (value != null) attrs[key] = value;
    }
    if (culture) {
        if (culture.locale) attrs["culture.locale"] = culture.locale;
        if (culture.timezone) attrs["culture.timezone"] = culture.timezone;
    }
    if (state?.state && typeof state.state.type === "string") attrs["state.type"] = state.state.type;
    const angular = contexts["angular"];
    if (angular) {
        const version = angular["version"];
        if (typeof version === "string" || typeof version === "number") attrs["angular.version"] = version;
    }
    const react = contexts["react"];
    if (react) {
        const version = react["version"];
        if (typeof version === "string" || typeof version === "number") attrs["react.version"] = version;
    }
    return attrs;
}
module.exports.scopeContextsToSpanAttributes = $a3b432afe2881755$var$scopeContextsToSpanAttributes;

});

parcelRegister("5Qfaf", function(module, exports) {
// This file is a compatibility shim for bundlers (e.g. webpack 4) that do not
// support the package.json `exports` field for resolving subpath exports.

module.exports = (parcelRequire("8GUzX"));

});
parcelRegister("8GUzX", function(module, exports) {

$parcel$export(module.exports, "AI_CITATIONS", function () { return $49d40eaf9ca0cfa4$export$b60c5e9f9b7b58bd; }, function (v) { return $49d40eaf9ca0cfa4$export$b60c5e9f9b7b58bd = v; });
$parcel$export(module.exports, "AI_COMPLETION_TOKENS_USED", function () { return $49d40eaf9ca0cfa4$export$cc06afd6de7f2c10; }, function (v) { return $49d40eaf9ca0cfa4$export$cc06afd6de7f2c10 = v; });
$parcel$export(module.exports, "AI_DOCUMENTS", function () { return $49d40eaf9ca0cfa4$export$ced6746028fe2cc; }, function (v) { return $49d40eaf9ca0cfa4$export$ced6746028fe2cc = v; });
$parcel$export(module.exports, "AI_FINISH_REASON", function () { return $49d40eaf9ca0cfa4$export$e6f4aa4f4fcb6da8; }, function (v) { return $49d40eaf9ca0cfa4$export$e6f4aa4f4fcb6da8 = v; });
$parcel$export(module.exports, "AI_FREQUENCY_PENALTY", function () { return $49d40eaf9ca0cfa4$export$f02d892201cd8d36; }, function (v) { return $49d40eaf9ca0cfa4$export$f02d892201cd8d36 = v; });
$parcel$export(module.exports, "AI_FUNCTION_CALL", function () { return $49d40eaf9ca0cfa4$export$f277a7ef9e273960; }, function (v) { return $49d40eaf9ca0cfa4$export$f277a7ef9e273960 = v; });
$parcel$export(module.exports, "AI_GENERATION_ID", function () { return $49d40eaf9ca0cfa4$export$1a8c212c3becaa80; }, function (v) { return $49d40eaf9ca0cfa4$export$1a8c212c3becaa80 = v; });
$parcel$export(module.exports, "AI_INPUT_MESSAGES", function () { return $49d40eaf9ca0cfa4$export$721b137086c68a47; }, function (v) { return $49d40eaf9ca0cfa4$export$721b137086c68a47 = v; });
$parcel$export(module.exports, "AI_IS_SEARCH_REQUIRED", function () { return $49d40eaf9ca0cfa4$export$6afde2bb69d9aa86; }, function (v) { return $49d40eaf9ca0cfa4$export$6afde2bb69d9aa86 = v; });
$parcel$export(module.exports, "AI_METADATA", function () { return $49d40eaf9ca0cfa4$export$eadb4b562c974031; }, function (v) { return $49d40eaf9ca0cfa4$export$eadb4b562c974031 = v; });
$parcel$export(module.exports, "AI_MODEL_ID", function () { return $49d40eaf9ca0cfa4$export$22a90f0ac1eee843; }, function (v) { return $49d40eaf9ca0cfa4$export$22a90f0ac1eee843 = v; });
$parcel$export(module.exports, "AI_MODEL_PROVIDER", function () { return $49d40eaf9ca0cfa4$export$a727f215a0be1dad; }, function (v) { return $49d40eaf9ca0cfa4$export$a727f215a0be1dad = v; });
$parcel$export(module.exports, "AI_PIPELINE_NAME", function () { return $49d40eaf9ca0cfa4$export$536bc61b34d995e5; }, function (v) { return $49d40eaf9ca0cfa4$export$536bc61b34d995e5 = v; });
$parcel$export(module.exports, "AI_PREAMBLE", function () { return $49d40eaf9ca0cfa4$export$c43ea6115b380e62; }, function (v) { return $49d40eaf9ca0cfa4$export$c43ea6115b380e62 = v; });
$parcel$export(module.exports, "AI_PRESENCE_PENALTY", function () { return $49d40eaf9ca0cfa4$export$d2a16e26bada7cf1; }, function (v) { return $49d40eaf9ca0cfa4$export$d2a16e26bada7cf1 = v; });
$parcel$export(module.exports, "AI_PROMPT_TOKENS_USED", function () { return $49d40eaf9ca0cfa4$export$604eb1bd2278163b; }, function (v) { return $49d40eaf9ca0cfa4$export$604eb1bd2278163b = v; });
$parcel$export(module.exports, "AI_RAW_PROMPTING", function () { return $49d40eaf9ca0cfa4$export$2f8568696c5aa352; }, function (v) { return $49d40eaf9ca0cfa4$export$2f8568696c5aa352 = v; });
$parcel$export(module.exports, "AI_RESPONSES", function () { return $49d40eaf9ca0cfa4$export$ccc8efd7dd31d3a9; }, function (v) { return $49d40eaf9ca0cfa4$export$ccc8efd7dd31d3a9 = v; });
$parcel$export(module.exports, "AI_RESPONSE_FORMAT", function () { return $49d40eaf9ca0cfa4$export$e176bf5dc45e40df; }, function (v) { return $49d40eaf9ca0cfa4$export$e176bf5dc45e40df = v; });
$parcel$export(module.exports, "AI_SEARCH_QUERIES", function () { return $49d40eaf9ca0cfa4$export$c4ea01fd53f64e16; }, function (v) { return $49d40eaf9ca0cfa4$export$c4ea01fd53f64e16 = v; });
$parcel$export(module.exports, "AI_SEARCH_RESULTS", function () { return $49d40eaf9ca0cfa4$export$bb5e6f2f31a15da9; }, function (v) { return $49d40eaf9ca0cfa4$export$bb5e6f2f31a15da9 = v; });
$parcel$export(module.exports, "AI_SEED", function () { return $49d40eaf9ca0cfa4$export$1762c11b666b026a; }, function (v) { return $49d40eaf9ca0cfa4$export$1762c11b666b026a = v; });
$parcel$export(module.exports, "AI_STREAMING", function () { return $49d40eaf9ca0cfa4$export$14ddd4b729910100; }, function (v) { return $49d40eaf9ca0cfa4$export$14ddd4b729910100 = v; });
$parcel$export(module.exports, "AI_TAGS", function () { return $49d40eaf9ca0cfa4$export$5311d7c8e1f8eabb; }, function (v) { return $49d40eaf9ca0cfa4$export$5311d7c8e1f8eabb = v; });
$parcel$export(module.exports, "AI_TEMPERATURE", function () { return $49d40eaf9ca0cfa4$export$2b748b9eca00828b; }, function (v) { return $49d40eaf9ca0cfa4$export$2b748b9eca00828b = v; });
$parcel$export(module.exports, "AI_TEXTS", function () { return $49d40eaf9ca0cfa4$export$5af25308c11addea; }, function (v) { return $49d40eaf9ca0cfa4$export$5af25308c11addea = v; });
$parcel$export(module.exports, "AI_TOOLS", function () { return $49d40eaf9ca0cfa4$export$28f78b3b1663cb92; }, function (v) { return $49d40eaf9ca0cfa4$export$28f78b3b1663cb92 = v; });
$parcel$export(module.exports, "AI_TOOL_CALLS", function () { return $49d40eaf9ca0cfa4$export$a1d3f09f0f1f066f; }, function (v) { return $49d40eaf9ca0cfa4$export$a1d3f09f0f1f066f = v; });
$parcel$export(module.exports, "AI_TOP_K", function () { return $49d40eaf9ca0cfa4$export$322bd4ea9f163663; }, function (v) { return $49d40eaf9ca0cfa4$export$322bd4ea9f163663 = v; });
$parcel$export(module.exports, "AI_TOP_P", function () { return $49d40eaf9ca0cfa4$export$95711b9e669edad8; }, function (v) { return $49d40eaf9ca0cfa4$export$95711b9e669edad8 = v; });
$parcel$export(module.exports, "AI_TOTAL_COST", function () { return $49d40eaf9ca0cfa4$export$5924d7d72384626a; }, function (v) { return $49d40eaf9ca0cfa4$export$5924d7d72384626a = v; });
$parcel$export(module.exports, "AI_TOTAL_TOKENS_USED", function () { return $49d40eaf9ca0cfa4$export$db3b1b877a4ce4db; }, function (v) { return $49d40eaf9ca0cfa4$export$db3b1b877a4ce4db = v; });
$parcel$export(module.exports, "AI_WARNINGS", function () { return $49d40eaf9ca0cfa4$export$a434a3e8afec2879; }, function (v) { return $49d40eaf9ca0cfa4$export$a434a3e8afec2879 = v; });
$parcel$export(module.exports, "ANGULAR_VERSION", function () { return $49d40eaf9ca0cfa4$export$fe00bb20636d42af; }, function (v) { return $49d40eaf9ca0cfa4$export$fe00bb20636d42af = v; });
$parcel$export(module.exports, "APP_APP_BUILD", function () { return $49d40eaf9ca0cfa4$export$712aa698b7ee271e; }, function (v) { return $49d40eaf9ca0cfa4$export$712aa698b7ee271e = v; });
$parcel$export(module.exports, "APP_APP_IDENTIFIER", function () { return $49d40eaf9ca0cfa4$export$1fac638b11ec16d9; }, function (v) { return $49d40eaf9ca0cfa4$export$1fac638b11ec16d9 = v; });
$parcel$export(module.exports, "APP_APP_NAME", function () { return $49d40eaf9ca0cfa4$export$d132016ea64058e3; }, function (v) { return $49d40eaf9ca0cfa4$export$d132016ea64058e3 = v; });
$parcel$export(module.exports, "APP_APP_START_TIME", function () { return $49d40eaf9ca0cfa4$export$53f2f47ec3b2f9ed; }, function (v) { return $49d40eaf9ca0cfa4$export$53f2f47ec3b2f9ed = v; });
$parcel$export(module.exports, "APP_APP_VERSION", function () { return $49d40eaf9ca0cfa4$export$9f80c4b11053cef1; }, function (v) { return $49d40eaf9ca0cfa4$export$9f80c4b11053cef1 = v; });
$parcel$export(module.exports, "APP_BUILD", function () { return $49d40eaf9ca0cfa4$export$5f7a08466d84e877; }, function (v) { return $49d40eaf9ca0cfa4$export$5f7a08466d84e877 = v; });
$parcel$export(module.exports, "APP_IDENTIFIER", function () { return $49d40eaf9ca0cfa4$export$2cea7f14750b8c19; }, function (v) { return $49d40eaf9ca0cfa4$export$2cea7f14750b8c19 = v; });
$parcel$export(module.exports, "APP_IN_FOREGROUND", function () { return $49d40eaf9ca0cfa4$export$34c59270f032a6c6; }, function (v) { return $49d40eaf9ca0cfa4$export$34c59270f032a6c6 = v; });
$parcel$export(module.exports, "APP_NAME", function () { return $49d40eaf9ca0cfa4$export$5b6c28c7dca07ad7; }, function (v) { return $49d40eaf9ca0cfa4$export$5b6c28c7dca07ad7 = v; });
$parcel$export(module.exports, "APP_START_COLD", function () { return $49d40eaf9ca0cfa4$export$1dc8ae58b58d6c50; }, function (v) { return $49d40eaf9ca0cfa4$export$1dc8ae58b58d6c50 = v; });
$parcel$export(module.exports, "APP_START_TIME", function () { return $49d40eaf9ca0cfa4$export$ba267414e3c0d822; }, function (v) { return $49d40eaf9ca0cfa4$export$ba267414e3c0d822 = v; });
$parcel$export(module.exports, "APP_START_TYPE", function () { return $49d40eaf9ca0cfa4$export$71b176005902b99e; }, function (v) { return $49d40eaf9ca0cfa4$export$71b176005902b99e = v; });
$parcel$export(module.exports, "APP_START_WARM", function () { return $49d40eaf9ca0cfa4$export$5c5b5a3c245a0079; }, function (v) { return $49d40eaf9ca0cfa4$export$5c5b5a3c245a0079 = v; });
$parcel$export(module.exports, "APP_VERSION", function () { return $49d40eaf9ca0cfa4$export$8ee1df3c6367a60; }, function (v) { return $49d40eaf9ca0cfa4$export$8ee1df3c6367a60 = v; });
$parcel$export(module.exports, "APP_VITALS_FRAMES_DELAY_VALUE", function () { return $49d40eaf9ca0cfa4$export$e8c7802ae95beccf; }, function (v) { return $49d40eaf9ca0cfa4$export$e8c7802ae95beccf = v; });
$parcel$export(module.exports, "APP_VITALS_FRAMES_FROZEN_COUNT", function () { return $49d40eaf9ca0cfa4$export$bb237734da4d464; }, function (v) { return $49d40eaf9ca0cfa4$export$bb237734da4d464 = v; });
$parcel$export(module.exports, "APP_VITALS_FRAMES_SLOW_COUNT", function () { return $49d40eaf9ca0cfa4$export$cdaaf6d1fdcba0b6; }, function (v) { return $49d40eaf9ca0cfa4$export$cdaaf6d1fdcba0b6 = v; });
$parcel$export(module.exports, "APP_VITALS_FRAMES_TOTAL_COUNT", function () { return $49d40eaf9ca0cfa4$export$36223ebd4a30e9f5; }, function (v) { return $49d40eaf9ca0cfa4$export$36223ebd4a30e9f5 = v; });
$parcel$export(module.exports, "APP_VITALS_START_COLD_VALUE", function () { return $49d40eaf9ca0cfa4$export$8feaa177bb7941e2; }, function (v) { return $49d40eaf9ca0cfa4$export$8feaa177bb7941e2 = v; });
$parcel$export(module.exports, "APP_VITALS_START_PREWARMED", function () { return $49d40eaf9ca0cfa4$export$e1ca25240db91d68; }, function (v) { return $49d40eaf9ca0cfa4$export$e1ca25240db91d68 = v; });
$parcel$export(module.exports, "APP_VITALS_START_REASON", function () { return $49d40eaf9ca0cfa4$export$404a223fd1ada08b; }, function (v) { return $49d40eaf9ca0cfa4$export$404a223fd1ada08b = v; });
$parcel$export(module.exports, "APP_VITALS_START_SCREEN", function () { return $49d40eaf9ca0cfa4$export$53362079310c68; }, function (v) { return $49d40eaf9ca0cfa4$export$53362079310c68 = v; });
$parcel$export(module.exports, "APP_VITALS_START_TYPE", function () { return $49d40eaf9ca0cfa4$export$3efb5af0ac379f77; }, function (v) { return $49d40eaf9ca0cfa4$export$3efb5af0ac379f77 = v; });
$parcel$export(module.exports, "APP_VITALS_START_WARM_VALUE", function () { return $49d40eaf9ca0cfa4$export$2c10c1ca0612c46d; }, function (v) { return $49d40eaf9ca0cfa4$export$2c10c1ca0612c46d = v; });
$parcel$export(module.exports, "APP_VITALS_TTFD_VALUE", function () { return $49d40eaf9ca0cfa4$export$bbb86ad4d6654da6; }, function (v) { return $49d40eaf9ca0cfa4$export$bbb86ad4d6654da6 = v; });
$parcel$export(module.exports, "APP_VITALS_TTID_VALUE", function () { return $49d40eaf9ca0cfa4$export$ad6896f00a2b1076; }, function (v) { return $49d40eaf9ca0cfa4$export$ad6896f00a2b1076 = v; });
$parcel$export(module.exports, "ART_GC_BLOCKING_COUNT", function () { return $49d40eaf9ca0cfa4$export$300f39d8506a273d; }, function (v) { return $49d40eaf9ca0cfa4$export$300f39d8506a273d = v; });
$parcel$export(module.exports, "ART_GC_BLOCKING_TIME", function () { return $49d40eaf9ca0cfa4$export$ecaa0e7f4773ddc7; }, function (v) { return $49d40eaf9ca0cfa4$export$ecaa0e7f4773ddc7 = v; });
$parcel$export(module.exports, "ART_GC_PRE_OOME_COUNT", function () { return $49d40eaf9ca0cfa4$export$74b78acb4c54c06b; }, function (v) { return $49d40eaf9ca0cfa4$export$74b78acb4c54c06b = v; });
$parcel$export(module.exports, "ART_GC_TOTAL_COUNT", function () { return $49d40eaf9ca0cfa4$export$b15b2c133bc50e33; }, function (v) { return $49d40eaf9ca0cfa4$export$b15b2c133bc50e33 = v; });
$parcel$export(module.exports, "ART_GC_TOTAL_TIME", function () { return $49d40eaf9ca0cfa4$export$5f1381d9ae1b1c95; }, function (v) { return $49d40eaf9ca0cfa4$export$5f1381d9ae1b1c95 = v; });
$parcel$export(module.exports, "ART_GC_WAITING_TIME", function () { return $49d40eaf9ca0cfa4$export$c170b7ff277132ea; }, function (v) { return $49d40eaf9ca0cfa4$export$c170b7ff277132ea = v; });
$parcel$export(module.exports, "ART_MEMORY_FREE", function () { return $49d40eaf9ca0cfa4$export$9459a5df93695e45; }, function (v) { return $49d40eaf9ca0cfa4$export$9459a5df93695e45 = v; });
$parcel$export(module.exports, "ART_MEMORY_FREE_UNTIL_GC", function () { return $49d40eaf9ca0cfa4$export$a7902bd57492ebe8; }, function (v) { return $49d40eaf9ca0cfa4$export$a7902bd57492ebe8 = v; });
$parcel$export(module.exports, "ART_MEMORY_FREE_UNTIL_OOME", function () { return $49d40eaf9ca0cfa4$export$d2ace0da59da09b7; }, function (v) { return $49d40eaf9ca0cfa4$export$d2ace0da59da09b7 = v; });
$parcel$export(module.exports, "ART_MEMORY_MAX", function () { return $49d40eaf9ca0cfa4$export$c15dd8d2461e0aeb; }, function (v) { return $49d40eaf9ca0cfa4$export$c15dd8d2461e0aeb = v; });
$parcel$export(module.exports, "ART_MEMORY_TOTAL", function () { return $49d40eaf9ca0cfa4$export$5405b0a98e00e538; }, function (v) { return $49d40eaf9ca0cfa4$export$5405b0a98e00e538 = v; });
$parcel$export(module.exports, "ATTRIBUTE_METADATA", function () { return $49d40eaf9ca0cfa4$export$bd393bbb84b309d3; }, function (v) { return $49d40eaf9ca0cfa4$export$bd393bbb84b309d3 = v; });
$parcel$export(module.exports, "ATTRIBUTE_TYPE", function () { return $49d40eaf9ca0cfa4$export$96f586f8837b86ae; }, function (v) { return $49d40eaf9ca0cfa4$export$96f586f8837b86ae = v; });
$parcel$export(module.exports, "AWS_CLOUDWATCH_LOGS_LOG_GROUP", function () { return $49d40eaf9ca0cfa4$export$5d9f28f388f552d2; }, function (v) { return $49d40eaf9ca0cfa4$export$5d9f28f388f552d2 = v; });
$parcel$export(module.exports, "AWS_CLOUDWATCH_LOGS_LOG_STREAM", function () { return $49d40eaf9ca0cfa4$export$b3d2f68e0e769504; }, function (v) { return $49d40eaf9ca0cfa4$export$b3d2f68e0e769504 = v; });
$parcel$export(module.exports, "AWS_CLOUDWATCH_LOGS_URL", function () { return $49d40eaf9ca0cfa4$export$2c98412ed43013e8; }, function (v) { return $49d40eaf9ca0cfa4$export$2c98412ed43013e8 = v; });
$parcel$export(module.exports, "AWS_DYNAMODB_ATTRIBUTE_DEFINITIONS", function () { return $49d40eaf9ca0cfa4$export$a7bd794d11c19f1b; }, function (v) { return $49d40eaf9ca0cfa4$export$a7bd794d11c19f1b = v; });
$parcel$export(module.exports, "AWS_DYNAMODB_CONSISTENT_READ", function () { return $49d40eaf9ca0cfa4$export$df4227832b83fdd0; }, function (v) { return $49d40eaf9ca0cfa4$export$df4227832b83fdd0 = v; });
$parcel$export(module.exports, "AWS_DYNAMODB_CONSUMED_CAPACITY", function () { return $49d40eaf9ca0cfa4$export$f131a6d8fbc0534f; }, function (v) { return $49d40eaf9ca0cfa4$export$f131a6d8fbc0534f = v; });
$parcel$export(module.exports, "AWS_DYNAMODB_COUNT", function () { return $49d40eaf9ca0cfa4$export$9bdc66d4a70e7e3a; }, function (v) { return $49d40eaf9ca0cfa4$export$9bdc66d4a70e7e3a = v; });
$parcel$export(module.exports, "AWS_DYNAMODB_EXCLUSIVE_START_TABLE", function () { return $49d40eaf9ca0cfa4$export$bfbbc3cbcaa90e98; }, function (v) { return $49d40eaf9ca0cfa4$export$bfbbc3cbcaa90e98 = v; });
$parcel$export(module.exports, "AWS_DYNAMODB_GLOBAL_SECONDARY_INDEXES", function () { return $49d40eaf9ca0cfa4$export$3565fa72459aa4d6; }, function (v) { return $49d40eaf9ca0cfa4$export$3565fa72459aa4d6 = v; });
$parcel$export(module.exports, "AWS_DYNAMODB_GLOBAL_SECONDARY_INDEX_UPDATES", function () { return $49d40eaf9ca0cfa4$export$bb67a834ae4bffdc; }, function (v) { return $49d40eaf9ca0cfa4$export$bb67a834ae4bffdc = v; });
$parcel$export(module.exports, "AWS_DYNAMODB_INDEX_NAME", function () { return $49d40eaf9ca0cfa4$export$4a06c859a283f06; }, function (v) { return $49d40eaf9ca0cfa4$export$4a06c859a283f06 = v; });
$parcel$export(module.exports, "AWS_DYNAMODB_ITEM_COLLECTION_METRICS", function () { return $49d40eaf9ca0cfa4$export$68324fac2038d0f2; }, function (v) { return $49d40eaf9ca0cfa4$export$68324fac2038d0f2 = v; });
$parcel$export(module.exports, "AWS_DYNAMODB_LIMIT", function () { return $49d40eaf9ca0cfa4$export$5e1bd62ffd2786fb; }, function (v) { return $49d40eaf9ca0cfa4$export$5e1bd62ffd2786fb = v; });
$parcel$export(module.exports, "AWS_DYNAMODB_LOCAL_SECONDARY_INDEXES", function () { return $49d40eaf9ca0cfa4$export$bfdf2261058f56b; }, function (v) { return $49d40eaf9ca0cfa4$export$bfdf2261058f56b = v; });
$parcel$export(module.exports, "AWS_DYNAMODB_PROJECTION", function () { return $49d40eaf9ca0cfa4$export$23bf57842d9d53df; }, function (v) { return $49d40eaf9ca0cfa4$export$23bf57842d9d53df = v; });
$parcel$export(module.exports, "AWS_DYNAMODB_PROVISIONED_READ_CAPACITY", function () { return $49d40eaf9ca0cfa4$export$bfbd7e060eeb4d35; }, function (v) { return $49d40eaf9ca0cfa4$export$bfbd7e060eeb4d35 = v; });
$parcel$export(module.exports, "AWS_DYNAMODB_PROVISIONED_WRITE_CAPACITY", function () { return $49d40eaf9ca0cfa4$export$82eb6cccda27c3ff; }, function (v) { return $49d40eaf9ca0cfa4$export$82eb6cccda27c3ff = v; });
$parcel$export(module.exports, "AWS_DYNAMODB_SCANNED_COUNT", function () { return $49d40eaf9ca0cfa4$export$8ea68734d455808f; }, function (v) { return $49d40eaf9ca0cfa4$export$8ea68734d455808f = v; });
$parcel$export(module.exports, "AWS_DYNAMODB_SCAN_FORWARD", function () { return $49d40eaf9ca0cfa4$export$40050e29324d44ee; }, function (v) { return $49d40eaf9ca0cfa4$export$40050e29324d44ee = v; });
$parcel$export(module.exports, "AWS_DYNAMODB_SEGMENT", function () { return $49d40eaf9ca0cfa4$export$5cd7541006d9f467; }, function (v) { return $49d40eaf9ca0cfa4$export$5cd7541006d9f467 = v; });
$parcel$export(module.exports, "AWS_DYNAMODB_SELECT", function () { return $49d40eaf9ca0cfa4$export$81c017edd95d692e; }, function (v) { return $49d40eaf9ca0cfa4$export$81c017edd95d692e = v; });
$parcel$export(module.exports, "AWS_DYNAMODB_TABLE_COUNT", function () { return $49d40eaf9ca0cfa4$export$120b3897a58cf903; }, function (v) { return $49d40eaf9ca0cfa4$export$120b3897a58cf903 = v; });
$parcel$export(module.exports, "AWS_DYNAMODB_TABLE_NAMES", function () { return $49d40eaf9ca0cfa4$export$d4a9de43b4b1076c; }, function (v) { return $49d40eaf9ca0cfa4$export$d4a9de43b4b1076c = v; });
$parcel$export(module.exports, "AWS_DYNAMODB_TOTAL_SEGMENTS", function () { return $49d40eaf9ca0cfa4$export$f37f4f9022f1ab17; }, function (v) { return $49d40eaf9ca0cfa4$export$f37f4f9022f1ab17 = v; });
$parcel$export(module.exports, "AWS_EXTENDED_REQUEST_ID", function () { return $49d40eaf9ca0cfa4$export$66ac18da14747cfb; }, function (v) { return $49d40eaf9ca0cfa4$export$66ac18da14747cfb = v; });
$parcel$export(module.exports, "AWS_KINESIS_STREAM_NAME", function () { return $49d40eaf9ca0cfa4$export$9e49b833525ca49d; }, function (v) { return $49d40eaf9ca0cfa4$export$9e49b833525ca49d = v; });
$parcel$export(module.exports, "AWS_LAMBDA_AWS_REQUEST_ID", function () { return $49d40eaf9ca0cfa4$export$b084fea5b3097227; }, function (v) { return $49d40eaf9ca0cfa4$export$b084fea5b3097227 = v; });
$parcel$export(module.exports, "AWS_LAMBDA_EXECUTION_DURATION_IN_MILLIS", function () { return $49d40eaf9ca0cfa4$export$e09cd8615652e8d0; }, function (v) { return $49d40eaf9ca0cfa4$export$e09cd8615652e8d0 = v; });
$parcel$export(module.exports, "AWS_LAMBDA_FUNCTION_NAME", function () { return $49d40eaf9ca0cfa4$export$a43a60ec723a90ee; }, function (v) { return $49d40eaf9ca0cfa4$export$a43a60ec723a90ee = v; });
$parcel$export(module.exports, "AWS_LAMBDA_FUNCTION_VERSION", function () { return $49d40eaf9ca0cfa4$export$34cc955357266287; }, function (v) { return $49d40eaf9ca0cfa4$export$34cc955357266287 = v; });
$parcel$export(module.exports, "AWS_LAMBDA_INVOKED_ARN", function () { return $49d40eaf9ca0cfa4$export$d9dd218693ea9bba; }, function (v) { return $49d40eaf9ca0cfa4$export$d9dd218693ea9bba = v; });
$parcel$export(module.exports, "AWS_LAMBDA_INVOKED_FUNCTION_ARN", function () { return $49d40eaf9ca0cfa4$export$c9649b7156282a2f; }, function (v) { return $49d40eaf9ca0cfa4$export$c9649b7156282a2f = v; });
$parcel$export(module.exports, "AWS_LAMBDA_REMAINING_TIME_IN_MILLIS", function () { return $49d40eaf9ca0cfa4$export$daa8ce1f8adc553e; }, function (v) { return $49d40eaf9ca0cfa4$export$daa8ce1f8adc553e = v; });
$parcel$export(module.exports, "AWS_LOG_GROUP_NAMES", function () { return $49d40eaf9ca0cfa4$export$cb93c7b05db202cf; }, function (v) { return $49d40eaf9ca0cfa4$export$cb93c7b05db202cf = v; });
$parcel$export(module.exports, "AWS_LOG_STREAM_NAMES", function () { return $49d40eaf9ca0cfa4$export$930f9bd3cc2e5b3d; }, function (v) { return $49d40eaf9ca0cfa4$export$930f9bd3cc2e5b3d = v; });
$parcel$export(module.exports, "AWS_REQUEST_EXTENDED_ID", function () { return $49d40eaf9ca0cfa4$export$48c6d4c44afdc0b; }, function (v) { return $49d40eaf9ca0cfa4$export$48c6d4c44afdc0b = v; });
$parcel$export(module.exports, "AWS_REQUEST_ID", function () { return $49d40eaf9ca0cfa4$export$c78d41789fe4b1e4; }, function (v) { return $49d40eaf9ca0cfa4$export$c78d41789fe4b1e4 = v; });
$parcel$export(module.exports, "AWS_S3_BUCKET", function () { return $49d40eaf9ca0cfa4$export$f462d9921f1f7332; }, function (v) { return $49d40eaf9ca0cfa4$export$f462d9921f1f7332 = v; });
$parcel$export(module.exports, "AWS_SECRETSMANAGER_SECRET_ARN", function () { return $49d40eaf9ca0cfa4$export$bc71f8df9a45e243; }, function (v) { return $49d40eaf9ca0cfa4$export$bc71f8df9a45e243 = v; });
$parcel$export(module.exports, "AWS_SNS_TOPIC_ARN", function () { return $49d40eaf9ca0cfa4$export$ed840ec4a5f5d053; }, function (v) { return $49d40eaf9ca0cfa4$export$ed840ec4a5f5d053 = v; });
$parcel$export(module.exports, "AWS_STEP_FUNCTIONS_ACTIVITY_ARN", function () { return $49d40eaf9ca0cfa4$export$c1a559a4f74a5e8e; }, function (v) { return $49d40eaf9ca0cfa4$export$c1a559a4f74a5e8e = v; });
$parcel$export(module.exports, "AWS_STEP_FUNCTIONS_STATE_MACHINE_ARN", function () { return $49d40eaf9ca0cfa4$export$d1c007424092e3f5; }, function (v) { return $49d40eaf9ca0cfa4$export$d1c007424092e3f5 = v; });
$parcel$export(module.exports, "BLOCKED_MAIN_THREAD", function () { return $49d40eaf9ca0cfa4$export$9ebb466ce954c49c; }, function (v) { return $49d40eaf9ca0cfa4$export$9ebb466ce954c49c = v; });
$parcel$export(module.exports, "BROWSER_NAME", function () { return $49d40eaf9ca0cfa4$export$e9aafc7348984403; }, function (v) { return $49d40eaf9ca0cfa4$export$e9aafc7348984403 = v; });
$parcel$export(module.exports, "BROWSER_PERFORMANCE_NAVIGATION_ACTIVATION_START", function () { return $49d40eaf9ca0cfa4$export$faaa46964f075237; }, function (v) { return $49d40eaf9ca0cfa4$export$faaa46964f075237 = v; });
$parcel$export(module.exports, "BROWSER_PERFORMANCE_TIME_ORIGIN", function () { return $49d40eaf9ca0cfa4$export$d28c4b3cc4431a87; }, function (v) { return $49d40eaf9ca0cfa4$export$d28c4b3cc4431a87 = v; });
$parcel$export(module.exports, "BROWSER_REPORT_TYPE", function () { return $49d40eaf9ca0cfa4$export$734b017b330c8fe6; }, function (v) { return $49d40eaf9ca0cfa4$export$734b017b330c8fe6 = v; });
$parcel$export(module.exports, "BROWSER_SCRIPT_INVOKER", function () { return $49d40eaf9ca0cfa4$export$683ebdc48ba3758d; }, function (v) { return $49d40eaf9ca0cfa4$export$683ebdc48ba3758d = v; });
$parcel$export(module.exports, "BROWSER_SCRIPT_INVOKER_TYPE", function () { return $49d40eaf9ca0cfa4$export$be0263971250ef44; }, function (v) { return $49d40eaf9ca0cfa4$export$be0263971250ef44 = v; });
$parcel$export(module.exports, "BROWSER_SCRIPT_SOURCE_CHAR_POSITION", function () { return $49d40eaf9ca0cfa4$export$36a0cbc35c405232; }, function (v) { return $49d40eaf9ca0cfa4$export$36a0cbc35c405232 = v; });
$parcel$export(module.exports, "BROWSER_VERSION", function () { return $49d40eaf9ca0cfa4$export$469f7765ba335497; }, function (v) { return $49d40eaf9ca0cfa4$export$469f7765ba335497 = v; });
$parcel$export(module.exports, "BROWSER_WEB_VITAL_CLS_REPORT_EVENT", function () { return $49d40eaf9ca0cfa4$export$fe6fe2b7af051610; }, function (v) { return $49d40eaf9ca0cfa4$export$fe6fe2b7af051610 = v; });
$parcel$export(module.exports, "BROWSER_WEB_VITAL_CLS_SOURCE_KEY", function () { return $49d40eaf9ca0cfa4$export$8345821877c4dfad; }, function (v) { return $49d40eaf9ca0cfa4$export$8345821877c4dfad = v; });
$parcel$export(module.exports, "BROWSER_WEB_VITAL_CLS_SOURCE_KEY_BASE", function () { return $49d40eaf9ca0cfa4$export$f6c188a7e02335cf; }, function (v) { return $49d40eaf9ca0cfa4$export$f6c188a7e02335cf = v; });
$parcel$export(module.exports, "BROWSER_WEB_VITAL_CLS_VALUE", function () { return $49d40eaf9ca0cfa4$export$aaf709a8971e825f; }, function (v) { return $49d40eaf9ca0cfa4$export$aaf709a8971e825f = v; });
$parcel$export(module.exports, "BROWSER_WEB_VITAL_FCP_VALUE", function () { return $49d40eaf9ca0cfa4$export$def01b82f8c092f7; }, function (v) { return $49d40eaf9ca0cfa4$export$def01b82f8c092f7 = v; });
$parcel$export(module.exports, "BROWSER_WEB_VITAL_FP_VALUE", function () { return $49d40eaf9ca0cfa4$export$23d4264c606a73a6; }, function (v) { return $49d40eaf9ca0cfa4$export$23d4264c606a73a6 = v; });
$parcel$export(module.exports, "BROWSER_WEB_VITAL_INP_VALUE", function () { return $49d40eaf9ca0cfa4$export$af9ece53bb92f66b; }, function (v) { return $49d40eaf9ca0cfa4$export$af9ece53bb92f66b = v; });
$parcel$export(module.exports, "BROWSER_WEB_VITAL_LCP_ELEMENT", function () { return $49d40eaf9ca0cfa4$export$25421625a565b69; }, function (v) { return $49d40eaf9ca0cfa4$export$25421625a565b69 = v; });
$parcel$export(module.exports, "BROWSER_WEB_VITAL_LCP_ID", function () { return $49d40eaf9ca0cfa4$export$ab0c90d873e69ccb; }, function (v) { return $49d40eaf9ca0cfa4$export$ab0c90d873e69ccb = v; });
$parcel$export(module.exports, "BROWSER_WEB_VITAL_LCP_LOAD_TIME", function () { return $49d40eaf9ca0cfa4$export$538c05cc8cb2a2bb; }, function (v) { return $49d40eaf9ca0cfa4$export$538c05cc8cb2a2bb = v; });
$parcel$export(module.exports, "BROWSER_WEB_VITAL_LCP_RENDER_TIME", function () { return $49d40eaf9ca0cfa4$export$f86df4de196e1a7c; }, function (v) { return $49d40eaf9ca0cfa4$export$f86df4de196e1a7c = v; });
$parcel$export(module.exports, "BROWSER_WEB_VITAL_LCP_REPORT_EVENT", function () { return $49d40eaf9ca0cfa4$export$51e8aa8c0d65e7b8; }, function (v) { return $49d40eaf9ca0cfa4$export$51e8aa8c0d65e7b8 = v; });
$parcel$export(module.exports, "BROWSER_WEB_VITAL_LCP_SIZE", function () { return $49d40eaf9ca0cfa4$export$99023486ecc470bd; }, function (v) { return $49d40eaf9ca0cfa4$export$99023486ecc470bd = v; });
$parcel$export(module.exports, "BROWSER_WEB_VITAL_LCP_URL", function () { return $49d40eaf9ca0cfa4$export$2f6c85eaf382e81; }, function (v) { return $49d40eaf9ca0cfa4$export$2f6c85eaf382e81 = v; });
$parcel$export(module.exports, "BROWSER_WEB_VITAL_LCP_VALUE", function () { return $49d40eaf9ca0cfa4$export$1158d57c0aed42be; }, function (v) { return $49d40eaf9ca0cfa4$export$1158d57c0aed42be = v; });
$parcel$export(module.exports, "BROWSER_WEB_VITAL_TTFB_REQUEST_TIME", function () { return $49d40eaf9ca0cfa4$export$d85c4f947ab776e3; }, function (v) { return $49d40eaf9ca0cfa4$export$d85c4f947ab776e3 = v; });
$parcel$export(module.exports, "BROWSER_WEB_VITAL_TTFB_VALUE", function () { return $49d40eaf9ca0cfa4$export$813ef8386d874918; }, function (v) { return $49d40eaf9ca0cfa4$export$813ef8386d874918 = v; });
$parcel$export(module.exports, "CACHE_HIT", function () { return $49d40eaf9ca0cfa4$export$7c2f74ff9251f64; }, function (v) { return $49d40eaf9ca0cfa4$export$7c2f74ff9251f64 = v; });
$parcel$export(module.exports, "CACHE_ITEM_SIZE", function () { return $49d40eaf9ca0cfa4$export$993f84dab107b880; }, function (v) { return $49d40eaf9ca0cfa4$export$993f84dab107b880 = v; });
$parcel$export(module.exports, "CACHE_KEY", function () { return $49d40eaf9ca0cfa4$export$7b9c2315e94d8d2f; }, function (v) { return $49d40eaf9ca0cfa4$export$7b9c2315e94d8d2f = v; });
$parcel$export(module.exports, "CACHE_OPERATION", function () { return $49d40eaf9ca0cfa4$export$f01e5cd42b9ec146; }, function (v) { return $49d40eaf9ca0cfa4$export$f01e5cd42b9ec146 = v; });
$parcel$export(module.exports, "CACHE_TTL", function () { return $49d40eaf9ca0cfa4$export$987f6b4367434b55; }, function (v) { return $49d40eaf9ca0cfa4$export$987f6b4367434b55 = v; });
$parcel$export(module.exports, "CACHE_WRITE", function () { return $49d40eaf9ca0cfa4$export$d9d145585d5022bb; }, function (v) { return $49d40eaf9ca0cfa4$export$d9d145585d5022bb = v; });
$parcel$export(module.exports, "CHANNEL", function () { return $49d40eaf9ca0cfa4$export$44ffba16bd48dac6; }, function (v) { return $49d40eaf9ca0cfa4$export$44ffba16bd48dac6 = v; });
$parcel$export(module.exports, "CLIENT_ADDRESS", function () { return $49d40eaf9ca0cfa4$export$3134892c5d2e251a; }, function (v) { return $49d40eaf9ca0cfa4$export$3134892c5d2e251a = v; });
$parcel$export(module.exports, "CLIENT_PORT", function () { return $49d40eaf9ca0cfa4$export$8495028d10296058; }, function (v) { return $49d40eaf9ca0cfa4$export$8495028d10296058 = v; });
$parcel$export(module.exports, "CLOUDFLARE_D1_DURATION", function () { return $49d40eaf9ca0cfa4$export$d6d0e4fcf46d490c; }, function (v) { return $49d40eaf9ca0cfa4$export$d6d0e4fcf46d490c = v; });
$parcel$export(module.exports, "CLOUDFLARE_D1_QUERY_TYPE", function () { return $49d40eaf9ca0cfa4$export$658dced473c19301; }, function (v) { return $49d40eaf9ca0cfa4$export$658dced473c19301 = v; });
$parcel$export(module.exports, "CLOUDFLARE_D1_ROWS_READ", function () { return $49d40eaf9ca0cfa4$export$97b0f9c3fbe64076; }, function (v) { return $49d40eaf9ca0cfa4$export$97b0f9c3fbe64076 = v; });
$parcel$export(module.exports, "CLOUDFLARE_D1_ROWS_WRITTEN", function () { return $49d40eaf9ca0cfa4$export$cf2c95ed5efbe9eb; }, function (v) { return $49d40eaf9ca0cfa4$export$cf2c95ed5efbe9eb = v; });
$parcel$export(module.exports, "CLOUDFLARE_DURABLE_OBJECT_QUERY_BINDINGS", function () { return $49d40eaf9ca0cfa4$export$880007904f61a388; }, function (v) { return $49d40eaf9ca0cfa4$export$880007904f61a388 = v; });
$parcel$export(module.exports, "CLOUDFLARE_DURABLE_OBJECT_RESPONSE_ROWS_READ", function () { return $49d40eaf9ca0cfa4$export$3e903b72d4d9e07d; }, function (v) { return $49d40eaf9ca0cfa4$export$3e903b72d4d9e07d = v; });
$parcel$export(module.exports, "CLOUDFLARE_DURABLE_OBJECT_RESPONSE_ROWS_WRITTEN", function () { return $49d40eaf9ca0cfa4$export$34da07180e0e56af; }, function (v) { return $49d40eaf9ca0cfa4$export$34da07180e0e56af = v; });
$parcel$export(module.exports, "CLOUDFLARE_R2_BUCKET", function () { return $49d40eaf9ca0cfa4$export$c49aafdaeb061953; }, function (v) { return $49d40eaf9ca0cfa4$export$c49aafdaeb061953 = v; });
$parcel$export(module.exports, "CLOUDFLARE_R2_OPERATION", function () { return $49d40eaf9ca0cfa4$export$ceb762c61de2f17f; }, function (v) { return $49d40eaf9ca0cfa4$export$ceb762c61de2f17f = v; });
$parcel$export(module.exports, "CLOUDFLARE_R2_REQUEST_DELIMITER", function () { return $49d40eaf9ca0cfa4$export$a5f54ccfb28c0caf; }, function (v) { return $49d40eaf9ca0cfa4$export$a5f54ccfb28c0caf = v; });
$parcel$export(module.exports, "CLOUDFLARE_R2_REQUEST_KEY", function () { return $49d40eaf9ca0cfa4$export$1c86a56857b024db; }, function (v) { return $49d40eaf9ca0cfa4$export$1c86a56857b024db = v; });
$parcel$export(module.exports, "CLOUDFLARE_R2_REQUEST_PART_NUMBER", function () { return $49d40eaf9ca0cfa4$export$7598f3464be47440; }, function (v) { return $49d40eaf9ca0cfa4$export$7598f3464be47440 = v; });
$parcel$export(module.exports, "CLOUDFLARE_R2_REQUEST_PREFIX", function () { return $49d40eaf9ca0cfa4$export$b673289c971fc0ae; }, function (v) { return $49d40eaf9ca0cfa4$export$b673289c971fc0ae = v; });
$parcel$export(module.exports, "CLOUDFLARE_WORKFLOW_ATTEMPT", function () { return $49d40eaf9ca0cfa4$export$98b23f3e6f0c2a6f; }, function (v) { return $49d40eaf9ca0cfa4$export$98b23f3e6f0c2a6f = v; });
$parcel$export(module.exports, "CLOUDFLARE_WORKFLOW_RETRIES_BACKOFF", function () { return $49d40eaf9ca0cfa4$export$6ddeaf0498614ebb; }, function (v) { return $49d40eaf9ca0cfa4$export$6ddeaf0498614ebb = v; });
$parcel$export(module.exports, "CLOUDFLARE_WORKFLOW_RETRIES_DELAY", function () { return $49d40eaf9ca0cfa4$export$97b78f78d64a7232; }, function (v) { return $49d40eaf9ca0cfa4$export$97b78f78d64a7232 = v; });
$parcel$export(module.exports, "CLOUDFLARE_WORKFLOW_RETRIES_LIMIT", function () { return $49d40eaf9ca0cfa4$export$5147715be870fff7; }, function (v) { return $49d40eaf9ca0cfa4$export$5147715be870fff7 = v; });
$parcel$export(module.exports, "CLOUDFLARE_WORKFLOW_TIMEOUT", function () { return $49d40eaf9ca0cfa4$export$5276bb46e6096fba; }, function (v) { return $49d40eaf9ca0cfa4$export$5276bb46e6096fba = v; });
$parcel$export(module.exports, "CLOUD_ACCOUNT_ID", function () { return $49d40eaf9ca0cfa4$export$cbcbc1f67a937cf3; }, function (v) { return $49d40eaf9ca0cfa4$export$cbcbc1f67a937cf3 = v; });
$parcel$export(module.exports, "CLOUD_AVAILABILITY_ZONE", function () { return $49d40eaf9ca0cfa4$export$226a2381b8f0cf78; }, function (v) { return $49d40eaf9ca0cfa4$export$226a2381b8f0cf78 = v; });
$parcel$export(module.exports, "CLOUD_PLATFORM", function () { return $49d40eaf9ca0cfa4$export$fd35512cae286064; }, function (v) { return $49d40eaf9ca0cfa4$export$fd35512cae286064 = v; });
$parcel$export(module.exports, "CLOUD_PROVIDER", function () { return $49d40eaf9ca0cfa4$export$de9bbf95ab1d81e; }, function (v) { return $49d40eaf9ca0cfa4$export$de9bbf95ab1d81e = v; });
$parcel$export(module.exports, "CLOUD_REGION", function () { return $49d40eaf9ca0cfa4$export$47fb20e8d18d7d15; }, function (v) { return $49d40eaf9ca0cfa4$export$47fb20e8d18d7d15 = v; });
$parcel$export(module.exports, "CLOUD_RESOURCE_ID", function () { return $49d40eaf9ca0cfa4$export$9db7964e4b8cb849; }, function (v) { return $49d40eaf9ca0cfa4$export$9db7964e4b8cb849 = v; });
$parcel$export(module.exports, "CLS", function () { return $49d40eaf9ca0cfa4$export$7139adf9d3bace41; }, function (v) { return $49d40eaf9ca0cfa4$export$7139adf9d3bace41 = v; });
$parcel$export(module.exports, "CLS_SOURCE_KEY", function () { return $49d40eaf9ca0cfa4$export$8ac3d09060e7f25d; }, function (v) { return $49d40eaf9ca0cfa4$export$8ac3d09060e7f25d = v; });
$parcel$export(module.exports, "CLS_SOURCE_KEY_BASE", function () { return $49d40eaf9ca0cfa4$export$dad0e4778ea23971; }, function (v) { return $49d40eaf9ca0cfa4$export$dad0e4778ea23971 = v; });
$parcel$export(module.exports, "CODE_FILEPATH", function () { return $49d40eaf9ca0cfa4$export$c14d903ccf9385a8; }, function (v) { return $49d40eaf9ca0cfa4$export$c14d903ccf9385a8 = v; });
$parcel$export(module.exports, "CODE_FILE_PATH", function () { return $49d40eaf9ca0cfa4$export$934cded0041affd7; }, function (v) { return $49d40eaf9ca0cfa4$export$934cded0041affd7 = v; });
$parcel$export(module.exports, "CODE_FUNCTION", function () { return $49d40eaf9ca0cfa4$export$6386da1dcba88c9d; }, function (v) { return $49d40eaf9ca0cfa4$export$6386da1dcba88c9d = v; });
$parcel$export(module.exports, "CODE_FUNCTION_NAME", function () { return $49d40eaf9ca0cfa4$export$a3371797e606e2; }, function (v) { return $49d40eaf9ca0cfa4$export$a3371797e606e2 = v; });
$parcel$export(module.exports, "CODE_LINENO", function () { return $49d40eaf9ca0cfa4$export$a5bbef0af83b23e5; }, function (v) { return $49d40eaf9ca0cfa4$export$a5bbef0af83b23e5 = v; });
$parcel$export(module.exports, "CODE_LINE_NUMBER", function () { return $49d40eaf9ca0cfa4$export$91ed1f55874222a6; }, function (v) { return $49d40eaf9ca0cfa4$export$91ed1f55874222a6 = v; });
$parcel$export(module.exports, "CODE_NAMESPACE", function () { return $49d40eaf9ca0cfa4$export$23de81068d2aed1b; }, function (v) { return $49d40eaf9ca0cfa4$export$23de81068d2aed1b = v; });
$parcel$export(module.exports, "CONNECTIONTYPE", function () { return $49d40eaf9ca0cfa4$export$d738320e1fba9e9d; }, function (v) { return $49d40eaf9ca0cfa4$export$d738320e1fba9e9d = v; });
$parcel$export(module.exports, "CONNECTION_RTT", function () { return $49d40eaf9ca0cfa4$export$2eacdea75497e8a5; }, function (v) { return $49d40eaf9ca0cfa4$export$2eacdea75497e8a5 = v; });
$parcel$export(module.exports, "CULTURE_CALENDAR", function () { return $49d40eaf9ca0cfa4$export$2bc3ea101f86c1d2; }, function (v) { return $49d40eaf9ca0cfa4$export$2bc3ea101f86c1d2 = v; });
$parcel$export(module.exports, "CULTURE_DISPLAY_NAME", function () { return $49d40eaf9ca0cfa4$export$c54e27e8d90ee081; }, function (v) { return $49d40eaf9ca0cfa4$export$c54e27e8d90ee081 = v; });
$parcel$export(module.exports, "CULTURE_IS_24_HOUR_FORMAT", function () { return $49d40eaf9ca0cfa4$export$4943adcec371c2a6; }, function (v) { return $49d40eaf9ca0cfa4$export$4943adcec371c2a6 = v; });
$parcel$export(module.exports, "CULTURE_LOCALE", function () { return $49d40eaf9ca0cfa4$export$f000a5900d0480c2; }, function (v) { return $49d40eaf9ca0cfa4$export$f000a5900d0480c2 = v; });
$parcel$export(module.exports, "CULTURE_TIMEZONE", function () { return $49d40eaf9ca0cfa4$export$8f5234893868273b; }, function (v) { return $49d40eaf9ca0cfa4$export$8f5234893868273b = v; });
$parcel$export(module.exports, "DB_COLLECTION_NAME", function () { return $49d40eaf9ca0cfa4$export$1a35518f6e81e8c7; }, function (v) { return $49d40eaf9ca0cfa4$export$1a35518f6e81e8c7 = v; });
$parcel$export(module.exports, "DB_DRIVER_NAME", function () { return $49d40eaf9ca0cfa4$export$a2d90911eaae60fc; }, function (v) { return $49d40eaf9ca0cfa4$export$a2d90911eaae60fc = v; });
$parcel$export(module.exports, "DB_NAME", function () { return $49d40eaf9ca0cfa4$export$3c22ff8b64b8f565; }, function (v) { return $49d40eaf9ca0cfa4$export$3c22ff8b64b8f565 = v; });
$parcel$export(module.exports, "DB_NAMESPACE", function () { return $49d40eaf9ca0cfa4$export$b8019c0e2a5b5f0f; }, function (v) { return $49d40eaf9ca0cfa4$export$b8019c0e2a5b5f0f = v; });
$parcel$export(module.exports, "DB_OPERATION", function () { return $49d40eaf9ca0cfa4$export$8c11477e471467c8; }, function (v) { return $49d40eaf9ca0cfa4$export$8c11477e471467c8 = v; });
$parcel$export(module.exports, "DB_OPERATION_BATCH_SIZE", function () { return $49d40eaf9ca0cfa4$export$92a96f6363488aee; }, function (v) { return $49d40eaf9ca0cfa4$export$92a96f6363488aee = v; });
$parcel$export(module.exports, "DB_OPERATION_NAME", function () { return $49d40eaf9ca0cfa4$export$f91beb6088f9ded9; }, function (v) { return $49d40eaf9ca0cfa4$export$f91beb6088f9ded9 = v; });
$parcel$export(module.exports, "DB_QUERY_PARAMETER_KEY", function () { return $49d40eaf9ca0cfa4$export$78bc7224576bf289; }, function (v) { return $49d40eaf9ca0cfa4$export$78bc7224576bf289 = v; });
$parcel$export(module.exports, "DB_QUERY_PARAMETER_KEY_BASE", function () { return $49d40eaf9ca0cfa4$export$a8027e0ea0d93ca; }, function (v) { return $49d40eaf9ca0cfa4$export$a8027e0ea0d93ca = v; });
$parcel$export(module.exports, "DB_QUERY_SUMMARY", function () { return $49d40eaf9ca0cfa4$export$5e59d3aea52e5037; }, function (v) { return $49d40eaf9ca0cfa4$export$5e59d3aea52e5037 = v; });
$parcel$export(module.exports, "DB_QUERY_TEXT", function () { return $49d40eaf9ca0cfa4$export$47e408be0da7933f; }, function (v) { return $49d40eaf9ca0cfa4$export$47e408be0da7933f = v; });
$parcel$export(module.exports, "DB_REDIS_CONNECTION", function () { return $49d40eaf9ca0cfa4$export$d5772b934ca13e57; }, function (v) { return $49d40eaf9ca0cfa4$export$d5772b934ca13e57 = v; });
$parcel$export(module.exports, "DB_REDIS_KEY", function () { return $49d40eaf9ca0cfa4$export$36e47f6a5777561d; }, function (v) { return $49d40eaf9ca0cfa4$export$36e47f6a5777561d = v; });
$parcel$export(module.exports, "DB_REDIS_PARAMETERS", function () { return $49d40eaf9ca0cfa4$export$e768cbc99cd68acf; }, function (v) { return $49d40eaf9ca0cfa4$export$e768cbc99cd68acf = v; });
$parcel$export(module.exports, "DB_RESPONSE_STATUS_CODE", function () { return $49d40eaf9ca0cfa4$export$dfcc6c69df1343f2; }, function (v) { return $49d40eaf9ca0cfa4$export$dfcc6c69df1343f2 = v; });
$parcel$export(module.exports, "DB_SQL_BINDINGS", function () { return $49d40eaf9ca0cfa4$export$69b0a5d9226b5211; }, function (v) { return $49d40eaf9ca0cfa4$export$69b0a5d9226b5211 = v; });
$parcel$export(module.exports, "DB_STATEMENT", function () { return $49d40eaf9ca0cfa4$export$da010a4f4fc971ae; }, function (v) { return $49d40eaf9ca0cfa4$export$da010a4f4fc971ae = v; });
$parcel$export(module.exports, "DB_STORED_PROCEDURE_NAME", function () { return $49d40eaf9ca0cfa4$export$5d515b35be0601a0; }, function (v) { return $49d40eaf9ca0cfa4$export$5d515b35be0601a0 = v; });
$parcel$export(module.exports, "DB_SYSTEM", function () { return $49d40eaf9ca0cfa4$export$3e1b1037a315c5ca; }, function (v) { return $49d40eaf9ca0cfa4$export$3e1b1037a315c5ca = v; });
$parcel$export(module.exports, "DB_SYSTEM_NAME", function () { return $49d40eaf9ca0cfa4$export$847fdd494825f0fb; }, function (v) { return $49d40eaf9ca0cfa4$export$847fdd494825f0fb = v; });
$parcel$export(module.exports, "DB_USER", function () { return $49d40eaf9ca0cfa4$export$a9d76f26c6c730a9; }, function (v) { return $49d40eaf9ca0cfa4$export$a9d76f26c6c730a9 = v; });
$parcel$export(module.exports, "DEVICEMEMORY", function () { return $49d40eaf9ca0cfa4$export$de03f86d1c9866ca; }, function (v) { return $49d40eaf9ca0cfa4$export$de03f86d1c9866ca = v; });
$parcel$export(module.exports, "DEVICE_ARCHS", function () { return $49d40eaf9ca0cfa4$export$65798ecab7eef8c; }, function (v) { return $49d40eaf9ca0cfa4$export$65798ecab7eef8c = v; });
$parcel$export(module.exports, "DEVICE_BATTERY_LEVEL", function () { return $49d40eaf9ca0cfa4$export$22aa61f48b9c79a0; }, function (v) { return $49d40eaf9ca0cfa4$export$22aa61f48b9c79a0 = v; });
$parcel$export(module.exports, "DEVICE_BATTERY_TEMPERATURE", function () { return $49d40eaf9ca0cfa4$export$69f5fb98f5aed812; }, function (v) { return $49d40eaf9ca0cfa4$export$69f5fb98f5aed812 = v; });
$parcel$export(module.exports, "DEVICE_BOOT_TIME", function () { return $49d40eaf9ca0cfa4$export$bdea5d1006fd280a; }, function (v) { return $49d40eaf9ca0cfa4$export$bdea5d1006fd280a = v; });
$parcel$export(module.exports, "DEVICE_BRAND", function () { return $49d40eaf9ca0cfa4$export$f63a7230c5b1d609; }, function (v) { return $49d40eaf9ca0cfa4$export$f63a7230c5b1d609 = v; });
$parcel$export(module.exports, "DEVICE_CHARGING", function () { return $49d40eaf9ca0cfa4$export$6f25e59b05bb8e17; }, function (v) { return $49d40eaf9ca0cfa4$export$6f25e59b05bb8e17 = v; });
$parcel$export(module.exports, "DEVICE_CHIPSET", function () { return $49d40eaf9ca0cfa4$export$a56ad13c4afc7421; }, function (v) { return $49d40eaf9ca0cfa4$export$a56ad13c4afc7421 = v; });
$parcel$export(module.exports, "DEVICE_CLASS", function () { return $49d40eaf9ca0cfa4$export$d9ce89ce8912bf12; }, function (v) { return $49d40eaf9ca0cfa4$export$d9ce89ce8912bf12 = v; });
$parcel$export(module.exports, "DEVICE_CONNECTION_TYPE", function () { return $49d40eaf9ca0cfa4$export$17094e5f380e4162; }, function (v) { return $49d40eaf9ca0cfa4$export$17094e5f380e4162 = v; });
$parcel$export(module.exports, "DEVICE_CPU_DESCRIPTION", function () { return $49d40eaf9ca0cfa4$export$28a0ffdf747973a0; }, function (v) { return $49d40eaf9ca0cfa4$export$28a0ffdf747973a0 = v; });
$parcel$export(module.exports, "DEVICE_EXTERNAL_FREE_STORAGE", function () { return $49d40eaf9ca0cfa4$export$5480ae1ba5d50bb9; }, function (v) { return $49d40eaf9ca0cfa4$export$5480ae1ba5d50bb9 = v; });
$parcel$export(module.exports, "DEVICE_EXTERNAL_STORAGE_SIZE", function () { return $49d40eaf9ca0cfa4$export$edc72ee4a17f5152; }, function (v) { return $49d40eaf9ca0cfa4$export$edc72ee4a17f5152 = v; });
$parcel$export(module.exports, "DEVICE_FAMILY", function () { return $49d40eaf9ca0cfa4$export$19e4df138d354f8b; }, function (v) { return $49d40eaf9ca0cfa4$export$19e4df138d354f8b = v; });
$parcel$export(module.exports, "DEVICE_FREE_MEMORY", function () { return $49d40eaf9ca0cfa4$export$92b0d20fa482b4b2; }, function (v) { return $49d40eaf9ca0cfa4$export$92b0d20fa482b4b2 = v; });
$parcel$export(module.exports, "DEVICE_FREE_STORAGE", function () { return $49d40eaf9ca0cfa4$export$3f638a793d61933f; }, function (v) { return $49d40eaf9ca0cfa4$export$3f638a793d61933f = v; });
$parcel$export(module.exports, "DEVICE_ID", function () { return $49d40eaf9ca0cfa4$export$3f511731cc3687d4; }, function (v) { return $49d40eaf9ca0cfa4$export$3f511731cc3687d4 = v; });
$parcel$export(module.exports, "DEVICE_LOCALE", function () { return $49d40eaf9ca0cfa4$export$692b08741d6b6265; }, function (v) { return $49d40eaf9ca0cfa4$export$692b08741d6b6265 = v; });
$parcel$export(module.exports, "DEVICE_LOW_MEMORY", function () { return $49d40eaf9ca0cfa4$export$cf67f8cb2324428e; }, function (v) { return $49d40eaf9ca0cfa4$export$cf67f8cb2324428e = v; });
$parcel$export(module.exports, "DEVICE_LOW_POWER_MODE", function () { return $49d40eaf9ca0cfa4$export$9d4197c1ffc5f359; }, function (v) { return $49d40eaf9ca0cfa4$export$9d4197c1ffc5f359 = v; });
$parcel$export(module.exports, "DEVICE_MANUFACTURER", function () { return $49d40eaf9ca0cfa4$export$509634fbff540e75; }, function (v) { return $49d40eaf9ca0cfa4$export$509634fbff540e75 = v; });
$parcel$export(module.exports, "DEVICE_MEMORY_ESTIMATED_CAPACITY", function () { return $49d40eaf9ca0cfa4$export$ccbc4fdff4b5eff5; }, function (v) { return $49d40eaf9ca0cfa4$export$ccbc4fdff4b5eff5 = v; });
$parcel$export(module.exports, "DEVICE_MEMORY_SIZE", function () { return $49d40eaf9ca0cfa4$export$e0cb371ca548b1d6; }, function (v) { return $49d40eaf9ca0cfa4$export$e0cb371ca548b1d6 = v; });
$parcel$export(module.exports, "DEVICE_MODEL", function () { return $49d40eaf9ca0cfa4$export$3c39026d09026bc2; }, function (v) { return $49d40eaf9ca0cfa4$export$3c39026d09026bc2 = v; });
$parcel$export(module.exports, "DEVICE_MODEL_ID", function () { return $49d40eaf9ca0cfa4$export$bf9e8248cb72cf00; }, function (v) { return $49d40eaf9ca0cfa4$export$bf9e8248cb72cf00 = v; });
$parcel$export(module.exports, "DEVICE_NAME", function () { return $49d40eaf9ca0cfa4$export$1054f22a72121d0f; }, function (v) { return $49d40eaf9ca0cfa4$export$1054f22a72121d0f = v; });
$parcel$export(module.exports, "DEVICE_ONLINE", function () { return $49d40eaf9ca0cfa4$export$723b8a59dad2e467; }, function (v) { return $49d40eaf9ca0cfa4$export$723b8a59dad2e467 = v; });
$parcel$export(module.exports, "DEVICE_ORIENTATION", function () { return $49d40eaf9ca0cfa4$export$160081ff141bac8e; }, function (v) { return $49d40eaf9ca0cfa4$export$160081ff141bac8e = v; });
$parcel$export(module.exports, "DEVICE_PROCESSOR_COUNT", function () { return $49d40eaf9ca0cfa4$export$194f62c84d27310; }, function (v) { return $49d40eaf9ca0cfa4$export$194f62c84d27310 = v; });
$parcel$export(module.exports, "DEVICE_PROCESSOR_FREQUENCY", function () { return $49d40eaf9ca0cfa4$export$7ed866d57b018d09; }, function (v) { return $49d40eaf9ca0cfa4$export$7ed866d57b018d09 = v; });
$parcel$export(module.exports, "DEVICE_SCREEN_DENSITY", function () { return $49d40eaf9ca0cfa4$export$d50bae4562e03e5; }, function (v) { return $49d40eaf9ca0cfa4$export$d50bae4562e03e5 = v; });
$parcel$export(module.exports, "DEVICE_SCREEN_DPI", function () { return $49d40eaf9ca0cfa4$export$649ea67a18fe8e8b; }, function (v) { return $49d40eaf9ca0cfa4$export$649ea67a18fe8e8b = v; });
$parcel$export(module.exports, "DEVICE_SCREEN_HEIGHT_PIXELS", function () { return $49d40eaf9ca0cfa4$export$136a5c1b43caaccd; }, function (v) { return $49d40eaf9ca0cfa4$export$136a5c1b43caaccd = v; });
$parcel$export(module.exports, "DEVICE_SCREEN_WIDTH_PIXELS", function () { return $49d40eaf9ca0cfa4$export$e33a28ea554b6ddc; }, function (v) { return $49d40eaf9ca0cfa4$export$e33a28ea554b6ddc = v; });
$parcel$export(module.exports, "DEVICE_SIMULATOR", function () { return $49d40eaf9ca0cfa4$export$acbe2d25ac76ea64; }, function (v) { return $49d40eaf9ca0cfa4$export$acbe2d25ac76ea64 = v; });
$parcel$export(module.exports, "DEVICE_STORAGE_SIZE", function () { return $49d40eaf9ca0cfa4$export$793c13e17d7e5e2b; }, function (v) { return $49d40eaf9ca0cfa4$export$793c13e17d7e5e2b = v; });
$parcel$export(module.exports, "DEVICE_THERMAL_STATE", function () { return $49d40eaf9ca0cfa4$export$a5617e33b89fd956; }, function (v) { return $49d40eaf9ca0cfa4$export$a5617e33b89fd956 = v; });
$parcel$export(module.exports, "DEVICE_TIMEZONE", function () { return $49d40eaf9ca0cfa4$export$b51f82164fa31e07; }, function (v) { return $49d40eaf9ca0cfa4$export$b51f82164fa31e07 = v; });
$parcel$export(module.exports, "DEVICE_USABLE_MEMORY", function () { return $49d40eaf9ca0cfa4$export$f2ef55183c04d202; }, function (v) { return $49d40eaf9ca0cfa4$export$f2ef55183c04d202 = v; });
$parcel$export(module.exports, "DIST", function () { return $49d40eaf9ca0cfa4$export$7c98fc0c48a16b1c; }, function (v) { return $49d40eaf9ca0cfa4$export$7c98fc0c48a16b1c = v; });
$parcel$export(module.exports, "EFFECTIVECONNECTIONTYPE", function () { return $49d40eaf9ca0cfa4$export$f0511e328234ae83; }, function (v) { return $49d40eaf9ca0cfa4$export$f0511e328234ae83 = v; });
$parcel$export(module.exports, "ENVIRONMENT", function () { return $49d40eaf9ca0cfa4$export$be46596bc6608f3b; }, function (v) { return $49d40eaf9ca0cfa4$export$be46596bc6608f3b = v; });
$parcel$export(module.exports, "ERROR_TYPE", function () { return $49d40eaf9ca0cfa4$export$f215947b3d76a6b7; }, function (v) { return $49d40eaf9ca0cfa4$export$f215947b3d76a6b7 = v; });
$parcel$export(module.exports, "EVENT_ID", function () { return $49d40eaf9ca0cfa4$export$89bbc91416db6670; }, function (v) { return $49d40eaf9ca0cfa4$export$89bbc91416db6670 = v; });
$parcel$export(module.exports, "EVENT_NAME", function () { return $49d40eaf9ca0cfa4$export$b4b5eff8a8712c89; }, function (v) { return $49d40eaf9ca0cfa4$export$b4b5eff8a8712c89 = v; });
$parcel$export(module.exports, "EXCEPTION_ESCAPED", function () { return $49d40eaf9ca0cfa4$export$f455969a57ab8a03; }, function (v) { return $49d40eaf9ca0cfa4$export$f455969a57ab8a03 = v; });
$parcel$export(module.exports, "EXCEPTION_MESSAGE", function () { return $49d40eaf9ca0cfa4$export$13f2f8f42af49cec; }, function (v) { return $49d40eaf9ca0cfa4$export$13f2f8f42af49cec = v; });
$parcel$export(module.exports, "EXCEPTION_STACKTRACE", function () { return $49d40eaf9ca0cfa4$export$cd357afe2ffdd2c3; }, function (v) { return $49d40eaf9ca0cfa4$export$cd357afe2ffdd2c3 = v; });
$parcel$export(module.exports, "EXCEPTION_TYPE", function () { return $49d40eaf9ca0cfa4$export$d9ca2a279a11be5e; }, function (v) { return $49d40eaf9ca0cfa4$export$d9ca2a279a11be5e = v; });
$parcel$export(module.exports, "FAAS_COLDSTART", function () { return $49d40eaf9ca0cfa4$export$bbd59a8c7efad4c9; }, function (v) { return $49d40eaf9ca0cfa4$export$bbd59a8c7efad4c9 = v; });
$parcel$export(module.exports, "FAAS_CRON", function () { return $49d40eaf9ca0cfa4$export$8413282a17f1cda5; }, function (v) { return $49d40eaf9ca0cfa4$export$8413282a17f1cda5 = v; });
$parcel$export(module.exports, "FAAS_DURATION_IN_MS", function () { return $49d40eaf9ca0cfa4$export$30d19ddc7705e7e8; }, function (v) { return $49d40eaf9ca0cfa4$export$30d19ddc7705e7e8 = v; });
$parcel$export(module.exports, "FAAS_ENTRY_POINT", function () { return $49d40eaf9ca0cfa4$export$64a4f09e2444b3d; }, function (v) { return $49d40eaf9ca0cfa4$export$64a4f09e2444b3d = v; });
$parcel$export(module.exports, "FAAS_EXECUTION", function () { return $49d40eaf9ca0cfa4$export$645b039fe163809e; }, function (v) { return $49d40eaf9ca0cfa4$export$645b039fe163809e = v; });
$parcel$export(module.exports, "FAAS_ID", function () { return $49d40eaf9ca0cfa4$export$b23ef8b8ffa607e1; }, function (v) { return $49d40eaf9ca0cfa4$export$b23ef8b8ffa607e1 = v; });
$parcel$export(module.exports, "FAAS_IDENTITY", function () { return $49d40eaf9ca0cfa4$export$8bf64516740c1369; }, function (v) { return $49d40eaf9ca0cfa4$export$8bf64516740c1369 = v; });
$parcel$export(module.exports, "FAAS_INVOCATION_ID", function () { return $49d40eaf9ca0cfa4$export$9a0dc8e612f3e10b; }, function (v) { return $49d40eaf9ca0cfa4$export$9a0dc8e612f3e10b = v; });
$parcel$export(module.exports, "FAAS_INVOKED_NAME", function () { return $49d40eaf9ca0cfa4$export$abe90fedb3dddda2; }, function (v) { return $49d40eaf9ca0cfa4$export$abe90fedb3dddda2 = v; });
$parcel$export(module.exports, "FAAS_INVOKED_PROVIDER", function () { return $49d40eaf9ca0cfa4$export$4a19da9c85ed2ade; }, function (v) { return $49d40eaf9ca0cfa4$export$4a19da9c85ed2ade = v; });
$parcel$export(module.exports, "FAAS_INVOKED_REGION", function () { return $49d40eaf9ca0cfa4$export$5e091479f094bdbc; }, function (v) { return $49d40eaf9ca0cfa4$export$5e091479f094bdbc = v; });
$parcel$export(module.exports, "FAAS_NAME", function () { return $49d40eaf9ca0cfa4$export$d70909b5aa96a79a; }, function (v) { return $49d40eaf9ca0cfa4$export$d70909b5aa96a79a = v; });
$parcel$export(module.exports, "FAAS_TIME", function () { return $49d40eaf9ca0cfa4$export$651d142a8017d83d; }, function (v) { return $49d40eaf9ca0cfa4$export$651d142a8017d83d = v; });
$parcel$export(module.exports, "FAAS_TRIGGER", function () { return $49d40eaf9ca0cfa4$export$44382a010a9f7fcf; }, function (v) { return $49d40eaf9ca0cfa4$export$44382a010a9f7fcf = v; });
$parcel$export(module.exports, "FAAS_VERSION", function () { return $49d40eaf9ca0cfa4$export$807abfdc6b7b9338; }, function (v) { return $49d40eaf9ca0cfa4$export$807abfdc6b7b9338 = v; });
$parcel$export(module.exports, "FCP", function () { return $49d40eaf9ca0cfa4$export$31881d07f2569218; }, function (v) { return $49d40eaf9ca0cfa4$export$31881d07f2569218 = v; });
$parcel$export(module.exports, "FLAG_EVALUATION_KEY", function () { return $49d40eaf9ca0cfa4$export$e5bbf306deb709a6; }, function (v) { return $49d40eaf9ca0cfa4$export$e5bbf306deb709a6 = v; });
$parcel$export(module.exports, "FLAG_EVALUATION_KEY_BASE", function () { return $49d40eaf9ca0cfa4$export$aa8721167c5c8d2d; }, function (v) { return $49d40eaf9ca0cfa4$export$aa8721167c5c8d2d = v; });
$parcel$export(module.exports, "FP", function () { return $49d40eaf9ca0cfa4$export$757b93e5b3adc7cb; }, function (v) { return $49d40eaf9ca0cfa4$export$757b93e5b3adc7cb = v; });
$parcel$export(module.exports, "FRAMES_DELAY", function () { return $49d40eaf9ca0cfa4$export$f869eaa92db1dc9b; }, function (v) { return $49d40eaf9ca0cfa4$export$f869eaa92db1dc9b = v; });
$parcel$export(module.exports, "FRAMES_FROZEN", function () { return $49d40eaf9ca0cfa4$export$5d1d761e41c32d9e; }, function (v) { return $49d40eaf9ca0cfa4$export$5d1d761e41c32d9e = v; });
$parcel$export(module.exports, "FRAMES_FROZEN_RATE", function () { return $49d40eaf9ca0cfa4$export$8aec72d9491f9399; }, function (v) { return $49d40eaf9ca0cfa4$export$8aec72d9491f9399 = v; });
$parcel$export(module.exports, "FRAMES_SLOW", function () { return $49d40eaf9ca0cfa4$export$5562635d2be2ab25; }, function (v) { return $49d40eaf9ca0cfa4$export$5562635d2be2ab25 = v; });
$parcel$export(module.exports, "FRAMES_SLOW_RATE", function () { return $49d40eaf9ca0cfa4$export$2dc31837ce6f7a3d; }, function (v) { return $49d40eaf9ca0cfa4$export$2dc31837ce6f7a3d = v; });
$parcel$export(module.exports, "FRAMES_TOTAL", function () { return $49d40eaf9ca0cfa4$export$b561df15f64d32e3; }, function (v) { return $49d40eaf9ca0cfa4$export$b561df15f64d32e3 = v; });
$parcel$export(module.exports, "FS_ERROR", function () { return $49d40eaf9ca0cfa4$export$181f78b28f2ffa57; }, function (v) { return $49d40eaf9ca0cfa4$export$181f78b28f2ffa57 = v; });
$parcel$export(module.exports, "GCP_FUNCTION_CONTEXT_EVENT_ID", function () { return $49d40eaf9ca0cfa4$export$6c97c77b89571c75; }, function (v) { return $49d40eaf9ca0cfa4$export$6c97c77b89571c75 = v; });
$parcel$export(module.exports, "GCP_FUNCTION_CONTEXT_EVENT_TYPE", function () { return $49d40eaf9ca0cfa4$export$51e431eaf1f9bf58; }, function (v) { return $49d40eaf9ca0cfa4$export$51e431eaf1f9bf58 = v; });
$parcel$export(module.exports, "GCP_FUNCTION_CONTEXT_ID", function () { return $49d40eaf9ca0cfa4$export$71429c7ef7cb7063; }, function (v) { return $49d40eaf9ca0cfa4$export$71429c7ef7cb7063 = v; });
$parcel$export(module.exports, "GCP_FUNCTION_CONTEXT_RESOURCE", function () { return $49d40eaf9ca0cfa4$export$99905d7583a6e8ac; }, function (v) { return $49d40eaf9ca0cfa4$export$99905d7583a6e8ac = v; });
$parcel$export(module.exports, "GCP_FUNCTION_CONTEXT_SOURCE", function () { return $49d40eaf9ca0cfa4$export$b6c4be74fd0c06bd; }, function (v) { return $49d40eaf9ca0cfa4$export$b6c4be74fd0c06bd = v; });
$parcel$export(module.exports, "GCP_FUNCTION_CONTEXT_SPECVERSION", function () { return $49d40eaf9ca0cfa4$export$fd23e5b8d261a89; }, function (v) { return $49d40eaf9ca0cfa4$export$fd23e5b8d261a89 = v; });
$parcel$export(module.exports, "GCP_FUNCTION_CONTEXT_TIME", function () { return $49d40eaf9ca0cfa4$export$25fabc9b3d1dd567; }, function (v) { return $49d40eaf9ca0cfa4$export$25fabc9b3d1dd567 = v; });
$parcel$export(module.exports, "GCP_FUNCTION_CONTEXT_TIMESTAMP", function () { return $49d40eaf9ca0cfa4$export$41507f7b07dad151; }, function (v) { return $49d40eaf9ca0cfa4$export$41507f7b07dad151 = v; });
$parcel$export(module.exports, "GCP_FUNCTION_CONTEXT_TYPE", function () { return $49d40eaf9ca0cfa4$export$1352f3699c35dd73; }, function (v) { return $49d40eaf9ca0cfa4$export$1352f3699c35dd73 = v; });
$parcel$export(module.exports, "GCP_PROJECT_ID", function () { return $49d40eaf9ca0cfa4$export$fd6c9d5c74d943ac; }, function (v) { return $49d40eaf9ca0cfa4$export$fd6c9d5c74d943ac = v; });
$parcel$export(module.exports, "GEN_AI_AGENT_NAME", function () { return $49d40eaf9ca0cfa4$export$c29634e3cf41e479; }, function (v) { return $49d40eaf9ca0cfa4$export$c29634e3cf41e479 = v; });
$parcel$export(module.exports, "GEN_AI_CONTEXT_UTILIZATION", function () { return $49d40eaf9ca0cfa4$export$e6a60882cce7a085; }, function (v) { return $49d40eaf9ca0cfa4$export$e6a60882cce7a085 = v; });
$parcel$export(module.exports, "GEN_AI_CONTEXT_WINDOW_SIZE", function () { return $49d40eaf9ca0cfa4$export$6773c9098ba5e194; }, function (v) { return $49d40eaf9ca0cfa4$export$6773c9098ba5e194 = v; });
$parcel$export(module.exports, "GEN_AI_CONVERSATION_ID", function () { return $49d40eaf9ca0cfa4$export$6ee6b62f50047686; }, function (v) { return $49d40eaf9ca0cfa4$export$6ee6b62f50047686 = v; });
$parcel$export(module.exports, "GEN_AI_COST_CACHE_CREATION_INPUT_TOKENS", function () { return $49d40eaf9ca0cfa4$export$efac052bb3661242; }, function (v) { return $49d40eaf9ca0cfa4$export$efac052bb3661242 = v; });
$parcel$export(module.exports, "GEN_AI_COST_CACHE_READ_INPUT_TOKENS", function () { return $49d40eaf9ca0cfa4$export$7ccd63b9ca955862; }, function (v) { return $49d40eaf9ca0cfa4$export$7ccd63b9ca955862 = v; });
$parcel$export(module.exports, "GEN_AI_COST_INPUT_TOKENS", function () { return $49d40eaf9ca0cfa4$export$50921df5a58cb3ef; }, function (v) { return $49d40eaf9ca0cfa4$export$50921df5a58cb3ef = v; });
$parcel$export(module.exports, "GEN_AI_COST_OUTPUT_TOKENS", function () { return $49d40eaf9ca0cfa4$export$8e48efc7acb57a97; }, function (v) { return $49d40eaf9ca0cfa4$export$8e48efc7acb57a97 = v; });
$parcel$export(module.exports, "GEN_AI_COST_REASONING_OUTPUT_TOKENS", function () { return $49d40eaf9ca0cfa4$export$cea9121727113f77; }, function (v) { return $49d40eaf9ca0cfa4$export$cea9121727113f77 = v; });
$parcel$export(module.exports, "GEN_AI_COST_TOTAL_TOKENS", function () { return $49d40eaf9ca0cfa4$export$bed35ff7f9af3aaa; }, function (v) { return $49d40eaf9ca0cfa4$export$bed35ff7f9af3aaa = v; });
$parcel$export(module.exports, "GEN_AI_EMBEDDINGS_INPUT", function () { return $49d40eaf9ca0cfa4$export$6b729e898b9067ce; }, function (v) { return $49d40eaf9ca0cfa4$export$6b729e898b9067ce = v; });
$parcel$export(module.exports, "GEN_AI_FUNCTION_ID", function () { return $49d40eaf9ca0cfa4$export$984fbab9b52f7e24; }, function (v) { return $49d40eaf9ca0cfa4$export$984fbab9b52f7e24 = v; });
$parcel$export(module.exports, "GEN_AI_INPUT_MESSAGES", function () { return $49d40eaf9ca0cfa4$export$9ea17906a87ada6f; }, function (v) { return $49d40eaf9ca0cfa4$export$9ea17906a87ada6f = v; });
$parcel$export(module.exports, "GEN_AI_OPERATION_NAME", function () { return $49d40eaf9ca0cfa4$export$394b443aaff3ef92; }, function (v) { return $49d40eaf9ca0cfa4$export$394b443aaff3ef92 = v; });
$parcel$export(module.exports, "GEN_AI_OPERATION_TYPE", function () { return $49d40eaf9ca0cfa4$export$6ddc374adbc06720; }, function (v) { return $49d40eaf9ca0cfa4$export$6ddc374adbc06720 = v; });
$parcel$export(module.exports, "GEN_AI_OUTPUT_MESSAGES", function () { return $49d40eaf9ca0cfa4$export$ab8c7ebc9add56b2; }, function (v) { return $49d40eaf9ca0cfa4$export$ab8c7ebc9add56b2 = v; });
$parcel$export(module.exports, "GEN_AI_PIPELINE_NAME", function () { return $49d40eaf9ca0cfa4$export$40ecc5bcd633d1ee; }, function (v) { return $49d40eaf9ca0cfa4$export$40ecc5bcd633d1ee = v; });
$parcel$export(module.exports, "GEN_AI_PROMPT", function () { return $49d40eaf9ca0cfa4$export$86a8df7fff52fc69; }, function (v) { return $49d40eaf9ca0cfa4$export$86a8df7fff52fc69 = v; });
$parcel$export(module.exports, "GEN_AI_PROMPT_NAME", function () { return $49d40eaf9ca0cfa4$export$cf2115d46768f4c5; }, function (v) { return $49d40eaf9ca0cfa4$export$cf2115d46768f4c5 = v; });
$parcel$export(module.exports, "GEN_AI_PROVIDER_NAME", function () { return $49d40eaf9ca0cfa4$export$3d7e036e195764db; }, function (v) { return $49d40eaf9ca0cfa4$export$3d7e036e195764db = v; });
$parcel$export(module.exports, "GEN_AI_REQUEST_AVAILABLE_TOOLS", function () { return $49d40eaf9ca0cfa4$export$60c1d11221608cee; }, function (v) { return $49d40eaf9ca0cfa4$export$60c1d11221608cee = v; });
$parcel$export(module.exports, "GEN_AI_REQUEST_FREQUENCY_PENALTY", function () { return $49d40eaf9ca0cfa4$export$bc3cef164abbc42c; }, function (v) { return $49d40eaf9ca0cfa4$export$bc3cef164abbc42c = v; });
$parcel$export(module.exports, "GEN_AI_REQUEST_MAX_TOKENS", function () { return $49d40eaf9ca0cfa4$export$43f9afb62cd79dec; }, function (v) { return $49d40eaf9ca0cfa4$export$43f9afb62cd79dec = v; });
$parcel$export(module.exports, "GEN_AI_REQUEST_MESSAGES", function () { return $49d40eaf9ca0cfa4$export$a5ab4ffc4765f75f; }, function (v) { return $49d40eaf9ca0cfa4$export$a5ab4ffc4765f75f = v; });
$parcel$export(module.exports, "GEN_AI_REQUEST_MODEL", function () { return $49d40eaf9ca0cfa4$export$ccf46db9ab1743ec; }, function (v) { return $49d40eaf9ca0cfa4$export$ccf46db9ab1743ec = v; });
$parcel$export(module.exports, "GEN_AI_REQUEST_PRESENCE_PENALTY", function () { return $49d40eaf9ca0cfa4$export$76c1c247342d776; }, function (v) { return $49d40eaf9ca0cfa4$export$76c1c247342d776 = v; });
$parcel$export(module.exports, "GEN_AI_REQUEST_REASONING_EFFORT", function () { return $49d40eaf9ca0cfa4$export$92f5944f0b02c9fb; }, function (v) { return $49d40eaf9ca0cfa4$export$92f5944f0b02c9fb = v; });
$parcel$export(module.exports, "GEN_AI_REQUEST_SEED", function () { return $49d40eaf9ca0cfa4$export$867eeefcb1c95b27; }, function (v) { return $49d40eaf9ca0cfa4$export$867eeefcb1c95b27 = v; });
$parcel$export(module.exports, "GEN_AI_REQUEST_STOP_SEQUENCES", function () { return $49d40eaf9ca0cfa4$export$5ada4697ae6aa17e; }, function (v) { return $49d40eaf9ca0cfa4$export$5ada4697ae6aa17e = v; });
$parcel$export(module.exports, "GEN_AI_REQUEST_TEMPERATURE", function () { return $49d40eaf9ca0cfa4$export$427122300e8d54d0; }, function (v) { return $49d40eaf9ca0cfa4$export$427122300e8d54d0 = v; });
$parcel$export(module.exports, "GEN_AI_REQUEST_TOP_K", function () { return $49d40eaf9ca0cfa4$export$bcea8881375c352f; }, function (v) { return $49d40eaf9ca0cfa4$export$bcea8881375c352f = v; });
$parcel$export(module.exports, "GEN_AI_REQUEST_TOP_P", function () { return $49d40eaf9ca0cfa4$export$b867715f9a0c04e9; }, function (v) { return $49d40eaf9ca0cfa4$export$b867715f9a0c04e9 = v; });
$parcel$export(module.exports, "GEN_AI_RESPONSE_FINISH_REASONS", function () { return $49d40eaf9ca0cfa4$export$69878a39cbdbe097; }, function (v) { return $49d40eaf9ca0cfa4$export$69878a39cbdbe097 = v; });
$parcel$export(module.exports, "GEN_AI_RESPONSE_ID", function () { return $49d40eaf9ca0cfa4$export$584c61a1b769552d; }, function (v) { return $49d40eaf9ca0cfa4$export$584c61a1b769552d = v; });
$parcel$export(module.exports, "GEN_AI_RESPONSE_MODEL", function () { return $49d40eaf9ca0cfa4$export$8169ebcb0b0331dd; }, function (v) { return $49d40eaf9ca0cfa4$export$8169ebcb0b0331dd = v; });
$parcel$export(module.exports, "GEN_AI_RESPONSE_STREAMING", function () { return $49d40eaf9ca0cfa4$export$2c9713b624877853; }, function (v) { return $49d40eaf9ca0cfa4$export$2c9713b624877853 = v; });
$parcel$export(module.exports, "GEN_AI_RESPONSE_TEXT", function () { return $49d40eaf9ca0cfa4$export$45942692aeb454e0; }, function (v) { return $49d40eaf9ca0cfa4$export$45942692aeb454e0 = v; });
$parcel$export(module.exports, "GEN_AI_RESPONSE_TIME_TO_FIRST_CHUNK", function () { return $49d40eaf9ca0cfa4$export$8e5efeaa031210cd; }, function (v) { return $49d40eaf9ca0cfa4$export$8e5efeaa031210cd = v; });
$parcel$export(module.exports, "GEN_AI_RESPONSE_TIME_TO_FIRST_TOKEN", function () { return $49d40eaf9ca0cfa4$export$35a62769ee05a05a; }, function (v) { return $49d40eaf9ca0cfa4$export$35a62769ee05a05a = v; });
$parcel$export(module.exports, "GEN_AI_RESPONSE_TOKENS_PER_SECOND", function () { return $49d40eaf9ca0cfa4$export$8ea4f7e986ca4b06; }, function (v) { return $49d40eaf9ca0cfa4$export$8ea4f7e986ca4b06 = v; });
$parcel$export(module.exports, "GEN_AI_RESPONSE_TOOL_CALLS", function () { return $49d40eaf9ca0cfa4$export$d2fd9ecaff0285a4; }, function (v) { return $49d40eaf9ca0cfa4$export$d2fd9ecaff0285a4 = v; });
$parcel$export(module.exports, "GEN_AI_SYSTEM", function () { return $49d40eaf9ca0cfa4$export$a6c8e656a4f9bb67; }, function (v) { return $49d40eaf9ca0cfa4$export$a6c8e656a4f9bb67 = v; });
$parcel$export(module.exports, "GEN_AI_SYSTEM_INSTRUCTIONS", function () { return $49d40eaf9ca0cfa4$export$352a8075b163d53; }, function (v) { return $49d40eaf9ca0cfa4$export$352a8075b163d53 = v; });
$parcel$export(module.exports, "GEN_AI_SYSTEM_MESSAGE", function () { return $49d40eaf9ca0cfa4$export$426d7b90ba5d79db; }, function (v) { return $49d40eaf9ca0cfa4$export$426d7b90ba5d79db = v; });
$parcel$export(module.exports, "GEN_AI_TOOL_CALL_ARGUMENTS", function () { return $49d40eaf9ca0cfa4$export$f5a1ee40934d19ce; }, function (v) { return $49d40eaf9ca0cfa4$export$f5a1ee40934d19ce = v; });
$parcel$export(module.exports, "GEN_AI_TOOL_CALL_RESULT", function () { return $49d40eaf9ca0cfa4$export$1ba812a9756622ce; }, function (v) { return $49d40eaf9ca0cfa4$export$1ba812a9756622ce = v; });
$parcel$export(module.exports, "GEN_AI_TOOL_DEFINITIONS", function () { return $49d40eaf9ca0cfa4$export$351120039c36e03; }, function (v) { return $49d40eaf9ca0cfa4$export$351120039c36e03 = v; });
$parcel$export(module.exports, "GEN_AI_TOOL_DESCRIPTION", function () { return $49d40eaf9ca0cfa4$export$d42aa25ca09e17c4; }, function (v) { return $49d40eaf9ca0cfa4$export$d42aa25ca09e17c4 = v; });
$parcel$export(module.exports, "GEN_AI_TOOL_INPUT", function () { return $49d40eaf9ca0cfa4$export$d268db29b88a4286; }, function (v) { return $49d40eaf9ca0cfa4$export$d268db29b88a4286 = v; });
$parcel$export(module.exports, "GEN_AI_TOOL_MESSAGE", function () { return $49d40eaf9ca0cfa4$export$c5deb6018f2d6251; }, function (v) { return $49d40eaf9ca0cfa4$export$c5deb6018f2d6251 = v; });
$parcel$export(module.exports, "GEN_AI_TOOL_NAME", function () { return $49d40eaf9ca0cfa4$export$e06baa3034409453; }, function (v) { return $49d40eaf9ca0cfa4$export$e06baa3034409453 = v; });
$parcel$export(module.exports, "GEN_AI_TOOL_OUTPUT", function () { return $49d40eaf9ca0cfa4$export$646fdb5910ce3931; }, function (v) { return $49d40eaf9ca0cfa4$export$646fdb5910ce3931 = v; });
$parcel$export(module.exports, "GEN_AI_TOOL_TYPE", function () { return $49d40eaf9ca0cfa4$export$662e3d2d4361e29b; }, function (v) { return $49d40eaf9ca0cfa4$export$662e3d2d4361e29b = v; });
$parcel$export(module.exports, "GEN_AI_USAGE_CACHE_CREATION_INPUT_TOKENS", function () { return $49d40eaf9ca0cfa4$export$1de3962f221ba441; }, function (v) { return $49d40eaf9ca0cfa4$export$1de3962f221ba441 = v; });
$parcel$export(module.exports, "GEN_AI_USAGE_CACHE_READ_INPUT_TOKENS", function () { return $49d40eaf9ca0cfa4$export$a4b3f0f5499c8738; }, function (v) { return $49d40eaf9ca0cfa4$export$a4b3f0f5499c8738 = v; });
$parcel$export(module.exports, "GEN_AI_USAGE_COMPLETION_TOKENS", function () { return $49d40eaf9ca0cfa4$export$1aecdac6cecbdc5b; }, function (v) { return $49d40eaf9ca0cfa4$export$1aecdac6cecbdc5b = v; });
$parcel$export(module.exports, "GEN_AI_USAGE_INPUT_TOKENS", function () { return $49d40eaf9ca0cfa4$export$2eb2ab35b317a103; }, function (v) { return $49d40eaf9ca0cfa4$export$2eb2ab35b317a103 = v; });
$parcel$export(module.exports, "GEN_AI_USAGE_INPUT_TOKENS_CACHED", function () { return $49d40eaf9ca0cfa4$export$c7e14ea195ede241; }, function (v) { return $49d40eaf9ca0cfa4$export$c7e14ea195ede241 = v; });
$parcel$export(module.exports, "GEN_AI_USAGE_INPUT_TOKENS_CACHE_WRITE", function () { return $49d40eaf9ca0cfa4$export$41ac034e7b9725a2; }, function (v) { return $49d40eaf9ca0cfa4$export$41ac034e7b9725a2 = v; });
$parcel$export(module.exports, "GEN_AI_USAGE_OUTPUT_TOKENS", function () { return $49d40eaf9ca0cfa4$export$9e521119d7751e37; }, function (v) { return $49d40eaf9ca0cfa4$export$9e521119d7751e37 = v; });
$parcel$export(module.exports, "GEN_AI_USAGE_OUTPUT_TOKENS_REASONING", function () { return $49d40eaf9ca0cfa4$export$cbac8f541a64a150; }, function (v) { return $49d40eaf9ca0cfa4$export$cbac8f541a64a150 = v; });
$parcel$export(module.exports, "GEN_AI_USAGE_PROMPT_TOKENS", function () { return $49d40eaf9ca0cfa4$export$93dd08efa94c9dd4; }, function (v) { return $49d40eaf9ca0cfa4$export$93dd08efa94c9dd4 = v; });
$parcel$export(module.exports, "GEN_AI_USAGE_REASONING_OUTPUT_TOKENS", function () { return $49d40eaf9ca0cfa4$export$183e3523dac20bca; }, function (v) { return $49d40eaf9ca0cfa4$export$183e3523dac20bca = v; });
$parcel$export(module.exports, "GEN_AI_USAGE_TOTAL_TOKENS", function () { return $49d40eaf9ca0cfa4$export$3867ca1d8381d4e3; }, function (v) { return $49d40eaf9ca0cfa4$export$3867ca1d8381d4e3 = v; });
$parcel$export(module.exports, "GRAPHQL_DOCUMENT", function () { return $49d40eaf9ca0cfa4$export$11febcf9917c0057; }, function (v) { return $49d40eaf9ca0cfa4$export$11febcf9917c0057 = v; });
$parcel$export(module.exports, "GRAPHQL_OPERATION_NAME", function () { return $49d40eaf9ca0cfa4$export$88ae1ee0c0a63398; }, function (v) { return $49d40eaf9ca0cfa4$export$88ae1ee0c0a63398 = v; });
$parcel$export(module.exports, "GRAPHQL_OPERATION_TYPE", function () { return $49d40eaf9ca0cfa4$export$d5bd986d1f283f29; }, function (v) { return $49d40eaf9ca0cfa4$export$d5bd986d1f283f29 = v; });
$parcel$export(module.exports, "HARDWARECONCURRENCY", function () { return $49d40eaf9ca0cfa4$export$fc4a2d238535d998; }, function (v) { return $49d40eaf9ca0cfa4$export$fc4a2d238535d998 = v; });
$parcel$export(module.exports, "HTTP_CLIENT_IP", function () { return $49d40eaf9ca0cfa4$export$57e53a60bf563f41; }, function (v) { return $49d40eaf9ca0cfa4$export$57e53a60bf563f41 = v; });
$parcel$export(module.exports, "HTTP_DECODED_RESPONSE_CONTENT_LENGTH", function () { return $49d40eaf9ca0cfa4$export$ffdb1464deb0eedb; }, function (v) { return $49d40eaf9ca0cfa4$export$ffdb1464deb0eedb = v; });
$parcel$export(module.exports, "HTTP_FLAVOR", function () { return $49d40eaf9ca0cfa4$export$b52670c950fd640; }, function (v) { return $49d40eaf9ca0cfa4$export$b52670c950fd640 = v; });
$parcel$export(module.exports, "HTTP_FRAGMENT", function () { return $49d40eaf9ca0cfa4$export$c499fd8f1db3d18e; }, function (v) { return $49d40eaf9ca0cfa4$export$c499fd8f1db3d18e = v; });
$parcel$export(module.exports, "HTTP_HOST", function () { return $49d40eaf9ca0cfa4$export$b2ee2242301eff05; }, function (v) { return $49d40eaf9ca0cfa4$export$b2ee2242301eff05 = v; });
$parcel$export(module.exports, "HTTP_METHOD", function () { return $49d40eaf9ca0cfa4$export$2ebf9f7586f16841; }, function (v) { return $49d40eaf9ca0cfa4$export$2ebf9f7586f16841 = v; });
$parcel$export(module.exports, "HTTP_QUERY", function () { return $49d40eaf9ca0cfa4$export$6e9ffd608b3e828b; }, function (v) { return $49d40eaf9ca0cfa4$export$6e9ffd608b3e828b = v; });
$parcel$export(module.exports, "HTTP_REQUEST_BODY_DATA", function () { return $49d40eaf9ca0cfa4$export$b960c5a73a722e6c; }, function (v) { return $49d40eaf9ca0cfa4$export$b960c5a73a722e6c = v; });
$parcel$export(module.exports, "HTTP_REQUEST_CONNECTION_END", function () { return $49d40eaf9ca0cfa4$export$a7a850351369c77e; }, function (v) { return $49d40eaf9ca0cfa4$export$a7a850351369c77e = v; });
$parcel$export(module.exports, "HTTP_REQUEST_CONNECT_START", function () { return $49d40eaf9ca0cfa4$export$b18bca78f4736a94; }, function (v) { return $49d40eaf9ca0cfa4$export$b18bca78f4736a94 = v; });
$parcel$export(module.exports, "HTTP_REQUEST_DOMAIN_LOOKUP_END", function () { return $49d40eaf9ca0cfa4$export$61a0059f562fb6c2; }, function (v) { return $49d40eaf9ca0cfa4$export$61a0059f562fb6c2 = v; });
$parcel$export(module.exports, "HTTP_REQUEST_DOMAIN_LOOKUP_START", function () { return $49d40eaf9ca0cfa4$export$7dc0d5aefb816d91; }, function (v) { return $49d40eaf9ca0cfa4$export$7dc0d5aefb816d91 = v; });
$parcel$export(module.exports, "HTTP_REQUEST_FETCH_START", function () { return $49d40eaf9ca0cfa4$export$58f6db56c841bef6; }, function (v) { return $49d40eaf9ca0cfa4$export$58f6db56c841bef6 = v; });
$parcel$export(module.exports, "HTTP_REQUEST_HEADER_KEY", function () { return $49d40eaf9ca0cfa4$export$97a3da679f509d5; }, function (v) { return $49d40eaf9ca0cfa4$export$97a3da679f509d5 = v; });
$parcel$export(module.exports, "HTTP_REQUEST_HEADER_KEY_BASE", function () { return $49d40eaf9ca0cfa4$export$c387ec65fd1c2638; }, function (v) { return $49d40eaf9ca0cfa4$export$c387ec65fd1c2638 = v; });
$parcel$export(module.exports, "HTTP_REQUEST_METHOD", function () { return $49d40eaf9ca0cfa4$export$4d9db82211f308a4; }, function (v) { return $49d40eaf9ca0cfa4$export$4d9db82211f308a4 = v; });
$parcel$export(module.exports, "HTTP_REQUEST_REDIRECT_END", function () { return $49d40eaf9ca0cfa4$export$ee4948a3be025123; }, function (v) { return $49d40eaf9ca0cfa4$export$ee4948a3be025123 = v; });
$parcel$export(module.exports, "HTTP_REQUEST_REDIRECT_START", function () { return $49d40eaf9ca0cfa4$export$e0021eb2979cddaa; }, function (v) { return $49d40eaf9ca0cfa4$export$e0021eb2979cddaa = v; });
$parcel$export(module.exports, "HTTP_REQUEST_REQUEST_START", function () { return $49d40eaf9ca0cfa4$export$7c0ac0c19a45beac; }, function (v) { return $49d40eaf9ca0cfa4$export$7c0ac0c19a45beac = v; });
$parcel$export(module.exports, "HTTP_REQUEST_RESEND_COUNT", function () { return $49d40eaf9ca0cfa4$export$6c32e9d84f534ee; }, function (v) { return $49d40eaf9ca0cfa4$export$6c32e9d84f534ee = v; });
$parcel$export(module.exports, "HTTP_REQUEST_RESPONSE_END", function () { return $49d40eaf9ca0cfa4$export$d1f9fbdb211dd29b; }, function (v) { return $49d40eaf9ca0cfa4$export$d1f9fbdb211dd29b = v; });
$parcel$export(module.exports, "HTTP_REQUEST_RESPONSE_START", function () { return $49d40eaf9ca0cfa4$export$45e7eea99a17d6e4; }, function (v) { return $49d40eaf9ca0cfa4$export$45e7eea99a17d6e4 = v; });
$parcel$export(module.exports, "HTTP_REQUEST_SAME_ORIGIN", function () { return $49d40eaf9ca0cfa4$export$20ea34e16c0aa64f; }, function (v) { return $49d40eaf9ca0cfa4$export$20ea34e16c0aa64f = v; });
$parcel$export(module.exports, "HTTP_REQUEST_SECURE_CONNECTION_START", function () { return $49d40eaf9ca0cfa4$export$8365b0f03557fae9; }, function (v) { return $49d40eaf9ca0cfa4$export$8365b0f03557fae9 = v; });
$parcel$export(module.exports, "HTTP_REQUEST_TIME_TO_FIRST_BYTE", function () { return $49d40eaf9ca0cfa4$export$49ebbb9621675650; }, function (v) { return $49d40eaf9ca0cfa4$export$49ebbb9621675650 = v; });
$parcel$export(module.exports, "HTTP_REQUEST_WORKER_START", function () { return $49d40eaf9ca0cfa4$export$842be66a901f093; }, function (v) { return $49d40eaf9ca0cfa4$export$842be66a901f093 = v; });
$parcel$export(module.exports, "HTTP_RESPONSE_BODY_SIZE", function () { return $49d40eaf9ca0cfa4$export$a9f5a6cb28adccb1; }, function (v) { return $49d40eaf9ca0cfa4$export$a9f5a6cb28adccb1 = v; });
$parcel$export(module.exports, "HTTP_RESPONSE_CONTENT_LENGTH", function () { return $49d40eaf9ca0cfa4$export$57b055d4bc586d67; }, function (v) { return $49d40eaf9ca0cfa4$export$57b055d4bc586d67 = v; });
$parcel$export(module.exports, "HTTP_RESPONSE_HEADER_CONTENT_LENGTH", function () { return $49d40eaf9ca0cfa4$export$3ddfd660caa7bf7a; }, function (v) { return $49d40eaf9ca0cfa4$export$3ddfd660caa7bf7a = v; });
$parcel$export(module.exports, "HTTP_RESPONSE_HEADER_KEY", function () { return $49d40eaf9ca0cfa4$export$fa7e1f5305153b3d; }, function (v) { return $49d40eaf9ca0cfa4$export$fa7e1f5305153b3d = v; });
$parcel$export(module.exports, "HTTP_RESPONSE_HEADER_KEY_BASE", function () { return $49d40eaf9ca0cfa4$export$5674ce9d013eb7bd; }, function (v) { return $49d40eaf9ca0cfa4$export$5674ce9d013eb7bd = v; });
$parcel$export(module.exports, "HTTP_RESPONSE_SIZE", function () { return $49d40eaf9ca0cfa4$export$6e8dc14cff6ccf72; }, function (v) { return $49d40eaf9ca0cfa4$export$6e8dc14cff6ccf72 = v; });
$parcel$export(module.exports, "HTTP_RESPONSE_STATUS_CODE", function () { return $49d40eaf9ca0cfa4$export$afd59480458e1b57; }, function (v) { return $49d40eaf9ca0cfa4$export$afd59480458e1b57 = v; });
$parcel$export(module.exports, "HTTP_RESPONSE_TRANSFER_SIZE", function () { return $49d40eaf9ca0cfa4$export$48e61fb9bccccba9; }, function (v) { return $49d40eaf9ca0cfa4$export$48e61fb9bccccba9 = v; });
$parcel$export(module.exports, "HTTP_ROUTE", function () { return $49d40eaf9ca0cfa4$export$d3e674514dd3a3e1; }, function (v) { return $49d40eaf9ca0cfa4$export$d3e674514dd3a3e1 = v; });
$parcel$export(module.exports, "HTTP_SCHEME", function () { return $49d40eaf9ca0cfa4$export$97ad02b50c60ef68; }, function (v) { return $49d40eaf9ca0cfa4$export$97ad02b50c60ef68 = v; });
$parcel$export(module.exports, "HTTP_SERVER_NAME", function () { return $49d40eaf9ca0cfa4$export$61d053b1b63e82c4; }, function (v) { return $49d40eaf9ca0cfa4$export$61d053b1b63e82c4 = v; });
$parcel$export(module.exports, "HTTP_SERVER_REQUEST_TIME_IN_QUEUE", function () { return $49d40eaf9ca0cfa4$export$54256cce0d674dea; }, function (v) { return $49d40eaf9ca0cfa4$export$54256cce0d674dea = v; });
$parcel$export(module.exports, "HTTP_STATUS_CODE", function () { return $49d40eaf9ca0cfa4$export$8c01f0f407bcc5ca; }, function (v) { return $49d40eaf9ca0cfa4$export$8c01f0f407bcc5ca = v; });
$parcel$export(module.exports, "HTTP_TARGET", function () { return $49d40eaf9ca0cfa4$export$be3f46982f6c7160; }, function (v) { return $49d40eaf9ca0cfa4$export$be3f46982f6c7160 = v; });
$parcel$export(module.exports, "HTTP_URL", function () { return $49d40eaf9ca0cfa4$export$778e4213e2788579; }, function (v) { return $49d40eaf9ca0cfa4$export$778e4213e2788579 = v; });
$parcel$export(module.exports, "HTTP_USER_AGENT", function () { return $49d40eaf9ca0cfa4$export$8b48ca3594d2b172; }, function (v) { return $49d40eaf9ca0cfa4$export$8b48ca3594d2b172 = v; });
$parcel$export(module.exports, "ID", function () { return $49d40eaf9ca0cfa4$export$8be180ec26319f9f; }, function (v) { return $49d40eaf9ca0cfa4$export$8be180ec26319f9f = v; });
$parcel$export(module.exports, "INP", function () { return $49d40eaf9ca0cfa4$export$60eccaddefa8fc1c; }, function (v) { return $49d40eaf9ca0cfa4$export$60eccaddefa8fc1c = v; });
$parcel$export(module.exports, "JSONRPC_PROTOCOL_VERSION", function () { return $49d40eaf9ca0cfa4$export$c99ce4fe37484d84; }, function (v) { return $49d40eaf9ca0cfa4$export$c99ce4fe37484d84 = v; });
$parcel$export(module.exports, "JSONRPC_REQUEST_ID", function () { return $49d40eaf9ca0cfa4$export$fdf432fcac7d8f37; }, function (v) { return $49d40eaf9ca0cfa4$export$fdf432fcac7d8f37 = v; });
$parcel$export(module.exports, "JVM_GC_ACTION", function () { return $49d40eaf9ca0cfa4$export$4c21cc9cdf2f5dbd; }, function (v) { return $49d40eaf9ca0cfa4$export$4c21cc9cdf2f5dbd = v; });
$parcel$export(module.exports, "JVM_GC_NAME", function () { return $49d40eaf9ca0cfa4$export$dcc1eab7f3f31816; }, function (v) { return $49d40eaf9ca0cfa4$export$dcc1eab7f3f31816 = v; });
$parcel$export(module.exports, "JVM_MEMORY_POOL_NAME", function () { return $49d40eaf9ca0cfa4$export$dcb7f1379b2b8f86; }, function (v) { return $49d40eaf9ca0cfa4$export$dcb7f1379b2b8f86 = v; });
$parcel$export(module.exports, "JVM_MEMORY_TYPE", function () { return $49d40eaf9ca0cfa4$export$53416edeea4c2d74; }, function (v) { return $49d40eaf9ca0cfa4$export$53416edeea4c2d74 = v; });
$parcel$export(module.exports, "JVM_THREAD_DAEMON", function () { return $49d40eaf9ca0cfa4$export$69f7e5d2b74c5c9e; }, function (v) { return $49d40eaf9ca0cfa4$export$69f7e5d2b74c5c9e = v; });
$parcel$export(module.exports, "JVM_THREAD_STATE", function () { return $49d40eaf9ca0cfa4$export$8e104aed582a26bc; }, function (v) { return $49d40eaf9ca0cfa4$export$8e104aed582a26bc = v; });
$parcel$export(module.exports, "KOA_NAME", function () { return $49d40eaf9ca0cfa4$export$577047501949be9; }, function (v) { return $49d40eaf9ca0cfa4$export$577047501949be9 = v; });
$parcel$export(module.exports, "KOA_TYPE", function () { return $49d40eaf9ca0cfa4$export$c4c45b599a2c15e; }, function (v) { return $49d40eaf9ca0cfa4$export$c4c45b599a2c15e = v; });
$parcel$export(module.exports, "LCP", function () { return $49d40eaf9ca0cfa4$export$361cb541700d648e; }, function (v) { return $49d40eaf9ca0cfa4$export$361cb541700d648e = v; });
$parcel$export(module.exports, "LCP_ELEMENT", function () { return $49d40eaf9ca0cfa4$export$974f160e11f25731; }, function (v) { return $49d40eaf9ca0cfa4$export$974f160e11f25731 = v; });
$parcel$export(module.exports, "LCP_ID", function () { return $49d40eaf9ca0cfa4$export$7162f5c702b95903; }, function (v) { return $49d40eaf9ca0cfa4$export$7162f5c702b95903 = v; });
$parcel$export(module.exports, "LCP_LOADTIME", function () { return $49d40eaf9ca0cfa4$export$a034d066a9090500; }, function (v) { return $49d40eaf9ca0cfa4$export$a034d066a9090500 = v; });
$parcel$export(module.exports, "LCP_RENDERTIME", function () { return $49d40eaf9ca0cfa4$export$70938021e43e047c; }, function (v) { return $49d40eaf9ca0cfa4$export$70938021e43e047c = v; });
$parcel$export(module.exports, "LCP_SIZE", function () { return $49d40eaf9ca0cfa4$export$5f6ac460012a73bb; }, function (v) { return $49d40eaf9ca0cfa4$export$5f6ac460012a73bb = v; });
$parcel$export(module.exports, "LCP_URL", function () { return $49d40eaf9ca0cfa4$export$d8e498c1c670bcbf; }, function (v) { return $49d40eaf9ca0cfa4$export$d8e498c1c670bcbf = v; });
$parcel$export(module.exports, "LOGGER_NAME", function () { return $49d40eaf9ca0cfa4$export$cc1a78a24d947903; }, function (v) { return $49d40eaf9ca0cfa4$export$cc1a78a24d947903 = v; });
$parcel$export(module.exports, "MCP_CANCELLED_REASON", function () { return $49d40eaf9ca0cfa4$export$d29b927e0bb0ffea; }, function (v) { return $49d40eaf9ca0cfa4$export$d29b927e0bb0ffea = v; });
$parcel$export(module.exports, "MCP_CANCELLED_REQUEST_ID", function () { return $49d40eaf9ca0cfa4$export$b3999cacef245779; }, function (v) { return $49d40eaf9ca0cfa4$export$b3999cacef245779 = v; });
$parcel$export(module.exports, "MCP_CLIENT_NAME", function () { return $49d40eaf9ca0cfa4$export$ff168b5f9cf9dcf6; }, function (v) { return $49d40eaf9ca0cfa4$export$ff168b5f9cf9dcf6 = v; });
$parcel$export(module.exports, "MCP_CLIENT_TITLE", function () { return $49d40eaf9ca0cfa4$export$2ab876a45bd6e64; }, function (v) { return $49d40eaf9ca0cfa4$export$2ab876a45bd6e64 = v; });
$parcel$export(module.exports, "MCP_CLIENT_VERSION", function () { return $49d40eaf9ca0cfa4$export$cb8027e4395c6c0e; }, function (v) { return $49d40eaf9ca0cfa4$export$cb8027e4395c6c0e = v; });
$parcel$export(module.exports, "MCP_LIFECYCLE_PHASE", function () { return $49d40eaf9ca0cfa4$export$f5303d1bac3c2660; }, function (v) { return $49d40eaf9ca0cfa4$export$f5303d1bac3c2660 = v; });
$parcel$export(module.exports, "MCP_LOGGING_DATA_TYPE", function () { return $49d40eaf9ca0cfa4$export$6c463c5f3b00f64; }, function (v) { return $49d40eaf9ca0cfa4$export$6c463c5f3b00f64 = v; });
$parcel$export(module.exports, "MCP_LOGGING_LEVEL", function () { return $49d40eaf9ca0cfa4$export$e25d553065457cab; }, function (v) { return $49d40eaf9ca0cfa4$export$e25d553065457cab = v; });
$parcel$export(module.exports, "MCP_LOGGING_LOGGER", function () { return $49d40eaf9ca0cfa4$export$15d24c154ea8a56f; }, function (v) { return $49d40eaf9ca0cfa4$export$15d24c154ea8a56f = v; });
$parcel$export(module.exports, "MCP_LOGGING_MESSAGE", function () { return $49d40eaf9ca0cfa4$export$e5065789a6c415d0; }, function (v) { return $49d40eaf9ca0cfa4$export$e5065789a6c415d0 = v; });
$parcel$export(module.exports, "MCP_METHOD_NAME", function () { return $49d40eaf9ca0cfa4$export$62662c561d7c7835; }, function (v) { return $49d40eaf9ca0cfa4$export$62662c561d7c7835 = v; });
$parcel$export(module.exports, "MCP_PROGRESS_CURRENT", function () { return $49d40eaf9ca0cfa4$export$218f394557fb0a5a; }, function (v) { return $49d40eaf9ca0cfa4$export$218f394557fb0a5a = v; });
$parcel$export(module.exports, "MCP_PROGRESS_MESSAGE", function () { return $49d40eaf9ca0cfa4$export$2a5ff6de5448ecdf; }, function (v) { return $49d40eaf9ca0cfa4$export$2a5ff6de5448ecdf = v; });
$parcel$export(module.exports, "MCP_PROGRESS_PERCENTAGE", function () { return $49d40eaf9ca0cfa4$export$9d23f3030ed2597e; }, function (v) { return $49d40eaf9ca0cfa4$export$9d23f3030ed2597e = v; });
$parcel$export(module.exports, "MCP_PROGRESS_TOKEN", function () { return $49d40eaf9ca0cfa4$export$a26ff217a6124160; }, function (v) { return $49d40eaf9ca0cfa4$export$a26ff217a6124160 = v; });
$parcel$export(module.exports, "MCP_PROGRESS_TOTAL", function () { return $49d40eaf9ca0cfa4$export$c8072f5fcfdb5b77; }, function (v) { return $49d40eaf9ca0cfa4$export$c8072f5fcfdb5b77 = v; });
$parcel$export(module.exports, "MCP_PROMPT_NAME", function () { return $49d40eaf9ca0cfa4$export$c4e4b74f1ccf3d96; }, function (v) { return $49d40eaf9ca0cfa4$export$c4e4b74f1ccf3d96 = v; });
$parcel$export(module.exports, "MCP_PROMPT_RESULT_DESCRIPTION", function () { return $49d40eaf9ca0cfa4$export$328519d02a26ac41; }, function (v) { return $49d40eaf9ca0cfa4$export$328519d02a26ac41 = v; });
$parcel$export(module.exports, "MCP_PROMPT_RESULT_MESSAGE_CONTENT", function () { return $49d40eaf9ca0cfa4$export$d2061b291c43d045; }, function (v) { return $49d40eaf9ca0cfa4$export$d2061b291c43d045 = v; });
$parcel$export(module.exports, "MCP_PROMPT_RESULT_MESSAGE_COUNT", function () { return $49d40eaf9ca0cfa4$export$d1f04dfd3d695286; }, function (v) { return $49d40eaf9ca0cfa4$export$d1f04dfd3d695286 = v; });
$parcel$export(module.exports, "MCP_PROMPT_RESULT_MESSAGE_ROLE", function () { return $49d40eaf9ca0cfa4$export$234fbd86ea0f0bd8; }, function (v) { return $49d40eaf9ca0cfa4$export$234fbd86ea0f0bd8 = v; });
$parcel$export(module.exports, "MCP_PROTOCOL_READY", function () { return $49d40eaf9ca0cfa4$export$e795000978a75b12; }, function (v) { return $49d40eaf9ca0cfa4$export$e795000978a75b12 = v; });
$parcel$export(module.exports, "MCP_PROTOCOL_VERSION", function () { return $49d40eaf9ca0cfa4$export$9f4683b4d1018ace; }, function (v) { return $49d40eaf9ca0cfa4$export$9f4683b4d1018ace = v; });
$parcel$export(module.exports, "MCP_REQUEST_ARGUMENT_KEY", function () { return $49d40eaf9ca0cfa4$export$e431b042fcdb1d63; }, function (v) { return $49d40eaf9ca0cfa4$export$e431b042fcdb1d63 = v; });
$parcel$export(module.exports, "MCP_REQUEST_ARGUMENT_KEY_BASE", function () { return $49d40eaf9ca0cfa4$export$a453239171ac9a23; }, function (v) { return $49d40eaf9ca0cfa4$export$a453239171ac9a23 = v; });
$parcel$export(module.exports, "MCP_REQUEST_ARGUMENT_NAME", function () { return $49d40eaf9ca0cfa4$export$3a7726a976c18d5f; }, function (v) { return $49d40eaf9ca0cfa4$export$3a7726a976c18d5f = v; });
$parcel$export(module.exports, "MCP_REQUEST_ARGUMENT_URI", function () { return $49d40eaf9ca0cfa4$export$7eca7a6c06843b93; }, function (v) { return $49d40eaf9ca0cfa4$export$7eca7a6c06843b93 = v; });
$parcel$export(module.exports, "MCP_REQUEST_ID", function () { return $49d40eaf9ca0cfa4$export$f25c55f83e5b0672; }, function (v) { return $49d40eaf9ca0cfa4$export$f25c55f83e5b0672 = v; });
$parcel$export(module.exports, "MCP_RESOURCE_PROTOCOL", function () { return $49d40eaf9ca0cfa4$export$9562bfac4eb079cb; }, function (v) { return $49d40eaf9ca0cfa4$export$9562bfac4eb079cb = v; });
$parcel$export(module.exports, "MCP_RESOURCE_URI", function () { return $49d40eaf9ca0cfa4$export$c276d164ff91d2f7; }, function (v) { return $49d40eaf9ca0cfa4$export$c276d164ff91d2f7 = v; });
$parcel$export(module.exports, "MCP_SERVER_NAME", function () { return $49d40eaf9ca0cfa4$export$2f3e0574f1a99754; }, function (v) { return $49d40eaf9ca0cfa4$export$2f3e0574f1a99754 = v; });
$parcel$export(module.exports, "MCP_SERVER_TITLE", function () { return $49d40eaf9ca0cfa4$export$15eecaab68167880; }, function (v) { return $49d40eaf9ca0cfa4$export$15eecaab68167880 = v; });
$parcel$export(module.exports, "MCP_SERVER_VERSION", function () { return $49d40eaf9ca0cfa4$export$513c47f6e194086a; }, function (v) { return $49d40eaf9ca0cfa4$export$513c47f6e194086a = v; });
$parcel$export(module.exports, "MCP_SESSION_ID", function () { return $49d40eaf9ca0cfa4$export$a3f464c4d5cd9096; }, function (v) { return $49d40eaf9ca0cfa4$export$a3f464c4d5cd9096 = v; });
$parcel$export(module.exports, "MCP_TOOL_NAME", function () { return $49d40eaf9ca0cfa4$export$ed366a03a2330b03; }, function (v) { return $49d40eaf9ca0cfa4$export$ed366a03a2330b03 = v; });
$parcel$export(module.exports, "MCP_TOOL_RESULT_CONTENT", function () { return $49d40eaf9ca0cfa4$export$9b802c784f235e1d; }, function (v) { return $49d40eaf9ca0cfa4$export$9b802c784f235e1d = v; });
$parcel$export(module.exports, "MCP_TOOL_RESULT_CONTENT_COUNT", function () { return $49d40eaf9ca0cfa4$export$add0fc8b8c5726a4; }, function (v) { return $49d40eaf9ca0cfa4$export$add0fc8b8c5726a4 = v; });
$parcel$export(module.exports, "MCP_TOOL_RESULT_IS_ERROR", function () { return $49d40eaf9ca0cfa4$export$e7f32463f5bfd554; }, function (v) { return $49d40eaf9ca0cfa4$export$e7f32463f5bfd554 = v; });
$parcel$export(module.exports, "MCP_TRANSPORT", function () { return $49d40eaf9ca0cfa4$export$f9346f394edf26a; }, function (v) { return $49d40eaf9ca0cfa4$export$f9346f394edf26a = v; });
$parcel$export(module.exports, "MDC_KEY", function () { return $49d40eaf9ca0cfa4$export$16b917774e73ef92; }, function (v) { return $49d40eaf9ca0cfa4$export$16b917774e73ef92 = v; });
$parcel$export(module.exports, "MDC_KEY_BASE", function () { return $49d40eaf9ca0cfa4$export$15d2b60bf3b65454; }, function (v) { return $49d40eaf9ca0cfa4$export$15d2b60bf3b65454 = v; });
$parcel$export(module.exports, "MESSAGING_BATCH_MESSAGE_COUNT", function () { return $49d40eaf9ca0cfa4$export$db55eca5af256142; }, function (v) { return $49d40eaf9ca0cfa4$export$db55eca5af256142 = v; });
$parcel$export(module.exports, "MESSAGING_DESTINATION", function () { return $49d40eaf9ca0cfa4$export$967c74f8b1f3d35; }, function (v) { return $49d40eaf9ca0cfa4$export$967c74f8b1f3d35 = v; });
$parcel$export(module.exports, "MESSAGING_DESTINATION_CONNECTION", function () { return $49d40eaf9ca0cfa4$export$7c33ae67962515d1; }, function (v) { return $49d40eaf9ca0cfa4$export$7c33ae67962515d1 = v; });
$parcel$export(module.exports, "MESSAGING_DESTINATION_NAME", function () { return $49d40eaf9ca0cfa4$export$9c69839b2d93489b; }, function (v) { return $49d40eaf9ca0cfa4$export$9c69839b2d93489b = v; });
$parcel$export(module.exports, "MESSAGING_MESSAGE_BODY_SIZE", function () { return $49d40eaf9ca0cfa4$export$be22d22d4b6cf5d8; }, function (v) { return $49d40eaf9ca0cfa4$export$be22d22d4b6cf5d8 = v; });
$parcel$export(module.exports, "MESSAGING_MESSAGE_CONVERSATION_ID", function () { return $49d40eaf9ca0cfa4$export$c529961b911626ac; }, function (v) { return $49d40eaf9ca0cfa4$export$c529961b911626ac = v; });
$parcel$export(module.exports, "MESSAGING_MESSAGE_ENVELOPE_SIZE", function () { return $49d40eaf9ca0cfa4$export$e39c4b15d2881f5; }, function (v) { return $49d40eaf9ca0cfa4$export$e39c4b15d2881f5 = v; });
$parcel$export(module.exports, "MESSAGING_MESSAGE_ID", function () { return $49d40eaf9ca0cfa4$export$a8ca145161313e7; }, function (v) { return $49d40eaf9ca0cfa4$export$a8ca145161313e7 = v; });
$parcel$export(module.exports, "MESSAGING_MESSAGE_RECEIVE_LATENCY", function () { return $49d40eaf9ca0cfa4$export$3c1204d03918d076; }, function (v) { return $49d40eaf9ca0cfa4$export$3c1204d03918d076 = v; });
$parcel$export(module.exports, "MESSAGING_MESSAGE_RETRY_COUNT", function () { return $49d40eaf9ca0cfa4$export$eaac3f141165e288; }, function (v) { return $49d40eaf9ca0cfa4$export$eaac3f141165e288 = v; });
$parcel$export(module.exports, "MESSAGING_OPERATION_NAME", function () { return $49d40eaf9ca0cfa4$export$4c7e6934714150e6; }, function (v) { return $49d40eaf9ca0cfa4$export$4c7e6934714150e6 = v; });
$parcel$export(module.exports, "MESSAGING_OPERATION_TYPE", function () { return $49d40eaf9ca0cfa4$export$6f71f9711d666eb4; }, function (v) { return $49d40eaf9ca0cfa4$export$6f71f9711d666eb4 = v; });
$parcel$export(module.exports, "MESSAGING_RABBITMQ_DESTINATION_ROUTING_KEY", function () { return $49d40eaf9ca0cfa4$export$2a3cd2bb71fb63a4; }, function (v) { return $49d40eaf9ca0cfa4$export$2a3cd2bb71fb63a4 = v; });
$parcel$export(module.exports, "MESSAGING_SYSTEM", function () { return $49d40eaf9ca0cfa4$export$55478a0b7d2ae98f; }, function (v) { return $49d40eaf9ca0cfa4$export$55478a0b7d2ae98f = v; });
$parcel$export(module.exports, "METHOD", function () { return $49d40eaf9ca0cfa4$export$bed10c4da9b8eb0a; }, function (v) { return $49d40eaf9ca0cfa4$export$bed10c4da9b8eb0a = v; });
$parcel$export(module.exports, "MIDDLEWARE_NAME", function () { return $49d40eaf9ca0cfa4$export$a82607b6424c06c8; }, function (v) { return $49d40eaf9ca0cfa4$export$a82607b6424c06c8 = v; });
$parcel$export(module.exports, "NAVIGATION_ORIGIN", function () { return $49d40eaf9ca0cfa4$export$6b081f3484c7f4e5; }, function (v) { return $49d40eaf9ca0cfa4$export$6b081f3484c7f4e5 = v; });
$parcel$export(module.exports, "NAVIGATION_ROUTE_ID", function () { return $49d40eaf9ca0cfa4$export$b7754d85fd39406c; }, function (v) { return $49d40eaf9ca0cfa4$export$b7754d85fd39406c = v; });
$parcel$export(module.exports, "NAVIGATION_TYPE", function () { return $49d40eaf9ca0cfa4$export$492856c046eb4728; }, function (v) { return $49d40eaf9ca0cfa4$export$492856c046eb4728 = v; });
$parcel$export(module.exports, "NEL_ELAPSED_TIME", function () { return $49d40eaf9ca0cfa4$export$c1678a2059fbe906; }, function (v) { return $49d40eaf9ca0cfa4$export$c1678a2059fbe906 = v; });
$parcel$export(module.exports, "NEL_PHASE", function () { return $49d40eaf9ca0cfa4$export$6d384a0bc1011c34; }, function (v) { return $49d40eaf9ca0cfa4$export$6d384a0bc1011c34 = v; });
$parcel$export(module.exports, "NEL_REFERRER", function () { return $49d40eaf9ca0cfa4$export$1499a7dbfc01e7d4; }, function (v) { return $49d40eaf9ca0cfa4$export$1499a7dbfc01e7d4 = v; });
$parcel$export(module.exports, "NEL_SAMPLING_FUNCTION", function () { return $49d40eaf9ca0cfa4$export$cfcbff40019f0ff1; }, function (v) { return $49d40eaf9ca0cfa4$export$cfcbff40019f0ff1 = v; });
$parcel$export(module.exports, "NEL_TYPE", function () { return $49d40eaf9ca0cfa4$export$27157b5f68e583af; }, function (v) { return $49d40eaf9ca0cfa4$export$27157b5f68e583af = v; });
$parcel$export(module.exports, "NETWORK_CONNECTION_EFFECTIVE_TYPE", function () { return $49d40eaf9ca0cfa4$export$54bf5ed61532925d; }, function (v) { return $49d40eaf9ca0cfa4$export$54bf5ed61532925d = v; });
$parcel$export(module.exports, "NETWORK_CONNECTION_RTT", function () { return $49d40eaf9ca0cfa4$export$60ed0786292ace08; }, function (v) { return $49d40eaf9ca0cfa4$export$60ed0786292ace08 = v; });
$parcel$export(module.exports, "NETWORK_CONNECTION_TYPE", function () { return $49d40eaf9ca0cfa4$export$d770bfb8345e146; }, function (v) { return $49d40eaf9ca0cfa4$export$d770bfb8345e146 = v; });
$parcel$export(module.exports, "NETWORK_LOCAL_ADDRESS", function () { return $49d40eaf9ca0cfa4$export$bb73817f1290ad28; }, function (v) { return $49d40eaf9ca0cfa4$export$bb73817f1290ad28 = v; });
$parcel$export(module.exports, "NETWORK_LOCAL_PORT", function () { return $49d40eaf9ca0cfa4$export$f201c980f2b75802; }, function (v) { return $49d40eaf9ca0cfa4$export$f201c980f2b75802 = v; });
$parcel$export(module.exports, "NETWORK_PEER_ADDRESS", function () { return $49d40eaf9ca0cfa4$export$b40e970572afd0ee; }, function (v) { return $49d40eaf9ca0cfa4$export$b40e970572afd0ee = v; });
$parcel$export(module.exports, "NETWORK_PEER_PORT", function () { return $49d40eaf9ca0cfa4$export$8850630a3d343488; }, function (v) { return $49d40eaf9ca0cfa4$export$8850630a3d343488 = v; });
$parcel$export(module.exports, "NETWORK_PROTOCOL_NAME", function () { return $49d40eaf9ca0cfa4$export$fd0a39a918d6516f; }, function (v) { return $49d40eaf9ca0cfa4$export$fd0a39a918d6516f = v; });
$parcel$export(module.exports, "NETWORK_PROTOCOL_VERSION", function () { return $49d40eaf9ca0cfa4$export$e68ef41f8e0335bf; }, function (v) { return $49d40eaf9ca0cfa4$export$e68ef41f8e0335bf = v; });
$parcel$export(module.exports, "NETWORK_TRANSPORT", function () { return $49d40eaf9ca0cfa4$export$5bff09650e762829; }, function (v) { return $49d40eaf9ca0cfa4$export$5bff09650e762829 = v; });
$parcel$export(module.exports, "NETWORK_TYPE", function () { return $49d40eaf9ca0cfa4$export$21c1adce0e067f37; }, function (v) { return $49d40eaf9ca0cfa4$export$21c1adce0e067f37 = v; });
$parcel$export(module.exports, "NET_HOST_IP", function () { return $49d40eaf9ca0cfa4$export$fed6ce86f48c84bc; }, function (v) { return $49d40eaf9ca0cfa4$export$fed6ce86f48c84bc = v; });
$parcel$export(module.exports, "NET_HOST_NAME", function () { return $49d40eaf9ca0cfa4$export$500c2675137ac16e; }, function (v) { return $49d40eaf9ca0cfa4$export$500c2675137ac16e = v; });
$parcel$export(module.exports, "NET_HOST_PORT", function () { return $49d40eaf9ca0cfa4$export$402c7728623fd8df; }, function (v) { return $49d40eaf9ca0cfa4$export$402c7728623fd8df = v; });
$parcel$export(module.exports, "NET_PEER_IP", function () { return $49d40eaf9ca0cfa4$export$15417259f4c0fe6b; }, function (v) { return $49d40eaf9ca0cfa4$export$15417259f4c0fe6b = v; });
$parcel$export(module.exports, "NET_PEER_NAME", function () { return $49d40eaf9ca0cfa4$export$2b3b7f579a727f45; }, function (v) { return $49d40eaf9ca0cfa4$export$2b3b7f579a727f45 = v; });
$parcel$export(module.exports, "NET_PEER_PORT", function () { return $49d40eaf9ca0cfa4$export$514832a0b029734b; }, function (v) { return $49d40eaf9ca0cfa4$export$514832a0b029734b = v; });
$parcel$export(module.exports, "NET_PROTOCOL_NAME", function () { return $49d40eaf9ca0cfa4$export$b0522e6a14dec1a4; }, function (v) { return $49d40eaf9ca0cfa4$export$b0522e6a14dec1a4 = v; });
$parcel$export(module.exports, "NET_PROTOCOL_VERSION", function () { return $49d40eaf9ca0cfa4$export$659ea19f71a7ee0b; }, function (v) { return $49d40eaf9ca0cfa4$export$659ea19f71a7ee0b = v; });
$parcel$export(module.exports, "NET_SOCK_FAMILY", function () { return $49d40eaf9ca0cfa4$export$1b61d972db315e73; }, function (v) { return $49d40eaf9ca0cfa4$export$1b61d972db315e73 = v; });
$parcel$export(module.exports, "NET_SOCK_HOST_ADDR", function () { return $49d40eaf9ca0cfa4$export$fb2970ee11a479ee; }, function (v) { return $49d40eaf9ca0cfa4$export$fb2970ee11a479ee = v; });
$parcel$export(module.exports, "NET_SOCK_HOST_PORT", function () { return $49d40eaf9ca0cfa4$export$920aceb2a8fad77e; }, function (v) { return $49d40eaf9ca0cfa4$export$920aceb2a8fad77e = v; });
$parcel$export(module.exports, "NET_SOCK_PEER_ADDR", function () { return $49d40eaf9ca0cfa4$export$48f8f6fbc999d187; }, function (v) { return $49d40eaf9ca0cfa4$export$48f8f6fbc999d187 = v; });
$parcel$export(module.exports, "NET_SOCK_PEER_NAME", function () { return $49d40eaf9ca0cfa4$export$eed590fa00a8223b; }, function (v) { return $49d40eaf9ca0cfa4$export$eed590fa00a8223b = v; });
$parcel$export(module.exports, "NET_SOCK_PEER_PORT", function () { return $49d40eaf9ca0cfa4$export$f2e5bb5cd4a130da; }, function (v) { return $49d40eaf9ca0cfa4$export$f2e5bb5cd4a130da = v; });
$parcel$export(module.exports, "NET_TRANSPORT", function () { return $49d40eaf9ca0cfa4$export$779ef03d633a9086; }, function (v) { return $49d40eaf9ca0cfa4$export$779ef03d633a9086 = v; });
$parcel$export(module.exports, "OS_BUILD", function () { return $49d40eaf9ca0cfa4$export$d98b87c8d53d0dbc; }, function (v) { return $49d40eaf9ca0cfa4$export$d98b87c8d53d0dbc = v; });
$parcel$export(module.exports, "OS_BUILD_ID", function () { return $49d40eaf9ca0cfa4$export$ca719aa57653a0a7; }, function (v) { return $49d40eaf9ca0cfa4$export$ca719aa57653a0a7 = v; });
$parcel$export(module.exports, "OS_DESCRIPTION", function () { return $49d40eaf9ca0cfa4$export$74b19c5f48270c05; }, function (v) { return $49d40eaf9ca0cfa4$export$74b19c5f48270c05 = v; });
$parcel$export(module.exports, "OS_KERNEL_VERSION", function () { return $49d40eaf9ca0cfa4$export$c351affe7e8098cb; }, function (v) { return $49d40eaf9ca0cfa4$export$c351affe7e8098cb = v; });
$parcel$export(module.exports, "OS_NAME", function () { return $49d40eaf9ca0cfa4$export$be7cd6b3ae3ae765; }, function (v) { return $49d40eaf9ca0cfa4$export$be7cd6b3ae3ae765 = v; });
$parcel$export(module.exports, "OS_RAW_DESCRIPTION", function () { return $49d40eaf9ca0cfa4$export$ec182524c4c57275; }, function (v) { return $49d40eaf9ca0cfa4$export$ec182524c4c57275 = v; });
$parcel$export(module.exports, "OS_ROOTED", function () { return $49d40eaf9ca0cfa4$export$9e45758246a85b07; }, function (v) { return $49d40eaf9ca0cfa4$export$9e45758246a85b07 = v; });
$parcel$export(module.exports, "OS_THEME", function () { return $49d40eaf9ca0cfa4$export$9fa5d5f0144954cb; }, function (v) { return $49d40eaf9ca0cfa4$export$9fa5d5f0144954cb = v; });
$parcel$export(module.exports, "OS_TYPE", function () { return $49d40eaf9ca0cfa4$export$e66ba5bc4b978023; }, function (v) { return $49d40eaf9ca0cfa4$export$e66ba5bc4b978023 = v; });
$parcel$export(module.exports, "OS_VERSION", function () { return $49d40eaf9ca0cfa4$export$2306e23cc611a36d; }, function (v) { return $49d40eaf9ca0cfa4$export$2306e23cc611a36d = v; });
$parcel$export(module.exports, "OTEL_KIND", function () { return $49d40eaf9ca0cfa4$export$144f8c1fe01428db; }, function (v) { return $49d40eaf9ca0cfa4$export$144f8c1fe01428db = v; });
$parcel$export(module.exports, "OTEL_SCOPE_NAME", function () { return $49d40eaf9ca0cfa4$export$f303b2744d52121c; }, function (v) { return $49d40eaf9ca0cfa4$export$f303b2744d52121c = v; });
$parcel$export(module.exports, "OTEL_SCOPE_VERSION", function () { return $49d40eaf9ca0cfa4$export$866b2dbc7bf18ce6; }, function (v) { return $49d40eaf9ca0cfa4$export$866b2dbc7bf18ce6 = v; });
$parcel$export(module.exports, "OTEL_STATUS_CODE", function () { return $49d40eaf9ca0cfa4$export$b4c85774878b4841; }, function (v) { return $49d40eaf9ca0cfa4$export$b4c85774878b4841 = v; });
$parcel$export(module.exports, "OTEL_STATUS_DESCRIPTION", function () { return $49d40eaf9ca0cfa4$export$1c967a71bc9a3077; }, function (v) { return $49d40eaf9ca0cfa4$export$1c967a71bc9a3077 = v; });
$parcel$export(module.exports, "PARAMS_KEY", function () { return $49d40eaf9ca0cfa4$export$5e3884a35a19eb90; }, function (v) { return $49d40eaf9ca0cfa4$export$5e3884a35a19eb90 = v; });
$parcel$export(module.exports, "PARAMS_KEY_BASE", function () { return $49d40eaf9ca0cfa4$export$6e7ff99bb3259573; }, function (v) { return $49d40eaf9ca0cfa4$export$6e7ff99bb3259573 = v; });
$parcel$export(module.exports, "PERFORMANCE_ACTIVATIONSTART", function () { return $49d40eaf9ca0cfa4$export$7c932cba2d9e7a7; }, function (v) { return $49d40eaf9ca0cfa4$export$7c932cba2d9e7a7 = v; });
$parcel$export(module.exports, "PERFORMANCE_TIMEORIGIN", function () { return $49d40eaf9ca0cfa4$export$94091942edce0667; }, function (v) { return $49d40eaf9ca0cfa4$export$94091942edce0667 = v; });
$parcel$export(module.exports, "PREVIOUS_ROUTE", function () { return $49d40eaf9ca0cfa4$export$3671a8a524706a9d; }, function (v) { return $49d40eaf9ca0cfa4$export$3671a8a524706a9d = v; });
$parcel$export(module.exports, "PROCESS_COMMAND_ARGS", function () { return $49d40eaf9ca0cfa4$export$c288888dc82d233f; }, function (v) { return $49d40eaf9ca0cfa4$export$c288888dc82d233f = v; });
$parcel$export(module.exports, "PROCESS_EXECUTABLE_NAME", function () { return $49d40eaf9ca0cfa4$export$8ff188536cebc35; }, function (v) { return $49d40eaf9ca0cfa4$export$8ff188536cebc35 = v; });
$parcel$export(module.exports, "PROCESS_PID", function () { return $49d40eaf9ca0cfa4$export$6407d78968c0eabe; }, function (v) { return $49d40eaf9ca0cfa4$export$6407d78968c0eabe = v; });
$parcel$export(module.exports, "PROCESS_RUNTIME_DESCRIPTION", function () { return $49d40eaf9ca0cfa4$export$43e9fb9ec28d9743; }, function (v) { return $49d40eaf9ca0cfa4$export$43e9fb9ec28d9743 = v; });
$parcel$export(module.exports, "PROCESS_RUNTIME_ENGINE_NAME", function () { return $49d40eaf9ca0cfa4$export$26f31d5c5c201739; }, function (v) { return $49d40eaf9ca0cfa4$export$26f31d5c5c201739 = v; });
$parcel$export(module.exports, "PROCESS_RUNTIME_ENGINE_VERSION", function () { return $49d40eaf9ca0cfa4$export$bff85124d2d35b93; }, function (v) { return $49d40eaf9ca0cfa4$export$bff85124d2d35b93 = v; });
$parcel$export(module.exports, "PROCESS_RUNTIME_NAME", function () { return $49d40eaf9ca0cfa4$export$495c671ed5a6408c; }, function (v) { return $49d40eaf9ca0cfa4$export$495c671ed5a6408c = v; });
$parcel$export(module.exports, "PROCESS_RUNTIME_VERSION", function () { return $49d40eaf9ca0cfa4$export$54b3d4d5548c35c3; }, function (v) { return $49d40eaf9ca0cfa4$export$54b3d4d5548c35c3 = v; });
$parcel$export(module.exports, "QUERY_KEY", function () { return $49d40eaf9ca0cfa4$export$2954db6444fe1fa8; }, function (v) { return $49d40eaf9ca0cfa4$export$2954db6444fe1fa8 = v; });
$parcel$export(module.exports, "QUERY_KEY_BASE", function () { return $49d40eaf9ca0cfa4$export$15c1c974d16dd678; }, function (v) { return $49d40eaf9ca0cfa4$export$15c1c974d16dd678 = v; });
$parcel$export(module.exports, "REACT_VERSION", function () { return $49d40eaf9ca0cfa4$export$9be2ae89a1eac217; }, function (v) { return $49d40eaf9ca0cfa4$export$9be2ae89a1eac217 = v; });
$parcel$export(module.exports, "RELEASE", function () { return $49d40eaf9ca0cfa4$export$5c698591c0e586a2; }, function (v) { return $49d40eaf9ca0cfa4$export$5c698591c0e586a2 = v; });
$parcel$export(module.exports, "REMIX_ACTION_FORM_DATA_KEY", function () { return $49d40eaf9ca0cfa4$export$b711f2bb9c9a848a; }, function (v) { return $49d40eaf9ca0cfa4$export$b711f2bb9c9a848a = v; });
$parcel$export(module.exports, "REMIX_ACTION_FORM_DATA_KEY_BASE", function () { return $49d40eaf9ca0cfa4$export$1d3a8501efd30213; }, function (v) { return $49d40eaf9ca0cfa4$export$1d3a8501efd30213 = v; });
$parcel$export(module.exports, "REPLAY_ID", function () { return $49d40eaf9ca0cfa4$export$cebaf684ced5a2c9; }, function (v) { return $49d40eaf9ca0cfa4$export$cebaf684ced5a2c9 = v; });
$parcel$export(module.exports, "RESOURCE_DEPLOYMENT_ENVIRONMENT", function () { return $49d40eaf9ca0cfa4$export$d4c658ecdcb7c78c; }, function (v) { return $49d40eaf9ca0cfa4$export$d4c658ecdcb7c78c = v; });
$parcel$export(module.exports, "RESOURCE_DEPLOYMENT_ENVIRONMENT_NAME", function () { return $49d40eaf9ca0cfa4$export$b1b162b01baeb044; }, function (v) { return $49d40eaf9ca0cfa4$export$b1b162b01baeb044 = v; });
$parcel$export(module.exports, "RESOURCE_RENDER_BLOCKING_STATUS", function () { return $49d40eaf9ca0cfa4$export$8be2d593d7f88ed8; }, function (v) { return $49d40eaf9ca0cfa4$export$8be2d593d7f88ed8 = v; });
$parcel$export(module.exports, "ROUTE", function () { return $49d40eaf9ca0cfa4$export$dbd0a3528a97ccc0; }, function (v) { return $49d40eaf9ca0cfa4$export$dbd0a3528a97ccc0 = v; });
$parcel$export(module.exports, "RPC_GRPC_STATUS_CODE", function () { return $49d40eaf9ca0cfa4$export$66581dc6d3d083d1; }, function (v) { return $49d40eaf9ca0cfa4$export$66581dc6d3d083d1 = v; });
$parcel$export(module.exports, "RPC_METHOD", function () { return $49d40eaf9ca0cfa4$export$e545f99e7abcc499; }, function (v) { return $49d40eaf9ca0cfa4$export$e545f99e7abcc499 = v; });
$parcel$export(module.exports, "RPC_RESPONSE_STATUS_CODE", function () { return $49d40eaf9ca0cfa4$export$7e1af5787f8c4aaa; }, function (v) { return $49d40eaf9ca0cfa4$export$7e1af5787f8c4aaa = v; });
$parcel$export(module.exports, "RPC_SERVICE", function () { return $49d40eaf9ca0cfa4$export$186c94c351c54768; }, function (v) { return $49d40eaf9ca0cfa4$export$186c94c351c54768 = v; });
$parcel$export(module.exports, "RPC_SYSTEM", function () { return $49d40eaf9ca0cfa4$export$2e3fd8dfcb16fe0c; }, function (v) { return $49d40eaf9ca0cfa4$export$2e3fd8dfcb16fe0c = v; });
$parcel$export(module.exports, "RPC_SYSTEM_NAME", function () { return $49d40eaf9ca0cfa4$export$7eeeceaa1dbd7cd5; }, function (v) { return $49d40eaf9ca0cfa4$export$7eeeceaa1dbd7cd5 = v; });
$parcel$export(module.exports, "RUNTIME_BUILD", function () { return $49d40eaf9ca0cfa4$export$9d5bffdff936d554; }, function (v) { return $49d40eaf9ca0cfa4$export$9d5bffdff936d554 = v; });
$parcel$export(module.exports, "RUNTIME_NAME", function () { return $49d40eaf9ca0cfa4$export$dc3a801c9a2c5b79; }, function (v) { return $49d40eaf9ca0cfa4$export$dc3a801c9a2c5b79 = v; });
$parcel$export(module.exports, "RUNTIME_RAW_DESCRIPTION", function () { return $49d40eaf9ca0cfa4$export$27933a9557f87e98; }, function (v) { return $49d40eaf9ca0cfa4$export$27933a9557f87e98 = v; });
$parcel$export(module.exports, "RUNTIME_VERSION", function () { return $49d40eaf9ca0cfa4$export$eefa737b40a0d535; }, function (v) { return $49d40eaf9ca0cfa4$export$eefa737b40a0d535 = v; });
$parcel$export(module.exports, "SCORE_KEY", function () { return $49d40eaf9ca0cfa4$export$92740ffbcb02553b; }, function (v) { return $49d40eaf9ca0cfa4$export$92740ffbcb02553b = v; });
$parcel$export(module.exports, "SCORE_KEY_BASE", function () { return $49d40eaf9ca0cfa4$export$500e89753f9f1008; }, function (v) { return $49d40eaf9ca0cfa4$export$500e89753f9f1008 = v; });
$parcel$export(module.exports, "SCORE_RATIO_KEY", function () { return $49d40eaf9ca0cfa4$export$d91a18e47fdddefd; }, function (v) { return $49d40eaf9ca0cfa4$export$d91a18e47fdddefd = v; });
$parcel$export(module.exports, "SCORE_RATIO_KEY_BASE", function () { return $49d40eaf9ca0cfa4$export$eccbe6f20884ea7f; }, function (v) { return $49d40eaf9ca0cfa4$export$eccbe6f20884ea7f = v; });
$parcel$export(module.exports, "SCORE_TOTAL", function () { return $49d40eaf9ca0cfa4$export$9e24f11d79141afb; }, function (v) { return $49d40eaf9ca0cfa4$export$9e24f11d79141afb = v; });
$parcel$export(module.exports, "SCORE_WEIGHT_KEY", function () { return $49d40eaf9ca0cfa4$export$f0b96ad9586f8887; }, function (v) { return $49d40eaf9ca0cfa4$export$f0b96ad9586f8887 = v; });
$parcel$export(module.exports, "SCORE_WEIGHT_KEY_BASE", function () { return $49d40eaf9ca0cfa4$export$8a92ed5d436a85c6; }, function (v) { return $49d40eaf9ca0cfa4$export$8a92ed5d436a85c6 = v; });
$parcel$export(module.exports, "SENTRY_ACTION", function () { return $49d40eaf9ca0cfa4$export$edd59acdf7e86a71; }, function (v) { return $49d40eaf9ca0cfa4$export$edd59acdf7e86a71 = v; });
$parcel$export(module.exports, "SENTRY_BROWSER_NAME", function () { return $49d40eaf9ca0cfa4$export$ae81a1ae71952d50; }, function (v) { return $49d40eaf9ca0cfa4$export$ae81a1ae71952d50 = v; });
$parcel$export(module.exports, "SENTRY_BROWSER_VERSION", function () { return $49d40eaf9ca0cfa4$export$6101470cd57eac1b; }, function (v) { return $49d40eaf9ca0cfa4$export$6101470cd57eac1b = v; });
$parcel$export(module.exports, "SENTRY_CANCELLATION_REASON", function () { return $49d40eaf9ca0cfa4$export$452c0aee9673fe67; }, function (v) { return $49d40eaf9ca0cfa4$export$452c0aee9673fe67 = v; });
$parcel$export(module.exports, "SENTRY_CATEGORY", function () { return $49d40eaf9ca0cfa4$export$773dddd1e8667756; }, function (v) { return $49d40eaf9ca0cfa4$export$773dddd1e8667756 = v; });
$parcel$export(module.exports, "SENTRY_CLIENT_SAMPLE_RATE", function () { return $49d40eaf9ca0cfa4$export$98815f8579a64a90; }, function (v) { return $49d40eaf9ca0cfa4$export$98815f8579a64a90 = v; });
$parcel$export(module.exports, "SENTRY_DESCRIPTION", function () { return $49d40eaf9ca0cfa4$export$7bc4e27428665019; }, function (v) { return $49d40eaf9ca0cfa4$export$7bc4e27428665019 = v; });
$parcel$export(module.exports, "SENTRY_DIST", function () { return $49d40eaf9ca0cfa4$export$e7d7477fa9057ee2; }, function (v) { return $49d40eaf9ca0cfa4$export$e7d7477fa9057ee2 = v; });
$parcel$export(module.exports, "SENTRY_DOMAIN", function () { return $49d40eaf9ca0cfa4$export$1f4267a3fc018448; }, function (v) { return $49d40eaf9ca0cfa4$export$1f4267a3fc018448 = v; });
$parcel$export(module.exports, "SENTRY_DSC_ENVIRONMENT", function () { return $49d40eaf9ca0cfa4$export$c171cae150389952; }, function (v) { return $49d40eaf9ca0cfa4$export$c171cae150389952 = v; });
$parcel$export(module.exports, "SENTRY_DSC_PROJECT_ID", function () { return $49d40eaf9ca0cfa4$export$d9bb35e957b22c72; }, function (v) { return $49d40eaf9ca0cfa4$export$d9bb35e957b22c72 = v; });
$parcel$export(module.exports, "SENTRY_DSC_PUBLIC_KEY", function () { return $49d40eaf9ca0cfa4$export$b3508a2c95f74e3d; }, function (v) { return $49d40eaf9ca0cfa4$export$b3508a2c95f74e3d = v; });
$parcel$export(module.exports, "SENTRY_DSC_RELEASE", function () { return $49d40eaf9ca0cfa4$export$20bb272f4d21532d; }, function (v) { return $49d40eaf9ca0cfa4$export$20bb272f4d21532d = v; });
$parcel$export(module.exports, "SENTRY_DSC_SAMPLED", function () { return $49d40eaf9ca0cfa4$export$d7e64fbd0102ce90; }, function (v) { return $49d40eaf9ca0cfa4$export$d7e64fbd0102ce90 = v; });
$parcel$export(module.exports, "SENTRY_DSC_SAMPLE_RATE", function () { return $49d40eaf9ca0cfa4$export$c17eae7e86dbba3c; }, function (v) { return $49d40eaf9ca0cfa4$export$c17eae7e86dbba3c = v; });
$parcel$export(module.exports, "SENTRY_DSC_TRACE_ID", function () { return $49d40eaf9ca0cfa4$export$349603c0a9165744; }, function (v) { return $49d40eaf9ca0cfa4$export$349603c0a9165744 = v; });
$parcel$export(module.exports, "SENTRY_DSC_TRANSACTION", function () { return $49d40eaf9ca0cfa4$export$4dadf693741f0283; }, function (v) { return $49d40eaf9ca0cfa4$export$4dadf693741f0283 = v; });
$parcel$export(module.exports, "SENTRY_ENVIRONMENT", function () { return $49d40eaf9ca0cfa4$export$6377864d12f7eeb3; }, function (v) { return $49d40eaf9ca0cfa4$export$6377864d12f7eeb3 = v; });
$parcel$export(module.exports, "SENTRY_EXCLUSIVE_TIME", function () { return $49d40eaf9ca0cfa4$export$ba081af9585ed4; }, function (v) { return $49d40eaf9ca0cfa4$export$ba081af9585ed4 = v; });
$parcel$export(module.exports, "SENTRY_GRAPHQL_OPERATION", function () { return $49d40eaf9ca0cfa4$export$7841dacb241485d0; }, function (v) { return $49d40eaf9ca0cfa4$export$7841dacb241485d0 = v; });
$parcel$export(module.exports, "SENTRY_GROUP", function () { return $49d40eaf9ca0cfa4$export$52c7044cf6301362; }, function (v) { return $49d40eaf9ca0cfa4$export$52c7044cf6301362 = v; });
$parcel$export(module.exports, "SENTRY_HTTP_PREFETCH", function () { return $49d40eaf9ca0cfa4$export$56ea1c9e44590e20; }, function (v) { return $49d40eaf9ca0cfa4$export$56ea1c9e44590e20 = v; });
$parcel$export(module.exports, "SENTRY_IDLE_SPAN_FINISH_REASON", function () { return $49d40eaf9ca0cfa4$export$7626e389d05f4c36; }, function (v) { return $49d40eaf9ca0cfa4$export$7626e389d05f4c36 = v; });
$parcel$export(module.exports, "SENTRY_IS_REMOTE", function () { return $49d40eaf9ca0cfa4$export$5e0a48187329b2e7; }, function (v) { return $49d40eaf9ca0cfa4$export$5e0a48187329b2e7 = v; });
$parcel$export(module.exports, "SENTRY_KIND", function () { return $49d40eaf9ca0cfa4$export$c322b150d7667841; }, function (v) { return $49d40eaf9ca0cfa4$export$c322b150d7667841 = v; });
$parcel$export(module.exports, "SENTRY_MAIN_THREAD", function () { return $49d40eaf9ca0cfa4$export$4a4797d3c962f753; }, function (v) { return $49d40eaf9ca0cfa4$export$4a4797d3c962f753 = v; });
$parcel$export(module.exports, "SENTRY_MESSAGE_PARAMETER_KEY", function () { return $49d40eaf9ca0cfa4$export$767524d5e72e2645; }, function (v) { return $49d40eaf9ca0cfa4$export$767524d5e72e2645 = v; });
$parcel$export(module.exports, "SENTRY_MESSAGE_TEMPLATE", function () { return $49d40eaf9ca0cfa4$export$497354ca7b0ee666; }, function (v) { return $49d40eaf9ca0cfa4$export$497354ca7b0ee666 = v; });
$parcel$export(module.exports, "SENTRY_METRIC_SOURCE", function () { return $49d40eaf9ca0cfa4$export$cbdc4ad11118116a; }, function (v) { return $49d40eaf9ca0cfa4$export$cbdc4ad11118116a = v; });
$parcel$export(module.exports, "SENTRY_MOBILE", function () { return $49d40eaf9ca0cfa4$export$5b890de778c4c2fe; }, function (v) { return $49d40eaf9ca0cfa4$export$5b890de778c4c2fe = v; });
$parcel$export(module.exports, "SENTRY_MODULE_KEY", function () { return $49d40eaf9ca0cfa4$export$a78d9803b5e0a83e; }, function (v) { return $49d40eaf9ca0cfa4$export$a78d9803b5e0a83e = v; });
$parcel$export(module.exports, "SENTRY_MODULE_KEY_BASE", function () { return $49d40eaf9ca0cfa4$export$df1b536467b3992a; }, function (v) { return $49d40eaf9ca0cfa4$export$df1b536467b3992a = v; });
$parcel$export(module.exports, "SENTRY_NEXTJS_SSR_FUNCTION_ROUTE", function () { return $49d40eaf9ca0cfa4$export$73104a329e205998; }, function (v) { return $49d40eaf9ca0cfa4$export$73104a329e205998 = v; });
$parcel$export(module.exports, "SENTRY_NEXTJS_SSR_FUNCTION_TYPE", function () { return $49d40eaf9ca0cfa4$export$5740e3da55330b0a; }, function (v) { return $49d40eaf9ca0cfa4$export$5740e3da55330b0a = v; });
$parcel$export(module.exports, "SENTRY_NORMALIZED_DB_QUERY", function () { return $49d40eaf9ca0cfa4$export$8dcc2d92ff6d65da; }, function (v) { return $49d40eaf9ca0cfa4$export$8dcc2d92ff6d65da = v; });
$parcel$export(module.exports, "SENTRY_NORMALIZED_DB_QUERY_HASH", function () { return $49d40eaf9ca0cfa4$export$e5f1321e53e24810; }, function (v) { return $49d40eaf9ca0cfa4$export$e5f1321e53e24810 = v; });
$parcel$export(module.exports, "SENTRY_NORMALIZED_DESCRIPTION", function () { return $49d40eaf9ca0cfa4$export$56dd3098cbca7c8a; }, function (v) { return $49d40eaf9ca0cfa4$export$56dd3098cbca7c8a = v; });
$parcel$export(module.exports, "SENTRY_OBSERVED_TIMESTAMP_NANOS", function () { return $49d40eaf9ca0cfa4$export$aa7aff70e4380665; }, function (v) { return $49d40eaf9ca0cfa4$export$aa7aff70e4380665 = v; });
$parcel$export(module.exports, "SENTRY_OP", function () { return $49d40eaf9ca0cfa4$export$dacb7d452aa6bcaf; }, function (v) { return $49d40eaf9ca0cfa4$export$dacb7d452aa6bcaf = v; });
$parcel$export(module.exports, "SENTRY_ORIGIN", function () { return $49d40eaf9ca0cfa4$export$15dfc6c5e8f9baf6; }, function (v) { return $49d40eaf9ca0cfa4$export$15dfc6c5e8f9baf6 = v; });
$parcel$export(module.exports, "SENTRY_PLATFORM", function () { return $49d40eaf9ca0cfa4$export$91ad03bba7909fb5; }, function (v) { return $49d40eaf9ca0cfa4$export$91ad03bba7909fb5 = v; });
$parcel$export(module.exports, "SENTRY_PROFILER_ID", function () { return $49d40eaf9ca0cfa4$export$86128e6c0ab71d64; }, function (v) { return $49d40eaf9ca0cfa4$export$86128e6c0ab71d64 = v; });
$parcel$export(module.exports, "SENTRY_PROFILE_ID", function () { return $49d40eaf9ca0cfa4$export$745b60c4819aec1d; }, function (v) { return $49d40eaf9ca0cfa4$export$745b60c4819aec1d = v; });
$parcel$export(module.exports, "SENTRY_RELEASE", function () { return $49d40eaf9ca0cfa4$export$d2c893bfac1da9a1; }, function (v) { return $49d40eaf9ca0cfa4$export$d2c893bfac1da9a1 = v; });
$parcel$export(module.exports, "SENTRY_REPLAY_ID", function () { return $49d40eaf9ca0cfa4$export$1c14ad02f9534b19; }, function (v) { return $49d40eaf9ca0cfa4$export$1c14ad02f9534b19 = v; });
$parcel$export(module.exports, "SENTRY_REPLAY_IS_BUFFERING", function () { return $49d40eaf9ca0cfa4$export$db3cb63e0594d014; }, function (v) { return $49d40eaf9ca0cfa4$export$db3cb63e0594d014 = v; });
$parcel$export(module.exports, "SENTRY_REPORT_EVENT", function () { return $49d40eaf9ca0cfa4$export$a65c9a0eba2c222d; }, function (v) { return $49d40eaf9ca0cfa4$export$a65c9a0eba2c222d = v; });
$parcel$export(module.exports, "SENTRY_SDK_INTEGRATIONS", function () { return $49d40eaf9ca0cfa4$export$68dbcca9c0e339ec; }, function (v) { return $49d40eaf9ca0cfa4$export$68dbcca9c0e339ec = v; });
$parcel$export(module.exports, "SENTRY_SDK_NAME", function () { return $49d40eaf9ca0cfa4$export$d59b669d4bb3f006; }, function (v) { return $49d40eaf9ca0cfa4$export$d59b669d4bb3f006 = v; });
$parcel$export(module.exports, "SENTRY_SDK_VERSION", function () { return $49d40eaf9ca0cfa4$export$4d88d347aa9667fc; }, function (v) { return $49d40eaf9ca0cfa4$export$4d88d347aa9667fc = v; });
$parcel$export(module.exports, "SENTRY_SEGMENT_ID", function () { return $49d40eaf9ca0cfa4$export$9943ffdcaa4bc506; }, function (v) { return $49d40eaf9ca0cfa4$export$9943ffdcaa4bc506 = v; });
$parcel$export(module.exports, "SENTRY_SEGMENT_NAME", function () { return $49d40eaf9ca0cfa4$export$d4f25b923533dbba; }, function (v) { return $49d40eaf9ca0cfa4$export$d4f25b923533dbba = v; });
$parcel$export(module.exports, "SENTRY_SERVER_SAMPLE_RATE", function () { return $49d40eaf9ca0cfa4$export$35f3396a1cdeea45; }, function (v) { return $49d40eaf9ca0cfa4$export$35f3396a1cdeea45 = v; });
$parcel$export(module.exports, "SENTRY_SOURCE", function () { return $49d40eaf9ca0cfa4$export$80e399da474bc98d; }, function (v) { return $49d40eaf9ca0cfa4$export$80e399da474bc98d = v; });
$parcel$export(module.exports, "SENTRY_SPAN_SOURCE", function () { return $49d40eaf9ca0cfa4$export$e01809e2dbceac35; }, function (v) { return $49d40eaf9ca0cfa4$export$e01809e2dbceac35 = v; });
$parcel$export(module.exports, "SENTRY_STATUS", function () { return $49d40eaf9ca0cfa4$export$41900d5c4e8a9c68; }, function (v) { return $49d40eaf9ca0cfa4$export$41900d5c4e8a9c68 = v; });
$parcel$export(module.exports, "SENTRY_STATUS_CODE", function () { return $49d40eaf9ca0cfa4$export$362bb1cb0bb5ca03; }, function (v) { return $49d40eaf9ca0cfa4$export$362bb1cb0bb5ca03 = v; });
$parcel$export(module.exports, "SENTRY_STATUS_MESSAGE", function () { return $49d40eaf9ca0cfa4$export$6803ac54f919d9cc; }, function (v) { return $49d40eaf9ca0cfa4$export$6803ac54f919d9cc = v; });
$parcel$export(module.exports, "SENTRY_SVELTEKIT_NAVIGATION_FROM", function () { return $49d40eaf9ca0cfa4$export$72f5b47540331169; }, function (v) { return $49d40eaf9ca0cfa4$export$72f5b47540331169 = v; });
$parcel$export(module.exports, "SENTRY_SVELTEKIT_NAVIGATION_TO", function () { return $49d40eaf9ca0cfa4$export$6c61a8c9aa5305cb; }, function (v) { return $49d40eaf9ca0cfa4$export$6c61a8c9aa5305cb = v; });
$parcel$export(module.exports, "SENTRY_SVELTEKIT_NAVIGATION_TYPE", function () { return $49d40eaf9ca0cfa4$export$6b5244c457b68e65; }, function (v) { return $49d40eaf9ca0cfa4$export$6b5244c457b68e65 = v; });
$parcel$export(module.exports, "SENTRY_THREAD_ID", function () { return $49d40eaf9ca0cfa4$export$b7bd0c9a886f3414; }, function (v) { return $49d40eaf9ca0cfa4$export$b7bd0c9a886f3414 = v; });
$parcel$export(module.exports, "SENTRY_TIMESTAMP_SEQUENCE", function () { return $49d40eaf9ca0cfa4$export$6b77f2bacac7c93d; }, function (v) { return $49d40eaf9ca0cfa4$export$6b77f2bacac7c93d = v; });
$parcel$export(module.exports, "SENTRY_TRACE_LIFECYCLE", function () { return $49d40eaf9ca0cfa4$export$ddbc15c0e8e8a7ea; }, function (v) { return $49d40eaf9ca0cfa4$export$ddbc15c0e8e8a7ea = v; });
$parcel$export(module.exports, "SENTRY_TRACE_PARENT_SPAN_ID", function () { return $49d40eaf9ca0cfa4$export$feb4fe753df28a82; }, function (v) { return $49d40eaf9ca0cfa4$export$feb4fe753df28a82 = v; });
$parcel$export(module.exports, "SENTRY_TRACE_STATUS", function () { return $49d40eaf9ca0cfa4$export$d6267756132e2175; }, function (v) { return $49d40eaf9ca0cfa4$export$d6267756132e2175 = v; });
$parcel$export(module.exports, "SENTRY_TRANSACTION", function () { return $49d40eaf9ca0cfa4$export$570ac5a3fd7e6cc6; }, function (v) { return $49d40eaf9ca0cfa4$export$570ac5a3fd7e6cc6 = v; });
$parcel$export(module.exports, "SENTRY_USER_EMAIL", function () { return $49d40eaf9ca0cfa4$export$5b9a0015e1c530ed; }, function (v) { return $49d40eaf9ca0cfa4$export$5b9a0015e1c530ed = v; });
$parcel$export(module.exports, "SENTRY_USER_GEO_CITY", function () { return $49d40eaf9ca0cfa4$export$8bbff71c84508218; }, function (v) { return $49d40eaf9ca0cfa4$export$8bbff71c84508218 = v; });
$parcel$export(module.exports, "SENTRY_USER_GEO_COUNTRY_CODE", function () { return $49d40eaf9ca0cfa4$export$b55aa07a514a2430; }, function (v) { return $49d40eaf9ca0cfa4$export$b55aa07a514a2430 = v; });
$parcel$export(module.exports, "SENTRY_USER_GEO_REGION", function () { return $49d40eaf9ca0cfa4$export$9927ad09f7c084dc; }, function (v) { return $49d40eaf9ca0cfa4$export$9927ad09f7c084dc = v; });
$parcel$export(module.exports, "SENTRY_USER_GEO_SUBDIVISION", function () { return $49d40eaf9ca0cfa4$export$52a07a35ff8ec6b6; }, function (v) { return $49d40eaf9ca0cfa4$export$52a07a35ff8ec6b6 = v; });
$parcel$export(module.exports, "SENTRY_USER_ID", function () { return $49d40eaf9ca0cfa4$export$a10d277c42e6cae3; }, function (v) { return $49d40eaf9ca0cfa4$export$a10d277c42e6cae3 = v; });
$parcel$export(module.exports, "SENTRY_USER_IP", function () { return $49d40eaf9ca0cfa4$export$cdc0ce5c66182801; }, function (v) { return $49d40eaf9ca0cfa4$export$cdc0ce5c66182801 = v; });
$parcel$export(module.exports, "SENTRY_USER_USERNAME", function () { return $49d40eaf9ca0cfa4$export$2504d4bd698dd962; }, function (v) { return $49d40eaf9ca0cfa4$export$2504d4bd698dd962 = v; });
$parcel$export(module.exports, "SERVER_ADDRESS", function () { return $49d40eaf9ca0cfa4$export$9dc86f3b876e96ef; }, function (v) { return $49d40eaf9ca0cfa4$export$9dc86f3b876e96ef = v; });
$parcel$export(module.exports, "SERVER_NAME", function () { return $49d40eaf9ca0cfa4$export$70ff7865f52549ae; }, function (v) { return $49d40eaf9ca0cfa4$export$70ff7865f52549ae = v; });
$parcel$export(module.exports, "SERVER_PORT", function () { return $49d40eaf9ca0cfa4$export$f77b53a42be6e6fd; }, function (v) { return $49d40eaf9ca0cfa4$export$f77b53a42be6e6fd = v; });
$parcel$export(module.exports, "SERVICE_NAME", function () { return $49d40eaf9ca0cfa4$export$818eb7ab11414506; }, function (v) { return $49d40eaf9ca0cfa4$export$818eb7ab11414506 = v; });
$parcel$export(module.exports, "SERVICE_VERSION", function () { return $49d40eaf9ca0cfa4$export$829ef6b2e59d984d; }, function (v) { return $49d40eaf9ca0cfa4$export$829ef6b2e59d984d = v; });
$parcel$export(module.exports, "SESSION_ID", function () { return $49d40eaf9ca0cfa4$export$b30f4cb52c088a26; }, function (v) { return $49d40eaf9ca0cfa4$export$b30f4cb52c088a26 = v; });
$parcel$export(module.exports, "STALL_PERCENTAGE", function () { return $49d40eaf9ca0cfa4$export$335eace0ff1771cd; }, function (v) { return $49d40eaf9ca0cfa4$export$335eace0ff1771cd = v; });
$parcel$export(module.exports, "STALL_TOTAL_TIME", function () { return $49d40eaf9ca0cfa4$export$374d88a2025416ac; }, function (v) { return $49d40eaf9ca0cfa4$export$374d88a2025416ac = v; });
$parcel$export(module.exports, "STATE_TYPE", function () { return $49d40eaf9ca0cfa4$export$bb7a91303551eb37; }, function (v) { return $49d40eaf9ca0cfa4$export$bb7a91303551eb37 = v; });
$parcel$export(module.exports, "THREAD_ID", function () { return $49d40eaf9ca0cfa4$export$f132ea291a7db56b; }, function (v) { return $49d40eaf9ca0cfa4$export$f132ea291a7db56b = v; });
$parcel$export(module.exports, "THREAD_NAME", function () { return $49d40eaf9ca0cfa4$export$f0abd4170bbd2468; }, function (v) { return $49d40eaf9ca0cfa4$export$f0abd4170bbd2468 = v; });
$parcel$export(module.exports, "TIMBER_TAG", function () { return $49d40eaf9ca0cfa4$export$50d00a157dc08581; }, function (v) { return $49d40eaf9ca0cfa4$export$50d00a157dc08581 = v; });
$parcel$export(module.exports, "TIME_TO_FULL_DISPLAY", function () { return $49d40eaf9ca0cfa4$export$484576567a98833f; }, function (v) { return $49d40eaf9ca0cfa4$export$484576567a98833f = v; });
$parcel$export(module.exports, "TIME_TO_INITIAL_DISPLAY", function () { return $49d40eaf9ca0cfa4$export$ec9e491e475d0c97; }, function (v) { return $49d40eaf9ca0cfa4$export$ec9e491e475d0c97 = v; });
$parcel$export(module.exports, "TRANSACTION", function () { return $49d40eaf9ca0cfa4$export$a86c59c10992220f; }, function (v) { return $49d40eaf9ca0cfa4$export$a86c59c10992220f = v; });
$parcel$export(module.exports, "TRPC_PROCEDURE_PATH", function () { return $49d40eaf9ca0cfa4$export$e12f06597e992fde; }, function (v) { return $49d40eaf9ca0cfa4$export$e12f06597e992fde = v; });
$parcel$export(module.exports, "TRPC_PROCEDURE_TYPE", function () { return $49d40eaf9ca0cfa4$export$7ec54678ba28ea59; }, function (v) { return $49d40eaf9ca0cfa4$export$7ec54678ba28ea59 = v; });
$parcel$export(module.exports, "TTFB", function () { return $49d40eaf9ca0cfa4$export$433ba14c16717110; }, function (v) { return $49d40eaf9ca0cfa4$export$433ba14c16717110 = v; });
$parcel$export(module.exports, "TTFB_REQUESTTIME", function () { return $49d40eaf9ca0cfa4$export$309ee349b8a537f; }, function (v) { return $49d40eaf9ca0cfa4$export$309ee349b8a537f = v; });
$parcel$export(module.exports, "TYPE", function () { return $49d40eaf9ca0cfa4$export$b87f371cbc396fcf; }, function (v) { return $49d40eaf9ca0cfa4$export$b87f371cbc396fcf = v; });
$parcel$export(module.exports, "UI_COMPONENT_NAME", function () { return $49d40eaf9ca0cfa4$export$60050fc49fe0e7e2; }, function (v) { return $49d40eaf9ca0cfa4$export$60050fc49fe0e7e2 = v; });
$parcel$export(module.exports, "UI_CONTRIBUTES_TO_TTFD", function () { return $49d40eaf9ca0cfa4$export$348c8e2b37f276cd; }, function (v) { return $49d40eaf9ca0cfa4$export$348c8e2b37f276cd = v; });
$parcel$export(module.exports, "UI_CONTRIBUTES_TO_TTID", function () { return $49d40eaf9ca0cfa4$export$7f47e8a8b2d97cb2; }, function (v) { return $49d40eaf9ca0cfa4$export$7f47e8a8b2d97cb2 = v; });
$parcel$export(module.exports, "UI_ELEMENT_HEIGHT", function () { return $49d40eaf9ca0cfa4$export$50d5adc4b543ce95; }, function (v) { return $49d40eaf9ca0cfa4$export$50d5adc4b543ce95 = v; });
$parcel$export(module.exports, "UI_ELEMENT_ID", function () { return $49d40eaf9ca0cfa4$export$9221f1d2c934d9f; }, function (v) { return $49d40eaf9ca0cfa4$export$9221f1d2c934d9f = v; });
$parcel$export(module.exports, "UI_ELEMENT_IDENTIFIER", function () { return $49d40eaf9ca0cfa4$export$3a56578b3ae09a02; }, function (v) { return $49d40eaf9ca0cfa4$export$3a56578b3ae09a02 = v; });
$parcel$export(module.exports, "UI_ELEMENT_LOAD_TIME", function () { return $49d40eaf9ca0cfa4$export$e47b8dab9466c895; }, function (v) { return $49d40eaf9ca0cfa4$export$e47b8dab9466c895 = v; });
$parcel$export(module.exports, "UI_ELEMENT_PAINT_TYPE", function () { return $49d40eaf9ca0cfa4$export$4ca52f75cf4889c5; }, function (v) { return $49d40eaf9ca0cfa4$export$4ca52f75cf4889c5 = v; });
$parcel$export(module.exports, "UI_ELEMENT_RENDER_TIME", function () { return $49d40eaf9ca0cfa4$export$7343d7d72195067f; }, function (v) { return $49d40eaf9ca0cfa4$export$7343d7d72195067f = v; });
$parcel$export(module.exports, "UI_ELEMENT_TYPE", function () { return $49d40eaf9ca0cfa4$export$f334f32f8d4d8063; }, function (v) { return $49d40eaf9ca0cfa4$export$f334f32f8d4d8063 = v; });
$parcel$export(module.exports, "UI_ELEMENT_URL", function () { return $49d40eaf9ca0cfa4$export$c7bf2089e89a217c; }, function (v) { return $49d40eaf9ca0cfa4$export$c7bf2089e89a217c = v; });
$parcel$export(module.exports, "UI_ELEMENT_WIDTH", function () { return $49d40eaf9ca0cfa4$export$f514f97553a434b2; }, function (v) { return $49d40eaf9ca0cfa4$export$f514f97553a434b2 = v; });
$parcel$export(module.exports, "URL", function () { return $49d40eaf9ca0cfa4$export$61abde59b50deb8e; }, function (v) { return $49d40eaf9ca0cfa4$export$61abde59b50deb8e = v; });
$parcel$export(module.exports, "URL_DOMAIN", function () { return $49d40eaf9ca0cfa4$export$5a5ce44f9fb51f93; }, function (v) { return $49d40eaf9ca0cfa4$export$5a5ce44f9fb51f93 = v; });
$parcel$export(module.exports, "URL_FRAGMENT", function () { return $49d40eaf9ca0cfa4$export$7044ea8d89b6f59d; }, function (v) { return $49d40eaf9ca0cfa4$export$7044ea8d89b6f59d = v; });
$parcel$export(module.exports, "URL_FULL", function () { return $49d40eaf9ca0cfa4$export$40eacf1a072c9dbd; }, function (v) { return $49d40eaf9ca0cfa4$export$40eacf1a072c9dbd = v; });
$parcel$export(module.exports, "URL_PATH", function () { return $49d40eaf9ca0cfa4$export$4c1fa0ac0eff2ac; }, function (v) { return $49d40eaf9ca0cfa4$export$4c1fa0ac0eff2ac = v; });
$parcel$export(module.exports, "URL_PATH_PARAMETER_KEY", function () { return $49d40eaf9ca0cfa4$export$5bee9450fe31dde1; }, function (v) { return $49d40eaf9ca0cfa4$export$5bee9450fe31dde1 = v; });
$parcel$export(module.exports, "URL_PATH_PARAMETER_KEY_BASE", function () { return $49d40eaf9ca0cfa4$export$d0b571fb4406d953; }, function (v) { return $49d40eaf9ca0cfa4$export$d0b571fb4406d953 = v; });
$parcel$export(module.exports, "URL_PORT", function () { return $49d40eaf9ca0cfa4$export$258b370e6c2b85d5; }, function (v) { return $49d40eaf9ca0cfa4$export$258b370e6c2b85d5 = v; });
$parcel$export(module.exports, "URL_QUERY", function () { return $49d40eaf9ca0cfa4$export$dc5e5523da291a4b; }, function (v) { return $49d40eaf9ca0cfa4$export$dc5e5523da291a4b = v; });
$parcel$export(module.exports, "URL_SAME_ORIGIN", function () { return $49d40eaf9ca0cfa4$export$fd5a8904ab5abfe0; }, function (v) { return $49d40eaf9ca0cfa4$export$fd5a8904ab5abfe0 = v; });
$parcel$export(module.exports, "URL_SCHEME", function () { return $49d40eaf9ca0cfa4$export$1350d8937b0f26fb; }, function (v) { return $49d40eaf9ca0cfa4$export$1350d8937b0f26fb = v; });
$parcel$export(module.exports, "URL_TEMPLATE", function () { return $49d40eaf9ca0cfa4$export$2a045f777fb349a8; }, function (v) { return $49d40eaf9ca0cfa4$export$2a045f777fb349a8 = v; });
$parcel$export(module.exports, "USER_AGENT_ORIGINAL", function () { return $49d40eaf9ca0cfa4$export$8bb874585539a88f; }, function (v) { return $49d40eaf9ca0cfa4$export$8bb874585539a88f = v; });
$parcel$export(module.exports, "USER_EMAIL", function () { return $49d40eaf9ca0cfa4$export$17d3a50785727199; }, function (v) { return $49d40eaf9ca0cfa4$export$17d3a50785727199 = v; });
$parcel$export(module.exports, "USER_FULL_NAME", function () { return $49d40eaf9ca0cfa4$export$2931c570009689e; }, function (v) { return $49d40eaf9ca0cfa4$export$2931c570009689e = v; });
$parcel$export(module.exports, "USER_GEO_CITY", function () { return $49d40eaf9ca0cfa4$export$199cbcedee735a43; }, function (v) { return $49d40eaf9ca0cfa4$export$199cbcedee735a43 = v; });
$parcel$export(module.exports, "USER_GEO_COUNTRY_CODE", function () { return $49d40eaf9ca0cfa4$export$4ba5bf9d4e3ed862; }, function (v) { return $49d40eaf9ca0cfa4$export$4ba5bf9d4e3ed862 = v; });
$parcel$export(module.exports, "USER_GEO_REGION", function () { return $49d40eaf9ca0cfa4$export$674c01ec2f0b89c3; }, function (v) { return $49d40eaf9ca0cfa4$export$674c01ec2f0b89c3 = v; });
$parcel$export(module.exports, "USER_GEO_SUBDIVISION", function () { return $49d40eaf9ca0cfa4$export$bda1686739fd61c7; }, function (v) { return $49d40eaf9ca0cfa4$export$bda1686739fd61c7 = v; });
$parcel$export(module.exports, "USER_HASH", function () { return $49d40eaf9ca0cfa4$export$8d804148f485d54c; }, function (v) { return $49d40eaf9ca0cfa4$export$8d804148f485d54c = v; });
$parcel$export(module.exports, "USER_ID", function () { return $49d40eaf9ca0cfa4$export$212a8f1ea37518bd; }, function (v) { return $49d40eaf9ca0cfa4$export$212a8f1ea37518bd = v; });
$parcel$export(module.exports, "USER_IP_ADDRESS", function () { return $49d40eaf9ca0cfa4$export$c9ac0fee28245883; }, function (v) { return $49d40eaf9ca0cfa4$export$c9ac0fee28245883 = v; });
$parcel$export(module.exports, "USER_NAME", function () { return $49d40eaf9ca0cfa4$export$77078610759fe5f6; }, function (v) { return $49d40eaf9ca0cfa4$export$77078610759fe5f6 = v; });
$parcel$export(module.exports, "USER_ROLES", function () { return $49d40eaf9ca0cfa4$export$7c6317deeec7a6c1; }, function (v) { return $49d40eaf9ca0cfa4$export$7c6317deeec7a6c1 = v; });
$parcel$export(module.exports, "VERCEL_BRANCH", function () { return $49d40eaf9ca0cfa4$export$877ebf2e4ad81f03; }, function (v) { return $49d40eaf9ca0cfa4$export$877ebf2e4ad81f03 = v; });
$parcel$export(module.exports, "VERCEL_BUILD_ID", function () { return $49d40eaf9ca0cfa4$export$70b2343945496e1f; }, function (v) { return $49d40eaf9ca0cfa4$export$70b2343945496e1f = v; });
$parcel$export(module.exports, "VERCEL_DEPLOYMENT_ID", function () { return $49d40eaf9ca0cfa4$export$8415b56d2c6d2b1d; }, function (v) { return $49d40eaf9ca0cfa4$export$8415b56d2c6d2b1d = v; });
$parcel$export(module.exports, "VERCEL_DESTINATION", function () { return $49d40eaf9ca0cfa4$export$cc81114a03caab18; }, function (v) { return $49d40eaf9ca0cfa4$export$cc81114a03caab18 = v; });
$parcel$export(module.exports, "VERCEL_EDGE_TYPE", function () { return $49d40eaf9ca0cfa4$export$bc14eb892daceb23; }, function (v) { return $49d40eaf9ca0cfa4$export$bc14eb892daceb23 = v; });
$parcel$export(module.exports, "VERCEL_ENTRYPOINT", function () { return $49d40eaf9ca0cfa4$export$3c973217450c3e9d; }, function (v) { return $49d40eaf9ca0cfa4$export$3c973217450c3e9d = v; });
$parcel$export(module.exports, "VERCEL_EXECUTION_REGION", function () { return $49d40eaf9ca0cfa4$export$582c0b730ff1ddb9; }, function (v) { return $49d40eaf9ca0cfa4$export$582c0b730ff1ddb9 = v; });
$parcel$export(module.exports, "VERCEL_ID", function () { return $49d40eaf9ca0cfa4$export$b3edfb545b65f1c5; }, function (v) { return $49d40eaf9ca0cfa4$export$b3edfb545b65f1c5 = v; });
$parcel$export(module.exports, "VERCEL_JA3_DIGEST", function () { return $49d40eaf9ca0cfa4$export$2593317d8731841c; }, function (v) { return $49d40eaf9ca0cfa4$export$2593317d8731841c = v; });
$parcel$export(module.exports, "VERCEL_JA4_DIGEST", function () { return $49d40eaf9ca0cfa4$export$8bb5bc1732aa41f; }, function (v) { return $49d40eaf9ca0cfa4$export$8bb5bc1732aa41f = v; });
$parcel$export(module.exports, "VERCEL_LOG_TYPE", function () { return $49d40eaf9ca0cfa4$export$74a79c98b110b5b9; }, function (v) { return $49d40eaf9ca0cfa4$export$74a79c98b110b5b9 = v; });
$parcel$export(module.exports, "VERCEL_PATH", function () { return $49d40eaf9ca0cfa4$export$26461b03281b4db4; }, function (v) { return $49d40eaf9ca0cfa4$export$26461b03281b4db4 = v; });
$parcel$export(module.exports, "VERCEL_PROJECT_ID", function () { return $49d40eaf9ca0cfa4$export$eaea590d6d3dd93c; }, function (v) { return $49d40eaf9ca0cfa4$export$eaea590d6d3dd93c = v; });
$parcel$export(module.exports, "VERCEL_PROJECT_NAME", function () { return $49d40eaf9ca0cfa4$export$af45365f70099379; }, function (v) { return $49d40eaf9ca0cfa4$export$af45365f70099379 = v; });
$parcel$export(module.exports, "VERCEL_PROXY_CACHE_ID", function () { return $49d40eaf9ca0cfa4$export$a49e732d34d5ba9b; }, function (v) { return $49d40eaf9ca0cfa4$export$a49e732d34d5ba9b = v; });
$parcel$export(module.exports, "VERCEL_PROXY_CLIENT_IP", function () { return $49d40eaf9ca0cfa4$export$7c147fe246bc8bd3; }, function (v) { return $49d40eaf9ca0cfa4$export$7c147fe246bc8bd3 = v; });
$parcel$export(module.exports, "VERCEL_PROXY_HOST", function () { return $49d40eaf9ca0cfa4$export$e5111b6070e1ee9e; }, function (v) { return $49d40eaf9ca0cfa4$export$e5111b6070e1ee9e = v; });
$parcel$export(module.exports, "VERCEL_PROXY_LAMBDA_REGION", function () { return $49d40eaf9ca0cfa4$export$591cbfd403f8c8d; }, function (v) { return $49d40eaf9ca0cfa4$export$591cbfd403f8c8d = v; });
$parcel$export(module.exports, "VERCEL_PROXY_METHOD", function () { return $49d40eaf9ca0cfa4$export$b1388db955bbb885; }, function (v) { return $49d40eaf9ca0cfa4$export$b1388db955bbb885 = v; });
$parcel$export(module.exports, "VERCEL_PROXY_PATH", function () { return $49d40eaf9ca0cfa4$export$e898d0e9e211abd9; }, function (v) { return $49d40eaf9ca0cfa4$export$e898d0e9e211abd9 = v; });
$parcel$export(module.exports, "VERCEL_PROXY_PATH_TYPE", function () { return $49d40eaf9ca0cfa4$export$ab6fee0e8a6ee069; }, function (v) { return $49d40eaf9ca0cfa4$export$ab6fee0e8a6ee069 = v; });
$parcel$export(module.exports, "VERCEL_PROXY_PATH_TYPE_VARIANT", function () { return $49d40eaf9ca0cfa4$export$9786ad94c199ffbb; }, function (v) { return $49d40eaf9ca0cfa4$export$9786ad94c199ffbb = v; });
$parcel$export(module.exports, "VERCEL_PROXY_REFERER", function () { return $49d40eaf9ca0cfa4$export$269890524eed693b; }, function (v) { return $49d40eaf9ca0cfa4$export$269890524eed693b = v; });
$parcel$export(module.exports, "VERCEL_PROXY_REGION", function () { return $49d40eaf9ca0cfa4$export$2ec623a8212d6b64; }, function (v) { return $49d40eaf9ca0cfa4$export$2ec623a8212d6b64 = v; });
$parcel$export(module.exports, "VERCEL_PROXY_RESPONSE_BYTE_SIZE", function () { return $49d40eaf9ca0cfa4$export$30e7673b01ff994e; }, function (v) { return $49d40eaf9ca0cfa4$export$30e7673b01ff994e = v; });
$parcel$export(module.exports, "VERCEL_PROXY_SCHEME", function () { return $49d40eaf9ca0cfa4$export$9ea93477840812bf; }, function (v) { return $49d40eaf9ca0cfa4$export$9ea93477840812bf = v; });
$parcel$export(module.exports, "VERCEL_PROXY_STATUS_CODE", function () { return $49d40eaf9ca0cfa4$export$a6da0c365670c430; }, function (v) { return $49d40eaf9ca0cfa4$export$a6da0c365670c430 = v; });
$parcel$export(module.exports, "VERCEL_PROXY_TIMESTAMP", function () { return $49d40eaf9ca0cfa4$export$7986b22da43f2885; }, function (v) { return $49d40eaf9ca0cfa4$export$7986b22da43f2885 = v; });
$parcel$export(module.exports, "VERCEL_PROXY_USER_AGENT", function () { return $49d40eaf9ca0cfa4$export$a9f943c7ceb3b42f; }, function (v) { return $49d40eaf9ca0cfa4$export$a9f943c7ceb3b42f = v; });
$parcel$export(module.exports, "VERCEL_PROXY_VERCEL_CACHE", function () { return $49d40eaf9ca0cfa4$export$dfe49501efcdffce; }, function (v) { return $49d40eaf9ca0cfa4$export$dfe49501efcdffce = v; });
$parcel$export(module.exports, "VERCEL_PROXY_VERCEL_ID", function () { return $49d40eaf9ca0cfa4$export$be465f50c92eb01d; }, function (v) { return $49d40eaf9ca0cfa4$export$be465f50c92eb01d = v; });
$parcel$export(module.exports, "VERCEL_PROXY_WAF_ACTION", function () { return $49d40eaf9ca0cfa4$export$c138d1796bb34999; }, function (v) { return $49d40eaf9ca0cfa4$export$c138d1796bb34999 = v; });
$parcel$export(module.exports, "VERCEL_PROXY_WAF_RULE_ID", function () { return $49d40eaf9ca0cfa4$export$85a0016690a0ccf2; }, function (v) { return $49d40eaf9ca0cfa4$export$85a0016690a0ccf2 = v; });
$parcel$export(module.exports, "VERCEL_REQUEST_ID", function () { return $49d40eaf9ca0cfa4$export$883acab36ede4bfa; }, function (v) { return $49d40eaf9ca0cfa4$export$883acab36ede4bfa = v; });
$parcel$export(module.exports, "VERCEL_SOURCE", function () { return $49d40eaf9ca0cfa4$export$9cfc88d203f9cdf1; }, function (v) { return $49d40eaf9ca0cfa4$export$9cfc88d203f9cdf1 = v; });
$parcel$export(module.exports, "VERCEL_STATUS_CODE", function () { return $49d40eaf9ca0cfa4$export$b3c6c599110d7bab; }, function (v) { return $49d40eaf9ca0cfa4$export$b3c6c599110d7bab = v; });
$parcel$export(module.exports, "_AWS_KINESIS_STREAM_NAME", function () { return $49d40eaf9ca0cfa4$export$247839c65766758; }, function (v) { return $49d40eaf9ca0cfa4$export$247839c65766758 = v; });
$parcel$export(module.exports, "_AWS_REQUEST_ID", function () { return $49d40eaf9ca0cfa4$export$f4d52b02df927d54; }, function (v) { return $49d40eaf9ca0cfa4$export$f4d52b02df927d54 = v; });
$parcel$export(module.exports, "_HTTP_REQUEST_METHOD", function () { return $49d40eaf9ca0cfa4$export$df30ee8c5b5f1989; }, function (v) { return $49d40eaf9ca0cfa4$export$df30ee8c5b5f1989 = v; });
$parcel$export(module.exports, "_SENTRY_SEGMENT_ID", function () { return $49d40eaf9ca0cfa4$export$268a117c860fca6d; }, function (v) { return $49d40eaf9ca0cfa4$export$268a117c860fca6d = v; });
var $49d40eaf9ca0cfa4$export$b60c5e9f9b7b58bd;
var $49d40eaf9ca0cfa4$export$cc06afd6de7f2c10;
var $49d40eaf9ca0cfa4$export$ced6746028fe2cc;
var $49d40eaf9ca0cfa4$export$e6f4aa4f4fcb6da8;
var $49d40eaf9ca0cfa4$export$f02d892201cd8d36;
var $49d40eaf9ca0cfa4$export$f277a7ef9e273960;
var $49d40eaf9ca0cfa4$export$1a8c212c3becaa80;
var $49d40eaf9ca0cfa4$export$721b137086c68a47;
var $49d40eaf9ca0cfa4$export$6afde2bb69d9aa86;
var $49d40eaf9ca0cfa4$export$eadb4b562c974031;
var $49d40eaf9ca0cfa4$export$22a90f0ac1eee843;
var $49d40eaf9ca0cfa4$export$a727f215a0be1dad;
var $49d40eaf9ca0cfa4$export$536bc61b34d995e5;
var $49d40eaf9ca0cfa4$export$c43ea6115b380e62;
var $49d40eaf9ca0cfa4$export$d2a16e26bada7cf1;
var $49d40eaf9ca0cfa4$export$604eb1bd2278163b;
var $49d40eaf9ca0cfa4$export$2f8568696c5aa352;
var $49d40eaf9ca0cfa4$export$ccc8efd7dd31d3a9;
var $49d40eaf9ca0cfa4$export$e176bf5dc45e40df;
var $49d40eaf9ca0cfa4$export$c4ea01fd53f64e16;
var $49d40eaf9ca0cfa4$export$bb5e6f2f31a15da9;
var $49d40eaf9ca0cfa4$export$1762c11b666b026a;
var $49d40eaf9ca0cfa4$export$14ddd4b729910100;
var $49d40eaf9ca0cfa4$export$5311d7c8e1f8eabb;
var $49d40eaf9ca0cfa4$export$2b748b9eca00828b;
var $49d40eaf9ca0cfa4$export$5af25308c11addea;
var $49d40eaf9ca0cfa4$export$28f78b3b1663cb92;
var $49d40eaf9ca0cfa4$export$a1d3f09f0f1f066f;
var $49d40eaf9ca0cfa4$export$322bd4ea9f163663;
var $49d40eaf9ca0cfa4$export$95711b9e669edad8;
var $49d40eaf9ca0cfa4$export$5924d7d72384626a;
var $49d40eaf9ca0cfa4$export$db3b1b877a4ce4db;
var $49d40eaf9ca0cfa4$export$a434a3e8afec2879;
var $49d40eaf9ca0cfa4$export$fe00bb20636d42af;
var $49d40eaf9ca0cfa4$export$712aa698b7ee271e;
var $49d40eaf9ca0cfa4$export$1fac638b11ec16d9;
var $49d40eaf9ca0cfa4$export$d132016ea64058e3;
var $49d40eaf9ca0cfa4$export$53f2f47ec3b2f9ed;
var $49d40eaf9ca0cfa4$export$9f80c4b11053cef1;
var $49d40eaf9ca0cfa4$export$5f7a08466d84e877;
var $49d40eaf9ca0cfa4$export$2cea7f14750b8c19;
var $49d40eaf9ca0cfa4$export$34c59270f032a6c6;
var $49d40eaf9ca0cfa4$export$5b6c28c7dca07ad7;
var $49d40eaf9ca0cfa4$export$1dc8ae58b58d6c50;
var $49d40eaf9ca0cfa4$export$ba267414e3c0d822;
var $49d40eaf9ca0cfa4$export$71b176005902b99e;
var $49d40eaf9ca0cfa4$export$5c5b5a3c245a0079;
var $49d40eaf9ca0cfa4$export$8ee1df3c6367a60;
var $49d40eaf9ca0cfa4$export$e8c7802ae95beccf;
var $49d40eaf9ca0cfa4$export$bb237734da4d464;
var $49d40eaf9ca0cfa4$export$cdaaf6d1fdcba0b6;
var $49d40eaf9ca0cfa4$export$36223ebd4a30e9f5;
var $49d40eaf9ca0cfa4$export$8feaa177bb7941e2;
var $49d40eaf9ca0cfa4$export$e1ca25240db91d68;
var $49d40eaf9ca0cfa4$export$404a223fd1ada08b;
var $49d40eaf9ca0cfa4$export$53362079310c68;
var $49d40eaf9ca0cfa4$export$3efb5af0ac379f77;
var $49d40eaf9ca0cfa4$export$2c10c1ca0612c46d;
var $49d40eaf9ca0cfa4$export$bbb86ad4d6654da6;
var $49d40eaf9ca0cfa4$export$ad6896f00a2b1076;
var $49d40eaf9ca0cfa4$export$300f39d8506a273d;
var $49d40eaf9ca0cfa4$export$ecaa0e7f4773ddc7;
var $49d40eaf9ca0cfa4$export$74b78acb4c54c06b;
var $49d40eaf9ca0cfa4$export$b15b2c133bc50e33;
var $49d40eaf9ca0cfa4$export$5f1381d9ae1b1c95;
var $49d40eaf9ca0cfa4$export$c170b7ff277132ea;
var $49d40eaf9ca0cfa4$export$9459a5df93695e45;
var $49d40eaf9ca0cfa4$export$a7902bd57492ebe8;
var $49d40eaf9ca0cfa4$export$d2ace0da59da09b7;
var $49d40eaf9ca0cfa4$export$c15dd8d2461e0aeb;
var $49d40eaf9ca0cfa4$export$5405b0a98e00e538;
var $49d40eaf9ca0cfa4$export$bd393bbb84b309d3;
var $49d40eaf9ca0cfa4$export$96f586f8837b86ae;
var $49d40eaf9ca0cfa4$export$5d9f28f388f552d2;
var $49d40eaf9ca0cfa4$export$b3d2f68e0e769504;
var $49d40eaf9ca0cfa4$export$2c98412ed43013e8;
var $49d40eaf9ca0cfa4$export$a7bd794d11c19f1b;
var $49d40eaf9ca0cfa4$export$df4227832b83fdd0;
var $49d40eaf9ca0cfa4$export$f131a6d8fbc0534f;
var $49d40eaf9ca0cfa4$export$9bdc66d4a70e7e3a;
var $49d40eaf9ca0cfa4$export$bfbbc3cbcaa90e98;
var $49d40eaf9ca0cfa4$export$3565fa72459aa4d6;
var $49d40eaf9ca0cfa4$export$bb67a834ae4bffdc;
var $49d40eaf9ca0cfa4$export$4a06c859a283f06;
var $49d40eaf9ca0cfa4$export$68324fac2038d0f2;
var $49d40eaf9ca0cfa4$export$5e1bd62ffd2786fb;
var $49d40eaf9ca0cfa4$export$bfdf2261058f56b;
var $49d40eaf9ca0cfa4$export$23bf57842d9d53df;
var $49d40eaf9ca0cfa4$export$bfbd7e060eeb4d35;
var $49d40eaf9ca0cfa4$export$82eb6cccda27c3ff;
var $49d40eaf9ca0cfa4$export$8ea68734d455808f;
var $49d40eaf9ca0cfa4$export$40050e29324d44ee;
var $49d40eaf9ca0cfa4$export$5cd7541006d9f467;
var $49d40eaf9ca0cfa4$export$81c017edd95d692e;
var $49d40eaf9ca0cfa4$export$120b3897a58cf903;
var $49d40eaf9ca0cfa4$export$d4a9de43b4b1076c;
var $49d40eaf9ca0cfa4$export$f37f4f9022f1ab17;
var $49d40eaf9ca0cfa4$export$66ac18da14747cfb;
var $49d40eaf9ca0cfa4$export$9e49b833525ca49d;
var $49d40eaf9ca0cfa4$export$b084fea5b3097227;
var $49d40eaf9ca0cfa4$export$e09cd8615652e8d0;
var $49d40eaf9ca0cfa4$export$a43a60ec723a90ee;
var $49d40eaf9ca0cfa4$export$34cc955357266287;
var $49d40eaf9ca0cfa4$export$d9dd218693ea9bba;
var $49d40eaf9ca0cfa4$export$c9649b7156282a2f;
var $49d40eaf9ca0cfa4$export$daa8ce1f8adc553e;
var $49d40eaf9ca0cfa4$export$cb93c7b05db202cf;
var $49d40eaf9ca0cfa4$export$930f9bd3cc2e5b3d;
var $49d40eaf9ca0cfa4$export$48c6d4c44afdc0b;
var $49d40eaf9ca0cfa4$export$c78d41789fe4b1e4;
var $49d40eaf9ca0cfa4$export$f462d9921f1f7332;
var $49d40eaf9ca0cfa4$export$bc71f8df9a45e243;
var $49d40eaf9ca0cfa4$export$ed840ec4a5f5d053;
var $49d40eaf9ca0cfa4$export$c1a559a4f74a5e8e;
var $49d40eaf9ca0cfa4$export$d1c007424092e3f5;
var $49d40eaf9ca0cfa4$export$9ebb466ce954c49c;
var $49d40eaf9ca0cfa4$export$e9aafc7348984403;
var $49d40eaf9ca0cfa4$export$faaa46964f075237;
var $49d40eaf9ca0cfa4$export$d28c4b3cc4431a87;
var $49d40eaf9ca0cfa4$export$734b017b330c8fe6;
var $49d40eaf9ca0cfa4$export$683ebdc48ba3758d;
var $49d40eaf9ca0cfa4$export$be0263971250ef44;
var $49d40eaf9ca0cfa4$export$36a0cbc35c405232;
var $49d40eaf9ca0cfa4$export$469f7765ba335497;
var $49d40eaf9ca0cfa4$export$fe6fe2b7af051610;
var $49d40eaf9ca0cfa4$export$8345821877c4dfad;
var $49d40eaf9ca0cfa4$export$f6c188a7e02335cf;
var $49d40eaf9ca0cfa4$export$aaf709a8971e825f;
var $49d40eaf9ca0cfa4$export$def01b82f8c092f7;
var $49d40eaf9ca0cfa4$export$23d4264c606a73a6;
var $49d40eaf9ca0cfa4$export$af9ece53bb92f66b;
var $49d40eaf9ca0cfa4$export$25421625a565b69;
var $49d40eaf9ca0cfa4$export$ab0c90d873e69ccb;
var $49d40eaf9ca0cfa4$export$538c05cc8cb2a2bb;
var $49d40eaf9ca0cfa4$export$f86df4de196e1a7c;
var $49d40eaf9ca0cfa4$export$51e8aa8c0d65e7b8;
var $49d40eaf9ca0cfa4$export$99023486ecc470bd;
var $49d40eaf9ca0cfa4$export$2f6c85eaf382e81;
var $49d40eaf9ca0cfa4$export$1158d57c0aed42be;
var $49d40eaf9ca0cfa4$export$d85c4f947ab776e3;
var $49d40eaf9ca0cfa4$export$813ef8386d874918;
var $49d40eaf9ca0cfa4$export$7c2f74ff9251f64;
var $49d40eaf9ca0cfa4$export$993f84dab107b880;
var $49d40eaf9ca0cfa4$export$7b9c2315e94d8d2f;
var $49d40eaf9ca0cfa4$export$f01e5cd42b9ec146;
var $49d40eaf9ca0cfa4$export$987f6b4367434b55;
var $49d40eaf9ca0cfa4$export$d9d145585d5022bb;
var $49d40eaf9ca0cfa4$export$44ffba16bd48dac6;
var $49d40eaf9ca0cfa4$export$3134892c5d2e251a;
var $49d40eaf9ca0cfa4$export$8495028d10296058;
var $49d40eaf9ca0cfa4$export$d6d0e4fcf46d490c;
var $49d40eaf9ca0cfa4$export$658dced473c19301;
var $49d40eaf9ca0cfa4$export$97b0f9c3fbe64076;
var $49d40eaf9ca0cfa4$export$cf2c95ed5efbe9eb;
var $49d40eaf9ca0cfa4$export$880007904f61a388;
var $49d40eaf9ca0cfa4$export$3e903b72d4d9e07d;
var $49d40eaf9ca0cfa4$export$34da07180e0e56af;
var $49d40eaf9ca0cfa4$export$c49aafdaeb061953;
var $49d40eaf9ca0cfa4$export$ceb762c61de2f17f;
var $49d40eaf9ca0cfa4$export$a5f54ccfb28c0caf;
var $49d40eaf9ca0cfa4$export$1c86a56857b024db;
var $49d40eaf9ca0cfa4$export$7598f3464be47440;
var $49d40eaf9ca0cfa4$export$b673289c971fc0ae;
var $49d40eaf9ca0cfa4$export$98b23f3e6f0c2a6f;
var $49d40eaf9ca0cfa4$export$6ddeaf0498614ebb;
var $49d40eaf9ca0cfa4$export$97b78f78d64a7232;
var $49d40eaf9ca0cfa4$export$5147715be870fff7;
var $49d40eaf9ca0cfa4$export$5276bb46e6096fba;
var $49d40eaf9ca0cfa4$export$cbcbc1f67a937cf3;
var $49d40eaf9ca0cfa4$export$226a2381b8f0cf78;
var $49d40eaf9ca0cfa4$export$fd35512cae286064;
var $49d40eaf9ca0cfa4$export$de9bbf95ab1d81e;
var $49d40eaf9ca0cfa4$export$47fb20e8d18d7d15;
var $49d40eaf9ca0cfa4$export$9db7964e4b8cb849;
var $49d40eaf9ca0cfa4$export$7139adf9d3bace41;
var $49d40eaf9ca0cfa4$export$8ac3d09060e7f25d;
var $49d40eaf9ca0cfa4$export$dad0e4778ea23971;
var $49d40eaf9ca0cfa4$export$c14d903ccf9385a8;
var $49d40eaf9ca0cfa4$export$934cded0041affd7;
var $49d40eaf9ca0cfa4$export$6386da1dcba88c9d;
var $49d40eaf9ca0cfa4$export$a3371797e606e2;
var $49d40eaf9ca0cfa4$export$a5bbef0af83b23e5;
var $49d40eaf9ca0cfa4$export$91ed1f55874222a6;
var $49d40eaf9ca0cfa4$export$23de81068d2aed1b;
var $49d40eaf9ca0cfa4$export$d738320e1fba9e9d;
var $49d40eaf9ca0cfa4$export$2eacdea75497e8a5;
var $49d40eaf9ca0cfa4$export$2bc3ea101f86c1d2;
var $49d40eaf9ca0cfa4$export$c54e27e8d90ee081;
var $49d40eaf9ca0cfa4$export$4943adcec371c2a6;
var $49d40eaf9ca0cfa4$export$f000a5900d0480c2;
var $49d40eaf9ca0cfa4$export$8f5234893868273b;
var $49d40eaf9ca0cfa4$export$1a35518f6e81e8c7;
var $49d40eaf9ca0cfa4$export$a2d90911eaae60fc;
var $49d40eaf9ca0cfa4$export$3c22ff8b64b8f565;
var $49d40eaf9ca0cfa4$export$b8019c0e2a5b5f0f;
var $49d40eaf9ca0cfa4$export$8c11477e471467c8;
var $49d40eaf9ca0cfa4$export$92a96f6363488aee;
var $49d40eaf9ca0cfa4$export$f91beb6088f9ded9;
var $49d40eaf9ca0cfa4$export$78bc7224576bf289;
var $49d40eaf9ca0cfa4$export$a8027e0ea0d93ca;
var $49d40eaf9ca0cfa4$export$5e59d3aea52e5037;
var $49d40eaf9ca0cfa4$export$47e408be0da7933f;
var $49d40eaf9ca0cfa4$export$d5772b934ca13e57;
var $49d40eaf9ca0cfa4$export$36e47f6a5777561d;
var $49d40eaf9ca0cfa4$export$e768cbc99cd68acf;
var $49d40eaf9ca0cfa4$export$dfcc6c69df1343f2;
var $49d40eaf9ca0cfa4$export$69b0a5d9226b5211;
var $49d40eaf9ca0cfa4$export$da010a4f4fc971ae;
var $49d40eaf9ca0cfa4$export$5d515b35be0601a0;
var $49d40eaf9ca0cfa4$export$3e1b1037a315c5ca;
var $49d40eaf9ca0cfa4$export$847fdd494825f0fb;
var $49d40eaf9ca0cfa4$export$a9d76f26c6c730a9;
var $49d40eaf9ca0cfa4$export$de03f86d1c9866ca;
var $49d40eaf9ca0cfa4$export$65798ecab7eef8c;
var $49d40eaf9ca0cfa4$export$22aa61f48b9c79a0;
var $49d40eaf9ca0cfa4$export$69f5fb98f5aed812;
var $49d40eaf9ca0cfa4$export$bdea5d1006fd280a;
var $49d40eaf9ca0cfa4$export$f63a7230c5b1d609;
var $49d40eaf9ca0cfa4$export$6f25e59b05bb8e17;
var $49d40eaf9ca0cfa4$export$a56ad13c4afc7421;
var $49d40eaf9ca0cfa4$export$d9ce89ce8912bf12;
var $49d40eaf9ca0cfa4$export$17094e5f380e4162;
var $49d40eaf9ca0cfa4$export$28a0ffdf747973a0;
var $49d40eaf9ca0cfa4$export$5480ae1ba5d50bb9;
var $49d40eaf9ca0cfa4$export$edc72ee4a17f5152;
var $49d40eaf9ca0cfa4$export$19e4df138d354f8b;
var $49d40eaf9ca0cfa4$export$92b0d20fa482b4b2;
var $49d40eaf9ca0cfa4$export$3f638a793d61933f;
var $49d40eaf9ca0cfa4$export$3f511731cc3687d4;
var $49d40eaf9ca0cfa4$export$692b08741d6b6265;
var $49d40eaf9ca0cfa4$export$cf67f8cb2324428e;
var $49d40eaf9ca0cfa4$export$9d4197c1ffc5f359;
var $49d40eaf9ca0cfa4$export$509634fbff540e75;
var $49d40eaf9ca0cfa4$export$ccbc4fdff4b5eff5;
var $49d40eaf9ca0cfa4$export$e0cb371ca548b1d6;
var $49d40eaf9ca0cfa4$export$3c39026d09026bc2;
var $49d40eaf9ca0cfa4$export$bf9e8248cb72cf00;
var $49d40eaf9ca0cfa4$export$1054f22a72121d0f;
var $49d40eaf9ca0cfa4$export$723b8a59dad2e467;
var $49d40eaf9ca0cfa4$export$160081ff141bac8e;
var $49d40eaf9ca0cfa4$export$194f62c84d27310;
var $49d40eaf9ca0cfa4$export$7ed866d57b018d09;
var $49d40eaf9ca0cfa4$export$d50bae4562e03e5;
var $49d40eaf9ca0cfa4$export$649ea67a18fe8e8b;
var $49d40eaf9ca0cfa4$export$136a5c1b43caaccd;
var $49d40eaf9ca0cfa4$export$e33a28ea554b6ddc;
var $49d40eaf9ca0cfa4$export$acbe2d25ac76ea64;
var $49d40eaf9ca0cfa4$export$793c13e17d7e5e2b;
var $49d40eaf9ca0cfa4$export$a5617e33b89fd956;
var $49d40eaf9ca0cfa4$export$b51f82164fa31e07;
var $49d40eaf9ca0cfa4$export$f2ef55183c04d202;
var $49d40eaf9ca0cfa4$export$7c98fc0c48a16b1c;
var $49d40eaf9ca0cfa4$export$f0511e328234ae83;
var $49d40eaf9ca0cfa4$export$be46596bc6608f3b;
var $49d40eaf9ca0cfa4$export$f215947b3d76a6b7;
var $49d40eaf9ca0cfa4$export$89bbc91416db6670;
var $49d40eaf9ca0cfa4$export$b4b5eff8a8712c89;
var $49d40eaf9ca0cfa4$export$f455969a57ab8a03;
var $49d40eaf9ca0cfa4$export$13f2f8f42af49cec;
var $49d40eaf9ca0cfa4$export$cd357afe2ffdd2c3;
var $49d40eaf9ca0cfa4$export$d9ca2a279a11be5e;
var $49d40eaf9ca0cfa4$export$bbd59a8c7efad4c9;
var $49d40eaf9ca0cfa4$export$8413282a17f1cda5;
var $49d40eaf9ca0cfa4$export$30d19ddc7705e7e8;
var $49d40eaf9ca0cfa4$export$64a4f09e2444b3d;
var $49d40eaf9ca0cfa4$export$645b039fe163809e;
var $49d40eaf9ca0cfa4$export$b23ef8b8ffa607e1;
var $49d40eaf9ca0cfa4$export$8bf64516740c1369;
var $49d40eaf9ca0cfa4$export$9a0dc8e612f3e10b;
var $49d40eaf9ca0cfa4$export$abe90fedb3dddda2;
var $49d40eaf9ca0cfa4$export$4a19da9c85ed2ade;
var $49d40eaf9ca0cfa4$export$5e091479f094bdbc;
var $49d40eaf9ca0cfa4$export$d70909b5aa96a79a;
var $49d40eaf9ca0cfa4$export$651d142a8017d83d;
var $49d40eaf9ca0cfa4$export$44382a010a9f7fcf;
var $49d40eaf9ca0cfa4$export$807abfdc6b7b9338;
var $49d40eaf9ca0cfa4$export$31881d07f2569218;
var $49d40eaf9ca0cfa4$export$e5bbf306deb709a6;
var $49d40eaf9ca0cfa4$export$aa8721167c5c8d2d;
var $49d40eaf9ca0cfa4$export$757b93e5b3adc7cb;
var $49d40eaf9ca0cfa4$export$f869eaa92db1dc9b;
var $49d40eaf9ca0cfa4$export$5d1d761e41c32d9e;
var $49d40eaf9ca0cfa4$export$8aec72d9491f9399;
var $49d40eaf9ca0cfa4$export$5562635d2be2ab25;
var $49d40eaf9ca0cfa4$export$2dc31837ce6f7a3d;
var $49d40eaf9ca0cfa4$export$b561df15f64d32e3;
var $49d40eaf9ca0cfa4$export$181f78b28f2ffa57;
var $49d40eaf9ca0cfa4$export$6c97c77b89571c75;
var $49d40eaf9ca0cfa4$export$51e431eaf1f9bf58;
var $49d40eaf9ca0cfa4$export$71429c7ef7cb7063;
var $49d40eaf9ca0cfa4$export$99905d7583a6e8ac;
var $49d40eaf9ca0cfa4$export$b6c4be74fd0c06bd;
var $49d40eaf9ca0cfa4$export$fd23e5b8d261a89;
var $49d40eaf9ca0cfa4$export$25fabc9b3d1dd567;
var $49d40eaf9ca0cfa4$export$41507f7b07dad151;
var $49d40eaf9ca0cfa4$export$1352f3699c35dd73;
var $49d40eaf9ca0cfa4$export$fd6c9d5c74d943ac;
var $49d40eaf9ca0cfa4$export$c29634e3cf41e479;
var $49d40eaf9ca0cfa4$export$e6a60882cce7a085;
var $49d40eaf9ca0cfa4$export$6773c9098ba5e194;
var $49d40eaf9ca0cfa4$export$6ee6b62f50047686;
var $49d40eaf9ca0cfa4$export$efac052bb3661242;
var $49d40eaf9ca0cfa4$export$7ccd63b9ca955862;
var $49d40eaf9ca0cfa4$export$50921df5a58cb3ef;
var $49d40eaf9ca0cfa4$export$8e48efc7acb57a97;
var $49d40eaf9ca0cfa4$export$cea9121727113f77;
var $49d40eaf9ca0cfa4$export$bed35ff7f9af3aaa;
var $49d40eaf9ca0cfa4$export$6b729e898b9067ce;
var $49d40eaf9ca0cfa4$export$984fbab9b52f7e24;
var $49d40eaf9ca0cfa4$export$9ea17906a87ada6f;
var $49d40eaf9ca0cfa4$export$394b443aaff3ef92;
var $49d40eaf9ca0cfa4$export$6ddc374adbc06720;
var $49d40eaf9ca0cfa4$export$ab8c7ebc9add56b2;
var $49d40eaf9ca0cfa4$export$40ecc5bcd633d1ee;
var $49d40eaf9ca0cfa4$export$86a8df7fff52fc69;
var $49d40eaf9ca0cfa4$export$cf2115d46768f4c5;
var $49d40eaf9ca0cfa4$export$3d7e036e195764db;
var $49d40eaf9ca0cfa4$export$60c1d11221608cee;
var $49d40eaf9ca0cfa4$export$bc3cef164abbc42c;
var $49d40eaf9ca0cfa4$export$43f9afb62cd79dec;
var $49d40eaf9ca0cfa4$export$a5ab4ffc4765f75f;
var $49d40eaf9ca0cfa4$export$ccf46db9ab1743ec;
var $49d40eaf9ca0cfa4$export$76c1c247342d776;
var $49d40eaf9ca0cfa4$export$92f5944f0b02c9fb;
var $49d40eaf9ca0cfa4$export$867eeefcb1c95b27;
var $49d40eaf9ca0cfa4$export$5ada4697ae6aa17e;
var $49d40eaf9ca0cfa4$export$427122300e8d54d0;
var $49d40eaf9ca0cfa4$export$bcea8881375c352f;
var $49d40eaf9ca0cfa4$export$b867715f9a0c04e9;
var $49d40eaf9ca0cfa4$export$69878a39cbdbe097;
var $49d40eaf9ca0cfa4$export$584c61a1b769552d;
var $49d40eaf9ca0cfa4$export$8169ebcb0b0331dd;
var $49d40eaf9ca0cfa4$export$2c9713b624877853;
var $49d40eaf9ca0cfa4$export$45942692aeb454e0;
var $49d40eaf9ca0cfa4$export$8e5efeaa031210cd;
var $49d40eaf9ca0cfa4$export$35a62769ee05a05a;
var $49d40eaf9ca0cfa4$export$8ea4f7e986ca4b06;
var $49d40eaf9ca0cfa4$export$d2fd9ecaff0285a4;
var $49d40eaf9ca0cfa4$export$a6c8e656a4f9bb67;
var $49d40eaf9ca0cfa4$export$352a8075b163d53;
var $49d40eaf9ca0cfa4$export$426d7b90ba5d79db;
var $49d40eaf9ca0cfa4$export$f5a1ee40934d19ce;
var $49d40eaf9ca0cfa4$export$1ba812a9756622ce;
var $49d40eaf9ca0cfa4$export$351120039c36e03;
var $49d40eaf9ca0cfa4$export$d42aa25ca09e17c4;
var $49d40eaf9ca0cfa4$export$d268db29b88a4286;
var $49d40eaf9ca0cfa4$export$c5deb6018f2d6251;
var $49d40eaf9ca0cfa4$export$e06baa3034409453;
var $49d40eaf9ca0cfa4$export$646fdb5910ce3931;
var $49d40eaf9ca0cfa4$export$662e3d2d4361e29b;
var $49d40eaf9ca0cfa4$export$1de3962f221ba441;
var $49d40eaf9ca0cfa4$export$a4b3f0f5499c8738;
var $49d40eaf9ca0cfa4$export$1aecdac6cecbdc5b;
var $49d40eaf9ca0cfa4$export$2eb2ab35b317a103;
var $49d40eaf9ca0cfa4$export$c7e14ea195ede241;
var $49d40eaf9ca0cfa4$export$41ac034e7b9725a2;
var $49d40eaf9ca0cfa4$export$9e521119d7751e37;
var $49d40eaf9ca0cfa4$export$cbac8f541a64a150;
var $49d40eaf9ca0cfa4$export$93dd08efa94c9dd4;
var $49d40eaf9ca0cfa4$export$183e3523dac20bca;
var $49d40eaf9ca0cfa4$export$3867ca1d8381d4e3;
var $49d40eaf9ca0cfa4$export$11febcf9917c0057;
var $49d40eaf9ca0cfa4$export$88ae1ee0c0a63398;
var $49d40eaf9ca0cfa4$export$d5bd986d1f283f29;
var $49d40eaf9ca0cfa4$export$fc4a2d238535d998;
var $49d40eaf9ca0cfa4$export$57e53a60bf563f41;
var $49d40eaf9ca0cfa4$export$ffdb1464deb0eedb;
var $49d40eaf9ca0cfa4$export$b52670c950fd640;
var $49d40eaf9ca0cfa4$export$c499fd8f1db3d18e;
var $49d40eaf9ca0cfa4$export$b2ee2242301eff05;
var $49d40eaf9ca0cfa4$export$2ebf9f7586f16841;
var $49d40eaf9ca0cfa4$export$6e9ffd608b3e828b;
var $49d40eaf9ca0cfa4$export$b960c5a73a722e6c;
var $49d40eaf9ca0cfa4$export$a7a850351369c77e;
var $49d40eaf9ca0cfa4$export$b18bca78f4736a94;
var $49d40eaf9ca0cfa4$export$61a0059f562fb6c2;
var $49d40eaf9ca0cfa4$export$7dc0d5aefb816d91;
var $49d40eaf9ca0cfa4$export$58f6db56c841bef6;
var $49d40eaf9ca0cfa4$export$97a3da679f509d5;
var $49d40eaf9ca0cfa4$export$c387ec65fd1c2638;
var $49d40eaf9ca0cfa4$export$4d9db82211f308a4;
var $49d40eaf9ca0cfa4$export$ee4948a3be025123;
var $49d40eaf9ca0cfa4$export$e0021eb2979cddaa;
var $49d40eaf9ca0cfa4$export$7c0ac0c19a45beac;
var $49d40eaf9ca0cfa4$export$6c32e9d84f534ee;
var $49d40eaf9ca0cfa4$export$d1f9fbdb211dd29b;
var $49d40eaf9ca0cfa4$export$45e7eea99a17d6e4;
var $49d40eaf9ca0cfa4$export$20ea34e16c0aa64f;
var $49d40eaf9ca0cfa4$export$8365b0f03557fae9;
var $49d40eaf9ca0cfa4$export$49ebbb9621675650;
var $49d40eaf9ca0cfa4$export$842be66a901f093;
var $49d40eaf9ca0cfa4$export$a9f5a6cb28adccb1;
var $49d40eaf9ca0cfa4$export$57b055d4bc586d67;
var $49d40eaf9ca0cfa4$export$3ddfd660caa7bf7a;
var $49d40eaf9ca0cfa4$export$fa7e1f5305153b3d;
var $49d40eaf9ca0cfa4$export$5674ce9d013eb7bd;
var $49d40eaf9ca0cfa4$export$6e8dc14cff6ccf72;
var $49d40eaf9ca0cfa4$export$afd59480458e1b57;
var $49d40eaf9ca0cfa4$export$48e61fb9bccccba9;
var $49d40eaf9ca0cfa4$export$d3e674514dd3a3e1;
var $49d40eaf9ca0cfa4$export$97ad02b50c60ef68;
var $49d40eaf9ca0cfa4$export$61d053b1b63e82c4;
var $49d40eaf9ca0cfa4$export$54256cce0d674dea;
var $49d40eaf9ca0cfa4$export$8c01f0f407bcc5ca;
var $49d40eaf9ca0cfa4$export$be3f46982f6c7160;
var $49d40eaf9ca0cfa4$export$778e4213e2788579;
var $49d40eaf9ca0cfa4$export$8b48ca3594d2b172;
var $49d40eaf9ca0cfa4$export$8be180ec26319f9f;
var $49d40eaf9ca0cfa4$export$60eccaddefa8fc1c;
var $49d40eaf9ca0cfa4$export$c99ce4fe37484d84;
var $49d40eaf9ca0cfa4$export$fdf432fcac7d8f37;
var $49d40eaf9ca0cfa4$export$4c21cc9cdf2f5dbd;
var $49d40eaf9ca0cfa4$export$dcc1eab7f3f31816;
var $49d40eaf9ca0cfa4$export$dcb7f1379b2b8f86;
var $49d40eaf9ca0cfa4$export$53416edeea4c2d74;
var $49d40eaf9ca0cfa4$export$69f7e5d2b74c5c9e;
var $49d40eaf9ca0cfa4$export$8e104aed582a26bc;
var $49d40eaf9ca0cfa4$export$577047501949be9;
var $49d40eaf9ca0cfa4$export$c4c45b599a2c15e;
var $49d40eaf9ca0cfa4$export$361cb541700d648e;
var $49d40eaf9ca0cfa4$export$974f160e11f25731;
var $49d40eaf9ca0cfa4$export$7162f5c702b95903;
var $49d40eaf9ca0cfa4$export$a034d066a9090500;
var $49d40eaf9ca0cfa4$export$70938021e43e047c;
var $49d40eaf9ca0cfa4$export$5f6ac460012a73bb;
var $49d40eaf9ca0cfa4$export$d8e498c1c670bcbf;
var $49d40eaf9ca0cfa4$export$cc1a78a24d947903;
var $49d40eaf9ca0cfa4$export$d29b927e0bb0ffea;
var $49d40eaf9ca0cfa4$export$b3999cacef245779;
var $49d40eaf9ca0cfa4$export$ff168b5f9cf9dcf6;
var $49d40eaf9ca0cfa4$export$2ab876a45bd6e64;
var $49d40eaf9ca0cfa4$export$cb8027e4395c6c0e;
var $49d40eaf9ca0cfa4$export$f5303d1bac3c2660;
var $49d40eaf9ca0cfa4$export$6c463c5f3b00f64;
var $49d40eaf9ca0cfa4$export$e25d553065457cab;
var $49d40eaf9ca0cfa4$export$15d24c154ea8a56f;
var $49d40eaf9ca0cfa4$export$e5065789a6c415d0;
var $49d40eaf9ca0cfa4$export$62662c561d7c7835;
var $49d40eaf9ca0cfa4$export$218f394557fb0a5a;
var $49d40eaf9ca0cfa4$export$2a5ff6de5448ecdf;
var $49d40eaf9ca0cfa4$export$9d23f3030ed2597e;
var $49d40eaf9ca0cfa4$export$a26ff217a6124160;
var $49d40eaf9ca0cfa4$export$c8072f5fcfdb5b77;
var $49d40eaf9ca0cfa4$export$c4e4b74f1ccf3d96;
var $49d40eaf9ca0cfa4$export$328519d02a26ac41;
var $49d40eaf9ca0cfa4$export$d2061b291c43d045;
var $49d40eaf9ca0cfa4$export$d1f04dfd3d695286;
var $49d40eaf9ca0cfa4$export$234fbd86ea0f0bd8;
var $49d40eaf9ca0cfa4$export$e795000978a75b12;
var $49d40eaf9ca0cfa4$export$9f4683b4d1018ace;
var $49d40eaf9ca0cfa4$export$e431b042fcdb1d63;
var $49d40eaf9ca0cfa4$export$a453239171ac9a23;
var $49d40eaf9ca0cfa4$export$3a7726a976c18d5f;
var $49d40eaf9ca0cfa4$export$7eca7a6c06843b93;
var $49d40eaf9ca0cfa4$export$f25c55f83e5b0672;
var $49d40eaf9ca0cfa4$export$9562bfac4eb079cb;
var $49d40eaf9ca0cfa4$export$c276d164ff91d2f7;
var $49d40eaf9ca0cfa4$export$2f3e0574f1a99754;
var $49d40eaf9ca0cfa4$export$15eecaab68167880;
var $49d40eaf9ca0cfa4$export$513c47f6e194086a;
var $49d40eaf9ca0cfa4$export$a3f464c4d5cd9096;
var $49d40eaf9ca0cfa4$export$ed366a03a2330b03;
var $49d40eaf9ca0cfa4$export$9b802c784f235e1d;
var $49d40eaf9ca0cfa4$export$add0fc8b8c5726a4;
var $49d40eaf9ca0cfa4$export$e7f32463f5bfd554;
var $49d40eaf9ca0cfa4$export$f9346f394edf26a;
var $49d40eaf9ca0cfa4$export$16b917774e73ef92;
var $49d40eaf9ca0cfa4$export$15d2b60bf3b65454;
var $49d40eaf9ca0cfa4$export$db55eca5af256142;
var $49d40eaf9ca0cfa4$export$967c74f8b1f3d35;
var $49d40eaf9ca0cfa4$export$7c33ae67962515d1;
var $49d40eaf9ca0cfa4$export$9c69839b2d93489b;
var $49d40eaf9ca0cfa4$export$be22d22d4b6cf5d8;
var $49d40eaf9ca0cfa4$export$c529961b911626ac;
var $49d40eaf9ca0cfa4$export$e39c4b15d2881f5;
var $49d40eaf9ca0cfa4$export$a8ca145161313e7;
var $49d40eaf9ca0cfa4$export$3c1204d03918d076;
var $49d40eaf9ca0cfa4$export$eaac3f141165e288;
var $49d40eaf9ca0cfa4$export$4c7e6934714150e6;
var $49d40eaf9ca0cfa4$export$6f71f9711d666eb4;
var $49d40eaf9ca0cfa4$export$2a3cd2bb71fb63a4;
var $49d40eaf9ca0cfa4$export$55478a0b7d2ae98f;
var $49d40eaf9ca0cfa4$export$bed10c4da9b8eb0a;
var $49d40eaf9ca0cfa4$export$a82607b6424c06c8;
var $49d40eaf9ca0cfa4$export$6b081f3484c7f4e5;
var $49d40eaf9ca0cfa4$export$b7754d85fd39406c;
var $49d40eaf9ca0cfa4$export$492856c046eb4728;
var $49d40eaf9ca0cfa4$export$c1678a2059fbe906;
var $49d40eaf9ca0cfa4$export$6d384a0bc1011c34;
var $49d40eaf9ca0cfa4$export$1499a7dbfc01e7d4;
var $49d40eaf9ca0cfa4$export$cfcbff40019f0ff1;
var $49d40eaf9ca0cfa4$export$27157b5f68e583af;
var $49d40eaf9ca0cfa4$export$54bf5ed61532925d;
var $49d40eaf9ca0cfa4$export$60ed0786292ace08;
var $49d40eaf9ca0cfa4$export$d770bfb8345e146;
var $49d40eaf9ca0cfa4$export$bb73817f1290ad28;
var $49d40eaf9ca0cfa4$export$f201c980f2b75802;
var $49d40eaf9ca0cfa4$export$b40e970572afd0ee;
var $49d40eaf9ca0cfa4$export$8850630a3d343488;
var $49d40eaf9ca0cfa4$export$fd0a39a918d6516f;
var $49d40eaf9ca0cfa4$export$e68ef41f8e0335bf;
var $49d40eaf9ca0cfa4$export$5bff09650e762829;
var $49d40eaf9ca0cfa4$export$21c1adce0e067f37;
var $49d40eaf9ca0cfa4$export$fed6ce86f48c84bc;
var $49d40eaf9ca0cfa4$export$500c2675137ac16e;
var $49d40eaf9ca0cfa4$export$402c7728623fd8df;
var $49d40eaf9ca0cfa4$export$15417259f4c0fe6b;
var $49d40eaf9ca0cfa4$export$2b3b7f579a727f45;
var $49d40eaf9ca0cfa4$export$514832a0b029734b;
var $49d40eaf9ca0cfa4$export$b0522e6a14dec1a4;
var $49d40eaf9ca0cfa4$export$659ea19f71a7ee0b;
var $49d40eaf9ca0cfa4$export$1b61d972db315e73;
var $49d40eaf9ca0cfa4$export$fb2970ee11a479ee;
var $49d40eaf9ca0cfa4$export$920aceb2a8fad77e;
var $49d40eaf9ca0cfa4$export$48f8f6fbc999d187;
var $49d40eaf9ca0cfa4$export$eed590fa00a8223b;
var $49d40eaf9ca0cfa4$export$f2e5bb5cd4a130da;
var $49d40eaf9ca0cfa4$export$779ef03d633a9086;
var $49d40eaf9ca0cfa4$export$d98b87c8d53d0dbc;
var $49d40eaf9ca0cfa4$export$ca719aa57653a0a7;
var $49d40eaf9ca0cfa4$export$74b19c5f48270c05;
var $49d40eaf9ca0cfa4$export$c351affe7e8098cb;
var $49d40eaf9ca0cfa4$export$be7cd6b3ae3ae765;
var $49d40eaf9ca0cfa4$export$ec182524c4c57275;
var $49d40eaf9ca0cfa4$export$9e45758246a85b07;
var $49d40eaf9ca0cfa4$export$9fa5d5f0144954cb;
var $49d40eaf9ca0cfa4$export$e66ba5bc4b978023;
var $49d40eaf9ca0cfa4$export$2306e23cc611a36d;
var $49d40eaf9ca0cfa4$export$144f8c1fe01428db;
var $49d40eaf9ca0cfa4$export$f303b2744d52121c;
var $49d40eaf9ca0cfa4$export$866b2dbc7bf18ce6;
var $49d40eaf9ca0cfa4$export$b4c85774878b4841;
var $49d40eaf9ca0cfa4$export$1c967a71bc9a3077;
var $49d40eaf9ca0cfa4$export$5e3884a35a19eb90;
var $49d40eaf9ca0cfa4$export$6e7ff99bb3259573;
var $49d40eaf9ca0cfa4$export$7c932cba2d9e7a7;
var $49d40eaf9ca0cfa4$export$94091942edce0667;
var $49d40eaf9ca0cfa4$export$3671a8a524706a9d;
var $49d40eaf9ca0cfa4$export$c288888dc82d233f;
var $49d40eaf9ca0cfa4$export$8ff188536cebc35;
var $49d40eaf9ca0cfa4$export$6407d78968c0eabe;
var $49d40eaf9ca0cfa4$export$43e9fb9ec28d9743;
var $49d40eaf9ca0cfa4$export$26f31d5c5c201739;
var $49d40eaf9ca0cfa4$export$bff85124d2d35b93;
var $49d40eaf9ca0cfa4$export$495c671ed5a6408c;
var $49d40eaf9ca0cfa4$export$54b3d4d5548c35c3;
var $49d40eaf9ca0cfa4$export$2954db6444fe1fa8;
var $49d40eaf9ca0cfa4$export$15c1c974d16dd678;
var $49d40eaf9ca0cfa4$export$9be2ae89a1eac217;
var $49d40eaf9ca0cfa4$export$5c698591c0e586a2;
var $49d40eaf9ca0cfa4$export$b711f2bb9c9a848a;
var $49d40eaf9ca0cfa4$export$1d3a8501efd30213;
var $49d40eaf9ca0cfa4$export$cebaf684ced5a2c9;
var $49d40eaf9ca0cfa4$export$d4c658ecdcb7c78c;
var $49d40eaf9ca0cfa4$export$b1b162b01baeb044;
var $49d40eaf9ca0cfa4$export$8be2d593d7f88ed8;
var $49d40eaf9ca0cfa4$export$dbd0a3528a97ccc0;
var $49d40eaf9ca0cfa4$export$66581dc6d3d083d1;
var $49d40eaf9ca0cfa4$export$e545f99e7abcc499;
var $49d40eaf9ca0cfa4$export$7e1af5787f8c4aaa;
var $49d40eaf9ca0cfa4$export$186c94c351c54768;
var $49d40eaf9ca0cfa4$export$2e3fd8dfcb16fe0c;
var $49d40eaf9ca0cfa4$export$7eeeceaa1dbd7cd5;
var $49d40eaf9ca0cfa4$export$9d5bffdff936d554;
var $49d40eaf9ca0cfa4$export$dc3a801c9a2c5b79;
var $49d40eaf9ca0cfa4$export$27933a9557f87e98;
var $49d40eaf9ca0cfa4$export$eefa737b40a0d535;
var $49d40eaf9ca0cfa4$export$92740ffbcb02553b;
var $49d40eaf9ca0cfa4$export$500e89753f9f1008;
var $49d40eaf9ca0cfa4$export$d91a18e47fdddefd;
var $49d40eaf9ca0cfa4$export$eccbe6f20884ea7f;
var $49d40eaf9ca0cfa4$export$9e24f11d79141afb;
var $49d40eaf9ca0cfa4$export$f0b96ad9586f8887;
var $49d40eaf9ca0cfa4$export$8a92ed5d436a85c6;
var $49d40eaf9ca0cfa4$export$edd59acdf7e86a71;
var $49d40eaf9ca0cfa4$export$ae81a1ae71952d50;
var $49d40eaf9ca0cfa4$export$6101470cd57eac1b;
var $49d40eaf9ca0cfa4$export$452c0aee9673fe67;
var $49d40eaf9ca0cfa4$export$773dddd1e8667756;
var $49d40eaf9ca0cfa4$export$98815f8579a64a90;
var $49d40eaf9ca0cfa4$export$7bc4e27428665019;
var $49d40eaf9ca0cfa4$export$e7d7477fa9057ee2;
var $49d40eaf9ca0cfa4$export$1f4267a3fc018448;
var $49d40eaf9ca0cfa4$export$c171cae150389952;
var $49d40eaf9ca0cfa4$export$d9bb35e957b22c72;
var $49d40eaf9ca0cfa4$export$b3508a2c95f74e3d;
var $49d40eaf9ca0cfa4$export$20bb272f4d21532d;
var $49d40eaf9ca0cfa4$export$d7e64fbd0102ce90;
var $49d40eaf9ca0cfa4$export$c17eae7e86dbba3c;
var $49d40eaf9ca0cfa4$export$349603c0a9165744;
var $49d40eaf9ca0cfa4$export$4dadf693741f0283;
var $49d40eaf9ca0cfa4$export$6377864d12f7eeb3;
var $49d40eaf9ca0cfa4$export$ba081af9585ed4;
var $49d40eaf9ca0cfa4$export$7841dacb241485d0;
var $49d40eaf9ca0cfa4$export$52c7044cf6301362;
var $49d40eaf9ca0cfa4$export$56ea1c9e44590e20;
var $49d40eaf9ca0cfa4$export$7626e389d05f4c36;
var $49d40eaf9ca0cfa4$export$5e0a48187329b2e7;
var $49d40eaf9ca0cfa4$export$c322b150d7667841;
var $49d40eaf9ca0cfa4$export$4a4797d3c962f753;
var $49d40eaf9ca0cfa4$export$767524d5e72e2645;
var $49d40eaf9ca0cfa4$export$497354ca7b0ee666;
var $49d40eaf9ca0cfa4$export$cbdc4ad11118116a;
var $49d40eaf9ca0cfa4$export$5b890de778c4c2fe;
var $49d40eaf9ca0cfa4$export$a78d9803b5e0a83e;
var $49d40eaf9ca0cfa4$export$df1b536467b3992a;
var $49d40eaf9ca0cfa4$export$73104a329e205998;
var $49d40eaf9ca0cfa4$export$5740e3da55330b0a;
var $49d40eaf9ca0cfa4$export$8dcc2d92ff6d65da;
var $49d40eaf9ca0cfa4$export$e5f1321e53e24810;
var $49d40eaf9ca0cfa4$export$56dd3098cbca7c8a;
var $49d40eaf9ca0cfa4$export$aa7aff70e4380665;
var $49d40eaf9ca0cfa4$export$dacb7d452aa6bcaf;
var $49d40eaf9ca0cfa4$export$15dfc6c5e8f9baf6;
var $49d40eaf9ca0cfa4$export$91ad03bba7909fb5;
var $49d40eaf9ca0cfa4$export$86128e6c0ab71d64;
var $49d40eaf9ca0cfa4$export$745b60c4819aec1d;
var $49d40eaf9ca0cfa4$export$d2c893bfac1da9a1;
var $49d40eaf9ca0cfa4$export$1c14ad02f9534b19;
var $49d40eaf9ca0cfa4$export$db3cb63e0594d014;
var $49d40eaf9ca0cfa4$export$a65c9a0eba2c222d;
var $49d40eaf9ca0cfa4$export$68dbcca9c0e339ec;
var $49d40eaf9ca0cfa4$export$d59b669d4bb3f006;
var $49d40eaf9ca0cfa4$export$4d88d347aa9667fc;
var $49d40eaf9ca0cfa4$export$9943ffdcaa4bc506;
var $49d40eaf9ca0cfa4$export$d4f25b923533dbba;
var $49d40eaf9ca0cfa4$export$35f3396a1cdeea45;
var $49d40eaf9ca0cfa4$export$80e399da474bc98d;
var $49d40eaf9ca0cfa4$export$e01809e2dbceac35;
var $49d40eaf9ca0cfa4$export$41900d5c4e8a9c68;
var $49d40eaf9ca0cfa4$export$362bb1cb0bb5ca03;
var $49d40eaf9ca0cfa4$export$6803ac54f919d9cc;
var $49d40eaf9ca0cfa4$export$72f5b47540331169;
var $49d40eaf9ca0cfa4$export$6c61a8c9aa5305cb;
var $49d40eaf9ca0cfa4$export$6b5244c457b68e65;
var $49d40eaf9ca0cfa4$export$b7bd0c9a886f3414;
var $49d40eaf9ca0cfa4$export$6b77f2bacac7c93d;
var $49d40eaf9ca0cfa4$export$ddbc15c0e8e8a7ea;
var $49d40eaf9ca0cfa4$export$feb4fe753df28a82;
var $49d40eaf9ca0cfa4$export$d6267756132e2175;
var $49d40eaf9ca0cfa4$export$570ac5a3fd7e6cc6;
var $49d40eaf9ca0cfa4$export$5b9a0015e1c530ed;
var $49d40eaf9ca0cfa4$export$8bbff71c84508218;
var $49d40eaf9ca0cfa4$export$b55aa07a514a2430;
var $49d40eaf9ca0cfa4$export$9927ad09f7c084dc;
var $49d40eaf9ca0cfa4$export$52a07a35ff8ec6b6;
var $49d40eaf9ca0cfa4$export$a10d277c42e6cae3;
var $49d40eaf9ca0cfa4$export$cdc0ce5c66182801;
var $49d40eaf9ca0cfa4$export$2504d4bd698dd962;
var $49d40eaf9ca0cfa4$export$9dc86f3b876e96ef;
var $49d40eaf9ca0cfa4$export$70ff7865f52549ae;
var $49d40eaf9ca0cfa4$export$f77b53a42be6e6fd;
var $49d40eaf9ca0cfa4$export$818eb7ab11414506;
var $49d40eaf9ca0cfa4$export$829ef6b2e59d984d;
var $49d40eaf9ca0cfa4$export$b30f4cb52c088a26;
var $49d40eaf9ca0cfa4$export$335eace0ff1771cd;
var $49d40eaf9ca0cfa4$export$374d88a2025416ac;
var $49d40eaf9ca0cfa4$export$bb7a91303551eb37;
var $49d40eaf9ca0cfa4$export$f132ea291a7db56b;
var $49d40eaf9ca0cfa4$export$f0abd4170bbd2468;
var $49d40eaf9ca0cfa4$export$50d00a157dc08581;
var $49d40eaf9ca0cfa4$export$484576567a98833f;
var $49d40eaf9ca0cfa4$export$ec9e491e475d0c97;
var $49d40eaf9ca0cfa4$export$a86c59c10992220f;
var $49d40eaf9ca0cfa4$export$e12f06597e992fde;
var $49d40eaf9ca0cfa4$export$7ec54678ba28ea59;
var $49d40eaf9ca0cfa4$export$433ba14c16717110;
var $49d40eaf9ca0cfa4$export$309ee349b8a537f;
var $49d40eaf9ca0cfa4$export$b87f371cbc396fcf;
var $49d40eaf9ca0cfa4$export$60050fc49fe0e7e2;
var $49d40eaf9ca0cfa4$export$348c8e2b37f276cd;
var $49d40eaf9ca0cfa4$export$7f47e8a8b2d97cb2;
var $49d40eaf9ca0cfa4$export$50d5adc4b543ce95;
var $49d40eaf9ca0cfa4$export$9221f1d2c934d9f;
var $49d40eaf9ca0cfa4$export$3a56578b3ae09a02;
var $49d40eaf9ca0cfa4$export$e47b8dab9466c895;
var $49d40eaf9ca0cfa4$export$4ca52f75cf4889c5;
var $49d40eaf9ca0cfa4$export$7343d7d72195067f;
var $49d40eaf9ca0cfa4$export$f334f32f8d4d8063;
var $49d40eaf9ca0cfa4$export$c7bf2089e89a217c;
var $49d40eaf9ca0cfa4$export$f514f97553a434b2;
var $49d40eaf9ca0cfa4$export$61abde59b50deb8e;
var $49d40eaf9ca0cfa4$export$5a5ce44f9fb51f93;
var $49d40eaf9ca0cfa4$export$7044ea8d89b6f59d;
var $49d40eaf9ca0cfa4$export$40eacf1a072c9dbd;
var $49d40eaf9ca0cfa4$export$4c1fa0ac0eff2ac;
var $49d40eaf9ca0cfa4$export$5bee9450fe31dde1;
var $49d40eaf9ca0cfa4$export$d0b571fb4406d953;
var $49d40eaf9ca0cfa4$export$258b370e6c2b85d5;
var $49d40eaf9ca0cfa4$export$dc5e5523da291a4b;
var $49d40eaf9ca0cfa4$export$fd5a8904ab5abfe0;
var $49d40eaf9ca0cfa4$export$1350d8937b0f26fb;
var $49d40eaf9ca0cfa4$export$2a045f777fb349a8;
var $49d40eaf9ca0cfa4$export$8bb874585539a88f;
var $49d40eaf9ca0cfa4$export$17d3a50785727199;
var $49d40eaf9ca0cfa4$export$2931c570009689e;
var $49d40eaf9ca0cfa4$export$199cbcedee735a43;
var $49d40eaf9ca0cfa4$export$4ba5bf9d4e3ed862;
var $49d40eaf9ca0cfa4$export$674c01ec2f0b89c3;
var $49d40eaf9ca0cfa4$export$bda1686739fd61c7;
var $49d40eaf9ca0cfa4$export$8d804148f485d54c;
var $49d40eaf9ca0cfa4$export$212a8f1ea37518bd;
var $49d40eaf9ca0cfa4$export$c9ac0fee28245883;
var $49d40eaf9ca0cfa4$export$77078610759fe5f6;
var $49d40eaf9ca0cfa4$export$7c6317deeec7a6c1;
var $49d40eaf9ca0cfa4$export$877ebf2e4ad81f03;
var $49d40eaf9ca0cfa4$export$70b2343945496e1f;
var $49d40eaf9ca0cfa4$export$8415b56d2c6d2b1d;
var $49d40eaf9ca0cfa4$export$cc81114a03caab18;
var $49d40eaf9ca0cfa4$export$bc14eb892daceb23;
var $49d40eaf9ca0cfa4$export$3c973217450c3e9d;
var $49d40eaf9ca0cfa4$export$582c0b730ff1ddb9;
var $49d40eaf9ca0cfa4$export$b3edfb545b65f1c5;
var $49d40eaf9ca0cfa4$export$2593317d8731841c;
var $49d40eaf9ca0cfa4$export$8bb5bc1732aa41f;
var $49d40eaf9ca0cfa4$export$74a79c98b110b5b9;
var $49d40eaf9ca0cfa4$export$26461b03281b4db4;
var $49d40eaf9ca0cfa4$export$eaea590d6d3dd93c;
var $49d40eaf9ca0cfa4$export$af45365f70099379;
var $49d40eaf9ca0cfa4$export$a49e732d34d5ba9b;
var $49d40eaf9ca0cfa4$export$7c147fe246bc8bd3;
var $49d40eaf9ca0cfa4$export$e5111b6070e1ee9e;
var $49d40eaf9ca0cfa4$export$591cbfd403f8c8d;
var $49d40eaf9ca0cfa4$export$b1388db955bbb885;
var $49d40eaf9ca0cfa4$export$e898d0e9e211abd9;
var $49d40eaf9ca0cfa4$export$ab6fee0e8a6ee069;
var $49d40eaf9ca0cfa4$export$9786ad94c199ffbb;
var $49d40eaf9ca0cfa4$export$269890524eed693b;
var $49d40eaf9ca0cfa4$export$2ec623a8212d6b64;
var $49d40eaf9ca0cfa4$export$30e7673b01ff994e;
var $49d40eaf9ca0cfa4$export$9ea93477840812bf;
var $49d40eaf9ca0cfa4$export$a6da0c365670c430;
var $49d40eaf9ca0cfa4$export$7986b22da43f2885;
var $49d40eaf9ca0cfa4$export$a9f943c7ceb3b42f;
var $49d40eaf9ca0cfa4$export$dfe49501efcdffce;
var $49d40eaf9ca0cfa4$export$be465f50c92eb01d;
var $49d40eaf9ca0cfa4$export$c138d1796bb34999;
var $49d40eaf9ca0cfa4$export$85a0016690a0ccf2;
var $49d40eaf9ca0cfa4$export$883acab36ede4bfa;
var $49d40eaf9ca0cfa4$export$9cfc88d203f9cdf1;
var $49d40eaf9ca0cfa4$export$b3c6c599110d7bab;
var $49d40eaf9ca0cfa4$export$247839c65766758;
var $49d40eaf9ca0cfa4$export$f4d52b02df927d54;
var $49d40eaf9ca0cfa4$export$df30ee8c5b5f1989;
var $49d40eaf9ca0cfa4$export$268a117c860fca6d;
"use strict";
const $49d40eaf9ca0cfa4$var$AI_CITATIONS = "ai.citations", $49d40eaf9ca0cfa4$var$AI_COMPLETION_TOKENS_USED = "ai.completion_tokens.used", $49d40eaf9ca0cfa4$var$AI_DOCUMENTS = "ai.documents", $49d40eaf9ca0cfa4$var$AI_FINISH_REASON = "ai.finish_reason", $49d40eaf9ca0cfa4$var$AI_FREQUENCY_PENALTY = "ai.frequency_penalty", $49d40eaf9ca0cfa4$var$AI_FUNCTION_CALL = "ai.function_call", $49d40eaf9ca0cfa4$var$AI_GENERATION_ID = "ai.generation_id", $49d40eaf9ca0cfa4$var$AI_INPUT_MESSAGES = "ai.input_messages", $49d40eaf9ca0cfa4$var$AI_IS_SEARCH_REQUIRED = "ai.is_search_required", $49d40eaf9ca0cfa4$var$AI_METADATA = "ai.metadata", $49d40eaf9ca0cfa4$var$AI_MODEL_ID = "ai.model_id", $49d40eaf9ca0cfa4$var$AI_MODEL_PROVIDER = "ai.model.provider", $49d40eaf9ca0cfa4$var$AI_PIPELINE_NAME = "ai.pipeline.name", $49d40eaf9ca0cfa4$var$AI_PREAMBLE = "ai.preamble", $49d40eaf9ca0cfa4$var$AI_PRESENCE_PENALTY = "ai.presence_penalty", $49d40eaf9ca0cfa4$var$AI_PROMPT_TOKENS_USED = "ai.prompt_tokens.used", $49d40eaf9ca0cfa4$var$AI_RAW_PROMPTING = "ai.raw_prompting", $49d40eaf9ca0cfa4$var$AI_RESPONSES = "ai.responses", $49d40eaf9ca0cfa4$var$AI_RESPONSE_FORMAT = "ai.response_format", $49d40eaf9ca0cfa4$var$AI_SEARCH_QUERIES = "ai.search_queries", $49d40eaf9ca0cfa4$var$AI_SEARCH_RESULTS = "ai.search_results", $49d40eaf9ca0cfa4$var$AI_SEED = "ai.seed", $49d40eaf9ca0cfa4$var$AI_STREAMING = "ai.streaming", $49d40eaf9ca0cfa4$var$AI_TAGS = "ai.tags", $49d40eaf9ca0cfa4$var$AI_TEMPERATURE = "ai.temperature", $49d40eaf9ca0cfa4$var$AI_TEXTS = "ai.texts", $49d40eaf9ca0cfa4$var$AI_TOOLS = "ai.tools", $49d40eaf9ca0cfa4$var$AI_TOOL_CALLS = "ai.tool_calls", $49d40eaf9ca0cfa4$var$AI_TOP_K = "ai.top_k", $49d40eaf9ca0cfa4$var$AI_TOP_P = "ai.top_p", $49d40eaf9ca0cfa4$var$AI_TOTAL_COST = "ai.total_cost", $49d40eaf9ca0cfa4$var$AI_TOTAL_TOKENS_USED = "ai.total_tokens.used", $49d40eaf9ca0cfa4$var$AI_WARNINGS = "ai.warnings", $49d40eaf9ca0cfa4$var$ANGULAR_VERSION = "angular.version", $49d40eaf9ca0cfa4$var$APP_APP_BUILD = "app.app_build", $49d40eaf9ca0cfa4$var$APP_APP_IDENTIFIER = "app.app_identifier", $49d40eaf9ca0cfa4$var$APP_APP_NAME = "app.app_name", $49d40eaf9ca0cfa4$var$APP_APP_START_TIME = "app.app_start_time", $49d40eaf9ca0cfa4$var$APP_APP_VERSION = "app.app_version", $49d40eaf9ca0cfa4$var$APP_BUILD = "app.build", $49d40eaf9ca0cfa4$var$APP_IDENTIFIER = "app.identifier", $49d40eaf9ca0cfa4$var$APP_IN_FOREGROUND = "app.in_foreground", $49d40eaf9ca0cfa4$var$APP_NAME = "app.name", $49d40eaf9ca0cfa4$var$APP_START_COLD = "app_start_cold", $49d40eaf9ca0cfa4$var$APP_START_TIME = "app.start_time", $49d40eaf9ca0cfa4$var$APP_START_TYPE = "app_start_type", $49d40eaf9ca0cfa4$var$APP_START_WARM = "app_start_warm", $49d40eaf9ca0cfa4$var$APP_VERSION = "app.version", $49d40eaf9ca0cfa4$var$APP_VITALS_FRAMES_DELAY_VALUE = "app.vitals.frames.delay.value", $49d40eaf9ca0cfa4$var$APP_VITALS_FRAMES_FROZEN_COUNT = "app.vitals.frames.frozen.count", $49d40eaf9ca0cfa4$var$APP_VITALS_FRAMES_SLOW_COUNT = "app.vitals.frames.slow.count", $49d40eaf9ca0cfa4$var$APP_VITALS_FRAMES_TOTAL_COUNT = "app.vitals.frames.total.count", $49d40eaf9ca0cfa4$var$APP_VITALS_START_COLD_VALUE = "app.vitals.start.cold.value", $49d40eaf9ca0cfa4$var$APP_VITALS_START_PREWARMED = "app.vitals.start.prewarmed", $49d40eaf9ca0cfa4$var$APP_VITALS_START_REASON = "app.vitals.start.reason", $49d40eaf9ca0cfa4$var$APP_VITALS_START_SCREEN = "app.vitals.start.screen", $49d40eaf9ca0cfa4$var$APP_VITALS_START_TYPE = "app.vitals.start.type", $49d40eaf9ca0cfa4$var$APP_VITALS_START_WARM_VALUE = "app.vitals.start.warm.value", $49d40eaf9ca0cfa4$var$APP_VITALS_TTFD_VALUE = "app.vitals.ttfd.value", $49d40eaf9ca0cfa4$var$APP_VITALS_TTID_VALUE = "app.vitals.ttid.value", $49d40eaf9ca0cfa4$var$ART_GC_BLOCKING_COUNT = "art.gc.blocking_count", $49d40eaf9ca0cfa4$var$ART_GC_BLOCKING_TIME = "art.gc.blocking_time", $49d40eaf9ca0cfa4$var$ART_GC_PRE_OOME_COUNT = "art.gc.pre_oome_count", $49d40eaf9ca0cfa4$var$ART_GC_TOTAL_COUNT = "art.gc.total_count", $49d40eaf9ca0cfa4$var$ART_GC_TOTAL_TIME = "art.gc.total_time", $49d40eaf9ca0cfa4$var$ART_GC_WAITING_TIME = "art.gc.waiting_time", $49d40eaf9ca0cfa4$var$ART_MEMORY_FREE = "art.memory.free", $49d40eaf9ca0cfa4$var$ART_MEMORY_FREE_UNTIL_GC = "art.memory.free_until_gc", $49d40eaf9ca0cfa4$var$ART_MEMORY_FREE_UNTIL_OOME = "art.memory.free_until_oome", $49d40eaf9ca0cfa4$var$ART_MEMORY_MAX = "art.memory.max", $49d40eaf9ca0cfa4$var$ART_MEMORY_TOTAL = "art.memory.total", $49d40eaf9ca0cfa4$var$AWS_CLOUDWATCH_LOGS_LOG_GROUP = "aws.cloudwatch.logs.log_group", $49d40eaf9ca0cfa4$var$AWS_CLOUDWATCH_LOGS_LOG_STREAM = "aws.cloudwatch.logs.log_stream", $49d40eaf9ca0cfa4$var$AWS_CLOUDWATCH_LOGS_URL = "aws.cloudwatch.logs.url", $49d40eaf9ca0cfa4$var$AWS_DYNAMODB_ATTRIBUTE_DEFINITIONS = "aws.dynamodb.attribute_definitions", $49d40eaf9ca0cfa4$var$AWS_DYNAMODB_CONSISTENT_READ = "aws.dynamodb.consistent_read", $49d40eaf9ca0cfa4$var$AWS_DYNAMODB_CONSUMED_CAPACITY = "aws.dynamodb.consumed_capacity", $49d40eaf9ca0cfa4$var$AWS_DYNAMODB_COUNT = "aws.dynamodb.count", $49d40eaf9ca0cfa4$var$AWS_DYNAMODB_EXCLUSIVE_START_TABLE = "aws.dynamodb.exclusive_start_table", $49d40eaf9ca0cfa4$var$AWS_DYNAMODB_GLOBAL_SECONDARY_INDEXES = "aws.dynamodb.global_secondary_indexes", $49d40eaf9ca0cfa4$var$AWS_DYNAMODB_GLOBAL_SECONDARY_INDEX_UPDATES = "aws.dynamodb.global_secondary_index_updates", $49d40eaf9ca0cfa4$var$AWS_DYNAMODB_INDEX_NAME = "aws.dynamodb.index_name", $49d40eaf9ca0cfa4$var$AWS_DYNAMODB_ITEM_COLLECTION_METRICS = "aws.dynamodb.item_collection_metrics", $49d40eaf9ca0cfa4$var$AWS_DYNAMODB_LIMIT = "aws.dynamodb.limit", $49d40eaf9ca0cfa4$var$AWS_DYNAMODB_LOCAL_SECONDARY_INDEXES = "aws.dynamodb.local_secondary_indexes", $49d40eaf9ca0cfa4$var$AWS_DYNAMODB_PROJECTION = "aws.dynamodb.projection", $49d40eaf9ca0cfa4$var$AWS_DYNAMODB_PROVISIONED_READ_CAPACITY = "aws.dynamodb.provisioned_read_capacity", $49d40eaf9ca0cfa4$var$AWS_DYNAMODB_PROVISIONED_WRITE_CAPACITY = "aws.dynamodb.provisioned_write_capacity", $49d40eaf9ca0cfa4$var$AWS_DYNAMODB_SCANNED_COUNT = "aws.dynamodb.scanned_count", $49d40eaf9ca0cfa4$var$AWS_DYNAMODB_SCAN_FORWARD = "aws.dynamodb.scan_forward", $49d40eaf9ca0cfa4$var$AWS_DYNAMODB_SEGMENT = "aws.dynamodb.segment", $49d40eaf9ca0cfa4$var$AWS_DYNAMODB_SELECT = "aws.dynamodb.select", $49d40eaf9ca0cfa4$var$AWS_DYNAMODB_TABLE_COUNT = "aws.dynamodb.table_count", $49d40eaf9ca0cfa4$var$AWS_DYNAMODB_TABLE_NAMES = "aws.dynamodb.table_names", $49d40eaf9ca0cfa4$var$AWS_DYNAMODB_TOTAL_SEGMENTS = "aws.dynamodb.total_segments", $49d40eaf9ca0cfa4$var$AWS_EXTENDED_REQUEST_ID = "aws.extended_request_id", $49d40eaf9ca0cfa4$var$AWS_KINESIS_STREAM_NAME = "aws.kinesis.stream_name", $49d40eaf9ca0cfa4$var$_AWS_KINESIS_STREAM_NAME = "aws.kinesis.stream.name", $49d40eaf9ca0cfa4$var$AWS_LAMBDA_AWS_REQUEST_ID = "aws.lambda.aws_request_id", $49d40eaf9ca0cfa4$var$AWS_LAMBDA_EXECUTION_DURATION_IN_MILLIS = "aws.lambda.execution_duration_in_millis", $49d40eaf9ca0cfa4$var$AWS_LAMBDA_FUNCTION_NAME = "aws.lambda.function_name", $49d40eaf9ca0cfa4$var$AWS_LAMBDA_FUNCTION_VERSION = "aws.lambda.function_version", $49d40eaf9ca0cfa4$var$AWS_LAMBDA_INVOKED_ARN = "aws.lambda.invoked_arn", $49d40eaf9ca0cfa4$var$AWS_LAMBDA_INVOKED_FUNCTION_ARN = "aws.lambda.invoked_function_arn", $49d40eaf9ca0cfa4$var$AWS_LAMBDA_REMAINING_TIME_IN_MILLIS = "aws.lambda.remaining_time_in_millis", $49d40eaf9ca0cfa4$var$AWS_LOG_GROUP_NAMES = "aws.log.group.names", $49d40eaf9ca0cfa4$var$AWS_LOG_STREAM_NAMES = "aws.log.stream.names", $49d40eaf9ca0cfa4$var$AWS_REQUEST_EXTENDED_ID = "aws.request.extended_id", $49d40eaf9ca0cfa4$var$AWS_REQUEST_ID = "aws.request_id", $49d40eaf9ca0cfa4$var$_AWS_REQUEST_ID = "aws.request.id", $49d40eaf9ca0cfa4$var$AWS_S3_BUCKET = "aws.s3.bucket", $49d40eaf9ca0cfa4$var$AWS_SECRETSMANAGER_SECRET_ARN = "aws.secretsmanager.secret.arn", $49d40eaf9ca0cfa4$var$AWS_SNS_TOPIC_ARN = "aws.sns.topic.arn", $49d40eaf9ca0cfa4$var$AWS_STEP_FUNCTIONS_ACTIVITY_ARN = "aws.step_functions.activity.arn", $49d40eaf9ca0cfa4$var$AWS_STEP_FUNCTIONS_STATE_MACHINE_ARN = "aws.step_functions.state_machine.arn", $49d40eaf9ca0cfa4$var$BLOCKED_MAIN_THREAD = "blocked_main_thread", $49d40eaf9ca0cfa4$var$BROWSER_NAME = "browser.name", $49d40eaf9ca0cfa4$var$BROWSER_PERFORMANCE_NAVIGATION_ACTIVATION_START = "browser.performance.navigation.activation_start", $49d40eaf9ca0cfa4$var$BROWSER_PERFORMANCE_TIME_ORIGIN = "browser.performance.time_origin", $49d40eaf9ca0cfa4$var$BROWSER_REPORT_TYPE = "browser.report.type", $49d40eaf9ca0cfa4$var$BROWSER_SCRIPT_INVOKER = "browser.script.invoker", $49d40eaf9ca0cfa4$var$BROWSER_SCRIPT_INVOKER_TYPE = "browser.script.invoker_type", $49d40eaf9ca0cfa4$var$BROWSER_SCRIPT_SOURCE_CHAR_POSITION = "browser.script.source_char_position", $49d40eaf9ca0cfa4$var$BROWSER_VERSION = "browser.version", $49d40eaf9ca0cfa4$var$BROWSER_WEB_VITAL_CLS_REPORT_EVENT = "browser.web_vital.cls.report_event", $49d40eaf9ca0cfa4$var$BROWSER_WEB_VITAL_CLS_SOURCE_KEY = "browser.web_vital.cls.source.<key>", $49d40eaf9ca0cfa4$var$BROWSER_WEB_VITAL_CLS_SOURCE_KEY_BASE = "browser.web_vital.cls.source", $49d40eaf9ca0cfa4$var$BROWSER_WEB_VITAL_CLS_VALUE = "browser.web_vital.cls.value", $49d40eaf9ca0cfa4$var$BROWSER_WEB_VITAL_FCP_VALUE = "browser.web_vital.fcp.value", $49d40eaf9ca0cfa4$var$BROWSER_WEB_VITAL_FP_VALUE = "browser.web_vital.fp.value", $49d40eaf9ca0cfa4$var$BROWSER_WEB_VITAL_INP_VALUE = "browser.web_vital.inp.value", $49d40eaf9ca0cfa4$var$BROWSER_WEB_VITAL_LCP_ELEMENT = "browser.web_vital.lcp.element", $49d40eaf9ca0cfa4$var$BROWSER_WEB_VITAL_LCP_ID = "browser.web_vital.lcp.id", $49d40eaf9ca0cfa4$var$BROWSER_WEB_VITAL_LCP_LOAD_TIME = "browser.web_vital.lcp.load_time", $49d40eaf9ca0cfa4$var$BROWSER_WEB_VITAL_LCP_RENDER_TIME = "browser.web_vital.lcp.render_time", $49d40eaf9ca0cfa4$var$BROWSER_WEB_VITAL_LCP_REPORT_EVENT = "browser.web_vital.lcp.report_event", $49d40eaf9ca0cfa4$var$BROWSER_WEB_VITAL_LCP_SIZE = "browser.web_vital.lcp.size", $49d40eaf9ca0cfa4$var$BROWSER_WEB_VITAL_LCP_URL = "browser.web_vital.lcp.url", $49d40eaf9ca0cfa4$var$BROWSER_WEB_VITAL_LCP_VALUE = "browser.web_vital.lcp.value", $49d40eaf9ca0cfa4$var$BROWSER_WEB_VITAL_TTFB_REQUEST_TIME = "browser.web_vital.ttfb.request_time", $49d40eaf9ca0cfa4$var$BROWSER_WEB_VITAL_TTFB_VALUE = "browser.web_vital.ttfb.value", $49d40eaf9ca0cfa4$var$CACHE_HIT = "cache.hit", $49d40eaf9ca0cfa4$var$CACHE_ITEM_SIZE = "cache.item_size", $49d40eaf9ca0cfa4$var$CACHE_KEY = "cache.key", $49d40eaf9ca0cfa4$var$CACHE_OPERATION = "cache.operation", $49d40eaf9ca0cfa4$var$CACHE_TTL = "cache.ttl", $49d40eaf9ca0cfa4$var$CACHE_WRITE = "cache.write", $49d40eaf9ca0cfa4$var$CHANNEL = "channel", $49d40eaf9ca0cfa4$var$CLIENT_ADDRESS = "client.address", $49d40eaf9ca0cfa4$var$CLIENT_PORT = "client.port", $49d40eaf9ca0cfa4$var$CLOUDFLARE_D1_DURATION = "cloudflare.d1.duration", $49d40eaf9ca0cfa4$var$CLOUDFLARE_D1_QUERY_TYPE = "cloudflare.d1.query_type", $49d40eaf9ca0cfa4$var$CLOUDFLARE_D1_ROWS_READ = "cloudflare.d1.rows_read", $49d40eaf9ca0cfa4$var$CLOUDFLARE_D1_ROWS_WRITTEN = "cloudflare.d1.rows_written", $49d40eaf9ca0cfa4$var$CLOUDFLARE_DURABLE_OBJECT_QUERY_BINDINGS = "cloudflare.durable_object.query.bindings", $49d40eaf9ca0cfa4$var$CLOUDFLARE_DURABLE_OBJECT_RESPONSE_ROWS_READ = "cloudflare.durable_object.response.rows_read", $49d40eaf9ca0cfa4$var$CLOUDFLARE_DURABLE_OBJECT_RESPONSE_ROWS_WRITTEN = "cloudflare.durable_object.response.rows_written", $49d40eaf9ca0cfa4$var$CLOUDFLARE_R2_BUCKET = "cloudflare.r2.bucket", $49d40eaf9ca0cfa4$var$CLOUDFLARE_R2_OPERATION = "cloudflare.r2.operation", $49d40eaf9ca0cfa4$var$CLOUDFLARE_R2_REQUEST_DELIMITER = "cloudflare.r2.request.delimiter", $49d40eaf9ca0cfa4$var$CLOUDFLARE_R2_REQUEST_KEY = "cloudflare.r2.request.key", $49d40eaf9ca0cfa4$var$CLOUDFLARE_R2_REQUEST_PART_NUMBER = "cloudflare.r2.request.part_number", $49d40eaf9ca0cfa4$var$CLOUDFLARE_R2_REQUEST_PREFIX = "cloudflare.r2.request.prefix", $49d40eaf9ca0cfa4$var$CLOUDFLARE_WORKFLOW_ATTEMPT = "cloudflare.workflow.attempt", $49d40eaf9ca0cfa4$var$CLOUDFLARE_WORKFLOW_RETRIES_BACKOFF = "cloudflare.workflow.retries.backoff", $49d40eaf9ca0cfa4$var$CLOUDFLARE_WORKFLOW_RETRIES_DELAY = "cloudflare.workflow.retries.delay", $49d40eaf9ca0cfa4$var$CLOUDFLARE_WORKFLOW_RETRIES_LIMIT = "cloudflare.workflow.retries.limit", $49d40eaf9ca0cfa4$var$CLOUDFLARE_WORKFLOW_TIMEOUT = "cloudflare.workflow.timeout", $49d40eaf9ca0cfa4$var$CLOUD_ACCOUNT_ID = "cloud.account.id", $49d40eaf9ca0cfa4$var$CLOUD_AVAILABILITY_ZONE = "cloud.availability_zone", $49d40eaf9ca0cfa4$var$CLOUD_PLATFORM = "cloud.platform", $49d40eaf9ca0cfa4$var$CLOUD_PROVIDER = "cloud.provider", $49d40eaf9ca0cfa4$var$CLOUD_REGION = "cloud.region", $49d40eaf9ca0cfa4$var$CLOUD_RESOURCE_ID = "cloud.resource_id", $49d40eaf9ca0cfa4$var$CLS = "cls", $49d40eaf9ca0cfa4$var$CLS_SOURCE_KEY = "cls.source.<key>", $49d40eaf9ca0cfa4$var$CLS_SOURCE_KEY_BASE = "cls.source", $49d40eaf9ca0cfa4$var$CODE_FILEPATH = "code.filepath", $49d40eaf9ca0cfa4$var$CODE_FILE_PATH = "code.file.path", $49d40eaf9ca0cfa4$var$CODE_FUNCTION = "code.function", $49d40eaf9ca0cfa4$var$CODE_FUNCTION_NAME = "code.function.name", $49d40eaf9ca0cfa4$var$CODE_LINENO = "code.lineno", $49d40eaf9ca0cfa4$var$CODE_LINE_NUMBER = "code.line.number", $49d40eaf9ca0cfa4$var$CODE_NAMESPACE = "code.namespace", $49d40eaf9ca0cfa4$var$CONNECTIONTYPE = "connectionType", $49d40eaf9ca0cfa4$var$CONNECTION_RTT = "connection.rtt", $49d40eaf9ca0cfa4$var$CULTURE_CALENDAR = "culture.calendar", $49d40eaf9ca0cfa4$var$CULTURE_DISPLAY_NAME = "culture.display_name", $49d40eaf9ca0cfa4$var$CULTURE_IS_24_HOUR_FORMAT = "culture.is_24_hour_format", $49d40eaf9ca0cfa4$var$CULTURE_LOCALE = "culture.locale", $49d40eaf9ca0cfa4$var$CULTURE_TIMEZONE = "culture.timezone", $49d40eaf9ca0cfa4$var$DB_COLLECTION_NAME = "db.collection.name", $49d40eaf9ca0cfa4$var$DB_DRIVER_NAME = "db.driver.name", $49d40eaf9ca0cfa4$var$DB_NAME = "db.name", $49d40eaf9ca0cfa4$var$DB_NAMESPACE = "db.namespace", $49d40eaf9ca0cfa4$var$DB_OPERATION = "db.operation", $49d40eaf9ca0cfa4$var$DB_OPERATION_BATCH_SIZE = "db.operation.batch.size", $49d40eaf9ca0cfa4$var$DB_OPERATION_NAME = "db.operation.name", $49d40eaf9ca0cfa4$var$DB_QUERY_PARAMETER_KEY = "db.query.parameter.<key>", $49d40eaf9ca0cfa4$var$DB_QUERY_PARAMETER_KEY_BASE = "db.query.parameter", $49d40eaf9ca0cfa4$var$DB_QUERY_SUMMARY = "db.query.summary", $49d40eaf9ca0cfa4$var$DB_QUERY_TEXT = "db.query.text", $49d40eaf9ca0cfa4$var$DB_REDIS_CONNECTION = "db.redis.connection", $49d40eaf9ca0cfa4$var$DB_REDIS_KEY = "db.redis.key", $49d40eaf9ca0cfa4$var$DB_REDIS_PARAMETERS = "db.redis.parameters", $49d40eaf9ca0cfa4$var$DB_RESPONSE_STATUS_CODE = "db.response.status_code", $49d40eaf9ca0cfa4$var$DB_SQL_BINDINGS = "db.sql.bindings", $49d40eaf9ca0cfa4$var$DB_STATEMENT = "db.statement", $49d40eaf9ca0cfa4$var$DB_STORED_PROCEDURE_NAME = "db.stored_procedure.name", $49d40eaf9ca0cfa4$var$DB_SYSTEM = "db.system", $49d40eaf9ca0cfa4$var$DB_SYSTEM_NAME = "db.system.name", $49d40eaf9ca0cfa4$var$DB_USER = "db.user", $49d40eaf9ca0cfa4$var$DEVICEMEMORY = "deviceMemory", $49d40eaf9ca0cfa4$var$DEVICE_ARCHS = "device.archs", $49d40eaf9ca0cfa4$var$DEVICE_BATTERY_LEVEL = "device.battery_level", $49d40eaf9ca0cfa4$var$DEVICE_BATTERY_TEMPERATURE = "device.battery_temperature", $49d40eaf9ca0cfa4$var$DEVICE_BOOT_TIME = "device.boot_time", $49d40eaf9ca0cfa4$var$DEVICE_BRAND = "device.brand", $49d40eaf9ca0cfa4$var$DEVICE_CHARGING = "device.charging", $49d40eaf9ca0cfa4$var$DEVICE_CHIPSET = "device.chipset", $49d40eaf9ca0cfa4$var$DEVICE_CLASS = "device.class", $49d40eaf9ca0cfa4$var$DEVICE_CONNECTION_TYPE = "device.connection_type", $49d40eaf9ca0cfa4$var$DEVICE_CPU_DESCRIPTION = "device.cpu_description", $49d40eaf9ca0cfa4$var$DEVICE_EXTERNAL_FREE_STORAGE = "device.external_free_storage", $49d40eaf9ca0cfa4$var$DEVICE_EXTERNAL_STORAGE_SIZE = "device.external_storage_size", $49d40eaf9ca0cfa4$var$DEVICE_FAMILY = "device.family", $49d40eaf9ca0cfa4$var$DEVICE_FREE_MEMORY = "device.free_memory", $49d40eaf9ca0cfa4$var$DEVICE_FREE_STORAGE = "device.free_storage", $49d40eaf9ca0cfa4$var$DEVICE_ID = "device.id", $49d40eaf9ca0cfa4$var$DEVICE_LOCALE = "device.locale", $49d40eaf9ca0cfa4$var$DEVICE_LOW_MEMORY = "device.low_memory", $49d40eaf9ca0cfa4$var$DEVICE_LOW_POWER_MODE = "device.low_power_mode", $49d40eaf9ca0cfa4$var$DEVICE_MANUFACTURER = "device.manufacturer", $49d40eaf9ca0cfa4$var$DEVICE_MEMORY_ESTIMATED_CAPACITY = "device.memory.estimated_capacity", $49d40eaf9ca0cfa4$var$DEVICE_MEMORY_SIZE = "device.memory_size", $49d40eaf9ca0cfa4$var$DEVICE_MODEL = "device.model", $49d40eaf9ca0cfa4$var$DEVICE_MODEL_ID = "device.model_id", $49d40eaf9ca0cfa4$var$DEVICE_NAME = "device.name", $49d40eaf9ca0cfa4$var$DEVICE_ONLINE = "device.online", $49d40eaf9ca0cfa4$var$DEVICE_ORIENTATION = "device.orientation", $49d40eaf9ca0cfa4$var$DEVICE_PROCESSOR_COUNT = "device.processor_count", $49d40eaf9ca0cfa4$var$DEVICE_PROCESSOR_FREQUENCY = "device.processor_frequency", $49d40eaf9ca0cfa4$var$DEVICE_SCREEN_DENSITY = "device.screen_density", $49d40eaf9ca0cfa4$var$DEVICE_SCREEN_DPI = "device.screen_dpi", $49d40eaf9ca0cfa4$var$DEVICE_SCREEN_HEIGHT_PIXELS = "device.screen_height_pixels", $49d40eaf9ca0cfa4$var$DEVICE_SCREEN_WIDTH_PIXELS = "device.screen_width_pixels", $49d40eaf9ca0cfa4$var$DEVICE_SIMULATOR = "device.simulator", $49d40eaf9ca0cfa4$var$DEVICE_STORAGE_SIZE = "device.storage_size", $49d40eaf9ca0cfa4$var$DEVICE_THERMAL_STATE = "device.thermal_state", $49d40eaf9ca0cfa4$var$DEVICE_TIMEZONE = "device.timezone", $49d40eaf9ca0cfa4$var$DEVICE_USABLE_MEMORY = "device.usable_memory", $49d40eaf9ca0cfa4$var$DIST = "dist", $49d40eaf9ca0cfa4$var$EFFECTIVECONNECTIONTYPE = "effectiveConnectionType", $49d40eaf9ca0cfa4$var$ENVIRONMENT = "environment", $49d40eaf9ca0cfa4$var$ERROR_TYPE = "error.type", $49d40eaf9ca0cfa4$var$EVENT_ID = "event.id", $49d40eaf9ca0cfa4$var$EVENT_NAME = "event.name", $49d40eaf9ca0cfa4$var$EXCEPTION_ESCAPED = "exception.escaped", $49d40eaf9ca0cfa4$var$EXCEPTION_MESSAGE = "exception.message", $49d40eaf9ca0cfa4$var$EXCEPTION_STACKTRACE = "exception.stacktrace", $49d40eaf9ca0cfa4$var$EXCEPTION_TYPE = "exception.type", $49d40eaf9ca0cfa4$var$FAAS_COLDSTART = "faas.coldstart", $49d40eaf9ca0cfa4$var$FAAS_CRON = "faas.cron", $49d40eaf9ca0cfa4$var$FAAS_DURATION_IN_MS = "faas.duration_in_ms", $49d40eaf9ca0cfa4$var$FAAS_ENTRY_POINT = "faas.entry_point", $49d40eaf9ca0cfa4$var$FAAS_EXECUTION = "faas.execution", $49d40eaf9ca0cfa4$var$FAAS_ID = "faas.id", $49d40eaf9ca0cfa4$var$FAAS_IDENTITY = "faas.identity", $49d40eaf9ca0cfa4$var$FAAS_INVOCATION_ID = "faas.invocation_id", $49d40eaf9ca0cfa4$var$FAAS_INVOKED_NAME = "faas.invoked_name", $49d40eaf9ca0cfa4$var$FAAS_INVOKED_PROVIDER = "faas.invoked_provider", $49d40eaf9ca0cfa4$var$FAAS_INVOKED_REGION = "faas.invoked_region", $49d40eaf9ca0cfa4$var$FAAS_NAME = "faas.name", $49d40eaf9ca0cfa4$var$FAAS_TIME = "faas.time", $49d40eaf9ca0cfa4$var$FAAS_TRIGGER = "faas.trigger", $49d40eaf9ca0cfa4$var$FAAS_VERSION = "faas.version", $49d40eaf9ca0cfa4$var$FCP = "fcp", $49d40eaf9ca0cfa4$var$FLAG_EVALUATION_KEY = "flag.evaluation.<key>", $49d40eaf9ca0cfa4$var$FLAG_EVALUATION_KEY_BASE = "flag.evaluation", $49d40eaf9ca0cfa4$var$FP = "fp", $49d40eaf9ca0cfa4$var$FRAMES_DELAY = "frames.delay", $49d40eaf9ca0cfa4$var$FRAMES_FROZEN = "frames.frozen", $49d40eaf9ca0cfa4$var$FRAMES_FROZEN_RATE = "frames_frozen_rate", $49d40eaf9ca0cfa4$var$FRAMES_SLOW = "frames.slow", $49d40eaf9ca0cfa4$var$FRAMES_SLOW_RATE = "frames_slow_rate", $49d40eaf9ca0cfa4$var$FRAMES_TOTAL = "frames.total", $49d40eaf9ca0cfa4$var$FS_ERROR = "fs_error", $49d40eaf9ca0cfa4$var$GCP_FUNCTION_CONTEXT_EVENT_ID = "gcp.function.context.event_id", $49d40eaf9ca0cfa4$var$GCP_FUNCTION_CONTEXT_EVENT_TYPE = "gcp.function.context.event_type", $49d40eaf9ca0cfa4$var$GCP_FUNCTION_CONTEXT_ID = "gcp.function.context.id", $49d40eaf9ca0cfa4$var$GCP_FUNCTION_CONTEXT_RESOURCE = "gcp.function.context.resource", $49d40eaf9ca0cfa4$var$GCP_FUNCTION_CONTEXT_SOURCE = "gcp.function.context.source", $49d40eaf9ca0cfa4$var$GCP_FUNCTION_CONTEXT_SPECVERSION = "gcp.function.context.specversion", $49d40eaf9ca0cfa4$var$GCP_FUNCTION_CONTEXT_TIME = "gcp.function.context.time", $49d40eaf9ca0cfa4$var$GCP_FUNCTION_CONTEXT_TIMESTAMP = "gcp.function.context.timestamp", $49d40eaf9ca0cfa4$var$GCP_FUNCTION_CONTEXT_TYPE = "gcp.function.context.type", $49d40eaf9ca0cfa4$var$GCP_PROJECT_ID = "gcp.project.id", $49d40eaf9ca0cfa4$var$GEN_AI_AGENT_NAME = "gen_ai.agent.name", $49d40eaf9ca0cfa4$var$GEN_AI_CONTEXT_UTILIZATION = "gen_ai.context.utilization", $49d40eaf9ca0cfa4$var$GEN_AI_CONTEXT_WINDOW_SIZE = "gen_ai.context.window_size", $49d40eaf9ca0cfa4$var$GEN_AI_CONVERSATION_ID = "gen_ai.conversation.id", $49d40eaf9ca0cfa4$var$GEN_AI_COST_CACHE_CREATION_INPUT_TOKENS = "gen_ai.cost.cache_creation.input_tokens", $49d40eaf9ca0cfa4$var$GEN_AI_COST_CACHE_READ_INPUT_TOKENS = "gen_ai.cost.cache_read.input_tokens", $49d40eaf9ca0cfa4$var$GEN_AI_COST_INPUT_TOKENS = "gen_ai.cost.input_tokens", $49d40eaf9ca0cfa4$var$GEN_AI_COST_OUTPUT_TOKENS = "gen_ai.cost.output_tokens", $49d40eaf9ca0cfa4$var$GEN_AI_COST_REASONING_OUTPUT_TOKENS = "gen_ai.cost.reasoning.output_tokens", $49d40eaf9ca0cfa4$var$GEN_AI_COST_TOTAL_TOKENS = "gen_ai.cost.total_tokens", $49d40eaf9ca0cfa4$var$GEN_AI_EMBEDDINGS_INPUT = "gen_ai.embeddings.input", $49d40eaf9ca0cfa4$var$GEN_AI_FUNCTION_ID = "gen_ai.function_id", $49d40eaf9ca0cfa4$var$GEN_AI_INPUT_MESSAGES = "gen_ai.input.messages", $49d40eaf9ca0cfa4$var$GEN_AI_OPERATION_NAME = "gen_ai.operation.name", $49d40eaf9ca0cfa4$var$GEN_AI_OPERATION_TYPE = "gen_ai.operation.type", $49d40eaf9ca0cfa4$var$GEN_AI_OUTPUT_MESSAGES = "gen_ai.output.messages", $49d40eaf9ca0cfa4$var$GEN_AI_PIPELINE_NAME = "gen_ai.pipeline.name", $49d40eaf9ca0cfa4$var$GEN_AI_PROMPT = "gen_ai.prompt", $49d40eaf9ca0cfa4$var$GEN_AI_PROMPT_NAME = "gen_ai.prompt.name", $49d40eaf9ca0cfa4$var$GEN_AI_PROVIDER_NAME = "gen_ai.provider.name", $49d40eaf9ca0cfa4$var$GEN_AI_REQUEST_AVAILABLE_TOOLS = "gen_ai.request.available_tools", $49d40eaf9ca0cfa4$var$GEN_AI_REQUEST_FREQUENCY_PENALTY = "gen_ai.request.frequency_penalty", $49d40eaf9ca0cfa4$var$GEN_AI_REQUEST_MAX_TOKENS = "gen_ai.request.max_tokens", $49d40eaf9ca0cfa4$var$GEN_AI_REQUEST_MESSAGES = "gen_ai.request.messages", $49d40eaf9ca0cfa4$var$GEN_AI_REQUEST_MODEL = "gen_ai.request.model", $49d40eaf9ca0cfa4$var$GEN_AI_REQUEST_PRESENCE_PENALTY = "gen_ai.request.presence_penalty", $49d40eaf9ca0cfa4$var$GEN_AI_REQUEST_REASONING_EFFORT = "gen_ai.request.reasoning_effort", $49d40eaf9ca0cfa4$var$GEN_AI_REQUEST_SEED = "gen_ai.request.seed", $49d40eaf9ca0cfa4$var$GEN_AI_REQUEST_STOP_SEQUENCES = "gen_ai.request.stop_sequences", $49d40eaf9ca0cfa4$var$GEN_AI_REQUEST_TEMPERATURE = "gen_ai.request.temperature", $49d40eaf9ca0cfa4$var$GEN_AI_REQUEST_TOP_K = "gen_ai.request.top_k", $49d40eaf9ca0cfa4$var$GEN_AI_REQUEST_TOP_P = "gen_ai.request.top_p", $49d40eaf9ca0cfa4$var$GEN_AI_RESPONSE_FINISH_REASONS = "gen_ai.response.finish_reasons", $49d40eaf9ca0cfa4$var$GEN_AI_RESPONSE_ID = "gen_ai.response.id", $49d40eaf9ca0cfa4$var$GEN_AI_RESPONSE_MODEL = "gen_ai.response.model", $49d40eaf9ca0cfa4$var$GEN_AI_RESPONSE_STREAMING = "gen_ai.response.streaming", $49d40eaf9ca0cfa4$var$GEN_AI_RESPONSE_TEXT = "gen_ai.response.text", $49d40eaf9ca0cfa4$var$GEN_AI_RESPONSE_TIME_TO_FIRST_CHUNK = "gen_ai.response.time_to_first_chunk", $49d40eaf9ca0cfa4$var$GEN_AI_RESPONSE_TIME_TO_FIRST_TOKEN = "gen_ai.response.time_to_first_token", $49d40eaf9ca0cfa4$var$GEN_AI_RESPONSE_TOKENS_PER_SECOND = "gen_ai.response.tokens_per_second", $49d40eaf9ca0cfa4$var$GEN_AI_RESPONSE_TOOL_CALLS = "gen_ai.response.tool_calls", $49d40eaf9ca0cfa4$var$GEN_AI_SYSTEM = "gen_ai.system", $49d40eaf9ca0cfa4$var$GEN_AI_SYSTEM_INSTRUCTIONS = "gen_ai.system_instructions", $49d40eaf9ca0cfa4$var$GEN_AI_SYSTEM_MESSAGE = "gen_ai.system.message", $49d40eaf9ca0cfa4$var$GEN_AI_TOOL_CALL_ARGUMENTS = "gen_ai.tool.call.arguments", $49d40eaf9ca0cfa4$var$GEN_AI_TOOL_CALL_RESULT = "gen_ai.tool.call.result", $49d40eaf9ca0cfa4$var$GEN_AI_TOOL_DEFINITIONS = "gen_ai.tool.definitions", $49d40eaf9ca0cfa4$var$GEN_AI_TOOL_DESCRIPTION = "gen_ai.tool.description", $49d40eaf9ca0cfa4$var$GEN_AI_TOOL_INPUT = "gen_ai.tool.input", $49d40eaf9ca0cfa4$var$GEN_AI_TOOL_MESSAGE = "gen_ai.tool.message", $49d40eaf9ca0cfa4$var$GEN_AI_TOOL_NAME = "gen_ai.tool.name", $49d40eaf9ca0cfa4$var$GEN_AI_TOOL_OUTPUT = "gen_ai.tool.output", $49d40eaf9ca0cfa4$var$GEN_AI_TOOL_TYPE = "gen_ai.tool.type", $49d40eaf9ca0cfa4$var$GEN_AI_USAGE_CACHE_CREATION_INPUT_TOKENS = "gen_ai.usage.cache_creation.input_tokens", $49d40eaf9ca0cfa4$var$GEN_AI_USAGE_CACHE_READ_INPUT_TOKENS = "gen_ai.usage.cache_read.input_tokens", $49d40eaf9ca0cfa4$var$GEN_AI_USAGE_COMPLETION_TOKENS = "gen_ai.usage.completion_tokens", $49d40eaf9ca0cfa4$var$GEN_AI_USAGE_INPUT_TOKENS = "gen_ai.usage.input_tokens", $49d40eaf9ca0cfa4$var$GEN_AI_USAGE_INPUT_TOKENS_CACHED = "gen_ai.usage.input_tokens.cached", $49d40eaf9ca0cfa4$var$GEN_AI_USAGE_INPUT_TOKENS_CACHE_WRITE = "gen_ai.usage.input_tokens.cache_write", $49d40eaf9ca0cfa4$var$GEN_AI_USAGE_OUTPUT_TOKENS = "gen_ai.usage.output_tokens", $49d40eaf9ca0cfa4$var$GEN_AI_USAGE_OUTPUT_TOKENS_REASONING = "gen_ai.usage.output_tokens.reasoning", $49d40eaf9ca0cfa4$var$GEN_AI_USAGE_PROMPT_TOKENS = "gen_ai.usage.prompt_tokens", $49d40eaf9ca0cfa4$var$GEN_AI_USAGE_REASONING_OUTPUT_TOKENS = "gen_ai.usage.reasoning.output_tokens", $49d40eaf9ca0cfa4$var$GEN_AI_USAGE_TOTAL_TOKENS = "gen_ai.usage.total_tokens", $49d40eaf9ca0cfa4$var$GRAPHQL_DOCUMENT = "graphql.document", $49d40eaf9ca0cfa4$var$GRAPHQL_OPERATION_NAME = "graphql.operation.name", $49d40eaf9ca0cfa4$var$GRAPHQL_OPERATION_TYPE = "graphql.operation.type", $49d40eaf9ca0cfa4$var$HARDWARECONCURRENCY = "hardwareConcurrency", $49d40eaf9ca0cfa4$var$HTTP_CLIENT_IP = "http.client_ip", $49d40eaf9ca0cfa4$var$HTTP_DECODED_RESPONSE_CONTENT_LENGTH = "http.decoded_response_content_length", $49d40eaf9ca0cfa4$var$HTTP_FLAVOR = "http.flavor", $49d40eaf9ca0cfa4$var$HTTP_FRAGMENT = "http.fragment", $49d40eaf9ca0cfa4$var$HTTP_HOST = "http.host", $49d40eaf9ca0cfa4$var$HTTP_METHOD = "http.method", $49d40eaf9ca0cfa4$var$HTTP_QUERY = "http.query", $49d40eaf9ca0cfa4$var$HTTP_REQUEST_BODY_DATA = "http.request.body.data", $49d40eaf9ca0cfa4$var$HTTP_REQUEST_CONNECTION_END = "http.request.connection_end", $49d40eaf9ca0cfa4$var$HTTP_REQUEST_CONNECT_START = "http.request.connect_start", $49d40eaf9ca0cfa4$var$HTTP_REQUEST_DOMAIN_LOOKUP_END = "http.request.domain_lookup_end", $49d40eaf9ca0cfa4$var$HTTP_REQUEST_DOMAIN_LOOKUP_START = "http.request.domain_lookup_start", $49d40eaf9ca0cfa4$var$HTTP_REQUEST_FETCH_START = "http.request.fetch_start", $49d40eaf9ca0cfa4$var$HTTP_REQUEST_HEADER_KEY = "http.request.header.<key>", $49d40eaf9ca0cfa4$var$HTTP_REQUEST_HEADER_KEY_BASE = "http.request.header", $49d40eaf9ca0cfa4$var$HTTP_REQUEST_METHOD = "http.request.method", $49d40eaf9ca0cfa4$var$_HTTP_REQUEST_METHOD = "http.request_method", $49d40eaf9ca0cfa4$var$HTTP_REQUEST_REDIRECT_END = "http.request.redirect_end", $49d40eaf9ca0cfa4$var$HTTP_REQUEST_REDIRECT_START = "http.request.redirect_start", $49d40eaf9ca0cfa4$var$HTTP_REQUEST_REQUEST_START = "http.request.request_start", $49d40eaf9ca0cfa4$var$HTTP_REQUEST_RESEND_COUNT = "http.request.resend_count", $49d40eaf9ca0cfa4$var$HTTP_REQUEST_RESPONSE_END = "http.request.response_end", $49d40eaf9ca0cfa4$var$HTTP_REQUEST_RESPONSE_START = "http.request.response_start", $49d40eaf9ca0cfa4$var$HTTP_REQUEST_SAME_ORIGIN = "http.request.same_origin", $49d40eaf9ca0cfa4$var$HTTP_REQUEST_SECURE_CONNECTION_START = "http.request.secure_connection_start", $49d40eaf9ca0cfa4$var$HTTP_REQUEST_TIME_TO_FIRST_BYTE = "http.request.time_to_first_byte", $49d40eaf9ca0cfa4$var$HTTP_REQUEST_WORKER_START = "http.request.worker_start", $49d40eaf9ca0cfa4$var$HTTP_RESPONSE_BODY_SIZE = "http.response.body.size", $49d40eaf9ca0cfa4$var$HTTP_RESPONSE_CONTENT_LENGTH = "http.response_content_length", $49d40eaf9ca0cfa4$var$HTTP_RESPONSE_HEADER_CONTENT_LENGTH = "http.response.header.content-length", $49d40eaf9ca0cfa4$var$HTTP_RESPONSE_HEADER_KEY = "http.response.header.<key>", $49d40eaf9ca0cfa4$var$HTTP_RESPONSE_HEADER_KEY_BASE = "http.response.header", $49d40eaf9ca0cfa4$var$HTTP_RESPONSE_SIZE = "http.response.size", $49d40eaf9ca0cfa4$var$HTTP_RESPONSE_STATUS_CODE = "http.response.status_code", $49d40eaf9ca0cfa4$var$HTTP_RESPONSE_TRANSFER_SIZE = "http.response_transfer_size", $49d40eaf9ca0cfa4$var$HTTP_ROUTE = "http.route", $49d40eaf9ca0cfa4$var$HTTP_SCHEME = "http.scheme", $49d40eaf9ca0cfa4$var$HTTP_SERVER_NAME = "http.server_name", $49d40eaf9ca0cfa4$var$HTTP_SERVER_REQUEST_TIME_IN_QUEUE = "http.server.request.time_in_queue", $49d40eaf9ca0cfa4$var$HTTP_STATUS_CODE = "http.status_code", $49d40eaf9ca0cfa4$var$HTTP_TARGET = "http.target", $49d40eaf9ca0cfa4$var$HTTP_URL = "http.url", $49d40eaf9ca0cfa4$var$HTTP_USER_AGENT = "http.user_agent", $49d40eaf9ca0cfa4$var$ID = "id", $49d40eaf9ca0cfa4$var$INP = "inp", $49d40eaf9ca0cfa4$var$JSONRPC_PROTOCOL_VERSION = "jsonrpc.protocol.version", $49d40eaf9ca0cfa4$var$JSONRPC_REQUEST_ID = "jsonrpc.request.id", $49d40eaf9ca0cfa4$var$JVM_GC_ACTION = "jvm.gc.action", $49d40eaf9ca0cfa4$var$JVM_GC_NAME = "jvm.gc.name", $49d40eaf9ca0cfa4$var$JVM_MEMORY_POOL_NAME = "jvm.memory.pool.name", $49d40eaf9ca0cfa4$var$JVM_MEMORY_TYPE = "jvm.memory.type", $49d40eaf9ca0cfa4$var$JVM_THREAD_DAEMON = "jvm.thread.daemon", $49d40eaf9ca0cfa4$var$JVM_THREAD_STATE = "jvm.thread.state", $49d40eaf9ca0cfa4$var$KOA_NAME = "koa.name", $49d40eaf9ca0cfa4$var$KOA_TYPE = "koa.type", $49d40eaf9ca0cfa4$var$LCP = "lcp", $49d40eaf9ca0cfa4$var$LCP_ELEMENT = "lcp.element", $49d40eaf9ca0cfa4$var$LCP_ID = "lcp.id", $49d40eaf9ca0cfa4$var$LCP_LOADTIME = "lcp.loadTime", $49d40eaf9ca0cfa4$var$LCP_RENDERTIME = "lcp.renderTime", $49d40eaf9ca0cfa4$var$LCP_SIZE = "lcp.size", $49d40eaf9ca0cfa4$var$LCP_URL = "lcp.url", $49d40eaf9ca0cfa4$var$LOGGER_NAME = "logger.name", $49d40eaf9ca0cfa4$var$MCP_CANCELLED_REASON = "mcp.cancelled.reason", $49d40eaf9ca0cfa4$var$MCP_CANCELLED_REQUEST_ID = "mcp.cancelled.request_id", $49d40eaf9ca0cfa4$var$MCP_CLIENT_NAME = "mcp.client.name", $49d40eaf9ca0cfa4$var$MCP_CLIENT_TITLE = "mcp.client.title", $49d40eaf9ca0cfa4$var$MCP_CLIENT_VERSION = "mcp.client.version", $49d40eaf9ca0cfa4$var$MCP_LIFECYCLE_PHASE = "mcp.lifecycle.phase", $49d40eaf9ca0cfa4$var$MCP_LOGGING_DATA_TYPE = "mcp.logging.data_type", $49d40eaf9ca0cfa4$var$MCP_LOGGING_LEVEL = "mcp.logging.level", $49d40eaf9ca0cfa4$var$MCP_LOGGING_LOGGER = "mcp.logging.logger", $49d40eaf9ca0cfa4$var$MCP_LOGGING_MESSAGE = "mcp.logging.message", $49d40eaf9ca0cfa4$var$MCP_METHOD_NAME = "mcp.method.name", $49d40eaf9ca0cfa4$var$MCP_PROGRESS_CURRENT = "mcp.progress.current", $49d40eaf9ca0cfa4$var$MCP_PROGRESS_MESSAGE = "mcp.progress.message", $49d40eaf9ca0cfa4$var$MCP_PROGRESS_PERCENTAGE = "mcp.progress.percentage", $49d40eaf9ca0cfa4$var$MCP_PROGRESS_TOKEN = "mcp.progress.token", $49d40eaf9ca0cfa4$var$MCP_PROGRESS_TOTAL = "mcp.progress.total", $49d40eaf9ca0cfa4$var$MCP_PROMPT_NAME = "mcp.prompt.name", $49d40eaf9ca0cfa4$var$MCP_PROMPT_RESULT_DESCRIPTION = "mcp.prompt.result.description", $49d40eaf9ca0cfa4$var$MCP_PROMPT_RESULT_MESSAGE_CONTENT = "mcp.prompt.result.message_content", $49d40eaf9ca0cfa4$var$MCP_PROMPT_RESULT_MESSAGE_COUNT = "mcp.prompt.result.message_count", $49d40eaf9ca0cfa4$var$MCP_PROMPT_RESULT_MESSAGE_ROLE = "mcp.prompt.result.message_role", $49d40eaf9ca0cfa4$var$MCP_PROTOCOL_READY = "mcp.protocol.ready", $49d40eaf9ca0cfa4$var$MCP_PROTOCOL_VERSION = "mcp.protocol.version", $49d40eaf9ca0cfa4$var$MCP_REQUEST_ARGUMENT_KEY = "mcp.request.argument.<key>", $49d40eaf9ca0cfa4$var$MCP_REQUEST_ARGUMENT_KEY_BASE = "mcp.request.argument", $49d40eaf9ca0cfa4$var$MCP_REQUEST_ARGUMENT_NAME = "mcp.request.argument.name", $49d40eaf9ca0cfa4$var$MCP_REQUEST_ARGUMENT_URI = "mcp.request.argument.uri", $49d40eaf9ca0cfa4$var$MCP_REQUEST_ID = "mcp.request.id", $49d40eaf9ca0cfa4$var$MCP_RESOURCE_PROTOCOL = "mcp.resource.protocol", $49d40eaf9ca0cfa4$var$MCP_RESOURCE_URI = "mcp.resource.uri", $49d40eaf9ca0cfa4$var$MCP_SERVER_NAME = "mcp.server.name", $49d40eaf9ca0cfa4$var$MCP_SERVER_TITLE = "mcp.server.title", $49d40eaf9ca0cfa4$var$MCP_SERVER_VERSION = "mcp.server.version", $49d40eaf9ca0cfa4$var$MCP_SESSION_ID = "mcp.session.id", $49d40eaf9ca0cfa4$var$MCP_TOOL_NAME = "mcp.tool.name", $49d40eaf9ca0cfa4$var$MCP_TOOL_RESULT_CONTENT = "mcp.tool.result.content", $49d40eaf9ca0cfa4$var$MCP_TOOL_RESULT_CONTENT_COUNT = "mcp.tool.result.content_count", $49d40eaf9ca0cfa4$var$MCP_TOOL_RESULT_IS_ERROR = "mcp.tool.result.is_error", $49d40eaf9ca0cfa4$var$MCP_TRANSPORT = "mcp.transport", $49d40eaf9ca0cfa4$var$MDC_KEY = "mdc.<key>", $49d40eaf9ca0cfa4$var$MDC_KEY_BASE = "mdc", $49d40eaf9ca0cfa4$var$MESSAGING_BATCH_MESSAGE_COUNT = "messaging.batch.message_count", $49d40eaf9ca0cfa4$var$MESSAGING_DESTINATION = "messaging.destination", $49d40eaf9ca0cfa4$var$MESSAGING_DESTINATION_CONNECTION = "messaging.destination.connection", $49d40eaf9ca0cfa4$var$MESSAGING_DESTINATION_NAME = "messaging.destination.name", $49d40eaf9ca0cfa4$var$MESSAGING_MESSAGE_BODY_SIZE = "messaging.message.body.size", $49d40eaf9ca0cfa4$var$MESSAGING_MESSAGE_CONVERSATION_ID = "messaging.message.conversation_id", $49d40eaf9ca0cfa4$var$MESSAGING_MESSAGE_ENVELOPE_SIZE = "messaging.message.envelope.size", $49d40eaf9ca0cfa4$var$MESSAGING_MESSAGE_ID = "messaging.message.id", $49d40eaf9ca0cfa4$var$MESSAGING_MESSAGE_RECEIVE_LATENCY = "messaging.message.receive.latency", $49d40eaf9ca0cfa4$var$MESSAGING_MESSAGE_RETRY_COUNT = "messaging.message.retry.count", $49d40eaf9ca0cfa4$var$MESSAGING_OPERATION_NAME = "messaging.operation.name", $49d40eaf9ca0cfa4$var$MESSAGING_OPERATION_TYPE = "messaging.operation.type", $49d40eaf9ca0cfa4$var$MESSAGING_RABBITMQ_DESTINATION_ROUTING_KEY = "messaging.rabbitmq.destination.routing_key", $49d40eaf9ca0cfa4$var$MESSAGING_SYSTEM = "messaging.system", $49d40eaf9ca0cfa4$var$METHOD = "method", $49d40eaf9ca0cfa4$var$MIDDLEWARE_NAME = "middleware.name", $49d40eaf9ca0cfa4$var$NAVIGATION_ORIGIN = "navigation.origin", $49d40eaf9ca0cfa4$var$NAVIGATION_ROUTE_ID = "navigation.route.id", $49d40eaf9ca0cfa4$var$NAVIGATION_TYPE = "navigation.type", $49d40eaf9ca0cfa4$var$NEL_ELAPSED_TIME = "nel.elapsed_time", $49d40eaf9ca0cfa4$var$NEL_PHASE = "nel.phase", $49d40eaf9ca0cfa4$var$NEL_REFERRER = "nel.referrer", $49d40eaf9ca0cfa4$var$NEL_SAMPLING_FUNCTION = "nel.sampling_function", $49d40eaf9ca0cfa4$var$NEL_TYPE = "nel.type", $49d40eaf9ca0cfa4$var$NETWORK_CONNECTION_EFFECTIVE_TYPE = "network.connection.effective_type", $49d40eaf9ca0cfa4$var$NETWORK_CONNECTION_RTT = "network.connection.rtt", $49d40eaf9ca0cfa4$var$NETWORK_CONNECTION_TYPE = "network.connection.type", $49d40eaf9ca0cfa4$var$NETWORK_LOCAL_ADDRESS = "network.local.address", $49d40eaf9ca0cfa4$var$NETWORK_LOCAL_PORT = "network.local.port", $49d40eaf9ca0cfa4$var$NETWORK_PEER_ADDRESS = "network.peer.address", $49d40eaf9ca0cfa4$var$NETWORK_PEER_PORT = "network.peer.port", $49d40eaf9ca0cfa4$var$NETWORK_PROTOCOL_NAME = "network.protocol.name", $49d40eaf9ca0cfa4$var$NETWORK_PROTOCOL_VERSION = "network.protocol.version", $49d40eaf9ca0cfa4$var$NETWORK_TRANSPORT = "network.transport", $49d40eaf9ca0cfa4$var$NETWORK_TYPE = "network.type", $49d40eaf9ca0cfa4$var$NET_HOST_IP = "net.host.ip", $49d40eaf9ca0cfa4$var$NET_HOST_NAME = "net.host.name", $49d40eaf9ca0cfa4$var$NET_HOST_PORT = "net.host.port", $49d40eaf9ca0cfa4$var$NET_PEER_IP = "net.peer.ip", $49d40eaf9ca0cfa4$var$NET_PEER_NAME = "net.peer.name", $49d40eaf9ca0cfa4$var$NET_PEER_PORT = "net.peer.port", $49d40eaf9ca0cfa4$var$NET_PROTOCOL_NAME = "net.protocol.name", $49d40eaf9ca0cfa4$var$NET_PROTOCOL_VERSION = "net.protocol.version", $49d40eaf9ca0cfa4$var$NET_SOCK_FAMILY = "net.sock.family", $49d40eaf9ca0cfa4$var$NET_SOCK_HOST_ADDR = "net.sock.host.addr", $49d40eaf9ca0cfa4$var$NET_SOCK_HOST_PORT = "net.sock.host.port", $49d40eaf9ca0cfa4$var$NET_SOCK_PEER_ADDR = "net.sock.peer.addr", $49d40eaf9ca0cfa4$var$NET_SOCK_PEER_NAME = "net.sock.peer.name", $49d40eaf9ca0cfa4$var$NET_SOCK_PEER_PORT = "net.sock.peer.port", $49d40eaf9ca0cfa4$var$NET_TRANSPORT = "net.transport", $49d40eaf9ca0cfa4$var$OS_BUILD = "os.build", $49d40eaf9ca0cfa4$var$OS_BUILD_ID = "os.build_id", $49d40eaf9ca0cfa4$var$OS_DESCRIPTION = "os.description", $49d40eaf9ca0cfa4$var$OS_KERNEL_VERSION = "os.kernel_version", $49d40eaf9ca0cfa4$var$OS_NAME = "os.name", $49d40eaf9ca0cfa4$var$OS_RAW_DESCRIPTION = "os.raw_description", $49d40eaf9ca0cfa4$var$OS_ROOTED = "os.rooted", $49d40eaf9ca0cfa4$var$OS_THEME = "os.theme", $49d40eaf9ca0cfa4$var$OS_TYPE = "os.type", $49d40eaf9ca0cfa4$var$OS_VERSION = "os.version", $49d40eaf9ca0cfa4$var$OTEL_KIND = "otel.kind", $49d40eaf9ca0cfa4$var$OTEL_SCOPE_NAME = "otel.scope.name", $49d40eaf9ca0cfa4$var$OTEL_SCOPE_VERSION = "otel.scope.version", $49d40eaf9ca0cfa4$var$OTEL_STATUS_CODE = "otel.status_code", $49d40eaf9ca0cfa4$var$OTEL_STATUS_DESCRIPTION = "otel.status_description", $49d40eaf9ca0cfa4$var$PARAMS_KEY = "params.<key>", $49d40eaf9ca0cfa4$var$PARAMS_KEY_BASE = "params", $49d40eaf9ca0cfa4$var$PERFORMANCE_ACTIVATIONSTART = "performance.activationStart", $49d40eaf9ca0cfa4$var$PERFORMANCE_TIMEORIGIN = "performance.timeOrigin", $49d40eaf9ca0cfa4$var$PREVIOUS_ROUTE = "previous_route", $49d40eaf9ca0cfa4$var$PROCESS_COMMAND_ARGS = "process.command_args", $49d40eaf9ca0cfa4$var$PROCESS_EXECUTABLE_NAME = "process.executable.name", $49d40eaf9ca0cfa4$var$PROCESS_PID = "process.pid", $49d40eaf9ca0cfa4$var$PROCESS_RUNTIME_DESCRIPTION = "process.runtime.description", $49d40eaf9ca0cfa4$var$PROCESS_RUNTIME_ENGINE_NAME = "process.runtime.engine.name", $49d40eaf9ca0cfa4$var$PROCESS_RUNTIME_ENGINE_VERSION = "process.runtime.engine.version", $49d40eaf9ca0cfa4$var$PROCESS_RUNTIME_NAME = "process.runtime.name", $49d40eaf9ca0cfa4$var$PROCESS_RUNTIME_VERSION = "process.runtime.version", $49d40eaf9ca0cfa4$var$QUERY_KEY = "query.<key>", $49d40eaf9ca0cfa4$var$QUERY_KEY_BASE = "query", $49d40eaf9ca0cfa4$var$REACT_VERSION = "react.version", $49d40eaf9ca0cfa4$var$RELEASE = "release", $49d40eaf9ca0cfa4$var$REMIX_ACTION_FORM_DATA_KEY = "remix.action_form_data.<key>", $49d40eaf9ca0cfa4$var$REMIX_ACTION_FORM_DATA_KEY_BASE = "remix.action_form_data", $49d40eaf9ca0cfa4$var$REPLAY_ID = "replay_id", $49d40eaf9ca0cfa4$var$RESOURCE_DEPLOYMENT_ENVIRONMENT = "resource.deployment.environment", $49d40eaf9ca0cfa4$var$RESOURCE_DEPLOYMENT_ENVIRONMENT_NAME = "resource.deployment.environment.name", $49d40eaf9ca0cfa4$var$RESOURCE_RENDER_BLOCKING_STATUS = "resource.render_blocking_status", $49d40eaf9ca0cfa4$var$ROUTE = "route", $49d40eaf9ca0cfa4$var$RPC_GRPC_STATUS_CODE = "rpc.grpc.status_code", $49d40eaf9ca0cfa4$var$RPC_METHOD = "rpc.method", $49d40eaf9ca0cfa4$var$RPC_RESPONSE_STATUS_CODE = "rpc.response.status_code", $49d40eaf9ca0cfa4$var$RPC_SERVICE = "rpc.service", $49d40eaf9ca0cfa4$var$RPC_SYSTEM = "rpc.system", $49d40eaf9ca0cfa4$var$RPC_SYSTEM_NAME = "rpc.system.name", $49d40eaf9ca0cfa4$var$RUNTIME_BUILD = "runtime.build", $49d40eaf9ca0cfa4$var$RUNTIME_NAME = "runtime.name", $49d40eaf9ca0cfa4$var$RUNTIME_RAW_DESCRIPTION = "runtime.raw_description", $49d40eaf9ca0cfa4$var$RUNTIME_VERSION = "runtime.version", $49d40eaf9ca0cfa4$var$SCORE_KEY = "score.<key>", $49d40eaf9ca0cfa4$var$SCORE_KEY_BASE = "score", $49d40eaf9ca0cfa4$var$SCORE_RATIO_KEY = "score.ratio.<key>", $49d40eaf9ca0cfa4$var$SCORE_RATIO_KEY_BASE = "score.ratio", $49d40eaf9ca0cfa4$var$SCORE_TOTAL = "score.total", $49d40eaf9ca0cfa4$var$SCORE_WEIGHT_KEY = "score.weight.<key>", $49d40eaf9ca0cfa4$var$SCORE_WEIGHT_KEY_BASE = "score.weight", $49d40eaf9ca0cfa4$var$SENTRY_ACTION = "sentry.action", $49d40eaf9ca0cfa4$var$SENTRY_BROWSER_NAME = "sentry.browser.name", $49d40eaf9ca0cfa4$var$SENTRY_BROWSER_VERSION = "sentry.browser.version", $49d40eaf9ca0cfa4$var$SENTRY_CANCELLATION_REASON = "sentry.cancellation_reason", $49d40eaf9ca0cfa4$var$SENTRY_CATEGORY = "sentry.category", $49d40eaf9ca0cfa4$var$SENTRY_CLIENT_SAMPLE_RATE = "sentry.client_sample_rate", $49d40eaf9ca0cfa4$var$SENTRY_DESCRIPTION = "sentry.description", $49d40eaf9ca0cfa4$var$SENTRY_DIST = "sentry.dist", $49d40eaf9ca0cfa4$var$SENTRY_DOMAIN = "sentry.domain", $49d40eaf9ca0cfa4$var$SENTRY_DSC_ENVIRONMENT = "sentry.dsc.environment", $49d40eaf9ca0cfa4$var$SENTRY_DSC_PROJECT_ID = "sentry.dsc.project_id", $49d40eaf9ca0cfa4$var$SENTRY_DSC_PUBLIC_KEY = "sentry.dsc.public_key", $49d40eaf9ca0cfa4$var$SENTRY_DSC_RELEASE = "sentry.dsc.release", $49d40eaf9ca0cfa4$var$SENTRY_DSC_SAMPLED = "sentry.dsc.sampled", $49d40eaf9ca0cfa4$var$SENTRY_DSC_SAMPLE_RATE = "sentry.dsc.sample_rate", $49d40eaf9ca0cfa4$var$SENTRY_DSC_TRACE_ID = "sentry.dsc.trace_id", $49d40eaf9ca0cfa4$var$SENTRY_DSC_TRANSACTION = "sentry.dsc.transaction", $49d40eaf9ca0cfa4$var$SENTRY_ENVIRONMENT = "sentry.environment", $49d40eaf9ca0cfa4$var$SENTRY_EXCLUSIVE_TIME = "sentry.exclusive_time", $49d40eaf9ca0cfa4$var$SENTRY_GRAPHQL_OPERATION = "sentry.graphql.operation", $49d40eaf9ca0cfa4$var$SENTRY_GROUP = "sentry.group", $49d40eaf9ca0cfa4$var$SENTRY_HTTP_PREFETCH = "sentry.http.prefetch", $49d40eaf9ca0cfa4$var$SENTRY_IDLE_SPAN_FINISH_REASON = "sentry.idle_span_finish_reason", $49d40eaf9ca0cfa4$var$SENTRY_IS_REMOTE = "sentry.is_remote", $49d40eaf9ca0cfa4$var$SENTRY_KIND = "sentry.kind", $49d40eaf9ca0cfa4$var$SENTRY_MAIN_THREAD = "sentry.main_thread", $49d40eaf9ca0cfa4$var$SENTRY_MESSAGE_PARAMETER_KEY = "sentry.message.parameter.<key>", $49d40eaf9ca0cfa4$var$SENTRY_MESSAGE_TEMPLATE = "sentry.message.template", $49d40eaf9ca0cfa4$var$SENTRY_METRIC_SOURCE = "sentry.metric.source", $49d40eaf9ca0cfa4$var$SENTRY_MOBILE = "sentry.mobile", $49d40eaf9ca0cfa4$var$SENTRY_MODULE_KEY = "sentry.module.<key>", $49d40eaf9ca0cfa4$var$SENTRY_MODULE_KEY_BASE = "sentry.module", $49d40eaf9ca0cfa4$var$SENTRY_NEXTJS_SSR_FUNCTION_ROUTE = "sentry.nextjs.ssr.function.route", $49d40eaf9ca0cfa4$var$SENTRY_NEXTJS_SSR_FUNCTION_TYPE = "sentry.nextjs.ssr.function.type", $49d40eaf9ca0cfa4$var$SENTRY_NORMALIZED_DB_QUERY = "sentry.normalized_db_query", $49d40eaf9ca0cfa4$var$SENTRY_NORMALIZED_DB_QUERY_HASH = "sentry.normalized_db_query.hash", $49d40eaf9ca0cfa4$var$SENTRY_NORMALIZED_DESCRIPTION = "sentry.normalized_description", $49d40eaf9ca0cfa4$var$SENTRY_OBSERVED_TIMESTAMP_NANOS = "sentry.observed_timestamp_nanos", $49d40eaf9ca0cfa4$var$SENTRY_OP = "sentry.op", $49d40eaf9ca0cfa4$var$SENTRY_ORIGIN = "sentry.origin", $49d40eaf9ca0cfa4$var$SENTRY_PLATFORM = "sentry.platform", $49d40eaf9ca0cfa4$var$SENTRY_PROFILER_ID = "sentry.profiler_id", $49d40eaf9ca0cfa4$var$SENTRY_PROFILE_ID = "sentry.profile_id", $49d40eaf9ca0cfa4$var$SENTRY_RELEASE = "sentry.release", $49d40eaf9ca0cfa4$var$SENTRY_REPLAY_ID = "sentry.replay_id", $49d40eaf9ca0cfa4$var$SENTRY_REPLAY_IS_BUFFERING = "sentry.replay_is_buffering", $49d40eaf9ca0cfa4$var$SENTRY_REPORT_EVENT = "sentry.report_event", $49d40eaf9ca0cfa4$var$SENTRY_SDK_INTEGRATIONS = "sentry.sdk.integrations", $49d40eaf9ca0cfa4$var$SENTRY_SDK_NAME = "sentry.sdk.name", $49d40eaf9ca0cfa4$var$SENTRY_SDK_VERSION = "sentry.sdk.version", $49d40eaf9ca0cfa4$var$SENTRY_SEGMENT_ID = "sentry.segment.id", $49d40eaf9ca0cfa4$var$_SENTRY_SEGMENT_ID = "sentry.segment_id", $49d40eaf9ca0cfa4$var$SENTRY_SEGMENT_NAME = "sentry.segment.name", $49d40eaf9ca0cfa4$var$SENTRY_SERVER_SAMPLE_RATE = "sentry.server_sample_rate", $49d40eaf9ca0cfa4$var$SENTRY_SOURCE = "sentry.source", $49d40eaf9ca0cfa4$var$SENTRY_SPAN_SOURCE = "sentry.span.source", $49d40eaf9ca0cfa4$var$SENTRY_STATUS = "sentry.status", $49d40eaf9ca0cfa4$var$SENTRY_STATUS_CODE = "sentry.status_code", $49d40eaf9ca0cfa4$var$SENTRY_STATUS_MESSAGE = "sentry.status.message", $49d40eaf9ca0cfa4$var$SENTRY_SVELTEKIT_NAVIGATION_FROM = "sentry.sveltekit.navigation.from", $49d40eaf9ca0cfa4$var$SENTRY_SVELTEKIT_NAVIGATION_TO = "sentry.sveltekit.navigation.to", $49d40eaf9ca0cfa4$var$SENTRY_SVELTEKIT_NAVIGATION_TYPE = "sentry.sveltekit.navigation.type", $49d40eaf9ca0cfa4$var$SENTRY_THREAD_ID = "sentry.thread.id", $49d40eaf9ca0cfa4$var$SENTRY_TIMESTAMP_SEQUENCE = "sentry.timestamp.sequence", $49d40eaf9ca0cfa4$var$SENTRY_TRACE_LIFECYCLE = "sentry.trace_lifecycle", $49d40eaf9ca0cfa4$var$SENTRY_TRACE_PARENT_SPAN_ID = "sentry.trace.parent_span_id", $49d40eaf9ca0cfa4$var$SENTRY_TRACE_STATUS = "sentry.trace.status", $49d40eaf9ca0cfa4$var$SENTRY_TRANSACTION = "sentry.transaction", $49d40eaf9ca0cfa4$var$SENTRY_USER_EMAIL = "sentry.user.email", $49d40eaf9ca0cfa4$var$SENTRY_USER_GEO_CITY = "sentry.user.geo.city", $49d40eaf9ca0cfa4$var$SENTRY_USER_GEO_COUNTRY_CODE = "sentry.user.geo.country_code", $49d40eaf9ca0cfa4$var$SENTRY_USER_GEO_REGION = "sentry.user.geo.region", $49d40eaf9ca0cfa4$var$SENTRY_USER_GEO_SUBDIVISION = "sentry.user.geo.subdivision", $49d40eaf9ca0cfa4$var$SENTRY_USER_ID = "sentry.user.id", $49d40eaf9ca0cfa4$var$SENTRY_USER_IP = "sentry.user.ip", $49d40eaf9ca0cfa4$var$SENTRY_USER_USERNAME = "sentry.user.username", $49d40eaf9ca0cfa4$var$SERVER_ADDRESS = "server.address", $49d40eaf9ca0cfa4$var$SERVER_NAME = "server_name", $49d40eaf9ca0cfa4$var$SERVER_PORT = "server.port", $49d40eaf9ca0cfa4$var$SERVICE_NAME = "service.name", $49d40eaf9ca0cfa4$var$SERVICE_VERSION = "service.version", $49d40eaf9ca0cfa4$var$SESSION_ID = "session.id", $49d40eaf9ca0cfa4$var$STALL_PERCENTAGE = "stall_percentage", $49d40eaf9ca0cfa4$var$STALL_TOTAL_TIME = "stall_total_time", $49d40eaf9ca0cfa4$var$STATE_TYPE = "state.type", $49d40eaf9ca0cfa4$var$THREAD_ID = "thread.id", $49d40eaf9ca0cfa4$var$THREAD_NAME = "thread.name", $49d40eaf9ca0cfa4$var$TIMBER_TAG = "timber.tag", $49d40eaf9ca0cfa4$var$TIME_TO_FULL_DISPLAY = "time_to_full_display", $49d40eaf9ca0cfa4$var$TIME_TO_INITIAL_DISPLAY = "time_to_initial_display", $49d40eaf9ca0cfa4$var$TRANSACTION = "transaction", $49d40eaf9ca0cfa4$var$TRPC_PROCEDURE_PATH = "trpc.procedure_path", $49d40eaf9ca0cfa4$var$TRPC_PROCEDURE_TYPE = "trpc.procedure_type", $49d40eaf9ca0cfa4$var$TTFB = "ttfb", $49d40eaf9ca0cfa4$var$TTFB_REQUESTTIME = "ttfb.requestTime", $49d40eaf9ca0cfa4$var$TYPE = "type", $49d40eaf9ca0cfa4$var$UI_COMPONENT_NAME = "ui.component_name", $49d40eaf9ca0cfa4$var$UI_CONTRIBUTES_TO_TTFD = "ui.contributes_to_ttfd", $49d40eaf9ca0cfa4$var$UI_CONTRIBUTES_TO_TTID = "ui.contributes_to_ttid", $49d40eaf9ca0cfa4$var$UI_ELEMENT_HEIGHT = "ui.element.height", $49d40eaf9ca0cfa4$var$UI_ELEMENT_ID = "ui.element.id", $49d40eaf9ca0cfa4$var$UI_ELEMENT_IDENTIFIER = "ui.element.identifier", $49d40eaf9ca0cfa4$var$UI_ELEMENT_LOAD_TIME = "ui.element.load_time", $49d40eaf9ca0cfa4$var$UI_ELEMENT_PAINT_TYPE = "ui.element.paint_type", $49d40eaf9ca0cfa4$var$UI_ELEMENT_RENDER_TIME = "ui.element.render_time", $49d40eaf9ca0cfa4$var$UI_ELEMENT_TYPE = "ui.element.type", $49d40eaf9ca0cfa4$var$UI_ELEMENT_URL = "ui.element.url", $49d40eaf9ca0cfa4$var$UI_ELEMENT_WIDTH = "ui.element.width", $49d40eaf9ca0cfa4$var$URL = "url", $49d40eaf9ca0cfa4$var$URL_DOMAIN = "url.domain", $49d40eaf9ca0cfa4$var$URL_FRAGMENT = "url.fragment", $49d40eaf9ca0cfa4$var$URL_FULL = "url.full", $49d40eaf9ca0cfa4$var$URL_PATH = "url.path", $49d40eaf9ca0cfa4$var$URL_PATH_PARAMETER_KEY = "url.path.parameter.<key>", $49d40eaf9ca0cfa4$var$URL_PATH_PARAMETER_KEY_BASE = "url.path.parameter", $49d40eaf9ca0cfa4$var$URL_PORT = "url.port", $49d40eaf9ca0cfa4$var$URL_QUERY = "url.query", $49d40eaf9ca0cfa4$var$URL_SAME_ORIGIN = "url.same_origin", $49d40eaf9ca0cfa4$var$URL_SCHEME = "url.scheme", $49d40eaf9ca0cfa4$var$URL_TEMPLATE = "url.template", $49d40eaf9ca0cfa4$var$USER_AGENT_ORIGINAL = "user_agent.original", $49d40eaf9ca0cfa4$var$USER_EMAIL = "user.email", $49d40eaf9ca0cfa4$var$USER_FULL_NAME = "user.full_name", $49d40eaf9ca0cfa4$var$USER_GEO_CITY = "user.geo.city", $49d40eaf9ca0cfa4$var$USER_GEO_COUNTRY_CODE = "user.geo.country_code", $49d40eaf9ca0cfa4$var$USER_GEO_REGION = "user.geo.region", $49d40eaf9ca0cfa4$var$USER_GEO_SUBDIVISION = "user.geo.subdivision", $49d40eaf9ca0cfa4$var$USER_HASH = "user.hash", $49d40eaf9ca0cfa4$var$USER_ID = "user.id", $49d40eaf9ca0cfa4$var$USER_IP_ADDRESS = "user.ip_address", $49d40eaf9ca0cfa4$var$USER_NAME = "user.name", $49d40eaf9ca0cfa4$var$USER_ROLES = "user.roles", $49d40eaf9ca0cfa4$var$VERCEL_BRANCH = "vercel.branch", $49d40eaf9ca0cfa4$var$VERCEL_BUILD_ID = "vercel.build_id", $49d40eaf9ca0cfa4$var$VERCEL_DEPLOYMENT_ID = "vercel.deployment_id", $49d40eaf9ca0cfa4$var$VERCEL_DESTINATION = "vercel.destination", $49d40eaf9ca0cfa4$var$VERCEL_EDGE_TYPE = "vercel.edge_type", $49d40eaf9ca0cfa4$var$VERCEL_ENTRYPOINT = "vercel.entrypoint", $49d40eaf9ca0cfa4$var$VERCEL_EXECUTION_REGION = "vercel.execution_region", $49d40eaf9ca0cfa4$var$VERCEL_ID = "vercel.id", $49d40eaf9ca0cfa4$var$VERCEL_JA3_DIGEST = "vercel.ja3_digest", $49d40eaf9ca0cfa4$var$VERCEL_JA4_DIGEST = "vercel.ja4_digest", $49d40eaf9ca0cfa4$var$VERCEL_LOG_TYPE = "vercel.log_type", $49d40eaf9ca0cfa4$var$VERCEL_PATH = "vercel.path", $49d40eaf9ca0cfa4$var$VERCEL_PROJECT_ID = "vercel.project_id", $49d40eaf9ca0cfa4$var$VERCEL_PROJECT_NAME = "vercel.project_name", $49d40eaf9ca0cfa4$var$VERCEL_PROXY_CACHE_ID = "vercel.proxy.cache_id", $49d40eaf9ca0cfa4$var$VERCEL_PROXY_CLIENT_IP = "vercel.proxy.client_ip", $49d40eaf9ca0cfa4$var$VERCEL_PROXY_HOST = "vercel.proxy.host", $49d40eaf9ca0cfa4$var$VERCEL_PROXY_LAMBDA_REGION = "vercel.proxy.lambda_region", $49d40eaf9ca0cfa4$var$VERCEL_PROXY_METHOD = "vercel.proxy.method", $49d40eaf9ca0cfa4$var$VERCEL_PROXY_PATH = "vercel.proxy.path", $49d40eaf9ca0cfa4$var$VERCEL_PROXY_PATH_TYPE = "vercel.proxy.path_type", $49d40eaf9ca0cfa4$var$VERCEL_PROXY_PATH_TYPE_VARIANT = "vercel.proxy.path_type_variant", $49d40eaf9ca0cfa4$var$VERCEL_PROXY_REFERER = "vercel.proxy.referer", $49d40eaf9ca0cfa4$var$VERCEL_PROXY_REGION = "vercel.proxy.region", $49d40eaf9ca0cfa4$var$VERCEL_PROXY_RESPONSE_BYTE_SIZE = "vercel.proxy.response_byte_size", $49d40eaf9ca0cfa4$var$VERCEL_PROXY_SCHEME = "vercel.proxy.scheme", $49d40eaf9ca0cfa4$var$VERCEL_PROXY_STATUS_CODE = "vercel.proxy.status_code", $49d40eaf9ca0cfa4$var$VERCEL_PROXY_TIMESTAMP = "vercel.proxy.timestamp", $49d40eaf9ca0cfa4$var$VERCEL_PROXY_USER_AGENT = "vercel.proxy.user_agent", $49d40eaf9ca0cfa4$var$VERCEL_PROXY_VERCEL_CACHE = "vercel.proxy.vercel_cache", $49d40eaf9ca0cfa4$var$VERCEL_PROXY_VERCEL_ID = "vercel.proxy.vercel_id", $49d40eaf9ca0cfa4$var$VERCEL_PROXY_WAF_ACTION = "vercel.proxy.waf_action", $49d40eaf9ca0cfa4$var$VERCEL_PROXY_WAF_RULE_ID = "vercel.proxy.waf_rule_id", $49d40eaf9ca0cfa4$var$VERCEL_REQUEST_ID = "vercel.request_id", $49d40eaf9ca0cfa4$var$VERCEL_SOURCE = "vercel.source", $49d40eaf9ca0cfa4$var$VERCEL_STATUS_CODE = "vercel.status_code", $49d40eaf9ca0cfa4$var$ATTRIBUTE_TYPE = {
    "ai.citations": "string[]",
    "ai.completion_tokens.used": "integer",
    "ai.documents": "string[]",
    "ai.finish_reason": "string",
    "ai.frequency_penalty": "double",
    "ai.function_call": "string",
    "ai.generation_id": "string",
    "ai.input_messages": "string",
    "ai.is_search_required": "boolean",
    "ai.metadata": "string",
    "ai.model_id": "string",
    "ai.model.provider": "string",
    "ai.pipeline.name": "string",
    "ai.preamble": "string",
    "ai.presence_penalty": "double",
    "ai.prompt_tokens.used": "integer",
    "ai.raw_prompting": "boolean",
    "ai.responses": "string[]",
    "ai.response_format": "string",
    "ai.search_queries": "string[]",
    "ai.search_results": "string[]",
    "ai.seed": "string",
    "ai.streaming": "boolean",
    "ai.tags": "string",
    "ai.temperature": "double",
    "ai.texts": "string[]",
    "ai.tools": "string[]",
    "ai.tool_calls": "string[]",
    "ai.top_k": "integer",
    "ai.top_p": "double",
    "ai.total_cost": "double",
    "ai.total_tokens.used": "integer",
    "ai.warnings": "string[]",
    "angular.version": "string",
    "app.app_build": "string",
    "app.app_identifier": "string",
    "app.app_name": "string",
    "app.app_start_time": "string",
    "app.app_version": "string",
    "app.build": "string",
    "app.identifier": "string",
    "app.in_foreground": "boolean",
    "app.name": "string",
    app_start_cold: "double",
    "app.start_time": "string",
    app_start_type: "string",
    app_start_warm: "double",
    "app.version": "string",
    "app.vitals.frames.delay.value": "integer",
    "app.vitals.frames.frozen.count": "integer",
    "app.vitals.frames.slow.count": "integer",
    "app.vitals.frames.total.count": "integer",
    "app.vitals.start.cold.value": "double",
    "app.vitals.start.prewarmed": "boolean",
    "app.vitals.start.reason": "string",
    "app.vitals.start.screen": "string",
    "app.vitals.start.type": "string",
    "app.vitals.start.warm.value": "double",
    "app.vitals.ttfd.value": "double",
    "app.vitals.ttid.value": "double",
    "art.gc.blocking_count": "integer",
    "art.gc.blocking_time": "double",
    "art.gc.pre_oome_count": "integer",
    "art.gc.total_count": "integer",
    "art.gc.total_time": "double",
    "art.gc.waiting_time": "double",
    "art.memory.free": "integer",
    "art.memory.free_until_gc": "integer",
    "art.memory.free_until_oome": "integer",
    "art.memory.max": "integer",
    "art.memory.total": "integer",
    "aws.cloudwatch.logs.log_group": "string",
    "aws.cloudwatch.logs.log_stream": "string",
    "aws.cloudwatch.logs.url": "string",
    "aws.dynamodb.attribute_definitions": "string[]",
    "aws.dynamodb.consistent_read": "boolean",
    "aws.dynamodb.consumed_capacity": "string[]",
    "aws.dynamodb.count": "integer",
    "aws.dynamodb.exclusive_start_table": "string",
    "aws.dynamodb.global_secondary_indexes": "string[]",
    "aws.dynamodb.global_secondary_index_updates": "string[]",
    "aws.dynamodb.index_name": "string",
    "aws.dynamodb.item_collection_metrics": "string",
    "aws.dynamodb.limit": "integer",
    "aws.dynamodb.local_secondary_indexes": "string[]",
    "aws.dynamodb.projection": "string",
    "aws.dynamodb.provisioned_read_capacity": "double",
    "aws.dynamodb.provisioned_write_capacity": "double",
    "aws.dynamodb.scanned_count": "integer",
    "aws.dynamodb.scan_forward": "boolean",
    "aws.dynamodb.segment": "integer",
    "aws.dynamodb.select": "string",
    "aws.dynamodb.table_count": "integer",
    "aws.dynamodb.table_names": "string[]",
    "aws.dynamodb.total_segments": "integer",
    "aws.extended_request_id": "string",
    "aws.kinesis.stream_name": "string",
    "aws.kinesis.stream.name": "string",
    "aws.lambda.aws_request_id": "string",
    "aws.lambda.execution_duration_in_millis": "double",
    "aws.lambda.function_name": "string",
    "aws.lambda.function_version": "string",
    "aws.lambda.invoked_arn": "string",
    "aws.lambda.invoked_function_arn": "string",
    "aws.lambda.remaining_time_in_millis": "double",
    "aws.log.group.names": "string[]",
    "aws.log.stream.names": "string[]",
    "aws.request.extended_id": "string",
    "aws.request_id": "string",
    "aws.request.id": "string",
    "aws.s3.bucket": "string",
    "aws.secretsmanager.secret.arn": "string",
    "aws.sns.topic.arn": "string",
    "aws.step_functions.activity.arn": "string",
    "aws.step_functions.state_machine.arn": "string",
    blocked_main_thread: "boolean",
    "browser.name": "string",
    "browser.performance.navigation.activation_start": "double",
    "browser.performance.time_origin": "double",
    "browser.report.type": "string",
    "browser.script.invoker": "string",
    "browser.script.invoker_type": "string",
    "browser.script.source_char_position": "integer",
    "browser.version": "string",
    "browser.web_vital.cls.report_event": "string",
    "browser.web_vital.cls.source.<key>": "string",
    "browser.web_vital.cls.value": "double",
    "browser.web_vital.fcp.value": "double",
    "browser.web_vital.fp.value": "double",
    "browser.web_vital.inp.value": "double",
    "browser.web_vital.lcp.element": "string",
    "browser.web_vital.lcp.id": "string",
    "browser.web_vital.lcp.load_time": "integer",
    "browser.web_vital.lcp.render_time": "integer",
    "browser.web_vital.lcp.report_event": "string",
    "browser.web_vital.lcp.size": "integer",
    "browser.web_vital.lcp.url": "string",
    "browser.web_vital.lcp.value": "double",
    "browser.web_vital.ttfb.request_time": "double",
    "browser.web_vital.ttfb.value": "double",
    "cache.hit": "boolean",
    "cache.item_size": "integer",
    "cache.key": "string[]",
    "cache.operation": "string",
    "cache.ttl": "integer",
    "cache.write": "boolean",
    channel: "string",
    "client.address": "string",
    "client.port": "integer",
    "cloudflare.d1.duration": "integer",
    "cloudflare.d1.query_type": "string",
    "cloudflare.d1.rows_read": "integer",
    "cloudflare.d1.rows_written": "integer",
    "cloudflare.durable_object.query.bindings": "integer",
    "cloudflare.durable_object.response.rows_read": "integer",
    "cloudflare.durable_object.response.rows_written": "integer",
    "cloudflare.r2.bucket": "string",
    "cloudflare.r2.operation": "string",
    "cloudflare.r2.request.delimiter": "string",
    "cloudflare.r2.request.key": "string",
    "cloudflare.r2.request.part_number": "integer",
    "cloudflare.r2.request.prefix": "string",
    "cloudflare.workflow.attempt": "integer",
    "cloudflare.workflow.retries.backoff": "string",
    "cloudflare.workflow.retries.delay": "string",
    "cloudflare.workflow.retries.limit": "integer",
    "cloudflare.workflow.timeout": "string",
    "cloud.account.id": "string",
    "cloud.availability_zone": "string",
    "cloud.platform": "string",
    "cloud.provider": "string",
    "cloud.region": "string",
    "cloud.resource_id": "string",
    cls: "double",
    "cls.source.<key>": "string",
    "code.filepath": "string",
    "code.file.path": "string",
    "code.function": "string",
    "code.function.name": "string",
    "code.lineno": "integer",
    "code.line.number": "integer",
    "code.namespace": "string",
    connectionType: "string",
    "connection.rtt": "integer",
    "culture.calendar": "string",
    "culture.display_name": "string",
    "culture.is_24_hour_format": "boolean",
    "culture.locale": "string",
    "culture.timezone": "string",
    "db.collection.name": "string",
    "db.driver.name": "string",
    "db.name": "string",
    "db.namespace": "string",
    "db.operation": "string",
    "db.operation.batch.size": "integer",
    "db.operation.name": "string",
    "db.query.parameter.<key>": "string",
    "db.query.summary": "string",
    "db.query.text": "string",
    "db.redis.connection": "string",
    "db.redis.key": "string",
    "db.redis.parameters": "string[]",
    "db.response.status_code": "string",
    "db.sql.bindings": "string[]",
    "db.statement": "string",
    "db.stored_procedure.name": "string",
    "db.system": "string",
    "db.system.name": "string",
    "db.user": "string",
    deviceMemory: "string",
    "device.archs": "string[]",
    "device.battery_level": "double",
    "device.battery_temperature": "double",
    "device.boot_time": "string",
    "device.brand": "string",
    "device.charging": "boolean",
    "device.chipset": "string",
    "device.class": "string",
    "device.connection_type": "string",
    "device.cpu_description": "string",
    "device.external_free_storage": "integer",
    "device.external_storage_size": "integer",
    "device.family": "string",
    "device.free_memory": "integer",
    "device.free_storage": "integer",
    "device.id": "string",
    "device.locale": "string",
    "device.low_memory": "boolean",
    "device.low_power_mode": "boolean",
    "device.manufacturer": "string",
    "device.memory.estimated_capacity": "integer",
    "device.memory_size": "integer",
    "device.model": "string",
    "device.model_id": "string",
    "device.name": "string",
    "device.online": "boolean",
    "device.orientation": "string",
    "device.processor_count": "integer",
    "device.processor_frequency": "double",
    "device.screen_density": "double",
    "device.screen_dpi": "integer",
    "device.screen_height_pixels": "integer",
    "device.screen_width_pixels": "integer",
    "device.simulator": "boolean",
    "device.storage_size": "integer",
    "device.thermal_state": "string",
    "device.timezone": "string",
    "device.usable_memory": "integer",
    dist: "string",
    effectiveConnectionType: "string",
    environment: "string",
    "error.type": "string",
    "event.id": "integer",
    "event.name": "string",
    "exception.escaped": "boolean",
    "exception.message": "string",
    "exception.stacktrace": "string",
    "exception.type": "string",
    "faas.coldstart": "boolean",
    "faas.cron": "string",
    "faas.duration_in_ms": "integer",
    "faas.entry_point": "string",
    "faas.execution": "string",
    "faas.id": "string",
    "faas.identity": "string",
    "faas.invocation_id": "string",
    "faas.invoked_name": "string",
    "faas.invoked_provider": "string",
    "faas.invoked_region": "string",
    "faas.name": "string",
    "faas.time": "string",
    "faas.trigger": "string",
    "faas.version": "string",
    fcp: "double",
    "flag.evaluation.<key>": "boolean",
    fp: "double",
    "frames.delay": "integer",
    "frames.frozen": "integer",
    frames_frozen_rate: "double",
    "frames.slow": "integer",
    frames_slow_rate: "double",
    "frames.total": "integer",
    fs_error: "string",
    "gcp.function.context.event_id": "string",
    "gcp.function.context.event_type": "string",
    "gcp.function.context.id": "string",
    "gcp.function.context.resource": "string",
    "gcp.function.context.source": "string",
    "gcp.function.context.specversion": "string",
    "gcp.function.context.time": "string",
    "gcp.function.context.timestamp": "string",
    "gcp.function.context.type": "string",
    "gcp.project.id": "string",
    "gen_ai.agent.name": "string",
    "gen_ai.context.utilization": "double",
    "gen_ai.context.window_size": "integer",
    "gen_ai.conversation.id": "string",
    "gen_ai.cost.cache_creation.input_tokens": "double",
    "gen_ai.cost.cache_read.input_tokens": "double",
    "gen_ai.cost.input_tokens": "double",
    "gen_ai.cost.output_tokens": "double",
    "gen_ai.cost.reasoning.output_tokens": "double",
    "gen_ai.cost.total_tokens": "double",
    "gen_ai.embeddings.input": "string",
    "gen_ai.function_id": "string",
    "gen_ai.input.messages": "string",
    "gen_ai.operation.name": "string",
    "gen_ai.operation.type": "string",
    "gen_ai.output.messages": "string",
    "gen_ai.pipeline.name": "string",
    "gen_ai.prompt": "string",
    "gen_ai.prompt.name": "string",
    "gen_ai.provider.name": "string",
    "gen_ai.request.available_tools": "string",
    "gen_ai.request.frequency_penalty": "double",
    "gen_ai.request.max_tokens": "integer",
    "gen_ai.request.messages": "string",
    "gen_ai.request.model": "string",
    "gen_ai.request.presence_penalty": "double",
    "gen_ai.request.reasoning_effort": "string",
    "gen_ai.request.seed": "string",
    "gen_ai.request.stop_sequences": "string[]",
    "gen_ai.request.temperature": "double",
    "gen_ai.request.top_k": "integer",
    "gen_ai.request.top_p": "double",
    "gen_ai.response.finish_reasons": "string",
    "gen_ai.response.id": "string",
    "gen_ai.response.model": "string",
    "gen_ai.response.streaming": "boolean",
    "gen_ai.response.text": "string",
    "gen_ai.response.time_to_first_chunk": "double",
    "gen_ai.response.time_to_first_token": "double",
    "gen_ai.response.tokens_per_second": "double",
    "gen_ai.response.tool_calls": "string",
    "gen_ai.system": "string",
    "gen_ai.system_instructions": "string",
    "gen_ai.system.message": "string",
    "gen_ai.tool.call.arguments": "string",
    "gen_ai.tool.call.result": "string",
    "gen_ai.tool.definitions": "string",
    "gen_ai.tool.description": "string",
    "gen_ai.tool.input": "string",
    "gen_ai.tool.message": "string",
    "gen_ai.tool.name": "string",
    "gen_ai.tool.output": "string",
    "gen_ai.tool.type": "string",
    "gen_ai.usage.cache_creation.input_tokens": "integer",
    "gen_ai.usage.cache_read.input_tokens": "integer",
    "gen_ai.usage.completion_tokens": "integer",
    "gen_ai.usage.input_tokens": "integer",
    "gen_ai.usage.input_tokens.cached": "integer",
    "gen_ai.usage.input_tokens.cache_write": "integer",
    "gen_ai.usage.output_tokens": "integer",
    "gen_ai.usage.output_tokens.reasoning": "integer",
    "gen_ai.usage.prompt_tokens": "integer",
    "gen_ai.usage.reasoning.output_tokens": "integer",
    "gen_ai.usage.total_tokens": "integer",
    "graphql.document": "string",
    "graphql.operation.name": "string",
    "graphql.operation.type": "string",
    hardwareConcurrency: "string",
    "http.client_ip": "string",
    "http.decoded_response_content_length": "integer",
    "http.flavor": "string",
    "http.fragment": "string",
    "http.host": "string",
    "http.method": "string",
    "http.query": "string",
    "http.request.body.data": "string",
    "http.request.connection_end": "double",
    "http.request.connect_start": "double",
    "http.request.domain_lookup_end": "double",
    "http.request.domain_lookup_start": "double",
    "http.request.fetch_start": "double",
    "http.request.header.<key>": "string[]",
    "http.request.method": "string",
    "http.request_method": "string",
    "http.request.redirect_end": "double",
    "http.request.redirect_start": "double",
    "http.request.request_start": "double",
    "http.request.resend_count": "integer",
    "http.request.response_end": "double",
    "http.request.response_start": "double",
    "http.request.same_origin": "boolean",
    "http.request.secure_connection_start": "double",
    "http.request.time_to_first_byte": "double",
    "http.request.worker_start": "double",
    "http.response.body.size": "integer",
    "http.response_content_length": "integer",
    "http.response.header.content-length": "string",
    "http.response.header.<key>": "string[]",
    "http.response.size": "integer",
    "http.response.status_code": "integer",
    "http.response_transfer_size": "integer",
    "http.route": "string",
    "http.scheme": "string",
    "http.server_name": "string",
    "http.server.request.time_in_queue": "double",
    "http.status_code": "integer",
    "http.target": "string",
    "http.url": "string",
    "http.user_agent": "string",
    id: "string",
    inp: "double",
    "jsonrpc.protocol.version": "string",
    "jsonrpc.request.id": "string",
    "jvm.gc.action": "string",
    "jvm.gc.name": "string",
    "jvm.memory.pool.name": "string",
    "jvm.memory.type": "string",
    "jvm.thread.daemon": "boolean",
    "jvm.thread.state": "string",
    "koa.name": "string",
    "koa.type": "string",
    lcp: "double",
    "lcp.element": "string",
    "lcp.id": "string",
    "lcp.loadTime": "integer",
    "lcp.renderTime": "integer",
    "lcp.size": "integer",
    "lcp.url": "string",
    "logger.name": "string",
    "mcp.cancelled.reason": "string",
    "mcp.cancelled.request_id": "string",
    "mcp.client.name": "string",
    "mcp.client.title": "string",
    "mcp.client.version": "string",
    "mcp.lifecycle.phase": "string",
    "mcp.logging.data_type": "string",
    "mcp.logging.level": "string",
    "mcp.logging.logger": "string",
    "mcp.logging.message": "string",
    "mcp.method.name": "string",
    "mcp.progress.current": "integer",
    "mcp.progress.message": "string",
    "mcp.progress.percentage": "double",
    "mcp.progress.token": "string",
    "mcp.progress.total": "integer",
    "mcp.prompt.name": "string",
    "mcp.prompt.result.description": "string",
    "mcp.prompt.result.message_content": "string",
    "mcp.prompt.result.message_count": "integer",
    "mcp.prompt.result.message_role": "string",
    "mcp.protocol.ready": "integer",
    "mcp.protocol.version": "string",
    "mcp.request.argument.<key>": "string",
    "mcp.request.argument.name": "string",
    "mcp.request.argument.uri": "string",
    "mcp.request.id": "string",
    "mcp.resource.protocol": "string",
    "mcp.resource.uri": "string",
    "mcp.server.name": "string",
    "mcp.server.title": "string",
    "mcp.server.version": "string",
    "mcp.session.id": "string",
    "mcp.tool.name": "string",
    "mcp.tool.result.content": "string",
    "mcp.tool.result.content_count": "integer",
    "mcp.tool.result.is_error": "boolean",
    "mcp.transport": "string",
    "mdc.<key>": "string",
    "messaging.batch.message_count": "integer",
    "messaging.destination": "string",
    "messaging.destination.connection": "string",
    "messaging.destination.name": "string",
    "messaging.message.body.size": "integer",
    "messaging.message.conversation_id": "string",
    "messaging.message.envelope.size": "integer",
    "messaging.message.id": "string",
    "messaging.message.receive.latency": "integer",
    "messaging.message.retry.count": "integer",
    "messaging.operation.name": "string",
    "messaging.operation.type": "string",
    "messaging.rabbitmq.destination.routing_key": "string",
    "messaging.system": "string",
    method: "string",
    "middleware.name": "string",
    "navigation.origin": "string",
    "navigation.route.id": "string",
    "navigation.type": "string",
    "nel.elapsed_time": "integer",
    "nel.phase": "string",
    "nel.referrer": "string",
    "nel.sampling_function": "double",
    "nel.type": "string",
    "network.connection.effective_type": "string",
    "network.connection.rtt": "integer",
    "network.connection.type": "string",
    "network.local.address": "string",
    "network.local.port": "integer",
    "network.peer.address": "string",
    "network.peer.port": "integer",
    "network.protocol.name": "string",
    "network.protocol.version": "string",
    "network.transport": "string",
    "network.type": "string",
    "net.host.ip": "string",
    "net.host.name": "string",
    "net.host.port": "integer",
    "net.peer.ip": "string",
    "net.peer.name": "string",
    "net.peer.port": "integer",
    "net.protocol.name": "string",
    "net.protocol.version": "string",
    "net.sock.family": "string",
    "net.sock.host.addr": "string",
    "net.sock.host.port": "integer",
    "net.sock.peer.addr": "string",
    "net.sock.peer.name": "string",
    "net.sock.peer.port": "integer",
    "net.transport": "string",
    "os.build": "string",
    "os.build_id": "string",
    "os.description": "string",
    "os.kernel_version": "string",
    "os.name": "string",
    "os.raw_description": "string",
    "os.rooted": "boolean",
    "os.theme": "string",
    "os.type": "string",
    "os.version": "string",
    "otel.kind": "string",
    "otel.scope.name": "string",
    "otel.scope.version": "string",
    "otel.status_code": "string",
    "otel.status_description": "string",
    "params.<key>": "string",
    "performance.activationStart": "double",
    "performance.timeOrigin": "double",
    previous_route: "string",
    "process.command_args": "string[]",
    "process.executable.name": "string",
    "process.pid": "integer",
    "process.runtime.description": "string",
    "process.runtime.engine.name": "string",
    "process.runtime.engine.version": "string",
    "process.runtime.name": "string",
    "process.runtime.version": "string",
    "query.<key>": "string",
    "react.version": "string",
    release: "string",
    "remix.action_form_data.<key>": "string",
    replay_id: "string",
    "resource.deployment.environment": "string",
    "resource.deployment.environment.name": "string",
    "resource.render_blocking_status": "string",
    route: "string",
    "rpc.grpc.status_code": "integer",
    "rpc.method": "string",
    "rpc.response.status_code": "string",
    "rpc.service": "string",
    "rpc.system": "string",
    "rpc.system.name": "string",
    "runtime.build": "string",
    "runtime.name": "string",
    "runtime.raw_description": "string",
    "runtime.version": "string",
    "score.<key>": "double",
    "score.ratio.<key>": "double",
    "score.total": "double",
    "score.weight.<key>": "double",
    "sentry.action": "string",
    "sentry.browser.name": "string",
    "sentry.browser.version": "string",
    "sentry.cancellation_reason": "string",
    "sentry.category": "string",
    "sentry.client_sample_rate": "double",
    "sentry.description": "string",
    "sentry.dist": "string",
    "sentry.domain": "string",
    "sentry.dsc.environment": "string",
    "sentry.dsc.project_id": "string",
    "sentry.dsc.public_key": "string",
    "sentry.dsc.release": "string",
    "sentry.dsc.sampled": "boolean",
    "sentry.dsc.sample_rate": "string",
    "sentry.dsc.trace_id": "string",
    "sentry.dsc.transaction": "string",
    "sentry.environment": "string",
    "sentry.exclusive_time": "double",
    "sentry.graphql.operation": "string",
    "sentry.group": "string",
    "sentry.http.prefetch": "boolean",
    "sentry.idle_span_finish_reason": "string",
    "sentry.is_remote": "boolean",
    "sentry.kind": "string",
    "sentry.main_thread": "boolean",
    "sentry.message.parameter.<key>": "string",
    "sentry.message.template": "string",
    "sentry.metric.source": "string",
    "sentry.mobile": "boolean",
    "sentry.module.<key>": "string",
    "sentry.nextjs.ssr.function.route": "string",
    "sentry.nextjs.ssr.function.type": "string",
    "sentry.normalized_db_query": "string",
    "sentry.normalized_db_query.hash": "string",
    "sentry.normalized_description": "string",
    "sentry.observed_timestamp_nanos": "string",
    "sentry.op": "string",
    "sentry.origin": "string",
    "sentry.platform": "string",
    "sentry.profiler_id": "string",
    "sentry.profile_id": "string",
    "sentry.release": "string",
    "sentry.replay_id": "string",
    "sentry.replay_is_buffering": "boolean",
    "sentry.report_event": "string",
    "sentry.sdk.integrations": "string[]",
    "sentry.sdk.name": "string",
    "sentry.sdk.version": "string",
    "sentry.segment.id": "string",
    "sentry.segment_id": "string",
    "sentry.segment.name": "string",
    "sentry.server_sample_rate": "double",
    "sentry.source": "string",
    "sentry.span.source": "string",
    "sentry.status": "string",
    "sentry.status_code": "integer",
    "sentry.status.message": "string",
    "sentry.sveltekit.navigation.from": "string",
    "sentry.sveltekit.navigation.to": "string",
    "sentry.sveltekit.navigation.type": "string",
    "sentry.thread.id": "integer",
    "sentry.timestamp.sequence": "integer",
    "sentry.trace_lifecycle": "string",
    "sentry.trace.parent_span_id": "string",
    "sentry.trace.status": "string",
    "sentry.transaction": "string",
    "sentry.user.email": "string",
    "sentry.user.geo.city": "string",
    "sentry.user.geo.country_code": "string",
    "sentry.user.geo.region": "string",
    "sentry.user.geo.subdivision": "string",
    "sentry.user.id": "string",
    "sentry.user.ip": "string",
    "sentry.user.username": "string",
    "server.address": "string",
    server_name: "string",
    "server.port": "integer",
    "service.name": "string",
    "service.version": "string",
    "session.id": "string",
    stall_percentage: "double",
    stall_total_time: "double",
    "state.type": "string",
    "thread.id": "integer",
    "thread.name": "string",
    "timber.tag": "string",
    time_to_full_display: "double",
    time_to_initial_display: "double",
    transaction: "string",
    "trpc.procedure_path": "string",
    "trpc.procedure_type": "string",
    ttfb: "double",
    "ttfb.requestTime": "double",
    type: "string",
    "ui.component_name": "string",
    "ui.contributes_to_ttfd": "boolean",
    "ui.contributes_to_ttid": "boolean",
    "ui.element.height": "integer",
    "ui.element.id": "string",
    "ui.element.identifier": "string",
    "ui.element.load_time": "double",
    "ui.element.paint_type": "string",
    "ui.element.render_time": "double",
    "ui.element.type": "string",
    "ui.element.url": "string",
    "ui.element.width": "integer",
    url: "string",
    "url.domain": "string",
    "url.fragment": "string",
    "url.full": "string",
    "url.path": "string",
    "url.path.parameter.<key>": "string",
    "url.port": "integer",
    "url.query": "string",
    "url.same_origin": "boolean",
    "url.scheme": "string",
    "url.template": "string",
    "user_agent.original": "string",
    "user.email": "string",
    "user.full_name": "string",
    "user.geo.city": "string",
    "user.geo.country_code": "string",
    "user.geo.region": "string",
    "user.geo.subdivision": "string",
    "user.hash": "string",
    "user.id": "string",
    "user.ip_address": "string",
    "user.name": "string",
    "user.roles": "string[]",
    "vercel.branch": "string",
    "vercel.build_id": "string",
    "vercel.deployment_id": "string",
    "vercel.destination": "string",
    "vercel.edge_type": "string",
    "vercel.entrypoint": "string",
    "vercel.execution_region": "string",
    "vercel.id": "string",
    "vercel.ja3_digest": "string",
    "vercel.ja4_digest": "string",
    "vercel.log_type": "string",
    "vercel.path": "string",
    "vercel.project_id": "string",
    "vercel.project_name": "string",
    "vercel.proxy.cache_id": "string",
    "vercel.proxy.client_ip": "string",
    "vercel.proxy.host": "string",
    "vercel.proxy.lambda_region": "string",
    "vercel.proxy.method": "string",
    "vercel.proxy.path": "string",
    "vercel.proxy.path_type": "string",
    "vercel.proxy.path_type_variant": "string",
    "vercel.proxy.referer": "string",
    "vercel.proxy.region": "string",
    "vercel.proxy.response_byte_size": "integer",
    "vercel.proxy.scheme": "string",
    "vercel.proxy.status_code": "integer",
    "vercel.proxy.timestamp": "integer",
    "vercel.proxy.user_agent": "string[]",
    "vercel.proxy.vercel_cache": "string",
    "vercel.proxy.vercel_id": "string",
    "vercel.proxy.waf_action": "string",
    "vercel.proxy.waf_rule_id": "string",
    "vercel.request_id": "string",
    "vercel.source": "string",
    "vercel.status_code": "integer"
}, $49d40eaf9ca0cfa4$var$ATTRIBUTE_METADATA = {
    "ai.citations": {
        brief: "References or sources cited by the AI model in its response.",
        type: "string[]",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: [
            "Citation 1",
            "Citation 2"
        ],
        deprecation: {},
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55
                ]
            }
        ]
    },
    "ai.completion_tokens.used": {
        brief: "The number of tokens used to respond to the message.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 10,
        deprecation: {
            replacement: "gen_ai.usage.output_tokens"
        },
        aliases: [
            "gen_ai.usage.output_tokens",
            "gen_ai.usage.completion_tokens"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    57,
                    61
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "ai.documents": {
        brief: "Documents or content chunks used as context for the AI model.",
        type: "string[]",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: [
            "document1.txt",
            "document2.pdf"
        ],
        deprecation: {},
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55
                ]
            }
        ]
    },
    "ai.finish_reason": {
        brief: "The reason why the model stopped generating.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "COMPLETE",
        deprecation: {
            replacement: "gen_ai.response.finish_reasons"
        },
        aliases: [
            "gen_ai.response.finish_reasons"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    55,
                    57,
                    61,
                    108,
                    127
                ]
            }
        ]
    },
    "ai.frequency_penalty": {
        brief: "Used to reduce repetitiveness of generated tokens. The higher the value, the stronger a penalty is applied to previously present tokens, proportional to how many times they have already appeared in the prompt or prior generation.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: .5,
        deprecation: {
            replacement: "gen_ai.request.frequency_penalty"
        },
        aliases: [
            "gen_ai.request.frequency_penalty"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55,
                    57,
                    61,
                    108
                ]
            }
        ]
    },
    "ai.function_call": {
        brief: "For an AI model call, the function that was called. This is deprecated for OpenAI, and replaced by tool_calls",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "function_name",
        deprecation: {
            replacement: "gen_ai.tool.name"
        },
        aliases: [
            "gen_ai.tool.name",
            "mcp.tool.name"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    55,
                    57,
                    61,
                    108
                ]
            }
        ]
    },
    "ai.generation_id": {
        brief: "Unique identifier for the completion.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "gen_123abc",
        deprecation: {
            replacement: "gen_ai.response.id"
        },
        aliases: [
            "gen_ai.response.id"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    55,
                    57,
                    61,
                    108,
                    127
                ]
            }
        ]
    },
    "ai.input_messages": {
        brief: "The input messages sent to the model",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: '[{"role": "user", "message": "hello"}]',
        deprecation: {
            replacement: "gen_ai.input.messages"
        },
        aliases: [
            "gen_ai.request.messages"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    65,
                    119
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "ai.is_search_required": {
        brief: "Boolean indicating if the model needs to perform a search.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !1,
        deprecation: {},
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55
                ]
            }
        ]
    },
    "ai.metadata": {
        brief: "Extra metadata passed to an AI pipeline step.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: '{"user_id": 123, "session_id": "abc123"}',
        deprecation: {},
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55,
                    127
                ]
            }
        ]
    },
    "ai.model_id": {
        brief: "The vendor-specific ID of the model used.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "gpt-4",
        deprecation: {
            replacement: "gen_ai.response.model"
        },
        aliases: [
            "gen_ai.response.model"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    57,
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "ai.model.provider": {
        brief: "The provider of the model.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "openai",
        deprecation: {
            replacement: "gen_ai.provider.name"
        },
        aliases: [
            "gen_ai.provider.name",
            "gen_ai.system"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    253
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    57,
                    61,
                    108,
                    127
                ]
            }
        ]
    },
    "ai.pipeline.name": {
        brief: "The name of the AI pipeline.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Autofix Pipeline",
        deprecation: {
            replacement: "gen_ai.pipeline.name"
        },
        aliases: [
            "gen_ai.pipeline.name"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    53,
                    76,
                    108,
                    127
                ]
            }
        ]
    },
    "ai.preamble": {
        brief: "For an AI model call, the preamble parameter. Preambles are a part of the prompt used to adjust the model's overall behavior and conversation style.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "You are now a clown.",
        deprecation: {
            replacement: "gen_ai.system_instructions"
        },
        aliases: [
            "gen_ai.system_instructions"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55
                ]
            }
        ]
    },
    "ai.presence_penalty": {
        brief: "Used to reduce repetitiveness of generated tokens. Similar to frequency_penalty, except that this penalty is applied equally to all tokens that have already appeared, regardless of their exact frequencies.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: .5,
        deprecation: {
            replacement: "gen_ai.request.presence_penalty"
        },
        aliases: [
            "gen_ai.request.presence_penalty"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55,
                    57,
                    61,
                    108
                ]
            }
        ]
    },
    "ai.prompt_tokens.used": {
        brief: "The number of tokens used to process just the prompt.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 20,
        deprecation: {
            replacement: "gen_ai.usage.input_tokens"
        },
        aliases: [
            "gen_ai.usage.prompt_tokens",
            "gen_ai.usage.input_tokens"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    57,
                    61
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "ai.raw_prompting": {
        brief: "When enabled, the user\u2019s prompt will be sent to the model without any pre-processing.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        deprecation: {},
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55
                ]
            }
        ]
    },
    "ai.responses": {
        brief: "The response messages sent back by the AI model.",
        type: "string[]",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: [
            "hello",
            "world"
        ],
        deprecation: {
            replacement: "gen_ai.output.messages"
        },
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    65,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "ai.response_format": {
        brief: "For an AI model call, the format of the response",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "json_object",
        deprecation: {},
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55,
                    127
                ]
            }
        ]
    },
    "ai.search_queries": {
        brief: "Queries used to search for relevant context or documents.",
        type: "string[]",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: [
            "climate change effects",
            "renewable energy"
        ],
        deprecation: {},
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55
                ]
            }
        ]
    },
    "ai.search_results": {
        brief: "Results returned from search queries for context.",
        type: "string[]",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: [
            "search_result_1, search_result_2"
        ],
        deprecation: {},
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55
                ]
            }
        ]
    },
    "ai.seed": {
        brief: "The seed, ideally models given the same seed and same other parameters will produce the exact same output.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1234567890",
        deprecation: {
            replacement: "gen_ai.request.seed"
        },
        aliases: [
            "gen_ai.request.seed"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    55,
                    57,
                    61,
                    108,
                    127
                ]
            }
        ]
    },
    "ai.streaming": {
        brief: "Whether the request was streamed back.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        deprecation: {
            replacement: "gen_ai.response.streaming"
        },
        aliases: [
            "gen_ai.response.streaming"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    76,
                    108
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "ai.tags": {
        brief: "Tags that describe an AI pipeline step.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: '{"executed_function": "add_integers"}',
        deprecation: {},
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55,
                    127
                ]
            }
        ]
    },
    "ai.temperature": {
        brief: "For an AI model call, the temperature parameter. Temperature essentially means how random the output will be.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: .1,
        deprecation: {
            replacement: "gen_ai.request.temperature"
        },
        aliases: [
            "gen_ai.request.temperature"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55,
                    57,
                    61,
                    108
                ]
            }
        ]
    },
    "ai.texts": {
        brief: "Raw text inputs provided to the model.",
        type: "string[]",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: [
            "Hello, how are you?",
            "What is the capital of France?"
        ],
        deprecation: {
            replacement: "gen_ai.input.messages"
        },
        aliases: [
            "gen_ai.input.messages"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55
                ]
            }
        ]
    },
    "ai.tools": {
        brief: "For an AI model call, the functions that are available",
        type: "string[]",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: [
            "function_1",
            "function_2"
        ],
        deprecation: {
            replacement: "gen_ai.tool.definitions"
        },
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    55,
                    65,
                    127
                ]
            }
        ]
    },
    "ai.tool_calls": {
        brief: "For an AI model call, the tool calls that were made.",
        type: "string[]",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: [
            "tool_call_1",
            "tool_call_2"
        ],
        deprecation: {
            replacement: "gen_ai.output.messages"
        },
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    55,
                    65
                ]
            }
        ]
    },
    "ai.top_k": {
        brief: "Limits the model to only consider the K most likely next tokens, where K is an integer (e.g., top_k=20 means only the 20 highest probability tokens are considered).",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 35,
        deprecation: {
            replacement: "gen_ai.request.top_k"
        },
        aliases: [
            "gen_ai.request.top_k"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55,
                    57,
                    61,
                    108
                ]
            }
        ]
    },
    "ai.top_p": {
        brief: "Limits the model to only consider tokens whose cumulative probability mass adds up to p, where p is a float between 0 and 1 (e.g., top_p=0.7 means only tokens that sum up to 70% of the probability mass are considered).",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: .7,
        deprecation: {
            replacement: "gen_ai.request.top_p"
        },
        aliases: [
            "gen_ai.request.top_p"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55,
                    57,
                    61,
                    108
                ]
            }
        ]
    },
    "ai.total_cost": {
        brief: "The total cost for the tokens used.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 12.34,
        deprecation: {
            replacement: "gen_ai.cost.total_tokens"
        },
        aliases: [
            "gen_ai.cost.total_tokens"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    53
                ]
            }
        ]
    },
    "ai.total_tokens.used": {
        brief: "The total number of tokens used to process the prompt.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 30,
        deprecation: {
            replacement: "gen_ai.usage.total_tokens"
        },
        aliases: [
            "gen_ai.usage.total_tokens"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    57,
                    61,
                    108
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "ai.warnings": {
        brief: "Warning messages generated during model execution.",
        type: "string[]",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: [
            "Token limit exceeded"
        ],
        deprecation: {},
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55
                ]
            }
        ]
    },
    "angular.version": {
        brief: "The version of the Angular framework",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "17.1.0",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    367
                ],
                description: "Added angular.version attribute"
            }
        ]
    },
    "app.app_build": {
        brief: "Internal build identifier, as it appears on the platform.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1",
        deprecation: {
            replacement: "app.build",
            reason: "Deprecated in favor of app.build"
        },
        aliases: [
            "app.build"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    296
                ],
                description: "Added and deprecated app.app_build in favor of app.build"
            }
        ]
    },
    "app.app_identifier": {
        brief: "Version-independent application identifier, often a dotted bundle ID.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "com.example.myapp",
        deprecation: {
            replacement: "app.identifier",
            reason: "Deprecated in favor of app.identifier"
        },
        aliases: [
            "app.identifier"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    296
                ],
                description: "Added and deprecated app.app_identifier in favor of app.identifier"
            }
        ]
    },
    "app.app_name": {
        brief: "Human readable application name, as it appears on the platform.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "My App",
        deprecation: {
            replacement: "app.name",
            reason: "Deprecated in favor of app.name"
        },
        aliases: [
            "app.name"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    296
                ],
                description: "Added and deprecated app.app_name in favor of app.name"
            }
        ]
    },
    "app.app_start_time": {
        brief: "Formatted UTC timestamp when the user started the application.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "2025-01-01T00:00:00.000Z",
        deprecation: {
            replacement: "app.start_time",
            reason: "Deprecated in favor of app.start_time"
        },
        aliases: [
            "app.start_time"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    296
                ],
                description: "Added and deprecated app.app_start_time in favor of app.start_time"
            }
        ]
    },
    "app.app_version": {
        brief: "Human readable application version, as it appears on the platform.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1.0.0",
        deprecation: {
            replacement: "app.version",
            reason: "Deprecated in favor of app.version"
        },
        aliases: [
            "app.version"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    296
                ],
                description: "Added and deprecated app.app_version in favor of app.version"
            }
        ]
    },
    "app.build": {
        brief: "Internal build identifier, as it appears on the platform.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1",
        aliases: [
            "app.app_build"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    296
                ],
                description: "Added app.build attribute"
            }
        ]
    },
    "app.identifier": {
        brief: "Version-independent application identifier, often a dotted bundle ID.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "com.example.myapp",
        aliases: [
            "app.app_identifier"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    296
                ],
                description: "Added app.identifier attribute"
            }
        ]
    },
    "app.in_foreground": {
        brief: "Whether the application is currently in the foreground.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    296
                ],
                description: "Added app.in_foreground attribute"
            }
        ]
    },
    "app.name": {
        brief: "Human readable application name, as it appears on the platform.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "My App",
        aliases: [
            "app.app_name"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    296
                ],
                description: "Added app.name attribute"
            }
        ]
    },
    app_start_cold: {
        brief: "The duration of a cold app start in milliseconds",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1234.56,
        deprecation: {
            replacement: "app.vitals.start.cold.value",
            reason: "Replaced by app.vitals.start.cold.value to align with the app.vitals.* namespace for mobile performance attributes"
        },
        aliases: [
            "app.vitals.start.cold.value"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    323
                ],
                description: "Added and deprecated in favor of app.vitals.start.cold.value"
            }
        ]
    },
    "app.start_time": {
        brief: "Formatted UTC timestamp when the user started the application.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "2025-01-01T00:00:00.000Z",
        aliases: [
            "app.app_start_time"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    296
                ],
                description: "Added app.start_time attribute"
            }
        ]
    },
    app_start_type: {
        brief: "Mobile app start variant. Either cold or warm.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "cold",
        deprecation: {
            replacement: "app.vitals.start.type",
            reason: "Replaced by app.vitals.start.type to align with the app.vitals.* namespace for mobile performance attributes"
        },
        aliases: [
            "app.vitals.start.type"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Deprecated in favor of app.vitals.start.type"
            },
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    app_start_warm: {
        brief: "The duration of a warm app start in milliseconds",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1234.56,
        deprecation: {
            replacement: "app.vitals.start.warm.value",
            reason: "Replaced by app.vitals.start.warm.value to align with the app.vitals.* namespace for mobile performance attributes"
        },
        aliases: [
            "app.vitals.start.warm.value"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    323
                ],
                description: "Added and deprecated in favor of app.vitals.start.warm.value"
            }
        ]
    },
    "app.version": {
        brief: "Human readable application version, as it appears on the platform.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1.0.0",
        aliases: [
            "app.app_version"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    296
                ],
                description: "Added app.version attribute"
            }
        ]
    },
    "app.vitals.frames.delay.value": {
        brief: "The sum of all delayed frame durations in seconds during the lifetime of the span. For more information see [frames delay](https://develop.sentry.dev/sdk/performance/frames-delay/).",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 5,
        aliases: [
            "frames.delay"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Added app.vitals.frames.delay.value to replace frames.delay"
            }
        ]
    },
    "app.vitals.frames.frozen.count": {
        brief: "The number of frozen frames rendered during the lifetime of the span.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 3,
        aliases: [
            "frames.frozen"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Added app.vitals.frames.frozen.count to replace frames.frozen"
            }
        ]
    },
    "app.vitals.frames.slow.count": {
        brief: "The number of slow frames rendered during the lifetime of the span.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1,
        aliases: [
            "frames.slow"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Added app.vitals.frames.slow.count to replace frames.slow"
            }
        ]
    },
    "app.vitals.frames.total.count": {
        brief: "The number of total frames rendered during the lifetime of the span.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 60,
        aliases: [
            "frames.total"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Added app.vitals.frames.total.count to replace frames.total"
            }
        ]
    },
    "app.vitals.start.cold.value": {
        brief: "The duration of a cold app start in milliseconds",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1234.56,
        aliases: [
            "app_start_cold"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Added app.vitals.start.cold.value attribute"
            }
        ]
    },
    "app.vitals.start.prewarmed": {
        brief: "Whether the app start was prewarmed.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    379
                ],
                description: "Added app.vitals.start.prewarmed attribute"
            }
        ]
    },
    "app.vitals.start.reason": {
        brief: "The reason that triggered the app start.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "push",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    353
                ],
                description: "Added app.vitals.start.reason attribute"
            }
        ]
    },
    "app.vitals.start.screen": {
        brief: "The screen that is rendered when the app start is complete. This is the screen the user first sees and can interact with after launch. The absence of this attribute on the app start span indicates a background app start where no UI was rendered.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "MainActivity",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    353
                ],
                description: "Added app.vitals.start.screen attribute"
            }
        ]
    },
    "app.vitals.start.type": {
        brief: "The type of app start, for example `cold` or `warm`",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "cold",
        aliases: [
            "app_start_type"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Added app.vitals.start.type attribute"
            }
        ]
    },
    "app.vitals.start.warm.value": {
        brief: "The duration of a warm app start in milliseconds",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1234.56,
        aliases: [
            "app_start_warm"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Added app.vitals.start.warm.value attribute"
            }
        ]
    },
    "app.vitals.ttfd.value": {
        brief: "The duration of time to full display in milliseconds",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1234.56,
        aliases: [
            "time_to_full_display"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Added app.vitals.ttfd.value attribute"
            }
        ]
    },
    "app.vitals.ttid.value": {
        brief: "The duration of time to initial display in milliseconds",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1234.56,
        aliases: [
            "time_to_initial_display"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Added app.vitals.ttid.value attribute"
            }
        ]
    },
    "art.gc.blocking_count": {
        brief: "Total number of blocking (stop-the-world) garbage collections performed by the Android Runtime",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    382
                ],
                description: "Added art.gc.blocking_count attribute"
            }
        ]
    },
    "art.gc.blocking_time": {
        brief: "Total time spent in blocking (stop-the-world) garbage collections by the Android Runtime, in milliseconds",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 11.873,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    382
                ],
                description: "Added art.gc.blocking_time attribute"
            }
        ]
    },
    "art.gc.pre_oome_count": {
        brief: "Total number of garbage collections triggered as a last resort before an OutOfMemoryError by the Android Runtime",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 0,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    382
                ],
                description: "Added art.gc.pre_oome_count attribute"
            }
        ]
    },
    "art.gc.total_count": {
        brief: "Total number of garbage collections performed by the Android Runtime",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    382
                ],
                description: "Added art.gc.total_count attribute"
            }
        ]
    },
    "art.gc.total_time": {
        brief: "Total time spent in garbage collection by the Android Runtime, in milliseconds",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 11.807,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    382
                ],
                description: "Added art.gc.total_time attribute"
            }
        ]
    },
    "art.gc.waiting_time": {
        brief: "Total time threads spent waiting for garbage collection to complete in the Android Runtime, in milliseconds",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 8.054,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    382
                ],
                description: "Added art.gc.waiting_time attribute"
            }
        ]
    },
    "art.memory.free": {
        brief: "Free memory available to the process as reported by the Android Runtime, in bytes",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 3181568,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    382
                ],
                description: "Added art.memory.free attribute"
            }
        ]
    },
    "art.memory.free_until_gc": {
        brief: "Free memory available before a garbage collection would be triggered by the Android Runtime, in bytes",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 3181568,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    382
                ],
                description: "Added art.memory.free_until_gc attribute"
            }
        ]
    },
    "art.memory.free_until_oome": {
        brief: "Free memory available before an OutOfMemoryError would be thrown by the Android Runtime, in bytes",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 196083712,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    382
                ],
                description: "Added art.memory.free_until_oome attribute"
            }
        ]
    },
    "art.memory.max": {
        brief: "Maximum memory the process is allowed to use as reported by the Android Runtime, in bytes",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 201326592,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    382
                ],
                description: "Added art.memory.max attribute"
            }
        ]
    },
    "art.memory.total": {
        brief: "Total memory currently allocated to the process by the Android Runtime, in bytes",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 7774208,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    382
                ],
                description: "Added art.memory.total attribute"
            }
        ]
    },
    "aws.cloudwatch.logs.log_group": {
        brief: "The name of the CloudWatch Logs log group",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "/aws/lambda/my-function",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    369
                ],
                description: "Added aws.cloudwatch.logs.log_group attribute"
            }
        ]
    },
    "aws.cloudwatch.logs.log_stream": {
        brief: "The name of the CloudWatch Logs log stream",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "2024/01/01/[$LATEST]abcdef1234567890",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    369
                ],
                description: "Added aws.cloudwatch.logs.log_stream attribute"
            }
        ]
    },
    "aws.cloudwatch.logs.url": {
        brief: "The URL to the CloudWatch Logs log group",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "https://console.aws.amazon.com/cloudwatch/home?region=us-east-1#logsV2:log-groups/log-group/my-log-group",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    369
                ],
                description: "Added aws.cloudwatch.logs.url attribute"
            }
        ]
    },
    "aws.dynamodb.attribute_definitions": {
        brief: "The JSON-serialized value of each item in the `AttributeDefinitions` request field.",
        type: "string[]",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: [
            '{ "AttributeName": "string", "AttributeType": "string" }'
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.attribute_definitions attribute"
            }
        ]
    },
    "aws.dynamodb.consistent_read": {
        brief: "The value of the `ConsistentRead` request parameter.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.consistent_read attribute"
            }
        ]
    },
    "aws.dynamodb.consumed_capacity": {
        brief: "The JSON-serialized value of each item in the `ConsumedCapacity` response field.",
        type: "string[]",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: [
            '{ "CapacityUnits": number, "GlobalSecondaryIndexes": { "string" : { "CapacityUnits": number, "ReadCapacityUnits": number, "WriteCapacityUnits": number } }, "LocalSecondaryIndexes": { "string" : { "CapacityUnits": number, "ReadCapacityUnits": number, "WriteCapacityUnits": number } }, "ReadCapacityUnits": number, "Table": { "CapacityUnits": number, "ReadCapacityUnits": number, "WriteCapacityUnits": number }, "TableName": "string", "WriteCapacityUnits": number }'
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.consumed_capacity attribute"
            }
        ]
    },
    "aws.dynamodb.count": {
        brief: "The value of the `Count` response parameter.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 10,
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.count attribute"
            }
        ]
    },
    "aws.dynamodb.exclusive_start_table": {
        brief: "The value of the `ExclusiveStartTableName` request parameter.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "Users",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.exclusive_start_table attribute"
            }
        ]
    },
    "aws.dynamodb.global_secondary_indexes": {
        brief: "The JSON-serialized value of each item of the `GlobalSecondaryIndexes` request field.",
        type: "string[]",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: [
            '{ "IndexName": "string", "KeySchema": [ { "AttributeName": "string", "KeyType": "string" } ], "Projection": { "NonKeyAttributes": [ "string" ], "ProjectionType": "string" }, "ProvisionedThroughput": { "ReadCapacityUnits": number, "WriteCapacityUnits": number } }'
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.global_secondary_indexes attribute"
            }
        ]
    },
    "aws.dynamodb.global_secondary_index_updates": {
        brief: "The JSON-serialized value of each item in the `GlobalSecondaryIndexUpdates` request field.",
        type: "string[]",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: [
            '{ "Create": { "IndexName": "string", "KeySchema": [ { "AttributeName": "string", "KeyType": "string" } ], "Projection": { "NonKeyAttributes": [ "string" ], "ProjectionType": "string" }, "ProvisionedThroughput": { "ReadCapacityUnits": number, "WriteCapacityUnits": number } }'
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.global_secondary_index_updates attribute"
            }
        ]
    },
    "aws.dynamodb.index_name": {
        brief: "The value of the `IndexName` request parameter.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "name_to_group",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.index_name attribute"
            }
        ]
    },
    "aws.dynamodb.item_collection_metrics": {
        brief: "The JSON-serialized value of the `ItemCollectionMetrics` response field.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: '{ "string" : [ { "ItemCollectionKey": { "string" : { "B": blob, "BOOL": boolean, "BS": [ blob ], "L": [ "AttributeValue" ], "M": { "string" : "AttributeValue" }, "N": "string", "NS": [ "string" ], "NULL": boolean, "S": "string", "SS": [ "string" ] } }, "SizeEstimateRangeGB": [ number ] } ] }',
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.item_collection_metrics attribute"
            }
        ]
    },
    "aws.dynamodb.limit": {
        brief: "The value of the `Limit` request parameter.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 10,
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.limit attribute"
            }
        ]
    },
    "aws.dynamodb.local_secondary_indexes": {
        brief: "The JSON-serialized value of each item of the `LocalSecondaryIndexes` request field.",
        type: "string[]",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: [
            '{ "IndexArn": "string", "IndexName": "string", "IndexSizeBytes": number, "ItemCount": number, "KeySchema": [ { "AttributeName": "string", "KeyType": "string" } ], "Projection": { "NonKeyAttributes": [ "string" ], "ProjectionType": "string" } }'
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.local_secondary_indexes attribute"
            }
        ]
    },
    "aws.dynamodb.projection": {
        brief: "The value of the `ProjectionExpression` request parameter.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "Title, Price, Color",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.projection attribute"
            }
        ]
    },
    "aws.dynamodb.provisioned_read_capacity": {
        brief: "The value of the `ProvisionedThroughput.ReadCapacityUnits` request parameter.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 1,
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.provisioned_read_capacity attribute"
            }
        ]
    },
    "aws.dynamodb.provisioned_write_capacity": {
        brief: "The value of the `ProvisionedThroughput.WriteCapacityUnits` request parameter.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 2,
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.provisioned_write_capacity attribute"
            }
        ]
    },
    "aws.dynamodb.scanned_count": {
        brief: "The value of the `ScannedCount` response parameter.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 50,
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.scanned_count attribute"
            }
        ]
    },
    "aws.dynamodb.scan_forward": {
        brief: "The value of the `ScanIndexForward` request parameter.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.scan_forward attribute"
            }
        ]
    },
    "aws.dynamodb.segment": {
        brief: "The value of the `Segment` request parameter.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 10,
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.segment attribute"
            }
        ]
    },
    "aws.dynamodb.select": {
        brief: "The value of the `Select` request parameter.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "ALL_ATTRIBUTES",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.select attribute"
            }
        ]
    },
    "aws.dynamodb.table_count": {
        brief: "The number of items in the `TableNames` response parameter.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 20,
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.table_count attribute"
            }
        ]
    },
    "aws.dynamodb.table_names": {
        brief: "The keys in the `RequestItems` object field.",
        type: "string[]",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: [
            "Users",
            "Cats"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.table_names attribute"
            }
        ]
    },
    "aws.dynamodb.total_segments": {
        brief: "The value of the `TotalSegments` request parameter.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 100,
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.total_segments attribute"
            }
        ]
    },
    "aws.extended_request_id": {
        brief: "The AWS extended request ID as returned in the response headers.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "wzHcyEWfmOGDIE5QOhTAqFDoDWP3y8IUvpNINCwL9N4TEHbUw0/gZJ+VZTmCNCWR7fezEN3eCiQ=",
        aliases: [
            "aws.request.extended_id"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    480
                ],
                description: "Added aws.extended_request_id attribute"
            }
        ]
    },
    "aws.kinesis.stream_name": {
        brief: "The name of the AWS Kinesis stream the request refers to.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "some-stream-name",
        aliases: [
            "aws.kinesis.stream.name"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    480
                ],
                description: "Added aws.kinesis.stream_name attribute"
            }
        ]
    },
    "aws.kinesis.stream.name": {
        brief: "The name of the AWS Kinesis stream the request refers to.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "some-stream-name",
        deprecation: {
            replacement: "aws.kinesis.stream_name",
            reason: "This attribute is being deprecated in favor of aws.kinesis.stream_name, which is the OTel-aligned replacement."
        },
        aliases: [
            "aws.kinesis.stream_name"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    480
                ],
                description: "Added aws.kinesis.stream.name attribute, deprecated in favor of aws.kinesis.stream_name"
            }
        ]
    },
    "aws.lambda.aws_request_id": {
        brief: "The AWS request ID as received by the Lambda function runtime",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "8476a536-e9f4-11e8-9739-2dfe598c3fcd",
        deprecation: {
            replacement: "faas.invocation_id",
            reason: "This attribute is being deprecated in favor of faas.invocation_id"
        },
        aliases: [
            "faas.invocation_id",
            "faas.execution"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    473
                ],
                description: "Added faas.execution as an alias"
            },
            {
                version: "0.11.1",
                prs: [
                    414,
                    424
                ],
                description: "Deprecated aws.lambda.aws_request_id in favor of faas.invocation_id"
            },
            {
                version: "0.7.0",
                prs: [
                    369
                ],
                description: "Added aws.lambda.aws_request_id attribute"
            }
        ]
    },
    "aws.lambda.execution_duration_in_millis": {
        brief: "The execution duration of the Lambda function invocation in milliseconds",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1234.56,
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    369
                ],
                description: "Added aws.lambda.execution_duration_in_millis attribute"
            }
        ]
    },
    "aws.lambda.function_name": {
        brief: "The name of the Lambda function",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "my-function",
        deprecation: {
            replacement: "faas.name",
            reason: "Use the OTel-aligned faas.name attribute instead"
        },
        aliases: [
            "faas.name"
        ],
        changelog: [
            {
                version: "0.11.1",
                prs: [
                    414
                ],
                description: "Deprecated aws.lambda.function_name in favor of faas.name"
            },
            {
                version: "0.7.0",
                prs: [
                    369
                ],
                description: "Added aws.lambda.function_name attribute"
            }
        ]
    },
    "aws.lambda.function_version": {
        brief: "The version of the Lambda function",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "$LATEST",
        deprecation: {
            replacement: "faas.version",
            reason: "Use the OTel-aligned faas.version attribute instead"
        },
        aliases: [
            "faas.version"
        ],
        changelog: [
            {
                version: "0.11.1",
                prs: [
                    414,
                    424
                ],
                description: "Deprecated aws.lambda.function_version in favor of faas.version"
            },
            {
                version: "0.7.0",
                prs: [
                    369
                ],
                description: "Added aws.lambda.function_version attribute"
            }
        ]
    },
    "aws.lambda.invoked_arn": {
        brief: "The full ARN of the Lambda function that was invoked",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "arn:aws:lambda:us-east-1:123456789012:function:my-function",
        aliases: [
            "aws.lambda.invoked_function_arn"
        ],
        changelog: [
            {
                version: "0.11.1",
                prs: [
                    414
                ]
            }
        ]
    },
    "aws.lambda.invoked_function_arn": {
        brief: "The full ARN of the Lambda function that was invoked",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "arn:aws:lambda:us-east-1:123456789012:function:my-function",
        deprecation: {
            replacement: "aws.lambda.invoked_arn",
            reason: "This attribute is being deprecated in favor of aws.lambda.invoked_arn"
        },
        aliases: [
            "aws.lambda.invoked_arn"
        ],
        changelog: [
            {
                version: "0.11.1",
                prs: [
                    414
                ],
                description: "Deprecated aws.lambda.invoked_function_arn in favor of aws.lambda.invoked_arn"
            },
            {
                version: "0.7.0",
                prs: [
                    369
                ],
                description: "Added aws.lambda.invoked_function_arn attribute"
            }
        ]
    },
    "aws.lambda.remaining_time_in_millis": {
        brief: "The remaining time in milliseconds before the Lambda function times out",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 5e3,
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    369
                ],
                description: "Added aws.lambda.remaining_time_in_millis attribute"
            }
        ]
    },
    "aws.log.group.names": {
        brief: "The name(s) of the AWS log group(s) an application is writing to.",
        type: "string[]",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: [
            "/aws/lambda/my-function",
            "opentelemetry-service"
        ],
        changelog: [
            {
                version: "0.11.1",
                prs: [
                    414
                ]
            }
        ]
    },
    "aws.log.stream.names": {
        brief: "The name(s) of the AWS log stream(s) an application is writing to.",
        type: "string[]",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: [
            "logs/main/10838bed-421f-43ef-870a-f43feacbbb5b"
        ],
        changelog: [
            {
                version: "0.11.1",
                prs: [
                    414
                ]
            }
        ]
    },
    "aws.request.extended_id": {
        brief: "The AWS extended request ID as returned in the response headers.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "wzHcyEWfmOGDIE5QOhTAqFDoDWP3y8IUvpNINCwL9N4TEHbUw0/gZJ+VZTmCNCWR7fezEN3eCiQ=",
        deprecation: {
            replacement: "aws.extended_request_id",
            reason: "This attribute is being deprecated in favor of aws.extended_request_id, which is the OTel-aligned replacement."
        },
        aliases: [
            "aws.extended_request_id"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    480
                ],
                description: "Added aws.request.extended_id attribute, deprecated in favor of aws.extended_request_id"
            }
        ]
    },
    "aws.request_id": {
        brief: "The AWS request ID as returned in the response headers.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "79b9da39-b7ae-508a-a6bc-864b2829c622",
        aliases: [
            "aws.request.id"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    480
                ],
                description: "Added aws.request_id attribute"
            }
        ]
    },
    "aws.request.id": {
        brief: "The AWS request ID as returned in the response headers.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "79b9da39-b7ae-508a-a6bc-864b2829c622",
        deprecation: {
            replacement: "aws.request_id",
            reason: "This attribute is being deprecated in favor of aws.request_id, which is the OTel-aligned replacement."
        },
        aliases: [
            "aws.request_id"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    480
                ],
                description: "Added aws.request.id attribute, deprecated in favor of aws.request_id"
            }
        ]
    },
    "aws.s3.bucket": {
        brief: "The S3 bucket name the request refers to.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "ot-demo-test",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    480
                ],
                description: "Added aws.s3.bucket attribute"
            }
        ]
    },
    "aws.secretsmanager.secret.arn": {
        brief: "The ARN of the Secret stored in Secrets Manager.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "arn:aws:secretsmanager:us-east-1:123456789012:secret:SecretName-6RandomCharacters",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    480
                ],
                description: "Added aws.secretsmanager.secret.arn attribute"
            }
        ]
    },
    "aws.sns.topic.arn": {
        brief: "The ARN of the AWS SNS Topic. An Amazon SNS topic is a logical access point that acts as a communication channel.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "arn:aws:sns:us-east-1:123456789012:mystack-mytopic-NZJ5JSMVGFIE",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    480
                ],
                description: "Added aws.sns.topic.arn attribute"
            }
        ]
    },
    "aws.step_functions.activity.arn": {
        brief: "The ARN of the AWS Step Functions Activity.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "arn:aws:states:us-east-1:123456789012:activity:get-greeting",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    480
                ],
                description: "Added aws.step_functions.activity.arn attribute"
            }
        ]
    },
    "aws.step_functions.state_machine.arn": {
        brief: "The ARN of the AWS Step Functions State Machine.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "arn:aws:states:us-east-1:123456789012:stateMachine:myStateMachine:1",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    480
                ],
                description: "Added aws.step_functions.state_machine.arn attribute"
            }
        ]
    },
    blocked_main_thread: {
        brief: "Whether the main thread was blocked by the span.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "browser.name": {
        brief: "The name of the browser.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Chrome",
        aliases: [
            "sentry.browser.name"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127,
                    139
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "browser.performance.navigation.activation_start": {
        brief: "The time between initiating a navigation to a page and the browser activating the page",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1.983,
        aliases: [
            "performance.activationStart"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    321
                ],
                description: "Added browser.performance.navigation.activation_start attribute"
            }
        ]
    },
    "browser.performance.time_origin": {
        brief: "The browser's performance.timeOrigin timestamp representing the time when the pageload was initiated",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1776185678886e-3,
        aliases: [
            "performance.timeOrigin"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    321
                ],
                description: "Added browser.performance.time_origin attribute attribute"
            }
        ]
    },
    "browser.report.type": {
        brief: "A browser report sent via reporting API..",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "network-error",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    68,
                    127
                ]
            }
        ]
    },
    "browser.script.invoker": {
        brief: "How a script was called in the browser.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Window.requestAnimationFrame",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "browser.script.invoker_type": {
        brief: "Browser script entry point type.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "event-listener",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "browser.script.source_char_position": {
        brief: "A number representing the script character position of the script.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 678,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "browser.version": {
        brief: "The version of the browser.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "120.0.6099.130",
        aliases: [
            "sentry.browser.version"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    59,
                    127,
                    139
                ]
            }
        ]
    },
    "browser.web_vital.cls.report_event": {
        brief: "The event that caused the SDK to report CLS (pagehide or navigation)",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "navigation",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    319
                ],
                description: "Added browser.web_vital.cls.report_event attribute"
            }
        ]
    },
    "browser.web_vital.cls.source.<key>": {
        brief: "The HTML elements or components responsible for the layout shift. <key> is a numeric index from 1 to N",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "body > div#app",
        aliases: [
            "cls.source.<key>"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    234
                ]
            }
        ]
    },
    "browser.web_vital.cls.value": {
        brief: "The value of the recorded Cumulative Layout Shift (CLS) web vital",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: .2361,
        aliases: [
            "cls"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    229
                ],
                description: "Added browser.web_vital.cls.value attribute"
            }
        ]
    },
    "browser.web_vital.fcp.value": {
        brief: "The time it takes for the browser to render the first piece of meaningful content on the screen",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 547.6951,
        aliases: [
            "fcp"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    235
                ]
            }
        ]
    },
    "browser.web_vital.fp.value": {
        brief: "The time in milliseconds it takes for the browser to render the first pixel on the screen",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 477.1926,
        aliases: [
            "fp"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    235
                ]
            }
        ]
    },
    "browser.web_vital.inp.value": {
        brief: "The value of the recorded Interaction to Next Paint (INP) web vital",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 200,
        aliases: [
            "inp"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    229
                ],
                description: "Added browser.web_vital.inp.value attribute"
            }
        ]
    },
    "browser.web_vital.lcp.element": {
        brief: "The HTML element selector or component name for which LCP was reported",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "body > div#app > div#container > div",
        aliases: [
            "lcp.element"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    233
                ]
            }
        ]
    },
    "browser.web_vital.lcp.id": {
        brief: "The id of the dom element responsible for the largest contentful paint",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "#gero",
        aliases: [
            "lcp.id"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    233
                ]
            }
        ]
    },
    "browser.web_vital.lcp.load_time": {
        brief: "The time it took for the LCP element to be loaded",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1402,
        aliases: [
            "lcp.loadTime"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    233
                ]
            }
        ]
    },
    "browser.web_vital.lcp.render_time": {
        brief: "The time it took for the LCP element to be rendered",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1685,
        aliases: [
            "lcp.renderTime"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    233
                ]
            }
        ]
    },
    "browser.web_vital.lcp.report_event": {
        brief: "The event that caused the SDK to report LCP (pagehide or navigation)",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "pagehide",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    319
                ],
                description: "Added browser.web_vital.lcp.report_event attribute"
            }
        ]
    },
    "browser.web_vital.lcp.size": {
        brief: "The size of the largest contentful paint element",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1024,
        aliases: [
            "lcp.size"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    233
                ]
            }
        ]
    },
    "browser.web_vital.lcp.url": {
        brief: "The url of the dom element responsible for the largest contentful paint",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "https://example.com/static/img.png",
        aliases: [
            "lcp.url"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    233
                ]
            }
        ]
    },
    "browser.web_vital.lcp.value": {
        brief: "The value of the recorded Largest Contentful Paint (LCP) web vital",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 2500,
        aliases: [
            "lcp"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    229
                ],
                description: "Added browser.web_vital.lcp.value attribute"
            }
        ]
    },
    "browser.web_vital.ttfb.request_time": {
        brief: "The time it takes for the server to process the initial request and send the first byte of a response to the user's browser",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1554.5814,
        aliases: [
            "ttfb.requestTime"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    235
                ]
            }
        ]
    },
    "browser.web_vital.ttfb.value": {
        brief: "The value of the recorded Time To First Byte (TTFB) web vital in Milliseconds",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 194.3322,
        aliases: [
            "ttfb"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    235
                ]
            }
        ]
    },
    "cache.hit": {
        brief: "If the cache was hit during this span.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "cache.item_size": {
        brief: "The size of the requested item in the cache. In bytes.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 58,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "cache.key": {
        brief: "The key of the cache accessed.",
        type: "string[]",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: [
            "my-cache-key",
            "my-other-cache-key"
        ],
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "cache.operation": {
        brief: "The operation being performed on the cache.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "get",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "cache.ttl": {
        brief: "The ttl of the cache in seconds",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 120,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "cache.write": {
        brief: "If the cache operation resulted in a write to the cache.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.5.0"
            }
        ]
    },
    channel: {
        brief: "The channel name that is being used.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "mail",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "client.address": {
        brief: "Client address - domain name if available without reverse DNS lookup; otherwise, IP address or Unix domain socket name.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "example.com",
        aliases: [
            "http.client_ip"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    106,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "client.port": {
        brief: "Client port number.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 5432,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "cloudflare.d1.duration": {
        brief: "The duration of a Cloudflare D1 operation.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 543,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "cloudflare.d1.query_type": {
        brief: "The type of query executed in a Cloudflare D1 operation",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "run",
        deprecation: {
            replacement: "db.operation.name"
        },
        aliases: [
            "db.operation.name",
            "db.operation"
        ],
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    392
                ],
                description: "Added cloudflare.d1.query_type attribute"
            }
        ]
    },
    "cloudflare.d1.rows_read": {
        brief: "The number of rows read in a Cloudflare D1 operation.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 12,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "cloudflare.d1.rows_written": {
        brief: "The number of rows written in a Cloudflare D1 operation.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 12,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "cloudflare.durable_object.query.bindings": {
        brief: "The number of bound parameters passed to the SQL exec call.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 2,
        changelog: [
            {
                version: "0.13.0",
                prs: [
                    435
                ],
                description: "Added cloudflare.durable_object.query.bindings attribute"
            }
        ]
    },
    "cloudflare.durable_object.response.rows_read": {
        brief: "The number of rows read by a Cloudflare Durable Object SQL operation.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 12,
        changelog: [
            {
                version: "0.13.0",
                prs: [
                    435
                ],
                description: "Added cloudflare.durable_object.response.rows_read attribute"
            }
        ]
    },
    "cloudflare.durable_object.response.rows_written": {
        brief: "The number of rows written by a Cloudflare Durable Object SQL operation.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1,
        changelog: [
            {
                version: "0.13.0",
                prs: [
                    435
                ],
                description: "Added cloudflare.durable_object.response.rows_written attribute"
            }
        ]
    },
    "cloudflare.r2.bucket": {
        brief: "The name of the Cloudflare R2 bucket binding",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "MY_BUCKET",
        changelog: [
            {
                version: "0.11.1",
                prs: [
                    413
                ],
                description: "Added cloudflare.r2.bucket attribute"
            }
        ]
    },
    "cloudflare.r2.operation": {
        brief: "The R2 API operation being performed",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "GetObject",
        changelog: [
            {
                version: "0.11.1",
                prs: [
                    413
                ],
                description: "Added cloudflare.r2.operation attribute"
            }
        ]
    },
    "cloudflare.r2.request.delimiter": {
        brief: "The delimiter used to group objects in an R2 list operation",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "/",
        changelog: [
            {
                version: "0.11.1",
                prs: [
                    413
                ],
                description: "Added cloudflare.r2.request.delimiter attribute"
            }
        ]
    },
    "cloudflare.r2.request.key": {
        brief: "The object key used in the R2 operation",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "my-file.txt",
        changelog: [
            {
                version: "0.11.1",
                prs: [
                    413
                ],
                description: "Added cloudflare.r2.request.key attribute"
            }
        ]
    },
    "cloudflare.r2.request.part_number": {
        brief: "The part number in a multipart upload operation",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1,
        changelog: [
            {
                version: "0.11.1",
                prs: [
                    413
                ],
                description: "Added cloudflare.r2.request.part_number attribute"
            }
        ]
    },
    "cloudflare.r2.request.prefix": {
        brief: "The prefix used to filter objects in an R2 list operation",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "images/",
        changelog: [
            {
                version: "0.11.1",
                prs: [
                    413
                ],
                description: "Added cloudflare.r2.request.prefix attribute"
            }
        ]
    },
    "cloudflare.workflow.attempt": {
        brief: "The current attempt number for a Cloudflare Workflow step",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    392
                ],
                description: "Added cloudflare.workflow.attempt attribute"
            }
        ]
    },
    "cloudflare.workflow.retries.backoff": {
        brief: "The backoff strategy for Cloudflare Workflow step retries",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "exponential",
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    392
                ],
                description: "Added cloudflare.workflow.retries.backoff attribute"
            }
        ]
    },
    "cloudflare.workflow.retries.delay": {
        brief: "The delay between Cloudflare Workflow step retries",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "5 seconds",
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    392
                ],
                description: "Added cloudflare.workflow.retries.delay attribute"
            }
        ]
    },
    "cloudflare.workflow.retries.limit": {
        brief: "The maximum number of retries for a Cloudflare Workflow step",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 3,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    392
                ],
                description: "Added cloudflare.workflow.retries.limit attribute"
            }
        ]
    },
    "cloudflare.workflow.timeout": {
        brief: "The timeout duration for a Cloudflare Workflow step",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1 minute",
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    392
                ],
                description: "Added cloudflare.workflow.timeout attribute"
            }
        ]
    },
    "cloud.account.id": {
        brief: "The cloud account ID the resource is assigned to",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "123456789012",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    364
                ],
                description: "Added cloud.account.id attribute"
            }
        ]
    },
    "cloud.availability_zone": {
        brief: "Cloud regions often have multiple, isolated locations known as zones to increase availability",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "us-east-1c",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    364
                ],
                description: "Added cloud.availability_zone attribute"
            }
        ]
    },
    "cloud.platform": {
        brief: "The cloud platform in use",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "aws_lambda",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    364
                ],
                description: "Added cloud.platform attribute"
            }
        ]
    },
    "cloud.provider": {
        brief: "Name of the cloud provider",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "aws",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    364
                ],
                description: "Added cloud.provider attribute"
            }
        ]
    },
    "cloud.region": {
        brief: "The geographical region the resource is running",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "us-east-1",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    364
                ],
                description: "Added cloud.region attribute"
            }
        ]
    },
    "cloud.resource_id": {
        brief: "Cloud provider-specific native identifier of the monitored cloud resource",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "arn:aws:lambda:REGION:ACCOUNT_ID:function:my-function",
        aliases: [
            "faas.id"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    475
                ],
                description: "Added faas.id as an alias"
            },
            {
                version: "0.11.1",
                prs: [
                    414
                ]
            }
        ],
        additionalContext: [
            "This can be an identifier for a resource in AWS, GCP, or Azure. There may be some overlap in values found here with other attributes. For instance, an AWS lambda ARN may be found here as well as in `aws.lambda.invoked_arn`. OTEL recommends setting them alongside each other."
        ]
    },
    cls: {
        brief: "The value of the recorded Cumulative Layout Shift (CLS) web vital",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: .2361,
        deprecation: {
            replacement: "browser.web_vital.cls.value",
            reason: "The CLS web vital is now recorded as a browser.web_vital.cls.value attribute."
        },
        aliases: [
            "browser.web_vital.cls.value"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    229
                ],
                description: "Added and deprecated attribute to document JS SDK's current behaviour"
            }
        ]
    },
    "cls.source.<key>": {
        brief: "The HTML elements or components responsible for the layout shift. <key> is a numeric index from 1 to N",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "body > div#app",
        deprecation: {
            replacement: "browser.web_vital.cls.source.<key>",
            reason: "The CLS source is now recorded as a browser.web_vital.cls.source.<key> attribute."
        },
        aliases: [
            "browser.web_vital.cls.source.<key>"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    234
                ]
            }
        ]
    },
    "code.filepath": {
        brief: "The source code file name that identifies the code unit as uniquely as possible (preferably an absolute file path).",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "/app/myapplication/http/handler/server.py",
        deprecation: {
            replacement: "code.file.path"
        },
        aliases: [
            "code.file.path"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "code.file.path": {
        brief: "The source code file name that identifies the code unit as uniquely as possible (preferably an absolute file path).",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "/app/myapplication/http/handler/server.py",
        aliases: [
            "code.filepath"
        ],
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "code.function": {
        brief: "The method or function name, or equivalent (usually rightmost part of the code unit's name).",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "server_request",
        aliases: [
            "code.function.name"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    74
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "code.function.name": {
        brief: "The method or function fully-qualified name without arguments.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "server_request",
        aliases: [
            "code.function"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "code.lineno": {
        brief: "The line number in code.filepath best representing the operation. It SHOULD point within the code unit named in code.function",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 42,
        deprecation: {
            replacement: "code.line.number"
        },
        aliases: [
            "code.line.number"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    61,
                    108
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "code.line.number": {
        brief: "The line number in code.filepath best representing the operation. It SHOULD point within the code unit named in code.function",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 42,
        aliases: [
            "code.lineno"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "code.namespace": {
        brief: "The 'namespace' within which code.function is defined. Usually the qualified class or module name, such that code.namespace + some separator + code.function form a unique identifier for the code unit.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "http.handler",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    74
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    connectionType: {
        brief: "Specifies the type of the current connection (e.g. wifi, ethernet, cellular , etc).",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "wifi",
        deprecation: {
            replacement: "network.connection.type",
            reason: "Old namespace-less attribute, to be replaced with network.connection.type for span-first future"
        },
        aliases: [
            "network.connection.type",
            "device.connection_type"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    279
                ],
                description: "Added and deprecated attribute to document JS SDK's current behaviour"
            }
        ]
    },
    "connection.rtt": {
        brief: "Specifies the estimated effective round-trip time of the current connection, in milliseconds.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 100,
        deprecation: {
            replacement: "network.connection.rtt",
            reason: "Old attribute name (no official namespace), to be replaced with network.connection.rtt for span-first future"
        },
        aliases: [
            "network.connection.rtt"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    279
                ],
                description: "Added and deprecated attribute to document JS SDK's current behaviour"
            }
        ]
    },
    "culture.calendar": {
        brief: "The calendar system used by the culture.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "GregorianCalendar",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    243
                ]
            }
        ]
    },
    "culture.display_name": {
        brief: "Human readable name of the culture.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "English (United States)",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    243
                ]
            }
        ]
    },
    "culture.is_24_hour_format": {
        brief: "Whether the culture uses 24-hour time format.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    243
                ]
            }
        ]
    },
    "culture.locale": {
        brief: "The locale identifier following RFC 4646.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "en-US",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    243
                ]
            }
        ]
    },
    "culture.timezone": {
        brief: "The timezone of the culture, as a geographic timezone identifier.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Europe/Vienna",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    243
                ]
            }
        ]
    },
    "db.collection.name": {
        brief: "The name of a collection (table, container) within the database.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "users",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    106,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "db.driver.name": {
        brief: "The name of the driver used for the database connection.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "psycopg2",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    297
                ],
                description: "Added db.driver.name attribute"
            }
        ]
    },
    "db.name": {
        brief: "The name of the database being accessed.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "customers",
        deprecation: {
            replacement: "db.namespace"
        },
        aliases: [
            "db.namespace"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "db.namespace": {
        brief: "The name of the database being accessed.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "customers",
        aliases: [
            "db.name"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "db.operation": {
        brief: "The name of the operation being executed.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "SELECT",
        deprecation: {
            replacement: "db.operation.name"
        },
        aliases: [
            "db.operation.name",
            "cloudflare.d1.query_type"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    199
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "db.operation.batch.size": {
        brief: "The number of queries included in a batch operation. Operations are only considered batches when they contain two or more operations, and so db.operation.batch.size SHOULD never be 1.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 3,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    407
                ],
                description: "Added db.operation.batch.size attribute"
            }
        ]
    },
    "db.operation.name": {
        brief: "The name of the operation being executed.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "SELECT",
        aliases: [
            "db.operation",
            "cloudflare.d1.query_type"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "db.query.parameter.<key>": {
        brief: "A query parameter used in db.query.text, with <key> being the parameter name, and the attribute value being a string representation of the parameter value.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "db.query.parameter.foo='123'",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    103,
                    127
                ]
            }
        ]
    },
    "db.query.summary": {
        brief: "A shortened representation of operation(s) in the full query. This attribute must be low-cardinality and should only contain the operation table names.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "SELECT users",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    208
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "db.query.text": {
        brief: "The database parameterized query being executed. Any parameter values (filters, insertion values, etc) should be replaced with parameter placeholders. If applicable, use `db.query.parameter.<key>` to add the parameter value.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "SELECT * FROM users WHERE id = $1",
        aliases: [
            "db.statement"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    208
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "db.redis.connection": {
        brief: "The redis connection name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "my-redis-instance",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "db.redis.key": {
        brief: "The key the Redis command is operating on.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "user:2047:city",
        changelog: [
            {
                version: "0.6.0",
                prs: [
                    326
                ],
                description: "Added db.redis.key attribute"
            }
        ]
    },
    "db.redis.parameters": {
        brief: "The array of command parameters given to a redis command.",
        type: "string[]",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: [
            "test",
            "*"
        ],
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "db.response.status_code": {
        brief: "Database response status code. The status code returned by the database. Usually it represents an error code, but may also represent partial success, warning, or differentiate between various types of successful outcomes.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "ORA-17002",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    462
                ],
                description: "Added db.response.status_code attribute"
            }
        ]
    },
    "db.sql.bindings": {
        brief: "The array of query bindings.",
        type: "string[]",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: [
            "1",
            "foo"
        ],
        deprecation: {
            replacement: "db.query.parameter.<key>",
            reason: "Instead of adding every binding in the db.sql.bindings attribute, add them as individual entires with db.query.parameter.<key>."
        },
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "db.statement": {
        brief: "The database statement being executed.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "SELECT * FROM users",
        deprecation: {
            replacement: "db.query.text"
        },
        aliases: [
            "db.query.text"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    199
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "db.stored_procedure.name": {
        brief: "The name of a stored procedure being called.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "GetUserById",
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    398
                ]
            }
        ]
    },
    "db.system": {
        brief: "An identifier for the database management system (DBMS) product being used. See [OpenTelemetry docs](https://github.com/open-telemetry/semantic-conventions/blob/main/docs/database/database-spans.md#notes-and-well-known-identifiers-for-dbsystem) for a list of well-known identifiers.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "postgresql",
        deprecation: {
            replacement: "db.system.name"
        },
        aliases: [
            "db.system.name"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    199,
                    224
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "db.system.name": {
        brief: "An identifier for the database management system (DBMS) product being used. See [OpenTelemetry docs](https://github.com/open-telemetry/semantic-conventions/blob/main/docs/database/database-spans.md#notes-and-well-known-identifiers-for-dbsystem) for a list of well-known identifiers.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "postgresql",
        aliases: [
            "db.system"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "db.user": {
        brief: "The database user.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "fancy_user",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    deviceMemory: {
        brief: "The estimated total memory capacity of the device, only a rough estimation in gigabytes.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "8 GB",
        deprecation: {
            replacement: "device.memory.estimated_capacity",
            reason: "Old namespace-less attribute, to be replaced with device.memory.estimated_capacity for span-first future"
        },
        aliases: [
            "device.memory.estimated_capacity"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    281
                ],
                description: "Added and deprecated attribute to document JS SDK's current behaviour"
            }
        ]
    },
    "device.archs": {
        brief: "The CPU architectures of the device.",
        type: "string[]",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: [
            "arm64-v8a",
            "armeabi-v7a",
            "armeabi"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.archs attribute"
            }
        ]
    },
    "device.battery_level": {
        brief: "The battery level of the device as a percentage (0-100).",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 100,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.battery_level attribute"
            }
        ]
    },
    "device.battery_temperature": {
        brief: "The battery temperature of the device in Celsius.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 25,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.battery_temperature attribute"
            }
        ]
    },
    "device.boot_time": {
        brief: "A formatted UTC timestamp when the system was booted.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "2018-02-08T12:52:12Z",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.boot_time attribute"
            }
        ]
    },
    "device.brand": {
        brief: "The brand of the device.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Apple",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    116,
                    127
                ]
            }
        ]
    },
    "device.charging": {
        brief: "Whether the device was charging or not.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !1,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.charging attribute"
            }
        ]
    },
    "device.chipset": {
        brief: "The chipset of the device.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Qualcomm SM8550",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.chipset attribute"
            }
        ]
    },
    "device.class": {
        brief: "The classification of the device. For example, `low`, `medium`, or `high`. Typically inferred by Relay - SDKs generally do not need to set this directly.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "medium",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    300
                ],
                description: "Added device.class attribute"
            }
        ]
    },
    "device.connection_type": {
        brief: "The internet connection type currently being used by the device.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "wifi",
        deprecation: {
            replacement: "network.connection.type",
            reason: "This attribute is being deprecated in favor of network.connection.type"
        },
        aliases: [
            "network.connection.type",
            "connectionType"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added and deprecated device.connection_type in favor of network.connection.type"
            }
        ]
    },
    "device.cpu_description": {
        brief: "A description of the CPU of the device.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Intel(R) Core(TM)2 Quad CPU Q6600 @ 2.40GHz",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.cpu_description attribute"
            }
        ]
    },
    "device.external_free_storage": {
        brief: "External storage free size in bytes.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 67108864e3,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.external_free_storage attribute"
            }
        ]
    },
    "device.external_storage_size": {
        brief: "External storage total size in bytes.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 134217728e3,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.external_storage_size attribute"
            }
        ]
    },
    "device.family": {
        brief: "The family of the device.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "iPhone",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    116,
                    127
                ]
            }
        ]
    },
    "device.free_memory": {
        brief: "Free system memory in bytes.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 2147483648,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    300
                ],
                description: "Added device.free_memory attribute"
            }
        ]
    },
    "device.free_storage": {
        brief: "Free device storage in bytes.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 107374182400,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.free_storage attribute"
            }
        ]
    },
    "device.id": {
        brief: "Unique device identifier.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "a1b2c3d4-e5f6-7890-abcd-ef1234567890",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.id attribute"
            }
        ]
    },
    "device.locale": {
        brief: "The locale of the device.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "en-US",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.locale attribute"
            }
        ]
    },
    "device.low_memory": {
        brief: "Whether the device was low on memory.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !1,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.low_memory attribute"
            }
        ]
    },
    "device.low_power_mode": {
        brief: "Whether the device is in Low Power Mode.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.6.0",
                prs: [
                    314
                ],
                description: "Added device.low_power_mode attribute"
            }
        ]
    },
    "device.manufacturer": {
        brief: "The manufacturer of the device.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "Google",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.manufacturer attribute"
            }
        ]
    },
    "device.memory.estimated_capacity": {
        brief: "The estimated total memory capacity of the device, only a rough estimation in gigabytes. Browsers report estimations in buckets of powers of 2, mostly capped at 8 GB",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 8,
        aliases: [
            "deviceMemory"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    281
                ],
                description: "Added attribute device.memory.estimated_capacity to be used instead of deviceMemory"
            }
        ]
    },
    "device.memory_size": {
        brief: "Total system memory available in bytes.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 17179869184,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    300
                ],
                description: "Added device.memory_size attribute"
            }
        ]
    },
    "device.model": {
        brief: "The model of the device.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "iPhone 15 Pro Max",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    116,
                    127
                ]
            }
        ]
    },
    "device.model_id": {
        brief: "An internal hardware revision to identify the device exactly.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "N861AP",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    300
                ],
                description: "Added device.model_id attribute"
            }
        ]
    },
    "device.name": {
        brief: "The name of the device. On mobile, this is the user-assigned device name. On servers and desktops, this is typically the hostname.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "localhost",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.name attribute"
            }
        ]
    },
    "device.online": {
        brief: "Whether the device was online or not.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.online attribute"
            }
        ]
    },
    "device.orientation": {
        brief: 'The orientation of the device, either "portrait" or "landscape".',
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "portrait",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.orientation attribute"
            }
        ]
    },
    "device.processor_count": {
        brief: 'Number of "logical processors".',
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 8,
        aliases: [
            "hardwareConcurrency"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    300
                ],
                description: "Added and deprecated attribute device.processor_count in favor of device.cpu.logical_core_count"
            }
        ]
    },
    "device.processor_frequency": {
        brief: "Processor frequency in MHz.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 2400,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.processor_frequency attribute"
            }
        ]
    },
    "device.screen_density": {
        brief: "The screen density of the device.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 2.625,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.screen_density attribute"
            }
        ]
    },
    "device.screen_dpi": {
        brief: "The screen density in dots-per-inch (DPI) of the device.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 420,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.screen_dpi attribute"
            }
        ]
    },
    "device.screen_height_pixels": {
        brief: "The height of the device screen in pixels.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 2400,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.screen_height_pixels attribute"
            }
        ]
    },
    "device.screen_width_pixels": {
        brief: "The width of the device screen in pixels.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1080,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.screen_width_pixels attribute"
            }
        ]
    },
    "device.simulator": {
        brief: "Whether the device is a simulator or an actual device.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !1,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    300
                ],
                description: "Added device.simulator attribute"
            }
        ]
    },
    "device.storage_size": {
        brief: "Total device storage in bytes.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 274877906944,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.storage_size attribute"
            }
        ]
    },
    "device.thermal_state": {
        brief: "The thermal state of the device. Based on Apple's `ProcessInfo.ThermalState` enum: `nominal`, `fair`, `serious`, or `critical`.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "nominal",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.thermal_state attribute"
            }
        ]
    },
    "device.timezone": {
        brief: "The timezone of the device.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Europe/Vienna",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.timezone attribute"
            }
        ]
    },
    "device.usable_memory": {
        brief: "Memory usable for the app in bytes.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 2147483648,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.usable_memory attribute"
            }
        ]
    },
    dist: {
        brief: "The sentry dist.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1.0",
        deprecation: {
            replacement: "sentry.dist",
            reason: "This attribute is being deprecated in favor of sentry.dist."
        },
        aliases: [
            "sentry.dist"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    489
                ],
                description: "Added dist attribute"
            }
        ]
    },
    effectiveConnectionType: {
        brief: "Specifies the estimated effective type of the current connection (e.g. slow-2g, 2g, 3g, 4g).",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "4g",
        deprecation: {
            replacement: "network.connection.effective_type",
            reason: "Old namespace-less attribute, to be replaced with network.connection.effective_type for span-first future"
        },
        aliases: [
            "network.connection.effective_type"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    279
                ],
                description: "Added and deprecated attribute to document JS SDK's current behaviour"
            }
        ]
    },
    environment: {
        brief: "The sentry environment.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "production",
        deprecation: {
            replacement: "sentry.environment"
        },
        aliases: [
            "sentry.environment"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "error.type": {
        brief: "Describes a class of error the operation ended with.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "timeout",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "event.id": {
        brief: "The unique identifier for this event (log record)",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1234567890,
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    101
                ]
            }
        ]
    },
    "event.name": {
        brief: "The name that uniquely identifies this event (log record)",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Process Payload",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    101,
                    127
                ]
            }
        ]
    },
    "exception.escaped": {
        brief: "SHOULD be set to true if the exception event is recorded at a point where it is known that the exception is escaping the scope of the span.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "exception.message": {
        brief: "The error message.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "ENOENT: no such file or directory",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "exception.stacktrace": {
        brief: "A stacktrace as a string in the natural representation for the language runtime. The representation is to be determined and documented by each language SIG.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: `Exception in thread "main" java.lang.RuntimeException: Test exception
 at com.example.GenerateTrace.methodB(GenerateTrace.java:13)
 at com.example.GenerateTrace.methodA(GenerateTrace.java:9)
 at com.example.GenerateTrace.main(GenerateTrace.java:5)`,
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "exception.type": {
        brief: "The type of the exception (its fully-qualified class name, if applicable). The dynamic type of the exception should be preferred over the static type in languages that support it.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "OSError",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "faas.coldstart": {
        brief: "A boolean that is true if the serverless function is executed for the first time (aka cold-start).",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "faas.cron": {
        brief: "A string containing the schedule period as Cron Expression.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "0/5 * * * ? *",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "faas.duration_in_ms": {
        brief: "The duration a function took to run, in milliseconds.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 120,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    403
                ]
            }
        ]
    },
    "faas.entry_point": {
        brief: "The code that's run when the cloud provider invokes your function.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "my_main_function",
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    403,
                    415
                ]
            }
        ]
    },
    "faas.execution": {
        brief: "The execution ID of the current function execution.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "af9d5aa4-a685-4c5f-a22b-444f80b3cc28",
        deprecation: {
            replacement: "faas.invocation_id",
            reason: "This attribute is being deprecated in favor of faas.invocation_id, which is the OTel-aligned replacement."
        },
        aliases: [
            "faas.invocation_id",
            "aws.lambda.aws_request_id"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    473
                ],
                description: "Added faas.execution attribute, deprecated in favor of faas.invocation_id"
            }
        ]
    },
    "faas.id": {
        brief: "The unique ID of the single function that this runtime instance executes.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "arn:aws:lambda:REGION:ACCOUNT_ID:function:my-function",
        deprecation: {
            replacement: "cloud.resource_id",
            reason: "This attribute is being deprecated in favor of cloud.resource_id, which is the OTel-aligned replacement (renamed in OTel semantic conventions v1.19.0)."
        },
        aliases: [
            "cloud.resource_id"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    475
                ],
                description: "Added faas.id attribute, deprecated in favor of cloud.resource_id"
            }
        ]
    },
    "faas.identity": {
        brief: "The Service Account (GCP), IAM Execution Role (AWS), or Managed Identity (Azure) used by the serverless function when interacting with other cloud services",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "name@project.iam.gserviceaccount.com (GCP), arn:aws:iam::123456789012:role/role-name (AWS), 00000000-0000-0000-0000-000000000000 (Azure)",
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    403
                ]
            }
        ]
    },
    "faas.invocation_id": {
        brief: "The invocation ID of the current function invocation.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "af9d5aa4-a685-4c5f-a22b-444f80b3cc28",
        aliases: [
            "aws.lambda.aws_request_id",
            "faas.execution"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    473
                ],
                description: "Added faas.execution as an alias"
            },
            {
                version: "0.11.1",
                prs: [
                    414,
                    424
                ]
            }
        ]
    },
    "faas.invoked_name": {
        brief: "The name of the invoked function.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "my-function",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    481
                ],
                description: "Added faas.invoked_name attribute"
            }
        ]
    },
    "faas.invoked_provider": {
        brief: "The cloud provider of the invoked function.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "aws",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    481
                ],
                description: "Added faas.invoked_provider attribute"
            }
        ]
    },
    "faas.invoked_region": {
        brief: "The cloud region of the invoked function.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "eu-central-1",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    481
                ],
                description: "Added faas.invoked_region attribute"
            }
        ]
    },
    "faas.name": {
        brief: "The name of the serverless function",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "my_function",
        aliases: [
            "aws.lambda.function_name"
        ],
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    403,
                    415
                ]
            }
        ]
    },
    "faas.time": {
        brief: "A string containing the function invocation time in the ISO 8601 format expressed in UTC.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "2020-01-23T13:47:06Z",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "faas.trigger": {
        brief: "Type of the trigger which caused this function invocation.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "timer",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "faas.version": {
        brief: "The version of the function that was invoked",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "$LATEST",
        aliases: [
            "aws.lambda.function_version"
        ],
        changelog: [
            {
                version: "0.11.1",
                prs: [
                    414,
                    424
                ]
            }
        ]
    },
    fcp: {
        brief: "The time it takes for the browser to render the first piece of meaningful content on the screen",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 547.6951,
        deprecation: {
            replacement: "browser.web_vital.fcp.value",
            reason: "This attribute is being deprecated in favor of browser.web_vital.fcp.value"
        },
        aliases: [
            "browser.web_vital.fcp.value"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    235
                ]
            }
        ]
    },
    "flag.evaluation.<key>": {
        brief: "An instance of a feature flag evaluation. The value of this attribute is the boolean representing the evaluation result. The <key> suffix is the name of the feature flag.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "flag.evaluation.is_new_ui=true",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    103
                ]
            }
        ]
    },
    fp: {
        brief: "The time it takes for the browser to render the first pixel on the screen",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 477.1926,
        deprecation: {
            replacement: "browser.web_vital.fp.value",
            reason: "This attribute is being deprecated in favor of browser.web_vital.fp.value"
        },
        aliases: [
            "browser.web_vital.fp.value"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    235
                ]
            }
        ]
    },
    "frames.delay": {
        brief: "The sum of all delayed frame durations in seconds during the lifetime of the span. For more information see [frames delay](https://develop.sentry.dev/sdk/performance/frames-delay/).",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 5,
        deprecation: {
            replacement: "app.vitals.frames.delay.value",
            reason: "Replaced by app.vitals.frames.delay.value to align with the app.vitals.* namespace for mobile performance attributes"
        },
        aliases: [
            "app.vitals.frames.delay.value"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Deprecated in favor of app.vitals.frames.delay.value"
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "frames.frozen": {
        brief: "The number of frozen frames rendered during the lifetime of the span.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 3,
        deprecation: {
            replacement: "app.vitals.frames.frozen.count",
            reason: "Replaced by app.vitals.frames.frozen.count to align with the app.vitals.* namespace for mobile performance attributes"
        },
        aliases: [
            "app.vitals.frames.frozen.count"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Deprecated in favor of app.vitals.frames.frozen.count"
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    frames_frozen_rate: {
        brief: "The rate of frozen frames, or `app_vitals.frames.frozen.count` divided by `app_vitals.frames.total.count`. This is computed by Relay.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    362
                ],
                description: "Added frames_frozen_rate attribute"
            }
        ]
    },
    "frames.slow": {
        brief: "The number of slow frames rendered during the lifetime of the span.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1,
        deprecation: {
            replacement: "app.vitals.frames.slow.count",
            reason: "Replaced by app.vitals.frames.slow.count to align with the app.vitals.* namespace for mobile performance attributes"
        },
        aliases: [
            "app.vitals.frames.slow.count"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Deprecated in favor of app.vitals.frames.slow.count"
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    frames_slow_rate: {
        brief: "The rate of slow frames, or `app_vitals.frames.slow.count` divided by `app_vitals.frames.total.count`. This is computed by Relay.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    362
                ],
                description: "Added frames_slow_rate attribute"
            }
        ]
    },
    "frames.total": {
        brief: "The number of total frames rendered during the lifetime of the span.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 60,
        deprecation: {
            replacement: "app.vitals.frames.total.count",
            reason: "Replaced by app.vitals.frames.total.count to align with the app.vitals.* namespace for mobile performance attributes"
        },
        aliases: [
            "app.vitals.frames.total.count"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Deprecated in favor of app.vitals.frames.total.count"
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    fs_error: {
        brief: "The error message of a file system error.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "ENOENT: no such file or directory",
        deprecation: {
            replacement: "error.type",
            reason: "This attribute is not part of the OpenTelemetry specification and error.type fits much better."
        },
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "gcp.function.context.event_id": {
        brief: "The event ID from the legacy GCP Cloud Function context (1st gen)",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1234567890",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    371
                ],
                description: "Added gcp.function.context.event_id attribute"
            }
        ]
    },
    "gcp.function.context.event_type": {
        brief: "The type of the GCP Cloud Function event",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "google.pubsub.topic.publish",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    371
                ],
                description: "Added gcp.function.context.event_type attribute"
            }
        ]
    },
    "gcp.function.context.id": {
        brief: "The unique event ID from the GCP CloudEvents context (2nd gen Cloud Functions)",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1234567890",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    371
                ],
                description: "Added gcp.function.context.id attribute"
            }
        ]
    },
    "gcp.function.context.resource": {
        brief: "The resource that triggered the GCP Cloud Function event",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "projects/my-project/topics/my-topic",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    371
                ],
                description: "Added gcp.function.context.resource attribute"
            }
        ]
    },
    "gcp.function.context.source": {
        brief: "The source of the GCP Cloud Function event",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "//pubsub.googleapis.com/projects/my-project/topics/my-topic",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    371
                ],
                description: "Added gcp.function.context.source attribute"
            }
        ]
    },
    "gcp.function.context.specversion": {
        brief: "The CloudEvents specification version of the GCP Cloud Function event",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1.0",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    371
                ],
                description: "Added gcp.function.context.specversion attribute"
            }
        ]
    },
    "gcp.function.context.time": {
        brief: "The timestamp of the GCP Cloud Function event",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "2024-01-01T00:00:00.000Z",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    371
                ],
                description: "Added gcp.function.context.time attribute"
            }
        ]
    },
    "gcp.function.context.timestamp": {
        brief: "The legacy timestamp of the GCP Cloud Function event",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "2024-01-01T00:00:00.000Z",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    371
                ],
                description: "Added gcp.function.context.timestamp attribute"
            }
        ]
    },
    "gcp.function.context.type": {
        brief: "The type of the GCP Cloud Function event context",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "cloud_functions.context",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    371
                ],
                description: "Added gcp.function.context.type attribute"
            }
        ]
    },
    "gcp.project.id": {
        brief: "The ID of the project in GCP that this resource is associated with",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "my-project-123",
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    403
                ]
            }
        ]
    },
    "gen_ai.agent.name": {
        brief: "The name of the agent being used.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "ResearchAssistant",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    62,
                    127
                ]
            }
        ]
    },
    "gen_ai.context.utilization": {
        brief: "The fraction of the model context window utilized by this generation.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: .75,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    315
                ],
                description: "Added gen_ai.context.utilization attribute"
            }
        ]
    },
    "gen_ai.context.window_size": {
        brief: "The maximum context window size supported by the model for this generation.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 128e3,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    315
                ],
                description: "Added gen_ai.context.window_size attribute"
            }
        ]
    },
    "gen_ai.conversation.id": {
        brief: "The unique identifier for a conversation (session, thread), used to store and correlate messages within this conversation.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "conv_5j66UpCpwteGg4YSxUnt7lPY",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    250
                ]
            }
        ]
    },
    "gen_ai.cost.cache_creation.input_tokens": {
        brief: "The cost of input tokens written to cache in USD.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 12.34,
        changelog: [
            {
                version: "0.16.0",
                description: "Added gen_ai.cost.cache_creation.input_tokens attribute"
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to calculate total cost, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans.",
            "Despite the name 'cost.cache_creation.input_tokens', this value is cost in USD, not a token count. For token counts, use gen_ai.usage.cache_creation.input_tokens.",
            "This is a subset of gen_ai.cost.input_tokens, not an independent cost. Do not sum this with gen_ai.cost.input_tokens \u2014 it is already included."
        ]
    },
    "gen_ai.cost.cache_read.input_tokens": {
        brief: "The cost of cached input tokens in USD.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 12.34,
        changelog: [
            {
                version: "0.16.0",
                description: "Added gen_ai.cost.cache_read.input_tokens attribute"
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to calculate total cost, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans.",
            "Despite the name 'cost.cache_read.input_tokens', this value is cost in USD, not a token count. For token counts, use gen_ai.usage.cache_read.input_tokens.",
            "This is a subset of gen_ai.cost.input_tokens, not an independent cost. Do not sum this with gen_ai.cost.input_tokens \u2014 it is already included."
        ]
    },
    "gen_ai.cost.input_tokens": {
        brief: "The total cost of all input tokens in USD (includes cached and cache creation tokens).",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 123.45,
        changelog: [
            {
                version: "0.9.0",
                prs: [
                    397
                ],
                description: "Add additional_context"
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    112
                ]
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to calculate total cost, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans.",
            "Despite the name 'cost.input_tokens', this value is cost in USD, not a token count. For token counts, use gen_ai.usage.input_tokens.",
            "This is the total cost of all input tokens, including cached and cache creation tokens at their respective rates. For the cached portion, see gen_ai.cost.cache_read.input_tokens. For the cache creation portion, see gen_ai.cost.cache_creation.input_tokens."
        ]
    },
    "gen_ai.cost.output_tokens": {
        brief: "The total cost of all output tokens in USD (includes reasoning tokens).",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 123.45,
        changelog: [
            {
                version: "0.9.0",
                prs: [
                    397
                ],
                description: "Add additional_context"
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    112
                ]
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to calculate total cost, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans.",
            "Despite the name 'cost.output_tokens', this value is cost in USD, not a token count. For token counts, use gen_ai.usage.output_tokens.",
            "This is the total cost of all output tokens, including reasoning tokens at their respective rate. For the reasoning portion, see gen_ai.cost.reasoning.output_tokens."
        ]
    },
    "gen_ai.cost.reasoning.output_tokens": {
        brief: "The cost of reasoning output tokens in USD.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 12.34,
        changelog: [
            {
                version: "0.16.0",
                description: "Added gen_ai.cost.reasoning.output_tokens attribute"
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to calculate total cost, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans.",
            "Despite the name 'cost.reasoning.output_tokens', this value is cost in USD, not a token count. For token counts, use gen_ai.usage.reasoning.output_tokens.",
            "This is a subset of gen_ai.cost.output_tokens, not an independent cost. Do not sum this with gen_ai.cost.output_tokens \u2014 it is already included."
        ]
    },
    "gen_ai.cost.total_tokens": {
        brief: "The total cost for the tokens used.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 12.34,
        aliases: [
            "ai.total_cost"
        ],
        changelog: [
            {
                version: "0.9.0",
                prs: [
                    397
                ],
                description: "Add additional_context"
            },
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    126
                ]
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to calculate total cost, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans.",
            "Despite the name 'cost.total_tokens', this value is cost in USD, not a token count. For token counts, use gen_ai.usage.total_tokens."
        ]
    },
    "gen_ai.embeddings.input": {
        brief: "The input to the embeddings model.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "What's the weather in Paris?",
        changelog: [
            {
                version: "0.3.1",
                prs: [
                    195
                ]
            }
        ]
    },
    "gen_ai.function_id": {
        brief: "Framework-specific tracing label for the execution of a function or other unit of execution in a generative AI system.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "my-awesome-function",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    308
                ],
                description: "Added gen_ai.function_id attribute"
            }
        ]
    },
    "gen_ai.input.messages": {
        brief: 'The messages passed to the model. It has to be a stringified version of an array of objects. The `role` attribute of each object must be `"user"`, `"assistant"`, `"tool"`, or `"system"`. For messages of the role `"tool"`, the `content` can be a string or an arbitrary object with information about the tool call. For other messages the `content` can be either a string or a list of objects in the format `{type: "text", text:"..."}`.',
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: '[{"role": "user", "parts": [{"type": "text", "content": "Weather in Paris?"}]}, {"role": "assistant", "parts": [{"type": "tool_call", "id": "call_VSPygqKTWdrhaFErNvMV18Yl", "name": "get_weather", "arguments": {"location": "Paris"}}]}, {"role": "tool", "parts": [{"type": "tool_call_response", "id": "call_VSPygqKTWdrhaFErNvMV18Yl", "result": "rainy, 57\xB0F"}]}]',
        aliases: [
            "ai.texts"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.4.0",
                prs: [
                    221
                ]
            }
        ]
    },
    "gen_ai.operation.name": {
        brief: "The name of the operation being performed. It has the following list of well-known values: 'chat', 'create_agent', 'embeddings', 'execute_tool', 'generate_content', 'invoke_agent', 'text_completion'. If one of them applies, then that value MUST be used. Otherwise a custom value MAY be used.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "chat",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    225
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    62,
                    127
                ]
            }
        ]
    },
    "gen_ai.operation.type": {
        brief: "The type of AI operation. Must be one of 'agent' (invoke_agent and create_agent spans), 'ai_client' (any LLM call), 'tool' (execute_tool spans), 'handoff' (handoff spans), 'other' (input and output processors, skill loading, guardrails etc.) . Added during ingestion based on span.op and gen_ai.operation.type. Used to filter and aggregate data in the UI",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "tool",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    257
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    113,
                    127
                ]
            }
        ]
    },
    "gen_ai.output.messages": {
        brief: "The model's response messages. It has to be a stringified version of an array of message objects, which can include text responses and tool calls.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: '[{"role": "assistant", "parts": [{"type": "text", "content": "The weather in Paris is currently rainy with a temperature of 57\xB0F."}], "finish_reason": "stop"}]',
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    221
                ]
            }
        ]
    },
    "gen_ai.pipeline.name": {
        brief: "Name of the AI pipeline or chain being executed.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Autofix Pipeline",
        aliases: [
            "ai.pipeline.name"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    76,
                    127
                ]
            }
        ]
    },
    "gen_ai.prompt": {
        brief: "The input messages sent to the model",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: '[{"role": "user", "message": "hello"}]',
        deprecation: {
            reason: "Deprecated from OTEL, use gen_ai.input.messages with the new format instead."
        },
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    74,
                    108,
                    119
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "gen_ai.prompt.name": {
        brief: "The name of the prompt that uniquely identifies it.",
        type: "string",
        applyScrubbing: {
            key: "manual",
            reason: "Prompt names may reveal user behavior patterns or sensitive operations"
        },
        isInOtel: !0,
        visibility: "public",
        example: "summarize_text",
        aliases: [
            "mcp.prompt.name"
        ],
        changelog: [
            {
                version: "0.12.0",
                prs: [
                    420
                ],
                description: "Added gen_ai.prompt.name attribute"
            }
        ]
    },
    "gen_ai.provider.name": {
        brief: "The Generative AI provider as identified by the client or server instrumentation.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "openai",
        aliases: [
            "ai.model.provider",
            "gen_ai.system"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    253
                ]
            }
        ]
    },
    "gen_ai.request.available_tools": {
        brief: "The available tools for the model. It has to be a stringified version of an array of objects.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: '[{"name": "get_weather", "description": "Get the weather for a given location"}, {"name": "get_news", "description": "Get the news for a given topic"}]',
        deprecation: {
            replacement: "gen_ai.tool.definitions"
        },
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    221
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    63,
                    127
                ]
            }
        ]
    },
    "gen_ai.request.frequency_penalty": {
        brief: "Used to reduce repetitiveness of generated tokens. The higher the value, the stronger a penalty is applied to previously present tokens, proportional to how many times they have already appeared in the prompt or prior generation.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: .5,
        aliases: [
            "ai.frequency_penalty"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    57
                ]
            }
        ]
    },
    "gen_ai.request.max_tokens": {
        brief: "The maximum number of tokens to generate in the response.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 2048,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    62
                ]
            }
        ]
    },
    "gen_ai.request.messages": {
        brief: 'The messages passed to the model. It has to be a stringified version of an array of objects. The `role` attribute of each object must be `"user"`, `"assistant"`, `"tool"`, or `"system"`. For messages of the role `"tool"`, the `content` can be a string or an arbitrary object with information about the tool call. For other messages the `content` can be either a string or a list of objects in the format `{type: "text", text:"..."}`.',
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: '[{"role": "system", "content": "Generate a random number."}, {"role": "user", "content": [{"text": "Generate a random number between 0 and 10.", "type": "text"}]}, {"role": "tool", "content": {"toolCallId": "1", "toolName": "Weather", "output": "rainy"}}]',
        deprecation: {
            replacement: "gen_ai.input.messages"
        },
        aliases: [
            "ai.input_messages"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    221
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    63,
                    74,
                    108,
                    119,
                    122
                ]
            }
        ]
    },
    "gen_ai.request.model": {
        brief: "The model identifier being used for the request.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "gpt-4-turbo-preview",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    62,
                    127
                ]
            }
        ]
    },
    "gen_ai.request.presence_penalty": {
        brief: "Used to reduce repetitiveness of generated tokens. Similar to frequency_penalty, except that this penalty is applied equally to all tokens that have already appeared, regardless of their exact frequencies.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: .5,
        aliases: [
            "ai.presence_penalty"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    57
                ]
            }
        ]
    },
    "gen_ai.request.reasoning_effort": {
        brief: "Constrains the effort on reasoning for reasoning models. Supported values vary by provider.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "high",
        changelog: [
            {
                version: "0.13.0",
                prs: [
                    334
                ],
                description: "Added gen_ai.request.reasoning_effort attribute"
            }
        ]
    },
    "gen_ai.request.seed": {
        brief: "The seed, ideally models given the same seed and same other parameters will produce the exact same output.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "1234567890",
        aliases: [
            "ai.seed"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    57,
                    127
                ]
            }
        ]
    },
    "gen_ai.request.stop_sequences": {
        brief: "List of sequences that the model will use to stop generating further tokens.",
        type: "string[]",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: [
            "forest",
            "lived"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    482
                ],
                description: "Added gen_ai.request.stop_sequences attribute"
            }
        ]
    },
    "gen_ai.request.temperature": {
        brief: "For an AI model call, the temperature parameter. Temperature essentially means how random the output will be.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: .1,
        aliases: [
            "ai.temperature"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    57
                ]
            }
        ]
    },
    "gen_ai.request.top_k": {
        brief: "Limits the model to only consider the K most likely next tokens, where K is an integer (e.g., top_k=20 means only the 20 highest probability tokens are considered).",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 35,
        aliases: [
            "ai.top_k"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    57
                ]
            }
        ]
    },
    "gen_ai.request.top_p": {
        brief: "Limits the model to only consider tokens whose cumulative probability mass adds up to p, where p is a float between 0 and 1 (e.g., top_p=0.7 means only tokens that sum up to 70% of the probability mass are considered).",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: .7,
        aliases: [
            "ai.top_p"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    57
                ]
            }
        ]
    },
    "gen_ai.response.finish_reasons": {
        brief: "The reason why the model stopped generating.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "COMPLETE",
        aliases: [
            "ai.finish_reason"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    57,
                    127
                ]
            }
        ]
    },
    "gen_ai.response.id": {
        brief: "Unique identifier for the completion.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "gen_123abc",
        aliases: [
            "ai.generation_id"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    57,
                    127
                ]
            }
        ]
    },
    "gen_ai.response.model": {
        brief: "The vendor-specific ID of the model used.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "gpt-4",
        aliases: [
            "ai.model_id"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "gen_ai.response.streaming": {
        brief: "Whether or not the AI model call's response was streamed back asynchronously",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        aliases: [
            "ai.streaming"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    76
                ]
            }
        ]
    },
    "gen_ai.response.text": {
        brief: "The model's response text messages. It has to be a stringified version of an array of response text messages.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: '["The weather in Paris is rainy and overcast, with temperatures around 57\xB0F", "The weather in London is sunny and warm, with temperatures around 65\xB0F"]',
        deprecation: {
            replacement: "gen_ai.output.messages"
        },
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    221
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    63,
                    74
                ]
            }
        ]
    },
    "gen_ai.response.time_to_first_chunk": {
        brief: "Time in seconds when the first response content chunk arrived in streaming responses.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: .6853435,
        aliases: [
            "gen_ai.response.time_to_first_token"
        ],
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    418
                ],
                description: "Added gen_ai.response.time_to_first_chunk attribute"
            }
        ]
    },
    "gen_ai.response.time_to_first_token": {
        brief: "Time in seconds when the first response content chunk arrived in streaming responses.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: .6853435,
        deprecation: {
            replacement: "gen_ai.response.time_to_first_chunk"
        },
        aliases: [
            "gen_ai.response.time_to_first_chunk"
        ],
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    418
                ],
                description: "Deprecate in favor of gen_ai.response.time_to_first_chunk"
            },
            {
                version: "0.4.0",
                prs: [
                    227
                ]
            }
        ]
    },
    "gen_ai.response.tokens_per_second": {
        brief: "The total output tokens per seconds throughput",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 12345.67,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    66
                ]
            }
        ]
    },
    "gen_ai.response.tool_calls": {
        brief: "The tool calls in the model's response. It has to be a stringified version of an array of objects.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: '[{"name": "get_weather", "arguments": {"location": "Paris"}}]',
        deprecation: {
            replacement: "gen_ai.output.messages"
        },
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    221
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    63,
                    74
                ]
            }
        ]
    },
    "gen_ai.system": {
        brief: "The provider of the model.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "openai",
        deprecation: {
            replacement: "gen_ai.provider.name"
        },
        aliases: [
            "ai.model.provider",
            "gen_ai.provider.name"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    253
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    57,
                    127
                ]
            }
        ]
    },
    "gen_ai.system_instructions": {
        brief: "The system instructions passed to the model.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "You are a helpful assistant",
        aliases: [
            "ai.preamble"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.4.0",
                prs: [
                    221
                ]
            }
        ]
    },
    "gen_ai.system.message": {
        brief: "The system instructions passed to the model.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "You are a helpful assistant",
        deprecation: {
            replacement: "gen_ai.system_instructions"
        },
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    221
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    62
                ]
            }
        ]
    },
    "gen_ai.tool.call.arguments": {
        brief: "The arguments of the tool call. It has to be a stringified version of the arguments to the tool.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: '{"location": "Paris"}',
        aliases: [
            "gen_ai.tool.input"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    265
                ]
            },
            {
                version: "0.4.0",
                prs: [
                    221
                ]
            }
        ]
    },
    "gen_ai.tool.call.result": {
        brief: "The result of the tool call. It has to be a stringified version of the result of the tool.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "rainy, 57\xB0F",
        aliases: [
            "gen_ai.tool.output",
            "gen_ai.tool.message",
            "mcp.tool.result.content"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    265
                ]
            },
            {
                version: "0.4.0",
                prs: [
                    221
                ]
            }
        ]
    },
    "gen_ai.tool.definitions": {
        brief: "The list of source system tool definitions available to the GenAI agent or model.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: '[{"type": "function", "name": "get_current_weather", "description": "Get the current weather in a given location", "parameters": {"type": "object", "properties": {"location": {"type": "string", "description": "The city and state, e.g. San Francisco, CA"}, "unit": {"type": "string", "enum": ["celsius", "fahrenheit"]}}, "required": ["location", "unit"]}}]',
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    221
                ]
            }
        ]
    },
    "gen_ai.tool.description": {
        brief: "The description of the tool being used.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "Searches the web for current information about a topic",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    62,
                    127
                ]
            }
        ]
    },
    "gen_ai.tool.input": {
        brief: "The input of the tool being used. It has to be a stringified version of the input to the tool.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: '{"location": "Paris"}',
        deprecation: {
            replacement: "gen_ai.tool.call.arguments"
        },
        aliases: [
            "gen_ai.tool.call.arguments"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    265
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    63,
                    74
                ]
            }
        ]
    },
    "gen_ai.tool.message": {
        brief: "The response from a tool or function call passed to the model.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "rainy, 57\xB0F",
        deprecation: {
            replacement: "gen_ai.tool.call.result"
        },
        aliases: [
            "gen_ai.tool.call.result",
            "gen_ai.tool.output",
            "mcp.tool.result.content"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    265
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    62
                ]
            }
        ]
    },
    "gen_ai.tool.name": {
        brief: "Name of the tool utilized by the agent.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "Flights",
        aliases: [
            "ai.function_call",
            "mcp.tool.name"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    57,
                    127
                ]
            }
        ]
    },
    "gen_ai.tool.output": {
        brief: "The output of the tool being used. It has to be a stringified version of the output of the tool.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "rainy, 57\xB0F",
        deprecation: {
            replacement: "gen_ai.tool.call.result"
        },
        aliases: [
            "gen_ai.tool.call.result",
            "gen_ai.tool.message",
            "mcp.tool.result.content"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    265
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    63,
                    74
                ]
            }
        ]
    },
    "gen_ai.tool.type": {
        brief: "The type of tool being used.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "function",
        deprecation: {
            reason: "The gen_ai.tool.type attribute is deprecated and should no longer be set."
        },
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    62,
                    127
                ]
            }
        ]
    },
    "gen_ai.usage.cache_creation.input_tokens": {
        brief: "The number of tokens written to the cache when processing the AI input (prompt).",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 100,
        aliases: [
            "gen_ai.usage.input_tokens.cache_write"
        ],
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    418
                ],
                description: "Added gen_ai.usage.cache_creation.input_tokens attribute"
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to count tokens, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans."
        ]
    },
    "gen_ai.usage.cache_read.input_tokens": {
        brief: "The number of cached tokens used to process the AI input (prompt).",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 50,
        aliases: [
            "gen_ai.usage.input_tokens.cached"
        ],
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    418
                ],
                description: "Added gen_ai.usage.cache_read.input_tokens attribute"
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to count tokens, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans.",
            "This is a subset of gen_ai.usage.input_tokens, not an independent count. Do not sum this with gen_ai.usage.input_tokens \u2014 it is already included."
        ]
    },
    "gen_ai.usage.completion_tokens": {
        brief: "The number of tokens used in the GenAI response (completion).",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 10,
        deprecation: {
            replacement: "gen_ai.usage.output_tokens"
        },
        aliases: [
            "ai.completion_tokens.used",
            "gen_ai.usage.output_tokens"
        ],
        changelog: [
            {
                version: "0.9.0",
                prs: [
                    397
                ],
                description: "Add additional_context"
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    61
                ]
            },
            {
                version: "0.0.0"
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to count tokens, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans."
        ]
    },
    "gen_ai.usage.input_tokens": {
        brief: "The number of tokens used to process the AI input (prompt) including cached input tokens.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 10,
        aliases: [
            "ai.prompt_tokens.used",
            "gen_ai.usage.prompt_tokens"
        ],
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    418
                ],
                description: "Update additional_context to reference gen_ai.usage.cache_read.input_tokens"
            },
            {
                version: "0.9.0",
                prs: [
                    397
                ],
                description: "Add additional_context"
            },
            {
                version: "0.5.0",
                prs: [
                    261
                ]
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    112
                ]
            },
            {
                version: "0.0.0"
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to count tokens, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans.",
            "This count includes cached input tokens. gen_ai.usage.cache_read.input_tokens is a subset of this value, not an independent count \u2014 do not sum them together."
        ]
    },
    "gen_ai.usage.input_tokens.cached": {
        brief: "The number of cached tokens used to process the AI input (prompt).",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 50,
        deprecation: {
            replacement: "gen_ai.usage.cache_read.input_tokens"
        },
        aliases: [
            "gen_ai.usage.cache_read.input_tokens"
        ],
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    418
                ],
                description: "Deprecate in favor of gen_ai.usage.cache_read.input_tokens"
            },
            {
                version: "0.9.0",
                prs: [
                    397
                ],
                description: "Add additional_context"
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    62,
                    112
                ]
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to count tokens, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans.",
            "This is a subset of gen_ai.usage.input_tokens, not an independent count. Do not sum this with gen_ai.usage.input_tokens \u2014 it is already included."
        ]
    },
    "gen_ai.usage.input_tokens.cache_write": {
        brief: "The number of tokens written to the cache when processing the AI input (prompt).",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 100,
        deprecation: {
            replacement: "gen_ai.usage.cache_creation.input_tokens"
        },
        aliases: [
            "gen_ai.usage.cache_creation.input_tokens"
        ],
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    418
                ],
                description: "Deprecate in favor of gen_ai.usage.cache_creation.input_tokens"
            },
            {
                version: "0.9.0",
                prs: [
                    397
                ],
                description: "Add additional_context"
            },
            {
                version: "0.4.0",
                prs: [
                    217,
                    228
                ]
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to count tokens, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans."
        ]
    },
    "gen_ai.usage.output_tokens": {
        brief: "The number of tokens used for creating the AI output (including reasoning tokens).",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 10,
        aliases: [
            "ai.completion_tokens.used",
            "gen_ai.usage.completion_tokens"
        ],
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    418
                ],
                description: "Update additional_context to reference gen_ai.usage.reasoning.output_tokens"
            },
            {
                version: "0.9.0",
                prs: [
                    397
                ],
                description: "Add additional_context"
            },
            {
                version: "0.5.0",
                prs: [
                    261
                ]
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    112
                ]
            },
            {
                version: "0.0.0"
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to count tokens, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans.",
            "This count includes reasoning tokens. gen_ai.usage.reasoning.output_tokens is a subset of this value, not an independent count \u2014 do not sum them together."
        ]
    },
    "gen_ai.usage.output_tokens.reasoning": {
        brief: "The number of tokens used for reasoning to create the AI output.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 75,
        deprecation: {
            replacement: "gen_ai.usage.reasoning.output_tokens"
        },
        aliases: [
            "gen_ai.usage.reasoning.output_tokens"
        ],
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    418
                ],
                description: "Deprecate in favor of gen_ai.usage.reasoning.output_tokens"
            },
            {
                version: "0.9.0",
                prs: [
                    397
                ],
                description: "Add additional_context"
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    62,
                    112
                ]
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to count tokens, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans.",
            "This is a subset of gen_ai.usage.output_tokens, not an independent count. Do not sum this with gen_ai.usage.output_tokens \u2014 it is already included."
        ]
    },
    "gen_ai.usage.prompt_tokens": {
        brief: "The number of tokens used in the GenAI input (prompt).",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 20,
        deprecation: {
            replacement: "gen_ai.usage.input_tokens"
        },
        aliases: [
            "ai.prompt_tokens.used",
            "gen_ai.usage.input_tokens"
        ],
        changelog: [
            {
                version: "0.9.0",
                prs: [
                    397
                ],
                description: "Add additional_context"
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    61
                ]
            },
            {
                version: "0.0.0"
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to count tokens, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans."
        ]
    },
    "gen_ai.usage.reasoning.output_tokens": {
        brief: "The number of tokens used for reasoning to create the AI output.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 75,
        aliases: [
            "gen_ai.usage.output_tokens.reasoning"
        ],
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    418
                ],
                description: "Added gen_ai.usage.reasoning.output_tokens attribute"
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to count tokens, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans.",
            "This is a subset of gen_ai.usage.output_tokens, not an independent count. Do not sum this with gen_ai.usage.output_tokens \u2014 it is already included."
        ]
    },
    "gen_ai.usage.total_tokens": {
        brief: "The total number of tokens used to process the prompt. (input tokens plus output todkens)",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 20,
        aliases: [
            "ai.total_tokens.used"
        ],
        changelog: [
            {
                version: "0.9.0",
                prs: [
                    397
                ],
                description: "Add additional_context"
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    57
                ]
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to count tokens, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans.",
            "This is the sum of gen_ai.usage.input_tokens and gen_ai.usage.output_tokens. Do not sum this with either of them \u2014 they are already included."
        ]
    },
    "graphql.document": {
        brief: "The GraphQL document being executed.",
        type: "string",
        applyScrubbing: {
            key: "auto",
            reason: "The document may contain sensitive information in arguments or variables. Instrumentation should redact sensitive information when possible."
        },
        isInOtel: !0,
        visibility: "public",
        example: "query findBookById { bookById(id: ?) { name } }",
        changelog: [
            {
                version: "0.7.0",
                description: "Adds the `graphql.document` attribute to track the GraphQL document being executed."
            }
        ]
    },
    "graphql.operation.name": {
        brief: "The name of the operation being executed.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "findBookById",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "graphql.operation.type": {
        brief: "The type of the operation being executed.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "query",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    hardwareConcurrency: {
        brief: "The number of logical CPU cores available.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "14",
        deprecation: {
            replacement: "device.processor_count",
            reason: "Old namespace-less attribute, to be replaced with device.processor_count for span-first future"
        },
        aliases: [
            "device.processor_count"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    281,
                    300
                ],
                description: "Added and deprecated attribute to document JS SDK's current behaviour"
            }
        ]
    },
    "http.client_ip": {
        brief: "Client address - domain name if available without reverse DNS lookup; otherwise, IP address or Unix domain socket name.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "example.com",
        deprecation: {
            replacement: "client.address"
        },
        aliases: [
            "client.address"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    106,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.decoded_response_content_length": {
        brief: "The decoded body size of the response (in bytes).",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 456,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.flavor": {
        brief: "The actual version of the protocol used for network communication.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "1.1",
        deprecation: {
            replacement: "network.protocol.version"
        },
        aliases: [
            "network.protocol.version",
            "net.protocol.version"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    108,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.fragment": {
        brief: "The fragments present in the URI. Note that this contains the leading # character, while the `url.fragment` attribute does not.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "#details",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "http.host": {
        brief: "The domain name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "example.com",
        deprecation: {
            replacement: "server.address",
            reason: "Deprecated, use one of `server.address` or `client.address`, depending on the usage"
        },
        aliases: [
            "server.address",
            "client.address",
            "http.server_name",
            "net.host.name",
            "server_name"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    108,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.method": {
        brief: "The HTTP method used.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "GET",
        deprecation: {
            replacement: "http.request.method"
        },
        aliases: [
            "http.request.method",
            "http.request_method",
            "method"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.query": {
        brief: "The query string present in the URL. Note that this contains the leading ? character, while the `url.query` attribute does not.",
        type: "string",
        applyScrubbing: {
            key: "auto",
            reason: "Query string values can contain sensitive information. Clients should attempt to scrub parameters that might contain sensitive information."
        },
        isInOtel: !1,
        visibility: "public",
        example: "?foo=bar&bar=baz",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "http.request.body.data": {
        brief: "HTTP request body data. Can be given as string or structural data of any format.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: '[{"role": "user", "message": "hello"}]',
        changelog: [
            {
                version: "0.6.0",
                prs: [
                    336
                ],
                description: "Added http.request.body.data attribute"
            }
        ]
    },
    "http.request.connection_end": {
        brief: "The UNIX timestamp representing the time immediately after the browser finishes establishing the connection to the server to retrieve the resource. The timestamp value includes the time interval to establish the transport connection, as well as other time intervals such as TLS handshake and SOCKS authentication.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 173282955515e-2,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    134
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.request.connect_start": {
        brief: "The UNIX timestamp representing the time immediately before the user agent starts establishing the connection to the server to retrieve the resource.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1732829555111e-3,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    134
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.request.domain_lookup_end": {
        brief: "The UNIX timestamp representing the time immediately after the browser finishes the domain-name lookup for the resource.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1732829555201e-3,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    134
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.request.domain_lookup_start": {
        brief: "The UNIX timestamp representing the time immediately before the browser starts the domain name lookup for the resource.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1732829555322e-3,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    134
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.request.fetch_start": {
        brief: "The UNIX timestamp representing the time immediately before the browser starts to fetch the resource.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1732829555389e-3,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    134
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.request.header.<key>": {
        brief: "HTTP request headers, <key> being the normalized HTTP Header name (lowercase), the value being the header values.",
        type: "string[]",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "http.request.header.custom-header=['foo', 'bar']",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    201,
                    204
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    103
                ]
            }
        ]
    },
    "http.request.method": {
        brief: "The HTTP method used.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "GET",
        aliases: [
            "method",
            "http.method",
            "http.request_method"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.request_method": {
        brief: "The HTTP method used.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "GET",
        deprecation: {
            replacement: "http.request.method"
        },
        aliases: [
            "method",
            "http.method",
            "http.request.method"
        ],
        changelog: [
            {
                version: "0.6.0",
                prs: [
                    343
                ],
                description: "Added http.request_method attribute"
            }
        ]
    },
    "http.request.redirect_end": {
        brief: "The UNIX timestamp representing the timestamp immediately after receiving the last byte of the response of the last redirect",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1732829558502e-3,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    130,
                    134
                ]
            }
        ]
    },
    "http.request.redirect_start": {
        brief: "The UNIX timestamp representing the start time of the fetch which that initiates the redirect.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1732829555495e-3,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    134
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.request.request_start": {
        brief: "The UNIX timestamp representing the time immediately before the browser starts requesting the resource from the server, cache, or local resource. If the transport connection fails and the browser retires the request, the value returned will be the start of the retry request.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 173282955551e-2,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    134
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.request.resend_count": {
        brief: "The ordinal number of request resending attempt (for any reason, including redirects).",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 2,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.request.response_end": {
        brief: "The UNIX timestamp representing the time immediately after the browser receives the last byte of the resource or immediately before the transport connection is closed, whichever comes first.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 173282955589e-2,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    134
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.request.response_start": {
        brief: "The UNIX timestamp representing the time immediately before the browser starts requesting the resource from the server, cache, or local resource. If the transport connection fails and the browser retires the request, the value returned will be the start of the retry request.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 17328295557e-1,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    134
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.request.same_origin": {
        brief: "Indicates that a URL has the same origin as the current page's origin in the browser.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        aliases: [
            "url.same_origin"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    456
                ],
                description: "Added http.request.same_origin attribute"
            }
        ]
    },
    "http.request.secure_connection_start": {
        brief: "The UNIX timestamp representing the time immediately before the browser starts the handshake process to secure the current connection. If a secure connection is not used, the property returns zero.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 173282955573e-2,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    134
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.request.time_to_first_byte": {
        brief: "The time in seconds from the browser's timeorigin to when the first byte of the request's response was received. See https://web.dev/articles/ttfb#measure-resource-requests",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1.032,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    131
                ]
            }
        ]
    },
    "http.request.worker_start": {
        brief: "The UNIX timestamp representing the timestamp immediately before dispatching the FetchEvent if a Service Worker thread is already running, or immediately before starting the Service Worker thread if it is not already running.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 173282955368e-2,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    130,
                    134
                ]
            }
        ]
    },
    "http.response.body.size": {
        brief: "The encoded body size of the response (in bytes).",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 123,
        aliases: [
            "http.response_content_length",
            "http.response.header.content-length"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    106
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.response_content_length": {
        brief: "The encoded body size of the response (in bytes).",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 123,
        deprecation: {
            replacement: "http.response.body.size"
        },
        aliases: [
            "http.response.body.size",
            "http.response.header.content-length"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    61,
                    106
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.response.header.content-length": {
        brief: "The size of the message body sent to the recipient (in bytes)",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "http.response.header.custom-header=['foo', 'bar']",
        aliases: [
            "http.response_content_length",
            "http.response.body.size"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.response.header.<key>": {
        brief: "HTTP response headers, <key> being the normalized HTTP Header name (lowercase), the value being the header values.",
        type: "string[]",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "http.response.header.custom-header=['foo', 'bar']",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    201,
                    204
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    103
                ]
            }
        ]
    },
    "http.response.size": {
        brief: "The transfer size of the response (in bytes).",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 456,
        aliases: [
            "http.response_transfer_size"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.response.status_code": {
        brief: "The status code of the HTTP response.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 404,
        aliases: [
            "http.status_code"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.response_transfer_size": {
        brief: "The transfer size of the response (in bytes).",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 456,
        deprecation: {
            replacement: "http.response.size"
        },
        aliases: [
            "http.response.size"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    61
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.route": {
        brief: "The matched route, that is, the path template in the format used by the respective server framework.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "/users/:id",
        aliases: [
            "url.template"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.scheme": {
        brief: "The URI scheme component identifying the used protocol.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "https",
        deprecation: {
            replacement: "url.scheme"
        },
        aliases: [
            "url.scheme"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.server_name": {
        brief: "The server domain name",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "example.com",
        deprecation: {
            replacement: "server.address"
        },
        aliases: [
            "server.address",
            "net.host.name",
            "http.host",
            "server_name"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    108,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.server.request.time_in_queue": {
        brief: "The time in milliseconds the request spent in the server queue before processing began. Measured from the X-Request-Start header set by reverse proxies (e.g., Nginx, HAProxy, Heroku) to when the application started handling the request.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 50,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    267
                ]
            }
        ]
    },
    "http.status_code": {
        brief: "The status code of the HTTP response.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 404,
        deprecation: {
            replacement: "http.response.status_code"
        },
        aliases: [
            "http.response.status_code"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    61
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.target": {
        brief: "The pathname and query string of the URL.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "/test?foo=bar#buzz",
        deprecation: {
            replacement: "url.path",
            reason: "This attribute is being deprecated in favor of url.path and url.query"
        },
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.url": {
        brief: "The URL of the resource that was fetched.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "https://example.com/test?foo=bar#buzz",
        deprecation: {
            replacement: "url.full"
        },
        aliases: [
            "url.full",
            "url"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    108
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.user_agent": {
        brief: "Value of the HTTP User-Agent header sent by the client.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "Mozilla/5.0 (iPhone; CPU iPhone OS 14_7_1 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/14.1.2 Mobile/15E148 Safari/604.1",
        deprecation: {
            replacement: "user_agent.original"
        },
        aliases: [
            "user_agent.original"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    id: {
        brief: "A unique identifier for the span.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "f47ac10b58cc4372a5670e02b2c3d479",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    inp: {
        brief: "The value of the recorded Interaction to Next Paint (INP) web vital",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 200,
        deprecation: {
            replacement: "browser.web_vital.inp.value",
            reason: "The INP web vital is now recorded as a browser.web_vital.inp.value attribute."
        },
        aliases: [
            "browser.web_vital.inp.value"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    229
                ],
                description: "Added and deprecated attribute to document JS SDK's current behaviour"
            }
        ]
    },
    "jsonrpc.protocol.version": {
        brief: "The version of the JSON-RPC protocol used.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "2.0",
        changelog: [
            {
                version: "0.12.0",
                prs: [
                    420
                ],
                description: "Added jsonrpc.protocol.version attribute"
            }
        ]
    },
    "jsonrpc.request.id": {
        brief: "The JSON-RPC request identifier. Unique within the session.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "1",
        aliases: [
            "mcp.request.id"
        ],
        changelog: [
            {
                version: "0.12.0",
                prs: [
                    420
                ],
                description: "Added jsonrpc.request.id attribute"
            }
        ]
    },
    "jvm.gc.action": {
        brief: "Name of the garbage collector action.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "end of minor GC",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "jvm.gc.name": {
        brief: "Name of the garbage collector.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "G1 Young Generation",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "jvm.memory.pool.name": {
        brief: "Name of the memory pool.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "G1 Old Gen",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "jvm.memory.type": {
        brief: "Name of the memory pool.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "G1 Old Gen",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "jvm.thread.daemon": {
        brief: "Whether the thread is daemon or not.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "jvm.thread.state": {
        brief: "State of the thread.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "blocked",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "koa.name": {
        brief: "The name of the Koa middleware or matched route that handled the request.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "/users/:id",
        deprecation: {
            reason: "No single replacement. SDKs should use http.route for router layers and code.function.name for middleware layers instead."
        },
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    490
                ],
                description: "Added koa.name attribute as deprecated"
            }
        ]
    },
    "koa.type": {
        brief: "The type of the Koa layer that handled the request.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "router",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    471
                ],
                description: "Added koa.type attribute"
            }
        ]
    },
    lcp: {
        brief: "The value of the recorded Largest Contentful Paint (LCP) web vital",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 2500,
        deprecation: {
            replacement: "browser.web_vital.lcp.value",
            reason: "The LCP web vital is now recorded as a browser.web_vital.lcp.value attribute."
        },
        aliases: [
            "browser.web_vital.lcp.value"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    229
                ],
                description: "Added and deprecated attribute to document JS SDK's current behaviour"
            }
        ]
    },
    "lcp.element": {
        brief: "The dom element responsible for the largest contentful paint.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "img",
        deprecation: {
            replacement: "browser.web_vital.lcp.element",
            reason: "The LCP element is now recorded as a browser.web_vital.lcp.element attribute."
        },
        aliases: [
            "browser.web_vital.lcp.element"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    233
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "lcp.id": {
        brief: "The id of the dom element responsible for the largest contentful paint.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "#hero",
        deprecation: {
            replacement: "browser.web_vital.lcp.id",
            reason: "The LCP id is now recorded as a browser.web_vital.lcp.id attribute."
        },
        aliases: [
            "browser.web_vital.lcp.id"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    233
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "lcp.loadTime": {
        brief: "The time it took for the LCP element to be loaded",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1402,
        deprecation: {
            replacement: "browser.web_vital.lcp.load_time",
            reason: "The LCP load time is now recorded as a browser.web_vital.lcp.load_time attribute."
        },
        aliases: [
            "browser.web_vital.lcp.load_time"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    233
                ]
            }
        ]
    },
    "lcp.renderTime": {
        brief: "The time it took for the LCP element to be rendered",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1685,
        deprecation: {
            replacement: "browser.web_vital.lcp.render_time",
            reason: "The LCP render time is now recorded as a browser.web_vital.lcp.render_time attribute."
        },
        aliases: [
            "browser.web_vital.lcp.render_time"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    233
                ]
            }
        ]
    },
    "lcp.size": {
        brief: "The size of the largest contentful paint element.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1234,
        deprecation: {
            replacement: "browser.web_vital.lcp.size",
            reason: "The LCP size is now recorded as a browser.web_vital.lcp.size attribute."
        },
        aliases: [
            "browser.web_vital.lcp.size"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    233
                ]
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "lcp.url": {
        brief: "The url of the dom element responsible for the largest contentful paint.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "https://example.com",
        deprecation: {
            replacement: "browser.web_vital.lcp.url",
            reason: "The LCP url is now recorded as a browser.web_vital.lcp.url attribute."
        },
        aliases: [
            "browser.web_vital.lcp.url"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    233
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "logger.name": {
        brief: "The name of the logger that generated this event.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "myLogger",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "mcp.cancelled.reason": {
        brief: "Reason for the cancellation of an MCP operation.",
        type: "string",
        applyScrubbing: {
            key: "manual",
            reason: "Cancellation reasons may contain user-specific or sensitive information"
        },
        isInOtel: !1,
        visibility: "public",
        example: "User cancelled the request",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.cancelled.request_id": {
        brief: "Request ID of the cancelled MCP operation.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "123",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.client.name": {
        brief: "Name of the MCP client application.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "claude-desktop",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.client.title": {
        brief: "Display title of the MCP client application.",
        type: "string",
        applyScrubbing: {
            key: "manual",
            reason: "Client titles may reveal user-specific application configurations or custom setups"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Claude Desktop",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.client.version": {
        brief: "Version of the MCP client application.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1.0.0",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.lifecycle.phase": {
        brief: "Lifecycle phase indicator for MCP operations.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "initialization_complete",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.logging.data_type": {
        brief: "Data type of the logged message content.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "string",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.logging.level": {
        brief: "Log level for MCP logging operations.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "info",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.logging.logger": {
        brief: "Logger name for MCP logging operations.",
        type: "string",
        applyScrubbing: {
            key: "manual",
            reason: "Logger names may be user-defined and could contain sensitive information"
        },
        isInOtel: !1,
        visibility: "public",
        example: "mcp_server",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.logging.message": {
        brief: "Log message content from MCP logging operations.",
        type: "string",
        applyScrubbing: {
            key: "auto",
            reason: "Log messages can contain user data"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Tool execution completed successfully",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.method.name": {
        brief: "The name of the MCP request or notification method being called.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "tools/call",
        changelog: [
            {
                version: "0.12.0",
                prs: [
                    420
                ],
                description: "Set is_in_otel=true, attribute exists in OTel MCP registry"
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.progress.current": {
        brief: "Current progress value of an MCP operation.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 50,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.progress.message": {
        brief: "Progress message describing the current state of an MCP operation.",
        type: "string",
        applyScrubbing: {
            key: "manual",
            reason: "Progress messages may contain user-specific or sensitive information"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Processing 50 of 100 items",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.progress.percentage": {
        brief: "Calculated progress percentage of an MCP operation. Computed from current/total * 100.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 50,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.progress.token": {
        brief: "Token for tracking progress of an MCP operation.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "progress-token-123",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.progress.total": {
        brief: "Total progress target value of an MCP operation.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 100,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.prompt.name": {
        brief: "Name of the MCP prompt template being used.",
        type: "string",
        applyScrubbing: {
            key: "manual",
            reason: "Prompt names may reveal user behavior patterns or sensitive operations"
        },
        isInOtel: !1,
        visibility: "public",
        example: "summarize",
        deprecation: {
            replacement: "gen_ai.prompt.name",
            reason: "OTel uses gen_ai.prompt.name for MCP prompt names"
        },
        aliases: [
            "gen_ai.prompt.name"
        ],
        changelog: [
            {
                version: "0.12.0",
                prs: [
                    420
                ],
                description: "Deprecated in favor of gen_ai.prompt.name"
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.prompt.result.description": {
        brief: "Description of the prompt result.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "A summary of the requested information",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.prompt.result.message_content": {
        brief: "Content of the message in the prompt result. Used for single message results only.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Please provide a summary of the document",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.prompt.result.message_count": {
        brief: "Number of messages in the prompt result.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 3,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.prompt.result.message_role": {
        brief: "Role of the message in the prompt result. Used for single message results only.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "user",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.protocol.ready": {
        brief: "Protocol readiness indicator for MCP session. Non-zero value indicates the protocol is ready.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.protocol.version": {
        brief: "MCP protocol version used in the session.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "2024-11-05",
        changelog: [
            {
                version: "0.12.0",
                prs: [
                    420
                ],
                description: "Set is_in_otel=true, attribute exists in OTel MCP registry"
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.request.argument.<key>": {
        brief: "MCP request argument with dynamic key suffix. The <key> is replaced with the actual argument name. The value is a JSON-stringified representation of the argument value.",
        type: "string",
        applyScrubbing: {
            key: "auto",
            reason: "Arguments contain user input"
        },
        isInOtel: !1,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "mcp.request.argument.query='weather in Paris'",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    176
                ]
            }
        ]
    },
    "mcp.request.argument.name": {
        brief: "Name argument from prompts/get MCP request.",
        type: "string",
        applyScrubbing: {
            key: "auto",
            reason: "Prompt names can contain user input"
        },
        isInOtel: !1,
        visibility: "public",
        example: "summarize",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.request.argument.uri": {
        brief: "URI argument from resources/read MCP request.",
        type: "string",
        applyScrubbing: {
            key: "auto",
            reason: "URIs can contain user file paths"
        },
        isInOtel: !1,
        visibility: "public",
        example: "file:///path/to/resource",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.request.id": {
        brief: "JSON-RPC request identifier for the MCP request. Unique within the MCP session.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1",
        deprecation: {
            replacement: "jsonrpc.request.id",
            reason: "OTel models MCP as JSON-RPC, uses jsonrpc.request.id"
        },
        aliases: [
            "jsonrpc.request.id"
        ],
        changelog: [
            {
                version: "0.12.0",
                prs: [
                    420
                ],
                description: "Deprecated in favor of jsonrpc.request.id"
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.resource.protocol": {
        brief: "Protocol of the resource URI being accessed, extracted from the URI.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "file",
        deprecation: {
            replacement: "network.protocol.name",
            reason: "OTel uses the generic network.protocol.name attribute"
        },
        aliases: [
            "network.protocol.name",
            "net.protocol.name"
        ],
        changelog: [
            {
                version: "0.12.0",
                prs: [
                    420
                ],
                description: "Deprecated in favor of network.protocol.name"
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.resource.uri": {
        brief: "The resource URI being accessed in an MCP operation.",
        type: "string",
        applyScrubbing: {
            key: "auto",
            reason: "URIs can contain sensitive file paths"
        },
        isInOtel: !0,
        visibility: "public",
        example: "file:///path/to/file.txt",
        changelog: [
            {
                version: "0.12.0",
                prs: [
                    420
                ],
                description: "Set is_in_otel=true, attribute exists in OTel MCP registry"
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.server.name": {
        brief: "Name of the MCP server application.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "sentry-mcp-server",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.server.title": {
        brief: "Display title of the MCP server application.",
        type: "string",
        applyScrubbing: {
            key: "manual",
            reason: "Server titles may reveal user-specific application configurations or custom setups"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Sentry MCP Server",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.server.version": {
        brief: "Version of the MCP server application.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "0.1.0",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.session.id": {
        brief: "Identifier for the MCP session.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "550e8400-e29b-41d4-a716-446655440000",
        changelog: [
            {
                version: "0.12.0",
                prs: [
                    420
                ],
                description: "Set is_in_otel=true, attribute exists in OTel MCP registry"
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.tool.name": {
        brief: "Name of the MCP tool being called.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "calculator",
        deprecation: {
            replacement: "gen_ai.tool.name",
            reason: "OTel uses gen_ai.tool.name for MCP tool names"
        },
        aliases: [
            "gen_ai.tool.name",
            "ai.function_call"
        ],
        changelog: [
            {
                version: "0.12.0",
                prs: [
                    420
                ],
                description: "Deprecated in favor of gen_ai.tool.name"
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.tool.result.content": {
        brief: "The content of the tool result.",
        type: "string",
        applyScrubbing: {
            key: "auto",
            reason: "Tool results can contain user data"
        },
        isInOtel: !1,
        visibility: "public",
        example: '{"output": "rainy", "toolCallId": "1"}',
        deprecation: {
            replacement: "gen_ai.tool.call.result",
            reason: "OTel uses gen_ai.tool.call.result for MCP tool results"
        },
        aliases: [
            "gen_ai.tool.call.result",
            "gen_ai.tool.message",
            "gen_ai.tool.output"
        ],
        changelog: [
            {
                version: "0.12.0",
                prs: [
                    420
                ],
                description: "Deprecated in favor of gen_ai.tool.call.result"
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            },
            {
                version: "0.2.0",
                prs: [
                    164
                ]
            }
        ]
    },
    "mcp.tool.result.content_count": {
        brief: "Number of content items in the tool result.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.tool.result.is_error": {
        brief: "Whether a tool execution resulted in an error.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !1,
        deprecation: {
            replacement: "error.type",
            reason: "OTel uses error.type set to 'tool_error' when isError is true. Cannot be automatically backfilled due to type mismatch (boolean vs string)."
        },
        changelog: [
            {
                version: "0.12.0",
                prs: [
                    420
                ],
                description: "Deprecated in favor of error.type"
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.transport": {
        brief: "Transport method used for MCP communication.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "stdio",
        deprecation: {
            replacement: "network.transport",
            reason: "OTel uses the generic network.transport attribute"
        },
        aliases: [
            "network.transport",
            "net.transport"
        ],
        changelog: [
            {
                version: "0.12.0",
                prs: [
                    420
                ],
                description: "Deprecated in favor of network.transport"
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mdc.<key>": {
        brief: "Attributes from the Mapped Diagnostic Context (MDC) present at the moment the log record was created. The MDC is supported by all the most popular logging solutions in the Java ecosystem, and it's usually implemented as a thread-local map that stores context for e.g. a specific request.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "mdc.some_key='some_value'",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    176
                ]
            }
        ]
    },
    "messaging.batch.message_count": {
        brief: "The number of messages sent, received, or processed in the scope of the batching operation.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 10,
        changelog: [
            {
                version: "0.6.0",
                prs: [
                    341
                ],
                description: "Added messaging.batch.message_count attribute"
            }
        ]
    },
    "messaging.destination": {
        brief: "The message destination name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "BestTopic",
        deprecation: {
            replacement: "messaging.destination.name",
            reason: "This attribute is being deprecated in favor of messaging.destination.name, which is the OTel-aligned replacement."
        },
        aliases: [
            "messaging.destination.name"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    482
                ],
                description: "Added messaging.destination attribute, deprecated in favor of messaging.destination.name"
            }
        ]
    },
    "messaging.destination.connection": {
        brief: "The message destination connection.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "BestTopic",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "messaging.destination.name": {
        brief: "The message destination name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "BestTopic",
        aliases: [
            "messaging.destination"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    482
                ],
                description: "Added messaging.destination as an alias"
            },
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "messaging.message.body.size": {
        brief: "The size of the message body in bytes.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 839,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "messaging.message.conversation_id": {
        brief: 'The conversation ID identifying the conversation to which the message belongs, represented as a string. Sometimes called "Correlation ID".',
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "MyConversationId",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    468
                ],
                description: "Added messaging.message.conversation_id attribute"
            }
        ]
    },
    "messaging.message.envelope.size": {
        brief: "The size of the message body and metadata in bytes.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 1045,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "messaging.message.id": {
        brief: "A value used by the messaging system as an identifier for the message, represented as a string.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "f47ac10b58cc4372a5670e02b2c3d479",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "messaging.message.receive.latency": {
        brief: "The latency between when the message was published and received.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1732847252,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "messaging.message.retry.count": {
        brief: "The amount of attempts to send the message.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 2,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "messaging.operation.name": {
        brief: "The name of the messaging operation being performed",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "send",
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    392
                ],
                description: "Added messaging.operation.name attribute"
            }
        ]
    },
    "messaging.operation.type": {
        brief: "A string identifying the type of the messaging operation",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "create",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    51,
                    127
                ]
            }
        ]
    },
    "messaging.rabbitmq.destination.routing_key": {
        brief: "RabbitMQ message routing key.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "myKey",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    468
                ],
                description: "Added messaging.rabbitmq.destination.routing_key attribute"
            }
        ]
    },
    "messaging.system": {
        brief: "The messaging system as identified by the client instrumentation.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "activemq",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    method: {
        brief: "The HTTP method used.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "GET",
        deprecation: {
            replacement: "http.request.method"
        },
        aliases: [
            "http.request.method",
            "http.request_method",
            "http.method"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "middleware.name": {
        brief: "The name of the middleware.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "AuthenticationMiddleware",
        changelog: [
            {
                version: "0.6.0",
                prs: [
                    336
                ],
                description: "Added middleware.name attribute"
            }
        ]
    },
    "navigation.origin": {
        brief: "The origin of the navigation (usually client side router navigations). Should preferrably parameterized template (like url.template) or a URL path otherwise.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "/users/:id",
        aliases: [
            "sentry.sveltekit.navigation.from"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    467
                ],
                description: "Added navigation.origin attribute"
            }
        ]
    },
    "navigation.route.id": {
        brief: "The identifier of the matched client-side route, as assigned by the routing framework (e.g., vue-router name, react-router id).",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "AboutView",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    468
                ],
                description: "Added navigation.route.id attribute"
            }
        ]
    },
    "navigation.type": {
        brief: "The type of navigation done by a client-side router.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "router.push",
        aliases: [
            "sentry.sveltekit.navigation.type"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    467
                ],
                description: "Added new deprecated alias"
            },
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "nel.elapsed_time": {
        brief: "The elapsed number of milliseconds between the start of the resource fetch and when it was completed or aborted by the user agent.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 100,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    68
                ]
            }
        ]
    },
    "nel.phase": {
        brief: 'If request failed, the phase of its network error. If request succeeded, "application".',
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "application",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    68,
                    127
                ]
            }
        ]
    },
    "nel.referrer": {
        brief: "request's referrer, as determined by the referrer policy associated with its client.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "https://example.com/foo?bar=baz",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    68,
                    127
                ]
            }
        ]
    },
    "nel.sampling_function": {
        brief: "The sampling function used to determine if the request should be sampled.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: .5,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    68
                ]
            }
        ]
    },
    "nel.type": {
        brief: 'If request failed, the type of its network error. If request succeeded, "ok".',
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "dns.unreachable",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    68,
                    127
                ]
            }
        ]
    },
    "network.connection.effective_type": {
        brief: "Specifies the effective type of the current connection (e.g. slow-2g, 2g, 3g, 4g).",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "4g",
        aliases: [
            "effectiveConnectionType"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    279
                ],
                description: "Added attribute network.connection.effective_type to be used instead of effectiveConnectionType"
            }
        ]
    },
    "network.connection.rtt": {
        brief: "Specifies the estimated effective round-trip time of the current connection, in milliseconds.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 100,
        aliases: [
            "connection.rtt"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    279
                ],
                description: "Added attribute network.connection.rtt to be used instead of connection.rtt"
            }
        ]
    },
    "network.connection.type": {
        brief: "Specifies the type of the current connection (e.g. wifi, ethernet, cellular , etc).",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "wifi",
        aliases: [
            "device.connection_type",
            "connectionType"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    279
                ],
                description: "Added attribute network.connection.type to be used instead of connectionType"
            }
        ]
    },
    "network.local.address": {
        brief: "Local address of the network connection - IP address or Unix domain socket name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "10.1.2.80",
        aliases: [
            "net.host.ip",
            "net.sock.host.addr"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "network.local.port": {
        brief: "Local port number of the network connection.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 65400,
        aliases: [
            "net.sock.host.port"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "network.peer.address": {
        brief: "Peer address of the network connection - IP address or Unix domain socket name.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "10.1.2.80",
        aliases: [
            "net.peer.ip",
            "net.sock.peer.addr"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    108,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "network.peer.port": {
        brief: "Peer port number of the network connection.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 65400,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "network.protocol.name": {
        brief: "OSI application layer or non-OSI equivalent.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "http",
        aliases: [
            "net.protocol.name",
            "mcp.resource.protocol"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "network.protocol.version": {
        brief: "The actual version of the protocol used for network communication.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "1.1",
        aliases: [
            "http.flavor",
            "net.protocol.version"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "network.transport": {
        brief: "OSI transport layer or inter-process communication method.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "tcp",
        aliases: [
            "net.transport",
            "mcp.transport"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "network.type": {
        brief: "OSI network layer or non-OSI equivalent.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "ipv4",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "net.host.ip": {
        brief: "Local address of the network connection - IP address or Unix domain socket name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "192.168.0.1",
        deprecation: {
            replacement: "network.local.address"
        },
        aliases: [
            "network.local.address",
            "net.sock.host.addr"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    108,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "net.host.name": {
        brief: "Server domain name if available without reverse DNS lookup; otherwise, IP address or Unix domain socket name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "example.com",
        deprecation: {
            replacement: "server.address"
        },
        aliases: [
            "server.address",
            "http.server_name",
            "http.host",
            "server_name"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    108,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "net.host.port": {
        brief: "Server port number.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 1337,
        deprecation: {
            replacement: "server.port"
        },
        aliases: [
            "server.port"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    61
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "net.peer.ip": {
        brief: "Peer address of the network connection - IP address or Unix domain socket name.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "192.168.0.1",
        deprecation: {
            replacement: "network.peer.address"
        },
        aliases: [
            "network.peer.address",
            "net.sock.peer.addr"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    108,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "net.peer.name": {
        brief: "Server domain name if available without reverse DNS lookup; otherwise, IP address or Unix domain socket name.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "example.com",
        deprecation: {
            replacement: "server.address",
            reason: "Deprecated, use server.address on client spans and client.address on server spans."
        },
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "net.peer.port": {
        brief: "Peer port number.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 1337,
        deprecation: {
            replacement: "server.port",
            reason: "Deprecated, use server.port on client spans and client.port on server spans."
        },
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    61
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "net.protocol.name": {
        brief: "OSI application layer or non-OSI equivalent.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "http",
        deprecation: {
            replacement: "network.protocol.name"
        },
        aliases: [
            "network.protocol.name",
            "mcp.resource.protocol"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "net.protocol.version": {
        brief: "The actual version of the protocol used for network communication.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "1.1",
        deprecation: {
            replacement: "network.protocol.version"
        },
        aliases: [
            "network.protocol.version",
            "http.flavor"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    108,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "net.sock.family": {
        brief: "OSI transport and network layer",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "inet",
        deprecation: {
            replacement: "network.transport",
            reason: "Deprecated, use network.transport and network.type."
        },
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "net.sock.host.addr": {
        brief: "Local address of the network connection mapping to Unix domain socket name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "/var/my.sock",
        deprecation: {
            replacement: "network.local.address"
        },
        aliases: [
            "network.local.address",
            "net.host.ip"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    108,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "net.sock.host.port": {
        brief: "Local port number of the network connection.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 8080,
        deprecation: {
            replacement: "network.local.port"
        },
        aliases: [
            "network.local.port"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    61
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "net.sock.peer.addr": {
        brief: "Peer address of the network connection - IP address",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "192.168.0.1",
        deprecation: {
            replacement: "network.peer.address"
        },
        aliases: [
            "network.peer.address",
            "net.peer.ip"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    108,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "net.sock.peer.name": {
        brief: "Peer address of the network connection - Unix domain socket name",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "/var/my.sock",
        deprecation: {
            reason: "Deprecated from OTEL, no replacement at this time"
        },
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    119,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "net.sock.peer.port": {
        brief: "Peer port number of the network connection.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 8080,
        deprecation: {
            replacement: "network.peer.port"
        },
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    61
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "net.transport": {
        brief: "OSI transport layer or inter-process communication method.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "tcp",
        deprecation: {
            replacement: "network.transport"
        },
        aliases: [
            "network.transport",
            "mcp.transport"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "os.build": {
        brief: "The build ID of the operating system.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1234567890",
        deprecation: {
            replacement: "os.build_id"
        },
        aliases: [
            "os.build_id"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    301
                ],
                description: "Added os.build attribute, deprecated in favor of os.build_id"
            }
        ]
    },
    "os.build_id": {
        brief: "The build ID of the operating system.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "1234567890",
        aliases: [
            "os.build"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    301
                ],
                description: "Added os.build as alias"
            },
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "os.description": {
        brief: "Human readable (not intended to be parsed) OS version information, like e.g. reported by ver or lsb_release -a commands.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "Ubuntu 18.04.1 LTS",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "os.kernel_version": {
        brief: "An independent kernel version string. Typically the entire output of the `uname` syscall.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "20.2.0",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    301
                ],
                description: "Added os.kernel_version attribute"
            }
        ]
    },
    "os.name": {
        brief: "Human readable operating system name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "Ubuntu",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "os.raw_description": {
        brief: "An unprocessed description string obtained by the operating system. For some well-known runtimes, Sentry will attempt to parse `name` and `version` from this string, if they are not explicitly given.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Ubuntu 22.04.4 LTS (Jammy Jellyfish)",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    301
                ],
                description: "Added os.raw_description attribute"
            }
        ]
    },
    "os.rooted": {
        brief: "Whether the operating system has been jailbroken or rooted.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    301
                ],
                description: "Added os.rooted attribute"
            }
        ]
    },
    "os.theme": {
        brief: "Whether the OS runs in dark mode or light mode.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "dark",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    301
                ],
                description: "Added os.theme attribute"
            }
        ]
    },
    "os.type": {
        brief: "The operating system type.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "linux",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "os.version": {
        brief: "The version of the operating system.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "18.04.2",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "otel.kind": {
        brief: "The span kind (https://opentelemetry.io/docs/concepts/signals/traces/#span-kind). Deprecated, use `sentry.kind` instead.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "SERVER",
        deprecation: {
            replacement: "sentry.kind",
            reason: "Deprecated in favor of sentry.kind"
        },
        aliases: [
            "sentry.kind"
        ],
        changelog: [
            {
                version: "0.13.0",
                prs: [
                    440
                ],
                description: "Added otel.kind attribute"
            }
        ]
    },
    "otel.scope.name": {
        brief: "The name of the instrumentation scope - (InstrumentationScope.Name in OTLP).",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "io.opentelemetry.contrib.mongodb",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "otel.scope.version": {
        brief: "The version of the instrumentation scope - (InstrumentationScope.Version in OTLP).",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "2.4.5",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "otel.status_code": {
        brief: "Name of the code, either \u201COK\u201D or \u201CERROR\u201D. MUST NOT be set if the status code is UNSET.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "OK",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "otel.status_description": {
        brief: "Description of the Status if it has a value, otherwise not set.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "resource not found",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "params.<key>": {
        brief: "Decoded parameters extracted from a URL path. Usually added by client-side routing frameworks like vue-router.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "params.id='123'",
        aliases: [
            "url.path.parameter.<key>"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    103
                ]
            }
        ]
    },
    "performance.activationStart": {
        brief: "The time between initiating a navigation to a page and the browser activating the page",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1.983,
        deprecation: {
            replacement: "browser.performance.navigation.activation_start",
            reason: "The activationStart is now recorded as the browser.performance.navigation.activation_start attribute."
        },
        aliases: [
            "browser.performance.navigation.activation_start"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    321
                ],
                description: "Added performance.activationStart attribute"
            }
        ]
    },
    "performance.timeOrigin": {
        brief: "The browser's performance.timeOrigin timestamp representing the time when the pageload was initiated",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1776185678886e-3,
        deprecation: {
            replacement: "browser.performance.time_origin",
            reason: "The timeOrigin is now recorded as the browser.performance.time_origin attribute."
        },
        aliases: [
            "browser.performance.time_origin"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    321
                ],
                description: "Added performance.timeOrigin attribute"
            }
        ]
    },
    previous_route: {
        brief: "Also used by mobile SDKs to indicate the previous route in the application.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "HomeScreen",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    74
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "process.command_args": {
        brief: "All the command arguments (including the command/executable itself) as received by the process.",
        type: "string[]",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: [
            "cmd/otecol",
            "--config=config.yaml"
        ],
        changelog: [
            {
                version: "0.6.0",
                prs: [
                    327
                ],
                description: "Added process.command_args attribute"
            }
        ]
    },
    "process.executable.name": {
        brief: "The name of the executable that started the process.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "getsentry",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "process.pid": {
        brief: "The process ID of the running process.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 12345,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "process.runtime.description": {
        brief: "An additional description about the runtime of the process, for example a specific vendor customization of the runtime environment. Equivalent to `raw_description` in the Sentry runtime context.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "Eclipse OpenJ9 VM openj9-0.21.0",
        aliases: [
            "runtime.raw_description"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "process.runtime.engine.name": {
        brief: "The name of the runtime engine.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "v8",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "process.runtime.engine.version": {
        brief: "The version of the runtime engine.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "12.9.202.13-rusty",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "process.runtime.name": {
        brief: "The name of the runtime. Equivalent to `name` in the Sentry runtime context.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "node",
        aliases: [
            "runtime.name"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "process.runtime.version": {
        brief: "The version of the runtime of this process, as returned by the runtime without modification. Equivalent to `version` in the Sentry runtime context.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "18.04.2",
        aliases: [
            "runtime.version"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "query.<key>": {
        brief: "An item in a query string. Usually added by client-side routing frameworks like vue-router.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "query.id='123'",
        deprecation: {
            replacement: "url.query",
            reason: "Instead of sending items individually in query.<key>, they should be sent all together with url.query."
        },
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    103
                ]
            }
        ]
    },
    "react.version": {
        brief: "The version of the React framework",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "18.2.0",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    368
                ],
                description: "Added react.version attribute"
            }
        ]
    },
    release: {
        brief: "The sentry release.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "production",
        deprecation: {
            replacement: "sentry.release"
        },
        aliases: [
            "sentry.release"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "remix.action_form_data.<key>": {
        brief: "Remix form data, <key> being the form data key, the value being the form data value.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "http.response.header.text='test'",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    103
                ]
            }
        ]
    },
    replay_id: {
        brief: "The id of the sentry replay.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "123e4567e89b12d3a456426614174000",
        deprecation: {
            replacement: "sentry.replay_id"
        },
        aliases: [
            "sentry.replay_id"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "resource.deployment.environment": {
        brief: "The software deployment environment name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "production",
        deprecation: {
            replacement: "sentry.environment"
        },
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    266
                ]
            }
        ]
    },
    "resource.deployment.environment.name": {
        brief: "The software deployment environment name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "production",
        deprecation: {
            replacement: "sentry.environment"
        },
        changelog: [
            {
                version: "0.3.1",
                prs: [
                    196
                ]
            }
        ]
    },
    "resource.render_blocking_status": {
        brief: "The render blocking status of the resource.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "non-blocking",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    route: {
        brief: "The matched route, that is, the path template in the format used by the respective server framework. Also used by mobile SDKs to indicate the current route in the application.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "App\\Controller::indexAction",
        deprecation: {
            replacement: "http.route"
        },
        aliases: [
            "http.route"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    74
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "rpc.grpc.status_code": {
        brief: "The numeric status code of the gRPC request.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 2,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "rpc.method": {
        brief: "The fully-qualified logical name of the method from the RPC interface perspective.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "com.example.ExampleService/exampleMethod",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    351
                ],
                description: "Added rpc.method attribute"
            }
        ]
    },
    "rpc.response.status_code": {
        brief: "Status code of the RPC returned by the RPC server or generated by the client.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "DEADLINE_EXCEEDED",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    352
                ],
                description: "Added rpc.response.status_code attribute"
            }
        ]
    },
    "rpc.service": {
        brief: "The full (logical) name of the service being called, including its package name, if applicable.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "myService.BestService",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "rpc.system": {
        brief: "A string identifying the remoting system.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "aws-api",
        deprecation: {
            replacement: "rpc.system.name",
            reason: "This attribute is being deprecated in favor of rpc.system.name, which is the OTel-aligned replacement."
        },
        aliases: [
            "rpc.system.name"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    482
                ],
                description: "Added rpc.system attribute, deprecated in favor of rpc.system.name"
            }
        ]
    },
    "rpc.system.name": {
        brief: "A string identifying the remoting system.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "aws-api",
        aliases: [
            "rpc.system"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    482
                ],
                description: "Added rpc.system.name attribute"
            }
        ]
    },
    "runtime.build": {
        brief: "The application build string, when it is separate from the version.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "stable",
        deprecation: {
            reason: "The runtime.* namespace is deprecated in favor of process.runtime.*. No direct OTel equivalent exists for this attribute."
        },
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    383
                ],
                description: "Added and deprecated runtime.build attribute"
            }
        ]
    },
    "runtime.name": {
        brief: "The name of the runtime. For example node, CPython, or rustc.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "node",
        deprecation: {
            replacement: "process.runtime.name",
            reason: "Prefer OTel-aligned process.runtime.name"
        },
        aliases: [
            "process.runtime.name"
        ],
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    383
                ],
                description: "Added and deprecated runtime.name attribute in favor of process.runtime.name"
            }
        ]
    },
    "runtime.raw_description": {
        brief: "Unprocessed description string as obtained from the runtime. Used to extract name and version for well-known runtimes.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Eclipse OpenJ9 VM openj9-0.21.0",
        deprecation: {
            replacement: "process.runtime.description",
            reason: "Prefer OTel-aligned process.runtime.description"
        },
        aliases: [
            "process.runtime.description"
        ],
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    383
                ],
                description: "Added and deprecated runtime.raw_description attribute in favor of process.runtime.description"
            }
        ]
    },
    "runtime.version": {
        brief: "The version of the runtime.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "18.04.2",
        deprecation: {
            replacement: "process.runtime.version",
            reason: "Prefer OTel-aligned process.runtime.version"
        },
        aliases: [
            "process.runtime.version"
        ],
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    383
                ],
                description: "Added and deprecated runtime.version attribute in favor of process.runtime.version"
            }
        ]
    },
    "score.<key>": {
        brief: "The weighted performance score for a web vital. This is defined as `score.weight.<key>` * `score.ratio.<key>`.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "score.cls=0.1723",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    355
                ],
                description: "Added score.<key> attribute"
            }
        ]
    },
    "score.ratio.<key>": {
        brief: "The score for a web vital, normalized to a number between 0 and 1.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "score.ratio.inp=0.7748",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    355
                ],
                description: "Added score.ratio.<key> attribute"
            }
        ]
    },
    "score.total": {
        brief: "The total performance score of a span. This is the sum of individual weighted web vital scores (see `score.<key>`).",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    355
                ],
                description: "Added score.total attribute"
            }
        ]
    },
    "score.weight.<key>": {
        brief: "The relative weight of a web vital in a span's performance score.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "score.weight.fcp=0.25",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    355
                ],
                description: "Added score.weight.<key> attribute"
            }
        ]
    },
    "sentry.action": {
        brief: "Used as a generic attribute representing the action depending on the type of span. For instance, this is the database query operation for DB spans, and the request method for HTTP spans.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "SELECT",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    212
                ]
            }
        ]
    },
    "sentry.browser.name": {
        brief: "The name of the browser.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Chrome",
        deprecation: {
            replacement: "browser.name"
        },
        aliases: [
            "browser.name"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    139
                ]
            }
        ]
    },
    "sentry.browser.version": {
        brief: "The version of the browser.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "120.0.6099.130",
        deprecation: {
            replacement: "browser.version"
        },
        aliases: [
            "browser.version"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    139
                ]
            }
        ]
    },
    "sentry.cancellation_reason": {
        brief: "The reason why a span ended early.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "document.hidden",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "sentry.category": {
        brief: "The high-level category of a span, derived from the span operation or span attributes. This categorizes spans by their general purpose (e.g., database, HTTP, UI). Known values include: 'ai', 'ai.pipeline', 'app', 'browser', 'cache', 'console', 'db', 'event', 'file', 'function.aws', 'function.azure', 'function.gcp', 'function.nextjs', 'function.remix', 'graphql', 'grpc', 'http', 'measure', 'middleware', 'navigation', 'pageload', 'queue', 'resource', 'rpc', 'serialize', 'subprocess', 'template', 'topic', 'ui', 'ui.angular', 'ui.ember', 'ui.react', 'ui.svelte', 'ui.vue', 'view', 'websocket'.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "db",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    218
                ]
            }
        ]
    },
    "sentry.client_sample_rate": {
        brief: "Rate at which a span was sampled in the SDK.",
        type: "double",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: .5,
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    102
                ]
            }
        ]
    },
    "sentry.description": {
        brief: "The human-readable description of a span.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "index view query",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    135
                ]
            }
        ]
    },
    "sentry.dist": {
        brief: "The sentry dist.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1.0",
        aliases: [
            "dist"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    489
                ],
                description: "Added dist as an alias"
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "sentry.domain": {
        brief: "Used as a generic attribute representing the domain depending on the type of span. For instance, this is the collection/table name for database spans, and the server address for HTTP spans.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "example.com",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    212
                ]
            }
        ]
    },
    "sentry.dsc.environment": {
        brief: "The environment from the dynamic sampling context.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "internal",
        example: "prod",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    185
                ]
            }
        ]
    },
    "sentry.dsc.project_id": {
        brief: "The ID of the project where the trace originated (i.e. the project of the SDK that started the trace). Propagated through the dynamic sampling context and set by Relay during ingestion.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "internal",
        example: "12345",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    358
                ],
                description: "Add sentry.dsc.project_id as an attribute"
            }
        ]
    },
    "sentry.dsc.public_key": {
        brief: "The public key from the dynamic sampling context.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "internal",
        example: "c51734c603c4430eb57cb0a5728a479d",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    185
                ]
            }
        ]
    },
    "sentry.dsc.release": {
        brief: "The release identifier from the dynamic sampling context.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "internal",
        example: "frontend@e8211be71b214afab5b85de4b4c54be3714952bb",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    185
                ]
            }
        ]
    },
    "sentry.dsc.sampled": {
        brief: "Whether the event was sampled according to the dynamic sampling context.",
        type: "boolean",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "internal",
        example: !0,
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    185
                ]
            }
        ]
    },
    "sentry.dsc.sample_rate": {
        brief: "The sample rate from the dynamic sampling context.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "internal",
        example: "1.0",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    185
                ]
            }
        ]
    },
    "sentry.dsc.trace_id": {
        brief: "The trace ID from the dynamic sampling context.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "internal",
        example: "047372980460430cbc78d9779df33a46",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    185
                ]
            }
        ]
    },
    "sentry.dsc.transaction": {
        brief: "The transaction name from the dynamic sampling context.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "internal",
        example: "/issues/errors-outages/",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    185
                ]
            }
        ]
    },
    "sentry.environment": {
        brief: "The sentry environment.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "production",
        aliases: [
            "environment"
        ],
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "sentry.exclusive_time": {
        brief: "The exclusive time duration of the span in milliseconds.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1234,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.3.0",
                prs: [
                    160
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "sentry.graphql.operation": {
        brief: "Indicates the type of graphql operation, emitted by the Javascript SDK.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "getUserById",
        changelog: [
            {
                version: "0.3.1",
                prs: [
                    190
                ]
            }
        ]
    },
    "sentry.group": {
        brief: "Stores the hash of `sentry.normalized_description`. This is primarily used for grouping spans in the product end.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    212
                ]
            }
        ]
    },
    "sentry.http.prefetch": {
        brief: "If an http request was a prefetch request.",
        type: "boolean",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "sentry.idle_span_finish_reason": {
        brief: "The reason why an idle span ended early.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "idleTimeout",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "sentry.is_remote": {
        brief: "Indicates whether a span's parent is remote.",
        type: "boolean",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.3.1",
                prs: [
                    190
                ]
            }
        ]
    },
    "sentry.kind": {
        brief: "Used to clarify the relationship between parents and children, or to distinguish between spans, e.g. a `server` and `client` span with the same name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "server",
        aliases: [
            "otel.kind"
        ],
        changelog: [
            {
                version: "0.3.1",
                prs: [
                    190
                ]
            }
        ]
    },
    "sentry.main_thread": {
        brief: "Whether the span or event occurred on the main thread. Computed by Relay and should not be set by SDKs.",
        type: "boolean",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.5.0"
            }
        ]
    },
    "sentry.message.parameter.<key>": {
        brief: "A parameter used in the message template. <key> can either be the number that represent the parameter's position in the template string (sentry.message.parameter.0, sentry.message.parameter.1, etc) or the parameter's name (sentry.message.parameter.item_id, sentry.message.parameter.user_id, etc)",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "sentry.message.parameter.0='123'",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    116
                ]
            }
        ]
    },
    "sentry.message.template": {
        brief: "The parameterized template string.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Hello, {name}!",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    116
                ]
            }
        ]
    },
    "sentry.metric.source": {
        brief: "The provenance of a metric.  For example, this can be set to indicate if a metric was generated by Relay from a span.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "span",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    476
                ],
                description: "Added sentry.metric.source attribute"
            }
        ]
    },
    "sentry.mobile": {
        brief: "Whether the application is using a mobile SDK. Computed by Relay and should not be set by SDKs.",
        type: "boolean",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.5.0"
            }
        ]
    },
    "sentry.module.<key>": {
        brief: "A module that was loaded in the process. The key is the name of the module.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "sentry.module.brianium/paratest='v7.7.0'",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    103
                ]
            }
        ]
    },
    "sentry.nextjs.ssr.function.route": {
        brief: "A parameterized route for a function in Next.js that contributes to Server-Side Rendering. Should be present on spans that track such functions when the file location of the function is known.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "/posts/[id]/layout",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    54,
                    106
                ]
            }
        ]
    },
    "sentry.nextjs.ssr.function.type": {
        brief: "A descriptor for a for a function in Next.js that contributes to Server-Side Rendering. Should be present on spans that track such functions.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "generateMetadata",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    54,
                    106
                ]
            }
        ]
    },
    "sentry.normalized_db_query": {
        brief: "The normalized version of `db.query.text`.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "SELECT .. FROM sentry_project WHERE (project_id = %s)",
        changelog: [
            {
                version: "0.3.1",
                prs: [
                    194
                ]
            }
        ]
    },
    "sentry.normalized_db_query.hash": {
        brief: "The hash of `sentry.normalized_db_query`.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    200
                ]
            }
        ]
    },
    "sentry.normalized_description": {
        brief: "Used as a generic attribute representing the normalized `sentry.description`. This refers to the legacy use case of `sentry.description` where it holds relevant data depending on the type of span (e.g. database query, resource url, http request description, etc).",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "SELECT .. FROM sentry_project WHERE (project_id = %s)",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    212
                ]
            }
        ]
    },
    "sentry.observed_timestamp_nanos": {
        brief: "The timestamp at which an envelope was received by Relay, in nanoseconds.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1544712660300000000",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    174
                ]
            },
            {
                version: "0.2.0",
                prs: [
                    137
                ]
            }
        ]
    },
    "sentry.op": {
        brief: "The operation of a span.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "http.client",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "sentry.origin": {
        brief: "The origin of the instrumentation (e.g. span, log, etc.)",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "auto.http.otel.fastify",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    68
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "sentry.platform": {
        brief: "The sdk platform that generated the event.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "php",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "sentry.profiler_id": {
        brief: "The id of the currently running profiler (continuous profiling)",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "18779b64dd35d1a538e7ce2dd2d3fad3",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    242
                ]
            }
        ]
    },
    "sentry.profile_id": {
        brief: "The ID of the Sentry profile the span is associated with. This is only meaningful for transaction-based profiling.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "123e4567e89b12d3a456426614174000",
        changelog: [
            {
                version: "0.6.0",
                prs: [
                    344
                ],
                description: "Added sentry.profile_id attribute"
            }
        ]
    },
    "sentry.release": {
        brief: "The sentry release.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "7.0.0",
        aliases: [
            "service.version",
            "release"
        ],
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "sentry.replay_id": {
        brief: "The id of the sentry replay.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "123e4567e89b12d3a456426614174000",
        aliases: [
            "replay_id"
        ],
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "sentry.replay_is_buffering": {
        brief: "A sentinel attribute on log events indicating whether the current Session Replay is being buffered (onErrorSampleRate).",
        type: "boolean",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    185
                ]
            }
        ]
    },
    "sentry.report_event": {
        brief: "(Deprecated) The event that caused the SDK to report CLS or LCP (pagehide or navigation)",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "pagehide",
        deprecation: {
            reason: "The report event is now recorded as a browser.web_vital.lcp.report_event or browser.web_vital.cls.report_event attribute. No backfill required."
        },
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    320
                ],
                description: "Added sentry.report_event attribute"
            }
        ]
    },
    "sentry.sdk.integrations": {
        brief: "A list of names identifying enabled integrations. The list shouldhave all enabled integrations, including default integrations. Defaultintegrations are included because different SDK releases may contain differentdefault integrations.",
        type: "string[]",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: [
            "InboundFilters",
            "FunctionToString",
            "BrowserApiErrors",
            "Breadcrumbs"
        ],
        changelog: [
            {
                version: "0.0.0",
                prs: [
                    42
                ]
            }
        ]
    },
    "sentry.sdk.name": {
        brief: "The sentry sdk name.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "@sentry/react",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "sentry.sdk.version": {
        brief: "The sentry sdk version.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "7.0.0",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "sentry.segment.id": {
        brief: "The segment ID of a span",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "051581bf3cb55c13",
        aliases: [
            "sentry.segment_id"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    107,
                    124
                ]
            }
        ]
    },
    "sentry.segment_id": {
        brief: "The segment ID of a span",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "051581bf3cb55c13",
        deprecation: {
            replacement: "sentry.segment.id"
        },
        aliases: [
            "sentry.segment.id"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    124
                ]
            }
        ]
    },
    "sentry.segment.name": {
        brief: "The segment name of a span",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "GET /user",
        aliases: [
            "sentry.transaction",
            "transaction"
        ],
        changelog: [
            {
                version: "0.6.0",
                prs: [
                    345
                ],
                description: "Added sentry.transaction and transaction aliases"
            },
            {
                version: "0.1.0",
                prs: [
                    104
                ]
            }
        ]
    },
    "sentry.server_sample_rate": {
        brief: "Rate at which a span was sampled in Relay.",
        type: "double",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: .5,
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    102
                ]
            }
        ]
    },
    "sentry.source": {
        brief: "The source of a span, also referred to as transaction source. Known values are:  `'custom'`, `'url'`, `'route'`, `'component'`, `'view'`, `'task'`. '`source`' describes a parametrized route, while `'url'` describes the full URL, potentially containing identifiers.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "route",
        deprecation: {
            replacement: "sentry.span.source",
            reason: "This attribute is being deprecated in favor of sentry.span.source"
        },
        changelog: [
            {
                version: "0.5.0"
            }
        ]
    },
    "sentry.span.source": {
        brief: "The source of a span, also referred to as transaction source. Known values are:  `'custom'`, `'url'`, `'route'`, `'component'`, `'view'`, `'task'`. '`source`' describes a parametrized route, while `'url'` describes the full URL, potentially containing identifiers.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "route",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    214
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "sentry.status": {
        brief: `The span's status (either "ok" or "error"). Older SDKs may set this to a more specific error, but this behaviour is deprecated.`,
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "ok",
        changelog: [
            {
                version: "0.14.0",
                prs: [
                    453
                ]
            }
        ]
    },
    "sentry.status_code": {
        brief: "The HTTP status code used in Sentry Insights. Typically set by Sentry during ingestion, rather than by clients.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 200,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    223,
                    228
                ]
            }
        ]
    },
    "sentry.status.message": {
        brief: "The from OTLP extracted status message.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "foobar",
        changelog: [
            {
                version: "0.3.1",
                prs: [
                    190
                ]
            }
        ]
    },
    "sentry.sveltekit.navigation.from": {
        brief: "the navigation origin (sveltekit router)",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "/home",
        deprecation: {
            replacement: "navigation.origin",
            reason: "Use the more generic attribute instead"
        },
        aliases: [
            "navigation.origin"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    467
                ],
                description: "Added sentry.sveltekit.navigation.from attribute"
            }
        ]
    },
    "sentry.sveltekit.navigation.to": {
        brief: "the navigation destination",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "/users/:id",
        deprecation: {
            reason: "the navigation destination is already covered by url.* attributes"
        },
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    467
                ],
                description: "Added sentry.sveltekit.navigation.to attribute"
            }
        ]
    },
    "sentry.sveltekit.navigation.type": {
        brief: "The type of navigation event emitted from the sveltekit client router",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "link",
        deprecation: {
            replacement: "navigation.type",
            reason: "Use the more generic attribute instead"
        },
        aliases: [
            "navigation.type"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    467
                ],
                description: "Added sentry.sveltekit.navigation.type attribute"
            }
        ]
    },
    "sentry.thread.id": {
        brief: "Current \u201Cmanaged\u201D thread ID.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 56,
        deprecation: {
            replacement: "thread.id",
            reason: "This attribute is being deprecated in favor of the OTel-standard thread.id"
        },
        changelog: [
            {
                version: "0.13.0",
                prs: [
                    451
                ]
            }
        ]
    },
    "sentry.timestamp.sequence": {
        brief: "A sequencing counter for deterministic ordering of logs or metrics when timestamps share the same integer millisecond. Starts at 0 on SDK initialization, increments by 1 for each captured item, and resets to 0 when the integer millisecond of the current item differs from the previous one.",
        type: "integer",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: 0,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    262
                ]
            }
        ]
    },
    "sentry.trace_lifecycle": {
        brief: "Indicates the chosen trace lifecycle mode of the SDK (stream or static)",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "stream",
        changelog: [
            {
                version: "0.13.0",
                prs: [
                    442
                ],
                description: "Added sentry.trace_lifecycle attribute"
            }
        ]
    },
    "sentry.trace.parent_span_id": {
        brief: "The span id of the span that was active when the log was collected. This should not be set if there was no active span.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "b0e6f15b45c36b12",
        deprecation: {},
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    287
                ],
                description: "Deprecate `sentry.trace.parent_span_id`"
            },
            {
                version: "0.1.0",
                prs: [
                    116
                ]
            }
        ]
    },
    "sentry.trace.status": {
        brief: `The segment's status (either "ok" or "error"). Older SDKs may set this to a more specific error, but this behaviour is deprecated.`,
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "ok",
        changelog: [
            {
                version: "0.14.0",
                prs: [
                    453
                ]
            }
        ]
    },
    "sentry.transaction": {
        brief: "The sentry transaction (segment name).",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "GET /",
        deprecation: {
            replacement: "sentry.segment.name",
            reason: "This attribute is being deprecated in favor of sentry.segment.name"
        },
        aliases: [
            "sentry.segment.name",
            "transaction"
        ],
        changelog: [
            {
                version: "0.6.0",
                prs: [
                    345
                ],
                description: "Deprecated sentry.transaction in favor of sentry.segment.name"
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "sentry.user.email": {
        brief: "User email address.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        deprecation: {
            replacement: "user.email"
        },
        aliases: [
            "user.email"
        ],
        changelog: [
            {
                version: "0.10.0",
                prs: [
                    406
                ]
            }
        ]
    },
    "sentry.user.geo.city": {
        brief: "Human readable city name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        deprecation: {
            replacement: "user.geo.city"
        },
        aliases: [
            "user.geo.city"
        ],
        changelog: [
            {
                version: "0.10.0",
                prs: [
                    406
                ]
            }
        ]
    },
    "sentry.user.geo.country_code": {
        brief: "Two-letter country code (ISO 3166-1 alpha-2).",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        deprecation: {
            replacement: "user.geo.country_code"
        },
        aliases: [
            "user.geo.country_code"
        ],
        changelog: [
            {
                version: "0.10.0",
                prs: [
                    406
                ]
            }
        ]
    },
    "sentry.user.geo.region": {
        brief: "Human readable region name or code.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        deprecation: {
            replacement: "user.geo.region"
        },
        aliases: [
            "user.geo.region"
        ],
        changelog: [
            {
                version: "0.10.0",
                prs: [
                    406
                ]
            }
        ]
    },
    "sentry.user.geo.subdivision": {
        brief: "Human readable subdivision name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        deprecation: {
            replacement: "user.geo.subdivision"
        },
        aliases: [
            "user.geo.subdivision"
        ],
        changelog: [
            {
                version: "0.10.0",
                prs: [
                    406
                ]
            }
        ]
    },
    "sentry.user.id": {
        brief: "Unique identifier of the user.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        deprecation: {
            replacement: "user.id"
        },
        aliases: [
            "user.id"
        ],
        changelog: [
            {
                version: "0.10.0",
                prs: [
                    406
                ]
            }
        ]
    },
    "sentry.user.ip": {
        brief: "The IP address of the user.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        deprecation: {
            replacement: "user.ip_address"
        },
        aliases: [
            "user.ip_address"
        ],
        changelog: [
            {
                version: "0.10.0",
                prs: [
                    406
                ]
            }
        ]
    },
    "sentry.user.username": {
        brief: "Short name or login/username of the user.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        deprecation: {
            replacement: "user.name"
        },
        aliases: [
            "user.name"
        ],
        changelog: [
            {
                version: "0.10.0",
                prs: [
                    406
                ]
            }
        ]
    },
    "server.address": {
        brief: "Server domain name if available without reverse DNS lookup; otherwise, IP address or Unix domain socket name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "example.com",
        aliases: [
            "http.server_name",
            "net.host.name",
            "http.host",
            "server_name"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    108,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    server_name: {
        brief: "Server domain name if available without reverse DNS lookup; otherwise, IP address or Unix domain socket name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "example.com",
        deprecation: {
            replacement: "server.address",
            reason: "This attribute is being deprecated in favor of server.address, which is the OTel-aligned replacement."
        },
        aliases: [
            "server.address",
            "http.server_name",
            "net.host.name",
            "http.host"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    477
                ],
                description: "Added server_name attribute, deprecated in favor of server.address"
            }
        ]
    },
    "server.port": {
        brief: "Server port number.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 1337,
        aliases: [
            "net.host.port"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "service.name": {
        brief: "Logical name of the service.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "omegastar",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "service.version": {
        brief: "The version string of the service API or implementation. The format is not defined by these conventions.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "5.0.0",
        aliases: [
            "sentry.release"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "session.id": {
        brief: "A unique id identifying the active session at the time of setting this attribute",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "00112233-4455-6677-8899-aabbccddeeff",
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    412
                ],
                description: "Added session.id attribute"
            }
        ]
    },
    stall_percentage: {
        brief: "The fraction of time the app was stalled. Only applies to React Native. This is computed by Relay.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    362
                ],
                description: "Added stall_percentage attribute"
            }
        ]
    },
    stall_total_time: {
        brief: "The combined duration of all stalls in milliseconds. Only applies to React Native. This is computed by Relay.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    362
                ],
                description: "Added stall_total_time attribute"
            }
        ]
    },
    "state.type": {
        brief: "The type of state management library",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "redux",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    365
                ],
                description: "Added state.type attribute"
            }
        ]
    },
    "thread.id": {
        brief: "Current \u201Cmanaged\u201D thread ID.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 56,
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "thread.name": {
        brief: "Current thread name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "main",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "timber.tag": {
        brief: "The log tag provided by the timber logging framework.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "MyTag",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    183
                ]
            }
        ]
    },
    time_to_full_display: {
        brief: "The duration of time to full display in milliseconds",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1234.56,
        deprecation: {
            replacement: "app.vitals.ttfd.value",
            reason: "Replaced by app.vitals.ttfd.value to align with the app.vitals.* namespace for mobile performance attributes"
        },
        aliases: [
            "app.vitals.ttfd.value"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Added and deprecated in favor of app.vitals.ttfd.value"
            }
        ]
    },
    time_to_initial_display: {
        brief: "The duration of time to initial display in milliseconds",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1234.56,
        deprecation: {
            replacement: "app.vitals.ttid.value",
            reason: "Replaced by app.vitals.ttid.value to align with the app.vitals.* namespace for mobile performance attributes"
        },
        aliases: [
            "app.vitals.ttid.value"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Added and deprecated in favor of app.vitals.ttid.value"
            }
        ]
    },
    transaction: {
        brief: "The sentry transaction (segment name).",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "GET /",
        deprecation: {
            replacement: "sentry.segment.name"
        },
        aliases: [
            "sentry.segment.name",
            "sentry.transaction"
        ],
        changelog: [
            {
                version: "0.6.0",
                prs: [
                    345
                ],
                description: "Updated transaction deprecation replacement to sentry.segment.name"
            },
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "trpc.procedure_path": {
        brief: "The path of the tRPC procedure being called",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "user.getById",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    370
                ],
                description: "Added trpc.procedure_path attribute"
            }
        ]
    },
    "trpc.procedure_type": {
        brief: "The type of the tRPC procedure",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "query",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    370
                ],
                description: "Added trpc.procedure_type attribute"
            }
        ]
    },
    ttfb: {
        brief: "The value of the recorded Time To First Byte (TTFB) web vital in milliseconds",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 194,
        deprecation: {
            replacement: "browser.web_vital.ttfb.value",
            reason: "This attribute is being deprecated in favor of browser.web_vital.ttfb.value"
        },
        aliases: [
            "browser.web_vital.ttfb.value"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    235
                ]
            }
        ]
    },
    "ttfb.requestTime": {
        brief: "The time it takes for the server to process the initial request and send the first byte of a response to the user's browser",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1554.5814,
        deprecation: {
            replacement: "browser.web_vital.ttfb.request_time",
            reason: "This attribute is being deprecated in favor of browser.web_vital.ttfb.request_time"
        },
        aliases: [
            "browser.web_vital.ttfb.request_time"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    235
                ]
            }
        ]
    },
    type: {
        brief: "More granular type of the operation happening.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "fetch",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "ui.component_name": {
        brief: "The name of the associated component.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "HomeButton",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "ui.contributes_to_ttfd": {
        brief: "Whether the span execution contributed to the TTFD (time to fully drawn) metric.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "ui.contributes_to_ttid": {
        brief: "Whether the span execution contributed to the TTID (time to initial display) metric.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "ui.element.height": {
        brief: "The height of the UI element (for Html in pixels)",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 256,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    284
                ],
                description: "Added ui.element.height attribute"
            }
        ]
    },
    "ui.element.id": {
        brief: "The id of the UI element",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "btn-login",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    284
                ],
                description: "Added ui.element.id attribute"
            }
        ]
    },
    "ui.element.identifier": {
        brief: "The identifier used to measure the UI element timing",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "heroImage",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    284
                ],
                description: "Added ui.element.identifier attribute"
            }
        ]
    },
    "ui.element.load_time": {
        brief: "The loading time of a UI element (from time origin to finished loading)",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 998.2234,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    284
                ],
                description: "Added ui.element.load_time attribute"
            }
        ]
    },
    "ui.element.paint_type": {
        brief: "The type of element paint. Can either be 'image-paint' or 'text-paint'",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "image-paint",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    284
                ],
                description: "Added ui.element.paint_type attribute"
            }
        ]
    },
    "ui.element.render_time": {
        brief: "The rendering time of the UI element (from time origin to finished rendering)",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1023.1124,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    284
                ],
                description: "Added ui.element.render_time attribute"
            }
        ]
    },
    "ui.element.type": {
        brief: "type of the UI element",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "img",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    284
                ],
                description: "Added ui.element.type attribute"
            }
        ]
    },
    "ui.element.url": {
        brief: "The URL of the UI element (e.g. an img src)",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "https://assets.myapp.com/hero.png",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    284
                ],
                description: "Added ui.element.url attribute"
            }
        ]
    },
    "ui.element.width": {
        brief: "The width of the UI element (for HTML in pixels)",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 512,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    284
                ],
                description: "Added ui.element.width attribute"
            }
        ]
    },
    url: {
        brief: "The URL of the resource that was fetched.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "https://example.com/test?foo=bar#buzz",
        deprecation: {
            replacement: "url.full"
        },
        aliases: [
            "url.full",
            "http.url"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "url.domain": {
        brief: "Server domain name if available without reverse DNS lookup; otherwise, IP address or Unix domain socket name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "example.com",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "url.fragment": {
        brief: "The fragments present in the URI. Note that this does not contain the leading # character, while the `http.fragment` attribute does.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "details",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "url.full": {
        brief: "The URL of the resource that was fetched.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "https://example.com/test?foo=bar#buzz",
        aliases: [
            "http.url",
            "url"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    108
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "url.path": {
        brief: "The URI path component.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "/foo",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "url.path.parameter.<key>": {
        brief: "Decoded parameters extracted from a URL path. Usually added by client-side routing frameworks like vue-router.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "url.path.parameter.id='123'",
        aliases: [
            "params.<key>"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    103
                ]
            }
        ]
    },
    "url.port": {
        brief: "Server port number.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 1337,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "url.query": {
        brief: "The query string present in the URL. Note that this does not contain the leading ? character, while the `http.query` attribute does.",
        type: "string",
        applyScrubbing: {
            key: "auto",
            reason: "Query string values can contain sensitive information. Clients should attempt to scrub parameters that might contain sensitive information."
        },
        isInOtel: !0,
        visibility: "public",
        example: "foo=bar&bar=baz",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "url.same_origin": {
        brief: "Indicates that a URL has the same origin as the current page's origin in the browser.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        deprecation: {
            replacement: "http.request.same_origin",
            reason: "This attribute is being deprecated in favor of http.request.same_origin."
        },
        aliases: [
            "http.request.same_origin"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    456
                ],
                description: "Added url.same_origin attribute, deprecated in favor of http.request.same_origin"
            }
        ]
    },
    "url.scheme": {
        brief: "The URI scheme component identifying the used protocol.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "https",
        aliases: [
            "http.scheme"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "url.template": {
        brief: "The low-cardinality template of an absolute path reference.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "/users/:id",
        aliases: [
            "http.route"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "user_agent.original": {
        brief: "Value of the HTTP User-Agent header sent by the client.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "Mozilla/5.0 (iPhone; CPU iPhone OS 14_7_1 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/14.1.2 Mobile/15E148 Safari/604.1",
        aliases: [
            "http.user_agent"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "user.email": {
        brief: "User email address.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "test@example.com",
        aliases: [
            "sentry.user.email"
        ],
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "user.full_name": {
        brief: "User's full name.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "John Smith",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "user.geo.city": {
        brief: "Human readable city name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Toronto",
        aliases: [
            "sentry.user.geo.city"
        ],
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "user.geo.country_code": {
        brief: "Two-letter country code (ISO 3166-1 alpha-2).",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "CA",
        aliases: [
            "sentry.user.geo.country_code"
        ],
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "user.geo.region": {
        brief: "Human readable region name or code.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Canada",
        aliases: [
            "sentry.user.geo.region"
        ],
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "user.geo.subdivision": {
        brief: "Human readable subdivision name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Ontario",
        aliases: [
            "sentry.user.geo.subdivision"
        ],
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "user.hash": {
        brief: "Unique user hash to correlate information for a user in anonymized form.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "8ae4c2993e0f4f3b8b2d1b1f3b5e8f4d",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "user.id": {
        brief: "Unique identifier of the user.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "S-1-5-21-202424912787-2692429404-2351956786-1000",
        aliases: [
            "sentry.user.id"
        ],
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "user.ip_address": {
        brief: "The IP address of the user.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "192.168.1.1",
        aliases: [
            "sentry.user.ip"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    75
                ]
            }
        ]
    },
    "user.name": {
        brief: "Short name or login/username of the user.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "j.smith",
        aliases: [
            "sentry.user.username"
        ],
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "user.roles": {
        brief: "Array of user roles at the time of the event.",
        type: "string[]",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: [
            "admin",
            "editor"
        ],
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "vercel.branch": {
        brief: "Git branch name for Vercel project",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "main",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.build_id": {
        brief: "Identifier for the Vercel build (only present on build logs)",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "bld_cotnkcr76",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.deployment_id": {
        brief: "Identifier for the Vercel deployment",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "dpl_233NRGRjVZX1caZrXWtz5g1TAksD",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.destination": {
        brief: "Origin of the external content in Vercel (only on external logs)",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "https://vitals.vercel-insights.com/v1",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.edge_type": {
        brief: "Type of edge runtime in Vercel",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "edge-function",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.entrypoint": {
        brief: "Entrypoint for the request in Vercel",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "api/index.js",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.execution_region": {
        brief: "Region where the request is executed",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "sfo1",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.id": {
        brief: "Unique identifier for the log entry in Vercel",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1573817187330377061717300000",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.ja3_digest": {
        brief: "JA3 fingerprint digest of Vercel request",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "769,47-53-5-10-49161-49162-49171-49172-50-56-19-4,0-10-11,23-24-25,0",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.ja4_digest": {
        brief: "JA4 fingerprint digest",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "t13d1516h2_8daaf6152771_02713d6af862",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.log_type": {
        brief: "Vercel log output type",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "stdout",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.path": {
        brief: "Function or dynamic path of the request in Vercel.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "/dynamic/[route].json",
        changelog: [
            {
                version: "0.6.0",
                prs: [
                    349
                ],
                description: "Added vercel.path attribute"
            }
        ]
    },
    "vercel.project_id": {
        brief: "Identifier for the Vercel project",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "gdufoJxB6b9b1fEqr1jUtFkyavUU",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.project_name": {
        brief: "Name of the Vercel project",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "my-app",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.cache_id": {
        brief: "Original request ID when request is served from cache",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "pdx1::v8g4b-1744143786684-93dafbc0f70d",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.client_ip": {
        brief: "Client IP address",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "120.75.16.101",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.host": {
        brief: "Hostname of the request",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "test.vercel.app",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.lambda_region": {
        brief: "Region where lambda function executed",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "sfo1",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.method": {
        brief: "HTTP method of the request",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "GET",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.path": {
        brief: "Request path with query parameters",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "/dynamic/some-value.json?route=some-value",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.path_type": {
        brief: "How the request was served based on its path and project configuration",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "func",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.path_type_variant": {
        brief: "Variant of the path type",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "api",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.referer": {
        brief: "Referer of the request",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "*.vercel.app",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.region": {
        brief: "Region where the request is processed",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "sfo1",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.response_byte_size": {
        brief: "Size of the response in bytes",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1024,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.scheme": {
        brief: "Protocol of the request",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "https",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.status_code": {
        brief: "HTTP status code of the proxy request",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 200,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.timestamp": {
        brief: "Unix timestamp when the proxy request was made",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1573817250172,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.user_agent": {
        brief: "User agent strings of the request",
        type: "string[]",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: [
            "Mozilla/5.0..."
        ],
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.vercel_cache": {
        brief: "Cache status sent to the browser",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "REVALIDATED",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.vercel_id": {
        brief: "Vercel-specific identifier",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "sfo1::abc123",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.waf_action": {
        brief: "Action taken by firewall rules",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "deny",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.waf_rule_id": {
        brief: "ID of the firewall rule that matched",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "rule_gAHz8jtSB1Gy",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.request_id": {
        brief: "Identifier of the Vercel request",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "643af4e3-975a-4cc7-9e7a-1eda11539d90",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.source": {
        brief: "Origin of the Vercel log (build, edge, lambda, static, external, or firewall)",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "build",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.status_code": {
        brief: "HTTP status code of the request (-1 means no response returned and the lambda crashed)",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 200,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    }
};
$49d40eaf9ca0cfa4$export$b60c5e9f9b7b58bd = $49d40eaf9ca0cfa4$var$AI_CITATIONS, $49d40eaf9ca0cfa4$export$cc06afd6de7f2c10 = $49d40eaf9ca0cfa4$var$AI_COMPLETION_TOKENS_USED, $49d40eaf9ca0cfa4$export$ced6746028fe2cc = $49d40eaf9ca0cfa4$var$AI_DOCUMENTS, $49d40eaf9ca0cfa4$export$e6f4aa4f4fcb6da8 = $49d40eaf9ca0cfa4$var$AI_FINISH_REASON, $49d40eaf9ca0cfa4$export$f02d892201cd8d36 = $49d40eaf9ca0cfa4$var$AI_FREQUENCY_PENALTY, $49d40eaf9ca0cfa4$export$f277a7ef9e273960 = $49d40eaf9ca0cfa4$var$AI_FUNCTION_CALL, $49d40eaf9ca0cfa4$export$1a8c212c3becaa80 = $49d40eaf9ca0cfa4$var$AI_GENERATION_ID, $49d40eaf9ca0cfa4$export$721b137086c68a47 = $49d40eaf9ca0cfa4$var$AI_INPUT_MESSAGES, $49d40eaf9ca0cfa4$export$6afde2bb69d9aa86 = $49d40eaf9ca0cfa4$var$AI_IS_SEARCH_REQUIRED, $49d40eaf9ca0cfa4$export$eadb4b562c974031 = $49d40eaf9ca0cfa4$var$AI_METADATA, $49d40eaf9ca0cfa4$export$22a90f0ac1eee843 = $49d40eaf9ca0cfa4$var$AI_MODEL_ID, $49d40eaf9ca0cfa4$export$a727f215a0be1dad = $49d40eaf9ca0cfa4$var$AI_MODEL_PROVIDER, $49d40eaf9ca0cfa4$export$536bc61b34d995e5 = $49d40eaf9ca0cfa4$var$AI_PIPELINE_NAME, $49d40eaf9ca0cfa4$export$c43ea6115b380e62 = $49d40eaf9ca0cfa4$var$AI_PREAMBLE, $49d40eaf9ca0cfa4$export$d2a16e26bada7cf1 = $49d40eaf9ca0cfa4$var$AI_PRESENCE_PENALTY, $49d40eaf9ca0cfa4$export$604eb1bd2278163b = $49d40eaf9ca0cfa4$var$AI_PROMPT_TOKENS_USED, $49d40eaf9ca0cfa4$export$2f8568696c5aa352 = $49d40eaf9ca0cfa4$var$AI_RAW_PROMPTING, $49d40eaf9ca0cfa4$export$ccc8efd7dd31d3a9 = $49d40eaf9ca0cfa4$var$AI_RESPONSES, $49d40eaf9ca0cfa4$export$e176bf5dc45e40df = $49d40eaf9ca0cfa4$var$AI_RESPONSE_FORMAT, $49d40eaf9ca0cfa4$export$c4ea01fd53f64e16 = $49d40eaf9ca0cfa4$var$AI_SEARCH_QUERIES, $49d40eaf9ca0cfa4$export$bb5e6f2f31a15da9 = $49d40eaf9ca0cfa4$var$AI_SEARCH_RESULTS, $49d40eaf9ca0cfa4$export$1762c11b666b026a = $49d40eaf9ca0cfa4$var$AI_SEED, $49d40eaf9ca0cfa4$export$14ddd4b729910100 = $49d40eaf9ca0cfa4$var$AI_STREAMING, $49d40eaf9ca0cfa4$export$5311d7c8e1f8eabb = $49d40eaf9ca0cfa4$var$AI_TAGS, $49d40eaf9ca0cfa4$export$2b748b9eca00828b = $49d40eaf9ca0cfa4$var$AI_TEMPERATURE, $49d40eaf9ca0cfa4$export$5af25308c11addea = $49d40eaf9ca0cfa4$var$AI_TEXTS, $49d40eaf9ca0cfa4$export$28f78b3b1663cb92 = $49d40eaf9ca0cfa4$var$AI_TOOLS, $49d40eaf9ca0cfa4$export$a1d3f09f0f1f066f = $49d40eaf9ca0cfa4$var$AI_TOOL_CALLS, $49d40eaf9ca0cfa4$export$322bd4ea9f163663 = $49d40eaf9ca0cfa4$var$AI_TOP_K, $49d40eaf9ca0cfa4$export$95711b9e669edad8 = $49d40eaf9ca0cfa4$var$AI_TOP_P, $49d40eaf9ca0cfa4$export$5924d7d72384626a = $49d40eaf9ca0cfa4$var$AI_TOTAL_COST, $49d40eaf9ca0cfa4$export$db3b1b877a4ce4db = $49d40eaf9ca0cfa4$var$AI_TOTAL_TOKENS_USED, $49d40eaf9ca0cfa4$export$a434a3e8afec2879 = $49d40eaf9ca0cfa4$var$AI_WARNINGS, $49d40eaf9ca0cfa4$export$fe00bb20636d42af = $49d40eaf9ca0cfa4$var$ANGULAR_VERSION, $49d40eaf9ca0cfa4$export$712aa698b7ee271e = $49d40eaf9ca0cfa4$var$APP_APP_BUILD, $49d40eaf9ca0cfa4$export$1fac638b11ec16d9 = $49d40eaf9ca0cfa4$var$APP_APP_IDENTIFIER, $49d40eaf9ca0cfa4$export$d132016ea64058e3 = $49d40eaf9ca0cfa4$var$APP_APP_NAME, $49d40eaf9ca0cfa4$export$53f2f47ec3b2f9ed = $49d40eaf9ca0cfa4$var$APP_APP_START_TIME, $49d40eaf9ca0cfa4$export$9f80c4b11053cef1 = $49d40eaf9ca0cfa4$var$APP_APP_VERSION, $49d40eaf9ca0cfa4$export$5f7a08466d84e877 = $49d40eaf9ca0cfa4$var$APP_BUILD, $49d40eaf9ca0cfa4$export$2cea7f14750b8c19 = $49d40eaf9ca0cfa4$var$APP_IDENTIFIER, $49d40eaf9ca0cfa4$export$34c59270f032a6c6 = $49d40eaf9ca0cfa4$var$APP_IN_FOREGROUND, $49d40eaf9ca0cfa4$export$5b6c28c7dca07ad7 = $49d40eaf9ca0cfa4$var$APP_NAME, $49d40eaf9ca0cfa4$export$1dc8ae58b58d6c50 = $49d40eaf9ca0cfa4$var$APP_START_COLD, $49d40eaf9ca0cfa4$export$ba267414e3c0d822 = $49d40eaf9ca0cfa4$var$APP_START_TIME, $49d40eaf9ca0cfa4$export$71b176005902b99e = $49d40eaf9ca0cfa4$var$APP_START_TYPE, $49d40eaf9ca0cfa4$export$5c5b5a3c245a0079 = $49d40eaf9ca0cfa4$var$APP_START_WARM, $49d40eaf9ca0cfa4$export$8ee1df3c6367a60 = $49d40eaf9ca0cfa4$var$APP_VERSION, $49d40eaf9ca0cfa4$export$e8c7802ae95beccf = $49d40eaf9ca0cfa4$var$APP_VITALS_FRAMES_DELAY_VALUE, $49d40eaf9ca0cfa4$export$bb237734da4d464 = $49d40eaf9ca0cfa4$var$APP_VITALS_FRAMES_FROZEN_COUNT, $49d40eaf9ca0cfa4$export$cdaaf6d1fdcba0b6 = $49d40eaf9ca0cfa4$var$APP_VITALS_FRAMES_SLOW_COUNT, $49d40eaf9ca0cfa4$export$36223ebd4a30e9f5 = $49d40eaf9ca0cfa4$var$APP_VITALS_FRAMES_TOTAL_COUNT, $49d40eaf9ca0cfa4$export$8feaa177bb7941e2 = $49d40eaf9ca0cfa4$var$APP_VITALS_START_COLD_VALUE, $49d40eaf9ca0cfa4$export$e1ca25240db91d68 = $49d40eaf9ca0cfa4$var$APP_VITALS_START_PREWARMED, $49d40eaf9ca0cfa4$export$404a223fd1ada08b = $49d40eaf9ca0cfa4$var$APP_VITALS_START_REASON, $49d40eaf9ca0cfa4$export$53362079310c68 = $49d40eaf9ca0cfa4$var$APP_VITALS_START_SCREEN, $49d40eaf9ca0cfa4$export$3efb5af0ac379f77 = $49d40eaf9ca0cfa4$var$APP_VITALS_START_TYPE, $49d40eaf9ca0cfa4$export$2c10c1ca0612c46d = $49d40eaf9ca0cfa4$var$APP_VITALS_START_WARM_VALUE, $49d40eaf9ca0cfa4$export$bbb86ad4d6654da6 = $49d40eaf9ca0cfa4$var$APP_VITALS_TTFD_VALUE, $49d40eaf9ca0cfa4$export$ad6896f00a2b1076 = $49d40eaf9ca0cfa4$var$APP_VITALS_TTID_VALUE, $49d40eaf9ca0cfa4$export$300f39d8506a273d = $49d40eaf9ca0cfa4$var$ART_GC_BLOCKING_COUNT, $49d40eaf9ca0cfa4$export$ecaa0e7f4773ddc7 = $49d40eaf9ca0cfa4$var$ART_GC_BLOCKING_TIME, $49d40eaf9ca0cfa4$export$74b78acb4c54c06b = $49d40eaf9ca0cfa4$var$ART_GC_PRE_OOME_COUNT, $49d40eaf9ca0cfa4$export$b15b2c133bc50e33 = $49d40eaf9ca0cfa4$var$ART_GC_TOTAL_COUNT, $49d40eaf9ca0cfa4$export$5f1381d9ae1b1c95 = $49d40eaf9ca0cfa4$var$ART_GC_TOTAL_TIME, $49d40eaf9ca0cfa4$export$c170b7ff277132ea = $49d40eaf9ca0cfa4$var$ART_GC_WAITING_TIME, $49d40eaf9ca0cfa4$export$9459a5df93695e45 = $49d40eaf9ca0cfa4$var$ART_MEMORY_FREE, $49d40eaf9ca0cfa4$export$a7902bd57492ebe8 = $49d40eaf9ca0cfa4$var$ART_MEMORY_FREE_UNTIL_GC, $49d40eaf9ca0cfa4$export$d2ace0da59da09b7 = $49d40eaf9ca0cfa4$var$ART_MEMORY_FREE_UNTIL_OOME, $49d40eaf9ca0cfa4$export$c15dd8d2461e0aeb = $49d40eaf9ca0cfa4$var$ART_MEMORY_MAX, $49d40eaf9ca0cfa4$export$5405b0a98e00e538 = $49d40eaf9ca0cfa4$var$ART_MEMORY_TOTAL, $49d40eaf9ca0cfa4$export$bd393bbb84b309d3 = $49d40eaf9ca0cfa4$var$ATTRIBUTE_METADATA, $49d40eaf9ca0cfa4$export$96f586f8837b86ae = $49d40eaf9ca0cfa4$var$ATTRIBUTE_TYPE, $49d40eaf9ca0cfa4$export$5d9f28f388f552d2 = $49d40eaf9ca0cfa4$var$AWS_CLOUDWATCH_LOGS_LOG_GROUP, $49d40eaf9ca0cfa4$export$b3d2f68e0e769504 = $49d40eaf9ca0cfa4$var$AWS_CLOUDWATCH_LOGS_LOG_STREAM, $49d40eaf9ca0cfa4$export$2c98412ed43013e8 = $49d40eaf9ca0cfa4$var$AWS_CLOUDWATCH_LOGS_URL, $49d40eaf9ca0cfa4$export$a7bd794d11c19f1b = $49d40eaf9ca0cfa4$var$AWS_DYNAMODB_ATTRIBUTE_DEFINITIONS, $49d40eaf9ca0cfa4$export$df4227832b83fdd0 = $49d40eaf9ca0cfa4$var$AWS_DYNAMODB_CONSISTENT_READ, $49d40eaf9ca0cfa4$export$f131a6d8fbc0534f = $49d40eaf9ca0cfa4$var$AWS_DYNAMODB_CONSUMED_CAPACITY, $49d40eaf9ca0cfa4$export$9bdc66d4a70e7e3a = $49d40eaf9ca0cfa4$var$AWS_DYNAMODB_COUNT, $49d40eaf9ca0cfa4$export$bfbbc3cbcaa90e98 = $49d40eaf9ca0cfa4$var$AWS_DYNAMODB_EXCLUSIVE_START_TABLE, $49d40eaf9ca0cfa4$export$3565fa72459aa4d6 = $49d40eaf9ca0cfa4$var$AWS_DYNAMODB_GLOBAL_SECONDARY_INDEXES, $49d40eaf9ca0cfa4$export$bb67a834ae4bffdc = $49d40eaf9ca0cfa4$var$AWS_DYNAMODB_GLOBAL_SECONDARY_INDEX_UPDATES, $49d40eaf9ca0cfa4$export$4a06c859a283f06 = $49d40eaf9ca0cfa4$var$AWS_DYNAMODB_INDEX_NAME, $49d40eaf9ca0cfa4$export$68324fac2038d0f2 = $49d40eaf9ca0cfa4$var$AWS_DYNAMODB_ITEM_COLLECTION_METRICS, $49d40eaf9ca0cfa4$export$5e1bd62ffd2786fb = $49d40eaf9ca0cfa4$var$AWS_DYNAMODB_LIMIT, $49d40eaf9ca0cfa4$export$bfdf2261058f56b = $49d40eaf9ca0cfa4$var$AWS_DYNAMODB_LOCAL_SECONDARY_INDEXES, $49d40eaf9ca0cfa4$export$23bf57842d9d53df = $49d40eaf9ca0cfa4$var$AWS_DYNAMODB_PROJECTION, $49d40eaf9ca0cfa4$export$bfbd7e060eeb4d35 = $49d40eaf9ca0cfa4$var$AWS_DYNAMODB_PROVISIONED_READ_CAPACITY, $49d40eaf9ca0cfa4$export$82eb6cccda27c3ff = $49d40eaf9ca0cfa4$var$AWS_DYNAMODB_PROVISIONED_WRITE_CAPACITY, $49d40eaf9ca0cfa4$export$8ea68734d455808f = $49d40eaf9ca0cfa4$var$AWS_DYNAMODB_SCANNED_COUNT, $49d40eaf9ca0cfa4$export$40050e29324d44ee = $49d40eaf9ca0cfa4$var$AWS_DYNAMODB_SCAN_FORWARD, $49d40eaf9ca0cfa4$export$5cd7541006d9f467 = $49d40eaf9ca0cfa4$var$AWS_DYNAMODB_SEGMENT, $49d40eaf9ca0cfa4$export$81c017edd95d692e = $49d40eaf9ca0cfa4$var$AWS_DYNAMODB_SELECT, $49d40eaf9ca0cfa4$export$120b3897a58cf903 = $49d40eaf9ca0cfa4$var$AWS_DYNAMODB_TABLE_COUNT, $49d40eaf9ca0cfa4$export$d4a9de43b4b1076c = $49d40eaf9ca0cfa4$var$AWS_DYNAMODB_TABLE_NAMES, $49d40eaf9ca0cfa4$export$f37f4f9022f1ab17 = $49d40eaf9ca0cfa4$var$AWS_DYNAMODB_TOTAL_SEGMENTS, $49d40eaf9ca0cfa4$export$66ac18da14747cfb = $49d40eaf9ca0cfa4$var$AWS_EXTENDED_REQUEST_ID, $49d40eaf9ca0cfa4$export$9e49b833525ca49d = $49d40eaf9ca0cfa4$var$AWS_KINESIS_STREAM_NAME, $49d40eaf9ca0cfa4$export$b084fea5b3097227 = $49d40eaf9ca0cfa4$var$AWS_LAMBDA_AWS_REQUEST_ID, $49d40eaf9ca0cfa4$export$e09cd8615652e8d0 = $49d40eaf9ca0cfa4$var$AWS_LAMBDA_EXECUTION_DURATION_IN_MILLIS, $49d40eaf9ca0cfa4$export$a43a60ec723a90ee = $49d40eaf9ca0cfa4$var$AWS_LAMBDA_FUNCTION_NAME, $49d40eaf9ca0cfa4$export$34cc955357266287 = $49d40eaf9ca0cfa4$var$AWS_LAMBDA_FUNCTION_VERSION, $49d40eaf9ca0cfa4$export$d9dd218693ea9bba = $49d40eaf9ca0cfa4$var$AWS_LAMBDA_INVOKED_ARN, $49d40eaf9ca0cfa4$export$c9649b7156282a2f = $49d40eaf9ca0cfa4$var$AWS_LAMBDA_INVOKED_FUNCTION_ARN, $49d40eaf9ca0cfa4$export$daa8ce1f8adc553e = $49d40eaf9ca0cfa4$var$AWS_LAMBDA_REMAINING_TIME_IN_MILLIS, $49d40eaf9ca0cfa4$export$cb93c7b05db202cf = $49d40eaf9ca0cfa4$var$AWS_LOG_GROUP_NAMES, $49d40eaf9ca0cfa4$export$930f9bd3cc2e5b3d = $49d40eaf9ca0cfa4$var$AWS_LOG_STREAM_NAMES, $49d40eaf9ca0cfa4$export$48c6d4c44afdc0b = $49d40eaf9ca0cfa4$var$AWS_REQUEST_EXTENDED_ID, $49d40eaf9ca0cfa4$export$c78d41789fe4b1e4 = $49d40eaf9ca0cfa4$var$AWS_REQUEST_ID, $49d40eaf9ca0cfa4$export$f462d9921f1f7332 = $49d40eaf9ca0cfa4$var$AWS_S3_BUCKET, $49d40eaf9ca0cfa4$export$bc71f8df9a45e243 = $49d40eaf9ca0cfa4$var$AWS_SECRETSMANAGER_SECRET_ARN, $49d40eaf9ca0cfa4$export$ed840ec4a5f5d053 = $49d40eaf9ca0cfa4$var$AWS_SNS_TOPIC_ARN, $49d40eaf9ca0cfa4$export$c1a559a4f74a5e8e = $49d40eaf9ca0cfa4$var$AWS_STEP_FUNCTIONS_ACTIVITY_ARN, $49d40eaf9ca0cfa4$export$d1c007424092e3f5 = $49d40eaf9ca0cfa4$var$AWS_STEP_FUNCTIONS_STATE_MACHINE_ARN, $49d40eaf9ca0cfa4$export$9ebb466ce954c49c = $49d40eaf9ca0cfa4$var$BLOCKED_MAIN_THREAD, $49d40eaf9ca0cfa4$export$e9aafc7348984403 = $49d40eaf9ca0cfa4$var$BROWSER_NAME, $49d40eaf9ca0cfa4$export$faaa46964f075237 = $49d40eaf9ca0cfa4$var$BROWSER_PERFORMANCE_NAVIGATION_ACTIVATION_START, $49d40eaf9ca0cfa4$export$d28c4b3cc4431a87 = $49d40eaf9ca0cfa4$var$BROWSER_PERFORMANCE_TIME_ORIGIN, $49d40eaf9ca0cfa4$export$734b017b330c8fe6 = $49d40eaf9ca0cfa4$var$BROWSER_REPORT_TYPE, $49d40eaf9ca0cfa4$export$683ebdc48ba3758d = $49d40eaf9ca0cfa4$var$BROWSER_SCRIPT_INVOKER, $49d40eaf9ca0cfa4$export$be0263971250ef44 = $49d40eaf9ca0cfa4$var$BROWSER_SCRIPT_INVOKER_TYPE, $49d40eaf9ca0cfa4$export$36a0cbc35c405232 = $49d40eaf9ca0cfa4$var$BROWSER_SCRIPT_SOURCE_CHAR_POSITION, $49d40eaf9ca0cfa4$export$469f7765ba335497 = $49d40eaf9ca0cfa4$var$BROWSER_VERSION, $49d40eaf9ca0cfa4$export$fe6fe2b7af051610 = $49d40eaf9ca0cfa4$var$BROWSER_WEB_VITAL_CLS_REPORT_EVENT, $49d40eaf9ca0cfa4$export$8345821877c4dfad = $49d40eaf9ca0cfa4$var$BROWSER_WEB_VITAL_CLS_SOURCE_KEY, $49d40eaf9ca0cfa4$export$f6c188a7e02335cf = $49d40eaf9ca0cfa4$var$BROWSER_WEB_VITAL_CLS_SOURCE_KEY_BASE, $49d40eaf9ca0cfa4$export$aaf709a8971e825f = $49d40eaf9ca0cfa4$var$BROWSER_WEB_VITAL_CLS_VALUE, $49d40eaf9ca0cfa4$export$def01b82f8c092f7 = $49d40eaf9ca0cfa4$var$BROWSER_WEB_VITAL_FCP_VALUE, $49d40eaf9ca0cfa4$export$23d4264c606a73a6 = $49d40eaf9ca0cfa4$var$BROWSER_WEB_VITAL_FP_VALUE, $49d40eaf9ca0cfa4$export$af9ece53bb92f66b = $49d40eaf9ca0cfa4$var$BROWSER_WEB_VITAL_INP_VALUE, $49d40eaf9ca0cfa4$export$25421625a565b69 = $49d40eaf9ca0cfa4$var$BROWSER_WEB_VITAL_LCP_ELEMENT, $49d40eaf9ca0cfa4$export$ab0c90d873e69ccb = $49d40eaf9ca0cfa4$var$BROWSER_WEB_VITAL_LCP_ID, $49d40eaf9ca0cfa4$export$538c05cc8cb2a2bb = $49d40eaf9ca0cfa4$var$BROWSER_WEB_VITAL_LCP_LOAD_TIME, $49d40eaf9ca0cfa4$export$f86df4de196e1a7c = $49d40eaf9ca0cfa4$var$BROWSER_WEB_VITAL_LCP_RENDER_TIME, $49d40eaf9ca0cfa4$export$51e8aa8c0d65e7b8 = $49d40eaf9ca0cfa4$var$BROWSER_WEB_VITAL_LCP_REPORT_EVENT, $49d40eaf9ca0cfa4$export$99023486ecc470bd = $49d40eaf9ca0cfa4$var$BROWSER_WEB_VITAL_LCP_SIZE, $49d40eaf9ca0cfa4$export$2f6c85eaf382e81 = $49d40eaf9ca0cfa4$var$BROWSER_WEB_VITAL_LCP_URL, $49d40eaf9ca0cfa4$export$1158d57c0aed42be = $49d40eaf9ca0cfa4$var$BROWSER_WEB_VITAL_LCP_VALUE, $49d40eaf9ca0cfa4$export$d85c4f947ab776e3 = $49d40eaf9ca0cfa4$var$BROWSER_WEB_VITAL_TTFB_REQUEST_TIME, $49d40eaf9ca0cfa4$export$813ef8386d874918 = $49d40eaf9ca0cfa4$var$BROWSER_WEB_VITAL_TTFB_VALUE, $49d40eaf9ca0cfa4$export$7c2f74ff9251f64 = $49d40eaf9ca0cfa4$var$CACHE_HIT, $49d40eaf9ca0cfa4$export$993f84dab107b880 = $49d40eaf9ca0cfa4$var$CACHE_ITEM_SIZE, $49d40eaf9ca0cfa4$export$7b9c2315e94d8d2f = $49d40eaf9ca0cfa4$var$CACHE_KEY, $49d40eaf9ca0cfa4$export$f01e5cd42b9ec146 = $49d40eaf9ca0cfa4$var$CACHE_OPERATION, $49d40eaf9ca0cfa4$export$987f6b4367434b55 = $49d40eaf9ca0cfa4$var$CACHE_TTL, $49d40eaf9ca0cfa4$export$d9d145585d5022bb = $49d40eaf9ca0cfa4$var$CACHE_WRITE, $49d40eaf9ca0cfa4$export$44ffba16bd48dac6 = $49d40eaf9ca0cfa4$var$CHANNEL, $49d40eaf9ca0cfa4$export$3134892c5d2e251a = $49d40eaf9ca0cfa4$var$CLIENT_ADDRESS, $49d40eaf9ca0cfa4$export$8495028d10296058 = $49d40eaf9ca0cfa4$var$CLIENT_PORT, $49d40eaf9ca0cfa4$export$d6d0e4fcf46d490c = $49d40eaf9ca0cfa4$var$CLOUDFLARE_D1_DURATION, $49d40eaf9ca0cfa4$export$658dced473c19301 = $49d40eaf9ca0cfa4$var$CLOUDFLARE_D1_QUERY_TYPE, $49d40eaf9ca0cfa4$export$97b0f9c3fbe64076 = $49d40eaf9ca0cfa4$var$CLOUDFLARE_D1_ROWS_READ, $49d40eaf9ca0cfa4$export$cf2c95ed5efbe9eb = $49d40eaf9ca0cfa4$var$CLOUDFLARE_D1_ROWS_WRITTEN, $49d40eaf9ca0cfa4$export$880007904f61a388 = $49d40eaf9ca0cfa4$var$CLOUDFLARE_DURABLE_OBJECT_QUERY_BINDINGS, $49d40eaf9ca0cfa4$export$3e903b72d4d9e07d = $49d40eaf9ca0cfa4$var$CLOUDFLARE_DURABLE_OBJECT_RESPONSE_ROWS_READ, $49d40eaf9ca0cfa4$export$34da07180e0e56af = $49d40eaf9ca0cfa4$var$CLOUDFLARE_DURABLE_OBJECT_RESPONSE_ROWS_WRITTEN, $49d40eaf9ca0cfa4$export$c49aafdaeb061953 = $49d40eaf9ca0cfa4$var$CLOUDFLARE_R2_BUCKET, $49d40eaf9ca0cfa4$export$ceb762c61de2f17f = $49d40eaf9ca0cfa4$var$CLOUDFLARE_R2_OPERATION, $49d40eaf9ca0cfa4$export$a5f54ccfb28c0caf = $49d40eaf9ca0cfa4$var$CLOUDFLARE_R2_REQUEST_DELIMITER, $49d40eaf9ca0cfa4$export$1c86a56857b024db = $49d40eaf9ca0cfa4$var$CLOUDFLARE_R2_REQUEST_KEY, $49d40eaf9ca0cfa4$export$7598f3464be47440 = $49d40eaf9ca0cfa4$var$CLOUDFLARE_R2_REQUEST_PART_NUMBER, $49d40eaf9ca0cfa4$export$b673289c971fc0ae = $49d40eaf9ca0cfa4$var$CLOUDFLARE_R2_REQUEST_PREFIX, $49d40eaf9ca0cfa4$export$98b23f3e6f0c2a6f = $49d40eaf9ca0cfa4$var$CLOUDFLARE_WORKFLOW_ATTEMPT, $49d40eaf9ca0cfa4$export$6ddeaf0498614ebb = $49d40eaf9ca0cfa4$var$CLOUDFLARE_WORKFLOW_RETRIES_BACKOFF, $49d40eaf9ca0cfa4$export$97b78f78d64a7232 = $49d40eaf9ca0cfa4$var$CLOUDFLARE_WORKFLOW_RETRIES_DELAY, $49d40eaf9ca0cfa4$export$5147715be870fff7 = $49d40eaf9ca0cfa4$var$CLOUDFLARE_WORKFLOW_RETRIES_LIMIT, $49d40eaf9ca0cfa4$export$5276bb46e6096fba = $49d40eaf9ca0cfa4$var$CLOUDFLARE_WORKFLOW_TIMEOUT, $49d40eaf9ca0cfa4$export$cbcbc1f67a937cf3 = $49d40eaf9ca0cfa4$var$CLOUD_ACCOUNT_ID, $49d40eaf9ca0cfa4$export$226a2381b8f0cf78 = $49d40eaf9ca0cfa4$var$CLOUD_AVAILABILITY_ZONE, $49d40eaf9ca0cfa4$export$fd35512cae286064 = $49d40eaf9ca0cfa4$var$CLOUD_PLATFORM, $49d40eaf9ca0cfa4$export$de9bbf95ab1d81e = $49d40eaf9ca0cfa4$var$CLOUD_PROVIDER, $49d40eaf9ca0cfa4$export$47fb20e8d18d7d15 = $49d40eaf9ca0cfa4$var$CLOUD_REGION, $49d40eaf9ca0cfa4$export$9db7964e4b8cb849 = $49d40eaf9ca0cfa4$var$CLOUD_RESOURCE_ID, $49d40eaf9ca0cfa4$export$7139adf9d3bace41 = "cls", $49d40eaf9ca0cfa4$export$8ac3d09060e7f25d = $49d40eaf9ca0cfa4$var$CLS_SOURCE_KEY, $49d40eaf9ca0cfa4$export$dad0e4778ea23971 = $49d40eaf9ca0cfa4$var$CLS_SOURCE_KEY_BASE, $49d40eaf9ca0cfa4$export$c14d903ccf9385a8 = $49d40eaf9ca0cfa4$var$CODE_FILEPATH, $49d40eaf9ca0cfa4$export$934cded0041affd7 = $49d40eaf9ca0cfa4$var$CODE_FILE_PATH, $49d40eaf9ca0cfa4$export$6386da1dcba88c9d = $49d40eaf9ca0cfa4$var$CODE_FUNCTION, $49d40eaf9ca0cfa4$export$a3371797e606e2 = $49d40eaf9ca0cfa4$var$CODE_FUNCTION_NAME, $49d40eaf9ca0cfa4$export$a5bbef0af83b23e5 = $49d40eaf9ca0cfa4$var$CODE_LINENO, $49d40eaf9ca0cfa4$export$91ed1f55874222a6 = $49d40eaf9ca0cfa4$var$CODE_LINE_NUMBER, $49d40eaf9ca0cfa4$export$23de81068d2aed1b = $49d40eaf9ca0cfa4$var$CODE_NAMESPACE, $49d40eaf9ca0cfa4$export$d738320e1fba9e9d = $49d40eaf9ca0cfa4$var$CONNECTIONTYPE, $49d40eaf9ca0cfa4$export$2eacdea75497e8a5 = $49d40eaf9ca0cfa4$var$CONNECTION_RTT, $49d40eaf9ca0cfa4$export$2bc3ea101f86c1d2 = $49d40eaf9ca0cfa4$var$CULTURE_CALENDAR, $49d40eaf9ca0cfa4$export$c54e27e8d90ee081 = $49d40eaf9ca0cfa4$var$CULTURE_DISPLAY_NAME, $49d40eaf9ca0cfa4$export$4943adcec371c2a6 = $49d40eaf9ca0cfa4$var$CULTURE_IS_24_HOUR_FORMAT, $49d40eaf9ca0cfa4$export$f000a5900d0480c2 = $49d40eaf9ca0cfa4$var$CULTURE_LOCALE, $49d40eaf9ca0cfa4$export$8f5234893868273b = $49d40eaf9ca0cfa4$var$CULTURE_TIMEZONE, $49d40eaf9ca0cfa4$export$1a35518f6e81e8c7 = $49d40eaf9ca0cfa4$var$DB_COLLECTION_NAME, $49d40eaf9ca0cfa4$export$a2d90911eaae60fc = $49d40eaf9ca0cfa4$var$DB_DRIVER_NAME, $49d40eaf9ca0cfa4$export$3c22ff8b64b8f565 = $49d40eaf9ca0cfa4$var$DB_NAME, $49d40eaf9ca0cfa4$export$b8019c0e2a5b5f0f = $49d40eaf9ca0cfa4$var$DB_NAMESPACE, $49d40eaf9ca0cfa4$export$8c11477e471467c8 = $49d40eaf9ca0cfa4$var$DB_OPERATION, $49d40eaf9ca0cfa4$export$92a96f6363488aee = $49d40eaf9ca0cfa4$var$DB_OPERATION_BATCH_SIZE, $49d40eaf9ca0cfa4$export$f91beb6088f9ded9 = $49d40eaf9ca0cfa4$var$DB_OPERATION_NAME, $49d40eaf9ca0cfa4$export$78bc7224576bf289 = $49d40eaf9ca0cfa4$var$DB_QUERY_PARAMETER_KEY, $49d40eaf9ca0cfa4$export$a8027e0ea0d93ca = $49d40eaf9ca0cfa4$var$DB_QUERY_PARAMETER_KEY_BASE, $49d40eaf9ca0cfa4$export$5e59d3aea52e5037 = $49d40eaf9ca0cfa4$var$DB_QUERY_SUMMARY, $49d40eaf9ca0cfa4$export$47e408be0da7933f = $49d40eaf9ca0cfa4$var$DB_QUERY_TEXT, $49d40eaf9ca0cfa4$export$d5772b934ca13e57 = $49d40eaf9ca0cfa4$var$DB_REDIS_CONNECTION, $49d40eaf9ca0cfa4$export$36e47f6a5777561d = $49d40eaf9ca0cfa4$var$DB_REDIS_KEY, $49d40eaf9ca0cfa4$export$e768cbc99cd68acf = $49d40eaf9ca0cfa4$var$DB_REDIS_PARAMETERS, $49d40eaf9ca0cfa4$export$dfcc6c69df1343f2 = $49d40eaf9ca0cfa4$var$DB_RESPONSE_STATUS_CODE, $49d40eaf9ca0cfa4$export$69b0a5d9226b5211 = $49d40eaf9ca0cfa4$var$DB_SQL_BINDINGS, $49d40eaf9ca0cfa4$export$da010a4f4fc971ae = $49d40eaf9ca0cfa4$var$DB_STATEMENT, $49d40eaf9ca0cfa4$export$5d515b35be0601a0 = $49d40eaf9ca0cfa4$var$DB_STORED_PROCEDURE_NAME, $49d40eaf9ca0cfa4$export$3e1b1037a315c5ca = $49d40eaf9ca0cfa4$var$DB_SYSTEM, $49d40eaf9ca0cfa4$export$847fdd494825f0fb = $49d40eaf9ca0cfa4$var$DB_SYSTEM_NAME, $49d40eaf9ca0cfa4$export$a9d76f26c6c730a9 = $49d40eaf9ca0cfa4$var$DB_USER, $49d40eaf9ca0cfa4$export$de03f86d1c9866ca = $49d40eaf9ca0cfa4$var$DEVICEMEMORY, $49d40eaf9ca0cfa4$export$65798ecab7eef8c = $49d40eaf9ca0cfa4$var$DEVICE_ARCHS, $49d40eaf9ca0cfa4$export$22aa61f48b9c79a0 = $49d40eaf9ca0cfa4$var$DEVICE_BATTERY_LEVEL, $49d40eaf9ca0cfa4$export$69f5fb98f5aed812 = $49d40eaf9ca0cfa4$var$DEVICE_BATTERY_TEMPERATURE, $49d40eaf9ca0cfa4$export$bdea5d1006fd280a = $49d40eaf9ca0cfa4$var$DEVICE_BOOT_TIME, $49d40eaf9ca0cfa4$export$f63a7230c5b1d609 = $49d40eaf9ca0cfa4$var$DEVICE_BRAND, $49d40eaf9ca0cfa4$export$6f25e59b05bb8e17 = $49d40eaf9ca0cfa4$var$DEVICE_CHARGING, $49d40eaf9ca0cfa4$export$a56ad13c4afc7421 = $49d40eaf9ca0cfa4$var$DEVICE_CHIPSET, $49d40eaf9ca0cfa4$export$d9ce89ce8912bf12 = $49d40eaf9ca0cfa4$var$DEVICE_CLASS, $49d40eaf9ca0cfa4$export$17094e5f380e4162 = $49d40eaf9ca0cfa4$var$DEVICE_CONNECTION_TYPE, $49d40eaf9ca0cfa4$export$28a0ffdf747973a0 = $49d40eaf9ca0cfa4$var$DEVICE_CPU_DESCRIPTION, $49d40eaf9ca0cfa4$export$5480ae1ba5d50bb9 = $49d40eaf9ca0cfa4$var$DEVICE_EXTERNAL_FREE_STORAGE, $49d40eaf9ca0cfa4$export$edc72ee4a17f5152 = $49d40eaf9ca0cfa4$var$DEVICE_EXTERNAL_STORAGE_SIZE, $49d40eaf9ca0cfa4$export$19e4df138d354f8b = $49d40eaf9ca0cfa4$var$DEVICE_FAMILY, $49d40eaf9ca0cfa4$export$92b0d20fa482b4b2 = $49d40eaf9ca0cfa4$var$DEVICE_FREE_MEMORY, $49d40eaf9ca0cfa4$export$3f638a793d61933f = $49d40eaf9ca0cfa4$var$DEVICE_FREE_STORAGE, $49d40eaf9ca0cfa4$export$3f511731cc3687d4 = $49d40eaf9ca0cfa4$var$DEVICE_ID, $49d40eaf9ca0cfa4$export$692b08741d6b6265 = $49d40eaf9ca0cfa4$var$DEVICE_LOCALE, $49d40eaf9ca0cfa4$export$cf67f8cb2324428e = $49d40eaf9ca0cfa4$var$DEVICE_LOW_MEMORY, $49d40eaf9ca0cfa4$export$9d4197c1ffc5f359 = $49d40eaf9ca0cfa4$var$DEVICE_LOW_POWER_MODE, $49d40eaf9ca0cfa4$export$509634fbff540e75 = $49d40eaf9ca0cfa4$var$DEVICE_MANUFACTURER, $49d40eaf9ca0cfa4$export$ccbc4fdff4b5eff5 = $49d40eaf9ca0cfa4$var$DEVICE_MEMORY_ESTIMATED_CAPACITY, $49d40eaf9ca0cfa4$export$e0cb371ca548b1d6 = $49d40eaf9ca0cfa4$var$DEVICE_MEMORY_SIZE, $49d40eaf9ca0cfa4$export$3c39026d09026bc2 = $49d40eaf9ca0cfa4$var$DEVICE_MODEL, $49d40eaf9ca0cfa4$export$bf9e8248cb72cf00 = $49d40eaf9ca0cfa4$var$DEVICE_MODEL_ID, $49d40eaf9ca0cfa4$export$1054f22a72121d0f = $49d40eaf9ca0cfa4$var$DEVICE_NAME, $49d40eaf9ca0cfa4$export$723b8a59dad2e467 = $49d40eaf9ca0cfa4$var$DEVICE_ONLINE, $49d40eaf9ca0cfa4$export$160081ff141bac8e = $49d40eaf9ca0cfa4$var$DEVICE_ORIENTATION, $49d40eaf9ca0cfa4$export$194f62c84d27310 = $49d40eaf9ca0cfa4$var$DEVICE_PROCESSOR_COUNT, $49d40eaf9ca0cfa4$export$7ed866d57b018d09 = $49d40eaf9ca0cfa4$var$DEVICE_PROCESSOR_FREQUENCY, $49d40eaf9ca0cfa4$export$d50bae4562e03e5 = $49d40eaf9ca0cfa4$var$DEVICE_SCREEN_DENSITY, $49d40eaf9ca0cfa4$export$649ea67a18fe8e8b = $49d40eaf9ca0cfa4$var$DEVICE_SCREEN_DPI, $49d40eaf9ca0cfa4$export$136a5c1b43caaccd = $49d40eaf9ca0cfa4$var$DEVICE_SCREEN_HEIGHT_PIXELS, $49d40eaf9ca0cfa4$export$e33a28ea554b6ddc = $49d40eaf9ca0cfa4$var$DEVICE_SCREEN_WIDTH_PIXELS, $49d40eaf9ca0cfa4$export$acbe2d25ac76ea64 = $49d40eaf9ca0cfa4$var$DEVICE_SIMULATOR, $49d40eaf9ca0cfa4$export$793c13e17d7e5e2b = $49d40eaf9ca0cfa4$var$DEVICE_STORAGE_SIZE, $49d40eaf9ca0cfa4$export$a5617e33b89fd956 = $49d40eaf9ca0cfa4$var$DEVICE_THERMAL_STATE, $49d40eaf9ca0cfa4$export$b51f82164fa31e07 = $49d40eaf9ca0cfa4$var$DEVICE_TIMEZONE, $49d40eaf9ca0cfa4$export$f2ef55183c04d202 = $49d40eaf9ca0cfa4$var$DEVICE_USABLE_MEMORY, $49d40eaf9ca0cfa4$export$7c98fc0c48a16b1c = $49d40eaf9ca0cfa4$var$DIST, $49d40eaf9ca0cfa4$export$f0511e328234ae83 = $49d40eaf9ca0cfa4$var$EFFECTIVECONNECTIONTYPE, $49d40eaf9ca0cfa4$export$be46596bc6608f3b = $49d40eaf9ca0cfa4$var$ENVIRONMENT, $49d40eaf9ca0cfa4$export$f215947b3d76a6b7 = $49d40eaf9ca0cfa4$var$ERROR_TYPE, $49d40eaf9ca0cfa4$export$89bbc91416db6670 = $49d40eaf9ca0cfa4$var$EVENT_ID, $49d40eaf9ca0cfa4$export$b4b5eff8a8712c89 = $49d40eaf9ca0cfa4$var$EVENT_NAME, $49d40eaf9ca0cfa4$export$f455969a57ab8a03 = $49d40eaf9ca0cfa4$var$EXCEPTION_ESCAPED, $49d40eaf9ca0cfa4$export$13f2f8f42af49cec = $49d40eaf9ca0cfa4$var$EXCEPTION_MESSAGE, $49d40eaf9ca0cfa4$export$cd357afe2ffdd2c3 = $49d40eaf9ca0cfa4$var$EXCEPTION_STACKTRACE, $49d40eaf9ca0cfa4$export$d9ca2a279a11be5e = $49d40eaf9ca0cfa4$var$EXCEPTION_TYPE, $49d40eaf9ca0cfa4$export$bbd59a8c7efad4c9 = $49d40eaf9ca0cfa4$var$FAAS_COLDSTART, $49d40eaf9ca0cfa4$export$8413282a17f1cda5 = $49d40eaf9ca0cfa4$var$FAAS_CRON, $49d40eaf9ca0cfa4$export$30d19ddc7705e7e8 = $49d40eaf9ca0cfa4$var$FAAS_DURATION_IN_MS, $49d40eaf9ca0cfa4$export$64a4f09e2444b3d = $49d40eaf9ca0cfa4$var$FAAS_ENTRY_POINT, $49d40eaf9ca0cfa4$export$645b039fe163809e = $49d40eaf9ca0cfa4$var$FAAS_EXECUTION, $49d40eaf9ca0cfa4$export$b23ef8b8ffa607e1 = $49d40eaf9ca0cfa4$var$FAAS_ID, $49d40eaf9ca0cfa4$export$8bf64516740c1369 = $49d40eaf9ca0cfa4$var$FAAS_IDENTITY, $49d40eaf9ca0cfa4$export$9a0dc8e612f3e10b = $49d40eaf9ca0cfa4$var$FAAS_INVOCATION_ID, $49d40eaf9ca0cfa4$export$abe90fedb3dddda2 = $49d40eaf9ca0cfa4$var$FAAS_INVOKED_NAME, $49d40eaf9ca0cfa4$export$4a19da9c85ed2ade = $49d40eaf9ca0cfa4$var$FAAS_INVOKED_PROVIDER, $49d40eaf9ca0cfa4$export$5e091479f094bdbc = $49d40eaf9ca0cfa4$var$FAAS_INVOKED_REGION, $49d40eaf9ca0cfa4$export$d70909b5aa96a79a = $49d40eaf9ca0cfa4$var$FAAS_NAME, $49d40eaf9ca0cfa4$export$651d142a8017d83d = $49d40eaf9ca0cfa4$var$FAAS_TIME, $49d40eaf9ca0cfa4$export$44382a010a9f7fcf = $49d40eaf9ca0cfa4$var$FAAS_TRIGGER, $49d40eaf9ca0cfa4$export$807abfdc6b7b9338 = $49d40eaf9ca0cfa4$var$FAAS_VERSION, $49d40eaf9ca0cfa4$export$31881d07f2569218 = "fcp", $49d40eaf9ca0cfa4$export$e5bbf306deb709a6 = $49d40eaf9ca0cfa4$var$FLAG_EVALUATION_KEY, $49d40eaf9ca0cfa4$export$aa8721167c5c8d2d = $49d40eaf9ca0cfa4$var$FLAG_EVALUATION_KEY_BASE, $49d40eaf9ca0cfa4$export$757b93e5b3adc7cb = "fp", $49d40eaf9ca0cfa4$export$f869eaa92db1dc9b = $49d40eaf9ca0cfa4$var$FRAMES_DELAY, $49d40eaf9ca0cfa4$export$5d1d761e41c32d9e = $49d40eaf9ca0cfa4$var$FRAMES_FROZEN, $49d40eaf9ca0cfa4$export$8aec72d9491f9399 = $49d40eaf9ca0cfa4$var$FRAMES_FROZEN_RATE, $49d40eaf9ca0cfa4$export$5562635d2be2ab25 = $49d40eaf9ca0cfa4$var$FRAMES_SLOW, $49d40eaf9ca0cfa4$export$2dc31837ce6f7a3d = $49d40eaf9ca0cfa4$var$FRAMES_SLOW_RATE, $49d40eaf9ca0cfa4$export$b561df15f64d32e3 = $49d40eaf9ca0cfa4$var$FRAMES_TOTAL, $49d40eaf9ca0cfa4$export$181f78b28f2ffa57 = $49d40eaf9ca0cfa4$var$FS_ERROR, $49d40eaf9ca0cfa4$export$6c97c77b89571c75 = $49d40eaf9ca0cfa4$var$GCP_FUNCTION_CONTEXT_EVENT_ID, $49d40eaf9ca0cfa4$export$51e431eaf1f9bf58 = $49d40eaf9ca0cfa4$var$GCP_FUNCTION_CONTEXT_EVENT_TYPE, $49d40eaf9ca0cfa4$export$71429c7ef7cb7063 = $49d40eaf9ca0cfa4$var$GCP_FUNCTION_CONTEXT_ID, $49d40eaf9ca0cfa4$export$99905d7583a6e8ac = $49d40eaf9ca0cfa4$var$GCP_FUNCTION_CONTEXT_RESOURCE, $49d40eaf9ca0cfa4$export$b6c4be74fd0c06bd = $49d40eaf9ca0cfa4$var$GCP_FUNCTION_CONTEXT_SOURCE, $49d40eaf9ca0cfa4$export$fd23e5b8d261a89 = $49d40eaf9ca0cfa4$var$GCP_FUNCTION_CONTEXT_SPECVERSION, $49d40eaf9ca0cfa4$export$25fabc9b3d1dd567 = $49d40eaf9ca0cfa4$var$GCP_FUNCTION_CONTEXT_TIME, $49d40eaf9ca0cfa4$export$41507f7b07dad151 = $49d40eaf9ca0cfa4$var$GCP_FUNCTION_CONTEXT_TIMESTAMP, $49d40eaf9ca0cfa4$export$1352f3699c35dd73 = $49d40eaf9ca0cfa4$var$GCP_FUNCTION_CONTEXT_TYPE, $49d40eaf9ca0cfa4$export$fd6c9d5c74d943ac = $49d40eaf9ca0cfa4$var$GCP_PROJECT_ID, $49d40eaf9ca0cfa4$export$c29634e3cf41e479 = $49d40eaf9ca0cfa4$var$GEN_AI_AGENT_NAME, $49d40eaf9ca0cfa4$export$e6a60882cce7a085 = $49d40eaf9ca0cfa4$var$GEN_AI_CONTEXT_UTILIZATION, $49d40eaf9ca0cfa4$export$6773c9098ba5e194 = $49d40eaf9ca0cfa4$var$GEN_AI_CONTEXT_WINDOW_SIZE, $49d40eaf9ca0cfa4$export$6ee6b62f50047686 = $49d40eaf9ca0cfa4$var$GEN_AI_CONVERSATION_ID, $49d40eaf9ca0cfa4$export$efac052bb3661242 = $49d40eaf9ca0cfa4$var$GEN_AI_COST_CACHE_CREATION_INPUT_TOKENS, $49d40eaf9ca0cfa4$export$7ccd63b9ca955862 = $49d40eaf9ca0cfa4$var$GEN_AI_COST_CACHE_READ_INPUT_TOKENS, $49d40eaf9ca0cfa4$export$50921df5a58cb3ef = $49d40eaf9ca0cfa4$var$GEN_AI_COST_INPUT_TOKENS, $49d40eaf9ca0cfa4$export$8e48efc7acb57a97 = $49d40eaf9ca0cfa4$var$GEN_AI_COST_OUTPUT_TOKENS, $49d40eaf9ca0cfa4$export$cea9121727113f77 = $49d40eaf9ca0cfa4$var$GEN_AI_COST_REASONING_OUTPUT_TOKENS, $49d40eaf9ca0cfa4$export$bed35ff7f9af3aaa = $49d40eaf9ca0cfa4$var$GEN_AI_COST_TOTAL_TOKENS, $49d40eaf9ca0cfa4$export$6b729e898b9067ce = $49d40eaf9ca0cfa4$var$GEN_AI_EMBEDDINGS_INPUT, $49d40eaf9ca0cfa4$export$984fbab9b52f7e24 = $49d40eaf9ca0cfa4$var$GEN_AI_FUNCTION_ID, $49d40eaf9ca0cfa4$export$9ea17906a87ada6f = $49d40eaf9ca0cfa4$var$GEN_AI_INPUT_MESSAGES, $49d40eaf9ca0cfa4$export$394b443aaff3ef92 = $49d40eaf9ca0cfa4$var$GEN_AI_OPERATION_NAME, $49d40eaf9ca0cfa4$export$6ddc374adbc06720 = $49d40eaf9ca0cfa4$var$GEN_AI_OPERATION_TYPE, $49d40eaf9ca0cfa4$export$ab8c7ebc9add56b2 = $49d40eaf9ca0cfa4$var$GEN_AI_OUTPUT_MESSAGES, $49d40eaf9ca0cfa4$export$40ecc5bcd633d1ee = $49d40eaf9ca0cfa4$var$GEN_AI_PIPELINE_NAME, $49d40eaf9ca0cfa4$export$86a8df7fff52fc69 = $49d40eaf9ca0cfa4$var$GEN_AI_PROMPT, $49d40eaf9ca0cfa4$export$cf2115d46768f4c5 = $49d40eaf9ca0cfa4$var$GEN_AI_PROMPT_NAME, $49d40eaf9ca0cfa4$export$3d7e036e195764db = $49d40eaf9ca0cfa4$var$GEN_AI_PROVIDER_NAME, $49d40eaf9ca0cfa4$export$60c1d11221608cee = $49d40eaf9ca0cfa4$var$GEN_AI_REQUEST_AVAILABLE_TOOLS, $49d40eaf9ca0cfa4$export$bc3cef164abbc42c = $49d40eaf9ca0cfa4$var$GEN_AI_REQUEST_FREQUENCY_PENALTY, $49d40eaf9ca0cfa4$export$43f9afb62cd79dec = $49d40eaf9ca0cfa4$var$GEN_AI_REQUEST_MAX_TOKENS, $49d40eaf9ca0cfa4$export$a5ab4ffc4765f75f = $49d40eaf9ca0cfa4$var$GEN_AI_REQUEST_MESSAGES, $49d40eaf9ca0cfa4$export$ccf46db9ab1743ec = $49d40eaf9ca0cfa4$var$GEN_AI_REQUEST_MODEL, $49d40eaf9ca0cfa4$export$76c1c247342d776 = $49d40eaf9ca0cfa4$var$GEN_AI_REQUEST_PRESENCE_PENALTY, $49d40eaf9ca0cfa4$export$92f5944f0b02c9fb = $49d40eaf9ca0cfa4$var$GEN_AI_REQUEST_REASONING_EFFORT, $49d40eaf9ca0cfa4$export$867eeefcb1c95b27 = $49d40eaf9ca0cfa4$var$GEN_AI_REQUEST_SEED, $49d40eaf9ca0cfa4$export$5ada4697ae6aa17e = $49d40eaf9ca0cfa4$var$GEN_AI_REQUEST_STOP_SEQUENCES, $49d40eaf9ca0cfa4$export$427122300e8d54d0 = $49d40eaf9ca0cfa4$var$GEN_AI_REQUEST_TEMPERATURE, $49d40eaf9ca0cfa4$export$bcea8881375c352f = $49d40eaf9ca0cfa4$var$GEN_AI_REQUEST_TOP_K, $49d40eaf9ca0cfa4$export$b867715f9a0c04e9 = $49d40eaf9ca0cfa4$var$GEN_AI_REQUEST_TOP_P, $49d40eaf9ca0cfa4$export$69878a39cbdbe097 = $49d40eaf9ca0cfa4$var$GEN_AI_RESPONSE_FINISH_REASONS, $49d40eaf9ca0cfa4$export$584c61a1b769552d = $49d40eaf9ca0cfa4$var$GEN_AI_RESPONSE_ID, $49d40eaf9ca0cfa4$export$8169ebcb0b0331dd = $49d40eaf9ca0cfa4$var$GEN_AI_RESPONSE_MODEL, $49d40eaf9ca0cfa4$export$2c9713b624877853 = $49d40eaf9ca0cfa4$var$GEN_AI_RESPONSE_STREAMING, $49d40eaf9ca0cfa4$export$45942692aeb454e0 = $49d40eaf9ca0cfa4$var$GEN_AI_RESPONSE_TEXT, $49d40eaf9ca0cfa4$export$8e5efeaa031210cd = $49d40eaf9ca0cfa4$var$GEN_AI_RESPONSE_TIME_TO_FIRST_CHUNK, $49d40eaf9ca0cfa4$export$35a62769ee05a05a = $49d40eaf9ca0cfa4$var$GEN_AI_RESPONSE_TIME_TO_FIRST_TOKEN, $49d40eaf9ca0cfa4$export$8ea4f7e986ca4b06 = $49d40eaf9ca0cfa4$var$GEN_AI_RESPONSE_TOKENS_PER_SECOND, $49d40eaf9ca0cfa4$export$d2fd9ecaff0285a4 = $49d40eaf9ca0cfa4$var$GEN_AI_RESPONSE_TOOL_CALLS, $49d40eaf9ca0cfa4$export$a6c8e656a4f9bb67 = $49d40eaf9ca0cfa4$var$GEN_AI_SYSTEM, $49d40eaf9ca0cfa4$export$352a8075b163d53 = $49d40eaf9ca0cfa4$var$GEN_AI_SYSTEM_INSTRUCTIONS, $49d40eaf9ca0cfa4$export$426d7b90ba5d79db = $49d40eaf9ca0cfa4$var$GEN_AI_SYSTEM_MESSAGE, $49d40eaf9ca0cfa4$export$f5a1ee40934d19ce = $49d40eaf9ca0cfa4$var$GEN_AI_TOOL_CALL_ARGUMENTS, $49d40eaf9ca0cfa4$export$1ba812a9756622ce = $49d40eaf9ca0cfa4$var$GEN_AI_TOOL_CALL_RESULT, $49d40eaf9ca0cfa4$export$351120039c36e03 = $49d40eaf9ca0cfa4$var$GEN_AI_TOOL_DEFINITIONS, $49d40eaf9ca0cfa4$export$d42aa25ca09e17c4 = $49d40eaf9ca0cfa4$var$GEN_AI_TOOL_DESCRIPTION, $49d40eaf9ca0cfa4$export$d268db29b88a4286 = $49d40eaf9ca0cfa4$var$GEN_AI_TOOL_INPUT, $49d40eaf9ca0cfa4$export$c5deb6018f2d6251 = $49d40eaf9ca0cfa4$var$GEN_AI_TOOL_MESSAGE, $49d40eaf9ca0cfa4$export$e06baa3034409453 = $49d40eaf9ca0cfa4$var$GEN_AI_TOOL_NAME, $49d40eaf9ca0cfa4$export$646fdb5910ce3931 = $49d40eaf9ca0cfa4$var$GEN_AI_TOOL_OUTPUT, $49d40eaf9ca0cfa4$export$662e3d2d4361e29b = $49d40eaf9ca0cfa4$var$GEN_AI_TOOL_TYPE, $49d40eaf9ca0cfa4$export$1de3962f221ba441 = $49d40eaf9ca0cfa4$var$GEN_AI_USAGE_CACHE_CREATION_INPUT_TOKENS, $49d40eaf9ca0cfa4$export$a4b3f0f5499c8738 = $49d40eaf9ca0cfa4$var$GEN_AI_USAGE_CACHE_READ_INPUT_TOKENS, $49d40eaf9ca0cfa4$export$1aecdac6cecbdc5b = $49d40eaf9ca0cfa4$var$GEN_AI_USAGE_COMPLETION_TOKENS, $49d40eaf9ca0cfa4$export$2eb2ab35b317a103 = $49d40eaf9ca0cfa4$var$GEN_AI_USAGE_INPUT_TOKENS, $49d40eaf9ca0cfa4$export$c7e14ea195ede241 = $49d40eaf9ca0cfa4$var$GEN_AI_USAGE_INPUT_TOKENS_CACHED, $49d40eaf9ca0cfa4$export$41ac034e7b9725a2 = $49d40eaf9ca0cfa4$var$GEN_AI_USAGE_INPUT_TOKENS_CACHE_WRITE, $49d40eaf9ca0cfa4$export$9e521119d7751e37 = $49d40eaf9ca0cfa4$var$GEN_AI_USAGE_OUTPUT_TOKENS, $49d40eaf9ca0cfa4$export$cbac8f541a64a150 = $49d40eaf9ca0cfa4$var$GEN_AI_USAGE_OUTPUT_TOKENS_REASONING, $49d40eaf9ca0cfa4$export$93dd08efa94c9dd4 = $49d40eaf9ca0cfa4$var$GEN_AI_USAGE_PROMPT_TOKENS, $49d40eaf9ca0cfa4$export$183e3523dac20bca = $49d40eaf9ca0cfa4$var$GEN_AI_USAGE_REASONING_OUTPUT_TOKENS, $49d40eaf9ca0cfa4$export$3867ca1d8381d4e3 = $49d40eaf9ca0cfa4$var$GEN_AI_USAGE_TOTAL_TOKENS, $49d40eaf9ca0cfa4$export$11febcf9917c0057 = $49d40eaf9ca0cfa4$var$GRAPHQL_DOCUMENT, $49d40eaf9ca0cfa4$export$88ae1ee0c0a63398 = $49d40eaf9ca0cfa4$var$GRAPHQL_OPERATION_NAME, $49d40eaf9ca0cfa4$export$d5bd986d1f283f29 = $49d40eaf9ca0cfa4$var$GRAPHQL_OPERATION_TYPE, $49d40eaf9ca0cfa4$export$fc4a2d238535d998 = $49d40eaf9ca0cfa4$var$HARDWARECONCURRENCY, $49d40eaf9ca0cfa4$export$57e53a60bf563f41 = $49d40eaf9ca0cfa4$var$HTTP_CLIENT_IP, $49d40eaf9ca0cfa4$export$ffdb1464deb0eedb = $49d40eaf9ca0cfa4$var$HTTP_DECODED_RESPONSE_CONTENT_LENGTH, $49d40eaf9ca0cfa4$export$b52670c950fd640 = $49d40eaf9ca0cfa4$var$HTTP_FLAVOR, $49d40eaf9ca0cfa4$export$c499fd8f1db3d18e = $49d40eaf9ca0cfa4$var$HTTP_FRAGMENT, $49d40eaf9ca0cfa4$export$b2ee2242301eff05 = $49d40eaf9ca0cfa4$var$HTTP_HOST, $49d40eaf9ca0cfa4$export$2ebf9f7586f16841 = $49d40eaf9ca0cfa4$var$HTTP_METHOD, $49d40eaf9ca0cfa4$export$6e9ffd608b3e828b = $49d40eaf9ca0cfa4$var$HTTP_QUERY, $49d40eaf9ca0cfa4$export$b960c5a73a722e6c = $49d40eaf9ca0cfa4$var$HTTP_REQUEST_BODY_DATA, $49d40eaf9ca0cfa4$export$a7a850351369c77e = $49d40eaf9ca0cfa4$var$HTTP_REQUEST_CONNECTION_END, $49d40eaf9ca0cfa4$export$b18bca78f4736a94 = $49d40eaf9ca0cfa4$var$HTTP_REQUEST_CONNECT_START, $49d40eaf9ca0cfa4$export$61a0059f562fb6c2 = $49d40eaf9ca0cfa4$var$HTTP_REQUEST_DOMAIN_LOOKUP_END, $49d40eaf9ca0cfa4$export$7dc0d5aefb816d91 = $49d40eaf9ca0cfa4$var$HTTP_REQUEST_DOMAIN_LOOKUP_START, $49d40eaf9ca0cfa4$export$58f6db56c841bef6 = $49d40eaf9ca0cfa4$var$HTTP_REQUEST_FETCH_START, $49d40eaf9ca0cfa4$export$97a3da679f509d5 = $49d40eaf9ca0cfa4$var$HTTP_REQUEST_HEADER_KEY, $49d40eaf9ca0cfa4$export$c387ec65fd1c2638 = $49d40eaf9ca0cfa4$var$HTTP_REQUEST_HEADER_KEY_BASE, $49d40eaf9ca0cfa4$export$4d9db82211f308a4 = $49d40eaf9ca0cfa4$var$HTTP_REQUEST_METHOD, $49d40eaf9ca0cfa4$export$ee4948a3be025123 = $49d40eaf9ca0cfa4$var$HTTP_REQUEST_REDIRECT_END, $49d40eaf9ca0cfa4$export$e0021eb2979cddaa = $49d40eaf9ca0cfa4$var$HTTP_REQUEST_REDIRECT_START, $49d40eaf9ca0cfa4$export$7c0ac0c19a45beac = $49d40eaf9ca0cfa4$var$HTTP_REQUEST_REQUEST_START, $49d40eaf9ca0cfa4$export$6c32e9d84f534ee = $49d40eaf9ca0cfa4$var$HTTP_REQUEST_RESEND_COUNT, $49d40eaf9ca0cfa4$export$d1f9fbdb211dd29b = $49d40eaf9ca0cfa4$var$HTTP_REQUEST_RESPONSE_END, $49d40eaf9ca0cfa4$export$45e7eea99a17d6e4 = $49d40eaf9ca0cfa4$var$HTTP_REQUEST_RESPONSE_START, $49d40eaf9ca0cfa4$export$20ea34e16c0aa64f = $49d40eaf9ca0cfa4$var$HTTP_REQUEST_SAME_ORIGIN, $49d40eaf9ca0cfa4$export$8365b0f03557fae9 = $49d40eaf9ca0cfa4$var$HTTP_REQUEST_SECURE_CONNECTION_START, $49d40eaf9ca0cfa4$export$49ebbb9621675650 = $49d40eaf9ca0cfa4$var$HTTP_REQUEST_TIME_TO_FIRST_BYTE, $49d40eaf9ca0cfa4$export$842be66a901f093 = $49d40eaf9ca0cfa4$var$HTTP_REQUEST_WORKER_START, $49d40eaf9ca0cfa4$export$a9f5a6cb28adccb1 = $49d40eaf9ca0cfa4$var$HTTP_RESPONSE_BODY_SIZE, $49d40eaf9ca0cfa4$export$57b055d4bc586d67 = $49d40eaf9ca0cfa4$var$HTTP_RESPONSE_CONTENT_LENGTH, $49d40eaf9ca0cfa4$export$3ddfd660caa7bf7a = $49d40eaf9ca0cfa4$var$HTTP_RESPONSE_HEADER_CONTENT_LENGTH, $49d40eaf9ca0cfa4$export$fa7e1f5305153b3d = $49d40eaf9ca0cfa4$var$HTTP_RESPONSE_HEADER_KEY, $49d40eaf9ca0cfa4$export$5674ce9d013eb7bd = $49d40eaf9ca0cfa4$var$HTTP_RESPONSE_HEADER_KEY_BASE, $49d40eaf9ca0cfa4$export$6e8dc14cff6ccf72 = $49d40eaf9ca0cfa4$var$HTTP_RESPONSE_SIZE, $49d40eaf9ca0cfa4$export$afd59480458e1b57 = $49d40eaf9ca0cfa4$var$HTTP_RESPONSE_STATUS_CODE, $49d40eaf9ca0cfa4$export$48e61fb9bccccba9 = $49d40eaf9ca0cfa4$var$HTTP_RESPONSE_TRANSFER_SIZE, $49d40eaf9ca0cfa4$export$d3e674514dd3a3e1 = $49d40eaf9ca0cfa4$var$HTTP_ROUTE, $49d40eaf9ca0cfa4$export$97ad02b50c60ef68 = $49d40eaf9ca0cfa4$var$HTTP_SCHEME, $49d40eaf9ca0cfa4$export$61d053b1b63e82c4 = $49d40eaf9ca0cfa4$var$HTTP_SERVER_NAME, $49d40eaf9ca0cfa4$export$54256cce0d674dea = $49d40eaf9ca0cfa4$var$HTTP_SERVER_REQUEST_TIME_IN_QUEUE, $49d40eaf9ca0cfa4$export$8c01f0f407bcc5ca = $49d40eaf9ca0cfa4$var$HTTP_STATUS_CODE, $49d40eaf9ca0cfa4$export$be3f46982f6c7160 = $49d40eaf9ca0cfa4$var$HTTP_TARGET, $49d40eaf9ca0cfa4$export$778e4213e2788579 = $49d40eaf9ca0cfa4$var$HTTP_URL, $49d40eaf9ca0cfa4$export$8b48ca3594d2b172 = $49d40eaf9ca0cfa4$var$HTTP_USER_AGENT, $49d40eaf9ca0cfa4$export$8be180ec26319f9f = "id", $49d40eaf9ca0cfa4$export$60eccaddefa8fc1c = "inp", $49d40eaf9ca0cfa4$export$c99ce4fe37484d84 = $49d40eaf9ca0cfa4$var$JSONRPC_PROTOCOL_VERSION, $49d40eaf9ca0cfa4$export$fdf432fcac7d8f37 = $49d40eaf9ca0cfa4$var$JSONRPC_REQUEST_ID, $49d40eaf9ca0cfa4$export$4c21cc9cdf2f5dbd = $49d40eaf9ca0cfa4$var$JVM_GC_ACTION, $49d40eaf9ca0cfa4$export$dcc1eab7f3f31816 = $49d40eaf9ca0cfa4$var$JVM_GC_NAME, $49d40eaf9ca0cfa4$export$dcb7f1379b2b8f86 = $49d40eaf9ca0cfa4$var$JVM_MEMORY_POOL_NAME, $49d40eaf9ca0cfa4$export$53416edeea4c2d74 = $49d40eaf9ca0cfa4$var$JVM_MEMORY_TYPE, $49d40eaf9ca0cfa4$export$69f7e5d2b74c5c9e = $49d40eaf9ca0cfa4$var$JVM_THREAD_DAEMON, $49d40eaf9ca0cfa4$export$8e104aed582a26bc = $49d40eaf9ca0cfa4$var$JVM_THREAD_STATE, $49d40eaf9ca0cfa4$export$577047501949be9 = $49d40eaf9ca0cfa4$var$KOA_NAME, $49d40eaf9ca0cfa4$export$c4c45b599a2c15e = $49d40eaf9ca0cfa4$var$KOA_TYPE, $49d40eaf9ca0cfa4$export$361cb541700d648e = "lcp", $49d40eaf9ca0cfa4$export$974f160e11f25731 = $49d40eaf9ca0cfa4$var$LCP_ELEMENT, $49d40eaf9ca0cfa4$export$7162f5c702b95903 = $49d40eaf9ca0cfa4$var$LCP_ID, $49d40eaf9ca0cfa4$export$a034d066a9090500 = $49d40eaf9ca0cfa4$var$LCP_LOADTIME, $49d40eaf9ca0cfa4$export$70938021e43e047c = $49d40eaf9ca0cfa4$var$LCP_RENDERTIME, $49d40eaf9ca0cfa4$export$5f6ac460012a73bb = $49d40eaf9ca0cfa4$var$LCP_SIZE, $49d40eaf9ca0cfa4$export$d8e498c1c670bcbf = $49d40eaf9ca0cfa4$var$LCP_URL, $49d40eaf9ca0cfa4$export$cc1a78a24d947903 = $49d40eaf9ca0cfa4$var$LOGGER_NAME, $49d40eaf9ca0cfa4$export$d29b927e0bb0ffea = $49d40eaf9ca0cfa4$var$MCP_CANCELLED_REASON, $49d40eaf9ca0cfa4$export$b3999cacef245779 = $49d40eaf9ca0cfa4$var$MCP_CANCELLED_REQUEST_ID, $49d40eaf9ca0cfa4$export$ff168b5f9cf9dcf6 = $49d40eaf9ca0cfa4$var$MCP_CLIENT_NAME, $49d40eaf9ca0cfa4$export$2ab876a45bd6e64 = $49d40eaf9ca0cfa4$var$MCP_CLIENT_TITLE, $49d40eaf9ca0cfa4$export$cb8027e4395c6c0e = $49d40eaf9ca0cfa4$var$MCP_CLIENT_VERSION, $49d40eaf9ca0cfa4$export$f5303d1bac3c2660 = $49d40eaf9ca0cfa4$var$MCP_LIFECYCLE_PHASE, $49d40eaf9ca0cfa4$export$6c463c5f3b00f64 = $49d40eaf9ca0cfa4$var$MCP_LOGGING_DATA_TYPE, $49d40eaf9ca0cfa4$export$e25d553065457cab = $49d40eaf9ca0cfa4$var$MCP_LOGGING_LEVEL, $49d40eaf9ca0cfa4$export$15d24c154ea8a56f = $49d40eaf9ca0cfa4$var$MCP_LOGGING_LOGGER, $49d40eaf9ca0cfa4$export$e5065789a6c415d0 = $49d40eaf9ca0cfa4$var$MCP_LOGGING_MESSAGE, $49d40eaf9ca0cfa4$export$62662c561d7c7835 = $49d40eaf9ca0cfa4$var$MCP_METHOD_NAME, $49d40eaf9ca0cfa4$export$218f394557fb0a5a = $49d40eaf9ca0cfa4$var$MCP_PROGRESS_CURRENT, $49d40eaf9ca0cfa4$export$2a5ff6de5448ecdf = $49d40eaf9ca0cfa4$var$MCP_PROGRESS_MESSAGE, $49d40eaf9ca0cfa4$export$9d23f3030ed2597e = $49d40eaf9ca0cfa4$var$MCP_PROGRESS_PERCENTAGE, $49d40eaf9ca0cfa4$export$a26ff217a6124160 = $49d40eaf9ca0cfa4$var$MCP_PROGRESS_TOKEN, $49d40eaf9ca0cfa4$export$c8072f5fcfdb5b77 = $49d40eaf9ca0cfa4$var$MCP_PROGRESS_TOTAL, $49d40eaf9ca0cfa4$export$c4e4b74f1ccf3d96 = $49d40eaf9ca0cfa4$var$MCP_PROMPT_NAME, $49d40eaf9ca0cfa4$export$328519d02a26ac41 = $49d40eaf9ca0cfa4$var$MCP_PROMPT_RESULT_DESCRIPTION, $49d40eaf9ca0cfa4$export$d2061b291c43d045 = $49d40eaf9ca0cfa4$var$MCP_PROMPT_RESULT_MESSAGE_CONTENT, $49d40eaf9ca0cfa4$export$d1f04dfd3d695286 = $49d40eaf9ca0cfa4$var$MCP_PROMPT_RESULT_MESSAGE_COUNT, $49d40eaf9ca0cfa4$export$234fbd86ea0f0bd8 = $49d40eaf9ca0cfa4$var$MCP_PROMPT_RESULT_MESSAGE_ROLE, $49d40eaf9ca0cfa4$export$e795000978a75b12 = $49d40eaf9ca0cfa4$var$MCP_PROTOCOL_READY, $49d40eaf9ca0cfa4$export$9f4683b4d1018ace = $49d40eaf9ca0cfa4$var$MCP_PROTOCOL_VERSION, $49d40eaf9ca0cfa4$export$e431b042fcdb1d63 = $49d40eaf9ca0cfa4$var$MCP_REQUEST_ARGUMENT_KEY, $49d40eaf9ca0cfa4$export$a453239171ac9a23 = $49d40eaf9ca0cfa4$var$MCP_REQUEST_ARGUMENT_KEY_BASE, $49d40eaf9ca0cfa4$export$3a7726a976c18d5f = $49d40eaf9ca0cfa4$var$MCP_REQUEST_ARGUMENT_NAME, $49d40eaf9ca0cfa4$export$7eca7a6c06843b93 = $49d40eaf9ca0cfa4$var$MCP_REQUEST_ARGUMENT_URI, $49d40eaf9ca0cfa4$export$f25c55f83e5b0672 = $49d40eaf9ca0cfa4$var$MCP_REQUEST_ID, $49d40eaf9ca0cfa4$export$9562bfac4eb079cb = $49d40eaf9ca0cfa4$var$MCP_RESOURCE_PROTOCOL, $49d40eaf9ca0cfa4$export$c276d164ff91d2f7 = $49d40eaf9ca0cfa4$var$MCP_RESOURCE_URI, $49d40eaf9ca0cfa4$export$2f3e0574f1a99754 = $49d40eaf9ca0cfa4$var$MCP_SERVER_NAME, $49d40eaf9ca0cfa4$export$15eecaab68167880 = $49d40eaf9ca0cfa4$var$MCP_SERVER_TITLE, $49d40eaf9ca0cfa4$export$513c47f6e194086a = $49d40eaf9ca0cfa4$var$MCP_SERVER_VERSION, $49d40eaf9ca0cfa4$export$a3f464c4d5cd9096 = $49d40eaf9ca0cfa4$var$MCP_SESSION_ID, $49d40eaf9ca0cfa4$export$ed366a03a2330b03 = $49d40eaf9ca0cfa4$var$MCP_TOOL_NAME, $49d40eaf9ca0cfa4$export$9b802c784f235e1d = $49d40eaf9ca0cfa4$var$MCP_TOOL_RESULT_CONTENT, $49d40eaf9ca0cfa4$export$add0fc8b8c5726a4 = $49d40eaf9ca0cfa4$var$MCP_TOOL_RESULT_CONTENT_COUNT, $49d40eaf9ca0cfa4$export$e7f32463f5bfd554 = $49d40eaf9ca0cfa4$var$MCP_TOOL_RESULT_IS_ERROR, $49d40eaf9ca0cfa4$export$f9346f394edf26a = $49d40eaf9ca0cfa4$var$MCP_TRANSPORT, $49d40eaf9ca0cfa4$export$16b917774e73ef92 = $49d40eaf9ca0cfa4$var$MDC_KEY, $49d40eaf9ca0cfa4$export$15d2b60bf3b65454 = "mdc", $49d40eaf9ca0cfa4$export$db55eca5af256142 = $49d40eaf9ca0cfa4$var$MESSAGING_BATCH_MESSAGE_COUNT, $49d40eaf9ca0cfa4$export$967c74f8b1f3d35 = $49d40eaf9ca0cfa4$var$MESSAGING_DESTINATION, $49d40eaf9ca0cfa4$export$7c33ae67962515d1 = $49d40eaf9ca0cfa4$var$MESSAGING_DESTINATION_CONNECTION, $49d40eaf9ca0cfa4$export$9c69839b2d93489b = $49d40eaf9ca0cfa4$var$MESSAGING_DESTINATION_NAME, $49d40eaf9ca0cfa4$export$be22d22d4b6cf5d8 = $49d40eaf9ca0cfa4$var$MESSAGING_MESSAGE_BODY_SIZE, $49d40eaf9ca0cfa4$export$c529961b911626ac = $49d40eaf9ca0cfa4$var$MESSAGING_MESSAGE_CONVERSATION_ID, $49d40eaf9ca0cfa4$export$e39c4b15d2881f5 = $49d40eaf9ca0cfa4$var$MESSAGING_MESSAGE_ENVELOPE_SIZE, $49d40eaf9ca0cfa4$export$a8ca145161313e7 = $49d40eaf9ca0cfa4$var$MESSAGING_MESSAGE_ID, $49d40eaf9ca0cfa4$export$3c1204d03918d076 = $49d40eaf9ca0cfa4$var$MESSAGING_MESSAGE_RECEIVE_LATENCY, $49d40eaf9ca0cfa4$export$eaac3f141165e288 = $49d40eaf9ca0cfa4$var$MESSAGING_MESSAGE_RETRY_COUNT, $49d40eaf9ca0cfa4$export$4c7e6934714150e6 = $49d40eaf9ca0cfa4$var$MESSAGING_OPERATION_NAME, $49d40eaf9ca0cfa4$export$6f71f9711d666eb4 = $49d40eaf9ca0cfa4$var$MESSAGING_OPERATION_TYPE, $49d40eaf9ca0cfa4$export$2a3cd2bb71fb63a4 = $49d40eaf9ca0cfa4$var$MESSAGING_RABBITMQ_DESTINATION_ROUTING_KEY, $49d40eaf9ca0cfa4$export$55478a0b7d2ae98f = $49d40eaf9ca0cfa4$var$MESSAGING_SYSTEM, $49d40eaf9ca0cfa4$export$bed10c4da9b8eb0a = $49d40eaf9ca0cfa4$var$METHOD, $49d40eaf9ca0cfa4$export$a82607b6424c06c8 = $49d40eaf9ca0cfa4$var$MIDDLEWARE_NAME, $49d40eaf9ca0cfa4$export$6b081f3484c7f4e5 = $49d40eaf9ca0cfa4$var$NAVIGATION_ORIGIN, $49d40eaf9ca0cfa4$export$b7754d85fd39406c = $49d40eaf9ca0cfa4$var$NAVIGATION_ROUTE_ID, $49d40eaf9ca0cfa4$export$492856c046eb4728 = $49d40eaf9ca0cfa4$var$NAVIGATION_TYPE, $49d40eaf9ca0cfa4$export$c1678a2059fbe906 = $49d40eaf9ca0cfa4$var$NEL_ELAPSED_TIME, $49d40eaf9ca0cfa4$export$6d384a0bc1011c34 = $49d40eaf9ca0cfa4$var$NEL_PHASE, $49d40eaf9ca0cfa4$export$1499a7dbfc01e7d4 = $49d40eaf9ca0cfa4$var$NEL_REFERRER, $49d40eaf9ca0cfa4$export$cfcbff40019f0ff1 = $49d40eaf9ca0cfa4$var$NEL_SAMPLING_FUNCTION, $49d40eaf9ca0cfa4$export$27157b5f68e583af = $49d40eaf9ca0cfa4$var$NEL_TYPE, $49d40eaf9ca0cfa4$export$54bf5ed61532925d = $49d40eaf9ca0cfa4$var$NETWORK_CONNECTION_EFFECTIVE_TYPE, $49d40eaf9ca0cfa4$export$60ed0786292ace08 = $49d40eaf9ca0cfa4$var$NETWORK_CONNECTION_RTT, $49d40eaf9ca0cfa4$export$d770bfb8345e146 = $49d40eaf9ca0cfa4$var$NETWORK_CONNECTION_TYPE, $49d40eaf9ca0cfa4$export$bb73817f1290ad28 = $49d40eaf9ca0cfa4$var$NETWORK_LOCAL_ADDRESS, $49d40eaf9ca0cfa4$export$f201c980f2b75802 = $49d40eaf9ca0cfa4$var$NETWORK_LOCAL_PORT, $49d40eaf9ca0cfa4$export$b40e970572afd0ee = $49d40eaf9ca0cfa4$var$NETWORK_PEER_ADDRESS, $49d40eaf9ca0cfa4$export$8850630a3d343488 = $49d40eaf9ca0cfa4$var$NETWORK_PEER_PORT, $49d40eaf9ca0cfa4$export$fd0a39a918d6516f = $49d40eaf9ca0cfa4$var$NETWORK_PROTOCOL_NAME, $49d40eaf9ca0cfa4$export$e68ef41f8e0335bf = $49d40eaf9ca0cfa4$var$NETWORK_PROTOCOL_VERSION, $49d40eaf9ca0cfa4$export$5bff09650e762829 = $49d40eaf9ca0cfa4$var$NETWORK_TRANSPORT, $49d40eaf9ca0cfa4$export$21c1adce0e067f37 = $49d40eaf9ca0cfa4$var$NETWORK_TYPE, $49d40eaf9ca0cfa4$export$fed6ce86f48c84bc = $49d40eaf9ca0cfa4$var$NET_HOST_IP, $49d40eaf9ca0cfa4$export$500c2675137ac16e = $49d40eaf9ca0cfa4$var$NET_HOST_NAME, $49d40eaf9ca0cfa4$export$402c7728623fd8df = $49d40eaf9ca0cfa4$var$NET_HOST_PORT, $49d40eaf9ca0cfa4$export$15417259f4c0fe6b = $49d40eaf9ca0cfa4$var$NET_PEER_IP, $49d40eaf9ca0cfa4$export$2b3b7f579a727f45 = $49d40eaf9ca0cfa4$var$NET_PEER_NAME, $49d40eaf9ca0cfa4$export$514832a0b029734b = $49d40eaf9ca0cfa4$var$NET_PEER_PORT, $49d40eaf9ca0cfa4$export$b0522e6a14dec1a4 = $49d40eaf9ca0cfa4$var$NET_PROTOCOL_NAME, $49d40eaf9ca0cfa4$export$659ea19f71a7ee0b = $49d40eaf9ca0cfa4$var$NET_PROTOCOL_VERSION, $49d40eaf9ca0cfa4$export$1b61d972db315e73 = $49d40eaf9ca0cfa4$var$NET_SOCK_FAMILY, $49d40eaf9ca0cfa4$export$fb2970ee11a479ee = $49d40eaf9ca0cfa4$var$NET_SOCK_HOST_ADDR, $49d40eaf9ca0cfa4$export$920aceb2a8fad77e = $49d40eaf9ca0cfa4$var$NET_SOCK_HOST_PORT, $49d40eaf9ca0cfa4$export$48f8f6fbc999d187 = $49d40eaf9ca0cfa4$var$NET_SOCK_PEER_ADDR, $49d40eaf9ca0cfa4$export$eed590fa00a8223b = $49d40eaf9ca0cfa4$var$NET_SOCK_PEER_NAME, $49d40eaf9ca0cfa4$export$f2e5bb5cd4a130da = $49d40eaf9ca0cfa4$var$NET_SOCK_PEER_PORT, $49d40eaf9ca0cfa4$export$779ef03d633a9086 = $49d40eaf9ca0cfa4$var$NET_TRANSPORT, $49d40eaf9ca0cfa4$export$d98b87c8d53d0dbc = $49d40eaf9ca0cfa4$var$OS_BUILD, $49d40eaf9ca0cfa4$export$ca719aa57653a0a7 = $49d40eaf9ca0cfa4$var$OS_BUILD_ID, $49d40eaf9ca0cfa4$export$74b19c5f48270c05 = $49d40eaf9ca0cfa4$var$OS_DESCRIPTION, $49d40eaf9ca0cfa4$export$c351affe7e8098cb = $49d40eaf9ca0cfa4$var$OS_KERNEL_VERSION, $49d40eaf9ca0cfa4$export$be7cd6b3ae3ae765 = $49d40eaf9ca0cfa4$var$OS_NAME, $49d40eaf9ca0cfa4$export$ec182524c4c57275 = $49d40eaf9ca0cfa4$var$OS_RAW_DESCRIPTION, $49d40eaf9ca0cfa4$export$9e45758246a85b07 = $49d40eaf9ca0cfa4$var$OS_ROOTED, $49d40eaf9ca0cfa4$export$9fa5d5f0144954cb = $49d40eaf9ca0cfa4$var$OS_THEME, $49d40eaf9ca0cfa4$export$e66ba5bc4b978023 = $49d40eaf9ca0cfa4$var$OS_TYPE, $49d40eaf9ca0cfa4$export$2306e23cc611a36d = $49d40eaf9ca0cfa4$var$OS_VERSION, $49d40eaf9ca0cfa4$export$144f8c1fe01428db = $49d40eaf9ca0cfa4$var$OTEL_KIND, $49d40eaf9ca0cfa4$export$f303b2744d52121c = $49d40eaf9ca0cfa4$var$OTEL_SCOPE_NAME, $49d40eaf9ca0cfa4$export$866b2dbc7bf18ce6 = $49d40eaf9ca0cfa4$var$OTEL_SCOPE_VERSION, $49d40eaf9ca0cfa4$export$b4c85774878b4841 = $49d40eaf9ca0cfa4$var$OTEL_STATUS_CODE, $49d40eaf9ca0cfa4$export$1c967a71bc9a3077 = $49d40eaf9ca0cfa4$var$OTEL_STATUS_DESCRIPTION, $49d40eaf9ca0cfa4$export$5e3884a35a19eb90 = $49d40eaf9ca0cfa4$var$PARAMS_KEY, $49d40eaf9ca0cfa4$export$6e7ff99bb3259573 = $49d40eaf9ca0cfa4$var$PARAMS_KEY_BASE, $49d40eaf9ca0cfa4$export$7c932cba2d9e7a7 = $49d40eaf9ca0cfa4$var$PERFORMANCE_ACTIVATIONSTART, $49d40eaf9ca0cfa4$export$94091942edce0667 = $49d40eaf9ca0cfa4$var$PERFORMANCE_TIMEORIGIN, $49d40eaf9ca0cfa4$export$3671a8a524706a9d = $49d40eaf9ca0cfa4$var$PREVIOUS_ROUTE, $49d40eaf9ca0cfa4$export$c288888dc82d233f = $49d40eaf9ca0cfa4$var$PROCESS_COMMAND_ARGS, $49d40eaf9ca0cfa4$export$8ff188536cebc35 = $49d40eaf9ca0cfa4$var$PROCESS_EXECUTABLE_NAME, $49d40eaf9ca0cfa4$export$6407d78968c0eabe = $49d40eaf9ca0cfa4$var$PROCESS_PID, $49d40eaf9ca0cfa4$export$43e9fb9ec28d9743 = $49d40eaf9ca0cfa4$var$PROCESS_RUNTIME_DESCRIPTION, $49d40eaf9ca0cfa4$export$26f31d5c5c201739 = $49d40eaf9ca0cfa4$var$PROCESS_RUNTIME_ENGINE_NAME, $49d40eaf9ca0cfa4$export$bff85124d2d35b93 = $49d40eaf9ca0cfa4$var$PROCESS_RUNTIME_ENGINE_VERSION, $49d40eaf9ca0cfa4$export$495c671ed5a6408c = $49d40eaf9ca0cfa4$var$PROCESS_RUNTIME_NAME, $49d40eaf9ca0cfa4$export$54b3d4d5548c35c3 = $49d40eaf9ca0cfa4$var$PROCESS_RUNTIME_VERSION, $49d40eaf9ca0cfa4$export$2954db6444fe1fa8 = $49d40eaf9ca0cfa4$var$QUERY_KEY, $49d40eaf9ca0cfa4$export$15c1c974d16dd678 = $49d40eaf9ca0cfa4$var$QUERY_KEY_BASE, $49d40eaf9ca0cfa4$export$9be2ae89a1eac217 = $49d40eaf9ca0cfa4$var$REACT_VERSION, $49d40eaf9ca0cfa4$export$5c698591c0e586a2 = $49d40eaf9ca0cfa4$var$RELEASE, $49d40eaf9ca0cfa4$export$b711f2bb9c9a848a = $49d40eaf9ca0cfa4$var$REMIX_ACTION_FORM_DATA_KEY, $49d40eaf9ca0cfa4$export$1d3a8501efd30213 = $49d40eaf9ca0cfa4$var$REMIX_ACTION_FORM_DATA_KEY_BASE, $49d40eaf9ca0cfa4$export$cebaf684ced5a2c9 = $49d40eaf9ca0cfa4$var$REPLAY_ID, $49d40eaf9ca0cfa4$export$d4c658ecdcb7c78c = $49d40eaf9ca0cfa4$var$RESOURCE_DEPLOYMENT_ENVIRONMENT, $49d40eaf9ca0cfa4$export$b1b162b01baeb044 = $49d40eaf9ca0cfa4$var$RESOURCE_DEPLOYMENT_ENVIRONMENT_NAME, $49d40eaf9ca0cfa4$export$8be2d593d7f88ed8 = $49d40eaf9ca0cfa4$var$RESOURCE_RENDER_BLOCKING_STATUS, $49d40eaf9ca0cfa4$export$dbd0a3528a97ccc0 = $49d40eaf9ca0cfa4$var$ROUTE, $49d40eaf9ca0cfa4$export$66581dc6d3d083d1 = $49d40eaf9ca0cfa4$var$RPC_GRPC_STATUS_CODE, $49d40eaf9ca0cfa4$export$e545f99e7abcc499 = $49d40eaf9ca0cfa4$var$RPC_METHOD, $49d40eaf9ca0cfa4$export$7e1af5787f8c4aaa = $49d40eaf9ca0cfa4$var$RPC_RESPONSE_STATUS_CODE, $49d40eaf9ca0cfa4$export$186c94c351c54768 = $49d40eaf9ca0cfa4$var$RPC_SERVICE, $49d40eaf9ca0cfa4$export$2e3fd8dfcb16fe0c = $49d40eaf9ca0cfa4$var$RPC_SYSTEM, $49d40eaf9ca0cfa4$export$7eeeceaa1dbd7cd5 = $49d40eaf9ca0cfa4$var$RPC_SYSTEM_NAME, $49d40eaf9ca0cfa4$export$9d5bffdff936d554 = $49d40eaf9ca0cfa4$var$RUNTIME_BUILD, $49d40eaf9ca0cfa4$export$dc3a801c9a2c5b79 = $49d40eaf9ca0cfa4$var$RUNTIME_NAME, $49d40eaf9ca0cfa4$export$27933a9557f87e98 = $49d40eaf9ca0cfa4$var$RUNTIME_RAW_DESCRIPTION, $49d40eaf9ca0cfa4$export$eefa737b40a0d535 = $49d40eaf9ca0cfa4$var$RUNTIME_VERSION, $49d40eaf9ca0cfa4$export$92740ffbcb02553b = $49d40eaf9ca0cfa4$var$SCORE_KEY, $49d40eaf9ca0cfa4$export$500e89753f9f1008 = $49d40eaf9ca0cfa4$var$SCORE_KEY_BASE, $49d40eaf9ca0cfa4$export$d91a18e47fdddefd = $49d40eaf9ca0cfa4$var$SCORE_RATIO_KEY, $49d40eaf9ca0cfa4$export$eccbe6f20884ea7f = $49d40eaf9ca0cfa4$var$SCORE_RATIO_KEY_BASE, $49d40eaf9ca0cfa4$export$9e24f11d79141afb = $49d40eaf9ca0cfa4$var$SCORE_TOTAL, $49d40eaf9ca0cfa4$export$f0b96ad9586f8887 = $49d40eaf9ca0cfa4$var$SCORE_WEIGHT_KEY, $49d40eaf9ca0cfa4$export$8a92ed5d436a85c6 = $49d40eaf9ca0cfa4$var$SCORE_WEIGHT_KEY_BASE, $49d40eaf9ca0cfa4$export$edd59acdf7e86a71 = $49d40eaf9ca0cfa4$var$SENTRY_ACTION, $49d40eaf9ca0cfa4$export$ae81a1ae71952d50 = $49d40eaf9ca0cfa4$var$SENTRY_BROWSER_NAME, $49d40eaf9ca0cfa4$export$6101470cd57eac1b = $49d40eaf9ca0cfa4$var$SENTRY_BROWSER_VERSION, $49d40eaf9ca0cfa4$export$452c0aee9673fe67 = $49d40eaf9ca0cfa4$var$SENTRY_CANCELLATION_REASON, $49d40eaf9ca0cfa4$export$773dddd1e8667756 = $49d40eaf9ca0cfa4$var$SENTRY_CATEGORY, $49d40eaf9ca0cfa4$export$98815f8579a64a90 = $49d40eaf9ca0cfa4$var$SENTRY_CLIENT_SAMPLE_RATE, $49d40eaf9ca0cfa4$export$7bc4e27428665019 = $49d40eaf9ca0cfa4$var$SENTRY_DESCRIPTION, $49d40eaf9ca0cfa4$export$e7d7477fa9057ee2 = $49d40eaf9ca0cfa4$var$SENTRY_DIST, $49d40eaf9ca0cfa4$export$1f4267a3fc018448 = $49d40eaf9ca0cfa4$var$SENTRY_DOMAIN, $49d40eaf9ca0cfa4$export$c171cae150389952 = $49d40eaf9ca0cfa4$var$SENTRY_DSC_ENVIRONMENT, $49d40eaf9ca0cfa4$export$d9bb35e957b22c72 = $49d40eaf9ca0cfa4$var$SENTRY_DSC_PROJECT_ID, $49d40eaf9ca0cfa4$export$b3508a2c95f74e3d = $49d40eaf9ca0cfa4$var$SENTRY_DSC_PUBLIC_KEY, $49d40eaf9ca0cfa4$export$20bb272f4d21532d = $49d40eaf9ca0cfa4$var$SENTRY_DSC_RELEASE, $49d40eaf9ca0cfa4$export$d7e64fbd0102ce90 = $49d40eaf9ca0cfa4$var$SENTRY_DSC_SAMPLED, $49d40eaf9ca0cfa4$export$c17eae7e86dbba3c = $49d40eaf9ca0cfa4$var$SENTRY_DSC_SAMPLE_RATE, $49d40eaf9ca0cfa4$export$349603c0a9165744 = $49d40eaf9ca0cfa4$var$SENTRY_DSC_TRACE_ID, $49d40eaf9ca0cfa4$export$4dadf693741f0283 = $49d40eaf9ca0cfa4$var$SENTRY_DSC_TRANSACTION, $49d40eaf9ca0cfa4$export$6377864d12f7eeb3 = $49d40eaf9ca0cfa4$var$SENTRY_ENVIRONMENT, $49d40eaf9ca0cfa4$export$ba081af9585ed4 = $49d40eaf9ca0cfa4$var$SENTRY_EXCLUSIVE_TIME, $49d40eaf9ca0cfa4$export$7841dacb241485d0 = $49d40eaf9ca0cfa4$var$SENTRY_GRAPHQL_OPERATION, $49d40eaf9ca0cfa4$export$52c7044cf6301362 = $49d40eaf9ca0cfa4$var$SENTRY_GROUP, $49d40eaf9ca0cfa4$export$56ea1c9e44590e20 = $49d40eaf9ca0cfa4$var$SENTRY_HTTP_PREFETCH, $49d40eaf9ca0cfa4$export$7626e389d05f4c36 = $49d40eaf9ca0cfa4$var$SENTRY_IDLE_SPAN_FINISH_REASON, $49d40eaf9ca0cfa4$export$5e0a48187329b2e7 = $49d40eaf9ca0cfa4$var$SENTRY_IS_REMOTE, $49d40eaf9ca0cfa4$export$c322b150d7667841 = $49d40eaf9ca0cfa4$var$SENTRY_KIND, $49d40eaf9ca0cfa4$export$4a4797d3c962f753 = $49d40eaf9ca0cfa4$var$SENTRY_MAIN_THREAD, $49d40eaf9ca0cfa4$export$767524d5e72e2645 = $49d40eaf9ca0cfa4$var$SENTRY_MESSAGE_PARAMETER_KEY, $49d40eaf9ca0cfa4$export$497354ca7b0ee666 = $49d40eaf9ca0cfa4$var$SENTRY_MESSAGE_TEMPLATE, $49d40eaf9ca0cfa4$export$cbdc4ad11118116a = $49d40eaf9ca0cfa4$var$SENTRY_METRIC_SOURCE, $49d40eaf9ca0cfa4$export$5b890de778c4c2fe = $49d40eaf9ca0cfa4$var$SENTRY_MOBILE, $49d40eaf9ca0cfa4$export$a78d9803b5e0a83e = $49d40eaf9ca0cfa4$var$SENTRY_MODULE_KEY, $49d40eaf9ca0cfa4$export$df1b536467b3992a = $49d40eaf9ca0cfa4$var$SENTRY_MODULE_KEY_BASE, $49d40eaf9ca0cfa4$export$73104a329e205998 = $49d40eaf9ca0cfa4$var$SENTRY_NEXTJS_SSR_FUNCTION_ROUTE, $49d40eaf9ca0cfa4$export$5740e3da55330b0a = $49d40eaf9ca0cfa4$var$SENTRY_NEXTJS_SSR_FUNCTION_TYPE, $49d40eaf9ca0cfa4$export$8dcc2d92ff6d65da = $49d40eaf9ca0cfa4$var$SENTRY_NORMALIZED_DB_QUERY, $49d40eaf9ca0cfa4$export$e5f1321e53e24810 = $49d40eaf9ca0cfa4$var$SENTRY_NORMALIZED_DB_QUERY_HASH, $49d40eaf9ca0cfa4$export$56dd3098cbca7c8a = $49d40eaf9ca0cfa4$var$SENTRY_NORMALIZED_DESCRIPTION, $49d40eaf9ca0cfa4$export$aa7aff70e4380665 = $49d40eaf9ca0cfa4$var$SENTRY_OBSERVED_TIMESTAMP_NANOS, $49d40eaf9ca0cfa4$export$dacb7d452aa6bcaf = $49d40eaf9ca0cfa4$var$SENTRY_OP, $49d40eaf9ca0cfa4$export$15dfc6c5e8f9baf6 = $49d40eaf9ca0cfa4$var$SENTRY_ORIGIN, $49d40eaf9ca0cfa4$export$91ad03bba7909fb5 = $49d40eaf9ca0cfa4$var$SENTRY_PLATFORM, $49d40eaf9ca0cfa4$export$86128e6c0ab71d64 = $49d40eaf9ca0cfa4$var$SENTRY_PROFILER_ID, $49d40eaf9ca0cfa4$export$745b60c4819aec1d = $49d40eaf9ca0cfa4$var$SENTRY_PROFILE_ID, $49d40eaf9ca0cfa4$export$d2c893bfac1da9a1 = $49d40eaf9ca0cfa4$var$SENTRY_RELEASE, $49d40eaf9ca0cfa4$export$1c14ad02f9534b19 = $49d40eaf9ca0cfa4$var$SENTRY_REPLAY_ID, $49d40eaf9ca0cfa4$export$db3cb63e0594d014 = $49d40eaf9ca0cfa4$var$SENTRY_REPLAY_IS_BUFFERING, $49d40eaf9ca0cfa4$export$a65c9a0eba2c222d = $49d40eaf9ca0cfa4$var$SENTRY_REPORT_EVENT, $49d40eaf9ca0cfa4$export$68dbcca9c0e339ec = $49d40eaf9ca0cfa4$var$SENTRY_SDK_INTEGRATIONS, $49d40eaf9ca0cfa4$export$d59b669d4bb3f006 = $49d40eaf9ca0cfa4$var$SENTRY_SDK_NAME, $49d40eaf9ca0cfa4$export$4d88d347aa9667fc = $49d40eaf9ca0cfa4$var$SENTRY_SDK_VERSION, $49d40eaf9ca0cfa4$export$9943ffdcaa4bc506 = $49d40eaf9ca0cfa4$var$SENTRY_SEGMENT_ID, $49d40eaf9ca0cfa4$export$d4f25b923533dbba = $49d40eaf9ca0cfa4$var$SENTRY_SEGMENT_NAME, $49d40eaf9ca0cfa4$export$35f3396a1cdeea45 = $49d40eaf9ca0cfa4$var$SENTRY_SERVER_SAMPLE_RATE, $49d40eaf9ca0cfa4$export$80e399da474bc98d = $49d40eaf9ca0cfa4$var$SENTRY_SOURCE, $49d40eaf9ca0cfa4$export$e01809e2dbceac35 = $49d40eaf9ca0cfa4$var$SENTRY_SPAN_SOURCE, $49d40eaf9ca0cfa4$export$41900d5c4e8a9c68 = $49d40eaf9ca0cfa4$var$SENTRY_STATUS, $49d40eaf9ca0cfa4$export$362bb1cb0bb5ca03 = $49d40eaf9ca0cfa4$var$SENTRY_STATUS_CODE, $49d40eaf9ca0cfa4$export$6803ac54f919d9cc = $49d40eaf9ca0cfa4$var$SENTRY_STATUS_MESSAGE, $49d40eaf9ca0cfa4$export$72f5b47540331169 = $49d40eaf9ca0cfa4$var$SENTRY_SVELTEKIT_NAVIGATION_FROM, $49d40eaf9ca0cfa4$export$6c61a8c9aa5305cb = $49d40eaf9ca0cfa4$var$SENTRY_SVELTEKIT_NAVIGATION_TO, $49d40eaf9ca0cfa4$export$6b5244c457b68e65 = $49d40eaf9ca0cfa4$var$SENTRY_SVELTEKIT_NAVIGATION_TYPE, $49d40eaf9ca0cfa4$export$b7bd0c9a886f3414 = $49d40eaf9ca0cfa4$var$SENTRY_THREAD_ID, $49d40eaf9ca0cfa4$export$6b77f2bacac7c93d = $49d40eaf9ca0cfa4$var$SENTRY_TIMESTAMP_SEQUENCE, $49d40eaf9ca0cfa4$export$ddbc15c0e8e8a7ea = $49d40eaf9ca0cfa4$var$SENTRY_TRACE_LIFECYCLE, $49d40eaf9ca0cfa4$export$feb4fe753df28a82 = $49d40eaf9ca0cfa4$var$SENTRY_TRACE_PARENT_SPAN_ID, $49d40eaf9ca0cfa4$export$d6267756132e2175 = $49d40eaf9ca0cfa4$var$SENTRY_TRACE_STATUS, $49d40eaf9ca0cfa4$export$570ac5a3fd7e6cc6 = $49d40eaf9ca0cfa4$var$SENTRY_TRANSACTION, $49d40eaf9ca0cfa4$export$5b9a0015e1c530ed = $49d40eaf9ca0cfa4$var$SENTRY_USER_EMAIL, $49d40eaf9ca0cfa4$export$8bbff71c84508218 = $49d40eaf9ca0cfa4$var$SENTRY_USER_GEO_CITY, $49d40eaf9ca0cfa4$export$b55aa07a514a2430 = $49d40eaf9ca0cfa4$var$SENTRY_USER_GEO_COUNTRY_CODE, $49d40eaf9ca0cfa4$export$9927ad09f7c084dc = $49d40eaf9ca0cfa4$var$SENTRY_USER_GEO_REGION, $49d40eaf9ca0cfa4$export$52a07a35ff8ec6b6 = $49d40eaf9ca0cfa4$var$SENTRY_USER_GEO_SUBDIVISION, $49d40eaf9ca0cfa4$export$a10d277c42e6cae3 = $49d40eaf9ca0cfa4$var$SENTRY_USER_ID, $49d40eaf9ca0cfa4$export$cdc0ce5c66182801 = $49d40eaf9ca0cfa4$var$SENTRY_USER_IP, $49d40eaf9ca0cfa4$export$2504d4bd698dd962 = $49d40eaf9ca0cfa4$var$SENTRY_USER_USERNAME, $49d40eaf9ca0cfa4$export$9dc86f3b876e96ef = $49d40eaf9ca0cfa4$var$SERVER_ADDRESS, $49d40eaf9ca0cfa4$export$70ff7865f52549ae = $49d40eaf9ca0cfa4$var$SERVER_NAME, $49d40eaf9ca0cfa4$export$f77b53a42be6e6fd = $49d40eaf9ca0cfa4$var$SERVER_PORT, $49d40eaf9ca0cfa4$export$818eb7ab11414506 = $49d40eaf9ca0cfa4$var$SERVICE_NAME, $49d40eaf9ca0cfa4$export$829ef6b2e59d984d = $49d40eaf9ca0cfa4$var$SERVICE_VERSION, $49d40eaf9ca0cfa4$export$b30f4cb52c088a26 = $49d40eaf9ca0cfa4$var$SESSION_ID, $49d40eaf9ca0cfa4$export$335eace0ff1771cd = $49d40eaf9ca0cfa4$var$STALL_PERCENTAGE, $49d40eaf9ca0cfa4$export$374d88a2025416ac = $49d40eaf9ca0cfa4$var$STALL_TOTAL_TIME, $49d40eaf9ca0cfa4$export$bb7a91303551eb37 = $49d40eaf9ca0cfa4$var$STATE_TYPE, $49d40eaf9ca0cfa4$export$f132ea291a7db56b = $49d40eaf9ca0cfa4$var$THREAD_ID, $49d40eaf9ca0cfa4$export$f0abd4170bbd2468 = $49d40eaf9ca0cfa4$var$THREAD_NAME, $49d40eaf9ca0cfa4$export$50d00a157dc08581 = $49d40eaf9ca0cfa4$var$TIMBER_TAG, $49d40eaf9ca0cfa4$export$484576567a98833f = $49d40eaf9ca0cfa4$var$TIME_TO_FULL_DISPLAY, $49d40eaf9ca0cfa4$export$ec9e491e475d0c97 = $49d40eaf9ca0cfa4$var$TIME_TO_INITIAL_DISPLAY, $49d40eaf9ca0cfa4$export$a86c59c10992220f = $49d40eaf9ca0cfa4$var$TRANSACTION, $49d40eaf9ca0cfa4$export$e12f06597e992fde = $49d40eaf9ca0cfa4$var$TRPC_PROCEDURE_PATH, $49d40eaf9ca0cfa4$export$7ec54678ba28ea59 = $49d40eaf9ca0cfa4$var$TRPC_PROCEDURE_TYPE, $49d40eaf9ca0cfa4$export$433ba14c16717110 = $49d40eaf9ca0cfa4$var$TTFB, $49d40eaf9ca0cfa4$export$309ee349b8a537f = $49d40eaf9ca0cfa4$var$TTFB_REQUESTTIME, $49d40eaf9ca0cfa4$export$b87f371cbc396fcf = $49d40eaf9ca0cfa4$var$TYPE, $49d40eaf9ca0cfa4$export$60050fc49fe0e7e2 = $49d40eaf9ca0cfa4$var$UI_COMPONENT_NAME, $49d40eaf9ca0cfa4$export$348c8e2b37f276cd = $49d40eaf9ca0cfa4$var$UI_CONTRIBUTES_TO_TTFD, $49d40eaf9ca0cfa4$export$7f47e8a8b2d97cb2 = $49d40eaf9ca0cfa4$var$UI_CONTRIBUTES_TO_TTID, $49d40eaf9ca0cfa4$export$50d5adc4b543ce95 = $49d40eaf9ca0cfa4$var$UI_ELEMENT_HEIGHT, $49d40eaf9ca0cfa4$export$9221f1d2c934d9f = $49d40eaf9ca0cfa4$var$UI_ELEMENT_ID, $49d40eaf9ca0cfa4$export$3a56578b3ae09a02 = $49d40eaf9ca0cfa4$var$UI_ELEMENT_IDENTIFIER, $49d40eaf9ca0cfa4$export$e47b8dab9466c895 = $49d40eaf9ca0cfa4$var$UI_ELEMENT_LOAD_TIME, $49d40eaf9ca0cfa4$export$4ca52f75cf4889c5 = $49d40eaf9ca0cfa4$var$UI_ELEMENT_PAINT_TYPE, $49d40eaf9ca0cfa4$export$7343d7d72195067f = $49d40eaf9ca0cfa4$var$UI_ELEMENT_RENDER_TIME, $49d40eaf9ca0cfa4$export$f334f32f8d4d8063 = $49d40eaf9ca0cfa4$var$UI_ELEMENT_TYPE, $49d40eaf9ca0cfa4$export$c7bf2089e89a217c = $49d40eaf9ca0cfa4$var$UI_ELEMENT_URL, $49d40eaf9ca0cfa4$export$f514f97553a434b2 = $49d40eaf9ca0cfa4$var$UI_ELEMENT_WIDTH, $49d40eaf9ca0cfa4$export$61abde59b50deb8e = "url", $49d40eaf9ca0cfa4$export$5a5ce44f9fb51f93 = $49d40eaf9ca0cfa4$var$URL_DOMAIN, $49d40eaf9ca0cfa4$export$7044ea8d89b6f59d = $49d40eaf9ca0cfa4$var$URL_FRAGMENT, $49d40eaf9ca0cfa4$export$40eacf1a072c9dbd = $49d40eaf9ca0cfa4$var$URL_FULL, $49d40eaf9ca0cfa4$export$4c1fa0ac0eff2ac = $49d40eaf9ca0cfa4$var$URL_PATH, $49d40eaf9ca0cfa4$export$5bee9450fe31dde1 = $49d40eaf9ca0cfa4$var$URL_PATH_PARAMETER_KEY, $49d40eaf9ca0cfa4$export$d0b571fb4406d953 = $49d40eaf9ca0cfa4$var$URL_PATH_PARAMETER_KEY_BASE, $49d40eaf9ca0cfa4$export$258b370e6c2b85d5 = $49d40eaf9ca0cfa4$var$URL_PORT, $49d40eaf9ca0cfa4$export$dc5e5523da291a4b = $49d40eaf9ca0cfa4$var$URL_QUERY, $49d40eaf9ca0cfa4$export$fd5a8904ab5abfe0 = $49d40eaf9ca0cfa4$var$URL_SAME_ORIGIN, $49d40eaf9ca0cfa4$export$1350d8937b0f26fb = $49d40eaf9ca0cfa4$var$URL_SCHEME, $49d40eaf9ca0cfa4$export$2a045f777fb349a8 = $49d40eaf9ca0cfa4$var$URL_TEMPLATE, $49d40eaf9ca0cfa4$export$8bb874585539a88f = $49d40eaf9ca0cfa4$var$USER_AGENT_ORIGINAL, $49d40eaf9ca0cfa4$export$17d3a50785727199 = $49d40eaf9ca0cfa4$var$USER_EMAIL, $49d40eaf9ca0cfa4$export$2931c570009689e = $49d40eaf9ca0cfa4$var$USER_FULL_NAME, $49d40eaf9ca0cfa4$export$199cbcedee735a43 = $49d40eaf9ca0cfa4$var$USER_GEO_CITY, $49d40eaf9ca0cfa4$export$4ba5bf9d4e3ed862 = $49d40eaf9ca0cfa4$var$USER_GEO_COUNTRY_CODE, $49d40eaf9ca0cfa4$export$674c01ec2f0b89c3 = $49d40eaf9ca0cfa4$var$USER_GEO_REGION, $49d40eaf9ca0cfa4$export$bda1686739fd61c7 = $49d40eaf9ca0cfa4$var$USER_GEO_SUBDIVISION, $49d40eaf9ca0cfa4$export$8d804148f485d54c = $49d40eaf9ca0cfa4$var$USER_HASH, $49d40eaf9ca0cfa4$export$212a8f1ea37518bd = $49d40eaf9ca0cfa4$var$USER_ID, $49d40eaf9ca0cfa4$export$c9ac0fee28245883 = $49d40eaf9ca0cfa4$var$USER_IP_ADDRESS, $49d40eaf9ca0cfa4$export$77078610759fe5f6 = $49d40eaf9ca0cfa4$var$USER_NAME, $49d40eaf9ca0cfa4$export$7c6317deeec7a6c1 = $49d40eaf9ca0cfa4$var$USER_ROLES, $49d40eaf9ca0cfa4$export$877ebf2e4ad81f03 = $49d40eaf9ca0cfa4$var$VERCEL_BRANCH, $49d40eaf9ca0cfa4$export$70b2343945496e1f = $49d40eaf9ca0cfa4$var$VERCEL_BUILD_ID, $49d40eaf9ca0cfa4$export$8415b56d2c6d2b1d = $49d40eaf9ca0cfa4$var$VERCEL_DEPLOYMENT_ID, $49d40eaf9ca0cfa4$export$cc81114a03caab18 = $49d40eaf9ca0cfa4$var$VERCEL_DESTINATION, $49d40eaf9ca0cfa4$export$bc14eb892daceb23 = $49d40eaf9ca0cfa4$var$VERCEL_EDGE_TYPE, $49d40eaf9ca0cfa4$export$3c973217450c3e9d = $49d40eaf9ca0cfa4$var$VERCEL_ENTRYPOINT, $49d40eaf9ca0cfa4$export$582c0b730ff1ddb9 = $49d40eaf9ca0cfa4$var$VERCEL_EXECUTION_REGION, $49d40eaf9ca0cfa4$export$b3edfb545b65f1c5 = $49d40eaf9ca0cfa4$var$VERCEL_ID, $49d40eaf9ca0cfa4$export$2593317d8731841c = $49d40eaf9ca0cfa4$var$VERCEL_JA3_DIGEST, $49d40eaf9ca0cfa4$export$8bb5bc1732aa41f = $49d40eaf9ca0cfa4$var$VERCEL_JA4_DIGEST, $49d40eaf9ca0cfa4$export$74a79c98b110b5b9 = $49d40eaf9ca0cfa4$var$VERCEL_LOG_TYPE, $49d40eaf9ca0cfa4$export$26461b03281b4db4 = $49d40eaf9ca0cfa4$var$VERCEL_PATH, $49d40eaf9ca0cfa4$export$eaea590d6d3dd93c = $49d40eaf9ca0cfa4$var$VERCEL_PROJECT_ID, $49d40eaf9ca0cfa4$export$af45365f70099379 = $49d40eaf9ca0cfa4$var$VERCEL_PROJECT_NAME, $49d40eaf9ca0cfa4$export$a49e732d34d5ba9b = $49d40eaf9ca0cfa4$var$VERCEL_PROXY_CACHE_ID, $49d40eaf9ca0cfa4$export$7c147fe246bc8bd3 = $49d40eaf9ca0cfa4$var$VERCEL_PROXY_CLIENT_IP, $49d40eaf9ca0cfa4$export$e5111b6070e1ee9e = $49d40eaf9ca0cfa4$var$VERCEL_PROXY_HOST, $49d40eaf9ca0cfa4$export$591cbfd403f8c8d = $49d40eaf9ca0cfa4$var$VERCEL_PROXY_LAMBDA_REGION, $49d40eaf9ca0cfa4$export$b1388db955bbb885 = $49d40eaf9ca0cfa4$var$VERCEL_PROXY_METHOD, $49d40eaf9ca0cfa4$export$e898d0e9e211abd9 = $49d40eaf9ca0cfa4$var$VERCEL_PROXY_PATH, $49d40eaf9ca0cfa4$export$ab6fee0e8a6ee069 = $49d40eaf9ca0cfa4$var$VERCEL_PROXY_PATH_TYPE, $49d40eaf9ca0cfa4$export$9786ad94c199ffbb = $49d40eaf9ca0cfa4$var$VERCEL_PROXY_PATH_TYPE_VARIANT, $49d40eaf9ca0cfa4$export$269890524eed693b = $49d40eaf9ca0cfa4$var$VERCEL_PROXY_REFERER, $49d40eaf9ca0cfa4$export$2ec623a8212d6b64 = $49d40eaf9ca0cfa4$var$VERCEL_PROXY_REGION, $49d40eaf9ca0cfa4$export$30e7673b01ff994e = $49d40eaf9ca0cfa4$var$VERCEL_PROXY_RESPONSE_BYTE_SIZE, $49d40eaf9ca0cfa4$export$9ea93477840812bf = $49d40eaf9ca0cfa4$var$VERCEL_PROXY_SCHEME, $49d40eaf9ca0cfa4$export$a6da0c365670c430 = $49d40eaf9ca0cfa4$var$VERCEL_PROXY_STATUS_CODE, $49d40eaf9ca0cfa4$export$7986b22da43f2885 = $49d40eaf9ca0cfa4$var$VERCEL_PROXY_TIMESTAMP, $49d40eaf9ca0cfa4$export$a9f943c7ceb3b42f = $49d40eaf9ca0cfa4$var$VERCEL_PROXY_USER_AGENT, $49d40eaf9ca0cfa4$export$dfe49501efcdffce = $49d40eaf9ca0cfa4$var$VERCEL_PROXY_VERCEL_CACHE, $49d40eaf9ca0cfa4$export$be465f50c92eb01d = $49d40eaf9ca0cfa4$var$VERCEL_PROXY_VERCEL_ID, $49d40eaf9ca0cfa4$export$c138d1796bb34999 = $49d40eaf9ca0cfa4$var$VERCEL_PROXY_WAF_ACTION, $49d40eaf9ca0cfa4$export$85a0016690a0ccf2 = $49d40eaf9ca0cfa4$var$VERCEL_PROXY_WAF_RULE_ID, $49d40eaf9ca0cfa4$export$883acab36ede4bfa = $49d40eaf9ca0cfa4$var$VERCEL_REQUEST_ID, $49d40eaf9ca0cfa4$export$9cfc88d203f9cdf1 = $49d40eaf9ca0cfa4$var$VERCEL_SOURCE, $49d40eaf9ca0cfa4$export$b3c6c599110d7bab = $49d40eaf9ca0cfa4$var$VERCEL_STATUS_CODE, $49d40eaf9ca0cfa4$export$247839c65766758 = $49d40eaf9ca0cfa4$var$_AWS_KINESIS_STREAM_NAME, $49d40eaf9ca0cfa4$export$f4d52b02df927d54 = $49d40eaf9ca0cfa4$var$_AWS_REQUEST_ID, $49d40eaf9ca0cfa4$export$df30ee8c5b5f1989 = $49d40eaf9ca0cfa4$var$_HTTP_REQUEST_METHOD, $49d40eaf9ca0cfa4$export$268a117c860fca6d = $49d40eaf9ca0cfa4$var$_SENTRY_SEGMENT_ID; //# sourceMappingURL=attributes.cjs.map

});



parcelRegister("1tl8I", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $79m2C = parcelRequire("79m2C");

var $hiZR1 = parcelRequire("hiZR1");

var $dsI2h = parcelRequire("dsI2h");

var $kBDP8 = parcelRequire("kBDP8");

var $4gyod = parcelRequire("4gyod");

var $dzfKZ = parcelRequire("dzfKZ");

var $6JkyB = parcelRequire("6JkyB");

var $1rqgb = parcelRequire("1rqgb");

var $fsIRO = parcelRequire("fsIRO");

var $ihsl1 = parcelRequire("ihsl1");

var $eP8Ri = parcelRequire("eP8Ri");
function $1128e5c02b7a2786$var$captureException(exception, hint) {
    return $79m2C.getCurrentScope().captureException(exception, $1rqgb.parseEventHintOrCaptureContext(hint));
}
function $1128e5c02b7a2786$var$captureMessage(message, captureContext) {
    const level = typeof captureContext === "string" ? captureContext : void 0;
    const hint = typeof captureContext !== "string" ? {
        captureContext: captureContext
    } : void 0;
    return $79m2C.getCurrentScope().captureMessage(message, level, hint);
}
function $1128e5c02b7a2786$var$captureEvent(event, hint) {
    return $79m2C.getCurrentScope().captureEvent(event, hint);
}
function $1128e5c02b7a2786$var$setContext(name, context) {
    $79m2C.getIsolationScope().setContext(name, context);
}
function $1128e5c02b7a2786$var$setExtras(extras) {
    $79m2C.getIsolationScope().setExtras(extras);
}
function $1128e5c02b7a2786$var$setExtra(key, extra) {
    $79m2C.getIsolationScope().setExtra(key, extra);
}
function $1128e5c02b7a2786$var$setTags(tags) {
    $79m2C.getIsolationScope().setTags(tags);
}
function $1128e5c02b7a2786$var$setTag(key, value) {
    $79m2C.getIsolationScope().setTag(key, value);
}
function $1128e5c02b7a2786$var$setAttributes(attributes) {
    $79m2C.getIsolationScope().setAttributes(attributes);
}
function $1128e5c02b7a2786$var$setAttribute(key, value) {
    $79m2C.getIsolationScope().setAttribute(key, value);
}
function $1128e5c02b7a2786$var$setUser(user) {
    $79m2C.getIsolationScope().setUser(user);
}
function $1128e5c02b7a2786$var$setConversationId(conversationId) {
    $79m2C.getIsolationScope().setConversationId(conversationId);
}
function $1128e5c02b7a2786$var$lastEventId() {
    return $79m2C.getIsolationScope().lastEventId();
}
function $1128e5c02b7a2786$var$captureCheckIn(checkIn, upsertMonitorConfig) {
    const scope = $79m2C.getCurrentScope();
    const client = $79m2C.getClient();
    if (!client) $hiZR1.DEBUG_BUILD && $4gyod.debug.warn("Cannot capture check-in. No client defined.");
    else if (!client.captureCheckIn) $hiZR1.DEBUG_BUILD && $4gyod.debug.warn("Cannot capture check-in. Client does not support sending check-ins.");
    else return client.captureCheckIn(checkIn, upsertMonitorConfig, scope);
    return $6JkyB.uuid4();
}
function $1128e5c02b7a2786$var$withMonitor(monitorSlug, callback, upsertMonitorConfig) {
    function runCallback() {
        const checkInId = $1128e5c02b7a2786$var$captureCheckIn({
            monitorSlug: monitorSlug,
            status: "in_progress"
        }, upsertMonitorConfig);
        const now = $ihsl1.timestampInSeconds();
        function finishCheckIn(status) {
            $1128e5c02b7a2786$var$captureCheckIn({
                monitorSlug: monitorSlug,
                status: status,
                checkInId: checkInId,
                duration: $ihsl1.timestampInSeconds() - now
            });
        }
        let maybePromiseResult;
        try {
            maybePromiseResult = callback();
        } catch (e) {
            finishCheckIn("error");
            throw e;
        }
        if ($dzfKZ.isThenable(maybePromiseResult)) return maybePromiseResult.then((r)=>{
            finishCheckIn("ok");
            return r;
        }, (e)=>{
            finishCheckIn("error");
            throw e;
        });
        finishCheckIn("ok");
        return maybePromiseResult;
    }
    return $79m2C.withIsolationScope(()=>upsertMonitorConfig?.isolateTrace ? $kBDP8.startNewTrace(runCallback) : runCallback());
}
async function $1128e5c02b7a2786$var$flush(timeout) {
    const client = $79m2C.getClient();
    if (client) return client.flush(timeout);
    $hiZR1.DEBUG_BUILD && $4gyod.debug.warn("Cannot flush events. No client defined.");
    return Promise.resolve(false);
}
async function $1128e5c02b7a2786$var$close(timeout) {
    const client = $79m2C.getClient();
    if (client) return client.close(timeout);
    $hiZR1.DEBUG_BUILD && $4gyod.debug.warn("Cannot flush events and disable SDK. No client defined.");
    return Promise.resolve(false);
}
function $1128e5c02b7a2786$var$isInitialized() {
    return !!$79m2C.getClient();
}
function $1128e5c02b7a2786$var$isEnabled() {
    const client = $79m2C.getClient();
    return client?.getOptions().enabled !== false && !!client?.getTransport();
}
function $1128e5c02b7a2786$var$addEventProcessor(callback) {
    $79m2C.getIsolationScope().addEventProcessor(callback);
}
function $1128e5c02b7a2786$var$startSession(context) {
    const isolationScope = $79m2C.getIsolationScope();
    const { user: user } = $fsIRO.getCombinedScopeData(isolationScope, $79m2C.getCurrentScope());
    const { userAgent: userAgent } = $eP8Ri.GLOBAL_OBJ.navigator || {};
    const session$1 = $dsI2h.makeSession({
        user: user,
        ...userAgent && {
            userAgent: userAgent
        },
        ...context
    });
    const currentSession = isolationScope.getSession();
    if (currentSession?.status === "ok") $dsI2h.updateSession(currentSession, {
        status: "exited"
    });
    $1128e5c02b7a2786$var$endSession();
    isolationScope.setSession(session$1);
    return session$1;
}
function $1128e5c02b7a2786$var$endSession() {
    const isolationScope = $79m2C.getIsolationScope();
    const currentScope = $79m2C.getCurrentScope();
    const session$1 = currentScope.getSession() || isolationScope.getSession();
    if (session$1) $dsI2h.closeSession(session$1);
    $1128e5c02b7a2786$var$_sendSessionUpdate();
    isolationScope.setSession();
}
function $1128e5c02b7a2786$var$_sendSessionUpdate() {
    const isolationScope = $79m2C.getIsolationScope();
    const client = $79m2C.getClient();
    const session = isolationScope.getSession();
    if (session && client) client.captureSession(session);
}
function $1128e5c02b7a2786$var$captureSession(end = false) {
    if (end) {
        $1128e5c02b7a2786$var$endSession();
        return;
    }
    $1128e5c02b7a2786$var$_sendSessionUpdate();
}
module.exports.addEventProcessor = $1128e5c02b7a2786$var$addEventProcessor;
module.exports.captureCheckIn = $1128e5c02b7a2786$var$captureCheckIn;
module.exports.captureEvent = $1128e5c02b7a2786$var$captureEvent;
module.exports.captureException = $1128e5c02b7a2786$var$captureException;
module.exports.captureMessage = $1128e5c02b7a2786$var$captureMessage;
module.exports.captureSession = $1128e5c02b7a2786$var$captureSession;
module.exports.close = $1128e5c02b7a2786$var$close;
module.exports.endSession = $1128e5c02b7a2786$var$endSession;
module.exports.flush = $1128e5c02b7a2786$var$flush;
module.exports.isEnabled = $1128e5c02b7a2786$var$isEnabled;
module.exports.isInitialized = $1128e5c02b7a2786$var$isInitialized;
module.exports.lastEventId = $1128e5c02b7a2786$var$lastEventId;
module.exports.setAttribute = $1128e5c02b7a2786$var$setAttribute;
module.exports.setAttributes = $1128e5c02b7a2786$var$setAttributes;
module.exports.setContext = $1128e5c02b7a2786$var$setContext;
module.exports.setConversationId = $1128e5c02b7a2786$var$setConversationId;
module.exports.setExtra = $1128e5c02b7a2786$var$setExtra;
module.exports.setExtras = $1128e5c02b7a2786$var$setExtras;
module.exports.setTag = $1128e5c02b7a2786$var$setTag;
module.exports.setTags = $1128e5c02b7a2786$var$setTags;
module.exports.setUser = $1128e5c02b7a2786$var$setUser;
module.exports.startSession = $1128e5c02b7a2786$var$startSession;
module.exports.withMonitor = $1128e5c02b7a2786$var$withMonitor;

});
parcelRegister("1rqgb", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $8Bk70 = parcelRequire("8Bk70");

var $k6fyv = parcelRequire("k6fyv");

var $d3JtV = parcelRequire("d3JtV");

var $5PTIz = parcelRequire("5PTIz");

var $6JkyB = parcelRequire("6JkyB");

var $eD1cG = parcelRequire("eD1cG");

var $fsIRO = parcelRequire("fsIRO");

var $arYVC = parcelRequire("arYVC");

var $eligX = parcelRequire("eligX");

var $ihsl1 = parcelRequire("ihsl1");
function $10ccaec5c8bbfe7b$var$prepareEvent(options, event, hint, scope, client, isolationScope) {
    const { normalizeDepth: normalizeDepth = 3, normalizeMaxBreadth: normalizeMaxBreadth = 1e3 } = options;
    const prepared = {
        ...event,
        event_id: event.event_id || hint.event_id || $6JkyB.uuid4(),
        timestamp: event.timestamp || $ihsl1.dateTimestampInSeconds()
    };
    const integrations = hint.integrations || options.integrations.map((i)=>i.name);
    $10ccaec5c8bbfe7b$var$applyClientOptions(prepared, options);
    $10ccaec5c8bbfe7b$var$applyIntegrationsMetadata(prepared, integrations);
    if (client) client.emit("applyFrameMetadata", event);
    if (event.type === void 0) $10ccaec5c8bbfe7b$var$applyDebugIds(prepared, options.stackParser);
    const finalScope = $10ccaec5c8bbfe7b$var$getFinalScope(scope, hint.captureContext);
    if (hint.mechanism) $6JkyB.addExceptionMechanism(prepared, hint.mechanism);
    const clientEventProcessors = client ? client.getEventProcessors() : [];
    const data = $fsIRO.getCombinedScopeData(isolationScope, finalScope);
    const attachments = [
        ...hint.attachments || [],
        ...data.attachments
    ];
    if (attachments.length) hint.attachments = attachments;
    $fsIRO.applyScopeDataToEvent(prepared, data);
    const eventProcessors$1 = [
        ...clientEventProcessors,
        // Run scope event processors _after_ all other processors
        ...data.eventProcessors
    ];
    const isInternalException = hint.data && hint.data.__sentry__ === true;
    const result = isInternalException ? $eligX.resolvedSyncPromise(prepared) : $k6fyv.notifyEventProcessors(eventProcessors$1, prepared, hint);
    return result.then((evt)=>{
        if (evt) $10ccaec5c8bbfe7b$var$applyDebugMeta(evt);
        if (typeof normalizeDepth === "number" && normalizeDepth > 0) return $10ccaec5c8bbfe7b$var$normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
        return evt;
    });
}
function $10ccaec5c8bbfe7b$var$applyClientOptions(event, options) {
    const { environment: environment, release: release, dist: dist, maxValueLength: maxValueLength } = options;
    event.environment = event.environment || environment || $8Bk70.DEFAULT_ENVIRONMENT;
    if (!event.release && release) event.release = release;
    if (!event.dist && dist) event.dist = dist;
    const request = event.request;
    if (request?.url && maxValueLength) request.url = $arYVC.truncate(request.url, maxValueLength);
    if (maxValueLength) event.exception?.values?.forEach((exception)=>{
        if (exception.value) exception.value = $arYVC.truncate(exception.value, maxValueLength);
    });
}
function $10ccaec5c8bbfe7b$var$applyDebugIds(event, stackParser) {
    const filenameDebugIdMap = $5PTIz.getFilenameToDebugIdMap(stackParser);
    event.exception?.values?.forEach((exception)=>{
        exception.stacktrace?.frames?.forEach((frame)=>{
            if (frame.filename) frame.debug_id = filenameDebugIdMap[frame.filename];
        });
    });
}
function $10ccaec5c8bbfe7b$var$applyDebugMeta(event) {
    const filenameDebugIdMap = {};
    event.exception?.values?.forEach((exception)=>{
        exception.stacktrace?.frames?.forEach((frame)=>{
            if (frame.debug_id) {
                if (frame.abs_path) filenameDebugIdMap[frame.abs_path] = frame.debug_id;
                else if (frame.filename) filenameDebugIdMap[frame.filename] = frame.debug_id;
                delete frame.debug_id;
            }
        });
    });
    if (Object.keys(filenameDebugIdMap).length === 0) return;
    event.debug_meta = event.debug_meta || {};
    event.debug_meta.images = event.debug_meta.images || [];
    const images = event.debug_meta.images;
    Object.entries(filenameDebugIdMap).forEach(([filename, debug_id])=>{
        images.push({
            type: "sourcemap",
            code_file: filename,
            debug_id: debug_id
        });
    });
}
function $10ccaec5c8bbfe7b$var$applyIntegrationsMetadata(event, integrationNames) {
    if (integrationNames.length > 0) {
        event.sdk = event.sdk || {};
        event.sdk.integrations = [
            ...event.sdk.integrations || [],
            ...integrationNames
        ];
    }
}
function $10ccaec5c8bbfe7b$var$normalizeEvent(event, depth, maxBreadth) {
    if (!event) return null;
    const normalized = {
        ...event,
        ...event.breadcrumbs && {
            breadcrumbs: event.breadcrumbs.map((b)=>({
                    ...b,
                    ...b.data && {
                        data: $eD1cG.normalize(b.data, depth, maxBreadth)
                    }
                }))
        },
        ...event.user && {
            user: $eD1cG.normalize(event.user, depth, maxBreadth)
        },
        ...event.contexts && {
            contexts: $eD1cG.normalize(event.contexts, depth, maxBreadth)
        },
        ...event.extra && {
            extra: $eD1cG.normalize(event.extra, depth, maxBreadth)
        }
    };
    if (event.contexts?.trace && normalized.contexts) {
        normalized.contexts.trace = event.contexts.trace;
        if (event.contexts.trace.data) normalized.contexts.trace.data = $eD1cG.normalize(event.contexts.trace.data, depth, maxBreadth);
    }
    if (event.spans) normalized.spans = event.spans.map((span)=>{
        return {
            ...span,
            ...span.data && {
                data: $eD1cG.normalize(span.data, depth, maxBreadth)
            }
        };
    });
    if (event.contexts?.flags && normalized.contexts) normalized.contexts.flags = $eD1cG.normalize(event.contexts.flags, 3, maxBreadth);
    return normalized;
}
function $10ccaec5c8bbfe7b$var$getFinalScope(scope$1, captureContext) {
    if (!captureContext) return scope$1;
    const finalScope = scope$1 ? scope$1.clone() : new $d3JtV.Scope();
    finalScope.update(captureContext);
    return finalScope;
}
function $10ccaec5c8bbfe7b$var$parseEventHintOrCaptureContext(hint) {
    if (!hint) return void 0;
    if ($10ccaec5c8bbfe7b$var$hintIsScopeOrFunction(hint)) return {
        captureContext: hint
    };
    if ($10ccaec5c8bbfe7b$var$hintIsScopeContext(hint)) return {
        captureContext: hint
    };
    return hint;
}
function $10ccaec5c8bbfe7b$var$hintIsScopeOrFunction(hint) {
    return hint instanceof $d3JtV.Scope || typeof hint === "function";
}
const $10ccaec5c8bbfe7b$var$captureContextKeys = [
    "user",
    "level",
    "extra",
    "contexts",
    "tags",
    "fingerprint",
    "propagationContext"
];
function $10ccaec5c8bbfe7b$var$hintIsScopeContext(hint) {
    return Object.keys(hint).some((key)=>$10ccaec5c8bbfe7b$var$captureContextKeys.includes(key));
}
module.exports.applyClientOptions = $10ccaec5c8bbfe7b$var$applyClientOptions;
module.exports.applyDebugIds = $10ccaec5c8bbfe7b$var$applyDebugIds;
module.exports.applyDebugMeta = $10ccaec5c8bbfe7b$var$applyDebugMeta;
module.exports.parseEventHintOrCaptureContext = $10ccaec5c8bbfe7b$var$parseEventHintOrCaptureContext;
module.exports.prepareEvent = $10ccaec5c8bbfe7b$var$prepareEvent;

});
parcelRegister("k6fyv", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $hiZR1 = parcelRequire("hiZR1");

var $4gyod = parcelRequire("4gyod");

var $dzfKZ = parcelRequire("dzfKZ");

var $eligX = parcelRequire("eligX");
function $ea206f2c356809f0$var$notifyEventProcessors(processors, event, hint, index = 0) {
    try {
        const result = $ea206f2c356809f0$var$_notifyEventProcessors(event, hint, processors, index);
        return $dzfKZ.isThenable(result) ? result : $eligX.resolvedSyncPromise(result);
    } catch (error) {
        return $eligX.rejectedSyncPromise(error);
    }
}
function $ea206f2c356809f0$var$_notifyEventProcessors(event, hint, processors, index) {
    const processor = processors[index];
    if (!event || !processor) return event;
    const result = processor({
        ...event
    }, hint);
    $hiZR1.DEBUG_BUILD && result === null && $4gyod.debug.log(`Event processor "${processor.id || "?"}" dropped event`);
    if ($dzfKZ.isThenable(result)) return result.then((final)=>$ea206f2c356809f0$var$_notifyEventProcessors(final, hint, processors, index + 1));
    return $ea206f2c356809f0$var$_notifyEventProcessors(result, hint, processors, index + 1);
}
module.exports.notifyEventProcessors = $ea206f2c356809f0$var$notifyEventProcessors;

});
parcelRegister("eligX", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $dzfKZ = parcelRequire("dzfKZ");
const $a711336b0e8ef2f0$var$STATE_PENDING = 0;
const $a711336b0e8ef2f0$var$STATE_RESOLVED = 1;
const $a711336b0e8ef2f0$var$STATE_REJECTED = 2;
function $a711336b0e8ef2f0$var$resolvedSyncPromise(value) {
    return new $a711336b0e8ef2f0$var$SyncPromise((resolve)=>{
        resolve(value);
    });
}
function $a711336b0e8ef2f0$var$rejectedSyncPromise(reason) {
    return new $a711336b0e8ef2f0$var$SyncPromise((_, reject)=>{
        reject(reason);
    });
}
class $a711336b0e8ef2f0$var$SyncPromise {
    constructor(executor){
        this._state = $a711336b0e8ef2f0$var$STATE_PENDING;
        this._handlers = [];
        this._runExecutor(executor);
    }
    /** @inheritdoc */ then(onfulfilled, onrejected) {
        return new $a711336b0e8ef2f0$var$SyncPromise((resolve, reject)=>{
            this._handlers.push([
                false,
                (result)=>{
                    if (!onfulfilled) resolve(result);
                    else try {
                        resolve(onfulfilled(result));
                    } catch (e) {
                        reject(e);
                    }
                },
                (reason)=>{
                    if (!onrejected) reject(reason);
                    else try {
                        resolve(onrejected(reason));
                    } catch (e) {
                        reject(e);
                    }
                }
            ]);
            this._executeHandlers();
        });
    }
    /** @inheritdoc */ catch(onrejected) {
        return this.then((val)=>val, onrejected);
    }
    /** @inheritdoc */ finally(onfinally) {
        return new $a711336b0e8ef2f0$var$SyncPromise((resolve, reject)=>{
            let val;
            let isRejected;
            return this.then((value)=>{
                isRejected = false;
                val = value;
                if (onfinally) onfinally();
            }, (reason)=>{
                isRejected = true;
                val = reason;
                if (onfinally) onfinally();
            }).then(()=>{
                if (isRejected) {
                    reject(val);
                    return;
                }
                resolve(val);
            });
        });
    }
    /** Excute the resolve/reject handlers. */ _executeHandlers() {
        if (this._state === $a711336b0e8ef2f0$var$STATE_PENDING) return;
        const cachedHandlers = this._handlers.slice();
        this._handlers = [];
        cachedHandlers.forEach((handler)=>{
            if (handler[0]) return;
            if (this._state === $a711336b0e8ef2f0$var$STATE_RESOLVED) handler[1](this._value);
            if (this._state === $a711336b0e8ef2f0$var$STATE_REJECTED) handler[2](this._value);
            handler[0] = true;
        });
    }
    /** Run the executor for the SyncPromise. */ _runExecutor(executor) {
        const setResult = (state, value)=>{
            if (this._state !== $a711336b0e8ef2f0$var$STATE_PENDING) return;
            if ($dzfKZ.isThenable(value)) {
                value.then(resolve, reject);
                return;
            }
            this._state = state;
            this._value = value;
            this._executeHandlers();
        };
        const resolve = (value)=>{
            setResult($a711336b0e8ef2f0$var$STATE_RESOLVED, value);
        };
        const reject = (reason)=>{
            setResult($a711336b0e8ef2f0$var$STATE_REJECTED, reason);
        };
        try {
            executor(resolve, reject);
        } catch (e) {
            reject(e);
        }
    }
}
module.exports.SyncPromise = $a711336b0e8ef2f0$var$SyncPromise;
module.exports.rejectedSyncPromise = $a711336b0e8ef2f0$var$rejectedSyncPromise;
module.exports.resolvedSyncPromise = $a711336b0e8ef2f0$var$resolvedSyncPromise;

});


parcelRegister("5PTIz", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $d7glj = parcelRequire("d7glj");

var $eP8Ri = parcelRequire("eP8Ri");
let $43fcef9295ee6c13$var$parsedStackResults;
let $43fcef9295ee6c13$var$lastSentryKeysCount;
let $43fcef9295ee6c13$var$lastNativeKeysCount;
let $43fcef9295ee6c13$var$cachedFilenameDebugIds;
function $43fcef9295ee6c13$var$getFilenameToDebugIdMap(stackParser) {
    const sentryDebugIdMap = $eP8Ri.GLOBAL_OBJ._sentryDebugIds;
    const nativeDebugIdMap = $eP8Ri.GLOBAL_OBJ._debugIds;
    if (!sentryDebugIdMap && !nativeDebugIdMap) return {};
    const sentryDebugIdKeys = sentryDebugIdMap ? Object.keys(sentryDebugIdMap) : [];
    const nativeDebugIdKeys = nativeDebugIdMap ? Object.keys(nativeDebugIdMap) : [];
    if ($43fcef9295ee6c13$var$cachedFilenameDebugIds && sentryDebugIdKeys.length === $43fcef9295ee6c13$var$lastSentryKeysCount && nativeDebugIdKeys.length === $43fcef9295ee6c13$var$lastNativeKeysCount) return $43fcef9295ee6c13$var$cachedFilenameDebugIds;
    $43fcef9295ee6c13$var$lastSentryKeysCount = sentryDebugIdKeys.length;
    $43fcef9295ee6c13$var$lastNativeKeysCount = nativeDebugIdKeys.length;
    $43fcef9295ee6c13$var$cachedFilenameDebugIds = {};
    if (!$43fcef9295ee6c13$var$parsedStackResults) $43fcef9295ee6c13$var$parsedStackResults = {};
    const processDebugIds = (debugIdKeys, debugIdMap)=>{
        for (const key of debugIdKeys){
            const debugId = debugIdMap[key];
            const result = $43fcef9295ee6c13$var$parsedStackResults?.[key];
            if (result && $43fcef9295ee6c13$var$cachedFilenameDebugIds && debugId) {
                $43fcef9295ee6c13$var$cachedFilenameDebugIds[result[0]] = debugId;
                if ($43fcef9295ee6c13$var$parsedStackResults) $43fcef9295ee6c13$var$parsedStackResults[key] = [
                    result[0],
                    debugId
                ];
            } else if (debugId) {
                const parsedStack = stackParser(key);
                for(let i = parsedStack.length - 1; i >= 0; i--){
                    const stackFrame = parsedStack[i];
                    const filename = stackFrame?.filename;
                    if (filename && $43fcef9295ee6c13$var$cachedFilenameDebugIds && $43fcef9295ee6c13$var$parsedStackResults) {
                        $43fcef9295ee6c13$var$cachedFilenameDebugIds[filename] = debugId;
                        $43fcef9295ee6c13$var$parsedStackResults[key] = [
                            filename,
                            debugId
                        ];
                        break;
                    }
                }
            }
        }
    };
    if (sentryDebugIdMap) processDebugIds(sentryDebugIdKeys, sentryDebugIdMap);
    if (nativeDebugIdMap) processDebugIds(nativeDebugIdKeys, nativeDebugIdMap);
    return $43fcef9295ee6c13$var$cachedFilenameDebugIds;
}
function $43fcef9295ee6c13$var$getDebugImagesForResources(stackParser, resource_paths) {
    const filenameDebugIdMap = $43fcef9295ee6c13$var$getFilenameToDebugIdMap(stackParser);
    if (!filenameDebugIdMap) return [];
    const images = [];
    for (const path of resource_paths){
        const normalizedPath = $d7glj.normalizeStackTracePath(path);
        if (normalizedPath && filenameDebugIdMap[normalizedPath]) images.push({
            type: "sourcemap",
            code_file: path,
            debug_id: filenameDebugIdMap[normalizedPath]
        });
    }
    return images;
}
module.exports.getDebugImagesForResources = $43fcef9295ee6c13$var$getDebugImagesForResources;
module.exports.getFilenameToDebugIdMap = $43fcef9295ee6c13$var$getFilenameToDebugIdMap;

});



parcelRegister("5Ezlt", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $4fnou = parcelRequire("4fnou");

var $f9GTk = parcelRequire("f9GTk");

var $Asczg = parcelRequire("Asczg");

var $diBhM = parcelRequire("diBhM");
function $41dc1b0c1a828222$var$waitForTracingChannelBinding(callback, retries = 1) {
    const binding = $diBhM.getAsyncContextStrategy($4fnou.getMainCarrier()).getTracingChannelBinding?.();
    if (binding) {
        callback();
        return;
    }
    if (!retries) return;
    $Asczg.safeUnref(setTimeout(()=>{
        $41dc1b0c1a828222$var$waitForTracingChannelBinding(callback, retries - 1);
    }, 1));
}
function $41dc1b0c1a828222$var$_INTERNAL_createTracingChannelBinding(asyncLocalStorage, getScopes) {
    return {
        asyncLocalStorage: asyncLocalStorage,
        getStoreWithActiveSpan: (span)=>{
            const { scope: scope, isolationScope: isolationScope } = getScopes();
            const activeScope = scope.clone();
            $f9GTk._setSpanForScope(activeScope, span);
            return {
                scope: activeScope,
                isolationScope: isolationScope
            };
        }
    };
}
module.exports._INTERNAL_createTracingChannelBinding = $41dc1b0c1a828222$var$_INTERNAL_createTracingChannelBinding;
module.exports.waitForTracingChannelBinding = $41dc1b0c1a828222$var$waitForTracingChannelBinding;

});
parcelRegister("Asczg", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $06d93d2ddb4c3bf4$var$safeUnref(timer) {
    if (typeof timer === "object" && typeof timer.unref === "function") timer.unref();
    return timer;
}
module.exports.safeUnref = $06d93d2ddb4c3bf4$var$safeUnref;

});


parcelRegister("aY6AE", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $7E8b3 = parcelRequire("7E8b3");
const $7fc49ea6c444fa75$var$SENTRY_API_VERSION = "7";
function $7fc49ea6c444fa75$var$getBaseApiEndpoint(dsn) {
    const protocol = dsn.protocol ? `${dsn.protocol}:` : "";
    const port = dsn.port ? `:${dsn.port}` : "";
    return `${protocol}//${dsn.host}${port}${dsn.path ? `/${dsn.path}` : ""}/api/`;
}
function $7fc49ea6c444fa75$var$_getIngestEndpoint(dsn) {
    return `${$7fc49ea6c444fa75$var$getBaseApiEndpoint(dsn)}${dsn.projectId}/envelope/`;
}
function $7fc49ea6c444fa75$var$_encodedAuth(dsn, sdkInfo) {
    const params = {
        sentry_version: $7fc49ea6c444fa75$var$SENTRY_API_VERSION
    };
    if (dsn.publicKey) params.sentry_key = dsn.publicKey;
    if (sdkInfo) params.sentry_client = `${sdkInfo.name}/${sdkInfo.version}`;
    return new URLSearchParams(params).toString();
}
function $7fc49ea6c444fa75$var$getEnvelopeEndpointWithUrlEncodedAuth(dsn, tunnel, sdkInfo) {
    return tunnel ? tunnel : `${$7fc49ea6c444fa75$var$_getIngestEndpoint(dsn)}?${$7fc49ea6c444fa75$var$_encodedAuth(dsn, sdkInfo)}`;
}
function $7fc49ea6c444fa75$var$getReportDialogEndpoint(dsnLike, dialogOptions) {
    const dsn$1 = $7E8b3.makeDsn(dsnLike);
    if (!dsn$1) return "";
    const endpoint = `${$7fc49ea6c444fa75$var$getBaseApiEndpoint(dsn$1)}embed/error-page/`;
    let encodedOptions = `dsn=${$7E8b3.dsnToString(dsn$1)}`;
    for(const key in dialogOptions){
        if (key === "dsn") continue;
        if (key === "onClose") continue;
        if (key === "user") {
            const user = dialogOptions.user;
            if (!user) continue;
            if (user.name) encodedOptions += `&name=${encodeURIComponent(user.name)}`;
            if (user.email) encodedOptions += `&email=${encodeURIComponent(user.email)}`;
        } else encodedOptions += `&${encodeURIComponent(key)}=${encodeURIComponent(dialogOptions[key])}`;
    }
    return `${endpoint}?${encodedOptions}`;
}
module.exports.SENTRY_API_VERSION = $7fc49ea6c444fa75$var$SENTRY_API_VERSION;
module.exports.getEnvelopeEndpointWithUrlEncodedAuth = $7fc49ea6c444fa75$var$getEnvelopeEndpointWithUrlEncodedAuth;
module.exports.getReportDialogEndpoint = $7fc49ea6c444fa75$var$getReportDialogEndpoint;

});

parcelRegister("cCAVw", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $aY6AE = parcelRequire("aY6AE");

var $8Bk70 = parcelRequire("8Bk70");

var $79m2C = parcelRequire("79m2C");

var $hiZR1 = parcelRequire("hiZR1");

var $gjixg = parcelRequire("gjixg");

var $g33UP = parcelRequire("g33UP");

var $7LBlQ = parcelRequire("7LBlQ");

var $5zO49 = parcelRequire("5zO49");

var $dsI2h = parcelRequire("dsI2h");

var $f0qnC = parcelRequire("f0qnC");

var $hOwNc = parcelRequire("hOwNc");

var $7P04K = parcelRequire("7P04K");

var $aQrJw = parcelRequire("aQrJw");

var $6lXp4 = parcelRequire("6lXp4");

var $4gyod = parcelRequire("4gyod");

var $7E8b3 = parcelRequire("7E8b3");

var $636GJ = parcelRequire("636GJ");

var $8008j = parcelRequire("8008j");

var $dzfKZ = parcelRequire("dzfKZ");

var $c9oD0 = parcelRequire("c9oD0");

var $6JkyB = parcelRequire("6JkyB");

var $dkhYR = parcelRequire("dkhYR");

var $1rqgb = parcelRequire("1rqgb");

var $gaj81 = parcelRequire("gaj81");

var $lLUp4 = parcelRequire("lLUp4");

var $cRlHT = parcelRequire("cRlHT");

var $8jbnX = parcelRequire("8jbnX");

var $eligX = parcelRequire("eligX");

var $Asczg = parcelRequire("Asczg");

var $lM2xr = parcelRequire("lM2xr");

var $2uqEP = parcelRequire("2uqEP");
const $9305ad8b789e6bf9$var$ALREADY_SEEN_ERROR = "Not capturing exception because it's already been captured.";
const $9305ad8b789e6bf9$var$MISSING_RELEASE_FOR_SESSION_ERROR = "Discarded session because of missing or non-string release";
const $9305ad8b789e6bf9$var$INTERNAL_ERROR_SYMBOL = /* @__PURE__ */ Symbol.for("SentryInternalError");
const $9305ad8b789e6bf9$var$DO_NOT_SEND_EVENT_SYMBOL = /* @__PURE__ */ Symbol.for("SentryDoNotSendEventError");
const $9305ad8b789e6bf9$var$DEFAULT_FLUSH_INTERVAL = 5e3;
function $9305ad8b789e6bf9$var$_makeInternalError(message) {
    return {
        message: message,
        [$9305ad8b789e6bf9$var$INTERNAL_ERROR_SYMBOL]: true
    };
}
function $9305ad8b789e6bf9$var$_makeDoNotSendEventError(message) {
    return {
        message: message,
        [$9305ad8b789e6bf9$var$DO_NOT_SEND_EVENT_SYMBOL]: true
    };
}
function $9305ad8b789e6bf9$var$_isInternalError(error) {
    return $dzfKZ.isObjectLike(error) && $9305ad8b789e6bf9$var$INTERNAL_ERROR_SYMBOL in error;
}
function $9305ad8b789e6bf9$var$_isDoNotSendEventError(error) {
    return $dzfKZ.isObjectLike(error) && $9305ad8b789e6bf9$var$DO_NOT_SEND_EVENT_SYMBOL in error;
}
function $9305ad8b789e6bf9$var$setupWeightBasedFlushing(client, afterCaptureHook, flushHook, estimateSizeFn, flushFn) {
    let weight = 0;
    let flushTimeout;
    let isTimerActive = false;
    client.on(flushHook, ()=>{
        weight = 0;
        clearTimeout(flushTimeout);
        isTimerActive = false;
    });
    client.on(afterCaptureHook, (item)=>{
        weight += estimateSizeFn(item);
        if (weight >= 8e5) flushFn(client);
        else if (!isTimerActive) {
            const flushInterval = client.getOptions()._flushInterval ?? $9305ad8b789e6bf9$var$DEFAULT_FLUSH_INTERVAL;
            if (flushInterval > 0) {
                isTimerActive = true;
                flushTimeout = $Asczg.safeUnref(setTimeout(()=>{
                    flushFn(client);
                }, flushInterval));
            }
        }
    });
    client.on("flush", ()=>{
        flushFn(client);
    });
}
class $9305ad8b789e6bf9$var$Client {
    /**
   * Initializes this client instance.
   *
   * @param options Options for the client.
   */ constructor(options){
        this._options = options;
        this._integrations = {};
        this._numProcessing = 0;
        this._outcomes = {};
        this._hooks = {};
        this._eventProcessors = [];
        this._promiseBuffer = $gaj81.makePromiseBuffer(options.transportOptions?.bufferSize ?? $aQrJw.DEFAULT_TRANSPORT_BUFFER_SIZE);
        this._dataCollection = $2uqEP.resolveDataCollectionOptions(options);
        if (options.dsn) this._dsn = $7E8b3.makeDsn(options.dsn);
        else $hiZR1.DEBUG_BUILD && $4gyod.debug.warn("No DSN provided, client will not send events.");
        if (this._dsn) {
            const url = $aY6AE.getEnvelopeEndpointWithUrlEncodedAuth(this._dsn, options.tunnel, options._metadata ? options._metadata.sdk : void 0);
            this._transport = options.transport({
                tunnel: this._options.tunnel,
                recordDroppedEvent: this.recordDroppedEvent.bind(this),
                ...options.transportOptions,
                url: url
            });
        }
        this._options.enableLogs = this._options.enableLogs ?? this._options._experiments?.enableLogs;
        if (this._options.enableLogs) $9305ad8b789e6bf9$var$setupWeightBasedFlushing(this, "afterCaptureLog", "flushLogs", $9305ad8b789e6bf9$var$estimateLogSizeInBytes, $7LBlQ._INTERNAL_flushLogsBuffer);
        const enableMetrics = this._options.enableMetrics ?? this._options._experiments?.enableMetrics ?? true;
        if (enableMetrics) $9305ad8b789e6bf9$var$setupWeightBasedFlushing(this, "afterCaptureMetric", "flushMetrics", $9305ad8b789e6bf9$var$estimateMetricSizeInBytes, $5zO49._INTERNAL_flushMetricsBuffer);
    }
    /**
   * Captures an exception event and sends it to Sentry.
   *
   * Unlike `captureException` exported from every SDK, this method requires that you pass it the current scope.
   */ captureException(exception, hint, scope) {
        const eventId = $6JkyB.uuid4();
        if ($6JkyB.checkOrSetAlreadyCaught(exception)) {
            $hiZR1.DEBUG_BUILD && $4gyod.debug.log($9305ad8b789e6bf9$var$ALREADY_SEEN_ERROR);
            return eventId;
        }
        const hintWithEventId = {
            event_id: eventId,
            ...hint
        };
        this._process(()=>this.eventFromException(exception, hintWithEventId).then((event)=>this._captureEvent(event, hintWithEventId, scope)).then((res)=>res), "error");
        return hintWithEventId.event_id;
    }
    /**
   * Captures a message event and sends it to Sentry.
   *
   * Unlike `captureMessage` exported from every SDK, this method requires that you pass it the current scope.
   */ captureMessage(message, level, hint, currentScope) {
        const hintWithEventId = {
            event_id: $6JkyB.uuid4(),
            ...hint
        };
        const eventMessage = $dzfKZ.isParameterizedString(message) ? message : String(message);
        const isMessage = $dzfKZ.isPrimitive(message);
        const promisedEvent = isMessage ? this.eventFromMessage(eventMessage, level, hintWithEventId) : this.eventFromException(message, hintWithEventId);
        this._process(()=>promisedEvent.then((event)=>this._captureEvent(event, hintWithEventId, currentScope)), isMessage ? "unknown" : "error");
        return hintWithEventId.event_id;
    }
    /**
   * Captures a manually created event and sends it to Sentry.
   *
   * Unlike `captureEvent` exported from every SDK, this method requires that you pass it the current scope.
   */ captureEvent(event, hint, currentScope) {
        const eventId = $6JkyB.uuid4();
        if (hint?.originalException && $6JkyB.checkOrSetAlreadyCaught(hint.originalException)) {
            $hiZR1.DEBUG_BUILD && $4gyod.debug.log($9305ad8b789e6bf9$var$ALREADY_SEEN_ERROR);
            return eventId;
        }
        const hintWithEventId = {
            event_id: eventId,
            ...hint
        };
        const sdkProcessingMetadata = event.sdkProcessingMetadata || {};
        const capturedSpanScope = sdkProcessingMetadata.capturedSpanScope;
        const capturedSpanIsolationScope = sdkProcessingMetadata.capturedSpanIsolationScope;
        const dataCategory = $9305ad8b789e6bf9$var$getDataCategoryByType(event.type);
        this._process(()=>this._captureEvent(event, hintWithEventId, capturedSpanScope || currentScope, capturedSpanIsolationScope), dataCategory);
        return hintWithEventId.event_id;
    }
    /**
   * Captures a session.
   */ captureSession(session$1) {
        this.sendSession(session$1);
        $dsI2h.updateSession(session$1, {
            init: false
        });
    }
    /**
   * Get the current Dsn.
   */ getDsn() {
        return this._dsn;
    }
    /**
   * Get the current options.
   */ getOptions() {
        return this._options;
    }
    /**
   * Get the resolved data collection configuration.
   */ getDataCollectionOptions() {
        return this._dataCollection;
    }
    /**
   * Get the SDK metadata.
   * @see SdkMetadata
   */ getSdkMetadata() {
        return this._options._metadata;
    }
    /**
   * Returns the transport that is used by the client.
   * Please note that the transport gets lazy initialized so it will only be there once the first event has been sent.
   */ getTransport() {
        return this._transport;
    }
    /**
   * Wait for all events to be sent or the timeout to expire, whichever comes first.
   *
   * @param timeout Maximum time in ms the client should wait for events to be flushed. Omitting this parameter will
   *   cause the client to wait until all events are sent before resolving the promise.
   * @returns A promise that will resolve with `true` if all events are sent before the timeout, or `false` if there are
   * still events in the queue when the timeout is reached.
   */ // @ts-expect-error - PromiseLike is a subset of Promise
    async flush(timeout) {
        const transport = this._transport;
        this.emit("flush");
        if (!transport) return true;
        const clientFinished = await this._isClientDoneProcessing(timeout);
        const transportFlushed = await transport.flush(timeout);
        return clientFinished && transportFlushed;
    }
    /**
   * Flush the event queue and set the client to `enabled = false`. See {@link Client.flush}.
   *
   * @param {number} timeout Maximum time in ms the client should wait before shutting down. Omitting this parameter will cause
   *   the client to wait until all events are sent before disabling itself.
   * @returns {Promise<boolean>} A promise which resolves to `true` if the flush completes successfully before the timeout, or `false` if
   * it doesn't.
   */ // @ts-expect-error - PromiseLike is a subset of Promise
    async close(timeout) {
        const result = await this.flush(timeout);
        this.getOptions().enabled = false;
        this.emit("close");
        return result;
    }
    /**
   * Get all installed event processors.
   */ getEventProcessors() {
        return this._eventProcessors;
    }
    /**
   * Adds an event processor that applies to any event processed by this client.
   */ addEventProcessor(eventProcessor) {
        this._eventProcessors.push(eventProcessor);
    }
    /**
   * Initialize this client.
   * Call this after the client was set on a scope.
   */ init() {
        if (this._isEnabled() || // Force integrations to be setup even if no DSN was set when we have
        // Spotlight enabled. This is particularly important for browser as we
        // don't support the `spotlight` option there and rely on the users
        // adding the `spotlightBrowserIntegration()` to their integrations which
        // wouldn't get initialized with the check below when there's no DSN set.
        this._options.integrations.some(({ name: name })=>name.startsWith("Spotlight"))) this._setupIntegrations();
    }
    /**
   * Gets an installed integration by its name.
   *
   * @returns {Integration|undefined} The installed integration or `undefined` if no integration with that `name` was installed.
   */ getIntegrationByName(integrationName) {
        return this._integrations[integrationName];
    }
    /**
   * Returns the names of all installed integrations.
   */ getIntegrationNames() {
        return Object.keys(this._integrations);
    }
    /**
   * Add an integration to the client.
   * This can be used to e.g. lazy load integrations.
   * In most cases, this should not be necessary,
   * and you're better off just passing the integrations via `integrations: []` at initialization time.
   * However, if you find the need to conditionally load & add an integration, you can use `addIntegration` to do so.
   */ addIntegration(integration$1) {
        const isAlreadyInstalled = this._integrations[integration$1.name];
        if (!isAlreadyInstalled && integration$1.beforeSetup) integration$1.beforeSetup(this);
        $g33UP.setupIntegration(this, integration$1, this._integrations);
        if (!isAlreadyInstalled) $g33UP.afterSetupIntegrations(this, [
            integration$1
        ]);
    }
    /**
   * Send a fully prepared event to Sentry.
   */ sendEvent(event, hint = {}) {
        this.emit("beforeSendEvent", event, hint);
        const genAiSpanItem = $7P04K.extractGenAiSpansFromEvent(event, this);
        let env = $gjixg.createEventEnvelope(event, this._dsn, this._options._metadata, this._options.tunnel);
        for (const attachment of hint.attachments || [])env = $636GJ.addItemToEnvelope(env, $636GJ.createAttachmentEnvelopeItem(attachment));
        if (genAiSpanItem) env = $636GJ.addItemToEnvelope(env, genAiSpanItem);
        this.sendEnvelope(env).then((sendResponse)=>this.emit("afterSendEvent", event, sendResponse));
    }
    /**
   * Send a session or session aggregrates to Sentry.
   */ sendSession(session) {
        const { release: clientReleaseOption, environment: clientEnvironmentOption = $8Bk70.DEFAULT_ENVIRONMENT } = this._options;
        if ("aggregates" in session) {
            const sessionAttrs = session.attrs || {};
            if (!sessionAttrs.release && !clientReleaseOption) {
                $hiZR1.DEBUG_BUILD && $4gyod.debug.warn($9305ad8b789e6bf9$var$MISSING_RELEASE_FOR_SESSION_ERROR);
                return;
            }
            sessionAttrs.release = sessionAttrs.release || clientReleaseOption;
            sessionAttrs.environment = sessionAttrs.environment || clientEnvironmentOption;
            session.attrs = sessionAttrs;
        } else {
            if (!session.release && !clientReleaseOption) {
                $hiZR1.DEBUG_BUILD && $4gyod.debug.warn($9305ad8b789e6bf9$var$MISSING_RELEASE_FOR_SESSION_ERROR);
                return;
            }
            session.release = session.release || clientReleaseOption;
            session.environment = session.environment || clientEnvironmentOption;
        }
        this.emit("beforeSendSession", session);
        const env = $gjixg.createSessionEnvelope(session, this._dsn, this._options._metadata, this._options.tunnel);
        this.sendEnvelope(env);
    }
    /**
   * Record on the client that an event got dropped (ie, an event that will not be sent to Sentry).
   */ recordDroppedEvent(reason, category, count = 1) {
        if (this._options.sendClientReports) {
            const key = `${reason}:${category}`;
            $hiZR1.DEBUG_BUILD && $4gyod.debug.log(`Recording outcome: "${key}"${count > 1 ? ` (${count} times)` : ""}`);
            this._outcomes[key] = (this._outcomes[key] || 0) + count;
        }
    }
    /**
   * Register a hook on this client.
   */ on(hook, callback) {
        const hookCallbacks = this._hooks[hook] = this._hooks[hook] || /* @__PURE__ */ new Set();
        const uniqueCallback = (...args)=>callback(...args);
        hookCallbacks.add(uniqueCallback);
        return ()=>{
            hookCallbacks.delete(uniqueCallback);
        };
    }
    /**
   * Emit a hook that was previously registered via `on()`.
   */ emit(hook, ...rest) {
        const callbacks = this._hooks[hook];
        if (callbacks) callbacks.forEach((callback)=>callback(...rest));
    }
    /**
   * Send an envelope to Sentry.
   */ // @ts-expect-error - PromiseLike is a subset of Promise
    async sendEnvelope(envelope) {
        this.emit("beforeEnvelope", envelope);
        if (this._isEnabled() && this._transport) try {
            return await this._transport.send(envelope);
        } catch (reason) {
            $hiZR1.DEBUG_BUILD && $4gyod.debug.error("Error while sending envelope:", reason);
            return {};
        }
        $hiZR1.DEBUG_BUILD && $4gyod.debug.error("Transport disabled");
        return {};
    }
    /**
   * Register a cleanup function to be called when the client is disposed.
   * This is useful for integrations that need to clean up global state.
   *
   * NOTE: This is a no-op in the base `Client` class. Subclasses like `ServerRuntimeClient`
   * override this method to actually register and execute cleanup callbacks.
   */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    registerCleanup(callback) {}
    /**
   * Disposes of the client and releases all resources.
   *
   * Subclasses should override this method to clean up their own resources, including invoking
   * any callbacks registered via {@link Client.registerCleanup}. The base implementation is a
   * no-op and does NOT execute registered cleanup callbacks.
   *
   * After calling dispose(), the client should not be used anymore.
   */ dispose() {}
    /* eslint-enable @typescript-eslint/unified-signatures */ /** Setup integrations for this client. */ _setupIntegrations() {
        const { integrations: integrations } = this._options;
        this._integrations = $g33UP.setupIntegrations(this, integrations);
        $g33UP.afterSetupIntegrations(this, integrations);
    }
    /** Updates existing session based on the provided event */ _updateSessionFromEvent(session$1, event) {
        let crashed = event.level === "fatal";
        let errored = false;
        const exceptions = event.exception?.values;
        if (exceptions) {
            errored = true;
            crashed = false;
            for (const ex of exceptions)if (ex.mechanism?.handled === false) {
                crashed = true;
                break;
            }
        }
        const sessionNonTerminal = session$1.status === "ok";
        const shouldUpdateAndSend = sessionNonTerminal && session$1.errors === 0 || sessionNonTerminal && crashed;
        if (shouldUpdateAndSend) {
            $dsI2h.updateSession(session$1, {
                ...crashed && {
                    status: "crashed"
                },
                errors: session$1.errors || Number(errored || crashed)
            });
            this.captureSession(session$1);
        }
    }
    /**
   * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
   * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
   * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
   * `false` otherwise
   */ async _isClientDoneProcessing(timeout) {
        let ticked = 0;
        while(!timeout || ticked < timeout){
            await new Promise((resolve)=>setTimeout(resolve, 1));
            if (!this._numProcessing) return true;
            ticked++;
        }
        return false;
    }
    /** Determines whether this SDK is enabled and a transport is present. */ _isEnabled() {
        return this.getOptions().enabled !== false && this._transport !== void 0;
    }
    /**
   * Adds common information to events.
   *
   * The information includes release and environment from `options`,
   * breadcrumbs and context (extra, tags and user) from the scope.
   *
   * Information that is already present in the event is never overwritten. For
   * nested objects, such as the context, keys are merged.
   *
   * @param event The original event.
   * @param hint May contain additional information about the original exception.
   * @param currentScope A scope containing event metadata.
   * @returns A new event with more information.
   */ _prepareEvent(event, hint, currentScope, isolationScope) {
        const options = this.getOptions();
        const integrations = this.getIntegrationNames();
        if (!hint.integrations && integrations.length) hint.integrations = integrations;
        this.emit("preprocessEvent", event, hint);
        if (!event.type) isolationScope.setLastEventId(event.event_id || hint.event_id);
        return $1rqgb.prepareEvent(options, event, hint, currentScope, this, isolationScope).then((evt)=>{
            if (evt === null) return evt;
            this.emit("postprocessEvent", evt, hint);
            evt.contexts = {
                trace: {
                    ...evt.contexts?.trace,
                    ...$79m2C.getTraceContextFromScope(currentScope)
                },
                ...evt.contexts
            };
            const dynamicSamplingContext$1 = $f0qnC.getDynamicSamplingContextFromScope(this, currentScope);
            evt.sdkProcessingMetadata = {
                dynamicSamplingContext: dynamicSamplingContext$1,
                ...evt.sdkProcessingMetadata
            };
            return evt;
        });
    }
    /**
   * Processes the event and logs an error in case of rejection
   * @param event
   * @param hint
   * @param scope
   */ _captureEvent(event, hint = {}, currentScope = $79m2C.getCurrentScope(), isolationScope = $79m2C.getIsolationScope()) {
        if ($hiZR1.DEBUG_BUILD && $9305ad8b789e6bf9$var$isErrorEvent(event)) $4gyod.debug.log(`Captured error event \`${$8008j.getPossibleEventMessages(event)[0] || "<unknown>"}\``);
        return this._processEvent(event, hint, currentScope, isolationScope).then((finalEvent)=>{
            return finalEvent.event_id;
        }, (reason)=>{
            if ($hiZR1.DEBUG_BUILD) {
                if ($9305ad8b789e6bf9$var$_isDoNotSendEventError(reason)) $4gyod.debug.log(reason.message);
                else if ($9305ad8b789e6bf9$var$_isInternalError(reason)) $4gyod.debug.warn(reason.message);
                else $4gyod.debug.warn(reason);
            }
            return void 0;
        });
    }
    /**
   * Processes an event (either error or message) and sends it to Sentry.
   *
   * This also adds breadcrumbs and context information to the event. However,
   * platform specific meta data (such as the User's IP address) must be added
   * by the SDK implementor.
   *
   *
   * @param event The event to send to Sentry.
   * @param hint May contain additional information about the original exception.
   * @param currentScope A scope containing event metadata.
   * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
   */ _processEvent(event, hint, currentScope, isolationScope) {
        const options = this.getOptions();
        const { sampleRate: sampleRate } = options;
        const isTransaction = $9305ad8b789e6bf9$var$isTransactionEvent(event);
        const isError = $9305ad8b789e6bf9$var$isErrorEvent(event);
        const eventType = event.type || "error";
        const beforeSendLabel = `before send for type \`${eventType}\``;
        const parsedSampleRate = typeof sampleRate === "undefined" ? void 0 : $dkhYR.parseSampleRate(sampleRate);
        if (isError && typeof parsedSampleRate === "number" && $lLUp4.safeMathRandom() > parsedSampleRate) {
            this.recordDroppedEvent("sample_rate", "error");
            return $eligX.rejectedSyncPromise($9305ad8b789e6bf9$var$_makeDoNotSendEventError(`Discarding event because it's not included in the random sample (sampling rate = ${sampleRate})`));
        }
        const dataCategory = $9305ad8b789e6bf9$var$getDataCategoryByType(event.type);
        return this._prepareEvent(event, hint, currentScope, isolationScope).then((prepared)=>{
            if (prepared === null) {
                this.recordDroppedEvent("event_processor", dataCategory);
                throw $9305ad8b789e6bf9$var$_makeDoNotSendEventError("An event processor returned `null`, will not send event.");
            }
            const isInternalException = hint.data?.__sentry__ === true;
            if (isInternalException) return prepared;
            const result = $9305ad8b789e6bf9$var$processBeforeSend(this, options, prepared, hint);
            return $9305ad8b789e6bf9$var$_validateBeforeSendResult(result, beforeSendLabel);
        }).then((processedEvent)=>{
            if (processedEvent === null) {
                this.recordDroppedEvent("before_send", dataCategory);
                if (isTransaction) {
                    const spans = event.spans || [];
                    const spanCount = 1 + spans.length;
                    this.recordDroppedEvent("before_send", "span", spanCount);
                }
                throw $9305ad8b789e6bf9$var$_makeDoNotSendEventError(`${beforeSendLabel} returned \`null\`, will not send event.`);
            }
            const session = currentScope.getSession() || isolationScope.getSession();
            if (isError && session) this._updateSessionFromEvent(session, processedEvent);
            if (isTransaction) {
                const spanCountBefore = processedEvent.sdkProcessingMetadata?.spanCountBeforeProcessing || 0;
                const spanCountAfter = processedEvent.spans ? processedEvent.spans.length : 0;
                const droppedSpanCount = spanCountBefore - spanCountAfter;
                if (droppedSpanCount > 0) this.recordDroppedEvent("before_send", "span", droppedSpanCount);
            }
            const transactionInfo = processedEvent.transaction_info;
            if (isTransaction && transactionInfo && processedEvent.transaction !== event.transaction) {
                const source = "custom";
                processedEvent.transaction_info = {
                    ...transactionInfo,
                    source: source
                };
            }
            this.sendEvent(processedEvent, hint);
            return processedEvent;
        }).then(null, (reason)=>{
            if ($9305ad8b789e6bf9$var$_isDoNotSendEventError(reason) || $9305ad8b789e6bf9$var$_isInternalError(reason)) throw reason;
            this.captureException(reason, {
                mechanism: {
                    handled: false,
                    type: "internal"
                },
                data: {
                    __sentry__: true
                },
                originalException: reason
            });
            throw $9305ad8b789e6bf9$var$_makeInternalError(`Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.
Reason: ${reason}`);
        });
    }
    /**
   * Occupies the client with processing and event
   */ _process(taskProducer, dataCategory) {
        this._numProcessing++;
        this._promiseBuffer.add(taskProducer).then((value)=>{
            this._numProcessing--;
            return value;
        }, (reason)=>{
            this._numProcessing--;
            if (reason === $gaj81.SENTRY_BUFFER_FULL_ERROR) this.recordDroppedEvent("queue_overflow", dataCategory);
            return reason;
        });
    }
    /**
   * Clears outcomes on this client and returns them.
   */ _clearOutcomes() {
        const outcomes = this._outcomes;
        this._outcomes = {};
        return Object.entries(outcomes).map(([key, quantity])=>{
            const [reason, category] = key.split(":");
            return {
                reason: reason,
                category: category,
                quantity: quantity
            };
        });
    }
    /**
   * Sends client reports as an envelope.
   */ _flushOutcomes() {
        $hiZR1.DEBUG_BUILD && $4gyod.debug.log("Flushing outcomes...");
        const outcomes = this._clearOutcomes();
        if (outcomes.length === 0) {
            $hiZR1.DEBUG_BUILD && $4gyod.debug.log("No outcomes to send");
            return;
        }
        if (!this._dsn) {
            $hiZR1.DEBUG_BUILD && $4gyod.debug.log("No dsn provided, will not send outcomes");
            return;
        }
        $hiZR1.DEBUG_BUILD && $4gyod.debug.log("Sending outcomes:", outcomes);
        const envelope = $6lXp4.createClientReportEnvelope(outcomes, this._options.tunnel && $7E8b3.dsnToString(this._dsn));
        this.sendEnvelope(envelope);
    }
}
function $9305ad8b789e6bf9$var$getDataCategoryByType(type) {
    return type === "replay_event" ? "replay" : type || "error";
}
function $9305ad8b789e6bf9$var$_validateBeforeSendResult(beforeSendResult, beforeSendLabel) {
    const invalidValueError = `${beforeSendLabel} must return \`null\` or a valid event.`;
    if ($dzfKZ.isThenable(beforeSendResult)) return beforeSendResult.then((event)=>{
        if (!$dzfKZ.isPlainObject(event) && event !== null) throw $9305ad8b789e6bf9$var$_makeInternalError(invalidValueError);
        return event;
    }, (e)=>{
        throw $9305ad8b789e6bf9$var$_makeInternalError(`${beforeSendLabel} rejected with ${e}`);
    });
    else if (!$dzfKZ.isPlainObject(beforeSendResult) && beforeSendResult !== null) throw $9305ad8b789e6bf9$var$_makeInternalError(invalidValueError);
    return beforeSendResult;
}
function $9305ad8b789e6bf9$var$processBeforeSend(client, options, event, hint) {
    const { beforeSend: beforeSend, beforeSendTransaction: beforeSendTransaction, ignoreSpans: ignoreSpans } = options;
    const beforeSendSpan$1 = !$hOwNc.isStreamedBeforeSendSpanCallback(options.beforeSendSpan) && options.beforeSendSpan;
    let processedEvent = event;
    if ($9305ad8b789e6bf9$var$isErrorEvent(processedEvent) && beforeSend) return beforeSend(processedEvent, hint);
    if ($9305ad8b789e6bf9$var$isTransactionEvent(processedEvent)) {
        if (beforeSendSpan$1 || ignoreSpans) {
            const rootSpanJson = $lM2xr.convertTransactionEventToSpanJson(processedEvent);
            if (ignoreSpans?.length && $cRlHT.shouldIgnoreSpan({
                description: rootSpanJson.description,
                op: rootSpanJson.op,
                attributes: rootSpanJson.data
            }, ignoreSpans)) return null;
            if (beforeSendSpan$1) {
                const processedRootSpanJson = beforeSendSpan$1(rootSpanJson);
                if (!processedRootSpanJson) $8jbnX.showSpanDropWarning();
                else processedEvent = $c9oD0.merge(event, $lM2xr.convertSpanJsonToTransactionEvent(processedRootSpanJson));
            }
            if (processedEvent.spans) {
                const processedSpans = [];
                const initialSpans = processedEvent.spans;
                for (const span of initialSpans){
                    if (ignoreSpans?.length && $cRlHT.shouldIgnoreSpan({
                        description: span.description,
                        op: span.op,
                        attributes: span.data
                    }, ignoreSpans)) {
                        $cRlHT.reparentChildSpans(initialSpans, span);
                        continue;
                    }
                    if (beforeSendSpan$1) {
                        const processedSpan = beforeSendSpan$1(span);
                        if (!processedSpan) {
                            $8jbnX.showSpanDropWarning();
                            processedSpans.push(span);
                        } else processedSpans.push(processedSpan);
                    } else processedSpans.push(span);
                }
                const droppedSpans = processedEvent.spans.length - processedSpans.length;
                if (droppedSpans) client.recordDroppedEvent("before_send", "span", droppedSpans);
                processedEvent.spans = processedSpans;
            }
        }
        if (beforeSendTransaction) {
            if (processedEvent.spans) {
                const spanCountBefore = processedEvent.spans.length;
                processedEvent.sdkProcessingMetadata = {
                    ...event.sdkProcessingMetadata,
                    spanCountBeforeProcessing: spanCountBefore
                };
            }
            return beforeSendTransaction(processedEvent, hint);
        }
    }
    return processedEvent;
}
function $9305ad8b789e6bf9$var$isErrorEvent(event) {
    return event.type === void 0;
}
function $9305ad8b789e6bf9$var$isTransactionEvent(event) {
    return event.type === "transaction";
}
function $9305ad8b789e6bf9$var$estimateMetricSizeInBytes(metric) {
    let weight = 0;
    if (metric.name) weight += metric.name.length * 2;
    weight += 8;
    return weight + $9305ad8b789e6bf9$var$estimateAttributesSizeInBytes(metric.attributes);
}
function $9305ad8b789e6bf9$var$estimateLogSizeInBytes(log) {
    let weight = 0;
    if (log.message) weight += log.message.length * 2;
    return weight + $9305ad8b789e6bf9$var$estimateAttributesSizeInBytes(log.attributes);
}
function $9305ad8b789e6bf9$var$estimateAttributesSizeInBytes(attributes) {
    if (!attributes) return 0;
    let weight = 0;
    Object.values(attributes).forEach((value)=>{
        if (Array.isArray(value)) weight += value.length * $9305ad8b789e6bf9$var$estimatePrimitiveSizeInBytes(value[0]);
        else if ($dzfKZ.isPrimitive(value)) weight += $9305ad8b789e6bf9$var$estimatePrimitiveSizeInBytes(value);
        else weight += 100;
    });
    return weight;
}
function $9305ad8b789e6bf9$var$estimatePrimitiveSizeInBytes(value) {
    if (typeof value === "string") return value.length * 2;
    else if (typeof value === "number") return 8;
    else if (typeof value === "boolean") return 4;
    return 0;
}
module.exports.Client = $9305ad8b789e6bf9$var$Client;

});
parcelRegister("g33UP", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $79m2C = parcelRequire("79m2C");

var $hiZR1 = parcelRequire("hiZR1");

var $4gyod = parcelRequire("4gyod");
const $baeff6b77bc7c47b$var$installedIntegrations = [];
function $baeff6b77bc7c47b$var$filterDuplicates(integrations) {
    const integrationsByName = {};
    integrations.forEach((currentInstance)=>{
        const { name: name } = currentInstance;
        const existingInstance = integrationsByName[name];
        if (existingInstance && !existingInstance.isDefaultInstance && currentInstance.isDefaultInstance) return;
        integrationsByName[name] = currentInstance;
    });
    return Object.values(integrationsByName);
}
function $baeff6b77bc7c47b$var$getIntegrationsToSetup(options) {
    const defaultIntegrations = options.defaultIntegrations || [];
    const userIntegrations = options.integrations;
    defaultIntegrations.forEach((integration)=>{
        integration.isDefaultInstance = true;
    });
    let integrations;
    if (Array.isArray(userIntegrations)) integrations = [
        ...defaultIntegrations,
        ...userIntegrations
    ];
    else if (typeof userIntegrations === "function") {
        const resolvedUserIntegrations = userIntegrations(defaultIntegrations);
        integrations = Array.isArray(resolvedUserIntegrations) ? resolvedUserIntegrations : [
            resolvedUserIntegrations
        ];
    } else integrations = defaultIntegrations;
    return $baeff6b77bc7c47b$var$filterDuplicates(integrations);
}
function $baeff6b77bc7c47b$var$setupIntegrations(client, integrations) {
    const integrationIndex = {};
    integrations.forEach((integration)=>{
        if (integration?.beforeSetup) integration.beforeSetup(client);
    });
    integrations.forEach((integration)=>{
        if (integration) $baeff6b77bc7c47b$var$setupIntegration(client, integration, integrationIndex);
    });
    return integrationIndex;
}
function $baeff6b77bc7c47b$var$afterSetupIntegrations(client, integrations) {
    for (const integration of integrations)if (integration?.afterAllSetup) integration.afterAllSetup(client);
}
function $baeff6b77bc7c47b$var$setupIntegration(client, integration, integrationIndex) {
    if (integrationIndex[integration.name]) {
        $hiZR1.DEBUG_BUILD && $4gyod.debug.log(`Integration skipped because it was already installed: ${integration.name}`);
        return;
    }
    integrationIndex[integration.name] = integration;
    if (!$baeff6b77bc7c47b$var$installedIntegrations.includes(integration.name) && typeof integration.setupOnce === "function") {
        integration.setupOnce();
        $baeff6b77bc7c47b$var$installedIntegrations.push(integration.name);
    }
    if (integration.setup && typeof integration.setup === "function") integration.setup(client);
    if (typeof integration.preprocessEvent === "function") {
        const callback = integration.preprocessEvent.bind(integration);
        client.on("preprocessEvent", (event, hint)=>callback(event, hint, client));
    }
    if (typeof integration.processEvent === "function") {
        const callback = integration.processEvent.bind(integration);
        const processor = Object.assign((event, hint)=>callback(event, hint, client), {
            id: integration.name
        });
        client.addEventProcessor(processor);
    }
    [
        "processSpan",
        "processSegmentSpan"
    ].forEach((hook)=>{
        const callback = integration[hook];
        if (typeof callback === "function") client.on(hook, (span)=>callback.call(integration, span, client));
    });
    $hiZR1.DEBUG_BUILD && $4gyod.debug.log(`Integration installed: ${integration.name}`);
}
function $baeff6b77bc7c47b$var$addIntegration(integration) {
    const client = $79m2C.getClient();
    if (!client) {
        $hiZR1.DEBUG_BUILD && $4gyod.debug.warn(`Cannot add integration "${integration.name}" because no SDK Client is available.`);
        return;
    }
    client.addIntegration(integration);
}
function $baeff6b77bc7c47b$var$defineIntegration(fn) {
    return fn;
}
function $baeff6b77bc7c47b$var$extendIntegration(integration, extendedIntegration) {
    const wrappedIntegration = {
        ...integration,
        ...extendedIntegration
    };
    for(const key in extendedIntegration){
        const baseValue = integration[key];
        const extendedValue = extendedIntegration[key];
        if (typeof baseValue === "function" && typeof extendedValue === "function") {
            const wrappedFunction = new Proxy(baseValue, {
                apply: (target, thisArg, args)=>{
                    Reflect.apply(target, thisArg, args);
                    return Reflect.apply(extendedValue, thisArg, args);
                }
            });
            wrappedIntegration[key] = wrappedFunction;
        }
    }
    return wrappedIntegration;
}
module.exports.addIntegration = $baeff6b77bc7c47b$var$addIntegration;
module.exports.afterSetupIntegrations = $baeff6b77bc7c47b$var$afterSetupIntegrations;
module.exports.defineIntegration = $baeff6b77bc7c47b$var$defineIntegration;
module.exports.extendIntegration = $baeff6b77bc7c47b$var$extendIntegration;
module.exports.getIntegrationsToSetup = $baeff6b77bc7c47b$var$getIntegrationsToSetup;
module.exports.installedIntegrations = $baeff6b77bc7c47b$var$installedIntegrations;
module.exports.setupIntegration = $baeff6b77bc7c47b$var$setupIntegration;
module.exports.setupIntegrations = $baeff6b77bc7c47b$var$setupIntegrations;

});

parcelRegister("7LBlQ", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $iSFYH = parcelRequire("iSFYH");

var $4fnou = parcelRequire("4fnou");

var $79m2C = parcelRequire("79m2C");

var $hiZR1 = parcelRequire("hiZR1");

var $4gyod = parcelRequire("4gyod");

var $dzfKZ = parcelRequire("dzfKZ");

var $fsIRO = parcelRequire("fsIRO");

var $f9GTk = parcelRequire("f9GTk");

var $ihsl1 = parcelRequire("ihsl1");

var $jv6Jx = parcelRequire("jv6Jx");

var $1J6fX = parcelRequire("1J6fX");

var $6d8RZ = parcelRequire("6d8RZ");

var $4rTRb = parcelRequire("4rTRb");
const $5a79e55ce7098100$var$MAX_LOG_BUFFER_SIZE = 100;
function $5a79e55ce7098100$var$setLogAttribute(logAttributes, key, value, setEvenIfPresent = true) {
    if (value && (!logAttributes[key] || setEvenIfPresent)) logAttributes[key] = value;
}
function $5a79e55ce7098100$var$_INTERNAL_captureSerializedLog(client, serializedLog) {
    const bufferMap = $5a79e55ce7098100$var$_getBufferMap();
    const logBuffer = $5a79e55ce7098100$var$_INTERNAL_getLogBuffer(client);
    if (logBuffer === void 0) bufferMap.set(client, [
        serializedLog
    ]);
    else if (logBuffer.length >= $5a79e55ce7098100$var$MAX_LOG_BUFFER_SIZE) {
        $5a79e55ce7098100$var$_INTERNAL_flushLogsBuffer(client, logBuffer);
        bufferMap.set(client, [
            serializedLog
        ]);
    } else bufferMap.set(client, [
        ...logBuffer,
        serializedLog
    ]);
}
function $5a79e55ce7098100$var$_INTERNAL_captureLog(beforeLog, currentScope = $79m2C.getCurrentScope(), captureSerializedLog = $5a79e55ce7098100$var$_INTERNAL_captureSerializedLog) {
    const client = currentScope?.getClient() ?? $79m2C.getClient();
    if (!client) {
        $hiZR1.DEBUG_BUILD && $4gyod.debug.warn("No client available to capture log.");
        return;
    }
    const { release: release, environment: environment, enableLogs: enableLogs = false, beforeSendLog: beforeSendLog } = client.getOptions();
    if (!enableLogs) {
        $hiZR1.DEBUG_BUILD && $4gyod.debug.warn("logging option not enabled, log will not be captured.");
        return;
    }
    const [, traceContext] = $1J6fX._getTraceInfoFromScope(client, currentScope);
    const processedLogAttributes = {
        ...beforeLog.attributes
    };
    const { user: { id: id, email: email, username: username }, attributes: scopeAttributes = {} } = $fsIRO.getCombinedScopeData($79m2C.getIsolationScope(), currentScope);
    $5a79e55ce7098100$var$setLogAttribute(processedLogAttributes, "user.id", id, false);
    $5a79e55ce7098100$var$setLogAttribute(processedLogAttributes, "user.email", email, false);
    $5a79e55ce7098100$var$setLogAttribute(processedLogAttributes, "user.name", username, false);
    $5a79e55ce7098100$var$setLogAttribute(processedLogAttributes, "sentry.release", release);
    $5a79e55ce7098100$var$setLogAttribute(processedLogAttributes, "sentry.environment", environment);
    const { name: name, version: version } = client.getSdkMetadata()?.sdk ?? {};
    $5a79e55ce7098100$var$setLogAttribute(processedLogAttributes, "sentry.sdk.name", name);
    $5a79e55ce7098100$var$setLogAttribute(processedLogAttributes, "sentry.sdk.version", version);
    const replay = client.getIntegrationByName("Replay");
    const replayId = replay?.getReplayId(true);
    $5a79e55ce7098100$var$setLogAttribute(processedLogAttributes, "sentry.replay_id", replayId);
    if (replayId && replay?.getRecordingMode() === "buffer") $5a79e55ce7098100$var$setLogAttribute(processedLogAttributes, "sentry._internal.replay_is_buffering", true);
    const beforeLogMessage = beforeLog.message;
    if ($dzfKZ.isParameterizedString(beforeLogMessage)) {
        const { __sentry_template_string__: __sentry_template_string__, __sentry_template_values__: __sentry_template_values__ = [] } = beforeLogMessage;
        if (__sentry_template_values__?.length) processedLogAttributes["sentry.message.template"] = __sentry_template_string__;
        __sentry_template_values__.forEach((param, index)=>{
            processedLogAttributes[`sentry.message.parameter.${index}`] = param;
        });
    }
    const span = $f9GTk._getSpanForScope(currentScope);
    $5a79e55ce7098100$var$setLogAttribute(processedLogAttributes, "sentry.trace.parent_span_id", span?.spanContext().spanId);
    const processedLog = {
        ...beforeLog,
        attributes: processedLogAttributes
    };
    client.emit("beforeCaptureLog", processedLog);
    const log = beforeSendLog ? $4gyod.consoleSandbox(()=>beforeSendLog(processedLog)) : processedLog;
    if (!log) {
        client.recordDroppedEvent("before_send", "log_item", 1);
        $hiZR1.DEBUG_BUILD && $4gyod.debug.warn("beforeSendLog returned null, log will not be captured.");
        return;
    }
    const { level: level, message: message, attributes: logAttributes = {}, severityNumber: severityNumber } = log;
    const timestamp = $ihsl1.timestampInSeconds();
    const sequenceAttr = $jv6Jx.getSequenceAttribute(timestamp);
    const serializedLog = {
        timestamp: timestamp,
        level: level,
        body: $5a79e55ce7098100$var$_removeLoneSurrogates(String(message)),
        trace_id: traceContext?.trace_id,
        severity_number: severityNumber ?? $6d8RZ.SEVERITY_TEXT_TO_SEVERITY_NUMBER[level],
        attributes: $5a79e55ce7098100$var$sanitizeLogAttributes({
            ...$iSFYH.serializeAttributes(scopeAttributes),
            ...$iSFYH.serializeAttributes(logAttributes, true),
            [sequenceAttr.key]: sequenceAttr.value
        })
    };
    captureSerializedLog(client, serializedLog);
    client.emit("afterCaptureLog", log);
}
function $5a79e55ce7098100$var$_INTERNAL_flushLogsBuffer(client, maybeLogBuffer) {
    const logBuffer = maybeLogBuffer ?? $5a79e55ce7098100$var$_INTERNAL_getLogBuffer(client) ?? [];
    if (logBuffer.length === 0) return;
    const clientOptions = client.getOptions();
    const envelope$1 = $4rTRb.createLogEnvelope(logBuffer, clientOptions._metadata, clientOptions.tunnel, client.getDsn(), client.getDataCollectionOptions().userInfo);
    $5a79e55ce7098100$var$_getBufferMap().set(client, []);
    client.emit("flushLogs");
    client.sendEnvelope(envelope$1);
}
function $5a79e55ce7098100$var$_INTERNAL_getLogBuffer(client) {
    return $5a79e55ce7098100$var$_getBufferMap().get(client);
}
function $5a79e55ce7098100$var$_getBufferMap() {
    return $4fnou.getGlobalSingleton("clientToLogBufferMap", ()=>/* @__PURE__ */ new WeakMap());
}
function $5a79e55ce7098100$var$sanitizeLogAttributes(attributes) {
    const sanitized = {};
    for (const [key, attr] of Object.entries(attributes)){
        const sanitizedKey = $5a79e55ce7098100$var$_removeLoneSurrogates(key);
        if (attr.type === "string") sanitized[sanitizedKey] = {
            ...attr,
            value: $5a79e55ce7098100$var$_removeLoneSurrogates(attr.value)
        };
        else sanitized[sanitizedKey] = attr;
    }
    return sanitized;
}
function $5a79e55ce7098100$var$_removeLoneSurrogates(str) {
    const strObj = Object(str);
    const isWellFormed = strObj["isWellFormed"];
    const toWellFormed = strObj["toWellFormed"];
    if (typeof isWellFormed === "function" && typeof toWellFormed === "function") return isWellFormed.call(str) ? str : toWellFormed.call(str);
    return str;
}
module.exports._INTERNAL_captureLog = $5a79e55ce7098100$var$_INTERNAL_captureLog;
module.exports._INTERNAL_captureSerializedLog = $5a79e55ce7098100$var$_INTERNAL_captureSerializedLog;
module.exports._INTERNAL_flushLogsBuffer = $5a79e55ce7098100$var$_INTERNAL_flushLogsBuffer;
module.exports._INTERNAL_getLogBuffer = $5a79e55ce7098100$var$_INTERNAL_getLogBuffer;
module.exports._removeLoneSurrogates = $5a79e55ce7098100$var$_removeLoneSurrogates;

});
parcelRegister("jv6Jx", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $e32622b942d3ee43$var$SEQUENCE_ATTR_KEY = "sentry.timestamp.sequence";
let $e32622b942d3ee43$var$_sequenceNumber = 0;
let $e32622b942d3ee43$var$_previousTimestampMs;
function $e32622b942d3ee43$var$getSequenceAttribute(timestampInSeconds) {
    const nowMs = Math.floor(timestampInSeconds * 1e3);
    if ($e32622b942d3ee43$var$_previousTimestampMs !== void 0 && nowMs !== $e32622b942d3ee43$var$_previousTimestampMs) $e32622b942d3ee43$var$_sequenceNumber = 0;
    const value = $e32622b942d3ee43$var$_sequenceNumber;
    $e32622b942d3ee43$var$_sequenceNumber++;
    $e32622b942d3ee43$var$_previousTimestampMs = nowMs;
    return {
        key: $e32622b942d3ee43$var$SEQUENCE_ATTR_KEY,
        value: {
            value: value,
            type: "integer"
        }
    };
}
module.exports.getSequenceAttribute = $e32622b942d3ee43$var$getSequenceAttribute;

});

parcelRegister("1J6fX", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $79m2C = parcelRequire("79m2C");

var $f0qnC = parcelRequire("f0qnC");

var $8jbnX = parcelRequire("8jbnX");
function $141ed8c76b683653$var$_getTraceInfoFromScope(client, scope) {
    if (!scope) return [
        void 0,
        void 0
    ];
    return $79m2C.withScope(scope, ()=>{
        const span = $8jbnX.getActiveSpan();
        const traceContext = span ? $8jbnX.spanToTraceContext(span) : $79m2C.getTraceContextFromScope(scope);
        const dynamicSamplingContext$1 = span ? $f0qnC.getDynamicSamplingContextFromSpan(span) : $f0qnC.getDynamicSamplingContextFromScope(client, scope);
        return [
            dynamicSamplingContext$1,
            traceContext
        ];
    });
}
module.exports._getTraceInfoFromScope = $141ed8c76b683653$var$_getTraceInfoFromScope;

});

parcelRegister("6d8RZ", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $485ad64f90543ec0$var$SEVERITY_TEXT_TO_SEVERITY_NUMBER = {
    trace: 1,
    debug: 5,
    info: 9,
    warn: 13,
    error: 17,
    fatal: 21
};
module.exports.SEVERITY_TEXT_TO_SEVERITY_NUMBER = $485ad64f90543ec0$var$SEVERITY_TEXT_TO_SEVERITY_NUMBER;

});

parcelRegister("4rTRb", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $7E8b3 = parcelRequire("7E8b3");

var $636GJ = parcelRequire("636GJ");

var $kIp0s = parcelRequire("kIp0s");
function $33d50304d0dce15e$var$createLogContainerEnvelopeItem(items, inferUserData) {
    const inferSetting = inferUserData ? "auto" : "never";
    return [
        {
            type: "log",
            item_count: items.length,
            content_type: "application/vnd.sentry.items.log+json"
        },
        {
            version: 2,
            ...$kIp0s.isBrowser() && {
                ingest_settings: {
                    infer_ip: inferSetting,
                    infer_user_agent: inferSetting
                }
            },
            items: items
        }
    ];
}
function $33d50304d0dce15e$var$createLogEnvelope(logs, metadata, tunnel, dsn$1, inferUserData) {
    const headers = {};
    if (metadata?.sdk) headers.sdk = {
        name: metadata.sdk.name,
        version: metadata.sdk.version
    };
    if (!!tunnel && !!dsn$1) headers.dsn = $7E8b3.dsnToString(dsn$1);
    return $636GJ.createEnvelope(headers, [
        $33d50304d0dce15e$var$createLogContainerEnvelopeItem(logs, inferUserData)
    ]);
}
module.exports.createLogContainerEnvelopeItem = $33d50304d0dce15e$var$createLogContainerEnvelopeItem;
module.exports.createLogEnvelope = $33d50304d0dce15e$var$createLogEnvelope;

});
parcelRegister("kIp0s", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $d9eHV = parcelRequire("d9eHV");

var $eP8Ri = parcelRequire("eP8Ri");
function $f14b5079e461196a$var$isBrowser() {
    return typeof window !== "undefined" && (!$d9eHV.isNodeEnv() || $f14b5079e461196a$var$isElectronNodeRenderer());
}
function $f14b5079e461196a$var$isElectronNodeRenderer() {
    const process = $eP8Ri.GLOBAL_OBJ.process;
    return process?.type === "renderer";
}
module.exports.isBrowser = $f14b5079e461196a$var$isBrowser;

});
parcelRegister("d9eHV", function(module, exports) {
Object.defineProperty(exports, Symbol.toStringTag, {
    value: 'Module'
});

var $h0BBG = parcelRequire("h0BBG");
function isNodeEnv() {
    return !$h0BBG.isBrowserBundle() && Object.prototype.toString.call(0) === "[object process]";
}
function dynamicRequire(mod, request) {
    return mod.require(request);
}
function loadModule(moduleName, existingModule = module) {
    let mod;
    try {
        mod = dynamicRequire(existingModule, moduleName);
    } catch  {}
    if (!mod) try {
        const { cwd } = dynamicRequire(existingModule, "process");
        mod = dynamicRequire(existingModule, `${cwd()}/node_modules/${moduleName}`);
    } catch  {}
    return mod;
}
exports.isNodeEnv = isNodeEnv;
exports.loadModule = loadModule;

});
parcelRegister("h0BBG", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $c61f9ba9ba9f737a$var$isBrowserBundle() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== "undefined" && !!__SENTRY_BROWSER_BUNDLE__;
}
function $c61f9ba9ba9f737a$var$getSDKSource() {
    /*! __SENTRY_SDK_SOURCE__ */ return "npm";
}
module.exports.getSDKSource = $c61f9ba9ba9f737a$var$getSDKSource;
module.exports.isBrowserBundle = $c61f9ba9ba9f737a$var$isBrowserBundle;

});





parcelRegister("5zO49", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $iSFYH = parcelRequire("iSFYH");

var $4fnou = parcelRequire("4fnou");

var $79m2C = parcelRequire("79m2C");

var $hiZR1 = parcelRequire("hiZR1");

var $4gyod = parcelRequire("4gyod");

var $fsIRO = parcelRequire("fsIRO");

var $f9GTk = parcelRequire("f9GTk");

var $ihsl1 = parcelRequire("ihsl1");

var $jv6Jx = parcelRequire("jv6Jx");

var $1J6fX = parcelRequire("1J6fX");

var $52ABl = parcelRequire("52ABl");
const $40f70eac3016efc0$var$MAX_METRIC_BUFFER_SIZE = 1e3;
function $40f70eac3016efc0$var$setMetricAttribute(metricAttributes, key, value, setEvenIfPresent = true) {
    if (value && (setEvenIfPresent || !(key in metricAttributes))) metricAttributes[key] = value;
}
function $40f70eac3016efc0$var$_INTERNAL_captureSerializedMetric(client, serializedMetric) {
    const bufferMap = $40f70eac3016efc0$var$_getBufferMap();
    const metricBuffer = $40f70eac3016efc0$var$_INTERNAL_getMetricBuffer(client);
    if (metricBuffer === void 0) bufferMap.set(client, [
        serializedMetric
    ]);
    else if (metricBuffer.length >= $40f70eac3016efc0$var$MAX_METRIC_BUFFER_SIZE) {
        $40f70eac3016efc0$var$_INTERNAL_flushMetricsBuffer(client, metricBuffer);
        bufferMap.set(client, [
            serializedMetric
        ]);
    } else bufferMap.set(client, [
        ...metricBuffer,
        serializedMetric
    ]);
}
function $40f70eac3016efc0$var$_enrichMetricAttributes(beforeMetric, client, user) {
    const { release: release, environment: environment } = client.getOptions();
    const processedMetricAttributes = {
        ...beforeMetric.attributes
    };
    $40f70eac3016efc0$var$setMetricAttribute(processedMetricAttributes, "user.id", user.id, false);
    $40f70eac3016efc0$var$setMetricAttribute(processedMetricAttributes, "user.email", user.email, false);
    $40f70eac3016efc0$var$setMetricAttribute(processedMetricAttributes, "user.name", user.username, false);
    $40f70eac3016efc0$var$setMetricAttribute(processedMetricAttributes, "sentry.release", release);
    $40f70eac3016efc0$var$setMetricAttribute(processedMetricAttributes, "sentry.environment", environment);
    const { name: name, version: version } = client.getSdkMetadata()?.sdk ?? {};
    $40f70eac3016efc0$var$setMetricAttribute(processedMetricAttributes, "sentry.sdk.name", name);
    $40f70eac3016efc0$var$setMetricAttribute(processedMetricAttributes, "sentry.sdk.version", version);
    const replay = client.getIntegrationByName("Replay");
    const replayId = replay?.getReplayId(true);
    $40f70eac3016efc0$var$setMetricAttribute(processedMetricAttributes, "sentry.replay_id", replayId);
    if (replayId && replay?.getRecordingMode() === "buffer") $40f70eac3016efc0$var$setMetricAttribute(processedMetricAttributes, "sentry._internal.replay_is_buffering", true);
    return {
        ...beforeMetric,
        attributes: processedMetricAttributes
    };
}
function $40f70eac3016efc0$var$_buildSerializedMetric(metric, client, currentScope, scopeAttributes) {
    const [, traceContext] = $1J6fX._getTraceInfoFromScope(client, currentScope);
    const span = $f9GTk._getSpanForScope(currentScope);
    const traceId = span ? span.spanContext().traceId : traceContext?.trace_id;
    const spanId = span ? span.spanContext().spanId : void 0;
    const timestamp = $ihsl1.timestampInSeconds();
    const sequenceAttr = $jv6Jx.getSequenceAttribute(timestamp);
    return {
        timestamp: timestamp,
        trace_id: traceId ?? "",
        span_id: spanId,
        name: metric.name,
        type: metric.type,
        unit: metric.unit,
        value: metric.value,
        attributes: {
            ...$iSFYH.serializeAttributes(scopeAttributes),
            ...$iSFYH.serializeAttributes(metric.attributes, "skip-undefined"),
            [sequenceAttr.key]: sequenceAttr.value
        }
    };
}
function $40f70eac3016efc0$var$_INTERNAL_captureMetric(beforeMetric, options) {
    const currentScope = options?.scope ?? $79m2C.getCurrentScope();
    const captureSerializedMetric = options?.captureSerializedMetric ?? $40f70eac3016efc0$var$_INTERNAL_captureSerializedMetric;
    const client = currentScope?.getClient() ?? $79m2C.getClient();
    if (!client) {
        $hiZR1.DEBUG_BUILD && $4gyod.debug.warn("No client available to capture metric.");
        return;
    }
    const { _experiments: _experiments, enableMetrics: enableMetrics, beforeSendMetric: beforeSendMetric } = client.getOptions();
    const metricsEnabled = enableMetrics ?? _experiments?.enableMetrics ?? true;
    if (!metricsEnabled) {
        $hiZR1.DEBUG_BUILD && $4gyod.debug.warn("metrics option not enabled, metric will not be captured.");
        return;
    }
    const { user: user, attributes: scopeAttributes } = $fsIRO.getCombinedScopeData($79m2C.getIsolationScope(), currentScope);
    const enrichedMetric = $40f70eac3016efc0$var$_enrichMetricAttributes(beforeMetric, client, user);
    client.emit("processMetric", enrichedMetric);
    const beforeSendCallback = beforeSendMetric || _experiments?.beforeSendMetric;
    const processedMetric = beforeSendCallback ? beforeSendCallback(enrichedMetric) : enrichedMetric;
    if (!processedMetric) {
        $hiZR1.DEBUG_BUILD && $4gyod.debug.log("`beforeSendMetric` returned `null`, will not send metric.");
        return;
    }
    const serializedMetric = $40f70eac3016efc0$var$_buildSerializedMetric(processedMetric, client, currentScope, scopeAttributes);
    $hiZR1.DEBUG_BUILD && $4gyod.debug.log("[Metric]", serializedMetric);
    captureSerializedMetric(client, serializedMetric);
    client.emit("afterCaptureMetric", processedMetric);
}
function $40f70eac3016efc0$var$_INTERNAL_flushMetricsBuffer(client, maybeMetricBuffer) {
    const metricBuffer = maybeMetricBuffer ?? $40f70eac3016efc0$var$_INTERNAL_getMetricBuffer(client) ?? [];
    if (metricBuffer.length === 0) return;
    const clientOptions = client.getOptions();
    const envelope$1 = $52ABl.createMetricEnvelope(metricBuffer, clientOptions._metadata, clientOptions.tunnel, client.getDsn(), client.getDataCollectionOptions().userInfo);
    $40f70eac3016efc0$var$_getBufferMap().set(client, []);
    client.emit("flushMetrics");
    client.sendEnvelope(envelope$1);
}
function $40f70eac3016efc0$var$_INTERNAL_getMetricBuffer(client) {
    return $40f70eac3016efc0$var$_getBufferMap().get(client);
}
function $40f70eac3016efc0$var$_getBufferMap() {
    return $4fnou.getGlobalSingleton("clientToMetricBufferMap", ()=>/* @__PURE__ */ new WeakMap());
}
module.exports._INTERNAL_captureMetric = $40f70eac3016efc0$var$_INTERNAL_captureMetric;
module.exports._INTERNAL_captureSerializedMetric = $40f70eac3016efc0$var$_INTERNAL_captureSerializedMetric;
module.exports._INTERNAL_flushMetricsBuffer = $40f70eac3016efc0$var$_INTERNAL_flushMetricsBuffer;
module.exports._INTERNAL_getMetricBuffer = $40f70eac3016efc0$var$_INTERNAL_getMetricBuffer;

});
parcelRegister("52ABl", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $7E8b3 = parcelRequire("7E8b3");

var $636GJ = parcelRequire("636GJ");

var $kIp0s = parcelRequire("kIp0s");
function $3ab987ee08c9b9bf$var$createMetricContainerEnvelopeItem(items, inferUserData) {
    const inferSetting = inferUserData ? "auto" : "never";
    return [
        {
            type: "trace_metric",
            item_count: items.length,
            content_type: "application/vnd.sentry.items.trace-metric+json"
        },
        {
            version: 2,
            ...$kIp0s.isBrowser() && {
                ingest_settings: {
                    infer_ip: inferSetting,
                    infer_user_agent: inferSetting
                }
            },
            items: items
        }
    ];
}
function $3ab987ee08c9b9bf$var$createMetricEnvelope(metrics, metadata, tunnel, dsn$1, inferUserData) {
    const headers = {};
    if (metadata?.sdk) headers.sdk = {
        name: metadata.sdk.name,
        version: metadata.sdk.version
    };
    if (!!tunnel && !!dsn$1) headers.dsn = $7E8b3.dsnToString(dsn$1);
    return $636GJ.createEnvelope(headers, [
        $3ab987ee08c9b9bf$var$createMetricContainerEnvelopeItem(metrics, inferUserData)
    ]);
}
module.exports.createMetricContainerEnvelopeItem = $3ab987ee08c9b9bf$var$createMetricContainerEnvelopeItem;
module.exports.createMetricEnvelope = $3ab987ee08c9b9bf$var$createMetricEnvelope;

});


parcelRegister("7P04K", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $kIp0s = parcelRequire("kIp0s");

var $8ICT0 = parcelRequire("8ICT0");

var $5JNGN = parcelRequire("5JNGN");
function $5b1d5adb8ce30968$var$extractGenAiSpansFromEvent(event, client) {
    if (event.type !== "transaction" || !event.spans?.length || !event.sdkProcessingMetadata?.hasGenAiSpans || client.getOptions().streamGenAiSpans === false || $8ICT0.hasSpanStreamingEnabled(client)) return void 0;
    const genAiSpans = [];
    const remainingSpans = [];
    for (const span of event.spans)if (span.op?.startsWith("gen_ai.")) genAiSpans.push($5JNGN.spanJsonToSerializedStreamedSpan(span));
    else remainingSpans.push(span);
    if (genAiSpans.length === 0) return void 0;
    event.spans = remainingSpans;
    const inferSetting = client.getDataCollectionOptions().userInfo ? "auto" : "never";
    return [
        {
            type: "span",
            item_count: genAiSpans.length,
            content_type: "application/vnd.sentry.items.span.v2+json"
        },
        {
            version: 2,
            ...$kIp0s.isBrowser() && {
                ingest_settings: {
                    infer_ip: inferSetting,
                    infer_user_agent: inferSetting
                }
            },
            items: genAiSpans
        }
    ];
}
module.exports.extractGenAiSpansFromEvent = $5b1d5adb8ce30968$var$extractGenAiSpansFromEvent;

});
parcelRegister("5JNGN", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $8jbnX = parcelRequire("8jbnX");
function $42d7b2f7ad06ebb4$var$spanJsonToSerializedStreamedSpan(span) {
    const streamedSpan = {
        trace_id: span.trace_id,
        span_id: span.span_id,
        parent_span_id: span.parent_span_id,
        name: span.description || "",
        start_timestamp: span.start_timestamp,
        end_timestamp: span.timestamp || span.start_timestamp,
        status: !span.status || span.status === "ok" || span.status === "cancelled" ? "ok" : "error",
        is_segment: false,
        attributes: {
            ...span.data
        },
        links: span.links
    };
    return $8jbnX.streamedSpanJsonToSerializedSpan(streamedSpan);
}
module.exports.spanJsonToSerializedStreamedSpan = $42d7b2f7ad06ebb4$var$spanJsonToSerializedStreamedSpan;

});


parcelRegister("aQrJw", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $hiZR1 = parcelRequire("hiZR1");

var $4gyod = parcelRequire("4gyod");

var $636GJ = parcelRequire("636GJ");

var $gaj81 = parcelRequire("gaj81");

var $iLGyZ = parcelRequire("iLGyZ");
const $7e5445f55743ead7$var$DEFAULT_TRANSPORT_BUFFER_SIZE = 64;
function $7e5445f55743ead7$var$createTransport(options, makeRequest, buffer = $gaj81.makePromiseBuffer(options.bufferSize || $7e5445f55743ead7$var$DEFAULT_TRANSPORT_BUFFER_SIZE)) {
    let rateLimits = {};
    const flush = (timeout)=>buffer.drain(timeout);
    function send(envelope$1) {
        const filteredEnvelopeItems = [];
        $636GJ.forEachEnvelopeItem(envelope$1, (item, type)=>{
            const dataCategory = $636GJ.envelopeItemTypeToDataCategory(type);
            if ($iLGyZ.isRateLimited(rateLimits, dataCategory)) options.recordDroppedEvent("ratelimit_backoff", dataCategory);
            else filteredEnvelopeItems.push(item);
        });
        if (filteredEnvelopeItems.length === 0) return Promise.resolve({});
        const filteredEnvelope = $636GJ.createEnvelope(envelope$1[0], filteredEnvelopeItems);
        const recordEnvelopeLoss = (reason)=>{
            if ($636GJ.envelopeContainsItemType(filteredEnvelope, [
                "client_report"
            ])) {
                $hiZR1.DEBUG_BUILD && $4gyod.debug.warn(`Dropping client report. Will not send outcomes (reason: ${reason}).`);
                return;
            }
            $636GJ.forEachEnvelopeItem(filteredEnvelope, (item, type)=>{
                options.recordDroppedEvent(reason, $636GJ.envelopeItemTypeToDataCategory(type));
            });
        };
        const requestTask = ()=>makeRequest({
                body: $636GJ.serializeEnvelope(filteredEnvelope)
            }).then((response)=>{
                if (response.statusCode === 413) {
                    $hiZR1.DEBUG_BUILD && $4gyod.debug.error("Sentry responded with status code 413. Envelope was discarded due to exceeding size limits.");
                    recordEnvelopeLoss("send_error");
                    return response;
                }
                if ($hiZR1.DEBUG_BUILD && response.statusCode !== void 0 && (response.statusCode < 200 || response.statusCode >= 300)) $4gyod.debug.warn(`Sentry responded with status code ${response.statusCode} to sent event.`);
                rateLimits = $iLGyZ.updateRateLimits(rateLimits, response);
                return response;
            }, (error)=>{
                recordEnvelopeLoss("network_error");
                $hiZR1.DEBUG_BUILD && $4gyod.debug.error("Encountered error running transport request:", error);
                throw error;
            });
        return buffer.add(requestTask).then((result)=>result, (error)=>{
            if (error === $gaj81.SENTRY_BUFFER_FULL_ERROR) {
                $hiZR1.DEBUG_BUILD && $4gyod.debug.error("Skipped sending event because buffer is full.");
                recordEnvelopeLoss("queue_overflow");
                return Promise.resolve({});
            } else throw error;
        });
    }
    return {
        send: send,
        flush: flush
    };
}
module.exports.DEFAULT_TRANSPORT_BUFFER_SIZE = $7e5445f55743ead7$var$DEFAULT_TRANSPORT_BUFFER_SIZE;
module.exports.createTransport = $7e5445f55743ead7$var$createTransport;

});
parcelRegister("gaj81", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $eligX = parcelRequire("eligX");

var $Asczg = parcelRequire("Asczg");
const $bc4c6b003ec5f07a$var$SENTRY_BUFFER_FULL_ERROR = /* @__PURE__ */ Symbol.for("SentryBufferFullError");
function $bc4c6b003ec5f07a$var$makePromiseBuffer(limit = 100) {
    const buffer = /* @__PURE__ */ new Set();
    function isReady() {
        return buffer.size < limit;
    }
    function remove(task) {
        buffer.delete(task);
    }
    function add(taskProducer) {
        if (!isReady()) return $eligX.rejectedSyncPromise($bc4c6b003ec5f07a$var$SENTRY_BUFFER_FULL_ERROR);
        const task = taskProducer();
        buffer.add(task);
        task.then(()=>remove(task), ()=>remove(task));
        return task;
    }
    function drain(timeout) {
        if (!buffer.size) return $eligX.resolvedSyncPromise(true);
        const drainPromise = Promise.allSettled(Array.from(buffer)).then(()=>true);
        if (!timeout) return drainPromise;
        const promises = [
            drainPromise,
            new Promise((resolve)=>$Asczg.safeUnref(setTimeout(()=>resolve(false), timeout)))
        ];
        return Promise.race(promises);
    }
    return {
        get $ () {
            return Array.from(buffer);
        },
        add: add,
        drain: drain
    };
}
module.exports.SENTRY_BUFFER_FULL_ERROR = $bc4c6b003ec5f07a$var$SENTRY_BUFFER_FULL_ERROR;
module.exports.makePromiseBuffer = $bc4c6b003ec5f07a$var$makePromiseBuffer;

});

parcelRegister("iLGyZ", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $lLUp4 = parcelRequire("lLUp4");
const $da9da2000bc0b3a9$var$DEFAULT_RETRY_AFTER = 60000;
function $da9da2000bc0b3a9$var$parseRetryAfterHeader(header, now = $lLUp4.safeDateNow()) {
    const headerDelay = parseInt(`${header}`, 10);
    if (!isNaN(headerDelay)) return headerDelay * 1e3;
    const headerDate = Date.parse(`${header}`);
    if (!isNaN(headerDate)) return headerDate - now;
    return $da9da2000bc0b3a9$var$DEFAULT_RETRY_AFTER;
}
function $da9da2000bc0b3a9$var$disabledUntil(limits, dataCategory) {
    return limits[dataCategory] || limits.all || 0;
}
function $da9da2000bc0b3a9$var$isRateLimited(limits, dataCategory, now = $lLUp4.safeDateNow()) {
    return $da9da2000bc0b3a9$var$disabledUntil(limits, dataCategory) > now;
}
function $da9da2000bc0b3a9$var$updateRateLimits(limits, { statusCode: statusCode, headers: headers }, now = $lLUp4.safeDateNow()) {
    const updatedRateLimits = {
        ...limits
    };
    const rateLimitHeader = headers?.["x-sentry-rate-limits"];
    const retryAfterHeader = headers?.["retry-after"];
    if (rateLimitHeader) for (const limit of rateLimitHeader.trim().split(",")){
        const [retryAfter, categories, , , namespaces] = limit.split(":", 5);
        const headerDelay = parseInt(retryAfter, 10);
        const delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1e3;
        if (!categories) updatedRateLimits.all = now + delay;
        else for (const category of categories.split(";")){
            if (category === "metric_bucket") {
                if (!namespaces || namespaces.split(";").includes("custom")) updatedRateLimits[category] = now + delay;
            } else updatedRateLimits[category] = now + delay;
        }
    }
    else if (retryAfterHeader) updatedRateLimits.all = now + $da9da2000bc0b3a9$var$parseRetryAfterHeader(retryAfterHeader, now);
    else if (statusCode === 429) updatedRateLimits.all = now + 60000;
    return updatedRateLimits;
}
module.exports.DEFAULT_RETRY_AFTER = $da9da2000bc0b3a9$var$DEFAULT_RETRY_AFTER;
module.exports.disabledUntil = $da9da2000bc0b3a9$var$disabledUntil;
module.exports.isRateLimited = $da9da2000bc0b3a9$var$isRateLimited;
module.exports.parseRetryAfterHeader = $da9da2000bc0b3a9$var$parseRetryAfterHeader;
module.exports.updateRateLimits = $da9da2000bc0b3a9$var$updateRateLimits;

});


parcelRegister("6lXp4", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $636GJ = parcelRequire("636GJ");

var $ihsl1 = parcelRequire("ihsl1");
function $4a02c8860b43173a$var$createClientReportEnvelope(discarded_events, dsn, timestamp) {
    const clientReportItem = [
        {
            type: "client_report"
        },
        {
            timestamp: timestamp || $ihsl1.dateTimestampInSeconds(),
            discarded_events: discarded_events
        }
    ];
    return $636GJ.createEnvelope(dsn ? {
        dsn: dsn
    } : {}, [
        clientReportItem
    ]);
}
module.exports.createClientReportEnvelope = $4a02c8860b43173a$var$createClientReportEnvelope;

});

parcelRegister("8008j", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $5d2e6d3e179f6cef$var$getPossibleEventMessages(event) {
    const possibleMessages = [];
    if (event.message) possibleMessages.push(event.message);
    try {
        const lastException = event.exception.values[event.exception.values.length - 1];
        if (lastException?.value) {
            possibleMessages.push(lastException.value);
            if (lastException.type) possibleMessages.push(`${lastException.type}: ${lastException.value}`);
        }
    } catch  {}
    return possibleMessages;
}
module.exports.getPossibleEventMessages = $5d2e6d3e179f6cef$var$getPossibleEventMessages;

});

parcelRegister("lM2xr", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $gTasE = parcelRequire("gTasE");
function $fda00cbf0015e60e$var$convertTransactionEventToSpanJson(event) {
    const { trace_id: trace_id, parent_span_id: parent_span_id, span_id: span_id, status: status, origin: origin, data: data, op: op } = event.contexts?.trace ?? {};
    return {
        data: data ?? {},
        description: event.transaction,
        op: op,
        parent_span_id: parent_span_id,
        span_id: span_id ?? "",
        start_timestamp: event.start_timestamp ?? 0,
        status: status,
        timestamp: event.timestamp,
        trace_id: trace_id ?? "",
        origin: origin,
        profile_id: data?.[$gTasE.SEMANTIC_ATTRIBUTE_PROFILE_ID],
        exclusive_time: data?.[$gTasE.SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME],
        measurements: event.measurements,
        is_segment: true
    };
}
function $fda00cbf0015e60e$var$convertSpanJsonToTransactionEvent(span) {
    return {
        type: "transaction",
        timestamp: span.timestamp,
        start_timestamp: span.start_timestamp,
        transaction: span.description,
        contexts: {
            trace: {
                trace_id: span.trace_id,
                span_id: span.span_id,
                parent_span_id: span.parent_span_id,
                op: span.op,
                status: span.status,
                origin: span.origin,
                data: {
                    ...span.data,
                    ...span.profile_id && {
                        [$gTasE.SEMANTIC_ATTRIBUTE_PROFILE_ID]: span.profile_id
                    },
                    ...span.exclusive_time && {
                        [$gTasE.SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME]: span.exclusive_time
                    }
                }
            }
        },
        measurements: span.measurements
    };
}
module.exports.convertSpanJsonToTransactionEvent = $fda00cbf0015e60e$var$convertSpanJsonToTransactionEvent;
module.exports.convertTransactionEventToSpanJson = $fda00cbf0015e60e$var$convertTransactionEventToSpanJson;

});

parcelRegister("2uqEP", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $6eIcS = parcelRequire("6eIcS");
const $1d030fc3840db492$var$DEFAULTS = {
    userInfo: true,
    cookies: true,
    httpHeaders: {
        request: true,
        response: true
    },
    httpBodies: [
        "incomingRequest",
        "outgoingRequest",
        "incomingResponse",
        "outgoingResponse"
    ],
    urlQueryParams: true,
    graphQL: {
        document: true,
        variables: true
    },
    genAI: {
        inputs: true,
        outputs: true
    },
    databaseQueryData: true,
    stackFrameVariables: true,
    frameContextLines: 5
};
function $1d030fc3840db492$var$resolveDataCollectionOptions(options) {
    const base = options.dataCollection != null ? $1d030fc3840db492$var$DEFAULTS : $6eIcS.defaultPiiToCollectionOptions(options.sendDefaultPii);
    const dc = options.dataCollection ?? {};
    return {
        userInfo: dc.userInfo ?? base.userInfo,
        cookies: dc.cookies ?? base.cookies,
        httpHeaders: {
            request: dc.httpHeaders?.request ?? base.httpHeaders.request,
            response: dc.httpHeaders?.response ?? base.httpHeaders.response
        },
        httpBodies: dc.httpBodies ?? base.httpBodies,
        // oxlint-disable-next-line typescript/no-deprecated
        urlQueryParams: dc.urlQueryParams ?? dc.queryParams ?? base.urlQueryParams,
        graphQL: {
            document: dc.graphQL?.document ?? base.graphQL.document,
            variables: dc.graphQL?.variables ?? base.graphQL.variables
        },
        genAI: {
            inputs: dc.genAI?.inputs ?? base.genAI.inputs,
            outputs: dc.genAI?.outputs ?? base.genAI.outputs
        },
        databaseQueryData: dc.databaseQueryData ?? base.databaseQueryData,
        stackFrameVariables: dc.stackFrameVariables ?? base.stackFrameVariables,
        frameContextLines: dc.frameContextLines ?? base.frameContextLines
    };
}
module.exports.resolveDataCollectionOptions = $1d030fc3840db492$var$resolveDataCollectionOptions;

});
parcelRegister("6eIcS", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $lb92t = parcelRequire("lb92t");
function $48a6576f65d4c256$var$defaultPiiToCollectionOptions(sendDefaultPii) {
    return sendDefaultPii === true ? {
        userInfo: true,
        cookies: true,
        httpHeaders: {
            request: true,
            response: true
        },
        httpBodies: [
            "incomingRequest",
            "outgoingRequest",
            "incomingResponse",
            "outgoingResponse"
        ],
        urlQueryParams: true,
        graphQL: {
            document: true,
            variables: true
        },
        genAI: {
            inputs: true,
            outputs: true
        },
        databaseQueryData: true,
        stackFrameVariables: true,
        frameContextLines: 7
    } : {
        userInfo: false,
        cookies: {
            deny: $lb92t.PII_HEADER_SNIPPETS
        },
        httpHeaders: {
            request: {
                deny: $lb92t.PII_HEADER_SNIPPETS
            },
            response: {
                deny: $lb92t.PII_HEADER_SNIPPETS
            }
        },
        httpBodies: [],
        urlQueryParams: {
            deny: $lb92t.PII_HEADER_SNIPPETS
        },
        // The GraphQL document has literal values redacted at collection time, so it was historically
        // always attached regardless of `sendDefaultPii`; keep it on to preserve that behavior.
        graphQL: {
            document: true,
            variables: true
        },
        genAI: {
            inputs: false,
            outputs: false
        },
        // Database query values were only sent with `sendDefaultPii: true` (e.g. Supabase gated on it),
        // so map the legacy "off" state to `false`.
        databaseQueryData: false,
        stackFrameVariables: true,
        frameContextLines: 7
    };
}
module.exports.defaultPiiToCollectionOptions = $48a6576f65d4c256$var$defaultPiiToCollectionOptions;

});
parcelRegister("lb92t", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $f6b1a2fdd9ad0d12$var$FILTERED_VALUE = "[Filtered]";
const $f6b1a2fdd9ad0d12$var$PII_HEADER_SNIPPETS = [
    "forwarded",
    "-ip",
    "remote-",
    "via",
    "-user"
];
const $f6b1a2fdd9ad0d12$var$SENSITIVE_KEY_SNIPPETS = [
    "auth",
    "token",
    "secret",
    "session",
    // for the user_session cookie
    "password",
    "passwd",
    "pwd",
    "key",
    "jwt",
    "bearer",
    "sso",
    "saml",
    "csrf",
    "xsrf",
    "credentials",
    "sid",
    "identity",
    // Always treat cookie headers as sensitive in case individual key-value cookie pairs cannot properly be extracted
    "set-cookie",
    "cookie"
];
const $f6b1a2fdd9ad0d12$var$SENSITIVE_COOKIE_NAME_SNIPPETS = [
    // Express / Connect default session cookie
    ".sid",
    // Opaque session ids (PHPSESSID, ASPSESSIONID*, BIGipServer*, *sessid*, …)
    "sessid",
    // Laravel etc. "remember me" tokens
    "remember",
    // OIDC / OAuth auxiliary (`oauth*` covered by header snippet `auth`)
    "oidc",
    "pkce",
    "nonce",
    // RFC 6265bis high-security cookie name prefixes
    "__secure-",
    "__host-",
    // Load balancer / CDN sticky-session cookies (opaque routing tokens)
    "awsalb",
    "awselb",
    "akamai",
    // BaaS / IdP session cookies (names often omit "session")
    "__stripe",
    "cognito",
    "firebase",
    "supabase",
    "sb-",
    // Step-up / MFA cookies
    "mfa",
    "2fa"
];
module.exports.FILTERED_VALUE = $f6b1a2fdd9ad0d12$var$FILTERED_VALUE;
module.exports.PII_HEADER_SNIPPETS = $f6b1a2fdd9ad0d12$var$PII_HEADER_SNIPPETS;
module.exports.SENSITIVE_COOKIE_NAME_SNIPPETS = $f6b1a2fdd9ad0d12$var$SENSITIVE_COOKIE_NAME_SNIPPETS;
module.exports.SENSITIVE_KEY_SNIPPETS = $f6b1a2fdd9ad0d12$var$SENSITIVE_KEY_SNIPPETS;

});




parcelRegister("39KQC", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $79m2C = parcelRequire("79m2C");

var $hiZR1 = parcelRequire("hiZR1");

var $4gyod = parcelRequire("4gyod");
function $24c68d513418c934$var$initAndBind(clientClass, options) {
    if (options.debug === true) {
        if ($hiZR1.DEBUG_BUILD) $4gyod.debug.enable();
        else $4gyod.consoleSandbox(()=>{
            console.warn("[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle.");
        });
    }
    const scope = $79m2C.getCurrentScope();
    scope.update(options.initialScope);
    const client = new clientClass(options);
    $24c68d513418c934$var$setCurrentClient(client);
    client.init();
    return client;
}
function $24c68d513418c934$var$setCurrentClient(client) {
    $79m2C.getCurrentScope().setClient(client);
}
module.exports.initAndBind = $24c68d513418c934$var$initAndBind;
module.exports.setCurrentClient = $24c68d513418c934$var$setCurrentClient;

});

parcelRegister("j3q4C", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $hiZR1 = parcelRequire("hiZR1");

var $4gyod = parcelRequire("4gyod");

var $636GJ = parcelRequire("636GJ");

var $lLUp4 = parcelRequire("lLUp4");

var $iLGyZ = parcelRequire("iLGyZ");

var $Asczg = parcelRequire("Asczg");
const $ddf285c8bfe16d30$var$MIN_DELAY = 100;
const $ddf285c8bfe16d30$var$START_DELAY = 5e3;
const $ddf285c8bfe16d30$var$MAX_DELAY = 36e5;
function $ddf285c8bfe16d30$var$makeOfflineTransport(createTransport) {
    function log(...args) {
        $hiZR1.DEBUG_BUILD && $4gyod.debug.log("[Offline]:", ...args);
    }
    return (options)=>{
        const transport = createTransport(options);
        if (!options.createStore) throw new Error("No `createStore` function was provided");
        const store = options.createStore(options);
        let retryDelay = $ddf285c8bfe16d30$var$START_DELAY;
        let flushTimer;
        function shouldQueue(env, error, retryDelay2) {
            if ($636GJ.envelopeContainsItemType(env, [
                "client_report"
            ])) return false;
            if (options.shouldStore) return options.shouldStore(env, error, retryDelay2);
            return true;
        }
        function flushIn(delay) {
            if (flushTimer) clearTimeout(flushTimer);
            flushTimer = $Asczg.safeUnref(setTimeout(async ()=>{
                flushTimer = void 0;
                const found = await store.shift();
                if (found) {
                    log("Attempting to send previously queued event");
                    found[0].sent_at = new Date($lLUp4.safeDateNow()).toISOString();
                    send(found, true).catch((e)=>{
                        log("Failed to retry sending", e);
                    });
                }
            }, delay));
        }
        function flushWithBackOff() {
            if (flushTimer) return;
            flushIn(retryDelay);
            retryDelay = Math.min(retryDelay * 2, $ddf285c8bfe16d30$var$MAX_DELAY);
        }
        async function send(envelope$1, isRetry = false) {
            if (!isRetry && $636GJ.envelopeContainsItemType(envelope$1, [
                "replay_event",
                "replay_recording"
            ])) {
                await store.push(envelope$1);
                flushIn($ddf285c8bfe16d30$var$MIN_DELAY);
                return {};
            }
            try {
                if (options.shouldSend && await options.shouldSend(envelope$1) === false) throw new Error("Envelope not sent because `shouldSend` callback returned false");
                const result = await transport.send(envelope$1);
                let delay = $ddf285c8bfe16d30$var$MIN_DELAY;
                if (result) {
                    if (result.headers?.["retry-after"]) delay = $iLGyZ.parseRetryAfterHeader(result.headers["retry-after"]);
                    else if (result.headers?.["x-sentry-rate-limits"]) delay = 6e4;
                    else if ((result.statusCode || 0) >= 400) return result;
                }
                flushIn(delay);
                retryDelay = $ddf285c8bfe16d30$var$START_DELAY;
                return result;
            } catch (e) {
                if (await shouldQueue(envelope$1, e, retryDelay)) {
                    if (isRetry) await store.unshift(envelope$1);
                    else await store.push(envelope$1);
                    flushWithBackOff();
                    log("Error sending. Event queued.", e);
                    return {};
                } else throw e;
            }
        }
        if (options.flushAtStartup) flushWithBackOff();
        return {
            send: send,
            flush: (timeout)=>{
                if (timeout === void 0) {
                    retryDelay = $ddf285c8bfe16d30$var$START_DELAY;
                    flushIn($ddf285c8bfe16d30$var$MIN_DELAY);
                }
                return transport.flush(timeout);
            }
        };
    };
}
module.exports.MIN_DELAY = $ddf285c8bfe16d30$var$MIN_DELAY;
module.exports.START_DELAY = $ddf285c8bfe16d30$var$START_DELAY;
module.exports.makeOfflineTransport = $ddf285c8bfe16d30$var$makeOfflineTransport;

});

parcelRegister("bjiMJ", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $aY6AE = parcelRequire("aY6AE");

var $7E8b3 = parcelRequire("7E8b3");

var $636GJ = parcelRequire("636GJ");
const $83c00a5c49bf69a3$var$MULTIPLEXED_TRANSPORT_EXTRA_KEY = "MULTIPLEXED_TRANSPORT_EXTRA_KEY";
function $83c00a5c49bf69a3$var$eventFromEnvelope(env, types) {
    let event;
    $636GJ.forEachEnvelopeItem(env, (item, type)=>{
        if (types.includes(type)) event = Array.isArray(item) ? item[1] : void 0;
        return !!event;
    });
    return event;
}
function $83c00a5c49bf69a3$var$makeOverrideReleaseTransport(createTransport, release) {
    return (options)=>{
        const transport = createTransport(options);
        return {
            ...transport,
            send: async (envelope)=>{
                const event = $83c00a5c49bf69a3$var$eventFromEnvelope(envelope, [
                    "event",
                    "transaction",
                    "profile",
                    "replay_event"
                ]);
                if (event) event.release = release;
                return transport.send(envelope);
            }
        };
    };
}
function $83c00a5c49bf69a3$var$overrideDsn(envelope$1, dsn) {
    return $636GJ.createEnvelope(dsn ? {
        ...envelope$1[0],
        dsn: dsn
    } : envelope$1[0], envelope$1[1]);
}
function $83c00a5c49bf69a3$var$makeMultiplexedTransport(createTransport, matcher) {
    return (options)=>{
        const fallbackTransport = createTransport(options);
        const otherTransports = /* @__PURE__ */ new Map();
        const actualMatcher = matcher || ((args)=>{
            const event = args.getEvent();
            if (event?.extra?.[$83c00a5c49bf69a3$var$MULTIPLEXED_TRANSPORT_EXTRA_KEY] && Array.isArray(event.extra[$83c00a5c49bf69a3$var$MULTIPLEXED_TRANSPORT_EXTRA_KEY])) return event.extra[$83c00a5c49bf69a3$var$MULTIPLEXED_TRANSPORT_EXTRA_KEY];
            return [];
        });
        function getTransport(dsn$1, release) {
            const key = release ? `${dsn$1}:${release}` : dsn$1;
            let transport = otherTransports.get(key);
            if (!transport) {
                const validatedDsn = $7E8b3.dsnFromString(dsn$1);
                if (!validatedDsn) return void 0;
                const url = $aY6AE.getEnvelopeEndpointWithUrlEncodedAuth(validatedDsn, options.tunnel);
                transport = release ? $83c00a5c49bf69a3$var$makeOverrideReleaseTransport(createTransport, release)({
                    ...options,
                    url: url
                }) : createTransport({
                    ...options,
                    url: url
                });
                otherTransports.set(key, transport);
            }
            return [
                dsn$1,
                transport
            ];
        }
        async function send(envelope) {
            function getEvent(types) {
                const eventTypes = types?.length ? types : [
                    "event"
                ];
                return $83c00a5c49bf69a3$var$eventFromEnvelope(envelope, eventTypes);
            }
            const transports = actualMatcher({
                envelope: envelope,
                getEvent: getEvent
            }).map((result)=>{
                if (typeof result === "string") return getTransport(result, void 0);
                else return getTransport(result.dsn, result.release);
            }).filter((t)=>!!t);
            const transportsWithFallback = transports.length ? transports : [
                [
                    "",
                    fallbackTransport
                ]
            ];
            const results = await Promise.all(transportsWithFallback.map(([dsn, transport])=>transport.send($83c00a5c49bf69a3$var$overrideDsn(envelope, dsn))));
            return results[0];
        }
        async function flush(timeout) {
            const allTransports = [
                ...otherTransports.values(),
                fallbackTransport
            ];
            const results = await Promise.all(allTransports.map((transport)=>transport.flush(timeout)));
            return results.every((r)=>r);
        }
        return {
            send: send,
            flush: flush
        };
    };
}
module.exports.MULTIPLEXED_TRANSPORT_EXTRA_KEY = $83c00a5c49bf69a3$var$MULTIPLEXED_TRANSPORT_EXTRA_KEY;
module.exports.eventFromEnvelope = $83c00a5c49bf69a3$var$eventFromEnvelope;
module.exports.makeMultiplexedTransport = $83c00a5c49bf69a3$var$makeMultiplexedTransport;

});

parcelRegister("kpR1z", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $hiZR1 = parcelRequire("hiZR1");

var $4gyod = parcelRequire("4gyod");
const $edcf4600002e7f37$var$SKIPPED_AI_PROVIDERS = /* @__PURE__ */ new Set();
function $edcf4600002e7f37$var$_INTERNAL_skipAiProviderWrapping(modules) {
    modules.forEach((module)=>{
        $edcf4600002e7f37$var$SKIPPED_AI_PROVIDERS.add(module);
        $hiZR1.DEBUG_BUILD && $4gyod.debug.log(`AI provider "${module}" wrapping will be skipped`);
    });
}
function $edcf4600002e7f37$var$_INTERNAL_shouldSkipAiProviderWrapping(module) {
    return $edcf4600002e7f37$var$SKIPPED_AI_PROVIDERS.has(module);
}
function $edcf4600002e7f37$var$_INTERNAL_clearAiProviderSkips() {
    $edcf4600002e7f37$var$SKIPPED_AI_PROVIDERS.clear();
    $hiZR1.DEBUG_BUILD && $4gyod.debug.log("Cleared AI provider skip registrations");
}
module.exports._INTERNAL_clearAiProviderSkips = $edcf4600002e7f37$var$_INTERNAL_clearAiProviderSkips;
module.exports._INTERNAL_shouldSkipAiProviderWrapping = $edcf4600002e7f37$var$_INTERNAL_shouldSkipAiProviderWrapping;
module.exports._INTERNAL_skipAiProviderWrapping = $edcf4600002e7f37$var$_INTERNAL_skipAiProviderWrapping;

});

parcelRegister("ghLoo", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $lb92t = parcelRequire("lb92t");
function $bdb2ff07d71413b0$var$isSensitiveKey(lower, denySnippets) {
    return denySnippets.some((snippet)=>lower.includes(snippet));
}
function $bdb2ff07d71413b0$var$filterKeyValueData(data, behavior, additionalDenyTerms) {
    if (behavior === false) return {};
    const denySnippets = additionalDenyTerms != null ? [
        ...$lb92t.SENSITIVE_KEY_SNIPPETS,
        ...additionalDenyTerms
    ] : $lb92t.SENSITIVE_KEY_SNIPPETS;
    const result = {};
    if (behavior === true) {
        for (const key of Object.keys(data))result[key] = $bdb2ff07d71413b0$var$isSensitiveKey(key.toLowerCase(), denySnippets) ? $lb92t.FILTERED_VALUE : data[key];
        return result;
    }
    if ("deny" in behavior) {
        const lowerTerms2 = behavior.deny.map((t)=>t.toLowerCase());
        for (const key of Object.keys(data)){
            const lower = key.toLowerCase();
            const isDenied = $bdb2ff07d71413b0$var$isSensitiveKey(lower, denySnippets) || lowerTerms2.some((term)=>lower.includes(term));
            result[key] = isDenied ? $lb92t.FILTERED_VALUE : data[key];
        }
        return result;
    }
    const lowerTerms = behavior.allow.map((t)=>t.toLowerCase());
    for (const key of Object.keys(data)){
        const lower = key.toLowerCase();
        if ($bdb2ff07d71413b0$var$isSensitiveKey(lower, denySnippets)) result[key] = $lb92t.FILTERED_VALUE;
        else {
            const isAllowed = lowerTerms.some((term)=>lower.includes(term));
            result[key] = isAllowed ? data[key] : $lb92t.FILTERED_VALUE;
        }
    }
    return result;
}
module.exports.filterKeyValueData = $bdb2ff07d71413b0$var$filterKeyValueData;

});

parcelRegister("lpr4K", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $fJi1f = parcelRequire("fJi1f");

var $lb92t = parcelRequire("lb92t");

var $ghLoo = parcelRequire("ghLoo");
function $f960ef66c031899c$var$filterCookies(cookieString, behavior) {
    if (behavior === false) return {};
    try {
        const parsed = $fJi1f.parseCookie(cookieString);
        if (Object.keys(parsed).length === 0) return {};
        return $ghLoo.filterKeyValueData(parsed, behavior, $lb92t.SENSITIVE_COOKIE_NAME_SNIPPETS);
    } catch  {
        return $lb92t.FILTERED_VALUE;
    }
}
module.exports.filterCookies = $f960ef66c031899c$var$filterCookies;

});
parcelRegister("fJi1f", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $b7390931e70405aa$var$parseCookie(str) {
    const obj = {};
    let index = 0;
    while(index < str.length){
        const eqIdx = str.indexOf("=", index);
        if (eqIdx === -1) break;
        let endIdx = str.indexOf(";", index);
        if (endIdx === -1) endIdx = str.length;
        else if (endIdx < eqIdx) {
            index = str.lastIndexOf(";", eqIdx - 1) + 1;
            continue;
        }
        const key = str.slice(index, eqIdx).trim();
        if (void 0 === obj[key]) {
            let val = str.slice(eqIdx + 1, endIdx).trim();
            if (val.charCodeAt(0) === 34) val = val.slice(1, -1);
            try {
                obj[key] = val.indexOf("%") !== -1 ? decodeURIComponent(val) : val;
            } catch  {
                obj[key] = val;
            }
        }
        index = endIdx + 1;
    }
    return obj;
}
module.exports.parseCookie = $b7390931e70405aa$var$parseCookie;

});


parcelRegister("9DnJa", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $lb92t = parcelRequire("lb92t");

var $ghLoo = parcelRequire("ghLoo");
function $703a2960914f4871$var$filterQueryParams(queryString, behavior) {
    if (behavior === false) return {};
    try {
        const params = new URLSearchParams(queryString);
        const parsed = {};
        params.forEach((value, key)=>{
            parsed[key] = value;
        });
        if (Object.keys(parsed).length === 0) return {};
        return $ghLoo.filterKeyValueData(parsed, behavior);
    } catch  {
        return $lb92t.FILTERED_VALUE;
    }
}
module.exports.filterQueryParams = $703a2960914f4871$var$filterQueryParams;

});

parcelRegister("6HYaL", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $4e256f3cb1e9e0bb$var$FALSY_ENV_VALUES = /* @__PURE__ */ new Set([
    "false",
    "f",
    "n",
    "no",
    "off",
    "0"
]);
const $4e256f3cb1e9e0bb$var$TRUTHY_ENV_VALUES = /* @__PURE__ */ new Set([
    "true",
    "t",
    "y",
    "yes",
    "on",
    "1"
]);
function $4e256f3cb1e9e0bb$var$envToBool(value, options) {
    const normalized = String(value).toLowerCase();
    if ($4e256f3cb1e9e0bb$var$FALSY_ENV_VALUES.has(normalized)) return false;
    if ($4e256f3cb1e9e0bb$var$TRUTHY_ENV_VALUES.has(normalized)) return true;
    return options?.strict ? null : Boolean(value);
}
module.exports.FALSY_ENV_VALUES = $4e256f3cb1e9e0bb$var$FALSY_ENV_VALUES;
module.exports.TRUTHY_ENV_VALUES = $4e256f3cb1e9e0bb$var$TRUTHY_ENV_VALUES;
module.exports.envToBool = $4e256f3cb1e9e0bb$var$envToBool;

});

parcelRegister("9SwL9", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $7E8b3 = parcelRequire("7E8b3");

var $636GJ = parcelRequire("636GJ");

var $lLUp4 = parcelRequire("lLUp4");
function $7312918c4676eb27$var$createCheckInEnvelope(checkIn, dynamicSamplingContext, metadata, tunnel, dsn$1) {
    const headers = {
        sent_at: new Date($lLUp4.safeDateNow()).toISOString()
    };
    if (metadata?.sdk) headers.sdk = {
        name: metadata.sdk.name,
        version: metadata.sdk.version
    };
    if (!!tunnel && !!dsn$1) headers.dsn = $7E8b3.dsnToString(dsn$1);
    if (dynamicSamplingContext) headers.trace = dynamicSamplingContext;
    const item = $7312918c4676eb27$var$createCheckInEnvelopeItem(checkIn);
    return $636GJ.createEnvelope(headers, [
        item
    ]);
}
function $7312918c4676eb27$var$createCheckInEnvelopeItem(checkIn) {
    const checkInHeaders = {
        type: "check_in"
    };
    return [
        checkInHeaders,
        checkIn
    ];
}
module.exports.createCheckInEnvelope = $7312918c4676eb27$var$createCheckInEnvelope;

});

parcelRegister("3Vae5", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $hLsvb = parcelRequire("hLsvb");
function $2daea0ae70f4fe62$var$isSentryRequestUrl(url, client) {
    const dsn = client?.getDsn();
    const tunnel = client?.getOptions().tunnel;
    return $2daea0ae70f4fe62$var$checkDsn(url, dsn) || $2daea0ae70f4fe62$var$checkTunnel(url, tunnel);
}
function $2daea0ae70f4fe62$var$checkTunnel(url, tunnel) {
    if (!tunnel) return false;
    return $2daea0ae70f4fe62$var$removeTrailingSlash(url) === $2daea0ae70f4fe62$var$removeTrailingSlash(tunnel);
}
function $2daea0ae70f4fe62$var$checkDsn(url$1, dsn) {
    const urlParts = $hLsvb.parseStringToURLObject(url$1);
    if (!urlParts || $hLsvb.isURLObjectRelative(urlParts)) return false;
    if (!dsn) return false;
    return $2daea0ae70f4fe62$var$hostnameMatchesDsnHost(urlParts.hostname, dsn.host) && /(^|&|\?)sentry_key=/.test(urlParts.search);
}
function $2daea0ae70f4fe62$var$hostnameMatchesDsnHost(hostname, dsnHost) {
    return hostname === dsnHost || dsnHost.length > 0 && hostname.endsWith(`.${dsnHost}`);
}
function $2daea0ae70f4fe62$var$removeTrailingSlash(str) {
    return str[str.length - 1] === "/" ? str.slice(0, -1) : str;
}
module.exports.isSentryRequestUrl = $2daea0ae70f4fe62$var$isSentryRequestUrl;

});
parcelRegister("hLsvb", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $gTasE = parcelRequire("gTasE");
const $ceecef5c6adf2f88$var$DEFAULT_BASE_URL = "thismessage:/";
function $ceecef5c6adf2f88$var$isURLObjectRelative(url) {
    return "isRelative" in url;
}
function $ceecef5c6adf2f88$var$parseStringToURLObject(url, urlBase) {
    const isRelative = url.indexOf("://") <= 0 && url.indexOf("//") !== 0;
    const base = urlBase ?? (isRelative ? $ceecef5c6adf2f88$var$DEFAULT_BASE_URL : void 0);
    try {
        if ("canParse" in URL && !URL.canParse(url, base)) return void 0;
        const fullUrlObject = new URL(url, base);
        if (isRelative) return {
            isRelative: isRelative,
            pathname: fullUrlObject.pathname,
            search: fullUrlObject.search,
            hash: fullUrlObject.hash
        };
        return fullUrlObject;
    } catch  {}
    return void 0;
}
function $ceecef5c6adf2f88$var$getSanitizedUrlStringFromUrlObject(url) {
    if ($ceecef5c6adf2f88$var$isURLObjectRelative(url)) return url.pathname;
    const newUrl = new URL(url);
    newUrl.search = "";
    newUrl.hash = "";
    if ([
        "80",
        "443"
    ].includes(newUrl.port)) newUrl.port = "";
    if (newUrl.password) newUrl.password = "%filtered%";
    if (newUrl.username) newUrl.username = "%filtered%";
    return newUrl.toString();
}
function $ceecef5c6adf2f88$var$getHttpSpanNameFromUrlObject(urlObject, kind, request, routeName) {
    const method = request?.method?.toUpperCase() ?? "GET";
    const route = routeName ? routeName : urlObject ? kind === "client" ? $ceecef5c6adf2f88$var$getSanitizedUrlStringFromUrlObject(urlObject) : urlObject.pathname : "/";
    return `${method} ${route}`;
}
function $ceecef5c6adf2f88$var$getHttpSpanDetailsFromUrlObject(urlObject, kind, spanOrigin, request, routeName) {
    const attributes = {
        [$gTasE.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: spanOrigin,
        [$gTasE.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE]: "url"
    };
    if (routeName) {
        attributes[kind === "server" ? "http.route" : "url.template"] = routeName;
        attributes[$gTasE.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE] = "route";
    }
    if (request?.method) attributes[$gTasE.SEMANTIC_ATTRIBUTE_HTTP_REQUEST_METHOD] = request.method.toUpperCase();
    if (urlObject) {
        if (urlObject.search) attributes["url.query"] = urlObject.search;
        if (urlObject.hash) attributes["url.fragment"] = urlObject.hash;
        if (urlObject.pathname) {
            attributes["url.path"] = urlObject.pathname;
            if (urlObject.pathname === "/") attributes[$gTasE.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE] = "route";
        }
        if (!$ceecef5c6adf2f88$var$isURLObjectRelative(urlObject)) {
            attributes[$gTasE.SEMANTIC_ATTRIBUTE_URL_FULL] = urlObject.href;
            if (urlObject.port) attributes["url.port"] = urlObject.port;
            if (urlObject.protocol) attributes["url.scheme"] = urlObject.protocol;
            if (urlObject.hostname) attributes[kind === "server" ? "server.address" : "url.domain"] = urlObject.hostname;
        }
    }
    return [
        $ceecef5c6adf2f88$var$getHttpSpanNameFromUrlObject(urlObject, kind, request, routeName),
        attributes
    ];
}
function $ceecef5c6adf2f88$var$parseUrl(url) {
    if (!url) return {};
    const match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) return {};
    const query = match[6] || "";
    const fragment = match[8] || "";
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        search: query,
        hash: fragment,
        relative: match[5] + query + fragment
    };
}
function $ceecef5c6adf2f88$var$stripUrlQueryAndFragment(urlPath) {
    return urlPath.split(/[?#]/, 1)[0];
}
function $ceecef5c6adf2f88$var$getSanitizedUrlString(url) {
    const { protocol: protocol, host: host, path: path } = url;
    const filteredHost = host?.replace(/^.*@/, "[filtered]:[filtered]@").replace(/(:80)$/, "").replace(/(:443)$/, "") || "";
    return `${protocol ? `${protocol}://` : ""}${filteredHost}${path}`;
}
function $ceecef5c6adf2f88$var$stripDataUrlContent(url, includeDataPrefix = true) {
    if (url.startsWith("data:")) {
        const match = url.match(/^data:([^;,]+)/);
        const mimeType = match ? match[1] : "text/plain";
        const isBase64 = url.includes(";base64,");
        const dataStart = url.indexOf(",");
        let dataPrefix = "";
        if (includeDataPrefix && dataStart !== -1) {
            const data = url.slice(dataStart + 1);
            dataPrefix = data.length > 10 ? `${data.slice(0, 10)}... [truncated]` : data;
        }
        return `data:${mimeType}${isBase64 ? ",base64" : ""}${dataPrefix ? `,${dataPrefix}` : ""}`;
    }
    return url;
}
module.exports.getHttpSpanDetailsFromUrlObject = $ceecef5c6adf2f88$var$getHttpSpanDetailsFromUrlObject;
module.exports.getSanitizedUrlString = $ceecef5c6adf2f88$var$getSanitizedUrlString;
module.exports.getSanitizedUrlStringFromUrlObject = $ceecef5c6adf2f88$var$getSanitizedUrlStringFromUrlObject;
module.exports.isURLObjectRelative = $ceecef5c6adf2f88$var$isURLObjectRelative;
module.exports.parseStringToURLObject = $ceecef5c6adf2f88$var$parseStringToURLObject;
module.exports.parseUrl = $ceecef5c6adf2f88$var$parseUrl;
module.exports.stripDataUrlContent = $ceecef5c6adf2f88$var$stripDataUrlContent;
module.exports.stripUrlQueryAndFragment = $ceecef5c6adf2f88$var$stripUrlQueryAndFragment;

});


parcelRegister("8UX2H", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $67e15a49324150b9$var$parameterize(strings, ...values) {
    const formatted = new String(String.raw(strings, ...values));
    formatted.__sentry_template_string__ = strings.join("\0").replace(/%/g, "%%").replace(/\0/g, "%s");
    formatted.__sentry_template_values__ = values;
    return formatted;
}
const $67e15a49324150b9$var$fmt = $67e15a49324150b9$var$parameterize;
module.exports.fmt = $67e15a49324150b9$var$fmt;
module.exports.parameterize = $67e15a49324150b9$var$parameterize;

});

parcelRegister("jizDx", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $aY6AE = parcelRequire("aY6AE");

var $4gyod = parcelRequire("4gyod");

var $7E8b3 = parcelRequire("7E8b3");

var $636GJ = parcelRequire("636GJ");
async function $e0cb5777708fbace$var$handleTunnelRequest(options) {
    const { request: request, allowedDsns: allowedDsns } = options;
    if (allowedDsns.length === 0) return new Response("Tunnel not configured", {
        status: 500
    });
    const body = new Uint8Array(await request.arrayBuffer());
    let envelopeHeader;
    try {
        [envelopeHeader] = $636GJ.parseEnvelope(body);
    } catch  {
        return new Response("Invalid envelope", {
            status: 400
        });
    }
    if (!envelopeHeader) return new Response("Invalid envelope: missing header", {
        status: 400
    });
    const dsn$1 = envelopeHeader.dsn;
    if (!dsn$1) return new Response("Invalid envelope: missing DSN", {
        status: 400
    });
    const isAllowed = allowedDsns.some((allowed)=>allowed === dsn$1);
    if (!isAllowed) {
        $4gyod.debug.warn(`Sentry tunnel: rejected request with unauthorized DSN (${dsn$1})`);
        return new Response("DSN not allowed", {
            status: 403
        });
    }
    const dsnComponents = $7E8b3.makeDsn(dsn$1);
    if (!dsnComponents) {
        $4gyod.debug.warn(`Could not extract DSN Components from: ${dsn$1}`);
        return new Response("Invalid DSN", {
            status: 403
        });
    }
    const sentryIngestUrl = $aY6AE.getEnvelopeEndpointWithUrlEncodedAuth(dsnComponents);
    try {
        return await fetch(sentryIngestUrl, {
            method: "POST",
            headers: {
                "Content-Type": "application/x-sentry-envelope"
            },
            body: body
        });
    } catch (error) {
        $4gyod.debug.error("Sentry tunnel: failed to forward envelope", error);
        return new Response("Failed to forward envelope to Sentry", {
            status: 500
        });
    }
}
module.exports.handleTunnelRequest = $e0cb5777708fbace$var$handleTunnelRequest;

});

parcelRegister("9FRK6", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $70b1a18c91e7d6ca$var$addAutoIpAddressToUser(objWithMaybeUser) {
    if (objWithMaybeUser.user?.ip_address === void 0) objWithMaybeUser.user = {
        ...objWithMaybeUser.user,
        ip_address: "{{auto}}"
    };
}
function $70b1a18c91e7d6ca$var$addAutoIpAddressToSession(session) {
    if ("aggregates" in session) {
        if (session.attrs?.["ip_address"] === void 0) session.attrs = {
            ...session.attrs,
            ip_address: "{{auto}}"
        };
    } else if (session.ipAddress === void 0) session.ipAddress = "{{auto}}";
}
module.exports.addAutoIpAddressToSession = $70b1a18c91e7d6ca$var$addAutoIpAddressToSession;
module.exports.addAutoIpAddressToUser = $70b1a18c91e7d6ca$var$addAutoIpAddressToUser;

});

parcelRegister("kxe8l", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $5qT6j = parcelRequire("5qT6j");
function $ef31da55840507f0$var$applySdkMetadata(options, name, names = [
    name
], source = "npm") {
    const sdk = (options._metadata = options._metadata || {}).sdk = options._metadata.sdk || {};
    if (!sdk.name) {
        sdk.name = `sentry.javascript.${name}`;
        sdk.packages = names.map((name2)=>({
                name: `${source}:@sentry/${name2}`,
                version: $5qT6j.SDK_VERSION
            }));
        sdk.version = $5qT6j.SDK_VERSION;
    }
}
module.exports.applySdkMetadata = $ef31da55840507f0$var$applySdkMetadata;

});

parcelRegister("7DICZ", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $diBhM = parcelRequire("diBhM");

var $4fnou = parcelRequire("4fnou");

var $79m2C = parcelRequire("79m2C");

var $1tl8I = parcelRequire("1tl8I");

var $4gyod = parcelRequire("4gyod");

var $8jbnX = parcelRequire("8jbnX");

var $6emr7 = parcelRequire("6emr7");

var $boFM9 = parcelRequire("boFM9");

var $f0qnC = parcelRequire("f0qnC");

var $l5MWU = parcelRequire("l5MWU");

var $3ZCGz = parcelRequire("3ZCGz");
function $58fecb14d4af6ee0$var$getTraceData(options = {}) {
    const client = options.client || $79m2C.getClient();
    if (!$1tl8I.isEnabled() || !client) return {};
    const carrier$1 = $4fnou.getMainCarrier();
    const acs = $diBhM.getAsyncContextStrategy(carrier$1);
    if (acs.getTraceData) return acs.getTraceData(options);
    const scope = options.scope || $79m2C.getCurrentScope();
    const span = options.span || $8jbnX.getActiveSpan();
    const isTwpPlaceholder = $boFM9.spanIsNonRecordingSpan(span) && !$6emr7.hasSpansEnabled(client.getOptions());
    if (!span && $79m2C.hasExternalPropagationContext()) return {};
    const sentryTrace = span && !isTwpPlaceholder ? $8jbnX.spanToTraceHeader(span) : $58fecb14d4af6ee0$var$scopeToTraceHeader(scope);
    const dsc = span ? $f0qnC.getDynamicSamplingContextFromSpan(span) : $f0qnC.getDynamicSamplingContextFromScope(client, scope);
    const baggage$1 = $l5MWU.dynamicSamplingContextToSentryBaggageHeader(dsc);
    const isValidSentryTraceHeader = $3ZCGz.TRACEPARENT_REGEXP.test(sentryTrace);
    if (!isValidSentryTraceHeader) {
        $4gyod.debug.warn("Invalid sentry-trace data. Cannot generate trace data");
        return {};
    }
    const traceData = {
        "sentry-trace": sentryTrace,
        baggage: baggage$1
    };
    if (options.propagateTraceparent) traceData.traceparent = span && !isTwpPlaceholder ? $8jbnX.spanToTraceparentHeader(span) : $58fecb14d4af6ee0$var$scopeToTraceparentHeader(scope);
    return traceData;
}
function $58fecb14d4af6ee0$var$scopeToTraceHeader(scope) {
    const { traceId: traceId, sampled: sampled, propagationSpanId: propagationSpanId } = scope.getPropagationContext();
    return $3ZCGz.generateSentryTraceHeader(traceId, propagationSpanId, sampled);
}
function $58fecb14d4af6ee0$var$scopeToTraceparentHeader(scope) {
    const { traceId: traceId, sampled: sampled, propagationSpanId: propagationSpanId } = scope.getPropagationContext();
    return $3ZCGz.generateTraceparentHeader(traceId, propagationSpanId, sampled);
}
module.exports.getTraceData = $58fecb14d4af6ee0$var$getTraceData;

});

parcelRegister("fM5oA", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $hiZR1 = parcelRequire("hiZR1");

var $4gyod = parcelRequire("4gyod");

var $arYVC = parcelRequire("arYVC");
const $b7bf862b4fbaac72$var$NOT_PROPAGATED_MESSAGE = "[Tracing] Not injecting trace data for url because it does not match tracePropagationTargets:";
function $b7bf862b4fbaac72$var$shouldPropagateTraceForUrl(url, tracePropagationTargets, decisionMap) {
    if (typeof url !== "string" || !tracePropagationTargets) return true;
    const cachedDecision = decisionMap?.get(url);
    if (cachedDecision !== void 0) {
        $hiZR1.DEBUG_BUILD && !cachedDecision && $4gyod.debug.log($b7bf862b4fbaac72$var$NOT_PROPAGATED_MESSAGE, url);
        return cachedDecision;
    }
    const decision = $arYVC.stringMatchesSomePattern(url, tracePropagationTargets);
    decisionMap?.set(url, decision);
    $hiZR1.DEBUG_BUILD && !decision && $4gyod.debug.log($b7bf862b4fbaac72$var$NOT_PROPAGATED_MESSAGE, url);
    return decision;
}
module.exports.shouldPropagateTraceForUrl = $b7bf862b4fbaac72$var$shouldPropagateTraceForUrl;

});

parcelRegister("aCCmm", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $7DICZ = parcelRequire("7DICZ");
function $7bbb35677a8c4d98$var$getTraceMetaTags(traceData$1) {
    return Object.entries(traceData$1 || $7DICZ.getTraceData()).map(([key, value])=>`<meta name="${key}" content="${value}"/>`).join("");
}
module.exports.getTraceMetaTags = $7bbb35677a8c4d98$var$getTraceMetaTags;

});

parcelRegister("aNC5c", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $7dcc056d77712105$var$uniq(input) {
    return Array.from(new Set(input));
}
module.exports.uniq = $7dcc056d77712105$var$uniq;

});

parcelRegister("akxwg", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $hiZR1 = parcelRequire("hiZR1");

var $4gyod = parcelRequire("4gyod");

var $6eIcS = parcelRequire("6eIcS");

var $lb92t = parcelRequire("lb92t");

var $ghLoo = parcelRequire("ghLoo");

var $Asczg = parcelRequire("Asczg");
const $7855c5de28ae978d$var$MAX_BODY_BYTE_LENGTH = 1048576;
const $7855c5de28ae978d$var$TEXT_CONTENT_TYPES = [
    "text/",
    "application/json",
    "application/x-www-form-urlencoded",
    "application/xml",
    "application/graphql"
];
function $7855c5de28ae978d$var$getMaxBodyByteLength(maxRequestBodySize) {
    if (maxRequestBodySize === "small") return 1e3;
    if (maxRequestBodySize === "medium") return 1e4;
    return $7855c5de28ae978d$var$MAX_BODY_BYTE_LENGTH;
}
function $7855c5de28ae978d$var$winterCGHeadersToDict(winterCGHeaders) {
    const headers = {};
    try {
        winterCGHeaders.forEach((value, key)=>{
            if (typeof value === "string") headers[key] = value;
        });
    } catch  {}
    return headers;
}
function $7855c5de28ae978d$var$headersToDict(reqHeaders) {
    const headers = /* @__PURE__ */ Object.create(null);
    try {
        Object.entries(reqHeaders).forEach(([key, value])=>{
            if (typeof value === "string") headers[key] = value;
            else if (typeof value === "number") headers[key] = String(value);
        });
    } catch  {}
    return headers;
}
function $7855c5de28ae978d$var$winterCGRequestToRequestData(req) {
    const headers = $7855c5de28ae978d$var$winterCGHeadersToDict(req.headers);
    return {
        method: req.method,
        url: req.url,
        query_string: $7855c5de28ae978d$var$extractQueryParamsFromUrl(req.url),
        headers: headers
    };
}
function $7855c5de28ae978d$var$isTextualContentType(contentType) {
    if (!contentType) return false;
    const lowerContentType = contentType.toLowerCase();
    return $7855c5de28ae978d$var$TEXT_CONTENT_TYPES.some((type)=>lowerContentType.includes(type));
}
async function $7855c5de28ae978d$var$captureBodyFromWinterCGRequest(request, isolationScope, maxRequestBodySize) {
    try {
        const contentType = request.headers.get("content-type");
        if (!$7855c5de28ae978d$var$isTextualContentType(contentType)) {
            $hiZR1.DEBUG_BUILD && $4gyod.debug.log("Skipping body capture for non-textual content type:", contentType);
            return;
        }
        if (!request.body) return;
        const contentLength = request.headers.get("content-length");
        const maxBodySize = $7855c5de28ae978d$var$getMaxBodyByteLength(maxRequestBodySize);
        if (contentLength) {
            const length = parseInt(contentLength, 10);
            if (!isNaN(length) && length > $7855c5de28ae978d$var$MAX_BODY_BYTE_LENGTH) {
                $hiZR1.DEBUG_BUILD && $4gyod.debug.log("Skipping body capture: body too large", length);
                return;
            }
        }
        const clonedRequest = request.clone();
        const bodyPromise = clonedRequest.text();
        const timeoutPromise = new Promise((resolve)=>{
            $Asczg.safeUnref(setTimeout(()=>resolve(null), 2e3));
        });
        const body = await Promise.race([
            bodyPromise,
            timeoutPromise
        ]);
        if (body === null) {
            $hiZR1.DEBUG_BUILD && $4gyod.debug.log("Timeout reading request body");
            return;
        }
        if (!body) return;
        const encoder = new TextEncoder();
        const bytes = encoder.encode(body);
        const bodyByteLength = bytes.length;
        let truncatedBody;
        if (bodyByteLength > maxBodySize) {
            const decoder = new TextDecoder();
            truncatedBody = `${decoder.decode(bytes.slice(0, maxBodySize - 3))}...`;
        } else truncatedBody = body;
        isolationScope.setSDKProcessingMetadata({
            normalizedRequest: {
                data: truncatedBody
            }
        });
        $hiZR1.DEBUG_BUILD && $4gyod.debug.log("Captured request body:", bodyByteLength, "bytes");
    } catch (error) {
        $hiZR1.DEBUG_BUILD && $4gyod.debug.error("Error capturing request body:", error);
    }
}
function $7855c5de28ae978d$var$httpRequestToRequestData(request) {
    const headers = request.headers || {};
    const forwardedHost = typeof headers["x-forwarded-host"] === "string" ? headers["x-forwarded-host"] : void 0;
    const host = forwardedHost || (typeof headers.host === "string" ? headers.host : void 0);
    const forwardedProto = typeof headers["x-forwarded-proto"] === "string" ? headers["x-forwarded-proto"] : void 0;
    const protocol = forwardedProto || request.protocol || (request.socket?.encrypted ? "https" : "http");
    const url = request.url || "";
    const absoluteUrl = $7855c5de28ae978d$var$getAbsoluteUrl({
        url: url,
        host: host,
        protocol: protocol
    });
    const data = request.body || void 0;
    const cookies = request.cookies;
    return {
        url: absoluteUrl,
        method: request.method,
        query_string: $7855c5de28ae978d$var$extractQueryParamsFromUrl(url),
        headers: $7855c5de28ae978d$var$headersToDict(headers),
        cookies: cookies,
        data: data
    };
}
function $7855c5de28ae978d$var$getAbsoluteUrl({ url: url, protocol: protocol, host: host }) {
    if (url?.startsWith("http")) return url;
    if (url && host) return `${protocol}://${host}${url}`;
    return void 0;
}
function $7855c5de28ae978d$var$httpHeadersToSpanAttributes(headers, dataCollection = false, lifecycle = "request") {
    const resolvedDataCollection = typeof dataCollection === "boolean" ? $6eIcS.defaultPiiToCollectionOptions(dataCollection) : dataCollection;
    const headerBehavior = lifecycle === "request" ? resolvedDataCollection.httpHeaders.request : resolvedDataCollection.httpHeaders.response;
    const cookieBehavior = resolvedDataCollection.cookies;
    const prefix = `http.${lifecycle}.header.`;
    const spanAttributes = {};
    try {
        const regularHeaders = {};
        for (const [key, value] of Object.entries(headers)){
            if (value == null) continue;
            const lowerKey = key.toLowerCase();
            const isCookieHeader = lowerKey === "cookie" || lowerKey === "set-cookie";
            if (isCookieHeader) {
                if (cookieBehavior === false) continue;
                if (typeof value === "string" && value !== "") {
                    const parsed = $7855c5de28ae978d$var$parseCookieHeader(value, lowerKey === "set-cookie");
                    const filtered = $ghLoo.filterKeyValueData(parsed, cookieBehavior, $lb92t.SENSITIVE_COOKIE_NAME_SNIPPETS);
                    for (const [cookieKey, cookieValue] of Object.entries(filtered))spanAttributes[`${prefix}${$7855c5de28ae978d$var$normalizeAttributeKey(lowerKey)}.${$7855c5de28ae978d$var$normalizeAttributeKey(cookieKey)}`] = cookieValue;
                } else spanAttributes[`${prefix}${$7855c5de28ae978d$var$normalizeAttributeKey(lowerKey)}`] = $lb92t.FILTERED_VALUE;
            } else {
                if (headerBehavior === false) continue;
                if (Array.isArray(value)) regularHeaders[lowerKey] = value.map((v)=>v != null ? String(v) : v).join(";");
                else if (typeof value === "string") regularHeaders[lowerKey] = value;
            }
        }
        if (headerBehavior !== false) {
            const filtered = $ghLoo.filterKeyValueData(regularHeaders, headerBehavior);
            for (const [headerKey, headerValue] of Object.entries(filtered))spanAttributes[`${prefix}${$7855c5de28ae978d$var$normalizeAttributeKey(headerKey)}`] = headerValue;
        }
    } catch  {}
    return spanAttributes;
}
function $7855c5de28ae978d$var$normalizeAttributeKey(key) {
    return key.replace(/-/g, "_");
}
function $7855c5de28ae978d$var$parseCookieHeader(value, isSetCookie) {
    const semicolonIndex = value.indexOf(";");
    const cookieString = isSetCookie && semicolonIndex !== -1 ? value.substring(0, semicolonIndex) : value;
    const cookies = isSetCookie ? [
        cookieString
    ] : cookieString.split("; ");
    const result = {};
    for (const cookie of cookies){
        const equalSignIndex = cookie.indexOf("=");
        const cookieKey = (equalSignIndex !== -1 ? cookie.substring(0, equalSignIndex) : cookie).toLowerCase();
        const cookieValue = equalSignIndex !== -1 ? cookie.substring(equalSignIndex + 1) : "";
        result[cookieKey] = cookieValue;
    }
    return result;
}
function $7855c5de28ae978d$var$extractQueryParamsFromUrl(url) {
    if (!url) return;
    try {
        const queryParams = new URL(url, "http://s.io").search.slice(1);
        return queryParams.length ? queryParams : void 0;
    } catch  {
        return void 0;
    }
}
module.exports.MAX_BODY_BYTE_LENGTH = $7855c5de28ae978d$var$MAX_BODY_BYTE_LENGTH;
module.exports.captureBodyFromWinterCGRequest = $7855c5de28ae978d$var$captureBodyFromWinterCGRequest;
module.exports.extractQueryParamsFromUrl = $7855c5de28ae978d$var$extractQueryParamsFromUrl;
module.exports.getMaxBodyByteLength = $7855c5de28ae978d$var$getMaxBodyByteLength;
module.exports.headersToDict = $7855c5de28ae978d$var$headersToDict;
module.exports.httpHeadersToSpanAttributes = $7855c5de28ae978d$var$httpHeadersToSpanAttributes;
module.exports.httpRequestToRequestData = $7855c5de28ae978d$var$httpRequestToRequestData;
module.exports.winterCGHeadersToDict = $7855c5de28ae978d$var$winterCGHeadersToDict;
module.exports.winterCGRequestToRequestData = $7855c5de28ae978d$var$winterCGRequestToRequestData;

});

parcelRegister("hqWNa", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $cb12783bd4b87204$var$SPAN_KIND = {
    INTERNAL: 0,
    SERVER: 1,
    CLIENT: 2,
    PRODUCER: 3,
    CONSUMER: 4
};
const $cb12783bd4b87204$var$SPAN_KIND_NAME = {
    [$cb12783bd4b87204$var$SPAN_KIND.INTERNAL]: "INTERNAL",
    [$cb12783bd4b87204$var$SPAN_KIND.SERVER]: "SERVER",
    [$cb12783bd4b87204$var$SPAN_KIND.CLIENT]: "CLIENT",
    [$cb12783bd4b87204$var$SPAN_KIND.PRODUCER]: "PRODUCER",
    [$cb12783bd4b87204$var$SPAN_KIND.CONSUMER]: "CONSUMER"
};
function $cb12783bd4b87204$var$spanKindToName(kind) {
    return $cb12783bd4b87204$var$SPAN_KIND_NAME[kind];
}
module.exports.SPAN_KIND = $cb12783bd4b87204$var$SPAN_KIND;
module.exports.spanKindToName = $cb12783bd4b87204$var$spanKindToName;

});

parcelRegister("7ZoMM", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $79m2C = parcelRequire("79m2C");

var $4gyod = parcelRequire("4gyod");

var $ihsl1 = parcelRequire("ihsl1");
const $5d1174d995d84087$var$DEFAULT_BREADCRUMBS = 100;
function $5d1174d995d84087$var$addBreadcrumb(breadcrumb, hint) {
    const client = $79m2C.getClient();
    const isolationScope = $79m2C.getIsolationScope();
    if (!client) return;
    const { beforeBreadcrumb: beforeBreadcrumb = null, maxBreadcrumbs: maxBreadcrumbs = $5d1174d995d84087$var$DEFAULT_BREADCRUMBS } = client.getOptions();
    if (maxBreadcrumbs <= 0) return;
    const timestamp = $ihsl1.dateTimestampInSeconds();
    const mergedBreadcrumb = {
        timestamp: timestamp,
        ...breadcrumb
    };
    const finalBreadcrumb = beforeBreadcrumb ? $4gyod.consoleSandbox(()=>beforeBreadcrumb(mergedBreadcrumb, hint)) : mergedBreadcrumb;
    if (finalBreadcrumb === null) return;
    if (client.emit) client.emit("beforeAddBreadcrumb", finalBreadcrumb, hint);
    isolationScope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
}
module.exports.addBreadcrumb = $5d1174d995d84087$var$addBreadcrumb;

});

parcelRegister("7aBU0", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $79m2C = parcelRequire("79m2C");

var $g33UP = parcelRequire("g33UP");

var $7OVjx = parcelRequire("7OVjx");
const $5386de359a08e65c$var$INTEGRATION_NAME = "FunctionToString";
const $5386de359a08e65c$var$SETUP_CLIENTS = /* @__PURE__ */ new WeakMap();
const $5386de359a08e65c$var$_functionToStringIntegration = ()=>{
    return {
        name: $5386de359a08e65c$var$INTEGRATION_NAME,
        setupOnce () {
            const originalFunctionToString = Function.prototype.toString;
            try {
                Function.prototype.toString = new Proxy(originalFunctionToString, {
                    apply (target, thisArg, args) {
                        const originalFunction = $7OVjx.getOriginalFunction(thisArg);
                        let context = thisArg;
                        try {
                            if ($5386de359a08e65c$var$SETUP_CLIENTS.has($79m2C.getClient()) && originalFunction) context = originalFunction;
                        } catch  {}
                        return Reflect.apply(target, context, args);
                    }
                });
            } catch  {}
        },
        setup (client) {
            $5386de359a08e65c$var$SETUP_CLIENTS.set(client, true);
        }
    };
};
const $5386de359a08e65c$var$functionToStringIntegration = $g33UP.defineIntegration($5386de359a08e65c$var$_functionToStringIntegration);
module.exports.functionToStringIntegration = $5386de359a08e65c$var$functionToStringIntegration;

});

parcelRegister("hfsCi", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $hiZR1 = parcelRequire("hiZR1");

var $g33UP = parcelRequire("g33UP");

var $4gyod = parcelRequire("4gyod");

var $8008j = parcelRequire("8008j");

var $6JkyB = parcelRequire("6JkyB");

var $arYVC = parcelRequire("arYVC");
const $c8ea091132ef9b7c$var$DEFAULT_IGNORE_ERRORS = [
    /^Script error\.?$/,
    /^Javascript error: Script error\.? on line 0$/,
    /^ResizeObserver loop completed with undelivered notifications.$/,
    // The browser logs this when a ResizeObserver handler takes a bit longer. Usually this is not an actual issue though. It indicates slowness.
    /^Cannot redefine property: googletag$/,
    // This is thrown when google tag manager is used in combination with an ad blocker
    /^Can't find variable: gmo$/,
    // Error from Google Search App https://issuetracker.google.com/issues/396043331
    /^undefined is not an object \(evaluating 'a\.[A-Z]'\)$/,
    // Random error that happens but not actionable or noticeable to end-users.
    /can't redefine non-configurable property "solana"/,
    // Probably a browser extension or custom browser (Brave) throwing this error
    /vv\(\)\.getRestrictions is not a function/,
    // Error thrown by GTM, seemingly not affecting end-users
    /Can't find variable: _AutofillCallbackHandler/,
    // Unactionable error in instagram webview https://developers.facebook.com/community/threads/320013549791141/
    /Object Not Found Matching Id:\d+, MethodName:simulateEvent/,
    // unactionable error from CEFSharp, a .NET library that embeds chromium in .NET apps
    /^Java exception was raised during method invocation$/
];
const $c8ea091132ef9b7c$var$INTEGRATION_NAME = "EventFilters";
const $c8ea091132ef9b7c$var$eventFiltersIntegration = $g33UP.defineIntegration((options = {})=>{
    let mergedOptions;
    return {
        name: $c8ea091132ef9b7c$var$INTEGRATION_NAME,
        setup (client) {
            const clientOptions = client.getOptions();
            mergedOptions = $c8ea091132ef9b7c$var$_mergeOptions(options, clientOptions);
        },
        processEvent (event, _hint, client) {
            if (!mergedOptions) {
                const clientOptions = client.getOptions();
                mergedOptions = $c8ea091132ef9b7c$var$_mergeOptions(options, clientOptions);
            }
            return $c8ea091132ef9b7c$var$_shouldDropEvent(event, mergedOptions) ? null : event;
        }
    };
});
const $c8ea091132ef9b7c$var$inboundFiltersIntegration = $g33UP.defineIntegration((options = {})=>{
    return {
        ...$c8ea091132ef9b7c$var$eventFiltersIntegration(options),
        name: "InboundFilters"
    };
});
function $c8ea091132ef9b7c$var$_mergeOptions(internalOptions = {}, clientOptions = {}) {
    return {
        allowUrls: [
            ...internalOptions.allowUrls || [],
            ...clientOptions.allowUrls || []
        ],
        denyUrls: [
            ...internalOptions.denyUrls || [],
            ...clientOptions.denyUrls || []
        ],
        ignoreErrors: [
            ...internalOptions.ignoreErrors || [],
            ...clientOptions.ignoreErrors || [],
            ...internalOptions.disableErrorDefaults ? [] : $c8ea091132ef9b7c$var$DEFAULT_IGNORE_ERRORS
        ],
        ignoreTransactions: [
            ...internalOptions.ignoreTransactions || [],
            ...clientOptions.ignoreTransactions || []
        ]
    };
}
function $c8ea091132ef9b7c$var$_shouldDropEvent(event, options) {
    if (!event.type) {
        if ($c8ea091132ef9b7c$var$_isIgnoredError(event, options.ignoreErrors)) {
            $hiZR1.DEBUG_BUILD && $4gyod.debug.warn(`Event dropped due to being matched by \`ignoreErrors\` option.
Event: ${$6JkyB.getEventDescription(event)}`);
            return true;
        }
        if ($c8ea091132ef9b7c$var$_isUselessError(event)) {
            $hiZR1.DEBUG_BUILD && $4gyod.debug.warn(`Event dropped due to not having an error message, error type or stacktrace.
Event: ${$6JkyB.getEventDescription(event)}`);
            return true;
        }
        if ($c8ea091132ef9b7c$var$_isDeniedUrl(event, options.denyUrls)) {
            $hiZR1.DEBUG_BUILD && $4gyod.debug.warn(`Event dropped due to being matched by \`denyUrls\` option.
Event: ${$6JkyB.getEventDescription(event)}.
Url: ${$c8ea091132ef9b7c$var$_getEventFilterUrl(event)}`);
            return true;
        }
        if (!$c8ea091132ef9b7c$var$_isAllowedUrl(event, options.allowUrls)) {
            $hiZR1.DEBUG_BUILD && $4gyod.debug.warn(`Event dropped due to not being matched by \`allowUrls\` option.
Event: ${$6JkyB.getEventDescription(event)}.
Url: ${$c8ea091132ef9b7c$var$_getEventFilterUrl(event)}`);
            return true;
        }
    } else if (event.type === "transaction") {
        if ($c8ea091132ef9b7c$var$_isIgnoredTransaction(event, options.ignoreTransactions)) {
            $hiZR1.DEBUG_BUILD && $4gyod.debug.warn(`Event dropped due to being matched by \`ignoreTransactions\` option.
Event: ${$6JkyB.getEventDescription(event)}`);
            return true;
        }
    }
    return false;
}
function $c8ea091132ef9b7c$var$_isIgnoredError(event, ignoreErrors) {
    if (!ignoreErrors?.length) return false;
    return $8008j.getPossibleEventMessages(event).some((message)=>$arYVC.stringMatchesSomePattern(message, ignoreErrors));
}
function $c8ea091132ef9b7c$var$_isIgnoredTransaction(event, ignoreTransactions) {
    if (!ignoreTransactions?.length) return false;
    const name = event.transaction;
    return name ? $arYVC.stringMatchesSomePattern(name, ignoreTransactions) : false;
}
function $c8ea091132ef9b7c$var$_isDeniedUrl(event, denyUrls) {
    if (!denyUrls?.length) return false;
    const url = $c8ea091132ef9b7c$var$_getEventFilterUrl(event);
    return !url ? false : $arYVC.stringMatchesSomePattern(url, denyUrls);
}
function $c8ea091132ef9b7c$var$_isAllowedUrl(event, allowUrls) {
    if (!allowUrls?.length) return true;
    const url = $c8ea091132ef9b7c$var$_getEventFilterUrl(event);
    return !url ? true : $arYVC.stringMatchesSomePattern(url, allowUrls);
}
function $c8ea091132ef9b7c$var$_getLastValidUrl(frames = []) {
    for(let i = frames.length - 1; i >= 0; i--){
        const frame = frames[i];
        if (frame && frame.filename !== "<anonymous>" && frame.filename !== "[native code]") return frame.filename || null;
    }
    return null;
}
function $c8ea091132ef9b7c$var$_getEventFilterUrl(event) {
    try {
        const rootException = [
            ...event.exception?.values ?? []
        ].reverse().find((value)=>value.mechanism?.parent_id === void 0 && value.stacktrace?.frames?.length);
        const frames = rootException?.stacktrace?.frames;
        return frames ? $c8ea091132ef9b7c$var$_getLastValidUrl(frames) : null;
    } catch  {
        $hiZR1.DEBUG_BUILD && $4gyod.debug.error(`Cannot extract url for event ${$6JkyB.getEventDescription(event)}`);
        return null;
    }
}
function $c8ea091132ef9b7c$var$_isUselessError(event) {
    if (!event.exception?.values?.length) return false;
    return(// No top-level message
    !event.message && // There are no exception values that have a stacktrace, a non-generic-Error type or value
    !event.exception.values.some((value)=>value.stacktrace || value.type && value.type !== "Error" || value.value));
}
module.exports.eventFiltersIntegration = $c8ea091132ef9b7c$var$eventFiltersIntegration;
module.exports.inboundFiltersIntegration = $c8ea091132ef9b7c$var$inboundFiltersIntegration;

});

parcelRegister("kP6ZH", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $g33UP = parcelRequire("g33UP");

var $20hDs = parcelRequire("20hDs");

var $l3xRy = parcelRequire("l3xRy");
const $f28dfef280c1ab2c$var$DEFAULT_KEY = "cause";
const $f28dfef280c1ab2c$var$DEFAULT_LIMIT = 5;
const $f28dfef280c1ab2c$var$INTEGRATION_NAME = "LinkedErrors";
const $f28dfef280c1ab2c$var$_linkedErrorsIntegration = (options = {})=>{
    const limit = options.limit || $f28dfef280c1ab2c$var$DEFAULT_LIMIT;
    const key = options.key || $f28dfef280c1ab2c$var$DEFAULT_KEY;
    return {
        name: $f28dfef280c1ab2c$var$INTEGRATION_NAME,
        preprocessEvent (event, hint, client) {
            const options2 = client.getOptions();
            $20hDs.applyAggregateErrorsToEvent($l3xRy.exceptionFromError, options2.stackParser, key, limit, event, hint);
        }
    };
};
const $f28dfef280c1ab2c$var$linkedErrorsIntegration = $g33UP.defineIntegration($f28dfef280c1ab2c$var$_linkedErrorsIntegration);
module.exports.linkedErrorsIntegration = $f28dfef280c1ab2c$var$linkedErrorsIntegration;

});
parcelRegister("20hDs", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $dzfKZ = parcelRequire("dzfKZ");
function $175942dcd5d10758$var$applyAggregateErrorsToEvent(exceptionFromErrorImplementation, parser, key, limit, event, hint) {
    if (!event.exception?.values || !hint || !$dzfKZ.isInstanceOf(hint.originalException, Error)) return;
    const originalException = event.exception.values.length > 0 ? event.exception.values[event.exception.values.length - 1] : void 0;
    if (originalException) event.exception.values = $175942dcd5d10758$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, hint.originalException, key, event.exception.values, originalException, 0);
}
function $175942dcd5d10758$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error, key, prevExceptions, exception, exceptionId) {
    if (prevExceptions.length >= limit + 1) return prevExceptions;
    let newExceptions = [
        ...prevExceptions
    ];
    if ($dzfKZ.isInstanceOf(error[key], Error)) {
        $175942dcd5d10758$var$applyExceptionGroupFieldsForParentException(exception, exceptionId, error);
        const newException = exceptionFromErrorImplementation(parser, error[key]);
        const newExceptionId = newExceptions.length;
        $175942dcd5d10758$var$applyExceptionGroupFieldsForChildException(newException, key, newExceptionId, exceptionId);
        newExceptions = $175942dcd5d10758$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error[key], key, [
            newException,
            ...newExceptions
        ], newException, newExceptionId);
    }
    if ($175942dcd5d10758$var$isExceptionGroup(error)) error.errors.forEach((childError, i)=>{
        if ($dzfKZ.isInstanceOf(childError, Error)) {
            $175942dcd5d10758$var$applyExceptionGroupFieldsForParentException(exception, exceptionId, error);
            const newException = exceptionFromErrorImplementation(parser, childError);
            const newExceptionId = newExceptions.length;
            $175942dcd5d10758$var$applyExceptionGroupFieldsForChildException(newException, `errors[${i}]`, newExceptionId, exceptionId);
            newExceptions = $175942dcd5d10758$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, childError, key, [
                newException,
                ...newExceptions
            ], newException, newExceptionId);
        }
    });
    return newExceptions;
}
function $175942dcd5d10758$var$isExceptionGroup(error) {
    return Array.isArray(error.errors);
}
function $175942dcd5d10758$var$applyExceptionGroupFieldsForParentException(exception, exceptionId, error) {
    exception.mechanism = {
        handled: true,
        type: "auto.core.linked_errors",
        ...$175942dcd5d10758$var$isExceptionGroup(error) && {
            is_exception_group: true
        },
        ...exception.mechanism,
        exception_id: exceptionId
    };
}
function $175942dcd5d10758$var$applyExceptionGroupFieldsForChildException(exception, source, exceptionId, parentId) {
    exception.mechanism = {
        handled: true,
        ...exception.mechanism,
        type: "chained",
        source: source,
        exception_id: exceptionId,
        parent_id: parentId
    };
}
module.exports.applyAggregateErrorsToEvent = $175942dcd5d10758$var$applyAggregateErrorsToEvent;

});

parcelRegister("l3xRy", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $dzfKZ = parcelRequire("dzfKZ");

var $6JkyB = parcelRequire("6JkyB");

var $eD1cG = parcelRequire("eD1cG");

var $7OVjx = parcelRequire("7OVjx");
function $f544253aaa1f26a1$var$parseStackFrames(stackParser, error) {
    return stackParser(error.stack || "", 1);
}
function $f544253aaa1f26a1$var$hasSentryFetchUrlHost(error) {
    return $dzfKZ.isError(error) && "__sentry_fetch_url_host__" in error && typeof error.__sentry_fetch_url_host__ === "string";
}
function $f544253aaa1f26a1$var$_enhanceErrorWithSentryInfo(error) {
    if ($f544253aaa1f26a1$var$hasSentryFetchUrlHost(error)) return `${error.message} (${error.__sentry_fetch_url_host__})`;
    return error.message;
}
function $f544253aaa1f26a1$var$exceptionFromError(stackParser, error) {
    const exception = {
        type: error.name || error.constructor.name,
        value: $f544253aaa1f26a1$var$_enhanceErrorWithSentryInfo(error)
    };
    const frames = $f544253aaa1f26a1$var$parseStackFrames(stackParser, error);
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    return exception;
}
function $f544253aaa1f26a1$var$getErrorPropertyFromObject(obj) {
    for(const prop in obj)if (Object.prototype.hasOwnProperty.call(obj, prop)) {
        const value = obj[prop];
        if (value instanceof Error) return value;
    }
    return void 0;
}
function $f544253aaa1f26a1$var$getMessageForObject(exception) {
    if ("name" in exception && typeof exception.name === "string") {
        let message = `'${exception.name}' captured as exception`;
        if ("message" in exception && typeof exception.message === "string") message += ` with message '${exception.message}'`;
        return message;
    } else if ("message" in exception && typeof exception.message === "string") return exception.message;
    const keys = $7OVjx.extractExceptionKeysForMessage(exception);
    if ($dzfKZ.isErrorEvent(exception)) return `Event \`ErrorEvent\` captured as exception with message \`${exception.message}\``;
    const className = $f544253aaa1f26a1$var$getObjectClassName(exception);
    return `${className && className !== "Object" ? `'${className}'` : "Object"} captured as exception with keys: ${keys}`;
}
function $f544253aaa1f26a1$var$getObjectClassName(obj) {
    try {
        const prototype = Object.getPrototypeOf(obj);
        return prototype ? prototype.constructor.name : void 0;
    } catch  {}
}
function $f544253aaa1f26a1$var$getException(client, mechanism, exception, hint) {
    if ($dzfKZ.isError(exception)) return [
        exception,
        void 0
    ];
    mechanism.synthetic = true;
    if ($dzfKZ.isPlainObject(exception)) {
        const normalizeDepth = client?.getOptions().normalizeDepth;
        const extras = {
            ["__serialized__"]: $eD1cG.normalizeToSize(exception, normalizeDepth)
        };
        const errorFromProp = $f544253aaa1f26a1$var$getErrorPropertyFromObject(exception);
        if (errorFromProp) return [
            errorFromProp,
            extras
        ];
        const message = $f544253aaa1f26a1$var$getMessageForObject(exception);
        const ex2 = hint?.syntheticException || new Error(message);
        ex2.message = message;
        return [
            ex2,
            extras
        ];
    }
    const ex = hint?.syntheticException || new Error(exception);
    ex.message = `${exception}`;
    return [
        ex,
        void 0
    ];
}
function $f544253aaa1f26a1$var$eventFromUnknownInput(client, stackParser, exception, hint) {
    const providedMechanism = hint?.data && hint.data.mechanism;
    const mechanism = providedMechanism || {
        handled: true,
        type: "generic"
    };
    const [ex, extras] = $f544253aaa1f26a1$var$getException(client, mechanism, exception, hint);
    const event = {
        exception: {
            values: [
                $f544253aaa1f26a1$var$exceptionFromError(stackParser, ex)
            ]
        }
    };
    if (extras) event.extra = extras;
    $6JkyB.addExceptionTypeValue(event, void 0, void 0);
    $6JkyB.addExceptionMechanism(event, mechanism);
    return {
        ...event,
        event_id: hint?.event_id
    };
}
function $f544253aaa1f26a1$var$eventFromMessage(stackParser, message, level = "info", hint, attachStacktrace) {
    const event = {
        event_id: hint?.event_id,
        level: level
    };
    if (attachStacktrace && hint?.syntheticException) {
        const frames = $f544253aaa1f26a1$var$parseStackFrames(stackParser, hint.syntheticException);
        if (frames.length) {
            event.exception = {
                values: [
                    {
                        value: message,
                        stacktrace: {
                            frames: frames
                        }
                    }
                ]
            };
            $6JkyB.addExceptionMechanism(event, {
                synthetic: true
            });
        }
    }
    if ($dzfKZ.isParameterizedString(message)) {
        const { __sentry_template_string__: __sentry_template_string__, __sentry_template_values__: __sentry_template_values__ } = message;
        event.logentry = {
            message: __sentry_template_string__,
            params: __sentry_template_values__
        };
        return event;
    }
    event.message = message;
    return event;
}
module.exports._enhanceErrorWithSentryInfo = $f544253aaa1f26a1$var$_enhanceErrorWithSentryInfo;
module.exports.eventFromMessage = $f544253aaa1f26a1$var$eventFromMessage;
module.exports.eventFromUnknownInput = $f544253aaa1f26a1$var$eventFromUnknownInput;
module.exports.exceptionFromError = $f544253aaa1f26a1$var$exceptionFromError;
module.exports.parseStackFrames = $f544253aaa1f26a1$var$parseStackFrames;

});


parcelRegister("6KRgN", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $g33UP = parcelRequire("g33UP");

var $318WW = parcelRequire("318WW");

var $636GJ = parcelRequire("636GJ");
const $4eb05c3cb4e40221$var$moduleMetadataIntegration = $g33UP.defineIntegration(()=>{
    return {
        name: "ModuleMetadata",
        setup (client) {
            client.on("beforeEnvelope", (envelope$1)=>{
                $636GJ.forEachEnvelopeItem(envelope$1, (item, type)=>{
                    if (type === "event") {
                        const event = Array.isArray(item) ? item[1] : void 0;
                        if (event) {
                            $318WW.stripMetadataFromStackFrames(event);
                            item[1] = event;
                        }
                    }
                });
            });
            client.on("applyFrameMetadata", (event)=>{
                if (event.type) return;
                const stackParser = client.getOptions().stackParser;
                $318WW.addMetadataToStackFrames(stackParser, event);
            });
        }
    };
});
module.exports.moduleMetadataIntegration = $4eb05c3cb4e40221$var$moduleMetadataIntegration;

});
parcelRegister("318WW", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $eP8Ri = parcelRequire("eP8Ri");
const $2328684cbfb71695$var$filenameMetadataMap = /* @__PURE__ */ new Map();
const $2328684cbfb71695$var$parsedStacks = /* @__PURE__ */ new Set();
function $2328684cbfb71695$var$getFilenameToMetadataMap(parser) {
    if (!$eP8Ri.GLOBAL_OBJ._sentryModuleMetadata) return {};
    const filenameMap = {};
    for (const stack of Object.keys($eP8Ri.GLOBAL_OBJ._sentryModuleMetadata)){
        const metadata = $eP8Ri.GLOBAL_OBJ._sentryModuleMetadata[stack];
        const frames = parser(stack);
        for (const frame of frames.reverse())if (frame.filename) {
            filenameMap[frame.filename] = metadata;
            break;
        }
    }
    return filenameMap;
}
function $2328684cbfb71695$var$ensureMetadataStacksAreParsed(parser) {
    if (!$eP8Ri.GLOBAL_OBJ._sentryModuleMetadata) return;
    for (const stack of Object.keys($eP8Ri.GLOBAL_OBJ._sentryModuleMetadata)){
        const metadata = $eP8Ri.GLOBAL_OBJ._sentryModuleMetadata[stack];
        if ($2328684cbfb71695$var$parsedStacks.has(stack)) continue;
        $2328684cbfb71695$var$parsedStacks.add(stack);
        const frames = parser(stack);
        for (const frame of frames.reverse())if (frame.filename) {
            $2328684cbfb71695$var$filenameMetadataMap.set(frame.filename, metadata);
            break;
        }
    }
}
function $2328684cbfb71695$var$getMetadataForUrl(parser, filename) {
    $2328684cbfb71695$var$ensureMetadataStacksAreParsed(parser);
    return $2328684cbfb71695$var$filenameMetadataMap.get(filename);
}
function $2328684cbfb71695$var$addMetadataToStackFrames(parser, event) {
    event.exception?.values?.forEach((exception)=>{
        exception.stacktrace?.frames?.forEach((frame)=>{
            if (!frame.filename || frame.module_metadata) return;
            const metadata = $2328684cbfb71695$var$getMetadataForUrl(parser, frame.filename);
            if (metadata) frame.module_metadata = metadata;
        });
    });
}
function $2328684cbfb71695$var$stripMetadataFromStackFrames(event) {
    event.exception?.values?.forEach((exception)=>{
        exception.stacktrace?.frames?.forEach((frame)=>{
            delete frame.module_metadata;
        });
    });
}
module.exports.addMetadataToStackFrames = $2328684cbfb71695$var$addMetadataToStackFrames;
module.exports.getFilenameToMetadataMap = $2328684cbfb71695$var$getFilenameToMetadataMap;
module.exports.getMetadataForUrl = $2328684cbfb71695$var$getMetadataForUrl;
module.exports.stripMetadataFromStackFrames = $2328684cbfb71695$var$stripMetadataFromStackFrames;

});


parcelRegister("h4TTy", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $79m2C = parcelRequire("79m2C");

var $g33UP = parcelRequire("g33UP");

var $gTasE = parcelRequire("gTasE");

var $fJi1f = parcelRequire("fJi1f");

var $akxwg = parcelRequire("akxwg");

var $cqXAJ = parcelRequire("cqXAJ");

var $452ZL = parcelRequire("452ZL");
const $c6ee2afa6da96d7b$var$INTEGRATION_NAME = "RequestData";
const $c6ee2afa6da96d7b$var$_requestDataIntegration = (options = {})=>{
    function resolveIncludeAndDataCollection(client) {
        const dc = client.getDataCollectionOptions();
        const dataCollection = {
            ...dc,
            ...options.include?.cookies === true && dc.cookies === false && {
                cookies: true
            },
            ...options.include?.headers === true && dc.httpHeaders.request === false && {
                httpHeaders: {
                    ...dc.httpHeaders,
                    request: true
                }
            }
        };
        return {
            dataCollection: dataCollection,
            include: {
                cookies: dataCollection.cookies !== false,
                // Always attach body data that's already on the scope — dataCollection.httpBodies gates write-time, not read-time
                data: true,
                headers: dataCollection.httpHeaders.request !== false,
                ip: dataCollection.userInfo,
                query_string: dataCollection.urlQueryParams !== false,
                // No dataCollection equivalent — URL is always included
                url: true,
                ...options.include
            }
        };
    }
    return {
        name: $c6ee2afa6da96d7b$var$INTEGRATION_NAME,
        processEvent (event, _hint, client) {
            const { sdkProcessingMetadata: sdkProcessingMetadata = {} } = event;
            const { normalizedRequest: normalizedRequest, ipAddress: ipAddress } = sdkProcessingMetadata;
            const { include: include } = resolveIncludeAndDataCollection(client);
            if (normalizedRequest) $c6ee2afa6da96d7b$var$addNormalizedRequestDataToEvent(event, normalizedRequest, {
                ipAddress: ipAddress
            }, include);
            return event;
        },
        processSegmentSpan (span, client) {
            const { sdkProcessingMetadata: sdkProcessingMetadata = {} } = $79m2C.getIsolationScope().getScopeData();
            const { normalizedRequest: normalizedRequest, ipAddress: ipAddress } = sdkProcessingMetadata;
            if (!normalizedRequest) return;
            const { include: include, dataCollection: dataCollection } = resolveIncludeAndDataCollection(client);
            $c6ee2afa6da96d7b$var$addNormalizedRequestDataToSpan(span, normalizedRequest, ipAddress, include, dataCollection);
        }
    };
};
const $c6ee2afa6da96d7b$var$requestDataIntegration = $g33UP.defineIntegration($c6ee2afa6da96d7b$var$_requestDataIntegration);
function $c6ee2afa6da96d7b$var$addNormalizedRequestDataToEvent(event, req, additionalData, include) {
    event.request = {
        ...event.request,
        ...$c6ee2afa6da96d7b$var$extractNormalizedRequestData(req, include)
    };
    if (include.ip) {
        const ip = req.headers && $cqXAJ.getClientIPAddress(req.headers) || additionalData.ipAddress;
        if (ip) event.user = {
            ...event.user,
            ip_address: ip
        };
    }
}
function $c6ee2afa6da96d7b$var$addNormalizedRequestDataToSpan(span, normalizedRequest, ipAddress, include, dataCollection) {
    const requestData = $c6ee2afa6da96d7b$var$extractNormalizedRequestData(normalizedRequest, include);
    const attributes = {};
    if (requestData.url) attributes["url.full"] = requestData.url;
    if (requestData.method) attributes["http.request.method"] = requestData.method;
    if (requestData.query_string) attributes["url.query"] = $c6ee2afa6da96d7b$var$normalizeQueryString(requestData.query_string);
    $452ZL.safeSetSpanJSONAttributes(span, attributes);
    if (requestData.cookies && Object.keys(requestData.cookies).length > 0) {
        const cookieString = Object.entries(requestData.cookies).map(([name, value])=>`${name}=${value}`).join("; ");
        const cookieAttributes = $akxwg.httpHeadersToSpanAttributes({
            cookie: cookieString
        }, dataCollection, "request");
        $452ZL.safeSetSpanJSONAttributes(span, cookieAttributes);
    }
    if (requestData.headers) {
        const headerAttributes = $akxwg.httpHeadersToSpanAttributes(requestData.headers, dataCollection, "request");
        $452ZL.safeSetSpanJSONAttributes(span, headerAttributes);
    }
    if (requestData.data != null) {
        const serialized = typeof requestData.data === "string" ? requestData.data : JSON.stringify(requestData.data);
        if (serialized) $452ZL.safeSetSpanJSONAttributes(span, {
            "http.request.body.data": serialized
        });
    }
    if (include.ip) {
        const ip = normalizedRequest.headers && $cqXAJ.getClientIPAddress(normalizedRequest.headers) || ipAddress || void 0;
        if (ip) $452ZL.safeSetSpanJSONAttributes(span, {
            [$gTasE.SEMANTIC_ATTRIBUTE_USER_IP_ADDRESS]: ip
        });
    }
}
function $c6ee2afa6da96d7b$var$extractNormalizedRequestData(normalizedRequest, include) {
    const requestData = {};
    const headers = {
        ...normalizedRequest.headers
    };
    if (include.headers) {
        requestData.headers = headers;
        if (!include.cookies) delete headers.cookie;
        if (!include.ip) {
            const ipHeaderNamesLower = new Set($cqXAJ.ipHeaderNames.map((name)=>name.toLowerCase()));
            for (const key of Object.keys(headers))if (ipHeaderNamesLower.has(key.toLowerCase())) delete headers[key];
        }
    }
    requestData.method = normalizedRequest.method;
    if (include.url) requestData.url = normalizedRequest.url;
    if (include.cookies) {
        const cookies = normalizedRequest.cookies || (headers?.cookie ? $fJi1f.parseCookie(headers.cookie) : void 0);
        requestData.cookies = cookies || {};
    }
    if (include.query_string) requestData.query_string = normalizedRequest.query_string;
    if (include.data) requestData.data = normalizedRequest.data;
    return requestData;
}
function $c6ee2afa6da96d7b$var$normalizeQueryString(queryString) {
    if (typeof queryString === "string") return queryString || void 0;
    const pairs = Array.isArray(queryString) ? queryString : Object.entries(queryString);
    const result = pairs.map(([key, value])=>`${key}=${value}`).join("&");
    return result || void 0;
}
module.exports.requestDataIntegration = $c6ee2afa6da96d7b$var$requestDataIntegration;

});
parcelRegister("cqXAJ", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $90d6235b78ec6d87$var$ipHeaderNames = [
    "X-Client-IP",
    "X-Forwarded-For",
    "Fly-Client-IP",
    "CF-Connecting-IP",
    "Fastly-Client-Ip",
    "True-Client-Ip",
    "X-Real-IP",
    "X-Cluster-Client-IP",
    "X-Forwarded",
    "Forwarded-For",
    "Forwarded",
    "X-Vercel-Forwarded-For"
];
function $90d6235b78ec6d87$var$getClientIPAddress(headers) {
    const lowerCaseHeaders = {};
    for (const key of Object.keys(headers))lowerCaseHeaders[key.toLowerCase()] = headers[key];
    const headerValues = $90d6235b78ec6d87$var$ipHeaderNames.map((headerName)=>{
        const rawValue = lowerCaseHeaders[headerName.toLowerCase()];
        const value = Array.isArray(rawValue) ? rawValue.join(";") : rawValue;
        if (headerName === "Forwarded") return $90d6235b78ec6d87$var$parseForwardedHeader(value);
        return value?.split(",").map((v)=>v.trim());
    });
    const flattenedHeaderValues = headerValues.reduce((acc, val)=>{
        if (!val) return acc;
        return acc.concat(val);
    }, []);
    const ipAddress = flattenedHeaderValues.find((ip)=>ip !== null && $90d6235b78ec6d87$var$isIP(ip));
    return ipAddress || null;
}
function $90d6235b78ec6d87$var$parseForwardedHeader(value) {
    if (!value) return null;
    for (const part of value.split(";")){
        if (part.startsWith("for=")) return part.slice(4);
    }
    return null;
}
function $90d6235b78ec6d87$var$isIP(str) {
    const regex = /(?:^(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}$)|(?:^(?:(?:[a-fA-F\d]{1,4}:){7}(?:[a-fA-F\d]{1,4}|:)|(?:[a-fA-F\d]{1,4}:){6}(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|:[a-fA-F\d]{1,4}|:)|(?:[a-fA-F\d]{1,4}:){5}(?::(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|(?::[a-fA-F\d]{1,4}){1,2}|:)|(?:[a-fA-F\d]{1,4}:){4}(?:(?::[a-fA-F\d]{1,4}){0,1}:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|(?::[a-fA-F\d]{1,4}){1,3}|:)|(?:[a-fA-F\d]{1,4}:){3}(?:(?::[a-fA-F\d]{1,4}){0,2}:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|(?::[a-fA-F\d]{1,4}){1,4}|:)|(?:[a-fA-F\d]{1,4}:){2}(?:(?::[a-fA-F\d]{1,4}){0,3}:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|(?::[a-fA-F\d]{1,4}){1,5}|:)|(?:[a-fA-F\d]{1,4}:){1}(?:(?::[a-fA-F\d]{1,4}){0,4}:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|(?::[a-fA-F\d]{1,4}){1,6}|:)|(?::(?:(?::[a-fA-F\d]{1,4}){0,5}:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|(?::[a-fA-F\d]{1,4}){1,7}|:)))(?:%[0-9a-zA-Z]{1,})?$)/;
    return regex.test(str);
}
module.exports.getClientIPAddress = $90d6235b78ec6d87$var$getClientIPAddress;
module.exports.ipHeaderNames = $90d6235b78ec6d87$var$ipHeaderNames;

});


parcelRegister("cWoZT", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $79m2C = parcelRequire("79m2C");

var $1tl8I = parcelRequire("1tl8I");

var $8mzKS = parcelRequire("8mzKS");

var $g33UP = parcelRequire("g33UP");

var $4gyod = parcelRequire("4gyod");

var $6JkyB = parcelRequire("6JkyB");

var $1VSHh = parcelRequire("1VSHh");

var $arYVC = parcelRequire("arYVC");

var $eP8Ri = parcelRequire("eP8Ri");
const $96be4ac107833148$var$INTEGRATION_NAME = "CaptureConsole";
const $96be4ac107833148$var$_captureConsoleIntegration = (options = {})=>{
    const levels = options.levels || $4gyod.CONSOLE_LEVELS;
    const handled = options.handled ?? true;
    return {
        name: $96be4ac107833148$var$INTEGRATION_NAME,
        setup (client) {
            if (!("console" in $eP8Ri.GLOBAL_OBJ)) return;
            $8mzKS.addConsoleInstrumentationHandler(({ args: args, level: level })=>{
                if ($79m2C.getClient() !== client || !levels.includes(level)) return;
                $96be4ac107833148$var$consoleHandler(args, level, handled);
            });
        }
    };
};
const $96be4ac107833148$var$captureConsoleIntegration = $g33UP.defineIntegration($96be4ac107833148$var$_captureConsoleIntegration);
function $96be4ac107833148$var$consoleHandler(args, level, handled) {
    const severityLevel = $1VSHh.severityLevelFromString(level);
    const syntheticException = new Error();
    const captureContext = {
        level: $1VSHh.severityLevelFromString(level),
        extra: {
            arguments: args
        }
    };
    $79m2C.withScope((scope)=>{
        scope.addEventProcessor((event)=>{
            event.logger = "console";
            $6JkyB.addExceptionMechanism(event, {
                handled: handled,
                type: "auto.core.capture_console"
            });
            return event;
        });
        if (level === "assert") {
            if (!args[0]) {
                const message2 = `Assertion failed: ${$arYVC.safeJoin(args.slice(1), " ") || "console.assert"}`;
                scope.setExtra("arguments", args.slice(1));
                scope.captureMessage(message2, severityLevel, {
                    captureContext: captureContext,
                    syntheticException: syntheticException
                });
            }
            return;
        }
        const error = args.find((arg)=>arg instanceof Error);
        if (error) {
            $1tl8I.captureException(error, captureContext);
            return;
        }
        const message = $arYVC.safeJoin(args, " ");
        scope.captureMessage(message, severityLevel, {
            captureContext: captureContext,
            syntheticException: syntheticException
        });
    });
}
module.exports.captureConsoleIntegration = $96be4ac107833148$var$captureConsoleIntegration;

});
parcelRegister("8mzKS", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $hiZR1 = parcelRequire("hiZR1");

var $4gyod = parcelRequire("4gyod");

var $7OVjx = parcelRequire("7OVjx");

var $arYVC = parcelRequire("arYVC");

var $eP8Ri = parcelRequire("eP8Ri");

var $1d06v = parcelRequire("1d06v");
const $616c1d0424cd4618$var$_filter = /* @__PURE__ */ new Set([]);
function $616c1d0424cd4618$var$addConsoleInstrumentationHandler(handler) {
    const type = "console";
    const removeHandler = $1d06v.addHandler(type, handler);
    $1d06v.maybeInstrument(type, $616c1d0424cd4618$var$instrumentConsole);
    return removeHandler;
}
function $616c1d0424cd4618$var$addConsoleInstrumentationFilter(filter) {
    for (const f of filter)$616c1d0424cd4618$var$_filter.add(f);
    return ()=>{
        for (const f of filter)$616c1d0424cd4618$var$_filter.delete(f);
    };
}
const $616c1d0424cd4618$var$instrumentedLevels = /* @__PURE__ */ new Set();
function $616c1d0424cd4618$var$instrumentConsole() {
    if (!("console" in $eP8Ri.GLOBAL_OBJ)) return;
    $4gyod.CONSOLE_LEVELS.forEach(function(level) {
        if ($616c1d0424cd4618$var$instrumentedLevels.has(level) || !(level in $eP8Ri.GLOBAL_OBJ.console)) return;
        $616c1d0424cd4618$var$instrumentedLevels.add(level);
        $7OVjx.fill($eP8Ri.GLOBAL_OBJ.console, level, function(originalConsoleMethod) {
            $4gyod.originalConsoleMethods[level] = originalConsoleMethod;
            return function(...args) {
                const firstArg = args[0];
                const log = $4gyod.originalConsoleMethods[level];
                const isFiltered = $616c1d0424cd4618$var$_filter.size && typeof firstArg === "string" && $arYVC.stringMatchesSomePattern(firstArg, $616c1d0424cd4618$var$_filter);
                if (!isFiltered) $1d06v.triggerHandlers("console", {
                    args: args,
                    level: level
                });
                if (!isFiltered || $hiZR1.DEBUG_BUILD && $4gyod.debug.isEnabled()) log?.apply($eP8Ri.GLOBAL_OBJ.console, args);
            };
        });
    });
}
module.exports.addConsoleInstrumentationFilter = $616c1d0424cd4618$var$addConsoleInstrumentationFilter;
module.exports.addConsoleInstrumentationHandler = $616c1d0424cd4618$var$addConsoleInstrumentationHandler;
module.exports.instrumentConsole = $616c1d0424cd4618$var$instrumentConsole;

});

parcelRegister("1VSHh", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $16858b02eb5859ce$var$severityLevelFromString(level) {
    return level === "warn" ? "warning" : [
        "fatal",
        "error",
        "warning",
        "log",
        "info",
        "debug"
    ].includes(level) ? level : "log";
}
module.exports.severityLevelFromString = $16858b02eb5859ce$var$severityLevelFromString;

});


parcelRegister("aB7g9", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $hiZR1 = parcelRequire("hiZR1");

var $g33UP = parcelRequire("g33UP");

var $4gyod = parcelRequire("4gyod");

var $d7glj = parcelRequire("d7glj");
const $7b72fda78f67a13c$var$INTEGRATION_NAME = "Dedupe";
const $7b72fda78f67a13c$var$_dedupeIntegration = ()=>{
    let previousEvent;
    return {
        name: $7b72fda78f67a13c$var$INTEGRATION_NAME,
        processEvent (currentEvent) {
            if (currentEvent.type) return currentEvent;
            try {
                if ($7b72fda78f67a13c$var$_shouldDropEvent(currentEvent, previousEvent)) {
                    $hiZR1.DEBUG_BUILD && $4gyod.debug.warn("Event dropped due to being a duplicate of previously captured event.");
                    return null;
                }
            } catch  {}
            return previousEvent = currentEvent;
        }
    };
};
const $7b72fda78f67a13c$var$dedupeIntegration = $g33UP.defineIntegration($7b72fda78f67a13c$var$_dedupeIntegration);
function $7b72fda78f67a13c$var$_shouldDropEvent(currentEvent, previousEvent) {
    if (!previousEvent) return false;
    if ($7b72fda78f67a13c$var$_isSameMessageEvent(currentEvent, previousEvent)) return true;
    if ($7b72fda78f67a13c$var$_isSameExceptionEvent(currentEvent, previousEvent)) return true;
    return false;
}
function $7b72fda78f67a13c$var$_isSameMessageEvent(currentEvent, previousEvent) {
    const currentMessage = currentEvent.message;
    const previousMessage = previousEvent.message;
    if (!currentMessage && !previousMessage) return false;
    if (currentMessage && !previousMessage || !currentMessage && previousMessage) return false;
    if (currentMessage !== previousMessage) return false;
    if (!$7b72fda78f67a13c$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$7b72fda78f67a13c$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $7b72fda78f67a13c$var$_isSameExceptionEvent(currentEvent, previousEvent) {
    const previousException = $7b72fda78f67a13c$var$_getExceptionFromEvent(previousEvent);
    const currentException = $7b72fda78f67a13c$var$_getExceptionFromEvent(currentEvent);
    if (!previousException || !currentException) return false;
    if (previousException.type !== currentException.type || previousException.value !== currentException.value) return false;
    if (!$7b72fda78f67a13c$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$7b72fda78f67a13c$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $7b72fda78f67a13c$var$_isSameStacktrace(currentEvent, previousEvent) {
    let currentFrames = $d7glj.getFramesFromEvent(currentEvent);
    let previousFrames = $d7glj.getFramesFromEvent(previousEvent);
    if (!currentFrames && !previousFrames) return true;
    if (currentFrames && !previousFrames || !currentFrames && previousFrames) return false;
    currentFrames;
    previousFrames;
    if (previousFrames.length !== currentFrames.length) return false;
    for(let i = 0; i < previousFrames.length; i++){
        const frameA = previousFrames[i];
        const frameB = currentFrames[i];
        if (frameA.filename !== frameB.filename || frameA.lineno !== frameB.lineno || frameA.colno !== frameB.colno || frameA.function !== frameB.function) return false;
    }
    return true;
}
function $7b72fda78f67a13c$var$_isSameFingerprint(currentEvent, previousEvent) {
    let currentFingerprint = currentEvent.fingerprint;
    let previousFingerprint = previousEvent.fingerprint;
    if (!currentFingerprint && !previousFingerprint) return true;
    if (currentFingerprint && !previousFingerprint || !currentFingerprint && previousFingerprint) return false;
    currentFingerprint;
    previousFingerprint;
    try {
        return !!(currentFingerprint.join("") === previousFingerprint.join(""));
    } catch  {
        return false;
    }
}
function $7b72fda78f67a13c$var$_getExceptionFromEvent(event) {
    return event.exception?.values?.[0];
}
module.exports._shouldDropEvent = $7b72fda78f67a13c$var$_shouldDropEvent;
module.exports.dedupeIntegration = $7b72fda78f67a13c$var$dedupeIntegration;

});

parcelRegister("8Vant", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $hiZR1 = parcelRequire("hiZR1");

var $g33UP = parcelRequire("g33UP");

var $4gyod = parcelRequire("4gyod");

var $dzfKZ = parcelRequire("dzfKZ");

var $eD1cG = parcelRequire("eD1cG");

var $c3njb = parcelRequire("c3njb");

var $arYVC = parcelRequire("arYVC");
const $67ebb260ae20e170$var$INTEGRATION_NAME = "ExtraErrorData";
const $67ebb260ae20e170$var$_extraErrorDataIntegration = (options = {})=>{
    const { depth: depth = 3, captureErrorCause: captureErrorCause = true } = options;
    return {
        name: $67ebb260ae20e170$var$INTEGRATION_NAME,
        processEvent (event, hint, client) {
            const { maxValueLength: maxValueLength } = client.getOptions();
            return $67ebb260ae20e170$var$_enhanceEventWithErrorData(event, hint, depth, captureErrorCause, maxValueLength);
        }
    };
};
const $67ebb260ae20e170$var$extraErrorDataIntegration = $g33UP.defineIntegration($67ebb260ae20e170$var$_extraErrorDataIntegration);
function $67ebb260ae20e170$var$_enhanceEventWithErrorData(event, hint = {}, depth, captureErrorCause, maxValueLength) {
    if (!hint.originalException || !$dzfKZ.isError(hint.originalException)) return event;
    const exceptionName = hint.originalException.name || hint.originalException.constructor.name;
    const errorData = $67ebb260ae20e170$var$_extractErrorData(hint.originalException, captureErrorCause, maxValueLength);
    if (errorData) {
        const contexts = {
            ...event.contexts
        };
        const normalizedErrorData = $eD1cG.normalize(errorData, depth);
        if ($dzfKZ.isPlainObject(normalizedErrorData)) {
            $c3njb.setSkipNormalizationHint(normalizedErrorData);
            contexts[exceptionName] = normalizedErrorData;
        }
        return {
            ...event,
            contexts: contexts
        };
    }
    return event;
}
function $67ebb260ae20e170$var$_extractErrorData(error, captureErrorCause, maxValueLength) {
    try {
        const nativeKeys = [
            "name",
            "message",
            "stack",
            "line",
            "column",
            "fileName",
            "lineNumber",
            "columnNumber",
            "toJSON"
        ];
        const extraErrorInfo = {};
        for (const key of Object.keys(error)){
            if (nativeKeys.indexOf(key) !== -1) continue;
            const value = error[key];
            extraErrorInfo[key] = $dzfKZ.isError(value) || typeof value === "string" ? maxValueLength ? $arYVC.truncate(`${value}`, maxValueLength) : `${value}` : value;
        }
        if (captureErrorCause && error.cause !== void 0) {
            if ($dzfKZ.isError(error.cause)) {
                const errorName = error.cause.name || error.cause.constructor.name;
                extraErrorInfo.cause = {
                    [errorName]: $67ebb260ae20e170$var$_extractErrorData(error.cause, false, maxValueLength)
                };
            } else extraErrorInfo.cause = error.cause;
        }
        if (typeof error.toJSON === "function") {
            const serializedError = error.toJSON();
            for (const key of Object.keys(serializedError)){
                const value = serializedError[key];
                extraErrorInfo[key] = $dzfKZ.isError(value) ? value.toString() : value;
            }
        }
        return extraErrorInfo;
    } catch (oO) {
        $hiZR1.DEBUG_BUILD && $4gyod.debug.error("Unable to extract extra data from the Error object:", oO);
    }
    return null;
}
module.exports.extraErrorDataIntegration = $67ebb260ae20e170$var$extraErrorDataIntegration;

});

parcelRegister("5k42w", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $g33UP = parcelRequire("g33UP");

var $btATC = parcelRequire("btATC");

var $eP8Ri = parcelRequire("eP8Ri");
const $3e01f42e11502dcf$var$INTEGRATION_NAME = "RewriteFrames";
const $3e01f42e11502dcf$var$rewriteFramesIntegration = $g33UP.defineIntegration((options = {})=>{
    const root = options.root;
    const prefix = options.prefix || "app:///";
    const isBrowser = "window" in $eP8Ri.GLOBAL_OBJ && !!$eP8Ri.GLOBAL_OBJ.window;
    const iteratee = options.iteratee || $3e01f42e11502dcf$var$generateIteratee({
        isBrowser: isBrowser,
        root: root,
        prefix: prefix
    });
    function _processExceptionsEvent(event) {
        try {
            return {
                ...event,
                exception: {
                    ...event.exception,
                    // The check for this is performed inside `process` call itself, safe to skip here
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    values: event.exception.values.map((value)=>({
                            ...value,
                            ...value.stacktrace && {
                                stacktrace: _processStacktrace(value.stacktrace)
                            }
                        }))
                }
            };
        } catch  {
            return event;
        }
    }
    function _processStacktrace(stacktrace) {
        return {
            ...stacktrace,
            frames: stacktrace?.frames?.map((f)=>iteratee(f))
        };
    }
    return {
        name: $3e01f42e11502dcf$var$INTEGRATION_NAME,
        processEvent (originalEvent) {
            let processedEvent = originalEvent;
            if (originalEvent.exception && Array.isArray(originalEvent.exception.values)) processedEvent = _processExceptionsEvent(processedEvent);
            return processedEvent;
        }
    };
});
function $3e01f42e11502dcf$var$generateIteratee({ isBrowser: isBrowser, root: root, prefix: prefix }) {
    return (frame)=>{
        if (!frame.filename) return frame;
        const isWindowsFrame = /^[a-zA-Z]:\\/.test(frame.filename) || // or the presence of a backslash without a forward slash (which are not allowed on Windows)
        frame.filename.includes("\\") && !frame.filename.includes("/");
        const startsWithSlash = /^\//.test(frame.filename);
        if (isBrowser) {
            if (root) {
                const oldFilename = frame.filename;
                if (oldFilename.indexOf(root) === 0) frame.filename = oldFilename.replace(root, prefix);
            }
        } else if (isWindowsFrame || startsWithSlash) {
            const filename = isWindowsFrame ? frame.filename.replace(/^[a-zA-Z]:/, "").replace(/\\/g, "/") : frame.filename;
            const base = root ? $btATC.relative(root, filename) : $btATC.basename(filename);
            frame.filename = `${prefix}${base}`;
        }
        return frame;
    };
}
module.exports.generateIteratee = $3e01f42e11502dcf$var$generateIteratee;
module.exports.rewriteFramesIntegration = $3e01f42e11502dcf$var$rewriteFramesIntegration;

});
parcelRegister("btATC", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $85af05f42a2fc54e$var$normalizeArray(parts, allowAboveRoot) {
    let up = 0;
    for(let i = parts.length - 1; i >= 0; i--){
        const last = parts[i];
        if (last === ".") parts.splice(i, 1);
        else if (last === "..") {
            parts.splice(i, 1);
            up++;
        } else if (up) {
            parts.splice(i, 1);
            up--;
        }
    }
    if (allowAboveRoot) for(; up--; up)parts.unshift("..");
    return parts;
}
const $85af05f42a2fc54e$var$splitPathRe = /^(\S+:\\|\/?)([\s\S]*?)((?:\.{1,2}|[^/\\]+?|)(\.[^./\\]*|))(?:[/\\]*)$/;
function $85af05f42a2fc54e$var$splitPath(filename) {
    const truncated = filename.length > 1024 ? `<truncated>${filename.slice(-1024)}` : filename;
    const parts = $85af05f42a2fc54e$var$splitPathRe.exec(truncated);
    return parts ? parts.slice(1) : [];
}
function $85af05f42a2fc54e$var$resolve(...args) {
    let resolvedPath = "";
    let resolvedAbsolute = false;
    for(let i = args.length - 1; i >= -1 && !resolvedAbsolute; i--){
        const path = i >= 0 ? args[i] : "/";
        if (!path) continue;
        resolvedPath = `${path}/${resolvedPath}`;
        resolvedAbsolute = path.charAt(0) === "/";
    }
    resolvedPath = $85af05f42a2fc54e$var$normalizeArray(resolvedPath.split("/").filter((p)=>!!p), !resolvedAbsolute).join("/");
    return (resolvedAbsolute ? "/" : "") + resolvedPath || ".";
}
function $85af05f42a2fc54e$var$trim(arr) {
    let start = 0;
    for(; start < arr.length; start++){
        if (arr[start] !== "") break;
    }
    let end = arr.length - 1;
    for(; end >= 0; end--){
        if (arr[end] !== "") break;
    }
    if (start > end) return [];
    return arr.slice(start, end - start + 1);
}
function $85af05f42a2fc54e$var$relative(from, to) {
    from = $85af05f42a2fc54e$var$resolve(from).slice(1);
    to = $85af05f42a2fc54e$var$resolve(to).slice(1);
    const fromParts = $85af05f42a2fc54e$var$trim(from.split("/"));
    const toParts = $85af05f42a2fc54e$var$trim(to.split("/"));
    const length = Math.min(fromParts.length, toParts.length);
    let samePartsLength = length;
    for(let i = 0; i < length; i++)if (fromParts[i] !== toParts[i]) {
        samePartsLength = i;
        break;
    }
    let outputParts = [];
    for(let i = samePartsLength; i < fromParts.length; i++)outputParts.push("..");
    outputParts = outputParts.concat(toParts.slice(samePartsLength));
    return outputParts.join("/");
}
function $85af05f42a2fc54e$var$normalizePath(path) {
    const isPathAbsolute = $85af05f42a2fc54e$var$isAbsolute(path);
    const trailingSlash = path.slice(-1) === "/";
    let normalizedPath = $85af05f42a2fc54e$var$normalizeArray(path.split("/").filter((p)=>!!p), !isPathAbsolute).join("/");
    if (!normalizedPath && !isPathAbsolute) normalizedPath = ".";
    if (normalizedPath && trailingSlash) normalizedPath += "/";
    return (isPathAbsolute ? "/" : "") + normalizedPath;
}
function $85af05f42a2fc54e$var$isAbsolute(path) {
    return path.charAt(0) === "/";
}
function $85af05f42a2fc54e$var$join(...args) {
    return $85af05f42a2fc54e$var$normalizePath(args.join("/"));
}
function $85af05f42a2fc54e$var$dirname(path) {
    const result = $85af05f42a2fc54e$var$splitPath(path);
    const root = result[0] || "";
    let dir = result[1];
    if (!root && !dir) return ".";
    if (dir) dir = dir.slice(0, dir.length - 1);
    return root + dir;
}
function $85af05f42a2fc54e$var$basename(path, ext) {
    let f = $85af05f42a2fc54e$var$splitPath(path)[2] || "";
    if (ext && f.slice(ext.length * -1) === ext) f = f.slice(0, f.length - ext.length);
    return f;
}
module.exports.basename = $85af05f42a2fc54e$var$basename;
module.exports.dirname = $85af05f42a2fc54e$var$dirname;
module.exports.isAbsolute = $85af05f42a2fc54e$var$isAbsolute;
module.exports.join = $85af05f42a2fc54e$var$join;
module.exports.normalizePath = $85af05f42a2fc54e$var$normalizePath;
module.exports.relative = $85af05f42a2fc54e$var$relative;
module.exports.resolve = $85af05f42a2fc54e$var$resolve;

});


parcelRegister("8mrnP", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $7ZoMM = parcelRequire("7ZoMM");

var $79m2C = parcelRequire("79m2C");

var $hiZR1 = parcelRequire("hiZR1");

var $1tl8I = parcelRequire("1tl8I");

var $g33UP = parcelRequire("g33UP");

var $gTasE = parcelRequire("gTasE");

var $4gyod = parcelRequire("4gyod");

var $6JkyB = parcelRequire("6JkyB");

var $dzfKZ = parcelRequire("dzfKZ");

var $yI1C9 = parcelRequire("yI1C9");

var $kBDP8 = parcelRequire("kBDP8");
const $61659e8eeb6b234d$var$AUTH_OPERATIONS_TO_INSTRUMENT = [
    "reauthenticate",
    "signInAnonymously",
    "signInWithOAuth",
    "signInWithIdToken",
    "signInWithOtp",
    "signInWithPassword",
    "signInWithSSO",
    "signOut",
    "signUp",
    "verifyOtp"
];
const $61659e8eeb6b234d$var$AUTH_ADMIN_OPERATIONS_TO_INSTRUMENT = [
    "createUser",
    "deleteUser",
    "listUsers",
    "getUserById",
    "updateUserById",
    "inviteUserByEmail"
];
const $61659e8eeb6b234d$var$FILTER_MAPPINGS = {
    eq: "eq",
    neq: "neq",
    gt: "gt",
    gte: "gte",
    lt: "lt",
    lte: "lte",
    like: "like",
    "like(all)": "likeAllOf",
    "like(any)": "likeAnyOf",
    ilike: "ilike",
    "ilike(all)": "ilikeAllOf",
    "ilike(any)": "ilikeAnyOf",
    is: "is",
    in: "in",
    cs: "contains",
    cd: "containedBy",
    sr: "rangeGt",
    nxl: "rangeGte",
    sl: "rangeLt",
    nxr: "rangeLte",
    adj: "rangeAdjacent",
    ov: "overlaps",
    fts: "",
    plfts: "plain",
    phfts: "phrase",
    wfts: "websearch",
    not: "not"
};
const $61659e8eeb6b234d$var$DB_OPERATIONS_TO_INSTRUMENT = [
    "select",
    "insert",
    "upsert",
    "update",
    "delete"
];
function $61659e8eeb6b234d$var$markAsInstrumented(fn) {
    try {
        fn.__SENTRY_INSTRUMENTED__ = true;
    } catch  {}
}
function $61659e8eeb6b234d$var$isInstrumented(fn) {
    try {
        return fn.__SENTRY_INSTRUMENTED__;
    } catch  {
        return false;
    }
}
function $61659e8eeb6b234d$var$getMutationBodyPayloadForTelemetry(rawBody, plainBody) {
    if (Object.keys(plainBody).length > 0) return plainBody;
    if (Array.isArray(rawBody) && rawBody.length > 0) return rawBody;
    return void 0;
}
function $61659e8eeb6b234d$var$hasMutationBodyForDescription(rawBody, plainBody) {
    return $61659e8eeb6b234d$var$getMutationBodyPayloadForTelemetry(rawBody, plainBody) !== void 0;
}
function $61659e8eeb6b234d$var$extractOperation(method, headers = {}) {
    switch(method){
        case "GET":
            return "select";
        case "POST":
            if (headers["Prefer"]?.includes("resolution=")) return "upsert";
            else return "insert";
        case "PATCH":
            return "update";
        case "DELETE":
            return "delete";
        default:
            return "<unknown-op>";
    }
}
function $61659e8eeb6b234d$var$translateFiltersIntoMethods(key, query) {
    if (query === "" || query === "*") return "select(*)";
    if (key === "select") return `select(${query})`;
    if (key === "or" || key.endsWith(".or")) return `${key}${query}`;
    const [filter, ...value] = query.split(".");
    let method;
    if (filter?.startsWith("fts")) method = "textSearch";
    else if (filter?.startsWith("plfts")) method = "textSearch[plain]";
    else if (filter?.startsWith("phfts")) method = "textSearch[phrase]";
    else if (filter?.startsWith("wfts")) method = "textSearch[websearch]";
    else method = filter && $61659e8eeb6b234d$var$FILTER_MAPPINGS[filter] || "filter";
    return `${method}(${key}, ${value.join(".")})`;
}
function $61659e8eeb6b234d$var$instrumentAuthOperation(operation, isAdmin = false) {
    return new Proxy(operation, {
        apply (target, thisArg, argumentsList) {
            return $kBDP8.startSpan({
                name: `auth ${isAdmin ? "(admin) " : ""}${operation.name}`,
                attributes: {
                    [$gTasE.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: "auto.db.supabase",
                    [$gTasE.SEMANTIC_ATTRIBUTE_SENTRY_OP]: "db",
                    "db.system": "postgresql",
                    "db.operation": `auth.${isAdmin ? "admin." : ""}${operation.name}`
                }
            }, (span)=>{
                return Reflect.apply(target, thisArg, argumentsList).then((res)=>{
                    if ($dzfKZ.isObjectLike(res) && "error" in res && res.error) {
                        span.setStatus({
                            code: $yI1C9.SPAN_STATUS_ERROR
                        });
                        $1tl8I.captureException(res.error, {
                            mechanism: {
                                handled: false,
                                type: "auto.db.supabase.auth"
                            }
                        });
                    } else span.setStatus({
                        code: $yI1C9.SPAN_STATUS_OK
                    });
                    span.end();
                    return res;
                }).catch((err)=>{
                    span.setStatus({
                        code: $yI1C9.SPAN_STATUS_ERROR
                    });
                    span.end();
                    $1tl8I.captureException(err, {
                        mechanism: {
                            handled: false,
                            type: "auto.db.supabase.auth"
                        }
                    });
                    throw err;
                }).then(...argumentsList);
            });
        }
    });
}
function $61659e8eeb6b234d$var$instrumentSupabaseAuthClient(supabaseClientInstance) {
    const auth = supabaseClientInstance.auth;
    if (!auth || $61659e8eeb6b234d$var$isInstrumented(supabaseClientInstance.auth)) return;
    for (const operation of $61659e8eeb6b234d$var$AUTH_OPERATIONS_TO_INSTRUMENT){
        const authOperation = auth[operation];
        if (!authOperation) continue;
        if (typeof supabaseClientInstance.auth[operation] === "function") supabaseClientInstance.auth[operation] = $61659e8eeb6b234d$var$instrumentAuthOperation(authOperation);
    }
    for (const operation of $61659e8eeb6b234d$var$AUTH_ADMIN_OPERATIONS_TO_INSTRUMENT){
        const authOperation = auth.admin[operation];
        if (!authOperation) continue;
        if (typeof supabaseClientInstance.auth.admin[operation] === "function") supabaseClientInstance.auth.admin[operation] = $61659e8eeb6b234d$var$instrumentAuthOperation(authOperation, true);
    }
    $61659e8eeb6b234d$var$markAsInstrumented(supabaseClientInstance.auth);
}
function $61659e8eeb6b234d$var$instrumentSupabaseClientConstructor(SupabaseClient, _options) {
    if ($61659e8eeb6b234d$var$isInstrumented(SupabaseClient.prototype.from)) return;
    SupabaseClient.prototype.from = new Proxy(SupabaseClient.prototype.from, {
        apply (target, thisArg, argumentsList) {
            const rv = Reflect.apply(target, thisArg, argumentsList);
            const PostgRESTQueryBuilder = rv.constructor;
            $61659e8eeb6b234d$var$instrumentPostgRESTQueryBuilder(PostgRESTQueryBuilder, _options);
            return rv;
        }
    });
    $61659e8eeb6b234d$var$markAsInstrumented(SupabaseClient.prototype.from);
}
function $61659e8eeb6b234d$var$instrumentPostgRESTFilterBuilder(PostgRESTFilterBuilder, _options) {
    if ($61659e8eeb6b234d$var$isInstrumented(PostgRESTFilterBuilder.prototype.then)) return;
    PostgRESTFilterBuilder.prototype.then = new Proxy(PostgRESTFilterBuilder.prototype.then, {
        apply (target, thisArg, argumentsList) {
            const operations = $61659e8eeb6b234d$var$DB_OPERATIONS_TO_INSTRUMENT;
            const typedThis = thisArg;
            const operation = $61659e8eeb6b234d$var$extractOperation(typedThis.method, typedThis.headers);
            if (!operations.includes(operation)) return Reflect.apply(target, thisArg, argumentsList);
            if (!typedThis?.url?.pathname || typeof typedThis.url.pathname !== "string") return Reflect.apply(target, thisArg, argumentsList);
            const pathParts = typedThis.url.pathname.split("/");
            const table = pathParts.length > 0 ? pathParts[pathParts.length - 1] : "";
            const queryItems = [];
            for (const [key, value] of typedThis.url.searchParams.entries())queryItems.push($61659e8eeb6b234d$var$translateFiltersIntoMethods(key, value));
            const body = /* @__PURE__ */ Object.create(null);
            if ($dzfKZ.isPlainObject(typedThis.body)) for (const [key, value] of Object.entries(typedThis.body))body[key] = value;
            const client = $79m2C.getClient();
            const shouldSendData = _options.sendOperationData ?? client?.getDataCollectionOptions().databaseQueryData === true;
            const bodyPayload = $61659e8eeb6b234d$var$getMutationBodyPayloadForTelemetry(typedThis.body, body);
            const mutationPart = operation === "select" ? "" : `${operation}${$61659e8eeb6b234d$var$hasMutationBodyForDescription(typedThis.body, body) ? "(...) " : ""}`;
            const queryPart = shouldSendData ? queryItems.join(" ") : queryItems.length > 0 ? "[redacted]" : "";
            const descriptionMiddle = [
                mutationPart.trimEnd(),
                queryPart
            ].filter(Boolean).join(" ");
            const description = descriptionMiddle ? `${descriptionMiddle} from(${table})` : `from(${table})`;
            const attributes = {
                "db.table": table,
                "db.schema": typedThis.schema,
                "db.url": typedThis.url.origin,
                "db.sdk": typedThis.headers["X-Client-Info"],
                "db.system": "postgresql",
                "db.operation": operation,
                [$gTasE.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: "auto.db.supabase",
                [$gTasE.SEMANTIC_ATTRIBUTE_SENTRY_OP]: "db"
            };
            if (queryItems.length && shouldSendData) attributes["db.query"] = queryItems;
            if (bodyPayload !== void 0 && shouldSendData) attributes["db.body"] = bodyPayload;
            return $kBDP8.startSpan({
                name: description,
                attributes: attributes
            }, (span)=>{
                return Reflect.apply(target, thisArg, []).then((res)=>{
                    if (span) {
                        if (res && typeof res === "object" && "status" in res) $yI1C9.setHttpStatus(span, res.status || 500);
                        span.end();
                    }
                    if (res?.error) {
                        const err = new Error(res.error.message);
                        if (res.error.code) err.code = res.error.code;
                        if (res.error.details) err.details = res.error.details;
                        const supabaseContext = {};
                        if (queryItems.length && shouldSendData) supabaseContext.query = queryItems;
                        if (bodyPayload !== void 0 && shouldSendData) supabaseContext.body = bodyPayload;
                        $1tl8I.captureException(err, (scope)=>{
                            scope.addEventProcessor((e)=>{
                                $6JkyB.addExceptionMechanism(e, {
                                    handled: false,
                                    type: "auto.db.supabase.postgres"
                                });
                                return e;
                            });
                            scope.setContext("supabase", supabaseContext);
                            return scope;
                        });
                    }
                    const breadcrumb = {
                        type: "supabase",
                        category: `db.${operation}`,
                        message: description
                    };
                    const data = {};
                    if (queryItems.length && shouldSendData) data.query = queryItems;
                    if (bodyPayload !== void 0 && shouldSendData) data.body = bodyPayload;
                    if (Object.keys(data).length) breadcrumb.data = data;
                    $7ZoMM.addBreadcrumb(breadcrumb);
                    return res;
                }, (err)=>{
                    if (span) {
                        $yI1C9.setHttpStatus(span, 500);
                        span.end();
                    }
                    throw err;
                }).then(...argumentsList);
            });
        }
    });
    $61659e8eeb6b234d$var$markAsInstrumented(PostgRESTFilterBuilder.prototype.then);
}
function $61659e8eeb6b234d$var$instrumentPostgRESTQueryBuilder(PostgRESTQueryBuilder, _options) {
    for (const operation of $61659e8eeb6b234d$var$DB_OPERATIONS_TO_INSTRUMENT){
        if ($61659e8eeb6b234d$var$isInstrumented(PostgRESTQueryBuilder.prototype[operation])) continue;
        PostgRESTQueryBuilder.prototype[operation] = new Proxy(PostgRESTQueryBuilder.prototype[operation], {
            apply (target, thisArg, argumentsList) {
                const rv = Reflect.apply(target, thisArg, argumentsList);
                const PostgRESTFilterBuilder = rv.constructor;
                $hiZR1.DEBUG_BUILD && $4gyod.debug.log(`Instrumenting ${operation} operation's PostgRESTFilterBuilder`);
                $61659e8eeb6b234d$var$instrumentPostgRESTFilterBuilder(PostgRESTFilterBuilder, _options);
                return rv;
            }
        });
        $61659e8eeb6b234d$var$markAsInstrumented(PostgRESTQueryBuilder.prototype[operation]);
    }
}
const $61659e8eeb6b234d$var$instrumentSupabaseClient = (supabaseClient, options = {})=>{
    if (!supabaseClient) {
        $hiZR1.DEBUG_BUILD && $4gyod.debug.warn("Supabase integration was not installed because no Supabase client was provided.");
        return;
    }
    const SupabaseClientConstructor = supabaseClient.constructor === Function ? supabaseClient : supabaseClient.constructor;
    $61659e8eeb6b234d$var$instrumentSupabaseClientConstructor(SupabaseClientConstructor, options);
    $61659e8eeb6b234d$var$instrumentSupabaseAuthClient(supabaseClient);
};
const $61659e8eeb6b234d$var$INTEGRATION_NAME = "Supabase";
const $61659e8eeb6b234d$var$_supabaseIntegration = (supabaseClient, options)=>{
    return {
        setupOnce () {
            $61659e8eeb6b234d$var$instrumentSupabaseClient(supabaseClient, options);
        },
        name: $61659e8eeb6b234d$var$INTEGRATION_NAME
    };
};
const $61659e8eeb6b234d$var$supabaseIntegration = $g33UP.defineIntegration((options)=>{
    return $61659e8eeb6b234d$var$_supabaseIntegration(options.supabaseClient, {
        sendOperationData: options.sendOperationData
    });
});
module.exports.DB_OPERATIONS_TO_INSTRUMENT = $61659e8eeb6b234d$var$DB_OPERATIONS_TO_INSTRUMENT;
module.exports.FILTER_MAPPINGS = $61659e8eeb6b234d$var$FILTER_MAPPINGS;
module.exports.extractOperation = $61659e8eeb6b234d$var$extractOperation;
module.exports.instrumentSupabaseClient = $61659e8eeb6b234d$var$instrumentSupabaseClient;
module.exports.supabaseIntegration = $61659e8eeb6b234d$var$supabaseIntegration;
module.exports.translateFiltersIntoMethods = $61659e8eeb6b234d$var$translateFiltersIntoMethods;

});

parcelRegister("cvcY5", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $g33UP = parcelRequire("g33UP");

var $dzfKZ = parcelRequire("dzfKZ");

var $arYVC = parcelRequire("arYVC");
const $91a2707b3b31f8aa$var$DEFAULT_LIMIT = 10;
const $91a2707b3b31f8aa$var$INTEGRATION_NAME = "ZodErrors";
function $91a2707b3b31f8aa$var$originalExceptionIsZodError(originalException) {
    return $dzfKZ.isError(originalException) && originalException.name === "ZodError" && Array.isArray(originalException.issues);
}
function $91a2707b3b31f8aa$var$flattenIssue(issue) {
    return {
        ...issue,
        path: "path" in issue && Array.isArray(issue.path) ? issue.path.join(".") : void 0,
        keys: "keys" in issue ? JSON.stringify(issue.keys) : void 0,
        unionErrors: "unionErrors" in issue ? JSON.stringify(issue.unionErrors) : void 0
    };
}
function $91a2707b3b31f8aa$var$flattenIssuePath(path) {
    return path.map((p)=>{
        if (typeof p === "number") return "<array>";
        else return p;
    }).join(".");
}
function $91a2707b3b31f8aa$var$formatIssueMessage(zodError) {
    const errorKeyMap = /* @__PURE__ */ new Set();
    for (const iss of zodError.issues){
        const issuePath = $91a2707b3b31f8aa$var$flattenIssuePath(iss.path);
        if (issuePath.length > 0) errorKeyMap.add(issuePath);
    }
    const errorKeys = Array.from(errorKeyMap);
    if (errorKeys.length === 0) {
        let rootExpectedType = "variable";
        if (zodError.issues.length > 0) {
            const iss = zodError.issues[0];
            if (iss !== void 0 && "expected" in iss && typeof iss.expected === "string") rootExpectedType = iss.expected;
        }
        return `Failed to validate ${rootExpectedType}`;
    }
    return `Failed to validate keys: ${$arYVC.truncate(errorKeys.join(", "), 100)}`;
}
function $91a2707b3b31f8aa$var$applyZodErrorsToEvent(limit, saveZodIssuesAsAttachment = false, event, hint) {
    if (!event.exception?.values || !hint.originalException || !$91a2707b3b31f8aa$var$originalExceptionIsZodError(hint.originalException) || hint.originalException.issues.length === 0) return event;
    try {
        const issuesToFlatten = saveZodIssuesAsAttachment ? hint.originalException.issues : hint.originalException.issues.slice(0, limit);
        const flattenedIssues = issuesToFlatten.map($91a2707b3b31f8aa$var$flattenIssue);
        if (saveZodIssuesAsAttachment) {
            if (!Array.isArray(hint.attachments)) hint.attachments = [];
            hint.attachments.push({
                filename: "zod_issues.json",
                data: JSON.stringify({
                    issues: flattenedIssues
                })
            });
        }
        return {
            ...event,
            exception: {
                ...event.exception,
                values: [
                    {
                        ...event.exception.values[0],
                        value: $91a2707b3b31f8aa$var$formatIssueMessage(hint.originalException)
                    },
                    ...event.exception.values.slice(1)
                ]
            },
            extra: {
                ...event.extra,
                "zoderror.issues": flattenedIssues.slice(0, limit)
            }
        };
    } catch (e) {
        return {
            ...event,
            extra: {
                ...event.extra,
                "zoderrors sentry integration parse error": {
                    message: "an exception was thrown while processing ZodError within applyZodErrorsToEvent()",
                    error: e instanceof Error ? `${e.name}: ${e.message}
${e.stack}` : "unknown"
                }
            }
        };
    }
}
const $91a2707b3b31f8aa$var$_zodErrorsIntegration = (options = {})=>{
    const limit = options.limit ?? $91a2707b3b31f8aa$var$DEFAULT_LIMIT;
    return {
        name: $91a2707b3b31f8aa$var$INTEGRATION_NAME,
        processEvent (originalEvent, hint) {
            const processedEvent = $91a2707b3b31f8aa$var$applyZodErrorsToEvent(limit, options.saveZodIssuesAsAttachment, originalEvent, hint);
            return processedEvent;
        }
    };
};
const $91a2707b3b31f8aa$var$zodErrorsIntegration = $g33UP.defineIntegration($91a2707b3b31f8aa$var$_zodErrorsIntegration);
module.exports.applyZodErrorsToEvent = $91a2707b3b31f8aa$var$applyZodErrorsToEvent;
module.exports.flattenIssue = $91a2707b3b31f8aa$var$flattenIssue;
module.exports.flattenIssuePath = $91a2707b3b31f8aa$var$flattenIssuePath;
module.exports.formatIssueMessage = $91a2707b3b31f8aa$var$formatIssueMessage;
module.exports.zodErrorsIntegration = $91a2707b3b31f8aa$var$zodErrorsIntegration;

});

parcelRegister("gzBJP", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $g33UP = parcelRequire("g33UP");

var $318WW = parcelRequire("318WW");

var $636GJ = parcelRequire("636GJ");

var $d7glj = parcelRequire("d7glj");

var $eP8Ri = parcelRequire("eP8Ri");
const $c10d303939cc62f6$var$thirdPartyErrorFilterIntegration = $g33UP.defineIntegration((options)=>{
    return {
        name: "ThirdPartyErrorsFilter",
        setup (client) {
            client.on("beforeEnvelope", (envelope$1)=>{
                $636GJ.forEachEnvelopeItem(envelope$1, (item, type)=>{
                    if (type === "event") {
                        const event = Array.isArray(item) ? item[1] : void 0;
                        if (event) {
                            $318WW.stripMetadataFromStackFrames(event);
                            item[1] = event;
                        }
                    }
                });
            });
            client.on("applyFrameMetadata", (event)=>{
                if (event.type) return;
                const stackParser = client.getOptions().stackParser;
                $318WW.addMetadataToStackFrames(stackParser, event);
            });
        },
        preprocessEvent (event) {
            if (options.ignoreSentryInternalFrames && ($eP8Ri.GLOBAL_OBJ._sentryWrappedDepth ?? 0) > 0) event.sdkProcessingMetadata = {
                ...event.sdkProcessingMetadata,
                insideSentryWrapped: true
            };
        },
        processEvent (event) {
            const insideSentryWrapped = options.ignoreSentryInternalFrames ? event.sdkProcessingMetadata?.insideSentryWrapped === true && event.exception?.values?.length === 1 : false;
            const frameKeys = $c10d303939cc62f6$var$getBundleKeysForAllFramesWithFilenames(event, options.ignoreSentryInternalFrames, insideSentryWrapped);
            if (frameKeys) {
                const arrayMethod = options.behaviour === "drop-error-if-contains-third-party-frames" || options.behaviour === "apply-tag-if-contains-third-party-frames" ? "some" : "every";
                const behaviourApplies = frameKeys[arrayMethod]((keys)=>!keys.some((key)=>options.filterKeys.includes(key)));
                if (behaviourApplies) {
                    const shouldDrop = options.behaviour === "drop-error-if-contains-third-party-frames" || options.behaviour === "drop-error-if-exclusively-contains-third-party-frames";
                    if (shouldDrop) return null;
                    else event.tags = {
                        ...event.tags,
                        third_party_code: true
                    };
                }
            }
            return event;
        }
    };
});
function $c10d303939cc62f6$var$isSentryInternalFrame(frame, frameIndex, insideSentryWrapped) {
    if (frameIndex !== 0) return false;
    if (insideSentryWrapped && $c10d303939cc62f6$var$isLikelyMinifiedSentryWrappedFrame(frame)) return true;
    if (frame.function === "sentryWrapped") return true;
    if (!frame.context_line || !frame.filename) return false;
    if (!frame.filename.includes("sentry") || !frame.filename.includes("helpers") || // Filename would look something like this: 'node_modules/@sentry/browser/build/npm/esm/helpers.js'
    !frame.context_line.includes($c10d303939cc62f6$var$SENTRY_INTERNAL_FN_APPLY)) return false;
    if (frame.pre_context) {
        const len = frame.pre_context.length;
        for(let i = 0; i < len; i++){
            if (frame.pre_context[i]?.includes($c10d303939cc62f6$var$SENTRY_INTERNAL_COMMENT)) return true;
        }
    }
    return false;
}
function $c10d303939cc62f6$var$getBundleKeysForAllFramesWithFilenames(event, ignoreSentryInternalFrames, insideSentryWrapped) {
    const frames = $d7glj.getFramesFromEvent(event);
    if (!frames) return void 0;
    return frames.filter((frame, index)=>{
        if (!frame.filename) return false;
        if (frame.lineno == null && frame.colno == null && frame.instruction_addr == null) return false;
        return !ignoreSentryInternalFrames || !$c10d303939cc62f6$var$isSentryInternalFrame(frame, index, !!insideSentryWrapped);
    }).map((frame)=>{
        if (!frame.module_metadata) return [];
        return Object.keys(frame.module_metadata).filter((key)=>key.startsWith($c10d303939cc62f6$var$BUNDLER_PLUGIN_APP_KEY_PREFIX)).map((key)=>key.slice($c10d303939cc62f6$var$BUNDLER_PLUGIN_APP_KEY_PREFIX.length));
    });
}
function $c10d303939cc62f6$var$isLikelyMinifiedSentryWrappedFrame(frame) {
    return !frame.context_line && !frame.pre_context && !!frame.function && frame.function.length <= 2;
}
const $c10d303939cc62f6$var$BUNDLER_PLUGIN_APP_KEY_PREFIX = "_sentryBundlerPluginAppKey:";
const $c10d303939cc62f6$var$SENTRY_INTERNAL_COMMENT = "Attempt to invoke user-land function";
const $c10d303939cc62f6$var$SENTRY_INTERNAL_FN_APPLY = "fn.apply(this, wrappedArguments)";
module.exports.thirdPartyErrorFilterIntegration = $c10d303939cc62f6$var$thirdPartyErrorFilterIntegration;

});

parcelRegister("jnFoQ", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $7ZoMM = parcelRequire("7ZoMM");

var $79m2C = parcelRequire("79m2C");

var $8mzKS = parcelRequire("8mzKS");

var $g33UP = parcelRequire("g33UP");

var $4gyod = parcelRequire("4gyod");

var $1VSHh = parcelRequire("1VSHh");

var $arYVC = parcelRequire("arYVC");

var $eP8Ri = parcelRequire("eP8Ri");
const $e1c0476a0254c472$var$INTEGRATION_NAME = "Console";
const $e1c0476a0254c472$var$consoleIntegration = $g33UP.defineIntegration((options = {})=>{
    const levels = new Set(options.levels || $4gyod.CONSOLE_LEVELS);
    return {
        name: $e1c0476a0254c472$var$INTEGRATION_NAME,
        setup (client) {
            const unsubscribe = $8mzKS.addConsoleInstrumentationHandler(({ args: args, level: level })=>{
                if ($79m2C.getClient() !== client || !levels.has(level)) return;
                $e1c0476a0254c472$var$addConsoleBreadcrumb(level, args);
            });
            client.registerCleanup(unsubscribe);
            if (options.filter) {
                const unsubscribe2 = $8mzKS.addConsoleInstrumentationFilter(options.filter);
                client.registerCleanup(unsubscribe2);
            }
        }
    };
});
function $e1c0476a0254c472$var$addConsoleBreadcrumb(level, args) {
    const breadcrumb = {
        category: "console",
        data: {
            arguments: args,
            logger: "console"
        },
        level: $1VSHh.severityLevelFromString(level),
        message: $e1c0476a0254c472$var$formatConsoleArgs(args)
    };
    if (level === "assert") {
        if (args[0] === false) {
            const assertionArgs = args.slice(1);
            breadcrumb.message = assertionArgs.length > 0 ? `Assertion failed: ${$e1c0476a0254c472$var$formatConsoleArgs(assertionArgs)}` : "Assertion failed";
            breadcrumb.data.arguments = assertionArgs;
        } else return;
    }
    $7ZoMM.addBreadcrumb(breadcrumb, {
        input: args,
        level: level
    });
}
function $e1c0476a0254c472$var$formatConsoleArgs(values) {
    return "util" in $eP8Ri.GLOBAL_OBJ && typeof $eP8Ri.GLOBAL_OBJ.util.format === "function" ? $eP8Ri.GLOBAL_OBJ.util.format(...values) : $arYVC.safeJoin(values, " ");
}
module.exports.addConsoleBreadcrumb = $e1c0476a0254c472$var$addConsoleBreadcrumb;
module.exports.consoleIntegration = $e1c0476a0254c472$var$consoleIntegration;

});

parcelRegister("4qll8", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $g33UP = parcelRequire("g33UP");

var $5EpvI = parcelRequire("5EpvI");
const $338a24ca2de17b8e$var$featureFlagsIntegration = $g33UP.defineIntegration(()=>{
    return {
        name: "FeatureFlags",
        processEvent (event, _hint, _client) {
            return $5EpvI._INTERNAL_copyFlagsFromScopeToEvent(event);
        },
        addFeatureFlag (name, value) {
            $5EpvI._INTERNAL_insertFlagToScope(name, value);
            $5EpvI._INTERNAL_addFeatureFlagToActiveSpan(name, value);
        }
    };
});
module.exports.featureFlagsIntegration = $338a24ca2de17b8e$var$featureFlagsIntegration;

});
parcelRegister("5EpvI", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $79m2C = parcelRequire("79m2C");

var $hiZR1 = parcelRequire("hiZR1");

var $4gyod = parcelRequire("4gyod");

var $8jbnX = parcelRequire("8jbnX");
const $41d47a04a308fad3$var$_INTERNAL_FLAG_BUFFER_SIZE = 100;
const $41d47a04a308fad3$var$_INTERNAL_MAX_FLAGS_PER_SPAN = 10;
const $41d47a04a308fad3$var$SPAN_FLAG_ATTRIBUTE_PREFIX = "flag.evaluation.";
function $41d47a04a308fad3$var$_INTERNAL_copyFlagsFromScopeToEvent(event) {
    if (event.type) return event;
    const scope = $79m2C.getCurrentScope();
    const flagContext = scope.getScopeData().contexts.flags;
    const flagBuffer = flagContext ? flagContext.values : [];
    if (!flagBuffer.length) return event;
    if (event.contexts === void 0) event.contexts = {};
    event.contexts.flags = {
        values: [
            ...flagBuffer
        ]
    };
    return event;
}
function $41d47a04a308fad3$var$_INTERNAL_insertFlagToScope(name, value, maxSize = $41d47a04a308fad3$var$_INTERNAL_FLAG_BUFFER_SIZE) {
    const scopeContexts = $79m2C.getCurrentScope().getScopeData().contexts;
    if (!scopeContexts.flags) scopeContexts.flags = {
        values: []
    };
    const flags = scopeContexts.flags.values;
    $41d47a04a308fad3$var$_INTERNAL_insertToFlagBuffer(flags, name, value, maxSize);
}
function $41d47a04a308fad3$var$_INTERNAL_insertToFlagBuffer(flags, name, value, maxSize) {
    if (typeof value !== "boolean") return;
    if (flags.length > maxSize) {
        $hiZR1.DEBUG_BUILD && $4gyod.debug.error(`[Feature Flags] insertToFlagBuffer called on a buffer larger than maxSize=${maxSize}`);
        return;
    }
    const index = flags.findIndex((f)=>f.flag === name);
    if (index !== -1) flags.splice(index, 1);
    if (flags.length === maxSize) flags.shift();
    flags.push({
        flag: name,
        result: value
    });
}
function $41d47a04a308fad3$var$_INTERNAL_addFeatureFlagToActiveSpan(name, value, maxFlagsPerSpan = $41d47a04a308fad3$var$_INTERNAL_MAX_FLAGS_PER_SPAN) {
    if (typeof value !== "boolean") return;
    const span = $8jbnX.getActiveSpan();
    if (!span) return;
    const attributes = $8jbnX.spanToJSON(span).data;
    if (`${$41d47a04a308fad3$var$SPAN_FLAG_ATTRIBUTE_PREFIX}${name}` in attributes) {
        span.setAttribute(`${$41d47a04a308fad3$var$SPAN_FLAG_ATTRIBUTE_PREFIX}${name}`, value);
        return;
    }
    const numOfAddedFlags = Object.keys(attributes).filter((key)=>key.startsWith($41d47a04a308fad3$var$SPAN_FLAG_ATTRIBUTE_PREFIX)).length;
    if (numOfAddedFlags < maxFlagsPerSpan) span.setAttribute(`${$41d47a04a308fad3$var$SPAN_FLAG_ATTRIBUTE_PREFIX}${name}`, value);
}
module.exports._INTERNAL_FLAG_BUFFER_SIZE = $41d47a04a308fad3$var$_INTERNAL_FLAG_BUFFER_SIZE;
module.exports._INTERNAL_MAX_FLAGS_PER_SPAN = $41d47a04a308fad3$var$_INTERNAL_MAX_FLAGS_PER_SPAN;
module.exports._INTERNAL_addFeatureFlagToActiveSpan = $41d47a04a308fad3$var$_INTERNAL_addFeatureFlagToActiveSpan;
module.exports._INTERNAL_copyFlagsFromScopeToEvent = $41d47a04a308fad3$var$_INTERNAL_copyFlagsFromScopeToEvent;
module.exports._INTERNAL_insertFlagToScope = $41d47a04a308fad3$var$_INTERNAL_insertFlagToScope;
module.exports._INTERNAL_insertToFlagBuffer = $41d47a04a308fad3$var$_INTERNAL_insertToFlagBuffer;

});


parcelRegister("dpTK0", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $g33UP = parcelRequire("g33UP");

var $5EpvI = parcelRequire("5EpvI");

var $7OVjx = parcelRequire("7OVjx");
const $9c48d92f9568e87d$var$growthbookIntegration = $g33UP.defineIntegration(({ growthbookClass: growthbookClass })=>{
    return {
        name: "GrowthBook",
        setupOnce () {
            const proto = growthbookClass.prototype;
            if (typeof proto.isOn === "function") $7OVjx.fill(proto, "isOn", $9c48d92f9568e87d$var$_wrapAndCaptureBooleanResult);
            if (typeof proto.getFeatureValue === "function") $7OVjx.fill(proto, "getFeatureValue", $9c48d92f9568e87d$var$_wrapAndCaptureBooleanResult);
        },
        processEvent (event, _hint, _client) {
            return $5EpvI._INTERNAL_copyFlagsFromScopeToEvent(event);
        }
    };
});
function $9c48d92f9568e87d$var$_wrapAndCaptureBooleanResult(original) {
    return function(...args) {
        const flagName = args[0];
        const result = original.apply(this, args);
        if (typeof flagName === "string" && typeof result === "boolean") {
            $5EpvI._INTERNAL_insertFlagToScope(flagName, result);
            $5EpvI._INTERNAL_addFeatureFlagToActiveSpan(flagName, result);
        }
        return result;
    };
}
module.exports.growthbookIntegration = $9c48d92f9568e87d$var$growthbookIntegration;

});

parcelRegister("8fRJG", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $79m2C = parcelRequire("79m2C");

var $g33UP = parcelRequire("g33UP");

var $gTasE = parcelRequire("gTasE");

var $8jbnX = parcelRequire("8jbnX");
const $602968418be91f2d$var$INTEGRATION_NAME = "ConversationId";
const $602968418be91f2d$var$_conversationIdIntegration = ()=>{
    return {
        name: $602968418be91f2d$var$INTEGRATION_NAME,
        setup (client) {
            client.on("spanStart", (span)=>{
                const scopeData = $79m2C.getCurrentScope().getScopeData();
                const isolationScopeData = $79m2C.getIsolationScope().getScopeData();
                const conversationId = scopeData.conversationId || isolationScopeData.conversationId;
                if (conversationId) {
                    const { op: op, data: attributes, description: name } = $8jbnX.spanToJSON(span);
                    if (!op?.startsWith("gen_ai.") && !attributes["ai.operationId"] && !name?.startsWith("ai.")) return;
                    span.setAttribute($gTasE.GEN_AI_CONVERSATION_ID_ATTRIBUTE, conversationId);
                }
            });
        }
    };
};
const $602968418be91f2d$var$conversationIdIntegration = $g33UP.defineIntegration($602968418be91f2d$var$_conversationIdIntegration);
module.exports.conversationIdIntegration = $602968418be91f2d$var$conversationIdIntegration;

});

parcelRegister("8vWe2", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $79m2C = parcelRequire("79m2C");

var $hiZR1 = parcelRequire("hiZR1");

var $4gyod = parcelRequire("4gyod");
function $632e625685374031$var$isProfilingIntegrationWithProfiler(integration) {
    return !!integration && typeof integration["_profiler"] !== "undefined" && typeof integration["_profiler"]["start"] === "function" && typeof integration["_profiler"]["stop"] === "function";
}
function $632e625685374031$var$startProfiler() {
    const client = $79m2C.getClient();
    if (!client) {
        $hiZR1.DEBUG_BUILD && $4gyod.debug.warn("No Sentry client available, profiling is not started");
        return;
    }
    const integration = client.getIntegrationByName("ProfilingIntegration");
    if (!integration) {
        $hiZR1.DEBUG_BUILD && $4gyod.debug.warn("ProfilingIntegration is not available");
        return;
    }
    if (!$632e625685374031$var$isProfilingIntegrationWithProfiler(integration)) {
        $hiZR1.DEBUG_BUILD && $4gyod.debug.warn("Profiler is not available on profiling integration.");
        return;
    }
    integration._profiler.start();
}
function $632e625685374031$var$stopProfiler() {
    const client = $79m2C.getClient();
    if (!client) {
        $hiZR1.DEBUG_BUILD && $4gyod.debug.warn("No Sentry client available, profiling is not started");
        return;
    }
    const integration = client.getIntegrationByName("ProfilingIntegration");
    if (!integration) {
        $hiZR1.DEBUG_BUILD && $4gyod.debug.warn("ProfilingIntegration is not available");
        return;
    }
    if (!$632e625685374031$var$isProfilingIntegrationWithProfiler(integration)) {
        $hiZR1.DEBUG_BUILD && $4gyod.debug.warn("Profiler is not available on profiling integration.");
        return;
    }
    integration._profiler.stop();
}
const $632e625685374031$var$profiler = {
    startProfiler: $632e625685374031$var$startProfiler,
    stopProfiler: $632e625685374031$var$stopProfiler
};
module.exports.profiler = $632e625685374031$var$profiler;

});

parcelRegister("6e3bz", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $79m2C = parcelRequire("79m2C");

var $gTasE = parcelRequire("gTasE");

var $8jbnX = parcelRequire("8jbnX");

var $yI1C9 = parcelRequire("yI1C9");

var $dzfKZ = parcelRequire("dzfKZ");

var $6emr7 = parcelRequire("6emr7");

var $boFM9 = parcelRequire("boFM9");

var $l5MWU = parcelRequire("l5MWU");

var $8ICT0 = parcelRequire("8ICT0");

var $kBDP8 = parcelRequire("kBDP8");

var $7DICZ = parcelRequire("7DICZ");

var $hLsvb = parcelRequire("hLsvb");
function $4886857bd3eff57a$var$instrumentFetchRequest(handlerData, shouldCreateSpan, shouldAttachHeaders, spans, spanOriginOrOptions) {
    if (!handlerData.fetchData) return void 0;
    const { method: method, url: url } = handlerData.fetchData;
    const shouldCreateSpanResult = $6emr7.hasSpansEnabled() && shouldCreateSpan(url);
    if (handlerData.endTimestamp) {
        const spanId = handlerData.fetchData.__span;
        if (!spanId) return;
        const span2 = spans[spanId];
        if (span2) {
            if (shouldCreateSpanResult) {
                $4886857bd3eff57a$var$endSpan(span2, handlerData);
                $4886857bd3eff57a$var$_callOnRequestSpanEnd(span2, handlerData, spanOriginOrOptions);
            }
            delete spans[spanId];
        }
        return void 0;
    }
    const { spanOrigin: spanOrigin = "auto.http.browser", propagateTraceparent: propagateTraceparent = false } = typeof spanOriginOrOptions === "object" ? spanOriginOrOptions : {
        spanOrigin: spanOriginOrOptions
    };
    const client = $79m2C.getClient();
    const hasParent = !!$8jbnX.getActiveSpan();
    const shouldEmitSpan = hasParent || !!client && $8ICT0.hasSpanStreamingEnabled(client);
    const span = shouldCreateSpanResult && shouldEmitSpan ? $kBDP8.startInactiveSpan($4886857bd3eff57a$var$getSpanStartOptions(url, method, spanOrigin)) : new $boFM9.SentryNonRecordingSpan();
    const spanForTraceHeaders = $kBDP8.spanIsIgnored(span) && hasParent ? void 0 : span;
    if (shouldCreateSpanResult && !shouldEmitSpan) client?.recordDroppedEvent("no_parent_span", "span");
    handlerData.fetchData.__span = span.spanContext().spanId;
    spans[span.spanContext().spanId] = span;
    if (shouldAttachHeaders(handlerData.fetchData.url)) {
        const request = handlerData.args[0];
        const options = {
            ...handlerData.args[1] || {}
        };
        const headers = $4886857bd3eff57a$var$_INTERNAL_getTracingHeadersForFetchRequest(request, options, // If performance is disabled (TWP) or there's no active root span (pageload/navigation/interaction),
        // we do not want to use the span as base for the trace headers,
        // which means that the headers will be generated from the scope and the sampling decision is deferred
        $6emr7.hasSpansEnabled() && shouldEmitSpan ? spanForTraceHeaders : void 0, propagateTraceparent);
        if (headers) {
            handlerData.args[1] = options;
            options.headers = headers;
        }
    }
    if (client) {
        const fetchHint = {
            input: handlerData.args,
            response: handlerData.response,
            startTimestamp: handlerData.startTimestamp,
            endTimestamp: handlerData.endTimestamp
        };
        client.emit("beforeOutgoingRequestSpan", span, fetchHint);
    }
    return span;
}
function $4886857bd3eff57a$var$_callOnRequestSpanEnd(span, handlerData, spanOriginOrOptions) {
    const onRequestSpanEnd = typeof spanOriginOrOptions === "object" && spanOriginOrOptions !== null ? spanOriginOrOptions.onRequestSpanEnd : void 0;
    onRequestSpanEnd?.(span, {
        headers: handlerData.response?.headers,
        error: handlerData.error
    });
}
function $4886857bd3eff57a$var$_INTERNAL_getTracingHeadersForFetchRequest(request, fetchOptionsObj, span, propagateTraceparent) {
    const traceHeaders = $7DICZ.getTraceData({
        span: span,
        propagateTraceparent: propagateTraceparent
    });
    const sentryTrace = traceHeaders["sentry-trace"];
    const baggage = traceHeaders.baggage;
    const traceparent = traceHeaders.traceparent;
    if (!sentryTrace) return void 0;
    const originalHeaders = fetchOptionsObj.headers || ($dzfKZ.isRequest(request) ? request.headers : void 0);
    if (!originalHeaders) return {
        ...traceHeaders
    };
    else if ($4886857bd3eff57a$var$isHeaders(originalHeaders)) {
        const newHeaders = new Headers(originalHeaders);
        if (!newHeaders.get("sentry-trace")) newHeaders.set("sentry-trace", sentryTrace);
        if (propagateTraceparent && traceparent && !newHeaders.get("traceparent")) newHeaders.set("traceparent", traceparent);
        if (baggage) {
            const prevBaggageHeader = newHeaders.get("baggage");
            if (!prevBaggageHeader) newHeaders.set("baggage", baggage);
            else if (!$4886857bd3eff57a$var$baggageHeaderHasSentryBaggageValues(prevBaggageHeader)) newHeaders.set("baggage", `${prevBaggageHeader},${baggage}`);
        }
        return newHeaders;
    } else if ($4886857bd3eff57a$var$isHeadersInitTupleArray(originalHeaders)) {
        const newHeaders = [
            ...originalHeaders
        ];
        if (!newHeaders.find((header)=>header[0] === "sentry-trace")) newHeaders.push([
            "sentry-trace",
            sentryTrace
        ]);
        if (propagateTraceparent && traceparent && !newHeaders.find((header)=>header[0] === "traceparent")) newHeaders.push([
            "traceparent",
            traceparent
        ]);
        const prevBaggageHeaderWithSentryValues = originalHeaders.find((header)=>header[0] === "baggage" && typeof header[1] === "string" && $4886857bd3eff57a$var$baggageHeaderHasSentryBaggageValues(header[1]));
        if (baggage && !prevBaggageHeaderWithSentryValues) newHeaders.push([
            "baggage",
            baggage
        ]);
        return newHeaders;
    } else {
        const existingSentryTraceHeader = "sentry-trace" in originalHeaders ? originalHeaders["sentry-trace"] : void 0;
        const existingTraceparentHeader = "traceparent" in originalHeaders ? originalHeaders.traceparent : void 0;
        const existingBaggageHeader = "baggage" in originalHeaders ? originalHeaders.baggage : void 0;
        const newBaggageHeaders = existingBaggageHeader ? Array.isArray(existingBaggageHeader) ? [
            ...existingBaggageHeader
        ] : [
            existingBaggageHeader
        ] : [];
        const prevBaggageHeaderWithSentryValues = existingBaggageHeader && (Array.isArray(existingBaggageHeader) ? existingBaggageHeader.find((headerItem)=>$4886857bd3eff57a$var$baggageHeaderHasSentryBaggageValues(headerItem)) : $4886857bd3eff57a$var$baggageHeaderHasSentryBaggageValues(existingBaggageHeader));
        if (baggage && !prevBaggageHeaderWithSentryValues) newBaggageHeaders.push(baggage);
        const newHeaders = Object.assign({}, originalHeaders, {
            "sentry-trace": existingSentryTraceHeader ?? sentryTrace,
            baggage: newBaggageHeaders.length > 0 ? newBaggageHeaders.join(",") : void 0
        });
        if (propagateTraceparent && traceparent && !existingTraceparentHeader) newHeaders.traceparent = traceparent;
        return newHeaders;
    }
}
function $4886857bd3eff57a$var$endSpan(span, handlerData) {
    if (handlerData.response) {
        $yI1C9.setHttpStatus(span, handlerData.response.status);
        const contentLength = handlerData.response?.headers?.get("content-length");
        if (contentLength) {
            const contentLengthNum = parseInt(contentLength);
            if (contentLengthNum > 0) span.setAttribute("http.response_content_length", contentLengthNum);
        }
    } else if (handlerData.error) span.setStatus({
        code: $yI1C9.SPAN_STATUS_ERROR,
        message: "internal_error"
    });
    span.end();
}
function $4886857bd3eff57a$var$baggageHeaderHasSentryBaggageValues(baggageHeader) {
    if (typeof baggageHeader !== "string") return false;
    return baggageHeader.split(",").some((baggageEntry)=>baggageEntry.trim().startsWith($l5MWU.SENTRY_BAGGAGE_KEY_PREFIX));
}
function $4886857bd3eff57a$var$isHeaders(headers) {
    return typeof Headers !== "undefined" && $dzfKZ.isInstanceOf(headers, Headers);
}
function $4886857bd3eff57a$var$isHeadersInitTupleArray(headers) {
    if (!Array.isArray(headers)) return false;
    return headers.every((item)=>Array.isArray(item) && item.length === 2 && typeof item[0] === "string");
}
function $4886857bd3eff57a$var$getSpanStartOptions(url$1, method, spanOrigin) {
    if (url$1.startsWith("data:")) {
        const sanitizedUrl2 = $hLsvb.stripDataUrlContent(url$1);
        return {
            name: `${method} ${sanitizedUrl2}`,
            attributes: $4886857bd3eff57a$var$getFetchSpanAttributes(url$1, void 0, method, spanOrigin)
        };
    }
    const parsedUrl = $hLsvb.parseStringToURLObject(url$1);
    const sanitizedUrl = parsedUrl ? $hLsvb.getSanitizedUrlStringFromUrlObject(parsedUrl) : url$1;
    return {
        name: `${method} ${sanitizedUrl}`,
        attributes: $4886857bd3eff57a$var$getFetchSpanAttributes(url$1, parsedUrl, method, spanOrigin)
    };
}
function $4886857bd3eff57a$var$getFetchSpanAttributes(url$1, parsedUrl, method, spanOrigin) {
    const attributes = {
        url: $hLsvb.stripDataUrlContent(url$1),
        type: "fetch",
        "http.method": method,
        [$gTasE.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: spanOrigin,
        [$gTasE.SEMANTIC_ATTRIBUTE_SENTRY_OP]: "http.client"
    };
    if (parsedUrl) {
        if (!$hLsvb.isURLObjectRelative(parsedUrl)) {
            attributes["http.url"] = $hLsvb.stripDataUrlContent(parsedUrl.href);
            attributes["server.address"] = parsedUrl.host;
        }
        if (parsedUrl.search) attributes["http.query"] = parsedUrl.search;
        if (parsedUrl.hash) attributes["http.fragment"] = parsedUrl.hash;
    }
    return attributes;
}
module.exports._INTERNAL_getTracingHeadersForFetchRequest = $4886857bd3eff57a$var$_INTERNAL_getTracingHeadersForFetchRequest;
module.exports._callOnRequestSpanEnd = $4886857bd3eff57a$var$_callOnRequestSpanEnd;
module.exports.instrumentFetchRequest = $4886857bd3eff57a$var$instrumentFetchRequest;

});

parcelRegister("hluB2", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $79m2C = parcelRequire("79m2C");
function $ca0c21a898cc3a93$var$captureFeedback(params, hint = {}, scope = $79m2C.getCurrentScope()) {
    const { message: message, name: name, email: email, url: url, source: source, associatedEventId: associatedEventId, tags: tags } = params;
    const feedbackEvent = {
        contexts: {
            feedback: {
                contact_email: email,
                name: name,
                message: message,
                url: url,
                source: source,
                associated_event_id: associatedEventId
            }
        },
        type: "feedback",
        level: "info",
        tags: tags
    };
    const client = scope?.getClient() || $79m2C.getClient();
    if (client) client.emit("beforeSendFeedback", feedbackEvent, hint);
    const eventId = scope.captureEvent(feedbackEvent, hint);
    return eventId;
}
module.exports.captureFeedback = $ca0c21a898cc3a93$var$captureFeedback;

});

parcelRegister("kfRXe", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $7LBlQ = parcelRequire("7LBlQ");

var $8UX2H = parcelRequire("8UX2H");
function $ebef0f8e0bc00b8e$var$captureLog(level, message, attributes, scope, severityNumber) {
    $7LBlQ._INTERNAL_captureLog({
        level: level,
        message: message,
        attributes: attributes,
        severityNumber: severityNumber
    }, scope);
}
function $ebef0f8e0bc00b8e$var$trace(message, attributes, { scope: scope } = {}) {
    $ebef0f8e0bc00b8e$var$captureLog("trace", message, attributes, scope);
}
function $ebef0f8e0bc00b8e$var$debug(message, attributes, { scope: scope } = {}) {
    $ebef0f8e0bc00b8e$var$captureLog("debug", message, attributes, scope);
}
function $ebef0f8e0bc00b8e$var$info(message, attributes, { scope: scope } = {}) {
    $ebef0f8e0bc00b8e$var$captureLog("info", message, attributes, scope);
}
function $ebef0f8e0bc00b8e$var$warn(message, attributes, { scope: scope } = {}) {
    $ebef0f8e0bc00b8e$var$captureLog("warn", message, attributes, scope);
}
function $ebef0f8e0bc00b8e$var$error(message, attributes, { scope: scope } = {}) {
    $ebef0f8e0bc00b8e$var$captureLog("error", message, attributes, scope);
}
function $ebef0f8e0bc00b8e$var$fatal(message, attributes, { scope: scope } = {}) {
    $ebef0f8e0bc00b8e$var$captureLog("fatal", message, attributes, scope);
}
module.exports.fmt = $8UX2H.fmt;
module.exports.debug = $ebef0f8e0bc00b8e$var$debug;
module.exports.error = $ebef0f8e0bc00b8e$var$error;
module.exports.fatal = $ebef0f8e0bc00b8e$var$fatal;
module.exports.info = $ebef0f8e0bc00b8e$var$info;
module.exports.trace = $ebef0f8e0bc00b8e$var$trace;
module.exports.warn = $ebef0f8e0bc00b8e$var$warn;

});

parcelRegister("42tGj", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $79m2C = parcelRequire("79m2C");

var $hiZR1 = parcelRequire("hiZR1");

var $8mzKS = parcelRequire("8mzKS");

var $g33UP = parcelRequire("g33UP");

var $gTasE = parcelRequire("gTasE");

var $4gyod = parcelRequire("4gyod");

var $dzfKZ = parcelRequire("dzfKZ");

var $eD1cG = parcelRequire("eD1cG");

var $7LBlQ = parcelRequire("7LBlQ");

var $8ar32 = parcelRequire("8ar32");
const $2f0e5f74adeb6feb$var$INTEGRATION_NAME = "ConsoleLogs";
const $2f0e5f74adeb6feb$var$DEFAULT_ATTRIBUTES = {
    [$gTasE.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: "auto.log.console"
};
const $2f0e5f74adeb6feb$var$_consoleLoggingIntegration = (options = {})=>{
    const levels = options.levels || $4gyod.CONSOLE_LEVELS;
    return {
        name: $2f0e5f74adeb6feb$var$INTEGRATION_NAME,
        setup (client) {
            const { enableLogs: enableLogs, normalizeDepth: normalizeDepth = 3, normalizeMaxBreadth: normalizeMaxBreadth = 1e3 } = client.getOptions();
            if (!enableLogs) {
                $hiZR1.DEBUG_BUILD && $4gyod.debug.warn("`enableLogs` is not enabled, ConsoleLogs integration disabled");
                return;
            }
            const unsubscribe = $8mzKS.addConsoleInstrumentationHandler(({ args: args, level: level })=>{
                if ($79m2C.getClient() !== client || !levels.includes(level)) return;
                const firstArg = args[0];
                const followingArgs = args.slice(1);
                if (level === "assert") {
                    if (!firstArg) {
                        const assertionMessage = followingArgs.length > 0 ? `Assertion failed: ${$8ar32.formatConsoleArgs(followingArgs, normalizeDepth, normalizeMaxBreadth)}` : "Assertion failed";
                        $7LBlQ._INTERNAL_captureLog({
                            level: "error",
                            message: assertionMessage,
                            attributes: $2f0e5f74adeb6feb$var$DEFAULT_ATTRIBUTES
                        });
                    }
                    return;
                }
                const isLevelLog = level === "log";
                const attributes = {
                    ...$2f0e5f74adeb6feb$var$DEFAULT_ATTRIBUTES
                };
                if ($dzfKZ.isPlainObject(firstArg)) {
                    Object.assign(attributes, $eD1cG.normalize(firstArg, normalizeDepth, normalizeMaxBreadth));
                    const remainingArgsStartIndex = typeof args[1] === "string" ? 2 : 1;
                    const remainingArgs = args.slice(remainingArgsStartIndex);
                    remainingArgs.forEach((arg, index)=>{
                        attributes[`sentry.message.parameter.${index}`] = $eD1cG.normalize(arg, normalizeDepth, normalizeMaxBreadth);
                    });
                } else {
                    const shouldGenerateTemplate = followingArgs.length > 0 && typeof firstArg === "string" && !$8ar32.hasConsoleSubstitutions(firstArg);
                    if (shouldGenerateTemplate) {
                        const templateAttrs = $8ar32.createConsoleTemplateAttributes(firstArg, followingArgs);
                        for (const [key, value] of Object.entries(templateAttrs))attributes[key] = key.startsWith("sentry.message.parameter.") ? $eD1cG.normalize(value, normalizeDepth, normalizeMaxBreadth) : value;
                    }
                }
                $7LBlQ._INTERNAL_captureLog({
                    level: isLevelLog ? "info" : level,
                    message: $8ar32.formatConsoleArgs(args, normalizeDepth, normalizeMaxBreadth),
                    severityNumber: isLevelLog ? 10 : void 0,
                    attributes: attributes
                });
            });
            client.registerCleanup(unsubscribe);
        }
    };
};
const $2f0e5f74adeb6feb$var$consoleLoggingIntegration = $g33UP.defineIntegration($2f0e5f74adeb6feb$var$_consoleLoggingIntegration);
module.exports.consoleLoggingIntegration = $2f0e5f74adeb6feb$var$consoleLoggingIntegration;

});
parcelRegister("8ar32", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $dzfKZ = parcelRequire("dzfKZ");

var $eD1cG = parcelRequire("eD1cG");

var $eP8Ri = parcelRequire("eP8Ri");
function $5f243d1221167345$var$formatConsoleArgs(values, normalizeDepth, normalizeMaxBreadth) {
    return "util" in $eP8Ri.GLOBAL_OBJ && typeof $eP8Ri.GLOBAL_OBJ.util.format === "function" ? $eP8Ri.GLOBAL_OBJ.util.format(...values) : $5f243d1221167345$var$safeJoinConsoleArgs(values, normalizeDepth, normalizeMaxBreadth);
}
function $5f243d1221167345$var$safeJoinConsoleArgs(values, normalizeDepth, normalizeMaxBreadth) {
    return values.map((value)=>$dzfKZ.isPrimitive(value) ? String(value) : JSON.stringify($eD1cG.normalize(value, normalizeDepth, normalizeMaxBreadth))).join(" ");
}
function $5f243d1221167345$var$hasConsoleSubstitutions(str) {
    return /%[sdifocO]/.test(str);
}
function $5f243d1221167345$var$createConsoleTemplateAttributes(firstArg, followingArgs) {
    const attributes = {};
    const template = new Array(followingArgs.length).fill("{}").join(" ");
    attributes["sentry.message.template"] = `${firstArg} ${template}`;
    followingArgs.forEach((arg, index)=>{
        attributes[`sentry.message.parameter.${index}`] = arg;
    });
    return attributes;
}
module.exports.createConsoleTemplateAttributes = $5f243d1221167345$var$createConsoleTemplateAttributes;
module.exports.formatConsoleArgs = $5f243d1221167345$var$formatConsoleArgs;
module.exports.hasConsoleSubstitutions = $5f243d1221167345$var$hasConsoleSubstitutions;
module.exports.safeJoinConsoleArgs = $5f243d1221167345$var$safeJoinConsoleArgs;

});


parcelRegister("dBNYS", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $5zO49 = parcelRequire("5zO49");
function $9e85803dea8d2739$var$captureMetric(type, name, value, options) {
    $5zO49._INTERNAL_captureMetric({
        type: type,
        name: name,
        value: value,
        unit: options?.unit,
        attributes: options?.attributes
    }, {
        scope: options?.scope
    });
}
function $9e85803dea8d2739$var$count(name, value = 1, options) {
    $9e85803dea8d2739$var$captureMetric("counter", name, value, options);
}
function $9e85803dea8d2739$var$gauge(name, value, options) {
    $9e85803dea8d2739$var$captureMetric("gauge", name, value, options);
}
function $9e85803dea8d2739$var$distribution(name, value, options) {
    $9e85803dea8d2739$var$captureMetric("distribution", name, value, options);
}
module.exports.count = $9e85803dea8d2739$var$count;
module.exports.distribution = $9e85803dea8d2739$var$distribution;
module.exports.gauge = $9e85803dea8d2739$var$gauge;

});

parcelRegister("c4s7L", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $79m2C = parcelRequire("79m2C");

var $7LBlQ = parcelRequire("7LBlQ");

var $8ar32 = parcelRequire("8ar32");

var $dzfKZ = parcelRequire("dzfKZ");

var $eD1cG = parcelRequire("eD1cG");
const $8c9bac9e469501b8$var$DEFAULT_CAPTURED_LEVELS = [
    "trace",
    "debug",
    "info",
    "warn",
    "error",
    "fatal"
];
function $8c9bac9e469501b8$var$createConsolaReporter(options = {}) {
    const levels = new Set(options.levels ?? $8c9bac9e469501b8$var$DEFAULT_CAPTURED_LEVELS);
    const providedClient = options.client;
    return {
        log (logObj) {
            const { type: type, level: level, message: consolaMessage, args: args, tag: tag, date: _date, ...rest } = logObj;
            const client = providedClient || $79m2C.getClient();
            if (!client) return;
            const logSeverityLevel = $8c9bac9e469501b8$var$getLogSeverityLevel(type, level);
            if (!levels.has(logSeverityLevel)) return;
            const { normalizeDepth: normalizeDepth = 3, normalizeMaxBreadth: normalizeMaxBreadth = 1e3 } = client.getOptions();
            const attributes = {};
            for (const [key, value] of Object.entries(rest))attributes[key] = $eD1cG.normalize(value, normalizeDepth, normalizeMaxBreadth);
            attributes["sentry.origin"] = "auto.log.consola";
            if (tag) attributes["consola.tag"] = tag;
            if (type) attributes["consola.type"] = type;
            if (level != null && typeof level === "number") attributes["consola.level"] = level;
            const extractionResult = $8c9bac9e469501b8$var$processExtractedAttributes($8c9bac9e469501b8$var$defaultExtractAttributes(args, normalizeDepth, normalizeMaxBreadth), normalizeDepth, normalizeMaxBreadth);
            if (extractionResult?.attributes) Object.assign(attributes, extractionResult.attributes);
            $7LBlQ._INTERNAL_captureLog({
                level: logSeverityLevel,
                message: extractionResult?.message || consolaMessage || args && $8ar32.formatConsoleArgs(args, normalizeDepth, normalizeMaxBreadth) || "",
                attributes: attributes
            });
        }
    };
}
const $8c9bac9e469501b8$var$CONSOLA_TYPE_TO_LOG_SEVERITY_LEVEL_MAP = {
    // Consola built-in types
    silent: "trace",
    fatal: "fatal",
    error: "error",
    warn: "warn",
    log: "info",
    info: "info",
    success: "info",
    fail: "error",
    ready: "info",
    start: "info",
    box: "info",
    debug: "debug",
    trace: "trace",
    verbose: "debug",
    // Custom types that might exist
    critical: "fatal",
    notice: "info"
};
const $8c9bac9e469501b8$var$CONSOLA_LEVEL_TO_LOG_SEVERITY_LEVEL_MAP = {
    0: "fatal",
    // Fatal and Error
    1: "warn",
    // Warnings
    2: "info",
    // Normal logs
    3: "info",
    // Informational logs, success, fail, ready, start, ...
    4: "debug",
    // Debug logs
    5: "trace"
};
function $8c9bac9e469501b8$var$getLogSeverityLevel(type, level) {
    if (type === "verbose") return "debug";
    if (type === "silent") return "trace";
    if (type) {
        const mappedLevel = $8c9bac9e469501b8$var$CONSOLA_TYPE_TO_LOG_SEVERITY_LEVEL_MAP[type];
        if (mappedLevel) return mappedLevel;
    }
    if (typeof level === "number") {
        const mappedLevel = $8c9bac9e469501b8$var$CONSOLA_LEVEL_TO_LOG_SEVERITY_LEVEL_MAP[level];
        if (mappedLevel) return mappedLevel;
    }
    return "info";
}
function $8c9bac9e469501b8$var$defaultExtractAttributes(args, normalizeDepth, normalizeMaxBreadth) {
    if (!args?.length) return {
        message: ""
    };
    const message = $8ar32.formatConsoleArgs(args, normalizeDepth, normalizeMaxBreadth);
    const firstArg = args[0];
    if ($dzfKZ.isPlainObject(firstArg)) {
        const remainingArgsStartIndex = typeof args[1] === "string" ? 2 : 1;
        const remainingArgs = args.slice(remainingArgsStartIndex);
        return {
            message: message,
            // Object content from first arg is added as attributes
            attributes: firstArg,
            // Add remaining args as message parameters
            messageParameters: remainingArgs
        };
    } else {
        const followingArgs = args.slice(1);
        const shouldAddTemplateAttr = followingArgs.length > 0 && typeof firstArg === "string" && !$8ar32.hasConsoleSubstitutions(firstArg);
        return {
            message: message,
            messageTemplate: shouldAddTemplateAttr ? firstArg : void 0,
            messageParameters: shouldAddTemplateAttr ? followingArgs : void 0
        };
    }
}
function $8c9bac9e469501b8$var$processExtractedAttributes(extractionResult, normalizeDepth, normalizeMaxBreadth) {
    const { message: message, attributes: attributes, messageTemplate: messageTemplate, messageParameters: messageParameters } = extractionResult;
    const messageParamAttributes = {};
    if (messageTemplate && messageParameters) {
        const templateAttrs = $8ar32.createConsoleTemplateAttributes(messageTemplate, messageParameters);
        for (const [key, value] of Object.entries(templateAttrs))messageParamAttributes[key] = key.startsWith("sentry.message.parameter.") ? $eD1cG.normalize(value, normalizeDepth, normalizeMaxBreadth) : value;
    } else if (messageParameters && messageParameters.length > 0) messageParameters.forEach((arg, index)=>{
        messageParamAttributes[`sentry.message.parameter.${index}`] = $eD1cG.normalize(arg, normalizeDepth, normalizeMaxBreadth);
    });
    return {
        message: message,
        attributes: {
            ...$eD1cG.normalize(attributes, normalizeDepth, normalizeMaxBreadth),
            ...messageParamAttributes
        }
    };
}
module.exports.createConsolaReporter = $8c9bac9e469501b8$var$createConsolaReporter;

});

parcelRegister("hLsdQ", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $79m2C = parcelRequire("79m2C");

var $gTasE = parcelRequire("gTasE");

var $iQAGO = parcelRequire("iQAGO");

var $8jbnX = parcelRequire("8jbnX");

var $MHfcn = parcelRequire("MHfcn");

var $dqmpD = parcelRequire("dqmpD");

var $8ICT0 = parcelRequire("8ICT0");

var $azBVI = parcelRequire("azBVI");

var $lwvSk = parcelRequire("lwvSk");
function $ceecb7cd6938cea4$var$onVercelAiSpanStart(span) {
    const { data: attributes, description: name } = $8jbnX.spanToJSON(span);
    if (!name) return;
    if (attributes[$lwvSk.AI_TOOL_CALL_NAME_ATTRIBUTE] && attributes[$lwvSk.AI_TOOL_CALL_ID_ATTRIBUTE] && name === "ai.toolCall") {
        $ceecb7cd6938cea4$var$processToolCallSpan(span, attributes);
        return;
    }
    if (!attributes[$lwvSk.AI_OPERATION_ID_ATTRIBUTE] && !name.startsWith("ai.")) return;
    const client = $79m2C.getClient();
    const integration = client?.getIntegrationByName("VercelAI");
    const enableTruncation = $iQAGO.shouldEnableTruncation(integration?.options?.enableTruncation);
    $ceecb7cd6938cea4$var$processGenerateSpan(span, name, attributes, enableTruncation);
}
function $ceecb7cd6938cea4$var$vercelAiEventProcessor(event) {
    if (event.type === "transaction" && event.spans) {
        const tokenAccumulator = /* @__PURE__ */ new Map();
        for (const span of event.spans){
            $ceecb7cd6938cea4$var$processEndedVercelAiSpan(span);
            $azBVI.accumulateTokensForParent(span, tokenAccumulator);
        }
        $azBVI.applyToolDescriptionsAndTokens(event.spans, tokenAccumulator);
        const trace = event.contexts?.trace;
        if (trace?.op === "gen_ai.invoke_agent") $azBVI.applyAccumulatedTokens(trace, tokenAccumulator);
    }
    return event;
}
function $ceecb7cd6938cea4$var$normalizeFinishReason(finishReason) {
    if (typeof finishReason !== "string") return "stop";
    switch(finishReason){
        case "tool-calls":
            return "tool_call";
        case "stop":
        case "length":
        case "content_filter":
        case "error":
            return finishReason;
        default:
            return finishReason;
    }
}
function $ceecb7cd6938cea4$var$buildOutputMessages(attributes) {
    const responseText = attributes[$lwvSk.AI_RESPONSE_TEXT_ATTRIBUTE];
    const responseToolCalls = attributes[$lwvSk.AI_RESPONSE_TOOL_CALLS_ATTRIBUTE];
    const finishReason = attributes[$lwvSk.AI_RESPONSE_FINISH_REASON_ATTRIBUTE];
    if (responseText == null && responseToolCalls == null) return;
    const parts = [];
    if (typeof responseText === "string" && responseText.length > 0) parts.push({
        type: "text",
        content: responseText
    });
    if (responseToolCalls != null) try {
        const toolCalls = typeof responseToolCalls === "string" ? JSON.parse(responseToolCalls) : responseToolCalls;
        if (Array.isArray(toolCalls)) {
            for (const toolCall of toolCalls){
                const args = toolCall.input ?? toolCall.args;
                parts.push({
                    type: "tool_call",
                    id: toolCall.toolCallId,
                    name: toolCall.toolName,
                    // Handle undefined args: JSON.stringify(undefined) returns undefined, not a string,
                    // which would cause the property to be omitted from the final JSON output
                    arguments: typeof args === "string" ? args : JSON.stringify(args ?? {})
                });
            }
            delete attributes[$lwvSk.AI_RESPONSE_TOOL_CALLS_ATTRIBUTE];
        }
    } catch  {}
    if (parts.length > 0) {
        const outputMessage = {
            role: "assistant",
            parts: parts,
            finish_reason: $ceecb7cd6938cea4$var$normalizeFinishReason(finishReason)
        };
        attributes[$MHfcn.GEN_AI_OUTPUT_MESSAGES_ATTRIBUTE] = JSON.stringify([
            outputMessage
        ]);
        delete attributes[$lwvSk.AI_RESPONSE_TEXT_ATTRIBUTE];
    }
}
function $ceecb7cd6938cea4$var$processVercelAiSpanAttributes(attributes) {
    $ceecb7cd6938cea4$var$renameAttributeKey(attributes, $lwvSk.AI_USAGE_COMPLETION_TOKENS_ATTRIBUTE, $MHfcn.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE);
    $ceecb7cd6938cea4$var$renameAttributeKey(attributes, $lwvSk.AI_USAGE_PROMPT_TOKENS_ATTRIBUTE, $MHfcn.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE);
    $ceecb7cd6938cea4$var$renameAttributeKey(attributes, $lwvSk.AI_USAGE_CACHED_INPUT_TOKENS_ATTRIBUTE, $MHfcn.GEN_AI_USAGE_INPUT_TOKENS_CACHED_ATTRIBUTE);
    $ceecb7cd6938cea4$var$renameAttributeKey(attributes, "ai.usage.inputTokens", $MHfcn.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE);
    $ceecb7cd6938cea4$var$renameAttributeKey(attributes, "ai.usage.outputTokens", $MHfcn.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE);
    $ceecb7cd6938cea4$var$renameAttributeKey(attributes, $lwvSk.AI_USAGE_TOKENS_ATTRIBUTE, $MHfcn.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE);
    $ceecb7cd6938cea4$var$renameAttributeKey(attributes, "ai.response.avgOutputTokensPerSecond", "ai.response.avgCompletionTokensPerSecond");
    const inputTokensAreCacheInclusive = Object.keys(attributes).some((key)=>key.startsWith($lwvSk.AI_USAGE_INPUT_TOKEN_DETAILS_ATTRIBUTE_PREFIX));
    if (!inputTokensAreCacheInclusive && typeof attributes[$MHfcn.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE] === "number" && typeof attributes[$MHfcn.GEN_AI_USAGE_INPUT_TOKENS_CACHED_ATTRIBUTE] === "number") attributes[$MHfcn.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE] = attributes[$MHfcn.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE] + attributes[$MHfcn.GEN_AI_USAGE_INPUT_TOKENS_CACHED_ATTRIBUTE];
    if (typeof attributes[$MHfcn.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE] === "number") {
        const outputTokens = typeof attributes[$MHfcn.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE] === "number" ? attributes[$MHfcn.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE] : 0;
        attributes[$MHfcn.GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE] = outputTokens + attributes[$MHfcn.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE];
    }
    if (attributes[$lwvSk.AI_PROMPT_TOOLS_ATTRIBUTE] && Array.isArray(attributes[$lwvSk.AI_PROMPT_TOOLS_ATTRIBUTE])) attributes[$lwvSk.AI_PROMPT_TOOLS_ATTRIBUTE] = $azBVI.convertAvailableToolsToJsonString(attributes[$lwvSk.AI_PROMPT_TOOLS_ATTRIBUTE]);
    if (attributes[$lwvSk.OPERATION_NAME_ATTRIBUTE]) {
        const rawOperationName = attributes[$lwvSk.AI_OPERATION_ID_ATTRIBUTE] ? attributes[$lwvSk.AI_OPERATION_ID_ATTRIBUTE] : attributes[$lwvSk.OPERATION_NAME_ATTRIBUTE];
        const operationName = $dqmpD.SPAN_TO_OPERATION_NAME.get(rawOperationName) ?? rawOperationName;
        attributes[$MHfcn.GEN_AI_OPERATION_NAME_ATTRIBUTE] = operationName;
        delete attributes[$lwvSk.OPERATION_NAME_ATTRIBUTE];
    }
    $ceecb7cd6938cea4$var$renameAttributeKey(attributes, $lwvSk.AI_PROMPT_MESSAGES_ATTRIBUTE, $MHfcn.GEN_AI_INPUT_MESSAGES_ATTRIBUTE);
    $ceecb7cd6938cea4$var$buildOutputMessages(attributes);
    $ceecb7cd6938cea4$var$renameAttributeKey(attributes, $lwvSk.AI_RESPONSE_OBJECT_ATTRIBUTE, "gen_ai.response.object");
    $ceecb7cd6938cea4$var$renameAttributeKey(attributes, $lwvSk.AI_PROMPT_TOOLS_ATTRIBUTE, "gen_ai.request.available_tools");
    $ceecb7cd6938cea4$var$renameAttributeKey(attributes, $lwvSk.AI_TOOL_CALL_ARGS_ATTRIBUTE, $MHfcn.GEN_AI_TOOL_INPUT_ATTRIBUTE);
    $ceecb7cd6938cea4$var$renameAttributeKey(attributes, $lwvSk.AI_TOOL_CALL_RESULT_ATTRIBUTE, $MHfcn.GEN_AI_TOOL_OUTPUT_ATTRIBUTE);
    $ceecb7cd6938cea4$var$renameAttributeKey(attributes, $lwvSk.AI_SCHEMA_ATTRIBUTE, "gen_ai.request.schema");
    $ceecb7cd6938cea4$var$renameAttributeKey(attributes, $lwvSk.AI_MODEL_ID_ATTRIBUTE, $MHfcn.GEN_AI_REQUEST_MODEL_ATTRIBUTE);
    if (Array.isArray(attributes[$lwvSk.AI_VALUES_ATTRIBUTE])) {
        const parsed = attributes[$lwvSk.AI_VALUES_ATTRIBUTE].map((v)=>{
            try {
                return JSON.parse(v);
            } catch  {
                return v;
            }
        });
        attributes[$MHfcn.GEN_AI_EMBEDDINGS_INPUT_ATTRIBUTE] = parsed.length === 1 ? parsed[0] : JSON.stringify(parsed);
    }
    $ceecb7cd6938cea4$var$addProviderMetadataToAttributes(attributes);
    for (const key of Object.keys(attributes)){
        if (Array.isArray(attributes[key])) attributes[key] = JSON.stringify(attributes[key]);
        if (key.startsWith("ai.")) $ceecb7cd6938cea4$var$renameAttributeKey(attributes, key, `vercel.${key}`);
    }
}
function $ceecb7cd6938cea4$var$processEndedVercelAiSpan(span) {
    const { data: attributes, origin: origin } = span;
    if (origin !== "auto.vercelai.otel") return;
    if (span.status && span.status !== "ok") span.status = "internal_error";
    $ceecb7cd6938cea4$var$processVercelAiSpanAttributes(attributes);
}
function $ceecb7cd6938cea4$var$processVercelAiStreamedSpan(span) {
    const attributes = span.attributes;
    if (attributes?.[$gTasE.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN] !== "auto.vercelai.otel") return;
    $ceecb7cd6938cea4$var$processVercelAiSpanAttributes(attributes);
    if (attributes[$gTasE.SEMANTIC_ATTRIBUTE_SENTRY_OP] === "gen_ai.execute_tool" && span.parent_span_id) {
        const descriptions = $dqmpD.toolDescriptionMap.get(span.parent_span_id);
        if (descriptions) {
            const toolName = attributes[$MHfcn.GEN_AI_TOOL_NAME_ATTRIBUTE];
            if (typeof toolName === "string") {
                const desc = descriptions.get(toolName);
                if (desc) attributes[$MHfcn.GEN_AI_TOOL_DESCRIPTION_ATTRIBUTE] = desc;
            }
        }
    }
    $dqmpD.toolDescriptionMap.delete(span.span_id);
}
function $ceecb7cd6938cea4$var$renameAttributeKey(attributes, oldKey, newKey) {
    if (attributes[oldKey] != null) {
        attributes[newKey] = attributes[oldKey];
        delete attributes[oldKey];
    }
}
function $ceecb7cd6938cea4$var$processToolCallSpan(span, attributes) {
    span.setAttribute($gTasE.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN, "auto.vercelai.otel");
    span.setAttribute($gTasE.SEMANTIC_ATTRIBUTE_SENTRY_OP, "gen_ai.execute_tool");
    span.setAttribute($MHfcn.GEN_AI_OPERATION_NAME_ATTRIBUTE, "execute_tool");
    $ceecb7cd6938cea4$var$renameAttributeKey(attributes, $lwvSk.AI_TOOL_CALL_NAME_ATTRIBUTE, $MHfcn.GEN_AI_TOOL_NAME_ATTRIBUTE);
    $ceecb7cd6938cea4$var$renameAttributeKey(attributes, $lwvSk.AI_TOOL_CALL_ID_ATTRIBUTE, $MHfcn.GEN_AI_TOOL_CALL_ID_ATTRIBUTE);
    const toolCallId = attributes[$MHfcn.GEN_AI_TOOL_CALL_ID_ATTRIBUTE];
    if (typeof toolCallId === "string") $dqmpD.toolCallSpanContextMap.set(toolCallId, span.spanContext());
    if (!attributes[$MHfcn.GEN_AI_TOOL_TYPE_ATTRIBUTE]) span.setAttribute($MHfcn.GEN_AI_TOOL_TYPE_ATTRIBUTE, "function");
    const toolName = attributes[$MHfcn.GEN_AI_TOOL_NAME_ATTRIBUTE];
    if (toolName) span.updateName(`execute_tool ${toolName}`);
}
function $ceecb7cd6938cea4$var$processGenerateSpan(span, name, attributes, enableTruncation) {
    span.setAttribute($gTasE.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN, "auto.vercelai.otel");
    const nameWthoutAi = name.replace("ai.", "");
    span.setAttribute("ai.pipeline.name", nameWthoutAi);
    span.updateName(nameWthoutAi);
    const functionId = attributes[$lwvSk.AI_TELEMETRY_FUNCTION_ID_ATTRIBUTE];
    if (functionId && typeof functionId === "string") span.setAttribute("gen_ai.function_id", functionId);
    $azBVI.requestMessagesFromPrompt(span, attributes, enableTruncation);
    if (attributes[$lwvSk.AI_MODEL_ID_ATTRIBUTE] && !attributes[$MHfcn.GEN_AI_RESPONSE_MODEL_ATTRIBUTE]) span.setAttribute($MHfcn.GEN_AI_RESPONSE_MODEL_ATTRIBUTE, attributes[$lwvSk.AI_MODEL_ID_ATTRIBUTE]);
    span.setAttribute("ai.streaming", name.includes("stream"));
    const operationName = $dqmpD.SPAN_TO_OPERATION_NAME.get(name);
    if (operationName) span.setAttribute($gTasE.SEMANTIC_ATTRIBUTE_SENTRY_OP, `gen_ai.${operationName}`);
    else if (name.startsWith("ai.stream")) span.setAttribute($gTasE.SEMANTIC_ATTRIBUTE_SENTRY_OP, "ai.run");
    if (operationName === "invoke_agent") {
        if (functionId && typeof functionId === "string") span.updateName(`invoke_agent ${functionId}`);
        else span.updateName("invoke_agent");
        return;
    }
    const modelId = attributes[$lwvSk.AI_MODEL_ID_ATTRIBUTE];
    if (modelId && operationName) span.updateName(`${operationName} ${modelId}`);
    const client = $79m2C.getClient();
    if (client && $8ICT0.hasSpanStreamingEnabled(client) && attributes[$lwvSk.AI_PROMPT_TOOLS_ATTRIBUTE] && Array.isArray(attributes[$lwvSk.AI_PROMPT_TOOLS_ATTRIBUTE])) {
        const descriptions = /* @__PURE__ */ new Map();
        for (const toolStr of attributes[$lwvSk.AI_PROMPT_TOOLS_ATTRIBUTE])try {
            const parsed = typeof toolStr === "string" ? JSON.parse(toolStr) : toolStr;
            if (parsed?.name && parsed?.description) descriptions.set(parsed.name, parsed.description);
        } catch  {}
        if (descriptions.size > 0) {
            const parentSpanId = $8jbnX.spanToJSON(span).parent_span_id;
            if (parentSpanId) $dqmpD.toolDescriptionMap.set(parentSpanId, descriptions);
        }
    }
}
function $ceecb7cd6938cea4$var$addVercelAiProcessors(client) {
    client.on("spanStart", $ceecb7cd6938cea4$var$onVercelAiSpanStart);
    client.addEventProcessor(Object.assign($ceecb7cd6938cea4$var$vercelAiEventProcessor, {
        id: "VercelAiEventProcessor"
    }));
    client.on("processSpan", (span)=>{
        $ceecb7cd6938cea4$var$processVercelAiStreamedSpan(span);
    });
}
function $ceecb7cd6938cea4$var$getProviderMetadataAttributes(providerMetadata) {
    const attributes = {};
    if (!providerMetadata || typeof providerMetadata !== "object") return attributes;
    const metadata = providerMetadata;
    const openaiMetadata = metadata.openai ?? metadata.azure;
    if (openaiMetadata) {
        $ceecb7cd6938cea4$var$setAttributeIfDefined(attributes, $MHfcn.GEN_AI_USAGE_INPUT_TOKENS_CACHED_ATTRIBUTE, openaiMetadata.cachedPromptTokens);
        $ceecb7cd6938cea4$var$setAttributeIfDefined(attributes, "gen_ai.usage.output_tokens.reasoning", openaiMetadata.reasoningTokens);
        $ceecb7cd6938cea4$var$setAttributeIfDefined(attributes, "gen_ai.usage.output_tokens.prediction_accepted", openaiMetadata.acceptedPredictionTokens);
        $ceecb7cd6938cea4$var$setAttributeIfDefined(attributes, "gen_ai.usage.output_tokens.prediction_rejected", openaiMetadata.rejectedPredictionTokens);
        $ceecb7cd6938cea4$var$setAttributeIfDefined(attributes, $MHfcn.GEN_AI_CONVERSATION_ID_ATTRIBUTE, openaiMetadata.responseId);
    }
    if (metadata.anthropic) {
        const cachedInputTokens = metadata.anthropic.usage?.cache_read_input_tokens ?? metadata.anthropic.cacheReadInputTokens;
        $ceecb7cd6938cea4$var$setAttributeIfDefined(attributes, $MHfcn.GEN_AI_USAGE_INPUT_TOKENS_CACHED_ATTRIBUTE, cachedInputTokens);
        const cacheWriteInputTokens = metadata.anthropic.usage?.cache_creation_input_tokens ?? metadata.anthropic.cacheCreationInputTokens;
        $ceecb7cd6938cea4$var$setAttributeIfDefined(attributes, $MHfcn.GEN_AI_USAGE_INPUT_TOKENS_CACHE_WRITE_ATTRIBUTE, cacheWriteInputTokens);
    }
    if (metadata.bedrock?.usage) {
        $ceecb7cd6938cea4$var$setAttributeIfDefined(attributes, $MHfcn.GEN_AI_USAGE_INPUT_TOKENS_CACHED_ATTRIBUTE, metadata.bedrock.usage.cacheReadInputTokens);
        $ceecb7cd6938cea4$var$setAttributeIfDefined(attributes, $MHfcn.GEN_AI_USAGE_INPUT_TOKENS_CACHE_WRITE_ATTRIBUTE, metadata.bedrock.usage.cacheWriteInputTokens);
    }
    if (metadata.deepseek) {
        $ceecb7cd6938cea4$var$setAttributeIfDefined(attributes, $MHfcn.GEN_AI_USAGE_INPUT_TOKENS_CACHED_ATTRIBUTE, metadata.deepseek.promptCacheHitTokens);
        $ceecb7cd6938cea4$var$setAttributeIfDefined(attributes, "gen_ai.usage.input_tokens.cache_miss", metadata.deepseek.promptCacheMissTokens);
    }
    return attributes;
}
function $ceecb7cd6938cea4$var$addProviderMetadataToAttributes(attributes) {
    const providerMetadata = attributes[$lwvSk.AI_RESPONSE_PROVIDER_METADATA_ATTRIBUTE];
    if (!providerMetadata) return;
    try {
        const derived = $ceecb7cd6938cea4$var$getProviderMetadataAttributes(JSON.parse(providerMetadata));
        for (const [key, value] of Object.entries(derived)){
            if (key === $MHfcn.GEN_AI_CONVERSATION_ID_ATTRIBUTE && attributes[key]) continue;
            attributes[key] = value;
        }
    } catch  {}
}
function $ceecb7cd6938cea4$var$setAttributeIfDefined(attributes, key, value) {
    if (value != null) attributes[key] = value;
}
module.exports.addVercelAiProcessors = $ceecb7cd6938cea4$var$addVercelAiProcessors;
module.exports.getProviderMetadataAttributes = $ceecb7cd6938cea4$var$getProviderMetadataAttributes;
module.exports.processVercelAiSpanAttributes = $ceecb7cd6938cea4$var$processVercelAiSpanAttributes;

});
parcelRegister("iQAGO", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $1tl8I = parcelRequire("1tl8I");

var $79m2C = parcelRequire("79m2C");

var $8ICT0 = parcelRequire("8ICT0");

var $dzfKZ = parcelRequire("dzfKZ");

var $MHfcn = parcelRequire("MHfcn");

var $l6DaT = parcelRequire("l6DaT");
function $db898b16f77fd380$var$resolveAIRecordingOptions(options) {
    const genAI = $79m2C.getClient()?.getDataCollectionOptions().genAI;
    return {
        ...options,
        recordInputs: options?.recordInputs ?? genAI?.inputs ?? false,
        recordOutputs: options?.recordOutputs ?? genAI?.outputs ?? false
    };
}
function $db898b16f77fd380$var$shouldEnableTruncation(enableTruncation) {
    if (enableTruncation !== void 0) return enableTruncation;
    const client = $79m2C.getClient();
    if (!client) return true;
    return !$8ICT0.hasSpanStreamingEnabled(client) && client.getOptions().streamGenAiSpans === false;
}
function $db898b16f77fd380$var$buildMethodPath(currentPath, prop) {
    return currentPath ? `${currentPath}.${prop}` : prop;
}
function $db898b16f77fd380$var$setTokenUsageAttributes(span, promptTokens, completionTokens, cachedInputTokens, cachedOutputTokens) {
    if (promptTokens !== void 0) span.setAttributes({
        [$MHfcn.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE]: promptTokens
    });
    if (completionTokens !== void 0) span.setAttributes({
        [$MHfcn.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE]: completionTokens
    });
    if (promptTokens !== void 0 || completionTokens !== void 0 || cachedInputTokens !== void 0 || cachedOutputTokens !== void 0) {
        const totalTokens = (promptTokens ?? 0) + (completionTokens ?? 0) + (cachedInputTokens ?? 0) + (cachedOutputTokens ?? 0);
        span.setAttributes({
            [$MHfcn.GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE]: totalTokens
        });
    }
}
function $db898b16f77fd380$var$endStreamSpan(span, state, recordOutputs) {
    if (!span.isRecording()) return;
    const attrs = {
        [$MHfcn.GEN_AI_RESPONSE_STREAMING_ATTRIBUTE]: true
    };
    if (state.responseId) attrs[$MHfcn.GEN_AI_RESPONSE_ID_ATTRIBUTE] = state.responseId;
    if (state.responseModel) attrs[$MHfcn.GEN_AI_RESPONSE_MODEL_ATTRIBUTE] = state.responseModel;
    if (state.promptTokens !== void 0) attrs[$MHfcn.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE] = state.promptTokens;
    if (state.completionTokens !== void 0) attrs[$MHfcn.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE] = state.completionTokens;
    if (state.totalTokens !== void 0) attrs[$MHfcn.GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE] = state.totalTokens;
    else if (state.promptTokens !== void 0 || state.completionTokens !== void 0 || state.cacheCreationInputTokens !== void 0 || state.cacheReadInputTokens !== void 0) attrs[$MHfcn.GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE] = (state.promptTokens ?? 0) + (state.completionTokens ?? 0) + (state.cacheCreationInputTokens ?? 0) + (state.cacheReadInputTokens ?? 0);
    if (state.finishReasons.length) attrs[$MHfcn.GEN_AI_RESPONSE_FINISH_REASONS_ATTRIBUTE] = JSON.stringify(state.finishReasons);
    if (recordOutputs && state.responseTexts.length) attrs[$MHfcn.GEN_AI_RESPONSE_TEXT_ATTRIBUTE] = state.responseTexts.join("");
    if (recordOutputs && state.toolCalls.length) attrs[$MHfcn.GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE] = JSON.stringify(state.toolCalls);
    span.setAttributes(attrs);
    span.end();
}
function $db898b16f77fd380$var$getTruncatedJsonString(value) {
    if (typeof value === "string") return $l6DaT.truncateGenAiStringInput(value);
    try {
        return JSON.stringify(Array.isArray(value) ? $l6DaT.truncateGenAiMessages(value) : value);
    } catch  {
        return "[unserializable]";
    }
}
function $db898b16f77fd380$var$extractSystemInstructions(messages) {
    if (!Array.isArray(messages)) return {
        systemInstructions: void 0,
        filteredMessages: messages
    };
    const systemMessageIndex = messages.findIndex((msg)=>msg && typeof msg === "object" && "role" in msg && msg.role === "system");
    if (systemMessageIndex === -1) return {
        systemInstructions: void 0,
        filteredMessages: messages
    };
    const systemMessage = messages[systemMessageIndex];
    const systemContent = typeof systemMessage.content === "string" ? systemMessage.content : systemMessage.content !== void 0 ? JSON.stringify(systemMessage.content) : void 0;
    if (!systemContent) return {
        systemInstructions: void 0,
        filteredMessages: messages
    };
    const systemInstructions = JSON.stringify([
        {
            type: "text",
            content: systemContent
        }
    ]);
    const filteredMessages = [
        ...messages.slice(0, systemMessageIndex),
        ...messages.slice(systemMessageIndex + 1)
    ];
    return {
        systemInstructions: systemInstructions,
        filteredMessages: filteredMessages
    };
}
async function $db898b16f77fd380$var$createWithResponseWrapper(originalWithResponse, instrumentedPromise, mechanismType) {
    const safeOriginalWithResponse = originalWithResponse.catch((error)=>{
        $1tl8I.captureException(error, {
            mechanism: {
                handled: false,
                type: mechanismType
            }
        });
        throw error;
    });
    const instrumentedResult = await instrumentedPromise;
    const originalWrapper = await safeOriginalWithResponse;
    if (originalWrapper && typeof originalWrapper === "object" && "data" in originalWrapper) return {
        ...originalWrapper,
        data: instrumentedResult
    };
    return instrumentedResult;
}
function $db898b16f77fd380$var$wrapPromiseWithMethods(originalPromiseLike, instrumentedPromise, mechanismType) {
    if (!$dzfKZ.isThenable(originalPromiseLike)) return instrumentedPromise;
    return new Proxy(originalPromiseLike, {
        get (target, prop) {
            const useInstrumentedPromise = prop in Promise.prototype || prop === Symbol.toStringTag;
            const source = useInstrumentedPromise ? instrumentedPromise : target;
            const value = Reflect.get(source, prop);
            if (prop === "withResponse" && typeof value === "function") return function wrappedWithResponse() {
                const originalWithResponse = value.call(target);
                return $db898b16f77fd380$var$createWithResponseWrapper(originalWithResponse, instrumentedPromise, mechanismType);
            };
            return typeof value === "function" ? value.bind(source) : value;
        }
    });
}
module.exports.buildMethodPath = $db898b16f77fd380$var$buildMethodPath;
module.exports.endStreamSpan = $db898b16f77fd380$var$endStreamSpan;
module.exports.extractSystemInstructions = $db898b16f77fd380$var$extractSystemInstructions;
module.exports.getTruncatedJsonString = $db898b16f77fd380$var$getTruncatedJsonString;
module.exports.resolveAIRecordingOptions = $db898b16f77fd380$var$resolveAIRecordingOptions;
module.exports.setTokenUsageAttributes = $db898b16f77fd380$var$setTokenUsageAttributes;
module.exports.shouldEnableTruncation = $db898b16f77fd380$var$shouldEnableTruncation;
module.exports.wrapPromiseWithMethods = $db898b16f77fd380$var$wrapPromiseWithMethods;

});
parcelRegister("MHfcn", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $09260731ccacb6e9$var$GEN_AI_PROMPT_ATTRIBUTE = "gen_ai.prompt";
const $09260731ccacb6e9$var$GEN_AI_SYSTEM_ATTRIBUTE = "gen_ai.system";
const $09260731ccacb6e9$var$GEN_AI_REQUEST_MODEL_ATTRIBUTE = "gen_ai.request.model";
const $09260731ccacb6e9$var$GEN_AI_REQUEST_STREAM_ATTRIBUTE = "gen_ai.request.stream";
const $09260731ccacb6e9$var$GEN_AI_REQUEST_TEMPERATURE_ATTRIBUTE = "gen_ai.request.temperature";
const $09260731ccacb6e9$var$GEN_AI_REQUEST_MAX_TOKENS_ATTRIBUTE = "gen_ai.request.max_tokens";
const $09260731ccacb6e9$var$GEN_AI_REQUEST_FREQUENCY_PENALTY_ATTRIBUTE = "gen_ai.request.frequency_penalty";
const $09260731ccacb6e9$var$GEN_AI_REQUEST_PRESENCE_PENALTY_ATTRIBUTE = "gen_ai.request.presence_penalty";
const $09260731ccacb6e9$var$GEN_AI_REQUEST_TOP_P_ATTRIBUTE = "gen_ai.request.top_p";
const $09260731ccacb6e9$var$GEN_AI_REQUEST_TOP_K_ATTRIBUTE = "gen_ai.request.top_k";
const $09260731ccacb6e9$var$GEN_AI_REQUEST_ENCODING_FORMAT_ATTRIBUTE = "gen_ai.request.encoding_format";
const $09260731ccacb6e9$var$GEN_AI_REQUEST_DIMENSIONS_ATTRIBUTE = "gen_ai.request.dimensions";
const $09260731ccacb6e9$var$GEN_AI_RESPONSE_FINISH_REASONS_ATTRIBUTE = "gen_ai.response.finish_reasons";
const $09260731ccacb6e9$var$GEN_AI_RESPONSE_MODEL_ATTRIBUTE = "gen_ai.response.model";
const $09260731ccacb6e9$var$GEN_AI_RESPONSE_ID_ATTRIBUTE = "gen_ai.response.id";
const $09260731ccacb6e9$var$GEN_AI_RESPONSE_STOP_REASON_ATTRIBUTE = "gen_ai.response.stop_reason";
const $09260731ccacb6e9$var$GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE = "gen_ai.usage.input_tokens";
const $09260731ccacb6e9$var$GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE = "gen_ai.usage.output_tokens";
const $09260731ccacb6e9$var$GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE = "gen_ai.usage.total_tokens";
const $09260731ccacb6e9$var$GEN_AI_OPERATION_NAME_ATTRIBUTE = "gen_ai.operation.name";
const $09260731ccacb6e9$var$GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE = "sentry.sdk_meta.gen_ai.input.messages.original_length";
const $09260731ccacb6e9$var$GEN_AI_INPUT_MESSAGES_ATTRIBUTE = "gen_ai.input.messages";
const $09260731ccacb6e9$var$GEN_AI_OUTPUT_MESSAGES_ATTRIBUTE = "gen_ai.output.messages";
const $09260731ccacb6e9$var$GEN_AI_SYSTEM_INSTRUCTIONS_ATTRIBUTE = "gen_ai.system_instructions";
const $09260731ccacb6e9$var$GEN_AI_RESPONSE_TEXT_ATTRIBUTE = "gen_ai.response.text";
const $09260731ccacb6e9$var$GEN_AI_REQUEST_AVAILABLE_TOOLS_ATTRIBUTE = "gen_ai.request.available_tools";
const $09260731ccacb6e9$var$GEN_AI_RESPONSE_STREAMING_ATTRIBUTE = "gen_ai.response.streaming";
const $09260731ccacb6e9$var$GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE = "gen_ai.response.tool_calls";
const $09260731ccacb6e9$var$GEN_AI_AGENT_NAME_ATTRIBUTE = "gen_ai.agent.name";
const $09260731ccacb6e9$var$GEN_AI_PIPELINE_NAME_ATTRIBUTE = "gen_ai.pipeline.name";
const $09260731ccacb6e9$var$GEN_AI_CONVERSATION_ID_ATTRIBUTE = "gen_ai.conversation.id";
const $09260731ccacb6e9$var$GEN_AI_USAGE_CACHE_CREATION_INPUT_TOKENS_ATTRIBUTE = "gen_ai.usage.cache_creation_input_tokens";
const $09260731ccacb6e9$var$GEN_AI_USAGE_CACHE_READ_INPUT_TOKENS_ATTRIBUTE = "gen_ai.usage.cache_read_input_tokens";
const $09260731ccacb6e9$var$GEN_AI_USAGE_INPUT_TOKENS_CACHE_WRITE_ATTRIBUTE = "gen_ai.usage.input_tokens.cache_write";
const $09260731ccacb6e9$var$GEN_AI_USAGE_INPUT_TOKENS_CACHED_ATTRIBUTE = "gen_ai.usage.input_tokens.cached";
const $09260731ccacb6e9$var$GEN_AI_INVOKE_AGENT_OPERATION_ATTRIBUTE = "gen_ai.invoke_agent";
const $09260731ccacb6e9$var$GEN_AI_EMBEDDINGS_INPUT_ATTRIBUTE = "gen_ai.embeddings.input";
const $09260731ccacb6e9$var$GEN_AI_EMBEDDINGS_OPERATION_ATTRIBUTE = "gen_ai.embeddings";
const $09260731ccacb6e9$var$GEN_AI_EXECUTE_TOOL_OPERATION_ATTRIBUTE = "gen_ai.execute_tool";
const $09260731ccacb6e9$var$GEN_AI_TOOL_NAME_ATTRIBUTE = "gen_ai.tool.name";
const $09260731ccacb6e9$var$GEN_AI_TOOL_CALL_ID_ATTRIBUTE = "gen_ai.tool.call.id";
const $09260731ccacb6e9$var$GEN_AI_TOOL_TYPE_ATTRIBUTE = "gen_ai.tool.type";
const $09260731ccacb6e9$var$GEN_AI_TOOL_INPUT_ATTRIBUTE = "gen_ai.tool.input";
const $09260731ccacb6e9$var$GEN_AI_TOOL_OUTPUT_ATTRIBUTE = "gen_ai.tool.output";
const $09260731ccacb6e9$var$GEN_AI_TOOL_DESCRIPTION_ATTRIBUTE = "gen_ai.tool.description";
module.exports.GEN_AI_AGENT_NAME_ATTRIBUTE = $09260731ccacb6e9$var$GEN_AI_AGENT_NAME_ATTRIBUTE;
module.exports.GEN_AI_CONVERSATION_ID_ATTRIBUTE = $09260731ccacb6e9$var$GEN_AI_CONVERSATION_ID_ATTRIBUTE;
module.exports.GEN_AI_EMBEDDINGS_INPUT_ATTRIBUTE = $09260731ccacb6e9$var$GEN_AI_EMBEDDINGS_INPUT_ATTRIBUTE;
module.exports.GEN_AI_EMBEDDINGS_OPERATION_ATTRIBUTE = $09260731ccacb6e9$var$GEN_AI_EMBEDDINGS_OPERATION_ATTRIBUTE;
module.exports.GEN_AI_EXECUTE_TOOL_OPERATION_ATTRIBUTE = $09260731ccacb6e9$var$GEN_AI_EXECUTE_TOOL_OPERATION_ATTRIBUTE;
module.exports.GEN_AI_INPUT_MESSAGES_ATTRIBUTE = $09260731ccacb6e9$var$GEN_AI_INPUT_MESSAGES_ATTRIBUTE;
module.exports.GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE = $09260731ccacb6e9$var$GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE;
module.exports.GEN_AI_INVOKE_AGENT_OPERATION_ATTRIBUTE = $09260731ccacb6e9$var$GEN_AI_INVOKE_AGENT_OPERATION_ATTRIBUTE;
module.exports.GEN_AI_OPERATION_NAME_ATTRIBUTE = $09260731ccacb6e9$var$GEN_AI_OPERATION_NAME_ATTRIBUTE;
module.exports.GEN_AI_OUTPUT_MESSAGES_ATTRIBUTE = $09260731ccacb6e9$var$GEN_AI_OUTPUT_MESSAGES_ATTRIBUTE;
module.exports.GEN_AI_PIPELINE_NAME_ATTRIBUTE = $09260731ccacb6e9$var$GEN_AI_PIPELINE_NAME_ATTRIBUTE;
module.exports.GEN_AI_PROMPT_ATTRIBUTE = $09260731ccacb6e9$var$GEN_AI_PROMPT_ATTRIBUTE;
module.exports.GEN_AI_REQUEST_AVAILABLE_TOOLS_ATTRIBUTE = $09260731ccacb6e9$var$GEN_AI_REQUEST_AVAILABLE_TOOLS_ATTRIBUTE;
module.exports.GEN_AI_REQUEST_DIMENSIONS_ATTRIBUTE = $09260731ccacb6e9$var$GEN_AI_REQUEST_DIMENSIONS_ATTRIBUTE;
module.exports.GEN_AI_REQUEST_ENCODING_FORMAT_ATTRIBUTE = $09260731ccacb6e9$var$GEN_AI_REQUEST_ENCODING_FORMAT_ATTRIBUTE;
module.exports.GEN_AI_REQUEST_FREQUENCY_PENALTY_ATTRIBUTE = $09260731ccacb6e9$var$GEN_AI_REQUEST_FREQUENCY_PENALTY_ATTRIBUTE;
module.exports.GEN_AI_REQUEST_MAX_TOKENS_ATTRIBUTE = $09260731ccacb6e9$var$GEN_AI_REQUEST_MAX_TOKENS_ATTRIBUTE;
module.exports.GEN_AI_REQUEST_MODEL_ATTRIBUTE = $09260731ccacb6e9$var$GEN_AI_REQUEST_MODEL_ATTRIBUTE;
module.exports.GEN_AI_REQUEST_PRESENCE_PENALTY_ATTRIBUTE = $09260731ccacb6e9$var$GEN_AI_REQUEST_PRESENCE_PENALTY_ATTRIBUTE;
module.exports.GEN_AI_REQUEST_STREAM_ATTRIBUTE = $09260731ccacb6e9$var$GEN_AI_REQUEST_STREAM_ATTRIBUTE;
module.exports.GEN_AI_REQUEST_TEMPERATURE_ATTRIBUTE = $09260731ccacb6e9$var$GEN_AI_REQUEST_TEMPERATURE_ATTRIBUTE;
module.exports.GEN_AI_REQUEST_TOP_K_ATTRIBUTE = $09260731ccacb6e9$var$GEN_AI_REQUEST_TOP_K_ATTRIBUTE;
module.exports.GEN_AI_REQUEST_TOP_P_ATTRIBUTE = $09260731ccacb6e9$var$GEN_AI_REQUEST_TOP_P_ATTRIBUTE;
module.exports.GEN_AI_RESPONSE_FINISH_REASONS_ATTRIBUTE = $09260731ccacb6e9$var$GEN_AI_RESPONSE_FINISH_REASONS_ATTRIBUTE;
module.exports.GEN_AI_RESPONSE_ID_ATTRIBUTE = $09260731ccacb6e9$var$GEN_AI_RESPONSE_ID_ATTRIBUTE;
module.exports.GEN_AI_RESPONSE_MODEL_ATTRIBUTE = $09260731ccacb6e9$var$GEN_AI_RESPONSE_MODEL_ATTRIBUTE;
module.exports.GEN_AI_RESPONSE_STOP_REASON_ATTRIBUTE = $09260731ccacb6e9$var$GEN_AI_RESPONSE_STOP_REASON_ATTRIBUTE;
module.exports.GEN_AI_RESPONSE_STREAMING_ATTRIBUTE = $09260731ccacb6e9$var$GEN_AI_RESPONSE_STREAMING_ATTRIBUTE;
module.exports.GEN_AI_RESPONSE_TEXT_ATTRIBUTE = $09260731ccacb6e9$var$GEN_AI_RESPONSE_TEXT_ATTRIBUTE;
module.exports.GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE = $09260731ccacb6e9$var$GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE;
module.exports.GEN_AI_SYSTEM_ATTRIBUTE = $09260731ccacb6e9$var$GEN_AI_SYSTEM_ATTRIBUTE;
module.exports.GEN_AI_SYSTEM_INSTRUCTIONS_ATTRIBUTE = $09260731ccacb6e9$var$GEN_AI_SYSTEM_INSTRUCTIONS_ATTRIBUTE;
module.exports.GEN_AI_TOOL_CALL_ID_ATTRIBUTE = $09260731ccacb6e9$var$GEN_AI_TOOL_CALL_ID_ATTRIBUTE;
module.exports.GEN_AI_TOOL_DESCRIPTION_ATTRIBUTE = $09260731ccacb6e9$var$GEN_AI_TOOL_DESCRIPTION_ATTRIBUTE;
module.exports.GEN_AI_TOOL_INPUT_ATTRIBUTE = $09260731ccacb6e9$var$GEN_AI_TOOL_INPUT_ATTRIBUTE;
module.exports.GEN_AI_TOOL_NAME_ATTRIBUTE = $09260731ccacb6e9$var$GEN_AI_TOOL_NAME_ATTRIBUTE;
module.exports.GEN_AI_TOOL_OUTPUT_ATTRIBUTE = $09260731ccacb6e9$var$GEN_AI_TOOL_OUTPUT_ATTRIBUTE;
module.exports.GEN_AI_TOOL_TYPE_ATTRIBUTE = $09260731ccacb6e9$var$GEN_AI_TOOL_TYPE_ATTRIBUTE;
module.exports.GEN_AI_USAGE_CACHE_CREATION_INPUT_TOKENS_ATTRIBUTE = $09260731ccacb6e9$var$GEN_AI_USAGE_CACHE_CREATION_INPUT_TOKENS_ATTRIBUTE;
module.exports.GEN_AI_USAGE_CACHE_READ_INPUT_TOKENS_ATTRIBUTE = $09260731ccacb6e9$var$GEN_AI_USAGE_CACHE_READ_INPUT_TOKENS_ATTRIBUTE;
module.exports.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE = $09260731ccacb6e9$var$GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE;
module.exports.GEN_AI_USAGE_INPUT_TOKENS_CACHED_ATTRIBUTE = $09260731ccacb6e9$var$GEN_AI_USAGE_INPUT_TOKENS_CACHED_ATTRIBUTE;
module.exports.GEN_AI_USAGE_INPUT_TOKENS_CACHE_WRITE_ATTRIBUTE = $09260731ccacb6e9$var$GEN_AI_USAGE_INPUT_TOKENS_CACHE_WRITE_ATTRIBUTE;
module.exports.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE = $09260731ccacb6e9$var$GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE;
module.exports.GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE = $09260731ccacb6e9$var$GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE;

});

parcelRegister("l6DaT", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $fomXY = parcelRequire("fomXY");
const $f5d88bcb2579e71f$var$DEFAULT_GEN_AI_MESSAGES_BYTE_LIMIT = 2e4;
const $f5d88bcb2579e71f$var$utf8Bytes = (text)=>{
    return new TextEncoder().encode(text).length;
};
const $f5d88bcb2579e71f$var$jsonBytes = (value)=>{
    return $f5d88bcb2579e71f$var$utf8Bytes(JSON.stringify(value));
};
function $f5d88bcb2579e71f$var$truncateTextByBytes(text, maxBytes) {
    if ($f5d88bcb2579e71f$var$utf8Bytes(text) <= maxBytes) return text;
    let low = 0;
    let high = text.length;
    let bestFit = "";
    while(low <= high){
        const mid = Math.floor((low + high) / 2);
        const candidate = text.slice(0, mid);
        const byteSize = $f5d88bcb2579e71f$var$utf8Bytes(candidate);
        if (byteSize <= maxBytes) {
            bestFit = candidate;
            low = mid + 1;
        } else high = mid - 1;
    }
    return bestFit;
}
function $f5d88bcb2579e71f$var$getItemText(item) {
    if (typeof item === "string") return item;
    if ("text" in item && typeof item.text === "string") return item.text;
    return "";
}
function $f5d88bcb2579e71f$var$withItemText(item, text) {
    if (typeof item === "string") return text;
    return {
        ...item,
        text: text
    };
}
function $f5d88bcb2579e71f$var$isContentMessage(message) {
    return message !== null && typeof message === "object" && "content" in message && typeof message.content === "string";
}
function $f5d88bcb2579e71f$var$isContentArrayMessage(message) {
    return message !== null && typeof message === "object" && "content" in message && Array.isArray(message.content);
}
function $f5d88bcb2579e71f$var$isPartsMessage(message) {
    return message !== null && typeof message === "object" && "parts" in message && Array.isArray(message.parts) && message.parts.length > 0;
}
function $f5d88bcb2579e71f$var$truncateContentMessage(message, maxBytes) {
    const emptyMessage = {
        ...message,
        content: ""
    };
    const overhead = $f5d88bcb2579e71f$var$jsonBytes(emptyMessage);
    const availableForContent = maxBytes - overhead;
    if (availableForContent <= 0) return [];
    const truncatedContent = $f5d88bcb2579e71f$var$truncateTextByBytes(message.content, availableForContent);
    return [
        {
            ...message,
            content: truncatedContent
        }
    ];
}
function $f5d88bcb2579e71f$var$getArrayItems(message) {
    if ("parts" in message && Array.isArray(message.parts)) return {
        key: "parts",
        items: message.parts
    };
    if ("content" in message && Array.isArray(message.content)) return {
        key: "content",
        items: message.content
    };
    return {
        key: null,
        items: []
    };
}
function $f5d88bcb2579e71f$var$truncateArrayMessage(message, maxBytes) {
    const { key: key, items: items } = $f5d88bcb2579e71f$var$getArrayItems(message);
    if (key === null || items.length === 0) return [];
    const emptyItems = items.map((item)=>$f5d88bcb2579e71f$var$withItemText(item, ""));
    const overhead = $f5d88bcb2579e71f$var$jsonBytes({
        ...message,
        [key]: emptyItems
    });
    let remainingBytes = maxBytes - overhead;
    if (remainingBytes <= 0) return [];
    const includedItems = [];
    for (const item of items){
        const text = $f5d88bcb2579e71f$var$getItemText(item);
        const textSize = $f5d88bcb2579e71f$var$utf8Bytes(text);
        if (textSize <= remainingBytes) {
            includedItems.push(item);
            remainingBytes -= textSize;
        } else if (includedItems.length === 0) {
            const truncated = $f5d88bcb2579e71f$var$truncateTextByBytes(text, remainingBytes);
            if (truncated) includedItems.push($f5d88bcb2579e71f$var$withItemText(item, truncated));
            break;
        } else break;
    }
    if (includedItems.length <= 0) return [];
    else return [
        {
            ...message,
            [key]: includedItems
        }
    ];
}
function $f5d88bcb2579e71f$var$truncateSingleMessage(message, maxBytes) {
    if (!message) return [];
    if (typeof message === "string") {
        const truncated = $f5d88bcb2579e71f$var$truncateTextByBytes(message, maxBytes);
        return truncated ? [
            truncated
        ] : [];
    }
    if (typeof message !== "object") return [];
    if ($f5d88bcb2579e71f$var$isContentMessage(message)) return $f5d88bcb2579e71f$var$truncateContentMessage(message, maxBytes);
    if ($f5d88bcb2579e71f$var$isContentArrayMessage(message) || $f5d88bcb2579e71f$var$isPartsMessage(message)) return $f5d88bcb2579e71f$var$truncateArrayMessage(message, maxBytes);
    return [];
}
function $f5d88bcb2579e71f$var$stripInlineMediaFromMessages(messages) {
    const stripped = messages.map((message)=>{
        let newMessage = void 0;
        if (!!message && typeof message === "object") {
            if ($f5d88bcb2579e71f$var$isContentArrayMessage(message)) newMessage = {
                ...message,
                content: $f5d88bcb2579e71f$var$stripInlineMediaFromMessages(message.content)
            };
            else if ("content" in message && $fomXY.isContentMedia(message.content)) newMessage = {
                ...message,
                content: $fomXY.stripInlineMediaFromSingleMessage(message.content)
            };
            if ($f5d88bcb2579e71f$var$isPartsMessage(message)) newMessage = {
                // might have to strip content AND parts
                ...newMessage ?? message,
                parts: $f5d88bcb2579e71f$var$stripInlineMediaFromMessages(message.parts)
            };
            if ($fomXY.isContentMedia(newMessage)) newMessage = $fomXY.stripInlineMediaFromSingleMessage(newMessage);
            else if ($fomXY.isContentMedia(message)) newMessage = $fomXY.stripInlineMediaFromSingleMessage(message);
        }
        return newMessage ?? message;
    });
    return stripped;
}
function $f5d88bcb2579e71f$var$truncateMessagesByBytes(messages, maxBytes) {
    if (!Array.isArray(messages) || messages.length === 0) return messages;
    const effectiveMaxBytes = maxBytes - 2;
    const lastMessage = messages[messages.length - 1];
    const stripped = $f5d88bcb2579e71f$var$stripInlineMediaFromMessages([
        lastMessage
    ]);
    const strippedMessage = stripped[0];
    const messageBytes = $f5d88bcb2579e71f$var$jsonBytes(strippedMessage);
    if (messageBytes <= effectiveMaxBytes) return stripped;
    return $f5d88bcb2579e71f$var$truncateSingleMessage(strippedMessage, effectiveMaxBytes);
}
function $f5d88bcb2579e71f$var$truncateGenAiMessages(messages) {
    return $f5d88bcb2579e71f$var$truncateMessagesByBytes(messages, $f5d88bcb2579e71f$var$DEFAULT_GEN_AI_MESSAGES_BYTE_LIMIT);
}
function $f5d88bcb2579e71f$var$truncateGenAiStringInput(input) {
    return $f5d88bcb2579e71f$var$truncateTextByBytes(input, $f5d88bcb2579e71f$var$DEFAULT_GEN_AI_MESSAGES_BYTE_LIMIT);
}
module.exports.DEFAULT_GEN_AI_MESSAGES_BYTE_LIMIT = $f5d88bcb2579e71f$var$DEFAULT_GEN_AI_MESSAGES_BYTE_LIMIT;
module.exports.truncateGenAiMessages = $f5d88bcb2579e71f$var$truncateGenAiMessages;
module.exports.truncateGenAiStringInput = $f5d88bcb2579e71f$var$truncateGenAiStringInput;

});
parcelRegister("fomXY", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $b34ae98baa703fc6$var$isContentMedia(part) {
    if (!part || typeof part !== "object") return false;
    return $b34ae98baa703fc6$var$isContentMediaSource(part) || $b34ae98baa703fc6$var$hasInlineData(part) || $b34ae98baa703fc6$var$hasImageUrl(part) || $b34ae98baa703fc6$var$hasInputAudio(part) || $b34ae98baa703fc6$var$hasFileData(part) || $b34ae98baa703fc6$var$hasMediaTypeData(part) || $b34ae98baa703fc6$var$hasVercelFileData(part) || $b34ae98baa703fc6$var$hasVercelImageData(part) || $b34ae98baa703fc6$var$hasBlobOrBase64Type(part) || $b34ae98baa703fc6$var$hasB64Json(part) || $b34ae98baa703fc6$var$hasImageGenerationResult(part) || $b34ae98baa703fc6$var$hasDataUri(part);
}
function $b34ae98baa703fc6$var$hasImageUrl(part) {
    if (!("image_url" in part)) return false;
    if (typeof part.image_url === "string") return part.image_url.startsWith("data:");
    return $b34ae98baa703fc6$var$hasNestedImageUrl(part);
}
function $b34ae98baa703fc6$var$hasNestedImageUrl(part) {
    return "image_url" in part && !!part.image_url && typeof part.image_url === "object" && "url" in part.image_url && typeof part.image_url.url === "string" && part.image_url.url.startsWith("data:");
}
function $b34ae98baa703fc6$var$isContentMediaSource(part) {
    return "type" in part && typeof part.type === "string" && "source" in part && $b34ae98baa703fc6$var$isContentMedia(part.source);
}
function $b34ae98baa703fc6$var$hasInlineData(part) {
    return "inlineData" in part && !!part.inlineData && typeof part.inlineData === "object" && "data" in part.inlineData && typeof part.inlineData.data === "string";
}
function $b34ae98baa703fc6$var$hasInputAudio(part) {
    return "type" in part && part.type === "input_audio" && "input_audio" in part && !!part.input_audio && typeof part.input_audio === "object" && "data" in part.input_audio && typeof part.input_audio.data === "string";
}
function $b34ae98baa703fc6$var$hasFileData(part) {
    return "type" in part && part.type === "file" && "file" in part && !!part.file && typeof part.file === "object" && "file_data" in part.file && typeof part.file.file_data === "string";
}
function $b34ae98baa703fc6$var$hasMediaTypeData(part) {
    return "media_type" in part && typeof part.media_type === "string" && "data" in part;
}
function $b34ae98baa703fc6$var$hasVercelFileData(part) {
    return "type" in part && part.type === "file" && "mediaType" in part && typeof part.mediaType === "string" && "data" in part && typeof part.data === "string" && // Only strip base64/binary data, not HTTP/HTTPS URLs which should be preserved as references
    !part.data.startsWith("http://") && !part.data.startsWith("https://");
}
function $b34ae98baa703fc6$var$hasVercelImageData(part) {
    return "type" in part && part.type === "image" && "image" in part && typeof part.image === "string" && // Only strip base64/data URIs, not HTTP/HTTPS URLs which should be preserved as references
    !part.image.startsWith("http://") && !part.image.startsWith("https://");
}
function $b34ae98baa703fc6$var$hasBlobOrBase64Type(part) {
    return "type" in part && (part.type === "blob" || part.type === "base64");
}
function $b34ae98baa703fc6$var$hasB64Json(part) {
    return "b64_json" in part;
}
function $b34ae98baa703fc6$var$hasImageGenerationResult(part) {
    return "type" in part && "result" in part && part.type === "image_generation";
}
function $b34ae98baa703fc6$var$hasDataUri(part) {
    return "uri" in part && typeof part.uri === "string" && part.uri.startsWith("data:");
}
const $b34ae98baa703fc6$var$REMOVED_STRING = "[Blob substitute]";
const $b34ae98baa703fc6$var$MEDIA_FIELDS = [
    "image_url",
    "data",
    "content",
    "b64_json",
    "result",
    "uri",
    "image"
];
function $b34ae98baa703fc6$var$stripInlineMediaFromSingleMessage(part) {
    const strip = {
        ...part
    };
    if ($b34ae98baa703fc6$var$isContentMedia(strip.source)) strip.source = $b34ae98baa703fc6$var$stripInlineMediaFromSingleMessage(strip.source);
    if ($b34ae98baa703fc6$var$hasInlineData(part)) strip.inlineData = {
        ...part.inlineData,
        data: $b34ae98baa703fc6$var$REMOVED_STRING
    };
    if ($b34ae98baa703fc6$var$hasNestedImageUrl(part)) strip.image_url = {
        ...part.image_url,
        url: $b34ae98baa703fc6$var$REMOVED_STRING
    };
    if ($b34ae98baa703fc6$var$hasInputAudio(part)) strip.input_audio = {
        ...part.input_audio,
        data: $b34ae98baa703fc6$var$REMOVED_STRING
    };
    if ($b34ae98baa703fc6$var$hasFileData(part)) strip.file = {
        ...part.file,
        file_data: $b34ae98baa703fc6$var$REMOVED_STRING
    };
    for (const field of $b34ae98baa703fc6$var$MEDIA_FIELDS)if (typeof strip[field] === "string") strip[field] = $b34ae98baa703fc6$var$REMOVED_STRING;
    return strip;
}
module.exports.isContentMedia = $b34ae98baa703fc6$var$isContentMedia;
module.exports.stripInlineMediaFromSingleMessage = $b34ae98baa703fc6$var$stripInlineMediaFromSingleMessage;

});



parcelRegister("dqmpD", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $9c5f16bcb474c656$var$toolCallSpanContextMap = /* @__PURE__ */ new Map();
const $9c5f16bcb474c656$var$toolDescriptionMap = /* @__PURE__ */ new Map();
const $9c5f16bcb474c656$var$SPAN_TO_OPERATION_NAME = /* @__PURE__ */ new Map([
    [
        "ai.generateText",
        "invoke_agent"
    ],
    [
        "ai.streamText",
        "invoke_agent"
    ],
    [
        "ai.generateObject",
        "invoke_agent"
    ],
    [
        "ai.streamObject",
        "invoke_agent"
    ],
    [
        "ai.generateText.doGenerate",
        "generate_content"
    ],
    [
        "ai.streamText.doStream",
        "generate_content"
    ],
    [
        "ai.generateObject.doGenerate",
        "generate_content"
    ],
    [
        "ai.streamObject.doStream",
        "generate_content"
    ],
    [
        "ai.embed.doEmbed",
        "embeddings"
    ],
    [
        "ai.embedMany.doEmbed",
        "embeddings"
    ],
    [
        "ai.rerank.doRerank",
        "rerank"
    ],
    [
        "ai.toolCall",
        "execute_tool"
    ]
]);
module.exports.SPAN_TO_OPERATION_NAME = $9c5f16bcb474c656$var$SPAN_TO_OPERATION_NAME;
module.exports.toolCallSpanContextMap = $9c5f16bcb474c656$var$toolCallSpanContextMap;
module.exports.toolDescriptionMap = $9c5f16bcb474c656$var$toolDescriptionMap;

});

parcelRegister("azBVI", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $MHfcn = parcelRequire("MHfcn");

var $iQAGO = parcelRequire("iQAGO");

var $arYVC = parcelRequire("arYVC");

var $dqmpD = parcelRequire("dqmpD");

var $lwvSk = parcelRequire("lwvSk");
function $7b2a9860d75ccca7$var$accumulateTokensForParent(span, tokenAccumulator) {
    const parentSpanId = span.parent_span_id;
    if (!parentSpanId) return;
    const inputTokens = span.data[$MHfcn.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE];
    const outputTokens = span.data[$MHfcn.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE];
    if (typeof inputTokens === "number" || typeof outputTokens === "number") {
        const existing = tokenAccumulator.get(parentSpanId) || {
            inputTokens: 0,
            outputTokens: 0
        };
        if (typeof inputTokens === "number") existing.inputTokens += inputTokens;
        if (typeof outputTokens === "number") existing.outputTokens += outputTokens;
        tokenAccumulator.set(parentSpanId, existing);
    }
}
function $7b2a9860d75ccca7$var$applyAccumulatedTokens(spanOrTrace, tokenAccumulator) {
    const accumulated = tokenAccumulator.get(spanOrTrace.span_id);
    if (!accumulated || !spanOrTrace.data) return;
    if (accumulated.inputTokens > 0) spanOrTrace.data[$MHfcn.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE] = accumulated.inputTokens;
    if (accumulated.outputTokens > 0) spanOrTrace.data[$MHfcn.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE] = accumulated.outputTokens;
    if (accumulated.inputTokens > 0 || accumulated.outputTokens > 0) spanOrTrace.data["gen_ai.usage.total_tokens"] = accumulated.inputTokens + accumulated.outputTokens;
}
function $7b2a9860d75ccca7$var$buildToolDescriptionMap(spans) {
    const toolDescriptions = /* @__PURE__ */ new Map();
    for (const span of spans){
        const availableTools = span.data[$MHfcn.GEN_AI_REQUEST_AVAILABLE_TOOLS_ATTRIBUTE];
        if (typeof availableTools !== "string") continue;
        try {
            const tools = JSON.parse(availableTools);
            for (const tool of tools)if (tool.name && tool.description && !toolDescriptions.has(tool.name)) toolDescriptions.set(tool.name, tool.description);
        } catch  {}
    }
    return toolDescriptions;
}
function $7b2a9860d75ccca7$var$applyToolDescriptionsAndTokens(spans, tokenAccumulator) {
    const toolDescriptions = $7b2a9860d75ccca7$var$buildToolDescriptionMap(spans);
    for (const span of spans){
        if (span.op === "gen_ai.execute_tool") {
            const toolName = span.data[$MHfcn.GEN_AI_TOOL_NAME_ATTRIBUTE];
            if (typeof toolName === "string") {
                const description = toolDescriptions.get(toolName);
                if (description) span.data[$MHfcn.GEN_AI_TOOL_DESCRIPTION_ATTRIBUTE] = description;
            }
        }
        if (span.op === "gen_ai.invoke_agent") $7b2a9860d75ccca7$var$applyAccumulatedTokens(span, tokenAccumulator);
    }
}
function $7b2a9860d75ccca7$var$_INTERNAL_getSpanContextForToolCallId(toolCallId) {
    return $dqmpD.toolCallSpanContextMap.get(toolCallId);
}
function $7b2a9860d75ccca7$var$_INTERNAL_cleanupToolCallSpanContext(toolCallId) {
    $dqmpD.toolCallSpanContextMap.delete(toolCallId);
}
function $7b2a9860d75ccca7$var$convertAvailableToolsToJsonString(tools) {
    const toolObjects = tools.map((tool)=>{
        if (typeof tool === "string") try {
            return JSON.parse(tool);
        } catch  {
            return tool;
        }
        return tool;
    });
    return JSON.stringify(toolObjects);
}
function $7b2a9860d75ccca7$var$filterMessagesArray(input) {
    return input.filter((m)=>!!m && typeof m === "object" && "role" in m && "content" in m);
}
function $7b2a9860d75ccca7$var$convertUserInputToMessagesFormat(userInput) {
    try {
        const p = JSON.parse(userInput);
        if (!!p && typeof p === "object") {
            let { messages: messages } = p;
            const { prompt: prompt, system: system } = p;
            const result = [];
            if (typeof system === "string") result.push({
                role: "system",
                content: system
            });
            if (typeof messages === "string") try {
                messages = JSON.parse(messages);
            } catch  {}
            if (Array.isArray(messages)) {
                result.push(...$7b2a9860d75ccca7$var$filterMessagesArray(messages));
                return result;
            }
            if (Array.isArray(prompt)) {
                result.push(...$7b2a9860d75ccca7$var$filterMessagesArray(prompt));
                return result;
            }
            if (typeof prompt === "string") result.push({
                role: "user",
                content: prompt
            });
            if (result.length > 0) return result;
        }
    } catch  {}
    return [];
}
function $7b2a9860d75ccca7$var$requestMessagesFromPrompt(span, attributes, enableTruncation) {
    if (typeof attributes[$lwvSk.AI_PROMPT_ATTRIBUTE] === "string" && !attributes[$MHfcn.GEN_AI_INPUT_MESSAGES_ATTRIBUTE] && !attributes[$lwvSk.AI_PROMPT_MESSAGES_ATTRIBUTE]) {
        const userInput = attributes[$lwvSk.AI_PROMPT_ATTRIBUTE];
        const messages = $7b2a9860d75ccca7$var$convertUserInputToMessagesFormat(userInput);
        if (messages.length) {
            const { systemInstructions: systemInstructions, filteredMessages: filteredMessages } = $iQAGO.extractSystemInstructions(messages);
            if (systemInstructions) span.setAttribute($MHfcn.GEN_AI_SYSTEM_INSTRUCTIONS_ATTRIBUTE, systemInstructions);
            const filteredLength = Array.isArray(filteredMessages) ? filteredMessages.length : 0;
            const messagesJson = enableTruncation ? $iQAGO.getTruncatedJsonString(filteredMessages) : $arYVC.stringify(filteredMessages);
            span.setAttributes({
                [$lwvSk.AI_PROMPT_ATTRIBUTE]: messagesJson,
                [$MHfcn.GEN_AI_INPUT_MESSAGES_ATTRIBUTE]: messagesJson,
                [$MHfcn.GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE]: filteredLength
            });
        }
    } else if (typeof attributes[$lwvSk.AI_PROMPT_MESSAGES_ATTRIBUTE] === "string") {
        const originalMessagesJson = attributes[$lwvSk.AI_PROMPT_MESSAGES_ATTRIBUTE];
        try {
            const messages = JSON.parse(originalMessagesJson);
            if (Array.isArray(messages)) {
                const { systemInstructions: systemInstructions, filteredMessages: filteredMessages } = $iQAGO.extractSystemInstructions(messages);
                if (systemInstructions) span.setAttribute($MHfcn.GEN_AI_SYSTEM_INSTRUCTIONS_ATTRIBUTE, systemInstructions);
                const filteredLength = Array.isArray(filteredMessages) ? filteredMessages.length : 0;
                const messagesJson = !enableTruncation && filteredMessages === messages ? originalMessagesJson : enableTruncation ? $iQAGO.getTruncatedJsonString(filteredMessages) : $arYVC.stringify(filteredMessages);
                span.setAttributes({
                    [$lwvSk.AI_PROMPT_MESSAGES_ATTRIBUTE]: messagesJson,
                    [$MHfcn.GEN_AI_INPUT_MESSAGES_ATTRIBUTE]: messagesJson,
                    [$MHfcn.GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE]: filteredLength
                });
            }
        } catch  {}
    }
}
module.exports._INTERNAL_cleanupToolCallSpanContext = $7b2a9860d75ccca7$var$_INTERNAL_cleanupToolCallSpanContext;
module.exports._INTERNAL_getSpanContextForToolCallId = $7b2a9860d75ccca7$var$_INTERNAL_getSpanContextForToolCallId;
module.exports.accumulateTokensForParent = $7b2a9860d75ccca7$var$accumulateTokensForParent;
module.exports.applyAccumulatedTokens = $7b2a9860d75ccca7$var$applyAccumulatedTokens;
module.exports.applyToolDescriptionsAndTokens = $7b2a9860d75ccca7$var$applyToolDescriptionsAndTokens;
module.exports.convertAvailableToolsToJsonString = $7b2a9860d75ccca7$var$convertAvailableToolsToJsonString;
module.exports.convertUserInputToMessagesFormat = $7b2a9860d75ccca7$var$convertUserInputToMessagesFormat;
module.exports.requestMessagesFromPrompt = $7b2a9860d75ccca7$var$requestMessagesFromPrompt;

});
parcelRegister("lwvSk", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $fab54fe9af573439$var$OPERATION_NAME_ATTRIBUTE = "operation.name";
const $fab54fe9af573439$var$AI_OPERATION_ID_ATTRIBUTE = "ai.operationId";
const $fab54fe9af573439$var$AI_PROMPT_ATTRIBUTE = "ai.prompt";
const $fab54fe9af573439$var$AI_SCHEMA_ATTRIBUTE = "ai.schema";
const $fab54fe9af573439$var$AI_RESPONSE_OBJECT_ATTRIBUTE = "ai.response.object";
const $fab54fe9af573439$var$AI_VALUES_ATTRIBUTE = "ai.values";
const $fab54fe9af573439$var$AI_RESPONSE_TEXT_ATTRIBUTE = "ai.response.text";
const $fab54fe9af573439$var$AI_RESPONSE_TOOL_CALLS_ATTRIBUTE = "ai.response.toolCalls";
const $fab54fe9af573439$var$AI_RESPONSE_FINISH_REASON_ATTRIBUTE = "ai.response.finishReason";
const $fab54fe9af573439$var$AI_PROMPT_MESSAGES_ATTRIBUTE = "ai.prompt.messages";
const $fab54fe9af573439$var$AI_PROMPT_TOOLS_ATTRIBUTE = "ai.prompt.tools";
const $fab54fe9af573439$var$AI_MODEL_ID_ATTRIBUTE = "ai.model.id";
const $fab54fe9af573439$var$AI_RESPONSE_PROVIDER_METADATA_ATTRIBUTE = "ai.response.providerMetadata";
const $fab54fe9af573439$var$AI_USAGE_CACHED_INPUT_TOKENS_ATTRIBUTE = "ai.usage.cachedInputTokens";
const $fab54fe9af573439$var$AI_USAGE_INPUT_TOKEN_DETAILS_ATTRIBUTE_PREFIX = "ai.usage.inputTokenDetails.";
const $fab54fe9af573439$var$AI_TELEMETRY_FUNCTION_ID_ATTRIBUTE = "ai.telemetry.functionId";
const $fab54fe9af573439$var$AI_USAGE_COMPLETION_TOKENS_ATTRIBUTE = "ai.usage.completionTokens";
const $fab54fe9af573439$var$AI_USAGE_PROMPT_TOKENS_ATTRIBUTE = "ai.usage.promptTokens";
const $fab54fe9af573439$var$AI_USAGE_TOKENS_ATTRIBUTE = "ai.usage.tokens";
const $fab54fe9af573439$var$AI_TOOL_CALL_NAME_ATTRIBUTE = "ai.toolCall.name";
const $fab54fe9af573439$var$AI_TOOL_CALL_ID_ATTRIBUTE = "ai.toolCall.id";
const $fab54fe9af573439$var$AI_TOOL_CALL_ARGS_ATTRIBUTE = "ai.toolCall.args";
const $fab54fe9af573439$var$AI_TOOL_CALL_RESULT_ATTRIBUTE = "ai.toolCall.result";
module.exports.AI_MODEL_ID_ATTRIBUTE = $fab54fe9af573439$var$AI_MODEL_ID_ATTRIBUTE;
module.exports.AI_OPERATION_ID_ATTRIBUTE = $fab54fe9af573439$var$AI_OPERATION_ID_ATTRIBUTE;
module.exports.AI_PROMPT_ATTRIBUTE = $fab54fe9af573439$var$AI_PROMPT_ATTRIBUTE;
module.exports.AI_PROMPT_MESSAGES_ATTRIBUTE = $fab54fe9af573439$var$AI_PROMPT_MESSAGES_ATTRIBUTE;
module.exports.AI_PROMPT_TOOLS_ATTRIBUTE = $fab54fe9af573439$var$AI_PROMPT_TOOLS_ATTRIBUTE;
module.exports.AI_RESPONSE_FINISH_REASON_ATTRIBUTE = $fab54fe9af573439$var$AI_RESPONSE_FINISH_REASON_ATTRIBUTE;
module.exports.AI_RESPONSE_OBJECT_ATTRIBUTE = $fab54fe9af573439$var$AI_RESPONSE_OBJECT_ATTRIBUTE;
module.exports.AI_RESPONSE_PROVIDER_METADATA_ATTRIBUTE = $fab54fe9af573439$var$AI_RESPONSE_PROVIDER_METADATA_ATTRIBUTE;
module.exports.AI_RESPONSE_TEXT_ATTRIBUTE = $fab54fe9af573439$var$AI_RESPONSE_TEXT_ATTRIBUTE;
module.exports.AI_RESPONSE_TOOL_CALLS_ATTRIBUTE = $fab54fe9af573439$var$AI_RESPONSE_TOOL_CALLS_ATTRIBUTE;
module.exports.AI_SCHEMA_ATTRIBUTE = $fab54fe9af573439$var$AI_SCHEMA_ATTRIBUTE;
module.exports.AI_TELEMETRY_FUNCTION_ID_ATTRIBUTE = $fab54fe9af573439$var$AI_TELEMETRY_FUNCTION_ID_ATTRIBUTE;
module.exports.AI_TOOL_CALL_ARGS_ATTRIBUTE = $fab54fe9af573439$var$AI_TOOL_CALL_ARGS_ATTRIBUTE;
module.exports.AI_TOOL_CALL_ID_ATTRIBUTE = $fab54fe9af573439$var$AI_TOOL_CALL_ID_ATTRIBUTE;
module.exports.AI_TOOL_CALL_NAME_ATTRIBUTE = $fab54fe9af573439$var$AI_TOOL_CALL_NAME_ATTRIBUTE;
module.exports.AI_TOOL_CALL_RESULT_ATTRIBUTE = $fab54fe9af573439$var$AI_TOOL_CALL_RESULT_ATTRIBUTE;
module.exports.AI_USAGE_CACHED_INPUT_TOKENS_ATTRIBUTE = $fab54fe9af573439$var$AI_USAGE_CACHED_INPUT_TOKENS_ATTRIBUTE;
module.exports.AI_USAGE_COMPLETION_TOKENS_ATTRIBUTE = $fab54fe9af573439$var$AI_USAGE_COMPLETION_TOKENS_ATTRIBUTE;
module.exports.AI_USAGE_INPUT_TOKEN_DETAILS_ATTRIBUTE_PREFIX = $fab54fe9af573439$var$AI_USAGE_INPUT_TOKEN_DETAILS_ATTRIBUTE_PREFIX;
module.exports.AI_USAGE_PROMPT_TOKENS_ATTRIBUTE = $fab54fe9af573439$var$AI_USAGE_PROMPT_TOKENS_ATTRIBUTE;
module.exports.AI_USAGE_TOKENS_ATTRIBUTE = $fab54fe9af573439$var$AI_USAGE_TOKENS_ATTRIBUTE;
module.exports.AI_VALUES_ATTRIBUTE = $fab54fe9af573439$var$AI_VALUES_ATTRIBUTE;
module.exports.OPERATION_NAME_ATTRIBUTE = $fab54fe9af573439$var$OPERATION_NAME_ATTRIBUTE;

});



parcelRegister("823gY", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $hiZR1 = parcelRequire("hiZR1");

var $1tl8I = parcelRequire("1tl8I");

var $gTasE = parcelRequire("gTasE");

var $4gyod = parcelRequire("4gyod");

var $arYVC = parcelRequire("arYVC");

var $yI1C9 = parcelRequire("yI1C9");

var $kBDP8 = parcelRequire("kBDP8");

var $MHfcn = parcelRequire("MHfcn");

var $iQAGO = parcelRequire("iQAGO");

var $aaeQR = parcelRequire("aaeQR");

var $cMrSV = parcelRequire("cMrSV");

var $e6pkh = parcelRequire("e6pkh");
function $5d910c8c982f1bc6$var$extractAvailableTools(params) {
    const tools = Array.isArray(params.tools) ? params.tools : [];
    const hasWebSearchOptions = params.web_search_options && typeof params.web_search_options === "object";
    const webSearchOptions = hasWebSearchOptions ? [
        {
            type: "web_search_options",
            ...params.web_search_options
        }
    ] : [];
    const availableTools = [
        ...tools,
        ...webSearchOptions
    ];
    if (availableTools.length === 0) return void 0;
    try {
        return JSON.stringify(availableTools);
    } catch (error) {
        $hiZR1.DEBUG_BUILD && $4gyod.debug.error("Failed to serialize OpenAI tools:", error);
        return void 0;
    }
}
function $5d910c8c982f1bc6$var$extractRequestAttributes(args, operationName) {
    const attributes = {
        [$MHfcn.GEN_AI_SYSTEM_ATTRIBUTE]: "openai",
        [$MHfcn.GEN_AI_OPERATION_NAME_ATTRIBUTE]: operationName,
        [$gTasE.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: "auto.ai.openai"
    };
    if (args.length > 0 && typeof args[0] === "object" && args[0] !== null) {
        const params = args[0];
        const availableTools = $5d910c8c982f1bc6$var$extractAvailableTools(params);
        if (availableTools) attributes[$MHfcn.GEN_AI_REQUEST_AVAILABLE_TOOLS_ATTRIBUTE] = availableTools;
        Object.assign(attributes, $e6pkh.extractRequestParameters(params));
    } else attributes[$MHfcn.GEN_AI_REQUEST_MODEL_ATTRIBUTE] = "unknown";
    return attributes;
}
function $5d910c8c982f1bc6$var$addRequestAttributes(span, params, operationName, enableTruncation) {
    if (operationName === "embeddings" && "input" in params) {
        const input = params.input;
        if (input == null) return;
        if (typeof input === "string" && input.length === 0) return;
        if (Array.isArray(input) && input.length === 0) return;
        span.setAttribute($MHfcn.GEN_AI_EMBEDDINGS_INPUT_ATTRIBUTE, typeof input === "string" ? input : JSON.stringify(input));
        return;
    }
    const src = "input" in params ? params.input : "messages" in params ? params.messages : void 0;
    if (!src) return;
    if (Array.isArray(src) && src.length === 0) return;
    const { systemInstructions: systemInstructions, filteredMessages: filteredMessages } = $iQAGO.extractSystemInstructions(src);
    if (systemInstructions) span.setAttribute($MHfcn.GEN_AI_SYSTEM_INSTRUCTIONS_ATTRIBUTE, systemInstructions);
    span.setAttribute($MHfcn.GEN_AI_INPUT_MESSAGES_ATTRIBUTE, enableTruncation ? $iQAGO.getTruncatedJsonString(filteredMessages) : $arYVC.stringify(filteredMessages));
    if (Array.isArray(filteredMessages)) span.setAttribute($MHfcn.GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE, filteredMessages.length);
    else span.setAttribute($MHfcn.GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE, 1);
}
function $5d910c8c982f1bc6$var$instrumentMethod(originalMethod, methodPath, instrumentedMethod, context, options) {
    return function instrumentedCall(...args) {
        const operationName = instrumentedMethod.operation || "unknown";
        const requestAttributes = $5d910c8c982f1bc6$var$extractRequestAttributes(args, operationName);
        const model = requestAttributes[$MHfcn.GEN_AI_REQUEST_MODEL_ATTRIBUTE] || "unknown";
        const params = args[0];
        const isStreamRequested = params && typeof params === "object" && params.stream === true;
        const spanConfig = {
            name: `${operationName} ${model}`,
            op: `gen_ai.${operationName}`,
            attributes: requestAttributes
        };
        if (isStreamRequested) {
            let originalResult2;
            const instrumentedPromise2 = $kBDP8.startSpanManual(spanConfig, (span)=>{
                originalResult2 = originalMethod.apply(context, args);
                if (options.recordInputs && params) $5d910c8c982f1bc6$var$addRequestAttributes(span, params, operationName, $iQAGO.shouldEnableTruncation(options.enableTruncation));
                return (async ()=>{
                    try {
                        const result = await originalResult2;
                        return $cMrSV.instrumentStream(result, span, options.recordOutputs ?? false);
                    } catch (error) {
                        span.setStatus({
                            code: $yI1C9.SPAN_STATUS_ERROR,
                            message: "internal_error"
                        });
                        $1tl8I.captureException(error, {
                            mechanism: {
                                handled: false,
                                type: "auto.ai.openai.stream",
                                data: {
                                    function: methodPath
                                }
                            }
                        });
                        span.end();
                        throw error;
                    }
                })();
            });
            return $iQAGO.wrapPromiseWithMethods(originalResult2, instrumentedPromise2, "auto.ai.openai");
        }
        let originalResult;
        const instrumentedPromise = $kBDP8.startSpan(spanConfig, (span)=>{
            originalResult = originalMethod.apply(context, args);
            if (options.recordInputs && params) $5d910c8c982f1bc6$var$addRequestAttributes(span, params, operationName, $iQAGO.shouldEnableTruncation(options.enableTruncation));
            return originalResult.then((result)=>{
                $e6pkh.addResponseAttributes(span, result, options.recordOutputs);
                return result;
            }, (error)=>{
                $1tl8I.captureException(error, {
                    mechanism: {
                        handled: false,
                        type: "auto.ai.openai",
                        data: {
                            function: methodPath
                        }
                    }
                });
                throw error;
            });
        });
        return $iQAGO.wrapPromiseWithMethods(originalResult, instrumentedPromise, "auto.ai.openai");
    };
}
function $5d910c8c982f1bc6$var$createDeepProxy(target, currentPath = "", options) {
    return new Proxy(target, {
        get (obj, prop) {
            const value = obj[prop];
            const methodPath = $iQAGO.buildMethodPath(currentPath, String(prop));
            const instrumentedMethod = $aaeQR.OPENAI_METHOD_REGISTRY[methodPath];
            if (typeof value === "function" && instrumentedMethod) return $5d910c8c982f1bc6$var$instrumentMethod(value, methodPath, instrumentedMethod, obj, options);
            if (typeof value === "function") return value.bind(obj);
            if (value && typeof value === "object") return $5d910c8c982f1bc6$var$createDeepProxy(value, methodPath, options);
            return value;
        }
    });
}
function $5d910c8c982f1bc6$var$instrumentOpenAiClient(client, options) {
    return $5d910c8c982f1bc6$var$createDeepProxy(client, "", $iQAGO.resolveAIRecordingOptions(options));
}
module.exports.addRequestAttributes = $5d910c8c982f1bc6$var$addRequestAttributes;
module.exports.extractRequestAttributes = $5d910c8c982f1bc6$var$extractRequestAttributes;
module.exports.instrumentOpenAiClient = $5d910c8c982f1bc6$var$instrumentOpenAiClient;

});
parcelRegister("aaeQR", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $76665bc4b4ab9617$var$OPENAI_INTEGRATION_NAME = "OpenAI";
const $76665bc4b4ab9617$var$OPENAI_METHOD_REGISTRY = {
    "responses.create": {
        operation: "chat"
    },
    "chat.completions.create": {
        operation: "chat"
    },
    "embeddings.create": {
        operation: "embeddings"
    },
    // Conversations API - for conversation state management
    // https://platform.openai.com/docs/guides/conversation-state
    "conversations.create": {
        operation: "chat"
    }
};
const $76665bc4b4ab9617$var$RESPONSES_TOOL_CALL_EVENT_TYPES = [
    "response.output_item.added",
    "response.function_call_arguments.delta",
    "response.function_call_arguments.done",
    "response.output_item.done"
];
const $76665bc4b4ab9617$var$RESPONSE_EVENT_TYPES = [
    "response.created",
    "response.in_progress",
    "response.failed",
    "response.completed",
    "response.incomplete",
    "response.queued",
    "response.output_text.delta",
    ...$76665bc4b4ab9617$var$RESPONSES_TOOL_CALL_EVENT_TYPES
];
module.exports.OPENAI_INTEGRATION_NAME = $76665bc4b4ab9617$var$OPENAI_INTEGRATION_NAME;
module.exports.OPENAI_METHOD_REGISTRY = $76665bc4b4ab9617$var$OPENAI_METHOD_REGISTRY;
module.exports.RESPONSES_TOOL_CALL_EVENT_TYPES = $76665bc4b4ab9617$var$RESPONSES_TOOL_CALL_EVENT_TYPES;
module.exports.RESPONSE_EVENT_TYPES = $76665bc4b4ab9617$var$RESPONSE_EVENT_TYPES;

});

parcelRegister("cMrSV", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $1tl8I = parcelRequire("1tl8I");

var $yI1C9 = parcelRequire("yI1C9");

var $iQAGO = parcelRequire("iQAGO");

var $aaeQR = parcelRequire("aaeQR");

var $e6pkh = parcelRequire("e6pkh");
function $94df99165174ade4$var$processChatCompletionToolCalls(toolCalls, state) {
    for (const toolCall of toolCalls){
        const index = toolCall.index;
        if (index === void 0 || !toolCall.function) continue;
        if (!(index in state.chatCompletionToolCalls)) state.chatCompletionToolCalls[index] = {
            ...toolCall,
            function: {
                name: toolCall.function.name,
                arguments: toolCall.function.arguments || ""
            }
        };
        else {
            const existingToolCall = state.chatCompletionToolCalls[index];
            if (toolCall.function.arguments && existingToolCall?.function) existingToolCall.function.arguments += toolCall.function.arguments;
        }
    }
}
function $94df99165174ade4$var$processChatCompletionChunk(chunk, state, recordOutputs) {
    state.responseId = chunk.id ?? state.responseId;
    state.responseModel = chunk.model ?? state.responseModel;
    if (chunk.usage) {
        state.promptTokens = chunk.usage.prompt_tokens;
        state.completionTokens = chunk.usage.completion_tokens;
        state.totalTokens = chunk.usage.total_tokens;
    }
    for (const choice of chunk.choices ?? []){
        if (recordOutputs) {
            if (choice.delta?.content) state.responseTexts.push(choice.delta.content);
            if (choice.delta?.tool_calls) $94df99165174ade4$var$processChatCompletionToolCalls(choice.delta.tool_calls, state);
        }
        if (choice.finish_reason) state.finishReasons.push(choice.finish_reason);
    }
}
function $94df99165174ade4$var$processResponsesApiEvent(streamEvent, state, recordOutputs, span) {
    if (!(streamEvent && typeof streamEvent === "object")) {
        state.eventTypes.push("unknown:non-object");
        return;
    }
    if (streamEvent instanceof Error) {
        span.setStatus({
            code: $yI1C9.SPAN_STATUS_ERROR,
            message: "internal_error"
        });
        $1tl8I.captureException(streamEvent, {
            mechanism: {
                handled: false,
                type: "auto.ai.openai.stream-response"
            }
        });
        return;
    }
    if (!("type" in streamEvent)) return;
    const event = streamEvent;
    if (!$aaeQR.RESPONSE_EVENT_TYPES.includes(event.type)) {
        state.eventTypes.push(event.type);
        return;
    }
    if (recordOutputs) {
        if (event.type === "response.output_item.done" && "item" in event) state.responsesApiToolCalls.push(event.item);
        if (event.type === "response.output_text.delta" && "delta" in event && event.delta) {
            state.responseTexts.push(event.delta);
            return;
        }
    }
    if ("response" in event) {
        const { response: response } = event;
        state.responseId = response.id ?? state.responseId;
        state.responseModel = response.model ?? state.responseModel;
        if (response.usage) {
            state.promptTokens = response.usage.input_tokens;
            state.completionTokens = response.usage.output_tokens;
            state.totalTokens = response.usage.total_tokens;
        }
        if (response.status) state.finishReasons.push(response.status);
        if (recordOutputs && response.output_text) state.responseTexts.push(response.output_text);
    }
}
async function* $94df99165174ade4$var$instrumentStream(stream, span, recordOutputs) {
    const state = {
        eventTypes: [],
        responseTexts: [],
        finishReasons: [],
        responseId: "",
        responseModel: "",
        promptTokens: void 0,
        completionTokens: void 0,
        totalTokens: void 0,
        chatCompletionToolCalls: {},
        responsesApiToolCalls: []
    };
    try {
        for await (const event of stream){
            if ($e6pkh.isChatCompletionChunk(event)) $94df99165174ade4$var$processChatCompletionChunk(event, state, recordOutputs);
            else if ($e6pkh.isResponsesApiStreamEvent(event)) $94df99165174ade4$var$processResponsesApiEvent(event, state, recordOutputs, span);
            yield event;
        }
    } finally{
        const allToolCalls = [
            ...Object.values(state.chatCompletionToolCalls),
            ...state.responsesApiToolCalls
        ];
        $iQAGO.endStreamSpan(span, {
            ...state,
            toolCalls: allToolCalls
        }, recordOutputs);
    }
}
module.exports.instrumentStream = $94df99165174ade4$var$instrumentStream;

});
parcelRegister("e6pkh", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $MHfcn = parcelRequire("MHfcn");
function $a4454574bb646848$var$isResponsesApiStreamEvent(event) {
    return event !== null && typeof event === "object" && "type" in event && typeof event.type === "string" && event.type.startsWith("response.");
}
function $a4454574bb646848$var$isChatCompletionChunk(event) {
    return event !== null && typeof event === "object" && "object" in event && event.object === "chat.completion.chunk";
}
function $a4454574bb646848$var$addResponseAttributes(span, result, recordOutputs) {
    if (!result || typeof result !== "object") return;
    const response = result;
    const attrs = {};
    if (typeof response.id === "string") attrs[$MHfcn.GEN_AI_RESPONSE_ID_ATTRIBUTE] = response.id;
    if (typeof response.model === "string") attrs[$MHfcn.GEN_AI_RESPONSE_MODEL_ATTRIBUTE] = response.model;
    if (response.object === "conversation" && typeof response.id === "string") attrs[$MHfcn.GEN_AI_CONVERSATION_ID_ATTRIBUTE] = response.id;
    if (response.usage && typeof response.usage === "object") {
        const usage = response.usage;
        const inputTokens = usage.prompt_tokens ?? usage.input_tokens;
        if (typeof inputTokens === "number") attrs[$MHfcn.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE] = inputTokens;
        const outputTokens = usage.completion_tokens ?? usage.output_tokens;
        if (typeof outputTokens === "number") attrs[$MHfcn.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE] = outputTokens;
        if (typeof usage.total_tokens === "number") attrs[$MHfcn.GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE] = usage.total_tokens;
    }
    if (Array.isArray(response.choices)) {
        const choices = response.choices;
        const finishReasons = choices.map((choice)=>choice.finish_reason).filter((reason)=>typeof reason === "string");
        if (finishReasons.length > 0) attrs[$MHfcn.GEN_AI_RESPONSE_FINISH_REASONS_ATTRIBUTE] = JSON.stringify(finishReasons);
        if (recordOutputs) {
            const responseTexts = choices.map((choice)=>{
                const message = choice.message;
                return message?.content || "";
            });
            attrs[$MHfcn.GEN_AI_RESPONSE_TEXT_ATTRIBUTE] = JSON.stringify(responseTexts);
            const toolCalls = choices.map((choice)=>{
                const message = choice.message;
                return message?.tool_calls;
            }).filter((calls)=>Array.isArray(calls) && calls.length > 0).flat();
            if (toolCalls.length > 0) attrs[$MHfcn.GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE] = JSON.stringify(toolCalls);
        }
    }
    if (typeof response.status === "string") {
        if (!attrs[$MHfcn.GEN_AI_RESPONSE_FINISH_REASONS_ATTRIBUTE]) attrs[$MHfcn.GEN_AI_RESPONSE_FINISH_REASONS_ATTRIBUTE] = JSON.stringify([
            response.status
        ]);
    }
    if (recordOutputs) {
        if (typeof response.output_text === "string" && !attrs[$MHfcn.GEN_AI_RESPONSE_TEXT_ATTRIBUTE]) attrs[$MHfcn.GEN_AI_RESPONSE_TEXT_ATTRIBUTE] = response.output_text;
        if (Array.isArray(response.output) && response.output.length > 0 && !attrs[$MHfcn.GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE]) {
            const functionCalls = response.output.filter((item)=>item?.type === "function_call");
            if (functionCalls.length > 0) attrs[$MHfcn.GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE] = JSON.stringify(functionCalls);
        }
    }
    span.setAttributes(attrs);
}
function $a4454574bb646848$var$extractConversationId(params) {
    if ("conversation" in params && typeof params.conversation === "string") return params.conversation;
    if ("previous_response_id" in params && typeof params.previous_response_id === "string") return params.previous_response_id;
    return void 0;
}
function $a4454574bb646848$var$extractRequestParameters(params) {
    const attributes = {
        [$MHfcn.GEN_AI_REQUEST_MODEL_ATTRIBUTE]: params.model ?? "unknown"
    };
    if ("temperature" in params) attributes[$MHfcn.GEN_AI_REQUEST_TEMPERATURE_ATTRIBUTE] = params.temperature;
    if ("top_p" in params) attributes[$MHfcn.GEN_AI_REQUEST_TOP_P_ATTRIBUTE] = params.top_p;
    if ("frequency_penalty" in params) attributes[$MHfcn.GEN_AI_REQUEST_FREQUENCY_PENALTY_ATTRIBUTE] = params.frequency_penalty;
    if ("presence_penalty" in params) attributes[$MHfcn.GEN_AI_REQUEST_PRESENCE_PENALTY_ATTRIBUTE] = params.presence_penalty;
    if ("stream" in params) attributes[$MHfcn.GEN_AI_REQUEST_STREAM_ATTRIBUTE] = params.stream;
    if ("encoding_format" in params) attributes[$MHfcn.GEN_AI_REQUEST_ENCODING_FORMAT_ATTRIBUTE] = params.encoding_format;
    if ("dimensions" in params) attributes[$MHfcn.GEN_AI_REQUEST_DIMENSIONS_ATTRIBUTE] = params.dimensions;
    const conversationId = $a4454574bb646848$var$extractConversationId(params);
    if (conversationId) attributes[$MHfcn.GEN_AI_CONVERSATION_ID_ATTRIBUTE] = conversationId;
    return attributes;
}
module.exports.addResponseAttributes = $a4454574bb646848$var$addResponseAttributes;
module.exports.extractRequestParameters = $a4454574bb646848$var$extractRequestParameters;
module.exports.isChatCompletionChunk = $a4454574bb646848$var$isChatCompletionChunk;
module.exports.isResponsesApiStreamEvent = $a4454574bb646848$var$isResponsesApiStreamEvent;

});



parcelRegister("55dom", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $1tl8I = parcelRequire("1tl8I");

var $gTasE = parcelRequire("gTasE");

var $yI1C9 = parcelRequire("yI1C9");

var $kBDP8 = parcelRequire("kBDP8");

var $MHfcn = parcelRequire("MHfcn");

var $iQAGO = parcelRequire("iQAGO");

var $fx2ii = parcelRequire("fx2ii");

var $eyueP = parcelRequire("eyueP");

var $gJivU = parcelRequire("gJivU");
function $3b37ceb84ecde680$var$extractRequestAttributes(args, methodPath, operationName) {
    const attributes = {
        [$MHfcn.GEN_AI_SYSTEM_ATTRIBUTE]: "anthropic",
        [$MHfcn.GEN_AI_OPERATION_NAME_ATTRIBUTE]: operationName,
        [$gTasE.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: "auto.ai.anthropic"
    };
    if (args.length > 0 && typeof args[0] === "object" && args[0] !== null) {
        const params = args[0];
        if (params.tools && Array.isArray(params.tools)) attributes[$MHfcn.GEN_AI_REQUEST_AVAILABLE_TOOLS_ATTRIBUTE] = JSON.stringify(params.tools);
        attributes[$MHfcn.GEN_AI_REQUEST_MODEL_ATTRIBUTE] = params.model ?? "unknown";
        if ("temperature" in params) attributes[$MHfcn.GEN_AI_REQUEST_TEMPERATURE_ATTRIBUTE] = params.temperature;
        if ("top_p" in params) attributes[$MHfcn.GEN_AI_REQUEST_TOP_P_ATTRIBUTE] = params.top_p;
        if ("stream" in params) attributes[$MHfcn.GEN_AI_REQUEST_STREAM_ATTRIBUTE] = params.stream;
        if ("top_k" in params) attributes[$MHfcn.GEN_AI_REQUEST_TOP_K_ATTRIBUTE] = params.top_k;
        if ("frequency_penalty" in params) attributes[$MHfcn.GEN_AI_REQUEST_FREQUENCY_PENALTY_ATTRIBUTE] = params.frequency_penalty;
        if ("max_tokens" in params) attributes[$MHfcn.GEN_AI_REQUEST_MAX_TOKENS_ATTRIBUTE] = params.max_tokens;
    } else if (methodPath === "models.retrieve" || methodPath === "models.get") attributes[$MHfcn.GEN_AI_REQUEST_MODEL_ATTRIBUTE] = args[0];
    else attributes[$MHfcn.GEN_AI_REQUEST_MODEL_ATTRIBUTE] = "unknown";
    return attributes;
}
function $3b37ceb84ecde680$var$addPrivateRequestAttributes(span, params, enableTruncation) {
    const messages = $gJivU.messagesFromParams(params);
    $gJivU.setMessagesAttribute(span, messages, enableTruncation);
    if ("prompt" in params) span.setAttributes({
        [$MHfcn.GEN_AI_PROMPT_ATTRIBUTE]: JSON.stringify(params.prompt)
    });
}
function $3b37ceb84ecde680$var$addContentAttributes(span, response) {
    if ("content" in response) {
        if (Array.isArray(response.content)) {
            span.setAttributes({
                [$MHfcn.GEN_AI_RESPONSE_TEXT_ATTRIBUTE]: response.content.map((item)=>item.text).filter((text)=>!!text).join("")
            });
            const toolCalls = [];
            for (const item of response.content)if (item.type === "tool_use" || item.type === "server_tool_use") toolCalls.push(item);
            if (toolCalls.length > 0) span.setAttributes({
                [$MHfcn.GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE]: JSON.stringify(toolCalls)
            });
        }
    }
    if ("completion" in response) span.setAttributes({
        [$MHfcn.GEN_AI_RESPONSE_TEXT_ATTRIBUTE]: response.completion
    });
    if ("input_tokens" in response) span.setAttributes({
        [$MHfcn.GEN_AI_RESPONSE_TEXT_ATTRIBUTE]: JSON.stringify(response.input_tokens)
    });
}
function $3b37ceb84ecde680$var$addMetadataAttributes(span, response) {
    if ("id" in response && "model" in response) {
        span.setAttributes({
            [$MHfcn.GEN_AI_RESPONSE_ID_ATTRIBUTE]: response.id,
            [$MHfcn.GEN_AI_RESPONSE_MODEL_ATTRIBUTE]: response.model
        });
        if ("usage" in response && response.usage) $iQAGO.setTokenUsageAttributes(span, response.usage.input_tokens, response.usage.output_tokens, response.usage.cache_creation_input_tokens, response.usage.cache_read_input_tokens);
    }
}
function $3b37ceb84ecde680$var$addResponseAttributes(span, response, recordOutputs) {
    if (!response || typeof response !== "object") return;
    if ("type" in response && response.type === "error") {
        $gJivU.handleResponseError(span, response);
        return;
    }
    if (recordOutputs) $3b37ceb84ecde680$var$addContentAttributes(span, response);
    $3b37ceb84ecde680$var$addMetadataAttributes(span, response);
}
function $3b37ceb84ecde680$var$handleStreamingError(error, span, methodPath) {
    $1tl8I.captureException(error, {
        mechanism: {
            handled: false,
            type: "auto.ai.anthropic",
            data: {
                function: methodPath
            }
        }
    });
    if (span.isRecording()) {
        span.setStatus({
            code: $yI1C9.SPAN_STATUS_ERROR,
            message: "internal_error"
        });
        span.end();
    }
    throw error;
}
function $3b37ceb84ecde680$var$handleStreamingRequest(originalMethod, target, context, args, requestAttributes, operationName, methodPath, params, options, isStreamRequested, isStreamingMethod) {
    const model = requestAttributes[$MHfcn.GEN_AI_REQUEST_MODEL_ATTRIBUTE] ?? "unknown";
    const spanConfig = {
        name: `${operationName} ${model}`,
        op: `gen_ai.${operationName}`,
        attributes: requestAttributes
    };
    if (isStreamRequested && !isStreamingMethod) {
        let originalResult;
        const instrumentedPromise = $kBDP8.startSpanManual(spanConfig, (span)=>{
            originalResult = originalMethod.apply(context, args);
            if (options.recordInputs && params) $3b37ceb84ecde680$var$addPrivateRequestAttributes(span, params, $iQAGO.shouldEnableTruncation(options.enableTruncation));
            return (async ()=>{
                try {
                    const result = await originalResult;
                    return $eyueP.instrumentAsyncIterableStream(result, span, options.recordOutputs ?? false);
                } catch (error) {
                    return $3b37ceb84ecde680$var$handleStreamingError(error, span, methodPath);
                }
            })();
        });
        return $iQAGO.wrapPromiseWithMethods(originalResult, instrumentedPromise, "auto.ai.anthropic");
    } else return $kBDP8.startSpanManual(spanConfig, (span)=>{
        try {
            if (options.recordInputs && params) $3b37ceb84ecde680$var$addPrivateRequestAttributes(span, params, $iQAGO.shouldEnableTruncation(options.enableTruncation));
            const messageStream = target.apply(context, args);
            return $eyueP.instrumentMessageStream(messageStream, span, options.recordOutputs ?? false);
        } catch (error) {
            return $3b37ceb84ecde680$var$handleStreamingError(error, span, methodPath);
        }
    });
}
function $3b37ceb84ecde680$var$instrumentMethod(originalMethod, methodPath, instrumentedMethod, context, options) {
    return new Proxy(originalMethod, {
        apply (target, thisArg, args) {
            const operationName = instrumentedMethod.operation || "unknown";
            const requestAttributes = $3b37ceb84ecde680$var$extractRequestAttributes(args, methodPath, operationName);
            const model = requestAttributes[$MHfcn.GEN_AI_REQUEST_MODEL_ATTRIBUTE] ?? "unknown";
            const params = typeof args[0] === "object" ? args[0] : void 0;
            const isStreamRequested = Boolean(params?.stream);
            const isStreamingMethod = instrumentedMethod.streaming === true;
            if (isStreamRequested || isStreamingMethod) return $3b37ceb84ecde680$var$handleStreamingRequest(originalMethod, target, context, args, requestAttributes, operationName, methodPath, params, options, isStreamRequested, isStreamingMethod);
            let originalResult;
            const instrumentedPromise = $kBDP8.startSpan({
                name: `${operationName} ${model}`,
                op: `gen_ai.${operationName}`,
                attributes: requestAttributes
            }, (span)=>{
                originalResult = target.apply(context, args);
                if (options.recordInputs && params) $3b37ceb84ecde680$var$addPrivateRequestAttributes(span, params, $iQAGO.shouldEnableTruncation(options.enableTruncation));
                return originalResult.then((result)=>{
                    $3b37ceb84ecde680$var$addResponseAttributes(span, result, options.recordOutputs);
                    return result;
                }, (error)=>{
                    $1tl8I.captureException(error, {
                        mechanism: {
                            handled: false,
                            type: "auto.ai.anthropic",
                            data: {
                                function: methodPath
                            }
                        }
                    });
                    throw error;
                });
            });
            return $iQAGO.wrapPromiseWithMethods(originalResult, instrumentedPromise, "auto.ai.anthropic");
        }
    });
}
function $3b37ceb84ecde680$var$createDeepProxy(target, currentPath = "", options) {
    return new Proxy(target, {
        get (obj, prop) {
            const value = obj[prop];
            const methodPath = $iQAGO.buildMethodPath(currentPath, String(prop));
            const instrumentedMethod = $fx2ii.ANTHROPIC_METHOD_REGISTRY[methodPath];
            if (typeof value === "function" && instrumentedMethod) return $3b37ceb84ecde680$var$instrumentMethod(value, methodPath, instrumentedMethod, obj, options);
            if (typeof value === "function") return value.bind(obj);
            if (value && typeof value === "object") return $3b37ceb84ecde680$var$createDeepProxy(value, methodPath, options);
            return value;
        }
    });
}
function $3b37ceb84ecde680$var$instrumentAnthropicAiClient(anthropicAiClient, options) {
    return $3b37ceb84ecde680$var$createDeepProxy(anthropicAiClient, "", $iQAGO.resolveAIRecordingOptions(options));
}
module.exports.addPrivateRequestAttributes = $3b37ceb84ecde680$var$addPrivateRequestAttributes;
module.exports.addResponseAttributes = $3b37ceb84ecde680$var$addResponseAttributes;
module.exports.extractRequestAttributes = $3b37ceb84ecde680$var$extractRequestAttributes;
module.exports.instrumentAnthropicAiClient = $3b37ceb84ecde680$var$instrumentAnthropicAiClient;

});
parcelRegister("fx2ii", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $b4ebb79f39f63b6d$var$ANTHROPIC_AI_INTEGRATION_NAME = "Anthropic_AI";
const $b4ebb79f39f63b6d$var$ANTHROPIC_METHOD_REGISTRY = {
    "messages.create": {
        operation: "chat"
    },
    "messages.stream": {
        operation: "chat",
        streaming: true
    },
    "messages.countTokens": {
        operation: "chat"
    },
    "models.get": {
        operation: "models"
    },
    "completions.create": {
        operation: "chat"
    },
    "models.retrieve": {
        operation: "models"
    },
    "beta.messages.create": {
        operation: "chat"
    }
};
module.exports.ANTHROPIC_AI_INTEGRATION_NAME = $b4ebb79f39f63b6d$var$ANTHROPIC_AI_INTEGRATION_NAME;
module.exports.ANTHROPIC_METHOD_REGISTRY = $b4ebb79f39f63b6d$var$ANTHROPIC_METHOD_REGISTRY;

});

parcelRegister("eyueP", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $1tl8I = parcelRequire("1tl8I");

var $yI1C9 = parcelRequire("yI1C9");

var $iQAGO = parcelRequire("iQAGO");

var $gJivU = parcelRequire("gJivU");
function $a98bb2527a018e59$var$isErrorEvent(event, span) {
    if ("type" in event && typeof event.type === "string") {
        if (event.type === "error") {
            span.setStatus({
                code: $yI1C9.SPAN_STATUS_ERROR,
                message: $gJivU.mapAnthropicErrorToStatusMessage(event.error?.type)
            });
            $1tl8I.captureException(event.error, {
                mechanism: {
                    handled: false,
                    type: "auto.ai.anthropic.anthropic_error"
                }
            });
            return true;
        }
    }
    return false;
}
function $a98bb2527a018e59$var$handleMessageMetadata(event, state) {
    if (event.type === "message_delta") {
        if (event.usage && typeof event.usage.output_tokens === "number") state.completionTokens = event.usage.output_tokens;
        if (event.delta?.stop_reason) state.finishReasons.push(event.delta.stop_reason);
    }
    if (event.message) {
        const message = event.message;
        if (message.id) state.responseId = message.id;
        if (message.model) state.responseModel = message.model;
        if (message.usage) {
            if (typeof message.usage.input_tokens === "number") state.promptTokens = message.usage.input_tokens;
            if (typeof message.usage.cache_creation_input_tokens === "number") state.cacheCreationInputTokens = message.usage.cache_creation_input_tokens;
            if (typeof message.usage.cache_read_input_tokens === "number") state.cacheReadInputTokens = message.usage.cache_read_input_tokens;
        }
    }
}
function $a98bb2527a018e59$var$handleContentBlockStart(event, state) {
    if (event.type !== "content_block_start" || typeof event.index !== "number" || !event.content_block) return;
    if (event.content_block.type === "tool_use" || event.content_block.type === "server_tool_use") state.activeToolBlocks[event.index] = {
        id: event.content_block.id,
        name: event.content_block.name,
        inputJsonParts: []
    };
}
function $a98bb2527a018e59$var$handleContentBlockDelta(event, state, recordOutputs) {
    if (event.type !== "content_block_delta" || !event.delta) return;
    if (typeof event.index === "number" && "partial_json" in event.delta && typeof event.delta.partial_json === "string") {
        const active = state.activeToolBlocks[event.index];
        if (active) active.inputJsonParts.push(event.delta.partial_json);
    }
    if (recordOutputs && typeof event.delta.text === "string") state.responseTexts.push(event.delta.text);
}
function $a98bb2527a018e59$var$handleContentBlockStop(event, state) {
    if (event.type !== "content_block_stop" || typeof event.index !== "number") return;
    const active = state.activeToolBlocks[event.index];
    if (!active) return;
    const raw = active.inputJsonParts.join("");
    let parsedInput;
    try {
        parsedInput = raw ? JSON.parse(raw) : {};
    } catch  {
        parsedInput = {
            __unparsed: raw
        };
    }
    state.toolCalls.push({
        type: "tool_use",
        id: active.id,
        name: active.name,
        input: parsedInput
    });
    delete state.activeToolBlocks[event.index];
}
function $a98bb2527a018e59$var$processEvent(event, state, recordOutputs, span) {
    if (!(event && typeof event === "object")) return;
    const isError = $a98bb2527a018e59$var$isErrorEvent(event, span);
    if (isError) return;
    $a98bb2527a018e59$var$handleMessageMetadata(event, state);
    $a98bb2527a018e59$var$handleContentBlockStart(event, state);
    $a98bb2527a018e59$var$handleContentBlockDelta(event, state, recordOutputs);
    $a98bb2527a018e59$var$handleContentBlockStop(event, state);
}
async function* $a98bb2527a018e59$var$instrumentAsyncIterableStream(stream, span, recordOutputs) {
    const state = {
        responseTexts: [],
        finishReasons: [],
        responseId: "",
        responseModel: "",
        promptTokens: void 0,
        completionTokens: void 0,
        cacheCreationInputTokens: void 0,
        cacheReadInputTokens: void 0,
        toolCalls: [],
        activeToolBlocks: {}
    };
    try {
        for await (const event of stream){
            $a98bb2527a018e59$var$processEvent(event, state, recordOutputs, span);
            yield event;
        }
    } finally{
        $iQAGO.endStreamSpan(span, state, recordOutputs);
    }
}
function $a98bb2527a018e59$var$instrumentMessageStream(stream, span, recordOutputs) {
    const state = {
        responseTexts: [],
        finishReasons: [],
        responseId: "",
        responseModel: "",
        promptTokens: void 0,
        completionTokens: void 0,
        cacheCreationInputTokens: void 0,
        cacheReadInputTokens: void 0,
        toolCalls: [],
        activeToolBlocks: {}
    };
    stream.on("streamEvent", (event)=>{
        $a98bb2527a018e59$var$processEvent(event, state, recordOutputs, span);
    });
    stream.on("message", ()=>{
        $iQAGO.endStreamSpan(span, state, recordOutputs);
    });
    stream.on("error", (error)=>{
        $1tl8I.captureException(error, {
            mechanism: {
                handled: false,
                type: "auto.ai.anthropic.stream_error"
            }
        });
        if (span.isRecording()) {
            span.setStatus({
                code: $yI1C9.SPAN_STATUS_ERROR,
                message: "internal_error"
            });
            span.end();
        }
    });
    return stream;
}
module.exports.instrumentAsyncIterableStream = $a98bb2527a018e59$var$instrumentAsyncIterableStream;
module.exports.instrumentMessageStream = $a98bb2527a018e59$var$instrumentMessageStream;

});
parcelRegister("gJivU", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $1tl8I = parcelRequire("1tl8I");

var $arYVC = parcelRequire("arYVC");

var $yI1C9 = parcelRequire("yI1C9");

var $MHfcn = parcelRequire("MHfcn");

var $iQAGO = parcelRequire("iQAGO");
function $c2df35b7e162c5a3$var$setMessagesAttribute(span, messages, enableTruncation) {
    if (Array.isArray(messages) && messages.length === 0) return;
    const { systemInstructions: systemInstructions, filteredMessages: filteredMessages } = $iQAGO.extractSystemInstructions(messages);
    if (systemInstructions) span.setAttributes({
        [$MHfcn.GEN_AI_SYSTEM_INSTRUCTIONS_ATTRIBUTE]: systemInstructions
    });
    const filteredLength = Array.isArray(filteredMessages) ? filteredMessages.length : 1;
    span.setAttributes({
        [$MHfcn.GEN_AI_INPUT_MESSAGES_ATTRIBUTE]: enableTruncation ? $iQAGO.getTruncatedJsonString(filteredMessages) : $arYVC.stringify(filteredMessages),
        [$MHfcn.GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE]: filteredLength
    });
}
const $c2df35b7e162c5a3$var$ANTHROPIC_ERROR_TYPE_TO_SPAN_STATUS = {
    invalid_request_error: "invalid_argument",
    authentication_error: "unauthenticated",
    permission_error: "permission_denied",
    not_found_error: "not_found",
    request_too_large: "failed_precondition",
    rate_limit_error: "resource_exhausted",
    api_error: "internal_error",
    overloaded_error: "unavailable"
};
function $c2df35b7e162c5a3$var$mapAnthropicErrorToStatusMessage(errorType) {
    if (!errorType) return "internal_error";
    return $c2df35b7e162c5a3$var$ANTHROPIC_ERROR_TYPE_TO_SPAN_STATUS[errorType] || "internal_error";
}
function $c2df35b7e162c5a3$var$handleResponseError(span, response) {
    if (response.error) {
        span.setStatus({
            code: $yI1C9.SPAN_STATUS_ERROR,
            message: $c2df35b7e162c5a3$var$mapAnthropicErrorToStatusMessage(response.error.type)
        });
        $1tl8I.captureException(response.error, {
            mechanism: {
                handled: false,
                type: "auto.ai.anthropic.anthropic_error"
            }
        });
    }
}
function $c2df35b7e162c5a3$var$messagesFromParams(params) {
    const { system: system, messages: messages, input: input } = params;
    const systemMessages = typeof system === "string" ? [
        {
            role: "system",
            content: params.system
        }
    ] : [];
    const inputParamMessages = Array.isArray(input) ? input : input != null ? [
        input
    ] : void 0;
    const messagesParamMessages = Array.isArray(messages) ? messages : messages != null ? [
        messages
    ] : [];
    const userMessages = inputParamMessages ?? messagesParamMessages;
    return [
        ...systemMessages,
        ...userMessages
    ];
}
module.exports.handleResponseError = $c2df35b7e162c5a3$var$handleResponseError;
module.exports.mapAnthropicErrorToStatusMessage = $c2df35b7e162c5a3$var$mapAnthropicErrorToStatusMessage;
module.exports.messagesFromParams = $c2df35b7e162c5a3$var$messagesFromParams;
module.exports.setMessagesAttribute = $c2df35b7e162c5a3$var$setMessagesAttribute;

});



parcelRegister("kqIrz", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $1tl8I = parcelRequire("1tl8I");

var $gTasE = parcelRequire("gTasE");

var $arYVC = parcelRequire("arYVC");

var $yI1C9 = parcelRequire("yI1C9");

var $kBDP8 = parcelRequire("kBDP8");

var $7vFKP = parcelRequire("7vFKP");

var $MHfcn = parcelRequire("MHfcn");

var $iQAGO = parcelRequire("iQAGO");

var $boef1 = parcelRequire("boef1");

var $6zRv1 = parcelRequire("6zRv1");

var $6CAlM = parcelRequire("6CAlM");
function $edf8b5f56d4920c5$var$extractModel(params, context) {
    if ("model" in params && typeof params.model === "string") return params.model;
    if (context && typeof context === "object") {
        const contextObj = context;
        if ("model" in contextObj && typeof contextObj.model === "string") return contextObj.model;
        if ("modelVersion" in contextObj && typeof contextObj.modelVersion === "string") return contextObj.modelVersion;
    }
    return "unknown";
}
function $edf8b5f56d4920c5$var$extractConfigAttributes(config) {
    const attributes = {};
    if ("temperature" in config && typeof config.temperature === "number") attributes[$MHfcn.GEN_AI_REQUEST_TEMPERATURE_ATTRIBUTE] = config.temperature;
    if ("topP" in config && typeof config.topP === "number") attributes[$MHfcn.GEN_AI_REQUEST_TOP_P_ATTRIBUTE] = config.topP;
    if ("topK" in config && typeof config.topK === "number") attributes[$MHfcn.GEN_AI_REQUEST_TOP_K_ATTRIBUTE] = config.topK;
    if ("maxOutputTokens" in config && typeof config.maxOutputTokens === "number") attributes[$MHfcn.GEN_AI_REQUEST_MAX_TOKENS_ATTRIBUTE] = config.maxOutputTokens;
    if ("frequencyPenalty" in config && typeof config.frequencyPenalty === "number") attributes[$MHfcn.GEN_AI_REQUEST_FREQUENCY_PENALTY_ATTRIBUTE] = config.frequencyPenalty;
    if ("presencePenalty" in config && typeof config.presencePenalty === "number") attributes[$MHfcn.GEN_AI_REQUEST_PRESENCE_PENALTY_ATTRIBUTE] = config.presencePenalty;
    return attributes;
}
function $edf8b5f56d4920c5$var$extractRequestAttributes(operationName, params, context) {
    const attributes = {
        [$MHfcn.GEN_AI_SYSTEM_ATTRIBUTE]: $boef1.GOOGLE_GENAI_SYSTEM_NAME,
        [$MHfcn.GEN_AI_OPERATION_NAME_ATTRIBUTE]: operationName,
        [$gTasE.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: "auto.ai.google_genai"
    };
    if (params) {
        attributes[$MHfcn.GEN_AI_REQUEST_MODEL_ATTRIBUTE] = $edf8b5f56d4920c5$var$extractModel(params, context);
        if ("config" in params && typeof params.config === "object" && params.config) {
            const config = params.config;
            Object.assign(attributes, $edf8b5f56d4920c5$var$extractConfigAttributes(config));
            if ("tools" in config && Array.isArray(config.tools)) {
                const functionDeclarations = config.tools.flatMap((tool)=>tool.functionDeclarations);
                attributes[$MHfcn.GEN_AI_REQUEST_AVAILABLE_TOOLS_ATTRIBUTE] = JSON.stringify(functionDeclarations);
            }
        }
    } else attributes[$MHfcn.GEN_AI_REQUEST_MODEL_ATTRIBUTE] = $edf8b5f56d4920c5$var$extractModel({}, context);
    return attributes;
}
function $edf8b5f56d4920c5$var$addPrivateRequestAttributes(span, params, operationName, enableTruncation) {
    if (operationName === "embeddings") {
        const contents = params.contents;
        if (contents != null) span.setAttribute($MHfcn.GEN_AI_EMBEDDINGS_INPUT_ATTRIBUTE, typeof contents === "string" ? contents : JSON.stringify(contents));
        return;
    }
    const messages = [];
    if ("config" in params && params.config && typeof params.config === "object" && "systemInstruction" in params.config && params.config.systemInstruction) messages.push(...$6CAlM.contentUnionToMessages(params.config.systemInstruction, "system"));
    if ("history" in params) messages.push(...$6CAlM.contentUnionToMessages(params.history, "user"));
    if ("contents" in params) messages.push(...$6CAlM.contentUnionToMessages(params.contents, "user"));
    if ("message" in params) messages.push(...$6CAlM.contentUnionToMessages(params.message, "user"));
    if (Array.isArray(messages) && messages.length) {
        const { systemInstructions: systemInstructions, filteredMessages: filteredMessages } = $iQAGO.extractSystemInstructions(messages);
        if (systemInstructions) span.setAttribute($MHfcn.GEN_AI_SYSTEM_INSTRUCTIONS_ATTRIBUTE, systemInstructions);
        const filteredLength = Array.isArray(filteredMessages) ? filteredMessages.length : 0;
        span.setAttributes({
            [$MHfcn.GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE]: filteredLength,
            [$MHfcn.GEN_AI_INPUT_MESSAGES_ATTRIBUTE]: enableTruncation ? $iQAGO.getTruncatedJsonString(filteredMessages) : $arYVC.stringify(filteredMessages)
        });
    }
}
function $edf8b5f56d4920c5$var$addResponseAttributes(span, response, recordOutputs) {
    if (!response || typeof response !== "object") return;
    if (response.modelVersion) span.setAttribute($MHfcn.GEN_AI_RESPONSE_MODEL_ATTRIBUTE, response.modelVersion);
    if (response.usageMetadata && typeof response.usageMetadata === "object") {
        const usage = response.usageMetadata;
        if (typeof usage.promptTokenCount === "number") span.setAttributes({
            [$MHfcn.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE]: usage.promptTokenCount
        });
        if (typeof usage.candidatesTokenCount === "number") span.setAttributes({
            [$MHfcn.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE]: usage.candidatesTokenCount
        });
        if (typeof usage.totalTokenCount === "number") span.setAttributes({
            [$MHfcn.GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE]: usage.totalTokenCount
        });
    }
    if (recordOutputs && Array.isArray(response.candidates) && response.candidates.length > 0) {
        const responseTexts = response.candidates.map((candidate)=>{
            if (candidate.content?.parts && Array.isArray(candidate.content.parts)) return candidate.content.parts.map((part)=>typeof part.text === "string" ? part.text : "").filter((text)=>text.length > 0).join("");
            return "";
        }).filter((text)=>text.length > 0);
        if (responseTexts.length > 0) span.setAttributes({
            [$MHfcn.GEN_AI_RESPONSE_TEXT_ATTRIBUTE]: responseTexts.join("")
        });
    }
    if (recordOutputs && response.functionCalls) {
        const functionCalls = response.functionCalls;
        if (Array.isArray(functionCalls) && functionCalls.length > 0) span.setAttributes({
            [$MHfcn.GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE]: JSON.stringify(functionCalls)
        });
    }
}
function $edf8b5f56d4920c5$var$instrumentMethod(originalMethod, methodPath, instrumentedMethod, context, options) {
    const isEmbeddings = instrumentedMethod.operation === "embeddings";
    return new Proxy(originalMethod, {
        apply (target, _, args) {
            const operationName = instrumentedMethod.operation || "unknown";
            const params = args[0];
            const requestAttributes = $edf8b5f56d4920c5$var$extractRequestAttributes(operationName, params, context);
            const model = requestAttributes[$MHfcn.GEN_AI_REQUEST_MODEL_ATTRIBUTE] ?? "unknown";
            if (instrumentedMethod.streaming) return $kBDP8.startSpanManual({
                name: `${operationName} ${model}`,
                op: `gen_ai.${operationName}`,
                attributes: requestAttributes
            }, async (span)=>{
                try {
                    if (options.recordInputs && params) $edf8b5f56d4920c5$var$addPrivateRequestAttributes(span, params, operationName, $iQAGO.shouldEnableTruncation(options.enableTruncation));
                    const stream = await target.apply(context, args);
                    return $6zRv1.instrumentStream(stream, span, Boolean(options.recordOutputs));
                } catch (error) {
                    span.setStatus({
                        code: $yI1C9.SPAN_STATUS_ERROR,
                        message: "internal_error"
                    });
                    $1tl8I.captureException(error, {
                        mechanism: {
                            handled: false,
                            type: "auto.ai.google_genai",
                            data: {
                                function: methodPath
                            }
                        }
                    });
                    span.end();
                    throw error;
                }
            });
            return $kBDP8.startSpan({
                name: `${operationName} ${model}`,
                op: `gen_ai.${operationName}`,
                attributes: requestAttributes
            }, (span)=>{
                if (options.recordInputs && params) $edf8b5f56d4920c5$var$addPrivateRequestAttributes(span, params, operationName, $iQAGO.shouldEnableTruncation(options.enableTruncation));
                return $7vFKP.handleCallbackErrors(()=>target.apply(context, args), (error)=>{
                    $1tl8I.captureException(error, {
                        mechanism: {
                            handled: false,
                            type: "auto.ai.google_genai",
                            data: {
                                function: methodPath
                            }
                        }
                    });
                }, ()=>{}, (result)=>{
                    if (!isEmbeddings) $edf8b5f56d4920c5$var$addResponseAttributes(span, result, options.recordOutputs);
                });
            });
        }
    });
}
function $edf8b5f56d4920c5$var$createDeepProxy(target, currentPath = "", options) {
    return new Proxy(target, {
        get: (t, prop, receiver)=>{
            const value = Reflect.get(t, prop, receiver);
            const methodPath = $iQAGO.buildMethodPath(currentPath, String(prop));
            const instrumentedMethod = $boef1.GOOGLE_GENAI_METHOD_REGISTRY[methodPath];
            if (typeof value === "function" && instrumentedMethod) {
                const wrappedMethod = instrumentedMethod.operation ? $edf8b5f56d4920c5$var$instrumentMethod(value, methodPath, instrumentedMethod, t, options) : value.bind(t);
                if (!instrumentedMethod.proxyResultPath) return wrappedMethod;
                return function(...args) {
                    const result = wrappedMethod(...args);
                    if (result && typeof result === "object") return $edf8b5f56d4920c5$var$createDeepProxy(result, instrumentedMethod.proxyResultPath, options);
                    return result;
                };
            }
            if (typeof value === "function") return value.bind(t);
            if (value && typeof value === "object") return $edf8b5f56d4920c5$var$createDeepProxy(value, methodPath, options);
            return value;
        }
    });
}
function $edf8b5f56d4920c5$var$instrumentGoogleGenAIClient(client, options) {
    return $edf8b5f56d4920c5$var$createDeepProxy(client, "", $iQAGO.resolveAIRecordingOptions(options));
}
module.exports.addPrivateRequestAttributes = $edf8b5f56d4920c5$var$addPrivateRequestAttributes;
module.exports.addResponseAttributes = $edf8b5f56d4920c5$var$addResponseAttributes;
module.exports.extractModel = $edf8b5f56d4920c5$var$extractModel;
module.exports.extractRequestAttributes = $edf8b5f56d4920c5$var$extractRequestAttributes;
module.exports.instrumentGoogleGenAIClient = $edf8b5f56d4920c5$var$instrumentGoogleGenAIClient;

});
parcelRegister("boef1", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $84acfba4078a9d84$var$GOOGLE_GENAI_INTEGRATION_NAME = "Google_GenAI";
const $84acfba4078a9d84$var$GOOGLE_GENAI_METHOD_REGISTRY = {
    "models.generateContent": {
        operation: "generate_content"
    },
    "models.generateContentStream": {
        operation: "generate_content",
        streaming: true
    },
    "models.embedContent": {
        operation: "embeddings"
    },
    "chats.create": {
        proxyResultPath: "chat"
    },
    "chat.sendMessage": {
        operation: "chat"
    },
    "chat.sendMessageStream": {
        operation: "chat",
        streaming: true
    }
};
const $84acfba4078a9d84$var$GOOGLE_GENAI_SYSTEM_NAME = "google_genai";
module.exports.GOOGLE_GENAI_INTEGRATION_NAME = $84acfba4078a9d84$var$GOOGLE_GENAI_INTEGRATION_NAME;
module.exports.GOOGLE_GENAI_METHOD_REGISTRY = $84acfba4078a9d84$var$GOOGLE_GENAI_METHOD_REGISTRY;
module.exports.GOOGLE_GENAI_SYSTEM_NAME = $84acfba4078a9d84$var$GOOGLE_GENAI_SYSTEM_NAME;

});

parcelRegister("6zRv1", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $1tl8I = parcelRequire("1tl8I");

var $yI1C9 = parcelRequire("yI1C9");

var $iQAGO = parcelRequire("iQAGO");
function $4c9f82cf6035d7d9$var$isErrorChunk(chunk, span) {
    const feedback = chunk?.promptFeedback;
    if (feedback?.blockReason) {
        const message = feedback.blockReasonMessage ?? feedback.blockReason;
        span.setStatus({
            code: $yI1C9.SPAN_STATUS_ERROR,
            message: "internal_error"
        });
        $1tl8I.captureException(`Content blocked: ${message}`, {
            mechanism: {
                handled: false,
                type: "auto.ai.google_genai"
            }
        });
        return true;
    }
    return false;
}
function $4c9f82cf6035d7d9$var$handleResponseMetadata(chunk, state) {
    if (typeof chunk.responseId === "string") state.responseId = chunk.responseId;
    if (typeof chunk.modelVersion === "string") state.responseModel = chunk.modelVersion;
    const usage = chunk.usageMetadata;
    if (usage) {
        if (typeof usage.promptTokenCount === "number") state.promptTokens = usage.promptTokenCount;
        if (typeof usage.candidatesTokenCount === "number") state.completionTokens = usage.candidatesTokenCount;
        if (typeof usage.totalTokenCount === "number") state.totalTokens = usage.totalTokenCount;
    }
}
function $4c9f82cf6035d7d9$var$handleCandidateContent(chunk, state, recordOutputs) {
    if (Array.isArray(chunk.functionCalls)) state.toolCalls.push(...chunk.functionCalls);
    for (const candidate of chunk.candidates ?? []){
        if (candidate?.finishReason && !state.finishReasons.includes(candidate.finishReason)) state.finishReasons.push(candidate.finishReason);
        for (const part of candidate?.content?.parts ?? []){
            if (recordOutputs && part.text) state.responseTexts.push(part.text);
            if (part.functionCall) state.toolCalls.push({
                type: "function",
                id: part.functionCall.id,
                name: part.functionCall.name,
                arguments: part.functionCall.args
            });
        }
    }
}
function $4c9f82cf6035d7d9$var$processChunk(chunk, state, recordOutputs, span) {
    if (!chunk || $4c9f82cf6035d7d9$var$isErrorChunk(chunk, span)) return;
    $4c9f82cf6035d7d9$var$handleResponseMetadata(chunk, state);
    $4c9f82cf6035d7d9$var$handleCandidateContent(chunk, state, recordOutputs);
}
async function* $4c9f82cf6035d7d9$var$instrumentStream(stream, span, recordOutputs) {
    const state = {
        responseTexts: [],
        finishReasons: [],
        toolCalls: []
    };
    try {
        for await (const chunk of stream){
            $4c9f82cf6035d7d9$var$processChunk(chunk, state, recordOutputs, span);
            yield chunk;
        }
    } finally{
        $iQAGO.endStreamSpan(span, state, recordOutputs);
    }
}
module.exports.instrumentStream = $4c9f82cf6035d7d9$var$instrumentStream;

});

parcelRegister("6CAlM", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $4d227d1dd7c83067$var$contentUnionToMessages(content, role = "user") {
    if (typeof content === "string") return [
        {
            role: role,
            content: content
        }
    ];
    if (Array.isArray(content)) return content.flatMap((content2)=>$4d227d1dd7c83067$var$contentUnionToMessages(content2, role));
    if (typeof content !== "object" || !content) return [];
    if ("role" in content && typeof content.role === "string") return [
        content
    ];
    if ("parts" in content) return [
        {
            ...content,
            role: role
        }
    ];
    return [
        {
            role: role,
            content: content
        }
    ];
}
module.exports.contentUnionToMessages = $4d227d1dd7c83067$var$contentUnionToMessages;

});


parcelRegister("l8LMz", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $1tl8I = parcelRequire("1tl8I");

var $gTasE = parcelRequire("gTasE");

var $yI1C9 = parcelRequire("yI1C9");

var $kBDP8 = parcelRequire("kBDP8");

var $MHfcn = parcelRequire("MHfcn");

var $iQAGO = parcelRequire("iQAGO");

var $lhIXN = parcelRequire("lhIXN");

var $1fQ84 = parcelRequire("1fQ84");
function $f63f68ef76574416$var$createLangChainCallbackHandler(options = {}) {
    const { recordInputs: recordInputs, recordOutputs: recordOutputs } = $iQAGO.resolveAIRecordingOptions(options);
    const enableTruncation = $iQAGO.shouldEnableTruncation(options.enableTruncation);
    const spanMap = /* @__PURE__ */ new Map();
    const exitSpan = (runId)=>{
        const span = spanMap.get(runId);
        if (span?.isRecording()) {
            span.end();
            spanMap.delete(runId);
        }
    };
    const handler = {
        // Required LangChain BaseCallbackHandler properties
        lc_serializable: false,
        lc_namespace: [
            "langchain_core",
            "callbacks",
            "sentry"
        ],
        lc_secrets: void 0,
        lc_attributes: void 0,
        lc_aliases: void 0,
        lc_serializable_keys: void 0,
        lc_id: [
            "langchain_core",
            "callbacks",
            "sentry"
        ],
        lc_kwargs: {},
        name: "SentryCallbackHandler",
        // BaseCallbackHandlerInput boolean flags
        ignoreLLM: false,
        ignoreChain: false,
        ignoreAgent: false,
        ignoreRetriever: false,
        ignoreCustomEvent: false,
        raiseError: false,
        awaitHandlers: true,
        handleLLMStart (llm, prompts, runId, _parentRunId, _extraParams, tags, metadata, _runName) {
            const invocationParams = $1fQ84.getInvocationParams(tags);
            const attributes = $1fQ84.extractLLMRequestAttributes(llm, prompts, recordInputs, enableTruncation, invocationParams, metadata);
            const modelName = attributes[$MHfcn.GEN_AI_REQUEST_MODEL_ATTRIBUTE];
            const operationName = attributes[$MHfcn.GEN_AI_OPERATION_NAME_ATTRIBUTE];
            $kBDP8.startSpanManual({
                name: `${operationName} ${modelName}`,
                op: "gen_ai.chat",
                attributes: {
                    ...$1fQ84.getAgentNameFromMetadata(metadata),
                    ...attributes,
                    [$gTasE.SEMANTIC_ATTRIBUTE_SENTRY_OP]: "gen_ai.chat"
                }
            }, (span)=>{
                spanMap.set(runId, span);
                return span;
            });
        },
        // Chat Model Start Handler
        handleChatModelStart (llm, messages, runId, _parentRunId, extraParams, tags, metadata, _runName) {
            const invocationParams = $1fQ84.getInvocationParams(tags);
            const attributes = $1fQ84.extractChatModelRequestAttributes(llm, messages, recordInputs, enableTruncation, invocationParams, metadata);
            const toolDefsJson = $1fQ84.extractToolDefinitions(extraParams);
            if (toolDefsJson) attributes[$MHfcn.GEN_AI_REQUEST_AVAILABLE_TOOLS_ATTRIBUTE] = toolDefsJson;
            const modelName = attributes[$MHfcn.GEN_AI_REQUEST_MODEL_ATTRIBUTE];
            const operationName = attributes[$MHfcn.GEN_AI_OPERATION_NAME_ATTRIBUTE];
            $kBDP8.startSpanManual({
                name: `${operationName} ${modelName}`,
                op: "gen_ai.chat",
                attributes: {
                    ...$1fQ84.getAgentNameFromMetadata(metadata),
                    ...attributes,
                    [$gTasE.SEMANTIC_ATTRIBUTE_SENTRY_OP]: "gen_ai.chat"
                }
            }, (span)=>{
                spanMap.set(runId, span);
                return span;
            });
        },
        // LLM End Handler - note: handleLLMEnd with capital LLM (used by both LLMs and chat models!)
        handleLLMEnd (output, runId, _parentRunId, _tags, _extraParams) {
            const span = spanMap.get(runId);
            if (span?.isRecording()) {
                const attributes = $1fQ84.extractLlmResponseAttributes(output, recordOutputs);
                if (attributes) span.setAttributes(attributes);
                exitSpan(runId);
            }
        },
        // LLM Error Handler - note: handleLLMError with capital LLM
        handleLLMError (error, runId) {
            const span = spanMap.get(runId);
            if (span?.isRecording()) {
                span.setStatus({
                    code: $yI1C9.SPAN_STATUS_ERROR,
                    message: "internal_error"
                });
                exitSpan(runId);
            }
            $1tl8I.captureException(error, {
                mechanism: {
                    handled: false,
                    type: `${$lhIXN.LANGCHAIN_ORIGIN}.llm_error_handler`
                }
            });
        },
        // Chain Start Handler
        handleChainStart (chain, inputs, runId, _parentRunId, _tags, metadata, _runType, runName) {
            if (metadata?.__sentry_langgraph__) return;
            const chainName = runName || chain.name || "unknown_chain";
            const attributes = {
                [$gTasE.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: "auto.ai.langchain",
                "langchain.chain.name": chainName
            };
            if (recordInputs) attributes["langchain.chain.inputs"] = JSON.stringify(inputs);
            $kBDP8.startSpanManual({
                name: `chain ${chainName}`,
                op: "gen_ai.invoke_agent",
                attributes: {
                    ...attributes,
                    [$gTasE.SEMANTIC_ATTRIBUTE_SENTRY_OP]: "gen_ai.invoke_agent"
                }
            }, (span)=>{
                spanMap.set(runId, span);
                return span;
            });
        },
        // Chain End Handler
        handleChainEnd (outputs, runId) {
            const span = spanMap.get(runId);
            if (span?.isRecording()) {
                if (recordOutputs) span.setAttributes({
                    "langchain.chain.outputs": JSON.stringify(outputs)
                });
                exitSpan(runId);
            }
        },
        // Chain Error Handler
        handleChainError (error, runId) {
            const span = spanMap.get(runId);
            if (span?.isRecording()) {
                span.setStatus({
                    code: $yI1C9.SPAN_STATUS_ERROR,
                    message: "internal_error"
                });
                exitSpan(runId);
            }
            $1tl8I.captureException(error, {
                mechanism: {
                    handled: false,
                    type: `${$lhIXN.LANGCHAIN_ORIGIN}.chain_error_handler`
                }
            });
        },
        // Tool Start Handler
        handleToolStart (tool, input, runId, _parentRunId, _tags, metadata, runName) {
            if (metadata?.__sentry_langgraph__) return;
            const toolName = runName || tool.name || "unknown_tool";
            const attributes = {
                ...$1fQ84.getAgentNameFromMetadata(metadata),
                [$gTasE.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: $lhIXN.LANGCHAIN_ORIGIN,
                [$MHfcn.GEN_AI_OPERATION_NAME_ATTRIBUTE]: "execute_tool",
                [$MHfcn.GEN_AI_TOOL_NAME_ATTRIBUTE]: toolName
            };
            if (recordInputs) attributes[$MHfcn.GEN_AI_TOOL_INPUT_ATTRIBUTE] = input;
            $kBDP8.startSpanManual({
                name: `execute_tool ${toolName}`,
                op: "gen_ai.execute_tool",
                attributes: {
                    ...attributes,
                    [$gTasE.SEMANTIC_ATTRIBUTE_SENTRY_OP]: "gen_ai.execute_tool"
                }
            }, (span)=>{
                spanMap.set(runId, span);
                return span;
            });
        },
        // Tool End Handler
        handleToolEnd (output, runId) {
            const span = spanMap.get(runId);
            if (span?.isRecording()) {
                if (recordOutputs) {
                    const outputObj = output;
                    const content = outputObj && typeof outputObj === "object" && "content" in outputObj ? outputObj.content : output;
                    span.setAttributes({
                        [$MHfcn.GEN_AI_TOOL_OUTPUT_ATTRIBUTE]: typeof content === "string" ? content : JSON.stringify(content)
                    });
                }
                exitSpan(runId);
            }
        },
        // Tool Error Handler
        handleToolError (error, runId) {
            const span = spanMap.get(runId);
            if (span?.isRecording()) {
                span.setStatus({
                    code: $yI1C9.SPAN_STATUS_ERROR,
                    message: "internal_error"
                });
                exitSpan(runId);
            }
            $1tl8I.captureException(error, {
                mechanism: {
                    handled: false,
                    type: `${$lhIXN.LANGCHAIN_ORIGIN}.tool_error_handler`
                }
            });
        },
        // LangChain BaseCallbackHandler required methods
        copy () {
            return handler;
        },
        toJSON () {
            return {
                lc: 1,
                type: "not_implemented",
                id: handler.lc_id
            };
        },
        toJSONNotImplemented () {
            return {
                lc: 1,
                type: "not_implemented",
                id: handler.lc_id
            };
        }
    };
    return handler;
}
module.exports.createLangChainCallbackHandler = $f63f68ef76574416$var$createLangChainCallbackHandler;

});
parcelRegister("lhIXN", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $f7ee10519bf70a22$var$LANGCHAIN_INTEGRATION_NAME = "LangChain";
const $f7ee10519bf70a22$var$LANGCHAIN_ORIGIN = "auto.ai.langchain";
const $f7ee10519bf70a22$var$ROLE_MAP = {
    human: "user",
    ai: "assistant",
    assistant: "assistant",
    system: "system",
    function: "function",
    tool: "tool"
};
module.exports.LANGCHAIN_INTEGRATION_NAME = $f7ee10519bf70a22$var$LANGCHAIN_INTEGRATION_NAME;
module.exports.LANGCHAIN_ORIGIN = $f7ee10519bf70a22$var$LANGCHAIN_ORIGIN;
module.exports.ROLE_MAP = $f7ee10519bf70a22$var$ROLE_MAP;

});

parcelRegister("1fQ84", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $gTasE = parcelRequire("gTasE");

var $arYVC = parcelRequire("arYVC");

var $MHfcn = parcelRequire("MHfcn");

var $fomXY = parcelRequire("fomXY");

var $iQAGO = parcelRequire("iQAGO");

var $lhIXN = parcelRequire("lhIXN");
const $0e9fa0f33dc5c906$var$setIfDefined = (target, key, value)=>{
    if (value != null) target[key] = value;
};
const $0e9fa0f33dc5c906$var$setNumberIfDefined = (target, key, value)=>{
    const n = Number(value);
    if (!Number.isNaN(n)) target[key] = n;
};
function $0e9fa0f33dc5c906$var$normalizeContent(v) {
    if (Array.isArray(v)) try {
        const stripped = v.map((part)=>part && typeof part === "object" && $fomXY.isContentMedia(part) ? $fomXY.stripInlineMediaFromSingleMessage(part) : part);
        return JSON.stringify(stripped);
    } catch  {
        return String(v);
    }
    return $arYVC.stringify(v, String);
}
function $0e9fa0f33dc5c906$var$normalizeMessageRole(role) {
    const normalized = role.toLowerCase();
    return $lhIXN.ROLE_MAP[normalized] ?? normalized;
}
function $0e9fa0f33dc5c906$var$normalizeRoleNameFromCtor(name) {
    if (name.includes("System")) return "system";
    if (name.includes("Human")) return "user";
    if (name.includes("AI") || name.includes("Assistant")) return "assistant";
    if (name.includes("Function")) return "function";
    if (name.includes("Tool")) return "tool";
    return "user";
}
function $0e9fa0f33dc5c906$var$getInvocationParams(tags) {
    if (!tags || Array.isArray(tags)) return void 0;
    return tags.invocation_params;
}
function $0e9fa0f33dc5c906$var$normalizeLangChainMessages(messages) {
    return messages.map((message)=>{
        const maybeGetType = message._getType;
        if (typeof maybeGetType === "function") {
            const messageType = maybeGetType.call(message);
            return {
                role: $0e9fa0f33dc5c906$var$normalizeMessageRole(messageType),
                content: $0e9fa0f33dc5c906$var$normalizeContent(message.content)
            };
        }
        if (message.lc === 1 && message.kwargs) {
            const id = message.id;
            const messageType = Array.isArray(id) && id.length > 0 ? id[id.length - 1] : "";
            const role = typeof messageType === "string" ? $0e9fa0f33dc5c906$var$normalizeRoleNameFromCtor(messageType) : "user";
            return {
                role: $0e9fa0f33dc5c906$var$normalizeMessageRole(role),
                content: $0e9fa0f33dc5c906$var$normalizeContent(message.kwargs?.content)
            };
        }
        if (message.type) {
            const role = String(message.type).toLowerCase();
            return {
                role: $0e9fa0f33dc5c906$var$normalizeMessageRole(role),
                content: $0e9fa0f33dc5c906$var$normalizeContent(message.content)
            };
        }
        if (message.role) return {
            role: $0e9fa0f33dc5c906$var$normalizeMessageRole(String(message.role)),
            content: $0e9fa0f33dc5c906$var$normalizeContent(message.content)
        };
        const ctor = message.constructor?.name;
        if (ctor && ctor !== "Object") return {
            role: $0e9fa0f33dc5c906$var$normalizeMessageRole($0e9fa0f33dc5c906$var$normalizeRoleNameFromCtor(ctor)),
            content: $0e9fa0f33dc5c906$var$normalizeContent(message.content)
        };
        return {
            role: "user",
            content: $0e9fa0f33dc5c906$var$normalizeContent(message.content)
        };
    });
}
function $0e9fa0f33dc5c906$var$extractCommonRequestAttributes(serialized, invocationParams, langSmithMetadata) {
    const attrs = {};
    const kwargs = "kwargs" in serialized ? serialized.kwargs : void 0;
    const temperature = invocationParams?.temperature ?? langSmithMetadata?.ls_temperature ?? kwargs?.temperature;
    $0e9fa0f33dc5c906$var$setNumberIfDefined(attrs, $MHfcn.GEN_AI_REQUEST_TEMPERATURE_ATTRIBUTE, temperature);
    const maxTokens = invocationParams?.max_tokens ?? langSmithMetadata?.ls_max_tokens ?? kwargs?.max_tokens;
    $0e9fa0f33dc5c906$var$setNumberIfDefined(attrs, $MHfcn.GEN_AI_REQUEST_MAX_TOKENS_ATTRIBUTE, maxTokens);
    const topP = invocationParams?.top_p ?? kwargs?.top_p;
    $0e9fa0f33dc5c906$var$setNumberIfDefined(attrs, $MHfcn.GEN_AI_REQUEST_TOP_P_ATTRIBUTE, topP);
    const frequencyPenalty = invocationParams?.frequency_penalty;
    $0e9fa0f33dc5c906$var$setNumberIfDefined(attrs, $MHfcn.GEN_AI_REQUEST_FREQUENCY_PENALTY_ATTRIBUTE, frequencyPenalty);
    const presencePenalty = invocationParams?.presence_penalty;
    $0e9fa0f33dc5c906$var$setNumberIfDefined(attrs, $MHfcn.GEN_AI_REQUEST_PRESENCE_PENALTY_ATTRIBUTE, presencePenalty);
    if (invocationParams && "stream" in invocationParams) $0e9fa0f33dc5c906$var$setIfDefined(attrs, $MHfcn.GEN_AI_REQUEST_STREAM_ATTRIBUTE, Boolean(invocationParams.stream));
    return attrs;
}
function $0e9fa0f33dc5c906$var$baseRequestAttributes(system, modelName, serialized, invocationParams, langSmithMetadata) {
    return {
        [$MHfcn.GEN_AI_SYSTEM_ATTRIBUTE]: $arYVC.stringify(system ?? "langchain", String),
        [$MHfcn.GEN_AI_OPERATION_NAME_ATTRIBUTE]: "chat",
        [$MHfcn.GEN_AI_REQUEST_MODEL_ATTRIBUTE]: $arYVC.stringify(modelName, String),
        [$gTasE.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: $lhIXN.LANGCHAIN_ORIGIN,
        ...$0e9fa0f33dc5c906$var$extractCommonRequestAttributes(serialized, invocationParams, langSmithMetadata)
    };
}
function $0e9fa0f33dc5c906$var$extractLLMRequestAttributes(llm, prompts, recordInputs, enableTruncation, invocationParams, langSmithMetadata) {
    const system = langSmithMetadata?.ls_provider;
    const modelName = invocationParams?.model ?? langSmithMetadata?.ls_model_name ?? "unknown";
    const attrs = $0e9fa0f33dc5c906$var$baseRequestAttributes(system, modelName, llm, invocationParams, langSmithMetadata);
    if (recordInputs && Array.isArray(prompts) && prompts.length > 0) {
        $0e9fa0f33dc5c906$var$setIfDefined(attrs, $MHfcn.GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE, prompts.length);
        const messages = prompts.map((p)=>({
                role: "user",
                content: p
            }));
        $0e9fa0f33dc5c906$var$setIfDefined(attrs, $MHfcn.GEN_AI_INPUT_MESSAGES_ATTRIBUTE, enableTruncation ? $iQAGO.getTruncatedJsonString(messages) : $arYVC.stringify(messages));
    }
    return attrs;
}
function $0e9fa0f33dc5c906$var$extractChatModelRequestAttributes(llm, langChainMessages, recordInputs, enableTruncation, invocationParams, langSmithMetadata) {
    const system = langSmithMetadata?.ls_provider ?? llm.id?.[2];
    const modelName = invocationParams?.model ?? langSmithMetadata?.ls_model_name ?? "unknown";
    const attrs = $0e9fa0f33dc5c906$var$baseRequestAttributes(system, modelName, llm, invocationParams, langSmithMetadata);
    if (recordInputs && Array.isArray(langChainMessages) && langChainMessages.length > 0) {
        const normalized = $0e9fa0f33dc5c906$var$normalizeLangChainMessages(langChainMessages.flat());
        const { systemInstructions: systemInstructions, filteredMessages: filteredMessages } = $iQAGO.extractSystemInstructions(normalized);
        if (systemInstructions) $0e9fa0f33dc5c906$var$setIfDefined(attrs, $MHfcn.GEN_AI_SYSTEM_INSTRUCTIONS_ATTRIBUTE, systemInstructions);
        const filteredLength = Array.isArray(filteredMessages) ? filteredMessages.length : 0;
        $0e9fa0f33dc5c906$var$setIfDefined(attrs, $MHfcn.GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE, filteredLength);
        $0e9fa0f33dc5c906$var$setIfDefined(attrs, $MHfcn.GEN_AI_INPUT_MESSAGES_ATTRIBUTE, enableTruncation ? $iQAGO.getTruncatedJsonString(filteredMessages) : $arYVC.stringify(filteredMessages));
    }
    return attrs;
}
function $0e9fa0f33dc5c906$var$addToolCallsAttributes(generations, attrs) {
    const toolCalls = [];
    const flatGenerations = generations.flat();
    for (const gen of flatGenerations){
        const msg = gen.message;
        const msgToolCalls = msg?.tool_calls;
        if (Array.isArray(msgToolCalls) && msgToolCalls.length > 0) toolCalls.push(...msgToolCalls);
        else {
            const content = gen.message?.content;
            if (Array.isArray(content)) for (const item of content){
                const t = item;
                if (t.type === "tool_use") toolCalls.push(t);
            }
        }
    }
    if (toolCalls.length > 0) $0e9fa0f33dc5c906$var$setIfDefined(attrs, $MHfcn.GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE, $arYVC.stringify(toolCalls, String));
}
function $0e9fa0f33dc5c906$var$addTokenUsageAttributes(llmOutput, attrs) {
    if (!llmOutput) return;
    const tokenUsage = llmOutput.tokenUsage;
    const anthropicUsage = llmOutput.usage;
    if (tokenUsage) {
        $0e9fa0f33dc5c906$var$setNumberIfDefined(attrs, $MHfcn.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE, tokenUsage.promptTokens);
        $0e9fa0f33dc5c906$var$setNumberIfDefined(attrs, $MHfcn.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE, tokenUsage.completionTokens);
        $0e9fa0f33dc5c906$var$setNumberIfDefined(attrs, $MHfcn.GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE, tokenUsage.totalTokens);
    } else if (anthropicUsage) {
        $0e9fa0f33dc5c906$var$setNumberIfDefined(attrs, $MHfcn.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE, anthropicUsage.input_tokens);
        $0e9fa0f33dc5c906$var$setNumberIfDefined(attrs, $MHfcn.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE, anthropicUsage.output_tokens);
        const input = Number(anthropicUsage.input_tokens);
        const output = Number(anthropicUsage.output_tokens);
        const total = (Number.isNaN(input) ? 0 : input) + (Number.isNaN(output) ? 0 : output);
        if (total > 0) $0e9fa0f33dc5c906$var$setNumberIfDefined(attrs, $MHfcn.GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE, total);
        if (anthropicUsage.cache_creation_input_tokens !== void 0) $0e9fa0f33dc5c906$var$setNumberIfDefined(attrs, $MHfcn.GEN_AI_USAGE_CACHE_CREATION_INPUT_TOKENS_ATTRIBUTE, anthropicUsage.cache_creation_input_tokens);
        if (anthropicUsage.cache_read_input_tokens !== void 0) $0e9fa0f33dc5c906$var$setNumberIfDefined(attrs, $MHfcn.GEN_AI_USAGE_CACHE_READ_INPUT_TOKENS_ATTRIBUTE, anthropicUsage.cache_read_input_tokens);
    }
}
function $0e9fa0f33dc5c906$var$extractLlmResponseAttributes(llmResult, recordOutputs) {
    if (!llmResult) return;
    const attrs = {};
    if (Array.isArray(llmResult.generations)) {
        const finishReasons = llmResult.generations.flat().map((g)=>{
            if (g.generationInfo?.finish_reason) return g.generationInfo.finish_reason;
            if (g.generation_info?.finish_reason) return g.generation_info.finish_reason;
            return null;
        }).filter((r)=>typeof r === "string");
        if (finishReasons.length > 0) $0e9fa0f33dc5c906$var$setIfDefined(attrs, $MHfcn.GEN_AI_RESPONSE_FINISH_REASONS_ATTRIBUTE, $arYVC.stringify(finishReasons, String));
        $0e9fa0f33dc5c906$var$addToolCallsAttributes(llmResult.generations, attrs);
        if (recordOutputs) {
            const texts = llmResult.generations.flat().map((gen)=>gen.text ?? gen.message?.content).filter((t)=>typeof t === "string");
            if (texts.length > 0) $0e9fa0f33dc5c906$var$setIfDefined(attrs, $MHfcn.GEN_AI_RESPONSE_TEXT_ATTRIBUTE, $arYVC.stringify(texts, String));
        }
    }
    $0e9fa0f33dc5c906$var$addTokenUsageAttributes(llmResult.llmOutput, attrs);
    const llmOutput = llmResult.llmOutput;
    const firstGeneration = llmResult.generations?.[0]?.[0];
    const v1Message = firstGeneration?.message;
    const modelName = llmOutput?.model_name ?? llmOutput?.model ?? v1Message?.response_metadata?.model_name;
    if (modelName) $0e9fa0f33dc5c906$var$setIfDefined(attrs, $MHfcn.GEN_AI_RESPONSE_MODEL_ATTRIBUTE, modelName);
    const responseId = llmOutput?.id ?? v1Message?.id;
    if (responseId) $0e9fa0f33dc5c906$var$setIfDefined(attrs, $MHfcn.GEN_AI_RESPONSE_ID_ATTRIBUTE, responseId);
    const stopReason = llmOutput?.stop_reason ?? v1Message?.response_metadata?.finish_reason;
    if (stopReason) $0e9fa0f33dc5c906$var$setIfDefined(attrs, $MHfcn.GEN_AI_RESPONSE_STOP_REASON_ATTRIBUTE, $arYVC.stringify(stopReason, String));
    return attrs;
}
function $0e9fa0f33dc5c906$var$getAgentNameFromMetadata(metadata) {
    const attrs = {};
    const agentName = metadata?.lc_agent_name;
    if (typeof agentName === "string") attrs[$MHfcn.GEN_AI_AGENT_NAME_ATTRIBUTE] = agentName;
    return attrs;
}
function $0e9fa0f33dc5c906$var$extractToolDefinitions(extraParams) {
    const tools = extraParams?.invocation_params?.tools ?? extraParams?.options?.tools;
    if (!Array.isArray(tools) || tools.length === 0) return void 0;
    const toolDefs = tools.map((tool)=>{
        const fn = tool.function;
        return {
            type: "function",
            name: tool.name ?? fn?.name ?? "",
            description: tool.description ?? fn?.description
        };
    });
    return JSON.stringify(toolDefs);
}
function $0e9fa0f33dc5c906$var$isCallbackManager(value) {
    if (!value || typeof value !== "object") return false;
    const candidate = value;
    return typeof candidate.addHandler === "function" && typeof candidate.copy === "function";
}
function $0e9fa0f33dc5c906$var$isSentryHandler(handler) {
    return typeof handler === "object" && handler?.name === "SentryCallbackHandler";
}
function $0e9fa0f33dc5c906$var$containsSentryHandler(handlers) {
    return handlers.some($0e9fa0f33dc5c906$var$isSentryHandler);
}
function $0e9fa0f33dc5c906$var$_INTERNAL_mergeLangChainCallbackHandler(existing, sentryHandler) {
    if (!existing) return [
        sentryHandler
    ];
    if ($0e9fa0f33dc5c906$var$isCallbackManager(existing)) {
        if ($0e9fa0f33dc5c906$var$containsSentryHandler(existing.handlers ?? [])) return existing;
        const copied = existing.copy();
        copied.addHandler(sentryHandler, true);
        return copied;
    }
    const handlers = Array.isArray(existing) ? existing : [
        existing
    ];
    if ($0e9fa0f33dc5c906$var$containsSentryHandler(handlers)) return existing;
    return [
        ...handlers,
        sentryHandler
    ];
}
module.exports._INTERNAL_mergeLangChainCallbackHandler = $0e9fa0f33dc5c906$var$_INTERNAL_mergeLangChainCallbackHandler;
module.exports.extractChatModelRequestAttributes = $0e9fa0f33dc5c906$var$extractChatModelRequestAttributes;
module.exports.extractLLMRequestAttributes = $0e9fa0f33dc5c906$var$extractLLMRequestAttributes;
module.exports.extractLlmResponseAttributes = $0e9fa0f33dc5c906$var$extractLlmResponseAttributes;
module.exports.extractToolDefinitions = $0e9fa0f33dc5c906$var$extractToolDefinitions;
module.exports.getAgentNameFromMetadata = $0e9fa0f33dc5c906$var$getAgentNameFromMetadata;
module.exports.getInvocationParams = $0e9fa0f33dc5c906$var$getInvocationParams;
module.exports.normalizeLangChainMessages = $0e9fa0f33dc5c906$var$normalizeLangChainMessages;

});


parcelRegister("9Af4h", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $1tl8I = parcelRequire("1tl8I");

var $gTasE = parcelRequire("gTasE");

var $kBDP8 = parcelRequire("kBDP8");

var $MHfcn = parcelRequire("MHfcn");

var $iQAGO = parcelRequire("iQAGO");

var $lhIXN = parcelRequire("lhIXN");
function $6fa32a117dc6d50b$var$inferSystemFromInstance(instance) {
    const name = instance.constructor?.name ?? "";
    if (name.includes("OpenAI")) return "openai";
    if (name.includes("Google")) return "google_genai";
    if (name.includes("Mistral")) return "mistralai";
    if (name.includes("Vertex")) return "google_vertexai";
    if (name.includes("Bedrock")) return "aws_bedrock";
    if (name.includes("Ollama")) return "ollama";
    if (name.includes("Cloudflare")) return "cloudflare";
    if (name.includes("Cohere")) return "cohere";
    return "langchain";
}
function $6fa32a117dc6d50b$var$extractEmbeddingAttributes(instance) {
    const embeddingsInstance = instance ?? {};
    const attributes = {
        [$gTasE.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: $lhIXN.LANGCHAIN_ORIGIN,
        [$gTasE.SEMANTIC_ATTRIBUTE_SENTRY_OP]: $MHfcn.GEN_AI_EMBEDDINGS_OPERATION_ATTRIBUTE,
        [$MHfcn.GEN_AI_OPERATION_NAME_ATTRIBUTE]: "embeddings",
        [$MHfcn.GEN_AI_REQUEST_MODEL_ATTRIBUTE]: embeddingsInstance.model ?? "unknown"
    };
    attributes[$MHfcn.GEN_AI_SYSTEM_ATTRIBUTE] = $6fa32a117dc6d50b$var$inferSystemFromInstance(embeddingsInstance);
    if ("dimensions" in embeddingsInstance) attributes[$MHfcn.GEN_AI_REQUEST_DIMENSIONS_ATTRIBUTE] = embeddingsInstance.dimensions;
    if ("encodingFormat" in embeddingsInstance) attributes[$MHfcn.GEN_AI_REQUEST_ENCODING_FORMAT_ATTRIBUTE] = embeddingsInstance.encodingFormat;
    return attributes;
}
function $6fa32a117dc6d50b$var$_INTERNAL_getLangChainEmbeddingsSpanOptions(instance, input, options = {}) {
    const { recordInputs: recordInputs } = $iQAGO.resolveAIRecordingOptions(options);
    const attributes = $6fa32a117dc6d50b$var$extractEmbeddingAttributes(instance);
    const modelName = attributes[$MHfcn.GEN_AI_REQUEST_MODEL_ATTRIBUTE] || "unknown";
    if (recordInputs && input != null) attributes[$MHfcn.GEN_AI_EMBEDDINGS_INPUT_ATTRIBUTE] = typeof input === "string" ? input : JSON.stringify(input);
    return {
        name: `embeddings ${modelName}`,
        op: $MHfcn.GEN_AI_EMBEDDINGS_OPERATION_ATTRIBUTE,
        attributes: attributes
    };
}
function $6fa32a117dc6d50b$var$instrumentEmbeddingMethod(originalMethod, options = {}) {
    return new Proxy(originalMethod, {
        apply (target, thisArg, args) {
            return $kBDP8.startSpan($6fa32a117dc6d50b$var$_INTERNAL_getLangChainEmbeddingsSpanOptions(thisArg, args[0], options), ()=>{
                return Reflect.apply(target, thisArg, args).then(void 0, (error)=>{
                    $1tl8I.captureException(error, {
                        mechanism: {
                            handled: false,
                            type: "auto.ai.langchain"
                        }
                    });
                    throw error;
                });
            });
        }
    });
}
function $6fa32a117dc6d50b$var$instrumentLangChainEmbeddings(instance, options) {
    const embeddingsInstance = instance;
    if (typeof embeddingsInstance.embedQuery === "function") embeddingsInstance.embedQuery = $6fa32a117dc6d50b$var$instrumentEmbeddingMethod(embeddingsInstance.embedQuery, options);
    if (typeof embeddingsInstance.embedDocuments === "function") embeddingsInstance.embedDocuments = $6fa32a117dc6d50b$var$instrumentEmbeddingMethod(embeddingsInstance.embedDocuments, options);
    return instance;
}
module.exports._INTERNAL_getLangChainEmbeddingsSpanOptions = $6fa32a117dc6d50b$var$_INTERNAL_getLangChainEmbeddingsSpanOptions;
module.exports.instrumentEmbeddingMethod = $6fa32a117dc6d50b$var$instrumentEmbeddingMethod;
module.exports.instrumentLangChainEmbeddings = $6fa32a117dc6d50b$var$instrumentLangChainEmbeddings;

});

parcelRegister("4xjJr", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $1tl8I = parcelRequire("1tl8I");

var $gTasE = parcelRequire("gTasE");

var $arYVC = parcelRequire("arYVC");

var $yI1C9 = parcelRequire("yI1C9");

var $kBDP8 = parcelRequire("kBDP8");

var $MHfcn = parcelRequire("MHfcn");

var $iQAGO = parcelRequire("iQAGO");

var $l8LMz = parcelRequire("l8LMz");

var $1fQ84 = parcelRequire("1fQ84");

var $kxKwQ = parcelRequire("kxKwQ");

var $bSQ9n = parcelRequire("bSQ9n");
let $34d98cd1571f68ef$var$_insideCreateReactAgent = false;
const $34d98cd1571f68ef$var$SENTRY_PATCHED = "__sentry_patched__";
function $34d98cd1571f68ef$var$_INTERNAL_getLangGraphCreateAgentSpanOptions(agentName) {
    const attributes = {
        [$gTasE.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: $kxKwQ.LANGGRAPH_ORIGIN,
        [$gTasE.SEMANTIC_ATTRIBUTE_SENTRY_OP]: "gen_ai.create_agent",
        [$MHfcn.GEN_AI_OPERATION_NAME_ATTRIBUTE]: "create_agent"
    };
    if (agentName) attributes[$MHfcn.GEN_AI_AGENT_NAME_ATTRIBUTE] = agentName;
    return {
        op: "gen_ai.create_agent",
        name: agentName ? `create_agent ${agentName}` : "create_agent",
        attributes: attributes
    };
}
function $34d98cd1571f68ef$var$instrumentStateGraphCompile(originalCompile, options) {
    if (Object.prototype.hasOwnProperty.call(originalCompile, $34d98cd1571f68ef$var$SENTRY_PATCHED)) return originalCompile;
    const sentryHandler = $l8LMz.createLangChainCallbackHandler(options);
    const wrapped = new Proxy(originalCompile, {
        apply (target, thisArg, args) {
            if ($34d98cd1571f68ef$var$_insideCreateReactAgent) return Reflect.apply(target, thisArg, args);
            return $kBDP8.startSpan($34d98cd1571f68ef$var$_INTERNAL_getLangGraphCreateAgentSpanOptions(), (span)=>{
                try {
                    const compiledGraph = Reflect.apply(target, thisArg, args);
                    const compileOptions = args.length > 0 ? args[0] : {};
                    if (compileOptions?.name && typeof compileOptions.name === "string") {
                        span.setAttribute($MHfcn.GEN_AI_AGENT_NAME_ATTRIBUTE, compileOptions.name);
                        span.updateName(`create_agent ${compileOptions.name}`);
                    }
                    const originalInvoke = compiledGraph.invoke;
                    if (originalInvoke && typeof originalInvoke === "function") compiledGraph.invoke = $34d98cd1571f68ef$var$instrumentCompiledGraphInvoke(originalInvoke.bind(compiledGraph), compiledGraph, compileOptions, options, void 0, sentryHandler);
                    return compiledGraph;
                } catch (error) {
                    span.setStatus({
                        code: $yI1C9.SPAN_STATUS_ERROR,
                        message: "internal_error"
                    });
                    $1tl8I.captureException(error, {
                        mechanism: {
                            handled: false,
                            type: "auto.ai.langgraph.error"
                        }
                    });
                    throw error;
                }
            });
        }
    });
    Object.defineProperty(wrapped, $34d98cd1571f68ef$var$SENTRY_PATCHED, {
        value: true,
        enumerable: false
    });
    return wrapped;
}
function $34d98cd1571f68ef$var$instrumentCompiledGraphInvoke(originalInvoke, graphInstance, compileOptions, options, llm, sentryCallbackHandler) {
    return new Proxy(originalInvoke, {
        apply (target, thisArg, args) {
            const modelName = llm?.modelName ?? llm?.model;
            return $kBDP8.startSpan({
                op: "gen_ai.invoke_agent",
                name: "invoke_agent",
                attributes: {
                    [$gTasE.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: $kxKwQ.LANGGRAPH_ORIGIN,
                    [$gTasE.SEMANTIC_ATTRIBUTE_SENTRY_OP]: $MHfcn.GEN_AI_INVOKE_AGENT_OPERATION_ATTRIBUTE,
                    [$MHfcn.GEN_AI_OPERATION_NAME_ATTRIBUTE]: "invoke_agent"
                }
            }, async (span)=>{
                try {
                    const graphName = compileOptions?.name;
                    if (graphName && typeof graphName === "string") {
                        span.setAttribute($MHfcn.GEN_AI_PIPELINE_NAME_ATTRIBUTE, graphName);
                        span.setAttribute($MHfcn.GEN_AI_AGENT_NAME_ATTRIBUTE, graphName);
                        span.updateName(`invoke_agent ${graphName}`);
                    }
                    if (modelName) span.setAttribute($MHfcn.GEN_AI_REQUEST_MODEL_ATTRIBUTE, modelName);
                    const config = args.length > 1 ? args[1] : void 0;
                    const configurable = config?.configurable;
                    const threadId = configurable?.thread_id;
                    if (threadId && typeof threadId === "string") span.setAttribute($MHfcn.GEN_AI_CONVERSATION_ID_ATTRIBUTE, threadId);
                    if (sentryCallbackHandler) {
                        const invokeConfig = args[1] ?? {};
                        args[1] = invokeConfig;
                        const existingMetadata = invokeConfig.metadata ?? {};
                        invokeConfig.metadata = {
                            ...existingMetadata,
                            __sentry_langgraph__: true,
                            ...typeof graphName === "string" ? {
                                lc_agent_name: graphName
                            } : {}
                        };
                        invokeConfig.callbacks = $1fQ84._INTERNAL_mergeLangChainCallbackHandler(invokeConfig.callbacks, sentryCallbackHandler);
                    }
                    const tools = $bSQ9n.extractToolsFromCompiledGraph(graphInstance);
                    if (tools) span.setAttribute($MHfcn.GEN_AI_REQUEST_AVAILABLE_TOOLS_ATTRIBUTE, JSON.stringify(tools));
                    const recordInputs = options.recordInputs;
                    const recordOutputs = options.recordOutputs;
                    const inputMessages = args.length > 0 ? args[0]?.messages ?? [] : [];
                    if (inputMessages && recordInputs) {
                        const normalizedMessages = $1fQ84.normalizeLangChainMessages(inputMessages);
                        const { systemInstructions: systemInstructions, filteredMessages: filteredMessages } = $iQAGO.extractSystemInstructions(normalizedMessages);
                        if (systemInstructions) span.setAttribute($MHfcn.GEN_AI_SYSTEM_INSTRUCTIONS_ATTRIBUTE, systemInstructions);
                        const enableTruncation = $iQAGO.shouldEnableTruncation(options.enableTruncation);
                        const filteredLength = Array.isArray(filteredMessages) ? filteredMessages.length : 0;
                        span.setAttributes({
                            [$MHfcn.GEN_AI_INPUT_MESSAGES_ATTRIBUTE]: enableTruncation ? $iQAGO.getTruncatedJsonString(filteredMessages) : $arYVC.stringify(filteredMessages),
                            [$MHfcn.GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE]: filteredLength
                        });
                    }
                    const result = await Reflect.apply(target, thisArg, args);
                    if (recordOutputs) $bSQ9n.setResponseAttributes(span, inputMessages ?? null, result);
                    return result;
                } catch (error) {
                    span.setStatus({
                        code: $yI1C9.SPAN_STATUS_ERROR,
                        message: "internal_error"
                    });
                    $1tl8I.captureException(error, {
                        mechanism: {
                            handled: false,
                            type: "auto.ai.langgraph.error"
                        }
                    });
                    throw error;
                }
            });
        }
    });
}
function $34d98cd1571f68ef$var$instrumentCreateReactAgent(originalCreateReactAgent, options) {
    if (Object.prototype.hasOwnProperty.call(originalCreateReactAgent, $34d98cd1571f68ef$var$SENTRY_PATCHED)) return originalCreateReactAgent;
    const resolvedOptions = $iQAGO.resolveAIRecordingOptions(options);
    const sentryHandler = $l8LMz.createLangChainCallbackHandler(resolvedOptions);
    const wrapped = new Proxy(originalCreateReactAgent, {
        apply (target, thisArg, args) {
            const llm = $bSQ9n.extractLLMFromParams(args);
            const agentName = $bSQ9n.extractAgentNameFromParams(args);
            const params = args[0];
            if (params && Array.isArray(params.tools) && params.tools.length > 0) $bSQ9n.wrapToolsWithSpans(params.tools, resolvedOptions, agentName ?? void 0);
            $34d98cd1571f68ef$var$_insideCreateReactAgent = true;
            let compiledGraph;
            try {
                compiledGraph = Reflect.apply(target, thisArg, args);
            } finally{
                $34d98cd1571f68ef$var$_insideCreateReactAgent = false;
            }
            const originalInvoke = compiledGraph.invoke;
            if (originalInvoke && typeof originalInvoke === "function") {
                const compileOptions = {};
                if (agentName) compileOptions.name = agentName;
                compiledGraph.invoke = $34d98cd1571f68ef$var$instrumentCompiledGraphInvoke(originalInvoke.bind(compiledGraph), compiledGraph, compileOptions, resolvedOptions, llm, sentryHandler);
            }
            return compiledGraph;
        }
    });
    Object.defineProperty(wrapped, $34d98cd1571f68ef$var$SENTRY_PATCHED, {
        value: true,
        enumerable: false
    });
    return wrapped;
}
function $34d98cd1571f68ef$var$instrumentLangGraph(stateGraph, options) {
    stateGraph.compile = $34d98cd1571f68ef$var$instrumentStateGraphCompile(stateGraph.compile, $iQAGO.resolveAIRecordingOptions(options));
    return stateGraph;
}
module.exports._INTERNAL_getLangGraphCreateAgentSpanOptions = $34d98cd1571f68ef$var$_INTERNAL_getLangGraphCreateAgentSpanOptions;
module.exports.instrumentCompiledGraphInvoke = $34d98cd1571f68ef$var$instrumentCompiledGraphInvoke;
module.exports.instrumentCreateReactAgent = $34d98cd1571f68ef$var$instrumentCreateReactAgent;
module.exports.instrumentLangGraph = $34d98cd1571f68ef$var$instrumentLangGraph;
module.exports.instrumentStateGraphCompile = $34d98cd1571f68ef$var$instrumentStateGraphCompile;

});
parcelRegister("kxKwQ", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $ef4afb59dac155cd$var$LANGGRAPH_INTEGRATION_NAME = "LangGraph";
const $ef4afb59dac155cd$var$LANGGRAPH_ORIGIN = "auto.ai.langgraph";
module.exports.LANGGRAPH_INTEGRATION_NAME = $ef4afb59dac155cd$var$LANGGRAPH_INTEGRATION_NAME;
module.exports.LANGGRAPH_ORIGIN = $ef4afb59dac155cd$var$LANGGRAPH_ORIGIN;

});

parcelRegister("bSQ9n", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $1tl8I = parcelRequire("1tl8I");

var $gTasE = parcelRequire("gTasE");

var $yI1C9 = parcelRequire("yI1C9");

var $kBDP8 = parcelRequire("kBDP8");

var $MHfcn = parcelRequire("MHfcn");

var $1fQ84 = parcelRequire("1fQ84");

var $kxKwQ = parcelRequire("kxKwQ");
function $8a6d30cefd3aee16$var$extractLLMFromParams(args) {
    const arg = args[0];
    if (typeof arg !== "object" || !arg || !("llm" in arg) || !arg.llm || typeof arg.llm !== "object") return null;
    const llm = arg.llm;
    if (typeof llm.modelName !== "string" && typeof llm.model !== "string") return null;
    return llm;
}
function $8a6d30cefd3aee16$var$extractAgentNameFromParams(args) {
    const arg = args[0];
    if (typeof arg === "object" && !!arg && "name" in arg && typeof arg.name === "string") return arg.name;
    return null;
}
function $8a6d30cefd3aee16$var$wrapToolsWithSpans(tools, options, agentName) {
    const SENTRY_WRAPPED = "__sentry_tool_wrapped__";
    for (const tool of tools){
        if (!tool || typeof tool !== "object") continue;
        const t = tool;
        const originalInvoke = t.invoke;
        if (typeof originalInvoke !== "function" || Object.prototype.hasOwnProperty.call(t, SENTRY_WRAPPED)) continue;
        const toolName = typeof t.name === "string" ? t.name : "unknown_tool";
        const toolDescription = typeof t.description === "string" ? t.description : void 0;
        const wrappedInvoke = new Proxy(originalInvoke, {
            apply (target, thisArg, args) {
                const spanAttributes = {
                    [$gTasE.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: $kxKwQ.LANGGRAPH_ORIGIN,
                    [$gTasE.SEMANTIC_ATTRIBUTE_SENTRY_OP]: $MHfcn.GEN_AI_EXECUTE_TOOL_OPERATION_ATTRIBUTE,
                    [$MHfcn.GEN_AI_OPERATION_NAME_ATTRIBUTE]: "execute_tool",
                    [$MHfcn.GEN_AI_TOOL_NAME_ATTRIBUTE]: toolName,
                    [$MHfcn.GEN_AI_TOOL_TYPE_ATTRIBUTE]: "function"
                };
                const callConfig = args[1];
                const callAgentName = callConfig?.metadata?.lc_agent_name ?? agentName;
                if (typeof callAgentName === "string") spanAttributes[$MHfcn.GEN_AI_AGENT_NAME_ATTRIBUTE] = callAgentName;
                if (toolDescription) spanAttributes[$MHfcn.GEN_AI_TOOL_DESCRIPTION_ATTRIBUTE] = toolDescription;
                const input = args[0];
                if (typeof input === "object" && !!input) {
                    if ("id" in input && typeof input.id === "string") spanAttributes[$MHfcn.GEN_AI_TOOL_CALL_ID_ATTRIBUTE] = input.id;
                    if (options.recordInputs) {
                        const toolArgs = "args" in input && typeof input.args === "object" ? input.args : input;
                        try {
                            spanAttributes[$MHfcn.GEN_AI_TOOL_INPUT_ATTRIBUTE] = JSON.stringify(toolArgs);
                        } catch  {}
                    }
                }
                return $kBDP8.startSpan({
                    op: $MHfcn.GEN_AI_EXECUTE_TOOL_OPERATION_ATTRIBUTE,
                    name: `execute_tool ${toolName}`,
                    attributes: spanAttributes
                }, async (span)=>{
                    try {
                        const result = await Reflect.apply(target, thisArg, args);
                        if (options.recordOutputs) try {
                            const resultObj = result;
                            const content = resultObj && typeof resultObj === "object" && "content" in resultObj ? resultObj.content : result;
                            span.setAttribute($MHfcn.GEN_AI_TOOL_OUTPUT_ATTRIBUTE, typeof content === "string" ? content : JSON.stringify(content));
                        } catch  {}
                        return result;
                    } catch (error) {
                        span.setStatus({
                            code: $yI1C9.SPAN_STATUS_ERROR,
                            message: "internal_error"
                        });
                        $1tl8I.captureException(error, {
                            mechanism: {
                                handled: false,
                                type: "auto.ai.langgraph.error"
                            }
                        });
                        throw error;
                    }
                });
            }
        });
        t.invoke = wrappedInvoke;
        Object.defineProperty(t, SENTRY_WRAPPED, {
            value: true,
            enumerable: false
        });
    }
    return tools;
}
function $8a6d30cefd3aee16$var$extractToolCalls(messages) {
    if (!messages || messages.length === 0) return null;
    const toolCalls = [];
    for (const message of messages)if (message && typeof message === "object") {
        const msgToolCalls = message.tool_calls;
        if (msgToolCalls && Array.isArray(msgToolCalls)) toolCalls.push(...msgToolCalls);
    }
    return toolCalls.length > 0 ? toolCalls : null;
}
function $8a6d30cefd3aee16$var$extractTokenUsageFromMessage(message) {
    const msg = message;
    let inputTokens = 0;
    let outputTokens = 0;
    let totalTokens = 0;
    if (msg.usage_metadata && typeof msg.usage_metadata === "object") {
        const usage = msg.usage_metadata;
        if (typeof usage.input_tokens === "number") inputTokens = usage.input_tokens;
        if (typeof usage.output_tokens === "number") outputTokens = usage.output_tokens;
        if (typeof usage.total_tokens === "number") totalTokens = usage.total_tokens;
        return {
            inputTokens: inputTokens,
            outputTokens: outputTokens,
            totalTokens: totalTokens
        };
    }
    if (msg.response_metadata && typeof msg.response_metadata === "object") {
        const metadata = msg.response_metadata;
        if (metadata.tokenUsage && typeof metadata.tokenUsage === "object") {
            const tokenUsage = metadata.tokenUsage;
            if (typeof tokenUsage.promptTokens === "number") inputTokens = tokenUsage.promptTokens;
            if (typeof tokenUsage.completionTokens === "number") outputTokens = tokenUsage.completionTokens;
            if (typeof tokenUsage.totalTokens === "number") totalTokens = tokenUsage.totalTokens;
        }
    }
    return {
        inputTokens: inputTokens,
        outputTokens: outputTokens,
        totalTokens: totalTokens
    };
}
function $8a6d30cefd3aee16$var$extractModelMetadata(span, message) {
    const msg = message;
    if (msg.response_metadata && typeof msg.response_metadata === "object") {
        const metadata = msg.response_metadata;
        if (metadata.model_name && typeof metadata.model_name === "string") span.setAttribute($MHfcn.GEN_AI_RESPONSE_MODEL_ATTRIBUTE, metadata.model_name);
        if (metadata.finish_reason && typeof metadata.finish_reason === "string") span.setAttribute($MHfcn.GEN_AI_RESPONSE_FINISH_REASONS_ATTRIBUTE, [
            metadata.finish_reason
        ]);
    }
}
function $8a6d30cefd3aee16$var$extractToolsFromCompiledGraph(compiledGraph) {
    if (!compiledGraph.builder?.nodes?.tools?.runnable?.tools) return null;
    const tools = compiledGraph.builder?.nodes?.tools?.runnable?.tools;
    if (!tools || !Array.isArray(tools) || tools.length === 0) return null;
    return tools.map((tool)=>({
            name: tool.lc_kwargs?.name,
            description: tool.lc_kwargs?.description,
            schema: tool.lc_kwargs?.schema
        }));
}
function $8a6d30cefd3aee16$var$setResponseAttributes(span, inputMessages, result) {
    const resultObj = result;
    const outputMessages = resultObj?.messages;
    if (!outputMessages || !Array.isArray(outputMessages)) return;
    const inputCount = inputMessages?.length ?? 0;
    const newMessages = outputMessages.length > inputCount ? outputMessages.slice(inputCount) : [];
    if (newMessages.length === 0) return;
    const toolCalls = $8a6d30cefd3aee16$var$extractToolCalls(newMessages);
    if (toolCalls) span.setAttribute($MHfcn.GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE, JSON.stringify(toolCalls));
    const normalizedNewMessages = $1fQ84.normalizeLangChainMessages(newMessages);
    span.setAttribute($MHfcn.GEN_AI_RESPONSE_TEXT_ATTRIBUTE, JSON.stringify(normalizedNewMessages));
    let totalInputTokens = 0;
    let totalOutputTokens = 0;
    let totalTokens = 0;
    for (const message of newMessages){
        const tokens = $8a6d30cefd3aee16$var$extractTokenUsageFromMessage(message);
        totalInputTokens += tokens.inputTokens;
        totalOutputTokens += tokens.outputTokens;
        totalTokens += tokens.totalTokens;
        $8a6d30cefd3aee16$var$extractModelMetadata(span, message);
    }
    if (totalInputTokens > 0) span.setAttribute($MHfcn.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE, totalInputTokens);
    if (totalOutputTokens > 0) span.setAttribute($MHfcn.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE, totalOutputTokens);
    if (totalTokens > 0) span.setAttribute($MHfcn.GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE, totalTokens);
}
module.exports.extractAgentNameFromParams = $8a6d30cefd3aee16$var$extractAgentNameFromParams;
module.exports.extractLLMFromParams = $8a6d30cefd3aee16$var$extractLLMFromParams;
module.exports.extractModelMetadata = $8a6d30cefd3aee16$var$extractModelMetadata;
module.exports.extractTokenUsageFromMessage = $8a6d30cefd3aee16$var$extractTokenUsageFromMessage;
module.exports.extractToolCalls = $8a6d30cefd3aee16$var$extractToolCalls;
module.exports.extractToolsFromCompiledGraph = $8a6d30cefd3aee16$var$extractToolsFromCompiledGraph;
module.exports.setResponseAttributes = $8a6d30cefd3aee16$var$setResponseAttributes;
module.exports.wrapToolsWithSpans = $8a6d30cefd3aee16$var$wrapToolsWithSpans;

});


parcelRegister("fXIk8", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $dzfKZ = parcelRequire("dzfKZ");

var $yI1C9 = parcelRequire("yI1C9");

var $kBDP8 = parcelRequire("kBDP8");

var $iQAGO = parcelRequire("iQAGO");

var $5wARY = parcelRequire("5wARY");

var $eDuSj = parcelRequire("eDuSj");
function $b9eebf7ee297680e$var$isReadableStream(value) {
    return $dzfKZ.isObjectLike(value) && typeof value.pipeThrough === "function" && typeof value.getReader === "function";
}
function $b9eebf7ee297680e$var$instrumentRun(originalRun, context, options) {
    return function instrumentedRun(...args) {
        const [model, inputs, runOptions] = args;
        const operationName = $eDuSj.getOperationName(inputs);
        const requestAttributes = $eDuSj.extractRequestAttributes(model, inputs, operationName);
        const modelName = typeof model === "string" ? model : "unknown";
        const isStreamRequested = !!inputs && typeof inputs === "object" && inputs.stream === true;
        const returnsRawResponse = !!runOptions && typeof runOptions === "object" && (runOptions.returnRawResponse === true || runOptions.websocket === true);
        const spanConfig = {
            name: `${operationName} ${modelName}`,
            op: `gen_ai.${operationName}`,
            attributes: requestAttributes
        };
        if (isStreamRequested && !returnsRawResponse) return $kBDP8.startSpanManual(spanConfig, (span)=>{
            const handleError = (error)=>{
                span.setStatus({
                    code: $yI1C9.SPAN_STATUS_ERROR,
                    message: "internal_error"
                });
                span.end();
                throw error;
            };
            let originalResult;
            try {
                originalResult = originalRun.apply(context, args);
            } catch (error) {
                return handleError(error);
            }
            if (options.recordInputs) $eDuSj.addRequestAttributes(span, inputs, operationName, $iQAGO.shouldEnableTruncation(options.enableTruncation));
            return originalResult.then((result)=>{
                if ($b9eebf7ee297680e$var$isReadableStream(result)) return $5wARY.instrumentWorkersAiStream(result, span, options.recordOutputs);
                $eDuSj.addResponseAttributes(span, result, options.recordOutputs);
                span.end();
                return result;
            }, handleError);
        });
        return $kBDP8.startSpan(spanConfig, (span)=>{
            const originalResult = originalRun.apply(context, args);
            if (options.recordInputs) $eDuSj.addRequestAttributes(span, inputs, operationName, $iQAGO.shouldEnableTruncation(options.enableTruncation));
            return originalResult.then((result)=>{
                if (!returnsRawResponse) $eDuSj.addResponseAttributes(span, result, options.recordOutputs);
                return result;
            });
        });
    };
}
function $b9eebf7ee297680e$var$instrumentWorkersAiClient(client, options) {
    const resolvedOptions = $iQAGO.resolveAIRecordingOptions(options);
    const instrumented = new Proxy(client, {
        get (target, prop, receiver) {
            const value = Reflect.get(target, prop, receiver);
            if (prop === "run" && typeof value === "function") return $b9eebf7ee297680e$var$instrumentRun(value, target, resolvedOptions);
            return typeof value === "function" ? value.bind(target) : value;
        }
    });
    return instrumented;
}
module.exports.instrumentWorkersAiClient = $b9eebf7ee297680e$var$instrumentWorkersAiClient;

});
parcelRegister("5wARY", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $yI1C9 = parcelRequire("yI1C9");

var $iQAGO = parcelRequire("iQAGO");

var $eDuSj = parcelRequire("eDuSj");
function $405c8a6c9e4cd8df$var$accumulateStreamingToolCalls(toolCalls, accumulator) {
    for (const toolCall of toolCalls){
        const name = toolCall.function?.name ?? toolCall.name;
        const args = toolCall.function?.arguments ?? toolCall.arguments;
        if (name == null && args == null) continue;
        const index = toolCall.index ?? 0;
        const existing = accumulator[index];
        if (!existing) accumulator[index] = {
            index: index,
            id: toolCall.id,
            type: toolCall.type,
            function: {
                name: name,
                arguments: args ?? ""
            }
        };
        else if (existing.function) {
            if (name && !existing.function.name) existing.function.name = name;
            if (args) existing.function.arguments = `${existing.function.arguments ?? ""}${args}`;
        }
    }
}
function $405c8a6c9e4cd8df$var$processLine(line, state, recordOutputs, toolCallAccumulator) {
    const trimmed = line.trim();
    if (!trimmed.startsWith("data:")) return;
    const data = trimmed.slice(5).trim();
    if (!data || data === "[DONE]") return;
    let parsed;
    try {
        parsed = JSON.parse(data);
    } catch  {
        return;
    }
    if (parsed.usage) {
        if (typeof parsed.usage.prompt_tokens === "number") state.promptTokens = parsed.usage.prompt_tokens;
        if (typeof parsed.usage.completion_tokens === "number") state.completionTokens = parsed.usage.completion_tokens;
        if (typeof parsed.usage.total_tokens === "number") state.totalTokens = parsed.usage.total_tokens;
    }
    if (recordOutputs && typeof parsed.response === "string") state.responseTexts.push(parsed.response);
    if (recordOutputs && Array.isArray(parsed.tool_calls) && parsed.tool_calls.length > 0) state.toolCalls.push(...parsed.tool_calls);
    if (Array.isArray(parsed.choices)) for (const choice of parsed.choices){
        if (recordOutputs && typeof choice.delta?.content === "string" && choice.delta.content) state.responseTexts.push(choice.delta.content);
        if (recordOutputs && Array.isArray(choice.delta?.tool_calls)) $405c8a6c9e4cd8df$var$accumulateStreamingToolCalls(choice.delta.tool_calls, toolCallAccumulator);
        if (typeof choice.finish_reason === "string") state.finishReasons.push(choice.finish_reason);
    }
}
function $405c8a6c9e4cd8df$var$instrumentWorkersAiStream(stream, span, recordOutputs) {
    const reader = stream.getReader();
    const decoder = new TextDecoder();
    const state = {
        responseId: "",
        responseModel: "",
        finishReasons: [],
        responseTexts: [],
        toolCalls: [],
        promptTokens: void 0,
        completionTokens: void 0,
        totalTokens: void 0
    };
    const toolCallAccumulator = {};
    let buffer = "";
    let spanEnded = false;
    const finish = ()=>{
        if (spanEnded) return;
        spanEnded = true;
        if (recordOutputs) {
            const accumulatedToolCalls = Object.values(toolCallAccumulator);
            if (accumulatedToolCalls.length > 0) state.toolCalls.push(...accumulatedToolCalls);
            $eDuSj.setOutputMessagesAttribute(span, {
                responseText: state.responseTexts.join(""),
                toolCalls: state.toolCalls
            });
        }
        $iQAGO.endStreamSpan(span, state, recordOutputs);
    };
    const flushBuffer = (isDone)=>{
        const lines = buffer.split("\n");
        buffer = isDone ? "" : lines.pop() ?? "";
        for (const line of lines)$405c8a6c9e4cd8df$var$processLine(line, state, recordOutputs, toolCallAccumulator);
    };
    return new ReadableStream({
        async pull (controller) {
            try {
                const { done: done, value: value } = await reader.read();
                if (done) {
                    buffer += decoder.decode();
                    flushBuffer(true);
                    finish();
                    controller.close();
                    return;
                }
                buffer += decoder.decode(value, {
                    stream: true
                });
                flushBuffer(false);
                controller.enqueue(value);
            } catch (error) {
                span.setStatus({
                    code: $yI1C9.SPAN_STATUS_ERROR,
                    message: "internal_error"
                });
                finish();
                controller.error(error);
            }
        },
        async cancel (reason) {
            finish();
            await reader.cancel(reason);
        }
    });
}
module.exports.instrumentWorkersAiStream = $405c8a6c9e4cd8df$var$instrumentWorkersAiStream;

});
parcelRegister("eDuSj", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $5Qfaf = parcelRequire("5Qfaf");

var $gTasE = parcelRequire("gTasE");

var $MHfcn = parcelRequire("MHfcn");

var $iQAGO = parcelRequire("iQAGO");

var $arYVC = parcelRequire("arYVC");

var $5z4jD = parcelRequire("5z4jD");
function $aa7ca85408411ff8$var$getOperationName(inputs) {
    if (inputs && typeof inputs === "object") {
        if ("messages" in inputs || "prompt" in inputs) return "chat";
        if ("text" in inputs) return "embeddings";
    }
    return "chat";
}
function $aa7ca85408411ff8$var$extractRequestAttributes(model, inputs, operationName) {
    const attributes$1 = {
        [$5Qfaf.GEN_AI_PROVIDER_NAME]: $5z4jD.WORKERS_AI_PROVIDER_NAME,
        [$5Qfaf.GEN_AI_OPERATION_NAME]: operationName,
        [$gTasE.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: $5z4jD.WORKERS_AI_ORIGIN,
        [$5Qfaf.GEN_AI_REQUEST_MODEL]: typeof model === "string" ? model : "unknown"
    };
    if (inputs && typeof inputs === "object") {
        const params = inputs;
        if (typeof params.temperature === "number") attributes$1[$5Qfaf.GEN_AI_REQUEST_TEMPERATURE] = params.temperature;
        if (typeof params.max_tokens === "number") attributes$1[$5Qfaf.GEN_AI_REQUEST_MAX_TOKENS] = params.max_tokens;
        if (typeof params.top_p === "number") attributes$1[$5Qfaf.GEN_AI_REQUEST_TOP_P] = params.top_p;
        if (typeof params.top_k === "number") attributes$1[$5Qfaf.GEN_AI_REQUEST_TOP_K] = params.top_k;
        if (typeof params.frequency_penalty === "number") attributes$1[$5Qfaf.GEN_AI_REQUEST_FREQUENCY_PENALTY] = params.frequency_penalty;
        if (typeof params.presence_penalty === "number") attributes$1[$5Qfaf.GEN_AI_REQUEST_PRESENCE_PENALTY] = params.presence_penalty;
        if (params.stream === true) attributes$1[$MHfcn.GEN_AI_REQUEST_STREAM_ATTRIBUTE] = true;
    }
    return attributes$1;
}
function $aa7ca85408411ff8$var$addRequestAttributes(span, inputs, operationName, enableTruncation) {
    if (!inputs || typeof inputs !== "object") return;
    const params = inputs;
    if (operationName === "embeddings") {
        const text = params.text;
        if (text == null || typeof text === "string" && text.length === 0 || Array.isArray(text) && text.length === 0) return;
        span.setAttribute($5Qfaf.GEN_AI_EMBEDDINGS_INPUT, typeof text === "string" ? text : JSON.stringify(text));
        return;
    }
    const src = params.messages ?? params.prompt;
    if (src == null || Array.isArray(src) && src.length === 0) return;
    const { systemInstructions: systemInstructions, filteredMessages: filteredMessages } = $iQAGO.extractSystemInstructions(src);
    if (systemInstructions) span.setAttribute($5Qfaf.GEN_AI_SYSTEM_INSTRUCTIONS, systemInstructions);
    span.setAttribute($5Qfaf.GEN_AI_INPUT_MESSAGES, enableTruncation ? $iQAGO.getTruncatedJsonString(filteredMessages) : $arYVC.stringify(filteredMessages));
    span.setAttribute($MHfcn.GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE, Array.isArray(filteredMessages) ? filteredMessages.length : 1);
}
function $aa7ca85408411ff8$var$setOutputMessagesAttribute(span, { responseText: responseText, toolCalls: toolCalls }) {
    const parts = [];
    if (typeof responseText === "string" && responseText.length > 0) parts.push({
        type: "text",
        content: responseText
    });
    if (Array.isArray(toolCalls)) for (const toolCall of toolCalls){
        if (!toolCall || typeof toolCall !== "object") continue;
        const call = toolCall;
        const name = call.function?.name ?? call.name;
        const args = call.function?.arguments ?? call.arguments;
        parts.push({
            type: "tool_call",
            id: call.id,
            name: name,
            arguments: typeof args === "string" ? args : JSON.stringify(args ?? {})
        });
    }
    if (parts.length > 0) span.setAttribute($MHfcn.GEN_AI_OUTPUT_MESSAGES_ATTRIBUTE, JSON.stringify([
        {
            role: "assistant",
            parts: parts
        }
    ]));
}
function $aa7ca85408411ff8$var$addResponseAttributes(span, result, recordOutputs) {
    if (!result || typeof result !== "object" || // Raw `Response` objects (from `returnRawResponse`/`websocket`) cannot be introspected without consuming them.
    typeof Response !== "undefined" && result instanceof Response) return;
    const response = result;
    if (response.usage) $iQAGO.setTokenUsageAttributes(span, response.usage.prompt_tokens, response.usage.completion_tokens);
    if (recordOutputs) {
        let responseText;
        if (typeof response.response === "string") {
            responseText = response.response;
            span.setAttribute($MHfcn.GEN_AI_RESPONSE_TEXT_ATTRIBUTE, response.response);
        } else if (response.response != null) {
            responseText = JSON.stringify(response.response);
            span.setAttribute($MHfcn.GEN_AI_RESPONSE_TEXT_ATTRIBUTE, responseText);
        }
        const toolCalls = Array.isArray(response.tool_calls) && response.tool_calls.length > 0 ? response.tool_calls : void 0;
        if (toolCalls) span.setAttribute($MHfcn.GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE, JSON.stringify(toolCalls));
        $aa7ca85408411ff8$var$setOutputMessagesAttribute(span, {
            responseText: responseText,
            toolCalls: toolCalls
        });
    }
}
module.exports.addRequestAttributes = $aa7ca85408411ff8$var$addRequestAttributes;
module.exports.addResponseAttributes = $aa7ca85408411ff8$var$addResponseAttributes;
module.exports.extractRequestAttributes = $aa7ca85408411ff8$var$extractRequestAttributes;
module.exports.getOperationName = $aa7ca85408411ff8$var$getOperationName;
module.exports.setOutputMessagesAttribute = $aa7ca85408411ff8$var$setOutputMessagesAttribute;

});
parcelRegister("5z4jD", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $40d391a70ecf1217$var$WORKERS_AI_PROVIDER_NAME = "cloudflare.workers_ai";
const $40d391a70ecf1217$var$WORKERS_AI_ORIGIN = "auto.ai.cloudflare.workers_ai";
module.exports.WORKERS_AI_ORIGIN = $40d391a70ecf1217$var$WORKERS_AI_ORIGIN;
module.exports.WORKERS_AI_PROVIDER_NAME = $40d391a70ecf1217$var$WORKERS_AI_PROVIDER_NAME;

});




parcelRegister("9HMF4", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $hiZR1 = parcelRequire("hiZR1");

var $4gyod = parcelRequire("4gyod");

var $Asczg = parcelRequire("Asczg");

var $f0qnC = parcelRequire("f0qnC");

var $er2dl = parcelRequire("er2dl");

var $g5F8v = parcelRequire("g5F8v");
const $710de057d46c073a$var$MAX_SPANS_PER_ENVELOPE = 1e3;
const $710de057d46c073a$var$MAX_TRACE_WEIGHT_IN_BYTES = 5e6;
class $710de057d46c073a$var$SpanBuffer {
    constructor(client, options){
        this._traceBuckets = /* @__PURE__ */ new Map();
        this._client = client;
        const { maxSpanLimit: maxSpanLimit, flushInterval: flushInterval, maxTraceWeightInBytes: maxTraceWeightInBytes } = options ?? {};
        this._maxSpanLimit = maxSpanLimit && maxSpanLimit > 0 && maxSpanLimit <= $710de057d46c073a$var$MAX_SPANS_PER_ENVELOPE ? maxSpanLimit : $710de057d46c073a$var$MAX_SPANS_PER_ENVELOPE;
        this._flushInterval = flushInterval && flushInterval > 0 ? flushInterval : 5e3;
        this._maxTraceWeight = maxTraceWeightInBytes && maxTraceWeightInBytes > 0 ? maxTraceWeightInBytes : $710de057d46c073a$var$MAX_TRACE_WEIGHT_IN_BYTES;
        this._client.on("flush", ()=>{
            this.drain();
        });
        this._client.on("close", ()=>{
            this._traceBuckets.forEach((bucket)=>{
                clearTimeout(bucket.timeout);
            });
            this._traceBuckets.clear();
        });
    }
    /**
   * Add a span to the buffer.
   */ add(spanJSON) {
        const traceId = spanJSON.trace_id;
        let bucket = this._traceBuckets.get(traceId);
        if (!bucket) {
            bucket = {
                spans: /* @__PURE__ */ new Set(),
                size: 0,
                timeout: $Asczg.safeUnref(setTimeout(()=>{
                    this.flush(traceId);
                }, this._flushInterval))
            };
            this._traceBuckets.set(traceId, bucket);
        }
        bucket.spans.add(spanJSON);
        bucket.size += $g5F8v.estimateSerializedSpanSizeInBytes(spanJSON);
        if (bucket.spans.size >= this._maxSpanLimit || bucket.size >= this._maxTraceWeight) this.flush(traceId);
    }
    /**
   * Drain and flush all buffered traces.
   */ drain() {
        if (!this._traceBuckets.size) return;
        $hiZR1.DEBUG_BUILD && $4gyod.debug.log(`Flushing span tree map with ${this._traceBuckets.size} traces`);
        this._traceBuckets.forEach((_, traceId)=>{
            this.flush(traceId);
        });
    }
    /**
   * Flush spans of a specific trace.
   * In contrast to {@link SpanBuffer.drain}, this method does not flush all traces, but only the one with the given traceId.
   */ flush(traceId) {
        const bucket = this._traceBuckets.get(traceId);
        if (!bucket) return;
        if (!bucket.spans.size) {
            this._removeTrace(traceId);
            return;
        }
        const spans = Array.from(bucket.spans);
        const segmentSpan = spans[0]?._segmentSpan;
        if (!segmentSpan) {
            $hiZR1.DEBUG_BUILD && $4gyod.debug.warn("No segment span reference found on span JSON, cannot compute DSC");
            this._removeTrace(traceId);
            return;
        }
        const dsc = $f0qnC.getDynamicSamplingContextFromSpan(segmentSpan);
        const cleanedSpans = spans.map((spanJSON)=>{
            const { _segmentSpan: _segmentSpan, ...cleanSpanJSON } = spanJSON;
            return cleanSpanJSON;
        });
        const envelope$1 = $er2dl.createStreamedSpanEnvelope(cleanedSpans, dsc, this._client);
        $hiZR1.DEBUG_BUILD && $4gyod.debug.log(`Sending span envelope for trace ${traceId} with ${cleanedSpans.length} spans`);
        this._client.sendEnvelope(envelope$1).then(null, (reason)=>{
            $hiZR1.DEBUG_BUILD && $4gyod.debug.error("Error while sending streamed span envelope:", reason);
        });
        this._removeTrace(traceId);
    }
    _removeTrace(traceId) {
        const bucket = this._traceBuckets.get(traceId);
        if (bucket) clearTimeout(bucket.timeout);
        this._traceBuckets.delete(traceId);
    }
}
module.exports.SpanBuffer = $710de057d46c073a$var$SpanBuffer;

});
parcelRegister("er2dl", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $7E8b3 = parcelRequire("7E8b3");

var $636GJ = parcelRequire("636GJ");

var $kIp0s = parcelRequire("kIp0s");

var $lLUp4 = parcelRequire("lLUp4");
function $a8254dfcba6b3b1e$var$createStreamedSpanEnvelope(serializedSpans, dsc, client) {
    const options = client.getOptions();
    const dsn$1 = client.getDsn();
    const tunnel = options.tunnel;
    const sdk = $636GJ.getSdkMetadataForEnvelopeHeader(options._metadata);
    const headers = {
        sent_at: new Date($lLUp4.safeDateNow()).toISOString(),
        ...$a8254dfcba6b3b1e$var$dscHasRequiredProps(dsc) && {
            trace: dsc
        },
        ...sdk && {
            sdk: sdk
        },
        ...!!tunnel && dsn$1 && {
            dsn: $7E8b3.dsnToString(dsn$1)
        }
    };
    const inferSetting = client.getDataCollectionOptions().userInfo ? "auto" : "never";
    const spanContainer = [
        {
            type: "span",
            item_count: serializedSpans.length,
            content_type: "application/vnd.sentry.items.span.v2+json"
        },
        {
            version: 2,
            ...$kIp0s.isBrowser() && {
                ingest_settings: {
                    infer_ip: inferSetting,
                    infer_user_agent: inferSetting
                }
            },
            items: serializedSpans
        }
    ];
    return $636GJ.createEnvelope(headers, [
        spanContainer
    ]);
}
function $a8254dfcba6b3b1e$var$dscHasRequiredProps(dsc) {
    return !!dsc.trace_id && !!dsc.public_key;
}
module.exports.createStreamedSpanEnvelope = $a8254dfcba6b3b1e$var$createStreamedSpanEnvelope;

});

parcelRegister("g5F8v", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $iSFYH = parcelRequire("iSFYH");
function $bb6d05c222195ab7$var$estimateSerializedSpanSizeInBytes(span) {
    let weight = 156;
    weight += span.name.length * 2;
    weight += $iSFYH.estimateTypedAttributesSizeInBytes(span.attributes);
    if (span.links && span.links.length > 0) {
        const firstLink = span.links[0];
        const attributes$1 = firstLink?.attributes;
        const linkWeight = 100 + (attributes$1 ? $iSFYH.estimateTypedAttributesSizeInBytes(attributes$1) : 0);
        weight += linkWeight * span.links.length;
    }
    return weight;
}
module.exports.estimateSerializedSpanSizeInBytes = $bb6d05c222195ab7$var$estimateSerializedSpanSizeInBytes;

});


parcelRegister("hPkVj", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $hiZR1 = parcelRequire("hiZR1");

var $g33UP = parcelRequire("g33UP");

var $hOwNc = parcelRequire("hOwNc");

var $452ZL = parcelRequire("452ZL");

var $8ICT0 = parcelRequire("8ICT0");

var $9HMF4 = parcelRequire("9HMF4");

var $4gyod = parcelRequire("4gyod");

var $8jbnX = parcelRequire("8jbnX");
const $cfa76e06b1450ea7$var$spanStreamingIntegration = $g33UP.defineIntegration(()=>{
    return {
        name: "SpanStreaming",
        setup (client) {
            const initialMessage = "SpanStreaming integration requires";
            const fallbackMsg = "Falling back to static trace lifecycle.";
            const clientOptions = client.getOptions();
            if (!$8ICT0.hasSpanStreamingEnabled(client)) {
                clientOptions.traceLifecycle = "static";
                $hiZR1.DEBUG_BUILD && $4gyod.debug.warn(`${initialMessage} \`traceLifecycle\` to be set to "stream"! ${fallbackMsg}`);
                return;
            }
            const beforeSendSpan$1 = clientOptions.beforeSendSpan;
            if (beforeSendSpan$1 && !$hOwNc.isStreamedBeforeSendSpanCallback(beforeSendSpan$1)) {
                clientOptions.traceLifecycle = "static";
                $hiZR1.DEBUG_BUILD && $4gyod.debug.warn(`${initialMessage} a beforeSendSpan callback using \`withStreamedSpan\`! ${fallbackMsg}`);
                return;
            }
            const buffer = new $9HMF4.SpanBuffer(client);
            client.on("afterSpanEnd", (span)=>{
                if (!$8jbnX.spanIsSampled(span)) return;
                buffer.add($452ZL.captureSpan(span, client));
            });
        }
    };
});
module.exports.spanStreamingIntegration = $cfa76e06b1450ea7$var$spanStreamingIntegration;

});

parcelRegister("1q5J2", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $108ca91da3c57e0d$var$getBreadcrumbLogLevelFromHttpStatusCode(statusCode) {
    if (statusCode === void 0) return void 0;
    else if (statusCode >= 400 && statusCode < 500) return "warning";
    else if (statusCode >= 500) return "error";
    else return void 0;
}
module.exports.getBreadcrumbLogLevelFromHttpStatusCode = $108ca91da3c57e0d$var$getBreadcrumbLogLevelFromHttpStatusCode;

});

parcelRegister("9rQX1", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
class $6e0fb59ca672966a$var$SentryError extends Error {
    constructor(message, logLevel = "warn"){
        super(message);
        this.message = message;
        this.logLevel = logLevel;
    }
}
module.exports.SentryError = $6e0fb59ca672966a$var$SentryError;

});

parcelRegister("f1mbT", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $79m2C = parcelRequire("79m2C");

var $dzfKZ = parcelRequire("dzfKZ");

var $7OVjx = parcelRequire("7OVjx");

var $58ep5 = parcelRequire("58ep5");

var $ihsl1 = parcelRequire("ihsl1");

var $eP8Ri = parcelRequire("eP8Ri");

var $1d06v = parcelRequire("1d06v");
function $aef829a030553ee2$var$addFetchInstrumentationHandler(handler, skipNativeFetchCheck) {
    const type = "fetch";
    const removeHandler = $1d06v.addHandler(type, handler);
    $1d06v.maybeInstrument(type, ()=>$aef829a030553ee2$var$instrumentFetch(void 0, skipNativeFetchCheck));
    return removeHandler;
}
function $aef829a030553ee2$var$addFetchEndInstrumentationHandler(handler) {
    const type = "fetch-body-resolved";
    const removeHandler = $1d06v.addHandler(type, handler);
    $1d06v.maybeInstrument(type, ()=>$aef829a030553ee2$var$instrumentFetch($aef829a030553ee2$var$streamHandler));
    return removeHandler;
}
function $aef829a030553ee2$var$instrumentFetch(onFetchResolved, skipNativeFetchCheck = false) {
    if (skipNativeFetchCheck && !$58ep5.supportsNativeFetch()) return;
    $7OVjx.fill($eP8Ri.GLOBAL_OBJ, "fetch", function(originalFetch) {
        return function(...args) {
            const virtualError = new Error();
            const { method: method, url: url } = $aef829a030553ee2$var$parseFetchArgs(args);
            const handlerData = {
                args: args,
                fetchData: {
                    method: method,
                    url: url
                },
                startTimestamp: $ihsl1.timestampInSeconds() * 1e3,
                virtualError: // // Adding the error to be able to fingerprint the failed fetch event in HttpClient instrumentation
                virtualError,
                headers: $aef829a030553ee2$var$getHeadersFromFetchArgs(args)
            };
            if (!onFetchResolved) $1d06v.triggerHandlers("fetch", {
                ...handlerData
            });
            return originalFetch.apply($eP8Ri.GLOBAL_OBJ, args).then(async (response)=>{
                if (onFetchResolved) onFetchResolved(response);
                else $1d06v.triggerHandlers("fetch", {
                    ...handlerData,
                    endTimestamp: $ihsl1.timestampInSeconds() * 1e3,
                    response: response
                });
                return response;
            }, (error)=>{
                $1d06v.triggerHandlers("fetch", {
                    ...handlerData,
                    endTimestamp: $ihsl1.timestampInSeconds() * 1e3,
                    error: error
                });
                if ($dzfKZ.isError(error) && error.stack === void 0) {
                    error.stack = virtualError.stack;
                    $7OVjx.addNonEnumerableProperty(error, "framesToPop", 1);
                }
                const client = $79m2C.getClient();
                const enhanceOption = client?.getOptions().enhanceFetchErrorMessages ?? "always";
                const shouldEnhance = enhanceOption !== false;
                if (shouldEnhance && error instanceof TypeError && (error.message === "Failed to fetch" || error.message === "Load failed" || error.message === "NetworkError when attempting to fetch resource.")) try {
                    const url2 = new URL(handlerData.fetchData.url);
                    const hostname = url2.host;
                    if (enhanceOption === "always") error.message = `${error.message} (${hostname})`;
                    else $7OVjx.addNonEnumerableProperty(error, "__sentry_fetch_url_host__", hostname);
                } catch  {}
                throw error;
            });
        };
    });
}
async function $aef829a030553ee2$var$resolveResponse(res, onFinishedResolving) {
    if (res?.body) {
        const body = res.body;
        const responseReader = body.getReader();
        const maxFetchDurationTimeout = setTimeout(()=>{
            body.cancel().then(null, ()=>{});
        }, 90000);
        let readingActive = true;
        while(readingActive){
            let chunkTimeout;
            try {
                chunkTimeout = setTimeout(()=>{
                    body.cancel().then(null, ()=>{});
                }, 5e3);
                const { done: done } = await responseReader.read();
                clearTimeout(chunkTimeout);
                if (done) {
                    onFinishedResolving();
                    readingActive = false;
                }
            } catch  {
                readingActive = false;
            } finally{
                clearTimeout(chunkTimeout);
            }
        }
        clearTimeout(maxFetchDurationTimeout);
        responseReader.releaseLock();
        body.cancel().then(null, ()=>{});
    }
}
function $aef829a030553ee2$var$streamHandler(response) {
    let clonedResponseForResolving;
    try {
        clonedResponseForResolving = response.clone();
    } catch  {
        return;
    }
    $aef829a030553ee2$var$resolveResponse(clonedResponseForResolving, ()=>{
        $1d06v.triggerHandlers("fetch-body-resolved", {
            endTimestamp: $ihsl1.timestampInSeconds() * 1e3,
            response: response
        });
    });
}
function $aef829a030553ee2$var$hasProp(obj, prop) {
    return $dzfKZ.isObjectLike(obj) && !!obj[prop];
}
function $aef829a030553ee2$var$getUrlFromResource(resource) {
    if (typeof resource === "string") return resource;
    if (!resource) return "";
    if ($aef829a030553ee2$var$hasProp(resource, "url")) return resource.url;
    if (resource.toString) return resource.toString();
    return "";
}
function $aef829a030553ee2$var$parseFetchArgs(fetchArgs) {
    if (fetchArgs.length === 0) return {
        method: "GET",
        url: ""
    };
    if (fetchArgs.length === 2) {
        const [resource, options] = fetchArgs;
        return {
            url: $aef829a030553ee2$var$getUrlFromResource(resource),
            method: $aef829a030553ee2$var$hasProp(options, "method") ? String(options.method).toUpperCase() : // Request object as first argument
            $dzfKZ.isRequest(resource) && $aef829a030553ee2$var$hasProp(resource, "method") ? String(resource.method).toUpperCase() : "GET"
        };
    }
    const arg = fetchArgs[0];
    return {
        url: $aef829a030553ee2$var$getUrlFromResource(arg),
        method: $aef829a030553ee2$var$hasProp(arg, "method") ? String(arg.method).toUpperCase() : "GET"
    };
}
function $aef829a030553ee2$var$getHeadersFromFetchArgs(fetchArgs) {
    const [requestArgument, optionsArgument] = fetchArgs;
    try {
        if (typeof optionsArgument === "object" && optionsArgument !== null && "headers" in optionsArgument && optionsArgument.headers) return new Headers(optionsArgument.headers);
        if ($dzfKZ.isRequest(requestArgument)) return new Headers(requestArgument.headers);
    } catch  {}
    return;
}
module.exports.addFetchEndInstrumentationHandler = $aef829a030553ee2$var$addFetchEndInstrumentationHandler;
module.exports.addFetchInstrumentationHandler = $aef829a030553ee2$var$addFetchInstrumentationHandler;
module.exports.parseFetchArgs = $aef829a030553ee2$var$parseFetchArgs;

});
parcelRegister("58ep5", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $hiZR1 = parcelRequire("hiZR1");

var $4gyod = parcelRequire("4gyod");

var $eP8Ri = parcelRequire("eP8Ri");
const $3bc8df623581c419$var$WINDOW = $eP8Ri.GLOBAL_OBJ;
function $3bc8df623581c419$var$supportsErrorEvent() {
    try {
        new ErrorEvent("");
        return true;
    } catch  {
        return false;
    }
}
function $3bc8df623581c419$var$supportsDOMError() {
    try {
        new DOMError("");
        return true;
    } catch  {
        return false;
    }
}
function $3bc8df623581c419$var$supportsDOMException() {
    try {
        new DOMException("");
        return true;
    } catch  {
        return false;
    }
}
function $3bc8df623581c419$var$supportsHistory() {
    return "history" in $3bc8df623581c419$var$WINDOW && !!$3bc8df623581c419$var$WINDOW.history;
}
const $3bc8df623581c419$var$supportsFetch = $3bc8df623581c419$var$_isFetchSupported;
function $3bc8df623581c419$var$_isFetchSupported() {
    if (!("fetch" in $3bc8df623581c419$var$WINDOW)) return false;
    try {
        new Headers();
        new Request("data:,");
        new Response();
        return true;
    } catch  {
        return false;
    }
}
function $3bc8df623581c419$var$isNativeFunction(func) {
    return func && /^function\s+\w+\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
function $3bc8df623581c419$var$supportsNativeFetch() {
    if (typeof EdgeRuntime === "string") return true;
    if (!$3bc8df623581c419$var$_isFetchSupported()) return false;
    if ($3bc8df623581c419$var$isNativeFunction($3bc8df623581c419$var$WINDOW.fetch)) return true;
    let result = false;
    const doc = $3bc8df623581c419$var$WINDOW.document;
    if (doc && typeof doc.createElement === "function") try {
        const sandbox = doc.createElement("iframe");
        sandbox.hidden = true;
        doc.head.appendChild(sandbox);
        if (sandbox.contentWindow?.fetch) result = $3bc8df623581c419$var$isNativeFunction(sandbox.contentWindow.fetch);
        doc.head.removeChild(sandbox);
    } catch (err) {
        $hiZR1.DEBUG_BUILD && $4gyod.debug.warn("Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ", err);
    }
    return result;
}
function $3bc8df623581c419$var$supportsReportingObserver() {
    return "ReportingObserver" in $3bc8df623581c419$var$WINDOW;
}
function $3bc8df623581c419$var$supportsReferrerPolicy() {
    if (!$3bc8df623581c419$var$_isFetchSupported()) return false;
    try {
        new Request("_", {
            referrerPolicy: "origin"
        });
        return true;
    } catch  {
        return false;
    }
}
module.exports.isNativeFunction = $3bc8df623581c419$var$isNativeFunction;
module.exports.supportsDOMError = $3bc8df623581c419$var$supportsDOMError;
module.exports.supportsDOMException = $3bc8df623581c419$var$supportsDOMException;
module.exports.supportsErrorEvent = $3bc8df623581c419$var$supportsErrorEvent;
module.exports.supportsFetch = $3bc8df623581c419$var$supportsFetch;
module.exports.supportsHistory = $3bc8df623581c419$var$supportsHistory;
module.exports.supportsNativeFetch = $3bc8df623581c419$var$supportsNativeFetch;
module.exports.supportsReferrerPolicy = $3bc8df623581c419$var$supportsReferrerPolicy;
module.exports.supportsReportingObserver = $3bc8df623581c419$var$supportsReportingObserver;

});


parcelRegister("5sHNN", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $3fa18b7a359e3284$var$replaceExports(exports1, exportName, wrappedConstructor) {
    const original = exports1[exportName];
    if (typeof original !== "function") return;
    try {
        exports1[exportName] = wrappedConstructor;
    } catch  {
        Object.defineProperty(exports1, exportName, {
            value: wrappedConstructor,
            writable: true,
            configurable: true,
            enumerable: true
        });
    }
    if (exports1.default === original) try {
        exports1.default = wrappedConstructor;
    } catch  {
        Object.defineProperty(exports1, "default", {
            value: wrappedConstructor,
            writable: true,
            configurable: true,
            enumerable: true
        });
    }
}
module.exports.replaceExports = $3fa18b7a359e3284$var$replaceExports;

});

parcelRegister("kzbBU", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
class $ef901519cfff0caa$var$LRUMap {
    constructor(_maxSize){
        this._maxSize = _maxSize;
        this._cache = /* @__PURE__ */ new Map();
    }
    /** Get the current size of the cache */ get size() {
        return this._cache.size;
    }
    /** Get an entry or undefined if it was not in the cache. Re-inserts to update the recently used order */ get(key) {
        const value = this._cache.get(key);
        if (value === void 0) return void 0;
        this._cache.delete(key);
        this._cache.set(key, value);
        return value;
    }
    /** Insert an entry and evict an older entry if we've reached maxSize */ set(key, value) {
        if (this._cache.size >= this._maxSize) {
            const nextKey = this._cache.keys().next().value;
            this._cache.delete(nextKey);
        }
        this._cache.set(key, value);
    }
    /** Remove an entry and return the entry if it was in the cache */ remove(key) {
        const value = this._cache.get(key);
        if (value) this._cache.delete(key);
        return value;
    }
    /** Clear all entries */ clear() {
        this._cache.clear();
    }
    /** Get all the keys */ keys() {
        return Array.from(this._cache.keys());
    }
    /** Get all the values */ values() {
        const values = [];
        this._cache.forEach((value)=>values.push(value));
        return values;
    }
}
module.exports.LRUMap = $ef901519cfff0caa$var$LRUMap;

});

parcelRegister("2K1Wi", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $1ff161bb55f6843f$var$escapeStringForRegex(regexString) {
    return regexString.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d");
}
module.exports.escapeStringForRegex = $1ff161bb55f6843f$var$escapeStringForRegex;

});

parcelRegister("fNJme", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $dzfKZ = parcelRequire("dzfKZ");

var $eP8Ri = parcelRequire("eP8Ri");
const $b80e9db6c971dbf6$var$WINDOW = $eP8Ri.GLOBAL_OBJ;
const $b80e9db6c971dbf6$var$DEFAULT_MAX_STRING_LENGTH = 80;
function $b80e9db6c971dbf6$var$htmlTreeAsString(elem, options = {}) {
    if (!elem) return "<unknown>";
    try {
        let currentElem = elem;
        const MAX_TRAVERSE_HEIGHT = 5;
        const out = [];
        let height = 0;
        let len = 0;
        const separator = " > ";
        const sepLength = separator.length;
        let nextStr;
        const keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
        const maxStringLength = !Array.isArray(options) && options.maxStringLength || $b80e9db6c971dbf6$var$DEFAULT_MAX_STRING_LENGTH;
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $b80e9db6c971dbf6$var$_htmlElementAsString(currentElem, keyAttrs);
            if (nextStr === "html" || height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch  {
        return "<unknown>";
    }
}
function $b80e9db6c971dbf6$var$_htmlElementAsString(el, keyAttrs) {
    const elem = el;
    const out = [];
    if (!elem?.tagName) return "";
    if ($b80e9db6c971dbf6$var$WINDOW.HTMLElement) {
        if (elem instanceof HTMLElement && elem.dataset) {
            if (elem.dataset["sentryComponent"]) return elem.dataset["sentryComponent"];
            if (elem.dataset["sentryElement"]) return elem.dataset["sentryElement"];
        }
    }
    out.push(elem.tagName.toLowerCase());
    const keyAttrPairs = keyAttrs?.length ? keyAttrs.filter((keyAttr)=>elem.getAttribute(keyAttr)).map((keyAttr)=>[
            keyAttr,
            elem.getAttribute(keyAttr)
        ]) : null;
    if (keyAttrPairs?.length) keyAttrPairs.forEach((keyAttrPair)=>{
        out.push(`[${keyAttrPair[0]}="${keyAttrPair[1]}"]`);
    });
    else {
        if (elem.id) out.push(`#${elem.id}`);
        const className = elem.className;
        if (className && $dzfKZ.isString(className)) {
            const classes = className.split(/\s+/);
            for (const c of classes)out.push(`.${c}`);
        }
    }
    for (const k of [
        "aria-label",
        "type",
        "name",
        "title",
        "alt"
    ]){
        const attr = elem.getAttribute(k);
        if (attr) out.push(`[${k}="${attr}"]`);
    }
    return out.join("");
}
function $b80e9db6c971dbf6$var$getLocationHref() {
    try {
        return $b80e9db6c971dbf6$var$WINDOW.document.location.href;
    } catch  {
        return "";
    }
}
function $b80e9db6c971dbf6$var$getComponentName(elem, maxTraverseHeight = 5) {
    if (!$b80e9db6c971dbf6$var$WINDOW.HTMLElement) return null;
    let currentElem = elem;
    for(let i = 0; i < maxTraverseHeight; i++){
        if (!currentElem) return null;
        if (currentElem instanceof HTMLElement) {
            if (currentElem.dataset["sentryComponent"]) return currentElem.dataset["sentryComponent"];
            if (currentElem.dataset["sentryElement"]) return currentElem.dataset["sentryElement"];
        }
        currentElem = currentElem.parentNode;
    }
    return null;
}
module.exports.getComponentName = $b80e9db6c971dbf6$var$getComponentName;
module.exports.getLocationHref = $b80e9db6c971dbf6$var$getLocationHref;
module.exports.htmlTreeAsString = $b80e9db6c971dbf6$var$htmlTreeAsString;

});



parcelRegister("e3Llk", function(module, exports) {

$parcel$export(module.exports, "addHistoryInstrumentationHandler", function () { return $a3c611db4c5b7bce$export$3f18c56c58114e75; });

var $f5byn = parcelRequire("f5byn");
var $4zVoD = parcelRequire("4zVoD");
var $i0qqg = parcelRequire("i0qqg");

var $gWPaa = parcelRequire("gWPaa");
let $a3c611db4c5b7bce$var$lastHref;
function $a3c611db4c5b7bce$export$3f18c56c58114e75(handler) {
    const type = "history";
    (0, $f5byn.addHandler)(type, handler);
    (0, $f5byn.maybeInstrument)(type, $a3c611db4c5b7bce$export$d9b613a6254a184e);
}
function $a3c611db4c5b7bce$export$d9b613a6254a184e() {
    (0, $gWPaa.WINDOW).addEventListener("popstate", ()=>{
        const to = (0, $gWPaa.WINDOW).location.href;
        const from = $a3c611db4c5b7bce$var$lastHref;
        $a3c611db4c5b7bce$var$lastHref = to;
        if (from === to) return;
        const handlerData = {
            from: from,
            to: to
        };
        (0, $f5byn.triggerHandlers)("history", handlerData);
    });
    if (!(0, $i0qqg.supportsHistory)()) return;
    function historyReplacementFunction(originalHistoryFunction) {
        return function(...args) {
            const url = args.length > 2 ? args[2] : void 0;
            if (url) {
                const from = $a3c611db4c5b7bce$var$lastHref;
                const to = $a3c611db4c5b7bce$var$getAbsoluteUrl(String(url));
                $a3c611db4c5b7bce$var$lastHref = to;
                if (from === to) return originalHistoryFunction.apply(this, args);
                const handlerData = {
                    from: from,
                    to: to
                };
                (0, $f5byn.triggerHandlers)("history", handlerData);
            }
            return originalHistoryFunction.apply(this, args);
        };
    }
    (0, $4zVoD.fill)((0, $gWPaa.WINDOW).history, "pushState", historyReplacementFunction);
    (0, $4zVoD.fill)((0, $gWPaa.WINDOW).history, "replaceState", historyReplacementFunction);
}
function $a3c611db4c5b7bce$var$getAbsoluteUrl(urlOrPath) {
    try {
        const url = new URL(urlOrPath, (0, $gWPaa.WINDOW).location.origin);
        return url.toString();
    } catch  {
        return urlOrPath;
    }
}

});
parcelRegister("f5byn", function(module, exports) {

$parcel$export(module.exports, "addHandler", function () { return $afb048eead44b8aa$export$a4e09611e30da72e; });
$parcel$export(module.exports, "maybeInstrument", function () { return $afb048eead44b8aa$export$e18d6c5462c01368; });
$parcel$export(module.exports, "triggerHandlers", function () { return $afb048eead44b8aa$export$b18c893e424d3127; });

var $hv7EP = parcelRequire("hv7EP");

var $w8bd7 = parcelRequire("w8bd7");

var $iFp2j = parcelRequire("iFp2j");
const $afb048eead44b8aa$var$handlers = {};
const $afb048eead44b8aa$var$instrumented = {};
function $afb048eead44b8aa$export$a4e09611e30da72e(type, handler) {
    $afb048eead44b8aa$var$handlers[type] = $afb048eead44b8aa$var$handlers[type] || [];
    $afb048eead44b8aa$var$handlers[type].push(handler);
    return ()=>{
        const typeHandlers = $afb048eead44b8aa$var$handlers[type];
        if (typeHandlers) {
            const index = typeHandlers.indexOf(handler);
            if (index !== -1) typeHandlers.splice(index, 1);
        }
    };
}
function $afb048eead44b8aa$export$b17eab759a1cb5fe() {
    Object.keys($afb048eead44b8aa$var$handlers).forEach((key)=>{
        $afb048eead44b8aa$var$handlers[key] = void 0;
    });
}
function $afb048eead44b8aa$export$e18d6c5462c01368(type, instrumentFn) {
    if (!$afb048eead44b8aa$var$instrumented[type]) {
        $afb048eead44b8aa$var$instrumented[type] = true;
        try {
            instrumentFn();
        } catch (e) {
            (0, $hv7EP.DEBUG_BUILD) && (0, $w8bd7.debug).error(`Error while instrumenting ${type}`, e);
        }
    }
}
function $afb048eead44b8aa$export$b18c893e424d3127(type, data) {
    const typeHandlers = type && $afb048eead44b8aa$var$handlers[type];
    if (!typeHandlers) return;
    for (const handler of typeHandlers)try {
        handler(data);
    } catch (e) {
        (0, $hv7EP.DEBUG_BUILD) && (0, $w8bd7.debug).error(`Error while triggering instrumentation handler.
Type: ${type}
Name: ${(0, $iFp2j.getFunctionName)(handler)}
Error:`, e);
    }
}

});
parcelRegister("hv7EP", function(module, exports) {

$parcel$export(module.exports, "DEBUG_BUILD", function () { return $cbdb458af46ab2df$export$16a28057038b10ef; });
const $cbdb458af46ab2df$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;

});

parcelRegister("w8bd7", function(module, exports) {

$parcel$export(module.exports, "consoleSandbox", function () { return $0609559d4cdceb9f$export$cda52e2a8927a2ca; });
$parcel$export(module.exports, "debug", function () { return $0609559d4cdceb9f$export$1c9f709888824e05; });

var $2vdTp = parcelRequire("2vdTp");

var $hv7EP = parcelRequire("hv7EP");

var $bZENS = parcelRequire("bZENS");
const $0609559d4cdceb9f$export$2a2b1d2252a69ecb = [
    "debug",
    "info",
    "warn",
    "error",
    "log",
    "assert",
    "trace"
];
const $0609559d4cdceb9f$var$PREFIX = "Sentry Logger ";
const $0609559d4cdceb9f$export$77c4ce905194557b = {};
function $0609559d4cdceb9f$export$cda52e2a8927a2ca(callback) {
    if (!("console" in (0, $bZENS.GLOBAL_OBJ))) return callback();
    const console = (0, $bZENS.GLOBAL_OBJ).console;
    const wrappedFuncs = {};
    const wrappedLevels = Object.keys($0609559d4cdceb9f$export$77c4ce905194557b);
    wrappedLevels.forEach((level)=>{
        const originalConsoleMethod = $0609559d4cdceb9f$export$77c4ce905194557b[level];
        wrappedFuncs[level] = console[level];
        console[level] = originalConsoleMethod;
    });
    try {
        return callback();
    } finally{
        wrappedLevels.forEach((level)=>{
            console[level] = wrappedFuncs[level];
        });
    }
}
function $0609559d4cdceb9f$var$enable() {
    $0609559d4cdceb9f$var$_getLoggerSettings().enabled = true;
}
function $0609559d4cdceb9f$var$disable() {
    $0609559d4cdceb9f$var$_getLoggerSettings().enabled = false;
}
function $0609559d4cdceb9f$var$isEnabled() {
    return $0609559d4cdceb9f$var$_getLoggerSettings().enabled;
}
function $0609559d4cdceb9f$var$log(...args) {
    $0609559d4cdceb9f$var$_maybeLog("log", ...args);
}
function $0609559d4cdceb9f$var$warn(...args) {
    $0609559d4cdceb9f$var$_maybeLog("warn", ...args);
}
function $0609559d4cdceb9f$var$error(...args) {
    $0609559d4cdceb9f$var$_maybeLog("error", ...args);
}
function $0609559d4cdceb9f$var$_maybeLog(level, ...args) {
    if (!(0, $hv7EP.DEBUG_BUILD)) return;
    if ($0609559d4cdceb9f$var$isEnabled()) $0609559d4cdceb9f$export$cda52e2a8927a2ca(()=>{
        (0, $bZENS.GLOBAL_OBJ).console[level](`${$0609559d4cdceb9f$var$PREFIX}[${level}]:`, ...args);
    });
}
function $0609559d4cdceb9f$var$_getLoggerSettings() {
    if (!(0, $hv7EP.DEBUG_BUILD)) return {
        enabled: false
    };
    return (0, $2vdTp.getGlobalSingleton)("loggerSettings", ()=>({
            enabled: false
        }));
}
const $0609559d4cdceb9f$export$1c9f709888824e05 = {
    enable: /** Enable logging. */ $0609559d4cdceb9f$var$enable,
    disable: /** Disable logging. */ $0609559d4cdceb9f$var$disable,
    isEnabled: /** Check if logging is enabled. */ $0609559d4cdceb9f$var$isEnabled,
    log: /** Log a message. */ $0609559d4cdceb9f$var$log,
    warn: /** Log a warning. */ $0609559d4cdceb9f$var$warn,
    error: /** Log an error. */ $0609559d4cdceb9f$var$error
};

});
parcelRegister("2vdTp", function(module, exports) {

$parcel$export(module.exports, "getMainCarrier", function () { return $1d2940d79e14f202$export$19eade501500c6c1; });
$parcel$export(module.exports, "getSentryCarrier", function () { return $1d2940d79e14f202$export$c8bfa33e4e8ae492; });
$parcel$export(module.exports, "getGlobalSingleton", function () { return $1d2940d79e14f202$export$7e223ec222791509; });

var $iOjzR = parcelRequire("iOjzR");

var $bZENS = parcelRequire("bZENS");
function $1d2940d79e14f202$export$19eade501500c6c1() {
    $1d2940d79e14f202$export$c8bfa33e4e8ae492((0, $bZENS.GLOBAL_OBJ));
    return 0, $bZENS.GLOBAL_OBJ;
}
function $1d2940d79e14f202$export$c8bfa33e4e8ae492(carrier) {
    const __SENTRY__ = carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    __SENTRY__.version = __SENTRY__.version || (0, $iOjzR.SDK_VERSION);
    return __SENTRY__[0, $iOjzR.SDK_VERSION] = __SENTRY__[0, $iOjzR.SDK_VERSION] || {};
}
function $1d2940d79e14f202$export$7e223ec222791509(name, creator, obj = (0, $bZENS.GLOBAL_OBJ)) {
    const __SENTRY__ = obj.__SENTRY__ = obj.__SENTRY__ || {};
    const carrier = __SENTRY__[0, $iOjzR.SDK_VERSION] = __SENTRY__[0, $iOjzR.SDK_VERSION] || {};
    return carrier[name] || (carrier[name] = creator());
}

});
parcelRegister("iOjzR", function(module, exports) {

$parcel$export(module.exports, "SDK_VERSION", function () { return $db1c152eaa57e264$export$31499a9cd224b78c; });
const $db1c152eaa57e264$export$31499a9cd224b78c = "10.67.0";

});

parcelRegister("bZENS", function(module, exports) {

$parcel$export(module.exports, "GLOBAL_OBJ", function () { return $8bb50aeefa1651fc$export$f1a6cdb1459e81d1; });
const $8bb50aeefa1651fc$export$f1a6cdb1459e81d1 = globalThis;

});



parcelRegister("iFp2j", function(module, exports) {

$parcel$export(module.exports, "getFunctionName", function () { return $d96f7a0a70f757cf$export$aad197c7121a6651; });
const $d96f7a0a70f757cf$var$STACKTRACE_FRAME_LIMIT = 50;
const $d96f7a0a70f757cf$export$27c7e15d453fc0ac = "?";
const $d96f7a0a70f757cf$var$WEBPACK_ERROR_REGEXP = /\(error: (.*)\)/;
const $d96f7a0a70f757cf$var$STRIP_FRAME_REGEXP = /captureMessage|captureException/;
function $d96f7a0a70f757cf$export$a5739666fb2d03d4(...parsers) {
    const sortedParsers = parsers.sort((a, b)=>a[0] - b[0]).map((p)=>p[1]);
    return (stack, skipFirstLines = 0, framesToPop = 0)=>{
        const frames = [];
        const lines = stack.split("\n");
        for(let i = skipFirstLines; i < lines.length; i++){
            let line = lines[i];
            if (line.length > 1024) line = line.slice(0, 1024);
            const cleanedLine = $d96f7a0a70f757cf$var$WEBPACK_ERROR_REGEXP.test(line) ? line.replace($d96f7a0a70f757cf$var$WEBPACK_ERROR_REGEXP, "$1") : line;
            if (cleanedLine.includes("Error: ")) continue;
            for (const parser of sortedParsers){
                const frame = parser(cleanedLine);
                if (frame) {
                    frames.push(frame);
                    break;
                }
            }
            if (frames.length >= $d96f7a0a70f757cf$var$STACKTRACE_FRAME_LIMIT + framesToPop) break;
        }
        return $d96f7a0a70f757cf$export$c55c24c0eeba0205(frames.slice(framesToPop));
    };
}
function $d96f7a0a70f757cf$export$1d5cf88b347146d4(stackParser) {
    if (Array.isArray(stackParser)) return $d96f7a0a70f757cf$export$a5739666fb2d03d4(...stackParser);
    return stackParser;
}
function $d96f7a0a70f757cf$export$c55c24c0eeba0205(stack) {
    if (!stack.length) return [];
    const localStack = Array.from(stack);
    if (/sentryWrapped/.test($d96f7a0a70f757cf$var$getLastStackFrame(localStack).function || "")) localStack.pop();
    localStack.reverse();
    if ($d96f7a0a70f757cf$var$STRIP_FRAME_REGEXP.test($d96f7a0a70f757cf$var$getLastStackFrame(localStack).function || "")) {
        localStack.pop();
        if ($d96f7a0a70f757cf$var$STRIP_FRAME_REGEXP.test($d96f7a0a70f757cf$var$getLastStackFrame(localStack).function || "")) localStack.pop();
    }
    return localStack.slice(0, $d96f7a0a70f757cf$var$STACKTRACE_FRAME_LIMIT).map((frame)=>({
            ...frame,
            filename: frame.filename || $d96f7a0a70f757cf$var$getLastStackFrame(localStack).filename,
            function: frame.function || $d96f7a0a70f757cf$export$27c7e15d453fc0ac
        }));
}
function $d96f7a0a70f757cf$var$getLastStackFrame(arr) {
    return arr[arr.length - 1] || {};
}
const $d96f7a0a70f757cf$var$defaultFunctionName = "<anonymous>";
function $d96f7a0a70f757cf$export$aad197c7121a6651(fn) {
    try {
        if (!fn || typeof fn !== "function") return $d96f7a0a70f757cf$var$defaultFunctionName;
        return fn.name || $d96f7a0a70f757cf$var$defaultFunctionName;
    } catch  {
        return $d96f7a0a70f757cf$var$defaultFunctionName;
    }
}
function $d96f7a0a70f757cf$export$91d8ca51bd9f6a47(event) {
    const exception = event.exception;
    if (exception) {
        const frames = [];
        try {
            exception.values.forEach((value)=>{
                if (value.stacktrace.frames) frames.push(...value.stacktrace.frames);
            });
            return frames;
        } catch  {
            return void 0;
        }
    }
    return void 0;
}
function $d96f7a0a70f757cf$export$60c0d6c8e038267a(path) {
    let filename = path?.startsWith("file://") ? path.slice(7) : path;
    if (filename?.match(/\/[A-Z]:/)) filename = filename.slice(1);
    return filename;
}

});


parcelRegister("4zVoD", function(module, exports) {

$parcel$export(module.exports, "fill", function () { return $3556f40848c63521$export$9563e054e6f787fb; });
$parcel$export(module.exports, "addNonEnumerableProperty", function () { return $3556f40848c63521$export$e73679ffaf56810e; });
$parcel$export(module.exports, "convertToPlainObject", function () { return $3556f40848c63521$export$62ff257738bf57f5; });

var $hv7EP = parcelRequire("hv7EP");

var $w8bd7 = parcelRequire("w8bd7");

var $9ISAs = parcelRequire("9ISAs");
function $3556f40848c63521$export$9563e054e6f787fb(source, name, replacementFactory) {
    if (!(name in source)) return;
    const original = source[name];
    if (typeof original !== "function") return;
    const wrapped = replacementFactory(original);
    if (typeof wrapped === "function") $3556f40848c63521$export$5c1499e2e5d010ae(wrapped, original);
    try {
        source[name] = wrapped;
    } catch  {
        (0, $hv7EP.DEBUG_BUILD) && (0, $w8bd7.debug).log(`Failed to replace method "${name}" in object`, source);
    }
}
function $3556f40848c63521$export$e73679ffaf56810e(obj, name, value) {
    try {
        Object.defineProperty(obj, name, {
            value: // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
            value,
            writable: true,
            configurable: true
        });
    } catch  {
        (0, $hv7EP.DEBUG_BUILD) && (0, $w8bd7.debug).log(`Failed to add non-enumerable property "${String(name)}" to object`, obj);
    }
}
function $3556f40848c63521$export$5c1499e2e5d010ae(wrapped, original) {
    try {
        const proto = original.prototype || {};
        wrapped.prototype = original.prototype = proto;
        $3556f40848c63521$export$e73679ffaf56810e(wrapped, "__sentry_original__", original);
    } catch  {}
}
function $3556f40848c63521$export$e00416b3cd122575(obj, field, wrapped, enumerable = true) {
    const original = obj[field];
    if (typeof original !== "function") throw new Error(`Cannot wrap method: ${field} is not a function`);
    if ($3556f40848c63521$export$e6cc1e135e2092e5(original)) throw new Error(`Attempting to wrap method ${field} multiple times`);
    $3556f40848c63521$export$5c1499e2e5d010ae(wrapped, original);
    Object.defineProperty(obj, field, {
        writable: true,
        configurable: true,
        enumerable: enumerable,
        value: wrapped
    });
}
function $3556f40848c63521$export$e6cc1e135e2092e5(func) {
    return func.__sentry_original__;
}
function $3556f40848c63521$export$62ff257738bf57f5(value) {
    if ((0, $9ISAs.isError)(value)) return {
        message: value.message,
        name: value.name,
        stack: value.stack,
        ...$3556f40848c63521$var$getOwnProperties(value)
    };
    if ((0, $9ISAs.isEvent)(value)) {
        const { type: type, target: target, currentTarget: currentTarget, detail: detail } = value;
        return {
            type: type,
            target: target,
            currentTarget: currentTarget,
            ...detail ? {
                detail: detail
            } : {},
            ...$3556f40848c63521$var$getOwnProperties(value)
        };
    }
    return value;
}
function $3556f40848c63521$var$getOwnProperties(obj) {
    if ((0, $9ISAs.isObjectLike)(obj)) return Object.fromEntries(Object.entries(obj));
    return {};
}
function $3556f40848c63521$export$b0244d5063c0b61b(exception) {
    const keys = Object.keys($3556f40848c63521$export$62ff257738bf57f5(exception));
    keys.sort();
    return !keys[0] ? "[object has no keys]" : keys.join(", ");
}
function $3556f40848c63521$export$d25f2688db1bb433(inputValue) {
    const memoizationMap = /* @__PURE__ */ new Map();
    return $3556f40848c63521$var$_dropUndefinedKeys(inputValue, memoizationMap);
}
function $3556f40848c63521$var$_dropUndefinedKeys(inputValue, memoizationMap) {
    if (inputValue === null || typeof inputValue !== "object") return inputValue;
    const memoVal = memoizationMap.get(inputValue);
    if (memoVal !== void 0) return memoVal;
    if (Array.isArray(inputValue)) {
        const returnValue = [];
        memoizationMap.set(inputValue, returnValue);
        inputValue.forEach((value)=>{
            returnValue.push($3556f40848c63521$var$_dropUndefinedKeys(value, memoizationMap));
        });
        return returnValue;
    }
    if ($3556f40848c63521$var$isPojo(inputValue)) {
        const returnValue = {};
        memoizationMap.set(inputValue, returnValue);
        const keys = Object.keys(inputValue);
        keys.forEach((key)=>{
            const val = inputValue[key];
            if (val !== void 0) returnValue[key] = $3556f40848c63521$var$_dropUndefinedKeys(val, memoizationMap);
        });
        return returnValue;
    }
    return inputValue;
}
function $3556f40848c63521$var$isPojo(input) {
    const constructor = input.constructor;
    return constructor === Object || constructor === void 0;
}
function $3556f40848c63521$export$92b78acdbe066b6b(wat) {
    let objectified;
    switch(true){
        // this will catch both undefined and null
        case wat == void 0:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === "symbol" || typeof wat === "bigint":
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, $9ISAs.isPrimitive)(wat):
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}

});
parcelRegister("9ISAs", function(module, exports) {

$parcel$export(module.exports, "isError", function () { return $714290faee0377ff$export$e6127cc7fe7395c3; });
$parcel$export(module.exports, "isString", function () { return $714290faee0377ff$export$844ec244b1367d54; });
$parcel$export(module.exports, "isPrimitive", function () { return $714290faee0377ff$export$c3825b437cbdea5c; });
$parcel$export(module.exports, "isPlainObject", function () { return $714290faee0377ff$export$53b83ca8eaab0383; });
$parcel$export(module.exports, "isObjectLike", function () { return $714290faee0377ff$export$c10d0b04eaa80a43; });
$parcel$export(module.exports, "isEvent", function () { return $714290faee0377ff$export$9671ea99bd126ace; });
$parcel$export(module.exports, "isRegExp", function () { return $714290faee0377ff$export$49841c62b9eff15; });
$parcel$export(module.exports, "isThenable", function () { return $714290faee0377ff$export$f5b060c2914b97c8; });
$parcel$export(module.exports, "isRequest", function () { return $714290faee0377ff$export$6d3d1f317d7cda57; });
const $714290faee0377ff$var$objectToString = Object.prototype.toString;
function $714290faee0377ff$export$e6127cc7fe7395c3(wat) {
    switch($714290faee0377ff$var$objectToString.call(wat)){
        case "[object Error]":
        case "[object Exception]":
        case "[object DOMException]":
        case "[object WebAssembly.Exception]":
            return true;
        default:
            return $714290faee0377ff$export$49034edbe6b62415(wat, Error);
    }
}
function $714290faee0377ff$var$isBuiltin(wat, className) {
    return $714290faee0377ff$var$objectToString.call(wat) === `[object ${className}]`;
}
function $714290faee0377ff$export$9f9636d330b71954(wat) {
    return $714290faee0377ff$var$isBuiltin(wat, "ErrorEvent");
}
function $714290faee0377ff$export$ef9e2056653f0c8e(wat) {
    return $714290faee0377ff$var$isBuiltin(wat, "DOMError");
}
function $714290faee0377ff$export$12e869b2a583f783(wat) {
    return $714290faee0377ff$var$isBuiltin(wat, "DOMException");
}
function $714290faee0377ff$export$844ec244b1367d54(wat) {
    return $714290faee0377ff$var$isBuiltin(wat, "String");
}
function $714290faee0377ff$export$dbcbffa59149b824(wat) {
    return typeof wat === "object" && wat !== null && "__sentry_template_string__" in wat && "__sentry_template_values__" in wat;
}
function $714290faee0377ff$export$c3825b437cbdea5c(wat) {
    return wat === null || $714290faee0377ff$export$dbcbffa59149b824(wat) || typeof wat !== "object" && typeof wat !== "function";
}
function $714290faee0377ff$export$53b83ca8eaab0383(wat) {
    return $714290faee0377ff$var$isBuiltin(wat, "Object");
}
function $714290faee0377ff$export$c10d0b04eaa80a43(wat) {
    return typeof wat === "object" && wat !== null;
}
function $714290faee0377ff$export$9671ea99bd126ace(wat) {
    return typeof Event !== "undefined" && $714290faee0377ff$export$49034edbe6b62415(wat, Event);
}
function $714290faee0377ff$export$45a5e7f76e0caa8d(wat) {
    return typeof Element !== "undefined" && $714290faee0377ff$export$49034edbe6b62415(wat, Element);
}
function $714290faee0377ff$export$49841c62b9eff15(wat) {
    return $714290faee0377ff$var$isBuiltin(wat, "RegExp");
}
function $714290faee0377ff$export$f5b060c2914b97c8(wat) {
    return Boolean(wat?.then && typeof wat.then === "function");
}
function $714290faee0377ff$export$bc2894c7158efbac(wat) {
    return $714290faee0377ff$export$53b83ca8eaab0383(wat) && "nativeEvent" in wat && "preventDefault" in wat && "stopPropagation" in wat;
}
function $714290faee0377ff$export$49034edbe6b62415(wat, base) {
    try {
        return wat instanceof base;
    } catch  {
        return false;
    }
}
function $714290faee0377ff$export$7916fad0ebc23f48(wat) {
    return !!(typeof wat === "object" && wat !== null && (wat.__isVue || wat._isVue || wat.__v_isVNode));
}
function $714290faee0377ff$export$6d3d1f317d7cda57(request) {
    return typeof Request !== "undefined" && $714290faee0377ff$export$49034edbe6b62415(request, Request);
}

});


parcelRegister("i0qqg", function(module, exports) {

$parcel$export(module.exports, "supportsHistory", function () { return $d1bcb909590b5d4d$export$67fc34576016d6ec; });
$parcel$export(module.exports, "isNativeFunction", function () { return $d1bcb909590b5d4d$export$d5f608b368e73f38; });
$parcel$export(module.exports, "supportsNativeFetch", function () { return $d1bcb909590b5d4d$export$c82d238e23c40b21; });

var $hv7EP = parcelRequire("hv7EP");

var $w8bd7 = parcelRequire("w8bd7");

var $bZENS = parcelRequire("bZENS");
const $d1bcb909590b5d4d$var$WINDOW = (0, $bZENS.GLOBAL_OBJ);
function $d1bcb909590b5d4d$export$caa710b4d7f9cadf() {
    try {
        new ErrorEvent("");
        return true;
    } catch  {
        return false;
    }
}
function $d1bcb909590b5d4d$export$1c08bd1a7eb3c472() {
    try {
        new DOMError("");
        return true;
    } catch  {
        return false;
    }
}
function $d1bcb909590b5d4d$export$ab12a5d056f1d3a() {
    try {
        new DOMException("");
        return true;
    } catch  {
        return false;
    }
}
function $d1bcb909590b5d4d$export$67fc34576016d6ec() {
    return "history" in $d1bcb909590b5d4d$var$WINDOW && !!$d1bcb909590b5d4d$var$WINDOW.history;
}
const $d1bcb909590b5d4d$export$edf3cb81fd7d2a3e = $d1bcb909590b5d4d$var$_isFetchSupported;
function $d1bcb909590b5d4d$var$_isFetchSupported() {
    if (!("fetch" in $d1bcb909590b5d4d$var$WINDOW)) return false;
    try {
        new Headers();
        new Request("data:,");
        new Response();
        return true;
    } catch  {
        return false;
    }
}
function $d1bcb909590b5d4d$export$d5f608b368e73f38(func) {
    return func && /^function\s+\w+\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
function $d1bcb909590b5d4d$export$c82d238e23c40b21() {
    if (typeof EdgeRuntime === "string") return true;
    if (!$d1bcb909590b5d4d$var$_isFetchSupported()) return false;
    if ($d1bcb909590b5d4d$export$d5f608b368e73f38($d1bcb909590b5d4d$var$WINDOW.fetch)) return true;
    let result = false;
    const doc = $d1bcb909590b5d4d$var$WINDOW.document;
    if (doc && typeof doc.createElement === "function") try {
        const sandbox = doc.createElement("iframe");
        sandbox.hidden = true;
        doc.head.appendChild(sandbox);
        if (sandbox.contentWindow?.fetch) result = $d1bcb909590b5d4d$export$d5f608b368e73f38(sandbox.contentWindow.fetch);
        doc.head.removeChild(sandbox);
    } catch (err) {
        (0, $hv7EP.DEBUG_BUILD) && (0, $w8bd7.debug).warn("Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ", err);
    }
    return result;
}
function $d1bcb909590b5d4d$export$531055a6c684a70a() {
    return "ReportingObserver" in $d1bcb909590b5d4d$var$WINDOW;
}
function $d1bcb909590b5d4d$export$2d308b428295192f() {
    if (!$d1bcb909590b5d4d$var$_isFetchSupported()) return false;
    try {
        new Request("_", {
            referrerPolicy: "origin"
        });
        return true;
    } catch  {
        return false;
    }
}

});

parcelRegister("gWPaa", function(module, exports) {

$parcel$export(module.exports, "WINDOW", function () { return $c569c00821d95915$export$56d8a8a25bd48b81; });

var $bZENS = parcelRequire("bZENS");
const $c569c00821d95915$export$56d8a8a25bd48b81 = (0, $bZENS.GLOBAL_OBJ);

});


parcelRegister("7Y1KN", function(module, exports) {

$parcel$export(module.exports, "dateTimestampInSeconds", function () { return $5ccf7f459efe79d7$export$7740643b9eeaf0c4; });
$parcel$export(module.exports, "timestampInSeconds", function () { return $5ccf7f459efe79d7$export$ee52dced521e3e18; });
$parcel$export(module.exports, "browserPerformanceTimeOrigin", function () { return $5ccf7f459efe79d7$export$baf075a948ffc0bf; });

var $4S04j = parcelRequire("4S04j");

var $bZENS = parcelRequire("bZENS");
const $5ccf7f459efe79d7$var$ONE_SECOND_IN_MS = 1e3;
function $5ccf7f459efe79d7$export$7740643b9eeaf0c4() {
    return (0, $4S04j.safeDateNow)() / $5ccf7f459efe79d7$var$ONE_SECOND_IN_MS;
}
function $5ccf7f459efe79d7$var$createUnixTimestampInSecondsFunc() {
    const { performance: performance } = (0, $bZENS.GLOBAL_OBJ);
    if (!performance?.now || !performance.timeOrigin) return $5ccf7f459efe79d7$export$7740643b9eeaf0c4;
    const timeOrigin = performance.timeOrigin;
    return ()=>{
        return (timeOrigin + (0, $4S04j.withRandomSafeContext)(()=>performance.now())) / $5ccf7f459efe79d7$var$ONE_SECOND_IN_MS;
    };
}
let $5ccf7f459efe79d7$var$_cachedTimestampInSeconds;
function $5ccf7f459efe79d7$export$ee52dced521e3e18() {
    const func = $5ccf7f459efe79d7$var$_cachedTimestampInSeconds ?? ($5ccf7f459efe79d7$var$_cachedTimestampInSeconds = $5ccf7f459efe79d7$var$createUnixTimestampInSecondsFunc());
    return func();
}
let $5ccf7f459efe79d7$var$cachedTimeOrigin = null;
function $5ccf7f459efe79d7$var$getBrowserTimeOrigin() {
    const { performance: performance } = (0, $bZENS.GLOBAL_OBJ);
    if (!performance?.now) return void 0;
    const threshold = 3e5;
    const performanceNow = (0, $4S04j.withRandomSafeContext)(()=>performance.now());
    const dateNow = (0, $4S04j.safeDateNow)();
    const timeOrigin = performance.timeOrigin;
    if (typeof timeOrigin === "number") {
        const timeOriginDelta = Math.abs(timeOrigin + performanceNow - dateNow);
        if (timeOriginDelta < threshold) return timeOrigin;
    }
    const navigationStart = performance.timing?.navigationStart;
    if (typeof navigationStart === "number") {
        const navigationStartDelta = Math.abs(navigationStart + performanceNow - dateNow);
        if (navigationStartDelta < threshold) return navigationStart;
    }
    return dateNow - performanceNow;
}
function $5ccf7f459efe79d7$export$baf075a948ffc0bf() {
    if ($5ccf7f459efe79d7$var$cachedTimeOrigin === null) $5ccf7f459efe79d7$var$cachedTimeOrigin = $5ccf7f459efe79d7$var$getBrowserTimeOrigin();
    return $5ccf7f459efe79d7$var$cachedTimeOrigin;
}

});
parcelRegister("4S04j", function(module, exports) {

$parcel$export(module.exports, "withRandomSafeContext", function () { return $38bc423408c69d59$export$ff239213cb80e2da; });
$parcel$export(module.exports, "safeMathRandom", function () { return $38bc423408c69d59$export$9869d72de32a3917; });
$parcel$export(module.exports, "safeDateNow", function () { return $38bc423408c69d59$export$65b1bada40c91b34; });

var $bZENS = parcelRequire("bZENS");
let $38bc423408c69d59$var$RESOLVED_RUNNER;
function $38bc423408c69d59$export$ff239213cb80e2da(cb) {
    if ($38bc423408c69d59$var$RESOLVED_RUNNER !== void 0) return $38bc423408c69d59$var$RESOLVED_RUNNER ? $38bc423408c69d59$var$RESOLVED_RUNNER(cb) : cb();
    const sym = /* @__PURE__ */ Symbol.for("__SENTRY_SAFE_RANDOM_ID_WRAPPER__");
    const globalWithSymbol = (0, $bZENS.GLOBAL_OBJ);
    if (sym in globalWithSymbol && typeof globalWithSymbol[sym] === "function") {
        $38bc423408c69d59$var$RESOLVED_RUNNER = globalWithSymbol[sym];
        return $38bc423408c69d59$var$RESOLVED_RUNNER(cb);
    }
    $38bc423408c69d59$var$RESOLVED_RUNNER = null;
    return cb();
}
function $38bc423408c69d59$export$9869d72de32a3917() {
    return $38bc423408c69d59$export$ff239213cb80e2da(()=>Math.random());
}
function $38bc423408c69d59$export$65b1bada40c91b34() {
    return $38bc423408c69d59$export$ff239213cb80e2da(()=>Date.now());
}

});


parcelRegister("h9p4m", function(module, exports) {

$parcel$export(module.exports, "uuid4", function () { return $c7c6b931de73f37c$export$19f53698e68b2496; });

var $4zVoD = parcelRequire("4zVoD");

var $4S04j = parcelRequire("4S04j");

var $kWdMm = parcelRequire("kWdMm");

var $bZENS = parcelRequire("bZENS");
function $c7c6b931de73f37c$var$getCrypto() {
    const gbl = (0, $bZENS.GLOBAL_OBJ);
    return gbl.crypto || gbl.msCrypto;
}
let $c7c6b931de73f37c$var$emptyUuid;
function $c7c6b931de73f37c$var$getRandomByte() {
    return (0, $4S04j.safeMathRandom)() * 16;
}
function $c7c6b931de73f37c$export$19f53698e68b2496(crypto = $c7c6b931de73f37c$var$getCrypto()) {
    try {
        if (crypto?.randomUUID) return (0, $4S04j.withRandomSafeContext)(()=>crypto.randomUUID()).replace(/-/g, "");
    } catch  {}
    if (!$c7c6b931de73f37c$var$emptyUuid) $c7c6b931de73f37c$var$emptyUuid = "10000000100040008000100000000000";
    return $c7c6b931de73f37c$var$emptyUuid.replace(/[018]/g, (c)=>// eslint-disable-next-line no-bitwise
        (c ^ ($c7c6b931de73f37c$var$getRandomByte() & 15) >> c / 4).toString(16));
}
function $c7c6b931de73f37c$var$getFirstException(event) {
    return event.exception?.values?.[0];
}
function $c7c6b931de73f37c$export$4157119e2b157127(event) {
    const { message: message, event_id: eventId } = event;
    if (message) return message;
    const firstException = $c7c6b931de73f37c$var$getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return `${firstException.type}: ${firstException.value}`;
        return firstException.type || firstException.value || eventId || "<unknown>";
    }
    return eventId || "<unknown>";
}
function $c7c6b931de73f37c$export$f26508487bf83ee7(event, value, type) {
    const exception = event.exception = event.exception || {};
    const values = exception.values = exception.values || [];
    const firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || "";
    if (!firstException.type) firstException.type = type || "Error";
}
function $c7c6b931de73f37c$export$c69a9a0313b03bb1(event, newMechanism) {
    const firstException = $c7c6b931de73f37c$var$getFirstException(event);
    if (!firstException) return;
    const defaultMechanism = {
        type: "generic",
        handled: true
    };
    const currentMechanism = firstException.mechanism;
    firstException.mechanism = {
        ...defaultMechanism,
        ...currentMechanism,
        ...newMechanism
    };
    if (newMechanism && "data" in newMechanism) {
        const mergedData = {
            ...currentMechanism?.data,
            ...newMechanism.data
        };
        firstException.mechanism.data = mergedData;
    }
}
const $c7c6b931de73f37c$var$SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
function $c7c6b931de73f37c$var$_parseInt(input) {
    return parseInt(input || "", 10);
}
function $c7c6b931de73f37c$export$d364f2020ab30578(input) {
    const match = input.match($c7c6b931de73f37c$var$SEMVER_REGEXP) || [];
    const major = $c7c6b931de73f37c$var$_parseInt(match[1]);
    const minor = $c7c6b931de73f37c$var$_parseInt(match[2]);
    const patch = $c7c6b931de73f37c$var$_parseInt(match[3]);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? void 0 : major,
        minor: isNaN(minor) ? void 0 : minor,
        patch: isNaN(patch) ? void 0 : patch,
        prerelease: match[4]
    };
}
function $c7c6b931de73f37c$export$ec2291bfc64632f0(lines, frame, linesOfContext = 5) {
    if (frame.lineno === void 0) return;
    const maxLines = lines.length;
    const sourceLine = Math.max(Math.min(maxLines - 1, frame.lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map((line)=>(0, $kWdMm.snipLine)(line, 0));
    const lineIndex = Math.min(maxLines - 1, sourceLine);
    frame.context_line = (0, $kWdMm.snipLine)(lines[lineIndex], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map((line)=>(0, $kWdMm.snipLine)(line, 0));
}
function $c7c6b931de73f37c$export$6de4ffac6a2f1098(exception) {
    if ($c7c6b931de73f37c$export$4a38e013f66150b(exception)) return true;
    try {
        (0, $4zVoD.addNonEnumerableProperty)(exception, "__sentry_captured__", true);
    } catch  {}
    return false;
}
function $c7c6b931de73f37c$export$4a38e013f66150b(exception) {
    try {
        return exception.__sentry_captured__;
    } catch  {}
}

});
parcelRegister("kWdMm", function(module, exports) {

$parcel$export(module.exports, "truncate", function () { return $f3e3e9a546966dcd$export$6a506b36fdea397d; });
$parcel$export(module.exports, "snipLine", function () { return $f3e3e9a546966dcd$export$4215662d762d6f9d; });
$parcel$export(module.exports, "isMatchingPattern", function () { return $f3e3e9a546966dcd$export$cdded5b28a5f8c6d; });
$parcel$export(module.exports, "stringMatchesSomePattern", function () { return $f3e3e9a546966dcd$export$a7a5ec66062ea5d; });

var $9ISAs = parcelRequire("9ISAs");

var $7viyI = parcelRequire("7viyI");
function $f3e3e9a546966dcd$export$fac44ee5b035f737(value, fallback = "[unserializable]") {
    if (typeof value === "string") return value;
    try {
        return JSON.stringify(value);
    } catch  {
        return typeof fallback === "function" ? fallback(value) : fallback;
    }
}
function $f3e3e9a546966dcd$export$6a506b36fdea397d(str, max = 0) {
    if (typeof str !== "string" || max === 0) return str;
    return str.length <= max ? str : `${str.slice(0, max)}...`;
}
function $f3e3e9a546966dcd$export$4215662d762d6f9d(line, colno) {
    let newLine = line;
    const lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) colno = lineLength;
    let start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    let end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = `'{snip} ${newLine}`;
    if (end < lineLength) newLine += " {snip}";
    return newLine;
}
function $f3e3e9a546966dcd$export$465e9d514283d4fd(input, delimiter) {
    if (!Array.isArray(input)) return "";
    const output = [];
    for(let i = 0; i < input.length; i++){
        const value = input[i];
        if ((0, $9ISAs.isPrimitive)(value)) output.push(String(value));
        else if (value instanceof Error) output.push(value.message ? `${value.name}: ${value.message}` : value.name);
        else output.push((0, $7viyI.stringifyValue)(void 0, value));
    }
    return output.join(delimiter);
}
function $f3e3e9a546966dcd$export$cdded5b28a5f8c6d(value, pattern, requireExactStringMatch = false) {
    if (!(0, $9ISAs.isString)(value)) return false;
    if ((0, $9ISAs.isRegExp)(pattern)) return pattern.test(value);
    if ((0, $9ISAs.isString)(pattern)) return requireExactStringMatch ? value === pattern : value.includes(pattern);
    if (typeof pattern === "function") return pattern(value);
    return false;
}
function $f3e3e9a546966dcd$export$a7a5ec66062ea5d(testString, patterns = [], requireExactStringMatch = false) {
    for (const pattern of patterns){
        if ($f3e3e9a546966dcd$export$cdded5b28a5f8c6d(testString, pattern, requireExactStringMatch)) return true;
    }
    return false;
}

});
parcelRegister("7viyI", function(module, exports) {

$parcel$export(module.exports, "normalize", function () { return $5769d31048f08858$export$a3295358bff77e; });
$parcel$export(module.exports, "stringifyValue", function () { return $5769d31048f08858$export$a110e5bc79f44a84; });

var $f0idJ = parcelRequire("f0idJ");

var $4zVoD = parcelRequire("4zVoD");

var $iFp2j = parcelRequire("iFp2j");
let $5769d31048f08858$var$stringifier;
function $5769d31048f08858$export$575c40989754ba4d(newStringifier) {
    $5769d31048f08858$var$stringifier = newStringifier;
}
function $5769d31048f08858$export$a3295358bff77e(input, depth = 100, maxProperties = Infinity) {
    try {
        return $5769d31048f08858$var$visit("", input, depth, maxProperties);
    } catch (err) {
        return {
            ERROR: `**non-serializable** (${err})`
        };
    }
}
function $5769d31048f08858$export$23fbbb20bed71033(object, depth = 3, maxSize = 102400) {
    const normalized = $5769d31048f08858$export$a3295358bff77e(object, depth);
    if ($5769d31048f08858$var$jsonSize(normalized) > maxSize) return $5769d31048f08858$export$23fbbb20bed71033(object, depth - 1, maxSize);
    return normalized;
}
function $5769d31048f08858$var$visit(key, value, depth = Infinity, maxProperties = Infinity, memo = $5769d31048f08858$var$memoBuilder()) {
    const [memoize, unmemoize] = memo;
    if (value == null || // this matches null and undefined -> eqeq not eqeqeq
    [
        "boolean",
        "string"
    ].includes(typeof value) || typeof value === "number" && Number.isFinite(value)) return value;
    const stringified = $5769d31048f08858$export$a110e5bc79f44a84(key, value);
    if (!stringified.startsWith("[object ")) return stringified;
    if ((0, $f0idJ.hasSkipNormalizationHint)(value)) return value;
    const overrideDepth = (0, $f0idJ.getNormalizationDepthOverrideHint)(value);
    const remainingDepth = overrideDepth !== void 0 ? overrideDepth : depth;
    if (remainingDepth === 0) return stringified.replace("object ", "");
    if (memoize(value)) return "[Circular ~]";
    const valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === "function") try {
        const jsonValue = valueWithToJSON.toJSON();
        return $5769d31048f08858$var$visit("", jsonValue, remainingDepth - 1, maxProperties, memo);
    } catch  {}
    const normalized = Array.isArray(value) ? [] : {};
    let numAdded = 0;
    const visitable = (0, $4zVoD.convertToPlainObject)(value);
    for(const visitKey in visitable){
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) continue;
        if (numAdded >= maxProperties) {
            normalized[visitKey] = "[MaxProperties ~]";
            break;
        }
        const visitValue = visitable[visitKey];
        normalized[visitKey] = $5769d31048f08858$var$visit(visitKey, visitValue, remainingDepth - 1, maxProperties, memo);
        numAdded++;
    }
    unmemoize(value);
    return normalized;
}
function $5769d31048f08858$export$a110e5bc79f44a84(key, value) {
    try {
        if ($5769d31048f08858$var$stringifier) {
            const stringified = $5769d31048f08858$var$stringifier(value);
            if (stringified) return stringified;
        }
        if (typeof $parcel$global !== "undefined" && value === $parcel$global) return "[Global]";
        if (typeof value === "number" && !Number.isFinite(value)) return `[${value}]`;
        if (typeof value === "function") return `[Function: ${(0, $iFp2j.getFunctionName)(value)}]`;
        if (typeof value === "symbol") return `[${String(value)}]`;
        if (typeof value === "bigint") return `[BigInt: ${String(value)}]`;
        const objName = $5769d31048f08858$var$getConstructorName(value);
        return `[object ${objName}]`;
    } catch (err) {
        return `**non-serializable** (${err})`;
    }
}
function $5769d31048f08858$var$getConstructorName(value) {
    const prototype = Object.getPrototypeOf(value);
    return prototype?.constructor ? prototype.constructor.name : "null prototype";
}
function $5769d31048f08858$var$utf8Length(value) {
    return ~-encodeURI(value).split(/%..|./).length;
}
function $5769d31048f08858$var$jsonSize(value) {
    return $5769d31048f08858$var$utf8Length(JSON.stringify(value));
}
function $5769d31048f08858$export$472b29734be05be3(url, basePath) {
    const escapedBase = basePath.replace(/\\/g, "/").replace(/[|\\{}()[\]^$+*?.]/g, "\\$&");
    let newUrl = url;
    try {
        newUrl = decodeURI(url);
    } catch  {}
    return newUrl.replace(/\\/g, "/").replace(/webpack:\/?/g, "").replace(new RegExp(`(file://)?/*${escapedBase}/*`, "ig"), "app:///");
}
function $5769d31048f08858$var$memoBuilder() {
    const inner = /* @__PURE__ */ new WeakSet();
    function memoize(obj) {
        if (inner.has(obj)) return true;
        inner.add(obj);
        return false;
    }
    function unmemoize(obj) {
        inner.delete(obj);
    }
    return [
        memoize,
        unmemoize
    ];
}

});
parcelRegister("f0idJ", function(module, exports) {

$parcel$export(module.exports, "hasSkipNormalizationHint", function () { return $aec4fd4e353f3590$export$c8d26b7b28f926c7; });
$parcel$export(module.exports, "getNormalizationDepthOverrideHint", function () { return $aec4fd4e353f3590$export$fe95a19841c4b155; });

var $4zVoD = parcelRequire("4zVoD");
const $aec4fd4e353f3590$var$SENTRY_SKIP_NORMALIZATION = /* @__PURE__ */ Symbol.for("sentry.skipNormalization");
const $aec4fd4e353f3590$var$SENTRY_OVERRIDE_NORMALIZATION_DEPTH = /* @__PURE__ */ Symbol.for("sentry.overrideNormalizationDepth");
function $aec4fd4e353f3590$export$280812de8e91ea53(obj) {
    (0, $4zVoD.addNonEnumerableProperty)(obj, $aec4fd4e353f3590$var$SENTRY_SKIP_NORMALIZATION, true);
}
function $aec4fd4e353f3590$export$610d1422c4bdc4c1(obj, depth) {
    (0, $4zVoD.addNonEnumerableProperty)(obj, $aec4fd4e353f3590$var$SENTRY_OVERRIDE_NORMALIZATION_DEPTH, depth);
}
function $aec4fd4e353f3590$export$c8d26b7b28f926c7(value) {
    return Boolean(value[$aec4fd4e353f3590$var$SENTRY_SKIP_NORMALIZATION]);
}
function $aec4fd4e353f3590$export$fe95a19841c4b155(value) {
    const v = value[$aec4fd4e353f3590$var$SENTRY_OVERRIDE_NORMALIZATION_DEPTH];
    return typeof v === "number" ? v : void 0;
}

});




parcelRegister("1rNqq", function(module, exports) {

$parcel$export(module.exports, "htmlTreeAsString", function () { return $10dea6db9539419c$export$5647df6b7814ac86; });

var $9ISAs = parcelRequire("9ISAs");
const $10dea6db9539419c$var$DEFAULT_MAX_STRING_LENGTH = 80;
const $10dea6db9539419c$var$accessors = {};
try {
    if (typeof Node !== "undefined") $10dea6db9539419c$var$accessors.parentNode = Object.getOwnPropertyDescriptor(Node.prototype, "parentNode").get;
    if (typeof Element !== "undefined") {
        $10dea6db9539419c$var$accessors.tagName = Object.getOwnPropertyDescriptor(Element.prototype, "tagName").get;
        $10dea6db9539419c$var$accessors.id = Object.getOwnPropertyDescriptor(Element.prototype, "id").get;
        $10dea6db9539419c$var$accessors.className = Object.getOwnPropertyDescriptor(Element.prototype, "className").get;
        $10dea6db9539419c$var$accessors.getAttribute = Element.prototype.getAttribute;
    }
    if (typeof HTMLElement !== "undefined") $10dea6db9539419c$var$accessors.dataset = Object.getOwnPropertyDescriptor(HTMLElement.prototype, "dataset").get;
} catch  {}
function $10dea6db9539419c$var$_safeRead(el, prop, arg) {
    const fn = $10dea6db9539419c$var$accessors[prop];
    if (fn) try {
        return fn.call(el, arg);
    } catch  {}
    const val = el[prop];
    return typeof val === "function" ? val.call(el, arg) : val;
}
function $10dea6db9539419c$export$5647df6b7814ac86(elem, options = {}) {
    if (!elem) return "<unknown>";
    try {
        let currentElem = elem;
        const MAX_TRAVERSE_HEIGHT = 5;
        const out = [];
        let height = 0;
        let len = 0;
        const separator = " > ";
        const sepLength = separator.length;
        let nextStr;
        const keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
        const maxStringLength = !Array.isArray(options) && options.maxStringLength || $10dea6db9539419c$var$DEFAULT_MAX_STRING_LENGTH;
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $10dea6db9539419c$var$_htmlElementAsString(currentElem, keyAttrs);
            if (nextStr === "html" || height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = $10dea6db9539419c$var$_safeRead(currentElem, "parentNode");
        }
        return out.reverse().join(separator);
    } catch  {
        return "<unknown>";
    }
}
function $10dea6db9539419c$var$_htmlElementAsString(el, keyAttrs) {
    const out = [];
    const tagName = $10dea6db9539419c$var$_safeRead(el, "tagName");
    if (!tagName) return "";
    if (typeof HTMLElement !== "undefined") {
        if (el instanceof HTMLElement) {
            const dataset = $10dea6db9539419c$var$_safeRead(el, "dataset");
            if (dataset) {
                if (dataset["sentryComponent"]) return dataset["sentryComponent"];
                if (dataset["sentryElement"]) return dataset["sentryElement"];
            }
        }
    }
    out.push(tagName.toLowerCase());
    const keyAttrPairs = keyAttrs?.length ? keyAttrs.filter((keyAttr)=>$10dea6db9539419c$var$_safeRead(el, "getAttribute", keyAttr)).map((keyAttr)=>[
            keyAttr,
            $10dea6db9539419c$var$_safeRead(el, "getAttribute", keyAttr)
        ]) : null;
    if (keyAttrPairs?.length) keyAttrPairs.forEach((keyAttrPair)=>{
        out.push(`[${keyAttrPair[0]}="${keyAttrPair[1]}"]`);
    });
    else {
        const id = $10dea6db9539419c$var$_safeRead(el, "id");
        if (id) out.push(`#${id}`);
        const className = $10dea6db9539419c$var$_safeRead(el, "className");
        if (className && (0, $9ISAs.isString)(className)) {
            const classes = className.split(/\s+/);
            for (const c of classes)out.push(`.${c}`);
        }
    }
    for (const k of [
        "aria-label",
        "type",
        "name",
        "title",
        "alt"
    ]){
        const attr = $10dea6db9539419c$var$_safeRead(el, "getAttribute", k);
        if (attr) out.push(`[${k}="${attr}"]`);
    }
    return out.join("");
}

});

parcelRegister("9yfTK", function(module, exports) {

$parcel$export(module.exports, "DEBUG_BUILD", function () { return $6f439f112497a31c$export$16a28057038b10ef; });
const $6f439f112497a31c$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;

});

parcelRegister("8xeDY", function(module, exports) {

$parcel$export(module.exports, "addPageListener", function () { return $636cc3bf349b01bd$export$26d3d892edc56833; });
$parcel$export(module.exports, "removePageListener", function () { return $636cc3bf349b01bd$export$324d7b4b46528191; });

var $gWPaa = parcelRequire("gWPaa");
function $636cc3bf349b01bd$export$26d3d892edc56833(type, listener, options) {
    if ((0, $gWPaa.WINDOW).document) (0, $gWPaa.WINDOW).addEventListener(type, listener, options);
}
function $636cc3bf349b01bd$export$324d7b4b46528191(type, listener, options) {
    if ((0, $gWPaa.WINDOW).document) (0, $gWPaa.WINDOW).removeEventListener(type, listener, options);
}

});

parcelRegister("k4o6c", function(module, exports) {

$parcel$export(module.exports, "runOnce", function () { return $03c545ad17fefe74$export$b841d51e31c12bab; });
const $03c545ad17fefe74$export$b841d51e31c12bab = (cb)=>{
    let called = false;
    return ()=>{
        if (!called) {
            cb();
            called = true;
        }
    };
};

});

parcelRegister("wwz0G", function(module, exports) {

$parcel$export(module.exports, "whenIdleOrHidden", function () { return $061c3fbdf61a755e$export$d3314d5863fc1fef; });

var $gWPaa = parcelRequire("gWPaa");

var $8xeDY = parcelRequire("8xeDY");

var $k4o6c = parcelRequire("k4o6c");
const $061c3fbdf61a755e$export$d3314d5863fc1fef = (cb)=>{
    const rIC = (0, $gWPaa.WINDOW).requestIdleCallback || (0, $gWPaa.WINDOW).setTimeout;
    if ((0, $gWPaa.WINDOW).document?.visibilityState === "hidden") cb();
    else {
        cb = (0, $k4o6c.runOnce)(cb);
        (0, $8xeDY.addPageListener)("visibilitychange", cb, {
            once: true,
            capture: true
        });
        (0, $8xeDY.addPageListener)("pagehide", cb, {
            once: true,
            capture: true
        });
        rIC(()=>{
            cb();
            (0, $8xeDY.removePageListener)("visibilitychange", cb, {
                capture: true
            });
            (0, $8xeDY.removePageListener)("pagehide", cb, {
                capture: true
            });
        });
    }
};

});

parcelRegister("f67fK", function(module, exports) {

$parcel$export(module.exports, "DEBUG_BUILD", function () { return $afdd0ad8f37e5b32$export$16a28057038b10ef; });
const $afdd0ad8f37e5b32$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;

});

parcelRegister("bHKc9", function(module, exports) {

$parcel$export(module.exports, "WINDOW", function () { return $88578b3b7a567c9d$export$56d8a8a25bd48b81; });
$parcel$export(module.exports, "shouldIgnoreOnError", function () { return $88578b3b7a567c9d$export$b79738ab10c590b2; });
$parcel$export(module.exports, "wrap", function () { return $88578b3b7a567c9d$export$4997ffc0176396a6; });
$parcel$export(module.exports, "getHttpRequestData", function () { return $88578b3b7a567c9d$export$a3c4a8453e8936f0; });

var $gaxBK = parcelRequire("gaxBK");
const $88578b3b7a567c9d$export$56d8a8a25bd48b81 = (0, $gaxBK.GLOBAL_OBJ);
let $88578b3b7a567c9d$var$ignoreOnError = 0;
function $88578b3b7a567c9d$export$b79738ab10c590b2() {
    return $88578b3b7a567c9d$var$ignoreOnError > 0;
}
function $88578b3b7a567c9d$export$1265a142ff5ba165() {
    $88578b3b7a567c9d$var$ignoreOnError++;
    setTimeout(()=>{
        $88578b3b7a567c9d$var$ignoreOnError--;
    });
}
function $88578b3b7a567c9d$export$4997ffc0176396a6(fn, options = {}) {
    function isFunction(fn2) {
        return typeof fn2 === "function";
    }
    if (!isFunction(fn)) return fn;
    try {
        const hasOwnWrapper = Object.prototype.hasOwnProperty.call(fn, "__sentry_wrapped__");
        if (hasOwnWrapper) {
            const wrapper = fn.__sentry_wrapped__;
            if (typeof wrapper === "function") return wrapper;
            else return fn;
        }
        if ((0, $gaxBK.getOriginalFunction)(fn)) return fn;
    } catch  {
        return fn;
    }
    const sentryWrapped = function(...args) {
        (0, $gaxBK.GLOBAL_OBJ)._sentryWrappedDepth = ((0, $gaxBK.GLOBAL_OBJ)._sentryWrappedDepth || 0) + 1;
        try {
            const wrappedArguments = args.map((arg)=>$88578b3b7a567c9d$export$4997ffc0176396a6(arg, options));
            return fn.apply(this, wrappedArguments);
        } catch (ex) {
            $88578b3b7a567c9d$export$1265a142ff5ba165();
            (0, $gaxBK.withScope)((scope)=>{
                scope.addEventProcessor((event)=>{
                    if (options.mechanism) {
                        (0, $gaxBK.addExceptionTypeValue)(event, void 0, void 0);
                        (0, $gaxBK.addExceptionMechanism)(event, options.mechanism);
                    }
                    event.extra = {
                        ...event.extra,
                        arguments: args
                    };
                    return event;
                });
                (0, $gaxBK.captureException)(ex);
            });
            throw ex;
        } finally{
            (0, $gaxBK.GLOBAL_OBJ)._sentryWrappedDepth = ((0, $gaxBK.GLOBAL_OBJ)._sentryWrappedDepth || 0) - 1;
        }
    };
    try {
        for(const property in fn)if (Object.prototype.hasOwnProperty.call(fn, property)) sentryWrapped[property] = fn[property];
    } catch  {}
    (0, $gaxBK.markFunctionWrapped)(sentryWrapped, fn);
    (0, $gaxBK.addNonEnumerableProperty)(fn, "__sentry_wrapped__", sentryWrapped);
    try {
        const descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, "name");
        if (descriptor.configurable) Object.defineProperty(sentryWrapped, "name", {
            get () {
                return fn.name;
            }
        });
    } catch  {}
    return sentryWrapped;
}
function $88578b3b7a567c9d$export$a3c4a8453e8936f0() {
    const url = (0, $gaxBK.getLocationHref)();
    const { referrer: referrer } = $88578b3b7a567c9d$export$56d8a8a25bd48b81.document || {};
    const { userAgent: userAgent } = $88578b3b7a567c9d$export$56d8a8a25bd48b81.navigator || {};
    const headers = {
        ...referrer && {
            Referer: referrer
        },
        ...userAgent && {
            "User-Agent": userAgent
        }
    };
    const request = {
        url: url,
        headers: headers
    };
    return request;
}

});

parcelRegister("7HchG", function(module, exports) {

$parcel$export(module.exports, "SENTRY_XHR_DATA_KEY", function () { return $59a613f82a8337f4$export$55b6bb1e45c6cf59; });
$parcel$export(module.exports, "addXhrInstrumentationHandler", function () { return $59a613f82a8337f4$export$26ace48dd54c9aea; });

var $f5byn = parcelRequire("f5byn");
var $9ISAs = parcelRequire("9ISAs");
var $7Y1KN = parcelRequire("7Y1KN");

var $gWPaa = parcelRequire("gWPaa");
const $59a613f82a8337f4$export$55b6bb1e45c6cf59 = "__sentry_xhr_v3__";
function $59a613f82a8337f4$export$26ace48dd54c9aea(handler) {
    const type = "xhr";
    (0, $f5byn.addHandler)(type, handler);
    (0, $f5byn.maybeInstrument)(type, $59a613f82a8337f4$export$c67d533bf77cbf54);
}
function $59a613f82a8337f4$export$c67d533bf77cbf54() {
    if (!(0, $gWPaa.WINDOW).XMLHttpRequest) return;
    const xhrproto = XMLHttpRequest.prototype;
    xhrproto.open = new Proxy(xhrproto.open, {
        apply (originalOpen, xhrOpenThisArg, xhrOpenArgArray) {
            const virtualError = new Error();
            const startTimestamp = (0, $7Y1KN.timestampInSeconds)() * 1e3;
            const method = (0, $9ISAs.isString)(xhrOpenArgArray[0]) ? xhrOpenArgArray[0].toUpperCase() : void 0;
            const url = $59a613f82a8337f4$var$parseXhrUrlArg(xhrOpenArgArray[1]);
            if (!method || !url) return originalOpen.apply(xhrOpenThisArg, xhrOpenArgArray);
            xhrOpenThisArg[$59a613f82a8337f4$export$55b6bb1e45c6cf59] = {
                method: method,
                url: url,
                request_headers: {}
            };
            if (method === "POST" && url.match(/sentry_key/)) xhrOpenThisArg.__sentry_own_request__ = true;
            const onreadystatechangeHandler = ()=>{
                const xhrInfo = xhrOpenThisArg[$59a613f82a8337f4$export$55b6bb1e45c6cf59];
                if (!xhrInfo) return;
                if (xhrOpenThisArg.readyState === 4) {
                    try {
                        xhrInfo.status_code = xhrOpenThisArg.status;
                    } catch  {}
                    const handlerData = {
                        endTimestamp: (0, $7Y1KN.timestampInSeconds)() * 1e3,
                        startTimestamp: startTimestamp,
                        xhr: xhrOpenThisArg,
                        virtualError: virtualError
                    };
                    (0, $f5byn.triggerHandlers)("xhr", handlerData);
                    xhrOpenThisArg.removeEventListener("readystatechange", onreadystatechangeHandler);
                }
            };
            if ("onreadystatechange" in xhrOpenThisArg && typeof xhrOpenThisArg.onreadystatechange === "function") xhrOpenThisArg.onreadystatechange = new Proxy(xhrOpenThisArg.onreadystatechange, {
                apply (originalOnreadystatechange, onreadystatechangeThisArg, onreadystatechangeArgArray) {
                    onreadystatechangeHandler();
                    return originalOnreadystatechange.apply(onreadystatechangeThisArg, onreadystatechangeArgArray);
                }
            });
            else xhrOpenThisArg.addEventListener("readystatechange", onreadystatechangeHandler);
            xhrOpenThisArg.setRequestHeader = new Proxy(xhrOpenThisArg.setRequestHeader, {
                apply (originalSetRequestHeader, setRequestHeaderThisArg, setRequestHeaderArgArray) {
                    const [header, value] = setRequestHeaderArgArray;
                    const xhrInfo = setRequestHeaderThisArg[$59a613f82a8337f4$export$55b6bb1e45c6cf59];
                    if (xhrInfo && (0, $9ISAs.isString)(header) && (0, $9ISAs.isString)(value)) xhrInfo.request_headers[header.toLowerCase()] = value;
                    return originalSetRequestHeader.apply(setRequestHeaderThisArg, setRequestHeaderArgArray);
                }
            });
            return originalOpen.apply(xhrOpenThisArg, xhrOpenArgArray);
        }
    });
    xhrproto.send = new Proxy(xhrproto.send, {
        apply (originalSend, sendThisArg, sendArgArray) {
            const sentryXhrData = sendThisArg[$59a613f82a8337f4$export$55b6bb1e45c6cf59];
            if (!sentryXhrData) return originalSend.apply(sendThisArg, sendArgArray);
            if (sendArgArray[0] !== void 0) sentryXhrData.body = sendArgArray[0];
            const handlerData = {
                startTimestamp: (0, $7Y1KN.timestampInSeconds)() * 1e3,
                xhr: sendThisArg
            };
            (0, $f5byn.triggerHandlers)("xhr", handlerData);
            return originalSend.apply(sendThisArg, sendArgArray);
        }
    });
}
function $59a613f82a8337f4$var$parseXhrUrlArg(url) {
    if ((0, $9ISAs.isString)(url)) return url;
    try {
        return url.toString();
    } catch  {}
    return void 0;
}

});

parcelRegister("7llDh", function(module, exports) {

$parcel$export(module.exports, "init", function () { return $558b4657388394e7$export$2cd8252107eb640b; });

var $gaxBK = parcelRequire("gaxBK");

var $kNI3G = parcelRequire("kNI3G");

var $5aA5x = parcelRequire("5aA5x");

var $eLkZ8 = parcelRequire("eLkZ8");

var $iajrg = parcelRequire("iajrg");

var $3uJ5t = parcelRequire("3uJ5t");

var $gTdoN = parcelRequire("gTdoN");

var $hQG0y = parcelRequire("hQG0y");

var $5kOO1 = parcelRequire("5kOO1");

var $dpJDD = parcelRequire("dpJDD");

var $iWSAv = parcelRequire("iWSAv");

var $hn3Pc = parcelRequire("hn3Pc");

var $cWFYW = parcelRequire("cWFYW");
function $558b4657388394e7$export$5783b2920b1d62b9(_options) {
    return [
        // TODO(v11): Replace with `eventFiltersIntegration` once we remove the deprecated `inboundFiltersIntegration`
        // eslint-disable-next-line typescript/no-deprecated
        (0, $gaxBK.inboundFiltersIntegration)(),
        (0, $gaxBK.functionToStringIntegration)(),
        (0, $gaxBK.conversationIdIntegration)(),
        (0, $eLkZ8.browserApiErrorsIntegration)(),
        (0, $5aA5x.breadcrumbsIntegration)(),
        (0, $gTdoN.globalHandlersIntegration)(),
        (0, $5kOO1.linkedErrorsIntegration)(),
        (0, $gaxBK.dedupeIntegration)(),
        (0, $hQG0y.httpContextIntegration)(),
        (0, $3uJ5t.cultureContextIntegration)(),
        (0, $iajrg.browserSessionIntegration)()
    ];
}
function $558b4657388394e7$export$2cd8252107eb640b(options = {}) {
    const shouldDisableBecauseIsBrowserExtenstion = !options.skipBrowserExtensionCheck && (0, $cWFYW.checkAndWarnIfIsEmbeddedBrowserExtension)();
    let defaultIntegrations = options.defaultIntegrations == null ? $558b4657388394e7$export$5783b2920b1d62b9() : options.defaultIntegrations;
    const clientOptions = {
        ...options,
        enabled: shouldDisableBecauseIsBrowserExtenstion ? false : options.enabled,
        stackParser: (0, $gaxBK.stackParserFromStackParserOptions)(options.stackParser || (0, $dpJDD.defaultStackParser)),
        integrations: (0, $gaxBK.getIntegrationsToSetup)({
            integrations: options.integrations,
            defaultIntegrations: defaultIntegrations
        }),
        transport: options.transport || (0, $iWSAv.makeFetchTransport)
    };
    (0, $gaxBK.setNormalizeStringifier)((0, $hn3Pc.normalizeStringifyValue));
    return (0, $gaxBK.initAndBind)((0, $kNI3G.BrowserClient), clientOptions);
}
function $558b4657388394e7$export$a3f323d81eede727() {}
function $558b4657388394e7$export$4e4d8b287d028b6b(callback) {
    callback();
}

});
parcelRegister("kNI3G", function(module, exports) {

$parcel$export(module.exports, "BrowserClient", function () { return $f24a8f5482b05238$export$1df9218a526d318d; });

var $gaxBK = parcelRequire("gaxBK");

var $bo6xz = parcelRequire("bo6xz");

var $bHKc9 = parcelRequire("bHKc9");
class $f24a8f5482b05238$export$1df9218a526d318d extends (0, $gaxBK.Client) {
    /**
   * Creates a new Browser SDK instance.
   *
   * @param options Configuration options for this SDK.
   */ constructor(options){
        const opts = $f24a8f5482b05238$export$4e107b20a7f977(options);
        const sdkSource = (0, $bHKc9.WINDOW).SENTRY_SDK_SOURCE || (0, $gaxBK.getSDKSource)();
        (0, $gaxBK.applySdkMetadata)(opts, "browser", [
            "browser"
        ], sdkSource);
        super(opts);
        const { userInfo: userInfo } = this.getDataCollectionOptions();
        if (opts._metadata?.sdk) opts._metadata.sdk.settings = {
            // Only allow IP inferral by Relay if the user opted in via dataCollection
            infer_ip: userInfo ? "auto" : "never",
            // purposefully allowing already passed settings to override the default
            ...opts._metadata.sdk.settings
        };
        const { sendClientReports: sendClientReports } = this._options;
        if ((0, $bHKc9.WINDOW).document) (0, $bHKc9.WINDOW).document.addEventListener("visibilitychange", ()=>{
            if ((0, $bHKc9.WINDOW).document.visibilityState === "hidden") {
                if (sendClientReports) this._flushOutcomes();
                queueMicrotask(()=>{
                    this.flush();
                });
            }
        });
        if (userInfo) this.on("beforeSendSession", (0, $gaxBK.addAutoIpAddressToSession));
    }
    /**
   * @inheritDoc
   */ eventFromException(exception, hint) {
        return (0, $bo6xz.eventFromException)(this._options.stackParser, exception, hint, this._options.attachStacktrace);
    }
    /**
   * @inheritDoc
   */ eventFromMessage(message, level = "info", hint) {
        return (0, $bo6xz.eventFromMessage)(this._options.stackParser, message, level, hint, this._options.attachStacktrace);
    }
    /**
   * @inheritDoc
   */ _prepareEvent(event, hint, currentScope, isolationScope) {
        event.platform = event.platform || "javascript";
        return super._prepareEvent(event, hint, currentScope, isolationScope);
    }
}
function $f24a8f5482b05238$export$4e107b20a7f977(optionsArg) {
    return {
        release: typeof __SENTRY_RELEASE__ === "string" ? __SENTRY_RELEASE__ : (0, $bHKc9.WINDOW).SENTRY_RELEASE?.id,
        // This supports the variable that sentry-webpack-plugin injects
        sendClientReports: true,
        // We default this to true, as it is the safer scenario
        parentSpanIsAlwaysRootSpan: true,
        ...optionsArg
    };
}

});
parcelRegister("bo6xz", function(module, exports) {

$parcel$export(module.exports, "exceptionFromError", function () { return $84a70268b5236ea2$export$a6c2d27607295951; });
$parcel$export(module.exports, "eventFromException", function () { return $84a70268b5236ea2$export$ea3ec7e569b823fc; });
$parcel$export(module.exports, "eventFromUnknownInput", function () { return $84a70268b5236ea2$export$9dd56ed1ef0c3420; });
$parcel$export(module.exports, "eventFromMessage", function () { return $84a70268b5236ea2$export$5425b53185d13d6c; });

var $gaxBK = parcelRequire("gaxBK");
function $84a70268b5236ea2$export$a6c2d27607295951(stackParser, ex) {
    const frames = $84a70268b5236ea2$var$parseStackFrames(stackParser, ex);
    const exception = {
        type: $84a70268b5236ea2$export$2e9ae379995d99e3(ex),
        value: $84a70268b5236ea2$export$86005d1b62804363(ex)
    };
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    if (exception.type === void 0 && exception.value === "") exception.value = "Unrecoverable error caught";
    return exception;
}
function $84a70268b5236ea2$var$eventFromPlainObject(stackParser, exception, syntheticException, isUnhandledRejection) {
    const client = (0, $gaxBK.getClient)();
    const normalizeDepth = client?.getOptions().normalizeDepth;
    const errorFromProp = $84a70268b5236ea2$var$getErrorPropertyFromObject(exception);
    const extra = {
        __serialized__: (0, $gaxBK.normalizeToSize)(exception, normalizeDepth)
    };
    if (errorFromProp) return {
        exception: {
            values: [
                $84a70268b5236ea2$export$a6c2d27607295951(stackParser, errorFromProp)
            ]
        },
        extra: extra
    };
    const event = {
        exception: {
            values: [
                {
                    type: (0, $gaxBK.isEvent)(exception) ? exception.constructor.name : isUnhandledRejection ? "UnhandledRejection" : "Error",
                    value: $84a70268b5236ea2$var$getNonErrorObjectExceptionValue(exception, {
                        isUnhandledRejection: isUnhandledRejection
                    })
                }
            ]
        },
        extra: extra
    };
    if (syntheticException) {
        const frames = $84a70268b5236ea2$var$parseStackFrames(stackParser, syntheticException);
        if (frames.length) event.exception.values[0].stacktrace = {
            frames: frames
        };
    }
    return event;
}
function $84a70268b5236ea2$var$eventFromError(stackParser, ex) {
    return {
        exception: {
            values: [
                $84a70268b5236ea2$export$a6c2d27607295951(stackParser, ex)
            ]
        }
    };
}
function $84a70268b5236ea2$var$parseStackFrames(stackParser, ex) {
    const stacktrace = ex.stacktrace || ex.stack || "";
    const skipLines = $84a70268b5236ea2$var$getSkipFirstStackStringLines(ex);
    const framesToPop = $84a70268b5236ea2$var$getPopFirstTopFrames(ex);
    try {
        return stackParser(stacktrace, skipLines, framesToPop);
    } catch  {}
    return [];
}
const $84a70268b5236ea2$var$reactMinifiedRegexp = /Minified React error #\d+;/i;
function $84a70268b5236ea2$var$getSkipFirstStackStringLines(ex) {
    if (ex && $84a70268b5236ea2$var$reactMinifiedRegexp.test(ex.message)) return 1;
    return 0;
}
function $84a70268b5236ea2$var$getPopFirstTopFrames(ex) {
    if (typeof ex.framesToPop === "number") return ex.framesToPop;
    return 0;
}
function $84a70268b5236ea2$var$isWebAssemblyException(exception) {
    if (typeof WebAssembly !== "undefined" && typeof WebAssembly.Exception !== "undefined") return exception instanceof WebAssembly.Exception;
    else return false;
}
function $84a70268b5236ea2$export$2e9ae379995d99e3(ex) {
    const name = ex?.name;
    if (!name && $84a70268b5236ea2$var$isWebAssemblyException(ex)) {
        const hasTypeInMessage = ex.message && Array.isArray(ex.message) && ex.message.length == 2;
        return hasTypeInMessage ? ex.message[0] : "WebAssembly.Exception";
    }
    return name;
}
function $84a70268b5236ea2$export$86005d1b62804363(ex) {
    const message = ex?.message;
    if ($84a70268b5236ea2$var$isWebAssemblyException(ex)) {
        if (Array.isArray(ex.message) && ex.message.length == 2) return ex.message[1];
        return "wasm exception";
    }
    if (!message) return "No error message";
    if (message.error && typeof message.error.message === "string") return (0, $gaxBK._INTERNAL_enhanceErrorWithSentryInfo)(message.error);
    return (0, $gaxBK._INTERNAL_enhanceErrorWithSentryInfo)(ex);
}
function $84a70268b5236ea2$export$ea3ec7e569b823fc(stackParser, exception, hint, attachStacktrace) {
    const syntheticException = hint?.syntheticException || void 0;
    const event = $84a70268b5236ea2$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace);
    (0, $gaxBK.addExceptionMechanism)(event);
    event.level = "error";
    if (hint?.event_id) event.event_id = hint.event_id;
    return (0, $gaxBK.resolvedSyncPromise)(event);
}
function $84a70268b5236ea2$export$5425b53185d13d6c(stackParser, message, level = "info", hint, attachStacktrace) {
    const syntheticException = hint?.syntheticException || void 0;
    const event = $84a70268b5236ea2$var$eventFromString(stackParser, message, syntheticException, attachStacktrace);
    event.level = level;
    if (hint?.event_id) event.event_id = hint.event_id;
    return (0, $gaxBK.resolvedSyncPromise)(event);
}
function $84a70268b5236ea2$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace, isUnhandledRejection) {
    let event;
    if ((0, $gaxBK.isErrorEvent)(exception) && exception.error) {
        const errorEvent = exception;
        return $84a70268b5236ea2$var$eventFromError(stackParser, errorEvent.error);
    }
    if ((0, $gaxBK.isDOMError)(exception) || (0, $gaxBK.isDOMException)(exception)) {
        const domException = exception;
        if ("stack" in exception) {
            event = $84a70268b5236ea2$var$eventFromError(stackParser, exception);
            const firstException = event.exception?.values?.[0];
            if (attachStacktrace && syntheticException && firstException && !firstException.stacktrace) {
                const frames = $84a70268b5236ea2$var$parseStackFrames(stackParser, syntheticException);
                if (frames.length) {
                    firstException.stacktrace = {
                        frames: frames
                    };
                    (0, $gaxBK.addExceptionMechanism)(event, {
                        synthetic: true
                    });
                }
            }
        } else {
            const name = domException.name || ((0, $gaxBK.isDOMError)(domException) ? "DOMError" : "DOMException");
            const message = domException.message ? `${name}: ${domException.message}` : name;
            event = $84a70268b5236ea2$var$eventFromString(stackParser, message, syntheticException, attachStacktrace);
            (0, $gaxBK.addExceptionTypeValue)(event, message);
        }
        if ("code" in domException) event.tags = {
            ...event.tags,
            "DOMException.code": `${domException.code}`
        };
        return event;
    }
    if ((0, $gaxBK.isError)(exception)) return $84a70268b5236ea2$var$eventFromError(stackParser, exception);
    if ((0, $gaxBK.isPlainObject)(exception) || (0, $gaxBK.isEvent)(exception)) {
        const objectException = exception;
        event = $84a70268b5236ea2$var$eventFromPlainObject(stackParser, objectException, syntheticException, isUnhandledRejection);
        (0, $gaxBK.addExceptionMechanism)(event, {
            synthetic: true
        });
        return event;
    }
    event = $84a70268b5236ea2$var$eventFromString(stackParser, exception, syntheticException, attachStacktrace);
    (0, $gaxBK.addExceptionTypeValue)(event, `${exception}`, void 0);
    (0, $gaxBK.addExceptionMechanism)(event, {
        synthetic: true
    });
    return event;
}
function $84a70268b5236ea2$var$eventFromString(stackParser, message, syntheticException, attachStacktrace) {
    const event = {};
    if (attachStacktrace && syntheticException) {
        const frames = $84a70268b5236ea2$var$parseStackFrames(stackParser, syntheticException);
        if (frames.length) event.exception = {
            values: [
                {
                    value: message,
                    stacktrace: {
                        frames: frames
                    }
                }
            ]
        };
        (0, $gaxBK.addExceptionMechanism)(event, {
            synthetic: true
        });
    }
    if ((0, $gaxBK.isParameterizedString)(message)) {
        const { __sentry_template_string__: __sentry_template_string__, __sentry_template_values__: __sentry_template_values__ } = message;
        event.logentry = {
            message: __sentry_template_string__,
            params: __sentry_template_values__
        };
        return event;
    }
    event.message = message;
    return event;
}
function $84a70268b5236ea2$var$getNonErrorObjectExceptionValue(exception, { isUnhandledRejection: isUnhandledRejection }) {
    const keys = (0, $gaxBK.extractExceptionKeysForMessage)(exception);
    const captureType = isUnhandledRejection ? "promise rejection" : "exception";
    if ((0, $gaxBK.isErrorEvent)(exception)) return `Event \`ErrorEvent\` captured as ${captureType} with message \`${exception.message}\``;
    if ((0, $gaxBK.isEvent)(exception)) {
        const className = $84a70268b5236ea2$var$getObjectClassName(exception);
        return `Event \`${className}\` (type=${exception.type}) captured as ${captureType}`;
    }
    return `Object captured as ${captureType} with keys: ${keys}`;
}
function $84a70268b5236ea2$var$getObjectClassName(obj) {
    try {
        const prototype = Object.getPrototypeOf(obj);
        return prototype ? prototype.constructor.name : void 0;
    } catch  {}
}
function $84a70268b5236ea2$var$getErrorPropertyFromObject(obj) {
    return Object.values(obj).find((v)=>v instanceof Error);
}

});


parcelRegister("5aA5x", function(module, exports) {

$parcel$export(module.exports, "breadcrumbsIntegration", function () { return $3c39e154bad98510$export$c079d904b326663a; });

var $gaxBK = parcelRequire("gaxBK");

var $9zMJO = parcelRequire("9zMJO");
var $e3Llk = parcelRequire("e3Llk");
var $7HchG = parcelRequire("7HchG");
var $1rNqq = parcelRequire("1rNqq");

var $f67fK = parcelRequire("f67fK");

var $bHKc9 = parcelRequire("bHKc9");
const $3c39e154bad98510$var$MAX_ALLOWED_STRING_LENGTH = 1024;
const $3c39e154bad98510$var$INTEGRATION_NAME = "Breadcrumbs";
const $3c39e154bad98510$var$_breadcrumbsIntegration = (options = {})=>{
    const _options = {
        console: true,
        dom: true,
        fetch: true,
        history: true,
        sentry: true,
        xhr: true,
        ...options
    };
    return {
        name: $3c39e154bad98510$var$INTEGRATION_NAME,
        setup (client) {
            if (_options.console) (0, $gaxBK.addConsoleInstrumentationHandler)($3c39e154bad98510$var$_getConsoleBreadcrumbHandler(client));
            if (_options.dom) (0, $9zMJO.addClickKeypressInstrumentationHandler)($3c39e154bad98510$var$_getDomBreadcrumbHandler(client, _options.dom));
            if (_options.xhr) (0, $7HchG.addXhrInstrumentationHandler)($3c39e154bad98510$var$_getXhrBreadcrumbHandler(client));
            if (_options.fetch) (0, $gaxBK.addFetchInstrumentationHandler)($3c39e154bad98510$var$_getFetchBreadcrumbHandler(client));
            if (_options.history) (0, $e3Llk.addHistoryInstrumentationHandler)($3c39e154bad98510$var$_getHistoryBreadcrumbHandler(client));
            if (_options.sentry) client.on("beforeSendEvent", $3c39e154bad98510$var$_getSentryBreadcrumbHandler(client));
        }
    };
};
const $3c39e154bad98510$export$c079d904b326663a = (0, $gaxBK.defineIntegration)($3c39e154bad98510$var$_breadcrumbsIntegration);
function $3c39e154bad98510$var$_getSentryBreadcrumbHandler(client) {
    return function addSentryBreadcrumb(event) {
        if ((0, $gaxBK.getClient)() !== client) return;
        (0, $gaxBK.addBreadcrumb)({
            category: `sentry.${event.type === "transaction" ? "transaction" : "event"}`,
            event_id: event.event_id,
            level: event.level,
            message: (0, $gaxBK.getEventDescription)(event)
        }, {
            event: event
        });
    };
}
function $3c39e154bad98510$var$_getDomBreadcrumbHandler(client, dom) {
    return function _innerDomBreadcrumb(handlerData) {
        if ((0, $gaxBK.getClient)() !== client) return;
        let target;
        let componentName;
        let keyAttrs = typeof dom === "object" ? dom.serializeAttribute : void 0;
        let maxStringLength = typeof dom === "object" && typeof dom.maxStringLength === "number" ? dom.maxStringLength : void 0;
        if (maxStringLength && maxStringLength > $3c39e154bad98510$var$MAX_ALLOWED_STRING_LENGTH) {
            (0, $f67fK.DEBUG_BUILD) && (0, $gaxBK.debug).warn(`\`dom.maxStringLength\` cannot exceed ${$3c39e154bad98510$var$MAX_ALLOWED_STRING_LENGTH}, but a value of ${maxStringLength} was configured. Sentry will use ${$3c39e154bad98510$var$MAX_ALLOWED_STRING_LENGTH} instead.`);
            maxStringLength = $3c39e154bad98510$var$MAX_ALLOWED_STRING_LENGTH;
        }
        if (typeof keyAttrs === "string") keyAttrs = [
            keyAttrs
        ];
        try {
            const event = handlerData.event;
            const element = $3c39e154bad98510$var$_isEvent(event) ? event.target : event;
            target = (0, $1rNqq.htmlTreeAsString)(element, {
                keyAttrs: keyAttrs,
                maxStringLength: maxStringLength
            });
            componentName = (0, $gaxBK.getComponentName)(element);
        } catch  {
            target = "<unknown>";
        }
        if (target.length === 0) return;
        const breadcrumb = {
            category: `ui.${handlerData.name}`,
            message: target
        };
        if (componentName) breadcrumb.data = {
            "ui.component_name": componentName
        };
        (0, $gaxBK.addBreadcrumb)(breadcrumb, {
            event: handlerData.event,
            name: handlerData.name,
            global: handlerData.global
        });
    };
}
function $3c39e154bad98510$var$_getConsoleBreadcrumbHandler(client) {
    return function _consoleBreadcrumb(handlerData) {
        if ((0, $gaxBK.getClient)() !== client) return;
        const breadcrumb = {
            category: "console",
            data: {
                arguments: handlerData.args,
                logger: "console"
            },
            level: (0, $gaxBK.severityLevelFromString)(handlerData.level),
            message: (0, $gaxBK.safeJoin)(handlerData.args, " ")
        };
        if (handlerData.level === "assert") {
            if (handlerData.args[0] === false) {
                breadcrumb.message = `Assertion failed: ${(0, $gaxBK.safeJoin)(handlerData.args.slice(1), " ") || "console.assert"}`;
                breadcrumb.data.arguments = handlerData.args.slice(1);
            } else return;
        }
        (0, $gaxBK.addBreadcrumb)(breadcrumb, {
            input: handlerData.args,
            level: handlerData.level
        });
    };
}
function $3c39e154bad98510$var$_getXhrBreadcrumbHandler(client) {
    return function _xhrBreadcrumb(handlerData) {
        if ((0, $gaxBK.getClient)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        const sentryXhrData = handlerData.xhr[0, $7HchG.SENTRY_XHR_DATA_KEY];
        if (!startTimestamp || !endTimestamp || !sentryXhrData) return;
        const { method: method, url: url, status_code: status_code, body: body } = sentryXhrData;
        const data = {
            method: method,
            url: url,
            status_code: status_code
        };
        const hint = {
            xhr: handlerData.xhr,
            input: body,
            startTimestamp: startTimestamp,
            endTimestamp: endTimestamp
        };
        const breadcrumb = {
            category: "xhr",
            data: data,
            type: "http",
            level: (0, $gaxBK.getBreadcrumbLogLevelFromHttpStatusCode)(status_code)
        };
        client.emit("beforeOutgoingRequestBreadcrumb", breadcrumb, hint);
        (0, $gaxBK.addBreadcrumb)(breadcrumb, hint);
    };
}
function $3c39e154bad98510$var$_getFetchBreadcrumbHandler(client) {
    return function _fetchBreadcrumb(handlerData) {
        if ((0, $gaxBK.getClient)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        if (!endTimestamp) return;
        if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === "POST") return;
        if (handlerData.error) {
            const hint = {
                data: handlerData.error,
                input: handlerData.args,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            const breadcrumb = {
                category: "fetch",
                data: handlerData.fetchData,
                level: "error",
                type: "http"
            };
            client.emit("beforeOutgoingRequestBreadcrumb", breadcrumb, hint);
            (0, $gaxBK.addBreadcrumb)(breadcrumb, hint);
        } else {
            const response = handlerData.response;
            const data = {
                ...handlerData.fetchData,
                status_code: response?.status
            };
            const hint = {
                input: handlerData.args,
                response: response,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            const breadcrumb = {
                category: "fetch",
                data: data,
                type: "http",
                level: (0, $gaxBK.getBreadcrumbLogLevelFromHttpStatusCode)(data.status_code)
            };
            client.emit("beforeOutgoingRequestBreadcrumb", breadcrumb, hint);
            (0, $gaxBK.addBreadcrumb)(breadcrumb, hint);
        }
    };
}
function $3c39e154bad98510$var$_getHistoryBreadcrumbHandler(client) {
    return function _historyBreadcrumb(handlerData) {
        if ((0, $gaxBK.getClient)() !== client) return;
        let from = handlerData.from;
        let to = handlerData.to;
        const parsedLoc = (0, $gaxBK.parseUrl)((0, $bHKc9.WINDOW).location.href);
        let parsedFrom = from ? (0, $gaxBK.parseUrl)(from) : void 0;
        const parsedTo = (0, $gaxBK.parseUrl)(to);
        if (!parsedFrom?.path) parsedFrom = parsedLoc;
        if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) to = parsedTo.relative;
        if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) from = parsedFrom.relative;
        (0, $gaxBK.addBreadcrumb)({
            category: "navigation",
            data: {
                from: from,
                to: to
            }
        });
    };
}
function $3c39e154bad98510$var$_isEvent(event) {
    return !!event && !!event.target;
}

});
parcelRegister("9zMJO", function(module, exports) {

$parcel$export(module.exports, "addClickKeypressInstrumentationHandler", function () { return $6f8d304a2aaf5790$export$5aeffd3db2cf9df7; });

var $f5byn = parcelRequire("f5byn");
var $4zVoD = parcelRequire("4zVoD");
var $h9p4m = parcelRequire("h9p4m");

var $gWPaa = parcelRequire("gWPaa");
const $6f8d304a2aaf5790$var$DEBOUNCE_DURATION = 1e3;
let $6f8d304a2aaf5790$var$debounceTimerID;
let $6f8d304a2aaf5790$var$lastCapturedEventType;
let $6f8d304a2aaf5790$var$lastCapturedEventTargetId;
function $6f8d304a2aaf5790$export$5aeffd3db2cf9df7(handler) {
    const type = "dom";
    (0, $f5byn.addHandler)(type, handler);
    (0, $f5byn.maybeInstrument)(type, $6f8d304a2aaf5790$export$3014bbf0af0e1d4a);
}
function $6f8d304a2aaf5790$export$3014bbf0af0e1d4a() {
    if (!(0, $gWPaa.WINDOW).document) return;
    const triggerDOMHandler = (0, $f5byn.triggerHandlers).bind(null, "dom");
    const globalDOMEventHandler = $6f8d304a2aaf5790$var$makeDOMEventHandler(triggerDOMHandler, true);
    (0, $gWPaa.WINDOW).document.addEventListener("click", globalDOMEventHandler, false);
    (0, $gWPaa.WINDOW).document.addEventListener("keypress", globalDOMEventHandler, false);
    [
        "EventTarget",
        "Node"
    ].forEach((target)=>{
        const globalObject = (0, $gWPaa.WINDOW);
        const proto = globalObject[target]?.prototype;
        if (!proto?.hasOwnProperty?.("addEventListener")) return;
        (0, $4zVoD.fill)(proto, "addEventListener", function(originalAddEventListener) {
            return function(type, listener, options) {
                if (type === "click" || type == "keypress") try {
                    const handlers = this.__sentry_instrumentation_handlers__ = this.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type] = handlers[type] || {
                        refCount: 0
                    };
                    if (!handlerForType.handler) {
                        const handler = $6f8d304a2aaf5790$var$makeDOMEventHandler(triggerDOMHandler);
                        handlerForType.handler = handler;
                        originalAddEventListener.call(this, type, handler, options);
                    }
                    handlerForType.refCount++;
                } catch  {}
                return originalAddEventListener.call(this, type, listener, options);
            };
        });
        (0, $4zVoD.fill)(proto, "removeEventListener", function(originalRemoveEventListener) {
            return function(type, listener, options) {
                if (type === "click" || type == "keypress") try {
                    const handlers = this.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type];
                    if (handlerForType) {
                        handlerForType.refCount--;
                        if (handlerForType.refCount <= 0) {
                            originalRemoveEventListener.call(this, type, handlerForType.handler, options);
                            handlerForType.handler = void 0;
                            delete handlers[type];
                        }
                        if (Object.keys(handlers).length === 0) delete this.__sentry_instrumentation_handlers__;
                    }
                } catch  {}
                return originalRemoveEventListener.call(this, type, listener, options);
            };
        });
    });
}
function $6f8d304a2aaf5790$var$isSimilarToLastCapturedEvent(event) {
    if (event.type !== $6f8d304a2aaf5790$var$lastCapturedEventType) return false;
    try {
        if (!event.target || event.target._sentryId !== $6f8d304a2aaf5790$var$lastCapturedEventTargetId) return false;
    } catch  {}
    return true;
}
function $6f8d304a2aaf5790$var$shouldSkipDOMEvent(eventType, target) {
    if (eventType !== "keypress") return false;
    if (!target?.tagName) return true;
    if (target.tagName === "INPUT" || target.tagName === "TEXTAREA" || target.isContentEditable) return false;
    return true;
}
function $6f8d304a2aaf5790$var$makeDOMEventHandler(handler, globalListener = false) {
    return (event)=>{
        if (!event || event["_sentryCaptured"]) return;
        const target = $6f8d304a2aaf5790$var$getEventTarget(event);
        if ($6f8d304a2aaf5790$var$shouldSkipDOMEvent(event.type, target)) return;
        (0, $4zVoD.addNonEnumerableProperty)(event, "_sentryCaptured", true);
        if (target && !target._sentryId) (0, $4zVoD.addNonEnumerableProperty)(target, "_sentryId", (0, $h9p4m.uuid4)());
        const name = event.type === "keypress" ? "input" : event.type;
        if (!$6f8d304a2aaf5790$var$isSimilarToLastCapturedEvent(event)) {
            const handlerData = {
                event: event,
                name: name,
                global: globalListener
            };
            handler(handlerData);
            $6f8d304a2aaf5790$var$lastCapturedEventType = event.type;
            $6f8d304a2aaf5790$var$lastCapturedEventTargetId = target ? target._sentryId : void 0;
        }
        clearTimeout($6f8d304a2aaf5790$var$debounceTimerID);
        $6f8d304a2aaf5790$var$debounceTimerID = (0, $gWPaa.WINDOW).setTimeout(()=>{
            $6f8d304a2aaf5790$var$lastCapturedEventTargetId = void 0;
            $6f8d304a2aaf5790$var$lastCapturedEventType = void 0;
        }, $6f8d304a2aaf5790$var$DEBOUNCE_DURATION);
    };
}
function $6f8d304a2aaf5790$var$getEventTarget(event) {
    try {
        return event.target;
    } catch  {
        return null;
    }
}

});


parcelRegister("eLkZ8", function(module, exports) {

$parcel$export(module.exports, "browserApiErrorsIntegration", function () { return $abf5bbae0db9af92$export$59bfe9f1c76150e; });

var $gaxBK = parcelRequire("gaxBK");

var $bHKc9 = parcelRequire("bHKc9");
const $abf5bbae0db9af92$var$DEFAULT_EVENT_TARGET = "EventTarget,Window,Node,ApplicationCache,AudioTrackList,BroadcastChannel,ChannelMergerNode,CryptoOperation,EventSource,FileReader,HTMLUnknownElement,IDBDatabase,IDBRequest,IDBTransaction,KeyOperation,MediaController,MessagePort,ModalWindow,Notification,SVGElementInstance,Screen,SharedWorker,TextTrack,TextTrackCue,TextTrackList,WebSocket,WebSocketWorker,Worker,XMLHttpRequest,XMLHttpRequestEventTarget,XMLHttpRequestUpload".split(",");
const $abf5bbae0db9af92$var$INTEGRATION_NAME = "BrowserApiErrors";
const $abf5bbae0db9af92$var$_browserApiErrorsIntegration = (options = {})=>{
    const _options = {
        XMLHttpRequest: true,
        eventTarget: true,
        requestAnimationFrame: true,
        setInterval: true,
        setTimeout: true,
        unregisterOriginalCallbacks: false,
        ...options
    };
    return {
        name: $abf5bbae0db9af92$var$INTEGRATION_NAME,
        // TODO: This currently only works for the first client this is setup
        // We may want to adjust this to check for client etc.
        setupOnce () {
            if (_options.setTimeout) (0, $gaxBK.fill)((0, $bHKc9.WINDOW), "setTimeout", $abf5bbae0db9af92$var$_wrapTimeFunction);
            if (_options.setInterval) (0, $gaxBK.fill)((0, $bHKc9.WINDOW), "setInterval", $abf5bbae0db9af92$var$_wrapTimeFunction);
            if (_options.requestAnimationFrame) (0, $gaxBK.fill)((0, $bHKc9.WINDOW), "requestAnimationFrame", $abf5bbae0db9af92$var$_wrapRAF);
            if (_options.XMLHttpRequest && "XMLHttpRequest" in (0, $bHKc9.WINDOW)) (0, $gaxBK.fill)(XMLHttpRequest.prototype, "send", $abf5bbae0db9af92$var$_wrapXHR);
            const eventTargetOption = _options.eventTarget;
            if (eventTargetOption) {
                const eventTarget = Array.isArray(eventTargetOption) ? eventTargetOption : $abf5bbae0db9af92$var$DEFAULT_EVENT_TARGET;
                eventTarget.forEach((target)=>$abf5bbae0db9af92$var$_wrapEventTarget(target, _options));
            }
        }
    };
};
const $abf5bbae0db9af92$export$59bfe9f1c76150e = (0, $gaxBK.defineIntegration)($abf5bbae0db9af92$var$_browserApiErrorsIntegration);
function $abf5bbae0db9af92$var$_wrapTimeFunction(original) {
    return function(...args) {
        const originalCallback = args[0];
        args[0] = (0, $bHKc9.wrap)(originalCallback, {
            mechanism: {
                handled: false,
                type: `auto.browser.browserapierrors.${(0, $gaxBK.getFunctionName)(original)}`
            }
        });
        return original.apply(this, args);
    };
}
function $abf5bbae0db9af92$var$_wrapRAF(original) {
    return function(callback) {
        return original.apply(this, [
            (0, $bHKc9.wrap)(callback, {
                mechanism: {
                    data: {
                        handler: (0, $gaxBK.getFunctionName)(original)
                    },
                    handled: false,
                    type: "auto.browser.browserapierrors.requestAnimationFrame"
                }
            })
        ]);
    };
}
function $abf5bbae0db9af92$var$_wrapXHR(originalSend) {
    return function(...args) {
        const xhr = this;
        const xmlHttpRequestProps = [
            "onload",
            "onerror",
            "onprogress",
            "onreadystatechange"
        ];
        xmlHttpRequestProps.forEach((prop)=>{
            if (prop in xhr && typeof xhr[prop] === "function") (0, $gaxBK.fill)(xhr, prop, function(original) {
                const wrapOptions = {
                    mechanism: {
                        data: {
                            handler: (0, $gaxBK.getFunctionName)(original)
                        },
                        handled: false,
                        type: `auto.browser.browserapierrors.xhr.${prop}`
                    }
                };
                const originalFunction = (0, $gaxBK.getOriginalFunction)(original);
                if (originalFunction) wrapOptions.mechanism.data.handler = (0, $gaxBK.getFunctionName)(originalFunction);
                return (0, $bHKc9.wrap)(original, wrapOptions);
            });
        });
        return originalSend.apply(this, args);
    };
}
function $abf5bbae0db9af92$var$_wrapEventTarget(target, integrationOptions) {
    const globalObject = (0, $bHKc9.WINDOW);
    const proto = globalObject[target]?.prototype;
    if (!proto?.hasOwnProperty?.("addEventListener")) return;
    (0, $gaxBK.fill)(proto, "addEventListener", function(original) {
        return function(eventName, fn, options) {
            try {
                if ($abf5bbae0db9af92$var$isEventListenerObject(fn)) fn.handleEvent = (0, $bHKc9.wrap)(fn.handleEvent, {
                    mechanism: {
                        data: {
                            handler: (0, $gaxBK.getFunctionName)(fn),
                            target: target
                        },
                        handled: false,
                        type: "auto.browser.browserapierrors.handleEvent"
                    }
                });
            } catch  {}
            if (integrationOptions.unregisterOriginalCallbacks) $abf5bbae0db9af92$var$unregisterOriginalCallback(this, eventName, fn);
            return original.apply(this, [
                eventName,
                (0, $bHKc9.wrap)(fn, {
                    mechanism: {
                        data: {
                            handler: (0, $gaxBK.getFunctionName)(fn),
                            target: target
                        },
                        handled: false,
                        type: "auto.browser.browserapierrors.addEventListener"
                    }
                }),
                options
            ]);
        };
    });
    (0, $gaxBK.fill)(proto, "removeEventListener", function(originalRemoveEventListener) {
        return function(eventName, fn, options) {
            try {
                if (Object.prototype.hasOwnProperty.call(fn, "__sentry_wrapped__")) {
                    const originalEventHandler = fn.__sentry_wrapped__;
                    if (originalEventHandler) originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
                }
            } catch  {}
            return originalRemoveEventListener.call(this, eventName, fn, options);
        };
    });
}
function $abf5bbae0db9af92$var$isEventListenerObject(obj) {
    return typeof obj.handleEvent === "function";
}
function $abf5bbae0db9af92$var$unregisterOriginalCallback(target, eventName, fn) {
    if (target && typeof target === "object" && "removeEventListener" in target && typeof target.removeEventListener === "function") target.removeEventListener(eventName, fn);
}

});

parcelRegister("iajrg", function(module, exports) {

$parcel$export(module.exports, "browserSessionIntegration", function () { return $d3983d4984259e30$export$1baa7880e357371c; });

var $gaxBK = parcelRequire("gaxBK");

var $e3Llk = parcelRequire("e3Llk");
var $wwz0G = parcelRequire("wwz0G");

var $f67fK = parcelRequire("f67fK");

var $bHKc9 = parcelRequire("bHKc9");
const $d3983d4984259e30$export$1baa7880e357371c = (0, $gaxBK.defineIntegration)((options = {})=>{
    const lifecycle = options.lifecycle ?? "route";
    return {
        name: "BrowserSession",
        setupOnce () {
            if (typeof (0, $bHKc9.WINDOW).document === "undefined") {
                (0, $f67fK.DEBUG_BUILD) && (0, $gaxBK.debug).warn("Using the `browserSessionIntegration` in non-browser environments is not supported.");
                return;
            }
            (0, $gaxBK.startSession)({
                ignoreDuration: true
            });
            let initialSessionSent = false;
            (0, $wwz0G.whenIdleOrHidden)(()=>{
                if (!initialSessionSent) {
                    (0, $gaxBK.captureSession)();
                    initialSessionSent = true;
                }
            });
            const isolationScope = (0, $gaxBK.getIsolationScope)();
            let previousUser = isolationScope.getUser();
            isolationScope.addScopeListener((scope)=>{
                const maybeNewUser = scope.getUser();
                if (previousUser?.id !== maybeNewUser?.id || previousUser?.ip_address !== maybeNewUser?.ip_address) {
                    previousUser = maybeNewUser;
                    if (initialSessionSent) (0, $gaxBK.captureSession)();
                }
            });
            if (lifecycle === "route") (0, $e3Llk.addHistoryInstrumentationHandler)(({ from: from, to: to })=>{
                if (from !== to) {
                    (0, $gaxBK.startSession)({
                        ignoreDuration: true
                    });
                    (0, $gaxBK.captureSession)();
                    initialSessionSent = true;
                }
            });
        }
    };
});

});

parcelRegister("3uJ5t", function(module, exports) {

$parcel$export(module.exports, "cultureContextIntegration", function () { return $28b725d213595887$export$ec5976aacdc85985; });

var $gaxBK = parcelRequire("gaxBK");

var $bHKc9 = parcelRequire("bHKc9");
const $28b725d213595887$var$INTEGRATION_NAME = "CultureContext";
const $28b725d213595887$var$_cultureContextIntegration = ()=>{
    return {
        name: $28b725d213595887$var$INTEGRATION_NAME,
        preprocessEvent (event) {
            const culture = $28b725d213595887$var$getCultureContext();
            if (culture) event.contexts = {
                ...event.contexts,
                culture: {
                    ...culture,
                    ...event.contexts?.culture
                }
            };
        },
        processSegmentSpan (span) {
            const culture = $28b725d213595887$var$getCultureContext();
            if (culture) (0, $gaxBK.safeSetSpanJSONAttributes)(span, {
                "culture.locale": culture.locale,
                "culture.timezone": culture.timezone,
                "culture.calendar": culture.calendar
            });
        }
    };
};
const $28b725d213595887$export$ec5976aacdc85985 = (0, $gaxBK.defineIntegration)($28b725d213595887$var$_cultureContextIntegration);
function $28b725d213595887$var$getCultureContext() {
    try {
        const intl = (0, $bHKc9.WINDOW).Intl;
        if (!intl) return void 0;
        const options = intl.DateTimeFormat().resolvedOptions();
        return {
            locale: options.locale,
            timezone: options.timeZone,
            calendar: options.calendar
        };
    } catch  {
        return void 0;
    }
}

});

parcelRegister("gTdoN", function(module, exports) {

$parcel$export(module.exports, "globalHandlersIntegration", function () { return $c4bc2d2938c4f693$export$66acc70e8cf2b71a; });

var $gaxBK = parcelRequire("gaxBK");

var $f67fK = parcelRequire("f67fK");

var $bo6xz = parcelRequire("bo6xz");

var $bHKc9 = parcelRequire("bHKc9");
const $c4bc2d2938c4f693$var$INTEGRATION_NAME = "GlobalHandlers";
const $c4bc2d2938c4f693$var$_globalHandlersIntegration = (options = {})=>{
    const _options = {
        onerror: true,
        onunhandledrejection: true,
        ...options
    };
    return {
        name: $c4bc2d2938c4f693$var$INTEGRATION_NAME,
        setupOnce () {
            Error.stackTraceLimit = 50;
        },
        setup (client) {
            if (_options.onerror) {
                $c4bc2d2938c4f693$var$_installGlobalOnErrorHandler(client);
                $c4bc2d2938c4f693$var$globalHandlerLog("onerror");
            }
            if (_options.onunhandledrejection) {
                $c4bc2d2938c4f693$var$_installGlobalOnUnhandledRejectionHandler(client);
                $c4bc2d2938c4f693$var$globalHandlerLog("onunhandledrejection");
            }
        }
    };
};
const $c4bc2d2938c4f693$export$66acc70e8cf2b71a = (0, $gaxBK.defineIntegration)($c4bc2d2938c4f693$var$_globalHandlersIntegration);
function $c4bc2d2938c4f693$var$_installGlobalOnErrorHandler(client) {
    (0, $gaxBK.addGlobalErrorInstrumentationHandler)((data)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $c4bc2d2938c4f693$var$getOptions();
        if ((0, $gaxBK.getClient)() !== client || (0, $bHKc9.shouldIgnoreOnError)()) return;
        const { msg: msg, url: url, line: line, column: column, error: error } = data;
        const event = $c4bc2d2938c4f693$var$_enhanceEventWithInitialFrame((0, $bo6xz.eventFromUnknownInput)(stackParser, error || msg, void 0, attachStacktrace, false), url, line, column);
        event.level = "error";
        (0, $gaxBK.captureEvent)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: "auto.browser.global_handlers.onerror"
            }
        });
    });
}
function $c4bc2d2938c4f693$var$_installGlobalOnUnhandledRejectionHandler(client) {
    (0, $gaxBK.addGlobalUnhandledRejectionInstrumentationHandler)((e)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $c4bc2d2938c4f693$var$getOptions();
        if ((0, $gaxBK.getClient)() !== client || (0, $bHKc9.shouldIgnoreOnError)()) return;
        const error = $c4bc2d2938c4f693$export$b2cc40fa8241780(e);
        const event = (0, $gaxBK.isPrimitive)(error) ? $c4bc2d2938c4f693$export$1353b5b36844a9ed(error) : (0, $bo6xz.eventFromUnknownInput)(stackParser, error, void 0, attachStacktrace, true);
        event.level = "error";
        (0, $gaxBK.captureEvent)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: "auto.browser.global_handlers.onunhandledrejection"
            }
        });
    });
}
function $c4bc2d2938c4f693$export$b2cc40fa8241780(error) {
    if ((0, $gaxBK.isPrimitive)(error)) return error;
    try {
        if ("reason" in error) return error.reason;
        if ("detail" in error && "reason" in error.detail) return error.detail.reason;
    } catch  {}
    return error;
}
function $c4bc2d2938c4f693$export$1353b5b36844a9ed(reason) {
    return {
        exception: {
            values: [
                {
                    type: "UnhandledRejection",
                    // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
                    value: `Non-Error promise rejection captured with value: ${String(reason)}`
                }
            ]
        }
    };
}
function $c4bc2d2938c4f693$var$_enhanceEventWithInitialFrame(event, url, lineno, colno) {
    const e = event.exception = event.exception || {};
    const ev = e.values = e.values || [];
    const ev0 = ev[0] = ev[0] || {};
    const ev0s = ev0.stacktrace = ev0.stacktrace || {};
    const ev0sf = ev0s.frames = ev0s.frames || [];
    if (ev0sf.length === 0) ev0sf.push({
        colno: colno,
        lineno: lineno,
        filename: $c4bc2d2938c4f693$var$getFilenameFromUrl(url) ?? (0, $gaxBK.getLocationHref)(),
        function: (0, $gaxBK.UNKNOWN_FUNCTION),
        in_app: true
    });
    return event;
}
function $c4bc2d2938c4f693$var$globalHandlerLog(type) {
    (0, $f67fK.DEBUG_BUILD) && (0, $gaxBK.debug).log(`Global Handler attached: ${type}`);
}
function $c4bc2d2938c4f693$var$getOptions() {
    const client = (0, $gaxBK.getClient)();
    const options = client?.getOptions() || {
        stackParser: ()=>[],
        attachStacktrace: false
    };
    return options;
}
function $c4bc2d2938c4f693$var$getFilenameFromUrl(url) {
    if (!(0, $gaxBK.isString)(url) || url.length === 0) return void 0;
    if (url.startsWith("data:")) return `<${(0, $gaxBK.stripDataUrlContent)(url, false)}>`;
    return url;
}

});

parcelRegister("hQG0y", function(module, exports) {

$parcel$export(module.exports, "httpContextIntegration", function () { return $cfe7e0e6753e7f9a$export$1378794447170364; });

var $gaxBK = parcelRequire("gaxBK");

var $bHKc9 = parcelRequire("bHKc9");
const $cfe7e0e6753e7f9a$export$1378794447170364 = (0, $gaxBK.defineIntegration)(()=>{
    return {
        name: "HttpContext",
        preprocessEvent (event) {
            if (!(0, $bHKc9.WINDOW).navigator && !(0, $bHKc9.WINDOW).location && !(0, $bHKc9.WINDOW).document) return;
            const reqData = (0, $bHKc9.getHttpRequestData)();
            const headers = {
                ...reqData.headers,
                ...event.request?.headers
            };
            event.request = {
                ...reqData,
                ...event.request,
                headers: headers
            };
        },
        processSegmentSpan (span) {
            const spanOp = span.attributes?.[0, $gaxBK.SEMANTIC_ATTRIBUTE_SENTRY_OP];
            if (!(0, $bHKc9.WINDOW).navigator && !(0, $bHKc9.WINDOW).location && !(0, $bHKc9.WINDOW).document) return;
            const reqData = (0, $bHKc9.getHttpRequestData)();
            (0, $gaxBK.safeSetSpanJSONAttributes)(span, {
                // Coerce empty string to undefined so the helper's nullish check drops it,
                // rather than writing an empty `url.full` attribute onto the span.
                "url.full": spanOp !== "http.client" ? reqData.url : void 0,
                "http.request.header.user_agent": reqData.headers["User-Agent"],
                "http.request.header.referer": reqData.headers["Referer"]
            });
        }
    };
});

});

parcelRegister("5kOO1", function(module, exports) {

$parcel$export(module.exports, "linkedErrorsIntegration", function () { return $3e263b00e2d401c7$export$ebabb00eb7f3a395; });

var $gaxBK = parcelRequire("gaxBK");

var $bo6xz = parcelRequire("bo6xz");
const $3e263b00e2d401c7$var$DEFAULT_KEY = "cause";
const $3e263b00e2d401c7$var$DEFAULT_LIMIT = 5;
const $3e263b00e2d401c7$var$INTEGRATION_NAME = "LinkedErrors";
const $3e263b00e2d401c7$var$_linkedErrorsIntegration = (options = {})=>{
    const limit = options.limit || $3e263b00e2d401c7$var$DEFAULT_LIMIT;
    const key = options.key || $3e263b00e2d401c7$var$DEFAULT_KEY;
    return {
        name: $3e263b00e2d401c7$var$INTEGRATION_NAME,
        preprocessEvent (event, hint, client) {
            const options2 = client.getOptions();
            (0, $gaxBK.applyAggregateErrorsToEvent)(// This differs from the LinkedErrors integration in core by using a different exceptionFromError function
            (0, $bo6xz.exceptionFromError), options2.stackParser, key, limit, event, hint);
        }
    };
};
const $3e263b00e2d401c7$export$ebabb00eb7f3a395 = (0, $gaxBK.defineIntegration)($3e263b00e2d401c7$var$_linkedErrorsIntegration);

});

parcelRegister("dpJDD", function(module, exports) {

$parcel$export(module.exports, "defaultStackParser", function () { return $9c4102f6dbc39e87$export$2b2b997d81bf3907; });

var $gaxBK = parcelRequire("gaxBK");
const $9c4102f6dbc39e87$var$OPERA10_PRIORITY = 10;
const $9c4102f6dbc39e87$var$OPERA11_PRIORITY = 20;
const $9c4102f6dbc39e87$var$CHROME_PRIORITY = 30;
const $9c4102f6dbc39e87$var$WINJS_PRIORITY = 40;
const $9c4102f6dbc39e87$var$GECKO_PRIORITY = 50;
function $9c4102f6dbc39e87$var$createFrame(filename, func, lineno, colno) {
    const frame = {
        filename: filename,
        function: func === "<anonymous>" ? (0, $gaxBK.UNKNOWN_FUNCTION) : func,
        in_app: true
    };
    if (lineno !== void 0) frame.lineno = lineno;
    if (colno !== void 0) frame.colno = colno;
    return frame;
}
const $9c4102f6dbc39e87$var$chromeRegexNoFnName = /^\s*at (\S+?)(?::(\d+))(?::(\d+))\s*$/i;
const $9c4102f6dbc39e87$var$chromeRegex = /^\s*at (?:(.+?\)(?: \[.+\])?|.*?) ?\((?:address at )?)?(?:async )?((?:<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
const $9c4102f6dbc39e87$var$chromeEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;
const $9c4102f6dbc39e87$var$chromeDataUriRegex = /at (.+?) ?\(data:(.+?),/;
const $9c4102f6dbc39e87$var$chromeStackParserFn = (line)=>{
    const dataUriMatch = line.match($9c4102f6dbc39e87$var$chromeDataUriRegex);
    if (dataUriMatch) return {
        filename: `<data:${dataUriMatch[2]}>`,
        function: dataUriMatch[1]
    };
    const noFnParts = $9c4102f6dbc39e87$var$chromeRegexNoFnName.exec(line);
    if (noFnParts) {
        const [, filename, line2, col] = noFnParts;
        return $9c4102f6dbc39e87$var$createFrame(filename, (0, $gaxBK.UNKNOWN_FUNCTION), +line2, +col);
    }
    const parts = $9c4102f6dbc39e87$var$chromeRegex.exec(line);
    if (parts) {
        const isEval = parts[2]?.indexOf("eval") === 0;
        if (isEval) {
            const subMatch = $9c4102f6dbc39e87$var$chromeEvalRegex.exec(parts[2]);
            if (subMatch) {
                parts[2] = subMatch[1];
                parts[3] = subMatch[2];
                parts[4] = subMatch[3];
            }
        }
        const [func, filename] = $9c4102f6dbc39e87$var$extractSafariExtensionDetails(parts[1] || (0, $gaxBK.UNKNOWN_FUNCTION), parts[2]);
        return $9c4102f6dbc39e87$var$createFrame(filename, func, parts[3] ? +parts[3] : void 0, parts[4] ? +parts[4] : void 0);
    }
    return;
};
const $9c4102f6dbc39e87$export$263a749fff749872 = [
    $9c4102f6dbc39e87$var$CHROME_PRIORITY,
    $9c4102f6dbc39e87$var$chromeStackParserFn
];
const $9c4102f6dbc39e87$var$geckoREgex = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:[-a-z]+)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
const $9c4102f6dbc39e87$var$geckoEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
const $9c4102f6dbc39e87$var$gecko = (line)=>{
    const parts = $9c4102f6dbc39e87$var$geckoREgex.exec(line);
    if (parts) {
        const isEval = parts[3] && parts[3].indexOf(" > eval") > -1;
        if (isEval) {
            const subMatch = $9c4102f6dbc39e87$var$geckoEvalRegex.exec(parts[3]);
            if (subMatch) {
                parts[1] = parts[1] || "eval";
                parts[3] = subMatch[1];
                parts[4] = subMatch[2];
                parts[5] = "";
            }
        }
        let filename = parts[3];
        let func = parts[1] || (0, $gaxBK.UNKNOWN_FUNCTION);
        [func, filename] = $9c4102f6dbc39e87$var$extractSafariExtensionDetails(func, filename);
        return $9c4102f6dbc39e87$var$createFrame(filename, func, parts[4] ? +parts[4] : void 0, parts[5] ? +parts[5] : void 0);
    }
    return;
};
const $9c4102f6dbc39e87$export$cdba47a5dd2804d = [
    $9c4102f6dbc39e87$var$GECKO_PRIORITY,
    $9c4102f6dbc39e87$var$gecko
];
const $9c4102f6dbc39e87$var$winjsRegex = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:[-a-z]+):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
const $9c4102f6dbc39e87$var$winjs = (line)=>{
    const parts = $9c4102f6dbc39e87$var$winjsRegex.exec(line);
    return parts ? $9c4102f6dbc39e87$var$createFrame(parts[2], parts[1] || (0, $gaxBK.UNKNOWN_FUNCTION), +parts[3], parts[4] ? +parts[4] : void 0) : void 0;
};
const $9c4102f6dbc39e87$export$179460296da408e8 = [
    $9c4102f6dbc39e87$var$WINJS_PRIORITY,
    $9c4102f6dbc39e87$var$winjs
];
const $9c4102f6dbc39e87$var$opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
const $9c4102f6dbc39e87$var$opera10 = (line)=>{
    const parts = $9c4102f6dbc39e87$var$opera10Regex.exec(line);
    return parts ? $9c4102f6dbc39e87$var$createFrame(parts[2], parts[3] || (0, $gaxBK.UNKNOWN_FUNCTION), +parts[1]) : void 0;
};
const $9c4102f6dbc39e87$export$f892b52c880ffc7a = [
    $9c4102f6dbc39e87$var$OPERA10_PRIORITY,
    $9c4102f6dbc39e87$var$opera10
];
const $9c4102f6dbc39e87$var$opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\(.*\))? in (.*):\s*$/i;
const $9c4102f6dbc39e87$var$opera11 = (line)=>{
    const parts = $9c4102f6dbc39e87$var$opera11Regex.exec(line);
    return parts ? $9c4102f6dbc39e87$var$createFrame(parts[5], parts[3] || parts[4] || (0, $gaxBK.UNKNOWN_FUNCTION), +parts[1], +parts[2]) : void 0;
};
const $9c4102f6dbc39e87$export$af11af13f09fb0dc = [
    $9c4102f6dbc39e87$var$OPERA11_PRIORITY,
    $9c4102f6dbc39e87$var$opera11
];
const $9c4102f6dbc39e87$export$7197c0fe6554c079 = [
    $9c4102f6dbc39e87$export$263a749fff749872,
    $9c4102f6dbc39e87$export$cdba47a5dd2804d
];
const $9c4102f6dbc39e87$export$2b2b997d81bf3907 = (0, $gaxBK.createStackParser)(...$9c4102f6dbc39e87$export$7197c0fe6554c079);
const $9c4102f6dbc39e87$var$extractSafariExtensionDetails = (func, filename)=>{
    const isSafariExtension = func.indexOf("safari-extension") !== -1;
    const isSafariWebExtension = func.indexOf("safari-web-extension") !== -1;
    return isSafariExtension || isSafariWebExtension ? [
        func.indexOf("@") !== -1 ? func.split("@")[0] : (0, $gaxBK.UNKNOWN_FUNCTION),
        isSafariExtension ? `safari-extension:${filename}` : `safari-web-extension:${filename}`
    ] : [
        func,
        filename
    ];
};

});

parcelRegister("iWSAv", function(module, exports) {

$parcel$export(module.exports, "makeFetchTransport", function () { return $dcb7fcc4851ba5de$export$b2311068c46d7cc8; });

var $gaxBK = parcelRequire("gaxBK");

var $3Xyip = parcelRequire("3Xyip");
const $dcb7fcc4851ba5de$var$DEFAULT_BROWSER_TRANSPORT_BUFFER_SIZE = 40;
function $dcb7fcc4851ba5de$export$b2311068c46d7cc8(options, nativeFetch = (0, $3Xyip.getNativeImplementation)("fetch")) {
    let pendingBodySize = 0;
    let pendingCount = 0;
    async function makeRequest(request) {
        const requestSize = request.body.length;
        pendingBodySize += requestSize;
        pendingCount++;
        const requestOptions = {
            body: request.body,
            method: "POST",
            referrerPolicy: "strict-origin",
            headers: options.headers,
            // Outgoing requests are usually cancelled when navigating to a different page, causing a "TypeError: Failed to
            // fetch" error and sending a "network_error" client-outcome - in Chrome, the request status shows "(cancelled)".
            // The `keepalive` flag keeps outgoing requests alive, even when switching pages. We want this since we're
            // frequently sending events right before the user is switching pages (eg. when finishing navigation transactions).
            // Gotchas:
            // - `keepalive` isn't supported by Firefox
            // - As per spec (https://fetch.spec.whatwg.org/#http-network-or-cache-fetch):
            //   If the sum of contentLength and inflightKeepaliveBytes is greater than 64 kibibytes, then return a network error.
            //   We will therefore only activate the flag when we're below that limit.
            // There is also a limit of requests that can be open at the same time, so we also limit this to 15
            // See https://github.com/getsentry/sentry-javascript/pull/7553 for details
            keepalive: pendingBodySize <= 6e4 && pendingCount < 15,
            ...options.fetchOptions
        };
        try {
            const response = await nativeFetch(options.url, requestOptions);
            return {
                statusCode: response.status,
                headers: {
                    "x-sentry-rate-limits": response.headers.get("X-Sentry-Rate-Limits"),
                    "retry-after": response.headers.get("Retry-After")
                }
            };
        } catch (e) {
            (0, $3Xyip.clearCachedImplementation)("fetch");
            throw e;
        } finally{
            pendingBodySize -= requestSize;
            pendingCount--;
        }
    }
    return (0, $gaxBK.createTransport)(options, makeRequest, (0, $gaxBK.makePromiseBuffer)(options.bufferSize || $dcb7fcc4851ba5de$var$DEFAULT_BROWSER_TRANSPORT_BUFFER_SIZE));
}

});
parcelRegister("3Xyip", function(module, exports) {

$parcel$export(module.exports, "getNativeImplementation", function () { return $2e217c43c085af00$export$e464f4a514ac28a8; });
$parcel$export(module.exports, "clearCachedImplementation", function () { return $2e217c43c085af00$export$8aa36702e8c8978; });

var $w8bd7 = parcelRequire("w8bd7");
var $i0qqg = parcelRequire("i0qqg");

var $9yfTK = parcelRequire("9yfTK");

var $gWPaa = parcelRequire("gWPaa");
const $2e217c43c085af00$var$cachedImplementations = {};
function $2e217c43c085af00$export$e464f4a514ac28a8(name) {
    const cached = $2e217c43c085af00$var$cachedImplementations[name];
    if (cached) return cached;
    let impl = (0, $gWPaa.WINDOW)[name];
    if ((0, $i0qqg.isNativeFunction)(impl)) return $2e217c43c085af00$var$cachedImplementations[name] = impl.bind((0, $gWPaa.WINDOW));
    const document = (0, $gWPaa.WINDOW).document;
    if (document && typeof document.createElement === "function") try {
        const sandbox = document.createElement("iframe");
        sandbox.hidden = true;
        document.head.appendChild(sandbox);
        const contentWindow = sandbox.contentWindow;
        if (contentWindow?.[name]) impl = contentWindow[name];
        document.head.removeChild(sandbox);
    } catch (e) {
        (0, $9yfTK.DEBUG_BUILD) && (0, $w8bd7.debug).warn(`Could not create sandbox iframe for ${name} check, bailing to window.${name}: `, e);
    }
    if (!impl) return impl;
    return $2e217c43c085af00$var$cachedImplementations[name] = impl.bind((0, $gWPaa.WINDOW));
}
function $2e217c43c085af00$export$8aa36702e8c8978(name) {
    $2e217c43c085af00$var$cachedImplementations[name] = void 0;
}
function $2e217c43c085af00$export$e7aa7bc5c1b3cfb3(...rest) {
    return $2e217c43c085af00$export$e464f4a514ac28a8("fetch")(...rest);
}
function $2e217c43c085af00$export$831dc9f2ab0a617b(...rest) {
    return $2e217c43c085af00$export$e464f4a514ac28a8("setTimeout")(...rest);
}

});


parcelRegister("hn3Pc", function(module, exports) {

$parcel$export(module.exports, "normalizeStringifyValue", function () { return $ca578d2f762df4d3$export$4c88c355e6072df5; });

var $1rNqq = parcelRequire("1rNqq");
var $zwrPu = parcelRequire("zwrPu");
const $ca578d2f762df4d3$var$HTML_ELEMENT_CONSTRUCTOR_NAME_REGEX = /^HTML(\w*)Element$/;
function $ca578d2f762df4d3$export$4c88c355e6072df5(value) {
    if (typeof window !== "undefined" && value === window) return "[Window]";
    if (typeof document !== "undefined" && value === document) return "[Document]";
    if ((0, $zwrPu.isElement)(value)) {
        const objName = $ca578d2f762df4d3$var$getConstructorName(value);
        if ($ca578d2f762df4d3$var$HTML_ELEMENT_CONSTRUCTOR_NAME_REGEX.test(objName)) return `[HTMLElement: ${(0, $1rNqq.htmlTreeAsString)(value)}]`;
    }
    return void 0;
}
function $ca578d2f762df4d3$var$getConstructorName(value) {
    const prototype = Object.getPrototypeOf(value);
    return prototype?.constructor ? prototype.constructor.name : "null prototype";
}

});
parcelRegister("zwrPu", function(module, exports) {

$parcel$export(module.exports, "isElement", function () { return $06ac7077feffd3df$export$45a5e7f76e0caa8d; });
function $06ac7077feffd3df$export$45a5e7f76e0caa8d(wat) {
    if (typeof Element === "undefined") return false;
    try {
        return wat instanceof Element;
    } catch  {
        return false;
    }
}

});


parcelRegister("cWFYW", function(module, exports) {

$parcel$export(module.exports, "checkAndWarnIfIsEmbeddedBrowserExtension", function () { return $96cb779065a79386$export$dc236a86065879fc; });

var $gaxBK = parcelRequire("gaxBK");

var $f67fK = parcelRequire("f67fK");

var $bHKc9 = parcelRequire("bHKc9");
function $96cb779065a79386$export$dc236a86065879fc() {
    if ($96cb779065a79386$var$_isEmbeddedBrowserExtension()) {
        if (0, $f67fK.DEBUG_BUILD) (0, $gaxBK.consoleSandbox)(()=>{
            console.error("[Sentry] You cannot use Sentry.init() in a browser extension, see: https://docs.sentry.io/platforms/javascript/best-practices/browser-extensions/");
        });
        return true;
    }
    return false;
}
function $96cb779065a79386$var$_isEmbeddedBrowserExtension() {
    if (typeof (0, $bHKc9.WINDOW).window === "undefined") return false;
    const _window = (0, $bHKc9.WINDOW);
    if (_window.nw) return false;
    const extensionObject = _window["chrome"] || _window["browser"];
    if (!extensionObject?.runtime?.id) return false;
    const href = (0, $gaxBK.getLocationHref)();
    const isDedicatedExtensionPage = (0, $bHKc9.WINDOW) === (0, $bHKc9.WINDOW).top && /^(?:chrome-extension|moz-extension|ms-browser-extension|safari-web-extension):\/\//.test(href);
    return !isDedicatedExtensionPage;
}

});


parcelRegister("b5JSv", function(module, exports) {

$parcel$export(module.exports, "bootstrap", function () { return $fd2663da44d16ed8$export$36aff1fbb4f5dfc6; });

var $4DjaP = parcelRequire("4DjaP");

var $3Kq1x = parcelRequire("3Kq1x");

var $gaxBK = parcelRequire("gaxBK");

var $7dLK0 = parcelRequire("7dLK0");

var $bpm9f = parcelRequire("bpm9f");

var $fZ4oz = parcelRequire("fZ4oz");

var $jaYVW = parcelRequire("jaYVW");

var $cqTsR = parcelRequire("cqTsR");

var $js5ua = parcelRequire("js5ua");

var $fN5b4 = parcelRequire("fN5b4");

var $4V4G7 = parcelRequire("4V4G7");

var $ltXBQ = parcelRequire("ltXBQ");
function $fd2663da44d16ed8$export$dde6bbf83f76d29d(sortedResults, availableIds) {
    const selectable = sortedResults.filter((r)=>availableIds.has(r.id));
    return selectable.length > 0 ? selectable[0] : null;
}
function $fd2663da44d16ed8$export$29c7871a87afb5ec(error) {
    const code = error && typeof error === "object" && "code" in error ? error.code : undefined;
    if (typeof code === "number") {
        const message = "message" in error ? error.message : undefined;
        $gaxBK.withScope((scope)=>{
            scope.setTag("frame_error_code", String(code));
            if (typeof message === "string") scope.setExtra("frame_error_message", message);
            $gaxBK.captureException(error);
        });
        return;
    }
    $gaxBK.captureException(error);
}
function $fd2663da44d16ed8$export$9250fabcd0c6426c(browserAdvisory, startButton, advisoryMessage) {
    if ((0, $4DjaP.isBrowserSupported)()) return true;
    if (advisoryMessage) browserAdvisory.innerHTML = advisoryMessage;
    browserAdvisory.classList.remove("hidden");
    (0, $4V4G7.toggleStartButton)(startButton, false, "Launch");
    return false;
}
async function $fd2663da44d16ed8$export$e820db9e9e2fc09b(token, deps) {
    const { selectedLocationInput: selectedLocationInput, startButton: startButton, errorContainer: errorContainer, sessionDeps: sessionDeps, setTerminal: setTerminal, setSelectedLocation: setSelectedLocation, awsRegionNames: awsRegionNames, frameAccountConfigs: frameAccountConfigs } = deps;
    const latencyResults = [];
    // ping each region and push the results to latencyResults array
    Object.entries(awsRegionNames).forEach(([, value])=>{
        const promise = (0, $fZ4oz.default)(value);
        if (promise) latencyResults.push(promise);
    });
    const results = await Promise.all(latencyResults);
    // sort the results by latency
    results.sort((a, b)=>a.latency - b.latency);
    // Build the set of region IDs that are actually present in the <select>.
    // This is the canonical authoritative set — regions in AwsRegionNames but absent
    // from the <select> (NORCAL / us-west-1) must not be auto-selected.
    const availableOptionValues = new Set(Array.from(selectedLocationInput.options).filter((opt)=>opt.value !== "" && !opt.disabled).map((opt)=>opt.value));
    const regionWithLowestLatency = $fd2663da44d16ed8$export$dde6bbf83f76d29d(results, availableOptionValues);
    if (!regionWithLowestLatency) {
        console.warn("startApp: no selectable regions available in <select>; skipping auto-selection");
        (0, $4V4G7.toggleStartButton)(startButton, true, "Launch");
        return;
    }
    const options = Array.from(selectedLocationInput.options);
    // update the labels with the latency
    options.forEach((option)=>{
        const regionInfo = results.find((r)=>r.id === option.value);
        if (regionInfo === undefined) return;
        if (regionWithLowestLatency.id === regionInfo.id) option.selected = true;
        option.label = `${option.dataset.name} (${regionInfo.latency} ms)`;
    });
    // start with the region with the lowest latency selected
    const selected = regionWithLowestLatency.id;
    setSelectedLocation(selected);
    (0, $js5ua.setSentryLocation)(options.find((option)=>option.value === selected));
    const account = (0, $ltXBQ.getEnumKeyByEnumValue)(awsRegionNames, selected);
    if (account && frameAccountConfigs[account]) await (0, $cqTsR.loadFrame)(frameAccountConfigs[account], token, sessionDeps, setTerminal);
    else {
        console.warn("Unknown region selected in startApp:", selected);
        errorContainer.innerText = "Unknown location selected. Please refresh and try again.";
        (0, $4V4G7.toggleStartButton)(startButton, true, "Launch");
    }
}
async function $fd2663da44d16ed8$export$65f22a49577e07ee(deps) {
    const { getTerminal: getTerminal, startButton: startButton, statusMessage: statusMessage, kwInput: kwInput, kwPasswordInput: kwPasswordInput, userNameInput: userNameInput, errorContainer: errorContainer, sessionDeps: sessionDeps, getSelectedLocation: getSelectedLocation, handleError: handleError, apiEndpoints: apiEndpoints, cookieNames: cookieNames, awsRegionNames: awsRegionNames, frameAccountConfigs: frameAccountConfigs } = deps;
    const terminal = getTerminal();
    if (!terminal) return;
    const session = await terminal.getOpenSession();
    const sessionState = session ? (0, $cqTsR.sessionStateString)(session) : undefined;
    if (session && sessionState === (0, $4DjaP.SessionState).OPEN) {
        await terminal.resume(session.id);
        (0, $4V4G7.toggleStartButton)(startButton, true, "Resuming...");
    } else if (session && sessionState === (0, $4DjaP.SessionState).CLOSING) {
        // Wait for session to close before starting a new one
        (0, $4V4G7.toggleStartButton)(startButton, false, "Waiting for session to close...");
        statusMessage.innerText = "Previous session is closing. Please wait...";
        const sessionClosed = await (0, $cqTsR.checkUntilClosed)(sessionDeps);
        if (sessionClosed) // Recursively call validateCredentials after session is closed
        await $fd2663da44d16ed8$export$65f22a49577e07ee(deps);
    } else try {
        const response = await (0, $3Kq1x.default).post(apiEndpoints.LOGIN, `pLogin=${kwInput.value}&pPwd=${kwPasswordInput.value}`);
        const ologin = response.data.APIResult;
        if (ologin === 1) {
            errorContainer.textContent = "";
            (0, $7dLK0.setCookie)(cookieNames.KWNUMBER, kwInput.value, 180);
            (0, $7dLK0.setCookie)(cookieNames.PASSWORD, kwPasswordInput.value, 180);
            (0, $7dLK0.setCookie)(cookieNames.USERNAME, userNameInput.value, 180);
            (0, $js5ua.setSentryUser)(kwInput, userNameInput);
            statusMessage.innerText = "Connection in progress";
            const selectedLocation = getSelectedLocation();
            const account = (0, $ltXBQ.getEnumKeyByEnumValue)(awsRegionNames, selectedLocation);
            if (account && frameAccountConfigs[account]) await (0, $cqTsR.startSession)(frameAccountConfigs[account].applicationId, sessionDeps);
            else {
                console.warn("Unknown region selected in validateCredentials:", selectedLocation);
                errorContainer.innerText = "Unknown location selected. Please refresh and try again.";
            }
        } else errorContainer.innerText = "Your KW number and/or password were not valid, were missing, or your company / agency required that we disable cloud access.";
    } catch (error) {
        handleError(error, "Error validating credentials");
    }
}
function $fd2663da44d16ed8$export$36aff1fbb4f5dfc6(config) {
    // The DOMContentLoaded handler is async; addEventListener ignores the returned
    // promise. The handler's async work (token fetch, launch) is internally
    // try/caught, but its synchronous prologue — the getRequiredElement lookups —
    // can still throw if a required element is missing, which would surface as an
    // unhandled rejection. Attach .catch so any fatal bootstrap failure is reported
    // to Sentry instead of vanishing.
    document.addEventListener("DOMContentLoaded", ()=>{
        onDomReady().catch($fd2663da44d16ed8$export$29c7871a87afb5ec);
    });
    async function onDomReady() {
        let terminal = null;
        let selectedLocation = "";
        const startButton = (0, $bpm9f.getRequiredElement)("btnlaunch");
        const clearButton = (0, $bpm9f.getRequiredElement)("btnClear");
        const statusMessage = (0, $bpm9f.getRequiredElement)("loginCheck");
        const kwInput = (0, $bpm9f.getRequiredElement)("kw_number");
        const kwPasswordInput = (0, $bpm9f.getRequiredElement)("kw_password");
        const userNameInput = (0, $bpm9f.getRequiredElement)("txt_username");
        const errorContainer = (0, $bpm9f.getRequiredElement)("LoginErrorMessage");
        const selectedLocationInput = (0, $bpm9f.getRequiredElement)("vmlocation");
        const loginForm = (0, $bpm9f.getRequiredElement)("loginForm");
        const loginFieldset = (0, $bpm9f.getRequiredElement)("loginFieldset");
        const browserAdvisory = (0, $bpm9f.getRequiredElement)("browserAdvisory");
        const copyrightYear = (0, $bpm9f.getRequiredElement)("copyrightYear");
        // The AWS notification banner is production-only markup. Gate its lookups
        // behind the config flag so the test site (which has no banner) never throws.
        let awsNotificationBanner = null;
        let awsNotificationCloseBtn = null;
        if (config.notificationBanner) {
            awsNotificationBanner = (0, $bpm9f.getRequiredElement)("aws-notification-banner");
            // Intentionally nullable: the close button is a parent-scoped, class-based
            // lookup guarded with `if (awsNotificationCloseBtn)`.
            awsNotificationCloseBtn = awsNotificationBanner.querySelector(".notification-banner__close");
        }
        const kwnumber = (0, $7dLK0.getCookie)(config.cookieNames.KWNUMBER);
        const userpass = (0, $7dLK0.getCookie)(config.cookieNames.PASSWORD);
        const username = (0, $7dLK0.getCookie)(config.cookieNames.USERNAME);
        /**
     * Handles errors by capturing them in Sentry and logging to the console.
     *
     * @param error - The error to handle.
     * @param message - Optional message to log with the error.
     * @returns void
     */ const handleError = (error, message = "An error occurred")=>{
            $gaxBK.captureException(error);
            console.warn(`ERROR: ${message}: ${String(error)}`);
        };
        if (kwnumber && userpass) {
            kwInput.value = kwnumber;
            kwPasswordInput.value = userpass;
            userNameInput.value = username ?? "";
            (0, $js5ua.setSentryUser)(kwInput, userNameInput);
        }
        // Prevent spaces from being used in the username field
        userNameInput.addEventListener("input", function() {
            this.value = this.value.replace(/\s+/g, "");
        });
        // Build dependencies object for session functions
        const sessionDeps = {
            startButton: startButton,
            statusMessage: statusMessage,
            loginFieldset: loginFieldset,
            kwInput: kwInput,
            kwPasswordInput: kwPasswordInput,
            userNameInput: userNameInput,
            terminal: null,
            serviceUrl: config.apiEndpoints.FRAME_GQL
        };
        const setTerminal = (newTerminal)=>{
            terminal = newTerminal;
            sessionDeps.terminal = newTerminal;
        };
        selectedLocationInput.addEventListener("change", (event)=>{
            (async ()=>{
                const target = event.target;
                selectedLocation = target.value;
                (0, $js5ua.setSentryLocation)(target.options[target.selectedIndex]);
                try {
                    const account = (0, $ltXBQ.getEnumKeyByEnumValue)(config.awsRegionNames, target.value);
                    if (account && config.frameAccountConfigs[account]) {
                        const token = await (0, $fN5b4.getToken)();
                        await (0, $cqTsR.loadFrame)(config.frameAccountConfigs[account], token, sessionDeps, setTerminal);
                    } else {
                        console.warn("Unknown region selected in change handler:", target.value);
                        errorContainer.innerText = "Unknown location selected. Please refresh and try again.";
                    }
                } catch (error) {
                    handleError(error, "Error changing location");
                }
            })();
        });
        // Validate form
        loginForm.addEventListener("submit", (event)=>{
            event.preventDefault();
            // check form validity
            if (!loginForm.checkValidity()) {
                console.warn("User did not fill out all required fields");
                loginForm.reportValidity();
                return;
            }
            $fd2663da44d16ed8$export$65f22a49577e07ee({
                getTerminal: ()=>terminal,
                startButton: startButton,
                statusMessage: statusMessage,
                kwInput: kwInput,
                kwPasswordInput: kwPasswordInput,
                userNameInput: userNameInput,
                errorContainer: errorContainer,
                sessionDeps: sessionDeps,
                getSelectedLocation: ()=>selectedLocation,
                handleError: handleError,
                apiEndpoints: config.apiEndpoints,
                cookieNames: config.cookieNames,
                awsRegionNames: config.awsRegionNames,
                frameAccountConfigs: config.frameAccountConfigs
            });
        });
        // Clear browser cookies and local storage
        clearButton.addEventListener("click", ()=>{
            try {
                (0, $7dLK0.clearCookie)(config.cookieNames.KWNUMBER);
                (0, $7dLK0.clearCookie)(config.cookieNames.PASSWORD);
                (0, $7dLK0.clearCookie)(config.cookieNames.USERNAME);
                (0, $ltXBQ.clearLocalStorage)();
                statusMessage.innerText = "Login information cleared";
                loginForm.reset();
            } catch (error) {
                handleError(error, "Error clearing cookies");
                errorContainer.innerText = "Error clearing login. Please reload the page and try again.";
            }
        });
        // Production-only notification banner wiring. The discriminated AppConfig
        // guarantees notices + storageKeys are present whenever notificationBanner is
        // true, so no extra presence checks are needed beyond the nullable close button.
        if (config.notificationBanner && awsNotificationBanner) {
            const banner = awsNotificationBanner;
            const { NOTIFICATION_DISMISSED: NOTIFICATION_DISMISSED } = config.storageKeys;
            if (awsNotificationCloseBtn) awsNotificationCloseBtn.addEventListener("click", ()=>{
                (0, $jaYVW.hideAwsNotification)(banner);
                // Store in localStorage that the user has dismissed this notification
                localStorage.setItem(NOTIFICATION_DISMISSED, "true");
            });
            (0, $jaYVW.showNotices)(config.notices, banner);
        }
        (0, $4V4G7.updateYear)(copyrightYear);
        $fd2663da44d16ed8$export$9250fabcd0c6426c(browserAdvisory, startButton, config.browserAdvisoryMessage);
        let frameToken = null;
        try {
            frameToken = await (0, $fN5b4.getToken)();
        } catch (error) {
            handleError(error, "Error getting token");
        }
        if (!frameToken) {
            errorContainer.textContent = "We're having trouble connecting to the cloud platform. Please reload the page and try again. If the problem persists, please contact support.";
            return;
        }
        try {
            await $fd2663da44d16ed8$export$e820db9e9e2fc09b(frameToken, {
                selectedLocationInput: selectedLocationInput,
                startButton: startButton,
                errorContainer: errorContainer,
                sessionDeps: sessionDeps,
                setTerminal: setTerminal,
                setSelectedLocation: (value)=>{
                    selectedLocation = value;
                },
                awsRegionNames: config.awsRegionNames,
                frameAccountConfigs: config.frameAccountConfigs
            });
        } catch (error) {
            $fd2663da44d16ed8$export$29c7871a87afb5ec(error);
            console.warn("ERROR: Error starting app:", error);
            errorContainer.textContent = "We're having trouble starting a cloud session. Please reload the page and try again, or select a different location. If the problem persists, please contact support.";
        }
    }
}

});
parcelRegister("4DjaP", function(module, exports) {
/*! For license information please see api.js.LICENSE.txt */ !function(e, t) {
    module.exports = t();
}("undefined" != typeof self ? self : module.exports, ()=>(()=>{
        var e = {
            1673: (e, t, r)=>{
                "use strict";
                r.d(t, {
                    D: ()=>s
                });
                var n = Object.prototype, i = n.toString, o = n.hasOwnProperty, a = new Map;
                function s(e, t) {
                    try {
                        return u(e, t);
                    } finally{
                        a.clear();
                    }
                }
                function u(e, t) {
                    if (e === t) return !0;
                    var r = i.call(e);
                    if (r !== i.call(t)) return !1;
                    switch(r){
                        case "[object Array]":
                            if (e.length !== t.length) return !1;
                        case "[object Object]":
                            if (c(e, t)) return !0;
                            var n = Object.keys(e), a = Object.keys(t), s = n.length;
                            if (s !== a.length) return !1;
                            for(var l = 0; l < s; ++l)if (!o.call(t, n[l])) return !1;
                            for(l = 0; l < s; ++l){
                                var f = n[l];
                                if (!u(e[f], t[f])) return !1;
                            }
                            return !0;
                        case "[object Error]":
                            return e.name === t.name && e.message === t.message;
                        case "[object Number]":
                            if (e != e) return t != t;
                        case "[object Boolean]":
                        case "[object Date]":
                            return +e == +t;
                        case "[object RegExp]":
                        case "[object String]":
                            return e == "" + t;
                        case "[object Map]":
                        case "[object Set]":
                            if (e.size !== t.size) return !1;
                            if (c(e, t)) return !0;
                            for(var p = e.entries(), d = "[object Map]" === r;;){
                                var h = p.next();
                                if (h.done) break;
                                var v = h.value, m = v[0], y = v[1];
                                if (!t.has(m)) return !1;
                                if (d && !u(y, t.get(m))) return !1;
                            }
                            return !0;
                    }
                    return !1;
                }
                function c(e, t) {
                    var r = a.get(e);
                    if (r) {
                        if (r.has(t)) return !0;
                    } else a.set(e, r = new Set);
                    return r.add(t), !1;
                }
            },
            7298: (e, t, r)=>{
                "use strict";
                r.r(t), r.d(t, {
                    ApolloClient: ()=>A,
                    ApolloError: ()=>y,
                    ApolloLink: ()=>u.i0,
                    FetchType: ()=>m,
                    HeuristicFragmentMatcher: ()=>ve,
                    HttpLink: ()=>Xe,
                    InMemoryCache: ()=>Fe,
                    IntrospectionFragmentMatcher: ()=>me,
                    NetworkStatus: ()=>n,
                    ObjectCache: ()=>Oe,
                    Observable: ()=>u.y$,
                    ObservableQuery: ()=>g,
                    StoreReader: ()=>be,
                    StoreWriter: ()=>xe,
                    WriteError: ()=>Ie,
                    assertIdValue: ()=>we,
                    concat: ()=>u.zo,
                    createOperation: ()=>u.zi,
                    default: ()=>rt,
                    defaultDataIdFromObject: ()=>Me,
                    defaultNormalizedCacheFactory: ()=>Te,
                    empty: ()=>u.cS,
                    enhanceErrorWithDocument: ()=>Re,
                    execute: ()=>u.ht,
                    from: ()=>u.Dp,
                    fromError: ()=>u.Qc,
                    fromPromise: ()=>u.p4,
                    getOperationName: ()=>u.rY,
                    gql: ()=>Ze.default,
                    isApolloError: ()=>v,
                    makePromise: ()=>u.$y,
                    split: ()=>u.Vl,
                    toPromise: ()=>u.Vi
                });
                var n, i = r(5949), o = r(52), a = r(1673), s = r(674), u = r(4907), c = r(1603), l = r(8754), f = r(7525);
                function p(e) {
                    return e < 7;
                }
                !function(e) {
                    e[e.loading = 1] = "loading", e[e.setVariables = 2] = "setVariables", e[e.fetchMore = 3] = "fetchMore", e[e.refetch = 4] = "refetch", e[e.poll = 6] = "poll", e[e.ready = 7] = "ready", e[e.error = 8] = "error";
                }(n || (n = {}));
                var d = function(e) {
                    function t() {
                        return null !== e && e.apply(this, arguments) || this;
                    }
                    return (0, i.ZT)(t, e), t.prototype[c.Z] = function() {
                        return this;
                    }, t.prototype["@@observable"] = function() {
                        return this;
                    }, t;
                }(s.Z);
                function h(e) {
                    return Array.isArray(e) && e.length > 0;
                }
                function v(e) {
                    return e.hasOwnProperty("graphQLErrors");
                }
                var m, y = function(e) {
                    function t(r) {
                        var n, i, o = r.graphQLErrors, a = r.networkError, s = r.errorMessage, u = r.extraInfo, c = e.call(this, s) || this;
                        return c.graphQLErrors = o || [], c.networkError = a || null, c.message = s || (i = "", h((n = c).graphQLErrors) && n.graphQLErrors.forEach(function(e) {
                            i += "GraphQL error: " + (e ? e.message : "Error message not found.") + "\n";
                        }), n.networkError && (i += "Network error: " + n.networkError.message + "\n"), i = i.replace(/\n$/, "")), c.extraInfo = u, c.__proto__ = t.prototype, c;
                    }
                    return (0, i.ZT)(t, e), t;
                }(Error);
                !function(e) {
                    e[e.normal = 1] = "normal", e[e.refetch = 2] = "refetch", e[e.poll = 3] = "poll";
                }(m || (m = {}));
                var g = function(e) {
                    function t(t) {
                        var r = t.queryManager, n = t.options, i = t.shouldSubscribe, a = void 0 === i || i, s = e.call(this, function(e) {
                            return s.onSubscribe(e);
                        }) || this;
                        s.observers = new Set, s.subscriptions = new Set, s.isTornDown = !1, s.options = n, s.variables = n.variables || {}, s.queryId = r.generateQueryId(), s.shouldSubscribe = a;
                        var u = (0, o.$H)(n.query);
                        return s.queryName = u && u.name && u.name.value, s.queryManager = r, s;
                    }
                    return (0, i.ZT)(t, e), t.prototype.result = function() {
                        var e = this;
                        return new Promise(function(t, r) {
                            var n = {
                                next: function(r) {
                                    t(r), e.observers.delete(n), e.observers.size || e.queryManager.removeQuery(e.queryId), setTimeout(function() {
                                        i.unsubscribe();
                                    }, 0);
                                },
                                error: r
                            }, i = e.subscribe(n);
                        });
                    }, t.prototype.currentResult = function() {
                        var e = this.getCurrentResult();
                        return void 0 === e.data && (e.data = {}), e;
                    }, t.prototype.getCurrentResult = function() {
                        if (this.isTornDown) {
                            var e = this.lastResult;
                            return {
                                data: !this.lastError && e && e.data || void 0,
                                error: this.lastError,
                                loading: !1,
                                networkStatus: n.error
                            };
                        }
                        var t, r, o, a = this.queryManager.getCurrentQueryResult(this), s = a.data, u = a.partial, c = this.queryManager.queryStore.get(this.queryId), l = this.options.fetchPolicy, f = "network-only" === l || "no-cache" === l;
                        if (c) {
                            var d = c.networkStatus;
                            if (void 0 === (o = this.options.errorPolicy) && (o = "none"), (r = c) && (r.networkError || "none" === o && h(r.graphQLErrors))) return {
                                data: void 0,
                                loading: !1,
                                networkStatus: d,
                                error: new y({
                                    graphQLErrors: c.graphQLErrors,
                                    networkError: c.networkError
                                })
                            };
                            c.variables && (this.options.variables = (0, i.pi)((0, i.pi)({}, this.options.variables), c.variables), this.variables = this.options.variables), t = {
                                data: s,
                                loading: p(d),
                                networkStatus: d
                            }, c.graphQLErrors && "all" === this.options.errorPolicy && (t.errors = c.graphQLErrors);
                        } else {
                            var v = f || u && "cache-only" !== l;
                            t = {
                                data: s,
                                loading: v,
                                networkStatus: v ? n.loading : n.ready
                            };
                        }
                        return u || this.updateLastResult((0, i.pi)((0, i.pi)({}, t), {
                            stale: !1
                        })), (0, i.pi)((0, i.pi)({}, t), {
                            partial: u
                        });
                    }, t.prototype.isDifferentFromLastResult = function(e) {
                        var t = this.lastResultSnapshot;
                        return !(t && e && t.networkStatus === e.networkStatus && t.stale === e.stale && (0, a.D)(t.data, e.data));
                    }, t.prototype.getLastResult = function() {
                        return this.lastResult;
                    }, t.prototype.getLastError = function() {
                        return this.lastError;
                    }, t.prototype.resetLastResults = function() {
                        delete this.lastResult, delete this.lastResultSnapshot, delete this.lastError, this.isTornDown = !1;
                    }, t.prototype.resetQueryStoreErrors = function() {
                        var e = this.queryManager.queryStore.get(this.queryId);
                        e && (e.networkError = null, e.graphQLErrors = []);
                    }, t.prototype.refetch = function(e) {
                        var t = this.options.fetchPolicy;
                        return "cache-only" === t ? Promise.reject(new l.ej(1)) : ("no-cache" !== t && "cache-and-network" !== t && (t = "network-only"), (0, a.D)(this.variables, e) || (this.variables = (0, i.pi)((0, i.pi)({}, this.variables), e)), (0, a.D)(this.options.variables, this.variables) || (this.options.variables = (0, i.pi)((0, i.pi)({}, this.options.variables), this.variables)), this.queryManager.fetchQuery(this.queryId, (0, i.pi)((0, i.pi)({}, this.options), {
                            fetchPolicy: t
                        }), m.refetch));
                    }, t.prototype.fetchMore = function(e) {
                        var t = this;
                        (0, l.kG)(e.updateQuery, 2);
                        var r = (0, i.pi)((0, i.pi)({}, e.query ? e : (0, i.pi)((0, i.pi)((0, i.pi)({}, this.options), e), {
                            variables: (0, i.pi)((0, i.pi)({}, this.variables), e.variables)
                        })), {
                            fetchPolicy: "network-only"
                        }), n = this.queryManager.generateQueryId();
                        return this.queryManager.fetchQuery(n, r, m.normal, this.queryId).then(function(i) {
                            return t.updateQuery(function(t) {
                                return e.updateQuery(t, {
                                    fetchMoreResult: i.data,
                                    variables: r.variables
                                });
                            }), t.queryManager.stopQuery(n), i;
                        }, function(e) {
                            throw t.queryManager.stopQuery(n), e;
                        });
                    }, t.prototype.subscribeToMore = function(e) {
                        var t = this, r = this.queryManager.startGraphQLSubscription({
                            query: e.document,
                            variables: e.variables
                        }).subscribe({
                            next: function(r) {
                                var n = e.updateQuery;
                                n && t.updateQuery(function(e, t) {
                                    return n(e, {
                                        subscriptionData: r,
                                        variables: t.variables
                                    });
                                });
                            },
                            error: function(t) {
                                e.onError && e.onError(t);
                            }
                        });
                        return this.subscriptions.add(r), function() {
                            t.subscriptions.delete(r) && r.unsubscribe();
                        };
                    }, t.prototype.setOptions = function(e) {
                        var t = this.options.fetchPolicy;
                        this.options = (0, i.pi)((0, i.pi)({}, this.options), e), e.pollInterval ? this.startPolling(e.pollInterval) : 0 === e.pollInterval && this.stopPolling();
                        var r = e.fetchPolicy;
                        return this.setVariables(this.options.variables, t !== r && ("cache-only" === t || "standby" === t || "network-only" === r), e.fetchResults);
                    }, t.prototype.setVariables = function(e, t, r) {
                        return void 0 === t && (t = !1), void 0 === r && (r = !0), this.isTornDown = !1, e = e || this.variables, !t && (0, a.D)(e, this.variables) ? this.observers.size && r ? this.result() : Promise.resolve() : (this.variables = this.options.variables = e, this.observers.size ? this.queryManager.fetchQuery(this.queryId, this.options) : Promise.resolve());
                    }, t.prototype.updateQuery = function(e) {
                        var t = this.queryManager, r = t.getQueryWithPreviousResult(this.queryId), n = r.previousResult, i = r.variables, a = r.document, s = (0, o.XY)(function() {
                            return e(n, {
                                variables: i
                            });
                        });
                        s && (t.dataStore.markUpdateQueryResult(a, i, s), t.broadcastQueries());
                    }, t.prototype.stopPolling = function() {
                        this.queryManager.stopPollingQuery(this.queryId), this.options.pollInterval = void 0;
                    }, t.prototype.startPolling = function(e) {
                        S(this), this.options.pollInterval = e, this.queryManager.startPollingQuery(this.options, this.queryId);
                    }, t.prototype.updateLastResult = function(e) {
                        var t = this.lastResult;
                        return this.lastResult = e, this.lastResultSnapshot = this.queryManager.assumeImmutableResults ? e : (0, o.Xh)(e), t;
                    }, t.prototype.onSubscribe = function(e) {
                        var t = this;
                        try {
                            var r = e._subscription._observer;
                            r && !r.error && (r.error = E);
                        } catch (e) {}
                        var n = !this.observers.size;
                        return this.observers.add(e), e.next && this.lastResult && e.next(this.lastResult), e.error && this.lastError && e.error(this.lastError), n && this.setUpQuery(), function() {
                            t.observers.delete(e) && !t.observers.size && t.tearDownQuery();
                        };
                    }, t.prototype.setUpQuery = function() {
                        var e = this, t = this.queryManager, r = this.queryId;
                        this.shouldSubscribe && t.addObservableQuery(r, this), this.options.pollInterval && (S(this), t.startPollingQuery(this.options, r));
                        var o = function(t) {
                            e.updateLastResult((0, i.pi)((0, i.pi)({}, e.lastResult), {
                                errors: t.graphQLErrors,
                                networkStatus: n.error,
                                loading: !1
                            })), b(e.observers, "error", e.lastError = t);
                        };
                        t.observeQuery(r, this.options, {
                            next: function(r) {
                                if (e.lastError || e.isDifferentFromLastResult(r)) {
                                    var n = e.updateLastResult(r), i = e.options, o = i.query, s = i.variables, u = i.fetchPolicy;
                                    t.transform(o).hasClientExports ? t.getLocalState().addExportedVariables(o, s).then(function(i) {
                                        var s = e.variables;
                                        e.variables = e.options.variables = i, !r.loading && n && "cache-only" !== u && t.transform(o).serverQuery && !(0, a.D)(s, i) ? e.refetch() : b(e.observers, "next", r);
                                    }) : b(e.observers, "next", r);
                                }
                            },
                            error: o
                        }).catch(o);
                    }, t.prototype.tearDownQuery = function() {
                        var e = this.queryManager;
                        this.isTornDown = !0, e.stopPollingQuery(this.queryId), this.subscriptions.forEach(function(e) {
                            return e.unsubscribe();
                        }), this.subscriptions.clear(), e.removeObservableQuery(this.queryId), e.stopQuery(this.queryId), this.observers.clear();
                    }, t;
                }(d);
                function E(e) {}
                function b(e, t, r) {
                    var n = [];
                    e.forEach(function(e) {
                        return e[t] && n.push(e);
                    }), n.forEach(function(e) {
                        return e[t](r);
                    });
                }
                function S(e) {
                    var t = e.options.fetchPolicy;
                    (0, l.kG)("cache-first" !== t && "cache-only" !== t, 3);
                }
                var _ = function() {
                    function e() {
                        this.store = {};
                    }
                    return e.prototype.getStore = function() {
                        return this.store;
                    }, e.prototype.get = function(e) {
                        return this.store[e];
                    }, e.prototype.initMutation = function(e, t, r) {
                        this.store[e] = {
                            mutation: t,
                            variables: r || {},
                            loading: !0,
                            error: null
                        };
                    }, e.prototype.markMutationError = function(e, t) {
                        var r = this.store[e];
                        r && (r.loading = !1, r.error = t);
                    }, e.prototype.markMutationResult = function(e) {
                        var t = this.store[e];
                        t && (t.loading = !1, t.error = null);
                    }, e.prototype.reset = function() {
                        this.store = {};
                    }, e;
                }(), w = function() {
                    function e() {
                        this.store = {};
                    }
                    return e.prototype.getStore = function() {
                        return this.store;
                    }, e.prototype.get = function(e) {
                        return this.store[e];
                    }, e.prototype.initQuery = function(e) {
                        var t = this.store[e.queryId];
                        (0, l.kG)(!t || t.document === e.document || (0, a.D)(t.document, e.document), 19);
                        var r = !1, i = null;
                        e.storePreviousVariables && t && t.networkStatus !== n.loading && ((0, a.D)(t.variables, e.variables) || (r = !0, i = t.variables));
                        var o = [];
                        t && t.graphQLErrors && (o = t.graphQLErrors), this.store[e.queryId] = {
                            document: e.document,
                            variables: e.variables,
                            previousVariables: i,
                            networkError: null,
                            graphQLErrors: o,
                            networkStatus: r ? n.setVariables : e.isPoll ? n.poll : e.isRefetch ? n.refetch : n.loading,
                            metadata: e.metadata
                        }, "string" == typeof e.fetchMoreForQueryId && this.store[e.fetchMoreForQueryId] && (this.store[e.fetchMoreForQueryId].networkStatus = n.fetchMore);
                    }, e.prototype.markQueryResult = function(e, t, r) {
                        this.store && this.store[e] && (this.store[e].networkError = null, this.store[e].graphQLErrors = h(t.errors) ? t.errors : [], this.store[e].previousVariables = null, this.store[e].networkStatus = n.ready, "string" == typeof r && this.store[r] && (this.store[r].networkStatus = n.ready));
                    }, e.prototype.markQueryError = function(e, t, r) {
                        this.store && this.store[e] && (this.store[e].networkError = t, this.store[e].networkStatus = n.error, "string" == typeof r && this.markQueryResultClient(r, !0));
                    }, e.prototype.markQueryResultClient = function(e, t) {
                        var r = this.store && this.store[e];
                        r && (r.networkError = null, r.previousVariables = null, t && (r.networkStatus = n.ready));
                    }, e.prototype.stopQuery = function(e) {
                        delete this.store[e];
                    }, e.prototype.reset = function(e) {
                        var t = this;
                        Object.keys(this.store).forEach(function(r) {
                            e.indexOf(r) < 0 ? t.stopQuery(r) : t.store[r].networkStatus = n.loading;
                        });
                    }, e;
                }();
                var O = function() {
                    function e(e) {
                        var t = e.client, r = e.resolvers, n = e.fragmentMatcher;
                        this.cache = e.cache, t && (this.client = t), r && this.addResolvers(r), n && this.setFragmentMatcher(n);
                    }
                    return e.prototype.addResolvers = function(e) {
                        var t = this;
                        this.resolvers = this.resolvers || {}, Array.isArray(e) ? e.forEach(function(e) {
                            t.resolvers = (0, o.Ee)(t.resolvers, e);
                        }) : this.resolvers = (0, o.Ee)(this.resolvers, e);
                    }, e.prototype.setResolvers = function(e) {
                        this.resolvers = {}, this.addResolvers(e);
                    }, e.prototype.getResolvers = function() {
                        return this.resolvers || {};
                    }, e.prototype.runResolvers = function(e) {
                        var t = e.document, r = e.remoteResult, n = e.context, o = e.variables, a = e.onlyRunForcedResolvers, s = void 0 !== a && a;
                        return (0, i.mG)(this, void 0, void 0, function() {
                            return (0, i.Jh)(this, function(e) {
                                return t ? [
                                    2,
                                    this.resolveDocument(t, r.data, n, o, this.fragmentMatcher, s).then(function(e) {
                                        return (0, i.pi)((0, i.pi)({}, r), {
                                            data: e.result
                                        });
                                    })
                                ] : [
                                    2,
                                    r
                                ];
                            });
                        });
                    }, e.prototype.setFragmentMatcher = function(e) {
                        this.fragmentMatcher = e;
                    }, e.prototype.getFragmentMatcher = function() {
                        return this.fragmentMatcher;
                    }, e.prototype.clientQuery = function(e) {
                        return (0, o.FS)([
                            "client"
                        ], e) && this.resolvers ? e : null;
                    }, e.prototype.serverQuery = function(e) {
                        return this.resolvers ? (0, o.ob)(e) : e;
                    }, e.prototype.prepareContext = function(e) {
                        void 0 === e && (e = {});
                        var t = this.cache;
                        return (0, i.pi)((0, i.pi)({}, e), {
                            cache: t,
                            getCacheKey: function(e) {
                                if (t.config) return t.config.dataIdFromObject(e);
                                (0, l.kG)(!1, 6);
                            }
                        });
                    }, e.prototype.addExportedVariables = function(e, t, r) {
                        return void 0 === t && (t = {}), void 0 === r && (r = {}), (0, i.mG)(this, void 0, void 0, function() {
                            return (0, i.Jh)(this, function(n) {
                                return e ? [
                                    2,
                                    this.resolveDocument(e, this.buildRootValueFromCache(e, t) || {}, this.prepareContext(r), t).then(function(e) {
                                        return (0, i.pi)((0, i.pi)({}, t), e.exportedVariables);
                                    })
                                ] : [
                                    2,
                                    (0, i.pi)({}, t)
                                ];
                            });
                        });
                    }, e.prototype.shouldForceResolvers = function(e) {
                        var t = !1;
                        return (0, f.Vn)(e, {
                            Directive: {
                                enter: function(e) {
                                    if ("client" === e.name.value && e.arguments && (t = e.arguments.some(function(e) {
                                        return "always" === e.name.value && "BooleanValue" === e.value.kind && !0 === e.value.value;
                                    }))) return f.$_;
                                }
                            }
                        }), t;
                    }, e.prototype.buildRootValueFromCache = function(e, t) {
                        return this.cache.diff({
                            query: (0, o.aL)(e),
                            variables: t,
                            returnPartialData: !0,
                            optimistic: !1
                        }).result;
                    }, e.prototype.resolveDocument = function(e, t, r, n, a, s) {
                        return void 0 === r && (r = {}), void 0 === n && (n = {}), void 0 === a && (a = function() {
                            return !0;
                        }), void 0 === s && (s = !1), (0, i.mG)(this, void 0, void 0, function() {
                            var u, c, l, f, p, d, h, v, m;
                            return (0, i.Jh)(this, function(y) {
                                var g;
                                return u = (0, o.p$)(e), c = (0, o.kU)(e), l = (0, o.F)(c), p = (f = u.operation) ? (g = f).charAt(0).toUpperCase() + g.slice(1) : "Query", h = (d = this).cache, v = d.client, m = {
                                    fragmentMap: l,
                                    context: (0, i.pi)((0, i.pi)({}, r), {
                                        cache: h,
                                        client: v
                                    }),
                                    variables: n,
                                    fragmentMatcher: a,
                                    defaultOperationType: p,
                                    exportedVariables: {},
                                    onlyRunForcedResolvers: s
                                }, [
                                    2,
                                    this.resolveSelectionSet(u.selectionSet, t, m).then(function(e) {
                                        return {
                                            result: e,
                                            exportedVariables: m.exportedVariables
                                        };
                                    })
                                ];
                            });
                        });
                    }, e.prototype.resolveSelectionSet = function(e, t, r) {
                        return (0, i.mG)(this, void 0, void 0, function() {
                            var n, a, s, u, c, f = this;
                            return (0, i.Jh)(this, function(p) {
                                return n = r.fragmentMap, a = r.context, s = r.variables, u = [
                                    t
                                ], c = function(e) {
                                    return (0, i.mG)(f, void 0, void 0, function() {
                                        var c;
                                        return (0, i.Jh)(this, function(i) {
                                            return (0, o.LZ)(e, s) ? (0, o.My)(e) ? [
                                                2,
                                                this.resolveField(e, t, r).then(function(t) {
                                                    var r;
                                                    void 0 !== t && u.push(((r = {})[(0, o.u2)(e)] = t, r));
                                                })
                                            ] : ((0, o.Ao)(e) ? c = e : (0, l.kG)(c = n[e.name.value], 7), c && c.typeCondition && r.fragmentMatcher(t, c.typeCondition.name.value, a) ? [
                                                2,
                                                this.resolveSelectionSet(c.selectionSet, t, r).then(function(e) {
                                                    u.push(e);
                                                })
                                            ] : [
                                                2
                                            ]) : [
                                                2
                                            ];
                                        });
                                    });
                                }, [
                                    2,
                                    Promise.all(e.selections.map(c)).then(function() {
                                        return (0, o.bw)(u);
                                    })
                                ];
                            });
                        });
                    }, e.prototype.resolveField = function(e, t, r) {
                        return (0, i.mG)(this, void 0, void 0, function() {
                            var n, a, s, u, c, l, f, p, d, h = this;
                            return (0, i.Jh)(this, function(i) {
                                return n = r.variables, a = e.name.value, s = (0, o.u2)(e), u = a !== s, c = t[s] || t[a], l = Promise.resolve(c), r.onlyRunForcedResolvers && !this.shouldForceResolvers(e) || (f = t.__typename || r.defaultOperationType, (p = this.resolvers && this.resolvers[f]) && (d = p[u ? a : s]) && (l = Promise.resolve(d(t, (0, o.NC)(e, n), r.context, {
                                    field: e,
                                    fragmentMap: r.fragmentMap
                                })))), [
                                    2,
                                    l.then(function(t) {
                                        return void 0 === t && (t = c), e.directives && e.directives.forEach(function(e) {
                                            "export" === e.name.value && e.arguments && e.arguments.forEach(function(e) {
                                                "as" === e.name.value && "StringValue" === e.value.kind && (r.exportedVariables[e.value.value] = t);
                                            });
                                        }), e.selectionSet ? null == t ? t : Array.isArray(t) ? h.resolveSubSelectedArray(e, t, r) : e.selectionSet ? h.resolveSelectionSet(e.selectionSet, t, r) : void 0 : t;
                                    })
                                ];
                            });
                        });
                    }, e.prototype.resolveSubSelectedArray = function(e, t, r) {
                        var n = this;
                        return Promise.all(t.map(function(t) {
                            return null === t ? null : Array.isArray(t) ? n.resolveSubSelectedArray(e, t, r) : e.selectionSet ? n.resolveSelectionSet(e.selectionSet, t, r) : void 0;
                        }));
                    }, e;
                }();
                function T(e) {
                    var t = new Set, r = null;
                    return new d(function(n) {
                        return t.add(n), r = r || e.subscribe({
                            next: function(e) {
                                t.forEach(function(t) {
                                    return t.next && t.next(e);
                                });
                            },
                            error: function(e) {
                                t.forEach(function(t) {
                                    return t.error && t.error(e);
                                });
                            },
                            complete: function() {
                                t.forEach(function(e) {
                                    return e.complete && e.complete();
                                });
                            }
                        }), function() {
                            t.delete(n) && !t.size && r && (r.unsubscribe(), r = null);
                        };
                    });
                }
                var I = Object.prototype.hasOwnProperty, R = function() {
                    function e(e) {
                        var t = e.link, r = e.queryDeduplication, n = void 0 !== r && r, i = e.store, a = e.onBroadcast, s = void 0 === a ? function() {} : a, u = e.ssrMode, c = void 0 !== u && u, l = e.clientAwareness, f = void 0 === l ? {} : l, p = e.localState, d = e.assumeImmutableResults;
                        this.mutationStore = new _, this.queryStore = new w, this.clientAwareness = {}, this.idCounter = 1, this.queries = new Map, this.fetchQueryRejectFns = new Map, this.transformCache = new (o.mr ? WeakMap : Map), this.inFlightLinkObservables = new Map, this.pollingInfoByQueryId = new Map, this.link = t, this.queryDeduplication = n, this.dataStore = i, this.onBroadcast = s, this.clientAwareness = f, this.localState = p || new O({
                            cache: i.getCache()
                        }), this.ssrMode = c, this.assumeImmutableResults = !!d;
                    }
                    return e.prototype.stop = function() {
                        var e = this;
                        this.queries.forEach(function(t, r) {
                            e.stopQueryNoBroadcast(r);
                        }), this.fetchQueryRejectFns.forEach(function(e) {
                            e(new l.ej(8));
                        });
                    }, e.prototype.mutate = function(e) {
                        var t = e.mutation, r = e.variables, n = e.optimisticResponse, a = e.updateQueries, s = e.refetchQueries, u = void 0 === s ? [] : s, c = e.awaitRefetchQueries, f = void 0 !== c && c, p = e.update, d = e.errorPolicy, v = void 0 === d ? "none" : d, m = e.fetchPolicy, g = e.context, E = void 0 === g ? {} : g;
                        return (0, i.mG)(this, void 0, void 0, function() {
                            var e, s, c, d = this;
                            return (0, i.Jh)(this, function(g) {
                                switch(g.label){
                                    case 0:
                                        return (0, l.kG)(t, 9), (0, l.kG)(!m || "no-cache" === m, 10), e = this.generateQueryId(), t = this.transform(t).document, this.setQuery(e, function() {
                                            return {
                                                document: t
                                            };
                                        }), r = this.getVariables(t, r), this.transform(t).hasClientExports ? [
                                            4,
                                            this.localState.addExportedVariables(t, r, E)
                                        ] : [
                                            3,
                                            2
                                        ];
                                    case 1:
                                        r = g.sent(), g.label = 2;
                                    case 2:
                                        return s = function() {
                                            var e = {};
                                            return a && d.queries.forEach(function(t, r) {
                                                var n = t.observableQuery;
                                                if (n) {
                                                    var i = n.queryName;
                                                    i && I.call(a, i) && (e[r] = {
                                                        updater: a[i],
                                                        query: d.queryStore.get(r)
                                                    });
                                                }
                                            }), e;
                                        }, this.mutationStore.initMutation(e, t, r), this.dataStore.markMutationInit({
                                            mutationId: e,
                                            document: t,
                                            variables: r,
                                            updateQueries: s(),
                                            update: p,
                                            optimisticResponse: n
                                        }), this.broadcastQueries(), c = this, [
                                            2,
                                            new Promise(function(a, l) {
                                                var d, g;
                                                c.getObservableFromLink(t, (0, i.pi)((0, i.pi)({}, E), {
                                                    optimisticResponse: n
                                                }), r, !1).subscribe({
                                                    next: function(n) {
                                                        (0, o.d2)(n) && "none" === v ? g = new y({
                                                            graphQLErrors: n.errors
                                                        }) : (c.mutationStore.markMutationResult(e), "no-cache" !== m && c.dataStore.markMutationResult({
                                                            mutationId: e,
                                                            result: n,
                                                            document: t,
                                                            variables: r,
                                                            updateQueries: s(),
                                                            update: p
                                                        }), d = n);
                                                    },
                                                    error: function(t) {
                                                        c.mutationStore.markMutationError(e, t), c.dataStore.markMutationComplete({
                                                            mutationId: e,
                                                            optimisticResponse: n
                                                        }), c.broadcastQueries(), c.setQuery(e, function() {
                                                            return {
                                                                document: null
                                                            };
                                                        }), l(new y({
                                                            networkError: t
                                                        }));
                                                    },
                                                    complete: function() {
                                                        if (g && c.mutationStore.markMutationError(e, g), c.dataStore.markMutationComplete({
                                                            mutationId: e,
                                                            optimisticResponse: n
                                                        }), c.broadcastQueries(), g) l(g);
                                                        else {
                                                            "function" == typeof u && (u = u(d));
                                                            var t = [];
                                                            h(u) && u.forEach(function(e) {
                                                                if ("string" == typeof e) c.queries.forEach(function(r) {
                                                                    var n = r.observableQuery;
                                                                    n && n.queryName === e && t.push(n.refetch());
                                                                });
                                                                else {
                                                                    var r = {
                                                                        query: e.query,
                                                                        variables: e.variables,
                                                                        fetchPolicy: "network-only"
                                                                    };
                                                                    e.context && (r.context = e.context), t.push(c.query(r));
                                                                }
                                                            }), Promise.all(f ? t : []).then(function() {
                                                                c.setQuery(e, function() {
                                                                    return {
                                                                        document: null
                                                                    };
                                                                }), "ignore" === v && d && (0, o.d2)(d) && delete d.errors, a(d);
                                                            });
                                                        }
                                                    }
                                                });
                                            })
                                        ];
                                }
                            });
                        });
                    }, e.prototype.fetchQuery = function(e, t, r, n) {
                        return (0, i.mG)(this, void 0, void 0, function() {
                            var a, s, u, c, l, f, p, d, h, g, E, b, S, _, w, O, T = this;
                            return (0, i.Jh)(this, function(I) {
                                switch(I.label){
                                    case 0:
                                        return s = void 0 === (a = t.metadata) ? null : a, c = void 0 === (u = t.fetchPolicy) ? "cache-first" : u, f = void 0 === (l = t.context) ? {} : l, p = this.transform(t.query).document, d = this.getVariables(p, t.variables), this.transform(p).hasClientExports ? [
                                            4,
                                            this.localState.addExportedVariables(p, d, f)
                                        ] : [
                                            3,
                                            2
                                        ];
                                    case 1:
                                        d = I.sent(), I.label = 2;
                                    case 2:
                                        if (t = (0, i.pi)((0, i.pi)({}, t), {
                                            variables: d
                                        }), E = g = "network-only" === c || "no-cache" === c, g || (b = this.dataStore.getCache().diff({
                                            query: p,
                                            variables: d,
                                            returnPartialData: !0,
                                            optimistic: !1
                                        }), E = !b.complete || "cache-and-network" === c, h = b.result), S = E && "cache-only" !== c && "standby" !== c, (0, o.FS)([
                                            "live"
                                        ], p) && (S = !0), _ = this.idCounter++, w = "no-cache" !== c ? this.updateQueryWatch(e, p, t) : void 0, this.setQuery(e, function() {
                                            return {
                                                document: p,
                                                lastRequestId: _,
                                                invalidated: !0,
                                                cancel: w
                                            };
                                        }), this.invalidate(n), this.queryStore.initQuery({
                                            queryId: e,
                                            document: p,
                                            storePreviousVariables: S,
                                            variables: d,
                                            isPoll: r === m.poll,
                                            isRefetch: r === m.refetch,
                                            metadata: s,
                                            fetchMoreForQueryId: n
                                        }), this.broadcastQueries(), S) {
                                            if (O = this.fetchRequest({
                                                requestId: _,
                                                queryId: e,
                                                document: p,
                                                options: t,
                                                fetchMoreForQueryId: n
                                            }).catch(function(t) {
                                                throw v(t) ? t : (_ >= T.getQuery(e).lastRequestId && (T.queryStore.markQueryError(e, t, n), T.invalidate(e), T.invalidate(n), T.broadcastQueries()), new y({
                                                    networkError: t
                                                }));
                                            }), "cache-and-network" !== c) return [
                                                2,
                                                O
                                            ];
                                            O.catch(function() {});
                                        }
                                        return this.queryStore.markQueryResultClient(e, !S), this.invalidate(e), this.invalidate(n), this.transform(p).hasForcedResolvers ? [
                                            2,
                                            this.localState.runResolvers({
                                                document: p,
                                                remoteResult: {
                                                    data: h
                                                },
                                                context: f,
                                                variables: d,
                                                onlyRunForcedResolvers: !0
                                            }).then(function(r) {
                                                return T.markQueryResult(e, r, t, n), T.broadcastQueries(), r;
                                            })
                                        ] : (this.broadcastQueries(), [
                                            2,
                                            {
                                                data: h
                                            }
                                        ]);
                                }
                            });
                        });
                    }, e.prototype.markQueryResult = function(e, t, r, n) {
                        var i = r.variables, o = r.errorPolicy;
                        "no-cache" === r.fetchPolicy ? this.setQuery(e, function() {
                            return {
                                newData: {
                                    result: t.data,
                                    complete: !0
                                }
                            };
                        }) : this.dataStore.markQueryResult(t, this.getQuery(e).document, i, n, "ignore" === o || "all" === o);
                    }, e.prototype.queryListenerForObserver = function(e, t, r) {
                        var n = this;
                        function i(e, t) {
                            if (r[e]) try {
                                r[e](t);
                            } catch (e) {}
                        }
                        return function(r, o) {
                            if (n.invalidate(e, !1), r) {
                                var a = n.getQuery(e), s = a.observableQuery, u = a.document, c = s ? s.options.fetchPolicy : t.fetchPolicy;
                                if ("standby" !== c) {
                                    var l = p(r.networkStatus), f = s && s.getLastResult();
                                    if (!l || t.returnPartialData || !o && r.previousVariables || !(!f || f.networkStatus === r.networkStatus) && t.notifyOnNetworkStatusChange || "cache-only" === c || "cache-and-network" === c) {
                                        var d = h(r.graphQLErrors), v = s && s.options.errorPolicy || t.errorPolicy || "none";
                                        if ("none" === v && d || r.networkError) return i("error", new y({
                                            graphQLErrors: r.graphQLErrors,
                                            networkError: r.networkError
                                        }));
                                        try {
                                            var m = void 0, g = void 0;
                                            if (o) "no-cache" !== c && "network-only" !== c && n.setQuery(e, function() {
                                                return {
                                                    newData: null
                                                };
                                            }), m = o.result, g = !o.complete;
                                            else {
                                                var E = s && s.getLastError();
                                                if (f && f.data && !("none" !== v && (E && E.graphQLErrors) !== r.graphQLErrors)) m = f.data, g = !1;
                                                else {
                                                    var b = n.dataStore.getCache().diff({
                                                        query: u,
                                                        variables: r.previousVariables || r.variables,
                                                        returnPartialData: !0,
                                                        optimistic: !0
                                                    });
                                                    m = b.result, g = !b.complete;
                                                }
                                            }
                                            var S = g && !(t.returnPartialData || "cache-only" === c), _ = {
                                                data: S ? f && f.data : m,
                                                loading: l,
                                                networkStatus: r.networkStatus,
                                                stale: S
                                            };
                                            "all" === v && d && (_.errors = r.graphQLErrors), i("next", _);
                                        } catch (e) {
                                            i("error", new y({
                                                networkError: e
                                            }));
                                        }
                                    }
                                }
                            }
                        };
                    }, e.prototype.transform = function(e) {
                        var t = this.transformCache;
                        if (!t.has(e)) {
                            var r = this.dataStore.getCache(), n = r.transformDocument(e), i = (0, o.Fo)(r.transformForLink(n)), a = this.localState.clientQuery(n), s = this.localState.serverQuery(i), u = {
                                document: n,
                                hasClientExports: (0, o.mj)(n),
                                hasForcedResolvers: this.localState.shouldForceResolvers(n),
                                clientQuery: a,
                                serverQuery: s,
                                defaultVars: (0, o.O4)((0, o.$H)(n))
                            }, c = function(e) {
                                e && !t.has(e) && t.set(e, u);
                            };
                            c(e), c(n), c(a), c(s);
                        }
                        return t.get(e);
                    }, e.prototype.getVariables = function(e, t) {
                        return (0, i.pi)((0, i.pi)({}, this.transform(e).defaultVars), t);
                    }, e.prototype.watchQuery = function(e, t) {
                        void 0 === t && (t = !0), (0, l.kG)("standby" !== e.fetchPolicy, 11), e.variables = this.getVariables(e.query, e.variables), void 0 === e.notifyOnNetworkStatusChange && (e.notifyOnNetworkStatusChange = !1);
                        var r = (0, i.pi)({}, e);
                        return new g({
                            queryManager: this,
                            options: r,
                            shouldSubscribe: t
                        });
                    }, e.prototype.query = function(e) {
                        var t = this;
                        return (0, l.kG)(e.query, 12), (0, l.kG)("Document" === e.query.kind, 13), (0, l.kG)(!e.returnPartialData, 14), (0, l.kG)(!e.pollInterval, 15), new Promise(function(r, n) {
                            var i = t.watchQuery(e, !1);
                            t.fetchQueryRejectFns.set("query:" + i.queryId, n), i.result().then(r, n).then(function() {
                                return t.fetchQueryRejectFns.delete("query:" + i.queryId);
                            });
                        });
                    }, e.prototype.generateQueryId = function() {
                        return String(this.idCounter++);
                    }, e.prototype.stopQueryInStore = function(e) {
                        this.stopQueryInStoreNoBroadcast(e), this.broadcastQueries();
                    }, e.prototype.stopQueryInStoreNoBroadcast = function(e) {
                        this.stopPollingQuery(e), this.queryStore.stopQuery(e), this.invalidate(e);
                    }, e.prototype.addQueryListener = function(e, t) {
                        this.setQuery(e, function(e) {
                            return e.listeners.add(t), {
                                invalidated: !1
                            };
                        });
                    }, e.prototype.updateQueryWatch = function(e, t, r) {
                        var n = this, i = this.getQuery(e).cancel;
                        i && i();
                        return this.dataStore.getCache().watch({
                            query: t,
                            variables: r.variables,
                            optimistic: !0,
                            previousResult: function() {
                                var t = null, r = n.getQuery(e).observableQuery;
                                if (r) {
                                    var i = r.getLastResult();
                                    i && (t = i.data);
                                }
                                return t;
                            },
                            callback: function(t) {
                                n.setQuery(e, function() {
                                    return {
                                        invalidated: !0,
                                        newData: t
                                    };
                                });
                            }
                        });
                    }, e.prototype.addObservableQuery = function(e, t) {
                        this.setQuery(e, function() {
                            return {
                                observableQuery: t
                            };
                        });
                    }, e.prototype.removeObservableQuery = function(e) {
                        var t = this.getQuery(e).cancel;
                        this.setQuery(e, function() {
                            return {
                                observableQuery: null
                            };
                        }), t && t();
                    }, e.prototype.clearStore = function() {
                        this.fetchQueryRejectFns.forEach(function(e) {
                            e(new l.ej(16));
                        });
                        var e = [];
                        return this.queries.forEach(function(t, r) {
                            t.observableQuery && e.push(r);
                        }), this.queryStore.reset(e), this.mutationStore.reset(), this.dataStore.reset();
                    }, e.prototype.resetStore = function() {
                        var e = this;
                        return this.clearStore().then(function() {
                            return e.reFetchObservableQueries();
                        });
                    }, e.prototype.reFetchObservableQueries = function(e) {
                        var t = this;
                        void 0 === e && (e = !1);
                        var r = [];
                        return this.queries.forEach(function(n, i) {
                            var o = n.observableQuery;
                            if (o) {
                                var a = o.options.fetchPolicy;
                                o.resetLastResults(), "cache-only" === a || !e && "standby" === a || r.push(o.refetch()), t.setQuery(i, function() {
                                    return {
                                        newData: null
                                    };
                                }), t.invalidate(i);
                            }
                        }), this.broadcastQueries(), Promise.all(r);
                    }, e.prototype.observeQuery = function(e, t, r) {
                        return this.addQueryListener(e, this.queryListenerForObserver(e, t, r)), this.fetchQuery(e, t);
                    }, e.prototype.startQuery = function(e, t, r) {
                        return this.addQueryListener(e, r), this.fetchQuery(e, t).catch(function() {}), e;
                    }, e.prototype.startGraphQLSubscription = function(e) {
                        var t = this, r = e.query, n = e.fetchPolicy, i = e.variables;
                        r = this.transform(r).document, i = this.getVariables(r, i);
                        var a = function(e) {
                            return t.getObservableFromLink(r, {}, e, !1).map(function(i) {
                                if (n && "no-cache" === n || (t.dataStore.markSubscriptionResult(i, r, e), t.broadcastQueries()), (0, o.d2)(i)) throw new y({
                                    graphQLErrors: i.errors
                                });
                                return i;
                            });
                        };
                        if (this.transform(r).hasClientExports) {
                            var s = this.localState.addExportedVariables(r, i).then(a);
                            return new d(function(e) {
                                var t = null;
                                return s.then(function(r) {
                                    return t = r.subscribe(e);
                                }, e.error), function() {
                                    return t && t.unsubscribe();
                                };
                            });
                        }
                        return a(i);
                    }, e.prototype.stopQuery = function(e) {
                        this.stopQueryNoBroadcast(e), this.broadcastQueries();
                    }, e.prototype.stopQueryNoBroadcast = function(e) {
                        this.stopQueryInStoreNoBroadcast(e), this.removeQuery(e);
                    }, e.prototype.removeQuery = function(e) {
                        this.fetchQueryRejectFns.delete("query:" + e), this.fetchQueryRejectFns.delete("fetchRequest:" + e), this.getQuery(e).subscriptions.forEach(function(e) {
                            return e.unsubscribe();
                        }), this.queries.delete(e);
                    }, e.prototype.getCurrentQueryResult = function(e, t) {
                        void 0 === t && (t = !0);
                        var r = e.options, n = r.variables, i = r.query, o = r.fetchPolicy, a = r.returnPartialData, s = e.getLastResult(), u = this.getQuery(e.queryId).newData;
                        if (u && u.complete) return {
                            data: u.result,
                            partial: !1
                        };
                        if ("no-cache" === o || "network-only" === o) return {
                            data: void 0,
                            partial: !1
                        };
                        var c = this.dataStore.getCache().diff({
                            query: i,
                            variables: n,
                            previousResult: s ? s.data : void 0,
                            returnPartialData: !0,
                            optimistic: t
                        }), l = c.complete;
                        return {
                            data: l || a ? c.result : void 0,
                            partial: !l
                        };
                    }, e.prototype.getQueryWithPreviousResult = function(e) {
                        var t;
                        if ("string" == typeof e) {
                            var r = this.getQuery(e).observableQuery;
                            (0, l.kG)(r, 17), t = r;
                        } else t = e;
                        var n = t.options, i = n.variables, o = n.query;
                        return {
                            previousResult: this.getCurrentQueryResult(t, !1).data,
                            variables: i,
                            document: o
                        };
                    }, e.prototype.broadcastQueries = function() {
                        var e = this;
                        this.onBroadcast(), this.queries.forEach(function(t, r) {
                            t.invalidated && t.listeners.forEach(function(n) {
                                n && n(e.queryStore.get(r), t.newData);
                            });
                        });
                    }, e.prototype.getLocalState = function() {
                        return this.localState;
                    }, e.prototype.getObservableFromLink = function(e, t, r, n) {
                        var a, s = this;
                        void 0 === n && (n = this.queryDeduplication);
                        var c = this.transform(e).serverQuery;
                        if (c) {
                            var l = this.inFlightLinkObservables, f = this.link, p = {
                                query: c,
                                variables: r,
                                operationName: (0, o.rY)(c) || void 0,
                                context: this.prepareContext((0, i.pi)((0, i.pi)({}, t), {
                                    forceFetch: !n
                                }))
                            };
                            if (t = p.context, n) {
                                var h = l.get(c) || new Map;
                                l.set(c, h);
                                var v = JSON.stringify(r);
                                if (!(a = h.get(v))) {
                                    h.set(v, a = T((0, u.ht)(f, p)));
                                    var m = function() {
                                        h.delete(v), h.size || l.delete(c), y.unsubscribe();
                                    }, y = a.subscribe({
                                        next: m,
                                        error: m,
                                        complete: m
                                    });
                                }
                            } else a = T((0, u.ht)(f, p));
                        } else a = d.of({
                            data: {}
                        }), t = this.prepareContext(t);
                        var g = this.transform(e).clientQuery;
                        return g && (a = function(e, t) {
                            return new d(function(r) {
                                var n = r.next, i = r.error, o = r.complete, a = 0, s = !1, u = {
                                    next: function(e) {
                                        ++a, new Promise(function(r) {
                                            r(t(e));
                                        }).then(function(e) {
                                            --a, n && n.call(r, e), s && u.complete();
                                        }, function(e) {
                                            --a, i && i.call(r, e);
                                        });
                                    },
                                    error: function(e) {
                                        i && i.call(r, e);
                                    },
                                    complete: function() {
                                        s = !0, a || o && o.call(r);
                                    }
                                }, c = e.subscribe(u);
                                return function() {
                                    return c.unsubscribe();
                                };
                            });
                        }(a, function(e) {
                            return s.localState.runResolvers({
                                document: g,
                                remoteResult: e,
                                context: t,
                                variables: r
                            });
                        })), a;
                    }, e.prototype.fetchRequest = function(e) {
                        var t, r, i = this, o = e.requestId, a = e.queryId, s = e.document, u = e.options, c = e.fetchMoreForQueryId, l = u.variables, f = u.errorPolicy, p = void 0 === f ? "none" : f, d = u.fetchPolicy;
                        return new Promise(function(e, f) {
                            var v = i.getObservableFromLink(s, u.context, l), m = "fetchRequest:" + a;
                            i.fetchQueryRejectFns.set(m, f);
                            var g = function() {
                                i.fetchQueryRejectFns.delete(m), i.setQuery(a, function(e) {
                                    e.subscriptions.delete(E);
                                });
                            }, E = v.map(function(e) {
                                if (o >= i.getQuery(a).lastRequestId && (i.markQueryResult(a, e, u, c), i.queryStore.markQueryResult(a, e, c), i.invalidate(a), i.invalidate(c), i.broadcastQueries()), "none" === p && h(e.errors)) return f(new y({
                                    graphQLErrors: e.errors
                                }));
                                if ("all" === p && (r = e.errors), c || "no-cache" === d) t = e.data;
                                else {
                                    var n = i.dataStore.getCache().diff({
                                        variables: l,
                                        query: s,
                                        optimistic: !1,
                                        returnPartialData: !0
                                    });
                                    (n.complete || u.returnPartialData) && (t = n.result);
                                }
                            }).subscribe({
                                error: function(e) {
                                    g(), f(e);
                                },
                                complete: function() {
                                    g(), e({
                                        data: t,
                                        errors: r,
                                        loading: !1,
                                        networkStatus: n.ready,
                                        stale: !1
                                    });
                                }
                            });
                            i.setQuery(a, function(e) {
                                e.subscriptions.add(E);
                            });
                        });
                    }, e.prototype.getQuery = function(e) {
                        return this.queries.get(e) || {
                            listeners: new Set,
                            invalidated: !1,
                            document: null,
                            newData: null,
                            lastRequestId: 1,
                            observableQuery: null,
                            subscriptions: new Set
                        };
                    }, e.prototype.setQuery = function(e, t) {
                        var r = this.getQuery(e), n = (0, i.pi)((0, i.pi)({}, r), t(r));
                        this.queries.set(e, n);
                    }, e.prototype.invalidate = function(e, t) {
                        void 0 === t && (t = !0), e && this.setQuery(e, function() {
                            return {
                                invalidated: t
                            };
                        });
                    }, e.prototype.prepareContext = function(e) {
                        void 0 === e && (e = {});
                        var t = this.localState.prepareContext(e);
                        return (0, i.pi)((0, i.pi)({}, t), {
                            clientAwareness: this.clientAwareness
                        });
                    }, e.prototype.checkInFlight = function(e) {
                        var t = this.queryStore.get(e);
                        return t && t.networkStatus !== n.ready && t.networkStatus !== n.error;
                    }, e.prototype.startPollingQuery = function(e, t, r) {
                        var n = this, o = e.pollInterval;
                        if ((0, l.kG)(o, 18), !this.ssrMode) {
                            var a = this.pollingInfoByQueryId.get(t);
                            a || this.pollingInfoByQueryId.set(t, a = {}), a.interval = o, a.options = (0, i.pi)((0, i.pi)({}, e), {
                                fetchPolicy: "network-only"
                            });
                            var s = function() {
                                var e = n.pollingInfoByQueryId.get(t);
                                e && (n.checkInFlight(t) ? u() : n.fetchQuery(t, e.options, m.poll).then(u, u));
                            }, u = function() {
                                var e = n.pollingInfoByQueryId.get(t);
                                e && (clearTimeout(e.timeout), e.timeout = setTimeout(s, e.interval));
                            };
                            r && this.addQueryListener(t, r), u();
                        }
                        return t;
                    }, e.prototype.stopPollingQuery = function(e) {
                        this.pollingInfoByQueryId.delete(e);
                    }, e;
                }(), x = function() {
                    function e(e) {
                        this.cache = e;
                    }
                    return e.prototype.getCache = function() {
                        return this.cache;
                    }, e.prototype.markQueryResult = function(e, t, r, n, i) {
                        void 0 === i && (i = !1);
                        var a = !(0, o.d2)(e);
                        i && (0, o.d2)(e) && e.data && (a = !0), !n && a && this.cache.write({
                            result: e.data,
                            dataId: "ROOT_QUERY",
                            query: t,
                            variables: r
                        });
                    }, e.prototype.markSubscriptionResult = function(e, t, r) {
                        (0, o.d2)(e) || this.cache.write({
                            result: e.data,
                            dataId: "ROOT_SUBSCRIPTION",
                            query: t,
                            variables: r
                        });
                    }, e.prototype.markMutationInit = function(e) {
                        var t, r = this;
                        e.optimisticResponse && (t = "function" == typeof e.optimisticResponse ? e.optimisticResponse(e.variables) : e.optimisticResponse, this.cache.recordOptimisticTransaction(function(n) {
                            var i = r.cache;
                            r.cache = n;
                            try {
                                r.markMutationResult({
                                    mutationId: e.mutationId,
                                    result: {
                                        data: t
                                    },
                                    document: e.document,
                                    variables: e.variables,
                                    updateQueries: e.updateQueries,
                                    update: e.update
                                });
                            } finally{
                                r.cache = i;
                            }
                        }, e.mutationId));
                    }, e.prototype.markMutationResult = function(e) {
                        var t = this;
                        if (!(0, o.d2)(e.result)) {
                            var r = [
                                {
                                    result: e.result.data,
                                    dataId: "ROOT_MUTATION",
                                    query: e.document,
                                    variables: e.variables
                                }
                            ], n = e.updateQueries;
                            n && Object.keys(n).forEach(function(i) {
                                var a = n[i], s = a.query, u = a.updater, c = t.cache.diff({
                                    query: s.document,
                                    variables: s.variables,
                                    returnPartialData: !0,
                                    optimistic: !1
                                }), l = c.result;
                                if (c.complete) {
                                    var f = (0, o.XY)(function() {
                                        return u(l, {
                                            mutationResult: e.result,
                                            queryName: (0, o.rY)(s.document) || void 0,
                                            queryVariables: s.variables
                                        });
                                    });
                                    f && r.push({
                                        result: f,
                                        dataId: "ROOT_QUERY",
                                        query: s.document,
                                        variables: s.variables
                                    });
                                }
                            }), this.cache.performTransaction(function(t) {
                                r.forEach(function(e) {
                                    return t.write(e);
                                });
                                var n = e.update;
                                n && (0, o.XY)(function() {
                                    return n(t, e.result);
                                });
                            });
                        }
                    }, e.prototype.markMutationComplete = function(e) {
                        e.optimisticResponse && this.cache.removeOptimistic(e.mutationId);
                    }, e.prototype.markUpdateQueryResult = function(e, t, r) {
                        this.cache.write({
                            result: r,
                            dataId: "ROOT_QUERY",
                            variables: t,
                            query: e
                        });
                    }, e.prototype.reset = function() {
                        return this.cache.reset();
                    }, e;
                }(), A = function() {
                    function e(e) {
                        var t = this;
                        this.defaultOptions = {}, this.resetStoreCallbacks = [], this.clearStoreCallbacks = [];
                        var r = e.cache, n = e.ssrMode, i = void 0 !== n && n, o = e.ssrForceFetchDelay, a = void 0 === o ? 0 : o, s = e.connectToDevTools, c = e.queryDeduplication, f = void 0 === c || c, p = e.defaultOptions, d = e.assumeImmutableResults, h = void 0 !== d && d, v = e.resolvers, m = e.typeDefs, y = e.fragmentMatcher, g = e.name, E = e.version, b = e.link;
                        if (!b && v && (b = u.i0.empty()), !b || !r) throw new l.ej(4);
                        this.link = b, this.cache = r, this.store = new x(r), this.disableNetworkFetches = i || a > 0, this.queryDeduplication = f, this.defaultOptions = p || {}, this.typeDefs = m, a && setTimeout(function() {
                            return t.disableNetworkFetches = !1;
                        }, a), this.watchQuery = this.watchQuery.bind(this), this.query = this.query.bind(this), this.mutate = this.mutate.bind(this), this.resetStore = this.resetStore.bind(this), this.reFetchObservableQueries = this.reFetchObservableQueries.bind(this);
                        void 0 !== s && s && "undefined" != typeof window && (window.__APOLLO_CLIENT__ = this), this.version = "2.6.10", this.localState = new O({
                            cache: r,
                            client: this,
                            resolvers: v,
                            fragmentMatcher: y
                        }), this.queryManager = new R({
                            link: this.link,
                            store: this.store,
                            queryDeduplication: f,
                            ssrMode: i,
                            clientAwareness: {
                                name: g,
                                version: E
                            },
                            localState: this.localState,
                            assumeImmutableResults: h,
                            onBroadcast: function() {
                                t.devToolsHookCb && t.devToolsHookCb({
                                    action: {},
                                    state: {
                                        queries: t.queryManager.queryStore.getStore(),
                                        mutations: t.queryManager.mutationStore.getStore()
                                    },
                                    dataWithOptimisticResults: t.cache.extract(!0)
                                });
                            }
                        });
                    }
                    return e.prototype.stop = function() {
                        this.queryManager.stop();
                    }, e.prototype.watchQuery = function(e) {
                        return this.defaultOptions.watchQuery && (e = (0, i.pi)((0, i.pi)({}, this.defaultOptions.watchQuery), e)), !this.disableNetworkFetches || "network-only" !== e.fetchPolicy && "cache-and-network" !== e.fetchPolicy || (e = (0, i.pi)((0, i.pi)({}, e), {
                            fetchPolicy: "cache-first"
                        })), this.queryManager.watchQuery(e);
                    }, e.prototype.query = function(e) {
                        return this.defaultOptions.query && (e = (0, i.pi)((0, i.pi)({}, this.defaultOptions.query), e)), (0, l.kG)("cache-and-network" !== e.fetchPolicy, 5), this.disableNetworkFetches && "network-only" === e.fetchPolicy && (e = (0, i.pi)((0, i.pi)({}, e), {
                            fetchPolicy: "cache-first"
                        })), this.queryManager.query(e);
                    }, e.prototype.mutate = function(e) {
                        return this.defaultOptions.mutate && (e = (0, i.pi)((0, i.pi)({}, this.defaultOptions.mutate), e)), this.queryManager.mutate(e);
                    }, e.prototype.subscribe = function(e) {
                        return this.queryManager.startGraphQLSubscription(e);
                    }, e.prototype.readQuery = function(e, t) {
                        return void 0 === t && (t = !1), this.cache.readQuery(e, t);
                    }, e.prototype.readFragment = function(e, t) {
                        return void 0 === t && (t = !1), this.cache.readFragment(e, t);
                    }, e.prototype.writeQuery = function(e) {
                        var t = this.cache.writeQuery(e);
                        return this.queryManager.broadcastQueries(), t;
                    }, e.prototype.writeFragment = function(e) {
                        var t = this.cache.writeFragment(e);
                        return this.queryManager.broadcastQueries(), t;
                    }, e.prototype.writeData = function(e) {
                        var t = this.cache.writeData(e);
                        return this.queryManager.broadcastQueries(), t;
                    }, e.prototype.__actionHookForDevTools = function(e) {
                        this.devToolsHookCb = e;
                    }, e.prototype.__requestRaw = function(e) {
                        return (0, u.ht)(this.link, e);
                    }, e.prototype.initQueryManager = function() {
                        return this.queryManager;
                    }, e.prototype.resetStore = function() {
                        var e = this;
                        return Promise.resolve().then(function() {
                            return e.queryManager.clearStore();
                        }).then(function() {
                            return Promise.all(e.resetStoreCallbacks.map(function(e) {
                                return e();
                            }));
                        }).then(function() {
                            return e.reFetchObservableQueries();
                        });
                    }, e.prototype.clearStore = function() {
                        var e = this;
                        return Promise.resolve().then(function() {
                            return e.queryManager.clearStore();
                        }).then(function() {
                            return Promise.all(e.clearStoreCallbacks.map(function(e) {
                                return e();
                            }));
                        });
                    }, e.prototype.onResetStore = function(e) {
                        var t = this;
                        return this.resetStoreCallbacks.push(e), function() {
                            t.resetStoreCallbacks = t.resetStoreCallbacks.filter(function(t) {
                                return t !== e;
                            });
                        };
                    }, e.prototype.onClearStore = function(e) {
                        var t = this;
                        return this.clearStoreCallbacks.push(e), function() {
                            t.clearStoreCallbacks = t.clearStoreCallbacks.filter(function(t) {
                                return t !== e;
                            });
                        };
                    }, e.prototype.reFetchObservableQueries = function(e) {
                        return this.queryManager.reFetchObservableQueries(e);
                    }, e.prototype.extract = function(e) {
                        return this.cache.extract(e);
                    }, e.prototype.restore = function(e) {
                        return this.cache.restore(e);
                    }, e.prototype.addResolvers = function(e) {
                        this.localState.addResolvers(e);
                    }, e.prototype.setResolvers = function(e) {
                        this.localState.setResolvers(e);
                    }, e.prototype.getResolvers = function() {
                        return this.localState.getResolvers();
                    }, e.prototype.setLocalStateFragmentMatcher = function(e) {
                        this.localState.setFragmentMatcher(e);
                    }, e;
                }();
                const N = A;
                function C(e) {
                    return {
                        kind: "Document",
                        definitions: [
                            {
                                kind: "OperationDefinition",
                                operation: "query",
                                name: {
                                    kind: "Name",
                                    value: "GeneratedClientQuery"
                                },
                                selectionSet: k(e)
                            }
                        ]
                    };
                }
                function k(e) {
                    if ("number" == typeof e || "boolean" == typeof e || "string" == typeof e || null == e) return null;
                    if (Array.isArray(e)) return k(e[0]);
                    var t = [];
                    return Object.keys(e).forEach(function(r) {
                        var n = k(e[r]);
                        t.push({
                            kind: "Field",
                            name: {
                                kind: "Name",
                                value: r
                            },
                            selectionSet: n || void 0
                        });
                    }), {
                        kind: "SelectionSet",
                        selections: t
                    };
                }
                var M, P = {
                    kind: "Document",
                    definitions: [
                        {
                            kind: "OperationDefinition",
                            operation: "query",
                            name: null,
                            variableDefinitions: null,
                            directives: [],
                            selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                    {
                                        kind: "Field",
                                        alias: null,
                                        name: {
                                            kind: "Name",
                                            value: "__typename"
                                        },
                                        arguments: [],
                                        directives: [],
                                        selectionSet: null
                                    }
                                ]
                            }
                        }
                    ]
                }, D = function() {
                    function e() {}
                    return e.prototype.transformDocument = function(e) {
                        return e;
                    }, e.prototype.transformForLink = function(e) {
                        return e;
                    }, e.prototype.readQuery = function(e, t) {
                        return void 0 === t && (t = !1), this.read({
                            query: e.query,
                            variables: e.variables,
                            optimistic: t
                        });
                    }, e.prototype.readFragment = function(e, t) {
                        return void 0 === t && (t = !1), this.read({
                            query: (0, o.Yk)(e.fragment, e.fragmentName),
                            variables: e.variables,
                            rootId: e.id,
                            optimistic: t
                        });
                    }, e.prototype.writeQuery = function(e) {
                        this.write({
                            dataId: "ROOT_QUERY",
                            result: e.data,
                            query: e.query,
                            variables: e.variables
                        });
                    }, e.prototype.writeFragment = function(e) {
                        this.write({
                            dataId: e.id,
                            result: e.data,
                            variables: e.variables,
                            query: (0, o.Yk)(e.fragment, e.fragmentName)
                        });
                    }, e.prototype.writeData = function(e) {
                        var t, r, n = e.id, i = e.data;
                        if (void 0 !== n) {
                            var o = null;
                            try {
                                o = this.read({
                                    rootId: n,
                                    optimistic: !1,
                                    query: P
                                });
                            } catch (e) {}
                            var a = o && o.__typename || "__ClientData", s = Object.assign({
                                __typename: a
                            }, i);
                            this.writeFragment({
                                id: n,
                                fragment: (t = s, r = a, {
                                    kind: "Document",
                                    definitions: [
                                        {
                                            kind: "FragmentDefinition",
                                            typeCondition: {
                                                kind: "NamedType",
                                                name: {
                                                    kind: "Name",
                                                    value: r || "__FakeType"
                                                }
                                            },
                                            name: {
                                                kind: "Name",
                                                value: "GeneratedClientQuery"
                                            },
                                            selectionSet: k(t)
                                        }
                                    ]
                                }),
                                data: s
                            });
                        } else this.writeQuery({
                            query: C(i),
                            data: i
                        });
                    }, e;
                }();
                M || (M = {});
                var F = null, L = {}, j = 1, U = "@wry/context:Slot", B = Array, Q = B[U] || function() {
                    var e = function() {
                        function e() {
                            this.id = [
                                "slot",
                                j++,
                                Date.now(),
                                Math.random().toString(36).slice(2)
                            ].join(":");
                        }
                        return e.prototype.hasValue = function() {
                            for(var e = F; e; e = e.parent)if (this.id in e.slots) {
                                var t = e.slots[this.id];
                                if (t === L) break;
                                return e !== F && (F.slots[this.id] = t), !0;
                            }
                            return F && (F.slots[this.id] = L), !1;
                        }, e.prototype.getValue = function() {
                            if (this.hasValue()) return F.slots[this.id];
                        }, e.prototype.withValue = function(e, t, r, n) {
                            var i, o = ((i = {
                                __proto__: null
                            })[this.id] = e, i), a = F;
                            F = {
                                parent: a,
                                slots: o
                            };
                            try {
                                return t.apply(n, r);
                            } finally{
                                F = a;
                            }
                        }, e.bind = function(e) {
                            var t = F;
                            return function() {
                                var r = F;
                                try {
                                    return F = t, e.apply(this, arguments);
                                } finally{
                                    F = r;
                                }
                            };
                        }, e.noContext = function(e, t, r) {
                            if (!F) return e.apply(r, t);
                            var n = F;
                            try {
                                return F = null, e.apply(r, t);
                            } finally{
                                F = n;
                            }
                        }, e;
                    }();
                    try {
                        Object.defineProperty(B, U, {
                            value: B[U] = e,
                            enumerable: !1,
                            writable: !1,
                            configurable: !1
                        });
                    } finally{
                        return e;
                    }
                }();
                function V() {}
                var q = function() {
                    function e(e, t) {
                        void 0 === e && (e = 1 / 0), void 0 === t && (t = V), this.max = e, this.dispose = t, this.map = new Map, this.newest = null, this.oldest = null;
                    }
                    return e.prototype.has = function(e) {
                        return this.map.has(e);
                    }, e.prototype.get = function(e) {
                        var t = this.getEntry(e);
                        return t && t.value;
                    }, e.prototype.getEntry = function(e) {
                        var t = this.map.get(e);
                        if (t && t !== this.newest) {
                            var r = t.older, n = t.newer;
                            n && (n.older = r), r && (r.newer = n), t.older = this.newest, t.older.newer = t, t.newer = null, this.newest = t, t === this.oldest && (this.oldest = n);
                        }
                        return t;
                    }, e.prototype.set = function(e, t) {
                        var r = this.getEntry(e);
                        return r ? r.value = t : (r = {
                            key: e,
                            value: t,
                            newer: null,
                            older: this.newest
                        }, this.newest && (this.newest.newer = r), this.newest = r, this.oldest = this.oldest || r, this.map.set(e, r), r.value);
                    }, e.prototype.clean = function() {
                        for(; this.oldest && this.map.size > this.max;)this.delete(this.oldest.key);
                    }, e.prototype.delete = function(e) {
                        var t = this.map.get(e);
                        return !!t && (t === this.newest && (this.newest = t.older), t === this.oldest && (this.oldest = t.newer), t.newer && (t.newer.older = t.older), t.older && (t.older.newer = t.newer), this.map.delete(e), this.dispose(t.value, e), !0);
                    }, e;
                }(), G = new Q, z = [], W = [], $ = 100;
                function H(e, t) {
                    if (!e) throw new Error(t || "assertion failure");
                }
                function K(e) {
                    switch(e.length){
                        case 0:
                            throw new Error("unknown value");
                        case 1:
                            return e[0];
                        case 2:
                            throw e[1];
                    }
                }
                var Y = function() {
                    function e(t, r) {
                        this.fn = t, this.args = r, this.parents = new Set, this.childValues = new Map, this.dirtyChildren = null, this.dirty = !0, this.recomputing = !1, this.value = [], ++e.count;
                    }
                    return e.prototype.recompute = function() {
                        if (H(!this.recomputing, "already recomputing"), function(e) {
                            var t = G.getValue();
                            if (t) return e.parents.add(t), t.childValues.has(e) || t.childValues.set(e, []), J(e) ? te(t, e) : re(t, e), t;
                        }(this) || !ie(this)) return J(this) ? function(e) {
                            var t = oe(e);
                            G.withValue(e, X, [
                                e
                            ]), function(e) {
                                if ("function" == typeof e.subscribe) try {
                                    se(e), e.unsubscribe = e.subscribe.apply(null, e.args);
                                } catch (t) {
                                    return e.setDirty(), !1;
                                }
                                return !0;
                            }(e) && function(e) {
                                if (e.dirty = !1, J(e)) return;
                                ee(e);
                            }(e);
                            return t.forEach(ie), K(e.value);
                        }(this) : K(this.value);
                    }, e.prototype.setDirty = function() {
                        this.dirty || (this.dirty = !0, this.value.length = 0, Z(this), se(this));
                    }, e.prototype.dispose = function() {
                        var e = this;
                        oe(this).forEach(ie), se(this), this.parents.forEach(function(t) {
                            t.setDirty(), ae(t, e);
                        });
                    }, e.count = 0, e;
                }();
                function X(e) {
                    e.recomputing = !0, e.value.length = 0;
                    try {
                        e.value[0] = e.fn.apply(null, e.args);
                    } catch (t) {
                        e.value[1] = t;
                    }
                    e.recomputing = !1;
                }
                function J(e) {
                    return e.dirty || !(!e.dirtyChildren || !e.dirtyChildren.size);
                }
                function Z(e) {
                    e.parents.forEach(function(t) {
                        return te(t, e);
                    });
                }
                function ee(e) {
                    e.parents.forEach(function(t) {
                        return re(t, e);
                    });
                }
                function te(e, t) {
                    if (H(e.childValues.has(t)), H(J(t)), e.dirtyChildren) {
                        if (e.dirtyChildren.has(t)) return;
                    } else e.dirtyChildren = W.pop() || new Set;
                    e.dirtyChildren.add(t), Z(e);
                }
                function re(e, t) {
                    H(e.childValues.has(t)), H(!J(t));
                    var r, n, i, o = e.childValues.get(t);
                    0 === o.length ? e.childValues.set(t, t.value.slice(0)) : (n = t.value, (i = (r = o).length) > 0 && i === n.length && r[i - 1] === n[i - 1] || e.setDirty()), ne(e, t), J(e) || ee(e);
                }
                function ne(e, t) {
                    var r = e.dirtyChildren;
                    r && (r.delete(t), 0 === r.size && (W.length < $ && W.push(r), e.dirtyChildren = null));
                }
                function ie(e) {
                    return 0 === e.parents.size && "function" == typeof e.reportOrphan && !0 === e.reportOrphan();
                }
                function oe(e) {
                    var t = z;
                    return e.childValues.size > 0 && (t = [], e.childValues.forEach(function(r, n) {
                        ae(e, n), t.push(n);
                    })), H(null === e.dirtyChildren), t;
                }
                function ae(e, t) {
                    t.parents.delete(e), e.childValues.delete(t), ne(e, t);
                }
                function se(e) {
                    var t = e.unsubscribe;
                    "function" == typeof t && (e.unsubscribe = void 0, t());
                }
                var ue = function() {
                    function e(e) {
                        this.weakness = e;
                    }
                    return e.prototype.lookup = function() {
                        for(var e = [], t = 0; t < arguments.length; t++)e[t] = arguments[t];
                        return this.lookupArray(e);
                    }, e.prototype.lookupArray = function(e) {
                        var t = this;
                        return e.forEach(function(e) {
                            return t = t.getChildTrie(e);
                        }), t.data || (t.data = Object.create(null));
                    }, e.prototype.getChildTrie = function(t) {
                        var r = this.weakness && function(e) {
                            switch(typeof e){
                                case "object":
                                    if (null === e) break;
                                case "function":
                                    return !0;
                            }
                            return !1;
                        }(t) ? this.weak || (this.weak = new WeakMap) : this.strong || (this.strong = new Map), n = r.get(t);
                        return n || r.set(t, n = new e(this.weakness)), n;
                    }, e;
                }();
                var ce = new ue("function" == typeof WeakMap);
                function le() {
                    for(var e = [], t = 0; t < arguments.length; t++)e[t] = arguments[t];
                    return ce.lookupArray(e);
                }
                var fe = new Set;
                function pe(e, t) {
                    void 0 === t && (t = Object.create(null));
                    var r = new q(t.max || Math.pow(2, 16), function(e) {
                        return e.dispose();
                    }), n = !!t.disposable, i = t.makeCacheKey || le;
                    function o() {
                        if (!n || G.hasValue()) {
                            var o = i.apply(null, arguments);
                            if (void 0 === o) return e.apply(null, arguments);
                            var a = Array.prototype.slice.call(arguments), s = r.get(o);
                            s ? s.args = a : (s = new Y(e, a), r.set(o, s), s.subscribe = t.subscribe, n && (s.reportOrphan = function() {
                                return r.delete(o);
                            }));
                            var u = s.recompute();
                            return r.set(o, s), fe.add(r), G.hasValue() || (fe.forEach(function(e) {
                                return e.clean();
                            }), fe.clear()), n ? void 0 : u;
                        }
                    }
                    return o.dirty = function() {
                        var e = i.apply(null, arguments), t = void 0 !== e && r.get(e);
                        t && t.setDirty();
                    }, o;
                }
                var de = !1;
                function he() {
                    var e = !de;
                    return (0, o.Y8)() || (de = !0), e;
                }
                var ve = function() {
                    function e() {}
                    return e.prototype.ensureReady = function() {
                        return Promise.resolve();
                    }, e.prototype.canBypassInit = function() {
                        return !0;
                    }, e.prototype.match = function(e, t, r) {
                        var n = r.store.get(e.id), i = "ROOT_QUERY" === e.id;
                        if (!n) return i;
                        var o = n.__typename, a = void 0 === o ? i && "Query" : o;
                        return a && a === t || (he(), "heuristic");
                    }, e;
                }(), me = function() {
                    function e(e) {
                        e && e.introspectionQueryResultData ? (this.possibleTypesMap = this.parseIntrospectionResult(e.introspectionQueryResultData), this.isReady = !0) : this.isReady = !1, this.match = this.match.bind(this);
                    }
                    return e.prototype.match = function(e, t, r) {
                        (0, l.kG)(this.isReady, 1);
                        var n = r.store.get(e.id), i = "ROOT_QUERY" === e.id;
                        if (!n) return i;
                        var o = n.__typename, a = void 0 === o ? i && "Query" : o;
                        if ((0, l.kG)(a, 2), a === t) return !0;
                        var s = this.possibleTypesMap[t];
                        return !!(a && s && s.indexOf(a) > -1);
                    }, e.prototype.parseIntrospectionResult = function(e) {
                        var t = {};
                        return e.__schema.types.forEach(function(e) {
                            "UNION" !== e.kind && "INTERFACE" !== e.kind || (t[e.name] = e.possibleTypes.map(function(e) {
                                return e.name;
                            }));
                        }), t;
                    }, e;
                }(), ye = Object.prototype.hasOwnProperty, ge = function() {
                    function e(e) {
                        var t = this;
                        void 0 === e && (e = Object.create(null)), this.data = e, this.depend = pe(function(e) {
                            return t.data[e];
                        }, {
                            disposable: !0,
                            makeCacheKey: function(e) {
                                return e;
                            }
                        });
                    }
                    return e.prototype.toObject = function() {
                        return this.data;
                    }, e.prototype.get = function(e) {
                        return this.depend(e), this.data[e];
                    }, e.prototype.set = function(e, t) {
                        t !== this.data[e] && (this.data[e] = t, this.depend.dirty(e));
                    }, e.prototype.delete = function(e) {
                        ye.call(this.data, e) && (delete this.data[e], this.depend.dirty(e));
                    }, e.prototype.clear = function() {
                        this.replace(null);
                    }, e.prototype.replace = function(e) {
                        var t = this;
                        e ? (Object.keys(e).forEach(function(r) {
                            t.set(r, e[r]);
                        }), Object.keys(this.data).forEach(function(r) {
                            ye.call(e, r) || t.delete(r);
                        })) : Object.keys(this.data).forEach(function(e) {
                            t.delete(e);
                        });
                    }, e;
                }();
                function Ee(e) {
                    return new ge(e);
                }
                var be = function() {
                    function e(e) {
                        var t = this, r = void 0 === e ? {} : e, n = r.cacheKeyRoot, i = void 0 === n ? new ue(o.mr) : n, a = r.freezeResults, s = this, u = s.executeStoreQuery, c = s.executeSelectionSet, l = s.executeSubSelectedArray;
                        this.freezeResults = void 0 !== a && a, this.executeStoreQuery = pe(function(e) {
                            return u.call(t, e);
                        }, {
                            makeCacheKey: function(e) {
                                var t = e.rootValue, r = e.contextValue;
                                if (r.store instanceof ge) return i.lookup(r.store, e.query, e.fragmentMatcher, JSON.stringify(e.variableValues), t.id);
                            }
                        }), this.executeSelectionSet = pe(function(e) {
                            return c.call(t, e);
                        }, {
                            makeCacheKey: function(e) {
                                var t = e.rootValue, r = e.execContext;
                                if (r.contextValue.store instanceof ge) return i.lookup(r.contextValue.store, e.selectionSet, r.fragmentMatcher, JSON.stringify(r.variableValues), t.id);
                            }
                        }), this.executeSubSelectedArray = pe(function(e) {
                            return l.call(t, e);
                        }, {
                            makeCacheKey: function(e) {
                                var t = e.execContext;
                                if (t.contextValue.store instanceof ge) return i.lookup(t.contextValue.store, e.field, e.array, JSON.stringify(t.variableValues));
                            }
                        });
                    }
                    return e.prototype.readQueryFromStore = function(e) {
                        return this.diffQueryAgainstStore((0, i.pi)((0, i.pi)({}, e), {
                            returnPartialData: !1
                        })).result;
                    }, e.prototype.diffQueryAgainstStore = function(e) {
                        var t = e.store, r = e.query, n = e.variables, i = e.previousResult, s = e.returnPartialData, u = void 0 === s || s, c = e.rootId, f = void 0 === c ? "ROOT_QUERY" : c, p = e.fragmentMatcherFunction, d = e.config, h = (0, o.iW)(r);
                        n = (0, o.f0)({}, (0, o.O4)(h), n);
                        var v = this.executeStoreQuery({
                            query: r,
                            rootValue: {
                                type: "id",
                                id: f,
                                generated: !0,
                                typename: "Query"
                            },
                            contextValue: {
                                store: t,
                                dataIdFromObject: d && d.dataIdFromObject,
                                cacheRedirects: d && d.cacheRedirects || {}
                            },
                            variableValues: n,
                            fragmentMatcher: p
                        }), m = v.missing && v.missing.length > 0;
                        return m && !u && v.missing.forEach(function(e) {
                            if (!e.tolerable) throw new l.ej(8);
                        }), i && (0, a.D)(i, v.result) && (v.result = i), {
                            result: v.result,
                            complete: !m
                        };
                    }, e.prototype.executeStoreQuery = function(e) {
                        var t = e.query, r = e.rootValue, n = e.contextValue, i = e.variableValues, a = e.fragmentMatcher, s = void 0 === a ? _e : a, u = (0, o.p$)(t), c = (0, o.kU)(t), l = (0, o.F)(c);
                        return this.executeSelectionSet({
                            selectionSet: u.selectionSet,
                            rootValue: r,
                            execContext: {
                                query: t,
                                fragmentMap: l,
                                contextValue: n,
                                variableValues: i,
                                fragmentMatcher: s
                            }
                        });
                    }, e.prototype.executeSelectionSet = function(e) {
                        var t = this, r = e.selectionSet, n = e.rootValue, a = e.execContext, s = a.fragmentMap, u = a.contextValue, c = a.variableValues, f = {
                            result: null
                        }, p = [], d = u.store.get(n.id), h = d && d.__typename || "ROOT_QUERY" === n.id && "Query" || void 0;
                        function v(e) {
                            var t;
                            return e.missing && (f.missing = f.missing || [], (t = f.missing).push.apply(t, e.missing)), e.result;
                        }
                        return r.selections.forEach(function(e) {
                            var r;
                            if ((0, o.LZ)(e, c)) {
                                if ((0, o.My)(e)) {
                                    var f = v(t.executeField(d, h, e, a));
                                    void 0 !== f && p.push(((r = {})[(0, o.u2)(e)] = f, r));
                                } else {
                                    var m = void 0;
                                    if ((0, o.Ao)(e)) m = e;
                                    else if (!(m = s[e.name.value])) throw new l.ej(9);
                                    var y = m.typeCondition && m.typeCondition.name.value, g = !y || a.fragmentMatcher(n, y, u);
                                    if (g) {
                                        var E = t.executeSelectionSet({
                                            selectionSet: m.selectionSet,
                                            rootValue: n,
                                            execContext: a
                                        });
                                        "heuristic" === g && E.missing && (E = (0, i.pi)((0, i.pi)({}, E), {
                                            missing: E.missing.map(function(e) {
                                                return (0, i.pi)((0, i.pi)({}, e), {
                                                    tolerable: !0
                                                });
                                            })
                                        })), p.push(v(E));
                                    }
                                }
                            }
                        }), f.result = (0, o.bw)(p), f;
                    }, e.prototype.executeField = function(e, t, r, n) {
                        var i = n.variableValues, a = n.contextValue, s = function(e, t, r, n, i, a) {
                            var s = a.directives, u = r;
                            (n || s) && (u = (0, o.PT)(u, n, s));
                            var c = void 0;
                            if (e && void 0 === (c = e[u]) && i.cacheRedirects && "string" == typeof t) {
                                var l = i.cacheRedirects[t];
                                if (l) {
                                    var f = l[r];
                                    f && (c = f(e, n, {
                                        getCacheKey: function(e) {
                                            var t = i.dataIdFromObject(e);
                                            return t && (0, o.aX)({
                                                id: t,
                                                typename: e.__typename
                                            });
                                        }
                                    }));
                                }
                            }
                            if (void 0 === c) return {
                                result: c,
                                missing: [
                                    {
                                        object: e,
                                        fieldName: u,
                                        tolerable: !1
                                    }
                                ]
                            };
                            (0, o.v4)(c) && (c = c.json);
                            return {
                                result: c
                            };
                        }(e, t, r.name.value, (0, o.NC)(r, i), a, {
                            resultKey: (0, o.u2)(r),
                            directives: (0, o.Qy)(r, i)
                        });
                        return Array.isArray(s.result) ? this.combineExecResults(s, this.executeSubSelectedArray({
                            field: r,
                            array: s.result,
                            execContext: n
                        })) : r.selectionSet ? null == s.result ? s : this.combineExecResults(s, this.executeSelectionSet({
                            selectionSet: r.selectionSet,
                            rootValue: s.result,
                            execContext: n
                        })) : (Se(r, s.result), s);
                    }, e.prototype.combineExecResults = function() {
                        for(var e, t = [], r = 0; r < arguments.length; r++)t[r] = arguments[r];
                        return t.forEach(function(t) {
                            t.missing && (e = e || []).push.apply(e, t.missing);
                        }), {
                            result: t.pop().result,
                            missing: e
                        };
                    }, e.prototype.executeSubSelectedArray = function(e) {
                        var t, r = this, n = e.field, i = e.array, o = e.execContext;
                        function a(e) {
                            return e.missing && (t = t || []).push.apply(t, e.missing), e.result;
                        }
                        return {
                            result: i = i.map(function(e) {
                                return null === e ? null : Array.isArray(e) ? a(r.executeSubSelectedArray({
                                    field: n,
                                    array: e,
                                    execContext: o
                                })) : n.selectionSet ? a(r.executeSelectionSet({
                                    selectionSet: n.selectionSet,
                                    rootValue: e,
                                    execContext: o
                                })) : (Se(n, e), e);
                            }),
                            missing: t
                        };
                    }, e;
                }();
                function Se(e, t) {
                    if (!e.selectionSet && (0, o.cQ)(t)) throw new l.ej(10);
                }
                function _e() {
                    return !0;
                }
                function we(e) {
                    (0, l.kG)((0, o.cQ)(e), 11);
                }
                var Oe = function() {
                    function e(e) {
                        void 0 === e && (e = Object.create(null)), this.data = e;
                    }
                    return e.prototype.toObject = function() {
                        return this.data;
                    }, e.prototype.get = function(e) {
                        return this.data[e];
                    }, e.prototype.set = function(e, t) {
                        this.data[e] = t;
                    }, e.prototype.delete = function(e) {
                        this.data[e] = void 0;
                    }, e.prototype.clear = function() {
                        this.data = Object.create(null);
                    }, e.prototype.replace = function(e) {
                        this.data = e || Object.create(null);
                    }, e;
                }();
                function Te(e) {
                    return new Oe(e);
                }
                var Ie = function(e) {
                    function t() {
                        var t = null !== e && e.apply(this, arguments) || this;
                        return t.type = "WriteError", t;
                    }
                    return (0, i.ZT)(t, e), t;
                }(Error);
                function Re(e, t) {
                    var r = new Ie("Error writing result to store for query:\n " + JSON.stringify(t));
                    return r.message += "\n" + e.message, r.stack = e.stack, r;
                }
                var xe = function() {
                    function e() {}
                    return e.prototype.writeQueryToStore = function(e) {
                        var t = e.query, r = e.result, n = e.store, i = void 0 === n ? Ee() : n;
                        return this.writeResultToStore({
                            dataId: "ROOT_QUERY",
                            result: r,
                            document: t,
                            store: i,
                            variables: e.variables,
                            dataIdFromObject: e.dataIdFromObject,
                            fragmentMatcherFunction: e.fragmentMatcherFunction
                        });
                    }, e.prototype.writeResultToStore = function(e) {
                        var t = e.dataId, r = e.result, n = e.document, i = e.store, a = void 0 === i ? Ee() : i, s = e.variables, u = e.dataIdFromObject, c = e.fragmentMatcherFunction, l = (0, o.$H)(n);
                        try {
                            return this.writeSelectionSetToStore({
                                result: r,
                                dataId: t,
                                selectionSet: l.selectionSet,
                                context: {
                                    store: a,
                                    processedData: {},
                                    variables: (0, o.f0)({}, (0, o.O4)(l), s),
                                    dataIdFromObject: u,
                                    fragmentMap: (0, o.F)((0, o.kU)(n)),
                                    fragmentMatcherFunction: c
                                }
                            });
                        } catch (e) {
                            throw Re(e, n);
                        }
                    }, e.prototype.writeSelectionSetToStore = function(e) {
                        var t = this, r = e.result, n = e.dataId, i = e.context, a = i.variables, s = i.store, u = i.fragmentMap;
                        return e.selectionSet.selections.forEach(function(e) {
                            var s;
                            if ((0, o.LZ)(e, a)) {
                                if ((0, o.My)(e)) {
                                    var c = (0, o.u2)(e), f = r[c];
                                    if (void 0 !== f) t.writeFieldToStore({
                                        dataId: n,
                                        value: f,
                                        field: e,
                                        context: i
                                    });
                                    else e.directives && e.directives.length && (e.directives.some(function(e) {
                                        return e.name && "defer" === e.name.value;
                                    }), e.directives.some(function(e) {
                                        return e.name && "client" === e.name.value;
                                    }));
                                } else {
                                    var p = void 0;
                                    (0, o.Ao)(e) ? p = e : (0, l.kG)(p = (u || {})[e.name.value], 3);
                                    var d = !0;
                                    if (i.fragmentMatcherFunction && p.typeCondition) {
                                        var h = n || "self", v = (0, o.aX)({
                                            id: h,
                                            typename: void 0
                                        }), m = {
                                            store: new Oe((s = {}, s[h] = r, s)),
                                            cacheRedirects: {}
                                        }, y = i.fragmentMatcherFunction(v, p.typeCondition.name.value, m);
                                        (0, o.yv)(), d = !!y;
                                    }
                                    d && t.writeSelectionSetToStore({
                                        result: r,
                                        selectionSet: p.selectionSet,
                                        dataId: n,
                                        context: i
                                    });
                                }
                            }
                        }), s;
                    }, e.prototype.writeFieldToStore = function(e) {
                        var t, r, n, s = e.field, u = e.value, c = e.dataId, f = e.context, p = f.dataIdFromObject, d = f.store, h = (0, o.vf)(s, f.variables);
                        if (s.selectionSet && null !== u) {
                            if (Array.isArray(u)) r = this.processArrayValue(u, c + "." + h, s.selectionSet, f);
                            else {
                                var v = c + "." + h, m = !0;
                                if (Ae(v) || (v = "$" + v), p) {
                                    var y = p(u);
                                    (0, l.kG)(!y || !Ae(y), 4), (y || "number" == typeof y && 0 === y) && (v = y, m = !1);
                                }
                                Ce(v, s, f.processedData) || this.writeSelectionSetToStore({
                                    dataId: v,
                                    result: u,
                                    selectionSet: s.selectionSet,
                                    context: f
                                });
                                var g = u.__typename;
                                r = (0, o.aX)({
                                    id: v,
                                    typename: g
                                }, m);
                                var E = (n = d.get(c)) && n[h];
                                if (E !== r && (0, o.cQ)(E)) {
                                    var b = void 0 !== E.typename, S = void 0 !== g, _ = b && S && E.typename !== g;
                                    (0, l.kG)(!m || E.generated || _, 5), (0, l.kG)(!b || S, 6), E.generated && (_ ? m || d.delete(E.id) : Ne(E.id, r.id, d));
                                }
                            }
                        } else r = null != u && "object" == typeof u ? {
                            type: "json",
                            json: u
                        } : u;
                        (n = d.get(c)) && (0, a.D)(r, n[h]) || d.set(c, (0, i.pi)((0, i.pi)({}, n), ((t = {})[h] = r, t)));
                    }, e.prototype.processArrayValue = function(e, t, r, n) {
                        var i = this;
                        return e.map(function(e, a) {
                            if (null === e) return null;
                            var s = t + "." + a;
                            if (Array.isArray(e)) return i.processArrayValue(e, s, r, n);
                            var u = !0;
                            if (n.dataIdFromObject) {
                                var c = n.dataIdFromObject(e);
                                c && (s = c, u = !1);
                            }
                            return Ce(s, r, n.processedData) || i.writeSelectionSetToStore({
                                dataId: s,
                                result: e,
                                selectionSet: r,
                                context: n
                            }), (0, o.aX)({
                                id: s,
                                typename: e.__typename
                            }, u);
                        });
                    }, e;
                }();
                function Ae(e) {
                    return "$" === e[0];
                }
                function Ne(e, t, r) {
                    if (e === t) return !1;
                    var n = r.get(e), s = r.get(t), u = !1;
                    Object.keys(n).forEach(function(e) {
                        var t = n[e], i = s[e];
                        (0, o.cQ)(t) && Ae(t.id) && (0, o.cQ)(i) && !(0, a.D)(t, i) && Ne(t.id, i.id, r) && (u = !0);
                    }), r.delete(e);
                    var c = (0, i.pi)((0, i.pi)({}, n), s);
                    return (0, a.D)(c, s) ? u : (r.set(t, c), !0);
                }
                function Ce(e, t, r) {
                    if (!r) return !1;
                    if (r[e]) {
                        if (r[e].indexOf(t) >= 0) return !0;
                        r[e].push(t);
                    } else r[e] = [
                        t
                    ];
                    return !1;
                }
                var ke = {
                    fragmentMatcher: new ve,
                    dataIdFromObject: Me,
                    addTypename: !0,
                    resultCaching: !0,
                    freezeResults: !1
                };
                function Me(e) {
                    if (e.__typename) {
                        if (void 0 !== e.id) return e.__typename + ":" + e.id;
                        if (void 0 !== e._id) return e.__typename + ":" + e._id;
                    }
                    return null;
                }
                var Pe = Object.prototype.hasOwnProperty, De = function(e) {
                    function t(t, r, n) {
                        var i = e.call(this, Object.create(null)) || this;
                        return i.optimisticId = t, i.parent = r, i.transaction = n, i;
                    }
                    return (0, i.ZT)(t, e), t.prototype.toObject = function() {
                        return (0, i.pi)((0, i.pi)({}, this.parent.toObject()), this.data);
                    }, t.prototype.get = function(e) {
                        return Pe.call(this.data, e) ? this.data[e] : this.parent.get(e);
                    }, t;
                }(Oe), Fe = function(e) {
                    function t(t) {
                        void 0 === t && (t = {});
                        var r = e.call(this) || this;
                        r.watches = new Set, r.typenameDocumentCache = new Map, r.cacheKeyRoot = new ue(o.mr), r.silenceBroadcast = !1, r.config = (0, i.pi)((0, i.pi)({}, ke), t), r.config.customResolvers && (r.config.cacheRedirects = r.config.customResolvers), r.config.cacheResolvers && (r.config.cacheRedirects = r.config.cacheResolvers), r.addTypename = !!r.config.addTypename, r.data = r.config.resultCaching ? new ge : new Oe, r.optimisticData = r.data, r.storeWriter = new xe, r.storeReader = new be({
                            cacheKeyRoot: r.cacheKeyRoot,
                            freezeResults: t.freezeResults
                        });
                        var n = r, a = n.maybeBroadcastWatch;
                        return r.maybeBroadcastWatch = pe(function(e) {
                            return a.call(r, e);
                        }, {
                            makeCacheKey: function(e) {
                                if (!e.optimistic && !e.previousResult) return n.data instanceof ge ? n.cacheKeyRoot.lookup(e.query, JSON.stringify(e.variables)) : void 0;
                            }
                        }), r;
                    }
                    return (0, i.ZT)(t, e), t.prototype.restore = function(e) {
                        return e && this.data.replace(e), this;
                    }, t.prototype.extract = function(e) {
                        return void 0 === e && (e = !1), (e ? this.optimisticData : this.data).toObject();
                    }, t.prototype.read = function(e) {
                        if ("string" == typeof e.rootId && void 0 === this.data.get(e.rootId)) return null;
                        var t = this.config.fragmentMatcher, r = t && t.match;
                        return this.storeReader.readQueryFromStore({
                            store: e.optimistic ? this.optimisticData : this.data,
                            query: this.transformDocument(e.query),
                            variables: e.variables,
                            rootId: e.rootId,
                            fragmentMatcherFunction: r,
                            previousResult: e.previousResult,
                            config: this.config
                        }) || null;
                    }, t.prototype.write = function(e) {
                        var t = this.config.fragmentMatcher, r = t && t.match;
                        this.storeWriter.writeResultToStore({
                            dataId: e.dataId,
                            result: e.result,
                            variables: e.variables,
                            document: this.transformDocument(e.query),
                            store: this.data,
                            dataIdFromObject: this.config.dataIdFromObject,
                            fragmentMatcherFunction: r
                        }), this.broadcastWatches();
                    }, t.prototype.diff = function(e) {
                        var t = this.config.fragmentMatcher, r = t && t.match;
                        return this.storeReader.diffQueryAgainstStore({
                            store: e.optimistic ? this.optimisticData : this.data,
                            query: this.transformDocument(e.query),
                            variables: e.variables,
                            returnPartialData: e.returnPartialData,
                            previousResult: e.previousResult,
                            fragmentMatcherFunction: r,
                            config: this.config
                        });
                    }, t.prototype.watch = function(e) {
                        var t = this;
                        return this.watches.add(e), function() {
                            t.watches.delete(e);
                        };
                    }, t.prototype.evict = function(e) {
                        throw new l.ej(7);
                    }, t.prototype.reset = function() {
                        return this.data.clear(), this.broadcastWatches(), Promise.resolve();
                    }, t.prototype.removeOptimistic = function(e) {
                        for(var t = [], r = 0, n = this.optimisticData; n instanceof De;)n.optimisticId === e ? ++r : t.push(n), n = n.parent;
                        if (r > 0) {
                            for(this.optimisticData = n; t.length > 0;){
                                var i = t.pop();
                                this.performTransaction(i.transaction, i.optimisticId);
                            }
                            this.broadcastWatches();
                        }
                    }, t.prototype.performTransaction = function(e, t) {
                        var r = this.data, n = this.silenceBroadcast;
                        this.silenceBroadcast = !0, "string" == typeof t && (this.data = this.optimisticData = new De(t, this.optimisticData, e));
                        try {
                            e(this);
                        } finally{
                            this.silenceBroadcast = n, this.data = r;
                        }
                        this.broadcastWatches();
                    }, t.prototype.recordOptimisticTransaction = function(e, t) {
                        return this.performTransaction(e, t);
                    }, t.prototype.transformDocument = function(e) {
                        if (this.addTypename) {
                            var t = this.typenameDocumentCache.get(e);
                            return t || (t = (0, o.Gw)(e), this.typenameDocumentCache.set(e, t), this.typenameDocumentCache.set(t, t)), t;
                        }
                        return e;
                    }, t.prototype.broadcastWatches = function() {
                        var e = this;
                        this.silenceBroadcast || this.watches.forEach(function(t) {
                            return e.maybeBroadcastWatch(t);
                        });
                    }, t.prototype.maybeBroadcastWatch = function(e) {
                        e.callback(this.diff({
                            query: e.query,
                            variables: e.variables,
                            previousResult: e.previousResult && e.previousResult(),
                            optimistic: e.optimistic
                        }));
                    }, t;
                }(D), Le = r(3306);
                var je = {
                    Name: function(e) {
                        return e.value;
                    },
                    Variable: function(e) {
                        return "$" + e.name;
                    },
                    Document: function(e) {
                        return Be(e.definitions, "\n\n") + "\n";
                    },
                    OperationDefinition: function(e) {
                        var t = e.operation, r = e.name, n = Ve("(", Be(e.variableDefinitions, ", "), ")"), i = Be(e.directives, " "), o = e.selectionSet;
                        return r || i || n || "query" !== t ? Be([
                            t,
                            Be([
                                r,
                                n
                            ]),
                            i,
                            o
                        ], " ") : o;
                    },
                    VariableDefinition: function(e) {
                        var t = e.directives;
                        return e.variable + ": " + e.type + Ve(" = ", e.defaultValue) + Ve(" ", Be(t, " "));
                    },
                    SelectionSet: function(e) {
                        return Qe(e.selections);
                    },
                    Field: function(e) {
                        var t = e.name, r = e.arguments, n = e.directives, i = e.selectionSet;
                        return Be([
                            Ve("", e.alias, ": ") + t + Ve("(", Be(r, ", "), ")"),
                            Be(n, " "),
                            i
                        ], " ");
                    },
                    Argument: function(e) {
                        return e.name + ": " + e.value;
                    },
                    FragmentSpread: function(e) {
                        return "..." + e.name + Ve(" ", Be(e.directives, " "));
                    },
                    InlineFragment: function(e) {
                        var t = e.directives, r = e.selectionSet;
                        return Be([
                            "...",
                            Ve("on ", e.typeCondition),
                            Be(t, " "),
                            r
                        ], " ");
                    },
                    FragmentDefinition: function(e) {
                        var t = e.typeCondition, r = e.variableDefinitions, n = e.directives, i = e.selectionSet;
                        return "fragment ".concat(e.name).concat(Ve("(", Be(r, ", "), ")"), " ") + "on ".concat(t, " ").concat(Ve("", Be(n, " "), " ")) + i;
                    },
                    IntValue: function(e) {
                        return e.value;
                    },
                    FloatValue: function(e) {
                        return e.value;
                    },
                    StringValue: function(e, t) {
                        var r = e.value;
                        return e.block ? (0, Le.LZ)(r, "description" === t ? "" : "  ") : JSON.stringify(r);
                    },
                    BooleanValue: function(e) {
                        return e.value ? "true" : "false";
                    },
                    NullValue: function() {
                        return "null";
                    },
                    EnumValue: function(e) {
                        return e.value;
                    },
                    ListValue: function(e) {
                        return "[" + Be(e.values, ", ") + "]";
                    },
                    ObjectValue: function(e) {
                        return "{" + Be(e.fields, ", ") + "}";
                    },
                    ObjectField: function(e) {
                        return e.name + ": " + e.value;
                    },
                    Directive: function(e) {
                        return "@" + e.name + Ve("(", Be(e.arguments, ", "), ")");
                    },
                    NamedType: function(e) {
                        return e.name;
                    },
                    ListType: function(e) {
                        return "[" + e.type + "]";
                    },
                    NonNullType: function(e) {
                        return e.type + "!";
                    },
                    SchemaDefinition: function(e) {
                        var t = e.operationTypes;
                        return Be([
                            "schema",
                            Be(e.directives, " "),
                            Qe(t)
                        ], " ");
                    },
                    OperationTypeDefinition: function(e) {
                        return e.operation + ": " + e.type;
                    },
                    ScalarTypeDefinition: Ue(function(e) {
                        return Be([
                            "scalar",
                            e.name,
                            Be(e.directives, " ")
                        ], " ");
                    }),
                    ObjectTypeDefinition: Ue(function(e) {
                        var t = e.directives, r = e.fields;
                        return Be([
                            "type",
                            e.name,
                            Ve("implements ", Be(e.interfaces, " & ")),
                            Be(t, " "),
                            Qe(r)
                        ], " ");
                    }),
                    FieldDefinition: Ue(function(e) {
                        var t = e.arguments, r = e.type, n = e.directives;
                        return e.name + (ze(t) ? Ve("(\n", qe(Be(t, "\n")), "\n)") : Ve("(", Be(t, ", "), ")")) + ": " + r + Ve(" ", Be(n, " "));
                    }),
                    InputValueDefinition: Ue(function(e) {
                        var t = e.directives;
                        return Be([
                            e.name + ": " + e.type,
                            Ve("= ", e.defaultValue),
                            Be(t, " ")
                        ], " ");
                    }),
                    InterfaceTypeDefinition: Ue(function(e) {
                        var t = e.fields;
                        return Be([
                            "interface",
                            e.name,
                            Be(e.directives, " "),
                            Qe(t)
                        ], " ");
                    }),
                    UnionTypeDefinition: Ue(function(e) {
                        var t = e.types;
                        return Be([
                            "union",
                            e.name,
                            Be(e.directives, " "),
                            t && 0 !== t.length ? "= " + Be(t, " | ") : ""
                        ], " ");
                    }),
                    EnumTypeDefinition: Ue(function(e) {
                        var t = e.values;
                        return Be([
                            "enum",
                            e.name,
                            Be(e.directives, " "),
                            Qe(t)
                        ], " ");
                    }),
                    EnumValueDefinition: Ue(function(e) {
                        return Be([
                            e.name,
                            Be(e.directives, " ")
                        ], " ");
                    }),
                    InputObjectTypeDefinition: Ue(function(e) {
                        var t = e.fields;
                        return Be([
                            "input",
                            e.name,
                            Be(e.directives, " "),
                            Qe(t)
                        ], " ");
                    }),
                    DirectiveDefinition: Ue(function(e) {
                        var t = e.arguments, r = e.repeatable, n = e.locations;
                        return "directive @" + e.name + (ze(t) ? Ve("(\n", qe(Be(t, "\n")), "\n)") : Ve("(", Be(t, ", "), ")")) + (r ? " repeatable" : "") + " on " + Be(n, " | ");
                    }),
                    SchemaExtension: function(e) {
                        var t = e.operationTypes;
                        return Be([
                            "extend schema",
                            Be(e.directives, " "),
                            Qe(t)
                        ], " ");
                    },
                    ScalarTypeExtension: function(e) {
                        return Be([
                            "extend scalar",
                            e.name,
                            Be(e.directives, " ")
                        ], " ");
                    },
                    ObjectTypeExtension: function(e) {
                        var t = e.directives, r = e.fields;
                        return Be([
                            "extend type",
                            e.name,
                            Ve("implements ", Be(e.interfaces, " & ")),
                            Be(t, " "),
                            Qe(r)
                        ], " ");
                    },
                    InterfaceTypeExtension: function(e) {
                        var t = e.fields;
                        return Be([
                            "extend interface",
                            e.name,
                            Be(e.directives, " "),
                            Qe(t)
                        ], " ");
                    },
                    UnionTypeExtension: function(e) {
                        var t = e.types;
                        return Be([
                            "extend union",
                            e.name,
                            Be(e.directives, " "),
                            t && 0 !== t.length ? "= " + Be(t, " | ") : ""
                        ], " ");
                    },
                    EnumTypeExtension: function(e) {
                        var t = e.values;
                        return Be([
                            "extend enum",
                            e.name,
                            Be(e.directives, " "),
                            Qe(t)
                        ], " ");
                    },
                    InputObjectTypeExtension: function(e) {
                        var t = e.fields;
                        return Be([
                            "extend input",
                            e.name,
                            Be(e.directives, " "),
                            Qe(t)
                        ], " ");
                    }
                };
                function Ue(e) {
                    return function(t) {
                        return Be([
                            t.description,
                            e(t)
                        ], "\n");
                    };
                }
                function Be(e, t) {
                    return e ? e.filter(function(e) {
                        return e;
                    }).join(t || "") : "";
                }
                function Qe(e) {
                    return e && 0 !== e.length ? "{\n" + qe(Be(e, "\n")) + "\n}" : "";
                }
                function Ve(e, t, r) {
                    return t ? e + t + (r || "") : "";
                }
                function qe(e) {
                    return e && "  " + e.replace(/\n/g, "\n  ");
                }
                function Ge(e) {
                    return -1 !== e.indexOf("\n");
                }
                function ze(e) {
                    return e && e.some(Ge);
                }
                var We = {
                    http: {
                        includeQuery: !0,
                        includeExtensions: !1
                    },
                    headers: {
                        accept: "*/*",
                        "content-type": "application/json"
                    },
                    options: {
                        method: "POST"
                    }
                }, $e = function(e, t, r) {
                    var n = new Error(r);
                    throw n.name = "ServerError", n.response = e, n.statusCode = e.status, n.result = t, n;
                }, He = function(e, t) {
                    for(var r = [], n = 2; n < arguments.length; n++)r[n - 2] = arguments[n];
                    var o = (0, i.pi)({}, t.options, {
                        headers: t.headers,
                        credentials: t.credentials
                    }), a = t.http;
                    r.forEach(function(e) {
                        o = (0, i.pi)({}, o, e.options, {
                            headers: (0, i.pi)({}, o.headers, e.headers)
                        }), e.credentials && (o.credentials = e.credentials), a = (0, i.pi)({}, a, e.http);
                    });
                    var s = e.query, u = {
                        operationName: e.operationName,
                        variables: e.variables
                    };
                    return a.includeExtensions && (u.extensions = e.extensions), a.includeQuery && (u.query = (0, f.Vn)(s, {
                        leave: je
                    })), {
                        options: o,
                        body: u
                    };
                }, Ke = function(e, t) {
                    var r;
                    try {
                        r = JSON.stringify(e);
                    } catch (e) {
                        var n = new l.ej(2);
                        throw n.parseError = e, n;
                    }
                    return r;
                }, Ye = function(e) {
                    void 0 === e && (e = {});
                    var t = e.uri, r = void 0 === t ? "/graphql" : t, n = e.fetch, o = e.includeExtensions, a = e.useGETForQueries, c = (0, i._T)(e, [
                        "uri",
                        "fetch",
                        "includeExtensions",
                        "useGETForQueries"
                    ]);
                    !function(e) {
                        if (!e && "undefined" == typeof fetch) throw new l.ej(1);
                    }(n), n || (n = fetch);
                    var f = {
                        http: {
                            includeExtensions: o
                        },
                        options: c.fetchOptions,
                        credentials: c.credentials,
                        headers: c.headers
                    };
                    return new u.i0(function(e) {
                        var t = function(e, t) {
                            var r = e.getContext().uri;
                            return r || ("function" == typeof t ? t(e) : t || "/graphql");
                        }(e, r), o = e.getContext(), c = {};
                        if (o.clientAwareness) {
                            var l = o.clientAwareness, p = l.name, d = l.version;
                            p && (c["apollographql-client-name"] = p), d && (c["apollographql-client-version"] = d);
                        }
                        var h, v = (0, i.pi)({}, c, o.headers), m = He(e, We, f, {
                            http: o.http,
                            options: o.fetchOptions,
                            credentials: o.credentials,
                            headers: v
                        }), y = m.options, g = m.body;
                        if (!y.signal) {
                            var E = function() {
                                if ("undefined" == typeof AbortController) return {
                                    controller: !1,
                                    signal: !1
                                };
                                var e = new AbortController;
                                return {
                                    controller: e,
                                    signal: e.signal
                                };
                            }();
                            (h = E.controller) && (y.signal = E.signal);
                        }
                        if (a && !e.query.definitions.some(function(e) {
                            return "OperationDefinition" === e.kind && "mutation" === e.operation;
                        }) && (y.method = "GET"), "GET" === y.method) {
                            var b = function(e, t) {
                                var r = [], n = function(e, t) {
                                    r.push(e + "=" + encodeURIComponent(t));
                                };
                                "query" in t && n("query", t.query);
                                t.operationName && n("operationName", t.operationName);
                                if (t.variables) {
                                    var i = void 0;
                                    try {
                                        i = Ke(t.variables);
                                    } catch (e) {
                                        return {
                                            parseError: e
                                        };
                                    }
                                    n("variables", i);
                                }
                                if (t.extensions) {
                                    var o = void 0;
                                    try {
                                        o = Ke(t.extensions);
                                    } catch (e) {
                                        return {
                                            parseError: e
                                        };
                                    }
                                    n("extensions", o);
                                }
                                var a = "", s = e, u = e.indexOf("#");
                                -1 !== u && (a = e.substr(u), s = e.substr(0, u));
                                var c = -1 === s.indexOf("?") ? "?" : "&", l = s + c + r.join("&") + a;
                                return {
                                    newURI: l
                                };
                            }(t, g), S = b.newURI, _ = b.parseError;
                            if (_) return (0, u.Qc)(_);
                            t = S;
                        } else try {
                            y.body = Ke(g);
                        } catch (_) {
                            return (0, u.Qc)(_);
                        }
                        return new s.Z(function(r) {
                            var i;
                            return n(t, y).then(function(t) {
                                return e.setContext({
                                    response: t
                                }), t;
                            }).then((i = e, function(e) {
                                return e.text().then(function(t) {
                                    try {
                                        return JSON.parse(t);
                                    } catch (n) {
                                        var r = n;
                                        return r.name = "ServerParseError", r.response = e, r.statusCode = e.status, r.bodyText = t, Promise.reject(r);
                                    }
                                }).then(function(t) {
                                    return e.status >= 300 && $e(e, t, "Response not successful: Received status code " + e.status), Array.isArray(t) || t.hasOwnProperty("data") || t.hasOwnProperty("errors") || $e(e, t, "Server response was missing for query '" + (Array.isArray(i) ? i.map(function(e) {
                                        return e.operationName;
                                    }) : i.operationName) + "'."), t;
                                });
                            })).then(function(e) {
                                return r.next(e), r.complete(), e;
                            }).catch(function(e) {
                                "AbortError" !== e.name && (e.result && e.result.errors && e.result.data && r.next(e.result), r.error(e));
                            }), function() {
                                h && h.abort();
                            };
                        });
                    });
                };
                var Xe = function(e) {
                    function t(t) {
                        return e.call(this, Ye(t).request) || this;
                    }
                    return (0, i.ZT)(t, e), t;
                }(u.i0);
                function Je(e) {
                    return new u.i0(function(t, r) {
                        return new s.Z(function(n) {
                            var i, o, a;
                            try {
                                i = r(t).subscribe({
                                    next: function(i) {
                                        i.errors && (a = e({
                                            graphQLErrors: i.errors,
                                            response: i,
                                            operation: t,
                                            forward: r
                                        })) ? o = a.subscribe({
                                            next: n.next.bind(n),
                                            error: n.error.bind(n),
                                            complete: n.complete.bind(n)
                                        }) : n.next(i);
                                    },
                                    error: function(i) {
                                        (a = e({
                                            operation: t,
                                            networkError: i,
                                            graphQLErrors: i && i.result && i.result.errors,
                                            forward: r
                                        })) ? o = a.subscribe({
                                            next: n.next.bind(n),
                                            error: n.error.bind(n),
                                            complete: n.complete.bind(n)
                                        }) : n.error(i);
                                    },
                                    complete: function() {
                                        a || n.complete.bind(n)();
                                    }
                                });
                            } catch (i) {
                                e({
                                    networkError: i,
                                    operation: t,
                                    forward: r
                                }), n.error(i);
                            }
                            return function() {
                                i && i.unsubscribe(), o && i.unsubscribe();
                            };
                        });
                    });
                }
                !function(e) {
                    function t(t) {
                        var r = e.call(this) || this;
                        return r.link = Je(t), r;
                    }
                    (0, i.ZT)(t, e), t.prototype.request = function(e, t) {
                        return this.link.request(e, t);
                    };
                }(u.i0);
                var Ze = r(3941), et = [
                    "request",
                    "uri",
                    "credentials",
                    "headers",
                    "fetch",
                    "fetchOptions",
                    "clientState",
                    "onError",
                    "cacheRedirects",
                    "cache",
                    "name",
                    "version",
                    "resolvers",
                    "typeDefs",
                    "fragmentMatcher"
                ], tt = function(e) {
                    function t(t) {
                        void 0 === t && (t = {});
                        if (t) Object.keys(t).filter(function(e) {
                            return -1 === et.indexOf(e);
                        });
                        var r = t.request, n = t.uri, i = t.credentials, o = t.headers, a = t.fetch, c = t.fetchOptions, f = t.clientState, p = t.cacheRedirects, d = t.onError, h = t.name, v = t.version, m = t.resolvers, y = t.typeDefs, g = t.fragmentMatcher, E = t.cache;
                        (0, l.kG)(!E || !p, 1), E || (E = p ? new Fe({
                            cacheRedirects: p
                        }) : new Fe);
                        var b = Je(d || function(e) {
                            var t = e.graphQLErrors;
                            t && t.forEach(function(e) {
                                return !0;
                            });
                        }), S = !!r && new u.i0(function(e, t) {
                            return new s.Z(function(n) {
                                var i;
                                return Promise.resolve(e).then(function(e) {
                                    return r(e);
                                }).then(function() {
                                    i = t(e).subscribe({
                                        next: n.next.bind(n),
                                        error: n.error.bind(n),
                                        complete: n.complete.bind(n)
                                    });
                                }).catch(n.error.bind(n)), function() {
                                    i && i.unsubscribe();
                                };
                            });
                        }), _ = new Xe({
                            uri: n || "/graphql",
                            fetch: a,
                            fetchOptions: c || {},
                            credentials: i || "same-origin",
                            headers: o || {}
                        }), w = u.i0.from([
                            b,
                            S,
                            _
                        ].filter(function(e) {
                            return !!e;
                        })), O = m, T = y, I = g;
                        return f && (f.defaults && E.writeData({
                            data: f.defaults
                        }), O = f.resolvers, T = f.typeDefs, I = f.fragmentMatcher), e.call(this, {
                            cache: E,
                            link: w,
                            name: h,
                            version: v,
                            resolvers: O,
                            typeDefs: T,
                            fragmentMatcher: I
                        }) || this;
                    }
                    return (0, i.ZT)(t, e), t;
                }(N);
                const rt = tt;
            },
            7946: (e, t, r)=>{
                "use strict";
                r.r(t), r.d(t, {
                    setContext: ()=>a
                });
                var n = r(5949), i = r(4907), o = r(674);
                function a(e) {
                    return new i.i0(function(t, r) {
                        var i = (0, n._T)(t, []);
                        return new o.Z(function(n) {
                            var o;
                            return Promise.resolve(i).then(function(r) {
                                return e(r, t.getContext());
                            }).then(t.setContext).then(function() {
                                o = r(t).subscribe({
                                    next: n.next.bind(n),
                                    error: n.error.bind(n),
                                    complete: n.complete.bind(n)
                                });
                            }).catch(n.error.bind(n)), function() {
                                o && o.unsubscribe();
                            };
                        });
                    });
                }
            },
            4907: (e, t, r)=>{
                "use strict";
                r.d(t, {
                    $y: ()=>c,
                    Dp: ()=>m,
                    Qc: ()=>f,
                    Vi: ()=>u,
                    Vl: ()=>y,
                    cS: ()=>v,
                    ht: ()=>b,
                    i0: ()=>E,
                    p4: ()=>l,
                    rY: ()=>a.rY,
                    y$: ()=>n.Z,
                    zi: ()=>p,
                    zo: ()=>g
                });
                var n = r(674), i = r(8754), o = r(5949), a = r(52);
                !function(e) {
                    function t(t, r) {
                        var n = e.call(this, t) || this;
                        return n.link = r, n;
                    }
                    (0, o.ZT)(t, e);
                }(Error);
                function s(e) {
                    return e.request.length <= 1;
                }
                function u(e) {
                    var t = !1;
                    return new Promise(function(r, n) {
                        e.subscribe({
                            next: function(e) {
                                t || (t = !0, r(e));
                            },
                            error: n
                        });
                    });
                }
                var c = u;
                function l(e) {
                    return new n.Z(function(t) {
                        e.then(function(e) {
                            t.next(e), t.complete();
                        }).catch(t.error.bind(t));
                    });
                }
                function f(e) {
                    return new n.Z(function(t) {
                        t.error(e);
                    });
                }
                function p(e, t) {
                    var r = (0, o.pi)({}, e);
                    return Object.defineProperty(t, "setContext", {
                        enumerable: !1,
                        value: function(e) {
                            r = (0, o.pi)({}, r, "function" == typeof e ? e(r) : e);
                        }
                    }), Object.defineProperty(t, "getContext", {
                        enumerable: !1,
                        value: function() {
                            return (0, o.pi)({}, r);
                        }
                    }), Object.defineProperty(t, "toKey", {
                        enumerable: !1,
                        value: function() {
                            return function(e) {
                                var t = e.query, r = e.variables, n = e.operationName;
                                return JSON.stringify([
                                    n,
                                    t,
                                    r
                                ]);
                            }(t);
                        }
                    }), t;
                }
                function d(e, t) {
                    return t ? t(e) : n.Z.of();
                }
                function h(e) {
                    return "function" == typeof e ? new E(e) : e;
                }
                function v() {
                    return new E(function() {
                        return n.Z.of();
                    });
                }
                function m(e) {
                    return 0 === e.length ? v() : e.map(h).reduce(function(e, t) {
                        return e.concat(t);
                    });
                }
                function y(e, t, r) {
                    var i = h(t), o = h(r || new E(d));
                    return s(i) && s(o) ? new E(function(t) {
                        return e(t) ? i.request(t) || n.Z.of() : o.request(t) || n.Z.of();
                    }) : new E(function(t, r) {
                        return e(t) ? i.request(t, r) || n.Z.of() : o.request(t, r) || n.Z.of();
                    });
                }
                var g = function(e, t) {
                    var r = h(e);
                    if (s(r)) return r;
                    var i = h(t);
                    return s(i) ? new E(function(e) {
                        return r.request(e, function(e) {
                            return i.request(e) || n.Z.of();
                        }) || n.Z.of();
                    }) : new E(function(e, t) {
                        return r.request(e, function(e) {
                            return i.request(e, t) || n.Z.of();
                        }) || n.Z.of();
                    });
                }, E = function() {
                    function e(e) {
                        e && (this.request = e);
                    }
                    return e.prototype.split = function(t, r, n) {
                        return this.concat(y(t, r, n || new e(d)));
                    }, e.prototype.concat = function(e) {
                        return g(this, e);
                    }, e.prototype.request = function(e, t) {
                        throw new i.ej(1);
                    }, e.empty = v, e.from = m, e.split = y, e.execute = b, e;
                }();
                function b(e, t) {
                    return e.request(p(t.context, function(e) {
                        var t = {
                            variables: e.variables || {},
                            extensions: e.extensions || {},
                            operationName: e.operationName,
                            query: e.query
                        };
                        return t.operationName || (t.operationName = "string" != typeof t.query ? (0, a.rY)(t.query) : ""), t;
                    }(function(e) {
                        for(var t = [
                            "query",
                            "operationName",
                            "variables",
                            "extensions",
                            "context"
                        ], r = 0, n = Object.keys(e); r < n.length; r++)if (t.indexOf(n[r]) < 0) throw new i.ej(2);
                        return e;
                    }(t)))) || n.Z.of();
                }
            },
            52: (e, t, r)=>{
                "use strict";
                r.d(t, {
                    $H: ()=>R,
                    Ao: ()=>v,
                    Ee: ()=>re,
                    F: ()=>k,
                    FS: ()=>S,
                    Fo: ()=>V,
                    Gw: ()=>B,
                    LZ: ()=>b,
                    My: ()=>h,
                    NC: ()=>p,
                    O4: ()=>M,
                    PT: ()=>f,
                    Qy: ()=>E,
                    XY: ()=>Z,
                    Xh: ()=>H,
                    Y8: ()=>J,
                    Yk: ()=>O,
                    aL: ()=>G,
                    aX: ()=>y,
                    bw: ()=>ne,
                    cQ: ()=>m,
                    d2: ()=>ee,
                    f0: ()=>T,
                    iW: ()=>N,
                    kU: ()=>A,
                    mj: ()=>_,
                    mr: ()=>W,
                    ob: ()=>z,
                    p$: ()=>C,
                    rY: ()=>x,
                    u2: ()=>d,
                    v4: ()=>g,
                    vf: ()=>c,
                    yv: ()=>X
                });
                var n = r(7525), i = r(8754), o = r(5949), a = r(7362), s = r.n(a);
                r(1673);
                function u(e, t, r, n) {
                    if (function(e) {
                        return "IntValue" === e.kind;
                    }(r) || function(e) {
                        return "FloatValue" === e.kind;
                    }(r)) e[t.value] = Number(r.value);
                    else if (function(e) {
                        return "BooleanValue" === e.kind;
                    }(r) || function(e) {
                        return "StringValue" === e.kind;
                    }(r)) e[t.value] = r.value;
                    else if (function(e) {
                        return "ObjectValue" === e.kind;
                    }(r)) {
                        var o = {};
                        r.fields.map(function(e) {
                            return u(o, e.name, e.value, n);
                        }), e[t.value] = o;
                    } else if (function(e) {
                        return "Variable" === e.kind;
                    }(r)) e[t.value] = (n || {})[r.name.value];
                    else if (function(e) {
                        return "ListValue" === e.kind;
                    }(r)) e[t.value] = r.values.map(function(e) {
                        var r = {};
                        return u(r, t, e, n), r[t.value];
                    });
                    else if (function(e) {
                        return "EnumValue" === e.kind;
                    }(r)) e[t.value] = r.value;
                    else {
                        if (!function(e) {
                            return "NullValue" === e.kind;
                        }(r)) throw new i.ej(17);
                        e[t.value] = null;
                    }
                }
                function c(e, t) {
                    var r = null;
                    e.directives && (r = {}, e.directives.forEach(function(e) {
                        r[e.name.value] = {}, e.arguments && e.arguments.forEach(function(n) {
                            return u(r[e.name.value], n.name, n.value, t);
                        });
                    }));
                    var n = null;
                    return e.arguments && e.arguments.length && (n = {}, e.arguments.forEach(function(e) {
                        return u(n, e.name, e.value, t);
                    })), f(e.name.value, n, r);
                }
                var l = [
                    "connection",
                    "include",
                    "skip",
                    "client",
                    "rest",
                    "export"
                ];
                function f(e, t, r) {
                    if (r && r.connection && r.connection.key) {
                        if (r.connection.filter && r.connection.filter.length > 0) {
                            var n = r.connection.filter ? r.connection.filter : [];
                            n.sort();
                            var i = t, o = {};
                            return n.forEach(function(e) {
                                o[e] = i[e];
                            }), r.connection.key + "(" + JSON.stringify(o) + ")";
                        }
                        return r.connection.key;
                    }
                    var a = e;
                    if (t) {
                        var u = s()(t);
                        a += "(" + u + ")";
                    }
                    return r && Object.keys(r).forEach(function(e) {
                        -1 === l.indexOf(e) && (r[e] && Object.keys(r[e]).length ? a += "@" + e + "(" + JSON.stringify(r[e]) + ")" : a += "@" + e);
                    }), a;
                }
                function p(e, t) {
                    if (e.arguments && e.arguments.length) {
                        var r = {};
                        return e.arguments.forEach(function(e) {
                            return u(r, e.name, e.value, t);
                        }), r;
                    }
                    return null;
                }
                function d(e) {
                    return e.alias ? e.alias.value : e.name.value;
                }
                function h(e) {
                    return "Field" === e.kind;
                }
                function v(e) {
                    return "InlineFragment" === e.kind;
                }
                function m(e) {
                    return e && "id" === e.type && "boolean" == typeof e.generated;
                }
                function y(e, t) {
                    return void 0 === t && (t = !1), (0, o.pi)({
                        type: "id",
                        generated: t
                    }, "string" == typeof e ? {
                        id: e,
                        typename: void 0
                    } : e);
                }
                function g(e) {
                    return null != e && "object" == typeof e && "json" === e.type;
                }
                function E(e, t) {
                    if (e.directives && e.directives.length) {
                        var r = {};
                        return e.directives.forEach(function(e) {
                            r[e.name.value] = p(e, t);
                        }), r;
                    }
                    return null;
                }
                function b(e, t) {
                    var r;
                    return void 0 === t && (t = {}), (r = e.directives, r ? r.filter(w).map(function(e) {
                        var t = e.arguments;
                        (0, i.kG)(t && 1 === t.length, 14);
                        var r = t[0];
                        (0, i.kG)(r.name && "if" === r.name.value, 15);
                        var n = r.value;
                        return (0, i.kG)(n && ("Variable" === n.kind || "BooleanValue" === n.kind), 16), {
                            directive: e,
                            ifArgument: r
                        };
                    }) : []).every(function(e) {
                        var r = e.directive, n = e.ifArgument, o = !1;
                        return "Variable" === n.value.kind ? (0, i.kG)(void 0 !== (o = t[n.value.name.value]), 13) : o = n.value.value, "skip" === r.name.value ? !o : o;
                    });
                }
                function S(e, t) {
                    return (function(e) {
                        var t = [];
                        return (0, n.Vn)(e, {
                            Directive: function(e) {
                                t.push(e.name.value);
                            }
                        }), t;
                    })(t).some(function(t) {
                        return e.indexOf(t) > -1;
                    });
                }
                function _(e) {
                    return e && S([
                        "client"
                    ], e) && S([
                        "export"
                    ], e);
                }
                function w(e) {
                    var t = e.name.value;
                    return "skip" === t || "include" === t;
                }
                function O(e, t) {
                    var r = t, n = [];
                    return e.definitions.forEach(function(e) {
                        if ("OperationDefinition" === e.kind) throw new i.ej(11);
                        "FragmentDefinition" === e.kind && n.push(e);
                    }), void 0 === r && ((0, i.kG)(1 === n.length, 12), r = n[0].name.value), (0, o.pi)((0, o.pi)({}, e), {
                        definitions: (0, o.pr)([
                            {
                                kind: "OperationDefinition",
                                operation: "query",
                                selectionSet: {
                                    kind: "SelectionSet",
                                    selections: [
                                        {
                                            kind: "FragmentSpread",
                                            name: {
                                                kind: "Name",
                                                value: r
                                            }
                                        }
                                    ]
                                }
                            }
                        ], e.definitions)
                    });
                }
                function T(e) {
                    for(var t = [], r = 1; r < arguments.length; r++)t[r - 1] = arguments[r];
                    return t.forEach(function(t) {
                        null != t && Object.keys(t).forEach(function(r) {
                            e[r] = t[r];
                        });
                    }), e;
                }
                function I(e) {
                    (0, i.kG)(e && "Document" === e.kind, 2);
                    var t = e.definitions.filter(function(e) {
                        return "FragmentDefinition" !== e.kind;
                    }).map(function(e) {
                        if ("OperationDefinition" !== e.kind) throw new i.ej(3);
                        return e;
                    });
                    return (0, i.kG)(t.length <= 1, 4), e;
                }
                function R(e) {
                    return I(e), e.definitions.filter(function(e) {
                        return "OperationDefinition" === e.kind;
                    })[0];
                }
                function x(e) {
                    return e.definitions.filter(function(e) {
                        return "OperationDefinition" === e.kind && e.name;
                    }).map(function(e) {
                        return e.name.value;
                    })[0] || null;
                }
                function A(e) {
                    return e.definitions.filter(function(e) {
                        return "FragmentDefinition" === e.kind;
                    });
                }
                function N(e) {
                    var t = R(e);
                    return (0, i.kG)(t && "query" === t.operation, 6), t;
                }
                function C(e) {
                    var t;
                    I(e);
                    for(var r = 0, n = e.definitions; r < n.length; r++){
                        var o = n[r];
                        if ("OperationDefinition" === o.kind) {
                            var a = o.operation;
                            if ("query" === a || "mutation" === a || "subscription" === a) return o;
                        }
                        "FragmentDefinition" !== o.kind || t || (t = o);
                    }
                    if (t) return t;
                    throw new i.ej(10);
                }
                function k(e) {
                    void 0 === e && (e = []);
                    var t = {};
                    return e.forEach(function(e) {
                        t[e.name.value] = e;
                    }), t;
                }
                function M(e) {
                    if (e && e.variableDefinitions && e.variableDefinitions.length) {
                        var t = e.variableDefinitions.filter(function(e) {
                            return e.defaultValue;
                        }).map(function(e) {
                            var t = {};
                            return u(t, e.variable.name, e.defaultValue), t;
                        });
                        return T.apply(void 0, (0, o.pr)([
                            {}
                        ], t));
                    }
                    return {};
                }
                function P(e, t, r) {
                    var n = 0;
                    return e.forEach(function(r, i) {
                        t.call(this, r, i, e) && (e[n++] = r);
                    }, r), e.length = n, e;
                }
                var D = {
                    kind: "Field",
                    name: {
                        kind: "Name",
                        value: "__typename"
                    }
                };
                function F(e, t) {
                    return e.selectionSet.selections.every(function(e) {
                        return "FragmentSpread" === e.kind && F(t[e.name.value], t);
                    });
                }
                function L(e) {
                    return F(R(e) || function(e) {
                        (0, i.kG)("Document" === e.kind, 7), (0, i.kG)(e.definitions.length <= 1, 8);
                        var t = e.definitions[0];
                        return (0, i.kG)("FragmentDefinition" === t.kind, 9), t;
                    }(e), k(A(e))) ? null : e;
                }
                function j(e) {
                    return function(t) {
                        return e.some(function(e) {
                            return e.name && e.name === t.name.value || e.test && e.test(t);
                        });
                    };
                }
                function U(e, t) {
                    var r = Object.create(null), i = [], a = Object.create(null), s = [], u = L((0, n.Vn)(t, {
                        Variable: {
                            enter: function(e, t, n) {
                                "VariableDefinition" !== n.kind && (r[e.name.value] = !0);
                            }
                        },
                        Field: {
                            enter: function(t) {
                                if (e && t.directives && e.some(function(e) {
                                    return e.remove;
                                }) && t.directives && t.directives.some(j(e))) return t.arguments && t.arguments.forEach(function(e) {
                                    "Variable" === e.value.kind && i.push({
                                        name: e.value.name.value
                                    });
                                }), t.selectionSet && q(t.selectionSet).forEach(function(e) {
                                    s.push({
                                        name: e.name.value
                                    });
                                }), null;
                            }
                        },
                        FragmentSpread: {
                            enter: function(e) {
                                a[e.name.value] = !0;
                            }
                        },
                        Directive: {
                            enter: function(t) {
                                if (j(e)(t)) return null;
                            }
                        }
                    }));
                    return u && P(i, function(e) {
                        return !r[e.name];
                    }).length && (u = function(e, t) {
                        var r = function(e) {
                            return function(t) {
                                return e.some(function(e) {
                                    return t.value && "Variable" === t.value.kind && t.value.name && (e.name === t.value.name.value || e.test && e.test(t));
                                });
                            };
                        }(e);
                        return L((0, n.Vn)(t, {
                            OperationDefinition: {
                                enter: function(t) {
                                    return (0, o.pi)((0, o.pi)({}, t), {
                                        variableDefinitions: t.variableDefinitions.filter(function(t) {
                                            return !e.some(function(e) {
                                                return e.name === t.variable.name.value;
                                            });
                                        })
                                    });
                                }
                            },
                            Field: {
                                enter: function(t) {
                                    if (e.some(function(e) {
                                        return e.remove;
                                    })) {
                                        var n = 0;
                                        if (t.arguments.forEach(function(e) {
                                            r(e) && (n += 1);
                                        }), 1 === n) return null;
                                    }
                                }
                            },
                            Argument: {
                                enter: function(e) {
                                    if (r(e)) return null;
                                }
                            }
                        }));
                    }(i, u)), u && P(s, function(e) {
                        return !a[e.name];
                    }).length && (u = function(e, t) {
                        function r(t) {
                            if (e.some(function(e) {
                                return e.name === t.name.value;
                            })) return null;
                        }
                        return L((0, n.Vn)(t, {
                            FragmentSpread: {
                                enter: r
                            },
                            FragmentDefinition: {
                                enter: r
                            }
                        }));
                    }(s, u)), u;
                }
                function B(e) {
                    return (0, n.Vn)(I(e), {
                        SelectionSet: {
                            enter: function(e, t, r) {
                                if (!r || "OperationDefinition" !== r.kind) {
                                    var n = e.selections;
                                    if (n) {
                                        if (!n.some(function(e) {
                                            return h(e) && ("__typename" === e.name.value || 0 === e.name.value.lastIndexOf("__", 0));
                                        })) {
                                            var i = r;
                                            if (!(h(i) && i.directives && i.directives.some(function(e) {
                                                return "export" === e.name.value;
                                            }))) return (0, o.pi)((0, o.pi)({}, e), {
                                                selections: (0, o.pr)(n, [
                                                    D
                                                ])
                                            });
                                        }
                                    }
                                }
                            }
                        }
                    });
                }
                var Q = {
                    test: function(e) {
                        var t = "connection" === e.name.value;
                        return t && (!e.arguments || e.arguments.some(function(e) {
                            return "key" === e.name.value;
                        })), t;
                    }
                };
                function V(e) {
                    return U([
                        Q
                    ], I(e));
                }
                function q(e) {
                    var t = [];
                    return e.selections.forEach(function(e) {
                        (h(e) || v(e)) && e.selectionSet ? q(e.selectionSet).forEach(function(e) {
                            return t.push(e);
                        }) : "FragmentSpread" === e.kind && t.push(e);
                    }), t;
                }
                function G(e) {
                    return "query" === C(e).operation ? e : (0, n.Vn)(e, {
                        OperationDefinition: {
                            enter: function(e) {
                                return (0, o.pi)((0, o.pi)({}, e), {
                                    operation: "query"
                                });
                            }
                        }
                    });
                }
                function z(e) {
                    I(e);
                    var t = U([
                        {
                            test: function(e) {
                                return "client" === e.name.value;
                            },
                            remove: !0
                        }
                    ], e);
                    return t && (t = (0, n.Vn)(t, {
                        FragmentDefinition: {
                            enter: function(e) {
                                if (e.selectionSet && e.selectionSet.selections.every(function(e) {
                                    return h(e) && "__typename" === e.name.value;
                                })) return null;
                            }
                        }
                    })), t;
                }
                var W = "function" == typeof WeakMap && !("object" == typeof navigator && "ReactNative" === navigator.product), $ = Object.prototype.toString;
                function H(e) {
                    return K(e, new Map);
                }
                function K(e, t) {
                    switch($.call(e)){
                        case "[object Array]":
                            if (t.has(e)) return t.get(e);
                            var r = e.slice(0);
                            return t.set(e, r), r.forEach(function(e, n) {
                                r[n] = K(e, t);
                            }), r;
                        case "[object Object]":
                            if (t.has(e)) return t.get(e);
                            var n = Object.create(Object.getPrototypeOf(e));
                            return t.set(e, n), Object.keys(e).forEach(function(r) {
                                n[r] = K(e[r], t);
                            }), n;
                        default:
                            return e;
                    }
                }
                function Y(e) {
                    return "development" === e;
                }
                function X() {
                    return !0 === Y("production");
                }
                function J() {
                    return !0 === Y("test");
                }
                function Z(e) {
                    try {
                        return e();
                    } catch (e) {
                        console.error && console.error(e);
                    }
                }
                function ee(e) {
                    return e.errors && e.errors.length;
                }
                var te = Object.prototype.hasOwnProperty;
                function re() {
                    for(var e = [], t = 0; t < arguments.length; t++)e[t] = arguments[t];
                    return ne(e);
                }
                function ne(e) {
                    var t = e[0] || {}, r = e.length;
                    if (r > 1) {
                        var n = [];
                        t = ae(t, n);
                        for(var i = 1; i < r; ++i)t = oe(t, e[i], n);
                    }
                    return t;
                }
                function ie(e) {
                    return null !== e && "object" == typeof e;
                }
                function oe(e, t, r) {
                    return ie(t) && ie(e) ? (Object.isExtensible && !Object.isExtensible(e) && (e = ae(e, r)), Object.keys(t).forEach(function(n) {
                        var i = t[n];
                        if (te.call(e, n)) {
                            var o = e[n];
                            i !== o && (e[n] = oe(ae(o, r), i, r));
                        } else e[n] = i;
                    }), e) : t;
                }
                function ae(e, t) {
                    return null !== e && "object" == typeof e && t.indexOf(e) < 0 && (e = Array.isArray(e) ? e.slice(0) : (0, o.pi)({
                        __proto__: Object.getPrototypeOf(e)
                    }, e), t.push(e)), e;
                }
                Object.create({});
            },
            3589: (e, t, r)=>{
                "use strict";
                var n, i, o;
                r(5710)(t, "__esModule", {
                    value: !0
                }), t.SUPPORTED_IOS_VERSION = t.RemotePointerEventAction = t.PointerType = t.PointerEventType = t.PointerEventPenButton = void 0, function(e) {
                    e.MOUSE = "mouse", e.PEN = "pen", e.TOUCH = "touch";
                }(n || (t.PointerType = n = {})), function(e) {
                    e.MOVE = "pointermove", e.DOWN = "pointerdown", e.UP = "pointerup", e.LEAVE = "pointerleave", e.ACTIVITY = "pointeractivity", e.OUT = "pointerout";
                }(i || (t.PointerEventType = i = {})), function(e) {
                    e[e.NO_BUTTON = 0] = "NO_BUTTON", e[e.TIP = 1] = "TIP", e[e.BARREL = 2] = "BARREL", e[e.ERASER = 32] = "ERASER";
                }(o || (t.PointerEventPenButton = o = {}));
                t.SUPPORTED_IOS_VERSION = 13;
                var a;
                !function(e) {
                    e.SEND = "send-remote-pointer-event", e.PROPAGATE = "propagate-remote-pointer-event", e.DISPATCH = "dispatch-remote-pointer-event";
                }(a || (t.RemotePointerEventAction = a = {}));
            },
            8569: (e, t, r)=>{
                "use strict";
                var n, i;
                r(5710)(t, "__esModule", {
                    value: !0
                }), t.MediaInputType = t.CloseAction = void 0, function(e) {
                    e.VIDEO_INPUT = "videoinput", e.AUDIO_INPUT = "audioinput";
                }(n || (t.MediaInputType = n = {})), function(e) {
                    e.DISCONNECTED = "disconnected", e.CLOSED = "closed";
                }(i || (t.CloseAction = i = {}));
            },
            1427: (e, t, r)=>{
                "use strict";
                var n;
                r(5710)(t, "__esModule", {
                    value: !0
                }), t.SessionStartProgress = void 0, function(e) {
                    e.CONNECTING = "connecting", e.CONNECTED = "connected", e.RECONNECTING = "reconnecting", e.DONE = "done";
                }(n || (t.SessionStartProgress = n = {}));
            },
            8083: (e, t, r)=>{
                "use strict";
                var n;
                r(5710)(t, "__esModule", {
                    value: !0
                }), t.TerminalConnectionErrorCode = void 0, function(e) {
                    e[e.CONNECT_TIMEOUT = 4101] = "CONNECT_TIMEOUT", e[e.CONNECTION_OFFLINE = 4102] = "CONNECTION_OFFLINE", e[e.RECONNECT = 4103] = "RECONNECT", e[e.CONNECTION_CANCELED = 4105] = "CONNECTION_CANCELED", e[e.RECONNECT_FAILED = 4106] = "RECONNECT_FAILED", e[e.SIGNALING_PEERS_TIMEOUT = 4107] = "SIGNALING_PEERS_TIMEOUT", e[e.WEBRTC_ICE_DISCONNECT = 4108] = "WEBRTC_ICE_DISCONNECT";
                }(n || (t.TerminalConnectionErrorCode = n = {}));
            },
            8980: (e, t, r)=>{
                "use strict";
                r(5710)(t, "__esModule", {
                    value: !0
                }), t.GraphQlClient = void 0;
                var n = r(7298), i = r(7946), o = r(5901), a = r(9777);
                t.GraphQlClient = class extends n.ApolloClient {
                    constructor(e, t){
                        const r = new n.HttpLink({
                            uri: t.url
                        }), o = (0, i.setContext)(async ()=>({
                                headers: {
                                    authorization: `Bearer ${await e.getToken()}`
                                }
                            }));
                        super({
                            link: n.ApolloLink.from([
                                o,
                                r
                            ]),
                            cache: new n.InMemoryCache({
                                addTypename: !1
                            }),
                            defaultOptions: {
                                query: {
                                    fetchPolicy: "no-cache",
                                    errorPolicy: "all"
                                },
                                mutate: {
                                    fetchPolicy: "no-cache",
                                    errorPolicy: "all"
                                }
                            }
                        });
                    }
                    async mutate(e) {
                        const t = await super.mutate(e);
                        if (t.errors) throw new o.ServiceGraphQlError(t.errors);
                        if (!t.data) throw new a.UnexpectedServiceError;
                        return t.data;
                    }
                    async query(e) {
                        const t = await super.query(e);
                        if (t.errors) throw new o.ServiceGraphQlError(t.errors);
                        if (!t.data) throw new a.UnexpectedServiceError;
                        return t.data;
                    }
                };
            },
            1457: (e, t, r)=>{
                "use strict";
                r(5710)(t, "__esModule", {
                    value: !0
                }), t.SimpleTokenProvider = void 0;
                var n = r(6884);
                t.SimpleTokenProvider = class {
                    constructor(e){
                        this._token = e;
                    }
                    async getToken() {
                        if (!this._token) throw new n.InvalidStateError("SimpleTokenProvider: missing token.");
                        return this._token;
                    }
                    setToken(e) {
                        this._token = e;
                    }
                };
            },
            5910: (e, t, r)=>{
                "use strict";
                var n = r(5710), i = r(9534);
                n(t, "__esModule", {
                    value: !0
                }), t.TERMINAL_SYSTEM_CONFIG_QUERY = t.TERMINAL_CONFIG_QUERY = void 0;
                var o = i(r(3941));
                const a = o.default`
  fragment KeyboardProfileFragment on KeyboardProfile {
    languageId
    isDefault
    name
    configurations {
      clientOsName
      mappings {
        keys
        action
        remapKeys
      }
    }
  }
`;
                t.TERMINAL_CONFIG_QUERY = o.default`
    query TerminalConfigQuery($terminalConfigurationId: ID!) {
      user: me {
        id
        email
        firstName
        lastName
      }
      terminalConfiguration(terminalConfigurationId: $terminalConfigurationId) {
        kind
        keyboard {
          profiles {
            ...KeyboardProfileFragment
          }
        }
        session {
          idleTimeoutMinutes
          maxSessionDurationMinutes
          userInactivityTimeoutMinutes
          rebootTime
          rebootNotificationPeriod
        }
        system {
          terminalUrl
          environment
        }
        video {
          yuv444
          maxBandwidthKbps
          maxFrameRateFps
          maxVideoBitRateMbps
          maxVideoQuantization
          qosRateChange
        }
        audio {
          maxAudioBitRateKbps
          autoplay
        }
        features {
          appSwitching {isEnabled}
          clipboard {
            isEnabled,
            direction
          }
          download {isEnabled}
          camera {isEnabled}
          microphone {isEnabled}
          usbRedirection {isEnabled}
          print {isEnabled}
          settingsDialog {isEnabled}
          upload {isEnabled}
          customHeader {
            isEnabled
            message
            color
            backgroundColor
          }
          sessionShare {isEnabled}
          sessionSuspending {isEnabled}
        }
        experimental {
          advancedSessionStartParameters
        }
        logging {
          isLocalConsoleEnabled
          isLogglyEnabled
          isSentryEnabled
          isSplunkEnabled
          sessionMessagesUrl
          splunkLoggingUrl,
        }
        items {
          id
          kind
          name
          order
          parentId
          ...on ApplicationItem {
            applicationId
            path
            workingDirectory
            arguments
            iconUrl
          }
          ...on FolderItem {
            items {
              ...on ApplicationItem {
                id
                kind
                name
                order
                parentId
                applicationId
                path
                workingDirectory
                arguments
                iconUrl
              }
            }
          }
        }
      }
    }
    ${a}
  `, t.TERMINAL_SYSTEM_CONFIG_QUERY = o.default`
    query TerminalSystemConfigQuery($terminalConfigurationId: ID!) {
      terminalConfiguration(terminalConfigurationId: $terminalConfigurationId) {
        system {
          terminalUrl
          terminalBuild
        }
      }
    }
  `;
            },
            87: (e, t, r)=>{
                "use strict";
                var n;
                r(5710)(t, "__esModule", {
                    value: !0
                }), t.TerminalEvent = void 0, function(e) {
                    e.SESSION_STARTING = "session-starting", e.SESSION_STARTED = "session-started", e.SESSION_RESUMING = "session-resuming", e.SESSION_RESUMED = "session-resumed", e.SESSION_JOINING = "session-joining", e.SESSION_JOINED = "session-joined", e.SESSION_CLOSING = "session-closing", e.SESSION_CLOSED = "session-closed", e.SESSION_DISCONNECTED = "session-disconnected", e.SESSION_SUSPEND = "session-suspend", e.SESSION_STATISTICS = "session-statistics", e.NO_RUNNING_APPS = "no-running-apps", e.USER_INACTIVE = "user-inactive", e.READY_FOR_INTERACTION = "ready-for-interaction", e.SESSION_START_PROGRESS = "session-start-progress";
                }(n || (t.TerminalEvent = n = {}));
            },
            5141: (e, t, r)=>{
                "use strict";
                var n;
                r(5710)(t, "__esModule", {
                    value: !0
                }), t.TerminalState = void 0, function(e) {
                    e.READY = "ready", e.RUNNING = "running", e.STARTING = "starting", e.STOPPING = "stopping";
                }(n || (t.TerminalState = n = {}));
            },
            8901: (e, t, r)=>{
                "use strict";
                var n = r(5710);
                n(t, "__esModule", {
                    value: !0
                }), n(t, "SessionStartProgress", {
                    enumerable: !0,
                    get: function() {
                        return h.SessionStartProgress;
                    }
                }), n(t, "SessionState", {
                    enumerable: !0,
                    get: function() {
                        return d.SessionState;
                    }
                }), t.TerminalBuild = void 0, n(t, "TerminalError", {
                    enumerable: !0,
                    get: function() {
                        return l.ErrorType;
                    }
                }), n(t, "TerminalErrorCode", {
                    enumerable: !0,
                    get: function() {
                        return a.TerminalErrorCode;
                    }
                }), n(t, "TerminalEvent", {
                    enumerable: !0,
                    get: function() {
                        return f.TerminalEvent;
                    }
                }), n(t, "TerminalState", {
                    enumerable: !0,
                    get: function() {
                        return p.TerminalState;
                    }
                }), t.createInstance = async function(e) {
                    if (console.log("Terminal instance initiated, using Terminal Api version:", "7.13.0"), !(0, s.isBrowserSupported)()) {
                        const e = (0, u.getBrowserName)(), t = (0, u.getBrowserVersion)();
                        throw console.error("Frame Terminal", "unsupported browser", {
                            browserName: e,
                            browserVersion: t
                        }), new o.NotSupportedError(`Terminal: Browser ${e} version ${t} is not supported.`, a.TerminalErrorCode.UNSUPPORTED_BROWSER);
                    }
                    const t = await (0, c.getTerminalUrl)(e.terminalConfigId, e.token, e.serviceUrl), r = await (0, c.getTerminalManifest)(t);
                    return (await (0, c.getTerminalApi)(r["terminal.js"])).createTerminal({
                        assetUrl: t,
                        manifest: r,
                        terminalApiVersion: "7.13.0",
                        ...e
                    });
                }, n(t, "isBrowserSupported", {
                    enumerable: !0,
                    get: function() {
                        return s.isBrowserSupported;
                    }
                }), r(8566);
                var i, o = r(8051), a = r(1158), s = r(4403), u = r(4709), c = r(4257), l = r(6368), f = r(87), p = r(5141), d = r(4958), h = r(1427);
                !function(e) {
                    e.LATEST = "latest", e.PREVIOUS = "previous", e.EXPERIMENTAL = "experimental";
                }(i || (t.TerminalBuild = i = {}));
            },
            4257: (e, t, r)=>{
                "use strict";
                var n = r(5710), i = r(9534);
                n(t, "__esModule", {
                    value: !0
                }), t.getTerminalApi = function(e) {
                    const t = window, r = t.TerminalApi;
                    delete t.TerminalApi;
                    const n = document.createElement("script");
                    n.src = e, "charset" in n && (n.charset = "utf-8");
                    return document.body.appendChild(n), new a.default((e, i)=>{
                        n.onload = ()=>{
                            t.TerminalApi ? e(t.TerminalApi) : i(new v.TerminalLoadFailedError("TerminalApi is not loaded")), r ? t.TerminalApi = r : delete t.TerminalApi;
                        }, n.onerror = i;
                    });
                }, t.getTerminalManifest = m, t.getTerminalUrl = async function(e, t, r) {
                    const n = new d.GraphQlClient(new h.SimpleTokenProvider(t), {
                        url: r
                    }), i = await n.query({
                        query: l.TERMINAL_SYSTEM_CONFIG_QUERY,
                        variables: {
                            terminalConfigurationId: e
                        }
                    }), { terminalUrl: o, terminalBuild: a } = i.terminalConfiguration.system;
                    return async function(e, t) {
                        let r = `${e}/${t}/${p.BundlePath.ES6}`;
                        t === f.TerminalBuild.LATEST || await async function(e) {
                            try {
                                return await m(e), !0;
                            } catch (t) {
                                return console.warn(`Failed to validate the terminal URL: ${e}, error`, t), !1;
                            }
                        }(r) || (r = `${e}/${f.TerminalBuild.LATEST}/${p.BundlePath.ES6}`);
                        return console.log(`Terminal url is set to ${r}`), r;
                    }(o, a);
                };
                var o = i(r(1982)), a = i(r(8756)), s = i(r(6812)), u = r(8362), c = r(3354), l = r(5910), f = r(8901), p = r(1660), d = r(8980), h = r(1457), v = r(1586);
                async function m(e) {
                    const t = new s.default((0, u.normalizeDirectoryUrl)(e)).filename("manifest.json").search(`t=${(0, o.default)()}`).toString(), r = await (await fetch(t)).json();
                    return (0, c.resolveAssetRecursive)(r, e);
                }
            },
            4958: (e, t, r)=>{
                "use strict";
                var n;
                r(5710)(t, "__esModule", {
                    value: !0
                }), t.SessionState = void 0, function(e) {
                    e.OPEN = "OPEN", e.CLOSED = "CLOSED", e.CLOSING = "CLOSING", e.FAILED = "FAILED", e.INIT = "INIT", e.RESERVED = "RESERVED";
                }(n || (t.SessionState = n = {}));
            },
            6368: (e, t, r)=>{
                "use strict";
                r(5710)(t, "__esModule", {
                    value: !0
                }), t.ErrorType = void 0;
                var n = r(5509), i = r(4104), o = r(5161), a = r(9680), s = r(3917), u = r(7422), c = r(6955), l = r(1423), f = r(8560), p = r(5551), d = r(2439), h = r(2127), v = r(9562), m = r(4401), y = r(5215), g = r(4281), E = r(2773), b = r(123), S = r(4909), _ = r(2141), w = r(2074), O = r(8404), T = r(6959), I = r(3645), R = r(4601), x = r(4813), A = r(5402), N = r(7491), C = r(5008), k = r(2743), M = r(806), P = r(2232), D = r(2145), F = r(5686), L = r(2502), j = r(4829), U = r(9043), B = r(8347), Q = r(2416), V = r(4934), q = r(3556), G = r(1419), z = r(1586), W = r(1934), $ = r(8280), H = r(4162), K = r(4046), Y = r(937), X = r(6868), J = r(9472), Z = r(6884), ee = r(1675), te = r(610), re = r(8051), ne = r(5680), ie = r(2569), oe = r(5901), ae = r(453), se = r(1158), ue = r(5421), ce = r(9777), le = r(3443), fe = r(7529), pe = r(2146), de = r(4111), he = r(2067), ve = r(1441), me = r(3549), ye = r(9418);
                t.ErrorType = {
                    AddMediaStreamTrackError: q.AddMediaStreamTrackError,
                    ApiDestroyedError: I.ApiDestroyedError,
                    ApplicationCloseFailedError: n.ApplicationCloseFailedError,
                    ApplicationFocusFailedError: i.ApplicationFocusFailedError,
                    ApplicationStartFailedError: o.ApplicationStartFailedError,
                    BufferTooSmallError: w.BufferTooSmallError,
                    CachedDataOverflowError: O.CachedDataOverflowError,
                    ConfigValidationError: G.ConfigValidationError,
                    ConnectionAbortedError: E.ConnectionAbortedError,
                    ConnectionCanceledError: b.ConnectionCanceledError,
                    ConnectionDestroyedError: pe.ConnectionDestroyedError,
                    ConnectionFailedError: S.ConnectionFailedError,
                    ConnectionLostError: de.ConnectionLostError,
                    ConnectionRefusedError: L.ConnectionRefusedError,
                    ControllerDestroyedError: $.ControllerDestroyedError,
                    DisplayConfigurationError: H.DisplayConfigurationError,
                    DomainJoinError: K.DomainJoinError,
                    FileModifiedError: p.FileModifiedError,
                    FileUploadCanceledError: d.FileUploadCanceledError,
                    FileUploadFailedError: h.FileUploadFailedError,
                    ForcePixelRatioError: Y.ForcePixelRatioError,
                    ForceResolutionError: X.ForceResolutionError,
                    InternalRpcError: he.InternalRpcError,
                    InvalidHidDeviceError: B.InvalidHidDeviceError,
                    InvalidMassStorageCmdError: j.InvalidMassStorageCmdError,
                    InvalidParamsError: J.InvalidParamsError,
                    InvalidStateError: Z.InvalidStateError,
                    MethodNotImplementedError: ee.MethodNotImplementedError,
                    MethodNotSupportedError: W.MethodNotSupportedError,
                    Mp4VideoStreamCorruptedError: a.Mp4VideoStreamCorruptedError,
                    Mp4VideoStreamFrozenError: s.Mp4VideoStreamFrozenError,
                    NotFoundError: te.NotFoundError,
                    NotSupportedError: re.NotSupportedError,
                    PlayerFailedError: l.PlayerFailedError,
                    PlayerStartCanceledError: m.PlayerStartCanceledError,
                    ReadingAbortedError: v.ReadingAbortedError,
                    RpcCallbackNotFoundError: ve.RpcCallbackNotFoundError,
                    RpcError: me.RpcError,
                    RpcExecutionError: ye.RpcExecutionError,
                    ServerApplicationStartFailedError: T.ServerApplicationStartFailedError,
                    ServerError: ne.ServerError,
                    ServiceError: ie.ServiceError,
                    ServiceGraphQlError: oe.ServiceGraphQlError,
                    ShortcutsConfigurationError: ae.ShortcutsConfigurationError,
                    SignalingConnectTimeoutError: k.SignalingConnectTimeoutError,
                    SignalingServerMissingUrlError: y.SignalingServerMissingUrlError,
                    TerminalError: se.TerminalError,
                    TerminalInternalError: ue.TerminalInternalError,
                    TerminalLoadFailedError: z.TerminalLoadFailedError,
                    TurnServerCredentialsError: M.TurnServerCredentialsError,
                    TurnServerCredentialsNotParsableError: P.TurnServerCredentialsNotParsableError,
                    TurnServerInternalServerError: D.TurnServerInternalServerError,
                    TurnServerMissingPropertyError: F.TurnServerMissingPropertyError,
                    UnexpectedServiceError: ce.UnexpectedServiceError,
                    UsbDeviceControllerError: Q.UsbDeviceControllerError,
                    UsbDeviceManagerError: V.UsbDeviceManagerError,
                    UsbDeviceNotFoundError: U.UsbDeviceNotFoundError,
                    UserAbortedConnectionError: f.UserAbortedConnectionError,
                    UserCanceledDomainJoinError: le.UserCanceledDomainJoinError,
                    UserInactivityError: g.UserInactivityError,
                    UserQuitDomainJoinError: fe.UserQuitDomainJoinError,
                    WebGlError: u.WebGlError,
                    WebRTCNegotiationTimeoutError: R.WebRTCNegotiationTimeoutError,
                    WebRTCPlayerCrashedError: c.WebRTCPlayerCrashedError,
                    WebRTCReconnectSignalingClientTimeoutError: x.WebRTCReconnectSignalingClientTimeoutError,
                    WebRTCRenegotiationTimeoutError: A.WebRTCRenegotiationTimeoutError,
                    WebRTCStunServerUnreachableError: N.WebRTCStunServerUnreachableError,
                    WebRTCTurnServerUnreachableError: C.WebRTCTurnServerUnreachableError,
                    WsConnectionError: _.WsConnectionError
                };
            },
            4403: (e, t, r)=>{
                "use strict";
                var n = r(5710), i = r(9534);
                n(t, "__esModule", {
                    value: !0
                }), t.BrowserVersion = t.Browser = void 0, t.isBrowserSupported = function() {
                    const e = (0, c.getBrowserName)(), t = (0, c.getBrowserVersion)(), r = (function(e) {
                        const t = new s.default([
                            [
                                o.CHROME,
                                a.CHROME
                            ],
                            [
                                o.FIREFOX,
                                a.FIREFOX
                            ],
                            [
                                o.SAFARI,
                                a.SAFARI
                            ],
                            [
                                o.EDGE,
                                a.EDGE
                            ],
                            [
                                o.ELECTRON,
                                a.ELECTRON
                            ]
                        ]), r = new s.default([
                            [
                                o.CHROME,
                                a.CHROME
                            ],
                            [
                                o.SAFARI,
                                a.SAFARI
                            ]
                        ]);
                        return e ? r : t;
                    })((0, c.isMobile)()).get(e);
                    return !!r && u.default.gte(t, r);
                };
                var o, a, s = i(r(8006)), u = i(r(6160)), c = r(4709);
                !function(e) {
                    e.CHROME = "chrome", e.FIREFOX = "firefox", e.EDGE = "microsoft edge", e.SAFARI = "safari", e.OCULUS = "OculusBrowser", e.ELECTRON = "electron";
                }(o || (t.Browser = o = {})), function(e) {
                    e.CHROME = "74.0.0", e.FIREFOX = "68.0.0", e.EDGE = "80.0.0", e.SAFARI = "12.0.0", e.ELECTRON = "20.1.1";
                }(a || (t.BrowserVersion = a = {}));
            },
            8362: (e, t, r)=>{
                "use strict";
                var n = r(5710), i = r(9534);
                n(t, "__esModule", {
                    value: !0
                }), t.normalizeDirectoryUrl = function(e) {
                    let t = new a.default(e).normalize().toString();
                    (0, o.default)(t).call(t, "/") || (t += "/");
                    return t;
                };
                var o = i(r(515)), a = i(r(6812));
            },
            3354: (e, t, r)=>{
                "use strict";
                var n = r(5710), i = r(9534);
                n(t, "__esModule", {
                    value: !0
                }), t.resolveAsset = s, t.resolveAssetRecursive = function e(t, r) {
                    for(const n in t)"string" == typeof t[n] ? t[n] = s(t[n], r) : "object" == typeof t[n] && e(t[n], r);
                    return t;
                };
                var o = i(r(6812)), a = r(8362);
                function s(e, t) {
                    const r = "undefined" != typeof self ? self : window, n = new o.default((0, a.normalizeDirectoryUrl)(t || r.TERMINAL_ROOT_URL)), i = e.split("?");
                    return n.filename(i[0]), i[1] && n.query(i[1]), n.normalize().toString();
                }
            },
            4709: (e, t, r)=>{
                "use strict";
                var n = r(7879), i = r(5710), o = r(3393), a = r(9534);
                i(t, "__esModule", {
                    value: !0
                }), t.PermissionState = t.PermissionQuery = t.CLIPBOARD_DATA_TYPE = t.BaseAudioContextState = void 0, t.arePointerEventsSupported = function() {
                    let e = !0;
                    if (M()) {
                        const t = navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/);
                        t && Number(t[1]) < v.SUPPORTED_IOS_VERSION && (e = !1);
                    }
                    return e;
                }, t.createAudioContext = function() {
                    return new (window.AudioContext || window.webkitAudioContext);
                }, t.getAudioStream = $, t.getBrowserName = z, t.getBrowserVersion = W, t.getCameraPermissionStatus = async function(e) {
                    return e.permissions.query({
                        name: s.CAMERA
                    });
                }, t.getClientOsName = function() {
                    return d.os.family;
                }, t.getMediaStream = async function(e, t, r) {
                    return t === m.MediaInputType.AUDIO_INPUT ? $(e, r) : H(e, r);
                }, t.getMediaStreamTracks = async function(e, t) {
                    return t === m.MediaInputType.AUDIO_INPUT ? e.getAudioTracks() : e.getVideoTracks();
                }, t.getMicrophonePermissionStatus = async function(e) {
                    return e.permissions.query({
                        name: s.MICROPHONE
                    });
                }, t.getSystemInfo = async function() {
                    return await window.xiframe.application.getSystemInfo();
                }, t.getSystemSecurityFeatures = async function() {
                    return await window.xiframe.application.getSystemSecurityFeatures();
                }, t.getTerminalBrowserInfo = async function() {
                    const e = await async function() {
                        var e, t, r;
                        const n = null !== (e = await (null === (t = window.application) || void 0 === t ? void 0 : t.api.application.getInfo())) && void 0 !== e ? e : await (null === (r = window.xiframe) || void 0 === r || null === (r = r.application) || void 0 === r ? void 0 : r.getInfo());
                        return n ? {
                            version: n.version || S,
                            name: b
                        } : void 0;
                    }();
                    return null != e ? e : {
                        name: z(),
                        version: W()
                    };
                }, t.getVideoStream = H, t.hasClipboardApi = function() {
                    return (R() || x()) && "clipboard" in navigator && "function" == typeof navigator.clipboard.readText && "function" == typeof navigator.clipboard.writeText;
                }, t.hasFileEntrySupport = function() {
                    const e = window.DataTransferItem;
                    return !(!e || "function" != typeof e.prototype.getAsEntry && "function" != typeof e.prototype.webkitGetAsEntry);
                }, t.hasKeyboardLock = function() {
                    return "keyboard" in navigator && "lock" in navigator.keyboard && "unlock" in navigator.keyboard;
                }, t.isAndroid = P, t.isChromeBook = function() {
                    return !!navigator.userAgent.match(/CrOS/i);
                }, t.isChromiumBased = R, t.isElectron = I, t.isFirefox = x, t.isForcingPixelRatioSupported = function() {
                    return T() || I();
                }, t.isGenericUsbSupported = V, t.isGetSystemInfoSupported = function() {
                    var e;
                    return F() && void 0 !== (null === (e = window.xiframe) || void 0 === e || null === (e = e.application) || void 0 === e ? void 0 : e.getSystemInfo);
                }, t.isGetSystemSecurityFeaturesSupported = function() {
                    var e;
                    return F() && void 0 !== (null === (e = window.xiframe) || void 0 === e || null === (e = e.application) || void 0 === e ? void 0 : e.getSystemSecurityFeatures);
                }, t.isHidUsbSupported = U, t.isIOS = M, t.isIpad = function() {
                    return !!navigator.userAgent.match(/iPad/i);
                }, t.isLinux = function() {
                    return O() === w.LINUX;
                }, t.isMac = function() {
                    return O() === w.MAC;
                }, t.isMobile = k, t.isMultiMonitorSupported = function() {
                    return R();
                }, t.isMultiScreenApiAvailable = function() {
                    return R() && "function" == typeof window.getScreenDetails;
                }, t.isNativeApp = F, t.isNativeAppInfoSupported = function() {
                    var e;
                    return F() && void 0 !== (null === (e = window.xiframe) || void 0 === e ? void 0 : e.application);
                }, t.isNativeClipboardSupported = D, t.isNativeClipboardTrackingSupported = function() {
                    var e, t, r;
                    return I() && void 0 !== (null === (e = window.xiframe) || void 0 === e || null === (e = e.clipboard) || void 0 === e ? void 0 : e.clipboardChangedEvent) && void 0 !== (null === (t = window.xiframe) || void 0 === t || null === (t = t.clipboard) || void 0 === t ? void 0 : t.startListeningForClipboardChangedEvent) && void 0 !== (null === (r = window.xiframe) || void 0 === r || null === (r = r.clipboard) || void 0 === r ? void 0 : r.stopListeningForClipboardChangedEvent);
                }, t.isNativeFullscreenSupported = function() {
                    var e;
                    return void 0 !== (null === (e = window.xiframe) || void 0 === e || null === (e = e.monitor) || void 0 === e ? void 0 : e.setFullscreenStatusHandler);
                }, t.isNativeHidSupported = L, t.isNativeKeyboardSendingKeysSupported = function() {
                    var e;
                    return (I() || q()) && void 0 !== (null === (e = window.xiframe) || void 0 === e || null === (e = e.keyboard) || void 0 === e ? void 0 : e.setSendKeyHandler);
                }, t.isNativeKeyboardSupported = q, t.isNativeLogSupported = function() {
                    var e;
                    return F() && void 0 !== (null === (e = window.xiframe) || void 0 === e ? void 0 : e.logger);
                }, t.isNativeMonitorSupported = function() {
                    var e;
                    return F() && void 0 !== (null === (e = window.xiframe) || void 0 === e ? void 0 : e.monitor);
                }, t.isNativeMouseSupported = function() {
                    var e;
                    return F() && void 0 !== (null === (e = window.xiframe) || void 0 === e ? void 0 : e.mouse);
                }, t.isNativePrintSupported = function() {
                    return R() && !k() || A();
                }, t.isNativeScannerSupported = function() {
                    var e;
                    return F() && void 0 !== (null === (e = window.xiframe) || void 0 === e ? void 0 : e.scanner);
                }, t.isNativeSmartCardSupported = function() {
                    var e;
                    return F() && void 0 !== (null === (e = window.xiframe) || void 0 === e ? void 0 : e.smartCard);
                }, t.isNativeUsbSupported = Q, t.isPdfjsPrintSupported = function() {
                    return x() && !k() || T() && k();
                }, t.isPenSupported = function() {
                    return T() || I();
                }, t.isPointerLockSupported = function() {
                    return "pointerLockElement" in document;
                }, t.isRichCopyPasteInNativeClipboardSupported = function() {
                    var e, t;
                    return D() && void 0 !== (null === (e = window.xiframe) || void 0 === e || null === (e = e.clipboard) || void 0 === e ? void 0 : e.read) && void 0 !== (null === (t = window.xiframe) || void 0 === t || null === (t = t.clipboard) || void 0 === t ? void 0 : t.write);
                }, t.isSafari = A, t.isSavingDisplaySetupSupported = function() {
                    var e;
                    return F() && I() && void 0 !== (null === (e = window.xiframe) || void 0 === e || null === (e = e.monitor) || void 0 === e ? void 0 : e.moveWindow);
                }, t.isSerialSupported = function() {
                    var e;
                    return I() && void 0 !== (null === (e = window.xiframe) || void 0 === e ? void 0 : e.serial);
                }, t.isTouchDevice = function() {
                    return "ontouchstart" in document.documentElement;
                }, t.isTouchUI = function() {
                    return P() || M();
                }, t.isUsbSupported = function() {
                    return U() || V();
                }, t.isWebHidSupported = j, t.isWebRTCSupported = function() {
                    return void 0 !== window.RTCPeerConnection;
                }, t.isWebUsbSupported = B, t.isWindows = N, t.isXrImmersiveModeSupported = async function() {
                    var e;
                    const t = null === (e = navigator) || void 0 === e ? void 0 : e.xr;
                    let r = !1;
                    if (void 0 !== t) try {
                        r = await t.isSessionSupported("immersive-vr");
                    } catch (e) {
                        console.log("XR is not supported");
                    }
                    return r;
                }, r(9064);
                var s, u, c, l = a(r(415)), f = a(r(1806)), p = E(r(9496)), d = E(r(5989)), h = a(r(6160)), v = r(3589), m = r(8569), y = r(4403);
                function g(e) {
                    if ("function" != typeof n) return null;
                    var t = new n, r = new n;
                    return (g = function(e) {
                        return e ? r : t;
                    })(e);
                }
                function E(e, t) {
                    if (!t && e && e.__esModule) return e;
                    if (null === e || "object" != typeof e && "function" != typeof e) return {
                        default: e
                    };
                    var r = g(t);
                    if (r && r.has(e)) return r.get(e);
                    var n = {
                        __proto__: null
                    }, a = i && o;
                    for(var s in e)if ("default" !== s && Object.prototype.hasOwnProperty.call(e, s)) {
                        var u = a ? o(e, s) : null;
                        u && (u.get || u.set) ? i(n, s, u) : n[s] = e[s];
                    }
                    return n.default = e, r && r.set(e, n), n;
                }
                !function(e) {
                    e.CAMERA = "camera", e.MICROPHONE = "microphone";
                }(s || (t.PermissionQuery = s = {})), function(e) {
                    e.GRANTED = "granted", e.DENIED = "denied", e.PROMPT = "prompt";
                }(u || (t.PermissionState = u = {})), function(e) {
                    e.SUSPENDED = "suspended", e.RUNNING = "running", e.CLOSED = "closed";
                }(c || (t.BaseAudioContextState = c = {}));
                const b = "FrameApp", S = "unknown";
                var _, w;
                function O() {
                    const e = navigator.appVersion.toLowerCase(), t = navigator.platform.toLowerCase();
                    return (0, l.default)(e).call(e, "mac") > -1 || (0, l.default)(t).call(t, "mac") > -1 ? w.MAC : (0, l.default)(e).call(e, "win") > -1 || (0, l.default)(t).call(t, "win") > -1 ? w.WINDOWS : (0, l.default)(e).call(e, "linux") > -1 || (0, l.default)(t).call(t, "linux") > -1 ? w.LINUX : w.UNKNOWN;
                }
                function T() {
                    return z() === y.Browser.CHROME;
                }
                function I() {
                    return z() === y.Browser.ELECTRON;
                }
                function R() {
                    return T() || I() || function() {
                        const e = W();
                        return z() === y.Browser.EDGE && h.default.gte(e, y.BrowserVersion.EDGE);
                    }();
                }
                function x() {
                    return z() === y.Browser.FIREFOX;
                }
                function A() {
                    return z() === y.Browser.SAFARI;
                }
                function N() {
                    return O() === w.WINDOWS;
                }
                function C() {
                    var e;
                    return (0, f.default)(e = navigator.userAgent).call(e, y.Browser.OCULUS);
                }
                function k() {
                    return !C() && (M() || P());
                }
                function M() {
                    return !!navigator.userAgent.match(/(iPad|iPhone|iPod)/g);
                }
                function P() {
                    return !!navigator.userAgent.match(/^(?=.*Android)(?!.*Windows Phone).*/);
                }
                function D() {
                    var e;
                    return (I() || F()) && void 0 !== (null === (e = window.xiframe) || void 0 === e ? void 0 : e.clipboard);
                }
                function F() {
                    return !!window.xiframe;
                }
                function L() {
                    var e;
                    return F() && void 0 !== (null === (e = window.xiframe) || void 0 === e ? void 0 : e.hid);
                }
                function j() {
                    return (!F() && !N() || I()) && void 0 !== window.navigator.hid;
                }
                function U() {
                    return L() || j();
                }
                function B() {
                    return (!F() && !N() || I()) && void 0 !== window.navigator.usb;
                }
                function Q() {
                    var e;
                    return F() && !I() && void 0 !== (null === (e = window.xiframe) || void 0 === e ? void 0 : e.usb);
                }
                function V() {
                    return Q() || B();
                }
                function q() {
                    var e;
                    return (I() || F()) && void 0 !== (null === (e = window.xiframe) || void 0 === e ? void 0 : e.keyboard);
                }
                function G() {
                    let e;
                    const t = /(SamsungBrowser\/\d+.\d+)/g.exec(window.navigator.userAgent);
                    if (t && 2 === t.length && C()) {
                        const r = window.navigator.userAgent.replace(t[1], "");
                        e = p.getParser(r);
                    } else e = p.getParser(window.navigator.userAgent);
                    return e;
                }
                function z() {
                    return G().getBrowserName().toLowerCase();
                }
                function W() {
                    const e = G();
                    return h.default.valid(h.default.coerce(e.getBrowserVersion())) || S;
                }
                async function $(e, t) {
                    return await e.mediaDevices.getUserMedia({
                        audio: !t || {
                            deviceId: t
                        },
                        video: !1
                    });
                }
                async function H(e, t) {
                    return await e.mediaDevices.getUserMedia({
                        audio: !1,
                        video: !t || {
                            deviceId: {
                                exact: t
                            }
                        }
                    });
                }
                !function(e) {
                    e.TEXT = "Text";
                }(_ || (t.CLIPBOARD_DATA_TYPE = _ = {})), function(e) {
                    e.WINDOWS = "Windows", e.MAC = "Mac", e.UNIX = "Unix", e.LINUX = "Linux", e.UNKNOWN = "UnknownOS";
                }(w || (w = {}));
            },
            5509: (e, t, r)=>{
                "use strict";
                r(5710)(t, "__esModule", {
                    value: !0
                }), t.ApplicationCloseFailedError = void 0;
                var n = r(1158);
                t.ApplicationCloseFailedError = class extends n.TerminalError {
                    constructor(e){
                        super(e, n.TerminalErrorCode.APPLICATION_CLOSE_FAILED);
                    }
                };
            },
            4104: (e, t, r)=>{
                "use strict";
                r(5710)(t, "__esModule", {
                    value: !0
                }), t.ApplicationFocusFailedError = void 0;
                var n = r(1158);
                t.ApplicationFocusFailedError = class extends n.TerminalError {
                    constructor(e){
                        super(e, n.TerminalErrorCode.APPLICATION_FOCUS_FAILED);
                    }
                };
            },
            5161: (e, t, r)=>{
                "use strict";
                r(5710)(t, "__esModule", {
                    value: !0
                }), t.ApplicationStartFailedError = void 0;
                var n = r(1158);
                t.ApplicationStartFailedError = class extends n.TerminalError {
                    constructor(e){
                        super(e, n.TerminalErrorCode.APPLICATION_START_FAILED);
                    }
                };
            },
            9680: (e, t, r)=>{
                "use strict";
                r(5710)(t, "__esModule", {
                    value: !0
                }), t.Mp4VideoStreamCorruptedError = void 0;
                var n = r(1158);
                t.Mp4VideoStreamCorruptedError = class extends n.TerminalError {
                    constructor(){
                        super("Mp4 video stream is corrupted.", n.TerminalErrorCode.MP4_VIDEO_STREAM_CORRUPTED);
                    }
                };
            },
            3917: (e, t, r)=>{
                "use strict";
                r(5710)(t, "__esModule", {
                    value: !0
                }), t.Mp4VideoStreamFrozenError = void 0;
                var n = r(1158);
                t.Mp4VideoStreamFrozenError = class extends n.TerminalError {
                    constructor(){
                        super("Mp4 video stream is frozen.", n.TerminalErrorCode.MP4_VIDEO_STREAM_FROZEN);
                    }
                };
            },
            7422: (e, t, r)=>{
                "use strict";
                r(5710)(t, "__esModule", {
                    value: !0
                }), t.WebGlError = void 0;
                var n = r(1158);
                t.WebGlError = class extends n.TerminalError {
                    constructor(e){
                        super(e, n.TerminalError.WEB_GL_ERROR);
                    }
                };
            },
            6955: (e, t, r)=>{
                "use strict";
                r(5710)(t, "__esModule", {
                    value: !0
                }), t.WebRTCPlayerCrashedError = void 0;
                var n = r(1158);
                t.WebRTCPlayerCrashedError = class extends n.TerminalError {
                    constructor(){
                        super("WebRTC player crashed.", n.TerminalErrorCode.WEB_RTC_PLAYER_CRASHED);
                    }
                };
            },
            1423: (e, t, r)=>{
                "use strict";
                r(5710)(t, "__esModule", {
                    value: !0
                }), t.PlayerFailedError = void 0;
                var n = r(1158);
                t.PlayerFailedError = class extends n.TerminalError {
                    constructor(){
                        super("All players have failed", n.TerminalErrorCode.VIDEO_DECODERS_FAILED);
                    }
                };
            },
            8560: (e, t, r)=>{
                "use strict";
                r(5710)(t, "__esModule", {
                    value: !0
                }), t.UserAbortedConnectionError = void 0;
                var n = r(1158);
                t.UserAbortedConnectionError = class extends n.TerminalError {
                    constructor(e){
                        super(e || "User has aborted connection.", n.TerminalErrorCode.USER_ABORTED_CONNECTION);
                    }
                };
            },
            5551: (e, t, r)=>{
                "use strict";
                r(5710)(t, "__esModule", {
                    value: !0
                }), t.FileModifiedError = void 0;
                var n = r(5421);
                t.FileModifiedError = class extends n.TerminalInternalError {
                };
            },
            2439: (e, t, r)=>{
                "use strict";
                r(5710)(t, "__esModule", {
                    value: !0
                }), t.FileUploadCanceledError = void 0;
                var n = r(1158);
                t.FileUploadCanceledError = class extends n.TerminalError {
                    constructor(e){
                        super(e || "Upload was canceled", n.TerminalError.FILE_UPLOAD_CANCELED);
                    }
                };
            },
            2127: (e, t, r)=>{
                "use strict";
                r(5710)(t, "__esModule", {
                    value: !0
                }), t.FileUploadFailedError = void 0;
                var n = r(1158);
                t.FileUploadFailedError = class extends n.TerminalError {
                    constructor(e){
                        super(e || "Unknown error occurred while uploading.", n.TerminalError.FILE_UPLOAD_FAILED);
                    }
                };
            },
            9562: (e, t, r)=>{
                "use strict";
                r(5710)(t, "__esModule", {
                    value: !0
                }), t.ReadingAbortedError = void 0;
                var n = r(5421);
                t.ReadingAbortedError = class extends n.TerminalInternalError {
                };
            },
            4401: (e, t, r)=>{
                "use strict";
                r(5710)(t, "__esModule", {
                    value: !0
                }), t.PlayerStartCanceledError = void 0;
                var n = r(1158);
                t.PlayerStartCanceledError = class extends n.TerminalError {
                    constructor(e){
                        super(e || "Player start was canceled by Terminal.", n.TerminalErrorCode.PLAYER_START_CANCELED);
                    }
                };
            },
            5215: (e, t, r)=>{
                "use strict";
                r(5710)(t, "__esModule", {
                    value: !0
                }), t.SignalingServerMissingUrlError = void 0;
                var n = r(1158);
                t.SignalingServerMissingUrlError = class extends n.TerminalError {
                    constructor(){
                        super("Signaling server url is missing.", n.TerminalErrorCode.SIGNALING_SERVER_MISSING_URL_ERROR);
                    }
                };
            },
            4281: (e, t, r)=>{
                "use strict";
                r(5710)(t, "__esModule", {
                    value: !0
                }), t.UserInactivityError = void 0;
                var n = r(5421);
                t.UserInactivityError = class extends n.TerminalInternalError {
                    constructor(){
                        super("User inactivity timeout error.");
                    }
                };
            },
            2773: (e, t, r)=>{
                "use strict";
                r(5710)(t, "__esModule", {
                    value: !0
                }), t.ConnectionAbortedError = void 0;
                var n = r(1158);
                t.ConnectionAbortedError = class extends n.TerminalError {
                    constructor(e){
                        super(e, n.TerminalErrorCode.CONNECTION_ABORTED);
                    }
                };
            },
            123: (e, t, r)=>{
                "use strict";
                r(5710)(t, "__esModule", {
                    value: !0
                }), t.ConnectionCanceledError = void 0;
                var n = r(2141);
                t.ConnectionCanceledError = class extends n.WsConnectionError {
                    constructor(e){
                        super("Web socket driver connection request was canceled by the Terminal.", e);
                    }
                };
            },
            4909: (e, t, r)=>{
                "use strict";
                r(5710)(t, "__esModule", {
                    value: !0
                }), t.ConnectionFailedError = void 0;
                var n = r(2141);
                t.ConnectionFailedError = class extends n.WsConnectionError {
                    constructor(e, t){
                        super(t || "Web socket driver connection has failed.", e);
                    }
                };
            },
            2141: (e, t, r)=>{
                "use strict";
                r(5710)(t, "__esModule", {
                    value: !0
                }), t.WsConnectionError = void 0;
                var n = r(1158);
                t.WsConnectionError = class extends n.TerminalError {
                };
            },
            2074: (e, t, r)=>{
                "use strict";
                r(5710)(t, "__esModule", {
                    value: !0
                }), t.BufferTooSmallError = void 0;
                var n = r(5421);
                t.BufferTooSmallError = class extends n.TerminalInternalError {
                };
            },
            8404: (e, t, r)=>{
                "use strict";
                r(5710)(t, "__esModule", {
                    value: !0
                }), t.CachedDataOverflowError = void 0;
                var n = r(5421);
                t.CachedDataOverflowError = class extends n.TerminalInternalError {
                };
            },
            6959: (e, t, r)=>{
                "use strict";
                r(5710)(t, "__esModule", {
                    value: !0
                }), t.ServerApplicationStartFailedError = void 0;
                var n = r(5680);
                t.ServerApplicationStartFailedError = class extends n.ServerError {
                };
            },
            3645: (e, t, r)=>{
                "use strict";
                r(5710)(t, "__esModule", {
                    value: !0
                }), t.ApiDestroyedError = void 0;
                var n = r(5421);
                t.ApiDestroyedError = class extends n.TerminalInternalError {
                    constructor(){
                        super("Api destroyed");
                    }
                };
            },
            4601: (e, t, r)=>{
                "use strict";
                r(5710)(t, "__esModule", {
                    value: !0
                }), t.WebRTCNegotiationTimeoutError = void 0;
                var n = r(1158), i = r(4909);
                t.WebRTCNegotiationTimeoutError = class extends i.ConnectionFailedError {
                    constructor(){
                        super(n.TerminalErrorCode.WEB_RTC_NEGOTIATION_TIMEOUT, "Connection negotiation timeout");
                    }
                };
            },
            4813: (e, t, r)=>{
                "use strict";
                r(5710)(t, "__esModule", {
                    value: !0
                }), t.WebRTCReconnectSignalingClientTimeoutError = void 0;
                var n = r(1158), i = r(4909);
                t.WebRTCReconnectSignalingClientTimeoutError = class extends i.ConnectionFailedError {
                    constructor(){
                        super(n.TerminalErrorCode.WEB_RTC_RECONNECT_SIGNALING_CLIENT_TIMEOUT, "Signaling client reconnect timeout");
                    }
                };
            },
            5402: (e, t, r)=>{
                "use strict";
                r(5710)(t, "__esModule", {
                    value: !0
                }), t.WebRTCRenegotiationTimeoutError = void 0;
                var n = r(1158), i = r(4909);
                t.WebRTCRenegotiationTimeoutError = class extends i.ConnectionFailedError {
                    constructor(){
                        super(n.TerminalErrorCode.WEB_RTC_RENEGOTIATION_TIMEOUT, "Connection renegotiation timeout");
                    }
                };
            },
            7491: (e, t, r)=>{
                "use strict";
                r(5710)(t, "__esModule", {
                    value: !0
                }), t.WebRTCStunServerUnreachableError = void 0;
                var n = r(1158), i = r(4909);
                t.WebRTCStunServerUnreachableError = class extends i.ConnectionFailedError {
                    constructor(){
                        super(n.TerminalErrorCode.WEB_RTC_STUN_SERVER_UNREACHABLE, "Stun server unreachable");
                    }
                };
            },
            5008: (e, t, r)=>{
                "use strict";
                r(5710)(t, "__esModule", {
                    value: !0
                }), t.WebRTCTurnServerUnreachableError = void 0;
                var n = r(1158), i = r(4909);
                t.WebRTCTurnServerUnreachableError = class extends i.ConnectionFailedError {
                    constructor(){
                        super(n.TerminalErrorCode.WEB_RTC_TURN_SERVER_UNREACHABLE, "Turn server unreachable");
                    }
                };
            },
            2743: (e, t, r)=>{
                "use strict";
                r(5710)(t, "__esModule", {
                    value: !0
                }), t.SignalingConnectTimeoutError = void 0;
                var n = r(8083), i = r(2141);
                t.SignalingConnectTimeoutError = class extends i.WsConnectionError {
                    constructor(e){
                        super(e || "Signaling connection timeout on waiting for server peers message.", n.TerminalConnectionErrorCode.SIGNALING_PEERS_TIMEOUT);
                    }
                };
            },
            806: (e, t, r)=>{
                "use strict";
                r(5710)(t, "__esModule", {
                    value: !0
                }), t.TurnServerCredentialsError = void 0;
                var n = r(1158);
                t.TurnServerCredentialsError = class extends n.TerminalError {
                    constructor(e){
                        super(e, n.TerminalErrorCode.TURN_SERVER_CREDENTIALS_ERROR);
                    }
                };
            },
            2232: (e, t, r)=>{
                "use strict";
                r(5710)(t, "__esModule", {
                    value: !0
                }), t.TurnServerCredentialsNotParsableError = void 0;
                var n = r(1158);
                t.TurnServerCredentialsNotParsableError = class extends n.TerminalError {
                    constructor(){
                        super("Turn server credentials parse error.", n.TerminalErrorCode.TURN_SERVER_NOT_PARSABLE_ERROR);
                    }
                };
            },
            2145: (e, t, r)=>{
                "use strict";
                r(5710)(t, "__esModule", {
                    value: !0
                }), t.TurnServerInternalServerError = void 0;
                var n = r(1158);
                t.TurnServerInternalServerError = class extends n.TerminalError {
                    constructor(){
                        super("Fetch TURN server returned internal server error.", n.TerminalErrorCode.TURN_SERVER_INTERNAL_SERVER_ERROR);
                    }
                };
            },
            5686: (e, t, r)=>{
                "use strict";
                r(5710)(t, "__esModule", {
                    value: !0
                }), t.TurnServerMissingPropertyError = void 0;
                var n = r(1158);
                t.TurnServerMissingPropertyError = class extends n.TerminalError {
                    constructor(){
                        super("Turn server credential property is missing.", n.TerminalErrorCode.TURN_SERVER_MISSING_PROPERTY_ERROR);
                    }
                };
            },
            2502: (e, t, r)=>{
                "use strict";
                r(5710)(t, "__esModule", {
                    value: !0
                }), t.ConnectionRefusedError = void 0;
                var n = r(1158);
                t.ConnectionRefusedError = class extends n.TerminalError {
                };
            },
            2416: (e, t, r)=>{
                "use strict";
                r(5710)(t, "__esModule", {
                    value: !0
                }), t.UsbDeviceControllerError = void 0;
                var n = r(5421);
                t.UsbDeviceControllerError = class extends n.TerminalInternalError {
                };
            },
            4934: (e, t, r)=>{
                "use strict";
                r(5710)(t, "__esModule", {
                    value: !0
                }), t.UsbDeviceManagerError = void 0;
                var n = r(5421);
                t.UsbDeviceManagerError = class extends n.TerminalInternalError {
                    constructor(e){
                        super(e);
                    }
                };
            },
            4829: (e, t, r)=>{
                "use strict";
                r(5710)(t, "__esModule", {
                    value: !0
                }), t.InvalidMassStorageCmdError = void 0;
                var n = r(5421);
                t.InvalidMassStorageCmdError = class extends n.TerminalInternalError {
                };
            },
            9043: (e, t, r)=>{
                "use strict";
                r(5710)(t, "__esModule", {
                    value: !0
                }), t.UsbDeviceNotFoundError = void 0;
                var n = r(5421);
                t.UsbDeviceNotFoundError = class extends n.TerminalInternalError {
                };
            },
            8347: (e, t, r)=>{
                "use strict";
                r(5710)(t, "__esModule", {
                    value: !0
                }), t.InvalidHidDeviceError = void 0;
                var n = r(5421);
                t.InvalidHidDeviceError = class extends n.TerminalInternalError {
                };
            },
            3556: (e, t, r)=>{
                "use strict";
                r(5710)(t, "__esModule", {
                    value: !0
                }), t.AddMediaStreamTrackError = void 0;
                var n = r(1158);
                t.AddMediaStreamTrackError = class extends n.TerminalError {
                    constructor(e){
                        super(e, n.TerminalErrorCode.ADD_MEDIA_STREAM_TRACK_ERROR);
                    }
                };
            },
            1419: (e, t, r)=>{
                "use strict";
                var n = r(5710), i = r(9534);
                n(t, "__esModule", {
                    value: !0
                }), t.ConfigValidationError = void 0;
                var o = i(r(1183)), a = r(1158);
                t.ConfigValidationError = class extends a.TerminalError {
                    constructor(e){
                        let t = "Config validation error\n";
                        e && (t = (0, o.default)(e).call(e, (e, t)=>e + `${t.message} (${t.dataPath})\n`, t)), super(t, a.TerminalErrorCode.CONFIG_VALIDATION_ERROR);
                    }
                };
            },
            1586: (e, t, r)=>{
                "use strict";
                r(5710)(t, "__esModule", {
                    value: !0
                }), t.TerminalLoadFailedError = void 0;
                var n = r(1158);
                t.TerminalLoadFailedError = class extends n.TerminalError {
                    constructor(e){
                        super(e, n.TerminalErrorCode.TERMINAL_LOAD_FAILED);
                    }
                };
            },
            1934: (e, t, r)=>{
                "use strict";
                r(5710)(t, "__esModule", {
                    value: !0
                }), t.MethodNotSupportedError = void 0;
                var n = r(1158);
                t.MethodNotSupportedError = class extends n.TerminalError {
                    constructor(){
                        super("Method not supported", n.TerminalErrorCode.METHOD_NOT_SUPPORTED);
                    }
                };
            },
            4122: (e, t, r)=>{
                "use strict";
                r(5710)(t, "__esModule", {
                    value: !0
                }), t.BaseError = void 0;
                class n extends Error {
                    get url() {
                        return this._url;
                    }
                    get code() {
                        return this._code;
                    }
                    constructor(e, t, r){
                        super(e), this.name = this.constructor.name, this._code = t, r && (this._url = r), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error(e).stack;
                    }
                }
                t.BaseError = n;
            },
            8280: (e, t, r)=>{
                "use strict";
                r(5710)(t, "__esModule", {
                    value: !0
                }), t.ControllerDestroyedError = void 0;
                var n = r(1158);
                t.ControllerDestroyedError = class extends n.TerminalError {
                    constructor(e, t){
                        super(e, t || n.TerminalErrorCode.CONTROLLER_ALREADY_DESTROYED);
                    }
                };
            },
            4162: (e, t, r)=>{
                "use strict";
                r(5710)(t, "__esModule", {
                    value: !0
                }), t.DisplayConfigurationError = void 0;
                var n = r(1158);
                t.DisplayConfigurationError = class extends n.TerminalError {
                    constructor(e){
                        super(e, n.TerminalErrorCode.DISPLAY_CONFIGURATION_ERROR);
                    }
                };
            },
            4046: (e, t, r)=>{
                "use strict";
                r(5710)(t, "__esModule", {
                    value: !0
                }), t.DomainJoinError = void 0;
                var n = r(1158);
                t.DomainJoinError = class extends n.TerminalError {
                    constructor(e){
                        super(e, n.TerminalErrorCode.DOMAIN_JOIN_ERROR);
                    }
                };
            },
            937: (e, t, r)=>{
                "use strict";
                r(5710)(t, "__esModule", {
                    value: !0
                }), t.ForcePixelRatioError = void 0;
                var n = r(1158);
                t.ForcePixelRatioError = class extends n.TerminalError {
                    constructor(e){
                        super(e, n.TerminalErrorCode.UNKNOWN_INVALID_PARAMS);
                    }
                };
            },
            6868: (e, t, r)=>{
                "use strict";
                r(5710)(t, "__esModule", {
                    value: !0
                }), t.ForceResolutionError = void 0;
                var n = r(1158);
                t.ForceResolutionError = class extends n.TerminalError {
                    constructor(e){
                        super(e, n.TerminalErrorCode.UNKNOWN_INVALID_PARAMS);
                    }
                };
            },
            9472: (e, t, r)=>{
                "use strict";
                r(5710)(t, "__esModule", {
                    value: !0
                }), t.InvalidParamsError = void 0;
                var n = r(1158);
                t.InvalidParamsError = class extends n.TerminalError {
                    constructor(e, t){
                        super(e, t || n.TerminalErrorCode.UNKNOWN_INVALID_PARAMS);
                    }
                };
            },
            6884: (e, t, r)=>{
                "use strict";
                r(5710)(t, "__esModule", {
                    value: !0
                }), t.InvalidStateError = void 0;
                var n = r(1158);
                t.InvalidStateError = class extends n.TerminalError {
                    constructor(e, t){
                        super(e, t || n.TerminalErrorCode.UNKNOWN_INVALID_STATE);
                    }
                };
            },
            1675: (e, t, r)=>{
                "use strict";
                r(5710)(t, "__esModule", {
                    value: !0
                }), t.MethodNotImplementedError = void 0;
                var n = r(1158);
                t.MethodNotImplementedError = class extends n.TerminalError {
                    constructor(e){
                        super(e, n.TerminalError.METHOD_NOT_IMPLEMENTED);
                    }
                };
            },
            610: (e, t, r)=>{
                "use strict";
                r(5710)(t, "__esModule", {
                    value: !0
                }), t.NotFoundError = void 0;
                var n = r(1158);
                t.NotFoundError = class extends n.TerminalError {
                };
            },
            8051: (e, t, r)=>{
                "use strict";
                r(5710)(t, "__esModule", {
                    value: !0
                }), t.NotSupportedError = void 0;
                var n = r(1158);
                t.NotSupportedError = class extends n.TerminalError {
                };
            },
            5680: (e, t, r)=>{
                "use strict";
                r(5710)(t, "__esModule", {
                    value: !0
                }), t.ServerError = void 0;
                var n = r(4122);
                t.ServerError = class extends n.BaseError {
                };
            },
            2569: (e, t, r)=>{
                "use strict";
                r(5710)(t, "__esModule", {
                    value: !0
                }), t.ServiceError = void 0;
                var n = r(4122);
                t.ServiceError = class extends n.BaseError {
                };
            },
            5901: (e, t, r)=>{
                "use strict";
                var n = r(5710), i = r(9534);
                n(t, "__esModule", {
                    value: !0
                }), t.ServiceGraphQlError = void 0;
                var o = i(r(1183)), a = r(2569);
                t.ServiceGraphQlError = class extends a.ServiceError {
                    get errors() {
                        return this._errors;
                    }
                    constructor(e){
                        super((0, o.default)(e).call(e, (t, r, n)=>{
                            let i = t + r.message;
                            return n + 1 < e.length && (i += "\n"), i;
                        }, "")), this._errors = e;
                    }
                };
            },
            453: (e, t, r)=>{
                "use strict";
                r(5710)(t, "__esModule", {
                    value: !0
                }), t.ShortcutsConfigurationError = void 0;
                var n = r(1158);
                t.ShortcutsConfigurationError = class extends n.TerminalError {
                    constructor(e){
                        super(e, n.TerminalErrorCode.UNKNOWN_INVALID_PARAMS);
                    }
                };
            },
            1158: (e, t, r)=>{
                "use strict";
                r(5710)(t, "__esModule", {
                    value: !0
                }), t.TerminalErrorCode = t.TerminalError = void 0;
                var n = r(4122);
                const i = {
                    USER_ABORTED_CONNECTION: 0,
                    CONNECTION_ABORTED: 1,
                    CONNECTION_LOST: 2,
                    NO_PORT_FOUND: 3,
                    NO_PORT_RECEIVED: 4,
                    CONNECTION_DESTROYED: 5,
                    WEB_RTC_ICE_CONNECTION_FAILED: 6,
                    WEB_RTC_NEGOTIATION_TIMEOUT: 7,
                    WEB_RTC_CONNECTION_FAILED: 8,
                    WEB_RTC_STUN_SERVER_UNREACHABLE: 9,
                    WEB_RTC_TURN_SERVER_UNREACHABLE: 10,
                    CONFIG_VALIDATION_ERROR: 100,
                    TERMINAL_LOAD_FAILED: 101,
                    TOKEN_MISSING: 102,
                    TERMINAL_ACTION_INVALID_STATE: 110,
                    PLAYER_ACTION_INVALID_STATE: 111,
                    PLAYER_START_CANCELED: 200,
                    VIDEO_DECODERS_FAILED: 202,
                    USER_BLOCKED_AUDIO: 203,
                    MP4_VIDEO_STREAM_CORRUPTED: 204,
                    MP4_VIDEO_STREAM_FROZEN: 205,
                    WEB_RTC_PLAYER_CRASHED: 206,
                    DISPLAY_CONFIGURATION_ERROR: 207,
                    ADD_MEDIA_STREAM_TRACK_ERROR: 208,
                    AUDIO_PLAYBACK_FAILED: 209,
                    STREAM_CLIENT_FAILED: 210,
                    FILE_UPLOAD_CANCELED: 250,
                    FILE_UPLOAD_FAILED: 251,
                    STARTING_USER_MEDIA_INPUT_DEVICE_FAILED: 260,
                    SCAN_MEDIA_DEVICE_ERROR: 261,
                    SETTINGS_APPLY_FAILED: 270,
                    SETTINGS_LOAD_FAILED: 271,
                    CHANGE_RESOLUTION_FAILED: 280,
                    SETTING_KEYBOARD_LAYOUT_FAILED: 281,
                    TOGGLE_ONSCREEN_KEYBOARD_FAILED: 282,
                    APPLICATION_START_FAILED: 300,
                    APPLICATION_CLOSE_FAILED: 301,
                    APPLICATION_NOT_FOUND: 302,
                    APPLICATION_START_FORBIDDEN_PARAMETER: 303,
                    APPLICATION_ID_PARAMETER_MISSING: 304,
                    APPLICATION_FOCUS_FAILED: 305,
                    APPLICATION_ONBOARD_FAILED: 350,
                    SESSION_REQUEST_ACTIVE: 400,
                    SESSION_REQUEST_ALREADY_OPEN: 401,
                    SESSION_REQUEST_ABORTED: 402,
                    SESSION_RESUME_MISSING_PARAMETER: 403,
                    SESSION_IN_INVALID_STATE: 404,
                    NO_ACTIVE_SESSION: 405,
                    DOMAIN_JOIN_ERROR: 406,
                    USER_CANCELED_DOMAIN_JOIN: 407,
                    USER_QUIT_DOMAIN_JOIN: 408,
                    CREDENTIALS_EXPIRED_DOMAIN_JOIN: 409,
                    CREDENTIALS_TOO_MANY_TRIES_DOMAIN_JOIN: 410,
                    CREDENTIALS_UNKNOWN_STATUS_CODE_DOMAIN_JOIN: 411,
                    FCP_PROBLEM_DOMAIN_JOIN: 412,
                    ACCOUNT_DATA_MISMATCH_DOMAIN_JOIN: 413,
                    ACCOUNT_DISABLED_DOMAIN_JOIN: 414,
                    COMPUTER_NOT_TRUSTED_DOMAIN_JOIN: 415,
                    SERVICE_SIDE_ERROR_DOMAIN_JOIN: 416,
                    INTERACTIVE_LOGON_DOMAIN_JOIN: 417,
                    CREDENTIALS_INTEGRITY_ERROR_DOMAIN_JOIN: 418,
                    SSO_CREDENTIALS_NOT_SET_ERROR_DOMAIN_JOIN: 419,
                    SCANNER_CANNOT_SET_RESOLUTION: 500,
                    SCANNER_CANNOT_SET_IMAGE_SIZE: 501,
                    SCANNER_CANNOT_SET_IMAGE_TYPE: 502,
                    INTERNAL_ERROR: 900,
                    UNEXPECTED_SERVICE_ERROR: 901,
                    UNKNOWN_INVALID_PARAMS: 902,
                    UNKNOWN_INVALID_STATE: 903,
                    CONTROLLER_ALREADY_DESTROYED: 904,
                    INTERNAL_RPC_ERROR: 905,
                    RPC_ERROR: 906,
                    WEB_GL_ERROR: 907,
                    UNSUPPORTED_BROWSER: 908,
                    TURN_SERVER_FORBIDDEN: 909,
                    TURN_SERVER_NOT_PARSABLE_ERROR: 910,
                    TURN_SERVER_INTERNAL_SERVER_ERROR: 911,
                    TURN_SERVER_MISSING_PROPERTY_ERROR: 912,
                    SIGNALING_SERVER_MISSING_URL_ERROR: 913,
                    TURN_SERVER_CREDENTIALS_ERROR: 914,
                    METHOD_NOT_SUPPORTED: 998,
                    METHOD_NOT_IMPLEMENTED: 999
                }, o = 5e3, a = t.TerminalErrorCode = {};
                for(const e in i)if (i.hasOwnProperty(e)) {
                    const t = o + i[e];
                    if (t < o || t > 5999) throw new Error(`TerminalError: error code ${t} out of range.`);
                    if (a[t]) throw new Error("TerminalError: error code already registered.");
                    a[e] = t;
                }
                t.TerminalError = class extends n.BaseError {
                    constructor(e, t){
                        super(e, t, "");
                    }
                };
            },
            5421: (e, t, r)=>{
                "use strict";
                r(5710)(t, "__esModule", {
                    value: !0
                }), t.TerminalInternalError = void 0;
                var n = r(1158);
                t.TerminalInternalError = class extends n.TerminalError {
                    constructor(e){
                        super(e, n.TerminalErrorCode.INTERNAL_ERROR);
                    }
                };
            },
            9777: (e, t, r)=>{
                "use strict";
                r(5710)(t, "__esModule", {
                    value: !0
                }), t.UnexpectedServiceError = void 0;
                var n = r(2569), i = r(1158);
                t.UnexpectedServiceError = class extends n.ServiceError {
                    constructor(){
                        super("Unexpected service error. Please contact our support.", i.TerminalError.UNEXPECTED_SERVICE_ERROR);
                    }
                };
            },
            3443: (e, t, r)=>{
                "use strict";
                r(5710)(t, "__esModule", {
                    value: !0
                }), t.UserCanceledDomainJoinError = void 0;
                var n = r(1158);
                t.UserCanceledDomainJoinError = class extends n.TerminalError {
                    constructor(){
                        super("User has disconnected the session before logging in.", n.TerminalErrorCode.USER_CANCELED_DOMAIN_JOIN);
                    }
                };
            },
            7529: (e, t, r)=>{
                "use strict";
                r(5710)(t, "__esModule", {
                    value: !0
                }), t.UserQuitDomainJoinError = void 0;
                var n = r(1158);
                t.UserQuitDomainJoinError = class extends n.TerminalError {
                    constructor(){
                        super("User has quit the session before logging in.", n.TerminalErrorCode.USER_QUIT_DOMAIN_JOIN);
                    }
                };
            },
            2146: (e, t, r)=>{
                "use strict";
                r(5710)(t, "__esModule", {
                    value: !0
                }), t.ConnectionDestroyedError = void 0;
                var n = r(8280), i = r(1158);
                t.ConnectionDestroyedError = class extends n.ControllerDestroyedError {
                    constructor(e){
                        super(e, i.TerminalErrorCode.CONNECTION_DESTROYED);
                    }
                };
            },
            4111: (e, t, r)=>{
                "use strict";
                r(5710)(t, "__esModule", {
                    value: !0
                }), t.ConnectionLostError = void 0;
                var n = r(1158);
                t.ConnectionLostError = class extends n.TerminalError {
                    constructor(e){
                        super(e, n.TerminalErrorCode.CONNECTION_LOST);
                    }
                };
            },
            2067: (e, t, r)=>{
                "use strict";
                r(5710)(t, "__esModule", {
                    value: !0
                }), t.InternalRpcErrorType = t.InternalRpcError = void 0;
                var n = r(1158);
                t.InternalRpcErrorType = {
                    PARSE_ERROR: "rpc-parse-error",
                    INVALID_REQUEST: "rpc-invalid-request",
                    METHOD_NOT_FOUND: "rpc-method-not-found",
                    INVALID_PARAMS: "rpc-invalid-params",
                    INTERNAL_ERROR: "rpc-internal-error"
                };
                t.InternalRpcError = class extends n.TerminalError {
                    constructor(e, t){
                        super("Internal rpc error.", n.TerminalErrorCode.INTERNAL_RPC_ERROR), this.requestId = e, this.errorId = t;
                    }
                };
            },
            1441: (e, t, r)=>{
                "use strict";
                r(5710)(t, "__esModule", {
                    value: !0
                }), t.RpcCallbackNotFoundError = void 0;
                var n = r(5421);
                t.RpcCallbackNotFoundError = class extends n.TerminalInternalError {
                };
            },
            3549: (e, t, r)=>{
                "use strict";
                r(5710)(t, "__esModule", {
                    value: !0
                }), t.RpcError = void 0;
                var n = r(1158);
                t.RpcError = class extends n.TerminalError {
                    constructor(e, t){
                        super(t.message, n.TerminalErrorCode.RPC_ERROR), this.requestId = e, this.error = t;
                    }
                };
            },
            9418: (e, t, r)=>{
                "use strict";
                r(5710)(t, "__esModule", {
                    value: !0
                }), t.RpcExecutionError = void 0;
                var n = r(1158);
                t.RpcExecutionError = class extends n.TerminalError {
                    constructor(e, t){
                        super(e, t);
                    }
                    toString() {
                        return `RpcExecutionError { code: ${this.code}, message: ${this.message} }`;
                    }
                };
            },
            1660: (e)=>{
                "use strict";
                e.exports.BundlePath = {
                    ES6: "es6"
                };
            },
            9496: function(e) {
                e.exports = function(e) {
                    var t = {};
                    function r(n) {
                        if (t[n]) return t[n].exports;
                        var i = t[n] = {
                            i: n,
                            l: !1,
                            exports: {}
                        };
                        return e[n].call(i.exports, i, i.exports, r), i.l = !0, i.exports;
                    }
                    return r.m = e, r.c = t, r.d = function(e, t, n) {
                        r.o(e, t) || Object.defineProperty(e, t, {
                            enumerable: !0,
                            get: n
                        });
                    }, r.r = function(e) {
                        "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
                            value: "Module"
                        }), Object.defineProperty(e, "__esModule", {
                            value: !0
                        });
                    }, r.t = function(e, t) {
                        if (1 & t && (e = r(e)), 8 & t) return e;
                        if (4 & t && "object" == typeof e && e && e.__esModule) return e;
                        var n = Object.create(null);
                        if (r.r(n), Object.defineProperty(n, "default", {
                            enumerable: !0,
                            value: e
                        }), 2 & t && "string" != typeof e) for(var i in e)r.d(n, i, (function(t) {
                            return e[t];
                        }).bind(null, i));
                        return n;
                    }, r.n = function(e) {
                        var t = e && e.__esModule ? function() {
                            return e.default;
                        } : function() {
                            return e;
                        };
                        return r.d(t, "a", t), t;
                    }, r.o = function(e, t) {
                        return Object.prototype.hasOwnProperty.call(e, t);
                    }, r.p = "", r(r.s = 90);
                }({
                    17: function(e, t, r) {
                        "use strict";
                        t.__esModule = !0, t.default = void 0;
                        var n = r(18), i = function() {
                            function e() {}
                            return e.getFirstMatch = function(e, t) {
                                var r = t.match(e);
                                return r && r.length > 0 && r[1] || "";
                            }, e.getSecondMatch = function(e, t) {
                                var r = t.match(e);
                                return r && r.length > 1 && r[2] || "";
                            }, e.matchAndReturnConst = function(e, t, r) {
                                if (e.test(t)) return r;
                            }, e.getWindowsVersionName = function(e) {
                                switch(e){
                                    case "NT":
                                        return "NT";
                                    case "XP":
                                    case "NT 5.1":
                                        return "XP";
                                    case "NT 5.0":
                                        return "2000";
                                    case "NT 5.2":
                                        return "2003";
                                    case "NT 6.0":
                                        return "Vista";
                                    case "NT 6.1":
                                        return "7";
                                    case "NT 6.2":
                                        return "8";
                                    case "NT 6.3":
                                        return "8.1";
                                    case "NT 10.0":
                                        return "10";
                                    default:
                                        return;
                                }
                            }, e.getMacOSVersionName = function(e) {
                                var t = e.split(".").splice(0, 2).map(function(e) {
                                    return parseInt(e, 10) || 0;
                                });
                                if (t.push(0), 10 === t[0]) switch(t[1]){
                                    case 5:
                                        return "Leopard";
                                    case 6:
                                        return "Snow Leopard";
                                    case 7:
                                        return "Lion";
                                    case 8:
                                        return "Mountain Lion";
                                    case 9:
                                        return "Mavericks";
                                    case 10:
                                        return "Yosemite";
                                    case 11:
                                        return "El Capitan";
                                    case 12:
                                        return "Sierra";
                                    case 13:
                                        return "High Sierra";
                                    case 14:
                                        return "Mojave";
                                    case 15:
                                        return "Catalina";
                                    default:
                                        return;
                                }
                            }, e.getAndroidVersionName = function(e) {
                                var t = e.split(".").splice(0, 2).map(function(e) {
                                    return parseInt(e, 10) || 0;
                                });
                                if (t.push(0), !(1 === t[0] && t[1] < 5)) return 1 === t[0] && t[1] < 6 ? "Cupcake" : 1 === t[0] && t[1] >= 6 ? "Donut" : 2 === t[0] && t[1] < 2 ? "Eclair" : 2 === t[0] && 2 === t[1] ? "Froyo" : 2 === t[0] && t[1] > 2 ? "Gingerbread" : 3 === t[0] ? "Honeycomb" : 4 === t[0] && t[1] < 1 ? "Ice Cream Sandwich" : 4 === t[0] && t[1] < 4 ? "Jelly Bean" : 4 === t[0] && t[1] >= 4 ? "KitKat" : 5 === t[0] ? "Lollipop" : 6 === t[0] ? "Marshmallow" : 7 === t[0] ? "Nougat" : 8 === t[0] ? "Oreo" : 9 === t[0] ? "Pie" : void 0;
                            }, e.getVersionPrecision = function(e) {
                                return e.split(".").length;
                            }, e.compareVersions = function(t, r, n) {
                                void 0 === n && (n = !1);
                                var i = e.getVersionPrecision(t), o = e.getVersionPrecision(r), a = Math.max(i, o), s = 0, u = e.map([
                                    t,
                                    r
                                ], function(t) {
                                    var r = a - e.getVersionPrecision(t), n = t + new Array(r + 1).join(".0");
                                    return e.map(n.split("."), function(e) {
                                        return new Array(20 - e.length).join("0") + e;
                                    }).reverse();
                                });
                                for(n && (s = a - Math.min(i, o)), a -= 1; a >= s;){
                                    if (u[0][a] > u[1][a]) return 1;
                                    if (u[0][a] === u[1][a]) {
                                        if (a === s) return 0;
                                        a -= 1;
                                    } else if (u[0][a] < u[1][a]) return -1;
                                }
                            }, e.map = function(e, t) {
                                var r, n = [];
                                if (Array.prototype.map) return Array.prototype.map.call(e, t);
                                for(r = 0; r < e.length; r += 1)n.push(t(e[r]));
                                return n;
                            }, e.find = function(e, t) {
                                var r, n;
                                if (Array.prototype.find) return Array.prototype.find.call(e, t);
                                for(r = 0, n = e.length; r < n; r += 1){
                                    var i = e[r];
                                    if (t(i, r)) return i;
                                }
                            }, e.assign = function(e) {
                                for(var t, r, n = e, i = arguments.length, o = new Array(i > 1 ? i - 1 : 0), a = 1; a < i; a++)o[a - 1] = arguments[a];
                                if (Object.assign) return Object.assign.apply(Object, [
                                    e
                                ].concat(o));
                                var s = function() {
                                    var e = o[t];
                                    "object" == typeof e && null !== e && Object.keys(e).forEach(function(t) {
                                        n[t] = e[t];
                                    });
                                };
                                for(t = 0, r = o.length; t < r; t += 1)s();
                                return e;
                            }, e.getBrowserAlias = function(e) {
                                return n.BROWSER_ALIASES_MAP[e];
                            }, e.getBrowserTypeByAlias = function(e) {
                                return n.BROWSER_MAP[e] || "";
                            }, e;
                        }();
                        t.default = i, e.exports = t.default;
                    },
                    18: function(e, t, r) {
                        "use strict";
                        t.__esModule = !0, t.ENGINE_MAP = t.OS_MAP = t.PLATFORMS_MAP = t.BROWSER_MAP = t.BROWSER_ALIASES_MAP = void 0, t.BROWSER_ALIASES_MAP = {
                            "Amazon Silk": "amazon_silk",
                            "Android Browser": "android",
                            Bada: "bada",
                            BlackBerry: "blackberry",
                            Chrome: "chrome",
                            Chromium: "chromium",
                            Electron: "electron",
                            Epiphany: "epiphany",
                            Firefox: "firefox",
                            Focus: "focus",
                            Generic: "generic",
                            "Google Search": "google_search",
                            Googlebot: "googlebot",
                            "Internet Explorer": "ie",
                            "K-Meleon": "k_meleon",
                            Maxthon: "maxthon",
                            "Microsoft Edge": "edge",
                            "MZ Browser": "mz",
                            "NAVER Whale Browser": "naver",
                            Opera: "opera",
                            "Opera Coast": "opera_coast",
                            PhantomJS: "phantomjs",
                            Puffin: "puffin",
                            QupZilla: "qupzilla",
                            QQ: "qq",
                            QQLite: "qqlite",
                            Safari: "safari",
                            Sailfish: "sailfish",
                            "Samsung Internet for Android": "samsung_internet",
                            SeaMonkey: "seamonkey",
                            Sleipnir: "sleipnir",
                            Swing: "swing",
                            Tizen: "tizen",
                            "UC Browser": "uc",
                            Vivaldi: "vivaldi",
                            "WebOS Browser": "webos",
                            WeChat: "wechat",
                            "Yandex Browser": "yandex",
                            Roku: "roku"
                        }, t.BROWSER_MAP = {
                            amazon_silk: "Amazon Silk",
                            android: "Android Browser",
                            bada: "Bada",
                            blackberry: "BlackBerry",
                            chrome: "Chrome",
                            chromium: "Chromium",
                            electron: "Electron",
                            epiphany: "Epiphany",
                            firefox: "Firefox",
                            focus: "Focus",
                            generic: "Generic",
                            googlebot: "Googlebot",
                            google_search: "Google Search",
                            ie: "Internet Explorer",
                            k_meleon: "K-Meleon",
                            maxthon: "Maxthon",
                            edge: "Microsoft Edge",
                            mz: "MZ Browser",
                            naver: "NAVER Whale Browser",
                            opera: "Opera",
                            opera_coast: "Opera Coast",
                            phantomjs: "PhantomJS",
                            puffin: "Puffin",
                            qupzilla: "QupZilla",
                            qq: "QQ Browser",
                            qqlite: "QQ Browser Lite",
                            safari: "Safari",
                            sailfish: "Sailfish",
                            samsung_internet: "Samsung Internet for Android",
                            seamonkey: "SeaMonkey",
                            sleipnir: "Sleipnir",
                            swing: "Swing",
                            tizen: "Tizen",
                            uc: "UC Browser",
                            vivaldi: "Vivaldi",
                            webos: "WebOS Browser",
                            wechat: "WeChat",
                            yandex: "Yandex Browser"
                        }, t.PLATFORMS_MAP = {
                            tablet: "tablet",
                            mobile: "mobile",
                            desktop: "desktop",
                            tv: "tv"
                        }, t.OS_MAP = {
                            WindowsPhone: "Windows Phone",
                            Windows: "Windows",
                            MacOS: "macOS",
                            iOS: "iOS",
                            Android: "Android",
                            WebOS: "WebOS",
                            BlackBerry: "BlackBerry",
                            Bada: "Bada",
                            Tizen: "Tizen",
                            Linux: "Linux",
                            ChromeOS: "Chrome OS",
                            PlayStation4: "PlayStation 4",
                            Roku: "Roku"
                        }, t.ENGINE_MAP = {
                            EdgeHTML: "EdgeHTML",
                            Blink: "Blink",
                            Trident: "Trident",
                            Presto: "Presto",
                            Gecko: "Gecko",
                            WebKit: "WebKit"
                        };
                    },
                    90: function(e, t, r) {
                        "use strict";
                        t.__esModule = !0, t.default = void 0;
                        var n, i = (n = r(91)) && n.__esModule ? n : {
                            default: n
                        }, o = r(18);
                        function a(e, t) {
                            for(var r = 0; r < t.length; r++){
                                var n = t[r];
                                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
                            }
                        }
                        var s = function() {
                            function e() {}
                            var t, r, n;
                            return e.getParser = function(e, t) {
                                if (void 0 === t && (t = !1), "string" != typeof e) throw new Error("UserAgent should be a string");
                                return new i.default(e, t);
                            }, e.parse = function(e) {
                                return new i.default(e).getResult();
                            }, t = e, n = [
                                {
                                    key: "BROWSER_MAP",
                                    get: function() {
                                        return o.BROWSER_MAP;
                                    }
                                },
                                {
                                    key: "ENGINE_MAP",
                                    get: function() {
                                        return o.ENGINE_MAP;
                                    }
                                },
                                {
                                    key: "OS_MAP",
                                    get: function() {
                                        return o.OS_MAP;
                                    }
                                },
                                {
                                    key: "PLATFORMS_MAP",
                                    get: function() {
                                        return o.PLATFORMS_MAP;
                                    }
                                }
                            ], r = null, n && a(t, n), e;
                        }();
                        t.default = s, e.exports = t.default;
                    },
                    91: function(e, t, r) {
                        "use strict";
                        t.__esModule = !0, t.default = void 0;
                        var n = u(r(92)), i = u(r(93)), o = u(r(94)), a = u(r(95)), s = u(r(17));
                        function u(e) {
                            return e && e.__esModule ? e : {
                                default: e
                            };
                        }
                        var c = function() {
                            function e(e, t) {
                                if (void 0 === t && (t = !1), null == e || "" === e) throw new Error("UserAgent parameter can't be empty");
                                this._ua = e, this.parsedResult = {}, !0 !== t && this.parse();
                            }
                            var t = e.prototype;
                            return t.getUA = function() {
                                return this._ua;
                            }, t.test = function(e) {
                                return e.test(this._ua);
                            }, t.parseBrowser = function() {
                                var e = this;
                                this.parsedResult.browser = {};
                                var t = s.default.find(n.default, function(t) {
                                    if ("function" == typeof t.test) return t.test(e);
                                    if (t.test instanceof Array) return t.test.some(function(t) {
                                        return e.test(t);
                                    });
                                    throw new Error("Browser's test function is not valid");
                                });
                                return t && (this.parsedResult.browser = t.describe(this.getUA())), this.parsedResult.browser;
                            }, t.getBrowser = function() {
                                return this.parsedResult.browser ? this.parsedResult.browser : this.parseBrowser();
                            }, t.getBrowserName = function(e) {
                                return e ? String(this.getBrowser().name).toLowerCase() || "" : this.getBrowser().name || "";
                            }, t.getBrowserVersion = function() {
                                return this.getBrowser().version;
                            }, t.getOS = function() {
                                return this.parsedResult.os ? this.parsedResult.os : this.parseOS();
                            }, t.parseOS = function() {
                                var e = this;
                                this.parsedResult.os = {};
                                var t = s.default.find(i.default, function(t) {
                                    if ("function" == typeof t.test) return t.test(e);
                                    if (t.test instanceof Array) return t.test.some(function(t) {
                                        return e.test(t);
                                    });
                                    throw new Error("Browser's test function is not valid");
                                });
                                return t && (this.parsedResult.os = t.describe(this.getUA())), this.parsedResult.os;
                            }, t.getOSName = function(e) {
                                var t = this.getOS().name;
                                return e ? String(t).toLowerCase() || "" : t || "";
                            }, t.getOSVersion = function() {
                                return this.getOS().version;
                            }, t.getPlatform = function() {
                                return this.parsedResult.platform ? this.parsedResult.platform : this.parsePlatform();
                            }, t.getPlatformType = function(e) {
                                void 0 === e && (e = !1);
                                var t = this.getPlatform().type;
                                return e ? String(t).toLowerCase() || "" : t || "";
                            }, t.parsePlatform = function() {
                                var e = this;
                                this.parsedResult.platform = {};
                                var t = s.default.find(o.default, function(t) {
                                    if ("function" == typeof t.test) return t.test(e);
                                    if (t.test instanceof Array) return t.test.some(function(t) {
                                        return e.test(t);
                                    });
                                    throw new Error("Browser's test function is not valid");
                                });
                                return t && (this.parsedResult.platform = t.describe(this.getUA())), this.parsedResult.platform;
                            }, t.getEngine = function() {
                                return this.parsedResult.engine ? this.parsedResult.engine : this.parseEngine();
                            }, t.getEngineName = function(e) {
                                return e ? String(this.getEngine().name).toLowerCase() || "" : this.getEngine().name || "";
                            }, t.parseEngine = function() {
                                var e = this;
                                this.parsedResult.engine = {};
                                var t = s.default.find(a.default, function(t) {
                                    if ("function" == typeof t.test) return t.test(e);
                                    if (t.test instanceof Array) return t.test.some(function(t) {
                                        return e.test(t);
                                    });
                                    throw new Error("Browser's test function is not valid");
                                });
                                return t && (this.parsedResult.engine = t.describe(this.getUA())), this.parsedResult.engine;
                            }, t.parse = function() {
                                return this.parseBrowser(), this.parseOS(), this.parsePlatform(), this.parseEngine(), this;
                            }, t.getResult = function() {
                                return s.default.assign({}, this.parsedResult);
                            }, t.satisfies = function(e) {
                                var t = this, r = {}, n = 0, i = {}, o = 0;
                                if (Object.keys(e).forEach(function(t) {
                                    var a = e[t];
                                    "string" == typeof a ? (i[t] = a, o += 1) : "object" == typeof a && (r[t] = a, n += 1);
                                }), n > 0) {
                                    var a = Object.keys(r), u = s.default.find(a, function(e) {
                                        return t.isOS(e);
                                    });
                                    if (u) {
                                        var c = this.satisfies(r[u]);
                                        if (void 0 !== c) return c;
                                    }
                                    var l = s.default.find(a, function(e) {
                                        return t.isPlatform(e);
                                    });
                                    if (l) {
                                        var f = this.satisfies(r[l]);
                                        if (void 0 !== f) return f;
                                    }
                                }
                                if (o > 0) {
                                    var p = Object.keys(i), d = s.default.find(p, function(e) {
                                        return t.isBrowser(e, !0);
                                    });
                                    if (void 0 !== d) return this.compareVersion(i[d]);
                                }
                            }, t.isBrowser = function(e, t) {
                                void 0 === t && (t = !1);
                                var r = this.getBrowserName().toLowerCase(), n = e.toLowerCase(), i = s.default.getBrowserTypeByAlias(n);
                                return t && i && (n = i.toLowerCase()), n === r;
                            }, t.compareVersion = function(e) {
                                var t = [
                                    0
                                ], r = e, n = !1, i = this.getBrowserVersion();
                                if ("string" == typeof i) return ">" === e[0] || "<" === e[0] ? (r = e.substr(1), "=" === e[1] ? (n = !0, r = e.substr(2)) : t = [], t.push(">" === e[0] ? 1 : -1)) : "=" === e[0] ? r = e.substr(1) : "~" === e[0] && (n = !0, r = e.substr(1)), t.indexOf(s.default.compareVersions(i, r, n)) > -1;
                            }, t.isOS = function(e) {
                                return this.getOSName(!0) === String(e).toLowerCase();
                            }, t.isPlatform = function(e) {
                                return this.getPlatformType(!0) === String(e).toLowerCase();
                            }, t.isEngine = function(e) {
                                return this.getEngineName(!0) === String(e).toLowerCase();
                            }, t.is = function(e, t) {
                                return void 0 === t && (t = !1), this.isBrowser(e, t) || this.isOS(e) || this.isPlatform(e);
                            }, t.some = function(e) {
                                var t = this;
                                return void 0 === e && (e = []), e.some(function(e) {
                                    return t.is(e);
                                });
                            }, e;
                        }();
                        t.default = c, e.exports = t.default;
                    },
                    92: function(e, t, r) {
                        "use strict";
                        t.__esModule = !0, t.default = void 0;
                        var n, i = (n = r(17)) && n.__esModule ? n : {
                            default: n
                        }, o = /version\/(\d+(\.?_?\d+)+)/i, a = [
                            {
                                test: [
                                    /googlebot/i
                                ],
                                describe: function(e) {
                                    var t = {
                                        name: "Googlebot"
                                    }, r = i.default.getFirstMatch(/googlebot\/(\d+(\.\d+))/i, e) || i.default.getFirstMatch(o, e);
                                    return r && (t.version = r), t;
                                }
                            },
                            {
                                test: [
                                    /opera/i
                                ],
                                describe: function(e) {
                                    var t = {
                                        name: "Opera"
                                    }, r = i.default.getFirstMatch(o, e) || i.default.getFirstMatch(/(?:opera)[\s/](\d+(\.?_?\d+)+)/i, e);
                                    return r && (t.version = r), t;
                                }
                            },
                            {
                                test: [
                                    /opr\/|opios/i
                                ],
                                describe: function(e) {
                                    var t = {
                                        name: "Opera"
                                    }, r = i.default.getFirstMatch(/(?:opr|opios)[\s/](\S+)/i, e) || i.default.getFirstMatch(o, e);
                                    return r && (t.version = r), t;
                                }
                            },
                            {
                                test: [
                                    /SamsungBrowser/i
                                ],
                                describe: function(e) {
                                    var t = {
                                        name: "Samsung Internet for Android"
                                    }, r = i.default.getFirstMatch(o, e) || i.default.getFirstMatch(/(?:SamsungBrowser)[\s/](\d+(\.?_?\d+)+)/i, e);
                                    return r && (t.version = r), t;
                                }
                            },
                            {
                                test: [
                                    /Whale/i
                                ],
                                describe: function(e) {
                                    var t = {
                                        name: "NAVER Whale Browser"
                                    }, r = i.default.getFirstMatch(o, e) || i.default.getFirstMatch(/(?:whale)[\s/](\d+(?:\.\d+)+)/i, e);
                                    return r && (t.version = r), t;
                                }
                            },
                            {
                                test: [
                                    /MZBrowser/i
                                ],
                                describe: function(e) {
                                    var t = {
                                        name: "MZ Browser"
                                    }, r = i.default.getFirstMatch(/(?:MZBrowser)[\s/](\d+(?:\.\d+)+)/i, e) || i.default.getFirstMatch(o, e);
                                    return r && (t.version = r), t;
                                }
                            },
                            {
                                test: [
                                    /focus/i
                                ],
                                describe: function(e) {
                                    var t = {
                                        name: "Focus"
                                    }, r = i.default.getFirstMatch(/(?:focus)[\s/](\d+(?:\.\d+)+)/i, e) || i.default.getFirstMatch(o, e);
                                    return r && (t.version = r), t;
                                }
                            },
                            {
                                test: [
                                    /swing/i
                                ],
                                describe: function(e) {
                                    var t = {
                                        name: "Swing"
                                    }, r = i.default.getFirstMatch(/(?:swing)[\s/](\d+(?:\.\d+)+)/i, e) || i.default.getFirstMatch(o, e);
                                    return r && (t.version = r), t;
                                }
                            },
                            {
                                test: [
                                    /coast/i
                                ],
                                describe: function(e) {
                                    var t = {
                                        name: "Opera Coast"
                                    }, r = i.default.getFirstMatch(o, e) || i.default.getFirstMatch(/(?:coast)[\s/](\d+(\.?_?\d+)+)/i, e);
                                    return r && (t.version = r), t;
                                }
                            },
                            {
                                test: [
                                    /opt\/\d+(?:.?_?\d+)+/i
                                ],
                                describe: function(e) {
                                    var t = {
                                        name: "Opera Touch"
                                    }, r = i.default.getFirstMatch(/(?:opt)[\s/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(o, e);
                                    return r && (t.version = r), t;
                                }
                            },
                            {
                                test: [
                                    /yabrowser/i
                                ],
                                describe: function(e) {
                                    var t = {
                                        name: "Yandex Browser"
                                    }, r = i.default.getFirstMatch(/(?:yabrowser)[\s/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(o, e);
                                    return r && (t.version = r), t;
                                }
                            },
                            {
                                test: [
                                    /ucbrowser/i
                                ],
                                describe: function(e) {
                                    var t = {
                                        name: "UC Browser"
                                    }, r = i.default.getFirstMatch(o, e) || i.default.getFirstMatch(/(?:ucbrowser)[\s/](\d+(\.?_?\d+)+)/i, e);
                                    return r && (t.version = r), t;
                                }
                            },
                            {
                                test: [
                                    /Maxthon|mxios/i
                                ],
                                describe: function(e) {
                                    var t = {
                                        name: "Maxthon"
                                    }, r = i.default.getFirstMatch(o, e) || i.default.getFirstMatch(/(?:Maxthon|mxios)[\s/](\d+(\.?_?\d+)+)/i, e);
                                    return r && (t.version = r), t;
                                }
                            },
                            {
                                test: [
                                    /epiphany/i
                                ],
                                describe: function(e) {
                                    var t = {
                                        name: "Epiphany"
                                    }, r = i.default.getFirstMatch(o, e) || i.default.getFirstMatch(/(?:epiphany)[\s/](\d+(\.?_?\d+)+)/i, e);
                                    return r && (t.version = r), t;
                                }
                            },
                            {
                                test: [
                                    /puffin/i
                                ],
                                describe: function(e) {
                                    var t = {
                                        name: "Puffin"
                                    }, r = i.default.getFirstMatch(o, e) || i.default.getFirstMatch(/(?:puffin)[\s/](\d+(\.?_?\d+)+)/i, e);
                                    return r && (t.version = r), t;
                                }
                            },
                            {
                                test: [
                                    /sleipnir/i
                                ],
                                describe: function(e) {
                                    var t = {
                                        name: "Sleipnir"
                                    }, r = i.default.getFirstMatch(o, e) || i.default.getFirstMatch(/(?:sleipnir)[\s/](\d+(\.?_?\d+)+)/i, e);
                                    return r && (t.version = r), t;
                                }
                            },
                            {
                                test: [
                                    /k-meleon/i
                                ],
                                describe: function(e) {
                                    var t = {
                                        name: "K-Meleon"
                                    }, r = i.default.getFirstMatch(o, e) || i.default.getFirstMatch(/(?:k-meleon)[\s/](\d+(\.?_?\d+)+)/i, e);
                                    return r && (t.version = r), t;
                                }
                            },
                            {
                                test: [
                                    /micromessenger/i
                                ],
                                describe: function(e) {
                                    var t = {
                                        name: "WeChat"
                                    }, r = i.default.getFirstMatch(/(?:micromessenger)[\s/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(o, e);
                                    return r && (t.version = r), t;
                                }
                            },
                            {
                                test: [
                                    /qqbrowser/i
                                ],
                                describe: function(e) {
                                    var t = {
                                        name: /qqbrowserlite/i.test(e) ? "QQ Browser Lite" : "QQ Browser"
                                    }, r = i.default.getFirstMatch(/(?:qqbrowserlite|qqbrowser)[/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(o, e);
                                    return r && (t.version = r), t;
                                }
                            },
                            {
                                test: [
                                    /msie|trident/i
                                ],
                                describe: function(e) {
                                    var t = {
                                        name: "Internet Explorer"
                                    }, r = i.default.getFirstMatch(/(?:msie |rv:)(\d+(\.?_?\d+)+)/i, e);
                                    return r && (t.version = r), t;
                                }
                            },
                            {
                                test: [
                                    /\sedg\//i
                                ],
                                describe: function(e) {
                                    var t = {
                                        name: "Microsoft Edge"
                                    }, r = i.default.getFirstMatch(/\sedg\/(\d+(\.?_?\d+)+)/i, e);
                                    return r && (t.version = r), t;
                                }
                            },
                            {
                                test: [
                                    /edg([ea]|ios)/i
                                ],
                                describe: function(e) {
                                    var t = {
                                        name: "Microsoft Edge"
                                    }, r = i.default.getSecondMatch(/edg([ea]|ios)\/(\d+(\.?_?\d+)+)/i, e);
                                    return r && (t.version = r), t;
                                }
                            },
                            {
                                test: [
                                    /vivaldi/i
                                ],
                                describe: function(e) {
                                    var t = {
                                        name: "Vivaldi"
                                    }, r = i.default.getFirstMatch(/vivaldi\/(\d+(\.?_?\d+)+)/i, e);
                                    return r && (t.version = r), t;
                                }
                            },
                            {
                                test: [
                                    /seamonkey/i
                                ],
                                describe: function(e) {
                                    var t = {
                                        name: "SeaMonkey"
                                    }, r = i.default.getFirstMatch(/seamonkey\/(\d+(\.?_?\d+)+)/i, e);
                                    return r && (t.version = r), t;
                                }
                            },
                            {
                                test: [
                                    /sailfish/i
                                ],
                                describe: function(e) {
                                    var t = {
                                        name: "Sailfish"
                                    }, r = i.default.getFirstMatch(/sailfish\s?browser\/(\d+(\.\d+)?)/i, e);
                                    return r && (t.version = r), t;
                                }
                            },
                            {
                                test: [
                                    /silk/i
                                ],
                                describe: function(e) {
                                    var t = {
                                        name: "Amazon Silk"
                                    }, r = i.default.getFirstMatch(/silk\/(\d+(\.?_?\d+)+)/i, e);
                                    return r && (t.version = r), t;
                                }
                            },
                            {
                                test: [
                                    /phantom/i
                                ],
                                describe: function(e) {
                                    var t = {
                                        name: "PhantomJS"
                                    }, r = i.default.getFirstMatch(/phantomjs\/(\d+(\.?_?\d+)+)/i, e);
                                    return r && (t.version = r), t;
                                }
                            },
                            {
                                test: [
                                    /slimerjs/i
                                ],
                                describe: function(e) {
                                    var t = {
                                        name: "SlimerJS"
                                    }, r = i.default.getFirstMatch(/slimerjs\/(\d+(\.?_?\d+)+)/i, e);
                                    return r && (t.version = r), t;
                                }
                            },
                            {
                                test: [
                                    /blackberry|\bbb\d+/i,
                                    /rim\stablet/i
                                ],
                                describe: function(e) {
                                    var t = {
                                        name: "BlackBerry"
                                    }, r = i.default.getFirstMatch(o, e) || i.default.getFirstMatch(/blackberry[\d]+\/(\d+(\.?_?\d+)+)/i, e);
                                    return r && (t.version = r), t;
                                }
                            },
                            {
                                test: [
                                    /(web|hpw)[o0]s/i
                                ],
                                describe: function(e) {
                                    var t = {
                                        name: "WebOS Browser"
                                    }, r = i.default.getFirstMatch(o, e) || i.default.getFirstMatch(/w(?:eb)?[o0]sbrowser\/(\d+(\.?_?\d+)+)/i, e);
                                    return r && (t.version = r), t;
                                }
                            },
                            {
                                test: [
                                    /bada/i
                                ],
                                describe: function(e) {
                                    var t = {
                                        name: "Bada"
                                    }, r = i.default.getFirstMatch(/dolfin\/(\d+(\.?_?\d+)+)/i, e);
                                    return r && (t.version = r), t;
                                }
                            },
                            {
                                test: [
                                    /tizen/i
                                ],
                                describe: function(e) {
                                    var t = {
                                        name: "Tizen"
                                    }, r = i.default.getFirstMatch(/(?:tizen\s?)?browser\/(\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(o, e);
                                    return r && (t.version = r), t;
                                }
                            },
                            {
                                test: [
                                    /qupzilla/i
                                ],
                                describe: function(e) {
                                    var t = {
                                        name: "QupZilla"
                                    }, r = i.default.getFirstMatch(/(?:qupzilla)[\s/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(o, e);
                                    return r && (t.version = r), t;
                                }
                            },
                            {
                                test: [
                                    /firefox|iceweasel|fxios/i
                                ],
                                describe: function(e) {
                                    var t = {
                                        name: "Firefox"
                                    }, r = i.default.getFirstMatch(/(?:firefox|iceweasel|fxios)[\s/](\d+(\.?_?\d+)+)/i, e);
                                    return r && (t.version = r), t;
                                }
                            },
                            {
                                test: [
                                    /electron/i
                                ],
                                describe: function(e) {
                                    var t = {
                                        name: "Electron"
                                    }, r = i.default.getFirstMatch(/(?:electron)\/(\d+(\.?_?\d+)+)/i, e);
                                    return r && (t.version = r), t;
                                }
                            },
                            {
                                test: [
                                    /MiuiBrowser/i
                                ],
                                describe: function(e) {
                                    var t = {
                                        name: "Miui"
                                    }, r = i.default.getFirstMatch(/(?:MiuiBrowser)[\s/](\d+(\.?_?\d+)+)/i, e);
                                    return r && (t.version = r), t;
                                }
                            },
                            {
                                test: [
                                    /chromium/i
                                ],
                                describe: function(e) {
                                    var t = {
                                        name: "Chromium"
                                    }, r = i.default.getFirstMatch(/(?:chromium)[\s/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(o, e);
                                    return r && (t.version = r), t;
                                }
                            },
                            {
                                test: [
                                    /chrome|crios|crmo/i
                                ],
                                describe: function(e) {
                                    var t = {
                                        name: "Chrome"
                                    }, r = i.default.getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.?_?\d+)+)/i, e);
                                    return r && (t.version = r), t;
                                }
                            },
                            {
                                test: [
                                    /GSA/i
                                ],
                                describe: function(e) {
                                    var t = {
                                        name: "Google Search"
                                    }, r = i.default.getFirstMatch(/(?:GSA)\/(\d+(\.?_?\d+)+)/i, e);
                                    return r && (t.version = r), t;
                                }
                            },
                            {
                                test: function(e) {
                                    var t = !e.test(/like android/i), r = e.test(/android/i);
                                    return t && r;
                                },
                                describe: function(e) {
                                    var t = {
                                        name: "Android Browser"
                                    }, r = i.default.getFirstMatch(o, e);
                                    return r && (t.version = r), t;
                                }
                            },
                            {
                                test: [
                                    /playstation 4/i
                                ],
                                describe: function(e) {
                                    var t = {
                                        name: "PlayStation 4"
                                    }, r = i.default.getFirstMatch(o, e);
                                    return r && (t.version = r), t;
                                }
                            },
                            {
                                test: [
                                    /safari|applewebkit/i
                                ],
                                describe: function(e) {
                                    var t = {
                                        name: "Safari"
                                    }, r = i.default.getFirstMatch(o, e);
                                    return r && (t.version = r), t;
                                }
                            },
                            {
                                test: [
                                    /.*/i
                                ],
                                describe: function(e) {
                                    var t = -1 !== e.search("\\(") ? /^(.*)\/(.*)[ \t]\((.*)/ : /^(.*)\/(.*) /;
                                    return {
                                        name: i.default.getFirstMatch(t, e),
                                        version: i.default.getSecondMatch(t, e)
                                    };
                                }
                            }
                        ];
                        t.default = a, e.exports = t.default;
                    },
                    93: function(e, t, r) {
                        "use strict";
                        t.__esModule = !0, t.default = void 0;
                        var n, i = (n = r(17)) && n.__esModule ? n : {
                            default: n
                        }, o = r(18), a = [
                            {
                                test: [
                                    /Roku\/DVP/
                                ],
                                describe: function(e) {
                                    var t = i.default.getFirstMatch(/Roku\/DVP-(\d+\.\d+)/i, e);
                                    return {
                                        name: o.OS_MAP.Roku,
                                        version: t
                                    };
                                }
                            },
                            {
                                test: [
                                    /windows phone/i
                                ],
                                describe: function(e) {
                                    var t = i.default.getFirstMatch(/windows phone (?:os)?\s?(\d+(\.\d+)*)/i, e);
                                    return {
                                        name: o.OS_MAP.WindowsPhone,
                                        version: t
                                    };
                                }
                            },
                            {
                                test: [
                                    /windows /i
                                ],
                                describe: function(e) {
                                    var t = i.default.getFirstMatch(/Windows ((NT|XP)( \d\d?.\d)?)/i, e), r = i.default.getWindowsVersionName(t);
                                    return {
                                        name: o.OS_MAP.Windows,
                                        version: t,
                                        versionName: r
                                    };
                                }
                            },
                            {
                                test: [
                                    /Macintosh(.*?) FxiOS(.*?)\//
                                ],
                                describe: function(e) {
                                    var t = {
                                        name: o.OS_MAP.iOS
                                    }, r = i.default.getSecondMatch(/(Version\/)(\d[\d.]+)/, e);
                                    return r && (t.version = r), t;
                                }
                            },
                            {
                                test: [
                                    /macintosh/i
                                ],
                                describe: function(e) {
                                    var t = i.default.getFirstMatch(/mac os x (\d+(\.?_?\d+)+)/i, e).replace(/[_\s]/g, "."), r = i.default.getMacOSVersionName(t), n = {
                                        name: o.OS_MAP.MacOS,
                                        version: t
                                    };
                                    return r && (n.versionName = r), n;
                                }
                            },
                            {
                                test: [
                                    /(ipod|iphone|ipad)/i
                                ],
                                describe: function(e) {
                                    var t = i.default.getFirstMatch(/os (\d+([_\s]\d+)*) like mac os x/i, e).replace(/[_\s]/g, ".");
                                    return {
                                        name: o.OS_MAP.iOS,
                                        version: t
                                    };
                                }
                            },
                            {
                                test: function(e) {
                                    var t = !e.test(/like android/i), r = e.test(/android/i);
                                    return t && r;
                                },
                                describe: function(e) {
                                    var t = i.default.getFirstMatch(/android[\s/-](\d+(\.\d+)*)/i, e), r = i.default.getAndroidVersionName(t), n = {
                                        name: o.OS_MAP.Android,
                                        version: t
                                    };
                                    return r && (n.versionName = r), n;
                                }
                            },
                            {
                                test: [
                                    /(web|hpw)[o0]s/i
                                ],
                                describe: function(e) {
                                    var t = i.default.getFirstMatch(/(?:web|hpw)[o0]s\/(\d+(\.\d+)*)/i, e), r = {
                                        name: o.OS_MAP.WebOS
                                    };
                                    return t && t.length && (r.version = t), r;
                                }
                            },
                            {
                                test: [
                                    /blackberry|\bbb\d+/i,
                                    /rim\stablet/i
                                ],
                                describe: function(e) {
                                    var t = i.default.getFirstMatch(/rim\stablet\sos\s(\d+(\.\d+)*)/i, e) || i.default.getFirstMatch(/blackberry\d+\/(\d+([_\s]\d+)*)/i, e) || i.default.getFirstMatch(/\bbb(\d+)/i, e);
                                    return {
                                        name: o.OS_MAP.BlackBerry,
                                        version: t
                                    };
                                }
                            },
                            {
                                test: [
                                    /bada/i
                                ],
                                describe: function(e) {
                                    var t = i.default.getFirstMatch(/bada\/(\d+(\.\d+)*)/i, e);
                                    return {
                                        name: o.OS_MAP.Bada,
                                        version: t
                                    };
                                }
                            },
                            {
                                test: [
                                    /tizen/i
                                ],
                                describe: function(e) {
                                    var t = i.default.getFirstMatch(/tizen[/\s](\d+(\.\d+)*)/i, e);
                                    return {
                                        name: o.OS_MAP.Tizen,
                                        version: t
                                    };
                                }
                            },
                            {
                                test: [
                                    /linux/i
                                ],
                                describe: function() {
                                    return {
                                        name: o.OS_MAP.Linux
                                    };
                                }
                            },
                            {
                                test: [
                                    /CrOS/
                                ],
                                describe: function() {
                                    return {
                                        name: o.OS_MAP.ChromeOS
                                    };
                                }
                            },
                            {
                                test: [
                                    /PlayStation 4/
                                ],
                                describe: function(e) {
                                    var t = i.default.getFirstMatch(/PlayStation 4[/\s](\d+(\.\d+)*)/i, e);
                                    return {
                                        name: o.OS_MAP.PlayStation4,
                                        version: t
                                    };
                                }
                            }
                        ];
                        t.default = a, e.exports = t.default;
                    },
                    94: function(e, t, r) {
                        "use strict";
                        t.__esModule = !0, t.default = void 0;
                        var n, i = (n = r(17)) && n.__esModule ? n : {
                            default: n
                        }, o = r(18), a = [
                            {
                                test: [
                                    /googlebot/i
                                ],
                                describe: function() {
                                    return {
                                        type: "bot",
                                        vendor: "Google"
                                    };
                                }
                            },
                            {
                                test: [
                                    /huawei/i
                                ],
                                describe: function(e) {
                                    var t = i.default.getFirstMatch(/(can-l01)/i, e) && "Nova", r = {
                                        type: o.PLATFORMS_MAP.mobile,
                                        vendor: "Huawei"
                                    };
                                    return t && (r.model = t), r;
                                }
                            },
                            {
                                test: [
                                    /nexus\s*(?:7|8|9|10).*/i
                                ],
                                describe: function() {
                                    return {
                                        type: o.PLATFORMS_MAP.tablet,
                                        vendor: "Nexus"
                                    };
                                }
                            },
                            {
                                test: [
                                    /ipad/i
                                ],
                                describe: function() {
                                    return {
                                        type: o.PLATFORMS_MAP.tablet,
                                        vendor: "Apple",
                                        model: "iPad"
                                    };
                                }
                            },
                            {
                                test: [
                                    /Macintosh(.*?) FxiOS(.*?)\//
                                ],
                                describe: function() {
                                    return {
                                        type: o.PLATFORMS_MAP.tablet,
                                        vendor: "Apple",
                                        model: "iPad"
                                    };
                                }
                            },
                            {
                                test: [
                                    /kftt build/i
                                ],
                                describe: function() {
                                    return {
                                        type: o.PLATFORMS_MAP.tablet,
                                        vendor: "Amazon",
                                        model: "Kindle Fire HD 7"
                                    };
                                }
                            },
                            {
                                test: [
                                    /silk/i
                                ],
                                describe: function() {
                                    return {
                                        type: o.PLATFORMS_MAP.tablet,
                                        vendor: "Amazon"
                                    };
                                }
                            },
                            {
                                test: [
                                    /tablet(?! pc)/i
                                ],
                                describe: function() {
                                    return {
                                        type: o.PLATFORMS_MAP.tablet
                                    };
                                }
                            },
                            {
                                test: function(e) {
                                    var t = e.test(/ipod|iphone/i), r = e.test(/like (ipod|iphone)/i);
                                    return t && !r;
                                },
                                describe: function(e) {
                                    var t = i.default.getFirstMatch(/(ipod|iphone)/i, e);
                                    return {
                                        type: o.PLATFORMS_MAP.mobile,
                                        vendor: "Apple",
                                        model: t
                                    };
                                }
                            },
                            {
                                test: [
                                    /nexus\s*[0-6].*/i,
                                    /galaxy nexus/i
                                ],
                                describe: function() {
                                    return {
                                        type: o.PLATFORMS_MAP.mobile,
                                        vendor: "Nexus"
                                    };
                                }
                            },
                            {
                                test: [
                                    /[^-]mobi/i
                                ],
                                describe: function() {
                                    return {
                                        type: o.PLATFORMS_MAP.mobile
                                    };
                                }
                            },
                            {
                                test: function(e) {
                                    return "blackberry" === e.getBrowserName(!0);
                                },
                                describe: function() {
                                    return {
                                        type: o.PLATFORMS_MAP.mobile,
                                        vendor: "BlackBerry"
                                    };
                                }
                            },
                            {
                                test: function(e) {
                                    return "bada" === e.getBrowserName(!0);
                                },
                                describe: function() {
                                    return {
                                        type: o.PLATFORMS_MAP.mobile
                                    };
                                }
                            },
                            {
                                test: function(e) {
                                    return "windows phone" === e.getBrowserName();
                                },
                                describe: function() {
                                    return {
                                        type: o.PLATFORMS_MAP.mobile,
                                        vendor: "Microsoft"
                                    };
                                }
                            },
                            {
                                test: function(e) {
                                    var t = Number(String(e.getOSVersion()).split(".")[0]);
                                    return "android" === e.getOSName(!0) && t >= 3;
                                },
                                describe: function() {
                                    return {
                                        type: o.PLATFORMS_MAP.tablet
                                    };
                                }
                            },
                            {
                                test: function(e) {
                                    return "android" === e.getOSName(!0);
                                },
                                describe: function() {
                                    return {
                                        type: o.PLATFORMS_MAP.mobile
                                    };
                                }
                            },
                            {
                                test: function(e) {
                                    return "macos" === e.getOSName(!0);
                                },
                                describe: function() {
                                    return {
                                        type: o.PLATFORMS_MAP.desktop,
                                        vendor: "Apple"
                                    };
                                }
                            },
                            {
                                test: function(e) {
                                    return "windows" === e.getOSName(!0);
                                },
                                describe: function() {
                                    return {
                                        type: o.PLATFORMS_MAP.desktop
                                    };
                                }
                            },
                            {
                                test: function(e) {
                                    return "linux" === e.getOSName(!0);
                                },
                                describe: function() {
                                    return {
                                        type: o.PLATFORMS_MAP.desktop
                                    };
                                }
                            },
                            {
                                test: function(e) {
                                    return "playstation 4" === e.getOSName(!0);
                                },
                                describe: function() {
                                    return {
                                        type: o.PLATFORMS_MAP.tv
                                    };
                                }
                            },
                            {
                                test: function(e) {
                                    return "roku" === e.getOSName(!0);
                                },
                                describe: function() {
                                    return {
                                        type: o.PLATFORMS_MAP.tv
                                    };
                                }
                            }
                        ];
                        t.default = a, e.exports = t.default;
                    },
                    95: function(e, t, r) {
                        "use strict";
                        t.__esModule = !0, t.default = void 0;
                        var n, i = (n = r(17)) && n.__esModule ? n : {
                            default: n
                        }, o = r(18), a = [
                            {
                                test: function(e) {
                                    return "microsoft edge" === e.getBrowserName(!0);
                                },
                                describe: function(e) {
                                    if (/\sedg\//i.test(e)) return {
                                        name: o.ENGINE_MAP.Blink
                                    };
                                    var t = i.default.getFirstMatch(/edge\/(\d+(\.?_?\d+)+)/i, e);
                                    return {
                                        name: o.ENGINE_MAP.EdgeHTML,
                                        version: t
                                    };
                                }
                            },
                            {
                                test: [
                                    /trident/i
                                ],
                                describe: function(e) {
                                    var t = {
                                        name: o.ENGINE_MAP.Trident
                                    }, r = i.default.getFirstMatch(/trident\/(\d+(\.?_?\d+)+)/i, e);
                                    return r && (t.version = r), t;
                                }
                            },
                            {
                                test: function(e) {
                                    return e.test(/presto/i);
                                },
                                describe: function(e) {
                                    var t = {
                                        name: o.ENGINE_MAP.Presto
                                    }, r = i.default.getFirstMatch(/presto\/(\d+(\.?_?\d+)+)/i, e);
                                    return r && (t.version = r), t;
                                }
                            },
                            {
                                test: function(e) {
                                    var t = e.test(/gecko/i), r = e.test(/like gecko/i);
                                    return t && !r;
                                },
                                describe: function(e) {
                                    var t = {
                                        name: o.ENGINE_MAP.Gecko
                                    }, r = i.default.getFirstMatch(/gecko\/(\d+(\.?_?\d+)+)/i, e);
                                    return r && (t.version = r), t;
                                }
                            },
                            {
                                test: [
                                    /(apple)?webkit\/537\.36/i
                                ],
                                describe: function() {
                                    return {
                                        name: o.ENGINE_MAP.Blink
                                    };
                                }
                            },
                            {
                                test: [
                                    /(apple)?webkit/i
                                ],
                                describe: function(e) {
                                    var t = {
                                        name: o.ENGINE_MAP.WebKit
                                    }, r = i.default.getFirstMatch(/webkit\/(\d+(\.?_?\d+)+)/i, e);
                                    return r && (t.version = r), t;
                                }
                            }
                        ];
                        t.default = a, e.exports = t.default;
                    }
                });
            },
            7362: (e)=>{
                "use strict";
                e.exports = function(e, t) {
                    t || (t = {}), "function" == typeof t && (t = {
                        cmp: t
                    });
                    var r, n = "boolean" == typeof t.cycles && t.cycles, i = t.cmp && (r = t.cmp, function(e) {
                        return function(t, n) {
                            return r({
                                key: t,
                                value: e[t]
                            }, {
                                key: n,
                                value: e[n]
                            });
                        };
                    }), o = [];
                    return function e(t) {
                        if (t && t.toJSON && "function" == typeof t.toJSON && (t = t.toJSON()), void 0 !== t) {
                            if ("number" == typeof t) return isFinite(t) ? "" + t : "null";
                            if ("object" != typeof t) return JSON.stringify(t);
                            var r, a;
                            if (Array.isArray(t)) {
                                for(a = "[", r = 0; r < t.length; r++)r && (a += ","), a += e(t[r]) || "null";
                                return a + "]";
                            }
                            if (null === t) return "null";
                            if (-1 !== o.indexOf(t)) {
                                if (n) return JSON.stringify("__cycle__");
                                throw new TypeError("Converting circular structure to JSON");
                            }
                            var s = o.push(t) - 1, u = Object.keys(t).sort(i && i(t));
                            for(a = "", r = 0; r < u.length; r++){
                                var c = u[r], l = e(t[c]);
                                l && (a && (a += ","), a += JSON.stringify(c) + ":" + l);
                            }
                            return o.splice(s, 1), "{" + a + "}";
                        }
                    }(e);
                };
            },
            3941: (e, t, r)=>{
                "use strict";
                r.r(t), r.d(t, {
                    default: ()=>X,
                    disableExperimentalFragmentVariables: ()=>G,
                    disableFragmentWarnings: ()=>V,
                    enableExperimentalFragmentVariables: ()=>q,
                    gql: ()=>B,
                    resetCaches: ()=>Q
                });
                var n = function() {
                    return n = Object.assign || function(e) {
                        for(var t, r = 1, n = arguments.length; r < n; r++)for(var i in t = arguments[r])Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
                        return e;
                    }, n.apply(this, arguments);
                };
                "function" == typeof SuppressedError && SuppressedError;
                var i = r(4636);
                function o(e, t) {
                    if (!Boolean(e)) throw new Error(t);
                }
                var a = r(8921);
                function s(e) {
                    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : e.prototype.toString;
                    e.prototype.toJSON = t, e.prototype.inspect = t, a.Z && (e.prototype[a.Z] = t);
                }
                function u(e) {
                    return u = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                        return typeof e;
                    } : function(e) {
                        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                    }, u(e);
                }
                function c(e, t) {
                    for(var r, n = /\r\n|[\n\r]/g, i = 1, o = t + 1; (r = n.exec(e.body)) && r.index < t;)i += 1, o = t + 1 - (r.index + r[0].length);
                    return {
                        line: i,
                        column: o
                    };
                }
                function l(e) {
                    return f(e.source, c(e.source, e.start));
                }
                function f(e, t) {
                    var r = e.locationOffset.column - 1, n = d(r) + e.body, i = t.line - 1, o = t.line + (e.locationOffset.line - 1), a = t.column + (1 === t.line ? r : 0), s = "".concat(e.name, ":").concat(o, ":").concat(a, "\n"), u = n.split(/\r\n|[\n\r]/g), c = u[i];
                    if (c.length > 120) {
                        for(var l = Math.floor(a / 80), f = a % 80, h = [], v = 0; v < c.length; v += 80)h.push(c.slice(v, v + 80));
                        return s + p([
                            [
                                "".concat(o),
                                h[0]
                            ]
                        ].concat(h.slice(1, l + 1).map(function(e) {
                            return [
                                "",
                                e
                            ];
                        }), [
                            [
                                " ",
                                d(f - 1) + "^"
                            ],
                            [
                                "",
                                h[l + 1]
                            ]
                        ]));
                    }
                    return s + p([
                        [
                            "".concat(o - 1),
                            u[i - 1]
                        ],
                        [
                            "".concat(o),
                            c
                        ],
                        [
                            "",
                            d(a - 1) + "^"
                        ],
                        [
                            "".concat(o + 1),
                            u[i + 1]
                        ]
                    ]);
                }
                function p(e) {
                    var t = e.filter(function(e) {
                        return void 0 !== e[1];
                    }), r = Math.max.apply(Math, t.map(function(e) {
                        return e[0].length;
                    }));
                    return t.map(function(e) {
                        var t, n = e[1];
                        return d(r - (t = e[0]).length) + t + (n ? " | " + n : " |");
                    }).join("\n");
                }
                function d(e) {
                    return Array(e + 1).join(" ");
                }
                function h(e, t, r, n, i, o, a) {
                    var s = Array.isArray(t) ? 0 !== t.length ? t : void 0 : t ? [
                        t
                    ] : void 0, l = r;
                    if (!l && s) {
                        var f = s[0];
                        l = f && f.loc && f.loc.source;
                    }
                    var p, d = n;
                    !d && s && (d = s.reduce(function(e, t) {
                        return t.loc && e.push(t.loc.start), e;
                    }, [])), d && 0 === d.length && (d = void 0), n && r ? p = n.map(function(e) {
                        return c(r, e);
                    }) : s && (p = s.reduce(function(e, t) {
                        return t.loc && e.push(c(t.loc.source, t.loc.start)), e;
                    }, []));
                    var v, m = a;
                    if (null == m && null != o) {
                        var y = o.extensions;
                        "object" == u(v = y) && null !== v && (m = y);
                    }
                    Object.defineProperties(this, {
                        message: {
                            value: e,
                            enumerable: !0,
                            writable: !0
                        },
                        locations: {
                            value: p || void 0,
                            enumerable: Boolean(p)
                        },
                        path: {
                            value: i || void 0,
                            enumerable: Boolean(i)
                        },
                        nodes: {
                            value: s || void 0
                        },
                        source: {
                            value: l || void 0
                        },
                        positions: {
                            value: d || void 0
                        },
                        originalError: {
                            value: o
                        },
                        extensions: {
                            value: m || void 0,
                            enumerable: Boolean(m)
                        }
                    }), o && o.stack ? Object.defineProperty(this, "stack", {
                        value: o.stack,
                        writable: !0,
                        configurable: !0
                    }) : Error.captureStackTrace ? Error.captureStackTrace(this, h) : Object.defineProperty(this, "stack", {
                        value: Error().stack,
                        writable: !0,
                        configurable: !0
                    });
                }
                function v(e, t, r) {
                    return new h("Syntax Error: ".concat(r), void 0, e, [
                        t
                    ]);
                }
                h.prototype = Object.create(Error.prototype, {
                    constructor: {
                        value: h
                    },
                    name: {
                        value: "GraphQLError"
                    },
                    toString: {
                        value: function() {
                            return function(e) {
                                var t = e.message;
                                if (e.nodes) for(var r = 0, n = e.nodes; r < n.length; r++){
                                    var i = n[r];
                                    i.loc && (t += "\n\n" + l(i.loc));
                                }
                                else if (e.source && e.locations) for(var o = 0, a = e.locations; o < a.length; o++)t += "\n\n" + f(e.source, a[o]);
                                return t;
                            }(this);
                        }
                    }
                });
                var m = Object.freeze({
                    NAME: "Name",
                    DOCUMENT: "Document",
                    OPERATION_DEFINITION: "OperationDefinition",
                    VARIABLE_DEFINITION: "VariableDefinition",
                    SELECTION_SET: "SelectionSet",
                    FIELD: "Field",
                    ARGUMENT: "Argument",
                    FRAGMENT_SPREAD: "FragmentSpread",
                    INLINE_FRAGMENT: "InlineFragment",
                    FRAGMENT_DEFINITION: "FragmentDefinition",
                    VARIABLE: "Variable",
                    INT: "IntValue",
                    FLOAT: "FloatValue",
                    STRING: "StringValue",
                    BOOLEAN: "BooleanValue",
                    NULL: "NullValue",
                    ENUM: "EnumValue",
                    LIST: "ListValue",
                    OBJECT: "ObjectValue",
                    OBJECT_FIELD: "ObjectField",
                    DIRECTIVE: "Directive",
                    NAMED_TYPE: "NamedType",
                    LIST_TYPE: "ListType",
                    NON_NULL_TYPE: "NonNullType",
                    SCHEMA_DEFINITION: "SchemaDefinition",
                    OPERATION_TYPE_DEFINITION: "OperationTypeDefinition",
                    SCALAR_TYPE_DEFINITION: "ScalarTypeDefinition",
                    OBJECT_TYPE_DEFINITION: "ObjectTypeDefinition",
                    FIELD_DEFINITION: "FieldDefinition",
                    INPUT_VALUE_DEFINITION: "InputValueDefinition",
                    INTERFACE_TYPE_DEFINITION: "InterfaceTypeDefinition",
                    UNION_TYPE_DEFINITION: "UnionTypeDefinition",
                    ENUM_TYPE_DEFINITION: "EnumTypeDefinition",
                    ENUM_VALUE_DEFINITION: "EnumValueDefinition",
                    INPUT_OBJECT_TYPE_DEFINITION: "InputObjectTypeDefinition",
                    DIRECTIVE_DEFINITION: "DirectiveDefinition",
                    SCHEMA_EXTENSION: "SchemaExtension",
                    SCALAR_TYPE_EXTENSION: "ScalarTypeExtension",
                    OBJECT_TYPE_EXTENSION: "ObjectTypeExtension",
                    INTERFACE_TYPE_EXTENSION: "InterfaceTypeExtension",
                    UNION_TYPE_EXTENSION: "UnionTypeExtension",
                    ENUM_TYPE_EXTENSION: "EnumTypeExtension",
                    INPUT_OBJECT_TYPE_EXTENSION: "InputObjectTypeExtension"
                });
                var y, g = function(e, t, r) {
                    this.body = e, this.name = t || "GraphQL request", this.locationOffset = r || {
                        line: 1,
                        column: 1
                    }, this.locationOffset.line > 0 || o(0, "line in locationOffset is 1-indexed and must be positive"), this.locationOffset.column > 0 || o(0, "column in locationOffset is 1-indexed and must be positive");
                };
                y = g, "function" == typeof Symbol && Symbol.toStringTag && Object.defineProperty(y.prototype, Symbol.toStringTag, {
                    get: function() {
                        return this.constructor.name;
                    }
                });
                var E = r(3306), b = Object.freeze({
                    SOF: "<SOF>",
                    EOF: "<EOF>",
                    BANG: "!",
                    DOLLAR: "$",
                    AMP: "&",
                    PAREN_L: "(",
                    PAREN_R: ")",
                    SPREAD: "...",
                    COLON: ":",
                    EQUALS: "=",
                    AT: "@",
                    BRACKET_L: "[",
                    BRACKET_R: "]",
                    BRACE_L: "{",
                    PIPE: "|",
                    BRACE_R: "}",
                    NAME: "Name",
                    INT: "Int",
                    FLOAT: "Float",
                    STRING: "String",
                    BLOCK_STRING: "BlockString",
                    COMMENT: "Comment"
                });
                function S() {
                    return this.lastToken = this.token, this.token = this.lookahead();
                }
                function _() {
                    var e = this.token;
                    if (e.kind !== b.EOF) do e = e.next || (e.next = T(this, e));
                    while (e.kind === b.COMMENT);
                    return e;
                }
                function w(e, t, r, n, i, o, a) {
                    this.kind = e, this.start = t, this.end = r, this.line = n, this.column = i, this.value = a, this.prev = o, this.next = null;
                }
                function O(e) {
                    return isNaN(e) ? b.EOF : e < 127 ? JSON.stringify(String.fromCharCode(e)) : '"\\u'.concat(("00" + e.toString(16).toUpperCase()).slice(-4), '"');
                }
                function T(e, t) {
                    var r = e.source, n = r.body, i = n.length, o = function(e, t, r) {
                        var n = e.length, i = t;
                        for(; i < n;){
                            var o = e.charCodeAt(i);
                            if (9 === o || 32 === o || 44 === o || 65279 === o) ++i;
                            else if (10 === o) ++i, ++r.line, r.lineStart = i;
                            else {
                                if (13 !== o) break;
                                10 === e.charCodeAt(i + 1) ? i += 2 : ++i, ++r.line, r.lineStart = i;
                            }
                        }
                        return i;
                    }(n, t.end, e), a = e.line, s = 1 + o - e.lineStart;
                    if (o >= i) return new w(b.EOF, i, i, a, s, t);
                    var u = n.charCodeAt(o);
                    switch(u){
                        case 33:
                            return new w(b.BANG, o, o + 1, a, s, t);
                        case 35:
                            return function(e, t, r, n, i) {
                                var o, a = e.body, s = t;
                                do o = a.charCodeAt(++s);
                                while (!isNaN(o) && (o > 31 || 9 === o));
                                return new w(b.COMMENT, t, s, r, n, i, a.slice(t + 1, s));
                            }(r, o, a, s, t);
                        case 36:
                            return new w(b.DOLLAR, o, o + 1, a, s, t);
                        case 38:
                            return new w(b.AMP, o, o + 1, a, s, t);
                        case 40:
                            return new w(b.PAREN_L, o, o + 1, a, s, t);
                        case 41:
                            return new w(b.PAREN_R, o, o + 1, a, s, t);
                        case 46:
                            if (46 === n.charCodeAt(o + 1) && 46 === n.charCodeAt(o + 2)) return new w(b.SPREAD, o, o + 3, a, s, t);
                            break;
                        case 58:
                            return new w(b.COLON, o, o + 1, a, s, t);
                        case 61:
                            return new w(b.EQUALS, o, o + 1, a, s, t);
                        case 64:
                            return new w(b.AT, o, o + 1, a, s, t);
                        case 91:
                            return new w(b.BRACKET_L, o, o + 1, a, s, t);
                        case 93:
                            return new w(b.BRACKET_R, o, o + 1, a, s, t);
                        case 123:
                            return new w(b.BRACE_L, o, o + 1, a, s, t);
                        case 124:
                            return new w(b.PIPE, o, o + 1, a, s, t);
                        case 125:
                            return new w(b.BRACE_R, o, o + 1, a, s, t);
                        case 65:
                        case 66:
                        case 67:
                        case 68:
                        case 69:
                        case 70:
                        case 71:
                        case 72:
                        case 73:
                        case 74:
                        case 75:
                        case 76:
                        case 77:
                        case 78:
                        case 79:
                        case 80:
                        case 81:
                        case 82:
                        case 83:
                        case 84:
                        case 85:
                        case 86:
                        case 87:
                        case 88:
                        case 89:
                        case 90:
                        case 95:
                        case 97:
                        case 98:
                        case 99:
                        case 100:
                        case 101:
                        case 102:
                        case 103:
                        case 104:
                        case 105:
                        case 106:
                        case 107:
                        case 108:
                        case 109:
                        case 110:
                        case 111:
                        case 112:
                        case 113:
                        case 114:
                        case 115:
                        case 116:
                        case 117:
                        case 118:
                        case 119:
                        case 120:
                        case 121:
                        case 122:
                            return function(e, t, r, n, i) {
                                var o = e.body, a = o.length, s = t + 1, u = 0;
                                for(; s !== a && !isNaN(u = o.charCodeAt(s)) && (95 === u || u >= 48 && u <= 57 || u >= 65 && u <= 90 || u >= 97 && u <= 122);)++s;
                                return new w(b.NAME, t, s, r, n, i, o.slice(t, s));
                            }(r, o, a, s, t);
                        case 45:
                        case 48:
                        case 49:
                        case 50:
                        case 51:
                        case 52:
                        case 53:
                        case 54:
                        case 55:
                        case 56:
                        case 57:
                            return function(e, t, r, n, i, o) {
                                var a = e.body, s = r, u = t, c = !1;
                                45 === s && (s = a.charCodeAt(++u));
                                if (48 === s) {
                                    if ((s = a.charCodeAt(++u)) >= 48 && s <= 57) throw v(e, u, "Invalid number, unexpected digit after 0: ".concat(O(s), "."));
                                } else u = I(e, u, s), s = a.charCodeAt(u);
                                46 === s && (c = !0, s = a.charCodeAt(++u), u = I(e, u, s), s = a.charCodeAt(u));
                                69 !== s && 101 !== s || (c = !0, 43 !== (s = a.charCodeAt(++u)) && 45 !== s || (s = a.charCodeAt(++u)), u = I(e, u, s), s = a.charCodeAt(u));
                                if (46 === s || 69 === s || 101 === s) throw v(e, u, "Invalid number, expected digit but got: ".concat(O(s), "."));
                                return new w(c ? b.FLOAT : b.INT, t, u, n, i, o, a.slice(t, u));
                            }(r, o, u, a, s, t);
                        case 34:
                            return 34 === n.charCodeAt(o + 1) && 34 === n.charCodeAt(o + 2) ? function(e, t, r, n, i, o) {
                                var a = e.body, s = t + 3, u = s, c = 0, l = "";
                                for(; s < a.length && !isNaN(c = a.charCodeAt(s));){
                                    if (34 === c && 34 === a.charCodeAt(s + 1) && 34 === a.charCodeAt(s + 2)) return l += a.slice(u, s), new w(b.BLOCK_STRING, t, s + 3, r, n, i, (0, E.W7)(l));
                                    if (c < 32 && 9 !== c && 10 !== c && 13 !== c) throw v(e, s, "Invalid character within String: ".concat(O(c), "."));
                                    10 === c ? (++s, ++o.line, o.lineStart = s) : 13 === c ? (10 === a.charCodeAt(s + 1) ? s += 2 : ++s, ++o.line, o.lineStart = s) : 92 === c && 34 === a.charCodeAt(s + 1) && 34 === a.charCodeAt(s + 2) && 34 === a.charCodeAt(s + 3) ? (l += a.slice(u, s) + '"""', u = s += 4) : ++s;
                                }
                                throw v(e, s, "Unterminated string.");
                            }(r, o, a, s, t, e) : function(e, t, r, n, i) {
                                var o = e.body, a = t + 1, s = a, u = 0, c = "";
                                for(; a < o.length && !isNaN(u = o.charCodeAt(a)) && 10 !== u && 13 !== u;){
                                    if (34 === u) return c += o.slice(s, a), new w(b.STRING, t, a + 1, r, n, i, c);
                                    if (u < 32 && 9 !== u) throw v(e, a, "Invalid character within String: ".concat(O(u), "."));
                                    if (++a, 92 === u) {
                                        switch(c += o.slice(s, a - 1), u = o.charCodeAt(a)){
                                            case 34:
                                                c += '"';
                                                break;
                                            case 47:
                                                c += "/";
                                                break;
                                            case 92:
                                                c += "\\";
                                                break;
                                            case 98:
                                                c += "\b";
                                                break;
                                            case 102:
                                                c += "\f";
                                                break;
                                            case 110:
                                                c += "\n";
                                                break;
                                            case 114:
                                                c += "\r";
                                                break;
                                            case 116:
                                                c += "\t";
                                                break;
                                            case 117:
                                                var l = R(o.charCodeAt(a + 1), o.charCodeAt(a + 2), o.charCodeAt(a + 3), o.charCodeAt(a + 4));
                                                if (l < 0) {
                                                    var f = o.slice(a + 1, a + 5);
                                                    throw v(e, a, "Invalid character escape sequence: \\u".concat(f, "."));
                                                }
                                                c += String.fromCharCode(l), a += 4;
                                                break;
                                            default:
                                                throw v(e, a, "Invalid character escape sequence: \\".concat(String.fromCharCode(u), "."));
                                        }
                                        s = ++a;
                                    }
                                }
                                throw v(e, a, "Unterminated string.");
                            }(r, o, a, s, t);
                    }
                    throw v(r, o, function(e) {
                        if (e < 32 && 9 !== e && 10 !== e && 13 !== e) return "Cannot contain the invalid character ".concat(O(e), ".");
                        if (39 === e) return "Unexpected single quote character ('), did you mean to use a double quote (\")?";
                        return "Cannot parse the unexpected character ".concat(O(e), ".");
                    }(u));
                }
                function I(e, t, r) {
                    var n = e.body, i = t, o = r;
                    if (o >= 48 && o <= 57) {
                        do o = n.charCodeAt(++i);
                        while (o >= 48 && o <= 57);
                        return i;
                    }
                    throw v(e, i, "Invalid number, expected digit but got: ".concat(O(o), "."));
                }
                function R(e, t, r, n) {
                    return x(e) << 12 | x(t) << 8 | x(r) << 4 | x(n);
                }
                function x(e) {
                    return e >= 48 && e <= 57 ? e - 48 : e >= 65 && e <= 70 ? e - 55 : e >= 97 && e <= 102 ? e - 87 : -1;
                }
                s(w, function() {
                    return {
                        kind: this.kind,
                        value: this.value,
                        line: this.line,
                        column: this.column
                    };
                });
                var A = Object.freeze({
                    QUERY: "QUERY",
                    MUTATION: "MUTATION",
                    SUBSCRIPTION: "SUBSCRIPTION",
                    FIELD: "FIELD",
                    FRAGMENT_DEFINITION: "FRAGMENT_DEFINITION",
                    FRAGMENT_SPREAD: "FRAGMENT_SPREAD",
                    INLINE_FRAGMENT: "INLINE_FRAGMENT",
                    VARIABLE_DEFINITION: "VARIABLE_DEFINITION",
                    SCHEMA: "SCHEMA",
                    SCALAR: "SCALAR",
                    OBJECT: "OBJECT",
                    FIELD_DEFINITION: "FIELD_DEFINITION",
                    ARGUMENT_DEFINITION: "ARGUMENT_DEFINITION",
                    INTERFACE: "INTERFACE",
                    UNION: "UNION",
                    ENUM: "ENUM",
                    ENUM_VALUE: "ENUM_VALUE",
                    INPUT_OBJECT: "INPUT_OBJECT",
                    INPUT_FIELD_DEFINITION: "INPUT_FIELD_DEFINITION"
                });
                var N = function() {
                    function e(e, t) {
                        var r = "string" == typeof e ? new g(e) : e;
                        r instanceof g || o(0, "Must provide Source. Received: ".concat((0, i.Z)(r))), this._lexer = function(e, t) {
                            var r = new w(b.SOF, 0, 0, 0, 0, null);
                            return {
                                source: e,
                                options: t,
                                lastToken: r,
                                token: r,
                                line: 1,
                                lineStart: 0,
                                advance: S,
                                lookahead: _
                            };
                        }(r), this._options = t || {};
                    }
                    var t = e.prototype;
                    return t.parseName = function() {
                        var e = this.expectToken(b.NAME);
                        return {
                            kind: m.NAME,
                            value: e.value,
                            loc: this.loc(e)
                        };
                    }, t.parseDocument = function() {
                        var e = this._lexer.token;
                        return {
                            kind: m.DOCUMENT,
                            definitions: this.many(b.SOF, this.parseDefinition, b.EOF),
                            loc: this.loc(e)
                        };
                    }, t.parseDefinition = function() {
                        if (this.peek(b.NAME)) switch(this._lexer.token.value){
                            case "query":
                            case "mutation":
                            case "subscription":
                                return this.parseOperationDefinition();
                            case "fragment":
                                return this.parseFragmentDefinition();
                            case "schema":
                            case "scalar":
                            case "type":
                            case "interface":
                            case "union":
                            case "enum":
                            case "input":
                            case "directive":
                                return this.parseTypeSystemDefinition();
                            case "extend":
                                return this.parseTypeSystemExtension();
                        }
                        else {
                            if (this.peek(b.BRACE_L)) return this.parseOperationDefinition();
                            if (this.peekDescription()) return this.parseTypeSystemDefinition();
                        }
                        throw this.unexpected();
                    }, t.parseOperationDefinition = function() {
                        var e = this._lexer.token;
                        if (this.peek(b.BRACE_L)) return {
                            kind: m.OPERATION_DEFINITION,
                            operation: "query",
                            name: void 0,
                            variableDefinitions: [],
                            directives: [],
                            selectionSet: this.parseSelectionSet(),
                            loc: this.loc(e)
                        };
                        var t, r = this.parseOperationType();
                        return this.peek(b.NAME) && (t = this.parseName()), {
                            kind: m.OPERATION_DEFINITION,
                            operation: r,
                            name: t,
                            variableDefinitions: this.parseVariableDefinitions(),
                            directives: this.parseDirectives(!1),
                            selectionSet: this.parseSelectionSet(),
                            loc: this.loc(e)
                        };
                    }, t.parseOperationType = function() {
                        var e = this.expectToken(b.NAME);
                        switch(e.value){
                            case "query":
                                return "query";
                            case "mutation":
                                return "mutation";
                            case "subscription":
                                return "subscription";
                        }
                        throw this.unexpected(e);
                    }, t.parseVariableDefinitions = function() {
                        return this.optionalMany(b.PAREN_L, this.parseVariableDefinition, b.PAREN_R);
                    }, t.parseVariableDefinition = function() {
                        var e = this._lexer.token;
                        return {
                            kind: m.VARIABLE_DEFINITION,
                            variable: this.parseVariable(),
                            type: (this.expectToken(b.COLON), this.parseTypeReference()),
                            defaultValue: this.expectOptionalToken(b.EQUALS) ? this.parseValueLiteral(!0) : void 0,
                            directives: this.parseDirectives(!0),
                            loc: this.loc(e)
                        };
                    }, t.parseVariable = function() {
                        var e = this._lexer.token;
                        return this.expectToken(b.DOLLAR), {
                            kind: m.VARIABLE,
                            name: this.parseName(),
                            loc: this.loc(e)
                        };
                    }, t.parseSelectionSet = function() {
                        var e = this._lexer.token;
                        return {
                            kind: m.SELECTION_SET,
                            selections: this.many(b.BRACE_L, this.parseSelection, b.BRACE_R),
                            loc: this.loc(e)
                        };
                    }, t.parseSelection = function() {
                        return this.peek(b.SPREAD) ? this.parseFragment() : this.parseField();
                    }, t.parseField = function() {
                        var e, t, r = this._lexer.token, n = this.parseName();
                        return this.expectOptionalToken(b.COLON) ? (e = n, t = this.parseName()) : t = n, {
                            kind: m.FIELD,
                            alias: e,
                            name: t,
                            arguments: this.parseArguments(!1),
                            directives: this.parseDirectives(!1),
                            selectionSet: this.peek(b.BRACE_L) ? this.parseSelectionSet() : void 0,
                            loc: this.loc(r)
                        };
                    }, t.parseArguments = function(e) {
                        return this.optionalMany(b.PAREN_L, e ? this.parseConstArgument : this.parseArgument, b.PAREN_R);
                    }, t.parseArgument = function() {
                        var e = this._lexer.token, t = this.parseName();
                        return this.expectToken(b.COLON), {
                            kind: m.ARGUMENT,
                            name: t,
                            value: this.parseValueLiteral(!1),
                            loc: this.loc(e)
                        };
                    }, t.parseConstArgument = function() {
                        var e = this._lexer.token;
                        return {
                            kind: m.ARGUMENT,
                            name: this.parseName(),
                            value: (this.expectToken(b.COLON), this.parseValueLiteral(!0)),
                            loc: this.loc(e)
                        };
                    }, t.parseFragment = function() {
                        var e = this._lexer.token;
                        this.expectToken(b.SPREAD);
                        var t = this.expectOptionalKeyword("on");
                        return !t && this.peek(b.NAME) ? {
                            kind: m.FRAGMENT_SPREAD,
                            name: this.parseFragmentName(),
                            directives: this.parseDirectives(!1),
                            loc: this.loc(e)
                        } : {
                            kind: m.INLINE_FRAGMENT,
                            typeCondition: t ? this.parseNamedType() : void 0,
                            directives: this.parseDirectives(!1),
                            selectionSet: this.parseSelectionSet(),
                            loc: this.loc(e)
                        };
                    }, t.parseFragmentDefinition = function() {
                        var e = this._lexer.token;
                        return this.expectKeyword("fragment"), this._options.experimentalFragmentVariables ? {
                            kind: m.FRAGMENT_DEFINITION,
                            name: this.parseFragmentName(),
                            variableDefinitions: this.parseVariableDefinitions(),
                            typeCondition: (this.expectKeyword("on"), this.parseNamedType()),
                            directives: this.parseDirectives(!1),
                            selectionSet: this.parseSelectionSet(),
                            loc: this.loc(e)
                        } : {
                            kind: m.FRAGMENT_DEFINITION,
                            name: this.parseFragmentName(),
                            typeCondition: (this.expectKeyword("on"), this.parseNamedType()),
                            directives: this.parseDirectives(!1),
                            selectionSet: this.parseSelectionSet(),
                            loc: this.loc(e)
                        };
                    }, t.parseFragmentName = function() {
                        if ("on" === this._lexer.token.value) throw this.unexpected();
                        return this.parseName();
                    }, t.parseValueLiteral = function(e) {
                        var t = this._lexer.token;
                        switch(t.kind){
                            case b.BRACKET_L:
                                return this.parseList(e);
                            case b.BRACE_L:
                                return this.parseObject(e);
                            case b.INT:
                                return this._lexer.advance(), {
                                    kind: m.INT,
                                    value: t.value,
                                    loc: this.loc(t)
                                };
                            case b.FLOAT:
                                return this._lexer.advance(), {
                                    kind: m.FLOAT,
                                    value: t.value,
                                    loc: this.loc(t)
                                };
                            case b.STRING:
                            case b.BLOCK_STRING:
                                return this.parseStringLiteral();
                            case b.NAME:
                                return "true" === t.value || "false" === t.value ? (this._lexer.advance(), {
                                    kind: m.BOOLEAN,
                                    value: "true" === t.value,
                                    loc: this.loc(t)
                                }) : "null" === t.value ? (this._lexer.advance(), {
                                    kind: m.NULL,
                                    loc: this.loc(t)
                                }) : (this._lexer.advance(), {
                                    kind: m.ENUM,
                                    value: t.value,
                                    loc: this.loc(t)
                                });
                            case b.DOLLAR:
                                if (!e) return this.parseVariable();
                        }
                        throw this.unexpected();
                    }, t.parseStringLiteral = function() {
                        var e = this._lexer.token;
                        return this._lexer.advance(), {
                            kind: m.STRING,
                            value: e.value,
                            block: e.kind === b.BLOCK_STRING,
                            loc: this.loc(e)
                        };
                    }, t.parseList = function(e) {
                        var t = this, r = this._lexer.token;
                        return {
                            kind: m.LIST,
                            values: this.any(b.BRACKET_L, function() {
                                return t.parseValueLiteral(e);
                            }, b.BRACKET_R),
                            loc: this.loc(r)
                        };
                    }, t.parseObject = function(e) {
                        var t = this, r = this._lexer.token;
                        return {
                            kind: m.OBJECT,
                            fields: this.any(b.BRACE_L, function() {
                                return t.parseObjectField(e);
                            }, b.BRACE_R),
                            loc: this.loc(r)
                        };
                    }, t.parseObjectField = function(e) {
                        var t = this._lexer.token, r = this.parseName();
                        return this.expectToken(b.COLON), {
                            kind: m.OBJECT_FIELD,
                            name: r,
                            value: this.parseValueLiteral(e),
                            loc: this.loc(t)
                        };
                    }, t.parseDirectives = function(e) {
                        for(var t = []; this.peek(b.AT);)t.push(this.parseDirective(e));
                        return t;
                    }, t.parseDirective = function(e) {
                        var t = this._lexer.token;
                        return this.expectToken(b.AT), {
                            kind: m.DIRECTIVE,
                            name: this.parseName(),
                            arguments: this.parseArguments(e),
                            loc: this.loc(t)
                        };
                    }, t.parseTypeReference = function() {
                        var e, t = this._lexer.token;
                        return this.expectOptionalToken(b.BRACKET_L) ? (e = this.parseTypeReference(), this.expectToken(b.BRACKET_R), e = {
                            kind: m.LIST_TYPE,
                            type: e,
                            loc: this.loc(t)
                        }) : e = this.parseNamedType(), this.expectOptionalToken(b.BANG) ? {
                            kind: m.NON_NULL_TYPE,
                            type: e,
                            loc: this.loc(t)
                        } : e;
                    }, t.parseNamedType = function() {
                        var e = this._lexer.token;
                        return {
                            kind: m.NAMED_TYPE,
                            name: this.parseName(),
                            loc: this.loc(e)
                        };
                    }, t.parseTypeSystemDefinition = function() {
                        var e = this.peekDescription() ? this._lexer.lookahead() : this._lexer.token;
                        if (e.kind === b.NAME) switch(e.value){
                            case "schema":
                                return this.parseSchemaDefinition();
                            case "scalar":
                                return this.parseScalarTypeDefinition();
                            case "type":
                                return this.parseObjectTypeDefinition();
                            case "interface":
                                return this.parseInterfaceTypeDefinition();
                            case "union":
                                return this.parseUnionTypeDefinition();
                            case "enum":
                                return this.parseEnumTypeDefinition();
                            case "input":
                                return this.parseInputObjectTypeDefinition();
                            case "directive":
                                return this.parseDirectiveDefinition();
                        }
                        throw this.unexpected(e);
                    }, t.peekDescription = function() {
                        return this.peek(b.STRING) || this.peek(b.BLOCK_STRING);
                    }, t.parseDescription = function() {
                        if (this.peekDescription()) return this.parseStringLiteral();
                    }, t.parseSchemaDefinition = function() {
                        var e = this._lexer.token;
                        this.expectKeyword("schema");
                        var t = this.parseDirectives(!0), r = this.many(b.BRACE_L, this.parseOperationTypeDefinition, b.BRACE_R);
                        return {
                            kind: m.SCHEMA_DEFINITION,
                            directives: t,
                            operationTypes: r,
                            loc: this.loc(e)
                        };
                    }, t.parseOperationTypeDefinition = function() {
                        var e = this._lexer.token, t = this.parseOperationType();
                        this.expectToken(b.COLON);
                        var r = this.parseNamedType();
                        return {
                            kind: m.OPERATION_TYPE_DEFINITION,
                            operation: t,
                            type: r,
                            loc: this.loc(e)
                        };
                    }, t.parseScalarTypeDefinition = function() {
                        var e = this._lexer.token, t = this.parseDescription();
                        this.expectKeyword("scalar");
                        var r = this.parseName(), n = this.parseDirectives(!0);
                        return {
                            kind: m.SCALAR_TYPE_DEFINITION,
                            description: t,
                            name: r,
                            directives: n,
                            loc: this.loc(e)
                        };
                    }, t.parseObjectTypeDefinition = function() {
                        var e = this._lexer.token, t = this.parseDescription();
                        this.expectKeyword("type");
                        var r = this.parseName(), n = this.parseImplementsInterfaces(), i = this.parseDirectives(!0), o = this.parseFieldsDefinition();
                        return {
                            kind: m.OBJECT_TYPE_DEFINITION,
                            description: t,
                            name: r,
                            interfaces: n,
                            directives: i,
                            fields: o,
                            loc: this.loc(e)
                        };
                    }, t.parseImplementsInterfaces = function() {
                        var e = [];
                        if (this.expectOptionalKeyword("implements")) {
                            this.expectOptionalToken(b.AMP);
                            do e.push(this.parseNamedType());
                            while (this.expectOptionalToken(b.AMP) || this._options.allowLegacySDLImplementsInterfaces && this.peek(b.NAME));
                        }
                        return e;
                    }, t.parseFieldsDefinition = function() {
                        return this._options.allowLegacySDLEmptyFields && this.peek(b.BRACE_L) && this._lexer.lookahead().kind === b.BRACE_R ? (this._lexer.advance(), this._lexer.advance(), []) : this.optionalMany(b.BRACE_L, this.parseFieldDefinition, b.BRACE_R);
                    }, t.parseFieldDefinition = function() {
                        var e = this._lexer.token, t = this.parseDescription(), r = this.parseName(), n = this.parseArgumentDefs();
                        this.expectToken(b.COLON);
                        var i = this.parseTypeReference(), o = this.parseDirectives(!0);
                        return {
                            kind: m.FIELD_DEFINITION,
                            description: t,
                            name: r,
                            arguments: n,
                            type: i,
                            directives: o,
                            loc: this.loc(e)
                        };
                    }, t.parseArgumentDefs = function() {
                        return this.optionalMany(b.PAREN_L, this.parseInputValueDef, b.PAREN_R);
                    }, t.parseInputValueDef = function() {
                        var e = this._lexer.token, t = this.parseDescription(), r = this.parseName();
                        this.expectToken(b.COLON);
                        var n, i = this.parseTypeReference();
                        this.expectOptionalToken(b.EQUALS) && (n = this.parseValueLiteral(!0));
                        var o = this.parseDirectives(!0);
                        return {
                            kind: m.INPUT_VALUE_DEFINITION,
                            description: t,
                            name: r,
                            type: i,
                            defaultValue: n,
                            directives: o,
                            loc: this.loc(e)
                        };
                    }, t.parseInterfaceTypeDefinition = function() {
                        var e = this._lexer.token, t = this.parseDescription();
                        this.expectKeyword("interface");
                        var r = this.parseName(), n = this.parseDirectives(!0), i = this.parseFieldsDefinition();
                        return {
                            kind: m.INTERFACE_TYPE_DEFINITION,
                            description: t,
                            name: r,
                            directives: n,
                            fields: i,
                            loc: this.loc(e)
                        };
                    }, t.parseUnionTypeDefinition = function() {
                        var e = this._lexer.token, t = this.parseDescription();
                        this.expectKeyword("union");
                        var r = this.parseName(), n = this.parseDirectives(!0), i = this.parseUnionMemberTypes();
                        return {
                            kind: m.UNION_TYPE_DEFINITION,
                            description: t,
                            name: r,
                            directives: n,
                            types: i,
                            loc: this.loc(e)
                        };
                    }, t.parseUnionMemberTypes = function() {
                        var e = [];
                        if (this.expectOptionalToken(b.EQUALS)) {
                            this.expectOptionalToken(b.PIPE);
                            do e.push(this.parseNamedType());
                            while (this.expectOptionalToken(b.PIPE));
                        }
                        return e;
                    }, t.parseEnumTypeDefinition = function() {
                        var e = this._lexer.token, t = this.parseDescription();
                        this.expectKeyword("enum");
                        var r = this.parseName(), n = this.parseDirectives(!0), i = this.parseEnumValuesDefinition();
                        return {
                            kind: m.ENUM_TYPE_DEFINITION,
                            description: t,
                            name: r,
                            directives: n,
                            values: i,
                            loc: this.loc(e)
                        };
                    }, t.parseEnumValuesDefinition = function() {
                        return this.optionalMany(b.BRACE_L, this.parseEnumValueDefinition, b.BRACE_R);
                    }, t.parseEnumValueDefinition = function() {
                        var e = this._lexer.token, t = this.parseDescription(), r = this.parseName(), n = this.parseDirectives(!0);
                        return {
                            kind: m.ENUM_VALUE_DEFINITION,
                            description: t,
                            name: r,
                            directives: n,
                            loc: this.loc(e)
                        };
                    }, t.parseInputObjectTypeDefinition = function() {
                        var e = this._lexer.token, t = this.parseDescription();
                        this.expectKeyword("input");
                        var r = this.parseName(), n = this.parseDirectives(!0), i = this.parseInputFieldsDefinition();
                        return {
                            kind: m.INPUT_OBJECT_TYPE_DEFINITION,
                            description: t,
                            name: r,
                            directives: n,
                            fields: i,
                            loc: this.loc(e)
                        };
                    }, t.parseInputFieldsDefinition = function() {
                        return this.optionalMany(b.BRACE_L, this.parseInputValueDef, b.BRACE_R);
                    }, t.parseTypeSystemExtension = function() {
                        var e = this._lexer.lookahead();
                        if (e.kind === b.NAME) switch(e.value){
                            case "schema":
                                return this.parseSchemaExtension();
                            case "scalar":
                                return this.parseScalarTypeExtension();
                            case "type":
                                return this.parseObjectTypeExtension();
                            case "interface":
                                return this.parseInterfaceTypeExtension();
                            case "union":
                                return this.parseUnionTypeExtension();
                            case "enum":
                                return this.parseEnumTypeExtension();
                            case "input":
                                return this.parseInputObjectTypeExtension();
                        }
                        throw this.unexpected(e);
                    }, t.parseSchemaExtension = function() {
                        var e = this._lexer.token;
                        this.expectKeyword("extend"), this.expectKeyword("schema");
                        var t = this.parseDirectives(!0), r = this.optionalMany(b.BRACE_L, this.parseOperationTypeDefinition, b.BRACE_R);
                        if (0 === t.length && 0 === r.length) throw this.unexpected();
                        return {
                            kind: m.SCHEMA_EXTENSION,
                            directives: t,
                            operationTypes: r,
                            loc: this.loc(e)
                        };
                    }, t.parseScalarTypeExtension = function() {
                        var e = this._lexer.token;
                        this.expectKeyword("extend"), this.expectKeyword("scalar");
                        var t = this.parseName(), r = this.parseDirectives(!0);
                        if (0 === r.length) throw this.unexpected();
                        return {
                            kind: m.SCALAR_TYPE_EXTENSION,
                            name: t,
                            directives: r,
                            loc: this.loc(e)
                        };
                    }, t.parseObjectTypeExtension = function() {
                        var e = this._lexer.token;
                        this.expectKeyword("extend"), this.expectKeyword("type");
                        var t = this.parseName(), r = this.parseImplementsInterfaces(), n = this.parseDirectives(!0), i = this.parseFieldsDefinition();
                        if (0 === r.length && 0 === n.length && 0 === i.length) throw this.unexpected();
                        return {
                            kind: m.OBJECT_TYPE_EXTENSION,
                            name: t,
                            interfaces: r,
                            directives: n,
                            fields: i,
                            loc: this.loc(e)
                        };
                    }, t.parseInterfaceTypeExtension = function() {
                        var e = this._lexer.token;
                        this.expectKeyword("extend"), this.expectKeyword("interface");
                        var t = this.parseName(), r = this.parseDirectives(!0), n = this.parseFieldsDefinition();
                        if (0 === r.length && 0 === n.length) throw this.unexpected();
                        return {
                            kind: m.INTERFACE_TYPE_EXTENSION,
                            name: t,
                            directives: r,
                            fields: n,
                            loc: this.loc(e)
                        };
                    }, t.parseUnionTypeExtension = function() {
                        var e = this._lexer.token;
                        this.expectKeyword("extend"), this.expectKeyword("union");
                        var t = this.parseName(), r = this.parseDirectives(!0), n = this.parseUnionMemberTypes();
                        if (0 === r.length && 0 === n.length) throw this.unexpected();
                        return {
                            kind: m.UNION_TYPE_EXTENSION,
                            name: t,
                            directives: r,
                            types: n,
                            loc: this.loc(e)
                        };
                    }, t.parseEnumTypeExtension = function() {
                        var e = this._lexer.token;
                        this.expectKeyword("extend"), this.expectKeyword("enum");
                        var t = this.parseName(), r = this.parseDirectives(!0), n = this.parseEnumValuesDefinition();
                        if (0 === r.length && 0 === n.length) throw this.unexpected();
                        return {
                            kind: m.ENUM_TYPE_EXTENSION,
                            name: t,
                            directives: r,
                            values: n,
                            loc: this.loc(e)
                        };
                    }, t.parseInputObjectTypeExtension = function() {
                        var e = this._lexer.token;
                        this.expectKeyword("extend"), this.expectKeyword("input");
                        var t = this.parseName(), r = this.parseDirectives(!0), n = this.parseInputFieldsDefinition();
                        if (0 === r.length && 0 === n.length) throw this.unexpected();
                        return {
                            kind: m.INPUT_OBJECT_TYPE_EXTENSION,
                            name: t,
                            directives: r,
                            fields: n,
                            loc: this.loc(e)
                        };
                    }, t.parseDirectiveDefinition = function() {
                        var e = this._lexer.token, t = this.parseDescription();
                        this.expectKeyword("directive"), this.expectToken(b.AT);
                        var r = this.parseName(), n = this.parseArgumentDefs(), i = this.expectOptionalKeyword("repeatable");
                        this.expectKeyword("on");
                        var o = this.parseDirectiveLocations();
                        return {
                            kind: m.DIRECTIVE_DEFINITION,
                            description: t,
                            name: r,
                            arguments: n,
                            repeatable: i,
                            locations: o,
                            loc: this.loc(e)
                        };
                    }, t.parseDirectiveLocations = function() {
                        this.expectOptionalToken(b.PIPE);
                        var e = [];
                        do e.push(this.parseDirectiveLocation());
                        while (this.expectOptionalToken(b.PIPE));
                        return e;
                    }, t.parseDirectiveLocation = function() {
                        var e = this._lexer.token, t = this.parseName();
                        if (void 0 !== A[t.value]) return t;
                        throw this.unexpected(e);
                    }, t.loc = function(e) {
                        if (!this._options.noLocation) return new C(e, this._lexer.lastToken, this._lexer.source);
                    }, t.peek = function(e) {
                        return this._lexer.token.kind === e;
                    }, t.expectToken = function(e) {
                        var t = this._lexer.token;
                        if (t.kind === e) return this._lexer.advance(), t;
                        throw v(this._lexer.source, t.start, "Expected ".concat(e, ", found ").concat(k(t)));
                    }, t.expectOptionalToken = function(e) {
                        var t = this._lexer.token;
                        if (t.kind === e) return this._lexer.advance(), t;
                    }, t.expectKeyword = function(e) {
                        var t = this._lexer.token;
                        if (t.kind !== b.NAME || t.value !== e) throw v(this._lexer.source, t.start, 'Expected "'.concat(e, '", found ').concat(k(t)));
                        this._lexer.advance();
                    }, t.expectOptionalKeyword = function(e) {
                        var t = this._lexer.token;
                        return t.kind === b.NAME && t.value === e && (this._lexer.advance(), !0);
                    }, t.unexpected = function(e) {
                        var t = e || this._lexer.token;
                        return v(this._lexer.source, t.start, "Unexpected ".concat(k(t)));
                    }, t.any = function(e, t, r) {
                        this.expectToken(e);
                        for(var n = []; !this.expectOptionalToken(r);)n.push(t.call(this));
                        return n;
                    }, t.optionalMany = function(e, t, r) {
                        if (this.expectOptionalToken(e)) {
                            var n = [];
                            do n.push(t.call(this));
                            while (!this.expectOptionalToken(r));
                            return n;
                        }
                        return [];
                    }, t.many = function(e, t, r) {
                        this.expectToken(e);
                        var n = [];
                        do n.push(t.call(this));
                        while (!this.expectOptionalToken(r));
                        return n;
                    }, e;
                }();
                function C(e, t, r) {
                    this.start = e.start, this.end = t.end, this.startToken = e, this.endToken = t, this.source = r;
                }
                function k(e) {
                    var t = e.value;
                    return t ? "".concat(e.kind, ' "').concat(t, '"') : e.kind;
                }
                s(C, function() {
                    return {
                        start: this.start,
                        end: this.end
                    };
                });
                var M = new Map, P = new Map, D = !0, F = !1;
                function L(e) {
                    return e.replace(/[\s,]+/g, " ").trim();
                }
                function j(e) {
                    var t = new Set, r = [];
                    return e.definitions.forEach(function(e) {
                        if ("FragmentDefinition" === e.kind) {
                            var n = e.name.value, i = L((a = e.loc).source.body.substring(a.start, a.end)), o = P.get(n);
                            o && !o.has(i) ? D && console.warn("Warning: fragment with name " + n + " already exists.\ngraphql-tag enforces all fragment names across your application to be unique; read more about\nthis in the docs: http://dev.apollodata.com/core/fragments.html#unique-names") : o || P.set(n, o = new Set), o.add(i), t.has(i) || (t.add(i), r.push(e));
                        } else r.push(e);
                        var a;
                    }), n(n({}, e), {
                        definitions: r
                    });
                }
                function U(e) {
                    var t = L(e);
                    if (!M.has(t)) {
                        var r = function(e, t) {
                            return new N(e, t).parseDocument();
                        }(e, {
                            experimentalFragmentVariables: F,
                            allowLegacyFragmentVariables: F
                        });
                        if (!r || "Document" !== r.kind) throw new Error("Not a valid GraphQL document.");
                        M.set(t, function(e) {
                            var t = new Set(e.definitions);
                            t.forEach(function(e) {
                                e.loc && delete e.loc, Object.keys(e).forEach(function(r) {
                                    var n = e[r];
                                    n && "object" == typeof n && t.add(n);
                                });
                            });
                            var r = e.loc;
                            return r && (delete r.startToken, delete r.endToken), e;
                        }(j(r)));
                    }
                    return M.get(t);
                }
                function B(e) {
                    for(var t = [], r = 1; r < arguments.length; r++)t[r - 1] = arguments[r];
                    "string" == typeof e && (e = [
                        e
                    ]);
                    var n = e[0];
                    return t.forEach(function(t, r) {
                        n += t && "Document" === t.kind ? t.loc.source.body : t, n += e[r + 1];
                    }), U(n);
                }
                function Q() {
                    M.clear(), P.clear();
                }
                function V() {
                    D = !1;
                }
                function q() {
                    F = !0;
                }
                function G() {
                    F = !1;
                }
                var z, W = B, $ = Q, H = V, K = q, Y = G;
                (z = B || (B = {})).gql = W, z.resetCaches = $, z.disableFragmentWarnings = H, z.enableExperimentalFragmentVariables = K, z.disableExperimentalFragmentVariables = Y, B.default = B;
                const X = B;
            },
            5989: function(e, t, r) {
                var n;
                e = r.nmd(e), (function() {
                    "use strict";
                    var i = {
                        function: !0,
                        object: !0
                    }, o = i[typeof window] && window || this, a = i[typeof t] && t && i.object && e && !e.nodeType && e && "object" == typeof r.g && r.g;
                    !a || a.global !== a && a.window !== a && a.self !== a || (o = a);
                    var s = Math.pow(2, 53) - 1, u = /\bOpera/, c = Object.prototype, l = c.hasOwnProperty, f = c.toString;
                    function p(e) {
                        return (e = String(e)).charAt(0).toUpperCase() + e.slice(1);
                    }
                    function d(e) {
                        return e = g(e), /^(?:webOS|i(?:OS|P))/.test(e) ? e : p(e);
                    }
                    function h(e, t) {
                        for(var r in e)l.call(e, r) && t(e[r], r, e);
                    }
                    function v(e) {
                        return null == e ? p(e) : f.call(e).slice(8, -1);
                    }
                    function m(e) {
                        return String(e).replace(/([ -])(?!$)/g, "$1?");
                    }
                    function y(e, t) {
                        var r = null;
                        return function(e, t) {
                            var r = -1, n = e ? e.length : 0;
                            if ("number" == typeof n && n > -1 && n <= s) for(; ++r < n;)t(e[r], r, e);
                            else h(e, t);
                        }(e, function(n, i) {
                            r = t(r, n, i, e);
                        }), r;
                    }
                    function g(e) {
                        return String(e).replace(/^ +| +$/g, "");
                    }
                    var E = function e(t) {
                        var r = o, n = t && "object" == typeof t && "String" != v(t);
                        n && (r = t, t = null);
                        var i = r.navigator || {}, a = i.userAgent || "";
                        t || (t = a);
                        var s, c, l, p, E, b = n ? !!i.likeChrome : /\bChrome\b/.test(t) && !/internal|\n/i.test(f.toString()), S = "Object", _ = n ? S : "ScriptBridgingProxyObject", w = n ? S : "Environment", O = n && r.java ? "JavaPackage" : v(r.java), T = n ? S : "RuntimeObject", I = /\bJava/.test(O) && r.java, R = I && v(r.environment) == w, x = I ? "a" : "\u03B1", A = I ? "b" : "\u03B2", N = r.document || {}, C = r.operamini || r.opera, k = u.test(k = n && C ? C["[[Class]]"] : v(C)) ? k : C = null, M = t, P = [], D = null, F = t == a, L = F && C && "function" == typeof C.version && C.version(), j = y([
                            {
                                label: "EdgeHTML",
                                pattern: "Edge"
                            },
                            "Trident",
                            {
                                label: "WebKit",
                                pattern: "AppleWebKit"
                            },
                            "iCab",
                            "Presto",
                            "NetFront",
                            "Tasman",
                            "KHTML",
                            "Gecko"
                        ], function(e, r) {
                            return e || RegExp("\\b" + (r.pattern || m(r)) + "\\b", "i").exec(t) && (r.label || r);
                        }), U = function(e) {
                            return y(e, function(e, r) {
                                return e || RegExp("\\b" + (r.pattern || m(r)) + "\\b", "i").exec(t) && (r.label || r);
                            });
                        }([
                            "Adobe AIR",
                            "Arora",
                            "Avant Browser",
                            "Breach",
                            "Camino",
                            "Electron",
                            "Epiphany",
                            "Fennec",
                            "Flock",
                            "Galeon",
                            "GreenBrowser",
                            "iCab",
                            "Iceweasel",
                            "K-Meleon",
                            "Konqueror",
                            "Lunascape",
                            "Maxthon",
                            {
                                label: "Microsoft Edge",
                                pattern: "(?:Edge|Edg|EdgA|EdgiOS)"
                            },
                            "Midori",
                            "Nook Browser",
                            "PaleMoon",
                            "PhantomJS",
                            "Raven",
                            "Rekonq",
                            "RockMelt",
                            {
                                label: "Samsung Internet",
                                pattern: "SamsungBrowser"
                            },
                            "SeaMonkey",
                            {
                                label: "Silk",
                                pattern: "(?:Cloud9|Silk-Accelerated)"
                            },
                            "Sleipnir",
                            "SlimBrowser",
                            {
                                label: "SRWare Iron",
                                pattern: "Iron"
                            },
                            "Sunrise",
                            "Swiftfox",
                            "Vivaldi",
                            "Waterfox",
                            "WebPositive",
                            {
                                label: "Yandex Browser",
                                pattern: "YaBrowser"
                            },
                            {
                                label: "UC Browser",
                                pattern: "UCBrowser"
                            },
                            "Opera Mini",
                            {
                                label: "Opera Mini",
                                pattern: "OPiOS"
                            },
                            "Opera",
                            {
                                label: "Opera",
                                pattern: "OPR"
                            },
                            "Chromium",
                            "Chrome",
                            {
                                label: "Chrome",
                                pattern: "(?:HeadlessChrome)"
                            },
                            {
                                label: "Chrome Mobile",
                                pattern: "(?:CriOS|CrMo)"
                            },
                            {
                                label: "Firefox",
                                pattern: "(?:Firefox|Minefield)"
                            },
                            {
                                label: "Firefox for iOS",
                                pattern: "FxiOS"
                            },
                            {
                                label: "IE",
                                pattern: "IEMobile"
                            },
                            {
                                label: "IE",
                                pattern: "MSIE"
                            },
                            "Safari"
                        ]), B = q([
                            {
                                label: "BlackBerry",
                                pattern: "BB10"
                            },
                            "BlackBerry",
                            {
                                label: "Galaxy S",
                                pattern: "GT-I9000"
                            },
                            {
                                label: "Galaxy S2",
                                pattern: "GT-I9100"
                            },
                            {
                                label: "Galaxy S3",
                                pattern: "GT-I9300"
                            },
                            {
                                label: "Galaxy S4",
                                pattern: "GT-I9500"
                            },
                            {
                                label: "Galaxy S5",
                                pattern: "SM-G900"
                            },
                            {
                                label: "Galaxy S6",
                                pattern: "SM-G920"
                            },
                            {
                                label: "Galaxy S6 Edge",
                                pattern: "SM-G925"
                            },
                            {
                                label: "Galaxy S7",
                                pattern: "SM-G930"
                            },
                            {
                                label: "Galaxy S7 Edge",
                                pattern: "SM-G935"
                            },
                            "Google TV",
                            "Lumia",
                            "iPad",
                            "iPod",
                            "iPhone",
                            "Kindle",
                            {
                                label: "Kindle Fire",
                                pattern: "(?:Cloud9|Silk-Accelerated)"
                            },
                            "Nexus",
                            "Nook",
                            "PlayBook",
                            "PlayStation Vita",
                            "PlayStation",
                            "TouchPad",
                            "Transformer",
                            {
                                label: "Wii U",
                                pattern: "WiiU"
                            },
                            "Wii",
                            "Xbox One",
                            {
                                label: "Xbox 360",
                                pattern: "Xbox"
                            },
                            "Xoom"
                        ]), Q = function(e) {
                            return y(e, function(e, r, n) {
                                return e || (r[B] || r[/^[a-z]+(?: +[a-z]+\b)*/i.exec(B)] || RegExp("\\b" + m(n) + "(?:\\b|\\w*\\d)", "i").exec(t)) && n;
                            });
                        }({
                            Apple: {
                                iPad: 1,
                                iPhone: 1,
                                iPod: 1
                            },
                            Alcatel: {},
                            Archos: {},
                            Amazon: {
                                Kindle: 1,
                                "Kindle Fire": 1
                            },
                            Asus: {
                                Transformer: 1
                            },
                            "Barnes & Noble": {
                                Nook: 1
                            },
                            BlackBerry: {
                                PlayBook: 1
                            },
                            Google: {
                                "Google TV": 1,
                                Nexus: 1
                            },
                            HP: {
                                TouchPad: 1
                            },
                            HTC: {},
                            Huawei: {},
                            Lenovo: {},
                            LG: {},
                            Microsoft: {
                                Xbox: 1,
                                "Xbox One": 1
                            },
                            Motorola: {
                                Xoom: 1
                            },
                            Nintendo: {
                                "Wii U": 1,
                                Wii: 1
                            },
                            Nokia: {
                                Lumia: 1
                            },
                            Oppo: {},
                            Samsung: {
                                "Galaxy S": 1,
                                "Galaxy S2": 1,
                                "Galaxy S3": 1,
                                "Galaxy S4": 1
                            },
                            Sony: {
                                PlayStation: 1,
                                "PlayStation Vita": 1
                            },
                            Xiaomi: {
                                Mi: 1,
                                Redmi: 1
                            }
                        }), V = function(e) {
                            return y(e, function(e, r) {
                                var n = r.pattern || m(r);
                                return !e && (e = RegExp("\\b" + n + "(?:/[\\d.]+|[ \\w.]*)", "i").exec(t)) && (e = function(e, t, r) {
                                    var n = {
                                        "10.0": "10",
                                        6.4: "10 Technical Preview",
                                        6.3: "8.1",
                                        6.2: "8",
                                        6.1: "Server 2008 R2 / 7",
                                        "6.0": "Server 2008 / Vista",
                                        5.2: "Server 2003 / XP 64-bit",
                                        5.1: "XP",
                                        5.01: "2000 SP1",
                                        "5.0": "2000",
                                        "4.0": "NT",
                                        "4.90": "ME"
                                    };
                                    return t && r && /^Win/i.test(e) && !/^Windows Phone /i.test(e) && (n = n[/[\d.]+$/.exec(e)]) && (e = "Windows " + n), e = String(e), t && r && (e = e.replace(RegExp(t, "i"), r)), d(e.replace(/ ce$/i, " CE").replace(/\bhpw/i, "web").replace(/\bMacintosh\b/, "Mac OS").replace(/_PowerPC\b/i, " OS").replace(/\b(OS X) [^ \d]+/i, "$1").replace(/\bMac (OS X)\b/, "$1").replace(/\/(\d)/, " $1").replace(/_/g, ".").replace(/(?: BePC|[ .]*fc[ \d.]+)$/i, "").replace(/\bx86\.64\b/gi, "x86_64").replace(/\b(Windows Phone) OS\b/, "$1").replace(/\b(Chrome OS \w+) [\d.]+\b/, "$1").split(" on ")[0]);
                                }(e, n, r.label || r)), e;
                            });
                        }([
                            "Windows Phone",
                            "KaiOS",
                            "Android",
                            "CentOS",
                            {
                                label: "Chrome OS",
                                pattern: "CrOS"
                            },
                            "Debian",
                            {
                                label: "DragonFly BSD",
                                pattern: "DragonFly"
                            },
                            "Fedora",
                            "FreeBSD",
                            "Gentoo",
                            "Haiku",
                            "Kubuntu",
                            "Linux Mint",
                            "OpenBSD",
                            "Red Hat",
                            "SuSE",
                            "Ubuntu",
                            "Xubuntu",
                            "Cygwin",
                            "Symbian OS",
                            "hpwOS",
                            "webOS ",
                            "webOS",
                            "Tablet OS",
                            "Tizen",
                            "Linux",
                            "Mac OS X",
                            "Macintosh",
                            "Mac",
                            "Windows 98;",
                            "Windows "
                        ]);
                        function q(e) {
                            return y(e, function(e, r) {
                                var n = r.pattern || m(r);
                                return !e && (e = RegExp("\\b" + n + " *\\d+[.\\w_]*", "i").exec(t) || RegExp("\\b" + n + " *\\w+-[\\w]*", "i").exec(t) || RegExp("\\b" + n + "(?:; *(?:[a-z]+[_-])?[a-z]+\\d+|[^ ();-]*)", "i").exec(t)) && ((e = String(r.label && !RegExp(n, "i").test(r.label) ? r.label : e).split("/"))[1] && !/[\d.]+/.test(e[0]) && (e[0] += " " + e[1]), r = r.label || r, e = d(e[0].replace(RegExp(n, "i"), r).replace(RegExp("; *(?:" + r + "[_-])?", "i"), " ").replace(RegExp("(" + r + ")[-_.]?(\\w)", "i"), "$1 $2"))), e;
                            });
                        }
                        function G(e) {
                            return y(e, function(e, r) {
                                return e || (RegExp(r + "(?:-[\\d.]+/|(?: for [\\w-]+)?[ /-])([\\d.]+[^ ();/_-]*)", "i").exec(t) || 0)[1] || null;
                            });
                        }
                        if (j && (j = [
                            j
                        ]), /\bAndroid\b/.test(V) && !B && (s = /\bAndroid[^;]*;(.*?)(?:Build|\) AppleWebKit)\b/i.exec(t)) && (B = g(s[1]).replace(/^[a-z]{2}-[a-z]{2};\s*/i, "") || null), Q && !B ? B = q([
                            Q
                        ]) : Q && B && (B = B.replace(RegExp("^(" + m(Q) + ")[-_.\\s]", "i"), Q + " ").replace(RegExp("^(" + m(Q) + ")[-_.]?(\\w)", "i"), Q + " $2")), (s = /\bGoogle TV\b/.exec(B)) && (B = s[0]), /\bSimulator\b/i.test(t) && (B = (B ? B + " " : "") + "Simulator"), "Opera Mini" == U && /\bOPiOS\b/.test(t) && P.push("running in Turbo/Uncompressed mode"), "IE" == U && /\blike iPhone OS\b/.test(t) ? (Q = (s = e(t.replace(/like iPhone OS/, ""))).manufacturer, B = s.product) : /^iP/.test(B) ? (U || (U = "Safari"), V = "iOS" + ((s = / OS ([\d_]+)/i.exec(t)) ? " " + s[1].replace(/_/g, ".") : "")) : "Konqueror" == U && /^Linux\b/i.test(V) ? V = "Kubuntu" : Q && "Google" != Q && (/Chrome/.test(U) && !/\bMobile Safari\b/i.test(t) || /\bVita\b/.test(B)) || /\bAndroid\b/.test(V) && /^Chrome/.test(U) && /\bVersion\//i.test(t) ? (U = "Android Browser", V = /\bAndroid\b/.test(V) ? V : "Android") : "Silk" == U ? (/\bMobi/i.test(t) || (V = "Android", P.unshift("desktop mode")), /Accelerated *= *true/i.test(t) && P.unshift("accelerated")) : "UC Browser" == U && /\bUCWEB\b/.test(t) ? P.push("speed mode") : "PaleMoon" == U && (s = /\bFirefox\/([\d.]+)\b/.exec(t)) ? P.push("identifying as Firefox " + s[1]) : "Firefox" == U && (s = /\b(Mobile|Tablet|TV)\b/i.exec(t)) ? (V || (V = "Firefox OS"), B || (B = s[1])) : !U || (s = !/\bMinefield\b/i.test(t) && /\b(?:Firefox|Safari)\b/.exec(U)) ? (U && !B && /[\/,]|^[^(]+?\)/.test(t.slice(t.indexOf(s + "/") + 8)) && (U = null), (s = B || Q || V) && (B || Q || /\b(?:Android|Symbian OS|Tablet OS|webOS)\b/.test(V)) && (U = /[a-z]+(?: Hat)?/i.exec(/\bAndroid\b/.test(V) ? V : s) + " Browser")) : "Electron" == U && (s = (/\bChrome\/([\d.]+)\b/.exec(t) || 0)[1]) && P.push("Chromium " + s), L || (L = G([
                            "(?:Cloud9|CriOS|CrMo|Edge|Edg|EdgA|EdgiOS|FxiOS|HeadlessChrome|IEMobile|Iron|Opera ?Mini|OPiOS|OPR|Raven|SamsungBrowser|Silk(?!/[\\d.]+$)|UCBrowser|YaBrowser)",
                            "Version",
                            m(U),
                            "(?:Firefox|Minefield|NetFront)"
                        ])), (s = ("iCab" == j && parseFloat(L) > 3 ? "WebKit" : /\bOpera\b/.test(U) && (/\bOPR\b/.test(t) ? "Blink" : "Presto")) || /\b(?:Midori|Nook|Safari)\b/i.test(t) && !/^(?:Trident|EdgeHTML)$/.test(j) && "WebKit" || !j && /\bMSIE\b/i.test(t) && ("Mac OS" == V ? "Tasman" : "Trident") || "WebKit" == j && /\bPlayStation\b(?! Vita\b)/i.test(U) && "NetFront") && (j = [
                            s
                        ]), "IE" == U && (s = (/; *(?:XBLWP|ZuneWP)(\d+)/i.exec(t) || 0)[1]) ? (U += " Mobile", V = "Windows Phone " + (/\+$/.test(s) ? s : s + ".x"), P.unshift("desktop mode")) : /\bWPDesktop\b/i.test(t) ? (U = "IE Mobile", V = "Windows Phone 8.x", P.unshift("desktop mode"), L || (L = (/\brv:([\d.]+)/.exec(t) || 0)[1])) : "IE" != U && "Trident" == j && (s = /\brv:([\d.]+)/.exec(t)) && (U && P.push("identifying as " + U + (L ? " " + L : "")), U = "IE", L = s[1]), F) {
                            if (p = "global", /^(?:boolean|number|string|undefined)$/.test(E = null != (l = r) ? typeof l[p] : "number") || "object" == E && !l[p]) v(s = r.runtime) == _ ? (U = "Adobe AIR", V = s.flash.system.Capabilities.os) : v(s = r.phantom) == T ? (U = "PhantomJS", L = (s = s.version || null) && s.major + "." + s.minor + "." + s.patch) : "number" == typeof N.documentMode && (s = /\bTrident\/(\d+)/i.exec(t)) ? ((s = +s[1] + 4) != (L = [
                                L,
                                N.documentMode
                            ])[1] && (P.push("IE " + L[1] + " mode"), j && (j[1] = ""), L[1] = s), L = "IE" == U ? String(L[1].toFixed(1)) : L[0]) : "number" == typeof N.documentMode && /^(?:Chrome|Firefox)\b/.test(U) && (P.push("masking as " + U + " " + L), U = "IE", L = "11.0", j = [
                                "Trident"
                            ], V = "Windows");
                            else if (I && (M = (s = I.lang.System).getProperty("os.arch"), V = V || s.getProperty("os.name") + " " + s.getProperty("os.version")), R) {
                                try {
                                    L = r.require("ringo/engine").version.join("."), U = "RingoJS";
                                } catch (e) {
                                    (s = r.system) && s.global.system == r.system && (U = "Narwhal", V || (V = s[0].os || null));
                                }
                                U || (U = "Rhino");
                            } else "object" == typeof r.process && !r.process.browser && (s = r.process) && ("object" == typeof s.versions && ("string" == typeof s.versions.electron ? (P.push("Node " + s.versions.node), U = "Electron", L = s.versions.electron) : "string" == typeof s.versions.nw && (P.push("Chromium " + L, "Node " + s.versions.node), U = "NW.js", L = s.versions.nw)), U || (U = "Node.js", M = s.arch, V = s.platform, L = (L = /[\d.]+/.exec(s.version)) ? L[0] : null));
                            V = V && d(V);
                        }
                        if (L && (s = /(?:[ab]|dp|pre|[ab]\d+pre)(?:\d+\+?)?$/i.exec(L) || /(?:alpha|beta)(?: ?\d)?/i.exec(t + ";" + (F && i.appMinorVersion)) || /\bMinefield\b/i.test(t) && "a") && (D = /b/i.test(s) ? "beta" : "alpha", L = L.replace(RegExp(s + "\\+?$"), "") + ("beta" == D ? A : x) + (/\d+\+?/.exec(s) || "")), "Fennec" == U || "Firefox" == U && /\b(?:Android|Firefox OS|KaiOS)\b/.test(V)) U = "Firefox Mobile";
                        else if ("Maxthon" == U && L) L = L.replace(/\.[\d.]+/, ".x");
                        else if (/\bXbox\b/i.test(B)) "Xbox 360" == B && (V = null), "Xbox 360" == B && /\bIEMobile\b/.test(t) && P.unshift("mobile mode");
                        else if (!/^(?:Chrome|IE|Opera)$/.test(U) && (!U || B || /Browser|Mobi/.test(U)) || "Windows CE" != V && !/Mobi/i.test(t)) {
                            if ("IE" == U && F) try {
                                null === r.external && P.unshift("platform preview");
                            } catch (e) {
                                P.unshift("embedded");
                            }
                            else (/\bBlackBerry\b/.test(B) || /\bBB10\b/.test(t)) && (s = (RegExp(B.replace(/ +/g, " *") + "/([.\\d]+)", "i").exec(t) || 0)[1] || L) ? (V = ((s = [
                                s,
                                /BB10/.test(t)
                            ])[1] ? (B = null, Q = "BlackBerry") : "Device Software") + " " + s[0], L = null) : this != h && "Wii" != B && (F && C || /Opera/.test(U) && /\b(?:MSIE|Firefox)\b/i.test(t) || "Firefox" == U && /\bOS X (?:\d+\.){2,}/.test(V) || "IE" == U && (V && !/^Win/.test(V) && L > 5.5 || /\bWindows XP\b/.test(V) && L > 8 || 8 == L && !/\bTrident\b/.test(t))) && !u.test(s = e.call(h, t.replace(u, "") + ";")) && s.name && (s = "ing as " + s.name + ((s = s.version) ? " " + s : ""), u.test(U) ? (/\bIE\b/.test(s) && "Mac OS" == V && (V = null), s = "identify" + s) : (s = "mask" + s, U = k ? d(k.replace(/([a-z])([A-Z])/g, "$1 $2")) : "Opera", /\bIE\b/.test(s) && (V = null), F || (L = null)), j = [
                                "Presto"
                            ], P.push(s));
                        } else U += " Mobile";
                        (s = (/\bAppleWebKit\/([\d.]+\+?)/i.exec(t) || 0)[1]) && (s = [
                            parseFloat(s.replace(/\.(\d)$/, ".0$1")),
                            s
                        ], "Safari" == U && "+" == s[1].slice(-1) ? (U = "WebKit Nightly", D = "alpha", L = s[1].slice(0, -1)) : L != s[1] && L != (s[2] = (/\bSafari\/([\d.]+\+?)/i.exec(t) || 0)[1]) || (L = null), s[1] = (/\b(?:Headless)?Chrome\/([\d.]+)/i.exec(t) || 0)[1], 537.36 == s[0] && 537.36 == s[2] && parseFloat(s[1]) >= 28 && "WebKit" == j && (j = [
                            "Blink"
                        ]), F && (b || s[1]) ? (j && (j[1] = "like Chrome"), s = s[1] || ((s = s[0]) < 530 ? 1 : s < 532 ? 2 : s < 532.05 ? 3 : s < 533 ? 4 : s < 534.03 ? 5 : s < 534.07 ? 6 : s < 534.1 ? 7 : s < 534.13 ? 8 : s < 534.16 ? 9 : s < 534.24 ? 10 : s < 534.3 ? 11 : s < 535.01 ? 12 : s < 535.02 ? "13+" : s < 535.07 ? 15 : s < 535.11 ? 16 : s < 535.19 ? 17 : s < 536.05 ? 18 : s < 536.1 ? 19 : s < 537.01 ? 20 : s < 537.11 ? "21+" : s < 537.13 ? 23 : s < 537.18 ? 24 : s < 537.24 ? 25 : s < 537.36 ? 26 : "Blink" != j ? "27" : "28")) : (j && (j[1] = "like Safari"), s = (s = s[0]) < 400 ? 1 : s < 500 ? 2 : s < 526 ? 3 : s < 533 ? 4 : s < 534 ? "4+" : s < 535 ? 5 : s < 537 ? 6 : s < 538 ? 7 : s < 601 ? 8 : s < 602 ? 9 : s < 604 ? 10 : s < 606 ? 11 : s < 608 ? 12 : "12"), j && (j[1] += " " + (s += "number" == typeof s ? ".x" : /[.+]/.test(s) ? "" : "+")), "Safari" == U && (!L || parseInt(L) > 45) ? L = s : "Chrome" == U && /\bHeadlessChrome/i.test(t) && P.unshift("headless")), "Opera" == U && (s = /\bzbov|zvav$/.exec(V)) ? (U += " ", P.unshift("desktop mode"), "zvav" == s ? (U += "Mini", L = null) : U += "Mobile", V = V.replace(RegExp(" *" + s + "$"), "")) : "Safari" == U && /\bChrome\b/.exec(j && j[1]) ? (P.unshift("desktop mode"), U = "Chrome Mobile", L = null, /\bOS X\b/.test(V) ? (Q = "Apple", V = "iOS 4.3+") : V = null) : /\bSRWare Iron\b/.test(U) && !L && (L = G("Chrome")), L && 0 == L.indexOf(s = /[\d.]+$/.exec(V)) && t.indexOf("/" + s + "-") > -1 && (V = g(V.replace(s, ""))), V && -1 != V.indexOf(U) && !RegExp(U + " OS").test(V) && (V = V.replace(RegExp(" *" + m(U) + " *"), "")), j && !/\b(?:Avant|Nook)\b/.test(U) && (/Browser|Lunascape|Maxthon/.test(U) || "Safari" != U && /^iOS/.test(V) && /\bSafari\b/.test(j[1]) || /^(?:Adobe|Arora|Breach|Midori|Opera|Phantom|Rekonq|Rock|Samsung Internet|Sleipnir|SRWare Iron|Vivaldi|Web)/.test(U) && j[1]) && (s = j[j.length - 1]) && P.push(s), P.length && (P = [
                            "(" + P.join("; ") + ")"
                        ]), Q && B && B.indexOf(Q) < 0 && P.push("on " + Q), B && P.push((/^on /.test(P[P.length - 1]) ? "" : "on ") + B), V && (s = / ([\d.+]+)$/.exec(V), c = s && "/" == V.charAt(V.length - s[0].length - 1), V = {
                            architecture: 32,
                            family: s && !c ? V.replace(s[0], "") : V,
                            version: s ? s[1] : null,
                            toString: function() {
                                var e = this.version;
                                return this.family + (e && !c ? " " + e : "") + (64 == this.architecture ? " 64-bit" : "");
                            }
                        }), (s = /\b(?:AMD|IA|Win|WOW|x86_|x)64\b/i.exec(M)) && !/\bi686\b/i.test(M) ? (V && (V.architecture = 64, V.family = V.family.replace(RegExp(" *" + s), "")), U && (/\bWOW64\b/i.test(t) || F && /\w(?:86|32)$/.test(i.cpuClass || i.platform) && !/\bWin64; x64\b/i.test(t)) && P.unshift("32-bit")) : V && /^OS X/.test(V.family) && "Chrome" == U && parseFloat(L) >= 39 && (V.architecture = 64), t || (t = null);
                        var z = {};
                        return z.description = t, z.layout = j && j[0], z.manufacturer = Q, z.name = U, z.prerelease = D, z.product = B, z.ua = t, z.version = U && L, z.os = V || {
                            architecture: null,
                            family: null,
                            version: null,
                            toString: function() {
                                return "null";
                            }
                        }, z.parse = e, z.toString = function() {
                            return this.description || "";
                        }, z.version && P.unshift(L), z.name && P.unshift(U), V && U && (V != String(V).split(" ")[0] || V != U.split(" ")[0] && !B) && P.push(B ? "(" + V + ")" : "on " + V), P.length && (z.description = P.join(" ")), z;
                    }();
                    o.platform = E, void 0 === (n = (function() {
                        return E;
                    }).call(t, r, t, e)) || (e.exports = n);
                }).call(this);
            },
            6160: (e, t)=>{
                var r;
                t = e.exports = y, r = function() {}, t.SEMVER_SPEC_VERSION = "2.0.0";
                var n = 256, i = Number.MAX_SAFE_INTEGER || 9007199254740991, o = n - 6, a = t.re = [], s = t.safeRe = [], u = t.src = [], c = t.tokens = {}, l = 0;
                function f(e) {
                    c[e] = l++;
                }
                var p = "[a-zA-Z0-9-]", d = [
                    [
                        "\\s",
                        1
                    ],
                    [
                        "\\d",
                        n
                    ],
                    [
                        p,
                        o
                    ]
                ];
                function h(e) {
                    for(var t = 0; t < d.length; t++){
                        var r = d[t][0], n = d[t][1];
                        e = e.split(r + "*").join(r + "{0," + n + "}").split(r + "+").join(r + "{1," + n + "}");
                    }
                    return e;
                }
                f("NUMERICIDENTIFIER"), u[c.NUMERICIDENTIFIER] = "0|[1-9]\\d*", f("NUMERICIDENTIFIERLOOSE"), u[c.NUMERICIDENTIFIERLOOSE] = "\\d+", f("NONNUMERICIDENTIFIER"), u[c.NONNUMERICIDENTIFIER] = "\\d*[a-zA-Z-]" + p + "*", f("MAINVERSION"), u[c.MAINVERSION] = "(" + u[c.NUMERICIDENTIFIER] + ")\\.(" + u[c.NUMERICIDENTIFIER] + ")\\.(" + u[c.NUMERICIDENTIFIER] + ")", f("MAINVERSIONLOOSE"), u[c.MAINVERSIONLOOSE] = "(" + u[c.NUMERICIDENTIFIERLOOSE] + ")\\.(" + u[c.NUMERICIDENTIFIERLOOSE] + ")\\.(" + u[c.NUMERICIDENTIFIERLOOSE] + ")", f("PRERELEASEIDENTIFIER"), u[c.PRERELEASEIDENTIFIER] = "(?:" + u[c.NUMERICIDENTIFIER] + "|" + u[c.NONNUMERICIDENTIFIER] + ")", f("PRERELEASEIDENTIFIERLOOSE"), u[c.PRERELEASEIDENTIFIERLOOSE] = "(?:" + u[c.NUMERICIDENTIFIERLOOSE] + "|" + u[c.NONNUMERICIDENTIFIER] + ")", f("PRERELEASE"), u[c.PRERELEASE] = "(?:-(" + u[c.PRERELEASEIDENTIFIER] + "(?:\\." + u[c.PRERELEASEIDENTIFIER] + ")*))", f("PRERELEASELOOSE"), u[c.PRERELEASELOOSE] = "(?:-?(" + u[c.PRERELEASEIDENTIFIERLOOSE] + "(?:\\." + u[c.PRERELEASEIDENTIFIERLOOSE] + ")*))", f("BUILDIDENTIFIER"), u[c.BUILDIDENTIFIER] = p + "+", f("BUILD"), u[c.BUILD] = "(?:\\+(" + u[c.BUILDIDENTIFIER] + "(?:\\." + u[c.BUILDIDENTIFIER] + ")*))", f("FULL"), f("FULLPLAIN"), u[c.FULLPLAIN] = "v?" + u[c.MAINVERSION] + u[c.PRERELEASE] + "?" + u[c.BUILD] + "?", u[c.FULL] = "^" + u[c.FULLPLAIN] + "$", f("LOOSEPLAIN"), u[c.LOOSEPLAIN] = "[v=\\s]*" + u[c.MAINVERSIONLOOSE] + u[c.PRERELEASELOOSE] + "?" + u[c.BUILD] + "?", f("LOOSE"), u[c.LOOSE] = "^" + u[c.LOOSEPLAIN] + "$", f("GTLT"), u[c.GTLT] = "((?:<|>)?=?)", f("XRANGEIDENTIFIERLOOSE"), u[c.XRANGEIDENTIFIERLOOSE] = u[c.NUMERICIDENTIFIERLOOSE] + "|x|X|\\*", f("XRANGEIDENTIFIER"), u[c.XRANGEIDENTIFIER] = u[c.NUMERICIDENTIFIER] + "|x|X|\\*", f("XRANGEPLAIN"), u[c.XRANGEPLAIN] = "[v=\\s]*(" + u[c.XRANGEIDENTIFIER] + ")(?:\\.(" + u[c.XRANGEIDENTIFIER] + ")(?:\\.(" + u[c.XRANGEIDENTIFIER] + ")(?:" + u[c.PRERELEASE] + ")?" + u[c.BUILD] + "?)?)?", f("XRANGEPLAINLOOSE"), u[c.XRANGEPLAINLOOSE] = "[v=\\s]*(" + u[c.XRANGEIDENTIFIERLOOSE] + ")(?:\\.(" + u[c.XRANGEIDENTIFIERLOOSE] + ")(?:\\.(" + u[c.XRANGEIDENTIFIERLOOSE] + ")(?:" + u[c.PRERELEASELOOSE] + ")?" + u[c.BUILD] + "?)?)?", f("XRANGE"), u[c.XRANGE] = "^" + u[c.GTLT] + "\\s*" + u[c.XRANGEPLAIN] + "$", f("XRANGELOOSE"), u[c.XRANGELOOSE] = "^" + u[c.GTLT] + "\\s*" + u[c.XRANGEPLAINLOOSE] + "$", f("COERCE"), u[c.COERCE] = "(^|[^\\d])(\\d{1,16})(?:\\.(\\d{1,16}))?(?:\\.(\\d{1,16}))?(?:$|[^\\d])", f("COERCERTL"), a[c.COERCERTL] = new RegExp(u[c.COERCE], "g"), s[c.COERCERTL] = new RegExp(h(u[c.COERCE]), "g"), f("LONETILDE"), u[c.LONETILDE] = "(?:~>?)", f("TILDETRIM"), u[c.TILDETRIM] = "(\\s*)" + u[c.LONETILDE] + "\\s+", a[c.TILDETRIM] = new RegExp(u[c.TILDETRIM], "g"), s[c.TILDETRIM] = new RegExp(h(u[c.TILDETRIM]), "g");
                f("TILDE"), u[c.TILDE] = "^" + u[c.LONETILDE] + u[c.XRANGEPLAIN] + "$", f("TILDELOOSE"), u[c.TILDELOOSE] = "^" + u[c.LONETILDE] + u[c.XRANGEPLAINLOOSE] + "$", f("LONECARET"), u[c.LONECARET] = "(?:\\^)", f("CARETTRIM"), u[c.CARETTRIM] = "(\\s*)" + u[c.LONECARET] + "\\s+", a[c.CARETTRIM] = new RegExp(u[c.CARETTRIM], "g"), s[c.CARETTRIM] = new RegExp(h(u[c.CARETTRIM]), "g");
                f("CARET"), u[c.CARET] = "^" + u[c.LONECARET] + u[c.XRANGEPLAIN] + "$", f("CARETLOOSE"), u[c.CARETLOOSE] = "^" + u[c.LONECARET] + u[c.XRANGEPLAINLOOSE] + "$", f("COMPARATORLOOSE"), u[c.COMPARATORLOOSE] = "^" + u[c.GTLT] + "\\s*(" + u[c.LOOSEPLAIN] + ")$|^$", f("COMPARATOR"), u[c.COMPARATOR] = "^" + u[c.GTLT] + "\\s*(" + u[c.FULLPLAIN] + ")$|^$", f("COMPARATORTRIM"), u[c.COMPARATORTRIM] = "(\\s*)" + u[c.GTLT] + "\\s*(" + u[c.LOOSEPLAIN] + "|" + u[c.XRANGEPLAIN] + ")", a[c.COMPARATORTRIM] = new RegExp(u[c.COMPARATORTRIM], "g"), s[c.COMPARATORTRIM] = new RegExp(h(u[c.COMPARATORTRIM]), "g");
                f("HYPHENRANGE"), u[c.HYPHENRANGE] = "^\\s*(" + u[c.XRANGEPLAIN] + ")\\s+-\\s+(" + u[c.XRANGEPLAIN] + ")\\s*$", f("HYPHENRANGELOOSE"), u[c.HYPHENRANGELOOSE] = "^\\s*(" + u[c.XRANGEPLAINLOOSE] + ")\\s+-\\s+(" + u[c.XRANGEPLAINLOOSE] + ")\\s*$", f("STAR"), u[c.STAR] = "(<|>)?=?\\s*\\*";
                for(var v = 0; v < l; v++)r(v, u[v]), a[v] || (a[v] = new RegExp(u[v]), s[v] = new RegExp(h(u[v])));
                function m(e, t) {
                    if (t && "object" == typeof t || (t = {
                        loose: !!t,
                        includePrerelease: !1
                    }), e instanceof y) return e;
                    if ("string" != typeof e) return null;
                    if (e.length > n) return null;
                    if (!(t.loose ? s[c.LOOSE] : s[c.FULL]).test(e)) return null;
                    try {
                        return new y(e, t);
                    } catch (e) {
                        return null;
                    }
                }
                function y(e, t) {
                    if (t && "object" == typeof t || (t = {
                        loose: !!t,
                        includePrerelease: !1
                    }), e instanceof y) {
                        if (e.loose === t.loose) return e;
                        e = e.version;
                    } else if ("string" != typeof e) throw new TypeError("Invalid Version: " + e);
                    if (e.length > n) throw new TypeError("version is longer than " + n + " characters");
                    if (!(this instanceof y)) return new y(e, t);
                    r("SemVer", e, t), this.options = t, this.loose = !!t.loose;
                    var o = e.trim().match(t.loose ? s[c.LOOSE] : s[c.FULL]);
                    if (!o) throw new TypeError("Invalid Version: " + e);
                    if (this.raw = e, this.major = +o[1], this.minor = +o[2], this.patch = +o[3], this.major > i || this.major < 0) throw new TypeError("Invalid major version");
                    if (this.minor > i || this.minor < 0) throw new TypeError("Invalid minor version");
                    if (this.patch > i || this.patch < 0) throw new TypeError("Invalid patch version");
                    this.prerelease = o[4] ? o[4].split(".").map(function(e) {
                        if (/^[0-9]+$/.test(e)) {
                            var t = +e;
                            if (t >= 0 && t < i) return t;
                        }
                        return e;
                    }) : [], this.build = o[5] ? o[5].split(".") : [], this.format();
                }
                t.parse = m, t.valid = function(e, t) {
                    var r = m(e, t);
                    return r ? r.version : null;
                }, t.clean = function(e, t) {
                    var r = m(e.trim().replace(/^[=v]+/, ""), t);
                    return r ? r.version : null;
                }, t.SemVer = y, y.prototype.format = function() {
                    return this.version = this.major + "." + this.minor + "." + this.patch, this.prerelease.length && (this.version += "-" + this.prerelease.join(".")), this.version;
                }, y.prototype.toString = function() {
                    return this.version;
                }, y.prototype.compare = function(e) {
                    return r("SemVer.compare", this.version, this.options, e), e instanceof y || (e = new y(e, this.options)), this.compareMain(e) || this.comparePre(e);
                }, y.prototype.compareMain = function(e) {
                    return e instanceof y || (e = new y(e, this.options)), E(this.major, e.major) || E(this.minor, e.minor) || E(this.patch, e.patch);
                }, y.prototype.comparePre = function(e) {
                    if (e instanceof y || (e = new y(e, this.options)), this.prerelease.length && !e.prerelease.length) return -1;
                    if (!this.prerelease.length && e.prerelease.length) return 1;
                    if (!this.prerelease.length && !e.prerelease.length) return 0;
                    var t = 0;
                    do {
                        var n = this.prerelease[t], i = e.prerelease[t];
                        if (r("prerelease compare", t, n, i), void 0 === n && void 0 === i) return 0;
                        if (void 0 === i) return 1;
                        if (void 0 === n) return -1;
                        if (n !== i) return E(n, i);
                    }while (++t);
                }, y.prototype.compareBuild = function(e) {
                    e instanceof y || (e = new y(e, this.options));
                    var t = 0;
                    do {
                        var n = this.build[t], i = e.build[t];
                        if (r("prerelease compare", t, n, i), void 0 === n && void 0 === i) return 0;
                        if (void 0 === i) return 1;
                        if (void 0 === n) return -1;
                        if (n !== i) return E(n, i);
                    }while (++t);
                }, y.prototype.inc = function(e, t) {
                    switch(e){
                        case "premajor":
                            this.prerelease.length = 0, this.patch = 0, this.minor = 0, this.major++, this.inc("pre", t);
                            break;
                        case "preminor":
                            this.prerelease.length = 0, this.patch = 0, this.minor++, this.inc("pre", t);
                            break;
                        case "prepatch":
                            this.prerelease.length = 0, this.inc("patch", t), this.inc("pre", t);
                            break;
                        case "prerelease":
                            0 === this.prerelease.length && this.inc("patch", t), this.inc("pre", t);
                            break;
                        case "major":
                            0 === this.minor && 0 === this.patch && 0 !== this.prerelease.length || this.major++, this.minor = 0, this.patch = 0, this.prerelease = [];
                            break;
                        case "minor":
                            0 === this.patch && 0 !== this.prerelease.length || this.minor++, this.patch = 0, this.prerelease = [];
                            break;
                        case "patch":
                            0 === this.prerelease.length && this.patch++, this.prerelease = [];
                            break;
                        case "pre":
                            if (0 === this.prerelease.length) this.prerelease = [
                                0
                            ];
                            else {
                                for(var r = this.prerelease.length; --r >= 0;)"number" == typeof this.prerelease[r] && (this.prerelease[r]++, r = -2);
                                -1 === r && this.prerelease.push(0);
                            }
                            t && (this.prerelease[0] === t ? isNaN(this.prerelease[1]) && (this.prerelease = [
                                t,
                                0
                            ]) : this.prerelease = [
                                t,
                                0
                            ]);
                            break;
                        default:
                            throw new Error("invalid increment argument: " + e);
                    }
                    return this.format(), this.raw = this.version, this;
                }, t.inc = function(e, t, r, n) {
                    "string" == typeof r && (n = r, r = void 0);
                    try {
                        return new y(e, r).inc(t, n).version;
                    } catch (e) {
                        return null;
                    }
                }, t.diff = function(e, t) {
                    if (w(e, t)) return null;
                    var r = m(e), n = m(t), i = "";
                    if (r.prerelease.length || n.prerelease.length) {
                        i = "pre";
                        var o = "prerelease";
                    }
                    for(var a in r)if (("major" === a || "minor" === a || "patch" === a) && r[a] !== n[a]) return i + a;
                    return o;
                }, t.compareIdentifiers = E;
                var g = /^[0-9]+$/;
                function E(e, t) {
                    var r = g.test(e), n = g.test(t);
                    return r && n && (e = +e, t = +t), e === t ? 0 : r && !n ? -1 : n && !r ? 1 : e < t ? -1 : 1;
                }
                function b(e, t, r) {
                    return new y(e, r).compare(new y(t, r));
                }
                function S(e, t, r) {
                    return b(e, t, r) > 0;
                }
                function _(e, t, r) {
                    return b(e, t, r) < 0;
                }
                function w(e, t, r) {
                    return 0 === b(e, t, r);
                }
                function O(e, t, r) {
                    return 0 !== b(e, t, r);
                }
                function T(e, t, r) {
                    return b(e, t, r) >= 0;
                }
                function I(e, t, r) {
                    return b(e, t, r) <= 0;
                }
                function R(e, t, r, n) {
                    switch(t){
                        case "===":
                            return "object" == typeof e && (e = e.version), "object" == typeof r && (r = r.version), e === r;
                        case "!==":
                            return "object" == typeof e && (e = e.version), "object" == typeof r && (r = r.version), e !== r;
                        case "":
                        case "=":
                        case "==":
                            return w(e, r, n);
                        case "!=":
                            return O(e, r, n);
                        case ">":
                            return S(e, r, n);
                        case ">=":
                            return T(e, r, n);
                        case "<":
                            return _(e, r, n);
                        case "<=":
                            return I(e, r, n);
                        default:
                            throw new TypeError("Invalid operator: " + t);
                    }
                }
                function x(e, t) {
                    if (t && "object" == typeof t || (t = {
                        loose: !!t,
                        includePrerelease: !1
                    }), e instanceof x) {
                        if (e.loose === !!t.loose) return e;
                        e = e.value;
                    }
                    if (!(this instanceof x)) return new x(e, t);
                    e = e.trim().split(/\s+/).join(" "), r("comparator", e, t), this.options = t, this.loose = !!t.loose, this.parse(e), this.value = this.semver === A ? "" : this.operator + this.semver.version, r("comp", this);
                }
                t.rcompareIdentifiers = function(e, t) {
                    return E(t, e);
                }, t.major = function(e, t) {
                    return new y(e, t).major;
                }, t.minor = function(e, t) {
                    return new y(e, t).minor;
                }, t.patch = function(e, t) {
                    return new y(e, t).patch;
                }, t.compare = b, t.compareLoose = function(e, t) {
                    return b(e, t, !0);
                }, t.compareBuild = function(e, t, r) {
                    var n = new y(e, r), i = new y(t, r);
                    return n.compare(i) || n.compareBuild(i);
                }, t.rcompare = function(e, t, r) {
                    return b(t, e, r);
                }, t.sort = function(e, r) {
                    return e.sort(function(e, n) {
                        return t.compareBuild(e, n, r);
                    });
                }, t.rsort = function(e, r) {
                    return e.sort(function(e, n) {
                        return t.compareBuild(n, e, r);
                    });
                }, t.gt = S, t.lt = _, t.eq = w, t.neq = O, t.gte = T, t.lte = I, t.cmp = R, t.Comparator = x;
                var A = {};
                function N(e, t) {
                    if (t && "object" == typeof t || (t = {
                        loose: !!t,
                        includePrerelease: !1
                    }), e instanceof N) return e.loose === !!t.loose && e.includePrerelease === !!t.includePrerelease ? e : new N(e.raw, t);
                    if (e instanceof x) return new N(e.value, t);
                    if (!(this instanceof N)) return new N(e, t);
                    if (this.options = t, this.loose = !!t.loose, this.includePrerelease = !!t.includePrerelease, this.raw = e.trim().split(/\s+/).join(" "), this.set = this.raw.split("||").map(function(e) {
                        return this.parseRange(e.trim());
                    }, this).filter(function(e) {
                        return e.length;
                    }), !this.set.length) throw new TypeError("Invalid SemVer Range: " + this.raw);
                    this.format();
                }
                function C(e, t) {
                    for(var r = !0, n = e.slice(), i = n.pop(); r && n.length;)r = n.every(function(e) {
                        return i.intersects(e, t);
                    }), i = n.pop();
                    return r;
                }
                function k(e) {
                    return !e || "x" === e.toLowerCase() || "*" === e;
                }
                function M(e, t, r, n, i, o, a, s, u, c, l, f, p) {
                    return ((t = k(r) ? "" : k(n) ? ">=" + r + ".0.0" : k(i) ? ">=" + r + "." + n + ".0" : ">=" + t) + " " + (s = k(u) ? "" : k(c) ? "<" + (+u + 1) + ".0.0" : k(l) ? "<" + u + "." + (+c + 1) + ".0" : f ? "<=" + u + "." + c + "." + l + "-" + f : "<=" + s)).trim();
                }
                function P(e, t, n) {
                    for(var i = 0; i < e.length; i++)if (!e[i].test(t)) return !1;
                    if (t.prerelease.length && !n.includePrerelease) {
                        for(i = 0; i < e.length; i++)if (r(e[i].semver), e[i].semver !== A && e[i].semver.prerelease.length > 0) {
                            var o = e[i].semver;
                            if (o.major === t.major && o.minor === t.minor && o.patch === t.patch) return !0;
                        }
                        return !1;
                    }
                    return !0;
                }
                function D(e, t, r) {
                    try {
                        t = new N(t, r);
                    } catch (e) {
                        return !1;
                    }
                    return t.test(e);
                }
                function F(e, t, r, n) {
                    var i, o, a, s, u;
                    switch(e = new y(e, n), t = new N(t, n), r){
                        case ">":
                            i = S, o = I, a = _, s = ">", u = ">=";
                            break;
                        case "<":
                            i = _, o = T, a = S, s = "<", u = "<=";
                            break;
                        default:
                            throw new TypeError('Must provide a hilo val of "<" or ">"');
                    }
                    if (D(e, t, n)) return !1;
                    for(var c = 0; c < t.set.length; ++c){
                        var l = null, f = null;
                        if (t.set[c].forEach(function(e) {
                            e.semver === A && (e = new x(">=0.0.0")), f = f || e, i(e.semver, (l = l || e).semver, n) ? l = e : a(e.semver, f.semver, n) && (f = e);
                        }), l.operator === s || l.operator === u) return !1;
                        if ((!f.operator || f.operator === s) && o(e, f.semver)) return !1;
                        if (f.operator === u && a(e, f.semver)) return !1;
                    }
                    return !0;
                }
                x.prototype.parse = function(e) {
                    var t = e.match(this.options.loose ? s[c.COMPARATORLOOSE] : s[c.COMPARATOR]);
                    if (!t) throw new TypeError("Invalid comparator: " + e);
                    this.operator = void 0 !== t[1] ? t[1] : "", "=" === this.operator && (this.operator = ""), this.semver = t[2] ? new y(t[2], this.options.loose) : A;
                }, x.prototype.toString = function() {
                    return this.value;
                }, x.prototype.test = function(e) {
                    if (r("Comparator.test", e, this.options.loose), this.semver === A || e === A) return !0;
                    if ("string" == typeof e) try {
                        e = new y(e, this.options);
                    } catch (e) {
                        return !1;
                    }
                    return R(e, this.operator, this.semver, this.options);
                }, x.prototype.intersects = function(e, t) {
                    if (!(e instanceof x)) throw new TypeError("a Comparator is required");
                    var r;
                    if (t && "object" == typeof t || (t = {
                        loose: !!t,
                        includePrerelease: !1
                    }), "" === this.operator) return "" === this.value || (r = new N(e.value, t), D(this.value, r, t));
                    if ("" === e.operator) return "" === e.value || (r = new N(this.value, t), D(e.semver, r, t));
                    var n = !(">=" !== this.operator && ">" !== this.operator || ">=" !== e.operator && ">" !== e.operator), i = !("<=" !== this.operator && "<" !== this.operator || "<=" !== e.operator && "<" !== e.operator), o = this.semver.version === e.semver.version, a = !(">=" !== this.operator && "<=" !== this.operator || ">=" !== e.operator && "<=" !== e.operator), s = R(this.semver, "<", e.semver, t) && (">=" === this.operator || ">" === this.operator) && ("<=" === e.operator || "<" === e.operator), u = R(this.semver, ">", e.semver, t) && ("<=" === this.operator || "<" === this.operator) && (">=" === e.operator || ">" === e.operator);
                    return n || i || o && a || s || u;
                }, t.Range = N, N.prototype.format = function() {
                    return this.range = this.set.map(function(e) {
                        return e.join(" ").trim();
                    }).join("||").trim(), this.range;
                }, N.prototype.toString = function() {
                    return this.range;
                }, N.prototype.parseRange = function(e) {
                    var t = this.options.loose;
                    e = e.replace(t ? s[c.HYPHENRANGELOOSE] : s[c.HYPHENRANGE], M), r("hyphen replace", e), e = e.replace(s[c.COMPARATORTRIM], "$1$2$3"), r("comparator trim", e, s[c.COMPARATORTRIM]), e = (e = (e = e.replace(s[c.TILDETRIM], "$1~")).replace(s[c.CARETTRIM], "$1^")).split(/\s+/).join(" ");
                    var n = t ? s[c.COMPARATORLOOSE] : s[c.COMPARATOR], i = e.split(" ").map(function(e) {
                        return function(e, t) {
                            return r("comp", e, t), e = function(e, t) {
                                return e.trim().split(/\s+/).map(function(e) {
                                    return function(e, t) {
                                        r("caret", e, t);
                                        var n = t.loose ? s[c.CARETLOOSE] : s[c.CARET];
                                        return e.replace(n, function(t, n, i, o, a) {
                                            var s;
                                            return r("caret", e, t, n, i, o, a), k(n) ? s = "" : k(i) ? s = ">=" + n + ".0.0 <" + (+n + 1) + ".0.0" : k(o) ? s = "0" === n ? ">=" + n + "." + i + ".0 <" + n + "." + (+i + 1) + ".0" : ">=" + n + "." + i + ".0 <" + (+n + 1) + ".0.0" : a ? (r("replaceCaret pr", a), s = "0" === n ? "0" === i ? ">=" + n + "." + i + "." + o + "-" + a + " <" + n + "." + i + "." + (+o + 1) : ">=" + n + "." + i + "." + o + "-" + a + " <" + n + "." + (+i + 1) + ".0" : ">=" + n + "." + i + "." + o + "-" + a + " <" + (+n + 1) + ".0.0") : (r("no pr"), s = "0" === n ? "0" === i ? ">=" + n + "." + i + "." + o + " <" + n + "." + i + "." + (+o + 1) : ">=" + n + "." + i + "." + o + " <" + n + "." + (+i + 1) + ".0" : ">=" + n + "." + i + "." + o + " <" + (+n + 1) + ".0.0"), r("caret return", s), s;
                                        });
                                    }(e, t);
                                }).join(" ");
                            }(e, t), r("caret", e), e = function(e, t) {
                                return e.trim().split(/\s+/).map(function(e) {
                                    return function(e, t) {
                                        var n = t.loose ? s[c.TILDELOOSE] : s[c.TILDE];
                                        return e.replace(n, function(t, n, i, o, a) {
                                            var s;
                                            return r("tilde", e, t, n, i, o, a), k(n) ? s = "" : k(i) ? s = ">=" + n + ".0.0 <" + (+n + 1) + ".0.0" : k(o) ? s = ">=" + n + "." + i + ".0 <" + n + "." + (+i + 1) + ".0" : a ? (r("replaceTilde pr", a), s = ">=" + n + "." + i + "." + o + "-" + a + " <" + n + "." + (+i + 1) + ".0") : s = ">=" + n + "." + i + "." + o + " <" + n + "." + (+i + 1) + ".0", r("tilde return", s), s;
                                        });
                                    }(e, t);
                                }).join(" ");
                            }(e, t), r("tildes", e), e = function(e, t) {
                                return r("replaceXRanges", e, t), e.split(/\s+/).map(function(e) {
                                    return function(e, t) {
                                        e = e.trim();
                                        var n = t.loose ? s[c.XRANGELOOSE] : s[c.XRANGE];
                                        return e.replace(n, function(n, i, o, a, s, u) {
                                            r("xRange", e, n, i, o, a, s, u);
                                            var c = k(o), l = c || k(a), f = l || k(s);
                                            return "=" === i && f && (i = ""), u = t.includePrerelease ? "-0" : "", c ? n = ">" === i || "<" === i ? "<0.0.0-0" : "*" : i && f ? (l && (a = 0), s = 0, ">" === i ? (i = ">=", l ? (o = +o + 1, a = 0, s = 0) : (a = +a + 1, s = 0)) : "<=" === i && (i = "<", l ? o = +o + 1 : a = +a + 1), n = i + o + "." + a + "." + s + u) : l ? n = ">=" + o + ".0.0" + u + " <" + (+o + 1) + ".0.0" + u : f && (n = ">=" + o + "." + a + ".0" + u + " <" + o + "." + (+a + 1) + ".0" + u), r("xRange return", n), n;
                                        });
                                    }(e, t);
                                }).join(" ");
                            }(e, t), r("xrange", e), e = function(e, t) {
                                return r("replaceStars", e, t), e.trim().replace(s[c.STAR], "");
                            }(e, t), r("stars", e), e;
                        }(e, this.options);
                    }, this).join(" ").split(/\s+/);
                    return this.options.loose && (i = i.filter(function(e) {
                        return !!e.match(n);
                    })), i = i.map(function(e) {
                        return new x(e, this.options);
                    }, this);
                }, N.prototype.intersects = function(e, t) {
                    if (!(e instanceof N)) throw new TypeError("a Range is required");
                    return this.set.some(function(r) {
                        return C(r, t) && e.set.some(function(e) {
                            return C(e, t) && r.every(function(r) {
                                return e.every(function(e) {
                                    return r.intersects(e, t);
                                });
                            });
                        });
                    });
                }, t.toComparators = function(e, t) {
                    return new N(e, t).set.map(function(e) {
                        return e.map(function(e) {
                            return e.value;
                        }).join(" ").trim().split(" ");
                    });
                }, N.prototype.test = function(e) {
                    if (!e) return !1;
                    if ("string" == typeof e) try {
                        e = new y(e, this.options);
                    } catch (e) {
                        return !1;
                    }
                    for(var t = 0; t < this.set.length; t++)if (P(this.set[t], e, this.options)) return !0;
                    return !1;
                }, t.satisfies = D, t.maxSatisfying = function(e, t, r) {
                    var n = null, i = null;
                    try {
                        var o = new N(t, r);
                    } catch (e) {
                        return null;
                    }
                    return e.forEach(function(e) {
                        o.test(e) && (n && -1 !== i.compare(e) || (i = new y(n = e, r)));
                    }), n;
                }, t.minSatisfying = function(e, t, r) {
                    var n = null, i = null;
                    try {
                        var o = new N(t, r);
                    } catch (e) {
                        return null;
                    }
                    return e.forEach(function(e) {
                        o.test(e) && (n && 1 !== i.compare(e) || (i = new y(n = e, r)));
                    }), n;
                }, t.minVersion = function(e, t) {
                    e = new N(e, t);
                    var r = new y("0.0.0");
                    if (e.test(r)) return r;
                    if (r = new y("0.0.0-0"), e.test(r)) return r;
                    r = null;
                    for(var n = 0; n < e.set.length; ++n)e.set[n].forEach(function(e) {
                        var t = new y(e.semver.version);
                        switch(e.operator){
                            case ">":
                                0 === t.prerelease.length ? t.patch++ : t.prerelease.push(0), t.raw = t.format();
                            case "":
                            case ">=":
                                r && !S(r, t) || (r = t);
                                break;
                            case "<":
                            case "<=":
                                break;
                            default:
                                throw new Error("Unexpected operation: " + e.operator);
                        }
                    });
                    if (r && e.test(r)) return r;
                    return null;
                }, t.validRange = function(e, t) {
                    try {
                        return new N(e, t).range || "*";
                    } catch (e) {
                        return null;
                    }
                }, t.ltr = function(e, t, r) {
                    return F(e, t, "<", r);
                }, t.gtr = function(e, t, r) {
                    return F(e, t, ">", r);
                }, t.outside = F, t.prerelease = function(e, t) {
                    var r = m(e, t);
                    return r && r.prerelease.length ? r.prerelease : null;
                }, t.intersects = function(e, t, r) {
                    return e = new N(e, r), t = new N(t, r), e.intersects(t);
                }, t.coerce = function(e, t) {
                    if (e instanceof y) return e;
                    "number" == typeof e && (e = String(e));
                    if ("string" != typeof e) return null;
                    var r = null;
                    if ((t = t || {}).rtl) {
                        for(var n; (n = s[c.COERCERTL].exec(e)) && (!r || r.index + r[0].length !== e.length);)r && n.index + n[0].length === r.index + r[0].length || (r = n), s[c.COERCERTL].lastIndex = n.index + n[1].length + n[2].length;
                        s[c.COERCERTL].lastIndex = -1;
                    } else r = e.match(s[c.COERCE]);
                    if (null === r) return null;
                    return m(r[2] + "." + (r[3] || "0") + "." + (r[4] || "0"), t);
                };
            },
            1603: (e, t, r)=>{
                "use strict";
                r.d(t, {
                    Z: ()=>n
                }), e = r.hmd(e);
                const n = function(e) {
                    var t, r = e.Symbol;
                    return "function" == typeof r ? r.observable ? t = r.observable : (t = r("observable"), r.observable = t) : t = "@@observable", t;
                }("undefined" != typeof self ? self : "undefined" != typeof window ? window : void 0 !== r.g ? r.g : e);
            },
            8754: (e, t, r)=>{
                "use strict";
                r.d(t, {
                    ej: ()=>s,
                    kG: ()=>u
                });
                var n = r(5949), i = "Invariant Violation", o = Object.setPrototypeOf, a = void 0 === o ? function(e, t) {
                    return e.__proto__ = t, e;
                } : o, s = function(e) {
                    function t(r) {
                        void 0 === r && (r = i);
                        var n = e.call(this, "number" == typeof r ? i + ": " + r + " (see https://github.com/apollographql/invariant-packages)" : r) || this;
                        return n.framesToPop = 1, n.name = i, a(n, t.prototype), n;
                    }
                    return (0, n.ZT)(t, e), t;
                }(Error);
                function u(e, t) {
                    if (!e) throw new s(t);
                }
                function c(e) {
                    return function() {
                        return console[e].apply(console, arguments);
                    };
                }
                !function(e) {
                    e.warn = c("warn"), e.error = c("error");
                }(u || (u = {}));
                var l = {
                    env: {}
                };
                try {
                    Function("stub", "process = stub")(l);
                } catch (e) {}
            },
            5949: (e, t, r)=>{
                "use strict";
                r.d(t, {
                    Jh: ()=>u,
                    ZT: ()=>i,
                    _T: ()=>a,
                    mG: ()=>s,
                    pi: ()=>o,
                    pr: ()=>c
                });
                var n = function(e, t) {
                    return n = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(e, t) {
                        e.__proto__ = t;
                    } || function(e, t) {
                        for(var r in t)t.hasOwnProperty(r) && (e[r] = t[r]);
                    }, n(e, t);
                };
                function i(e, t) {
                    function r() {
                        this.constructor = e;
                    }
                    n(e, t), e.prototype = null === t ? Object.create(t) : (r.prototype = t.prototype, new r);
                }
                var o = function() {
                    return o = Object.assign || function(e) {
                        for(var t, r = 1, n = arguments.length; r < n; r++)for(var i in t = arguments[r])Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
                        return e;
                    }, o.apply(this, arguments);
                };
                function a(e, t) {
                    var r = {};
                    for(var n in e)Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
                    if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
                        var i = 0;
                        for(n = Object.getOwnPropertySymbols(e); i < n.length; i++)t.indexOf(n[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[i]) && (r[n[i]] = e[n[i]]);
                    }
                    return r;
                }
                function s(e, t, r, n) {
                    return new (r || (r = Promise))(function(i, o) {
                        function a(e) {
                            try {
                                u(n.next(e));
                            } catch (e) {
                                o(e);
                            }
                        }
                        function s(e) {
                            try {
                                u(n.throw(e));
                            } catch (e) {
                                o(e);
                            }
                        }
                        function u(e) {
                            var t;
                            e.done ? i(e.value) : (t = e.value, t instanceof r ? t : new r(function(e) {
                                e(t);
                            })).then(a, s);
                        }
                        u((n = n.apply(e, t || [])).next());
                    });
                }
                function u(e, t) {
                    var r, n, i, o, a = {
                        label: 0,
                        sent: function() {
                            if (1 & i[0]) throw i[1];
                            return i[1];
                        },
                        trys: [],
                        ops: []
                    };
                    return o = {
                        next: s(0),
                        throw: s(1),
                        return: s(2)
                    }, "function" == typeof Symbol && (o[Symbol.iterator] = function() {
                        return this;
                    }), o;
                    function s(o) {
                        return function(s) {
                            return function(o) {
                                if (r) throw new TypeError("Generator is already executing.");
                                for(; a;)try {
                                    if (r = 1, n && (i = 2 & o[0] ? n.return : o[0] ? n.throw || ((i = n.return) && i.call(n), 0) : n.next) && !(i = i.call(n, o[1])).done) return i;
                                    switch(n = 0, i && (o = [
                                        2 & o[0],
                                        i.value
                                    ]), o[0]){
                                        case 0:
                                        case 1:
                                            i = o;
                                            break;
                                        case 4:
                                            return a.label++, {
                                                value: o[1],
                                                done: !1
                                            };
                                        case 5:
                                            a.label++, n = o[1], o = [
                                                0
                                            ];
                                            continue;
                                        case 7:
                                            o = a.ops.pop(), a.trys.pop();
                                            continue;
                                        default:
                                            if (!(i = a.trys, (i = i.length > 0 && i[i.length - 1]) || 6 !== o[0] && 2 !== o[0])) {
                                                a = 0;
                                                continue;
                                            }
                                            if (3 === o[0] && (!i || o[1] > i[0] && o[1] < i[3])) {
                                                a.label = o[1];
                                                break;
                                            }
                                            if (6 === o[0] && a.label < i[1]) {
                                                a.label = i[1], i = o;
                                                break;
                                            }
                                            if (i && a.label < i[2]) {
                                                a.label = i[2], a.ops.push(o);
                                                break;
                                            }
                                            i[2] && a.ops.pop(), a.trys.pop();
                                            continue;
                                    }
                                    o = t.call(e, a);
                                } catch (e) {
                                    o = [
                                        6,
                                        e
                                    ], n = 0;
                                } finally{
                                    r = i = 0;
                                }
                                if (5 & o[0]) throw o[1];
                                return {
                                    value: o[0] ? o[1] : void 0,
                                    done: !0
                                };
                            }([
                                o,
                                s
                            ]);
                        };
                    }
                }
                function c() {
                    for(var e = 0, t = 0, r = arguments.length; t < r; t++)e += arguments[t].length;
                    var n = Array(e), i = 0;
                    for(t = 0; t < r; t++)for(var o = arguments[t], a = 0, s = o.length; a < s; a++, i++)n[i] = o[a];
                    return n;
                }
            },
            6261: function(e, t, r) {
                var n, i;
                !function(o, a) {
                    "use strict";
                    e.exports ? e.exports = a() : void 0 === (i = "function" == typeof (n = a) ? n.call(t, r, t, e) : n) || (e.exports = i);
                }(0, function(e) {
                    "use strict";
                    var t = e && e.IPv6;
                    return {
                        best: function(e) {
                            var t, r, n = e.toLowerCase().split(":"), i = n.length, o = 8;
                            for("" === n[0] && "" === n[1] && "" === n[2] ? (n.shift(), n.shift()) : "" === n[0] && "" === n[1] ? n.shift() : "" === n[i - 1] && "" === n[i - 2] && n.pop(), -1 !== n[(i = n.length) - 1].indexOf(".") && (o = 7), t = 0; t < i && "" !== n[t]; t++);
                            if (t < o) for(n.splice(t, 1, "0000"); n.length < o;)n.splice(t, 0, "0000");
                            for(var a = 0; a < o; a++){
                                r = n[a].split("");
                                for(var s = 0; s < 3 && "0" === r[0] && r.length > 1; s++)r.splice(0, 1);
                                n[a] = r.join("");
                            }
                            var u = -1, c = 0, l = 0, f = -1, p = !1;
                            for(a = 0; a < o; a++)p ? "0" === n[a] ? l += 1 : (p = !1, l > c && (u = f, c = l)) : "0" === n[a] && (p = !0, f = a, l = 1);
                            l > c && (u = f, c = l), c > 1 && n.splice(u, c, ""), i = n.length;
                            var d = "";
                            for("" === n[0] && (d = ":"), a = 0; a < i && (d += n[a], a !== i - 1); a++)d += ":";
                            return "" === n[i - 1] && (d += ":"), d;
                        },
                        noConflict: function() {
                            return e.IPv6 === this && (e.IPv6 = t), this;
                        }
                    };
                });
            },
            8776: function(e, t, r) {
                var n, i;
                !function(o, a) {
                    "use strict";
                    e.exports ? e.exports = a() : void 0 === (i = "function" == typeof (n = a) ? n.call(t, r, t, e) : n) || (e.exports = i);
                }(0, function(e) {
                    "use strict";
                    var t = e && e.SecondLevelDomains, r = {
                        list: {
                            ac: " com gov mil net org ",
                            ae: " ac co gov mil name net org pro sch ",
                            af: " com edu gov net org ",
                            al: " com edu gov mil net org ",
                            ao: " co ed gv it og pb ",
                            ar: " com edu gob gov int mil net org tur ",
                            at: " ac co gv or ",
                            au: " asn com csiro edu gov id net org ",
                            ba: " co com edu gov mil net org rs unbi unmo unsa untz unze ",
                            bb: " biz co com edu gov info net org store tv ",
                            bh: " biz cc com edu gov info net org ",
                            bn: " com edu gov net org ",
                            bo: " com edu gob gov int mil net org tv ",
                            br: " adm adv agr am arq art ato b bio blog bmd cim cng cnt com coop ecn edu eng esp etc eti far flog fm fnd fot fst g12 ggf gov imb ind inf jor jus lel mat med mil mus net nom not ntr odo org ppg pro psc psi qsl rec slg srv tmp trd tur tv vet vlog wiki zlg ",
                            bs: " com edu gov net org ",
                            bz: " du et om ov rg ",
                            ca: " ab bc mb nb nf nl ns nt nu on pe qc sk yk ",
                            ck: " biz co edu gen gov info net org ",
                            cn: " ac ah bj com cq edu fj gd gov gs gx gz ha hb he hi hl hn jl js jx ln mil net nm nx org qh sc sd sh sn sx tj tw xj xz yn zj ",
                            co: " com edu gov mil net nom org ",
                            cr: " ac c co ed fi go or sa ",
                            cy: " ac biz com ekloges gov ltd name net org parliament press pro tm ",
                            do: " art com edu gob gov mil net org sld web ",
                            dz: " art asso com edu gov net org pol ",
                            ec: " com edu fin gov info med mil net org pro ",
                            eg: " com edu eun gov mil name net org sci ",
                            er: " com edu gov ind mil net org rochest w ",
                            es: " com edu gob nom org ",
                            et: " biz com edu gov info name net org ",
                            fj: " ac biz com info mil name net org pro ",
                            fk: " ac co gov net nom org ",
                            fr: " asso com f gouv nom prd presse tm ",
                            gg: " co net org ",
                            gh: " com edu gov mil org ",
                            gn: " ac com gov net org ",
                            gr: " com edu gov mil net org ",
                            gt: " com edu gob ind mil net org ",
                            gu: " com edu gov net org ",
                            hk: " com edu gov idv net org ",
                            hu: " 2000 agrar bolt casino city co erotica erotika film forum games hotel info ingatlan jogasz konyvelo lakas media news org priv reklam sex shop sport suli szex tm tozsde utazas video ",
                            id: " ac co go mil net or sch web ",
                            il: " ac co gov idf k12 muni net org ",
                            in: " ac co edu ernet firm gen gov i ind mil net nic org res ",
                            iq: " com edu gov i mil net org ",
                            ir: " ac co dnssec gov i id net org sch ",
                            it: " edu gov ",
                            je: " co net org ",
                            jo: " com edu gov mil name net org sch ",
                            jp: " ac ad co ed go gr lg ne or ",
                            ke: " ac co go info me mobi ne or sc ",
                            kh: " com edu gov mil net org per ",
                            ki: " biz com de edu gov info mob net org tel ",
                            km: " asso com coop edu gouv k medecin mil nom notaires pharmaciens presse tm veterinaire ",
                            kn: " edu gov net org ",
                            kr: " ac busan chungbuk chungnam co daegu daejeon es gangwon go gwangju gyeongbuk gyeonggi gyeongnam hs incheon jeju jeonbuk jeonnam k kg mil ms ne or pe re sc seoul ulsan ",
                            kw: " com edu gov net org ",
                            ky: " com edu gov net org ",
                            kz: " com edu gov mil net org ",
                            lb: " com edu gov net org ",
                            lk: " assn com edu gov grp hotel int ltd net ngo org sch soc web ",
                            lr: " com edu gov net org ",
                            lv: " asn com conf edu gov id mil net org ",
                            ly: " com edu gov id med net org plc sch ",
                            ma: " ac co gov m net org press ",
                            mc: " asso tm ",
                            me: " ac co edu gov its net org priv ",
                            mg: " com edu gov mil nom org prd tm ",
                            mk: " com edu gov inf name net org pro ",
                            ml: " com edu gov net org presse ",
                            mn: " edu gov org ",
                            mo: " com edu gov net org ",
                            mt: " com edu gov net org ",
                            mv: " aero biz com coop edu gov info int mil museum name net org pro ",
                            mw: " ac co com coop edu gov int museum net org ",
                            mx: " com edu gob net org ",
                            my: " com edu gov mil name net org sch ",
                            nf: " arts com firm info net other per rec store web ",
                            ng: " biz com edu gov mil mobi name net org sch ",
                            ni: " ac co com edu gob mil net nom org ",
                            np: " com edu gov mil net org ",
                            nr: " biz com edu gov info net org ",
                            om: " ac biz co com edu gov med mil museum net org pro sch ",
                            pe: " com edu gob mil net nom org sld ",
                            ph: " com edu gov i mil net ngo org ",
                            pk: " biz com edu fam gob gok gon gop gos gov net org web ",
                            pl: " art bialystok biz com edu gda gdansk gorzow gov info katowice krakow lodz lublin mil net ngo olsztyn org poznan pwr radom slupsk szczecin torun warszawa waw wroc wroclaw zgora ",
                            pr: " ac biz com edu est gov info isla name net org pro prof ",
                            ps: " com edu gov net org plo sec ",
                            pw: " belau co ed go ne or ",
                            ro: " arts com firm info nom nt org rec store tm www ",
                            rs: " ac co edu gov in org ",
                            sb: " com edu gov net org ",
                            sc: " com edu gov net org ",
                            sh: " co com edu gov net nom org ",
                            sl: " com edu gov net org ",
                            st: " co com consulado edu embaixada gov mil net org principe saotome store ",
                            sv: " com edu gob org red ",
                            sz: " ac co org ",
                            tr: " av bbs bel biz com dr edu gen gov info k12 name net org pol tel tsk tv web ",
                            tt: " aero biz cat co com coop edu gov info int jobs mil mobi museum name net org pro tel travel ",
                            tw: " club com ebiz edu game gov idv mil net org ",
                            mu: " ac co com gov net or org ",
                            mz: " ac co edu gov org ",
                            na: " co com ",
                            nz: " ac co cri geek gen govt health iwi maori mil net org parliament school ",
                            pa: " abo ac com edu gob ing med net nom org sld ",
                            pt: " com edu gov int net nome org publ ",
                            py: " com edu gov mil net org ",
                            qa: " com edu gov mil net org ",
                            re: " asso com nom ",
                            ru: " ac adygeya altai amur arkhangelsk astrakhan bashkiria belgorod bir bryansk buryatia cbg chel chelyabinsk chita chukotka chuvashia com dagestan e-burg edu gov grozny int irkutsk ivanovo izhevsk jar joshkar-ola kalmykia kaluga kamchatka karelia kazan kchr kemerovo khabarovsk khakassia khv kirov koenig komi kostroma kranoyarsk kuban kurgan kursk lipetsk magadan mari mari-el marine mil mordovia mosreg msk murmansk nalchik net nnov nov novosibirsk nsk omsk orenburg org oryol penza perm pp pskov ptz rnd ryazan sakhalin samara saratov simbirsk smolensk spb stavropol stv surgut tambov tatarstan tom tomsk tsaritsyn tsk tula tuva tver tyumen udm udmurtia ulan-ude vladikavkaz vladimir vladivostok volgograd vologda voronezh vrn vyatka yakutia yamal yekaterinburg yuzhno-sakhalinsk ",
                            rw: " ac co com edu gouv gov int mil net ",
                            sa: " com edu gov med net org pub sch ",
                            sd: " com edu gov info med net org tv ",
                            se: " a ac b bd c d e f g h i k l m n o org p parti pp press r s t tm u w x y z ",
                            sg: " com edu gov idn net org per ",
                            sn: " art com edu gouv org perso univ ",
                            sy: " com edu gov mil net news org ",
                            th: " ac co go in mi net or ",
                            tj: " ac biz co com edu go gov info int mil name net nic org test web ",
                            tn: " agrinet com defense edunet ens fin gov ind info intl mincom nat net org perso rnrt rns rnu tourism ",
                            tz: " ac co go ne or ",
                            ua: " biz cherkassy chernigov chernovtsy ck cn co com crimea cv dn dnepropetrovsk donetsk dp edu gov if in ivano-frankivsk kh kharkov kherson khmelnitskiy kiev kirovograd km kr ks kv lg lugansk lutsk lviv me mk net nikolaev od odessa org pl poltava pp rovno rv sebastopol sumy te ternopil uzhgorod vinnica vn zaporizhzhe zhitomir zp zt ",
                            ug: " ac co go ne or org sc ",
                            uk: " ac bl british-library co cym gov govt icnet jet lea ltd me mil mod national-library-scotland nel net nhs nic nls org orgn parliament plc police sch scot soc ",
                            us: " dni fed isa kids nsn ",
                            uy: " com edu gub mil net org ",
                            ve: " co com edu gob info mil net org web ",
                            vi: " co com k12 net org ",
                            vn: " ac biz com edu gov health info int name net org pro ",
                            ye: " co com gov ltd me net org plc ",
                            yu: " ac co edu gov org ",
                            za: " ac agric alt bourse city co cybernet db edu gov grondar iaccess imt inca landesign law mil net ngo nis nom olivetti org pix school tm web ",
                            zm: " ac co com edu gov net org sch ",
                            com: "ar br cn de eu gb gr hu jpn kr no qc ru sa se uk us uy za ",
                            net: "gb jp se uk ",
                            org: "ae",
                            de: "com "
                        },
                        has: function(e) {
                            var t = e.lastIndexOf(".");
                            if (t <= 0 || t >= e.length - 1) return !1;
                            var n = e.lastIndexOf(".", t - 1);
                            if (n <= 0 || n >= t - 1) return !1;
                            var i = r.list[e.slice(t + 1)];
                            return !!i && i.indexOf(" " + e.slice(n + 1, t) + " ") >= 0;
                        },
                        is: function(e) {
                            var t = e.lastIndexOf(".");
                            if (t <= 0 || t >= e.length - 1) return !1;
                            if (e.lastIndexOf(".", t - 1) >= 0) return !1;
                            var n = r.list[e.slice(t + 1)];
                            return !!n && n.indexOf(" " + e.slice(0, t) + " ") >= 0;
                        },
                        get: function(e) {
                            var t = e.lastIndexOf(".");
                            if (t <= 0 || t >= e.length - 1) return null;
                            var n = e.lastIndexOf(".", t - 1);
                            if (n <= 0 || n >= t - 1) return null;
                            var i = r.list[e.slice(t + 1)];
                            return i ? i.indexOf(" " + e.slice(n + 1, t) + " ") < 0 ? null : e.slice(n + 1) : null;
                        },
                        noConflict: function() {
                            return e.SecondLevelDomains === this && (e.SecondLevelDomains = t), this;
                        }
                    };
                    return r;
                });
            },
            6812: function(e, t, r) {
                var n, i, o;
                !function(a, s) {
                    "use strict";
                    e.exports ? e.exports = s(r(4344), r(6261), r(8776)) : (i = [
                        r(4344),
                        r(6261),
                        r(8776)
                    ], void 0 === (o = "function" == typeof (n = s) ? n.apply(t, i) : n) || (e.exports = o));
                }(0, function(e, t, r, n) {
                    "use strict";
                    var i = n && n.URI;
                    function o(e, t) {
                        var r = arguments.length >= 1;
                        if (!(this instanceof o)) return r ? arguments.length >= 2 ? new o(e, t) : new o(e) : new o;
                        if (void 0 === e) {
                            if (r) throw new TypeError("undefined is not a valid argument for URI");
                            e = "undefined" != typeof location ? location.href + "" : "";
                        }
                        if (null === e && r) throw new TypeError("null is not a valid argument for URI");
                        return this.href(e), void 0 !== t ? this.absoluteTo(t) : this;
                    }
                    o.version = "1.19.11";
                    var a = o.prototype, s = Object.prototype.hasOwnProperty;
                    function u(e) {
                        return e.replace(/([.*+?^=!:${}()|[\]\/\\])/g, "\\$1");
                    }
                    function c(e) {
                        return void 0 === e ? "Undefined" : String(Object.prototype.toString.call(e)).slice(8, -1);
                    }
                    function l(e) {
                        return "Array" === c(e);
                    }
                    function f(e, t) {
                        var r, n, i = {};
                        if ("RegExp" === c(t)) i = null;
                        else if (l(t)) for(r = 0, n = t.length; r < n; r++)i[t[r]] = !0;
                        else i[t] = !0;
                        for(r = 0, n = e.length; r < n; r++)(i && void 0 !== i[e[r]] || !i && t.test(e[r])) && (e.splice(r, 1), n--, r--);
                        return e;
                    }
                    function p(e, t) {
                        var r, n;
                        if (l(t)) {
                            for(r = 0, n = t.length; r < n; r++)if (!p(e, t[r])) return !1;
                            return !0;
                        }
                        var i = c(t);
                        for(r = 0, n = e.length; r < n; r++)if ("RegExp" === i) {
                            if ("string" == typeof e[r] && e[r].match(t)) return !0;
                        } else if (e[r] === t) return !0;
                        return !1;
                    }
                    function d(e, t) {
                        if (!l(e) || !l(t)) return !1;
                        if (e.length !== t.length) return !1;
                        e.sort(), t.sort();
                        for(var r = 0, n = e.length; r < n; r++)if (e[r] !== t[r]) return !1;
                        return !0;
                    }
                    function h(e) {
                        return e.replace(/^\/+|\/+$/g, "");
                    }
                    function v(e) {
                        return escape(e);
                    }
                    function m(e) {
                        return encodeURIComponent(e).replace(/[!'()*]/g, v).replace(/\*/g, "%2A");
                    }
                    o._parts = function() {
                        return {
                            protocol: null,
                            username: null,
                            password: null,
                            hostname: null,
                            urn: null,
                            port: null,
                            path: null,
                            query: null,
                            fragment: null,
                            preventInvalidHostname: o.preventInvalidHostname,
                            duplicateQueryParameters: o.duplicateQueryParameters,
                            escapeQuerySpace: o.escapeQuerySpace
                        };
                    }, o.preventInvalidHostname = !1, o.duplicateQueryParameters = !1, o.escapeQuerySpace = !0, o.protocol_expression = /^[a-z][a-z0-9.+-]*$/i, o.idn_expression = /[^a-z0-9\._-]/i, o.punycode_expression = /(xn--)/i, o.ip4_expression = /^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/, o.ip6_expression = /^\s*((([0-9A-Fa-f]{1,4}:){7}([0-9A-Fa-f]{1,4}|:))|(([0-9A-Fa-f]{1,4}:){6}(:[0-9A-Fa-f]{1,4}|((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){5}(((:[0-9A-Fa-f]{1,4}){1,2})|:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){4}(((:[0-9A-Fa-f]{1,4}){1,3})|((:[0-9A-Fa-f]{1,4})?:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){3}(((:[0-9A-Fa-f]{1,4}){1,4})|((:[0-9A-Fa-f]{1,4}){0,2}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){2}(((:[0-9A-Fa-f]{1,4}){1,5})|((:[0-9A-Fa-f]{1,4}){0,3}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){1}(((:[0-9A-Fa-f]{1,4}){1,6})|((:[0-9A-Fa-f]{1,4}){0,4}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(:(((:[0-9A-Fa-f]{1,4}){1,7})|((:[0-9A-Fa-f]{1,4}){0,5}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(%.+)?\s*$/, o.find_uri_expression = /\b((?:[a-z][\w-]+:(?:\/{1,3}|[a-z0-9%])|www\d{0,3}[.]|[a-z0-9.\-]+[.][a-z]{2,4}\/)(?:[^\s()<>]+|\(([^\s()<>]+|(\([^\s()<>]+\)))*\))+(?:\(([^\s()<>]+|(\([^\s()<>]+\)))*\)|[^\s`!()\[\]{};:'".,<>?«»“”‘’]))/gi, o.findUri = {
                        start: /\b(?:([a-z][a-z0-9.+-]*:\/\/)|www\.)/gi,
                        end: /[\s\r\n]|$/,
                        trim: /[`!()\[\]{};:'".,<>?«»“”„‘’]+$/,
                        parens: /(\([^\)]*\)|\[[^\]]*\]|\{[^}]*\}|<[^>]*>)/g
                    }, o.leading_whitespace_expression = /^[\x00-\x20\u00a0\u1680\u2000-\u200a\u2028\u2029\u202f\u205f\u3000\ufeff]+/, o.ascii_tab_whitespace = /[\u0009\u000A\u000D]+/g, o.defaultPorts = {
                        http: "80",
                        https: "443",
                        ftp: "21",
                        gopher: "70",
                        ws: "80",
                        wss: "443"
                    }, o.hostProtocols = [
                        "http",
                        "https"
                    ], o.invalid_hostname_characters = /[^a-zA-Z0-9\.\-:_]/, o.domAttributes = {
                        a: "href",
                        blockquote: "cite",
                        link: "href",
                        base: "href",
                        script: "src",
                        form: "action",
                        img: "src",
                        area: "href",
                        iframe: "src",
                        embed: "src",
                        source: "src",
                        track: "src",
                        input: "src",
                        audio: "src",
                        video: "src"
                    }, o.getDomAttribute = function(e) {
                        if (e && e.nodeName) {
                            var t = e.nodeName.toLowerCase();
                            if ("input" !== t || "image" === e.type) return o.domAttributes[t];
                        }
                    }, o.encode = m, o.decode = decodeURIComponent, o.iso8859 = function() {
                        o.encode = escape, o.decode = unescape;
                    }, o.unicode = function() {
                        o.encode = m, o.decode = decodeURIComponent;
                    }, o.characters = {
                        pathname: {
                            encode: {
                                expression: /%(24|26|2B|2C|3B|3D|3A|40)/gi,
                                map: {
                                    "%24": "$",
                                    "%26": "&",
                                    "%2B": "+",
                                    "%2C": ",",
                                    "%3B": ";",
                                    "%3D": "=",
                                    "%3A": ":",
                                    "%40": "@"
                                }
                            },
                            decode: {
                                expression: /[\/\?#]/g,
                                map: {
                                    "/": "%2F",
                                    "?": "%3F",
                                    "#": "%23"
                                }
                            }
                        },
                        reserved: {
                            encode: {
                                expression: /%(21|23|24|26|27|28|29|2A|2B|2C|2F|3A|3B|3D|3F|40|5B|5D)/gi,
                                map: {
                                    "%3A": ":",
                                    "%2F": "/",
                                    "%3F": "?",
                                    "%23": "#",
                                    "%5B": "[",
                                    "%5D": "]",
                                    "%40": "@",
                                    "%21": "!",
                                    "%24": "$",
                                    "%26": "&",
                                    "%27": "'",
                                    "%28": "(",
                                    "%29": ")",
                                    "%2A": "*",
                                    "%2B": "+",
                                    "%2C": ",",
                                    "%3B": ";",
                                    "%3D": "="
                                }
                            }
                        },
                        urnpath: {
                            encode: {
                                expression: /%(21|24|27|28|29|2A|2B|2C|3B|3D|40)/gi,
                                map: {
                                    "%21": "!",
                                    "%24": "$",
                                    "%27": "'",
                                    "%28": "(",
                                    "%29": ")",
                                    "%2A": "*",
                                    "%2B": "+",
                                    "%2C": ",",
                                    "%3B": ";",
                                    "%3D": "=",
                                    "%40": "@"
                                }
                            },
                            decode: {
                                expression: /[\/\?#:]/g,
                                map: {
                                    "/": "%2F",
                                    "?": "%3F",
                                    "#": "%23",
                                    ":": "%3A"
                                }
                            }
                        }
                    }, o.encodeQuery = function(e, t) {
                        var r = o.encode(e + "");
                        return void 0 === t && (t = o.escapeQuerySpace), t ? r.replace(/%20/g, "+") : r;
                    }, o.decodeQuery = function(e, t) {
                        e += "", void 0 === t && (t = o.escapeQuerySpace);
                        try {
                            return o.decode(t ? e.replace(/\+/g, "%20") : e);
                        } catch (t) {
                            return e;
                        }
                    };
                    var y, g = {
                        encode: "encode",
                        decode: "decode"
                    }, E = function(e, t) {
                        return function(r) {
                            try {
                                return o[t](r + "").replace(o.characters[e][t].expression, function(r) {
                                    return o.characters[e][t].map[r];
                                });
                            } catch (e) {
                                return r;
                            }
                        };
                    };
                    for(y in g)o[y + "PathSegment"] = E("pathname", g[y]), o[y + "UrnPathSegment"] = E("urnpath", g[y]);
                    var b = function(e, t, r) {
                        return function(n) {
                            var i;
                            i = r ? function(e) {
                                return o[t](o[r](e));
                            } : o[t];
                            for(var a = (n + "").split(e), s = 0, u = a.length; s < u; s++)a[s] = i(a[s]);
                            return a.join(e);
                        };
                    };
                    function S(e) {
                        return function(t, r) {
                            return void 0 === t ? this._parts[e] || "" : (this._parts[e] = t || null, this.build(!r), this);
                        };
                    }
                    function _(e, t) {
                        return function(r, n) {
                            return void 0 === r ? this._parts[e] || "" : (null !== r && (r += "").charAt(0) === t && (r = r.substring(1)), this._parts[e] = r, this.build(!n), this);
                        };
                    }
                    o.decodePath = b("/", "decodePathSegment"), o.decodeUrnPath = b(":", "decodeUrnPathSegment"), o.recodePath = b("/", "encodePathSegment", "decode"), o.recodeUrnPath = b(":", "encodeUrnPathSegment", "decode"), o.encodeReserved = E("reserved", "encode"), o.parse = function(e, t) {
                        var r;
                        return t || (t = {
                            preventInvalidHostname: o.preventInvalidHostname
                        }), (r = (e = (e = e.replace(o.leading_whitespace_expression, "")).replace(o.ascii_tab_whitespace, "")).indexOf("#")) > -1 && (t.fragment = e.substring(r + 1) || null, e = e.substring(0, r)), (r = e.indexOf("?")) > -1 && (t.query = e.substring(r + 1) || null, e = e.substring(0, r)), "//" === (e = (e = e.replace(/^(https?|ftp|wss?)?:+[/\\]*/i, "$1://")).replace(/^[/\\]{2,}/i, "//")).substring(0, 2) ? (t.protocol = null, e = e.substring(2), e = o.parseAuthority(e, t)) : (r = e.indexOf(":")) > -1 && (t.protocol = e.substring(0, r) || null, t.protocol && !t.protocol.match(o.protocol_expression) ? t.protocol = void 0 : "//" === e.substring(r + 1, r + 3).replace(/\\/g, "/") ? (e = e.substring(r + 3), e = o.parseAuthority(e, t)) : (e = e.substring(r + 1), t.urn = !0)), t.path = e, t;
                    }, o.parseHost = function(e, t) {
                        e || (e = "");
                        var r, n, i = (e = e.replace(/\\/g, "/")).indexOf("/");
                        if (-1 === i && (i = e.length), "[" === e.charAt(0)) r = e.indexOf("]"), t.hostname = e.substring(1, r) || null, t.port = e.substring(r + 2, i) || null, "/" === t.port && (t.port = null);
                        else {
                            var a = e.indexOf(":"), s = e.indexOf("/"), u = e.indexOf(":", a + 1);
                            -1 !== u && (-1 === s || u < s) ? (t.hostname = e.substring(0, i) || null, t.port = null) : (n = e.substring(0, i).split(":"), t.hostname = n[0] || null, t.port = n[1] || null);
                        }
                        return t.hostname && "/" !== e.substring(i).charAt(0) && (i++, e = "/" + e), t.preventInvalidHostname && o.ensureValidHostname(t.hostname, t.protocol), t.port && o.ensureValidPort(t.port), e.substring(i) || "/";
                    }, o.parseAuthority = function(e, t) {
                        return e = o.parseUserinfo(e, t), o.parseHost(e, t);
                    }, o.parseUserinfo = function(e, t) {
                        var r = e;
                        -1 !== e.indexOf("\\") && (e = e.replace(/\\/g, "/"));
                        var n, i = e.indexOf("/"), a = e.lastIndexOf("@", i > -1 ? i : e.length - 1);
                        return a > -1 && (-1 === i || a < i) ? (n = e.substring(0, a).split(":"), t.username = n[0] ? o.decode(n[0]) : null, n.shift(), t.password = n[0] ? o.decode(n.join(":")) : null, e = r.substring(a + 1)) : (t.username = null, t.password = null), e;
                    }, o.parseQuery = function(e, t) {
                        if (!e) return {};
                        if (!(e = e.replace(/&+/g, "&").replace(/^\?*&*|&+$/g, ""))) return {};
                        for(var r, n, i, a = {}, u = e.split("&"), c = u.length, l = 0; l < c; l++)r = u[l].split("="), n = o.decodeQuery(r.shift(), t), i = r.length ? o.decodeQuery(r.join("="), t) : null, "__proto__" !== n && (s.call(a, n) ? ("string" != typeof a[n] && null !== a[n] || (a[n] = [
                            a[n]
                        ]), a[n].push(i)) : a[n] = i);
                        return a;
                    }, o.build = function(e) {
                        var t = "", r = !1;
                        return e.protocol && (t += e.protocol + ":"), e.urn || !t && !e.hostname || (t += "//", r = !0), t += o.buildAuthority(e) || "", "string" == typeof e.path && ("/" !== e.path.charAt(0) && r && (t += "/"), t += e.path), "string" == typeof e.query && e.query && (t += "?" + e.query), "string" == typeof e.fragment && e.fragment && (t += "#" + e.fragment), t;
                    }, o.buildHost = function(e) {
                        var t = "";
                        return e.hostname ? (o.ip6_expression.test(e.hostname) ? t += "[" + e.hostname + "]" : t += e.hostname, e.port && (t += ":" + e.port), t) : "";
                    }, o.buildAuthority = function(e) {
                        return o.buildUserinfo(e) + o.buildHost(e);
                    }, o.buildUserinfo = function(e) {
                        var t = "";
                        return e.username && (t += o.encode(e.username)), e.password && (t += ":" + o.encode(e.password)), t && (t += "@"), t;
                    }, o.buildQuery = function(e, t, r) {
                        var n, i, a, u, c = "";
                        for(i in e)if ("__proto__" !== i && s.call(e, i)) {
                            if (l(e[i])) for(n = {}, a = 0, u = e[i].length; a < u; a++)void 0 !== e[i][a] && void 0 === n[e[i][a] + ""] && (c += "&" + o.buildQueryParameter(i, e[i][a], r), !0 !== t && (n[e[i][a] + ""] = !0));
                            else void 0 !== e[i] && (c += "&" + o.buildQueryParameter(i, e[i], r));
                        }
                        return c.substring(1);
                    }, o.buildQueryParameter = function(e, t, r) {
                        return o.encodeQuery(e, r) + (null !== t ? "=" + o.encodeQuery(t, r) : "");
                    }, o.addQuery = function(e, t, r) {
                        if ("object" == typeof t) for(var n in t)s.call(t, n) && o.addQuery(e, n, t[n]);
                        else {
                            if ("string" != typeof t) throw new TypeError("URI.addQuery() accepts an object, string as the name parameter");
                            if (void 0 === e[t]) return void (e[t] = r);
                            "string" == typeof e[t] && (e[t] = [
                                e[t]
                            ]), l(r) || (r = [
                                r
                            ]), e[t] = (e[t] || []).concat(r);
                        }
                    }, o.setQuery = function(e, t, r) {
                        if ("object" == typeof t) for(var n in t)s.call(t, n) && o.setQuery(e, n, t[n]);
                        else {
                            if ("string" != typeof t) throw new TypeError("URI.setQuery() accepts an object, string as the name parameter");
                            e[t] = void 0 === r ? null : r;
                        }
                    }, o.removeQuery = function(e, t, r) {
                        var n, i, a;
                        if (l(t)) for(n = 0, i = t.length; n < i; n++)e[t[n]] = void 0;
                        else if ("RegExp" === c(t)) for(a in e)t.test(a) && (e[a] = void 0);
                        else if ("object" == typeof t) for(a in t)s.call(t, a) && o.removeQuery(e, a, t[a]);
                        else {
                            if ("string" != typeof t) throw new TypeError("URI.removeQuery() accepts an object, string, RegExp as the first parameter");
                            void 0 !== r ? "RegExp" === c(r) ? e[t] = !l(e[t]) && r.test(e[t]) ? void 0 : f(e[t], r) : e[t] !== String(r) || l(r) && 1 !== r.length ? l(e[t]) && (e[t] = f(e[t], r)) : e[t] = void 0 : e[t] = void 0;
                        }
                    }, o.hasQuery = function(e, t, r, n) {
                        switch(c(t)){
                            case "String":
                                break;
                            case "RegExp":
                                for(var i in e)if (s.call(e, i) && t.test(i) && (void 0 === r || o.hasQuery(e, i, r))) return !0;
                                return !1;
                            case "Object":
                                for(var a in t)if (s.call(t, a) && !o.hasQuery(e, a, t[a])) return !1;
                                return !0;
                            default:
                                throw new TypeError("URI.hasQuery() accepts a string, regular expression or object as the name parameter");
                        }
                        switch(c(r)){
                            case "Undefined":
                                return t in e;
                            case "Boolean":
                                return r === Boolean(l(e[t]) ? e[t].length : e[t]);
                            case "Function":
                                return !!r(e[t], t, e);
                            case "Array":
                                return !!l(e[t]) && (n ? p : d)(e[t], r);
                            case "RegExp":
                                return l(e[t]) ? !!n && p(e[t], r) : Boolean(e[t] && e[t].match(r));
                            case "Number":
                                r = String(r);
                            case "String":
                                return l(e[t]) ? !!n && p(e[t], r) : e[t] === r;
                            default:
                                throw new TypeError("URI.hasQuery() accepts undefined, boolean, string, number, RegExp, Function as the value parameter");
                        }
                    }, o.joinPaths = function() {
                        for(var e = [], t = [], r = 0, n = 0; n < arguments.length; n++){
                            var i = new o(arguments[n]);
                            e.push(i);
                            for(var a = i.segment(), s = 0; s < a.length; s++)"string" == typeof a[s] && t.push(a[s]), a[s] && r++;
                        }
                        if (!t.length || !r) return new o("");
                        var u = new o("").segment(t);
                        return "" !== e[0].path() && "/" !== e[0].path().slice(0, 1) || u.path("/" + u.path()), u.normalize();
                    }, o.commonPath = function(e, t) {
                        var r, n = Math.min(e.length, t.length);
                        for(r = 0; r < n; r++)if (e.charAt(r) !== t.charAt(r)) {
                            r--;
                            break;
                        }
                        return r < 1 ? e.charAt(0) === t.charAt(0) && "/" === e.charAt(0) ? "/" : "" : ("/" === e.charAt(r) && "/" === t.charAt(r) || (r = e.substring(0, r).lastIndexOf("/")), e.substring(0, r + 1));
                    }, o.withinString = function(e, t, r) {
                        r || (r = {});
                        var n = r.start || o.findUri.start, i = r.end || o.findUri.end, a = r.trim || o.findUri.trim, s = r.parens || o.findUri.parens, u = /[a-z0-9-]=["']?$/i;
                        for(n.lastIndex = 0;;){
                            var c = n.exec(e);
                            if (!c) break;
                            var l = c.index;
                            if (r.ignoreHtml) {
                                var f = e.slice(Math.max(l - 3, 0), l);
                                if (f && u.test(f)) continue;
                            }
                            for(var p = l + e.slice(l).search(i), d = e.slice(l, p), h = -1;;){
                                var v = s.exec(d);
                                if (!v) break;
                                h = Math.max(h, v.index + v[0].length);
                            }
                            if (!((d = h > -1 ? d.slice(0, h) + d.slice(h).replace(a, "") : d.replace(a, "")).length <= c[0].length || r.ignore && r.ignore.test(d))) {
                                var m = t(d, l, p = l + d.length, e);
                                void 0 !== m ? (m = String(m), e = e.slice(0, l) + m + e.slice(p), n.lastIndex = l + m.length) : n.lastIndex = p;
                            }
                        }
                        return n.lastIndex = 0, e;
                    }, o.ensureValidHostname = function(t, r) {
                        var n = !!t, i = !1;
                        if (!!r && (i = p(o.hostProtocols, r)), i && !n) throw new TypeError("Hostname cannot be empty, if protocol is " + r);
                        if (t && t.match(o.invalid_hostname_characters)) {
                            if (!e) throw new TypeError('Hostname "' + t + '" contains characters other than [A-Z0-9.-:_] and Punycode.js is not available');
                            if (e.toASCII(t).match(o.invalid_hostname_characters)) throw new TypeError('Hostname "' + t + '" contains characters other than [A-Z0-9.-:_]');
                        }
                    }, o.ensureValidPort = function(e) {
                        if (e) {
                            var t = Number(e);
                            if (!(/^[0-9]+$/.test(t) && t > 0 && t < 65536)) throw new TypeError('Port "' + e + '" is not a valid port');
                        }
                    }, o.noConflict = function(e) {
                        if (e) {
                            var t = {
                                URI: this.noConflict()
                            };
                            return n.URITemplate && "function" == typeof n.URITemplate.noConflict && (t.URITemplate = n.URITemplate.noConflict()), n.IPv6 && "function" == typeof n.IPv6.noConflict && (t.IPv6 = n.IPv6.noConflict()), n.SecondLevelDomains && "function" == typeof n.SecondLevelDomains.noConflict && (t.SecondLevelDomains = n.SecondLevelDomains.noConflict()), t;
                        }
                        return n.URI === this && (n.URI = i), this;
                    }, a.build = function(e) {
                        return !0 === e ? this._deferred_build = !0 : (void 0 === e || this._deferred_build) && (this._string = o.build(this._parts), this._deferred_build = !1), this;
                    }, a.clone = function() {
                        return new o(this);
                    }, a.valueOf = a.toString = function() {
                        return this.build(!1)._string;
                    }, a.protocol = S("protocol"), a.username = S("username"), a.password = S("password"), a.hostname = S("hostname"), a.port = S("port"), a.query = _("query", "?"), a.fragment = _("fragment", "#"), a.search = function(e, t) {
                        var r = this.query(e, t);
                        return "string" == typeof r && r.length ? "?" + r : r;
                    }, a.hash = function(e, t) {
                        var r = this.fragment(e, t);
                        return "string" == typeof r && r.length ? "#" + r : r;
                    }, a.pathname = function(e, t) {
                        if (void 0 === e || !0 === e) {
                            var r = this._parts.path || (this._parts.hostname ? "/" : "");
                            return e ? (this._parts.urn ? o.decodeUrnPath : o.decodePath)(r) : r;
                        }
                        return this._parts.path = this._parts.urn ? e ? o.recodeUrnPath(e) : "" : e ? o.recodePath(e) : "/", this.build(!t), this;
                    }, a.path = a.pathname, a.href = function(e, t) {
                        var r;
                        if (void 0 === e) return this.toString();
                        this._string = "", this._parts = o._parts();
                        var n = e instanceof o, i = "object" == typeof e && (e.hostname || e.path || e.pathname);
                        e.nodeName && (e = e[o.getDomAttribute(e)] || "", i = !1);
                        if (!n && i && void 0 !== e.pathname && (e = e.toString()), "string" == typeof e || e instanceof String) this._parts = o.parse(String(e), this._parts);
                        else {
                            if (!n && !i) throw new TypeError("invalid input");
                            var a = n ? e._parts : e;
                            for(r in a)"query" !== r && s.call(this._parts, r) && (this._parts[r] = a[r]);
                            a.query && this.query(a.query, !1);
                        }
                        return this.build(!t), this;
                    }, a.is = function(e) {
                        var t = !1, n = !1, i = !1, a = !1, s = !1, u = !1, c = !1, l = !this._parts.urn;
                        switch(this._parts.hostname && (l = !1, n = o.ip4_expression.test(this._parts.hostname), i = o.ip6_expression.test(this._parts.hostname), s = (a = !(t = n || i)) && r && r.has(this._parts.hostname), u = a && o.idn_expression.test(this._parts.hostname), c = a && o.punycode_expression.test(this._parts.hostname)), e.toLowerCase()){
                            case "relative":
                                return l;
                            case "absolute":
                                return !l;
                            case "domain":
                            case "name":
                                return a;
                            case "sld":
                                return s;
                            case "ip":
                                return t;
                            case "ip4":
                            case "ipv4":
                            case "inet4":
                                return n;
                            case "ip6":
                            case "ipv6":
                            case "inet6":
                                return i;
                            case "idn":
                                return u;
                            case "url":
                                return !this._parts.urn;
                            case "urn":
                                return !!this._parts.urn;
                            case "punycode":
                                return c;
                        }
                        return null;
                    };
                    var w = a.protocol, O = a.port, T = a.hostname;
                    a.protocol = function(e, t) {
                        if (e && !(e = e.replace(/:(\/\/)?$/, "")).match(o.protocol_expression)) throw new TypeError('Protocol "' + e + "\" contains characters other than [A-Z0-9.+-] or doesn't start with [A-Z]");
                        return w.call(this, e, t);
                    }, a.scheme = a.protocol, a.port = function(e, t) {
                        return this._parts.urn ? void 0 === e ? "" : this : (void 0 !== e && (0 === e && (e = null), e && (":" === (e += "").charAt(0) && (e = e.substring(1)), o.ensureValidPort(e))), O.call(this, e, t));
                    }, a.hostname = function(e, t) {
                        if (this._parts.urn) return void 0 === e ? "" : this;
                        if (void 0 !== e) {
                            var r = {
                                preventInvalidHostname: this._parts.preventInvalidHostname
                            };
                            if ("/" !== o.parseHost(e, r)) throw new TypeError('Hostname "' + e + '" contains characters other than [A-Z0-9.-]');
                            e = r.hostname, this._parts.preventInvalidHostname && o.ensureValidHostname(e, this._parts.protocol);
                        }
                        return T.call(this, e, t);
                    }, a.origin = function(e, t) {
                        if (this._parts.urn) return void 0 === e ? "" : this;
                        if (void 0 === e) {
                            var r = this.protocol();
                            return this.authority() ? (r ? r + "://" : "") + this.authority() : "";
                        }
                        var n = o(e);
                        return this.protocol(n.protocol()).authority(n.authority()).build(!t), this;
                    }, a.host = function(e, t) {
                        if (this._parts.urn) return void 0 === e ? "" : this;
                        if (void 0 === e) return this._parts.hostname ? o.buildHost(this._parts) : "";
                        if ("/" !== o.parseHost(e, this._parts)) throw new TypeError('Hostname "' + e + '" contains characters other than [A-Z0-9.-]');
                        return this.build(!t), this;
                    }, a.authority = function(e, t) {
                        if (this._parts.urn) return void 0 === e ? "" : this;
                        if (void 0 === e) return this._parts.hostname ? o.buildAuthority(this._parts) : "";
                        if ("/" !== o.parseAuthority(e, this._parts)) throw new TypeError('Hostname "' + e + '" contains characters other than [A-Z0-9.-]');
                        return this.build(!t), this;
                    }, a.userinfo = function(e, t) {
                        if (this._parts.urn) return void 0 === e ? "" : this;
                        if (void 0 === e) {
                            var r = o.buildUserinfo(this._parts);
                            return r ? r.substring(0, r.length - 1) : r;
                        }
                        return "@" !== e[e.length - 1] && (e += "@"), o.parseUserinfo(e, this._parts), this.build(!t), this;
                    }, a.resource = function(e, t) {
                        var r;
                        return void 0 === e ? this.path() + this.search() + this.hash() : (r = o.parse(e), this._parts.path = r.path, this._parts.query = r.query, this._parts.fragment = r.fragment, this.build(!t), this);
                    }, a.subdomain = function(e, t) {
                        if (this._parts.urn) return void 0 === e ? "" : this;
                        if (void 0 === e) {
                            if (!this._parts.hostname || this.is("IP")) return "";
                            var r = this._parts.hostname.length - this.domain().length - 1;
                            return this._parts.hostname.substring(0, r) || "";
                        }
                        var n = this._parts.hostname.length - this.domain().length, i = this._parts.hostname.substring(0, n), a = new RegExp("^" + u(i));
                        if (e && "." !== e.charAt(e.length - 1) && (e += "."), -1 !== e.indexOf(":")) throw new TypeError("Domains cannot contain colons");
                        return e && o.ensureValidHostname(e, this._parts.protocol), this._parts.hostname = this._parts.hostname.replace(a, e), this.build(!t), this;
                    }, a.domain = function(e, t) {
                        if (this._parts.urn) return void 0 === e ? "" : this;
                        if ("boolean" == typeof e && (t = e, e = void 0), void 0 === e) {
                            if (!this._parts.hostname || this.is("IP")) return "";
                            var r = this._parts.hostname.match(/\./g);
                            if (r && r.length < 2) return this._parts.hostname;
                            var n = this._parts.hostname.length - this.tld(t).length - 1;
                            return n = this._parts.hostname.lastIndexOf(".", n - 1) + 1, this._parts.hostname.substring(n) || "";
                        }
                        if (!e) throw new TypeError("cannot set domain empty");
                        if (-1 !== e.indexOf(":")) throw new TypeError("Domains cannot contain colons");
                        if (o.ensureValidHostname(e, this._parts.protocol), !this._parts.hostname || this.is("IP")) this._parts.hostname = e;
                        else {
                            var i = new RegExp(u(this.domain()) + "$");
                            this._parts.hostname = this._parts.hostname.replace(i, e);
                        }
                        return this.build(!t), this;
                    }, a.tld = function(e, t) {
                        if (this._parts.urn) return void 0 === e ? "" : this;
                        if ("boolean" == typeof e && (t = e, e = void 0), void 0 === e) {
                            if (!this._parts.hostname || this.is("IP")) return "";
                            var n = this._parts.hostname.lastIndexOf("."), i = this._parts.hostname.substring(n + 1);
                            return !0 !== t && r && r.list[i.toLowerCase()] && r.get(this._parts.hostname) || i;
                        }
                        var o;
                        if (!e) throw new TypeError("cannot set TLD empty");
                        if (e.match(/[^a-zA-Z0-9-]/)) {
                            if (!r || !r.is(e)) throw new TypeError('TLD "' + e + '" contains characters other than [A-Z0-9]');
                            o = new RegExp(u(this.tld()) + "$"), this._parts.hostname = this._parts.hostname.replace(o, e);
                        } else {
                            if (!this._parts.hostname || this.is("IP")) throw new ReferenceError("cannot set TLD on non-domain host");
                            o = new RegExp(u(this.tld()) + "$"), this._parts.hostname = this._parts.hostname.replace(o, e);
                        }
                        return this.build(!t), this;
                    }, a.directory = function(e, t) {
                        if (this._parts.urn) return void 0 === e ? "" : this;
                        if (void 0 === e || !0 === e) {
                            if (!this._parts.path && !this._parts.hostname) return "";
                            if ("/" === this._parts.path) return "/";
                            var r = this._parts.path.length - this.filename().length - 1, n = this._parts.path.substring(0, r) || (this._parts.hostname ? "/" : "");
                            return e ? o.decodePath(n) : n;
                        }
                        var i = this._parts.path.length - this.filename().length, a = this._parts.path.substring(0, i), s = new RegExp("^" + u(a));
                        return this.is("relative") || (e || (e = "/"), "/" !== e.charAt(0) && (e = "/" + e)), e && "/" !== e.charAt(e.length - 1) && (e += "/"), e = o.recodePath(e), this._parts.path = this._parts.path.replace(s, e), this.build(!t), this;
                    }, a.filename = function(e, t) {
                        if (this._parts.urn) return void 0 === e ? "" : this;
                        if ("string" != typeof e) {
                            if (!this._parts.path || "/" === this._parts.path) return "";
                            var r = this._parts.path.lastIndexOf("/"), n = this._parts.path.substring(r + 1);
                            return e ? o.decodePathSegment(n) : n;
                        }
                        var i = !1;
                        "/" === e.charAt(0) && (e = e.substring(1)), e.match(/\.?\//) && (i = !0);
                        var a = new RegExp(u(this.filename()) + "$");
                        return e = o.recodePath(e), this._parts.path = this._parts.path.replace(a, e), i ? this.normalizePath(t) : this.build(!t), this;
                    }, a.suffix = function(e, t) {
                        if (this._parts.urn) return void 0 === e ? "" : this;
                        if (void 0 === e || !0 === e) {
                            if (!this._parts.path || "/" === this._parts.path) return "";
                            var r, n, i = this.filename(), a = i.lastIndexOf(".");
                            return -1 === a ? "" : (r = i.substring(a + 1), n = /^[a-z0-9%]+$/i.test(r) ? r : "", e ? o.decodePathSegment(n) : n);
                        }
                        "." === e.charAt(0) && (e = e.substring(1));
                        var s, c = this.suffix();
                        if (c) s = e ? new RegExp(u(c) + "$") : new RegExp(u("." + c) + "$");
                        else {
                            if (!e) return this;
                            this._parts.path += "." + o.recodePath(e);
                        }
                        return s && (e = o.recodePath(e), this._parts.path = this._parts.path.replace(s, e)), this.build(!t), this;
                    }, a.segment = function(e, t, r) {
                        var n = this._parts.urn ? ":" : "/", i = this.path(), o = "/" === i.substring(0, 1), a = i.split(n);
                        if (void 0 !== e && "number" != typeof e && (r = t, t = e, e = void 0), void 0 !== e && "number" != typeof e) throw new Error('Bad segment "' + e + '", must be 0-based integer');
                        if (o && a.shift(), e < 0 && (e = Math.max(a.length + e, 0)), void 0 === t) return void 0 === e ? a : a[e];
                        if (null === e || void 0 === a[e]) {
                            if (l(t)) {
                                a = [];
                                for(var s = 0, u = t.length; s < u; s++)(t[s].length || a.length && a[a.length - 1].length) && (a.length && !a[a.length - 1].length && a.pop(), a.push(h(t[s])));
                            } else (t || "string" == typeof t) && (t = h(t), "" === a[a.length - 1] ? a[a.length - 1] = t : a.push(t));
                        } else t ? a[e] = h(t) : a.splice(e, 1);
                        return o && a.unshift(""), this.path(a.join(n), r);
                    }, a.segmentCoded = function(e, t, r) {
                        var n, i, a;
                        if ("number" != typeof e && (r = t, t = e, e = void 0), void 0 === t) {
                            if (l(n = this.segment(e, t, r))) for(i = 0, a = n.length; i < a; i++)n[i] = o.decode(n[i]);
                            else n = void 0 !== n ? o.decode(n) : void 0;
                            return n;
                        }
                        if (l(t)) for(i = 0, a = t.length; i < a; i++)t[i] = o.encode(t[i]);
                        else t = "string" == typeof t || t instanceof String ? o.encode(t) : t;
                        return this.segment(e, t, r);
                    };
                    var I = a.query;
                    return a.query = function(e, t) {
                        if (!0 === e) return o.parseQuery(this._parts.query, this._parts.escapeQuerySpace);
                        if ("function" == typeof e) {
                            var r = o.parseQuery(this._parts.query, this._parts.escapeQuerySpace), n = e.call(this, r);
                            return this._parts.query = o.buildQuery(n || r, this._parts.duplicateQueryParameters, this._parts.escapeQuerySpace), this.build(!t), this;
                        }
                        return void 0 !== e && "string" != typeof e ? (this._parts.query = o.buildQuery(e, this._parts.duplicateQueryParameters, this._parts.escapeQuerySpace), this.build(!t), this) : I.call(this, e, t);
                    }, a.setQuery = function(e, t, r) {
                        var n = o.parseQuery(this._parts.query, this._parts.escapeQuerySpace);
                        if ("string" == typeof e || e instanceof String) n[e] = void 0 !== t ? t : null;
                        else {
                            if ("object" != typeof e) throw new TypeError("URI.addQuery() accepts an object, string as the name parameter");
                            for(var i in e)s.call(e, i) && (n[i] = e[i]);
                        }
                        return this._parts.query = o.buildQuery(n, this._parts.duplicateQueryParameters, this._parts.escapeQuerySpace), "string" != typeof e && (r = t), this.build(!r), this;
                    }, a.addQuery = function(e, t, r) {
                        var n = o.parseQuery(this._parts.query, this._parts.escapeQuerySpace);
                        return o.addQuery(n, e, void 0 === t ? null : t), this._parts.query = o.buildQuery(n, this._parts.duplicateQueryParameters, this._parts.escapeQuerySpace), "string" != typeof e && (r = t), this.build(!r), this;
                    }, a.removeQuery = function(e, t, r) {
                        var n = o.parseQuery(this._parts.query, this._parts.escapeQuerySpace);
                        return o.removeQuery(n, e, t), this._parts.query = o.buildQuery(n, this._parts.duplicateQueryParameters, this._parts.escapeQuerySpace), "string" != typeof e && (r = t), this.build(!r), this;
                    }, a.hasQuery = function(e, t, r) {
                        var n = o.parseQuery(this._parts.query, this._parts.escapeQuerySpace);
                        return o.hasQuery(n, e, t, r);
                    }, a.setSearch = a.setQuery, a.addSearch = a.addQuery, a.removeSearch = a.removeQuery, a.hasSearch = a.hasQuery, a.normalize = function() {
                        return this._parts.urn ? this.normalizeProtocol(!1).normalizePath(!1).normalizeQuery(!1).normalizeFragment(!1).build() : this.normalizeProtocol(!1).normalizeHostname(!1).normalizePort(!1).normalizePath(!1).normalizeQuery(!1).normalizeFragment(!1).build();
                    }, a.normalizeProtocol = function(e) {
                        return "string" == typeof this._parts.protocol && (this._parts.protocol = this._parts.protocol.toLowerCase(), this.build(!e)), this;
                    }, a.normalizeHostname = function(r) {
                        return this._parts.hostname && (this.is("IDN") && e ? this._parts.hostname = e.toASCII(this._parts.hostname) : this.is("IPv6") && t && (this._parts.hostname = t.best(this._parts.hostname)), this._parts.hostname = this._parts.hostname.toLowerCase(), this.build(!r)), this;
                    }, a.normalizePort = function(e) {
                        return "string" == typeof this._parts.protocol && this._parts.port === o.defaultPorts[this._parts.protocol] && (this._parts.port = null, this.build(!e)), this;
                    }, a.normalizePath = function(e) {
                        var t, r = this._parts.path;
                        if (!r) return this;
                        if (this._parts.urn) return this._parts.path = o.recodeUrnPath(this._parts.path), this.build(!e), this;
                        if ("/" === this._parts.path) return this;
                        var n, i, a = "";
                        for("/" !== (r = o.recodePath(r)).charAt(0) && (t = !0, r = "/" + r), "/.." !== r.slice(-3) && "/." !== r.slice(-2) || (r += "/"), r = r.replace(/(\/(\.\/)+)|(\/\.$)/g, "/").replace(/\/{2,}/g, "/"), t && (a = r.substring(1).match(/^(\.\.\/)+/) || "") && (a = a[0]); -1 !== (n = r.search(/\/\.\.(\/|$)/));)0 !== n ? (-1 === (i = r.substring(0, n).lastIndexOf("/")) && (i = n), r = r.substring(0, i) + r.substring(n + 3)) : r = r.substring(3);
                        return t && this.is("relative") && (r = a + r.substring(1)), this._parts.path = r, this.build(!e), this;
                    }, a.normalizePathname = a.normalizePath, a.normalizeQuery = function(e) {
                        return "string" == typeof this._parts.query && (this._parts.query.length ? this.query(o.parseQuery(this._parts.query, this._parts.escapeQuerySpace)) : this._parts.query = null, this.build(!e)), this;
                    }, a.normalizeFragment = function(e) {
                        return this._parts.fragment || (this._parts.fragment = null, this.build(!e)), this;
                    }, a.normalizeSearch = a.normalizeQuery, a.normalizeHash = a.normalizeFragment, a.iso8859 = function() {
                        var e = o.encode, t = o.decode;
                        o.encode = escape, o.decode = decodeURIComponent;
                        try {
                            this.normalize();
                        } finally{
                            o.encode = e, o.decode = t;
                        }
                        return this;
                    }, a.unicode = function() {
                        var e = o.encode, t = o.decode;
                        o.encode = m, o.decode = unescape;
                        try {
                            this.normalize();
                        } finally{
                            o.encode = e, o.decode = t;
                        }
                        return this;
                    }, a.readable = function() {
                        var t = this.clone();
                        t.username("").password("").normalize();
                        var r = "";
                        if (t._parts.protocol && (r += t._parts.protocol + "://"), t._parts.hostname && (t.is("punycode") && e ? (r += e.toUnicode(t._parts.hostname), t._parts.port && (r += ":" + t._parts.port)) : r += t.host()), t._parts.hostname && t._parts.path && "/" !== t._parts.path.charAt(0) && (r += "/"), r += t.path(!0), t._parts.query) {
                            for(var n = "", i = 0, a = t._parts.query.split("&"), s = a.length; i < s; i++){
                                var u = (a[i] || "").split("=");
                                n += "&" + o.decodeQuery(u[0], this._parts.escapeQuerySpace).replace(/&/g, "%26"), void 0 !== u[1] && (n += "=" + o.decodeQuery(u[1], this._parts.escapeQuerySpace).replace(/&/g, "%26"));
                            }
                            r += "?" + n.substring(1);
                        }
                        return r += o.decodeQuery(t.hash(), !0);
                    }, a.absoluteTo = function(e) {
                        var t, r, n, i = this.clone(), a = [
                            "protocol",
                            "username",
                            "password",
                            "hostname",
                            "port"
                        ];
                        if (this._parts.urn) throw new Error("URNs do not have any generally defined hierarchical components");
                        if (e instanceof o || (e = new o(e)), i._parts.protocol) return i;
                        if (i._parts.protocol = e._parts.protocol, this._parts.hostname) return i;
                        for(r = 0; n = a[r]; r++)i._parts[n] = e._parts[n];
                        return i._parts.path ? (".." === i._parts.path.substring(-2) && (i._parts.path += "/"), "/" !== i.path().charAt(0) && (t = (t = e.directory()) || (0 === e.path().indexOf("/") ? "/" : ""), i._parts.path = (t ? t + "/" : "") + i._parts.path, i.normalizePath())) : (i._parts.path = e._parts.path, i._parts.query || (i._parts.query = e._parts.query)), i.build(), i;
                    }, a.relativeTo = function(e) {
                        var t, r, n, i, a, s = this.clone().normalize();
                        if (s._parts.urn) throw new Error("URNs do not have any generally defined hierarchical components");
                        if (e = new o(e).normalize(), t = s._parts, r = e._parts, i = s.path(), a = e.path(), "/" !== i.charAt(0)) throw new Error("URI is already relative");
                        if ("/" !== a.charAt(0)) throw new Error("Cannot calculate a URI relative to another relative URI");
                        if (t.protocol === r.protocol && (t.protocol = null), t.username !== r.username || t.password !== r.password) return s.build();
                        if (null !== t.protocol || null !== t.username || null !== t.password) return s.build();
                        if (t.hostname !== r.hostname || t.port !== r.port) return s.build();
                        if (t.hostname = null, t.port = null, i === a) return t.path = "", s.build();
                        if (!(n = o.commonPath(i, a))) return s.build();
                        var u = r.path.substring(n.length).replace(/[^\/]*$/, "").replace(/.*?\//g, "../");
                        return t.path = u + t.path.substring(n.length) || "./", s.build();
                    }, a.equals = function(e) {
                        var t, r, n, i, a, u = this.clone(), c = new o(e), f = {};
                        if (u.normalize(), c.normalize(), u.toString() === c.toString()) return !0;
                        if (n = u.query(), i = c.query(), u.query(""), c.query(""), u.toString() !== c.toString()) return !1;
                        if (n.length !== i.length) return !1;
                        for(a in t = o.parseQuery(n, this._parts.escapeQuerySpace), r = o.parseQuery(i, this._parts.escapeQuerySpace), t)if (s.call(t, a)) {
                            if (l(t[a])) {
                                if (!d(t[a], r[a])) return !1;
                            } else if (t[a] !== r[a]) return !1;
                            f[a] = !0;
                        }
                        for(a in r)if (s.call(r, a) && !f[a]) return !1;
                        return !0;
                    }, a.preventInvalidHostname = function(e) {
                        return this._parts.preventInvalidHostname = !!e, this;
                    }, a.duplicateQueryParameters = function(e) {
                        return this._parts.duplicateQueryParameters = !!e, this;
                    }, a.escapeQuerySpace = function(e) {
                        return this._parts.escapeQuerySpace = !!e, this;
                    }, o;
                });
            },
            4344: function(e, t, r) {
                var n;
                e = r.nmd(e), function(i) {
                    var o = "object" == typeof r.g && r.g;
                    var a, s = 2147483647, u = 36, c = 1, l = 26, f = 38, p = 700, d = 72, h = 128, v = "-", m = /^xn--/, y = /[^\x20-\x7E]/, g = /[\x2E\u3002\uFF0E\uFF61]/g, E = {
                        overflow: "Overflow: input needs wider integers to process",
                        "not-basic": "Illegal input >= 0x80 (not a basic code point)",
                        "invalid-input": "Invalid input"
                    }, b = u - c, S = Math.floor, _ = String.fromCharCode;
                    function w(e) {
                        throw new RangeError(E[e]);
                    }
                    function O(e, t) {
                        for(var r = e.length, n = []; r--;)n[r] = t(e[r]);
                        return n;
                    }
                    function T(e, t) {
                        var r = e.split("@"), n = "";
                        return r.length > 1 && (n = r[0] + "@", e = r[1]), n + O((e = e.replace(g, ".")).split("."), t).join(".");
                    }
                    function I(e) {
                        for(var t, r, n = [], i = 0, o = e.length; i < o;)(t = e.charCodeAt(i++)) >= 55296 && t <= 56319 && i < o ? 56320 == (64512 & (r = e.charCodeAt(i++))) ? n.push(((1023 & t) << 10) + (1023 & r) + 65536) : (n.push(t), i--) : n.push(t);
                        return n;
                    }
                    function R(e) {
                        return O(e, function(e) {
                            var t = "";
                            return e > 65535 && (t += _((e -= 65536) >>> 10 & 1023 | 55296), e = 56320 | 1023 & e), t += _(e);
                        }).join("");
                    }
                    function x(e, t) {
                        return e + 22 + 75 * (e < 26) - ((0 != t) << 5);
                    }
                    function A(e, t, r) {
                        var n = 0;
                        for(e = r ? S(e / p) : e >> 1, e += S(e / t); e > b * l >> 1; n += u)e = S(e / b);
                        return S(n + (b + 1) * e / (e + f));
                    }
                    function N(e) {
                        var t, r, n, i, o, a, f, p, m, y, g, E = [], b = e.length, _ = 0, O = h, T = d;
                        for((r = e.lastIndexOf(v)) < 0 && (r = 0), n = 0; n < r; ++n)e.charCodeAt(n) >= 128 && w("not-basic"), E.push(e.charCodeAt(n));
                        for(i = r > 0 ? r + 1 : 0; i < b;){
                            for(o = _, a = 1, f = u; i >= b && w("invalid-input"), ((p = (g = e.charCodeAt(i++)) - 48 < 10 ? g - 22 : g - 65 < 26 ? g - 65 : g - 97 < 26 ? g - 97 : u) >= u || p > S((s - _) / a)) && w("overflow"), _ += p * a, !(p < (m = f <= T ? c : f >= T + l ? l : f - T)); f += u)a > S(s / (y = u - m)) && w("overflow"), a *= y;
                            T = A(_ - o, t = E.length + 1, 0 == o), S(_ / t) > s - O && w("overflow"), O += S(_ / t), _ %= t, E.splice(_++, 0, O);
                        }
                        return R(E);
                    }
                    function C(e) {
                        var t, r, n, i, o, a, f, p, m, y, g, E, b, O, T, R = [];
                        for(E = (e = I(e)).length, t = h, r = 0, o = d, a = 0; a < E; ++a)(g = e[a]) < 128 && R.push(_(g));
                        for(n = i = R.length, i && R.push(v); n < E;){
                            for(f = s, a = 0; a < E; ++a)(g = e[a]) >= t && g < f && (f = g);
                            for(f - t > S((s - r) / (b = n + 1)) && w("overflow"), r += (f - t) * b, t = f, a = 0; a < E; ++a)if ((g = e[a]) < t && ++r > s && w("overflow"), g == t) {
                                for(p = r, m = u; !(p < (y = m <= o ? c : m >= o + l ? l : m - o)); m += u)R.push(_(x(y + (T = p - y) % (O = u - y), 0))), p = S(T / O);
                                R.push(_(x(p, 0))), o = A(r, b, n == i), r = 0, ++n;
                            }
                            ++r, ++t;
                        }
                        return R.join("");
                    }
                    a = {
                        version: "1.3.2",
                        ucs2: {
                            decode: I,
                            encode: R
                        },
                        decode: N,
                        encode: C,
                        toASCII: function(e) {
                            return T(e, function(e) {
                                return y.test(e) ? "xn--" + C(e) : e;
                            });
                        },
                        toUnicode: function(e) {
                            return T(e, function(e) {
                                return m.test(e) ? N(e.slice(4).toLowerCase()) : e;
                            });
                        }
                    }, void 0 === (n = (function() {
                        return a;
                    }).call(t, r, t, e)) || (e.exports = n);
                }();
            },
            8566: (e, t, r)=>{
                "use strict";
                r.r(t), r.d(t, {
                    DOMException: ()=>S,
                    Headers: ()=>l,
                    Request: ()=>y,
                    Response: ()=>E,
                    fetch: ()=>_
                });
                var n = "undefined" != typeof globalThis && globalThis || "undefined" != typeof self && self || void 0 !== r.g && r.g || {}, i = {
                    searchParams: "URLSearchParams" in n,
                    iterable: "Symbol" in n && "iterator" in Symbol,
                    blob: "FileReader" in n && "Blob" in n && function() {
                        try {
                            return new Blob, !0;
                        } catch (e) {
                            return !1;
                        }
                    }(),
                    formData: "FormData" in n,
                    arrayBuffer: "ArrayBuffer" in n
                };
                if (i.arrayBuffer) var o = [
                    "[object Int8Array]",
                    "[object Uint8Array]",
                    "[object Uint8ClampedArray]",
                    "[object Int16Array]",
                    "[object Uint16Array]",
                    "[object Int32Array]",
                    "[object Uint32Array]",
                    "[object Float32Array]",
                    "[object Float64Array]"
                ], a = ArrayBuffer.isView || function(e) {
                    return e && o.indexOf(Object.prototype.toString.call(e)) > -1;
                };
                function s(e) {
                    if ("string" != typeof e && (e = String(e)), /[^a-z0-9\-#$%&'*+.^_`|~!]/i.test(e) || "" === e) throw new TypeError('Invalid character in header field name: "' + e + '"');
                    return e.toLowerCase();
                }
                function u(e) {
                    return "string" != typeof e && (e = String(e)), e;
                }
                function c(e) {
                    var t = {
                        next: function() {
                            var t = e.shift();
                            return {
                                done: void 0 === t,
                                value: t
                            };
                        }
                    };
                    return i.iterable && (t[Symbol.iterator] = function() {
                        return t;
                    }), t;
                }
                function l(e) {
                    this.map = {}, e instanceof l ? e.forEach(function(e, t) {
                        this.append(t, e);
                    }, this) : Array.isArray(e) ? e.forEach(function(e) {
                        if (2 != e.length) throw new TypeError("Headers constructor: expected name/value pair to be length 2, found" + e.length);
                        this.append(e[0], e[1]);
                    }, this) : e && Object.getOwnPropertyNames(e).forEach(function(t) {
                        this.append(t, e[t]);
                    }, this);
                }
                function f(e) {
                    if (!e._noBody) return e.bodyUsed ? Promise.reject(new TypeError("Already read")) : void (e.bodyUsed = !0);
                }
                function p(e) {
                    return new Promise(function(t, r) {
                        e.onload = function() {
                            t(e.result);
                        }, e.onerror = function() {
                            r(e.error);
                        };
                    });
                }
                function d(e) {
                    var t = new FileReader, r = p(t);
                    return t.readAsArrayBuffer(e), r;
                }
                function h(e) {
                    if (e.slice) return e.slice(0);
                    var t = new Uint8Array(e.byteLength);
                    return t.set(new Uint8Array(e)), t.buffer;
                }
                function v() {
                    return this.bodyUsed = !1, this._initBody = function(e) {
                        var t;
                        this.bodyUsed = this.bodyUsed, this._bodyInit = e, e ? "string" == typeof e ? this._bodyText = e : i.blob && Blob.prototype.isPrototypeOf(e) ? this._bodyBlob = e : i.formData && FormData.prototype.isPrototypeOf(e) ? this._bodyFormData = e : i.searchParams && URLSearchParams.prototype.isPrototypeOf(e) ? this._bodyText = e.toString() : i.arrayBuffer && i.blob && (t = e) && DataView.prototype.isPrototypeOf(t) ? (this._bodyArrayBuffer = h(e.buffer), this._bodyInit = new Blob([
                            this._bodyArrayBuffer
                        ])) : i.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(e) || a(e)) ? this._bodyArrayBuffer = h(e) : this._bodyText = e = Object.prototype.toString.call(e) : (this._noBody = !0, this._bodyText = ""), this.headers.get("content-type") || ("string" == typeof e ? this.headers.set("content-type", "text/plain;charset=UTF-8") : this._bodyBlob && this._bodyBlob.type ? this.headers.set("content-type", this._bodyBlob.type) : i.searchParams && URLSearchParams.prototype.isPrototypeOf(e) && this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8"));
                    }, i.blob && (this.blob = function() {
                        var e = f(this);
                        if (e) return e;
                        if (this._bodyBlob) return Promise.resolve(this._bodyBlob);
                        if (this._bodyArrayBuffer) return Promise.resolve(new Blob([
                            this._bodyArrayBuffer
                        ]));
                        if (this._bodyFormData) throw new Error("could not read FormData body as blob");
                        return Promise.resolve(new Blob([
                            this._bodyText
                        ]));
                    }), this.arrayBuffer = function() {
                        if (this._bodyArrayBuffer) {
                            var e = f(this);
                            return e || (ArrayBuffer.isView(this._bodyArrayBuffer) ? Promise.resolve(this._bodyArrayBuffer.buffer.slice(this._bodyArrayBuffer.byteOffset, this._bodyArrayBuffer.byteOffset + this._bodyArrayBuffer.byteLength)) : Promise.resolve(this._bodyArrayBuffer));
                        }
                        if (i.blob) return this.blob().then(d);
                        throw new Error("could not read as ArrayBuffer");
                    }, this.text = function() {
                        var e, t, r, n, i = f(this);
                        if (i) return i;
                        if (this._bodyBlob) return e = this._bodyBlob, t = new FileReader, r = p(t), n = /charset=([A-Za-z0-9_-]+)/.exec(e.type), t.readAsText(e, n ? n[1] : "utf-8"), r;
                        if (this._bodyArrayBuffer) return Promise.resolve(function(e) {
                            for(var t = new Uint8Array(e), r = new Array(t.length), n = 0; n < t.length; n++)r[n] = String.fromCharCode(t[n]);
                            return r.join("");
                        }(this._bodyArrayBuffer));
                        if (this._bodyFormData) throw new Error("could not read FormData body as text");
                        return Promise.resolve(this._bodyText);
                    }, i.formData && (this.formData = function() {
                        return this.text().then(g);
                    }), this.json = function() {
                        return this.text().then(JSON.parse);
                    }, this;
                }
                l.prototype.append = function(e, t) {
                    e = s(e), t = u(t);
                    var r = this.map[e];
                    this.map[e] = r ? r + ", " + t : t;
                }, l.prototype.delete = function(e) {
                    delete this.map[s(e)];
                }, l.prototype.get = function(e) {
                    return e = s(e), this.has(e) ? this.map[e] : null;
                }, l.prototype.has = function(e) {
                    return this.map.hasOwnProperty(s(e));
                }, l.prototype.set = function(e, t) {
                    this.map[s(e)] = u(t);
                }, l.prototype.forEach = function(e, t) {
                    for(var r in this.map)this.map.hasOwnProperty(r) && e.call(t, this.map[r], r, this);
                }, l.prototype.keys = function() {
                    var e = [];
                    return this.forEach(function(t, r) {
                        e.push(r);
                    }), c(e);
                }, l.prototype.values = function() {
                    var e = [];
                    return this.forEach(function(t) {
                        e.push(t);
                    }), c(e);
                }, l.prototype.entries = function() {
                    var e = [];
                    return this.forEach(function(t, r) {
                        e.push([
                            r,
                            t
                        ]);
                    }), c(e);
                }, i.iterable && (l.prototype[Symbol.iterator] = l.prototype.entries);
                var m = [
                    "CONNECT",
                    "DELETE",
                    "GET",
                    "HEAD",
                    "OPTIONS",
                    "PATCH",
                    "POST",
                    "PUT",
                    "TRACE"
                ];
                function y(e, t) {
                    if (!(this instanceof y)) throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
                    var r, i, o = (t = t || {}).body;
                    if (e instanceof y) {
                        if (e.bodyUsed) throw new TypeError("Already read");
                        this.url = e.url, this.credentials = e.credentials, t.headers || (this.headers = new l(e.headers)), this.method = e.method, this.mode = e.mode, this.signal = e.signal, o || null == e._bodyInit || (o = e._bodyInit, e.bodyUsed = !0);
                    } else this.url = String(e);
                    if (this.credentials = t.credentials || this.credentials || "same-origin", !t.headers && this.headers || (this.headers = new l(t.headers)), this.method = (i = (r = t.method || this.method || "GET").toUpperCase(), m.indexOf(i) > -1 ? i : r), this.mode = t.mode || this.mode || null, this.signal = t.signal || this.signal || function() {
                        if ("AbortController" in n) return (new AbortController).signal;
                    }(), this.referrer = null, ("GET" === this.method || "HEAD" === this.method) && o) throw new TypeError("Body not allowed for GET or HEAD requests");
                    if (this._initBody(o), !("GET" !== this.method && "HEAD" !== this.method || "no-store" !== t.cache && "no-cache" !== t.cache)) {
                        var a = /([?&])_=[^&]*/;
                        if (a.test(this.url)) this.url = this.url.replace(a, "$1_=" + (new Date).getTime());
                        else this.url += (/\?/.test(this.url) ? "&" : "?") + "_=" + (new Date).getTime();
                    }
                }
                function g(e) {
                    var t = new FormData;
                    return e.trim().split("&").forEach(function(e) {
                        if (e) {
                            var r = e.split("="), n = r.shift().replace(/\+/g, " "), i = r.join("=").replace(/\+/g, " ");
                            t.append(decodeURIComponent(n), decodeURIComponent(i));
                        }
                    }), t;
                }
                function E(e, t) {
                    if (!(this instanceof E)) throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
                    if (t || (t = {}), this.type = "default", this.status = void 0 === t.status ? 200 : t.status, this.status < 200 || this.status > 599) throw new RangeError("Failed to construct 'Response': The status provided (0) is outside the range [200, 599].");
                    this.ok = this.status >= 200 && this.status < 300, this.statusText = void 0 === t.statusText ? "" : "" + t.statusText, this.headers = new l(t.headers), this.url = t.url || "", this._initBody(e);
                }
                y.prototype.clone = function() {
                    return new y(this, {
                        body: this._bodyInit
                    });
                }, v.call(y.prototype), v.call(E.prototype), E.prototype.clone = function() {
                    return new E(this._bodyInit, {
                        status: this.status,
                        statusText: this.statusText,
                        headers: new l(this.headers),
                        url: this.url
                    });
                }, E.error = function() {
                    var e = new E(null, {
                        status: 200,
                        statusText: ""
                    });
                    return e.ok = !1, e.status = 0, e.type = "error", e;
                };
                var b = [
                    301,
                    302,
                    303,
                    307,
                    308
                ];
                E.redirect = function(e, t) {
                    if (-1 === b.indexOf(t)) throw new RangeError("Invalid status code");
                    return new E(null, {
                        status: t,
                        headers: {
                            location: e
                        }
                    });
                };
                var S = n.DOMException;
                try {
                    new S;
                } catch (e) {
                    (S = function(e, t) {
                        this.message = e, this.name = t;
                        var r = Error(e);
                        this.stack = r.stack;
                    }).prototype = Object.create(Error.prototype), S.prototype.constructor = S;
                }
                function _(e, t) {
                    return new Promise(function(r, o) {
                        var a = new y(e, t);
                        if (a.signal && a.signal.aborted) return o(new S("Aborted", "AbortError"));
                        var c = new XMLHttpRequest;
                        function f() {
                            c.abort();
                        }
                        if (c.onload = function() {
                            var e, t, n = {
                                statusText: c.statusText,
                                headers: (e = c.getAllResponseHeaders() || "", t = new l, e.replace(/\r?\n[\t ]+/g, " ").split("\r").map(function(e) {
                                    return 0 === e.indexOf("\n") ? e.substr(1, e.length) : e;
                                }).forEach(function(e) {
                                    var r = e.split(":"), n = r.shift().trim();
                                    if (n) {
                                        var i = r.join(":").trim();
                                        try {
                                            t.append(n, i);
                                        } catch (e) {
                                            console.warn("Response " + e.message);
                                        }
                                    }
                                }), t)
                            };
                            n.status = 0 === a.url.indexOf("file://") && (c.status < 200 || c.status > 599) ? 200 : c.status, n.url = "responseURL" in c ? c.responseURL : n.headers.get("X-Request-URL");
                            var i = "response" in c ? c.response : c.responseText;
                            setTimeout(function() {
                                r(new E(i, n));
                            }, 0);
                        }, c.onerror = function() {
                            setTimeout(function() {
                                o(new TypeError("Network request failed"));
                            }, 0);
                        }, c.ontimeout = function() {
                            setTimeout(function() {
                                o(new TypeError("Network request timed out"));
                            }, 0);
                        }, c.onabort = function() {
                            setTimeout(function() {
                                o(new S("Aborted", "AbortError"));
                            }, 0);
                        }, c.open(a.method, function(e) {
                            try {
                                return "" === e && n.location.href ? n.location.href : e;
                            } catch (t) {
                                return e;
                            }
                        }(a.url), !0), "include" === a.credentials ? c.withCredentials = !0 : "omit" === a.credentials && (c.withCredentials = !1), "responseType" in c && (i.blob ? c.responseType = "blob" : i.arrayBuffer && (c.responseType = "arraybuffer")), t && "object" == typeof t.headers && !(t.headers instanceof l || n.Headers && t.headers instanceof n.Headers)) {
                            var p = [];
                            Object.getOwnPropertyNames(t.headers).forEach(function(e) {
                                p.push(s(e)), c.setRequestHeader(e, u(t.headers[e]));
                            }), a.headers.forEach(function(e, t) {
                                -1 === p.indexOf(t) && c.setRequestHeader(t, e);
                            });
                        } else a.headers.forEach(function(e, t) {
                            c.setRequestHeader(t, e);
                        });
                        a.signal && (a.signal.addEventListener("abort", f), c.onreadystatechange = function() {
                            4 === c.readyState && a.signal.removeEventListener("abort", f);
                        }), c.send(void 0 === a._bodyInit ? null : a._bodyInit);
                    });
                }
                _.polyfill = !0, n.fetch || (n.fetch = _, n.Headers = l, n.Request = y, n.Response = E);
            },
            674: (e, t, r)=>{
                "use strict";
                r.d(t, {
                    Z: ()=>i
                });
                var n = r(8666);
                const i = r.n(n)();
            },
            8666: (e, t, r)=>{
                e.exports = r(7603).Observable;
            },
            7603: (e, t)=>{
                "use strict";
                function r(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }
                function n(e, t) {
                    for(var r = 0; r < t.length; r++){
                        var n = t[r];
                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
                    }
                }
                function i(e, t, r) {
                    return t && n(e.prototype, t), r && n(e, r), e;
                }
                t.Observable = void 0;
                var o = function() {
                    return "function" == typeof Symbol;
                }, a = function(e) {
                    return o() && Boolean(Symbol[e]);
                }, s = function(e) {
                    return a(e) ? Symbol[e] : "@@" + e;
                };
                o() && !a("observable") && (Symbol.observable = Symbol("observable"));
                var u = s("iterator"), c = s("observable"), l = s("species");
                function f(e, t) {
                    var r = e[t];
                    if (null != r) {
                        if ("function" != typeof r) throw new TypeError(r + " is not a function");
                        return r;
                    }
                }
                function p(e) {
                    var t = e.constructor;
                    return void 0 !== t && null === (t = t[l]) && (t = void 0), void 0 !== t ? t : _;
                }
                function d(e) {
                    return e instanceof _;
                }
                function h(e) {
                    h.log ? h.log(e) : setTimeout(function() {
                        throw e;
                    });
                }
                function v(e) {
                    Promise.resolve().then(function() {
                        try {
                            e();
                        } catch (e) {
                            h(e);
                        }
                    });
                }
                function m(e) {
                    var t = e._cleanup;
                    if (void 0 !== t && (e._cleanup = void 0, t)) try {
                        if ("function" == typeof t) t();
                        else {
                            var r = f(t, "unsubscribe");
                            r && r.call(t);
                        }
                    } catch (e) {
                        h(e);
                    }
                }
                function y(e) {
                    e._observer = void 0, e._queue = void 0, e._state = "closed";
                }
                function g(e, t, r) {
                    e._state = "running";
                    var n = e._observer;
                    try {
                        var i = f(n, t);
                        switch(t){
                            case "next":
                                i && i.call(n, r);
                                break;
                            case "error":
                                if (y(e), !i) throw r;
                                i.call(n, r);
                                break;
                            case "complete":
                                y(e), i && i.call(n);
                        }
                    } catch (e) {
                        h(e);
                    }
                    "closed" === e._state ? m(e) : "running" === e._state && (e._state = "ready");
                }
                function E(e, t, r) {
                    if ("closed" !== e._state) {
                        if ("buffering" !== e._state) return "ready" !== e._state ? (e._state = "buffering", e._queue = [
                            {
                                type: t,
                                value: r
                            }
                        ], void v(function() {
                            return function(e) {
                                var t = e._queue;
                                if (t) {
                                    e._queue = void 0, e._state = "ready";
                                    for(var r = 0; r < t.length && (g(e, t[r].type, t[r].value), "closed" !== e._state); ++r);
                                }
                            }(e);
                        })) : void g(e, t, r);
                        e._queue.push({
                            type: t,
                            value: r
                        });
                    }
                }
                var b = function() {
                    function e(t, n) {
                        r(this, e), this._cleanup = void 0, this._observer = t, this._queue = void 0, this._state = "initializing";
                        var i = new S(this);
                        try {
                            this._cleanup = n.call(void 0, i);
                        } catch (e) {
                            i.error(e);
                        }
                        "initializing" === this._state && (this._state = "ready");
                    }
                    return i(e, [
                        {
                            key: "unsubscribe",
                            value: function() {
                                "closed" !== this._state && (y(this), m(this));
                            }
                        },
                        {
                            key: "closed",
                            get: function() {
                                return "closed" === this._state;
                            }
                        }
                    ]), e;
                }(), S = function() {
                    function e(t) {
                        r(this, e), this._subscription = t;
                    }
                    return i(e, [
                        {
                            key: "next",
                            value: function(e) {
                                E(this._subscription, "next", e);
                            }
                        },
                        {
                            key: "error",
                            value: function(e) {
                                E(this._subscription, "error", e);
                            }
                        },
                        {
                            key: "complete",
                            value: function() {
                                E(this._subscription, "complete");
                            }
                        },
                        {
                            key: "closed",
                            get: function() {
                                return "closed" === this._subscription._state;
                            }
                        }
                    ]), e;
                }(), _ = function() {
                    function e(t) {
                        if (r(this, e), !(this instanceof e)) throw new TypeError("Observable cannot be called as a function");
                        if ("function" != typeof t) throw new TypeError("Observable initializer must be a function");
                        this._subscriber = t;
                    }
                    return i(e, [
                        {
                            key: "subscribe",
                            value: function(e) {
                                return "object" == typeof e && null !== e || (e = {
                                    next: e,
                                    error: arguments[1],
                                    complete: arguments[2]
                                }), new b(e, this._subscriber);
                            }
                        },
                        {
                            key: "forEach",
                            value: function(e) {
                                var t = this;
                                return new Promise(function(r, n) {
                                    if ("function" == typeof e) var i = t.subscribe({
                                        next: function(t) {
                                            try {
                                                e(t, o);
                                            } catch (e) {
                                                n(e), i.unsubscribe();
                                            }
                                        },
                                        error: n,
                                        complete: r
                                    });
                                    else n(new TypeError(e + " is not a function"));
                                    function o() {
                                        i.unsubscribe(), r();
                                    }
                                });
                            }
                        },
                        {
                            key: "map",
                            value: function(e) {
                                var t = this;
                                if ("function" != typeof e) throw new TypeError(e + " is not a function");
                                return new (p(this))(function(r) {
                                    return t.subscribe({
                                        next: function(t) {
                                            try {
                                                t = e(t);
                                            } catch (e) {
                                                return r.error(e);
                                            }
                                            r.next(t);
                                        },
                                        error: function(e) {
                                            r.error(e);
                                        },
                                        complete: function() {
                                            r.complete();
                                        }
                                    });
                                });
                            }
                        },
                        {
                            key: "filter",
                            value: function(e) {
                                var t = this;
                                if ("function" != typeof e) throw new TypeError(e + " is not a function");
                                return new (p(this))(function(r) {
                                    return t.subscribe({
                                        next: function(t) {
                                            try {
                                                if (!e(t)) return;
                                            } catch (e) {
                                                return r.error(e);
                                            }
                                            r.next(t);
                                        },
                                        error: function(e) {
                                            r.error(e);
                                        },
                                        complete: function() {
                                            r.complete();
                                        }
                                    });
                                });
                            }
                        },
                        {
                            key: "reduce",
                            value: function(e) {
                                var t = this;
                                if ("function" != typeof e) throw new TypeError(e + " is not a function");
                                var r = p(this), n = arguments.length > 1, i = !1, o = arguments[1];
                                return new r(function(r) {
                                    return t.subscribe({
                                        next: function(t) {
                                            var a = !i;
                                            if (i = !0, !a || n) try {
                                                o = e(o, t);
                                            } catch (e) {
                                                return r.error(e);
                                            }
                                            else o = t;
                                        },
                                        error: function(e) {
                                            r.error(e);
                                        },
                                        complete: function() {
                                            if (!i && !n) return r.error(new TypeError("Cannot reduce an empty sequence"));
                                            r.next(o), r.complete();
                                        }
                                    });
                                });
                            }
                        },
                        {
                            key: "concat",
                            value: function() {
                                for(var e = this, t = arguments.length, r = new Array(t), n = 0; n < t; n++)r[n] = arguments[n];
                                var i = p(this);
                                return new i(function(t) {
                                    var n, o = 0;
                                    return function e(a) {
                                        n = a.subscribe({
                                            next: function(e) {
                                                t.next(e);
                                            },
                                            error: function(e) {
                                                t.error(e);
                                            },
                                            complete: function() {
                                                o === r.length ? (n = void 0, t.complete()) : e(i.from(r[o++]));
                                            }
                                        });
                                    }(e), function() {
                                        n && (n.unsubscribe(), n = void 0);
                                    };
                                });
                            }
                        },
                        {
                            key: "flatMap",
                            value: function(e) {
                                var t = this;
                                if ("function" != typeof e) throw new TypeError(e + " is not a function");
                                var r = p(this);
                                return new r(function(n) {
                                    var i = [], o = t.subscribe({
                                        next: function(t) {
                                            if (e) try {
                                                t = e(t);
                                            } catch (e) {
                                                return n.error(e);
                                            }
                                            var o = r.from(t).subscribe({
                                                next: function(e) {
                                                    n.next(e);
                                                },
                                                error: function(e) {
                                                    n.error(e);
                                                },
                                                complete: function() {
                                                    var e = i.indexOf(o);
                                                    e >= 0 && i.splice(e, 1), a();
                                                }
                                            });
                                            i.push(o);
                                        },
                                        error: function(e) {
                                            n.error(e);
                                        },
                                        complete: function() {
                                            a();
                                        }
                                    });
                                    function a() {
                                        o.closed && 0 === i.length && n.complete();
                                    }
                                    return function() {
                                        i.forEach(function(e) {
                                            return e.unsubscribe();
                                        }), o.unsubscribe();
                                    };
                                });
                            }
                        },
                        {
                            key: c,
                            value: function() {
                                return this;
                            }
                        }
                    ], [
                        {
                            key: "from",
                            value: function(t) {
                                var r = "function" == typeof this ? this : e;
                                if (null == t) throw new TypeError(t + " is not an object");
                                var n = f(t, c);
                                if (n) {
                                    var i = n.call(t);
                                    if (Object(i) !== i) throw new TypeError(i + " is not an object");
                                    return d(i) && i.constructor === r ? i : new r(function(e) {
                                        return i.subscribe(e);
                                    });
                                }
                                if (a("iterator") && (n = f(t, u))) return new r(function(e) {
                                    v(function() {
                                        if (!e.closed) {
                                            var r = !0, i = !1, o = void 0;
                                            try {
                                                for(var a, s = n.call(t)[Symbol.iterator](); !(r = (a = s.next()).done); r = !0){
                                                    if (e.next(a.value), e.closed) return;
                                                }
                                            } catch (e) {
                                                i = !0, o = e;
                                            } finally{
                                                try {
                                                    r || null == s.return || s.return();
                                                } finally{
                                                    if (i) throw o;
                                                }
                                            }
                                            e.complete();
                                        }
                                    });
                                });
                                if (Array.isArray(t)) return new r(function(e) {
                                    v(function() {
                                        if (!e.closed) {
                                            for(var r = 0; r < t.length; ++r)if (e.next(t[r]), e.closed) return;
                                            e.complete();
                                        }
                                    });
                                });
                                throw new TypeError(t + " is not observable");
                            }
                        },
                        {
                            key: "of",
                            value: function() {
                                for(var t = arguments.length, r = new Array(t), n = 0; n < t; n++)r[n] = arguments[n];
                                return new ("function" == typeof this ? this : e)(function(e) {
                                    v(function() {
                                        if (!e.closed) {
                                            for(var t = 0; t < r.length; ++t)if (e.next(r[t]), e.closed) return;
                                            e.complete();
                                        }
                                    });
                                });
                            }
                        },
                        {
                            key: l,
                            get: function() {
                                return this;
                            }
                        }
                    ]), e;
                }();
                t.Observable = _, o() && Object.defineProperty(_, Symbol("extensions"), {
                    value: {
                        symbol: c,
                        hostReportError: h
                    },
                    configurable: !0
                });
            },
            1982: (e, t, r)=>{
                e.exports = r(4998);
            },
            515: (e, t, r)=>{
                e.exports = r(9844);
            },
            1806: (e, t, r)=>{
                e.exports = r(3773);
            },
            415: (e, t, r)=>{
                e.exports = r(5705);
            },
            1183: (e, t, r)=>{
                e.exports = r(6376);
            },
            8006: (e, t, r)=>{
                e.exports = r(4297);
            },
            5710: (e, t, r)=>{
                e.exports = r(1165);
            },
            3393: (e, t, r)=>{
                e.exports = r(5397);
            },
            8756: (e, t, r)=>{
                e.exports = r(7500);
            },
            7879: (e, t, r)=>{
                e.exports = r(7582);
            },
            9534: (e)=>{
                e.exports = function(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    };
                }, e.exports.__esModule = !0, e.exports.default = e.exports;
            },
            7062: (e, t, r)=>{
                "use strict";
                r(6128);
                var n = r(9407);
                e.exports = n("Array", "includes");
            },
            3335: (e, t, r)=>{
                "use strict";
                r(4984);
                var n = r(9407);
                e.exports = n("Array", "indexOf");
            },
            5247: (e, t, r)=>{
                "use strict";
                r(4269);
                var n = r(9407);
                e.exports = n("Array", "reduce");
            },
            8630: (e, t, r)=>{
                "use strict";
                r(2302);
                var n = r(4388);
                e.exports = n.Date.now;
            },
            6225: (e, t, r)=>{
                "use strict";
                var n = r(2242), i = r(7487), o = String.prototype;
                e.exports = function(e) {
                    var t = e.endsWith;
                    return "string" == typeof e || e === o || n(o, e) && t === o.endsWith ? i : t;
                };
            },
            931: (e, t, r)=>{
                "use strict";
                var n = r(2242), i = r(7062), o = r(4858), a = Array.prototype, s = String.prototype;
                e.exports = function(e) {
                    var t = e.includes;
                    return e === a || n(a, e) && t === a.includes ? i : "string" == typeof e || e === s || n(s, e) && t === s.includes ? o : t;
                };
            },
            7888: (e, t, r)=>{
                "use strict";
                var n = r(2242), i = r(3335), o = Array.prototype;
                e.exports = function(e) {
                    var t = e.indexOf;
                    return e === o || n(o, e) && t === o.indexOf ? i : t;
                };
            },
            6329: (e, t, r)=>{
                "use strict";
                var n = r(2242), i = r(5247), o = Array.prototype;
                e.exports = function(e) {
                    var t = e.reduce;
                    return e === o || n(o, e) && t === o.reduce ? i : t;
                };
            },
            2461: (e, t, r)=>{
                "use strict";
                r(7189), r(727), r(1400), r(1732), r(9823);
                var n = r(4388);
                e.exports = n.Map;
            },
            296: (e, t, r)=>{
                "use strict";
                r(9614);
                var n = r(4388).Object, i = e.exports = function(e, t, r) {
                    return n.defineProperty(e, t, r);
                };
                n.defineProperty.sham && (i.sham = !0);
            },
            8628: (e, t, r)=>{
                "use strict";
                r(8331);
                var n = r(4388).Object, i = e.exports = function(e, t) {
                    return n.getOwnPropertyDescriptor(e, t);
                };
                n.getOwnPropertyDescriptor.sham && (i.sham = !0);
            },
            9057: (e, t, r)=>{
                "use strict";
                r(1935), r(7189), r(1732), r(7971), r(261), r(6766), r(5412), r(9363), r(9823);
                var n = r(4388);
                e.exports = n.Promise;
            },
            7487: (e, t, r)=>{
                "use strict";
                r(1381);
                var n = r(9407);
                e.exports = n("String", "endsWith");
            },
            4858: (e, t, r)=>{
                "use strict";
                r(1021);
                var n = r(9407);
                e.exports = n("String", "includes");
            },
            1170: (e, t, r)=>{
                "use strict";
                r(7189), r(1732), r(9284);
                var n = r(4388);
                e.exports = n.WeakMap;
            },
            6735: (e, t, r)=>{
                "use strict";
                var n = r(342), i = r(9665), o = TypeError;
                e.exports = function(e) {
                    if (n(e)) return e;
                    throw new o(i(e) + " is not a function");
                };
            },
            1298: (e, t, r)=>{
                "use strict";
                var n = r(3878), i = r(9665), o = TypeError;
                e.exports = function(e) {
                    if (n(e)) return e;
                    throw new o(i(e) + " is not a constructor");
                };
            },
            6689: (e, t, r)=>{
                "use strict";
                var n = r(500), i = String, o = TypeError;
                e.exports = function(e) {
                    if (n(e)) return e;
                    throw new o("Can't set " + i(e) + " as a prototype");
                };
            },
            9747: (e)=>{
                "use strict";
                e.exports = function() {};
            },
            6406: (e, t, r)=>{
                "use strict";
                var n = r(2242), i = TypeError;
                e.exports = function(e, t) {
                    if (n(t, e)) return e;
                    throw new i("Incorrect invocation");
                };
            },
            7934: (e, t, r)=>{
                "use strict";
                var n = r(2660), i = String, o = TypeError;
                e.exports = function(e) {
                    if (n(e)) return e;
                    throw new o(i(e) + " is not an object");
                };
            },
            5872: (e, t, r)=>{
                "use strict";
                var n = r(7909);
                e.exports = n(function() {
                    if ("function" == typeof ArrayBuffer) {
                        var e = new ArrayBuffer(8);
                        Object.isExtensible(e) && Object.defineProperty(e, "a", {
                            value: 8
                        });
                    }
                });
            },
            4029: (e, t, r)=>{
                "use strict";
                var n = r(4036), i = r(3928), o = r(1159), a = function(e) {
                    return function(t, r, a) {
                        var s, u = n(t), c = o(u), l = i(a, c);
                        if (e && r != r) {
                            for(; c > l;)if ((s = u[l++]) != s) return !0;
                        } else for(; c > l; l++)if ((e || l in u) && u[l] === r) return e || l || 0;
                        return !e && -1;
                    };
                };
                e.exports = {
                    includes: a(!0),
                    indexOf: a(!1)
                };
            },
            1389: (e, t, r)=>{
                "use strict";
                var n = r(1492), i = r(6021), o = r(1958), a = r(9449), s = r(1159), u = r(5552), c = i([].push), l = function(e) {
                    var t = 1 === e, r = 2 === e, i = 3 === e, l = 4 === e, f = 6 === e, p = 7 === e, d = 5 === e || f;
                    return function(h, v, m, y) {
                        for(var g, E, b = a(h), S = o(b), _ = s(S), w = n(v, m), O = 0, T = y || u, I = t ? T(h, _) : r || p ? T(h, 0) : void 0; _ > O; O++)if ((d || O in S) && (E = w(g = S[O], O, b), e)) {
                            if (t) I[O] = E;
                            else if (E) switch(e){
                                case 3:
                                    return !0;
                                case 5:
                                    return g;
                                case 6:
                                    return O;
                                case 2:
                                    c(I, g);
                            }
                            else switch(e){
                                case 4:
                                    return !1;
                                case 7:
                                    c(I, g);
                            }
                        }
                        return f ? -1 : i || l ? l : I;
                    };
                };
                e.exports = {
                    forEach: l(0),
                    map: l(1),
                    filter: l(2),
                    some: l(3),
                    every: l(4),
                    find: l(5),
                    findIndex: l(6),
                    filterReject: l(7)
                };
            },
            3888: (e, t, r)=>{
                "use strict";
                var n = r(7909);
                e.exports = function(e, t) {
                    var r = [][e];
                    return !!r && n(function() {
                        r.call(null, t || function() {
                            return 1;
                        }, 1);
                    });
                };
            },
            213: (e, t, r)=>{
                "use strict";
                var n = r(6735), i = r(9449), o = r(1958), a = r(1159), s = TypeError, u = function(e) {
                    return function(t, r, u, c) {
                        var l = i(t), f = o(l), p = a(l);
                        n(r);
                        var d = e ? p - 1 : 0, h = e ? -1 : 1;
                        if (u < 2) for(;;){
                            if (d in f) {
                                c = f[d], d += h;
                                break;
                            }
                            if (d += h, e ? d < 0 : p <= d) throw new s("Reduce of empty array with no initial value");
                        }
                        for(; e ? d >= 0 : p > d; d += h)d in f && (c = r(c, f[d], d, l));
                        return c;
                    };
                };
                e.exports = {
                    left: u(!1),
                    right: u(!0)
                };
            },
            2529: (e, t, r)=>{
                "use strict";
                var n = r(6021);
                e.exports = n([].slice);
            },
            4182: (e, t, r)=>{
                "use strict";
                var n = r(7170), i = r(3878), o = r(2660), a = r(8701)("species"), s = Array;
                e.exports = function(e) {
                    var t;
                    return n(e) && (i(t = e.constructor) && (t === s || n(t.prototype)) || o(t) && null === (t = t[a])) && (t = void 0), void 0 === t ? s : t;
                };
            },
            5552: (e, t, r)=>{
                "use strict";
                var n = r(4182);
                e.exports = function(e, t) {
                    return new (n(e))(0 === t ? 0 : t);
                };
            },
            2886: (e)=>{
                "use strict";
                e.exports = function(e, t) {
                    return 1 === t ? function(t, r) {
                        return t[e](r);
                    } : function(t, r, n) {
                        return t[e](r, n);
                    };
                };
            },
            4712: (e, t, r)=>{
                "use strict";
                var n = r(8701)("iterator"), i = !1;
                try {
                    var o = 0, a = {
                        next: function() {
                            return {
                                done: !!o++
                            };
                        },
                        return: function() {
                            i = !0;
                        }
                    };
                    a[n] = function() {
                        return this;
                    }, Array.from(a, function() {
                        throw 2;
                    });
                } catch (e) {}
                e.exports = function(e, t) {
                    try {
                        if (!t && !i) return !1;
                    } catch (e) {
                        return !1;
                    }
                    var r = !1;
                    try {
                        var o = {};
                        o[n] = function() {
                            return {
                                next: function() {
                                    return {
                                        done: r = !0
                                    };
                                }
                            };
                        }, e(o);
                    } catch (e) {}
                    return r;
                };
            },
            4847: (e, t, r)=>{
                "use strict";
                var n = r(6021), i = n({}.toString), o = n("".slice);
                e.exports = function(e) {
                    return o(i(e), 8, -1);
                };
            },
            6220: (e, t, r)=>{
                "use strict";
                var n = r(3895), i = r(342), o = r(4847), a = r(8701)("toStringTag"), s = Object, u = "Arguments" === o(function() {
                    return arguments;
                }());
                e.exports = n ? o : function(e) {
                    var t, r, n;
                    return void 0 === e ? "Undefined" : null === e ? "Null" : "string" == typeof (r = function(e, t) {
                        try {
                            return e[t];
                        } catch (e) {}
                    }(t = s(e), a)) ? r : u ? o(t) : "Object" === (n = o(t)) && i(t.callee) ? "Arguments" : n;
                };
            },
            329: (e, t, r)=>{
                "use strict";
                var n = r(4136), i = r(4843), o = r(9102), a = r(1492), s = r(6406), u = r(2237), c = r(3762), l = r(3259), f = r(8893), p = r(6331), d = r(4451), h = r(1854).fastKey, v = r(8354), m = v.set, y = v.getterFor;
                e.exports = {
                    getConstructor: function(e, t, r, l) {
                        var f = e(function(e, i) {
                            s(e, p), m(e, {
                                type: t,
                                index: n(null),
                                first: void 0,
                                last: void 0,
                                size: 0
                            }), d || (e.size = 0), u(i) || c(i, e[l], {
                                that: e,
                                AS_ENTRIES: r
                            });
                        }), p = f.prototype, v = y(t), g = function(e, t, r) {
                            var n, i, o = v(e), a = E(e, t);
                            return a ? a.value = r : (o.last = a = {
                                index: i = h(t, !0),
                                key: t,
                                value: r,
                                previous: n = o.last,
                                next: void 0,
                                removed: !1
                            }, o.first || (o.first = a), n && (n.next = a), d ? o.size++ : e.size++, "F" !== i && (o.index[i] = a)), e;
                        }, E = function(e, t) {
                            var r, n = v(e), i = h(t);
                            if ("F" !== i) return n.index[i];
                            for(r = n.first; r; r = r.next)if (r.key === t) return r;
                        };
                        return o(p, {
                            clear: function() {
                                for(var e = v(this), t = e.first; t;)t.removed = !0, t.previous && (t.previous = t.previous.next = void 0), t = t.next;
                                e.first = e.last = void 0, e.index = n(null), d ? e.size = 0 : this.size = 0;
                            },
                            delete: function(e) {
                                var t = this, r = v(t), n = E(t, e);
                                if (n) {
                                    var i = n.next, o = n.previous;
                                    delete r.index[n.index], n.removed = !0, o && (o.next = i), i && (i.previous = o), r.first === n && (r.first = i), r.last === n && (r.last = o), d ? r.size-- : t.size--;
                                }
                                return !!n;
                            },
                            forEach: function(e) {
                                for(var t, r = v(this), n = a(e, arguments.length > 1 ? arguments[1] : void 0); t = t ? t.next : r.first;)for(n(t.value, t.key, this); t && t.removed;)t = t.previous;
                            },
                            has: function(e) {
                                return !!E(this, e);
                            }
                        }), o(p, r ? {
                            get: function(e) {
                                var t = E(this, e);
                                return t && t.value;
                            },
                            set: function(e, t) {
                                return g(this, 0 === e ? 0 : e, t);
                            }
                        } : {
                            add: function(e) {
                                return g(this, e = 0 === e ? 0 : e, e);
                            }
                        }), d && i(p, "size", {
                            configurable: !0,
                            get: function() {
                                return v(this).size;
                            }
                        }), f;
                    },
                    setStrong: function(e, t, r) {
                        var n = t + " Iterator", i = y(t), o = y(n);
                        l(e, t, function(e, t) {
                            m(this, {
                                type: n,
                                target: e,
                                state: i(e),
                                kind: t,
                                last: void 0
                            });
                        }, function() {
                            for(var e = o(this), t = e.kind, r = e.last; r && r.removed;)r = r.previous;
                            return e.target && (e.last = r = r ? r.next : e.state.first) ? f("keys" === t ? r.key : "values" === t ? r.value : [
                                r.key,
                                r.value
                            ], !1) : (e.target = void 0, f(void 0, !0));
                        }, r ? "entries" : "values", !r, !0), p(t);
                    }
                };
            },
            943: (e, t, r)=>{
                "use strict";
                var n = r(6021), i = r(9102), o = r(1854).getWeakData, a = r(6406), s = r(7934), u = r(2237), c = r(2660), l = r(3762), f = r(1389), p = r(9489), d = r(8354), h = d.set, v = d.getterFor, m = f.find, y = f.findIndex, g = n([].splice), E = 0, b = function(e) {
                    return e.frozen || (e.frozen = new S);
                }, S = function() {
                    this.entries = [];
                }, _ = function(e, t) {
                    return m(e.entries, function(e) {
                        return e[0] === t;
                    });
                };
                S.prototype = {
                    get: function(e) {
                        var t = _(this, e);
                        if (t) return t[1];
                    },
                    has: function(e) {
                        return !!_(this, e);
                    },
                    set: function(e, t) {
                        var r = _(this, e);
                        r ? r[1] = t : this.entries.push([
                            e,
                            t
                        ]);
                    },
                    delete: function(e) {
                        var t = y(this.entries, function(t) {
                            return t[0] === e;
                        });
                        return ~t && g(this.entries, t, 1), !!~t;
                    }
                }, e.exports = {
                    getConstructor: function(e, t, r, n) {
                        var f = e(function(e, i) {
                            a(e, d), h(e, {
                                type: t,
                                id: E++,
                                frozen: void 0
                            }), u(i) || l(i, e[n], {
                                that: e,
                                AS_ENTRIES: r
                            });
                        }), d = f.prototype, m = v(t), y = function(e, t, r) {
                            var n = m(e), i = o(s(t), !0);
                            return !0 === i ? b(n).set(t, r) : i[n.id] = r, e;
                        };
                        return i(d, {
                            delete: function(e) {
                                var t = m(this);
                                if (!c(e)) return !1;
                                var r = o(e);
                                return !0 === r ? b(t).delete(e) : r && p(r, t.id) && delete r[t.id];
                            },
                            has: function(e) {
                                var t = m(this);
                                if (!c(e)) return !1;
                                var r = o(e);
                                return !0 === r ? b(t).has(e) : r && p(r, t.id);
                            }
                        }), i(d, r ? {
                            get: function(e) {
                                var t = m(this);
                                if (c(e)) {
                                    var r = o(e);
                                    return !0 === r ? b(t).get(e) : r ? r[t.id] : void 0;
                                }
                            },
                            set: function(e, t) {
                                return y(this, e, t);
                            }
                        } : {
                            add: function(e) {
                                return y(this, e, !0);
                            }
                        }), f;
                    }
                };
            },
            1577: (e, t, r)=>{
                "use strict";
                var n = r(434), i = r(5620), o = r(1854), a = r(7909), s = r(6847), u = r(3762), c = r(6406), l = r(342), f = r(2660), p = r(2237), d = r(6752), h = r(1032).f, v = r(1389).forEach, m = r(4451), y = r(8354), g = y.set, E = y.getterFor;
                e.exports = function(e, t, r) {
                    var y, b = -1 !== e.indexOf("Map"), S = -1 !== e.indexOf("Weak"), _ = b ? "set" : "add", w = i[e], O = w && w.prototype, T = {};
                    if (m && l(w) && (S || O.forEach && !a(function() {
                        (new w).entries().next();
                    }))) {
                        var I = (y = t(function(t, r) {
                            g(c(t, I), {
                                type: e,
                                collection: new w
                            }), p(r) || u(r, t[_], {
                                that: t,
                                AS_ENTRIES: b
                            });
                        })).prototype, R = E(e);
                        v([
                            "add",
                            "clear",
                            "delete",
                            "forEach",
                            "get",
                            "has",
                            "set",
                            "keys",
                            "values",
                            "entries"
                        ], function(e) {
                            var t = "add" === e || "set" === e;
                            !(e in O) || S && "clear" === e || s(I, e, function(r, n) {
                                var i = R(this).collection;
                                if (!t && S && !f(r)) return "get" === e && void 0;
                                var o = i[e](0 === r ? 0 : r, n);
                                return t ? this : o;
                            });
                        }), S || h(I, "size", {
                            configurable: !0,
                            get: function() {
                                return R(this).collection.size;
                            }
                        });
                    } else y = r.getConstructor(t, e, b, _), o.enable();
                    return d(y, e, !1, !0), T[e] = y, n({
                        global: !0,
                        forced: !0
                    }, T), S || r.setStrong(y, e, b), y;
                };
            },
            6965: (e, t, r)=>{
                "use strict";
                var n = r(9489), i = r(3419), o = r(8428), a = r(1032);
                e.exports = function(e, t, r) {
                    for(var s = i(t), u = a.f, c = o.f, l = 0; l < s.length; l++){
                        var f = s[l];
                        n(e, f) || r && n(r, f) || u(e, f, c(t, f));
                    }
                };
            },
            2541: (e, t, r)=>{
                "use strict";
                var n = r(8701)("match");
                e.exports = function(e) {
                    var t = /./;
                    try {
                        "/./"[e](t);
                    } catch (r) {
                        try {
                            return t[n] = !1, "/./"[e](t);
                        } catch (e) {}
                    }
                    return !1;
                };
            },
            380: (e, t, r)=>{
                "use strict";
                var n = r(7909);
                e.exports = !n(function() {
                    function e() {}
                    return e.prototype.constructor = null, Object.getPrototypeOf(new e) !== e.prototype;
                });
            },
            8893: (e)=>{
                "use strict";
                e.exports = function(e, t) {
                    return {
                        value: e,
                        done: t
                    };
                };
            },
            6847: (e, t, r)=>{
                "use strict";
                var n = r(4451), i = r(1032), o = r(618);
                e.exports = n ? function(e, t, r) {
                    return i.f(e, t, o(1, r));
                } : function(e, t, r) {
                    return e[t] = r, e;
                };
            },
            618: (e)=>{
                "use strict";
                e.exports = function(e, t) {
                    return {
                        enumerable: !(1 & e),
                        configurable: !(2 & e),
                        writable: !(4 & e),
                        value: t
                    };
                };
            },
            4843: (e, t, r)=>{
                "use strict";
                var n = r(1032);
                e.exports = function(e, t, r) {
                    return n.f(e, t, r);
                };
            },
            4423: (e, t, r)=>{
                "use strict";
                var n = r(6847);
                e.exports = function(e, t, r, i) {
                    return i && i.enumerable ? e[t] = r : n(e, t, r), e;
                };
            },
            9102: (e, t, r)=>{
                "use strict";
                var n = r(4423);
                e.exports = function(e, t, r) {
                    for(var i in t)r && r.unsafe && e[i] ? e[i] = t[i] : n(e, i, t[i], r);
                    return e;
                };
            },
            1395: (e, t, r)=>{
                "use strict";
                var n = r(5620), i = Object.defineProperty;
                e.exports = function(e, t) {
                    try {
                        i(n, e, {
                            value: t,
                            configurable: !0,
                            writable: !0
                        });
                    } catch (r) {
                        n[e] = t;
                    }
                    return t;
                };
            },
            4451: (e, t, r)=>{
                "use strict";
                var n = r(7909);
                e.exports = !n(function() {
                    return 7 !== Object.defineProperty({}, 1, {
                        get: function() {
                            return 7;
                        }
                    })[1];
                });
            },
            5338: (e, t, r)=>{
                "use strict";
                var n = r(5620), i = r(2660), o = n.document, a = i(o) && i(o.createElement);
                e.exports = function(e) {
                    return a ? o.createElement(e) : {};
                };
            },
            1753: (e)=>{
                "use strict";
                e.exports = {
                    CSSRuleList: 0,
                    CSSStyleDeclaration: 0,
                    CSSValueList: 0,
                    ClientRectList: 0,
                    DOMRectList: 0,
                    DOMStringList: 0,
                    DOMTokenList: 1,
                    DataTransferItemList: 0,
                    FileList: 0,
                    HTMLAllCollection: 0,
                    HTMLCollection: 0,
                    HTMLFormElement: 0,
                    HTMLSelectElement: 0,
                    MediaList: 0,
                    MimeTypeArray: 0,
                    NamedNodeMap: 0,
                    NodeList: 1,
                    PaintRequestList: 0,
                    Plugin: 0,
                    PluginArray: 0,
                    SVGLengthList: 0,
                    SVGNumberList: 0,
                    SVGPathSegList: 0,
                    SVGPointList: 0,
                    SVGStringList: 0,
                    SVGTransformList: 0,
                    SourceBufferList: 0,
                    StyleSheetList: 0,
                    TextTrackCueList: 0,
                    TextTrackList: 0,
                    TouchList: 0
                };
            },
            8783: (e, t, r)=>{
                "use strict";
                var n = r(6933), i = r(811);
                e.exports = !n && !i && "object" == typeof window && "object" == typeof document;
            },
            6933: (e)=>{
                "use strict";
                e.exports = "object" == typeof Deno && Deno && "object" == typeof Deno.version;
            },
            2024: (e, t, r)=>{
                "use strict";
                var n = r(4906);
                e.exports = /ipad|iphone|ipod/i.test(n) && "undefined" != typeof Pebble;
            },
            2079: (e, t, r)=>{
                "use strict";
                var n = r(4906);
                e.exports = /(?:ipad|iphone|ipod).*applewebkit/i.test(n);
            },
            811: (e, t, r)=>{
                "use strict";
                var n = r(5620), i = r(4847);
                e.exports = "process" === i(n.process);
            },
            7356: (e, t, r)=>{
                "use strict";
                var n = r(4906);
                e.exports = /web0s(?!.*chrome)/i.test(n);
            },
            4906: (e)=>{
                "use strict";
                e.exports = "undefined" != typeof navigator && String(navigator.userAgent) || "";
            },
            119: (e, t, r)=>{
                "use strict";
                var n, i, o = r(5620), a = r(4906), s = o.process, u = o.Deno, c = s && s.versions || u && u.version, l = c && c.v8;
                l && (i = (n = l.split("."))[0] > 0 && n[0] < 4 ? 1 : +(n[0] + n[1])), !i && a && (!(n = a.match(/Edge\/(\d+)/)) || n[1] >= 74) && (n = a.match(/Chrome\/(\d+)/)) && (i = +n[1]), e.exports = i;
            },
            7812: (e)=>{
                "use strict";
                e.exports = [
                    "constructor",
                    "hasOwnProperty",
                    "isPrototypeOf",
                    "propertyIsEnumerable",
                    "toLocaleString",
                    "toString",
                    "valueOf"
                ];
            },
            6715: (e, t, r)=>{
                "use strict";
                var n = r(6021), i = Error, o = n("".replace), a = String(new i("zxcasd").stack), s = /\n\s*at [^:]*:[^\n]*/, u = s.test(a);
                e.exports = function(e, t) {
                    if (u && "string" == typeof e && !i.prepareStackTrace) for(; t--;)e = o(e, s, "");
                    return e;
                };
            },
            4079: (e, t, r)=>{
                "use strict";
                var n = r(6847), i = r(6715), o = r(8761), a = Error.captureStackTrace;
                e.exports = function(e, t, r, s) {
                    o && (a ? a(e, t) : n(e, "stack", i(r, s)));
                };
            },
            8761: (e, t, r)=>{
                "use strict";
                var n = r(7909), i = r(618);
                e.exports = !n(function() {
                    var e = new Error("a");
                    return !("stack" in e) || (Object.defineProperty(e, "stack", i(1, 7)), 7 !== e.stack);
                });
            },
            434: (e, t, r)=>{
                "use strict";
                var n = r(5620), i = r(9522), o = r(3806), a = r(342), s = r(8428).f, u = r(7025), c = r(4388), l = r(1492), f = r(6847), p = r(9489), d = function(e) {
                    var t = function(r, n, o) {
                        if (this instanceof t) {
                            switch(arguments.length){
                                case 0:
                                    return new e;
                                case 1:
                                    return new e(r);
                                case 2:
                                    return new e(r, n);
                            }
                            return new e(r, n, o);
                        }
                        return i(e, this, arguments);
                    };
                    return t.prototype = e.prototype, t;
                };
                e.exports = function(e, t) {
                    var r, i, h, v, m, y, g, E, b, S = e.target, _ = e.global, w = e.stat, O = e.proto, T = _ ? n : w ? n[S] : (n[S] || {}).prototype, I = _ ? c : c[S] || f(c, S, {})[S], R = I.prototype;
                    for(v in t)i = !(r = u(_ ? v : S + (w ? "." : "#") + v, e.forced)) && T && p(T, v), y = I[v], i && (g = e.dontCallGetSet ? (b = s(T, v)) && b.value : T[v]), m = i && g ? g : t[v], i && typeof y == typeof m || (E = e.bind && i ? l(m, n) : e.wrap && i ? d(m) : O && a(m) ? o(m) : m, (e.sham || m && m.sham || y && y.sham) && f(E, "sham", !0), f(I, v, E), O && (p(c, h = S + "Prototype") || f(c, h, {}), f(c[h], v, m), e.real && R && (r || !R[v]) && f(R, v, m)));
                };
            },
            7909: (e)=>{
                "use strict";
                e.exports = function(e) {
                    try {
                        return !!e();
                    } catch (e) {
                        return !0;
                    }
                };
            },
            7036: (e, t, r)=>{
                "use strict";
                var n = r(7909);
                e.exports = !n(function() {
                    return Object.isExtensible(Object.preventExtensions({}));
                });
            },
            9522: (e, t, r)=>{
                "use strict";
                var n = r(2396), i = Function.prototype, o = i.apply, a = i.call;
                e.exports = "object" == typeof Reflect && Reflect.apply || (n ? a.bind(o) : function() {
                    return a.apply(o, arguments);
                });
            },
            1492: (e, t, r)=>{
                "use strict";
                var n = r(3806), i = r(6735), o = r(2396), a = n(n.bind);
                e.exports = function(e, t) {
                    return i(e), void 0 === t ? e : o ? a(e, t) : function() {
                        return e.apply(t, arguments);
                    };
                };
            },
            2396: (e, t, r)=>{
                "use strict";
                var n = r(7909);
                e.exports = !n(function() {
                    var e = (function() {}).bind();
                    return "function" != typeof e || e.hasOwnProperty("prototype");
                });
            },
            9556: (e, t, r)=>{
                "use strict";
                var n = r(2396), i = Function.prototype.call;
                e.exports = n ? i.bind(i) : function() {
                    return i.apply(i, arguments);
                };
            },
            172: (e, t, r)=>{
                "use strict";
                var n = r(4451), i = r(9489), o = Function.prototype, a = n && Object.getOwnPropertyDescriptor, s = i(o, "name"), u = s && "something" === (function() {}).name, c = s && (!n || n && a(o, "name").configurable);
                e.exports = {
                    EXISTS: s,
                    PROPER: u,
                    CONFIGURABLE: c
                };
            },
            1645: (e, t, r)=>{
                "use strict";
                var n = r(6021), i = r(6735);
                e.exports = function(e, t, r) {
                    try {
                        return n(i(Object.getOwnPropertyDescriptor(e, t)[r]));
                    } catch (e) {}
                };
            },
            3806: (e, t, r)=>{
                "use strict";
                var n = r(4847), i = r(6021);
                e.exports = function(e) {
                    if ("Function" === n(e)) return i(e);
                };
            },
            6021: (e, t, r)=>{
                "use strict";
                var n = r(2396), i = Function.prototype, o = i.call, a = n && i.bind.bind(o, o);
                e.exports = n ? a : function(e) {
                    return function() {
                        return o.apply(e, arguments);
                    };
                };
            },
            9407: (e, t, r)=>{
                "use strict";
                var n = r(5620), i = r(4388);
                e.exports = function(e, t) {
                    var r = i[e + "Prototype"], o = r && r[t];
                    if (o) return o;
                    var a = n[e], s = a && a.prototype;
                    return s && s[t];
                };
            },
            889: (e, t, r)=>{
                "use strict";
                var n = r(4388), i = r(5620), o = r(342), a = function(e) {
                    return o(e) ? e : void 0;
                };
                e.exports = function(e, t) {
                    return arguments.length < 2 ? a(n[e]) || a(i[e]) : n[e] && n[e][t] || i[e] && i[e][t];
                };
            },
            3856: (e, t, r)=>{
                "use strict";
                var n = r(6220), i = r(787), o = r(2237), a = r(1724), s = r(8701)("iterator");
                e.exports = function(e) {
                    if (!o(e)) return i(e, s) || i(e, "@@iterator") || a[n(e)];
                };
            },
            2346: (e, t, r)=>{
                "use strict";
                var n = r(9556), i = r(6735), o = r(7934), a = r(9665), s = r(3856), u = TypeError;
                e.exports = function(e, t) {
                    var r = arguments.length < 2 ? s(e) : t;
                    if (i(r)) return o(n(r, e));
                    throw new u(a(e) + " is not iterable");
                };
            },
            787: (e, t, r)=>{
                "use strict";
                var n = r(6735), i = r(2237);
                e.exports = function(e, t) {
                    var r = e[t];
                    return i(r) ? void 0 : n(r);
                };
            },
            5620: function(e, t, r) {
                "use strict";
                var n = function(e) {
                    return e && e.Math === Math && e;
                };
                e.exports = n("object" == typeof globalThis && globalThis) || n("object" == typeof window && window) || n("object" == typeof self && self) || n("object" == typeof r.g && r.g) || n("object" == typeof this && this) || function() {
                    return this;
                }() || Function("return this")();
            },
            9489: (e, t, r)=>{
                "use strict";
                var n = r(6021), i = r(9449), o = n({}.hasOwnProperty);
                e.exports = Object.hasOwn || function(e, t) {
                    return o(i(e), t);
                };
            },
            9290: (e)=>{
                "use strict";
                e.exports = {};
            },
            8831: (e)=>{
                "use strict";
                e.exports = function(e, t) {
                    try {
                        1 === arguments.length ? console.error(e) : console.error(e, t);
                    } catch (e) {}
                };
            },
            4206: (e, t, r)=>{
                "use strict";
                var n = r(889);
                e.exports = n("document", "documentElement");
            },
            8713: (e, t, r)=>{
                "use strict";
                var n = r(4451), i = r(7909), o = r(5338);
                e.exports = !n && !i(function() {
                    return 7 !== Object.defineProperty(o("div"), "a", {
                        get: function() {
                            return 7;
                        }
                    }).a;
                });
            },
            1958: (e, t, r)=>{
                "use strict";
                var n = r(6021), i = r(7909), o = r(4847), a = Object, s = n("".split);
                e.exports = i(function() {
                    return !a("z").propertyIsEnumerable(0);
                }) ? function(e) {
                    return "String" === o(e) ? s(e, "") : a(e);
                } : a;
            },
            8228: (e, t, r)=>{
                "use strict";
                var n = r(6021), i = r(342), o = r(9188), a = n(Function.toString);
                i(o.inspectSource) || (o.inspectSource = function(e) {
                    return a(e);
                }), e.exports = o.inspectSource;
            },
            9654: (e, t, r)=>{
                "use strict";
                var n = r(2660), i = r(6847);
                e.exports = function(e, t) {
                    n(t) && "cause" in t && i(e, "cause", t.cause);
                };
            },
            1854: (e, t, r)=>{
                "use strict";
                var n = r(434), i = r(6021), o = r(9290), a = r(2660), s = r(9489), u = r(1032).f, c = r(6141), l = r(1620), f = r(644), p = r(7644), d = r(7036), h = !1, v = p("meta"), m = 0, y = function(e) {
                    u(e, v, {
                        value: {
                            objectID: "O" + m++,
                            weakData: {}
                        }
                    });
                }, g = e.exports = {
                    enable: function() {
                        g.enable = function() {}, h = !0;
                        var e = c.f, t = i([].splice), r = {};
                        r[v] = 1, e(r).length && (c.f = function(r) {
                            for(var n = e(r), i = 0, o = n.length; i < o; i++)if (n[i] === v) {
                                t(n, i, 1);
                                break;
                            }
                            return n;
                        }, n({
                            target: "Object",
                            stat: !0,
                            forced: !0
                        }, {
                            getOwnPropertyNames: l.f
                        }));
                    },
                    fastKey: function(e, t) {
                        if (!a(e)) return "symbol" == typeof e ? e : ("string" == typeof e ? "S" : "P") + e;
                        if (!s(e, v)) {
                            if (!f(e)) return "F";
                            if (!t) return "E";
                            y(e);
                        }
                        return e[v].objectID;
                    },
                    getWeakData: function(e, t) {
                        if (!s(e, v)) {
                            if (!f(e)) return !0;
                            if (!t) return !1;
                            y(e);
                        }
                        return e[v].weakData;
                    },
                    onFreeze: function(e) {
                        return d && h && f(e) && !s(e, v) && y(e), e;
                    }
                };
                o[v] = !0;
            },
            8354: (e, t, r)=>{
                "use strict";
                var n, i, o, a = r(8224), s = r(5620), u = r(2660), c = r(6847), l = r(9489), f = r(9188), p = r(546), d = r(9290), h = "Object already initialized", v = s.TypeError;
                if (a || f.state) {
                    var m = f.state || (f.state = new s.WeakMap);
                    m.get = m.get, m.has = m.has, m.set = m.set, n = function(e, t) {
                        if (m.has(e)) throw new v(h);
                        return t.facade = e, m.set(e, t), t;
                    }, i = function(e) {
                        return m.get(e) || {};
                    }, o = function(e) {
                        return m.has(e);
                    };
                } else {
                    var y = p("state");
                    d[y] = !0, n = function(e, t) {
                        if (l(e, y)) throw new v(h);
                        return t.facade = e, c(e, y, t), t;
                    }, i = function(e) {
                        return l(e, y) ? e[y] : {};
                    }, o = function(e) {
                        return l(e, y);
                    };
                }
                e.exports = {
                    set: n,
                    get: i,
                    has: o,
                    enforce: function(e) {
                        return o(e) ? i(e) : n(e, {});
                    },
                    getterFor: function(e) {
                        return function(t) {
                            var r;
                            if (!u(t) || (r = i(t)).type !== e) throw new v("Incompatible receiver, " + e + " required");
                            return r;
                        };
                    }
                };
            },
            6808: (e, t, r)=>{
                "use strict";
                var n = r(8701), i = r(1724), o = n("iterator"), a = Array.prototype;
                e.exports = function(e) {
                    return void 0 !== e && (i.Array === e || a[o] === e);
                };
            },
            7170: (e, t, r)=>{
                "use strict";
                var n = r(4847);
                e.exports = Array.isArray || function(e) {
                    return "Array" === n(e);
                };
            },
            342: (e)=>{
                "use strict";
                var t = "object" == typeof document && document.all;
                e.exports = void 0 === t && void 0 !== t ? function(e) {
                    return "function" == typeof e || e === t;
                } : function(e) {
                    return "function" == typeof e;
                };
            },
            3878: (e, t, r)=>{
                "use strict";
                var n = r(6021), i = r(7909), o = r(342), a = r(6220), s = r(889), u = r(8228), c = function() {}, l = [], f = s("Reflect", "construct"), p = /^\s*(?:class|function)\b/, d = n(p.exec), h = !p.test(c), v = function(e) {
                    if (!o(e)) return !1;
                    try {
                        return f(c, l, e), !0;
                    } catch (e) {
                        return !1;
                    }
                }, m = function(e) {
                    if (!o(e)) return !1;
                    switch(a(e)){
                        case "AsyncFunction":
                        case "GeneratorFunction":
                        case "AsyncGeneratorFunction":
                            return !1;
                    }
                    try {
                        return h || !!d(p, u(e));
                    } catch (e) {
                        return !0;
                    }
                };
                m.sham = !0, e.exports = !f || i(function() {
                    var e;
                    return v(v.call) || !v(Object) || !v(function() {
                        e = !0;
                    }) || e;
                }) ? m : v;
            },
            7025: (e, t, r)=>{
                "use strict";
                var n = r(7909), i = r(342), o = /#|\.prototype\./, a = function(e, t) {
                    var r = u[s(e)];
                    return r === l || r !== c && (i(t) ? n(t) : !!t);
                }, s = a.normalize = function(e) {
                    return String(e).replace(o, ".").toLowerCase();
                }, u = a.data = {}, c = a.NATIVE = "N", l = a.POLYFILL = "P";
                e.exports = a;
            },
            2237: (e)=>{
                "use strict";
                e.exports = function(e) {
                    return null == e;
                };
            },
            2660: (e, t, r)=>{
                "use strict";
                var n = r(342);
                e.exports = function(e) {
                    return "object" == typeof e ? null !== e : n(e);
                };
            },
            500: (e, t, r)=>{
                "use strict";
                var n = r(2660);
                e.exports = function(e) {
                    return n(e) || null === e;
                };
            },
            6338: (e)=>{
                "use strict";
                e.exports = !0;
            },
            465: (e, t, r)=>{
                "use strict";
                var n = r(2660), i = r(4847), o = r(8701)("match");
                e.exports = function(e) {
                    var t;
                    return n(e) && (void 0 !== (t = e[o]) ? !!t : "RegExp" === i(e));
                };
            },
            3197: (e, t, r)=>{
                "use strict";
                var n = r(889), i = r(342), o = r(2242), a = r(69), s = Object;
                e.exports = a ? function(e) {
                    return "symbol" == typeof e;
                } : function(e) {
                    var t = n("Symbol");
                    return i(t) && o(t.prototype, s(e));
                };
            },
            3762: (e, t, r)=>{
                "use strict";
                var n = r(1492), i = r(9556), o = r(7934), a = r(9665), s = r(6808), u = r(1159), c = r(2242), l = r(2346), f = r(3856), p = r(2928), d = TypeError, h = function(e, t) {
                    this.stopped = e, this.result = t;
                }, v = h.prototype;
                e.exports = function(e, t, r) {
                    var m, y, g, E, b, S, _, w = !(!r || !r.AS_ENTRIES), O = !(!r || !r.IS_RECORD), T = !(!r || !r.IS_ITERATOR), I = !(!r || !r.INTERRUPTED), R = n(t, r && r.that), x = function(e) {
                        return m && p(m, "normal", e), new h(!0, e);
                    }, A = function(e) {
                        return w ? (o(e), I ? R(e[0], e[1], x) : R(e[0], e[1])) : I ? R(e, x) : R(e);
                    };
                    if (O) m = e.iterator;
                    else if (T) m = e;
                    else {
                        if (!(y = f(e))) throw new d(a(e) + " is not iterable");
                        if (s(y)) {
                            for(g = 0, E = u(e); E > g; g++)if ((b = A(e[g])) && c(v, b)) return b;
                            return new h(!1);
                        }
                        m = l(e, y);
                    }
                    for(S = O ? e.next : m.next; !(_ = i(S, m)).done;){
                        try {
                            b = A(_.value);
                        } catch (e) {
                            p(m, "throw", e);
                        }
                        if ("object" == typeof b && b && c(v, b)) return b;
                    }
                    return new h(!1);
                };
            },
            2928: (e, t, r)=>{
                "use strict";
                var n = r(9556), i = r(7934), o = r(787);
                e.exports = function(e, t, r) {
                    var a, s;
                    i(e);
                    try {
                        if (!(a = o(e, "return"))) {
                            if ("throw" === t) throw r;
                            return r;
                        }
                        a = n(a, e);
                    } catch (e) {
                        s = !0, a = e;
                    }
                    if ("throw" === t) throw r;
                    if (s) throw a;
                    return i(a), r;
                };
            },
            7171: (e, t, r)=>{
                "use strict";
                var n = r(8335).IteratorPrototype, i = r(4136), o = r(618), a = r(6752), s = r(1724), u = function() {
                    return this;
                };
                e.exports = function(e, t, r, c) {
                    var l = t + " Iterator";
                    return e.prototype = i(n, {
                        next: o(+!c, r)
                    }), a(e, l, !1, !0), s[l] = u, e;
                };
            },
            3259: (e, t, r)=>{
                "use strict";
                var n = r(434), i = r(9556), o = r(6338), a = r(172), s = r(342), u = r(7171), c = r(6167), l = r(44), f = r(6752), p = r(6847), d = r(4423), h = r(8701), v = r(1724), m = r(8335), y = a.PROPER, g = a.CONFIGURABLE, E = m.IteratorPrototype, b = m.BUGGY_SAFARI_ITERATORS, S = h("iterator"), _ = "keys", w = "values", O = "entries", T = function() {
                    return this;
                };
                e.exports = function(e, t, r, a, h, m, I) {
                    u(r, t, a);
                    var R, x, A, N = function(e) {
                        if (e === h && D) return D;
                        if (!b && e && e in M) return M[e];
                        switch(e){
                            case _:
                            case w:
                            case O:
                                return function() {
                                    return new r(this, e);
                                };
                        }
                        return function() {
                            return new r(this);
                        };
                    }, C = t + " Iterator", k = !1, M = e.prototype, P = M[S] || M["@@iterator"] || h && M[h], D = !b && P || N(h), F = "Array" === t && M.entries || P;
                    if (F && (R = c(F.call(new e))) !== Object.prototype && R.next && (o || c(R) === E || (l ? l(R, E) : s(R[S]) || d(R, S, T)), f(R, C, !0, !0), o && (v[C] = T)), y && h === w && P && P.name !== w && (!o && g ? p(M, "name", w) : (k = !0, D = function() {
                        return i(P, this);
                    })), h) {
                        if (x = {
                            values: N(w),
                            keys: m ? D : N(_),
                            entries: N(O)
                        }, I) for(A in x)(b || k || !(A in M)) && d(M, A, x[A]);
                        else n({
                            target: t,
                            proto: !0,
                            forced: b || k
                        }, x);
                    }
                    return o && !I || M[S] === D || d(M, S, D, {
                        name: h
                    }), v[t] = D, x;
                };
            },
            8335: (e, t, r)=>{
                "use strict";
                var n, i, o, a = r(7909), s = r(342), u = r(2660), c = r(4136), l = r(6167), f = r(4423), p = r(8701), d = r(6338), h = p("iterator"), v = !1;
                [].keys && ("next" in (o = [].keys()) ? (i = l(l(o))) !== Object.prototype && (n = i) : v = !0), !u(n) || a(function() {
                    var e = {};
                    return n[h].call(e) !== e;
                }) ? n = {} : d && (n = c(n)), s(n[h]) || f(n, h, function() {
                    return this;
                }), e.exports = {
                    IteratorPrototype: n,
                    BUGGY_SAFARI_ITERATORS: v
                };
            },
            1724: (e)=>{
                "use strict";
                e.exports = {};
            },
            1159: (e, t, r)=>{
                "use strict";
                var n = r(9505);
                e.exports = function(e) {
                    return n(e.length);
                };
            },
            850: (e, t, r)=>{
                "use strict";
                var n = r(889), i = r(2886), o = n("Map");
                e.exports = {
                    Map: o,
                    set: i("set", 2),
                    get: i("get", 1),
                    has: i("has", 1),
                    remove: i("delete", 1),
                    proto: o.prototype
                };
            },
            1686: (e)=>{
                "use strict";
                var t = Math.ceil, r = Math.floor;
                e.exports = Math.trunc || function(e) {
                    var n = +e;
                    return (n > 0 ? r : t)(n);
                };
            },
            9194: (e, t, r)=>{
                "use strict";
                var n, i, o, a, s, u = r(5620), c = r(751), l = r(1492), f = r(7112).set, p = r(750), d = r(2079), h = r(2024), v = r(7356), m = r(811), y = u.MutationObserver || u.WebKitMutationObserver, g = u.document, E = u.process, b = u.Promise, S = c("queueMicrotask");
                if (!S) {
                    var _ = new p, w = function() {
                        var e, t;
                        for(m && (e = E.domain) && e.exit(); t = _.get();)try {
                            t();
                        } catch (e) {
                            throw _.head && n(), e;
                        }
                        e && e.enter();
                    };
                    d || m || v || !y || !g ? !h && b && b.resolve ? ((a = b.resolve(void 0)).constructor = b, s = l(a.then, a), n = function() {
                        s(w);
                    }) : m ? n = function() {
                        E.nextTick(w);
                    } : (f = l(f, u), n = function() {
                        f(w);
                    }) : (i = !0, o = g.createTextNode(""), new y(w).observe(o, {
                        characterData: !0
                    }), n = function() {
                        o.data = i = !i;
                    }), S = function(e) {
                        _.head || n(), _.add(e);
                    };
                }
                e.exports = S;
            },
            5759: (e, t, r)=>{
                "use strict";
                var n = r(6735), i = TypeError, o = function(e) {
                    var t, r;
                    this.promise = new e(function(e, n) {
                        if (void 0 !== t || void 0 !== r) throw new i("Bad Promise constructor");
                        t = e, r = n;
                    }), this.resolve = n(t), this.reject = n(r);
                };
                e.exports.f = function(e) {
                    return new o(e);
                };
            },
            823: (e, t, r)=>{
                "use strict";
                var n = r(7482);
                e.exports = function(e, t) {
                    return void 0 === e ? arguments.length < 2 ? "" : t : n(e);
                };
            },
            2679: (e, t, r)=>{
                "use strict";
                var n = r(465), i = TypeError;
                e.exports = function(e) {
                    if (n(e)) throw new i("The method doesn't accept regular expressions");
                    return e;
                };
            },
            4136: (e, t, r)=>{
                "use strict";
                var n, i = r(7934), o = r(2539), a = r(7812), s = r(9290), u = r(4206), c = r(5338), l = r(546), f = "prototype", p = "script", d = l("IE_PROTO"), h = function() {}, v = function(e) {
                    return "<" + p + ">" + e + "</" + p + ">";
                }, m = function(e) {
                    e.write(v("")), e.close();
                    var t = e.parentWindow.Object;
                    return e = null, t;
                }, y = function() {
                    try {
                        n = new ActiveXObject("htmlfile");
                    } catch (e) {}
                    var e, t, r;
                    y = "undefined" != typeof document ? document.domain && n ? m(n) : (t = c("iframe"), r = "java" + p + ":", t.style.display = "none", u.appendChild(t), t.src = String(r), (e = t.contentWindow.document).open(), e.write(v("document.F=Object")), e.close(), e.F) : m(n);
                    for(var i = a.length; i--;)delete y[f][a[i]];
                    return y();
                };
                s[d] = !0, e.exports = Object.create || function(e, t) {
                    var r;
                    return null !== e ? (h[f] = i(e), r = new h, h[f] = null, r[d] = e) : r = y(), void 0 === t ? r : o.f(r, t);
                };
            },
            2539: (e, t, r)=>{
                "use strict";
                var n = r(4451), i = r(9095), o = r(1032), a = r(7934), s = r(4036), u = r(8564);
                t.f = n && !i ? Object.defineProperties : function(e, t) {
                    a(e);
                    for(var r, n = s(t), i = u(t), c = i.length, l = 0; c > l;)o.f(e, r = i[l++], n[r]);
                    return e;
                };
            },
            1032: (e, t, r)=>{
                "use strict";
                var n = r(4451), i = r(8713), o = r(9095), a = r(7934), s = r(7966), u = TypeError, c = Object.defineProperty, l = Object.getOwnPropertyDescriptor, f = "enumerable", p = "configurable", d = "writable";
                t.f = n ? o ? function(e, t, r) {
                    if (a(e), t = s(t), a(r), "function" == typeof e && "prototype" === t && "value" in r && d in r && !r[d]) {
                        var n = l(e, t);
                        n && n[d] && (e[t] = r.value, r = {
                            configurable: p in r ? r[p] : n[p],
                            enumerable: f in r ? r[f] : n[f],
                            writable: !1
                        });
                    }
                    return c(e, t, r);
                } : c : function(e, t, r) {
                    if (a(e), t = s(t), a(r), i) try {
                        return c(e, t, r);
                    } catch (e) {}
                    if ("get" in r || "set" in r) throw new u("Accessors not supported");
                    return "value" in r && (e[t] = r.value), e;
                };
            },
            8428: (e, t, r)=>{
                "use strict";
                var n = r(4451), i = r(9556), o = r(7196), a = r(618), s = r(4036), u = r(7966), c = r(9489), l = r(8713), f = Object.getOwnPropertyDescriptor;
                t.f = n ? f : function(e, t) {
                    if (e = s(e), t = u(t), l) try {
                        return f(e, t);
                    } catch (e) {}
                    if (c(e, t)) return a(!i(o.f, e, t), e[t]);
                };
            },
            1620: (e, t, r)=>{
                "use strict";
                var n = r(4847), i = r(4036), o = r(6141).f, a = r(2529), s = "object" == typeof window && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];
                e.exports.f = function(e) {
                    return s && "Window" === n(e) ? function(e) {
                        try {
                            return o(e);
                        } catch (e) {
                            return a(s);
                        }
                    }(e) : o(i(e));
                };
            },
            6141: (e, t, r)=>{
                "use strict";
                var n = r(1224), i = r(7812).concat("length", "prototype");
                t.f = Object.getOwnPropertyNames || function(e) {
                    return n(e, i);
                };
            },
            3529: (e, t)=>{
                "use strict";
                t.f = Object.getOwnPropertySymbols;
            },
            6167: (e, t, r)=>{
                "use strict";
                var n = r(9489), i = r(342), o = r(9449), a = r(546), s = r(380), u = a("IE_PROTO"), c = Object, l = c.prototype;
                e.exports = s ? c.getPrototypeOf : function(e) {
                    var t = o(e);
                    if (n(t, u)) return t[u];
                    var r = t.constructor;
                    return i(r) && t instanceof r ? r.prototype : t instanceof c ? l : null;
                };
            },
            644: (e, t, r)=>{
                "use strict";
                var n = r(7909), i = r(2660), o = r(4847), a = r(5872), s = Object.isExtensible, u = n(function() {
                    s(1);
                });
                e.exports = u || a ? function(e) {
                    return !!i(e) && (!a || "ArrayBuffer" !== o(e)) && (!s || s(e));
                } : s;
            },
            2242: (e, t, r)=>{
                "use strict";
                var n = r(6021);
                e.exports = n({}.isPrototypeOf);
            },
            1224: (e, t, r)=>{
                "use strict";
                var n = r(6021), i = r(9489), o = r(4036), a = r(4029).indexOf, s = r(9290), u = n([].push);
                e.exports = function(e, t) {
                    var r, n = o(e), c = 0, l = [];
                    for(r in n)!i(s, r) && i(n, r) && u(l, r);
                    for(; t.length > c;)i(n, r = t[c++]) && (~a(l, r) || u(l, r));
                    return l;
                };
            },
            8564: (e, t, r)=>{
                "use strict";
                var n = r(1224), i = r(7812);
                e.exports = Object.keys || function(e) {
                    return n(e, i);
                };
            },
            7196: (e, t)=>{
                "use strict";
                var r = {}.propertyIsEnumerable, n = Object.getOwnPropertyDescriptor, i = n && !r.call({
                    1: 2
                }, 1);
                t.f = i ? function(e) {
                    var t = n(this, e);
                    return !!t && t.enumerable;
                } : r;
            },
            44: (e, t, r)=>{
                "use strict";
                var n = r(1645), i = r(7934), o = r(6689);
                e.exports = Object.setPrototypeOf || ("__proto__" in {} ? function() {
                    var e, t = !1, r = {};
                    try {
                        (e = n(Object.prototype, "__proto__", "set"))(r, []), t = r instanceof Array;
                    } catch (e) {}
                    return function(r, n) {
                        return i(r), o(n), t ? e(r, n) : r.__proto__ = n, r;
                    };
                }() : void 0);
            },
            3111: (e, t, r)=>{
                "use strict";
                var n = r(3895), i = r(6220);
                e.exports = n ? ({}).toString : function() {
                    return "[object " + i(this) + "]";
                };
            },
            4374: (e, t, r)=>{
                "use strict";
                var n = r(9556), i = r(342), o = r(2660), a = TypeError;
                e.exports = function(e, t) {
                    var r, s;
                    if ("string" === t && i(r = e.toString) && !o(s = n(r, e))) return s;
                    if (i(r = e.valueOf) && !o(s = n(r, e))) return s;
                    if ("string" !== t && i(r = e.toString) && !o(s = n(r, e))) return s;
                    throw new a("Can't convert object to primitive value");
                };
            },
            3419: (e, t, r)=>{
                "use strict";
                var n = r(889), i = r(6021), o = r(6141), a = r(3529), s = r(7934), u = i([].concat);
                e.exports = n("Reflect", "ownKeys") || function(e) {
                    var t = o.f(s(e)), r = a.f;
                    return r ? u(t, r(e)) : t;
                };
            },
            4388: (e)=>{
                "use strict";
                e.exports = {};
            },
            7854: (e)=>{
                "use strict";
                e.exports = function(e) {
                    try {
                        return {
                            error: !1,
                            value: e()
                        };
                    } catch (e) {
                        return {
                            error: !0,
                            value: e
                        };
                    }
                };
            },
            4194: (e, t, r)=>{
                "use strict";
                var n = r(5620), i = r(2882), o = r(342), a = r(7025), s = r(8228), u = r(8701), c = r(8783), l = r(6933), f = r(6338), p = r(119), d = i && i.prototype, h = u("species"), v = !1, m = o(n.PromiseRejectionEvent), y = a("Promise", function() {
                    var e = s(i), t = e !== String(i);
                    if (!t && 66 === p) return !0;
                    if (f && (!d.catch || !d.finally)) return !0;
                    if (!p || p < 51 || !/native code/.test(e)) {
                        var r = new i(function(e) {
                            e(1);
                        }), n = function(e) {
                            e(function() {}, function() {});
                        };
                        if ((r.constructor = {})[h] = n, !(v = r.then(function() {}) instanceof n)) return !0;
                    }
                    return !t && (c || l) && !m;
                });
                e.exports = {
                    CONSTRUCTOR: y,
                    REJECTION_EVENT: m,
                    SUBCLASSING: v
                };
            },
            2882: (e, t, r)=>{
                "use strict";
                var n = r(5620);
                e.exports = n.Promise;
            },
            2764: (e, t, r)=>{
                "use strict";
                var n = r(7934), i = r(2660), o = r(5759);
                e.exports = function(e, t) {
                    if (n(e), i(t) && t.constructor === e) return t;
                    var r = o.f(e);
                    return (0, r.resolve)(t), r.promise;
                };
            },
            4549: (e, t, r)=>{
                "use strict";
                var n = r(2882), i = r(4712), o = r(4194).CONSTRUCTOR;
                e.exports = o || !i(function(e) {
                    n.all(e).then(void 0, function() {});
                });
            },
            750: (e)=>{
                "use strict";
                var t = function() {
                    this.head = null, this.tail = null;
                };
                t.prototype = {
                    add: function(e) {
                        var t = {
                            item: e,
                            next: null
                        }, r = this.tail;
                        r ? r.next = t : this.head = t, this.tail = t;
                    },
                    get: function() {
                        var e = this.head;
                        if (e) return null === (this.head = e.next) && (this.tail = null), e.item;
                    }
                }, e.exports = t;
            },
            4734: (e, t, r)=>{
                "use strict";
                var n = r(2237), i = TypeError;
                e.exports = function(e) {
                    if (n(e)) throw new i("Can't call method on " + e);
                    return e;
                };
            },
            751: (e, t, r)=>{
                "use strict";
                var n = r(5620), i = r(4451), o = Object.getOwnPropertyDescriptor;
                e.exports = function(e) {
                    if (!i) return n[e];
                    var t = o(n, e);
                    return t && t.value;
                };
            },
            6331: (e, t, r)=>{
                "use strict";
                var n = r(889), i = r(4843), o = r(8701), a = r(4451), s = o("species");
                e.exports = function(e) {
                    var t = n(e);
                    a && t && !t[s] && i(t, s, {
                        configurable: !0,
                        get: function() {
                            return this;
                        }
                    });
                };
            },
            6752: (e, t, r)=>{
                "use strict";
                var n = r(3895), i = r(1032).f, o = r(6847), a = r(9489), s = r(3111), u = r(8701)("toStringTag");
                e.exports = function(e, t, r, c) {
                    var l = r ? e : e && e.prototype;
                    l && (a(l, u) || i(l, u, {
                        configurable: !0,
                        value: t
                    }), c && !n && o(l, "toString", s));
                };
            },
            546: (e, t, r)=>{
                "use strict";
                var n = r(5260), i = r(7644), o = n("keys");
                e.exports = function(e) {
                    return o[e] || (o[e] = i(e));
                };
            },
            9188: (e, t, r)=>{
                "use strict";
                var n = r(5620), i = r(1395), o = "__core-js_shared__", a = n[o] || i(o, {});
                e.exports = a;
            },
            5260: (e, t, r)=>{
                "use strict";
                var n = r(6338), i = r(9188);
                (e.exports = function(e, t) {
                    return i[e] || (i[e] = void 0 !== t ? t : {});
                })("versions", []).push({
                    version: "3.35.0",
                    mode: n ? "pure" : "global",
                    copyright: "\xa9 2014-2023 Denis Pushkarev (zloirock.ru)",
                    license: "https://github.com/zloirock/core-js/blob/v3.35.0/LICENSE",
                    source: "https://github.com/zloirock/core-js"
                });
            },
            4889: (e, t, r)=>{
                "use strict";
                var n = r(7934), i = r(1298), o = r(2237), a = r(8701)("species");
                e.exports = function(e, t) {
                    var r, s = n(e).constructor;
                    return void 0 === s || o(r = n(s)[a]) ? t : i(r);
                };
            },
            8115: (e, t, r)=>{
                "use strict";
                var n = r(6021), i = r(1977), o = r(7482), a = r(4734), s = n("".charAt), u = n("".charCodeAt), c = n("".slice), l = function(e) {
                    return function(t, r) {
                        var n, l, f = o(a(t)), p = i(r), d = f.length;
                        return p < 0 || p >= d ? e ? "" : void 0 : (n = u(f, p)) < 55296 || n > 56319 || p + 1 === d || (l = u(f, p + 1)) < 56320 || l > 57343 ? e ? s(f, p) : n : e ? c(f, p, p + 2) : l - 56320 + (n - 55296 << 10) + 65536;
                    };
                };
                e.exports = {
                    codeAt: l(!1),
                    charAt: l(!0)
                };
            },
            6498: (e, t, r)=>{
                "use strict";
                var n = r(119), i = r(7909), o = r(5620).String;
                e.exports = !!Object.getOwnPropertySymbols && !i(function() {
                    var e = Symbol("symbol detection");
                    return !o(e) || !(Object(e) instanceof Symbol) || !Symbol.sham && n && n < 41;
                });
            },
            7112: (e, t, r)=>{
                "use strict";
                var n, i, o, a, s = r(5620), u = r(9522), c = r(1492), l = r(342), f = r(9489), p = r(7909), d = r(4206), h = r(2529), v = r(5338), m = r(5636), y = r(2079), g = r(811), E = s.setImmediate, b = s.clearImmediate, S = s.process, _ = s.Dispatch, w = s.Function, O = s.MessageChannel, T = s.String, I = 0, R = {}, x = "onreadystatechange";
                p(function() {
                    n = s.location;
                });
                var A = function(e) {
                    if (f(R, e)) {
                        var t = R[e];
                        delete R[e], t();
                    }
                }, N = function(e) {
                    return function() {
                        A(e);
                    };
                }, C = function(e) {
                    A(e.data);
                }, k = function(e) {
                    s.postMessage(T(e), n.protocol + "//" + n.host);
                };
                E && b || (E = function(e) {
                    m(arguments.length, 1);
                    var t = l(e) ? e : w(e), r = h(arguments, 1);
                    return R[++I] = function() {
                        u(t, void 0, r);
                    }, i(I), I;
                }, b = function(e) {
                    delete R[e];
                }, g ? i = function(e) {
                    S.nextTick(N(e));
                } : _ && _.now ? i = function(e) {
                    _.now(N(e));
                } : O && !y ? (a = (o = new O).port2, o.port1.onmessage = C, i = c(a.postMessage, a)) : s.addEventListener && l(s.postMessage) && !s.importScripts && n && "file:" !== n.protocol && !p(k) ? (i = k, s.addEventListener("message", C, !1)) : i = x in v("script") ? function(e) {
                    d.appendChild(v("script"))[x] = function() {
                        d.removeChild(this), A(e);
                    };
                } : function(e) {
                    setTimeout(N(e), 0);
                }), e.exports = {
                    set: E,
                    clear: b
                };
            },
            3928: (e, t, r)=>{
                "use strict";
                var n = r(1977), i = Math.max, o = Math.min;
                e.exports = function(e, t) {
                    var r = n(e);
                    return r < 0 ? i(r + t, 0) : o(r, t);
                };
            },
            4036: (e, t, r)=>{
                "use strict";
                var n = r(1958), i = r(4734);
                e.exports = function(e) {
                    return n(i(e));
                };
            },
            1977: (e, t, r)=>{
                "use strict";
                var n = r(1686);
                e.exports = function(e) {
                    var t = +e;
                    return t != t || 0 === t ? 0 : n(t);
                };
            },
            9505: (e, t, r)=>{
                "use strict";
                var n = r(1977), i = Math.min;
                e.exports = function(e) {
                    return e > 0 ? i(n(e), 9007199254740991) : 0;
                };
            },
            9449: (e, t, r)=>{
                "use strict";
                var n = r(4734), i = Object;
                e.exports = function(e) {
                    return i(n(e));
                };
            },
            5107: (e, t, r)=>{
                "use strict";
                var n = r(9556), i = r(2660), o = r(3197), a = r(787), s = r(4374), u = r(8701), c = TypeError, l = u("toPrimitive");
                e.exports = function(e, t) {
                    if (!i(e) || o(e)) return e;
                    var r, u = a(e, l);
                    if (u) {
                        if (void 0 === t && (t = "default"), r = n(u, e, t), !i(r) || o(r)) return r;
                        throw new c("Can't convert object to primitive value");
                    }
                    return void 0 === t && (t = "number"), s(e, t);
                };
            },
            7966: (e, t, r)=>{
                "use strict";
                var n = r(5107), i = r(3197);
                e.exports = function(e) {
                    var t = n(e, "string");
                    return i(t) ? t : t + "";
                };
            },
            3895: (e, t, r)=>{
                "use strict";
                var n = {};
                n[r(8701)("toStringTag")] = "z", e.exports = "[object z]" === String(n);
            },
            7482: (e, t, r)=>{
                "use strict";
                var n = r(6220), i = String;
                e.exports = function(e) {
                    if ("Symbol" === n(e)) throw new TypeError("Cannot convert a Symbol value to a string");
                    return i(e);
                };
            },
            9665: (e)=>{
                "use strict";
                var t = String;
                e.exports = function(e) {
                    try {
                        return t(e);
                    } catch (e) {
                        return "Object";
                    }
                };
            },
            7644: (e, t, r)=>{
                "use strict";
                var n = r(6021), i = 0, o = Math.random(), a = n(1..toString);
                e.exports = function(e) {
                    return "Symbol(" + (void 0 === e ? "" : e) + ")_" + a(++i + o, 36);
                };
            },
            69: (e, t, r)=>{
                "use strict";
                var n = r(6498);
                e.exports = n && !Symbol.sham && "symbol" == typeof Symbol.iterator;
            },
            9095: (e, t, r)=>{
                "use strict";
                var n = r(4451), i = r(7909);
                e.exports = n && i(function() {
                    return 42 !== Object.defineProperty(function() {}, "prototype", {
                        value: 42,
                        writable: !1
                    }).prototype;
                });
            },
            5636: (e)=>{
                "use strict";
                var t = TypeError;
                e.exports = function(e, r) {
                    if (e < r) throw new t("Not enough arguments");
                    return e;
                };
            },
            8224: (e, t, r)=>{
                "use strict";
                var n = r(5620), i = r(342), o = n.WeakMap;
                e.exports = i(o) && /native code/.test(String(o));
            },
            8701: (e, t, r)=>{
                "use strict";
                var n = r(5620), i = r(5260), o = r(9489), a = r(7644), s = r(6498), u = r(69), c = n.Symbol, l = i("wks"), f = u ? c.for || c : c && c.withoutSetter || a;
                e.exports = function(e) {
                    return o(l, e) || (l[e] = s && o(c, e) ? c[e] : f("Symbol." + e)), l[e];
                };
            },
            9166: (e, t, r)=>{
                "use strict";
                var n = r(434), i = r(2242), o = r(6167), a = r(44), s = r(6965), u = r(4136), c = r(6847), l = r(618), f = r(9654), p = r(4079), d = r(3762), h = r(823), v = r(8701)("toStringTag"), m = Error, y = [].push, g = function(e, t) {
                    var r, n = i(E, this);
                    a ? r = a(new m, n ? o(this) : E) : (r = n ? this : u(E), c(r, v, "Error")), void 0 !== t && c(r, "message", h(t)), p(r, g, r.stack, 1), arguments.length > 2 && f(r, arguments[2]);
                    var s = [];
                    return d(e, y, {
                        that: s
                    }), c(r, "errors", s), r;
                };
                a ? a(g, m) : s(g, m, {
                    name: !0
                });
                var E = g.prototype = u(m.prototype, {
                    constructor: l(1, g),
                    message: l(1, ""),
                    name: l(1, "AggregateError")
                });
                n({
                    global: !0,
                    constructor: !0,
                    arity: 2
                }, {
                    AggregateError: g
                });
            },
            1935: (e, t, r)=>{
                "use strict";
                r(9166);
            },
            6128: (e, t, r)=>{
                "use strict";
                var n = r(434), i = r(4029).includes, o = r(7909), a = r(9747);
                n({
                    target: "Array",
                    proto: !0,
                    forced: o(function() {
                        return !Array(1).includes();
                    })
                }, {
                    includes: function(e) {
                        return i(this, e, arguments.length > 1 ? arguments[1] : void 0);
                    }
                }), a("includes");
            },
            4984: (e, t, r)=>{
                "use strict";
                var n = r(434), i = r(3806), o = r(4029).indexOf, a = r(3888), s = i([].indexOf), u = !!s && 1 / s([
                    1
                ], 1, -0) < 0;
                n({
                    target: "Array",
                    proto: !0,
                    forced: u || !a("indexOf")
                }, {
                    indexOf: function(e) {
                        var t = arguments.length > 1 ? arguments[1] : void 0;
                        return u ? s(this, e, t) || 0 : o(this, e, t);
                    }
                });
            },
            7189: (e, t, r)=>{
                "use strict";
                var n = r(4036), i = r(9747), o = r(1724), a = r(8354), s = r(1032).f, u = r(3259), c = r(8893), l = r(6338), f = r(4451), p = "Array Iterator", d = a.set, h = a.getterFor(p);
                e.exports = u(Array, "Array", function(e, t) {
                    d(this, {
                        type: p,
                        target: n(e),
                        index: 0,
                        kind: t
                    });
                }, function() {
                    var e = h(this), t = e.target, r = e.index++;
                    if (!t || r >= t.length) return e.target = void 0, c(void 0, !0);
                    switch(e.kind){
                        case "keys":
                            return c(r, !1);
                        case "values":
                            return c(t[r], !1);
                    }
                    return c([
                        r,
                        t[r]
                    ], !1);
                }, "values");
                var v = o.Arguments = o.Array;
                if (i("keys"), i("values"), i("entries"), !l && f && "values" !== v.name) try {
                    s(v, "name", {
                        value: "values"
                    });
                } catch (e) {}
            },
            4269: (e, t, r)=>{
                "use strict";
                var n = r(434), i = r(213).left, o = r(3888), a = r(119);
                n({
                    target: "Array",
                    proto: !0,
                    forced: !r(811) && a > 79 && a < 83 || !o("reduce")
                }, {
                    reduce: function(e) {
                        var t = arguments.length;
                        return i(this, e, t, t > 1 ? arguments[1] : void 0);
                    }
                });
            },
            2302: (e, t, r)=>{
                "use strict";
                var n = r(434), i = r(6021), o = Date, a = i(o.prototype.getTime);
                n({
                    target: "Date",
                    stat: !0
                }, {
                    now: function() {
                        return a(new o);
                    }
                });
            },
            4341: (e, t, r)=>{
                "use strict";
                r(1577)("Map", function(e) {
                    return function() {
                        return e(this, arguments.length ? arguments[0] : void 0);
                    };
                }, r(329));
            },
            1400: (e, t, r)=>{
                "use strict";
                var n = r(434), i = r(6021), o = r(6735), a = r(4734), s = r(3762), u = r(850), c = r(6338), l = u.Map, f = u.has, p = u.get, d = u.set, h = i([].push);
                n({
                    target: "Map",
                    stat: !0,
                    forced: c
                }, {
                    groupBy: function(e, t) {
                        a(e), o(t);
                        var r = new l, n = 0;
                        return s(e, function(e) {
                            var i = t(e, n++);
                            f(r, i) ? h(p(r, i), e) : d(r, i, [
                                e
                            ]);
                        }), r;
                    }
                });
            },
            727: (e, t, r)=>{
                "use strict";
                r(4341);
            },
            9614: (e, t, r)=>{
                "use strict";
                var n = r(434), i = r(4451), o = r(1032).f;
                n({
                    target: "Object",
                    stat: !0,
                    forced: Object.defineProperty !== o,
                    sham: !i
                }, {
                    defineProperty: o
                });
            },
            8331: (e, t, r)=>{
                "use strict";
                var n = r(434), i = r(7909), o = r(4036), a = r(8428).f, s = r(4451);
                n({
                    target: "Object",
                    stat: !0,
                    forced: !s || i(function() {
                        a(1);
                    }),
                    sham: !s
                }, {
                    getOwnPropertyDescriptor: function(e, t) {
                        return a(o(e), t);
                    }
                });
            },
            1732: ()=>{},
            261: (e, t, r)=>{
                "use strict";
                var n = r(434), i = r(9556), o = r(6735), a = r(5759), s = r(7854), u = r(3762);
                n({
                    target: "Promise",
                    stat: !0,
                    forced: r(4549)
                }, {
                    allSettled: function(e) {
                        var t = this, r = a.f(t), n = r.resolve, c = r.reject, l = s(function() {
                            var r = o(t.resolve), a = [], s = 0, c = 1;
                            u(e, function(e) {
                                var o = s++, u = !1;
                                c++, i(r, t, e).then(function(e) {
                                    u || (u = !0, a[o] = {
                                        status: "fulfilled",
                                        value: e
                                    }, --c || n(a));
                                }, function(e) {
                                    u || (u = !0, a[o] = {
                                        status: "rejected",
                                        reason: e
                                    }, --c || n(a));
                                });
                            }), --c || n(a);
                        });
                        return l.error && c(l.value), r.promise;
                    }
                });
            },
            2118: (e, t, r)=>{
                "use strict";
                var n = r(434), i = r(9556), o = r(6735), a = r(5759), s = r(7854), u = r(3762);
                n({
                    target: "Promise",
                    stat: !0,
                    forced: r(4549)
                }, {
                    all: function(e) {
                        var t = this, r = a.f(t), n = r.resolve, c = r.reject, l = s(function() {
                            var r = o(t.resolve), a = [], s = 0, l = 1;
                            u(e, function(e) {
                                var o = s++, u = !1;
                                l++, i(r, t, e).then(function(e) {
                                    u || (u = !0, a[o] = e, --l || n(a));
                                }, c);
                            }), --l || n(a);
                        });
                        return l.error && c(l.value), r.promise;
                    }
                });
            },
            6766: (e, t, r)=>{
                "use strict";
                var n = r(434), i = r(9556), o = r(6735), a = r(889), s = r(5759), u = r(7854), c = r(3762), l = r(4549), f = "No one promise resolved";
                n({
                    target: "Promise",
                    stat: !0,
                    forced: l
                }, {
                    any: function(e) {
                        var t = this, r = a("AggregateError"), n = s.f(t), l = n.resolve, p = n.reject, d = u(function() {
                            var n = o(t.resolve), a = [], s = 0, u = 1, d = !1;
                            c(e, function(e) {
                                var o = s++, c = !1;
                                u++, i(n, t, e).then(function(e) {
                                    c || d || (d = !0, l(e));
                                }, function(e) {
                                    c || d || (c = !0, a[o] = e, --u || p(new r(a, f)));
                                });
                            }), --u || p(new r(a, f));
                        });
                        return d.error && p(d.value), n.promise;
                    }
                });
            },
            9227: (e, t, r)=>{
                "use strict";
                var n = r(434), i = r(6338), o = r(4194).CONSTRUCTOR, a = r(2882), s = r(889), u = r(342), c = r(4423), l = a && a.prototype;
                if (n({
                    target: "Promise",
                    proto: !0,
                    forced: o,
                    real: !0
                }, {
                    catch: function(e) {
                        return this.then(void 0, e);
                    }
                }), !i && u(a)) {
                    var f = s("Promise").prototype.catch;
                    l.catch !== f && c(l, "catch", f, {
                        unsafe: !0
                    });
                }
            },
            8668: (e, t, r)=>{
                "use strict";
                var n, i, o, a = r(434), s = r(6338), u = r(811), c = r(5620), l = r(9556), f = r(4423), p = r(44), d = r(6752), h = r(6331), v = r(6735), m = r(342), y = r(2660), g = r(6406), E = r(4889), b = r(7112).set, S = r(9194), _ = r(8831), w = r(7854), O = r(750), T = r(8354), I = r(2882), R = r(4194), x = r(5759), A = "Promise", N = R.CONSTRUCTOR, C = R.REJECTION_EVENT, k = R.SUBCLASSING, M = T.getterFor(A), P = T.set, D = I && I.prototype, F = I, L = D, j = c.TypeError, U = c.document, B = c.process, Q = x.f, V = Q, q = !!(U && U.createEvent && c.dispatchEvent), G = "unhandledrejection", z = function(e) {
                    var t;
                    return !(!y(e) || !m(t = e.then)) && t;
                }, W = function(e, t) {
                    var r, n, i, o = t.value, a = 1 === t.state, s = a ? e.ok : e.fail, u = e.resolve, c = e.reject, f = e.domain;
                    try {
                        s ? (a || (2 === t.rejection && X(t), t.rejection = 1), !0 === s ? r = o : (f && f.enter(), r = s(o), f && (f.exit(), i = !0)), r === e.promise ? c(new j("Promise-chain cycle")) : (n = z(r)) ? l(n, r, u, c) : u(r)) : c(o);
                    } catch (e) {
                        f && !i && f.exit(), c(e);
                    }
                }, $ = function(e, t) {
                    e.notified || (e.notified = !0, S(function() {
                        for(var r, n = e.reactions; r = n.get();)W(r, e);
                        e.notified = !1, t && !e.rejection && K(e);
                    }));
                }, H = function(e, t, r) {
                    var n, i;
                    q ? ((n = U.createEvent("Event")).promise = t, n.reason = r, n.initEvent(e, !1, !0), c.dispatchEvent(n)) : n = {
                        promise: t,
                        reason: r
                    }, !C && (i = c["on" + e]) ? i(n) : e === G && _("Unhandled promise rejection", r);
                }, K = function(e) {
                    l(b, c, function() {
                        var t, r = e.facade, n = e.value;
                        if (Y(e) && (t = w(function() {
                            u ? B.emit("unhandledRejection", n, r) : H(G, r, n);
                        }), e.rejection = u || Y(e) ? 2 : 1, t.error)) throw t.value;
                    });
                }, Y = function(e) {
                    return 1 !== e.rejection && !e.parent;
                }, X = function(e) {
                    l(b, c, function() {
                        var t = e.facade;
                        u ? B.emit("rejectionHandled", t) : H("rejectionhandled", t, e.value);
                    });
                }, J = function(e, t, r) {
                    return function(n) {
                        e(t, n, r);
                    };
                }, Z = function(e, t, r) {
                    e.done || (e.done = !0, r && (e = r), e.value = t, e.state = 2, $(e, !0));
                }, ee = function(e, t, r) {
                    if (!e.done) {
                        e.done = !0, r && (e = r);
                        try {
                            if (e.facade === t) throw new j("Promise can't be resolved itself");
                            var n = z(t);
                            n ? S(function() {
                                var r = {
                                    done: !1
                                };
                                try {
                                    l(n, t, J(ee, r, e), J(Z, r, e));
                                } catch (t) {
                                    Z(r, t, e);
                                }
                            }) : (e.value = t, e.state = 1, $(e, !1));
                        } catch (t) {
                            Z({
                                done: !1
                            }, t, e);
                        }
                    }
                };
                if (N && (F = function(e) {
                    g(this, L), v(e), l(n, this);
                    var t = M(this);
                    try {
                        e(J(ee, t), J(Z, t));
                    } catch (e) {
                        Z(t, e);
                    }
                }, (n = function(e) {
                    P(this, {
                        type: A,
                        done: !1,
                        notified: !1,
                        parent: !1,
                        reactions: new O,
                        rejection: !1,
                        state: 0,
                        value: void 0
                    });
                }).prototype = f(L = F.prototype, "then", function(e, t) {
                    var r = M(this), n = Q(E(this, F));
                    return r.parent = !0, n.ok = !m(e) || e, n.fail = m(t) && t, n.domain = u ? B.domain : void 0, 0 === r.state ? r.reactions.add(n) : S(function() {
                        W(n, r);
                    }), n.promise;
                }), i = function() {
                    var e = new n, t = M(e);
                    this.promise = e, this.resolve = J(ee, t), this.reject = J(Z, t);
                }, x.f = Q = function(e) {
                    return e === F || undefined === e ? new i(e) : V(e);
                }, !s && m(I) && D !== Object.prototype)) {
                    o = D.then, k || f(D, "then", function(e, t) {
                        var r = this;
                        return new F(function(e, t) {
                            l(o, r, e, t);
                        }).then(e, t);
                    }, {
                        unsafe: !0
                    });
                    try {
                        delete D.constructor;
                    } catch (e) {}
                    p && p(D, L);
                }
                a({
                    global: !0,
                    constructor: !0,
                    wrap: !0,
                    forced: N
                }, {
                    Promise: F
                }), d(F, A, !1, !0), h(A);
            },
            9363: (e, t, r)=>{
                "use strict";
                var n = r(434), i = r(6338), o = r(2882), a = r(7909), s = r(889), u = r(342), c = r(4889), l = r(2764), f = r(4423), p = o && o.prototype;
                if (n({
                    target: "Promise",
                    proto: !0,
                    real: !0,
                    forced: !!o && a(function() {
                        p.finally.call({
                            then: function() {}
                        }, function() {});
                    })
                }, {
                    finally: function(e) {
                        var t = c(this, s("Promise")), r = u(e);
                        return this.then(r ? function(r) {
                            return l(t, e()).then(function() {
                                return r;
                            });
                        } : e, r ? function(r) {
                            return l(t, e()).then(function() {
                                throw r;
                            });
                        } : e);
                    }
                }), !i && u(o)) {
                    var d = s("Promise").prototype.finally;
                    p.finally !== d && f(p, "finally", d, {
                        unsafe: !0
                    });
                }
            },
            7971: (e, t, r)=>{
                "use strict";
                r(8668), r(2118), r(9227), r(1912), r(8981), r(8469);
            },
            1912: (e, t, r)=>{
                "use strict";
                var n = r(434), i = r(9556), o = r(6735), a = r(5759), s = r(7854), u = r(3762);
                n({
                    target: "Promise",
                    stat: !0,
                    forced: r(4549)
                }, {
                    race: function(e) {
                        var t = this, r = a.f(t), n = r.reject, c = s(function() {
                            var a = o(t.resolve);
                            u(e, function(e) {
                                i(a, t, e).then(r.resolve, n);
                            });
                        });
                        return c.error && n(c.value), r.promise;
                    }
                });
            },
            8981: (e, t, r)=>{
                "use strict";
                var n = r(434), i = r(5759);
                n({
                    target: "Promise",
                    stat: !0,
                    forced: r(4194).CONSTRUCTOR
                }, {
                    reject: function(e) {
                        var t = i.f(this);
                        return (0, t.reject)(e), t.promise;
                    }
                });
            },
            8469: (e, t, r)=>{
                "use strict";
                var n = r(434), i = r(889), o = r(6338), a = r(2882), s = r(4194).CONSTRUCTOR, u = r(2764), c = i("Promise"), l = o && !s;
                n({
                    target: "Promise",
                    stat: !0,
                    forced: o || s
                }, {
                    resolve: function(e) {
                        return u(l && this === c ? a : this, e);
                    }
                });
            },
            5412: (e, t, r)=>{
                "use strict";
                var n = r(434), i = r(5759);
                n({
                    target: "Promise",
                    stat: !0
                }, {
                    withResolvers: function() {
                        var e = i.f(this);
                        return {
                            promise: e.promise,
                            resolve: e.resolve,
                            reject: e.reject
                        };
                    }
                });
            },
            1381: (e, t, r)=>{
                "use strict";
                var n, i = r(434), o = r(3806), a = r(8428).f, s = r(9505), u = r(7482), c = r(2679), l = r(4734), f = r(2541), p = r(6338), d = o("".slice), h = Math.min, v = f("endsWith");
                i({
                    target: "String",
                    proto: !0,
                    forced: !!(p || v || (n = a(String.prototype, "endsWith"), !n || n.writable)) && !v
                }, {
                    endsWith: function(e) {
                        var t = u(l(this));
                        c(e);
                        var r = arguments.length > 1 ? arguments[1] : void 0, n = t.length, i = void 0 === r ? n : h(s(r), n), o = u(e);
                        return d(t, i - o.length, i) === o;
                    }
                });
            },
            1021: (e, t, r)=>{
                "use strict";
                var n = r(434), i = r(6021), o = r(2679), a = r(4734), s = r(7482), u = r(2541), c = i("".indexOf);
                n({
                    target: "String",
                    proto: !0,
                    forced: !u("includes")
                }, {
                    includes: function(e) {
                        return !!~c(s(a(this)), s(o(e)), arguments.length > 1 ? arguments[1] : void 0);
                    }
                });
            },
            9823: (e, t, r)=>{
                "use strict";
                var n = r(8115).charAt, i = r(7482), o = r(8354), a = r(3259), s = r(8893), u = "String Iterator", c = o.set, l = o.getterFor(u);
                a(String, "String", function(e) {
                    c(this, {
                        type: u,
                        string: i(e),
                        index: 0
                    });
                }, function() {
                    var e, t = l(this), r = t.string, i = t.index;
                    return i >= r.length ? s(void 0, !0) : (e = n(r, i), t.index += e.length, s(e, !1));
                });
            },
            4043: (e, t, r)=>{
                "use strict";
                var n, i = r(7036), o = r(5620), a = r(6021), s = r(9102), u = r(1854), c = r(1577), l = r(943), f = r(2660), p = r(8354).enforce, d = r(7909), h = r(8224), v = Object, m = Array.isArray, y = v.isExtensible, g = v.isFrozen, E = v.isSealed, b = v.freeze, S = v.seal, _ = !o.ActiveXObject && "ActiveXObject" in o, w = function(e) {
                    return function() {
                        return e(this, arguments.length ? arguments[0] : void 0);
                    };
                }, O = c("WeakMap", w, l), T = O.prototype, I = a(T.set);
                if (h) {
                    if (_) {
                        n = l.getConstructor(w, "WeakMap", !0), u.enable();
                        var R = a(T.delete), x = a(T.has), A = a(T.get);
                        s(T, {
                            delete: function(e) {
                                if (f(e) && !y(e)) {
                                    var t = p(this);
                                    return t.frozen || (t.frozen = new n), R(this, e) || t.frozen.delete(e);
                                }
                                return R(this, e);
                            },
                            has: function(e) {
                                if (f(e) && !y(e)) {
                                    var t = p(this);
                                    return t.frozen || (t.frozen = new n), x(this, e) || t.frozen.has(e);
                                }
                                return x(this, e);
                            },
                            get: function(e) {
                                if (f(e) && !y(e)) {
                                    var t = p(this);
                                    return t.frozen || (t.frozen = new n), x(this, e) ? A(this, e) : t.frozen.get(e);
                                }
                                return A(this, e);
                            },
                            set: function(e, t) {
                                if (f(e) && !y(e)) {
                                    var r = p(this);
                                    r.frozen || (r.frozen = new n), x(this, e) ? I(this, e, t) : r.frozen.set(e, t);
                                } else I(this, e, t);
                                return this;
                            }
                        });
                    } else i && d(function() {
                        var e = b([]);
                        return I(new O, e, 1), !g(e);
                    }) && s(T, {
                        set: function(e, t) {
                            var r;
                            return m(e) && (g(e) ? r = b : E(e) && (r = S)), I(this, e, t), r && r(e), this;
                        }
                    });
                }
            },
            9284: (e, t, r)=>{
                "use strict";
                r(4043);
            },
            469: (e, t, r)=>{
                "use strict";
                r(7189);
                var n = r(1753), i = r(5620), o = r(6752), a = r(1724);
                for(var s in n)o(i[s], s), a[s] = a.Array;
            },
            4998: (e, t, r)=>{
                "use strict";
                var n = r(8630);
                e.exports = n;
            },
            9844: (e, t, r)=>{
                "use strict";
                var n = r(6225);
                e.exports = n;
            },
            3773: (e, t, r)=>{
                "use strict";
                var n = r(931);
                e.exports = n;
            },
            5705: (e, t, r)=>{
                "use strict";
                var n = r(7888);
                e.exports = n;
            },
            6376: (e, t, r)=>{
                "use strict";
                var n = r(6329);
                e.exports = n;
            },
            4297: (e, t, r)=>{
                "use strict";
                var n = r(2461);
                r(469), e.exports = n;
            },
            1165: (e, t, r)=>{
                "use strict";
                var n = r(296);
                e.exports = n;
            },
            5397: (e, t, r)=>{
                "use strict";
                var n = r(8628);
                e.exports = n;
            },
            7500: (e, t, r)=>{
                "use strict";
                var n = r(9057);
                r(469), e.exports = n;
            },
            7582: (e, t, r)=>{
                "use strict";
                var n = r(1170);
                r(469), e.exports = n;
            },
            607: (e, t, r)=>{
                "use strict";
                var n = r(5547), i = r(3454), o = TypeError;
                e.exports = function(e) {
                    if (n(e)) return e;
                    throw new o(i(e) + " is not a function");
                };
            },
            293: (e, t, r)=>{
                "use strict";
                var n = r(4942).charAt;
                e.exports = function(e, t, r) {
                    return t + (r ? n(e, t).length : 1);
                };
            },
            4738: (e, t, r)=>{
                "use strict";
                var n = r(2922), i = String, o = TypeError;
                e.exports = function(e) {
                    if (n(e)) return e;
                    throw new o(i(e) + " is not an object");
                };
            },
            3458: (e, t, r)=>{
                "use strict";
                var n = r(3238), i = r(645), o = r(1024), a = function(e) {
                    return function(t, r, a) {
                        var s, u = n(t), c = o(u), l = i(a, c);
                        if (e && r != r) {
                            for(; c > l;)if ((s = u[l++]) != s) return !0;
                        } else for(; c > l; l++)if ((e || l in u) && u[l] === r) return e || l || 0;
                        return !e && -1;
                    };
                };
                e.exports = {
                    includes: a(!0),
                    indexOf: a(!1)
                };
            },
            5067: (e, t, r)=>{
                "use strict";
                var n = r(5207), i = n({}.toString), o = n("".slice);
                e.exports = function(e) {
                    return o(i(e), 8, -1);
                };
            },
            1331: (e, t, r)=>{
                "use strict";
                var n = r(7804), i = r(5547), o = r(5067), a = r(5553)("toStringTag"), s = Object, u = "Arguments" === o(function() {
                    return arguments;
                }());
                e.exports = n ? o : function(e) {
                    var t, r, n;
                    return void 0 === e ? "Undefined" : null === e ? "Null" : "string" == typeof (r = function(e, t) {
                        try {
                            return e[t];
                        } catch (e) {}
                    }(t = s(e), a)) ? r : u ? o(t) : "Object" === (n = o(t)) && i(t.callee) ? "Arguments" : n;
                };
            },
            775: (e, t, r)=>{
                "use strict";
                var n = r(3531), i = r(66), o = r(9070), a = r(2030);
                e.exports = function(e, t, r) {
                    for(var s = i(t), u = a.f, c = o.f, l = 0; l < s.length; l++){
                        var f = s[l];
                        n(e, f) || r && n(r, f) || u(e, f, c(t, f));
                    }
                };
            },
            9238: (e, t, r)=>{
                "use strict";
                var n = r(4694), i = r(2030), o = r(7999);
                e.exports = n ? function(e, t, r) {
                    return i.f(e, t, o(1, r));
                } : function(e, t, r) {
                    return e[t] = r, e;
                };
            },
            7999: (e)=>{
                "use strict";
                e.exports = function(e, t) {
                    return {
                        enumerable: !(1 & e),
                        configurable: !(2 & e),
                        writable: !(4 & e),
                        value: t
                    };
                };
            },
            3300: (e, t, r)=>{
                "use strict";
                var n = r(5547), i = r(2030), o = r(6543), a = r(4143);
                e.exports = function(e, t, r, s) {
                    s || (s = {});
                    var u = s.enumerable, c = void 0 !== s.name ? s.name : t;
                    if (n(r) && o(r, c, s), s.global) u ? e[t] = r : a(t, r);
                    else {
                        try {
                            s.unsafe ? e[t] && (u = !0) : delete e[t];
                        } catch (e) {}
                        u ? e[t] = r : i.f(e, t, {
                            value: r,
                            enumerable: !1,
                            configurable: !s.nonConfigurable,
                            writable: !s.nonWritable
                        });
                    }
                    return e;
                };
            },
            4143: (e, t, r)=>{
                "use strict";
                var n = r(5628), i = Object.defineProperty;
                e.exports = function(e, t) {
                    try {
                        i(n, e, {
                            value: t,
                            configurable: !0,
                            writable: !0
                        });
                    } catch (r) {
                        n[e] = t;
                    }
                    return t;
                };
            },
            4694: (e, t, r)=>{
                "use strict";
                var n = r(5392);
                e.exports = !n(function() {
                    return 7 !== Object.defineProperty({}, 1, {
                        get: function() {
                            return 7;
                        }
                    })[1];
                });
            },
            7694: (e, t, r)=>{
                "use strict";
                var n = r(5628), i = r(2922), o = n.document, a = i(o) && i(o.createElement);
                e.exports = function(e) {
                    return a ? o.createElement(e) : {};
                };
            },
            8270: (e)=>{
                "use strict";
                e.exports = "undefined" != typeof navigator && String(navigator.userAgent) || "";
            },
            6262: (e, t, r)=>{
                "use strict";
                var n, i, o = r(5628), a = r(8270), s = o.process, u = o.Deno, c = s && s.versions || u && u.version, l = c && c.v8;
                l && (i = (n = l.split("."))[0] > 0 && n[0] < 4 ? 1 : +(n[0] + n[1])), !i && a && (!(n = a.match(/Edge\/(\d+)/)) || n[1] >= 74) && (n = a.match(/Chrome\/(\d+)/)) && (i = +n[1]), e.exports = i;
            },
            1989: (e)=>{
                "use strict";
                e.exports = [
                    "constructor",
                    "hasOwnProperty",
                    "isPrototypeOf",
                    "propertyIsEnumerable",
                    "toLocaleString",
                    "toString",
                    "valueOf"
                ];
            },
            3937: (e, t, r)=>{
                "use strict";
                var n = r(5628), i = r(9070).f, o = r(9238), a = r(3300), s = r(4143), u = r(775), c = r(5416);
                e.exports = function(e, t) {
                    var r, l, f, p, d, h = e.target, v = e.global, m = e.stat;
                    if (r = v ? n : m ? n[h] || s(h, {}) : (n[h] || {}).prototype) for(l in t){
                        if (p = t[l], f = e.dontCallGetSet ? (d = i(r, l)) && d.value : r[l], !c(v ? l : h + (m ? "." : "#") + l, e.forced) && void 0 !== f) {
                            if (typeof p == typeof f) continue;
                            u(p, f);
                        }
                        (e.sham || f && f.sham) && o(p, "sham", !0), a(r, l, p, e);
                    }
                };
            },
            5392: (e)=>{
                "use strict";
                e.exports = function(e) {
                    try {
                        return !!e();
                    } catch (e) {
                        return !0;
                    }
                };
            },
            9041: (e, t, r)=>{
                "use strict";
                r(6433);
                var n = r(8209), i = r(3300), o = r(4493), a = r(5392), s = r(5553), u = r(9238), c = s("species"), l = RegExp.prototype;
                e.exports = function(e, t, r, f) {
                    var p = s(e), d = !a(function() {
                        var t = {};
                        return t[p] = function() {
                            return 7;
                        }, 7 !== ""[e](t);
                    }), h = d && !a(function() {
                        var t = !1, r = /a/;
                        return "split" === e && ((r = {}).constructor = {}, r.constructor[c] = function() {
                            return r;
                        }, r.flags = "", r[p] = /./[p]), r.exec = function() {
                            return t = !0, null;
                        }, r[p](""), !t;
                    });
                    if (!d || !h || r) {
                        var v = n(/./[p]), m = t(p, ""[e], function(e, t, r, i, a) {
                            var s = n(e), u = t.exec;
                            return u === o || u === l.exec ? d && !a ? {
                                done: !0,
                                value: v(t, r, i)
                            } : {
                                done: !0,
                                value: s(r, t, i)
                            } : {
                                done: !1
                            };
                        });
                        i(String.prototype, e, m[0]), i(l, p, m[1]);
                    }
                    f && u(l[p], "sham", !0);
                };
            },
            9500: (e, t, r)=>{
                "use strict";
                var n = r(9232), i = Function.prototype, o = i.apply, a = i.call;
                e.exports = "object" == typeof Reflect && Reflect.apply || (n ? a.bind(o) : function() {
                    return a.apply(o, arguments);
                });
            },
            9232: (e, t, r)=>{
                "use strict";
                var n = r(5392);
                e.exports = !n(function() {
                    var e = (function() {}).bind();
                    return "function" != typeof e || e.hasOwnProperty("prototype");
                });
            },
            5304: (e, t, r)=>{
                "use strict";
                var n = r(9232), i = Function.prototype.call;
                e.exports = n ? i.bind(i) : function() {
                    return i.apply(i, arguments);
                };
            },
            4930: (e, t, r)=>{
                "use strict";
                var n = r(4694), i = r(3531), o = Function.prototype, a = n && Object.getOwnPropertyDescriptor, s = i(o, "name"), u = s && "something" === (function() {}).name, c = s && (!n || n && a(o, "name").configurable);
                e.exports = {
                    EXISTS: s,
                    PROPER: u,
                    CONFIGURABLE: c
                };
            },
            8209: (e, t, r)=>{
                "use strict";
                var n = r(5067), i = r(5207);
                e.exports = function(e) {
                    if ("Function" === n(e)) return i(e);
                };
            },
            5207: (e, t, r)=>{
                "use strict";
                var n = r(9232), i = Function.prototype, o = i.call, a = n && i.bind.bind(o, o);
                e.exports = n ? a : function(e) {
                    return function() {
                        return o.apply(e, arguments);
                    };
                };
            },
            6341: (e, t, r)=>{
                "use strict";
                var n = r(5628), i = r(5547);
                e.exports = function(e, t) {
                    var r;
                    return arguments.length < 2 ? i(r = n[e]) ? r : void 0 : n[e] && n[e][t];
                };
            },
            2698: (e, t, r)=>{
                "use strict";
                var n = r(607), i = r(7930);
                e.exports = function(e, t) {
                    var r = e[t];
                    return i(r) ? void 0 : n(r);
                };
            },
            5095: (e, t, r)=>{
                "use strict";
                var n = r(5207), i = r(4874), o = Math.floor, a = n("".charAt), s = n("".replace), u = n("".slice), c = /\$([$&'`]|\d{1,2}|<[^>]*>)/g, l = /\$([$&'`]|\d{1,2})/g;
                e.exports = function(e, t, r, n, f, p) {
                    var d = r + e.length, h = n.length, v = l;
                    return void 0 !== f && (f = i(f), v = c), s(p, v, function(i, s) {
                        var c;
                        switch(a(s, 0)){
                            case "$":
                                return "$";
                            case "&":
                                return e;
                            case "`":
                                return u(t, 0, r);
                            case "'":
                                return u(t, d);
                            case "<":
                                c = f[u(s, 1, -1)];
                                break;
                            default:
                                var l = +s;
                                if (0 === l) return i;
                                if (l > h) {
                                    var p = o(l / 10);
                                    return 0 === p ? i : p <= h ? void 0 === n[p - 1] ? a(s, 1) : n[p - 1] + a(s, 1) : i;
                                }
                                c = n[l - 1];
                        }
                        return void 0 === c ? "" : c;
                    });
                };
            },
            5628: function(e, t, r) {
                "use strict";
                var n = function(e) {
                    return e && e.Math === Math && e;
                };
                e.exports = n("object" == typeof globalThis && globalThis) || n("object" == typeof window && window) || n("object" == typeof self && self) || n("object" == typeof r.g && r.g) || n("object" == typeof this && this) || function() {
                    return this;
                }() || Function("return this")();
            },
            3531: (e, t, r)=>{
                "use strict";
                var n = r(5207), i = r(4874), o = n({}.hasOwnProperty);
                e.exports = Object.hasOwn || function(e, t) {
                    return o(i(e), t);
                };
            },
            6710: (e)=>{
                "use strict";
                e.exports = {};
            },
            5913: (e, t, r)=>{
                "use strict";
                var n = r(6341);
                e.exports = n("document", "documentElement");
            },
            7199: (e, t, r)=>{
                "use strict";
                var n = r(4694), i = r(5392), o = r(7694);
                e.exports = !n && !i(function() {
                    return 7 !== Object.defineProperty(o("div"), "a", {
                        get: function() {
                            return 7;
                        }
                    }).a;
                });
            },
            3415: (e, t, r)=>{
                "use strict";
                var n = r(5207), i = r(5392), o = r(5067), a = Object, s = n("".split);
                e.exports = i(function() {
                    return !a("z").propertyIsEnumerable(0);
                }) ? function(e) {
                    return "String" === o(e) ? s(e, "") : a(e);
                } : a;
            },
            8833: (e, t, r)=>{
                "use strict";
                var n = r(5207), i = r(5547), o = r(8866), a = n(Function.toString);
                i(o.inspectSource) || (o.inspectSource = function(e) {
                    return a(e);
                }), e.exports = o.inspectSource;
            },
            5972: (e, t, r)=>{
                "use strict";
                var n, i, o, a = r(1337), s = r(5628), u = r(2922), c = r(9238), l = r(3531), f = r(8866), p = r(2992), d = r(6710), h = "Object already initialized", v = s.TypeError;
                if (a || f.state) {
                    var m = f.state || (f.state = new s.WeakMap);
                    m.get = m.get, m.has = m.has, m.set = m.set, n = function(e, t) {
                        if (m.has(e)) throw new v(h);
                        return t.facade = e, m.set(e, t), t;
                    }, i = function(e) {
                        return m.get(e) || {};
                    }, o = function(e) {
                        return m.has(e);
                    };
                } else {
                    var y = p("state");
                    d[y] = !0, n = function(e, t) {
                        if (l(e, y)) throw new v(h);
                        return t.facade = e, c(e, y, t), t;
                    }, i = function(e) {
                        return l(e, y) ? e[y] : {};
                    }, o = function(e) {
                        return l(e, y);
                    };
                }
                e.exports = {
                    set: n,
                    get: i,
                    has: o,
                    enforce: function(e) {
                        return o(e) ? i(e) : n(e, {});
                    },
                    getterFor: function(e) {
                        return function(t) {
                            var r;
                            if (!u(t) || (r = i(t)).type !== e) throw new v("Incompatible receiver, " + e + " required");
                            return r;
                        };
                    }
                };
            },
            5547: (e)=>{
                "use strict";
                var t = "object" == typeof document && document.all;
                e.exports = void 0 === t && void 0 !== t ? function(e) {
                    return "function" == typeof e || e === t;
                } : function(e) {
                    return "function" == typeof e;
                };
            },
            5416: (e, t, r)=>{
                "use strict";
                var n = r(5392), i = r(5547), o = /#|\.prototype\./, a = function(e, t) {
                    var r = u[s(e)];
                    return r === l || r !== c && (i(t) ? n(t) : !!t);
                }, s = a.normalize = function(e) {
                    return String(e).replace(o, ".").toLowerCase();
                }, u = a.data = {}, c = a.NATIVE = "N", l = a.POLYFILL = "P";
                e.exports = a;
            },
            7930: (e)=>{
                "use strict";
                e.exports = function(e) {
                    return null == e;
                };
            },
            2922: (e, t, r)=>{
                "use strict";
                var n = r(5547);
                e.exports = function(e) {
                    return "object" == typeof e ? null !== e : n(e);
                };
            },
            5988: (e)=>{
                "use strict";
                e.exports = !1;
            },
            6610: (e, t, r)=>{
                "use strict";
                var n = r(6341), i = r(5547), o = r(5692), a = r(8675), s = Object;
                e.exports = a ? function(e) {
                    return "symbol" == typeof e;
                } : function(e) {
                    var t = n("Symbol");
                    return i(t) && o(t.prototype, s(e));
                };
            },
            1024: (e, t, r)=>{
                "use strict";
                var n = r(7450);
                e.exports = function(e) {
                    return n(e.length);
                };
            },
            6543: (e, t, r)=>{
                "use strict";
                var n = r(5207), i = r(5392), o = r(5547), a = r(3531), s = r(4694), u = r(4930).CONFIGURABLE, c = r(8833), l = r(5972), f = l.enforce, p = l.get, d = String, h = Object.defineProperty, v = n("".slice), m = n("".replace), y = n([].join), g = s && !i(function() {
                    return 8 !== h(function() {}, "length", {
                        value: 8
                    }).length;
                }), E = String(String).split("String"), b = e.exports = function(e, t, r) {
                    "Symbol(" === v(d(t), 0, 7) && (t = "[" + m(d(t), /^Symbol\(([^)]*)\)/, "$1") + "]"), r && r.getter && (t = "get " + t), r && r.setter && (t = "set " + t), (!a(e, "name") || u && e.name !== t) && (s ? h(e, "name", {
                        value: t,
                        configurable: !0
                    }) : e.name = t), g && r && a(r, "arity") && e.length !== r.arity && h(e, "length", {
                        value: r.arity
                    });
                    try {
                        r && a(r, "constructor") && r.constructor ? s && h(e, "prototype", {
                            writable: !1
                        }) : e.prototype && (e.prototype = void 0);
                    } catch (e) {}
                    var n = f(e);
                    return a(n, "source") || (n.source = y(E, "string" == typeof t ? t : "")), e;
                };
                Function.prototype.toString = b(function() {
                    return o(this) && p(this).source || c(this);
                }, "toString");
            },
            5779: (e)=>{
                "use strict";
                var t = Math.ceil, r = Math.floor;
                e.exports = Math.trunc || function(e) {
                    var n = +e;
                    return (n > 0 ? r : t)(n);
                };
            },
            5572: (e, t, r)=>{
                "use strict";
                var n, i = r(4738), o = r(3742), a = r(1989), s = r(6710), u = r(5913), c = r(7694), l = r(2992), f = "prototype", p = "script", d = l("IE_PROTO"), h = function() {}, v = function(e) {
                    return "<" + p + ">" + e + "</" + p + ">";
                }, m = function(e) {
                    e.write(v("")), e.close();
                    var t = e.parentWindow.Object;
                    return e = null, t;
                }, y = function() {
                    try {
                        n = new ActiveXObject("htmlfile");
                    } catch (e) {}
                    var e, t, r;
                    y = "undefined" != typeof document ? document.domain && n ? m(n) : (t = c("iframe"), r = "java" + p + ":", t.style.display = "none", u.appendChild(t), t.src = String(r), (e = t.contentWindow.document).open(), e.write(v("document.F=Object")), e.close(), e.F) : m(n);
                    for(var i = a.length; i--;)delete y[f][a[i]];
                    return y();
                };
                s[d] = !0, e.exports = Object.create || function(e, t) {
                    var r;
                    return null !== e ? (h[f] = i(e), r = new h, h[f] = null, r[d] = e) : r = y(), void 0 === t ? r : o.f(r, t);
                };
            },
            3742: (e, t, r)=>{
                "use strict";
                var n = r(4694), i = r(1089), o = r(2030), a = r(4738), s = r(3238), u = r(5265);
                t.f = n && !i ? Object.defineProperties : function(e, t) {
                    a(e);
                    for(var r, n = s(t), i = u(t), c = i.length, l = 0; c > l;)o.f(e, r = i[l++], n[r]);
                    return e;
                };
            },
            2030: (e, t, r)=>{
                "use strict";
                var n = r(4694), i = r(7199), o = r(1089), a = r(4738), s = r(3561), u = TypeError, c = Object.defineProperty, l = Object.getOwnPropertyDescriptor, f = "enumerable", p = "configurable", d = "writable";
                t.f = n ? o ? function(e, t, r) {
                    if (a(e), t = s(t), a(r), "function" == typeof e && "prototype" === t && "value" in r && d in r && !r[d]) {
                        var n = l(e, t);
                        n && n[d] && (e[t] = r.value, r = {
                            configurable: p in r ? r[p] : n[p],
                            enumerable: f in r ? r[f] : n[f],
                            writable: !1
                        });
                    }
                    return c(e, t, r);
                } : c : function(e, t, r) {
                    if (a(e), t = s(t), a(r), i) try {
                        return c(e, t, r);
                    } catch (e) {}
                    if ("get" in r || "set" in r) throw new u("Accessors not supported");
                    return "value" in r && (e[t] = r.value), e;
                };
            },
            9070: (e, t, r)=>{
                "use strict";
                var n = r(4694), i = r(5304), o = r(5085), a = r(7999), s = r(3238), u = r(3561), c = r(3531), l = r(7199), f = Object.getOwnPropertyDescriptor;
                t.f = n ? f : function(e, t) {
                    if (e = s(e), t = u(t), l) try {
                        return f(e, t);
                    } catch (e) {}
                    if (c(e, t)) return a(!i(o.f, e, t), e[t]);
                };
            },
            3817: (e, t, r)=>{
                "use strict";
                var n = r(9864), i = r(1989).concat("length", "prototype");
                t.f = Object.getOwnPropertyNames || function(e) {
                    return n(e, i);
                };
            },
            68: (e, t)=>{
                "use strict";
                t.f = Object.getOwnPropertySymbols;
            },
            5692: (e, t, r)=>{
                "use strict";
                var n = r(5207);
                e.exports = n({}.isPrototypeOf);
            },
            9864: (e, t, r)=>{
                "use strict";
                var n = r(5207), i = r(3531), o = r(3238), a = r(3458).indexOf, s = r(6710), u = n([].push);
                e.exports = function(e, t) {
                    var r, n = o(e), c = 0, l = [];
                    for(r in n)!i(s, r) && i(n, r) && u(l, r);
                    for(; t.length > c;)i(n, r = t[c++]) && (~a(l, r) || u(l, r));
                    return l;
                };
            },
            5265: (e, t, r)=>{
                "use strict";
                var n = r(9864), i = r(1989);
                e.exports = Object.keys || function(e) {
                    return n(e, i);
                };
            },
            5085: (e, t)=>{
                "use strict";
                var r = {}.propertyIsEnumerable, n = Object.getOwnPropertyDescriptor, i = n && !r.call({
                    1: 2
                }, 1);
                t.f = i ? function(e) {
                    var t = n(this, e);
                    return !!t && t.enumerable;
                } : r;
            },
            3085: (e, t, r)=>{
                "use strict";
                var n = r(5304), i = r(5547), o = r(2922), a = TypeError;
                e.exports = function(e, t) {
                    var r, s;
                    if ("string" === t && i(r = e.toString) && !o(s = n(r, e))) return s;
                    if (i(r = e.valueOf) && !o(s = n(r, e))) return s;
                    if ("string" !== t && i(r = e.toString) && !o(s = n(r, e))) return s;
                    throw new a("Can't convert object to primitive value");
                };
            },
            66: (e, t, r)=>{
                "use strict";
                var n = r(6341), i = r(5207), o = r(3817), a = r(68), s = r(4738), u = i([].concat);
                e.exports = n("Reflect", "ownKeys") || function(e) {
                    var t = o.f(s(e)), r = a.f;
                    return r ? u(t, r(e)) : t;
                };
            },
            2493: (e, t, r)=>{
                "use strict";
                var n = r(5304), i = r(4738), o = r(5547), a = r(5067), s = r(4493), u = TypeError;
                e.exports = function(e, t) {
                    var r = e.exec;
                    if (o(r)) {
                        var c = n(r, e, t);
                        return null !== c && i(c), c;
                    }
                    if ("RegExp" === a(e)) return n(s, e, t);
                    throw new u("RegExp#exec called on incompatible receiver");
                };
            },
            4493: (e, t, r)=>{
                "use strict";
                var n, i, o = r(5304), a = r(5207), s = r(9338), u = r(5337), c = r(2053), l = r(7995), f = r(5572), p = r(5972).get, d = r(9383), h = r(3275), v = l("native-string-replace", String.prototype.replace), m = RegExp.prototype.exec, y = m, g = a("".charAt), E = a("".indexOf), b = a("".replace), S = a("".slice), _ = (i = /b*/g, o(m, n = /a/, "a"), o(m, i, "a"), 0 !== n.lastIndex || 0 !== i.lastIndex), w = c.BROKEN_CARET, O = void 0 !== /()??/.exec("")[1];
                (_ || O || w || d || h) && (y = function(e) {
                    var t, r, n, i, a, c, l, d = this, h = p(d), T = s(e), I = h.raw;
                    if (I) return I.lastIndex = d.lastIndex, t = o(y, I, T), d.lastIndex = I.lastIndex, t;
                    var R = h.groups, x = w && d.sticky, A = o(u, d), N = d.source, C = 0, k = T;
                    if (x && (A = b(A, "y", ""), -1 === E(A, "g") && (A += "g"), k = S(T, d.lastIndex), d.lastIndex > 0 && (!d.multiline || d.multiline && "\n" !== g(T, d.lastIndex - 1)) && (N = "(?: " + N + ")", k = " " + k, C++), r = new RegExp("^(?:" + N + ")", A)), O && (r = new RegExp("^" + N + "$(?!\\s)", A)), _ && (n = d.lastIndex), i = o(m, x ? r : d, k), x ? i ? (i.input = S(i.input, C), i[0] = S(i[0], C), i.index = d.lastIndex, d.lastIndex += i[0].length) : d.lastIndex = 0 : _ && i && (d.lastIndex = d.global ? i.index + i[0].length : n), O && i && i.length > 1 && o(v, i[0], r, function() {
                        for(a = 1; a < arguments.length - 2; a++)void 0 === arguments[a] && (i[a] = void 0);
                    }), i && R) for(i.groups = c = f(null), a = 0; a < R.length; a++)c[(l = R[a])[0]] = i[l[1]];
                    return i;
                }), e.exports = y;
            },
            5337: (e, t, r)=>{
                "use strict";
                var n = r(4738);
                e.exports = function() {
                    var e = n(this), t = "";
                    return e.hasIndices && (t += "d"), e.global && (t += "g"), e.ignoreCase && (t += "i"), e.multiline && (t += "m"), e.dotAll && (t += "s"), e.unicode && (t += "u"), e.unicodeSets && (t += "v"), e.sticky && (t += "y"), t;
                };
            },
            2053: (e, t, r)=>{
                "use strict";
                var n = r(5392), i = r(5628).RegExp, o = n(function() {
                    var e = i("a", "y");
                    return e.lastIndex = 2, null !== e.exec("abcd");
                }), a = o || n(function() {
                    return !i("a", "y").sticky;
                }), s = o || n(function() {
                    var e = i("^r", "gy");
                    return e.lastIndex = 2, null !== e.exec("str");
                });
                e.exports = {
                    BROKEN_CARET: s,
                    MISSED_STICKY: a,
                    UNSUPPORTED_Y: o
                };
            },
            9383: (e, t, r)=>{
                "use strict";
                var n = r(5392), i = r(5628).RegExp;
                e.exports = n(function() {
                    var e = i(".", "s");
                    return !(e.dotAll && e.test("\n") && "s" === e.flags);
                });
            },
            3275: (e, t, r)=>{
                "use strict";
                var n = r(5392), i = r(5628).RegExp;
                e.exports = n(function() {
                    var e = i("(?<a>b)", "g");
                    return "b" !== e.exec("b").groups.a || "bc" !== "b".replace(e, "$<a>c");
                });
            },
            4202: (e, t, r)=>{
                "use strict";
                var n = r(7930), i = TypeError;
                e.exports = function(e) {
                    if (n(e)) throw new i("Can't call method on " + e);
                    return e;
                };
            },
            2992: (e, t, r)=>{
                "use strict";
                var n = r(7995), i = r(1188), o = n("keys");
                e.exports = function(e) {
                    return o[e] || (o[e] = i(e));
                };
            },
            8866: (e, t, r)=>{
                "use strict";
                var n = r(5628), i = r(4143), o = "__core-js_shared__", a = n[o] || i(o, {});
                e.exports = a;
            },
            7995: (e, t, r)=>{
                "use strict";
                var n = r(5988), i = r(8866);
                (e.exports = function(e, t) {
                    return i[e] || (i[e] = void 0 !== t ? t : {});
                })("versions", []).push({
                    version: "3.35.0",
                    mode: n ? "pure" : "global",
                    copyright: "\xa9 2014-2023 Denis Pushkarev (zloirock.ru)",
                    license: "https://github.com/zloirock/core-js/blob/v3.35.0/LICENSE",
                    source: "https://github.com/zloirock/core-js"
                });
            },
            4942: (e, t, r)=>{
                "use strict";
                var n = r(5207), i = r(2501), o = r(9338), a = r(4202), s = n("".charAt), u = n("".charCodeAt), c = n("".slice), l = function(e) {
                    return function(t, r) {
                        var n, l, f = o(a(t)), p = i(r), d = f.length;
                        return p < 0 || p >= d ? e ? "" : void 0 : (n = u(f, p)) < 55296 || n > 56319 || p + 1 === d || (l = u(f, p + 1)) < 56320 || l > 57343 ? e ? s(f, p) : n : e ? c(f, p, p + 2) : l - 56320 + (n - 55296 << 10) + 65536;
                    };
                };
                e.exports = {
                    codeAt: l(!1),
                    charAt: l(!0)
                };
            },
            2083: (e, t, r)=>{
                "use strict";
                var n = r(6262), i = r(5392), o = r(5628).String;
                e.exports = !!Object.getOwnPropertySymbols && !i(function() {
                    var e = Symbol("symbol detection");
                    return !o(e) || !(Object(e) instanceof Symbol) || !Symbol.sham && n && n < 41;
                });
            },
            645: (e, t, r)=>{
                "use strict";
                var n = r(2501), i = Math.max, o = Math.min;
                e.exports = function(e, t) {
                    var r = n(e);
                    return r < 0 ? i(r + t, 0) : o(r, t);
                };
            },
            3238: (e, t, r)=>{
                "use strict";
                var n = r(3415), i = r(4202);
                e.exports = function(e) {
                    return n(i(e));
                };
            },
            2501: (e, t, r)=>{
                "use strict";
                var n = r(5779);
                e.exports = function(e) {
                    var t = +e;
                    return t != t || 0 === t ? 0 : n(t);
                };
            },
            7450: (e, t, r)=>{
                "use strict";
                var n = r(2501), i = Math.min;
                e.exports = function(e) {
                    return e > 0 ? i(n(e), 9007199254740991) : 0;
                };
            },
            4874: (e, t, r)=>{
                "use strict";
                var n = r(4202), i = Object;
                e.exports = function(e) {
                    return i(n(e));
                };
            },
            1086: (e, t, r)=>{
                "use strict";
                var n = r(5304), i = r(2922), o = r(6610), a = r(2698), s = r(3085), u = r(5553), c = TypeError, l = u("toPrimitive");
                e.exports = function(e, t) {
                    if (!i(e) || o(e)) return e;
                    var r, u = a(e, l);
                    if (u) {
                        if (void 0 === t && (t = "default"), r = n(u, e, t), !i(r) || o(r)) return r;
                        throw new c("Can't convert object to primitive value");
                    }
                    return void 0 === t && (t = "number"), s(e, t);
                };
            },
            3561: (e, t, r)=>{
                "use strict";
                var n = r(1086), i = r(6610);
                e.exports = function(e) {
                    var t = n(e, "string");
                    return i(t) ? t : t + "";
                };
            },
            7804: (e, t, r)=>{
                "use strict";
                var n = {};
                n[r(5553)("toStringTag")] = "z", e.exports = "[object z]" === String(n);
            },
            9338: (e, t, r)=>{
                "use strict";
                var n = r(1331), i = String;
                e.exports = function(e) {
                    if ("Symbol" === n(e)) throw new TypeError("Cannot convert a Symbol value to a string");
                    return i(e);
                };
            },
            3454: (e)=>{
                "use strict";
                var t = String;
                e.exports = function(e) {
                    try {
                        return t(e);
                    } catch (e) {
                        return "Object";
                    }
                };
            },
            1188: (e, t, r)=>{
                "use strict";
                var n = r(5207), i = 0, o = Math.random(), a = n(1..toString);
                e.exports = function(e) {
                    return "Symbol(" + (void 0 === e ? "" : e) + ")_" + a(++i + o, 36);
                };
            },
            8675: (e, t, r)=>{
                "use strict";
                var n = r(2083);
                e.exports = n && !Symbol.sham && "symbol" == typeof Symbol.iterator;
            },
            1089: (e, t, r)=>{
                "use strict";
                var n = r(4694), i = r(5392);
                e.exports = n && i(function() {
                    return 42 !== Object.defineProperty(function() {}, "prototype", {
                        value: 42,
                        writable: !1
                    }).prototype;
                });
            },
            1337: (e, t, r)=>{
                "use strict";
                var n = r(5628), i = r(5547), o = n.WeakMap;
                e.exports = i(o) && /native code/.test(String(o));
            },
            5553: (e, t, r)=>{
                "use strict";
                var n = r(5628), i = r(7995), o = r(3531), a = r(1188), s = r(2083), u = r(8675), c = n.Symbol, l = i("wks"), f = u ? c.for || c : c && c.withoutSetter || a;
                e.exports = function(e) {
                    return o(l, e) || (l[e] = s && o(c, e) ? c[e] : f("Symbol." + e)), l[e];
                };
            },
            6433: (e, t, r)=>{
                "use strict";
                var n = r(3937), i = r(4493);
                n({
                    target: "RegExp",
                    proto: !0,
                    forced: /./.exec !== i
                }, {
                    exec: i
                });
            },
            9064: (e, t, r)=>{
                "use strict";
                var n = r(9500), i = r(5304), o = r(5207), a = r(9041), s = r(5392), u = r(4738), c = r(5547), l = r(7930), f = r(2501), p = r(7450), d = r(9338), h = r(4202), v = r(293), m = r(2698), y = r(5095), g = r(2493), E = r(5553)("replace"), b = Math.max, S = Math.min, _ = o([].concat), w = o([].push), O = o("".indexOf), T = o("".slice), I = "$0" === "a".replace(/./, "$0"), R = !!/./[E] && "" === /./[E]("a", "$0");
                a("replace", function(e, t, r) {
                    var o = R ? "$" : "$0";
                    return [
                        function(e, r) {
                            var n = h(this), o = l(e) ? void 0 : m(e, E);
                            return o ? i(o, e, n, r) : i(t, d(n), e, r);
                        },
                        function(e, i) {
                            var a = u(this), s = d(e);
                            if ("string" == typeof i && -1 === O(i, o) && -1 === O(i, "$<")) {
                                var l = r(t, a, s, i);
                                if (l.done) return l.value;
                            }
                            var h = c(i);
                            h || (i = d(i));
                            var m, E = a.global;
                            E && (m = a.unicode, a.lastIndex = 0);
                            for(var I, R = []; null !== (I = g(a, s)) && (w(R, I), E);)"" === d(I[0]) && (a.lastIndex = v(s, p(a.lastIndex), m));
                            for(var x, A = "", N = 0, C = 0; C < R.length; C++){
                                for(var k, M = d((I = R[C])[0]), P = b(S(f(I.index), s.length), 0), D = [], F = 1; F < I.length; F++)w(D, void 0 === (x = I[F]) ? x : String(x));
                                var L = I.groups;
                                if (h) {
                                    var j = _([
                                        M
                                    ], D, P, s);
                                    void 0 !== L && w(j, L), k = d(n(i, void 0, j));
                                } else k = y(M, s, P, D, L, i);
                                P >= N && (A += T(s, N, P) + k, N = P + M.length);
                            }
                            return A + T(s, N);
                        }
                    ];
                }, !!s(function() {
                    var e = /./;
                    return e.exec = function() {
                        var e = [];
                        return e.groups = {
                            a: "7"
                        }, e;
                    }, "7" !== "".replace(e, "$<a>");
                }) || !I || R);
            },
            4636: (e, t, r)=>{
                "use strict";
                r.d(t, {
                    Z: ()=>s
                });
                var n = r(8921);
                function i(e) {
                    return i = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                        return typeof e;
                    } : function(e) {
                        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                    }, i(e);
                }
                var o = 10, a = 2;
                function s(e) {
                    return u(e, []);
                }
                function u(e, t) {
                    switch(i(e)){
                        case "string":
                            return JSON.stringify(e);
                        case "function":
                            return e.name ? "[function ".concat(e.name, "]") : "[function]";
                        case "object":
                            return null === e ? "null" : function(e, t) {
                                if (-1 !== t.indexOf(e)) return "[Circular]";
                                var r = [].concat(t, [
                                    e
                                ]), i = function(e) {
                                    var t = e[String(n.Z)];
                                    if ("function" == typeof t) return t;
                                    if ("function" == typeof e.inspect) return e.inspect;
                                }(e);
                                if (void 0 !== i) {
                                    var s = i.call(e);
                                    if (s !== e) return "string" == typeof s ? s : u(s, r);
                                } else if (Array.isArray(e)) return function(e, t) {
                                    if (0 === e.length) return "[]";
                                    if (t.length > a) return "[Array]";
                                    for(var r = Math.min(o, e.length), n = e.length - r, i = [], s = 0; s < r; ++s)i.push(u(e[s], t));
                                    1 === n ? i.push("... 1 more item") : n > 1 && i.push("... ".concat(n, " more items"));
                                    return "[" + i.join(", ") + "]";
                                }(e, r);
                                return function(e, t) {
                                    var r = Object.keys(e);
                                    if (0 === r.length) return "{}";
                                    if (t.length > a) return "[" + function(e) {
                                        var t = Object.prototype.toString.call(e).replace(/^\[object /, "").replace(/]$/, "");
                                        if ("Object" === t && "function" == typeof e.constructor) {
                                            var r = e.constructor.name;
                                            if ("string" == typeof r && "" !== r) return r;
                                        }
                                        return t;
                                    }(e) + "]";
                                    var n = r.map(function(r) {
                                        return r + ": " + u(e[r], t);
                                    });
                                    return "{ " + n.join(", ") + " }";
                                }(e, r);
                            }(e, t);
                        default:
                            return String(e);
                    }
                }
            },
            8921: (e, t, r)=>{
                "use strict";
                r.d(t, {
                    Z: ()=>n
                });
                const n = "function" == typeof Symbol && "function" == typeof Symbol.for ? Symbol.for("nodejs.util.inspect.custom") : void 0;
            },
            3306: (e, t, r)=>{
                "use strict";
                function n(e) {
                    var t = e.split(/\r\n|[\n\r]/g), r = function(e) {
                        for(var t = null, r = 1; r < e.length; r++){
                            var n = e[r], o = i(n);
                            if (o !== n.length && (null === t || o < t) && 0 === (t = o)) break;
                        }
                        return null === t ? 0 : t;
                    }(t);
                    if (0 !== r) for(var n = 1; n < t.length; n++)t[n] = t[n].slice(r);
                    for(; t.length > 0 && o(t[0]);)t.shift();
                    for(; t.length > 0 && o(t[t.length - 1]);)t.pop();
                    return t.join("\n");
                }
                function i(e) {
                    for(var t = 0; t < e.length && (" " === e[t] || "\t" === e[t]);)t++;
                    return t;
                }
                function o(e) {
                    return i(e) === e.length;
                }
                function a(e) {
                    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "", r = arguments.length > 2 && void 0 !== arguments[2] && arguments[2], n = -1 === e.indexOf("\n"), i = !n || '"' === e[e.length - 1] || r, o = "";
                    return !i || n && (" " === e[0] || "\t" === e[0]) || (o += "\n" + t), o += t ? e.replace(/\n/g, "\n" + t) : e, i && (o += "\n"), '"""' + o.replace(/"""/g, '\\"""') + '"""';
                }
                r.d(t, {
                    LZ: ()=>a,
                    W7: ()=>n
                });
            },
            7525: (e, t, r)=>{
                "use strict";
                r.d(t, {
                    $_: ()=>o,
                    Vn: ()=>a
                });
                var n = r(4636), i = {
                    Name: [],
                    Document: [
                        "definitions"
                    ],
                    OperationDefinition: [
                        "name",
                        "variableDefinitions",
                        "directives",
                        "selectionSet"
                    ],
                    VariableDefinition: [
                        "variable",
                        "type",
                        "defaultValue",
                        "directives"
                    ],
                    Variable: [
                        "name"
                    ],
                    SelectionSet: [
                        "selections"
                    ],
                    Field: [
                        "alias",
                        "name",
                        "arguments",
                        "directives",
                        "selectionSet"
                    ],
                    Argument: [
                        "name",
                        "value"
                    ],
                    FragmentSpread: [
                        "name",
                        "directives"
                    ],
                    InlineFragment: [
                        "typeCondition",
                        "directives",
                        "selectionSet"
                    ],
                    FragmentDefinition: [
                        "name",
                        "variableDefinitions",
                        "typeCondition",
                        "directives",
                        "selectionSet"
                    ],
                    IntValue: [],
                    FloatValue: [],
                    StringValue: [],
                    BooleanValue: [],
                    NullValue: [],
                    EnumValue: [],
                    ListValue: [
                        "values"
                    ],
                    ObjectValue: [
                        "fields"
                    ],
                    ObjectField: [
                        "name",
                        "value"
                    ],
                    Directive: [
                        "name",
                        "arguments"
                    ],
                    NamedType: [
                        "name"
                    ],
                    ListType: [
                        "type"
                    ],
                    NonNullType: [
                        "type"
                    ],
                    SchemaDefinition: [
                        "directives",
                        "operationTypes"
                    ],
                    OperationTypeDefinition: [
                        "type"
                    ],
                    ScalarTypeDefinition: [
                        "description",
                        "name",
                        "directives"
                    ],
                    ObjectTypeDefinition: [
                        "description",
                        "name",
                        "interfaces",
                        "directives",
                        "fields"
                    ],
                    FieldDefinition: [
                        "description",
                        "name",
                        "arguments",
                        "type",
                        "directives"
                    ],
                    InputValueDefinition: [
                        "description",
                        "name",
                        "type",
                        "defaultValue",
                        "directives"
                    ],
                    InterfaceTypeDefinition: [
                        "description",
                        "name",
                        "directives",
                        "fields"
                    ],
                    UnionTypeDefinition: [
                        "description",
                        "name",
                        "directives",
                        "types"
                    ],
                    EnumTypeDefinition: [
                        "description",
                        "name",
                        "directives",
                        "values"
                    ],
                    EnumValueDefinition: [
                        "description",
                        "name",
                        "directives"
                    ],
                    InputObjectTypeDefinition: [
                        "description",
                        "name",
                        "directives",
                        "fields"
                    ],
                    DirectiveDefinition: [
                        "description",
                        "name",
                        "arguments",
                        "locations"
                    ],
                    SchemaExtension: [
                        "directives",
                        "operationTypes"
                    ],
                    ScalarTypeExtension: [
                        "name",
                        "directives"
                    ],
                    ObjectTypeExtension: [
                        "name",
                        "interfaces",
                        "directives",
                        "fields"
                    ],
                    InterfaceTypeExtension: [
                        "name",
                        "directives",
                        "fields"
                    ],
                    UnionTypeExtension: [
                        "name",
                        "directives",
                        "types"
                    ],
                    EnumTypeExtension: [
                        "name",
                        "directives",
                        "values"
                    ],
                    InputObjectTypeExtension: [
                        "name",
                        "directives",
                        "fields"
                    ]
                }, o = Object.freeze({});
                function a(e, t) {
                    var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : i, a = void 0, c = Array.isArray(e), l = [
                        e
                    ], f = -1, p = [], d = void 0, h = void 0, v = void 0, m = [], y = [], g = e;
                    do {
                        var E = ++f === l.length, b = E && 0 !== p.length;
                        if (E) {
                            if (h = 0 === y.length ? void 0 : m[m.length - 1], d = v, v = y.pop(), b) {
                                if (c) d = d.slice();
                                else {
                                    for(var S = {}, _ = 0, w = Object.keys(d); _ < w.length; _++){
                                        var O = w[_];
                                        S[O] = d[O];
                                    }
                                    d = S;
                                }
                                for(var T = 0, I = 0; I < p.length; I++){
                                    var R = p[I][0], x = p[I][1];
                                    c && (R -= T), c && null === x ? (d.splice(R, 1), T++) : d[R] = x;
                                }
                            }
                            f = a.index, l = a.keys, p = a.edits, c = a.inArray, a = a.prev;
                        } else {
                            if (h = v ? c ? f : l[f] : void 0, null == (d = v ? v[h] : g)) continue;
                            v && m.push(h);
                        }
                        var A = void 0;
                        if (!Array.isArray(d)) {
                            if (!s(d)) throw new Error("Invalid AST Node: " + (0, n.Z)(d));
                            var N = u(t, d.kind, E);
                            if (N) {
                                if ((A = N.call(t, d, h, v, m, y)) === o) break;
                                if (!1 === A) {
                                    if (!E) {
                                        m.pop();
                                        continue;
                                    }
                                } else if (void 0 !== A && (p.push([
                                    h,
                                    A
                                ]), !E)) {
                                    if (!s(A)) {
                                        m.pop();
                                        continue;
                                    }
                                    d = A;
                                }
                            }
                        }
                        void 0 === A && b && p.push([
                            h,
                            d
                        ]), E ? m.pop() : (a = {
                            inArray: c,
                            index: f,
                            keys: l,
                            edits: p,
                            prev: a
                        }, l = (c = Array.isArray(d)) ? d : r[d.kind] || [], f = -1, p = [], v && y.push(v), v = d);
                    }while (void 0 !== a);
                    return 0 !== p.length && (g = p[p.length - 1][1]), g;
                }
                function s(e) {
                    return Boolean(e && "string" == typeof e.kind);
                }
                function u(e, t, r) {
                    var n = e[t];
                    if (n) {
                        if (!r && "function" == typeof n) return n;
                        var i = r ? n.leave : n.enter;
                        if ("function" == typeof i) return i;
                    } else {
                        var o = r ? e.leave : e.enter;
                        if (o) {
                            if ("function" == typeof o) return o;
                            var a = o[t];
                            if ("function" == typeof a) return a;
                        }
                    }
                }
            }
        }, t = {};
        function r(n) {
            var i = t[n];
            if (void 0 !== i) return i.exports;
            var o = t[n] = {
                id: n,
                loaded: !1,
                exports: {}
            };
            return e[n].call(o.exports, o, o.exports, r), o.loaded = !0, o.exports;
        }
        return r.n = (e)=>{
            var t = e && e.__esModule ? ()=>e.default : ()=>e;
            return r.d(t, {
                a: t
            }), t;
        }, r.d = (e, t)=>{
            for(var n in t)r.o(t, n) && !r.o(e, n) && Object.defineProperty(e, n, {
                enumerable: !0,
                get: t[n]
            });
        }, r.g = function() {
            if ("object" == typeof globalThis) return globalThis;
            try {
                return this || new Function("return this")();
            } catch (e) {
                if ("object" == typeof window) return window;
            }
        }(), r.hmd = (e)=>((e = Object.create(e)).children || (e.children = []), Object.defineProperty(e, "exports", {
                enumerable: !0,
                set: ()=>{
                    throw new Error("ES Modules may not assign module.exports or exports.*, Use ESM export syntax, instead: " + e.id);
                }
            }), e), r.o = (e, t)=>Object.prototype.hasOwnProperty.call(e, t), r.r = (e)=>{
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(e, "__esModule", {
                value: !0
            });
        }, r.nmd = (e)=>(e.paths = [], e.children || (e.children = []), e), r(8901);
    })()); //# sourceMappingURL=maps/api.js.map

});

parcelRegister("bpm9f", function(module, exports) {

$parcel$export(module.exports, "getRequiredElement", function () { return $6442a5dadd07c76a$export$5cea8db1bd3fa760; });
/**
 * DOM Module
 *
 * Element-resolution helpers. Distinct from ui.ts, whose functions operate on
 * already-resolved elements (widget-state mutation).
 */ /**
 * Looks up a required element by id, returning it typed as `T`.
 *
 * The app's DOM lookups assume the element exists (they were previously written
 * as unguarded `as` casts). This helper preserves that contract but fails fast
 * with an identifying error instead of surfacing a missing element as a later,
 * opaque null dereference.
 *
 * Use only for elements that MUST exist. For genuinely optional elements, use a
 * guarded `querySelector`/`getElementById` with an explicit null check instead.
 *
 * @param id - The element id to look up.
 * @returns The element, typed as `T`.
 * @throws {Error} If no element with that id exists in the document.
 */ function $6442a5dadd07c76a$export$5cea8db1bd3fa760(id) {
    const element = document.getElementById(id);
    if (element === null) throw new Error(`Required element not found: #${id}`);
    return element;
}

});

parcelRegister("fZ4oz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $66f7f8f8da9935f5$export$2e2bcd8739ae039; });

var $ltXBQ = parcelRequire("ltXBQ");
function $66f7f8f8da9935f5$export$2e2bcd8739ae039(selectedRegion) {
    let addedElement = null;
    try {
        const regionInfo = (0, $ltXBQ.getRegionInfo)(selectedRegion);
        if (!regionInfo) return undefined;
        const randomString = Math.floor(Math.random() * 0xfffffffffffff).toString(36);
        addedElement = document.createElement("div");
        addedElement.id = randomString;
        addedElement.className = "pingRegion";
        document.body.insertBefore(addedElement, document.body.firstChild);
        const imageCell = document.createElement("img");
        imageCell.id = `imageCell-${randomString}`;
        imageCell.style.display = "none";
        addedElement.appendChild(imageCell);
        const targetUrl = `${regionInfo.endpoint}ping?x=${randomString}`;
        const pingImageOne = document.createElement("img");
        pingImageOne.id = `pingImageOne-${randomString}`;
        pingImageOne.dataset.image = "1";
        pingImageOne.style.display = "none";
        imageCell.appendChild(pingImageOne);
        const pingImageTwo = document.createElement("img");
        pingImageTwo.id = `pingImageTwo-${randomString}`;
        pingImageTwo.dataset.image = "2";
        pingImageTwo.style.display = "none";
        imageCell.appendChild(pingImageTwo);
        return new Promise((resolve)=>{
            pingImageOne.addEventListener("error", ()=>{
                const startTime = new Date().getTime();
                imageCell.innerHTML = "";
                imageCell.appendChild(pingImageTwo);
                pingImageTwo.addEventListener("error", ()=>{
                    const endTime = new Date().getTime();
                    const elapsed = endTime - startTime;
                    resolve({
                        id: regionInfo.id,
                        name: regionInfo.name,
                        latency: elapsed
                    });
                    document.body.removeChild(addedElement); // Remove the dynamically created element
                });
                pingImageTwo.setAttribute("src", targetUrl);
            });
            pingImageOne.setAttribute("src", targetUrl);
        });
    } catch (error) {
        if (addedElement && document.body.contains(addedElement)) document.body.removeChild(addedElement); // Ensure cleanup in case of an error
        console.error(error);
    }
}

});

parcelRegister("jaYVW", function(module, exports) {

$parcel$export(module.exports, "hideAwsNotification", function () { return $3bb5f15271b33d7c$export$812b7a8239124c29; });
$parcel$export(module.exports, "showNotices", function () { return $3bb5f15271b33d7c$export$574fe7292d23add; });
/**
 * Notifications Module
 *
 * Handles display and management of notification banners and notices.
 */ 
var $bAPCA = parcelRequire("bAPCA");
function $3bb5f15271b33d7c$export$b22aa7ad5b186f13(awsNotificationBanner, severity, title, message, timestamp = new Date()) {
    if (!awsNotificationBanner) return;
    // Remove any existing severity classes
    awsNotificationBanner.classList.remove("notification-banner--critical", "notification-banner--warning", "notification-banner--info");
    // Add the appropriate severity class
    awsNotificationBanner.classList.add(`notification-banner--${severity}`);
    // Update the content
    const titleElement = awsNotificationBanner.querySelector(".notification-banner__title");
    const textElement = awsNotificationBanner.querySelector(".notification-banner__text");
    const timeElement = awsNotificationBanner.querySelector("time");
    if (titleElement) titleElement.textContent = title;
    if (textElement) textElement.textContent = message;
    if (timeElement) {
        const formattedDate = timestamp.toISOString();
        const readableDate = timestamp.toLocaleString("en-US", {
            month: "long",
            day: "numeric",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            timeZoneName: "short"
        });
        timeElement.setAttribute("datetime", formattedDate);
        timeElement.textContent = readableDate;
    }
    // Show the banner
    awsNotificationBanner.classList.remove("notification-banner--hidden");
}
function $3bb5f15271b33d7c$export$812b7a8239124c29(awsNotificationBanner) {
    if (!awsNotificationBanner) return;
    awsNotificationBanner.classList.add("notification-banner--hidden");
}
function $3bb5f15271b33d7c$export$574fe7292d23add(noticesData, awsNotificationBanner) {
    const hasNotices = noticesData?.notices.length > 0;
    const wasDismissed = localStorage.getItem((0, $bAPCA.StorageKeys).NOTIFICATION_DISMISSED) === "true";
    const shouldShowNotification = hasNotices && !wasDismissed;
    if (shouldShowNotification) {
        const notices = noticesData?.notices;
        notices.forEach(({ severity: severity, title: title, message: message, datetime: datetime })=>$3bb5f15271b33d7c$export$b22aa7ad5b186f13(awsNotificationBanner, severity, title, message, new Date(datetime)));
    }
}

});

parcelRegister("cqTsR", function(module, exports) {

$parcel$export(module.exports, "sessionStateString", function () { return $5adb9af6043686d4$export$898bfd536090f163; });
$parcel$export(module.exports, "checkUntilClosed", function () { return $5adb9af6043686d4$export$dc096980b9559842; });
$parcel$export(module.exports, "startSession", function () { return $5adb9af6043686d4$export$c0d84948cecf78d8; });
$parcel$export(module.exports, "loadFrame", function () { return $5adb9af6043686d4$export$ce24fe47d96d8eb0; });

var $4DjaP = parcelRequire("4DjaP");

var $gaxBK = parcelRequire("gaxBK");

var $4V4G7 = parcelRequire("4V4G7");

var $ltXBQ = parcelRequire("ltXBQ");
function $5adb9af6043686d4$export$898bfd536090f163(session) {
    return session.state;
}
async function $5adb9af6043686d4$export$dc096980b9559842(deps) {
    const { terminal: terminal, startButton: startButton, statusMessage: statusMessage } = deps;
    // SDK types getOpenSession() as non-nullable, but at runtime it CAN return null.
    const session = await terminal.getOpenSession();
    if (session && session.state) {
        const isClosing = $5adb9af6043686d4$export$898bfd536090f163(session) === (0, $4DjaP.SessionState).CLOSING;
        if (isClosing) {
            (0, $4V4G7.toggleStartButton)(startButton, false, "Closing last session...");
            statusMessage.innerText = "We're doing some cleanup from the previous session. We'll be ready to launch soon.";
            const sessionGetter = ()=>terminal.getOpenSession();
            const isClosingCheck = (result)=>result !== null && $5adb9af6043686d4$export$898bfd536090f163(result) === (0, $4DjaP.SessionState).CLOSING;
            await (0, $ltXBQ.pollSession)(sessionGetter, isClosingCheck, 1000);
            return true;
        }
    }
    // Session is either null (closed) or not in CLOSING state (already closed)
    return true;
}
async function $5adb9af6043686d4$export$c0d84948cecf78d8(applicationId, deps) {
    const { terminal: terminal, kwInput: kwInput, kwPasswordInput: kwPasswordInput, userNameInput: userNameInput } = deps;
    $gaxBK.setContext("Application", {
        id: applicationId
    });
    if (!terminal) throw new Error(`Terminal not loaded. Could not start session. Application ID: ${applicationId}`);
    let session = await terminal.getOpenSession();
    if (session) {
        $gaxBK.addBreadcrumb({
            category: "session",
            message: `Resuming session ${session.id}`,
            level: "info"
        });
        session = await terminal.resume(session.id);
    } else {
        $gaxBK.addBreadcrumb({
            category: "session",
            message: `Starting session for application ${applicationId}`,
            level: "info"
        });
        const sessionData = `${kwInput.value}_${kwPasswordInput.value}_${userNameInput.value}`;
        session = await terminal.start({
            appId: applicationId,
            userData: sessionData
        });
        $gaxBK.addBreadcrumb({
            category: "session",
            message: `Session started ${session.id}`,
            level: "info"
        });
    }
    return session;
}
async function $5adb9af6043686d4$export$ce24fe47d96d8eb0(accountConfig, token, deps, setTerminal) {
    const { startButton: startButton, statusMessage: statusMessage, loginFieldset: loginFieldset, kwInput: kwInput, kwPasswordInput: kwPasswordInput, userNameInput: userNameInput } = deps;
    const sessionOptions = {
        serviceUrl: deps.serviceUrl,
        terminalConfigId: accountConfig.terminalConfigId,
        token: token
    };
    try {
        const terminal = await (0, $4DjaP.createInstance)(sessionOptions);
        setTerminal(terminal);
        terminal.bind((0, $4DjaP.TerminalEvent).SESSION_STARTING, ()=>{
            statusMessage.innerText = "Connecting...";
            (0, $4V4G7.toggleStartButton)(startButton, false, "Connecting...");
            loginFieldset.disabled = true;
        });
        terminal.bind((0, $4DjaP.TerminalEvent).SESSION_RESUMING, ()=>{
            statusMessage.innerText = "Resuming previous session...";
            (0, $4V4G7.toggleStartButton)(startButton, false, "Resuming...");
            loginFieldset.disabled = true;
        });
        terminal.bind((0, $4DjaP.TerminalEvent).SESSION_STARTED, ()=>{
            statusMessage.innerText = "Connected.";
            loginFieldset.disabled = true;
            (0, $4V4G7.toggleStartButton)(startButton, false, "Connected.");
        });
        terminal.bind((0, $4DjaP.TerminalEvent).SESSION_RESUMED, ()=>{
            statusMessage.innerText = "Connected.";
            loginFieldset.disabled = true;
            (0, $4V4G7.toggleStartButton)(startButton, false, "Connected.");
        });
        terminal.bind((0, $4DjaP.TerminalEvent).SESSION_DISCONNECTED, async ()=>{
            statusMessage.innerText = "Disconnected. Click Resume to reconnect to your previous session or change location to start a new session.";
            loginFieldset.disabled = false;
            (0, $4V4G7.toggleKwInputs)(kwInput, kwPasswordInput, userNameInput, false);
            (0, $4V4G7.toggleStartButton)(startButton, true, "Resume");
            const sessionClosed = await $5adb9af6043686d4$export$dc096980b9559842({
                ...deps,
                terminal: terminal
            });
            if (sessionClosed) {
                statusMessage.innerText = "Session disconnected. Click Launch to start a new session.";
                (0, $4V4G7.toggleStartButton)(startButton, true, "Launch");
                loginFieldset.disabled = false;
                (0, $4V4G7.toggleKwInputs)(kwInput, kwPasswordInput, userNameInput, true);
            }
        });
        terminal.bind((0, $4DjaP.TerminalEvent).SESSION_CLOSED, async ()=>{
            statusMessage.innerText = "Closing session...";
            (0, $4V4G7.toggleStartButton)(startButton, false, "Closing...");
            const sessionClosed = await $5adb9af6043686d4$export$dc096980b9559842({
                ...deps,
                terminal: terminal
            });
            if (sessionClosed) {
                statusMessage.innerText = "Session ended.";
                loginFieldset.disabled = false;
                (0, $4V4G7.toggleStartButton)(startButton, true, "Launch");
            }
        });
        // check for open session right away
        const session = await terminal.getOpenSession();
        if (session && $5adb9af6043686d4$export$898bfd536090f163(session) === (0, $4DjaP.SessionState).OPEN) {
            loginFieldset.disabled = false;
            (0, $4V4G7.toggleKwInputs)(kwInput, kwPasswordInput, userNameInput, false);
            statusMessage.innerText = "An active session is already running. Click Resume to reconnect or change location to start a new session.";
            (0, $4V4G7.toggleStartButton)(startButton, true, "Resume");
        } else if (session && $5adb9af6043686d4$export$898bfd536090f163(session) === (0, $4DjaP.SessionState).CLOSING) {
            const sessionClosed = await $5adb9af6043686d4$export$dc096980b9559842({
                ...deps,
                terminal: terminal
            });
            if (sessionClosed) {
                statusMessage.innerText = "Click Launch to start a new session.";
                (0, $4V4G7.toggleStartButton)(startButton, true, "Launch");
                loginFieldset.disabled = false;
                (0, $4V4G7.toggleKwInputs)(kwInput, kwPasswordInput, userNameInput, true);
            }
        } else if (session === null) {
            loginFieldset.disabled = false;
            (0, $4V4G7.toggleKwInputs)(kwInput, kwPasswordInput, userNameInput, true);
            (0, $4V4G7.toggleStartButton)(startButton, true, "Launch");
        }
    } catch (error) {
        console.warn(`Error loading Frame terminal: ${String(error)}`);
        throw error;
    }
}

});

parcelRegister("js5ua", function(module, exports) {

$parcel$export(module.exports, "setSentryUser", function () { return $2f96a94ffa07465a$export$5ceec5c8be62fa1b; });
$parcel$export(module.exports, "setSentryLocation", function () { return $2f96a94ffa07465a$export$52377dc05369123a; });
/**
 * Telemetry Module
 *
 * Handles Sentry integration.
 */ 
var $gaxBK = parcelRequire("gaxBK");
function $2f96a94ffa07465a$export$5ceec5c8be62fa1b(kwInput, userNameInput) {
    $gaxBK.setUser({
        id: kwInput.value,
        username: userNameInput.value
    });
}
function $2f96a94ffa07465a$export$52377dc05369123a(option) {
    if (!option) {
        console.warn("No option provided to setSentryLocation");
        return;
    }
    $gaxBK.setContext("Location", {
        id: option.id,
        name: option.label
    });
}

});

parcelRegister("fN5b4", function(module, exports) {

$parcel$export(module.exports, "getToken", function () { return $e487d876ad4cd512$export$257b2d10b709d8ef; });
/**
 * Token Management Module
 *
 * Handles JWT token retrieval, validation, and caching for Frame authentication.
 */ 
var $bAPCA = parcelRequire("bAPCA");

var $1mFEN = parcelRequire("1mFEN");
function $e487d876ad4cd512$export$d1a8c8b605234fe8(payload) {
    return payload.exp * 1000 - Date.now() > 1800000;
}
async function $e487d876ad4cd512$export$257b2d10b709d8ef() {
    let token = localStorage.getItem((0, $bAPCA.StorageKeys).FRAME_TOKEN);
    if (token === null) token = await (0, $1mFEN.requestToken)((0, $bAPCA.ApiEndpoints).TOKEN);
    const payload = (0, $1mFEN.getTokenPayload)(token);
    if (!$e487d876ad4cd512$export$d1a8c8b605234fe8(payload)) token = await (0, $1mFEN.requestToken)((0, $bAPCA.ApiEndpoints).TOKEN);
    localStorage.setItem((0, $bAPCA.StorageKeys).FRAME_TOKEN, token);
    return token;
}

});



//# sourceMappingURL=src691146790.c716230a.js.map
